function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};
var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
    parcelRequire = function(id) {
        if (id in $parcel$modules) {
            return $parcel$modules[id].exports;
        }
        if (id in $parcel$inits) {
            var init = $parcel$inits[id];
            delete $parcel$inits[id];
            var module = {
                id: id,
                exports: {}
            };
            $parcel$modules[id] = module;
            init.call(module.exports, module, module.exports);
            return module.exports;
        }
        var err = new Error("Cannot find module '" + id + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
    };
    parcelRequire.register = function register(id, init) {
        $parcel$inits[id] = init;
    };
    $parcel$global["parcelRequire94c2"] = parcelRequire;
}
var parcelRegister = parcelRequire.register;
if (!$parcel$global.lb) {
    $parcel$global.lb = new Set();
    $parcel$global.bq = [];
    $parcel$global.rlb = (bundle)=>{
        $parcel$global.lb.add(bundle);
        $parcel$global.pq();
    };
    $parcel$global.rwr = (b, r, d)=>{
        $parcel$global.bq.push({
            b,
            r,
            d
        });
        $parcel$global.pq();
    };
    $parcel$global.pq = ()=>{
        var runnableEntry = $parcel$global.bq.find((i)=>{
            return i.d.every((dep)=>{
                return $parcel$global.lb.has(dep);
            });
        });
        if (runnableEntry) {
            $parcel$global.bq = $parcel$global.bq.filter((i)=>{
                return i.b !== runnableEntry.b;
            });
            runnableEntry.r();
            $parcel$global.pq();
        }
    };
}
parcelRegister("kFGm5", function(module, exports) {
    var $kJvGp = parcelRequire("kJvGp");
    var $ee7Ev = parcelRequire("ee7Ev");
    var $3zPPS = parcelRequire("3zPPS");
    var $4bGgA = parcelRequire("4bGgA");
    var $i31gq = parcelRequire("i31gq");
    var $8BG5F = parcelRequire("8BG5F");
    var $224h2 = parcelRequire("224h2");
    var $5YL8y = parcelRequire("5YL8y");
    var $f0c87dd638da6507$var$CLONE_DEEP_FLAG = 1, $f0c87dd638da6507$var$CLONE_FLAT_FLAG = 2, $f0c87dd638da6507$var$CLONE_SYMBOLS_FLAG = 4;
    var $f0c87dd638da6507$var$omit = $224h2(function(object, paths) {
        var result = {};
        if (object == null) return result;
        var isDeep = false;
        paths = $kJvGp(paths, function(path) {
            path = $4bGgA(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
        });
        $i31gq(object, $5YL8y(object), result);
        if (isDeep) result = $ee7Ev(result, $f0c87dd638da6507$var$CLONE_DEEP_FLAG | $f0c87dd638da6507$var$CLONE_FLAT_FLAG | $f0c87dd638da6507$var$CLONE_SYMBOLS_FLAG, $8BG5F);
        var length = paths.length;
        while(length--)$3zPPS(result, paths[length]);
        return result;
    });
    module.exports = $f0c87dd638da6507$var$omit;
});
parcelRegister("3zPPS", function(module, exports) {
    var $4bGgA = parcelRequire("4bGgA");
    var $iTvqy = parcelRequire("iTvqy");
    var $2wKO3 = parcelRequire("2wKO3");
    var $cNyDu = parcelRequire("cNyDu");
    function $29acd9759e1173c0$var$baseUnset(object, path) {
        path = $4bGgA(path, object);
        object = $2wKO3(object, path);
        return object == null || delete object[$cNyDu($iTvqy(path))];
    }
    module.exports = $29acd9759e1173c0$var$baseUnset;
});
parcelRegister("2wKO3", function(module, exports) {
    var $dS3e6 = parcelRequire("dS3e6");
    var $jADKY = parcelRequire("jADKY");
    function $1d72e0aabaa913d7$var$parent(object, path) {
        return path.length < 2 ? object : $dS3e6(object, $jADKY(path, 0, -1));
    }
    module.exports = $1d72e0aabaa913d7$var$parent;
});
parcelRegister("8BG5F", function(module, exports) {
    var $jtsd5 = parcelRequire("jtsd5");
    function $64426db23baa732e$var$customOmitClone(value) {
        return $jtsd5(value) ? undefined : value;
    }
    module.exports = $64426db23baa732e$var$customOmitClone;
});
parcelRegister("8dloj", function(module, exports) {
    var $7Smv0 = parcelRequire("7Smv0");
    var $224h2 = parcelRequire("224h2");
    var $5fb02174d73b0468$var$pick = $224h2(function(object, paths) {
        return object == null ? {} : $7Smv0(object, paths);
    });
    module.exports = $5fb02174d73b0468$var$pick;
});
parcelRegister("7Smv0", function(module, exports) {
    var $h5G5y = parcelRequire("h5G5y");
    var $cj1vT = parcelRequire("cj1vT");
    function $5bbf076b50457091$var$basePick(object, paths) {
        return $h5G5y(object, paths, function(value, path) {
            return $cj1vT(object, path);
        });
    }
    module.exports = $5bbf076b50457091$var$basePick;
});
parcelRegister("gpO36", function(module, exports) {
    $parcel$export(module.exports, "createRoot", ()=>$bf35cdd4cc1c7094$export$882461b6382ed46c, (v)=>$bf35cdd4cc1c7094$export$882461b6382ed46c = v);
    var $bf35cdd4cc1c7094$export$882461b6382ed46c;
    var $bf35cdd4cc1c7094$export$757ceba2d55c277e;
    'use strict';
    var $lEfVV = parcelRequire("lEfVV");
    var $bf35cdd4cc1c7094$var$i;
    $bf35cdd4cc1c7094$export$882461b6382ed46c = $lEfVV.createRoot;
    $bf35cdd4cc1c7094$export$757ceba2d55c277e = $lEfVV.hydrateRoot;
});
parcelRegister("9BVaU", function(module, exports) {
    $parcel$export(module.exports, "LooselyLazy", ()=>$d222720657fccc76$export$33c5f161e1d4706);
    var $9VQ8l = parcelRequire("9VQ8l");
    var $74RJ9 = parcelRequire("74RJ9");
    var $7Tz2G = parcelRequire("7Tz2G");
    var $gAS98 = parcelRequire("gAS98");
    var $415sU = parcelRequire("415sU");
    const $d222720657fccc76$export$33c5f161e1d4706 = {
        init: (config)=>{
            (0, $74RJ9.setConfig)(config);
            (0, $7Tz2G.LISTENERS).length = 0;
            (0, $gAS98.setCurrent)(0);
            if (!(0, $415sU.isNodeEnvironment)()) (0, $9VQ8l.collect)();
        }
    };
});
parcelRegister("9VQ8l", function(module, exports) {
    $parcel$export(module.exports, "collect", ()=>$d7452a18d891667e$export$bb44f104e3c54dae);
    var $74RJ9 = parcelRequire("74RJ9");
    var $hFKiK = parcelRequire("hFKiK");
    var $bKjSY = parcelRequire("bKjSY");
    var $lCZ4x = parcelRequire("lCZ4x");
    const $d7452a18d891667e$export$bb44f104e3c54dae = ()=>{
        const markers = document.querySelectorAll('input[data-lazy-begin]');
        const { mode: mode } = (0, $74RJ9.getConfig)();
        for(let i = 0, j = markers.length; i < j; i += 1){
            const el = markers[i];
            const { lazyBegin: lazyBegin } = el.dataset || {};
            const value = mode === (0, $74RJ9.MODE).RENDER ? (0, $bKjSY.cloneElements)(markers[i], lazyBegin) : (0, $lCZ4x.refElements)(markers[i], lazyBegin);
            if ((0, $hFKiK.COLLECTED).has(lazyBegin)) (0, $hFKiK.COLLECTED).get(lazyBegin).push(value);
            else (0, $hFKiK.COLLECTED).set(lazyBegin, [
                value
            ]);
        }
    };
});
parcelRegister("bKjSY", function(module, exports) {
    $parcel$export(module.exports, "cloneElements", ()=>$a4da7362939762be$export$c42217d53a7ebafb);
    const $a4da7362939762be$export$c42217d53a7ebafb = (fromEl, id)=>{
        const fragment = document.createElement('div');
        let el = fromEl;
        while(el = el.nextSibling){
            if (el.dataset && el.dataset.lazyEnd === id) break;
            fragment.appendChild(el.cloneNode(true));
        }
        return Array.from(fragment.childNodes);
    };
});
parcelRegister("lCZ4x", function(module, exports) {
    $parcel$export(module.exports, "refElements", ()=>$537244463971d7d4$export$c69443129766a7fc);
    const $537244463971d7d4$export$c69443129766a7fc = (fromEl, id)=>{
        const result = [];
        let el = fromEl;
        while(el = el.nextSibling){
            if (el.dataset && el.dataset.lazyEnd === id) break;
            result.push(el);
        }
        return result;
    };
});
parcelRegister("9lmTX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a22cac565d88251d$export$2e2bcd8739ae039);
    var $3FyZ4 = parcelRequire("3FyZ4");
    var $eIp1n = parcelRequire("eIp1n");
    var $6WXNs = parcelRequire("6WXNs");
    const $a22cac565d88251d$var$transformApplication = (application)=>{
        switch(application){
            case 0, $eIp1n.JIRA_SOFTWARE:
                return 'jira-software';
            case 0, $eIp1n.JIRA_PRODUCT_DISCOVERY:
                return 'jira-product-discovery';
            case 0, $eIp1n.JIRA_CORE:
                return 'jira-core';
            case 0, $eIp1n.JIRA_SERVICE_DESK:
                return 'jira-servicedesk';
            case 0, $eIp1n.JIRA_PORTFOLIO:
                return 'jira-portfolio';
            default:
                return 'unknown';
        }
    };
    const $a22cac565d88251d$var$transformEdition = (edition)=>{
        switch(edition){
            case 0, $6WXNs.FREE_EDITION:
                return 'jedi';
            case 0, $6WXNs.STANDARD_EDITION:
                return 'standard';
            case 0, $6WXNs.PREMIUM_EDITION:
                return 'premium';
            case 0, $6WXNs.UNLICENSED:
                return 'unlicensed';
            default:
                return 'unknown';
        }
    };
    const $a22cac565d88251d$var$transformAction = (action, wasExperienceSuccesful)=>{
        if (action !== undefined) return action;
        return wasExperienceSuccesful ? 'taskSuccess' : 'taskFail';
    };
    const $a22cac565d88251d$var$createAnalyticsEvent = ({ experience: experience, wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, field: field, hasEdit: hasEdit, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes })=>({
            source: 'ui',
            action: $a22cac565d88251d$var$transformAction(action, wasExperienceSuccesful),
            actionSubject: 'ui',
            attributes: {
                ...additionalAttributes,
                task: experience,
                ...location ? {
                    reason: location
                } : {},
                ...field ? {
                    field: field
                } : {},
                ...typeof hasEdit === 'boolean' ? {
                    hasEdit: hasEdit
                } : {},
                analyticsSource: analyticsSource,
                application: $a22cac565d88251d$var$transformApplication(application),
                edition: $a22cac565d88251d$var$transformEdition(edition)
            }
        });
    var $a22cac565d88251d$export$2e2bcd8739ae039 = (experienceDescription)=>{
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const event = $a22cac565d88251d$var$createAnalyticsEvent(experienceDescription);
            const clientInstance = client.getInstance();
            clientInstance.sendOperationalEvent(event);
        });
    };
});
parcelRegister("gXEQH", function(module, exports) {
    $parcel$export(module.exports, "routeAnalyticsAttributes", ()=>$d518287b36cbf350$export$c71778b3a4356b04);
    var $keguF = parcelRequire("keguF");
    var $77Wva = parcelRequire("77Wva");
    const $d518287b36cbf350$export$c71778b3a4356b04 = Object.defineProperties({}, {
        routeName: {
            enumerable: true,
            get: (0, $keguF.getRouteName)
        },
        userLocation: {
            enumerable: true,
            get: (0, $keguF.getUserLocation)
        },
        previousSubProduct: {
            enumerable: true,
            get: (0, $keguF.getPreviousSubProduct)
        },
        isProjectAdmin: {
            enumerable: true,
            get: (0, $77Wva.getIsProjectAdmin)
        }
    });
});
parcelRegister("77Wva", function(module, exports) {
    $parcel$export(module.exports, "getIsProjectAdmin", ()=>$6b9122e612958aea$export$34ff06260ad17f2b);
    $parcel$export(module.exports, "setIsProjectAdmin", ()=>$6b9122e612958aea$export$d53e6d79d3fa5f31);
    let $6b9122e612958aea$var$projectAdmin = null;
    const $6b9122e612958aea$export$34ff06260ad17f2b = ()=>{
        if ($6b9122e612958aea$var$projectAdmin == null || !$6b9122e612958aea$var$projectAdmin.loading && $6b9122e612958aea$var$projectAdmin.isProjectAdmin == null) return 'UNKNOWN';
        if ($6b9122e612958aea$var$projectAdmin.loading === true) return 'LOADING';
        return Boolean($6b9122e612958aea$var$projectAdmin.isProjectAdmin);
    };
    const $6b9122e612958aea$export$d53e6d79d3fa5f31 = (projectAdminState)=>{
        $6b9122e612958aea$var$projectAdmin = projectAdminState;
    };
});
parcelRegister("80E03", function(module, exports) {
    var $WBLbN = parcelRequire("WBLbN");
    if (!$parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_) {
        (parcelRequire("cNJNa"));
        const isDevMode = false;
        (0, $WBLbN.defaults).devtools = isDevMode && (()=>({
                serialize: {
                    replacer: (key, value)=>value instanceof HTMLElement ? {
                            data: {
                                tagName: value.tagName,
                                className: value.className,
                                id: value.id,
                                __SANITIZED__: true
                            },
                            __serializedType__: 'HTMLElement'
                        } : value
                }
            }));
        (0, $WBLbN.defaults).batchUpdates = !false;
        Object.freeze((0, $WBLbN.defaults));
        $parcel$global._IS_JIRA_GLOBAL_SIDE_EFFECT_INIT_ = true;
    }
});
parcelRegister("cNJNa", function(module, exports) {
    const $951d94f6d5f27bca$var$style = document.createElement('style');
    $951d94f6d5f27bca$var$style.textContent = `html,body,p,div,h1,h2,h3,h4,h5,h6,ul,ol,dl,img,pre,form,fieldset{margin:0;padding:0}img,fieldset{border:0}body,html{width:100%;height:100%}body{background-color:var(--ds-surface,#fff);color:var(--ds-text,#172b4d);font:var(--ds-font-body,normal 400 14px/1.42857 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);-ms-overflow-style:-ms-autohiding-scrollbar;-webkit-text-decoration-skip-ink:auto;text-decoration-skip-ink:auto}p,ul,ol,dl,h1,h2,h3,h4,h5,h6,blockquote,pre,form,table{margin:var(--ds-space-150,12px)0 0 0}a{color:var(--ds-link,#0052cc);text-decoration:none}a:hover{color:var(--ds-link,#0065ff);text-decoration:underline}a:active{color:var(--ds-link-pressed,#0747a6)}a:focus-visible{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#2684ff);outline-offset:var(--ds-space-025,2px)}@supports not selector(*:focus-visible){a:focus{outline:var(--ds-border-width-outline,2px)solid var(--ds-border-focused,#4c9aff);outline-offset:var(--ds-space-025,2px)}}h1{font:var(--ds-font-heading-xlarge,600 2.07143em/1.10345 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h2{font:var(--ds-font-heading-large,500 1.71429em/1.16667 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.01em;color:var(--ds-text);margin-top:var(--ds-space-500)}h3{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px}h4{font:var(--ds-font-heading-small,600 1.14286em/1.25 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.006em;color:var(--ds-text);margin-top:var(--ds-space-300)}h5{font:var(--ds-font-heading-xsmall,600 1em/1.14286 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.003em;color:var(--ds-text);margin-top:var(--ds-space-200)}h6{font:var(--ds-font-heading-xxsmall,600 .857143em/1.33333 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);color:var(--ds-text);margin-top:var(--ds-space-250);text-transform:uppercase}ul,ol,dl{padding-left:var(--ds-space-500,40px)}dd,dd+dt,li+li,ul ul:not(:first-child),ol ul:not(:first-child),ul ol:not(:first-child),ol ol:not(:first-child){margin-top:var(--ds-space-050,4px)}p:first-child,ul:first-child,ol:first-child,dl:first-child,h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child,h6:first-child,blockquote:first-child,pre:first-child,form:first-child,table:first-child{margin-top:0}blockquote,q{color:inherit}blockquote{padding-left:var(--ds-space-500,40px);border:none}[dir=rtl] blockquote{padding-left:0;padding-right:var(--ds-space-500,40px)}blockquote:before,q:before{content:"\u{201C}"}blockquote:after,q:after{content:"\u{201D}"}blockquote:before{float:left;text-align:right;width:1em;margin-left:-1em}[dir=rtl] blockquote:before{float:right;text-align:left;margin-right:-1em}blockquote>:last-child{display:inline-block}small{font:var(--ds-font-body-small,normal 400 11px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)}code,kbd{font-family:var(--ds-font-family-code,"SFMono-Medium","SF Mono","Segoe UI Mono","Roboto Mono","Ubuntu Mono",Menlo,Consolas,Courier,monospace)}var,address,dfn,cite{font-style:italic}abbr{border-bottom:1px var(--ds-border,#ccc)dotted;cursor:help}@supports (color-scheme:dark) and (color-scheme:light){[data-color-mode=light]{--lightningcss-light:initial;--lightningcss-dark: ;color-scheme:light}[data-color-mode=dark]{--lightningcss-light: ;--lightningcss-dark:initial;color-scheme:dark}}table{border-collapse:collapse;width:100%}thead,tbody,tfoot{border-bottom:2px solid var(--ds-border,#dfe1e6)}td,th{padding:var(--ds-space-050,4px)var(--ds-space-100,8px);text-align:left;border:none}th{vertical-align:top}td:first-child,th:first-child{padding-left:0}td:last-child,th:last-child{padding-right:0}caption{font:var(--ds-font-heading-medium,500 1.42857em/1.2 -apple-system,BlinkMacSystemFont,"Segoe UI","Roboto","Oxygen","Ubuntu","Fira Sans","Droid Sans","Helvetica Neue",sans-serif);letter-spacing:-.008em;color:var(--ds-text);margin-top:28px;margin-bottom:var(--ds-space-100,8px);text-align:left}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}@-moz-document url-prefix(){img{font-size:0}img:-moz-broken{font-size:inherit}}button{font-family:inherit}.assistive{clip:rect(1px,1px,1px,1px)!important;white-space:nowrap!important;border:0!important;width:1px!important;height:1px!important;padding:0!important;position:absolute!important;overflow:hidden!important}`;
    document.querySelector('head').appendChild($951d94f6d5f27bca$var$style);
});
parcelRegister("8R80x", function(module, exports) {
    $parcel$export(module.exports, "getPlaceholdersFromHTML", ()=>$c9ae2df088b0cf45$export$9e9f35acc3af3a9a);
    $parcel$export(module.exports, "EntryPointPlaceholderContext", ()=>$c9ae2df088b0cf45$export$b5b377bb81310c48);
    $parcel$export(module.exports, "EntryPointPlaceholder", ()=>$c9ae2df088b0cf45$export$db2828f683d11042);
    var $eUqFw = parcelRequire("eUqFw");
    var $gGtKh = parcelRequire("gGtKh");
    function $c9ae2df088b0cf45$export$9e9f35acc3af3a9a() {
        const placeholders = document.querySelectorAll('[data-ep-placeholder-id]');
        return new Map(Array.from(placeholders, (el)=>[
                el.dataset.epPlaceholderId,
                el.innerHTML
            ]));
    }
    const $c9ae2df088b0cf45$export$b5b377bb81310c48 = (0, $eUqFw.createContext)(new Map());
    function $c9ae2df088b0cf45$export$db2828f683d11042({ children: children, entryPoint: entryPoint, fallback: originalFallback, name: name, ...placeholderProps }) {
        const { root: root } = entryPoint;
        const hasMounted = (0, $eUqFw.useRef)(false);
        const placeholders = (0, $eUqFw.useContext)($c9ae2df088b0cf45$export$b5b377bb81310c48);
        const ssrFallback = placeholders.get(name);
        const [fallback, setFallback] = (0, $eUqFw.useState)(!ssrFallback || root.getModuleIfRequired() ? originalFallback : (0, ($parcel$interopDefault($eUqFw))).createElement("span", {
            dangerouslySetInnerHTML: {
                __html: ssrFallback
            },
            "data-ep-placeholder-id": name
        }));
        const lastOriginalFallback = (0, $eUqFw.useRef)(originalFallback);
        lastOriginalFallback.current = originalFallback;
        (0, $eUqFw.useLayoutEffect)(()=>{
            if (hasMounted.current && placeholders.has(name)) {
                placeholders.delete(name);
                setFallback(lastOriginalFallback.current);
            }
        }, [
            entryPoint,
            name,
            placeholders,
            setFallback
        ]);
        (0, $eUqFw.useEffect)(()=>{
            const onComplete = ()=>{
                if (placeholders.has(name)) placeholders.delete(name);
                setFallback(lastOriginalFallback.current);
            };
            const unsubscribe = root.onComplete(onComplete, onComplete);
            return ()=>{
                unsubscribe();
                onComplete();
            };
        }, [
            name,
            placeholders,
            root
        ]);
        (0, $eUqFw.useEffect)(()=>{
            hasMounted.current = true;
        }, []);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            fallback: fallback,
            name: name,
            ...placeholderProps
        }, (0, ($parcel$interopDefault($eUqFw))).createElement("span", {
            "data-ep-placeholder-id": name
        }, children));
    }
});
parcelRegister("d16Bc", function(module, exports) {
    $parcel$export(module.exports, "initPlatformFeatureFlags", ()=>$00f2fa4abeba3937$export$2d291317456ada16);
    var $iDwTy = parcelRequire("iDwTy");
    var $eI5EY = parcelRequire("eI5EY");
    var $1ybV0 = parcelRequire("1ybV0");
    const $00f2fa4abeba3937$export$2d291317456ada16 = ([isOverride, resolver])=>{
        if ((0, $1ybV0.ff)('fix_jira_ssr_platform_ff_oxim4')) (0, $iDwTy.setBooleanFeatureFlagResolver)((flagKey)=>isOverride(flagKey) ? resolver(flagKey) : (0, $eI5EY.fg)(flagKey) || (0, $1ybV0.ff)(flagKey));
    };
});
parcelRegister("6U1dF", function(module, exports) {
    $parcel$export(module.exports, "NonCritical", ()=>$7c939f739e44c405$export$20fd89b1bf707b1a);
    $parcel$export(module.exports, "default", ()=>$7c939f739e44c405$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $0cdA8 = parcelRequire("0cdA8");
    var $h3mHU = parcelRequire("h3mHU");
    const $7c939f739e44c405$export$83d969795398ec56 = ({ children: children, timerThreshold: timerThreshold })=>{
        const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
        const [isFirstRun, setFirstRun] = (0, $eUqFw.useState)(true);
        const [hasThresholdTimerExpired, setHasThresholdTimerExpired] = (0, $eUqFw.useState)(false);
        (0, $eUqFw.useEffect)(()=>{
            if (timerThreshold != null) setTimeout(()=>{
                setHasThresholdTimerExpired(true);
            }, timerThreshold);
        }, [
            timerThreshold
        ]);
        if (!isFirstRun || isReady || hasThresholdTimerExpired) {
            isFirstRun && setFirstRun(false);
            return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children);
        }
        return null;
    };
    const $7c939f739e44c405$export$5b2f4b62d18632 = ({ id: id = 'non-critical-with-timer', teamName: teamName, ...props })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: id,
            teamName: teamName,
            packageName: "jiraPlatformNonCritical",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($7c939f739e44c405$export$83d969795398ec56, props));
    const $7c939f739e44c405$var$NonCriticalComponent = (props)=>{
        const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
        const [isFirstRun, setFirstRun] = (0, $eUqFw.useState)(true);
        if (!isFirstRun || isReady) {
            isFirstRun && setFirstRun(false);
            return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, props.children);
        }
        return null;
    };
    const $7c939f739e44c405$export$20fd89b1bf707b1a = ({ id: id = 'non-critical', teamName: teamName, ...props })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: id,
            teamName: teamName,
            packageName: "jiraPlatformNonCritical",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($7c939f739e44c405$var$NonCriticalComponent, props));
    var $7c939f739e44c405$export$2e2bcd8739ae039 = $7c939f739e44c405$var$NonCriticalComponent;
});
parcelRegister("h3mHU", function(module, exports) {
    $parcel$export(module.exports, "useSpaStatePageReady", ()=>$76cb153a8803a558$export$ea2491906b753456);
    $parcel$export(module.exports, "SpaStatePageReady", ()=>$76cb153a8803a558$export$c34439f945fccbdf);
    $parcel$export(module.exports, "SpaStatePageReadyOnUpdate", ()=>$76cb153a8803a558$export$41e70078eeddaddc);
    var $eUqFw = parcelRequire("eUqFw");
    var $3viaK = parcelRequire("3viaK");
    var $WBLbN = parcelRequire("WBLbN");
    var $lcJyp = parcelRequire("lcJyp");
    var $cfLkw = parcelRequire("cfLkw");
    const $76cb153a8803a558$export$e6897aa59ee7aee5 = ({ currentPage: currentPage })=>{
        const { apps: apps } = currentPage;
        const appIds = Object.keys(apps);
        return {
            isReady: appIds.length ? appIds.every((id)=>apps[id].endTime || apps[id].timeoutTime) : false
        };
    };
    const $76cb153a8803a558$export$ea2491906b753456 = (0, $WBLbN.createHook)((0, $cfLkw.default), {
        selector: $76cb153a8803a558$export$e6897aa59ee7aee5
    });
    const $76cb153a8803a558$export$c34439f945fccbdf = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
                op: setAppReady
            }));
    const $76cb153a8803a558$export$41e70078eeddaddc = ({ comparer: comparer })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
                op: setAppReady,
                args: comparer
            }));
});
parcelRegister("3viaK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$114bcd9b637bc682$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $hTLlD = parcelRequire("hTLlD");
    class $114bcd9b637bc682$var$OpTrigger extends (0, $eUqFw.Component) {
        static{
            this.defaultProps = {
                args: []
            };
        }
        componentDidMount() {
            this.props.op(...this.props.args);
        }
        shouldComponentUpdate(nextProps) {
            return !(0, ($parcel$interopDefault($hTLlD)))(this.props.args, nextProps.args);
        }
        componentDidUpdate() {
            this.props.op(...this.props.args);
        }
        render() {
            return null;
        }
    }
    var $114bcd9b637bc682$export$2e2bcd8739ae039 = $114bcd9b637bc682$var$OpTrigger;
});
parcelRegister("lcJyp", function(module, exports) {
    $parcel$export(module.exports, "SpaStateSubscriber", ()=>$847fac6342ee5df8$export$fd52daf2a3c1ec68);
    $parcel$export(module.exports, "SpaStateActionsSubscriber", ()=>$847fac6342ee5df8$export$3dfa91988c213fbc);
    $parcel$export(module.exports, "useSpaState", ()=>$847fac6342ee5df8$export$a57865516f6345d1);
    $parcel$export(module.exports, "useSpaStateActions", ()=>$847fac6342ee5df8$export$b134752525935b78);
    var $WBLbN = parcelRequire("WBLbN");
    var $cfLkw = parcelRequire("cfLkw");
    const $847fac6342ee5df8$export$fd52daf2a3c1ec68 = (0, $WBLbN.createSubscriber)((0, $cfLkw.default));
    const $847fac6342ee5df8$export$3dfa91988c213fbc = (0, $WBLbN.createSubscriber)((0, $cfLkw.default), {
        selector: null
    });
    const $847fac6342ee5df8$export$a57865516f6345d1 = (0, $WBLbN.createHook)((0, $cfLkw.default));
    const $847fac6342ee5df8$export$b134752525935b78 = (0, $WBLbN.createHook)((0, $cfLkw.default), {
        selector: null
    });
});
parcelRegister("cfLkw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e76bb655f4dbc8c$export$2e2bcd8739ae039);
    var $hompL = parcelRequire("hompL");
    var $WBLbN = parcelRequire("WBLbN");
    var $a2pDC = parcelRequire("a2pDC");
    const $7e76bb655f4dbc8c$export$d4c72bab9d6cc13a = {
        transitionCheckTimestamp: -1,
        currentPage: {
            uuid: false ? '' : (0, ($parcel$interopDefault($hompL))).v4(),
            startTime: typeof performance !== 'undefined' && performance.timing !== undefined && performance.timing.navigationStart || 0,
            apps: {},
            userLocation: ''
        },
        visitedPages: [],
        navigation: {
            isCollapsed: false,
            viewId: 'noView',
            viewType: '',
            projectType: null,
            isInitialEventSent: false,
            pageId: null,
            nextViewId: ''
        }
    };
    const $7e76bb655f4dbc8c$var$store = (0, $WBLbN.createStore)({
        name: 'spa-state',
        initialState: $7e76bb655f4dbc8c$export$d4c72bab9d6cc13a,
        actions: $a2pDC
    });
    var $7e76bb655f4dbc8c$export$2e2bcd8739ae039 = $7e76bb655f4dbc8c$var$store;
});
parcelRegister("a2pDC", function(module, exports) {
    $parcel$export(module.exports, "setAppStart", ()=>(parcelRequire("gKuw7")).setAppStart);
    $parcel$export(module.exports, "setAppReady", ()=>(parcelRequire("gKuw7")).setAppReady);
    $parcel$export(module.exports, "setAppStartWithAppId", ()=>(parcelRequire("gKuw7")).setAppStartWithAppId);
    $parcel$export(module.exports, "setAppReadyWithAppId", ()=>(parcelRequire("gKuw7")).setAppReadyWithAppId);
    $parcel$export(module.exports, "setAppErrorReady", ()=>(parcelRequire("gKuw7")).setAppErrorReady);
    $parcel$export(module.exports, "setTimeoutReady", ()=>(parcelRequire("gKuw7")).setTimeoutReady);
    $parcel$export(module.exports, "setTimeoutReadyWithAppId", ()=>(parcelRequire("gKuw7")).setTimeoutReadyWithAppId);
    $parcel$export(module.exports, "resetCurrentPage", ()=>(parcelRequire("gKuw7")).resetCurrentPage);
    $parcel$export(module.exports, "setResourceMetrics", ()=>(parcelRequire("gKuw7")).setResourceMetrics);
    var $gKuw7 = parcelRequire("gKuw7");
});
parcelRegister("gKuw7", function(module, exports) {
    $parcel$export(module.exports, "resetCurrentPage", ()=>$1354b0144a8be88b$export$5639685a1fb81722);
    $parcel$export(module.exports, "setTimeoutReadyWithAppId", ()=>$1354b0144a8be88b$export$8a98548dad2fa97b);
    $parcel$export(module.exports, "setTimeoutReady", ()=>$1354b0144a8be88b$export$b9cc4378ea785421);
    $parcel$export(module.exports, "setAppStartWithAppId", ()=>$1354b0144a8be88b$export$9d528722f2ff2999);
    $parcel$export(module.exports, "setAppStart", ()=>$1354b0144a8be88b$export$71192061050856ad);
    $parcel$export(module.exports, "setAppReadyWithAppId", ()=>$1354b0144a8be88b$export$6a25429a42d30f9a);
    $parcel$export(module.exports, "setAppReady", ()=>$1354b0144a8be88b$export$fc59cc4ed9bba7cd);
    $parcel$export(module.exports, "setAppErrorReady", ()=>$1354b0144a8be88b$export$aff63c1e41443b6a);
    $parcel$export(module.exports, "setResourceMetrics", ()=>$1354b0144a8be88b$export$8ad155d489dcf34d);
    var $hompL = parcelRequire("hompL");
    var $7Nhwm = parcelRequire("7Nhwm");
    var $1ybV0 = parcelRequire("1ybV0");
    var $keguF = parcelRequire("keguF");
    var $jlwEU = parcelRequire("jlwEU");
    var $4KuMM = parcelRequire("4KuMM");
    const $1354b0144a8be88b$export$7bd623b29ec8e1eb = 10000;
    const $1354b0144a8be88b$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            performance.mark('resetCurrentPage');
            (0, $7Nhwm.browserMetrics).startPageLoad({
                isInitial: false
            });
            (0, $jlwEU.default)(nextRouteUfoName, nextRouteName);
            if ((0, $1ybV0.ff)('uip.ufo')) {
                (0, $4KuMM.GlobalPageLoadExperience).abort({
                    force: true
                });
                (0, $4KuMM.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
            }
            if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
                currentPage: {
                    uuid: (0, ($parcel$interopDefault($hompL))).v4(),
                    apps: {},
                    startTime: Date.now(),
                    userLocation: ''
                },
                visitedPages: [
                    ...currentState.visitedPages,
                    {
                        ...currentState.currentPage
                    }
                ],
                transitionCheckTimestamp: 0
            });
        };
    const $1354b0144a8be88b$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
                const apps = {
                    ...currentPage.apps
                };
                if (apps[appId] && apps[appId].expectingTimeout) {
                    const updatedPage = {
                        ...currentPage,
                        apps: {
                            ...apps,
                            [appId]: {
                                ...apps[appId],
                                timeoutTime: timeoutTime,
                                expectingTimeout: 0
                            }
                        }
                    };
                    setState({
                        currentPage: updatedPage
                    });
                }
            }
        };
    const $1354b0144a8be88b$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($1354b0144a8be88b$export$8a98548dad2fa97b(appId, timeoutTime));
        };
    const $1354b0144a8be88b$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
                const timeoutId = setTimeout(()=>{
                    dispatch($1354b0144a8be88b$export$8a98548dad2fa97b(appId));
                }, $1354b0144a8be88b$export$7bd623b29ec8e1eb);
                const updatedPage = {
                    ...currentPage,
                    userLocation: (0, $keguF.getUserLocation)(),
                    apps: {
                        ...currentPage.apps,
                        [appId]: {
                            startTime: startTime,
                            expectingTimeout: timeoutId
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $1354b0144a8be88b$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($1354b0144a8be88b$export$9d528722f2ff2999(appId, startTime));
        };
    const $1354b0144a8be88b$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
                const apps = {
                    ...currentPage.apps
                };
                clearTimeout(currentPage.apps[appId].expectingTimeout);
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            endTime: endTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $1354b0144a8be88b$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
            dispatch($1354b0144a8be88b$export$6a25429a42d30f9a(appId, endTime));
        };
    const $1354b0144a8be88b$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            const { currentPage: currentPage } = currentState;
            if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        'error-page': {
                            endTime: Date.now()
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        };
    const $1354b0144a8be88b$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
            const currentState = getState();
            setState({
                currentPage: {
                    ...currentState.currentPage,
                    resources: [
                        ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                        resourceMetrics
                    ]
                }
            });
        };
});
parcelRegister("h97Af", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97ef913b7770c56a$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $6iz4v = parcelRequire("6iz4v");
    const $97ef913b7770c56a$var$PerformanceMark = ({ metricKey: metricKey, onSet: onSet })=>{
        const renderRef = (0, $eUqFw.useRef)(false);
        if (!renderRef.current) {
            renderRef.current = true;
            (0, $6iz4v.setMark)(metricKey);
            onSet && onSet();
        }
        return null;
    };
    var $97ef913b7770c56a$export$2e2bcd8739ae039 = $97ef913b7770c56a$var$PerformanceMark;
});
parcelRegister("ibSOG", function(module, exports) {
    $parcel$export(module.exports, "PageContainer", ()=>$ae84b0fa7dce8133$export$5f86df0ee0a255b5);
    var $7JEyt = parcelRequire("7JEyt");
    var $eUqFw = parcelRequire("eUqFw");
    var $jGR8u = parcelRequire("jGR8u");
    var $6WwlF = parcelRequire("6WwlF");
    var $h97Af = parcelRequire("h97Af");
    var $0cdA8 = parcelRequire("0cdA8");
    var $9zysr = parcelRequire("9zysr");
    var $4u3Wx = parcelRequire("4u3Wx");
    var $Qx7Xg = parcelRequire("Qx7Xg");
    var $cB0s9 = parcelRequire("cB0s9");
    var $b00xW = parcelRequire("b00xW");
    var $dWu0t = parcelRequire("dWu0t");
    var $6FP8W = parcelRequire("6FP8W");
    var $hwyJ1 = parcelRequire("hwyJ1");
    var $14yu2 = parcelRequire("14yu2");
    var $egmX2 = parcelRequire("egmX2");
    var $8WuJm = parcelRequire("8WuJm");
    var $bQiKj = parcelRequire("bQiKj");
    var $2B87Z = parcelRequire("2B87Z");
    var $69Ipc = parcelRequire("69Ipc");
    var $5Wexj = parcelRequire("5Wexj");
    var $jG5np = parcelRequire("jG5np");
    var $kqXZB = parcelRequire("kqXZB");
    var $l8xBK = parcelRequire("l8xBK");
    var $eymfV = parcelRequire("eymfV");
    var $4LQUt = parcelRequire("4LQUt");
    var $fpQ73 = parcelRequire("fpQ73");
    var $1cu0z = parcelRequire("1cu0z");
    const $ae84b0fa7dce8133$var$mainWrapperStyles = {
        root: "_4t3i1osq _1e0c1txw _2lx21bp4 _9beo1bgi",
        themed: "_11q71o10 _11q31r52"
    };
    const $ae84b0fa7dce8133$var$ROOT_TEST_ID = 'page-layout.root';
    const $ae84b0fa7dce8133$var$MAIN_TEST_ID = 'page-layout.main';
    const $ae84b0fa7dce8133$var$PageContainerNew = ({ id: id, locale: locale, baseUrl: baseUrl, children: children, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
        const [isChromeless] = (0, $4u3Wx.useIsChromeless)();
        const [isFullscreen] = (0, $Qx7Xg.useIsFullscreen)();
        const { hasTheming: hasTheming } = (0, $6WwlF.useBusinessLookAndFeel)();
        const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, $14yu2.useBannerJsmPackagingUpdates)();
        const pageContainerPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
            (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$898b6208220685b0), (0, $7688150c048b38d1$export$e2bc63118050de32), (0, $7688150c048b38d1$export$59f83d43fe209319), true, false);
        }, []);
        const mainWrapper = (content)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.Main), {
                isFixed: true,
                testId: $ae84b0fa7dce8133$var$MAIN_TEST_ID
            }, (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
                className: (0, $7JEyt.default)([
                    $ae84b0fa7dce8133$var$mainWrapperStyles.root,
                    hasTheming && $ae84b0fa7dce8133$var$mainWrapperStyles.themed
                ])
            }, isJsmPackagingUpdatesEnabled && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $egmX2.BannerJsmPackagingUpdateAsync), null), content));
        const showBanner = !isChromeless && !isFullscreen;
        const showTopNav = !isChromeless && !isFullscreen;
        const showSidebar = !isChromeless && !isFullscreen;
        const showHorizontalNav = !isChromeless;
        const showRightSidebar = !isChromeless && !isFullscreen;
        const showLayoutRemoteStateUpdater = !isChromeless && !isFullscreen;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $7688150c048b38d1$export$e2bc63118050de32)
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1cu0z.ThemeSetter), null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jG5np.GlobalContainers), {
            id: id,
            locale: locale,
            baseUrl: baseUrl,
            messages: messages,
            Router: Router,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $7688150c048b38d1$export$59f83d43fe209319),
            onSet: pageContainerPerformanceTiming
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
            sourceName: "navigationNext"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.PageLayout), {
            skipLinksLabel: "",
            testId: $ae84b0fa7dce8133$var$ROOT_TEST_ID
        }, showBanner && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "banner",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $69Ipc.Banner), null)), showTopNav && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "top-nav",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4LQUt.TopNav), null)), showSidebar && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "sidebar",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eymfV.Sidebar), null)), mainWrapper((0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, showHorizontalNav && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $kqXZB.HorizontalNav), null), children)), showRightSidebar && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "right-sidebar",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $l8xBK.RightSidebar), null)), showLayoutRemoteStateUpdater && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            packageName: "jiraPageContainerV2",
            id: "layout-remote-state-updater",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cB0s9.LayoutRemoteStateUpdater), null))), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5Wexj.GlobalComponents), {
            sharedGlobalComponents: (0, $bQiKj.sharedLayout).globalComponents
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $b00xW.GlobalBottomRightCornerContainer), null))));
    };
    const $ae84b0fa7dce8133$var$PageContainerOld = ({ id: id, locale: locale, baseUrl: baseUrl, children: children, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
        const HorizontalNavComponent = (0, $dWu0t.useHorizontalNavComponent)();
        const { isEnabled: isJsmPackagingUpdatesEnabled } = (0, $14yu2.useBannerJsmPackagingUpdates)();
        const pageContainerPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
            (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$898b6208220685b0), (0, $7688150c048b38d1$export$e2bc63118050de32), (0, $7688150c048b38d1$export$59f83d43fe209319), true, false);
        }, []);
        let contentChildren = isJsmPackagingUpdatesEnabled ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $egmX2.BannerJsmPackagingUpdateAsync), null), children) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children);
        if (HorizontalNavComponent != null) contentChildren = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $kqXZB.HorizontalNavWrapper), {
            navComponent: HorizontalNavComponent
        }, isJsmPackagingUpdatesEnabled && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $egmX2.BannerJsmPackagingUpdateAsync), null), children);
        const panelContent = (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $fpQ73.FullHeight), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.PageLayout), {
            skipLinksLabel: ""
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "banner",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $69Ipc.Banner), null)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "top-nav",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4LQUt.TopNav), null)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.LeftPanel), {
            width: 0
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.Content), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "sidebar",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eymfV.Sidebar), null)), contentChildren, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "right-sidebar",
            packageName: "page-container",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $l8xBK.RightSidebar), null))), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            packageName: "page-container",
            id: "layout-remote-state-updater",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cB0s9.LayoutRemoteStateUpdater), null)))), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5Wexj.GlobalComponents), {
            sharedGlobalComponents: (0, $bQiKj.sharedLayout).globalComponents
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $b00xW.GlobalBottomRightCornerContainer), null));
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $7688150c048b38d1$export$e2bc63118050de32)
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1cu0z.ThemeSetter), null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jG5np.GlobalContainers), {
            id: id,
            locale: locale,
            baseUrl: baseUrl,
            messages: messages,
            Router: Router,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $7688150c048b38d1$export$59f83d43fe209319),
            onSet: pageContainerPerformanceTiming
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
            sourceName: "navigationNext"
        }, panelContent)));
    };
    const $ae84b0fa7dce8133$export$5f86df0ee0a255b5 = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $ae84b0fa7dce8133$var$PageContainerNew, $ae84b0fa7dce8133$var$PageContainerOld);
});
parcelRegister("6WwlF", function(module, exports) {
    $parcel$export(module.exports, "useBusinessLookAndFeel", ()=>$7836b6e7c7b98ca3$export$ad3385faee9e435a);
    var $b3nmi = parcelRequire("b3nmi");
    var $exb0h = parcelRequire("exb0h");
    var $kLSws = parcelRequire("kLSws");
    var $dWu0t = parcelRequire("dWu0t");
    var $6FP8W = parcelRequire("6FP8W");
    var $10fdS = parcelRequire("10fdS");
    var $bEe6y = parcelRequire("bEe6y");
    const $7836b6e7c7b98ca3$export$ad3385faee9e435a = ()=>{
        const route = (0, $10fdS.useCurrentRoute)();
        const HorizontalNavComponent = (0, $dWu0t.useHorizontalNavComponent)();
        const isBusinessRouteGroup = route.group === (0, $exb0h.ROUTE_GROUPS_CLASSIC_BUSINESS);
        const hasProjectViewNavigation = (0, $6FP8W.getWillShowNav4)() ? HorizontalNavComponent != null : HorizontalNavComponent === (0, $b3nmi.AsyncHorizontalProjectNav) || HorizontalNavComponent === (0, $b3nmi.AsyncHorizontalOverviewNav) || HorizontalNavComponent === (0, $bEe6y.AsyncHorizontalSoftwareProjectNav) || HorizontalNavComponent === (0, $kLSws.AsyncHorizontalNavPlans);
        const hasTheming = (0, $6FP8W.getWillShowNav4)() ? HorizontalNavComponent === (0, $b3nmi.AsyncHorizontalProjectNav) || HorizontalNavComponent === (0, $b3nmi.AsyncHorizontalOverviewNav) || route.name === (0, $exb0h.ROUTE_NAMES_ISSUE) : hasProjectViewNavigation;
        const isInset = hasTheming && !isBusinessRouteGroup;
        return {
            isInset: isInset,
            hasTheming: hasTheming,
            hasProjectViewNavigation: hasProjectViewNavigation
        };
    };
});
parcelRegister("b3nmi", function(module, exports) {
    $parcel$export(module.exports, "AsyncHorizontalProjectNav", ()=>$9702ab3631bfd06d$export$862dd1c0126bb181);
    $parcel$export(module.exports, "AsyncHorizontalOverviewNav", ()=>$9702ab3631bfd06d$export$beabdf5c49f01377);
    var $eUqFw = parcelRequire("eUqFw");
    var $gGtKh = parcelRequire("gGtKh");
    var $56koX = parcelRequire("56koX");
    const $9702ab3631bfd06d$var$LazyHorizontalProjectNav = (0, $56koX.lazyForPaint)(()=>(parcelRequire("bRTUX")), {
        moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/project-navigation/index.tsx"
    });
    const $9702ab3631bfd06d$export$862dd1c0126bb181 = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "horizontal-project-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($9702ab3631bfd06d$var$LazyHorizontalProjectNav, null));
    const $9702ab3631bfd06d$var$LazyHorizontalOverviewNav = (0, $56koX.lazyForPaint)(()=>(parcelRequire("3aryZ")), {
        moduleId: "./src/packages/business/navigation/horizontal-nav/src/ui/overview-navigation/index.tsx"
    });
    const $9702ab3631bfd06d$export$beabdf5c49f01377 = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "horizontal-overview-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($9702ab3631bfd06d$var$LazyHorizontalOverviewNav, null));
});
parcelRegister("bRTUX", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("lIxVq")
    ]).then(()=>parcelRequire('4XF6i'));
});
parcelRegister("3aryZ", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("g9yoo")
    ]).then(()=>parcelRequire('iiqLF'));
});
parcelRegister("exb0h", function(module, exports) {
    $parcel$export(module.exports, "ROUTE_GROUPS_ARCHIVE_ISSUES", ()=>$67f07001968fe110$export$1ba937db1fe6ef01);
    $parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_BUSINESS", ()=>$67f07001968fe110$export$bbf08d4d25df5504);
    $parcel$export(module.exports, "ROUTE_GROUPS_CLASSIC_SOFTWARE", ()=>$67f07001968fe110$export$e3e759b7f50aaee1);
    $parcel$export(module.exports, "ROUTE_GROUPS_COMPONENTS", ()=>$67f07001968fe110$export$89337611b52bc9a3);
    $parcel$export(module.exports, "ROUTE_GROUPS_CONNECT", ()=>$67f07001968fe110$export$3d7937b12eb9e5d5);
    $parcel$export(module.exports, "ROUTE_GROUPS_DASHBOARD", ()=>$67f07001968fe110$export$7a3d181d86fce9e6);
    $parcel$export(module.exports, "ROUTE_GROUPS_DEVOPS", ()=>$67f07001968fe110$export$7a22726acd7d6021);
    $parcel$export(module.exports, "ROUTE_GROUPS_DIRECTORIES", ()=>$67f07001968fe110$export$f3f4a9f53ba00861);
    $parcel$export(module.exports, "ROUTE_GROUPS_EOC", ()=>$67f07001968fe110$export$112d69653b2f1d8b);
    $parcel$export(module.exports, "ROUTE_GROUPS_ERRORS", ()=>$67f07001968fe110$export$74e0426b66571086);
    $parcel$export(module.exports, "ROUTE_GROUPS_GLOBAL_SETTINGS", ()=>$67f07001968fe110$export$c2e20e142c95c1ce);
    $parcel$export(module.exports, "ROUTE_GROUPS_HELP_CENTER_SETTINGS", ()=>$67f07001968fe110$export$f8cea29bebf098c);
    $parcel$export(module.exports, "ROUTE_GROUPS_HOME", ()=>$67f07001968fe110$export$5801ef8dfc9a2f70);
    $parcel$export(module.exports, "ROUTE_GROUPS_ISSUE", ()=>$67f07001968fe110$export$7246838143f848f3);
    $parcel$export(module.exports, "ROUTE_GROUPS_ISSUE_NAVIGATOR", ()=>$67f07001968fe110$export$54f96702980a2f87);
    $parcel$export(module.exports, "ROUTE_GROUPS_LEGACY", ()=>$67f07001968fe110$export$5566db8fbd042fc4);
    $parcel$export(module.exports, "ROUTE_GROUPS_MARKETPLACE", ()=>$67f07001968fe110$export$656d0cc2c67b2708);
    $parcel$export(module.exports, "ROUTE_GROUPS_PEOPLE_PROFILES", ()=>$67f07001968fe110$export$bfdbcebc4c81b043);
    $parcel$export(module.exports, "ROUTE_GROUPS_PERSONAL_SETTINGS", ()=>$67f07001968fe110$export$82021d71ad19e227);
    $parcel$export(module.exports, "ROUTE_GROUPS_PLAN_SETTINGS", ()=>$67f07001968fe110$export$6f266218a6973848);
    $parcel$export(module.exports, "ROUTE_GROUPS_POLARIS", ()=>$67f07001968fe110$export$a846fcaeeea8e0ff);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROFORMA", ()=>$67f07001968fe110$export$6c87a9dff4e7a2de);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC", ()=>$67f07001968fe110$export$ab79970dcfac06a1);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_CORE", ()=>$67f07001968fe110$export$d1a70f80bb22f18a);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK", ()=>$67f07001968fe110$export$bd925e9fcb6ce37f);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE", ()=>$67f07001968fe110$export$86509a1baabd62ee);
    $parcel$export(module.exports, "ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE_BOARDS", ()=>$67f07001968fe110$export$98823ed9eedfc756);
    $parcel$export(module.exports, "ROUTE_GROUPS_REDIRECTS", ()=>$67f07001968fe110$export$da8d13fe1ccd5c09);
    $parcel$export(module.exports, "ROUTE_GROUPS_SERVICEDESK", ()=>$67f07001968fe110$export$78fb2f6176b7c6b8);
    $parcel$export(module.exports, "ROUTE_GROUPS_SOFTWARE", ()=>$67f07001968fe110$export$26efaec7a7a8b361);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY", ()=>$67f07001968fe110$export$88041353cc69458d);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PLANS_DIRECTORY", ()=>$67f07001968fe110$export$f88d57dcb03ba452);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY", ()=>$67f07001968fe110$export$e8aa63af071c2da9);
    $parcel$export(module.exports, "ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK", ()=>$67f07001968fe110$export$b114d0da2ebcff6c);
    $parcel$export(module.exports, "ROUTE_NAMES_BOARDS_DIRECTORY", ()=>$67f07001968fe110$export$29cc94b8cea5c920);
    $parcel$export(module.exports, "ROUTE_NAMES_BROWSE_PROJECT_REDIRECT", ()=>$67f07001968fe110$export$4d1b45005cdcfb39);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_BOARD", ()=>$67f07001968fe110$export$a42ea04fdf53eeaf);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_CLASSIC_REPORTS", ()=>$67f07001968fe110$export$ca4c5f5b3e2daa18);
    $parcel$export(module.exports, "ROUTE_NAMES_BUSINESS_REPORTS", ()=>$67f07001968fe110$export$d58a5411a2ac6260);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_ONBOARDING_GET_STARTED", ()=>$67f07001968fe110$export$24514ee19772b5af);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR", ()=>$67f07001968fe110$export$ec333dd1d6a8b38);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT", ()=>$67f07001968fe110$export$ed495fbad44791af);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY", ()=>$67f07001968fe110$export$5281552f8109b7c0);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE", ()=>$67f07001968fe110$export$6e8473713ed4557a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS", ()=>$67f07001968fe110$export$cbdd5c24d69b2cb1);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS", ()=>$67f07001968fe110$export$e7f012f402be01ea);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD", ()=>$67f07001968fe110$export$b34d3882b42d660d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED", ()=>$67f07001968fe110$export$ed869c60c6a56182);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR", ()=>$67f07001968fe110$export$5013269f29c75b37);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED", ()=>$67f07001968fe110$export$fc8b48319e993d43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM", ()=>$67f07001968fe110$export$d6e60a2059f028d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER", ()=>$67f07001968fe110$export$3d589aae17a00bc9);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT", ()=>$67f07001968fe110$export$bd92ef03b23dd672);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED", ()=>$67f07001968fe110$export$fa7fc44c718fc850);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST", ()=>$67f07001968fe110$export$1dffaf831e01e2b4);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED", ()=>$67f07001968fe110$export$5f8187412dd60f35);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SAMPLE_ONBOARDING", ()=>$67f07001968fe110$export$3d2c1c04d18f6c43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT", ()=>$67f07001968fe110$export$cd22a5d8f560a1d8);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY", ()=>$67f07001968fe110$export$cad1b1aa5ce26bbc);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY_EMBED", ()=>$67f07001968fe110$export$ee073463b4144367);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE", ()=>$67f07001968fe110$export$ea034943499772ea);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED", ()=>$67f07001968fe110$export$19bc888bcf37d22d);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT", ()=>$67f07001968fe110$export$e0746183e11767fb);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CODE", ()=>$67f07001968fe110$export$3e2d215ce157adc8);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS", ()=>$67f07001968fe110$export$8a8485bb05daf40b);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", ()=>$67f07001968fe110$export$a2799b01de5bb62);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_FEATURES", ()=>$67f07001968fe110$export$2d4f89c4b1ee3640);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT", ()=>$67f07001968fe110$export$75609d3416c31f79);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_NOTIFICATION_EMAIL", ()=>$67f07001968fe110$export$79793dc26e0b7b1a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_OPSGENIE", ()=>$67f07001968fe110$export$2eda7466fbfdef43);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS", ()=>$67f07001968fe110$export$417297669917ee1a);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", ()=>$67f07001968fe110$export$8c79f3309ac0737);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", ()=>$67f07001968fe110$export$ef71a22e7befd35c);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_EDIT_FORMS", ()=>$67f07001968fe110$export$62ba1e294f5007c1);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_FORMS", ()=>$67f07001968fe110$export$a4315324546ecc89);
    $parcel$export(module.exports, "ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_TOOLCHAIN", ()=>$67f07001968fe110$export$a653cf6d478b3df1);
    $parcel$export(module.exports, "ROUTE_NAMES_COMPASS_PRODUCT_SETTINGS", ()=>$67f07001968fe110$export$b0f268fe53a03e98);
    $parcel$export(module.exports, "ROUTE_NAMES_CONFLUENCE_PRODUCT_SETTINGS", ()=>$67f07001968fe110$export$f4160b48e4ab8f39);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL", ()=>$67f07001968fe110$export$608f359cf8b08d2e);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_INVALID", ()=>$67f07001968fe110$export$8bfbf790fe89f8d3);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT", ()=>$67f07001968fe110$export$d7011d1ed949f970);
    $parcel$export(module.exports, "ROUTE_NAMES_CONNECT_PROJECT", ()=>$67f07001968fe110$export$bd2506db44585db6);
    $parcel$export(module.exports, "ROUTE_NAMES_CREATE_PROJECT", ()=>$67f07001968fe110$export$200fa5ad16f8c112);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD", ()=>$67f07001968fe110$export$a296bb962bea95b5);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY", ()=>$67f07001968fe110$export$b9960c143c0414eb);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE", ()=>$67f07001968fe110$export$411171d2fcaefaea);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_EDIT", ()=>$67f07001968fe110$export$ee104ed514f63003);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_SELECTED", ()=>$67f07001968fe110$export$9233f9ddcecd3062);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW", ()=>$67f07001968fe110$export$b3240ec044a6c70f);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_VIEW_EMBED", ()=>$67f07001968fe110$export$2463c779e12367e3);
    $parcel$export(module.exports, "ROUTE_NAMES_DASHBOARD_WALLBOARD", ()=>$67f07001968fe110$export$dd3e5187eae2abe9);
    $parcel$export(module.exports, "ROUTE_NAMES_DEVOPS_CONNECTED_PROJECT", ()=>$67f07001968fe110$export$38ca7e07048a5bfd);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING", ()=>$67f07001968fe110$export$48749e87cc44a5a5);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_CREATE", ()=>$67f07001968fe110$export$21c230ef79df9e9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_DETAIL", ()=>$67f07001968fe110$export$d2d813dd057a8352);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_API_KEY_MANAGEMENT", ()=>$67f07001968fe110$export$54ed2374d14a7e88);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ASSIGN_CUSTOM_ROLES", ()=>$67f07001968fe110$export$58368fe796f5ecb4);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_AUTOMATIONS", ()=>$67f07001968fe110$export$bbb4032f8f259109);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_CUSTOM_ROLES", ()=>$67f07001968fe110$export$5b17b30c2dd69cf2);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERTS", ()=>$67f07001968fe110$export$d18d0b9a9e85e59c);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL", ()=>$67f07001968fe110$export$5126a481501fc518);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL", ()=>$67f07001968fe110$export$40e720d8c26e6804);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_MAINTENANCE", ()=>$67f07001968fe110$export$dc8ac1f7e9373a32);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORTS", ()=>$67f07001968fe110$export$8ca3e3f0326ba27f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD", ()=>$67f07001968fe110$export$c3d17be12795c864);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_HEARTBEATS", ()=>$67f07001968fe110$export$9cd1c70eda5cae15);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL", ()=>$67f07001968fe110$export$99f769b27f537a72);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INCOMING_CALL_DETAIL", ()=>$67f07001968fe110$export$5c5fe79d3f9ec214);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATIONS", ()=>$67f07001968fe110$export$901b974cf0954c88);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_CREATE", ()=>$67f07001968fe110$export$b2dd23a345bd5cb3);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_DETAIL", ()=>$67f07001968fe110$export$8ae7cbc0a73f9351);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LIST", ()=>$67f07001968fe110$export$8057ebe7fb7f7f8d);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_INTEGRATION_LOG", ()=>$67f07001968fe110$export$a22387b9744e62e3);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_MAINTENANCE", ()=>$67f07001968fe110$export$f6fefa9d2e5bbda1);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL", ()=>$67f07001968fe110$export$e6de4aa6c719d2b);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ON_CALL_REDIRECT", ()=>$67f07001968fe110$export$b195ada84b7e695f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW", ()=>$67f07001968fe110$export$1800d32171b754a6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS", ()=>$67f07001968fe110$export$d22a153bfcbaaaa0);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_PERMISSIONS", ()=>$67f07001968fe110$export$a9a41c76994b6ae9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_POLICIES", ()=>$67f07001968fe110$export$5bd6f2569c3cfd5c);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS", ()=>$67f07001968fe110$export$dc70eff53ff26c70);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_TEAM", ()=>$67f07001968fe110$export$1fe2ca96b360df19);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE", ()=>$67f07001968fe110$export$1ff01e77517a80b0);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS", ()=>$67f07001968fe110$export$de3f8f3198f8213a);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS_DETAIL", ()=>$67f07001968fe110$export$b2cb569d360db382);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERTS", ()=>$67f07001968fe110$export$da985e953465731f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS", ()=>$67f07001968fe110$export$b7eee2afd0a5c6b9);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING", ()=>$67f07001968fe110$export$9b6c84986db47d98);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE", ()=>$67f07001968fe110$export$89276f76fdd700d6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL", ()=>$67f07001968fe110$export$ea64769f19da8c95);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS", ()=>$67f07001968fe110$export$4a584839d9a9eb6f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD", ()=>$67f07001968fe110$export$27d27c817eeb97cc);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL", ()=>$67f07001968fe110$export$9f533c13cfb48a8f);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATIONS", ()=>$67f07001968fe110$export$6889e571e5aa6ba6);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE", ()=>$67f07001968fe110$export$bdd811277711c53d);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL", ()=>$67f07001968fe110$export$c7b51c0e8ad6f77a);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST", ()=>$67f07001968fe110$export$a348fc7f3b4cfe34);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG", ()=>$67f07001968fe110$export$a4eff769c94da831);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_TEAM_POLICIES", ()=>$67f07001968fe110$export$7c928ca9c9822772);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_UNLOCK_OPERATIONS", ()=>$67f07001968fe110$export$b48311a8f24f4b63);
    $parcel$export(module.exports, "ROUTE_NAMES_EOC_WHO_IS_ON_CALL", ()=>$67f07001968fe110$export$20649eac204f7661);
    $parcel$export(module.exports, "ROUTE_NAMES_ERRORS_NOT_FOUND", ()=>$67f07001968fe110$export$62170875a111d729);
    $parcel$export(module.exports, "ROUTE_NAMES_EXTERNAL_IMPORT", ()=>$67f07001968fe110$export$2928f3d69e7ac609);
    $parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY", ()=>$67f07001968fe110$export$259e18cafd820487);
    $parcel$export(module.exports, "ROUTE_NAMES_FILTERS_DIRECTORY_SECURE", ()=>$67f07001968fe110$export$4b8f333757e638a4);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN", ()=>$67f07001968fe110$export$ac4f65a14002f892);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_ADMIN_SETTINGS", ()=>$67f07001968fe110$export$c73ddc4b44ccb359);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_FIELD_CONTEXTUAL_CONFIGURATION", ()=>$67f07001968fe110$export$7ad826b482229119);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_GLOBAL", ()=>$67f07001968fe110$export$3df864df9b639033);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_PROJECT", ()=>$67f07001968fe110$export$7d67bf4077ebe18d);
    $parcel$export(module.exports, "ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE", ()=>$67f07001968fe110$export$5ff797dfd5df551f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG", ()=>$67f07001968fe110$export$8a66ba1da5efa2c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR", ()=>$67f07001968fe110$export$eadf5aff28def565);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT", ()=>$67f07001968fe110$export$8f9c045e8fd449b7);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_MAIL_SETTINGS", ()=>$67f07001968fe110$export$1bf439327974644b);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CONTACT_ADMINISTRATOR", ()=>$67f07001968fe110$export$e2a9d163770d0d46);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS", ()=>$67f07001968fe110$export$21b497c57bcd299a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_ASSOCIATE", ()=>$67f07001968fe110$export$8d4d1f7df6e5d4e4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_CONFIGURE", ()=>$67f07001968fe110$export$df5ca261227a6052);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_DELETE", ()=>$67f07001968fe110$export$9f2f4303259b8508);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_EDIT", ()=>$67f07001968fe110$export$7fd53fe07eecc273);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_MANAGE", ()=>$67f07001968fe110$export$c8e9ba2b5bc9dab2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS_TRANSLATE", ()=>$67f07001968fe110$export$e05a6c9e9b9b0c48);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EXPLICIT_FIELD_ASSOCIATION_PROJECT_LIST", ()=>$67f07001968fe110$export$f9759b206b651b1f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES", ()=>$67f07001968fe110$export$7a337a2687b5d5e3);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS", ()=>$67f07001968fe110$export$a41998c1a3572e41);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_CONFIGURE", ()=>$67f07001968fe110$export$2c9fe9e6005a9c36);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUTS_COPY", ()=>$67f07001968fe110$export$5d8d82ff1de3586e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES", ()=>$67f07001968fe110$export$8a0ed100d885c17c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_CONFIGURE", ()=>$67f07001968fe110$export$1c7041445acf79e8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_COPY", ()=>$67f07001968fe110$export$e4712523d95125f6);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_DELETE", ()=>$67f07001968fe110$export$7401274ad357ff94);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT", ()=>$67f07001968fe110$export$6984b21077857555);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_EDIT_ENTRY", ()=>$67f07001968fe110$export$5a2dae98f768aedf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FIELD_LAYOUT_SCHEMES_VIEW", ()=>$67f07001968fe110$export$5eef1c6eb1388ac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS", ()=>$67f07001968fe110$export$69bcf2c26d45e030);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_GLOBAL_PERMISSIONS", ()=>$67f07001968fe110$export$ba1417cf5de80f81);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES", ()=>$67f07001968fe110$export$fdcfcb2e2eb16afd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_ACTIVATE", ()=>$67f07001968fe110$export$5d3e6bffd6b5abfe);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DEACTIVATE", ()=>$67f07001968fe110$export$5c676bbb7e3aae9e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_DELETE", ()=>$67f07001968fe110$export$8bb013ced097489a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_LINK_TYPES_EDIT", ()=>$67f07001968fe110$export$e384ae6a87fadedd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH", ()=>$67f07001968fe110$export$8f55a911c4bd95bf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_VIEW", ()=>$67f07001968fe110$export$d7b98892cb31fba5);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_ADD", ()=>$67f07001968fe110$export$8be4b203f526b2cd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_DELETE", ()=>$67f07001968fe110$export$df09947903c514c4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_EDIT", ()=>$67f07001968fe110$export$cf4a57a81e0bfbca);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_ADD", ()=>$67f07001968fe110$export$bc64365bbb09c05e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_DELETE", ()=>$67f07001968fe110$export$5b12571311ebe766);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_SCHEME_EDIT", ()=>$67f07001968fe110$export$56dc46fe1de63994);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NOTIFICATION_VIEW", ()=>$67f07001968fe110$export$65af0e5a36d4b4e9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES", ()=>$67f07001968fe110$export$dec448f9d2e50c90);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_ADD", ()=>$67f07001968fe110$export$9ff4144e1dcf9fa4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_DELETE", ()=>$67f07001968fe110$export$8aab6fb9a62dda95);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PERMISSIONS_SCHEMES_EDIT", ()=>$67f07001968fe110$export$9f804a2650117f51);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES", ()=>$67f07001968fe110$export$7dd4b916600f670);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_DELETE", ()=>$67f07001968fe110$export$c1b40a8a70c0aafa);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_EDIT", ()=>$67f07001968fe110$export$ff10d812380db045);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES_TRANSLATE", ()=>$67f07001968fe110$export$8deeffdf8dfed878);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES", ()=>$67f07001968fe110$export$561687f2fa9b9cc9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS", ()=>$67f07001968fe110$export$691d30818c14141c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DEFAULT", ()=>$67f07001968fe110$export$8fa58495105f8fb0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_DELETE", ()=>$67f07001968fe110$export$8304c57494d82ffd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_EDIT", ()=>$67f07001968fe110$export$353609deec72a2ba);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_RESOLUTIONS_TRANSLATE", ()=>$67f07001968fe110$export$1cb56e4c132ac8fd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_EDIT", ()=>$67f07001968fe110$export$5fe3eec0a6bda09);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_ADD", ()=>$67f07001968fe110$export$12b56880d6fb7ac7);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_DELETE", ()=>$67f07001968fe110$export$9986e8be82998857);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_LEVEL_EDIT", ()=>$67f07001968fe110$export$3280ec16231916af);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES", ()=>$67f07001968fe110$export$54885d105d1e2b37);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_ADD", ()=>$67f07001968fe110$export$f34d87c870f3bf43);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_DELETE", ()=>$67f07001968fe110$export$4108ebf71e36e461);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_SECURITY_SCHEMES_EDIT", ()=>$67f07001968fe110$export$d42ec33a6e69686e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES", ()=>$67f07001968fe110$export$8d2cfabd01e2feaa);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_STATUSES_TRANSLATE", ()=>$67f07001968fe110$export$d0fe3726dffeca80);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE", ()=>$67f07001968fe110$export$b4aa4b2b8fb7267a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_CONFIGURE_EDIT", ()=>$67f07001968fe110$export$3743711165f5dd4f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES", ()=>$67f07001968fe110$export$5df6f81deab9567c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_ADD", ()=>$67f07001968fe110$export$b3db2a2ee8a9a8e4);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_CONFIGURE", ()=>$67f07001968fe110$export$d5fc8cd4b3fd2b84);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_COPY", ()=>$67f07001968fe110$export$a03360d8b616ef34);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_DELETE", ()=>$67f07001968fe110$export$336e54edc189df7f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT", ()=>$67f07001968fe110$export$53572e9a81205523);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES_EDIT_ITEM", ()=>$67f07001968fe110$export$b71f2ef452117a2a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS", ()=>$67f07001968fe110$export$f79745fee583cd62);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_COPY", ()=>$67f07001968fe110$export$2281663e19f399c1);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_DELETE", ()=>$67f07001968fe110$export$38c52d8c5e5dad29);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS_EDIT", ()=>$67f07001968fe110$export$10babc3f11b4e6e2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY", ()=>$67f07001968fe110$export$adf2f51c41b4e22a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY_REDIRECT", ()=>$67f07001968fe110$export$11b217754d4c7d24);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS", ()=>$67f07001968fe110$export$3414f0d81f1c11d);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_DISABLE", ()=>$67f07001968fe110$export$5574c73a9a5878ca);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_EDIT", ()=>$67f07001968fe110$export$cb2626c385b72992);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_SUBTASKS_TRANSLATE", ()=>$67f07001968fe110$export$fa7aa7cabc3ec459);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TIME_TRACKING", ()=>$67f07001968fe110$export$8b0450672651ef67);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES", ()=>$67f07001968fe110$export$ef510a15f840e437);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_DELETE", ()=>$67f07001968fe110$export$bc159fa4984a907f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_EDIT", ()=>$67f07001968fe110$export$47bfbce13af95d24);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES", ()=>$67f07001968fe110$export$c8cb78e94cd3f83c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ADD_OR_COPY", ()=>$67f07001968fe110$export$4496279df22177be);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_ASSOCIATE", ()=>$67f07001968fe110$export$afdfef5d17c56988);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES_DELETE", ()=>$67f07001968fe110$export$ac9b4b1136300033);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES", ()=>$67f07001968fe110$export$4aa31dc2a6d4f2ee);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_CONFIGURE", ()=>$67f07001968fe110$export$c56f5509b93eba68);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_COPY", ()=>$67f07001968fe110$export$dd9462e97e11637a);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_DELETE", ()=>$67f07001968fe110$export$11f8c53e10f63cfb);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_EDIT", ()=>$67f07001968fe110$export$758ad3ad6916c9f6);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES_ENTITY", ()=>$67f07001968fe110$export$9d65a754315eb617);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_TRANSLATE", ()=>$67f07001968fe110$export$564b665f6ca740dd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW", ()=>$67f07001968fe110$export$256fc89c38c1b9e9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT", ()=>$67f07001968fe110$export$ddeae77164bfac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES", ()=>$67f07001968fe110$export$fa2b355372963545);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_SCHEMES_EDIT", ()=>$67f07001968fe110$export$45511e437e54fa02);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION", ()=>$67f07001968fe110$export$ad76895f03f27a7c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_TRANSITION_META_ATTRIBUTES", ()=>$67f07001968fe110$export$1c291d65a59b1636);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD", ()=>$67f07001968fe110$export$d9bb14d665bfeea5);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE", ()=>$67f07001968fe110$export$8b44cb3da7b8f857);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME", ()=>$67f07001968fe110$export$9ca6a09e1518d3bb);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD", ()=>$67f07001968fe110$export$4c211b3188348679);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE", ()=>$67f07001968fe110$export$24757bb1837e33af);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL", ()=>$67f07001968fe110$export$95b5d0bd29a3a076);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW", ()=>$67f07001968fe110$export$d55d4330b58683da);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP", ()=>$67f07001968fe110$export$f4d5833f0b40a26b);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR", ()=>$67f07001968fe110$export$c78577545f514ca8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PERMISSION_SCHEMES", ()=>$67f07001968fe110$export$253eb3db7152d010);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_APPLICATION_LINKS", ()=>$67f07001968fe110$export$16b4392a63a3eacf);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_DVCS", ()=>$67f07001968fe110$export$b2d5a7bc804ed9c9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_SDMAIL", ()=>$67f07001968fe110$export$f870832f94ca5009);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PRODUCTS_STATUS_PAGE", ()=>$67f07001968fe110$export$8b3a1b2e8e954dc2);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_DELETE", ()=>$67f07001968fe110$export$15603150075c3d64);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_EDIT", ()=>$67f07001968fe110$export$92536fe760c41862);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_PROJECTS_CATEGORIES_VIEW", ()=>$67f07001968fe110$export$3f4d05032349dae0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SHARED_DASHBOARDS", ()=>$67f07001968fe110$export$8ff94a2e5f98315f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_NOTIFICATION_HELPER", ()=>$67f07001968fe110$export$c906c6946fef5d99);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADMIN_PERMISSION_HELPER", ()=>$67f07001968fe110$export$a1916b723e186494);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_ATTACHMENTS", ()=>$67f07001968fe110$export$5070b4c974017f28);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS", ()=>$67f07001968fe110$export$bee7f9f93cb74124);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_ADD", ()=>$67f07001968fe110$export$efe4008073ab3b69);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_DELETE", ()=>$67f07001968fe110$export$9e40228f1c62d4d9);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_EVENTS_EDIT", ()=>$67f07001968fe110$export$223f8094878fea34);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_LEXORANK_MANAGEMENT", ()=>$67f07001968fe110$export$2f589c572415c043);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_SERVICES", ()=>$67f07001968fe110$export$8cc394a1f5ca4ac0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ADVANCED_WEBHOOKS", ()=>$67f07001968fe110$export$a11311cd333dae90);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_BULK_MAIL", ()=>$67f07001968fe110$export$2b2f159267202dcc);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_ADVANCED_SETTINGS", ()=>$67f07001968fe110$export$c5a6874288d2e609);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GENERAL_CONFIGURATION_EDIT_SETTINGS", ()=>$67f07001968fe110$export$55dd30b027c838fe);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_GLOBAL_PERMISSIONS", ()=>$67f07001968fe110$export$aee9c7dbf672403c);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_BACKUP_MANAGER", ()=>$67f07001968fe110$export$75f2fbd33e76028e);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_CLOUD_OR_SERVER_IMPORT", ()=>$67f07001968fe110$export$ca57c3dfefb2c826);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT", ()=>$67f07001968fe110$export$8f2e6f133c022a59);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_CSV", ()=>$67f07001968fe110$export$bcd741cf5a35ece8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_JSON", ()=>$67f07001968fe110$export$bfd8ab4625d5c275);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_IMPORT_EXPORT_EXTERNAL_IMPORT_TRELLO", ()=>$67f07001968fe110$export$750a33c4058af733);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_ISSUE_COLLECTORS", ()=>$67f07001968fe110$export$1b66c7594340363f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_DELETE_MAIL_HANDLER", ()=>$67f07001968fe110$export$fe2fa966509db649);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_INCOMING_MAIL", ()=>$67f07001968fe110$export$373b97e8d136f558);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_OUTGOING_MAIL", ()=>$67f07001968fe110$export$64909bb6f2181592);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_MAIL_SEND_MAIL", ()=>$67f07001968fe110$export$53d6ade2eaa2ae84);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_GLOBAL_PERMISSIONS_OLD", ()=>$67f07001968fe110$export$e49d7a1ddf301d09);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES", ()=>$67f07001968fe110$export$9469cfde1d14fcac);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS", ()=>$67f07001968fe110$export$be2e231547dca6dd);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_GROUPS", ()=>$67f07001968fe110$export$ad6f28bbfe57d0a0);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_ACTORS_USERS", ()=>$67f07001968fe110$export$2fb73d5c1c0e7186);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_DELETE", ()=>$67f07001968fe110$export$46b4f43d6ece38fc);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_EDIT", ()=>$67f07001968fe110$export$49d1c20d84d46735);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SECURITY_PROJECT_ROLES_USAGE", ()=>$67f07001968fe110$export$265062715b11a1ef);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_SHARED_FILTERS", ()=>$67f07001968fe110$export$e9f5eae9444c9b46);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_TROUBLESHOOTING_AUDIT_LOG", ()=>$67f07001968fe110$export$e19bf9459d6eba56);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER", ()=>$67f07001968fe110$export$40097704c31872d8);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_DASHBOARD_EDIT", ()=>$67f07001968fe110$export$dcdf0405aa7e2078);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_LOOK_AND_FEEL", ()=>$67f07001968fe110$export$fb75113636566d39);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_PREFERENCES_APPLY", ()=>$67f07001968fe110$export$e27baa0c7747e67f);
    $parcel$export(module.exports, "ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_USER_DEFAULTS", ()=>$67f07001968fe110$export$40d189100899f572);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS", ()=>$67f07001968fe110$export$341933b279728599);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_NOTIFICATIONS", ()=>$67f07001968fe110$export$ae4b815061537207);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_EMAIL", ()=>$67f07001968fe110$export$5cd0dd5a6be6aa2b);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_KNOWLEDGE_BASE", ()=>$67f07001968fe110$export$bee46016693b19dc);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPES", ()=>$67f07001968fe110$export$c39a25878c902e0a);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPE_FIELDS", ()=>$67f07001968fe110$export$6eaa6ce8101f6468);
    $parcel$export(module.exports, "ROUTE_NAMES_HELP_CENTER_SETTINGS_WEB_PORTAL", ()=>$67f07001968fe110$export$2e90ab5aa3463c0d);
    $parcel$export(module.exports, "ROUTE_NAMES_HOME_ONBOARDING_REDIRECT", ()=>$67f07001968fe110$export$d70320ae3b4d9e43);
    $parcel$export(module.exports, "ROUTE_NAMES_HOME_REDIRECT", ()=>$67f07001968fe110$export$b2b57cde1fa39bf5);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE", ()=>$67f07001968fe110$export$e8e3b3a04b70a016);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE_CREATE_EMBED", ()=>$67f07001968fe110$export$1a3116351e4f3550);
    $parcel$export(module.exports, "ROUTE_NAMES_ISSUE_EMBED", ()=>$67f07001968fe110$export$6e2629d41c380b47);
    $parcel$export(module.exports, "ROUTE_NAMES_JIRA_SEARCH", ()=>$67f07001968fe110$export$ced38e55e6d33a4e);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES", ()=>$67f07001968fe110$export$d61d16755cb40ff3);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR", ()=>$67f07001968fe110$export$bb6392f1b2e80781);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY", ()=>$67f07001968fe110$export$6fd25e722e91a0d8);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES", ()=>$67f07001968fe110$export$18f32f825e7a5a6f);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES", ()=>$67f07001968fe110$export$b17f22f274f4cd5e);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE", ()=>$67f07001968fe110$export$285854ec33f7cc);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY", ()=>$67f07001968fe110$export$77cf9c44bbdaa05b);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE", ()=>$67f07001968fe110$export$d6f1b92110a16f2a);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS", ()=>$67f07001968fe110$export$fea47b97c6086336);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS", ()=>$67f07001968fe110$export$264d0a2b60d052cd);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_LANDING", ()=>$67f07001968fe110$export$991ba0c465b48539);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH", ()=>$67f07001968fe110$export$904b472d57dee40d);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH_ARTICLES", ()=>$67f07001968fe110$export$bbe98dfa7f6a1e4a);
    $parcel$export(module.exports, "ROUTE_NAMES_KNOWLEDGE_HUB_SETUP", ()=>$67f07001968fe110$export$8cfdaccf43a32440);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_ALL_REPORTS", ()=>$67f07001968fe110$export$37bd400c00057d64);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BACKLOG", ()=>$67f07001968fe110$export$eb66bd587b5f093d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_BOARD", ()=>$67f07001968fe110$export$521baa72494c2a67);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_GENERAL", ()=>$67f07001968fe110$export$ca255c93be51d5bc);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CONNECT_PROJECT", ()=>$67f07001968fe110$export$51e45f736a60769b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_CUSTOM_REPORT", ()=>$67f07001968fe110$export$e64c3c8f45d7eb28);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_FALLBACK", ()=>$67f07001968fe110$export$5475ba822739444a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN", ()=>$67f07001968fe110$export$8483f5c57513e386);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_ISSUE", ()=>$67f07001968fe110$export$93c4d1960660bdb3);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_QUICKSEARCH", ()=>$67f07001968fe110$export$a5421dcc88027406);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS", ()=>$67f07001968fe110$export$81d5ef2e5cb06446);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_CUSTOMERS", ()=>$67f07001968fe110$export$77f5621cd10b53c5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_GETTING_STARTED", ()=>$67f07001968fe110$export$41008c2b014795bf);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_JIRA_AUTOMATION", ()=>$67f07001968fe110$export$3001841111579cf2);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_KNOWLEDGE", ()=>$67f07001968fe110$export$28dc2fac9c08502e);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES", ()=>$67f07001968fe110$export$4487dfcd6dce7088);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_QUEUES_MANAGE", ()=>$67f07001968fe110$export$c344587fa7092e8c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS", ()=>$67f07001968fe110$export$3fbd487079a23c0f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_REPORTS_CUSTOM", ()=>$67f07001968fe110$export$d6822df31c37b21a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_FALLBACK", ()=>$67f07001968fe110$export$d39bcac6fced7707);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE", ()=>$67f07001968fe110$export$da975f212e8a3e43);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_SETTINGS_LANGUAGE_PAGES", ()=>$67f07001968fe110$export$6e6feddeb62a0825);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_JSD_WIDGETS", ()=>$67f07001968fe110$export$d7df906c2ffbeab4);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PIN", ()=>$67f07001968fe110$export$c71836085985a7d3);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES", ()=>$67f07001968fe110$export$a17a19a9de903839);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_BAMBOO", ()=>$67f07001968fe110$export$e66c1e847a52ebb5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE", ()=>$67f07001968fe110$export$f0254c80025ed0fc);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE_CONFIG", ()=>$67f07001968fe110$export$1d4a64220d5b474d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS", ()=>$67f07001968fe110$export$8af215d394bc18c1);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_ADD", ()=>$67f07001968fe110$export$b6b536a795b08b39);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_HELP", ()=>$67f07001968fe110$export$59cde094247fca1a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS_VIEW", ()=>$67f07001968fe110$export$d27bf19e22921164);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_CONFIG", ()=>$67f07001968fe110$export$3467807847c0a87d);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS", ()=>$67f07001968fe110$export$1996eeee6a067f1c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DELETE", ()=>$67f07001968fe110$export$ec7cb9394e8994c9);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV", ()=>$67f07001968fe110$export$f01730982626c4af);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT", ()=>$67f07001968fe110$export$9d1758ddc1563e90);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS", ()=>$67f07001968fe110$export$ecff223feb9d08be);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS_ASSOCIATE", ()=>$67f07001968fe110$export$487bc26cddb34312);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT", ()=>$67f07001968fe110$export$118290072826cd87);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY", ()=>$67f07001968fe110$export$e5994b7b1acebe82);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY_ASSOCIATE", ()=>$67f07001968fe110$export$84b0e53f785e02cf);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES", ()=>$67f07001968fe110$export$d58992a667105ce8);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES_ASSOCIATE", ()=>$67f07001968fe110$export$bb1cea2d23743f65);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS", ()=>$67f07001968fe110$export$76dac5f55ab3705e);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS_ASSOCIATE", ()=>$67f07001968fe110$export$a7c4adb03bc6e997);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_OPSGENIE", ()=>$67f07001968fe110$export$2dc565d0b2334780);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE", ()=>$67f07001968fe110$export$28687a1181a7676f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS", ()=>$67f07001968fe110$export$2e74a7026073fa54);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS_ASSOCIATE", ()=>$67f07001968fe110$export$58fdfc78d176c564);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS", ()=>$67f07001968fe110$export$cb8548f16119b181);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS_ASSOCIATE", ()=>$67f07001968fe110$export$66e3f6af203a567f);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SUMMARY", ()=>$67f07001968fe110$export$658e7e21f1c7b69b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS", ()=>$67f07001968fe110$export$1fa628a4527d424c);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE", ()=>$67f07001968fe110$export$c2989c5c00f9f64b);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REDIRECT", ()=>$67f07001968fe110$export$2d21e5416485b195);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_AVERAGE_AGE", ()=>$67f07001968fe110$export$e514491aa85dd54a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CONFIG", ()=>$67f07001968fe110$export$d9662297242bfcb5);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_CREATED_VS_RESOLVED", ()=>$67f07001968fe110$export$2a53516b15393945);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_DEVELOPER_WORKLOAD", ()=>$67f07001968fe110$export$62e00190aa938a43);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_PIE", ()=>$67f07001968fe110$export$22a3924a6eab79ab);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RECENTLY_CREATED", ()=>$67f07001968fe110$export$677cf3d89d18bb74);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_RESOLUTION_TIME", ()=>$67f07001968fe110$export$7eef86163449ad98);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY", ()=>$67f07001968fe110$export$8f56061e1403fa5a);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_SINCE", ()=>$67f07001968fe110$export$adeb429de8df1e02);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_TIME_TRACKING_REPORT", ()=>$67f07001968fe110$export$931d6222073b5708);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_VERSION_WORKLOAD", ()=>$67f07001968fe110$export$2106f1ac8ba807e1);
    $parcel$export(module.exports, "ROUTE_NAMES_LEGACY_REPORTS_WORKLOAD_PIE", ()=>$67f07001968fe110$export$36678521a86f620b);
    $parcel$export(module.exports, "ROUTE_NAMES_LOGIN_EMBED", ()=>$67f07001968fe110$export$55248356780fc584);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE", ()=>$67f07001968fe110$export$cd84c5a333c8d16a);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_ADDONS_EMCEE_PUBLIC", ()=>$67f07001968fe110$export$624af6f61b05f55);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_APP_REQUESTS", ()=>$67f07001968fe110$export$2ed9525182145b82);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_INDEX", ()=>$67f07001968fe110$export$7fb2b42fc4e7df8b);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_MANAGE_APPS", ()=>$67f07001968fe110$export$fa962db82ae571b2);
    $parcel$export(module.exports, "ROUTE_NAMES_MARKETPLACE_PROMOTIONS", ()=>$67f07001968fe110$export$e145bf76b1aef705);
    $parcel$export(module.exports, "ROUTE_NAMES_NOTIFICATION_LOGS", ()=>$67f07001968fe110$export$8febbfb647e4c8b9);
    $parcel$export(module.exports, "ROUTE_NAMES_OPSGENIE_SCHEDULE", ()=>$67f07001968fe110$export$4b34f3d336f4ccd2);
    $parcel$export(module.exports, "ROUTE_NAMES_PEOPLE_INDEX", ()=>$67f07001968fe110$export$a979a5c1f5e3631c);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS", ()=>$67f07001968fe110$export$ffcbf91dfadffd0);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL", ()=>$67f07001968fe110$export$1807a39cc63b856c);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS", ()=>$67f07001968fe110$export$2be8d3c6fedd5276);
    $parcel$export(module.exports, "ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS", ()=>$67f07001968fe110$export$6268da7263eb670d);
    $parcel$export(module.exports, "ROUTE_NAMES_PLANS_DIRECTORY", ()=>$67f07001968fe110$export$93bd4a896a0fc581);
    $parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_EDIT", ()=>$67f07001968fe110$export$2b9b1bfb538ab810);
    $parcel$export(module.exports, "ROUTE_NAMES_PLAYBOOKS_LIST", ()=>$67f07001968fe110$export$d1217085321b2648);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_COLLECTIONS", ()=>$67f07001968fe110$export$39624171b7c8a10a);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_IDEAS", ()=>$67f07001968fe110$export$1654cd6813e90e6b);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_INSIGHTS", ()=>$67f07001968fe110$export$33059cd02df2febd);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ONBOARDING", ()=>$67f07001968fe110$export$1d746ff2bc48ceb4);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_PLAYS", ()=>$67f07001968fe110$export$145c578104a45fd2);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_ROOMS", ()=>$67f07001968fe110$export$a51df1bc877c58e5);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_ACCESS", ()=>$67f07001968fe110$export$45208fff8de46880);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_SETTINGS_GLOBAL_FIELDS", ()=>$67f07001968fe110$export$c710a35d40378fa5);
    $parcel$export(module.exports, "ROUTE_NAMES_POLARIS_UNLICENSED", ()=>$67f07001968fe110$export$15d6b93ff5273ce3);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_AUTHENTICATION_SETTINGS", ()=>$67f07001968fe110$export$e26f2863c7ccd504);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS", ()=>$67f07001968fe110$export$496da9aa0fe819ff);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_COMPLIANCE", ()=>$67f07001968fe110$export$f7bbc23b5f8e2d3b);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CONFIGURATION", ()=>$67f07001968fe110$export$53ce69fb34f6d286);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_CUSTOMER_ACCESS", ()=>$67f07001968fe110$export$b6e861786143eb1b);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_EMAIL_REQUESTS", ()=>$67f07001968fe110$export$f7e3d3b413c017e1);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_FEATURE_USAGE", ()=>$67f07001968fe110$export$b84d34b8175abde5);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS", ()=>$67f07001968fe110$export$50e4e3e5231fb74f);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS", ()=>$67f07001968fe110$export$39d913ae557ba8f3);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_KB_PERMISSIONS", ()=>$67f07001968fe110$export$a2d9bcceac584c93);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS", ()=>$67f07001968fe110$export$eb2e5f1608ec8b32);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION", ()=>$67f07001968fe110$export$9ac90b948c53bf58);
    $parcel$export(module.exports, "ROUTE_NAMES_PRODUCTS_JSW_STORAGE_MANAGEMENT", ()=>$67f07001968fe110$export$bb5665894498893f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_CLASSIC_BUSINESS", ()=>$67f07001968fe110$export$fc61479fdfdd263a);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_SERVICEDESK", ()=>$67f07001968fe110$export$5ae82b891e42770e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_EXPORT_SOFTWARE", ()=>$67f07001968fe110$export$8dcc46e162f2235b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_CLASSIC_BUSINESS", ()=>$67f07001968fe110$export$a934caa57ac0ac0b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SERVICEDESK", ()=>$67f07001968fe110$export$25a4e6c77f91c259);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SOFTWARE", ()=>$67f07001968fe110$export$2a9a9bab313fd713);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_CLASSIC_BUSINESS", ()=>$67f07001968fe110$export$82ad2da638fc34d8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SERVICEDESK", ()=>$67f07001968fe110$export$ff67cffdbd881a41);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SOFTWARE", ()=>$67f07001968fe110$export$c41c7d73df3fc08c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_CLASSIC_BUSINESS", ()=>$67f07001968fe110$export$65f234e4799edddc);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SERVICEDESK", ()=>$67f07001968fe110$export$215ea4e7405fa88c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SOFTWARE", ()=>$67f07001968fe110$export$927b1972180d9cc4);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY", ()=>$67f07001968fe110$export$ff1365ce4d652337);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA", ()=>$67f07001968fe110$export$79b30013cbfdee04);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE", ()=>$67f07001968fe110$export$33c2dcc7c7abc45e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECTS_REDIRECT", ()=>$67f07001968fe110$export$a6ef20aa08a533b1);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_COMPONENTS", ()=>$67f07001968fe110$export$5908e15483da8a45);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_DIRECTORY_REDIRECT", ()=>$67f07001968fe110$export$a3812f6f4e60d897);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR", ()=>$67f07001968fe110$export$3c8c119f40a061a9);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC", ()=>$67f07001968fe110$export$47e034646abefdb2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE", ()=>$67f07001968fe110$export$f36f4cf8b17f250f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_NOT_FOUND", ()=>$67f07001968fe110$export$841e880a0d425b3e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_PAGES", ()=>$67f07001968fe110$export$1fde4a6e7df24a97);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION", ()=>$67f07001968fe110$export$69335bf8b709edc7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS", ()=>$67f07001968fe110$export$946b472f7559a889);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS", ()=>$67f07001968fe110$export$373fdf6888021ed0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS_REDIRECT", ()=>$67f07001968fe110$export$d6a5f13a3d30923c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPROVALS", ()=>$67f07001968fe110$export$adfff93b0b015409);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS", ()=>$67f07001968fe110$export$404de4ddea701cff);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS_FIELDS", ()=>$67f07001968fe110$export$596e1f6f6f4997b2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION", ()=>$67f07001968fe110$export$8da0e4cdbdd0cd0b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DATA_CLASSIFICATIONS", ()=>$67f07001968fe110$export$d610a17dff3a01fa);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DEFAULT_REDIRECT", ()=>$67f07001968fe110$export$284db5107f3db516);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS", ()=>$67f07001968fe110$export$fbce46826eefc586);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FIELDS", ()=>$67f07001968fe110$export$c86b29c76317ac6f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS", ()=>$67f07001968fe110$export$3160b86e1b5dc391);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES", ()=>$67f07001968fe110$export$690c0080c930fca);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES_WORKFLOW", ()=>$67f07001968fe110$export$171ba8c33c05c4ef);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS", ()=>$67f07001968fe110$export$e2f2c23286c3255c);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS_ISSUE_LOGS", ()=>$67f07001968fe110$export$5a262d40e10207a1);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL", ()=>$67f07001968fe110$export$ab790cb87175797e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_JIRA_FORM_BUILDER", ()=>$67f07001968fe110$export$db780b39656c673a);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_PROJECT_FORMS", ()=>$67f07001968fe110$export$a77cb4dafc511d3);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS", ()=>$67f07001968fe110$export$253fd82874264ee4);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS_NEXTGEN", ()=>$67f07001968fe110$export$eaf9ab4ec0c25813);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_APPS_FIELDS", ()=>$67f07001968fe110$export$574bcdf6b73fcf1f);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT", ()=>$67f07001968fe110$export$a14853dfff8da872);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_NOTIFICATIONS", ()=>$67f07001968fe110$export$ba8fd0e6db8d3e08);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_PERMISSIONS", ()=>$67f07001968fe110$export$1c74da1e52e6d212);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS", ()=>$67f07001968fe110$export$d416059b17fe7d4e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_WIDGET_SETTINGS", ()=>$67f07001968fe110$export$d5a3a037d2760bb7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN", ()=>$67f07001968fe110$export$eb187d42a7448d45);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_DETAILS", ()=>$67f07001968fe110$export$688de32d31fc70f5);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS", ()=>$67f07001968fe110$export$13d770f8814d480a);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES", ()=>$67f07001968fe110$export$3a628f9376166ffb);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_ITSM_REQUEST_TYPES_FIELDS", ()=>$67f07001968fe110$export$649dafa225625f30);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS", ()=>$67f07001968fe110$export$dbfe76dd37018b2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL", ()=>$67f07001968fe110$export$20db7bb9d1bd8b38);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATION_EMAIL", ()=>$67f07001968fe110$export$a1fa8e6e125780ae);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS", ()=>$67f07001968fe110$export$fc6b949fd2bc782d);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES", ()=>$67f07001968fe110$export$c940f866ac7760a0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_REQUEST_TYPES_FIELDS", ()=>$67f07001968fe110$export$184d4979f6f9fe7e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES", ()=>$67f07001968fe110$export$959f50de166cc45e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_UNASSIGNED_REQUEST_TYPES_FIELDS", ()=>$67f07001968fe110$export$b13b8c8bb4e30a75);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS", ()=>$67f07001968fe110$export$40d6fc2b9a4f09d2);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_APPS_FIELDS", ()=>$67f07001968fe110$export$cc1af211e3feda50);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_AUTOMATION", ()=>$67f07001968fe110$export$3873539001f5aed7);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CARD", ()=>$67f07001968fe110$export$89fcbafce559080b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CSM", ()=>$67f07001968fe110$export$c3f05da9e4e13249);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CUSTOM_FILTERS", ()=>$67f07001968fe110$export$619694ab37142384);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_DETAILS", ()=>$67f07001968fe110$export$cb89b516b9cf418b);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_FEATURES", ()=>$67f07001968fe110$export$50680f54e95bb859);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_INSIGHTS", ()=>$67f07001968fe110$export$194c2b4da7e38757);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_REDIRECT", ()=>$67f07001968fe110$export$962d838817f090f8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_ROADMAP", ()=>$67f07001968fe110$export$eacbdb340a470309);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_SWIMLANES", ()=>$67f07001968fe110$export$6a7782d87a21425d);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_TIMELINE", ()=>$67f07001968fe110$export$c2f56336162e799e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DATA_CLASSIFICATIONS", ()=>$67f07001968fe110$export$ba419378ad70624e);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_DETAILS", ()=>$67f07001968fe110$export$62f38c589a73d386);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FIELDS", ()=>$67f07001968fe110$export$77c8066c0822f152);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FEATURES", ()=>$67f07001968fe110$export$90900ebfa6f48861);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ISSUE_TYPES", ()=>$67f07001968fe110$export$93ff02c205edd1a8);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS", ()=>$67f07001968fe110$export$db7f5d93be70ee30);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS", ()=>$67f07001968fe110$export$432229516b7f82da);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL", ()=>$67f07001968fe110$export$8f554d4ef9f084c0);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_OPSGENIE", ()=>$67f07001968fe110$export$6b2b99b0055772a3);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_TOOLCHAIN", ()=>$67f07001968fe110$export$83c7a51057be6264);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS", ()=>$67f07001968fe110$export$46706d786aab3829);
    $parcel$export(module.exports, "ROUTE_NAMES_PROJECT_VERSIONS", ()=>$67f07001968fe110$export$b690025ef7e3cf6c);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD", ()=>$67f07001968fe110$export$ea48cc6bf1183d11);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG", ()=>$67f07001968fe110$export$930e4881302bbd54);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED", ()=>$67f07001968fe110$export$375801b708576466);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD", ()=>$67f07001968fe110$export$5b1e8463bd590143);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED", ()=>$67f07001968fe110$export$1606662a398a24be);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_LAST_VISITED_PROJECT_REDIRECT", ()=>$67f07001968fe110$export$c5b19a37e49ceb28);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_REPORT", ()=>$67f07001968fe110$export$c46680afe70295f3);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_UIF_BACKLOG", ()=>$67f07001968fe110$export$831fc7eba98b58c9);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG", ()=>$67f07001968fe110$export$4061c0c586f3b7c8);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_BOARD", ()=>$67f07001968fe110$export$99e0abd8ba1de289);
    $parcel$export(module.exports, "ROUTE_NAMES_RAPIDBOARD_USER_REPORT", ()=>$67f07001968fe110$export$cd96a6a0cc4831ab);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS", ()=>$67f07001968fe110$export$db1b3d2fee80859);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY", ()=>$67f07001968fe110$export$b0f3f3214ab1b150);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_BOARDS", ()=>$67f07001968fe110$export$fb4e3ee7e7c21e9f);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CALENDAR", ()=>$67f07001968fe110$export$8c8f03e75b6708ac);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CALENDAR_EAP", ()=>$67f07001968fe110$export$2e93790099768be5);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR", ()=>$67f07001968fe110$export$3c3d8caf61c9aa0c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS", ()=>$67f07001968fe110$export$f9cc808094ce0ddd);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE", ()=>$67f07001968fe110$export$9bde4a0b155f2972);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT", ()=>$67f07001968fe110$export$a52f5ffbbe135078);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA", ()=>$67f07001968fe110$export$e6773bf0fbccdb9c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION", ()=>$67f07001968fe110$export$8e3dd8487a7b65bd);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION", ()=>$67f07001968fe110$export$258b44fcc29a5961);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS", ()=>$67f07001968fe110$export$ea1146ebce07be6d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT", ()=>$67f07001968fe110$export$53731240ce2d3b76);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE", ()=>$67f07001968fe110$export$956eb40834ddee22);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT", ()=>$67f07001968fe110$export$9057470ebf41169);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME", ()=>$67f07001968fe110$export$c42e107c5275b36);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE", ()=>$67f07001968fe110$export$3e7c6a54a9d2267a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE", ()=>$67f07001968fe110$export$c3e2697b35a149c4);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT", ()=>$67f07001968fe110$export$288c7dd61dd0c291);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA", ()=>$67f07001968fe110$export$37161a981d69c891);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION", ()=>$67f07001968fe110$export$cfe61aa92a4d585d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION", ()=>$67f07001968fe110$export$9ed512ab4c81669c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT", ()=>$67f07001968fe110$export$37a9bdd8513f462d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT", ()=>$67f07001968fe110$export$f01162415f3a2ee3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2", ()=>$67f07001968fe110$export$860dd13b1e836ed8);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS", ()=>$67f07001968fe110$export$5eaf1dce55090ff3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS", ()=>$67f07001968fe110$export$1fe309e7cdbd1c1);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS", ()=>$67f07001968fe110$export$fcd9750494ff0236);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_EARLY_ACCESS_ITSM", ()=>$67f07001968fe110$export$ad856b38e93b93b2);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE", ()=>$67f07001968fe110$export$a833209ca71d2e56);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INCIDENTS", ()=>$67f07001968fe110$export$829d1776460a6ad3);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_INDEX", ()=>$67f07001968fe110$export$d30ab2da08d8b7b9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUE", ()=>$67f07001968fe110$export$3c71889849aeaa08);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ISSUES", ()=>$67f07001968fe110$export$354bf2df81f6ffb0);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ITSM_SAMPLE_SPACE", ()=>$67f07001968fe110$export$f8880b461acd270d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_JIRA_AUTOMATION", ()=>$67f07001968fe110$export$876055c0ede2f8df);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS", ()=>$67f07001968fe110$export$bf493c66e34711c8);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE", ()=>$67f07001968fe110$export$212f6e2c7c2a53bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE", ()=>$67f07001968fe110$export$7c28c6e8d8a6545);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE", ()=>$67f07001968fe110$export$8d55b6ef2cd92f8c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS", ()=>$67f07001968fe110$export$f7fbe9a4717b7a50);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS", ()=>$67f07001968fe110$export$8c800f176d079d28);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2", ()=>$67f07001968fe110$export$1c5fbcbfc0923176);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE", ()=>$67f07001968fe110$export$59644e5d8d69a016);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT", ()=>$67f07001968fe110$export$c7074ebe0ca83f98);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE", ()=>$67f07001968fe110$export$2b4737953287a354);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING", ()=>$67f07001968fe110$export$e7a8d6d534c5e2fe);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW", ()=>$67f07001968fe110$export$5dcba309e2bfa88b);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW", ()=>$67f07001968fe110$export$2d961b0101f8733e);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_PROJECT_CONVERSION", ()=>$67f07001968fe110$export$195fe2558f1a8591);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON", ()=>$67f07001968fe110$export$1b3cf68be370a45b);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE", ()=>$67f07001968fe110$export$45c35381e5da2232);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT", ()=>$67f07001968fe110$export$d479ba53b9bf65a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE", ()=>$67f07001968fe110$export$ccd12890649c59cc);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING", ()=>$67f07001968fe110$export$8c84064031188e80);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW", ()=>$67f07001968fe110$export$46c6fef035fbe8ba);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_QUEUES_NEW", ()=>$67f07001968fe110$export$6fb23ec5a12d5c24);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REDIRECT", ()=>$67f07001968fe110$export$156b2dfbd87d576f);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS", ()=>$67f07001968fe110$export$6961f1ed0407cb26);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM", ()=>$67f07001968fe110$export$ba284efd679bf637);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE", ()=>$67f07001968fe110$export$e48a3df597407767);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT", ()=>$67f07001968fe110$export$c73718d4a6efea1d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE", ()=>$67f07001968fe110$export$ed454783ba1bacb9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE", ()=>$67f07001968fe110$export$48f6285d4729ca9d);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION", ()=>$67f07001968fe110$export$8066418cead2d2ef);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE", ()=>$67f07001968fe110$export$b3db7857ac710a89);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE", ()=>$67f07001968fe110$export$d574810e3edad044);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY", ()=>$67f07001968fe110$export$be4b2ffade787316);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE", ()=>$67f07001968fe110$export$3caf79b5f4be02d7);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD", ()=>$67f07001968fe110$export$29bc361328055683);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES", ()=>$67f07001968fe110$export$a4a5a333fe874d97);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_NEW", ()=>$67f07001968fe110$export$2193b681ac1ae132);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT", ()=>$67f07001968fe110$export$f1bfd5b3918619a9);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS", ()=>$67f07001968fe110$export$a4c4f7898d6b914a);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_NEW", ()=>$67f07001968fe110$export$6cffae90b9277bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT", ()=>$67f07001968fe110$export$17e76ebd53424ed5);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_EDIT", ()=>$67f07001968fe110$export$b1329dc26a81a277);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_NEW", ()=>$67f07001968fe110$export$e1cba0bfe330f5c);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS", ()=>$67f07001968fe110$export$8e68c55c334de101);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICES", ()=>$67f07001968fe110$export$5cb7cfba189a0240);
    $parcel$export(module.exports, "ROUTE_NAMES_SERVICE_HUB_SERVICE_DETAILS", ()=>$67f07001968fe110$export$d28aab4a6d6f1d0d);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_AUTOMATION", ()=>$67f07001968fe110$export$1cf56e2d6c4edb35);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG", ()=>$67f07001968fe110$export$27c1770584d7e3fe);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS", ()=>$67f07001968fe110$export$22e0ebdea08537f7);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_RECOMMENDATIONS", ()=>$67f07001968fe110$export$4db732436e4edfaf);
    $parcel$export(module.exports, "ROUTE_NAMES_SETTINGS_VIEW_CUSTOM_FIELDS", ()=>$67f07001968fe110$export$e832418dbed0717e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS", ()=>$67f07001968fe110$export$ee09be798f0e4471);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT", ()=>$67f07001968fe110$export$653bf90ae3578f21);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT", ()=>$67f07001968fe110$export$9da4125a0c62444d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP", ()=>$67f07001968fe110$export$fbcc0fd9b402bb12);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES", ()=>$67f07001968fe110$export$e74fe5bd41e23fbd);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT", ()=>$67f07001968fe110$export$1a93e63ddbe4aa06);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR", ()=>$67f07001968fe110$export$3b6dbbe49882589d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS", ()=>$67f07001968fe110$export$eb01394789016fd4);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT", ()=>$67f07001968fe110$export$f17f4523583fa8e5);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS", ()=>$67f07001968fe110$export$eaa4d6eec75a6778);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT", ()=>$67f07001968fe110$export$dcc96e4abbdc0d39);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG", ()=>$67f07001968fe110$export$9eaf39ba5a56c72a);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BACKLOG_EMBED", ()=>$67f07001968fe110$export$495be3320b67814a);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS", ()=>$67f07001968fe110$export$25752eb5bb5e3d32);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_BOARDS_EMBED", ()=>$67f07001968fe110$export$f116716aedb35e10);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR", ()=>$67f07001968fe110$export$36fffb6b49d9f31d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC", ()=>$67f07001968fe110$export$a6d07be4ff318f84);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC_EMBED", ()=>$67f07001968fe110$export$a9a43f1114df1ad9);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CALENDAR_EMBED", ()=>$67f07001968fe110$export$3a4c7a521a900b4d);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT", ()=>$67f07001968fe110$export$9dcf51a9040a4fd6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT_EMBED", ()=>$67f07001968fe110$export$a74f9f6bd0d4fb26);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE", ()=>$67f07001968fe110$export$f8cb86acf6b74661);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_CODE_CLASSIC", ()=>$67f07001968fe110$export$2d3d850c64058bfb);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS", ()=>$67f07001968fe110$export$af6b51164f66908b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC", ()=>$67f07001968fe110$export$12efc96fc9c9fb34);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM", ()=>$67f07001968fe110$export$6ab1901e04e623ba);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_CLASSIC", ()=>$67f07001968fe110$export$bccc7d0812737c4e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_BUILDER", ()=>$67f07001968fe110$export$458fb992f2637a20);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC", ()=>$67f07001968fe110$export$c9c9c64f68ba51e3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT", ()=>$67f07001968fe110$export$50264cbc90a39f19);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC", ()=>$67f07001968fe110$export$b9d0cbe0888fa72e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS", ()=>$67f07001968fe110$export$b8045610416fa8ca);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC", ()=>$67f07001968fe110$export$8e80136ad13099e3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS", ()=>$67f07001968fe110$export$b5fe44c0bc324494);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC", ()=>$67f07001968fe110$export$7a4f52d9060a20d2);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR", ()=>$67f07001968fe110$export$d6a9e4695952522e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST", ()=>$67f07001968fe110$export$deab88d0814c564b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC", ()=>$67f07001968fe110$export$906faff110f898ef);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_CLASSIC_EMBED", ()=>$67f07001968fe110$export$ab3f2a34a3b0db87);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_LIST_EMBED", ()=>$67f07001968fe110$export$4ed84a2011fdc400);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_NEXTGEN_REDIRECT", ()=>$67f07001968fe110$export$f7b286b39bf6051b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING", ()=>$67f07001968fe110$export$6c4337c0332c8c7f);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED", ()=>$67f07001968fe110$export$e7c78887745b2326);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE", ()=>$67f07001968fe110$export$3805e4f07dca7584);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC", ()=>$67f07001968fe110$export$f77254983320e888);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR", ()=>$67f07001968fe110$export$2e784832f1c6bb);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED", ()=>$67f07001968fe110$export$7f97fa79520a4c5b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES", ()=>$67f07001968fe110$export$9e53cdb1ac02195c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES_EMBED", ()=>$67f07001968fe110$export$58bd507904dc221c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT", ()=>$67f07001968fe110$export$7a821e22be2c2f14);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT_EMBED", ()=>$67f07001968fe110$export$ca8966ef80bfafc6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS", ()=>$67f07001968fe110$export$e7423156dba31a7c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_RELEASES", ()=>$67f07001968fe110$export$cba7e383b2409c7b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER", ()=>$67f07001968fe110$export$d5378fb71d5242c0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS", ()=>$67f07001968fe110$export$4b16b72c72da8833);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES", ()=>$67f07001968fe110$export$10114d78cefb1f53);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE", ()=>$67f07001968fe110$export$92fe23ed30100817);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES", ()=>$67f07001968fe110$export$e824495554c83069);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PERMISSIONS", ()=>$67f07001968fe110$export$8df2e9efdd625a44);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PLAN_INFO", ()=>$67f07001968fe110$export$aeb4d3006e298033);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS", ()=>$67f07001968fe110$export$e15d3c40985c4b53);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES", ()=>$67f07001968fe110$export$1d8c84454fd2d571);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS", ()=>$67f07001968fe110$export$db61a12efb59745c);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCENARIOS", ()=>$67f07001968fe110$export$2da67fb5bd6bc2ee);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCHEDULING", ()=>$67f07001968fe110$export$182e0167fd960de6);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY", ()=>$67f07001968fe110$export$2d9e2484ee02e7da);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY_EMBED", ()=>$67f07001968fe110$export$b7fff19fd89b617f);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TEAMS", ()=>$67f07001968fe110$export$ea23f150f64e8a4e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE", ()=>$67f07001968fe110$export$116338bd93f78ad0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE_EMBED", ()=>$67f07001968fe110$export$c9cd65a78227cf18);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_PRESENTATION_TOOLKIT_REPORT", ()=>$67f07001968fe110$export$7a4b4b66d7637fbb);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_RELEASE_NOTES", ()=>$67f07001968fe110$export$d75d93e5d44182cc);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS", ()=>$67f07001968fe110$export$cc3027ae3767801);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN", ()=>$67f07001968fe110$export$3492ce83b8884e0e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP", ()=>$67f07001968fe110$export$b4798b7e62733393);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL", ()=>$67f07001968fe110$export$388685c701d6e0d3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE", ()=>$67f07001968fe110$export$5ff4d2d4257ea2b0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME", ()=>$67f07001968fe110$export$fa83895c1eac55e7);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC", ()=>$67f07001968fe110$export$5c82bb95a06a1846);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY", ()=>$67f07001968fe110$export$c725b9c7e11dd69e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC", ()=>$67f07001968fe110$export$90594f89c675ba05);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY", ()=>$67f07001968fe110$export$ae0d999dd2bdd59b);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REQUESTS", ()=>$67f07001968fe110$export$43bbf6935a91d277);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC", ()=>$67f07001968fe110$export$92e23977438282b2);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP", ()=>$67f07001968fe110$export$296115eb5b7129d3);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC", ()=>$67f07001968fe110$export$17574f41c3925d64);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_ROADMAP_REDIRECT", ()=>$67f07001968fe110$export$955692fbfe35fc16);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY", ()=>$67f07001968fe110$export$30af3a767b8ad2d8);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC", ()=>$67f07001968fe110$export$f47d664298c2c2f0);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE", ()=>$67f07001968fe110$export$1714b5ad9b672bc7);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC", ()=>$67f07001968fe110$export$c9634bf15518a3a1);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL", ()=>$67f07001968fe110$export$3b5eb3ea8cbeeed);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT", ()=>$67f07001968fe110$export$c29d90ae9a4b648e);
    $parcel$export(module.exports, "ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH", ()=>$67f07001968fe110$export$8f2717a951373c25);
    $parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_CONFIGURATION", ()=>$67f07001968fe110$export$831acb5098f5706d);
    $parcel$export(module.exports, "ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT", ()=>$67f07001968fe110$export$d218cda46c433fe1);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK", ()=>$67f07001968fe110$export$61147168ac2833f9);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASH_PLANS_DIRECTORY", ()=>$67f07001968fe110$export$9fe0117c0fd486a8);
    $parcel$export(module.exports, "ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY", ()=>$67f07001968fe110$export$a49474778d15635d);
    $parcel$export(module.exports, "ROUTE_NAMES_USER_SEGMENTATION", ()=>$67f07001968fe110$export$af3296e54e7fb362);
    $parcel$export(module.exports, "ROUTE_NAMES_YOUR_WORK", ()=>$67f07001968fe110$export$281f2e01ee9e4977);
    const $67f07001968fe110$export$1ba937db1fe6ef01 = 'archive-issues';
    const $67f07001968fe110$export$3fd002e197e83a30 = 'arj-settings';
    const $67f07001968fe110$export$bbf08d4d25df5504 = 'classic-business';
    const $67f07001968fe110$export$e3e759b7f50aaee1 = 'classic-software';
    const $67f07001968fe110$export$89337611b52bc9a3 = 'components';
    const $67f07001968fe110$export$3d7937b12eb9e5d5 = 'connect';
    const $67f07001968fe110$export$7a3d181d86fce9e6 = 'dashboard';
    const $67f07001968fe110$export$294c878a3842c859 = 'dashboards';
    const $67f07001968fe110$export$7a22726acd7d6021 = 'devops';
    const $67f07001968fe110$export$f3f4a9f53ba00861 = 'directories';
    const $67f07001968fe110$export$112d69653b2f1d8b = 'eoc';
    const $67f07001968fe110$export$74e0426b66571086 = 'errors';
    const $67f07001968fe110$export$c2e20e142c95c1ce = 'global-settings';
    const $67f07001968fe110$export$f8cea29bebf098c = 'helpcenter-settings';
    const $67f07001968fe110$export$5801ef8dfc9a2f70 = 'home';
    const $67f07001968fe110$export$7246838143f848f3 = 'issue';
    const $67f07001968fe110$export$54f96702980a2f87 = 'issue-navigator';
    const $67f07001968fe110$export$5566db8fbd042fc4 = 'legacy';
    const $67f07001968fe110$export$20344ad17b5fca86 = 'legacy-jsd-settings';
    const $67f07001968fe110$export$656d0cc2c67b2708 = 'marketplace';
    const $67f07001968fe110$export$bfdbcebc4c81b043 = 'people-profiles';
    const $67f07001968fe110$export$82021d71ad19e227 = 'personal-settings';
    const $67f07001968fe110$export$6f266218a6973848 = 'plan-settings';
    const $67f07001968fe110$export$a846fcaeeea8e0ff = 'polaris';
    const $67f07001968fe110$export$6c87a9dff4e7a2de = 'proforma';
    const $67f07001968fe110$export$ab79970dcfac06a1 = 'project-settings-classic';
    const $67f07001968fe110$export$d1a70f80bb22f18a = 'project-settings-core';
    const $67f07001968fe110$export$bd925e9fcb6ce37f = 'project-settings-servicedesk';
    const $67f07001968fe110$export$86509a1baabd62ee = 'project-settings-software';
    const $67f07001968fe110$export$98823ed9eedfc756 = 'project-settings-software-boards';
    const $67f07001968fe110$export$da8d13fe1ccd5c09 = 'redirects';
    const $67f07001968fe110$export$78fb2f6176b7c6b8 = 'servicedesk';
    const $67f07001968fe110$export$d4a2a2e87da2135a = 'services';
    const $67f07001968fe110$export$26efaec7a7a8b361 = 'software';
    const $67f07001968fe110$export$db781fb68c08f7e2 = 'versions';
    const $67f07001968fe110$export$88041353cc69458d = 'archived-issues-directory';
    const $67f07001968fe110$export$f88d57dcb03ba452 = 'archived-plans-directory';
    const $67f07001968fe110$export$e8aa63af071c2da9 = 'archived-projects-directory';
    const $67f07001968fe110$export$b114d0da2ebcff6c = 'archived-project-direct-link';
    const $67f07001968fe110$export$29cc94b8cea5c920 = 'boards-directory';
    const $67f07001968fe110$export$4d1b45005cdcfb39 = 'browse-project-redirect';
    const $67f07001968fe110$export$a42ea04fdf53eeaf = 'next-gen-business-board';
    const $67f07001968fe110$export$ca4c5f5b3e2daa18 = 'business-classic-reports';
    const $67f07001968fe110$export$d58a5411a2ac6260 = 'next-gen-business-reports';
    const $67f07001968fe110$export$24514ee19772b5af = `${$67f07001968fe110$export$bbf08d4d25df5504}-onboarding-get-started`;
    const $67f07001968fe110$export$ec333dd1d6a8b38 = `${$67f07001968fe110$export$bbf08d4d25df5504}-overview-calendar`;
    const $67f07001968fe110$export$ed495fbad44791af = `${$67f07001968fe110$export$bbf08d4d25df5504}-overview-redirect`;
    const $67f07001968fe110$export$5281552f8109b7c0 = `${$67f07001968fe110$export$bbf08d4d25df5504}-overview-summary`;
    const $67f07001968fe110$export$6e8473713ed4557a = `${$67f07001968fe110$export$bbf08d4d25df5504}-overview-timeline`;
    const $67f07001968fe110$export$cbdd5c24d69b2cb1 = `${$67f07001968fe110$export$bbf08d4d25df5504}-approvals`;
    const $67f07001968fe110$export$e7f012f402be01ea = `${$67f07001968fe110$export$bbf08d4d25df5504}-attachments`;
    const $67f07001968fe110$export$b34d3882b42d660d = `${$67f07001968fe110$export$bbf08d4d25df5504}-board`;
    const $67f07001968fe110$export$ed869c60c6a56182 = `${$67f07001968fe110$export$bbf08d4d25df5504}-board-embed`;
    const $67f07001968fe110$export$5013269f29c75b37 = `${$67f07001968fe110$export$bbf08d4d25df5504}-calendar`;
    const $67f07001968fe110$export$fc8b48319e993d43 = `${$67f07001968fe110$export$bbf08d4d25df5504}-calendar-embed`;
    const $67f07001968fe110$export$40903feb5b038923 = `${$67f07001968fe110$export$bbf08d4d25df5504}-files`;
    const $67f07001968fe110$export$d6e60a2059f028d = `${$67f07001968fe110$export$bbf08d4d25df5504}-form`;
    const $67f07001968fe110$export$3d589aae17a00bc9 = `${$67f07001968fe110$export$bbf08d4d25df5504}-form-builder`;
    const $67f07001968fe110$export$bd92ef03b23dd672 = `${$67f07001968fe110$export$bbf08d4d25df5504}-form-submit`;
    const $67f07001968fe110$export$fa7fc44c718fc850 = `${$67f07001968fe110$export$bbf08d4d25df5504}-form-submit-embed`;
    const $67f07001968fe110$export$1dffaf831e01e2b4 = `${$67f07001968fe110$export$bbf08d4d25df5504}-list`;
    const $67f07001968fe110$export$5f8187412dd60f35 = `${$67f07001968fe110$export$bbf08d4d25df5504}-list-embed`;
    const $67f07001968fe110$export$3d2c1c04d18f6c43 = `${$67f07001968fe110$export$bbf08d4d25df5504}-sample-onboarding`;
    const $67f07001968fe110$export$cd22a5d8f560a1d8 = `${$67f07001968fe110$export$bbf08d4d25df5504}-shortcut`;
    const $67f07001968fe110$export$cad1b1aa5ce26bbc = `${$67f07001968fe110$export$bbf08d4d25df5504}-summary`;
    const $67f07001968fe110$export$ee073463b4144367 = `${$67f07001968fe110$export$bbf08d4d25df5504}-summary-embed`;
    const $67f07001968fe110$export$ea034943499772ea = `${$67f07001968fe110$export$bbf08d4d25df5504}-timeline`;
    const $67f07001968fe110$export$19bc888bcf37d22d = `${$67f07001968fe110$export$bbf08d4d25df5504}-timeline-embed`;
    const $67f07001968fe110$export$e0746183e11767fb = `${$67f07001968fe110$export$bbf08d4d25df5504}-redirect`;
    const $67f07001968fe110$export$3e2d215ce157adc8 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-code`;
    const $67f07001968fe110$export$8a8485bb05daf40b = `${$67f07001968fe110$export$d1a70f80bb22f18a}-proforma-project-forms`;
    const $67f07001968fe110$export$a2799b01de5bb62 = `${$67f07001968fe110$export$ab79970dcfac06a1}-data-classifications`;
    const $67f07001968fe110$export$1bc2b66dcb07293a = `${$67f07001968fe110$export$e3e759b7f50aaee1}-details`;
    const $67f07001968fe110$export$2d4f89c4b1ee3640 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-features`;
    const $67f07001968fe110$export$75609d3416c31f79 = `${$67f07001968fe110$export$ab79970dcfac06a1}-issue-layout`;
    const $67f07001968fe110$export$79793dc26e0b7b1a = `${$67f07001968fe110$export$e3e759b7f50aaee1}-notifications-notification-email`;
    const $67f07001968fe110$export$2eda7466fbfdef43 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-link-opsgenie`;
    const $67f07001968fe110$export$417297669917ee1a = `${$67f07001968fe110$export$e3e759b7f50aaee1}-details`;
    const $67f07001968fe110$export$8c79f3309ac0737 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-notifications`;
    const $67f07001968fe110$export$ef71a22e7befd35c = `${$67f07001968fe110$export$e3e759b7f50aaee1}-notifications-issue-logs`;
    const $67f07001968fe110$export$62ba1e294f5007c1 = `${$67f07001968fe110$export$86509a1baabd62ee}-proforma-edit-forms`;
    const $67f07001968fe110$export$a4315324546ecc89 = `${$67f07001968fe110$export$86509a1baabd62ee}-proforma-project-forms`;
    const $67f07001968fe110$export$a653cf6d478b3df1 = `${$67f07001968fe110$export$86509a1baabd62ee}-toolchain-company-managed`;
    const $67f07001968fe110$export$b0f268fe53a03e98 = 'compass-product-settings';
    const $67f07001968fe110$export$f4160b48e4ab8f39 = 'confluence-product-settings';
    const $67f07001968fe110$export$608f359cf8b08d2e = 'connect-general';
    const $67f07001968fe110$export$8bfbf790fe89f8d3 = 'connect-general-invalid';
    const $67f07001968fe110$export$d7011d1ed949f970 = 'connect-general-service-desk-project';
    const $67f07001968fe110$export$bd2506db44585db6 = 'connect-project';
    const $67f07001968fe110$export$200fa5ad16f8c112 = 'create-project';
    const $67f07001968fe110$export$21702f145fe1bbb0 = 'customer-service-accounts';
    const $67f07001968fe110$export$a296bb962bea95b5 = 'dashboard';
    const $67f07001968fe110$export$b9960c143c0414eb = 'dashboards-directory';
    const $67f07001968fe110$export$411171d2fcaefaea = 'dashboards-directory-secure';
    const $67f07001968fe110$export$ee104ed514f63003 = 'dashboard-edit';
    const $67f07001968fe110$export$9233f9ddcecd3062 = 'dashboard-selected';
    const $67f07001968fe110$export$b3240ec044a6c70f = 'dashboard-view';
    const $67f07001968fe110$export$2463c779e12367e3 = 'dashboard-view-embed';
    const $67f07001968fe110$export$dd3e5187eae2abe9 = 'dashboard-wallboard';
    const $67f07001968fe110$export$38ca7e07048a5bfd = 'devops-connected-project';
    const $67f07001968fe110$export$a9044bbb0247378d = 'eoc-alerts';
    const $67f07001968fe110$export$ae7376e552380ac0 = 'eoc-alert-detail';
    const $67f07001968fe110$export$48749e87cc44a5a5 = 'eoc-alert-issue-syncing';
    const $67f07001968fe110$export$21c230ef79df9e9 = 'eoc-alert-issue-syncing-create';
    const $67f07001968fe110$export$d2d813dd057a8352 = 'eoc-alert-issue-syncing-detail';
    const $67f07001968fe110$export$54ed2374d14a7e88 = 'eoc-api-key-management';
    const $67f07001968fe110$export$58368fe796f5ecb4 = 'eoc-assign-custom-roles';
    const $67f07001968fe110$export$bbb4032f8f259109 = 'eoc-automations';
    const $67f07001968fe110$export$5b17b30c2dd69cf2 = 'eoc-custom-roles';
    const $67f07001968fe110$export$d18d0b9a9e85e59c = 'eoc-global-alerts';
    const $67f07001968fe110$export$5126a481501fc518 = 'eoc-global-alert-detail';
    const $67f07001968fe110$export$40e720d8c26e6804 = 'eoc-global-group-detail';
    const $67f07001968fe110$export$dc8ac1f7e9373a32 = 'eoc-global-maintenance';
    const $67f07001968fe110$export$8ca3e3f0326ba27f = 'eoc-global-reports';
    const $67f07001968fe110$export$c3d17be12795c864 = 'eoc-global-report-dashboard';
    const $67f07001968fe110$export$9cd1c70eda5cae15 = 'eoc-heartbeats';
    const $67f07001968fe110$export$99f769b27f537a72 = 'eoc-incoming-call';
    const $67f07001968fe110$export$5c5fe79d3f9ec214 = 'eoc-incoming-call-detail';
    const $67f07001968fe110$export$901b974cf0954c88 = 'eoc-integrations';
    const $67f07001968fe110$export$b2dd23a345bd5cb3 = 'eoc-integration-create';
    const $67f07001968fe110$export$8ae7cbc0a73f9351 = 'eoc-integration-detail';
    const $67f07001968fe110$export$8057ebe7fb7f7f8d = 'eoc-integration-list';
    const $67f07001968fe110$export$a22387b9744e62e3 = 'eoc-integration-log';
    const $67f07001968fe110$export$f6fefa9d2e5bbda1 = 'eoc-maintenance';
    const $67f07001968fe110$export$e6de4aa6c719d2b = 'eoc-on-call';
    const $67f07001968fe110$export$b195ada84b7e695f = `${$67f07001968fe110$export$e6de4aa6c719d2b}-redirect`;
    const $67f07001968fe110$export$1800d32171b754a6 = 'eoc-overview';
    const $67f07001968fe110$export$d22a153bfcbaaaa0 = 'eoc-overview-all-teams';
    const $67f07001968fe110$export$a9a41c76994b6ae9 = 'eoc-permissions';
    const $67f07001968fe110$export$5bd6f2569c3cfd5c = 'eoc-policies';
    const $67f07001968fe110$export$dc70eff53ff26c70 = 'eoc-reports';
    const $67f07001968fe110$export$1fe2ca96b360df19 = 'eoc-reports-team';
    const $67f07001968fe110$export$1ff01e77517a80b0 = 'eoc-reports-unsubscribe';
    const $67f07001968fe110$export$de3f8f3198f8213a = 'eoc-role-based-notifications';
    const $67f07001968fe110$export$b2cb569d360db382 = 'eoc-role-based-notifications-detail';
    const $67f07001968fe110$export$c4531cbbea51b6a1 = 'eoc-settings';
    const $67f07001968fe110$export$da985e953465731f = 'eoc-team-alerts';
    const $67f07001968fe110$export$b7eee2afd0a5c6b9 = 'eoc-team-alert-detail';
    const $67f07001968fe110$export$9b6c84986db47d98 = 'eoc-team-alert-issue-syncing';
    const $67f07001968fe110$export$89276f76fdd700d6 = 'eoc-team-alert-issue-syncing-create';
    const $67f07001968fe110$export$ea64769f19da8c95 = 'eoc-team-alert-issue-syncing-detail';
    const $67f07001968fe110$export$4a584839d9a9eb6f = 'eoc-team-customer-logs';
    const $67f07001968fe110$export$27d27c817eeb97cc = 'eoc-team-customer-logs-download';
    const $67f07001968fe110$export$9f533c13cfb48a8f = 'eoc-team-group-detail';
    const $67f07001968fe110$export$6889e571e5aa6ba6 = 'eoc-team-integrations';
    const $67f07001968fe110$export$bdd811277711c53d = 'eoc-team-integration-create';
    const $67f07001968fe110$export$c7b51c0e8ad6f77a = 'eoc-team-integration-detail';
    const $67f07001968fe110$export$a348fc7f3b4cfe34 = 'eoc-team-integration-list';
    const $67f07001968fe110$export$a4eff769c94da831 = 'eoc-team-integration-log';
    const $67f07001968fe110$export$7c928ca9c9822772 = 'eoc-team-policies';
    const $67f07001968fe110$export$b48311a8f24f4b63 = 'eoc-unlock-operations';
    const $67f07001968fe110$export$20649eac204f7661 = 'eoc-who-is-on-call';
    const $67f07001968fe110$export$62170875a111d729 = 'errors-not-found';
    const $67f07001968fe110$export$2928f3d69e7ac609 = 'external-import';
    const $67f07001968fe110$export$259e18cafd820487 = 'filters-directory';
    const $67f07001968fe110$export$4b8f333757e638a4 = 'filters-directory-secure';
    const $67f07001968fe110$export$ac4f65a14002f892 = 'forge-spa-admin';
    const $67f07001968fe110$export$c73ddc4b44ccb359 = 'forge-spa-admin-settings';
    const $67f07001968fe110$export$7ad826b482229119 = 'forge-spa-field-context-config';
    const $67f07001968fe110$export$3df864df9b639033 = 'forge-spa-global';
    const $67f07001968fe110$export$7d67bf4077ebe18d = 'forge-spa-project';
    const $67f07001968fe110$export$5ff797dfd5df551f = 'forge-spa-servicedesk-queue';
    const $67f07001968fe110$export$8a66ba1da5efa2c = 'global-admin-helper-email-notifications-log';
    const $67f07001968fe110$export$eadf5aff28def565 = 'global-issue-navigator';
    const $67f07001968fe110$export$8f9c045e8fd449b7 = 'global-issue-navigator-browse-issue-redirect';
    const $67f07001968fe110$export$1bf439327974644b = 'global-mail-settings';
    const $67f07001968fe110$export$e2a9d163770d0d46 = 'global-settings-contact-administrator';
    const $67f07001968fe110$export$21b497c57bcd299a = 'global-settings-issues-custom-fields-view';
    const $67f07001968fe110$export$8d4d1f7df6e5d4e4 = 'global-settings-issues-custom-fields-associate';
    const $67f07001968fe110$export$df5ca261227a6052 = 'global-settings-issues-custom-fields-config';
    const $67f07001968fe110$export$9f2f4303259b8508 = 'global-settings-issues-custom-fields-delete';
    const $67f07001968fe110$export$7fd53fe07eecc273 = 'global-settings-issues-custom-fields-edit';
    const $67f07001968fe110$export$c8e9ba2b5bc9dab2 = 'global-settings-issues-custom-fields-manage';
    const $67f07001968fe110$export$e05a6c9e9b9b0c48 = 'global-settings-issues-custom-fields-translate';
    const $67f07001968fe110$export$f9759b206b651b1f = 'global-settings-issues-explicit-field-association-project-list';
    const $67f07001968fe110$export$7a337a2687b5d5e3 = 'global-settings-issues-edit-permissions-schemes';
    const $67f07001968fe110$export$a41998c1a3572e41 = 'global-settings-issues-fieldlayouts-view';
    const $67f07001968fe110$export$2c9fe9e6005a9c36 = 'global-settings-issues-fieldview';
    const $67f07001968fe110$export$5d8d82ff1de3586e = 'global-settings-issues-fieldlayouts-copy';
    const $67f07001968fe110$export$8a0ed100d885c17c = 'global-settings-issues-fieldlayouts-schemes-view';
    const $67f07001968fe110$export$1c7041445acf79e8 = 'global-settings-issues-fieldlayouts-schemes-config';
    const $67f07001968fe110$export$e4712523d95125f6 = 'global-settings-issues-fieldlayouts-schemes-copy';
    const $67f07001968fe110$export$7401274ad357ff94 = 'global-settings-issues-fieldlayouts-schemes-delete';
    const $67f07001968fe110$export$6984b21077857555 = 'global-settings-issues-fieldlayouts-schemes-edit';
    const $67f07001968fe110$export$5a2dae98f768aedf = 'global-settings-issues-fieldlayouts-schemes-entity';
    const $67f07001968fe110$export$5eef1c6eb1388ac0 = 'global-settings-issues-fieldlayouts-config';
    const $67f07001968fe110$export$69bcf2c26d45e030 = 'global-settings-issues-form-data-connections';
    const $67f07001968fe110$export$ba1417cf5de80f81 = 'global-settings-global-permissions';
    const $67f07001968fe110$export$fdcfcb2e2eb16afd = 'global-settings-issues-linktypes-view';
    const $67f07001968fe110$export$5d3e6bffd6b5abfe = 'global-settings-issues-linktypes-activate';
    const $67f07001968fe110$export$5c676bbb7e3aae9e = 'global-settings-issues-linktypes-deactivate';
    const $67f07001968fe110$export$8bb013ced097489a = 'global-settings-issues-linktypes-delete';
    const $67f07001968fe110$export$e384ae6a87fadedd = 'global-settings-issues-linktypes-edit';
    const $67f07001968fe110$export$8f55a911c4bd95bf = 'global-settings-issues-new-issue-search';
    const $67f07001968fe110$export$d7b98892cb31fba5 = 'global-settings-issues-new-issue-view';
    const $67f07001968fe110$export$8be4b203f526b2cd = 'global-settings-issues-notification-add';
    const $67f07001968fe110$export$df09947903c514c4 = 'global-settings-issues-notification-delete';
    const $67f07001968fe110$export$cf4a57a81e0bfbca = 'global-settings-issues-notification-edit';
    const $67f07001968fe110$export$bc64365bbb09c05e = 'global-settings-issues-notification-scheme-add';
    const $67f07001968fe110$export$5b12571311ebe766 = 'global-settings-issues-notification-scheme-delete';
    const $67f07001968fe110$export$56dc46fe1de63994 = 'global-settings-issues-notification-scheme-edit';
    const $67f07001968fe110$export$65af0e5a36d4b4e9 = 'global-settings-issues-notification-view';
    const $67f07001968fe110$export$dec448f9d2e50c90 = 'global-settings-issues-permissions-schemes-view';
    const $67f07001968fe110$export$9ff4144e1dcf9fa4 = 'global-settings-issues-permissions-schemes-add';
    const $67f07001968fe110$export$8aab6fb9a62dda95 = 'global-settings-issues-permissions-schemes-delete';
    const $67f07001968fe110$export$9f804a2650117f51 = 'global-settings-issues-permissions-schemes-edit';
    const $67f07001968fe110$export$7dd4b916600f670 = 'global-settings-issues-priorities';
    const $67f07001968fe110$export$c1b40a8a70c0aafa = 'global-settings-issues-priorities-delete';
    const $67f07001968fe110$export$ff10d812380db045 = 'global-settings-issues-priorities-edit';
    const $67f07001968fe110$export$8deeffdf8dfed878 = 'global-settings-issues-priorities-translations';
    const $67f07001968fe110$export$561687f2fa9b9cc9 = 'global-settings-issues-priority-schemes';
    const $67f07001968fe110$export$691d30818c14141c = 'global-settings-issues-resolutions';
    const $67f07001968fe110$export$8fa58495105f8fb0 = 'global-settings-issues-resolutions-default';
    const $67f07001968fe110$export$8304c57494d82ffd = 'global-settings-issues-resolutions-delete';
    const $67f07001968fe110$export$353609deec72a2ba = 'global-settings-issues-resolutions-edit';
    const $67f07001968fe110$export$1cb56e4c132ac8fd = 'global-settings-issues-resolutions-translations';
    const $67f07001968fe110$export$5fe3eec0a6bda09 = 'global-settings-issues-security-edit';
    const $67f07001968fe110$export$12b56880d6fb7ac7 = 'global-settings-issues-security-level-add';
    const $67f07001968fe110$export$9986e8be82998857 = 'global-settings-issues-security-level-delete';
    const $67f07001968fe110$export$3280ec16231916af = 'global-settings-issues-security-level-edit';
    const $67f07001968fe110$export$54885d105d1e2b37 = 'global-settings-issues-security-schemes';
    const $67f07001968fe110$export$f34d87c870f3bf43 = 'global-settings-issues-security-schemes-add';
    const $67f07001968fe110$export$4108ebf71e36e461 = 'global-settings-issues-security-schemes-delete';
    const $67f07001968fe110$export$d42ec33a6e69686e = 'global-settings-issues-security-schemes-edit';
    const $67f07001968fe110$export$8d2cfabd01e2feaa = 'global-settings-issues-statuses';
    const $67f07001968fe110$export$d0fe3726dffeca80 = 'global-settings-issues-statuses-translations';
    const $67f07001968fe110$export$b4aa4b2b8fb7267a = 'global-settings-issues-field-configure';
    const $67f07001968fe110$export$3743711165f5dd4f = 'global-settings-issues-field-configure-edit';
    const $67f07001968fe110$export$5df6f81deab9567c = 'global-settings-issues-field-schemes-view';
    const $67f07001968fe110$export$b3db2a2ee8a9a8e4 = 'global-settings-issues-field-schemes-add';
    const $67f07001968fe110$export$d5fc8cd4b3fd2b84 = 'global-settings-issues-field-schemes-configure';
    const $67f07001968fe110$export$a03360d8b616ef34 = 'global-settings-issues-field-schemes-copy';
    const $67f07001968fe110$export$336e54edc189df7f = 'global-settings-issues-field-schemes-delete';
    const $67f07001968fe110$export$53572e9a81205523 = 'global-settings-issues-field-schemes-edit';
    const $67f07001968fe110$export$b71f2ef452117a2a = 'global-settings-issues-field-schemes-edit-item';
    const $67f07001968fe110$export$f79745fee583cd62 = 'global-settings-issues-field-screens';
    const $67f07001968fe110$export$2281663e19f399c1 = 'global-settings-issues-field-copy';
    const $67f07001968fe110$export$38c52d8c5e5dad29 = 'global-settings-issues-field-delete';
    const $67f07001968fe110$export$10babc3f11b4e6e2 = 'global-settings-issues-field-edit';
    const $67f07001968fe110$export$adf2f51c41b4e22a = 'global-settings-issues-hierarchy-view';
    const $67f07001968fe110$export$11b217754d4c7d24 = 'global-settings-issues-hierarchy-redirect';
    const $67f07001968fe110$export$3414f0d81f1c11d = 'global-settings-issues-subtasks-manage';
    const $67f07001968fe110$export$5574c73a9a5878ca = 'global-settings-issues-subtasks-disable';
    const $67f07001968fe110$export$cb2626c385b72992 = 'global-settings-issues-subtasks-edit';
    const $67f07001968fe110$export$fa7aa7cabc3ec459 = 'global-settings-issues-subtasks-tranlations';
    const $67f07001968fe110$export$8b0450672651ef67 = 'global-settings-issues-time-tracking';
    const $67f07001968fe110$export$ef510a15f840e437 = 'global-settings-issues-types-view';
    const $67f07001968fe110$export$bc159fa4984a907f = 'global-settings-issues-types-delete';
    const $67f07001968fe110$export$47bfbce13af95d24 = 'global-settings-issues-types-edit';
    const $67f07001968fe110$export$c8cb78e94cd3f83c = 'global-settings-issues-types-schemes-manage';
    const $67f07001968fe110$export$4496279df22177be = 'global-settings-issues-types-schemes-option';
    const $67f07001968fe110$export$afdfef5d17c56988 = 'global-settings-issues-types-schemes-associate-default';
    const $67f07001968fe110$export$ac9b4b1136300033 = 'global-settings-issues-types-schemes-option-delete';
    const $67f07001968fe110$export$4aa31dc2a6d4f2ee = 'global-settings-issues-types-screen-schemes-view';
    const $67f07001968fe110$export$c56f5509b93eba68 = 'global-settings-issues-types-screen-schemes-configure';
    const $67f07001968fe110$export$dd9462e97e11637a = 'global-settings-issues-types-screen-schemes-copy';
    const $67f07001968fe110$export$11f8c53e10f63cfb = 'global-settings-issues-types-screen-schemes-delete';
    const $67f07001968fe110$export$758ad3ad6916c9f6 = 'global-settings-issues-types-screen-schemes-edit';
    const $67f07001968fe110$export$9d65a754315eb617 = 'global-settings-issues-types-screen-schemes-entity';
    const $67f07001968fe110$export$564b665f6ca740dd = 'global-settings-issues-types-translations';
    const $67f07001968fe110$export$256fc89c38c1b9e9 = 'global-settings-issues-workflows-pages';
    const $67f07001968fe110$export$ddeae77164bfac0 = 'global-settings-issues-workflow-edit';
    const $67f07001968fe110$export$fa2b355372963545 = 'global-settings-issues-workflows-schemes-view';
    const $67f07001968fe110$export$45511e437e54fa02 = 'global-settings-issues-workflows-schemes-edit';
    const $67f07001968fe110$export$ad76895f03f27a7c = 'global-settings-issues-workflow-transition';
    const $67f07001968fe110$export$1c291d65a59b1636 = 'global-settings-issues-workflow-transition-meta-attributes';
    const $67f07001968fe110$export$d9bb14d665bfeea5 = 'global-settings-migrations-dashboard';
    const $67f07001968fe110$export$8b44cb3da7b8f857 = 'global-settings-migrations-focus-page';
    const $67f07001968fe110$export$9ca6a09e1518d3bb = 'global-settings-migrations-home';
    const $67f07001968fe110$export$4c211b3188348679 = 'global-settings-performance-custom-field';
    const $67f07001968fe110$export$24757bb1837e33af = 'global-settings-performance-issue';
    const $67f07001968fe110$export$95b5d0bd29a3a076 = 'global-settings-performance-metric-detail';
    const $67f07001968fe110$export$d55d4330b58683da = 'global-settings-performance-overview';
    const $67f07001968fe110$export$f4d5833f0b40a26b = 'global-settings-performance-project-cleanup';
    const $67f07001968fe110$export$c78577545f514ca8 = 'global-settings-performance-project-role-actor';
    const $67f07001968fe110$export$253eb3db7152d010 = 'global-settings-permissions-schemes';
    const $67f07001968fe110$export$16b4392a63a3eacf = 'global-settings-products-applinks';
    const $67f07001968fe110$export$b2d5a7bc804ed9c9 = 'global-settings-products-dvcs';
    const $67f07001968fe110$export$f870832f94ca5009 = 'global-settings-products-sdmail';
    const $67f07001968fe110$export$8b3a1b2e8e954dc2 = 'global-settings-products-jsd-status';
    const $67f07001968fe110$export$15603150075c3d64 = 'global-settings-projects-categories-delete';
    const $67f07001968fe110$export$92536fe760c41862 = 'global-settings-projects-categories-edit';
    const $67f07001968fe110$export$3f4d05032349dae0 = 'global-settings-projects-categories-view';
    const $67f07001968fe110$export$8ff94a2e5f98315f = 'global-settings-system-shared-dashboards';
    const $67f07001968fe110$export$c906c6946fef5d99 = 'global-settings-system-helper-notification';
    const $67f07001968fe110$export$a1916b723e186494 = 'global-settings-system-helper-permission';
    const $67f07001968fe110$export$5070b4c974017f28 = 'global-settings-system-attachments';
    const $67f07001968fe110$export$bee7f9f93cb74124 = 'global-settings-system-events';
    const $67f07001968fe110$export$efe4008073ab3b69 = 'global-settings-system-events-add';
    const $67f07001968fe110$export$9e40228f1c62d4d9 = 'global-settings-system-events-delete';
    const $67f07001968fe110$export$223f8094878fea34 = 'global-settings-system-events-edit';
    const $67f07001968fe110$export$2f589c572415c043 = 'global-settings-system-lexorank';
    const $67f07001968fe110$export$8cc394a1f5ca4ac0 = 'global-settings-system-services';
    const $67f07001968fe110$export$a11311cd333dae90 = 'global-settings-system-webhooks';
    const $67f07001968fe110$export$2b2f159267202dcc = 'global-settings-system-bulk-mail';
    const $67f07001968fe110$export$c5a6874288d2e609 = 'global-settings-system-application-advanced';
    const $67f07001968fe110$export$55dd30b027c838fe = 'global-settings-system-application-edit';
    const $67f07001968fe110$export$aee9c7dbf672403c = 'global-settings-system-global-permissions';
    const $67f07001968fe110$export$75f2fbd33e76028e = 'global-settings-system-export';
    const $67f07001968fe110$export$ca57c3dfefb2c826 = 'global-settings-system-import-cloud';
    const $67f07001968fe110$export$8f2e6f133c022a59 = 'global-settings-system-import-external';
    const $67f07001968fe110$export$bcd741cf5a35ece8 = 'global-settings-system-import-csv';
    const $67f07001968fe110$export$bfd8ab4625d5c275 = 'global-settings-system-import-json';
    const $67f07001968fe110$export$750a33c4058af733 = 'global-settings-system-import-trello';
    const $67f07001968fe110$export$1b66c7594340363f = 'global-settings-system-collectors';
    const $67f07001968fe110$export$fe2fa966509db649 = 'global-settings-system-delete-mail-handler';
    const $67f07001968fe110$export$373b97e8d136f558 = 'global-settings-system-mail-incoming';
    const $67f07001968fe110$export$64909bb6f2181592 = 'global-settings-system-mail-outgoing';
    const $67f07001968fe110$export$53d6ade2eaa2ae84 = 'global-settings-system-mail-send';
    const $67f07001968fe110$export$e49d7a1ddf301d09 = 'global-settings-system-permissions';
    const $67f07001968fe110$export$9469cfde1d14fcac = 'global-settings-system-roles-view';
    const $67f07001968fe110$export$be2e231547dca6dd = 'global-settings-system-roles-actors';
    const $67f07001968fe110$export$ad6f28bbfe57d0a0 = 'global-settings-system-roles-actors-groups';
    const $67f07001968fe110$export$2fb73d5c1c0e7186 = 'global-settings-system-roles-actors-users';
    const $67f07001968fe110$export$46b4f43d6ece38fc = 'global-settings-system-roles-delete';
    const $67f07001968fe110$export$49d1c20d84d46735 = 'global-settings-system-roles-edit';
    const $67f07001968fe110$export$265062715b11a1ef = 'global-settings-system-roles-usage';
    const $67f07001968fe110$export$e9f5eae9444c9b46 = 'global-settings-system-shared-filters';
    const $67f07001968fe110$export$e19bf9459d6eba56 = 'global-settings-system-auditing';
    const $67f07001968fe110$export$40097704c31872d8 = 'global-settings-system-ui-announcement-banner';
    const $67f07001968fe110$export$dcdf0405aa7e2078 = 'global-settings-system-ui-dashboard-edit';
    const $67f07001968fe110$export$fb75113636566d39 = 'global-settings-system-look';
    const $67f07001968fe110$export$e27baa0c7747e67f = 'global-settings-system-ui-default-user-preferences-apply';
    const $67f07001968fe110$export$40d189100899f572 = 'global-settings-system-default-settings';
    const $67f07001968fe110$export$341933b279728599 = $67f07001968fe110$export$f8cea29bebf098c;
    const $67f07001968fe110$export$ae4b815061537207 = `${$67f07001968fe110$export$f8cea29bebf098c}-customer-notifications`;
    const $67f07001968fe110$export$5cd0dd5a6be6aa2b = `${$67f07001968fe110$export$f8cea29bebf098c}-email`;
    const $67f07001968fe110$export$bee46016693b19dc = `${$67f07001968fe110$export$f8cea29bebf098c}-kb`;
    const $67f07001968fe110$export$c39a25878c902e0a = `${$67f07001968fe110$export$f8cea29bebf098c}-unassigned-ticket-types-config`;
    const $67f07001968fe110$export$6eaa6ce8101f6468 = `${$67f07001968fe110$export$f8cea29bebf098c}-unassigned-ticket-type-fields`;
    const $67f07001968fe110$export$2e90ab5aa3463c0d = `${$67f07001968fe110$export$f8cea29bebf098c}-web-portal`;
    const $67f07001968fe110$export$d70320ae3b4d9e43 = 'home-onboarding-redirect';
    const $67f07001968fe110$export$b2b57cde1fa39bf5 = 'home-redirect';
    const $67f07001968fe110$export$e8e3b3a04b70a016 = 'issue';
    const $67f07001968fe110$export$1a3116351e4f3550 = 'issue-create-embed';
    const $67f07001968fe110$export$6e2629d41c380b47 = 'issue-embed';
    const $67f07001968fe110$export$ced38e55e6d33a4e = 'jira-search';
    const $67f07001968fe110$export$d61d16755cb40ff3 = 'knowledge-hub-all-articles';
    const $67f07001968fe110$export$bb6392f1b2e80781 = 'kb-article-embed-editor';
    const $67f07001968fe110$export$6fd25e722e91a0d8 = 'knowledge-hub-article-in-category';
    const $67f07001968fe110$export$18f32f825e7a5a6f = 'knowledge-hub-browse-all-articles';
    const $67f07001968fe110$export$b17f22f274f4cd5e = 'knowledge-hub-browse-all-categories';
    const $67f07001968fe110$export$285854ec33f7cc = 'knowledge-hub-browse-view-article';
    const $67f07001968fe110$export$77cf9c44bbdaa05b = 'knowledge-hub-category';
    const $67f07001968fe110$export$d6f1b92110a16f2a = 'knowledge-hub-category-page';
    const $67f07001968fe110$export$fea47b97c6086336 = 'knowledge-hub-drafts';
    const $67f07001968fe110$export$264d0a2b60d052cd = 'knowledge-hub-suggested-topics';
    const $67f07001968fe110$export$991ba0c465b48539 = 'knowledge-hub-landing';
    const $67f07001968fe110$export$904b472d57dee40d = 'knowledge-hub-search';
    const $67f07001968fe110$export$bbe98dfa7f6a1e4a = 'knowledge-hub-search-articles';
    const $67f07001968fe110$export$8cfdaccf43a32440 = 'knowledge-hub-setup';
    const $67f07001968fe110$export$37bd400c00057d64 = 'legacy-all-reports';
    const $67f07001968fe110$export$eb66bd587b5f093d = 'legacy-backlog';
    const $67f07001968fe110$export$521baa72494c2a67 = 'legacy-board';
    const $67f07001968fe110$export$ca255c93be51d5bc = 'legacy-connect-general';
    const $67f07001968fe110$export$51e45f736a60769b = 'legacy-connect-project';
    const $67f07001968fe110$export$2da88c0583f7fff0 = 'legacy-core-reports';
    const $67f07001968fe110$export$e64c3c8f45d7eb28 = 'legacy-custom-report';
    const $67f07001968fe110$export$5475ba822739444a = 'legacy-fallback';
    const $67f07001968fe110$export$8483f5c57513e386 = 'legacy-gin';
    const $67f07001968fe110$export$93c4d1960660bdb3 = 'legacy-gin-issue';
    const $67f07001968fe110$export$a5421dcc88027406 = 'legacy-gin-quicksearch';
    const $67f07001968fe110$export$81d5ef2e5cb06446 = 'legacy-gin-subscriptions';
    const $67f07001968fe110$export$bf4001a5c23bef67 = 'legacy-issue';
    const $67f07001968fe110$export$77f5621cd10b53c5 = 'legacy-jsd-customers';
    const $67f07001968fe110$export$93a199a38574778b = 'legacy-jsd-customer-permissions';
    const $67f07001968fe110$export$41008c2b014795bf = 'legacy-jsd-getting-started';
    const $67f07001968fe110$export$3001841111579cf2 = 'legacy-jsd-jira-automation';
    const $67f07001968fe110$export$28dc2fac9c08502e = 'legacy-jsd-knowledge';
    const $67f07001968fe110$export$4487dfcd6dce7088 = 'legacy-jsd-queues';
    const $67f07001968fe110$export$c344587fa7092e8c = 'legacy-jsd-queues-manage';
    const $67f07001968fe110$export$3fbd487079a23c0f = 'legacy-jsd-reports';
    const $67f07001968fe110$export$d6822df31c37b21a = 'legacy-jsd-reports-custom';
    const $67f07001968fe110$export$d39bcac6fced7707 = 'legacy-jsd-settings-fallback';
    const $67f07001968fe110$export$da975f212e8a3e43 = 'legacy-jsd-settings-language';
    const $67f07001968fe110$export$6e6feddeb62a0825 = 'legacy-jsd-settings-language-pages';
    const $67f07001968fe110$export$d3822e148f92bddb = 'legacy-jsd-settings-portal-pages';
    const $67f07001968fe110$export$d7df906c2ffbeab4 = 'legacy-jsd-widgets';
    const $67f07001968fe110$export$c71836085985a7d3 = 'legacy-pin';
    const $67f07001968fe110$export$a17a19a9de903839 = 'legacy-project-releases';
    const $67f07001968fe110$export$e66c1e847a52ebb5 = 'legacy-project-releases-bamboo';
    const $67f07001968fe110$export$f0254c80025ed0fc = 'legacy-project-releases-note';
    const $67f07001968fe110$export$1d4a64220d5b474d = 'legacy-project-releases-note-config';
    const $67f07001968fe110$export$8af215d394bc18c1 = 'legacy-project-settings-collectors';
    const $67f07001968fe110$export$b6b536a795b08b39 = 'legacy-project-settings-collectors-add';
    const $67f07001968fe110$export$59cde094247fca1a = 'legacy-project-settings-collectors-help';
    const $67f07001968fe110$export$d27bf19e22921164 = 'legacy-project-settings-collectors-view';
    const $67f07001968fe110$export$3467807847c0a87d = 'legacy-project-settings-config';
    const $67f07001968fe110$export$1996eeee6a067f1c = 'project-settings-classic-data-classifications';
    const $67f07001968fe110$export$ec7cb9394e8994c9 = 'legacy-project-settings-delete';
    const $67f07001968fe110$export$f01730982626c4af = 'legacy-project-settings-dev';
    const $67f07001968fe110$export$9d1758ddc1563e90 = 'legacy-project-settings-edit';
    const $67f07001968fe110$export$ecff223feb9d08be = 'legacy-project-settings-fields';
    const $67f07001968fe110$export$487bc26cddb34312 = 'legacy-project-settings-fields-associate';
    const $67f07001968fe110$export$118290072826cd87 = 'legacy-project-settings-issue-layout';
    const $67f07001968fe110$export$e5994b7b1acebe82 = 'legacy-project-settings-issue-security';
    const $67f07001968fe110$export$84b0e53f785e02cf = 'legacy-project-settings-issue-security-associate';
    const $67f07001968fe110$export$d58992a667105ce8 = 'legacy-project-settings-issue-types';
    const $67f07001968fe110$export$bb1cea2d23743f65 = 'legacy-project-settings-issue-types-associate';
    const $67f07001968fe110$export$76dac5f55ab3705e = 'legacy-project-settings-notifications';
    const $67f07001968fe110$export$a7c4adb03bc6e997 = 'legacy-project-settings-notifications-associate';
    const $67f07001968fe110$export$2dc565d0b2334780 = 'legacy-project-settings-opsgenie';
    const $67f07001968fe110$export$28687a1181a7676f = 'legacy-project-settings-people';
    const $67f07001968fe110$export$2e74a7026073fa54 = 'legacy-project-settings-permissions';
    const $67f07001968fe110$export$58fdfc78d176c564 = 'legacy-project-settings-permissions-associate';
    const $67f07001968fe110$export$cb8548f16119b181 = 'legacy-project-settings-screens';
    const $67f07001968fe110$export$66e3f6af203a567f = 'legacy-project-settings-screens-associate';
    const $67f07001968fe110$export$658e7e21f1c7b69b = 'legacy-project-settings-summary';
    const $67f07001968fe110$export$1fa628a4527d424c = 'legacy-project-settings-workflows';
    const $67f07001968fe110$export$c2989c5c00f9f64b = 'legacy-project-settings-workflows-associate';
    const $67f07001968fe110$export$2d21e5416485b195 = 'legacy-redirect';
    const $67f07001968fe110$export$e514491aa85dd54a = 'legacy-reports-average-age-report';
    const $67f07001968fe110$export$d9662297242bfcb5 = 'legacy-reports-configure';
    const $67f07001968fe110$export$2a53516b15393945 = 'legacy-reports-created-vs-resolved-report';
    const $67f07001968fe110$export$62e00190aa938a43 = 'legacy-reports-developer-workload-report';
    const $67f07001968fe110$export$22a3924a6eab79ab = 'legacy-reports-pie-report';
    const $67f07001968fe110$export$677cf3d89d18bb74 = 'legacy-reports-recently-created-report';
    const $67f07001968fe110$export$7eef86163449ad98 = 'legacy-reports-resolution-time-report';
    const $67f07001968fe110$export$8f56061e1403fa5a = 'legacy-reports-single-level-group-by-report';
    const $67f07001968fe110$export$adeb429de8df1e02 = 'legacy-reports-time-since-report';
    const $67f07001968fe110$export$931d6222073b5708 = 'legacy-reports-time-tracking-report';
    const $67f07001968fe110$export$2106f1ac8ba807e1 = 'legacy-reports-version-workload-report';
    const $67f07001968fe110$export$36678521a86f620b = 'legacy-reports-workload-pie-report';
    const $67f07001968fe110$export$55248356780fc584 = 'login-embed';
    const $67f07001968fe110$export$cd84c5a333c8d16a = 'global-settings-addons-emcee';
    const $67f07001968fe110$export$624af6f61b05f55 = 'addons-emcee-public';
    const $67f07001968fe110$export$2ed9525182145b82 = 'marketplace-app-requests';
    const $67f07001968fe110$export$7fb2b42fc4e7df8b = 'marketplace-index';
    const $67f07001968fe110$export$fa962db82ae571b2 = 'global-settings-addons-upm';
    const $67f07001968fe110$export$e145bf76b1aef705 = 'marketplace-promotions';
    const $67f07001968fe110$export$8febbfb647e4c8b9 = 'notification-logs';
    const $67f07001968fe110$export$4b34f3d336f4ccd2 = 'opsgenie-schedule';
    const $67f07001968fe110$export$a979a5c1f5e3631c = 'people-index';
    const $67f07001968fe110$export$ffcbf91dfadffd0 = 'personal-settings';
    const $67f07001968fe110$export$1807a39cc63b856c = 'personal-settings-general';
    const $67f07001968fe110$export$2be8d3c6fedd5276 = 'personal-settings-notifications';
    const $67f07001968fe110$export$6268da7263eb670d = 'personal-settings-ops-notifications';
    const $67f07001968fe110$export$93bd4a896a0fc581 = 'plans-directory';
    const $67f07001968fe110$export$2b9b1bfb538ab810 = 'project-settings-playbooks-edit';
    const $67f07001968fe110$export$d1217085321b2648 = 'project-settings-playbooks-list';
    const $67f07001968fe110$export$39624171b7c8a10a = 'polaris-collections';
    const $67f07001968fe110$export$1654cd6813e90e6b = 'polaris-ideas';
    const $67f07001968fe110$export$33059cd02df2febd = 'polaris-insights';
    const $67f07001968fe110$export$1d746ff2bc48ceb4 = 'polaris-onboarding';
    const $67f07001968fe110$export$145c578104a45fd2 = 'polaris-plays';
    const $67f07001968fe110$export$a51df1bc877c58e5 = 'polaris-rooms';
    const $67f07001968fe110$export$45208fff8de46880 = 'polaris-settings-access';
    const $67f07001968fe110$export$c710a35d40378fa5 = 'polaris-settings-global-fields';
    const $67f07001968fe110$export$15d6b93ff5273ce3 = 'polaris-unlicensed';
    const $67f07001968fe110$export$e26f2863c7ccd504 = 'products-jsm-authentication-settings';
    const $67f07001968fe110$export$496da9aa0fe819ff = 'products-jsm-chatops-and-videos-tools';
    const $67f07001968fe110$export$f7bbc23b5f8e2d3b = 'products-jsm-compliance';
    const $67f07001968fe110$export$53ce69fb34f6d286 = 'products-jsm-configuration';
    const $67f07001968fe110$export$b6e861786143eb1b = 'products-jsm-customer-access';
    const $67f07001968fe110$export$f7e3d3b413c017e1 = 'products-jsm-email-requests';
    const $67f07001968fe110$export$b84d34b8175abde5 = 'products-jsm-feature-usage';
    const $67f07001968fe110$export$50e4e3e5231fb74f = 'products-jsm-global-ops-reports';
    const $67f07001968fe110$export$39d913ae557ba8f3 = 'products-jsm-incident-management-tools';
    const $67f07001968fe110$export$a2d9bcceac584c93 = 'products-jsm-kb-permissions';
    const $67f07001968fe110$export$eb2e5f1608ec8b32 = 'products-jsm-organizations';
    const $67f07001968fe110$export$9ac90b948c53bf58 = 'products-jsw-configuration';
    const $67f07001968fe110$export$bb5665894498893f = 'products-jsw-storage-management';
    const $67f07001968fe110$export$fc61479fdfdd263a = 'classic-business-proforma-export';
    const $67f07001968fe110$export$5ae82b891e42770e = 'servicedesk-proforma-export';
    const $67f07001968fe110$export$8dcc46e162f2235b = 'software-proforma-export';
    const $67f07001968fe110$export$a934caa57ac0ac0b = 'classic-business-proforma-issue-forms-direct';
    const $67f07001968fe110$export$25a4e6c77f91c259 = 'servicedesk-proforma-issue-forms-direct';
    const $67f07001968fe110$export$2a9a9bab313fd713 = 'software-proforma-issue-forms-direct';
    const $67f07001968fe110$export$82ad2da638fc34d8 = 'classic-business-proforma-issue-forms-direct-embed';
    const $67f07001968fe110$export$ff67cffdbd881a41 = 'servicedesk-proforma-issue-forms-direct-embed';
    const $67f07001968fe110$export$c41c7d73df3fc08c = 'software-proforma-issue-forms-direct-embed';
    const $67f07001968fe110$export$65f234e4799edddc = 'classic-business-proforma-issue-forms-general';
    const $67f07001968fe110$export$215ea4e7405fa88c = 'servicedesk-proforma-issue-forms-general';
    const $67f07001968fe110$export$927b1972180d9cc4 = 'software-proforma-issue-forms-general';
    const $67f07001968fe110$export$ff1365ce4d652337 = 'projects-directory';
    const $67f07001968fe110$export$79b30013cbfdee04 = 'projects-directory-legacy-path-spa';
    const $67f07001968fe110$export$33c2dcc7c7abc45e = 'projects-directory-manage';
    const $67f07001968fe110$export$a6ef20aa08a533b1 = 'projects-redirect';
    const $67f07001968fe110$export$5908e15483da8a45 = 'project-components';
    const $67f07001968fe110$export$a3812f6f4e60d897 = 'project-directory-redirect';
    const $67f07001968fe110$export$3c8c119f40a061a9 = 'issue-navigator';
    const $67f07001968fe110$export$47e034646abefdb2 = 'issue-navigator-classic';
    const $67f07001968fe110$export$f36f4cf8b17f250f = 'issue-navigator-core';
    const $67f07001968fe110$export$841e880a0d425b3e = 'project-not-found';
    const $67f07001968fe110$export$1fde4a6e7df24a97 = 'project-pages';
    const $67f07001968fe110$export$69335bf8b709edc7 = 'project-settings-automation';
    const $67f07001968fe110$export$946b472f7559a889 = 'project-settings-components';
    const $67f07001968fe110$export$373fdf6888021ed0 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-access`;
    const $67f07001968fe110$export$d6a5f13a3d30923c = `${$67f07001968fe110$export$d1a70f80bb22f18a}-access-redirect`;
    const $67f07001968fe110$export$adfff93b0b015409 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-approvals`;
    const $67f07001968fe110$export$404de4ddea701cff = `${$67f07001968fe110$export$d1a70f80bb22f18a}-apps`;
    const $67f07001968fe110$export$596e1f6f6f4997b2 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-apps-fields`;
    const $67f07001968fe110$export$8da0e4cdbdd0cd0b = `${$67f07001968fe110$export$d1a70f80bb22f18a}-automation`;
    const $67f07001968fe110$export$d610a17dff3a01fa = `${$67f07001968fe110$export$d1a70f80bb22f18a}-data-classifications`;
    const $67f07001968fe110$export$284db5107f3db516 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-redirect`;
    const $67f07001968fe110$export$fbce46826eefc586 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-details`;
    const $67f07001968fe110$export$c86b29c76317ac6f = `${$67f07001968fe110$export$d1a70f80bb22f18a}-fields`;
    const $67f07001968fe110$export$3160b86e1b5dc391 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-forge-apps`;
    const $67f07001968fe110$export$690c0080c930fca = `${$67f07001968fe110$export$d1a70f80bb22f18a}-issuetypes`;
    const $67f07001968fe110$export$171ba8c33c05c4ef = `${$67f07001968fe110$export$d1a70f80bb22f18a}-issuetypes-workflow`;
    const $67f07001968fe110$export$e2f2c23286c3255c = `${$67f07001968fe110$export$d1a70f80bb22f18a}-notifications`;
    const $67f07001968fe110$export$5a262d40e10207a1 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-notifications-issue-logs`;
    const $67f07001968fe110$export$ab790cb87175797e = `${$67f07001968fe110$export$d1a70f80bb22f18a}-notifications-notification-email`;
    const $67f07001968fe110$export$db780b39656c673a = `${$67f07001968fe110$export$d1a70f80bb22f18a}-proforma-jira-form-builder`;
    const $67f07001968fe110$export$a77cb4dafc511d3 = `${$67f07001968fe110$export$d1a70f80bb22f18a}-proforma-project-forms`;
    const $67f07001968fe110$export$253fd82874264ee4 = `${$67f07001968fe110$export$86509a1baabd62ee}-forge-apps`;
    const $67f07001968fe110$export$eaf9ab4ec0c25813 = `${$67f07001968fe110$export$86509a1baabd62ee}-apps-forge`;
    const $67f07001968fe110$export$574bcdf6b73fcf1f = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-apps-fields`;
    const $67f07001968fe110$export$a14853dfff8da872 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-chat`;
    const $67f07001968fe110$export$ba8fd0e6db8d3e08 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-customer-notifications`;
    const $67f07001968fe110$export$1c74da1e52e6d212 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-customer-permissions`;
    const $67f07001968fe110$export$d416059b17fe7d4e = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-email`;
    const $67f07001968fe110$export$d5a3a037d2760bb7 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-widget`;
    const $67f07001968fe110$export$eb187d42a7448d45 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-internal-notifications-nextGen`;
    const $67f07001968fe110$export$688de32d31fc70f5 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-details`;
    const $67f07001968fe110$export$13d770f8814d480a = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-forge-apps`;
    const $67f07001968fe110$export$3a628f9376166ffb = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-itsm-ticket-types-config`;
    const $67f07001968fe110$export$649dafa225625f30 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-itsm-ticket-type-fields`;
    const $67f07001968fe110$export$dbfe76dd37018b2 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-notifications`;
    const $67f07001968fe110$export$20db7bb9d1bd8b38 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-notifications-notification-email`;
    const $67f07001968fe110$export$a1fa8e6e125780ae = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-notification-email`;
    const $67f07001968fe110$export$fc6b949fd2bc782d = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-portal-settings`;
    const $67f07001968fe110$export$c940f866ac7760a0 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-ticket-types-config`;
    const $67f07001968fe110$export$184d4979f6f9fe7e = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-ticket-type-fields`;
    const $67f07001968fe110$export$959f50de166cc45e = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-unassigned-ticket-types-config`;
    const $67f07001968fe110$export$b13b8c8bb4e30a75 = `${$67f07001968fe110$export$bd925e9fcb6ce37f}-unassigned-ticket-type-fields`;
    const $67f07001968fe110$export$40d6fc2b9a4f09d2 = 'project-settings-software-access';
    const $67f07001968fe110$export$cc1af211e3feda50 = `${$67f07001968fe110$export$86509a1baabd62ee}-apps-fields`;
    const $67f07001968fe110$export$3873539001f5aed7 = 'project-settings-software-automation';
    const $67f07001968fe110$export$89fcbafce559080b = 'project-settings-software-boards-card';
    const $67f07001968fe110$export$c3f05da9e4e13249 = 'project-settings-software-boards-csm';
    const $67f07001968fe110$export$619694ab37142384 = 'project-settings-software-boards-custom-filters';
    const $67f07001968fe110$export$cb89b516b9cf418b = 'project-settings-software-boards-details';
    const $67f07001968fe110$export$50680f54e95bb859 = 'project-settings-software-boards-features';
    const $67f07001968fe110$export$194c2b4da7e38757 = 'project-settings-software-boards-insights';
    const $67f07001968fe110$export$962d838817f090f8 = 'project-settings-software-boards-redirect';
    const $67f07001968fe110$export$eacbdb340a470309 = 'project-settings-software-boards-roadmap';
    const $67f07001968fe110$export$6a7782d87a21425d = 'project-settings-software-boards-swimlanes';
    const $67f07001968fe110$export$c2f56336162e799e = 'project-settings-software-boards-timeline';
    const $67f07001968fe110$export$ba419378ad70624e = 'project-settings-software-data-classifications';
    const $67f07001968fe110$export$62f38c589a73d386 = 'project-settings-software-details';
    const $67f07001968fe110$export$77c8066c0822f152 = `${$67f07001968fe110$export$86509a1baabd62ee}-fields`;
    const $67f07001968fe110$export$90900ebfa6f48861 = 'project-settings-software-next-gen-features';
    const $67f07001968fe110$export$93ff02c205edd1a8 = 'project-settings-software-issuetypes';
    const $67f07001968fe110$export$db7f5d93be70ee30 = `${$67f07001968fe110$export$86509a1baabd62ee}-notifications`;
    const $67f07001968fe110$export$432229516b7f82da = `${$67f07001968fe110$export$86509a1baabd62ee}-notifications-issue-logs`;
    const $67f07001968fe110$export$8f554d4ef9f084c0 = 'project-settings-software-notifications-notification-email';
    const $67f07001968fe110$export$6b2b99b0055772a3 = `${$67f07001968fe110$export$86509a1baabd62ee}-link-opsgenie`;
    const $67f07001968fe110$export$83c7a51057be6264 = `${$67f07001968fe110$export$86509a1baabd62ee}-toolchain-team-managed`;
    const $67f07001968fe110$export$46706d786aab3829 = 'project-settings-versions';
    const $67f07001968fe110$export$b690025ef7e3cf6c = 'project-versions';
    const $67f07001968fe110$export$ea48cc6bf1183d11 = 'rapidboard';
    const $67f07001968fe110$export$930e4881302bbd54 = 'rapidboard-backlog';
    const $67f07001968fe110$export$375801b708576466 = 'rapidboard-backlog-embed';
    const $67f07001968fe110$export$5b1e8463bd590143 = 'rapidboard-board';
    const $67f07001968fe110$export$1606662a398a24be = 'rapidboard-board-embed';
    const $67f07001968fe110$export$83a890b48b63829a = 'rapidboard-board-pretty-url-redirect';
    const $67f07001968fe110$export$c5b19a37e49ceb28 = 'rapidboard-last-visited-project-redirect';
    const $67f07001968fe110$export$c46680afe70295f3 = 'rapidboard-report';
    const $67f07001968fe110$export$831fc7eba98b58c9 = 'rapidboard-uif-backlog';
    const $67f07001968fe110$export$4061c0c586f3b7c8 = 'rapidboard-user-backlog';
    const $67f07001968fe110$export$99e0abd8ba1de289 = 'rapidboard-user-board';
    const $67f07001968fe110$export$cd96a6a0cc4831ab = 'rapidboard-user-report';
    const $67f07001968fe110$export$db1b3d2fee80859 = 'servicedesk-atlassian-analytics';
    const $67f07001968fe110$export$b0f3f3214ab1b150 = 'servicedesk-project-summary';
    const $67f07001968fe110$export$fb4e3ee7e7c21e9f = 'servicedesk-boards';
    const $67f07001968fe110$export$8c8f03e75b6708ac = 'servicedesk-calendar';
    const $67f07001968fe110$export$2e93790099768be5 = 'servicedesk-calendar-eap';
    const $67f07001968fe110$export$3c3d8caf61c9aa0c = 'servicedesk-change-calendar';
    const $67f07001968fe110$export$f9cc808094ce0ddd = 'servicedesk-cmdb-assets';
    const $67f07001968fe110$export$9bde4a0b155f2972 = 'servicedesk-cmdb-configure';
    const $67f07001968fe110$export$a52f5ffbbe135078 = 'servicedesk-cmdb-object';
    const $67f07001968fe110$export$e6773bf0fbccdb9c = 'servicedesk-cmdb-object-schema';
    const $67f07001968fe110$export$8e3dd8487a7b65bd = 'servicedesk-cmdb-object-schema-configuration';
    const $67f07001968fe110$export$258b44fcc29a5961 = 'servicedesk-cmdb-object-type-configuration';
    const $67f07001968fe110$export$ea1146ebce07be6d = 'servicedesk-cmdb-assets-reports';
    const $67f07001968fe110$export$53731240ce2d3b76 = 'servicedesk-cmdb-assets-reports-default-redirect';
    const $67f07001968fe110$export$956eb40834ddee22 = 'servicedesk-cmdb-assets-reports-unsubscribe';
    const $67f07001968fe110$export$9057470ebf41169 = 'servicedesk-cmdb-manage-object-schemas';
    const $67f07001968fe110$export$c42e107c5275b36 = 'servicedesk-cmdb-insight';
    const $67f07001968fe110$export$3e7c6a54a9d2267a = 'servicedesk-cmdb-configure';
    const $67f07001968fe110$export$c3e2697b35a149c4 = 'servicedesk-cmdb-landing-page';
    const $67f07001968fe110$export$288c7dd61dd0c291 = 'servicedesk-cmdb-object';
    const $67f07001968fe110$export$37161a981d69c891 = 'servicedesk-cmdb-object-schema';
    const $67f07001968fe110$export$cfe61aa92a4d585d = 'servicedesk-cmdb-object-schema-configuration';
    const $67f07001968fe110$export$9ed512ab4c81669c = 'servicedesk-cmdb-object-type-configuration';
    const $67f07001968fe110$export$37a9bdd8513f462d = 'servicedesk-connect-project';
    const $67f07001968fe110$export$f01162415f3a2ee3 = 'servicedesk-create-project';
    const $67f07001968fe110$export$860dd13b1e836ed8 = 'servicedesk-customers-v2';
    const $67f07001968fe110$export$5eaf1dce55090ff3 = 'servicedesk-customer-details';
    const $67f07001968fe110$export$1fe309e7cdbd1c1 = 'servicedesk-customer-service-escalations';
    const $67f07001968fe110$export$fcd9750494ff0236 = 'servicedesk-customer-service-products';
    const $67f07001968fe110$export$ad856b38e93b93b2 = 'servicedesk-early-access-itsm';
    const $67f07001968fe110$export$a833209ca71d2e56 = 'servicedesk-getting-started-page';
    const $67f07001968fe110$export$829d1776460a6ad3 = 'servicedesk-incidents';
    const $67f07001968fe110$export$d30ab2da08d8b7b9 = 'servicedesk-index';
    const $67f07001968fe110$export$3c71889849aeaa08 = 'servicedesk-issue';
    const $67f07001968fe110$export$354bf2df81f6ffb0 = 'servicedesk-issues';
    const $67f07001968fe110$export$f8880b461acd270d = 'servicedesk-itsm-sample-space';
    const $67f07001968fe110$export$876055c0ede2f8df = 'servicedesk-automation';
    const $67f07001968fe110$export$bf493c66e34711c8 = 'servicedesk-kb-requests-reports';
    const $67f07001968fe110$export$212f6e2c7c2a53bb = 'servicedesk-kb-requests-reports-time-scale-issue';
    const $67f07001968fe110$export$7c28c6e8d8a6545 = 'servicedesk-kb-requests-reports-time-scale';
    const $67f07001968fe110$export$8d55b6ef2cd92f8c = 'servicedesk-oncall-schedule';
    const $67f07001968fe110$export$f7fbe9a4717b7a50 = 'servicedesk-organizations';
    const $67f07001968fe110$export$8c800f176d079d28 = 'servicedesk-organization-details';
    const $67f07001968fe110$export$1c5fbcbfc0923176 = 'servicedesk-organization_v2';
    const $67f07001968fe110$export$59644e5d8d69a016 = 'servicedesk-practice-custom-and-issue';
    const $67f07001968fe110$export$c7074ebe0ca83f98 = 'servicedesk-practice-edit';
    const $67f07001968fe110$export$2b4737953287a354 = 'servicedesk-practice-issue';
    const $67f07001968fe110$export$e7a8d6d534c5e2fe = 'servicedesk-practice-landing';
    const $67f07001968fe110$export$5dcba309e2bfa88b = 'servicedesk-practice-manage-view';
    const $67f07001968fe110$export$2d961b0101f8733e = 'servicedesk-practice-new';
    const $67f07001968fe110$export$195fe2558f1a8591 = 'servicedesk-project-conversion';
    const $67f07001968fe110$export$1b3cf68be370a45b = 'servicedesk-queues-addon';
    const $67f07001968fe110$export$45c35381e5da2232 = 'servicedesk-queues-custom-and-issue';
    const $67f07001968fe110$export$d479ba53b9bf65a = 'servicedesk-queues-edit';
    const $67f07001968fe110$export$ccd12890649c59cc = 'servicedesk-queues-issue';
    const $67f07001968fe110$export$8c84064031188e80 = 'servicedesk-queues-landing';
    const $67f07001968fe110$export$46c6fef035fbe8ba = 'servicedesk-queues-manage-view';
    const $67f07001968fe110$export$6fb23ec5a12d5c24 = 'servicedesk-queues-new';
    const $67f07001968fe110$export$156b2dfbd87d576f = 'servicedesk-redirect';
    const $67f07001968fe110$export$6961f1ed0407cb26 = 'servicedesk-reports';
    const $67f07001968fe110$export$ba284efd679bf637 = 'servicedesk-reports-custom';
    const $67f07001968fe110$export$e48a3df597407767 = 'servicedesk-reports-custom-create';
    const $67f07001968fe110$export$c73718d4a6efea1d = 'servicedesk-reports-custom-edit';
    const $67f07001968fe110$export$ed454783ba1bacb9 = 'servicedesk-reports-custom-time-scale-issue';
    const $67f07001968fe110$export$48f6285d4729ca9d = 'servicedesk-reports-custom-time-scale';
    const $67f07001968fe110$export$8066418cead2d2ef = 'servicedesk-reports-satisfaction';
    const $67f07001968fe110$export$b3db7857ac710a89 = 'servicedesk-reports-satisfaction-time-scale-issue';
    const $67f07001968fe110$export$d574810e3edad044 = 'servicedesk-reports-satisfaction-time-scale';
    const $67f07001968fe110$export$be4b2ffade787316 = 'servicedesk-reports-summary';
    const $67f07001968fe110$export$3caf79b5f4be02d7 = 'servicedesk-reports-type';
    const $67f07001968fe110$export$29bc361328055683 = 'servicedesk-reports-workload';
    const $67f07001968fe110$export$a4a5a333fe874d97 = 'servicedesk-services';
    const $67f07001968fe110$export$2193b681ac1ae132 = 'servicedesk-services-new';
    const $67f07001968fe110$export$f1bfd5b3918619a9 = 'servicedesk-services-without-project';
    const $67f07001968fe110$export$a4c4f7898d6b914a = 'servicedesk-service-details';
    const $67f07001968fe110$export$6cffae90b9277bb = 'servicedesk-service-details-new';
    const $67f07001968fe110$export$17e76ebd53424ed5 = 'servicedesk-service-details-without-project';
    const $67f07001968fe110$export$b1329dc26a81a277 = 'servicedesk-service-modal-edit';
    const $67f07001968fe110$export$e1cba0bfe330f5c = 'servicedesk-service-modal-new';
    const $67f07001968fe110$export$8e68c55c334de101 = 'servicedesk-sla-settings';
    const $67f07001968fe110$export$5cb7cfba189a0240 = 'service-hub-services';
    const $67f07001968fe110$export$d28aab4a6d6f1d0d = 'service-hub-service-details';
    const $67f07001968fe110$export$1cf56e2d6c4edb35 = 'global-automation';
    const $67f07001968fe110$export$27c1770584d7e3fe = 'global-settings-issues-cmdb-field-config';
    const $67f07001968fe110$export$22e0ebdea08537f7 = 'admin-oauth-credentials';
    const $67f07001968fe110$export$4db732436e4edfaf = 'recommendations';
    const $67f07001968fe110$export$e832418dbed0717e = 'view-custom-fields';
    const $67f07001968fe110$export$ee09be798f0e4471 = 'software-advanced-roadmaps';
    const $67f07001968fe110$export$653bf90ae3578f21 = 'software-advanced-roadmaps-getting-started-redirect';
    const $67f07001968fe110$export$9da4125a0c62444d = 'software-advanced-roadmaps-redirect';
    const $67f07001968fe110$export$fbcc0fd9b402bb12 = 'software-advanced-roadmaps-setup';
    const $67f07001968fe110$export$e74fe5bd41e23fbd = `${$67f07001968fe110$export$3fd002e197e83a30}-dependencies`;
    const $67f07001968fe110$export$1a93e63ddbe4aa06 = `${$67f07001968fe110$export$3fd002e197e83a30}-dependencies-redirect`;
    const $67f07001968fe110$export$3b6dbbe49882589d = `${$67f07001968fe110$export$3fd002e197e83a30}-financial-year`;
    const $67f07001968fe110$export$eb01394789016fd4 = `${$67f07001968fe110$export$3fd002e197e83a30}-loading-limits`;
    const $67f07001968fe110$export$f17f4523583fa8e5 = `${$67f07001968fe110$export$3fd002e197e83a30}-loading-limits-redirect`;
    const $67f07001968fe110$export$eaa4d6eec75a6778 = `${$67f07001968fe110$export$3fd002e197e83a30}-permissions`;
    const $67f07001968fe110$export$dcc96e4abbdc0d39 = `${$67f07001968fe110$export$3fd002e197e83a30}-permissions-redirect`;
    const $67f07001968fe110$export$9eaf39ba5a56c72a = 'software-backlog';
    const $67f07001968fe110$export$495be3320b67814a = 'software-backlog-embed';
    const $67f07001968fe110$export$25752eb5bb5e3d32 = 'software-boards';
    const $67f07001968fe110$export$f116716aedb35e10 = 'software-boards-embed';
    const $67f07001968fe110$export$36fffb6b49d9f31d = 'software-calendar';
    const $67f07001968fe110$export$a6d07be4ff318f84 = 'software-calendar-classic';
    const $67f07001968fe110$export$a9a43f1114df1ad9 = 'software-calendar-classic-embed';
    const $67f07001968fe110$export$3a4c7a521a900b4d = 'software-calendar-embed';
    const $67f07001968fe110$export$9dcf51a9040a4fd6 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-proforma-issue-forms-direct`;
    const $67f07001968fe110$export$a74f9f6bd0d4fb26 = `${$67f07001968fe110$export$e3e759b7f50aaee1}-proforma-issue-forms-direct-embed`;
    const $67f07001968fe110$export$f8cb86acf6b74661 = 'software-code';
    const $67f07001968fe110$export$2d3d850c64058bfb = 'software-code-classic';
    const $67f07001968fe110$export$af6b51164f66908b = 'software-deployments';
    const $67f07001968fe110$export$12efc96fc9c9fb34 = 'software-deployments-classic';
    const $67f07001968fe110$export$6ab1901e04e623ba = 'software-form';
    const $67f07001968fe110$export$bccc7d0812737c4e = 'software-form-classic';
    const $67f07001968fe110$export$458fb992f2637a20 = 'software-form-builder';
    const $67f07001968fe110$export$c9c9c64f68ba51e3 = 'software-form-builder-classic';
    const $67f07001968fe110$export$50264cbc90a39f19 = 'software-form-submit';
    const $67f07001968fe110$export$b9d0cbe0888fa72e = 'software-form-submit-classic';
    const $67f07001968fe110$export$b8045610416fa8ca = 'software-goals';
    const $67f07001968fe110$export$8e80136ad13099e3 = 'software-goals-classic';
    const $67f07001968fe110$export$b5fe44c0bc324494 = 'software-incidents';
    const $67f07001968fe110$export$7a4f52d9060a20d2 = 'software-incidents-classic';
    const $67f07001968fe110$export$d6a9e4695952522e = 'software-issue-navigator';
    const $67f07001968fe110$export$deab88d0814c564b = 'software-list';
    const $67f07001968fe110$export$906faff110f898ef = 'software-list-classic';
    const $67f07001968fe110$export$ab3f2a34a3b0db87 = 'software-list-classic-embed';
    const $67f07001968fe110$export$4ed84a2011fdc400 = 'software-list-embed';
    const $67f07001968fe110$export$f7b286b39bf6051b = 'software-nextgen-redirect';
    const $67f07001968fe110$export$6c4337c0332c8c7f = 'software-onboarding';
    const $67f07001968fe110$export$e7c78887745b2326 = 'software-onboarding-get-started';
    const $67f07001968fe110$export$3805e4f07dca7584 = 'software-periscope';
    const $67f07001968fe110$export$f77254983320e888 = 'software-periscope-classic';
    const $67f07001968fe110$export$2e784832f1c6bb = 'software-plan-calendar';
    const $67f07001968fe110$export$7f97fa79520a4c5b = 'software-plan-calendar-embed';
    const $67f07001968fe110$export$9e53cdb1ac02195c = 'software-plan-dependencies';
    const $67f07001968fe110$export$58bd507904dc221c = 'software-plan-dependencies-embed';
    const $67f07001968fe110$export$7a821e22be2c2f14 = 'software-plan-increment';
    const $67f07001968fe110$export$ca8966ef80bfafc6 = 'software-plan-increment-embed';
    const $67f07001968fe110$export$e7423156dba31a7c = 'software-plan-increments';
    const $67f07001968fe110$export$cba7e383b2409c7b = 'software-plan-releases';
    const $67f07001968fe110$export$d5378fb71d5242c0 = `${$67f07001968fe110$export$6f266218a6973848}-auto-scheduler`;
    const $67f07001968fe110$export$4b16b72c72da8833 = `${$67f07001968fe110$export$6f266218a6973848}-custom-fields`;
    const $67f07001968fe110$export$10114d78cefb1f53 = `${$67f07001968fe110$export$6f266218a6973848}-exclusion-rules`;
    const $67f07001968fe110$export$92fe23ed30100817 = `${$67f07001968fe110$export$6f266218a6973848}-find-your-issue`;
    const $67f07001968fe110$export$e824495554c83069 = `${$67f07001968fe110$export$6f266218a6973848}-issue-sources`;
    const $67f07001968fe110$export$8df2e9efdd625a44 = `${$67f07001968fe110$export$6f266218a6973848}-permissions`;
    const $67f07001968fe110$export$aeb4d3006e298033 = `${$67f07001968fe110$export$6f266218a6973848}-plan-info`;
    const $67f07001968fe110$export$e15d3c40985c4b53 = `${$67f07001968fe110$export$6f266218a6973848}-program-boards`;
    const $67f07001968fe110$export$1d8c84454fd2d571 = `${$67f07001968fe110$export$6f266218a6973848}-removed-issues`;
    const $67f07001968fe110$export$db61a12efb59745c = `${$67f07001968fe110$export$6f266218a6973848}-saved-views`;
    const $67f07001968fe110$export$2da67fb5bd6bc2ee = `${$67f07001968fe110$export$6f266218a6973848}-scenarios`;
    const $67f07001968fe110$export$182e0167fd960de6 = `${$67f07001968fe110$export$6f266218a6973848}-scheduling`;
    const $67f07001968fe110$export$2d9e2484ee02e7da = 'software-plan-summary';
    const $67f07001968fe110$export$b7fff19fd89b617f = 'software-plan-summary-embed';
    const $67f07001968fe110$export$ea23f150f64e8a4e = 'software-plan-teams';
    const $67f07001968fe110$export$116338bd93f78ad0 = 'software-plan-timeline';
    const $67f07001968fe110$export$c9cd65a78227cf18 = 'software-advanced-roadmaps-embed';
    const $67f07001968fe110$export$7a4b4b66d7637fbb = 'software-presentation-toolkit-report';
    const $67f07001968fe110$export$d75d93e5d44182cc = 'software-release-notes';
    const $67f07001968fe110$export$cc3027ae3767801 = 'software-reports';
    const $67f07001968fe110$export$3492ce83b8884e0e = 'software-reports-burndown';
    const $67f07001968fe110$export$b4798b7e62733393 = 'software-reports-burnup';
    const $67f07001968fe110$export$388685c701d6e0d3 = 'software-reports-control';
    const $67f07001968fe110$export$5ff4d2d4257ea2b0 = 'software-reports-cumulative';
    const $67f07001968fe110$export$fa83895c1eac55e7 = 'software-reports-cycle-time';
    const $67f07001968fe110$export$5c82bb95a06a1846 = 'software-reports-cycle-time-classic';
    const $67f07001968fe110$export$c725b9c7e11dd69e = 'software-reports-deployment-frequency';
    const $67f07001968fe110$export$90594f89c675ba05 = 'software-reports-deployment-frequency-classic';
    const $67f07001968fe110$export$ae0d999dd2bdd59b = 'software-reports-velocity';
    const $67f07001968fe110$export$43bbf6935a91d277 = 'software-requests';
    const $67f07001968fe110$export$92e23977438282b2 = 'software-requests-classic';
    const $67f07001968fe110$export$296115eb5b7129d3 = 'software-roadmap';
    const $67f07001968fe110$export$17574f41c3925d64 = 'software-roadmap-classic';
    const $67f07001968fe110$export$955692fbfe35fc16 = 'software-roadmap-redirect';
    const $67f07001968fe110$export$30af3a767b8ad2d8 = 'software-security';
    const $67f07001968fe110$export$f47d664298c2c2f0 = 'software-security-classic';
    const $67f07001968fe110$export$1714b5ad9b672bc7 = 'software-timeline';
    const $67f07001968fe110$export$c9634bf15518a3a1 = 'software-timeline-classic';
    const $67f07001968fe110$export$3b5eb3ea8cbeeed = 'software-version-detail';
    const $67f07001968fe110$export$c29d90ae9a4b648e = 'software-version-detail-legacy-redirect';
    const $67f07001968fe110$export$8f2717a951373c25 = 'software-version-detail-no-tab-path';
    const $67f07001968fe110$export$831acb5098f5706d = 'system-configuration-general';
    const $67f07001968fe110$export$d218cda46c433fe1 = 'system-dashboard-edit';
    const $67f07001968fe110$export$61147168ac2833f9 = 'trashed-plan-direct-link';
    const $67f07001968fe110$export$9fe0117c0fd486a8 = 'trash-plans-directory';
    const $67f07001968fe110$export$a49474778d15635d = 'trash-projects-directory';
    const $67f07001968fe110$export$af3296e54e7fb362 = 'user-segmentation';
    const $67f07001968fe110$export$281f2e01ee9e4977 = 'your-work';
});
parcelRegister("kLSws", function(module, exports) {
    $parcel$export(module.exports, "AsyncHorizontalNavPlans", ()=>$245a320c345a7203$export$84e1a5f003939496);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $gGtKh = parcelRequire("gGtKh");
    const $245a320c345a7203$var$LazyHorizontalPlansNav = (0, $56koX.lazyForPaint)(()=>(parcelRequire("7XewV")).then(({ HorizontalPlansNav: HorizontalPlansNav })=>HorizontalPlansNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-plans/src/ui/index.tsx"
    });
    const $245a320c345a7203$export$84e1a5f003939496 = ({ store: store })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "horizontal-software-plans-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($245a320c345a7203$var$LazyHorizontalPlansNav, {
            store: store
        }));
});
parcelRegister("7XewV", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("2k0t5")),
        $d1Cng("dsiAd"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("69IeS")
    ]).then(()=>parcelRequire('jwhxa'));
});
parcelRegister("1f3I0", function(module, exports) {
    "use strict";
    var $kmVhr = parcelRequire("kmVhr");
    module.exports = $kmVhr(function(bundle) {
        return new Promise(function(resolve, reject) {
            var existingLinks = document.getElementsByTagName('link');
            if ([].concat(existingLinks).some(function isCurrentBundle(link) {
                return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
            })) {
                resolve();
                return;
            }
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = bundle;
            link.onerror = function(e) {
                link.onerror = link.onload = null;
                link.remove();
                reject(e);
            };
            link.onload = function() {
                link.onerror = link.onload = null;
                resolve();
            };
            document.getElementsByTagName('head')[0].appendChild(link);
        });
    });
});
parcelRegister("kmVhr", function(module, exports) {
    "use strict";
    var $ed424b6c80f23bb9$var$cachedBundles = {};
    var $ed424b6c80f23bb9$var$cachedPreloads = {};
    var $ed424b6c80f23bb9$var$cachedPrefetches = {};
    function $ed424b6c80f23bb9$var$getCache(type) {
        switch(type){
            case 'preload':
                return $ed424b6c80f23bb9$var$cachedPreloads;
            case 'prefetch':
                return $ed424b6c80f23bb9$var$cachedPrefetches;
            default:
                return $ed424b6c80f23bb9$var$cachedBundles;
        }
    }
    module.exports = function(loader, type) {
        return function(bundle) {
            var cache = $ed424b6c80f23bb9$var$getCache(type);
            if (cache[bundle]) return cache[bundle];
            return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
                delete cache[bundle];
                throw e;
            });
        };
    };
});
parcelRegister("dWu0t", function(module, exports) {
    $parcel$export(module.exports, "useHorizontalNavComponent", ()=>$c641efd495101387$export$205771a0e64e4c7c);
    var $b3nmi = parcelRequire("b3nmi");
    var $7ZZxN = parcelRequire("7ZZxN");
    var $exb0h = parcelRequire("exb0h");
    var $1ybV0 = parcelRequire("1ybV0");
    var $eI5EY = parcelRequire("eI5EY");
    var $4u3Wx = parcelRequire("4u3Wx");
    var $6FP8W = parcelRequire("6FP8W");
    var $10fdS = parcelRequire("10fdS");
    var $bNe1g = parcelRequire("bNe1g");
    var $ddT06 = parcelRequire("ddT06");
    var $bEe6y = parcelRequire("bEe6y");
    var $lB25E = parcelRequire("lB25E");
    const $c641efd495101387$export$965942f8308cd740 = (0, $lB25E.createRouterSelector)((state)=>(0, $ddT06.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(state.query.config));
    const $c641efd495101387$export$205771a0e64e4c7c = ()=>{
        const route = (0, $10fdS.useCurrentRoute)();
        const { data: projectData } = (0, $bNe1g.useProjectContext)();
        const hasBoardSettingsPageQueryParam = (0, $eI5EY.fg)('jira_hide_horizontal_nav_on_board_settings_pages') && $c641efd495101387$export$965942f8308cd740();
        if (!(0, $6FP8W.getWillShowNav4)()) {
            const [isChromeless] = (0, $4u3Wx.useIsChromeless)();
            if (isChromeless) return null;
        }
        if (route.navigation?.horizontal == null) return null;
        if (route.navigation.horizontal === (0, $afb3b9e0346cd1fd$export$712453ef44fd2eba)) {
            if ((0, $6FP8W.getWillShowNav4)()) return null;
            switch(projectData?.projectType){
                case 0, $7ZZxN.CORE_PROJECT:
                    return 0, $b3nmi.AsyncHorizontalProjectNav;
                default:
                    return null;
            }
        }
        if (route.group === (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE) && hasBoardSettingsPageQueryParam && (0, $6FP8W.getWillShowNav4)() && (0, $1ybV0.ff)('simplified-boards-milestone-2_07hbk')) return null;
        if (route.navigation.horizontal === (0, $afb3b9e0346cd1fd$export$9ab1d1d726b36319)) switch(projectData?.projectType){
            case 0, $7ZZxN.CORE_PROJECT:
                return 0, $b3nmi.AsyncHorizontalProjectNav;
            case 0, $7ZZxN.SOFTWARE_PROJECT:
                if ((0, $6FP8W.getWillShowNav4)()) return 0, $bEe6y.AsyncHorizontalSoftwareProjectNav;
                return null;
            default:
                return null;
        }
        if ('onlyShowHorziontalOnNav4' in route.navigation && route.navigation.onlyShowHorziontalOnNav4) return (0, $6FP8W.getWillShowNav4)() ? route.navigation.horizontal : null;
        if ('horizontalFeatureFlag' in route.navigation) switch(route.navigation.horizontalFeatureFlag){
            case 'jsm_views_of_work_phase_1':
                return (0, $eI5EY.fg)('jsm_views_of_work_phase_1') ? route.navigation.horizontal : null;
            default:
                {
                    const exhaustiveCheck = route.navigation.horizontalFeatureFlag;
                    return exhaustiveCheck;
                }
        }
        return route.navigation.horizontal;
    };
});
parcelRegister("4u3Wx", function(module, exports) {
    $parcel$export(module.exports, "useIsChromeless", ()=>$958ecff90d5df897$export$c88b74884f5222ba);
    var $WBLbN = parcelRequire("WBLbN");
    var $53ucm = parcelRequire("53ucm");
    const $958ecff90d5df897$export$c88b74884f5222ba = (0, $WBLbN.createHook)((0, $53ucm.layoutStore), {
        selector: (state)=>state.isChromeless
    });
});
parcelRegister("53ucm", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", ()=>$775b7b0f5d2674bd$export$539e68c09584883a);
    $parcel$export(module.exports, "layoutStore", ()=>$775b7b0f5d2674bd$export$b8cdfd44cddaf07);
    $parcel$export(module.exports, "useLayoutStoreActions", ()=>$775b7b0f5d2674bd$export$6136bc3b9858cff4);
    $parcel$export(module.exports, "useDetailPanelWidth", ()=>$775b7b0f5d2674bd$export$95fd7b6da3b9bbb0);
    $parcel$export(module.exports, "useDetailPanelActions", ()=>$775b7b0f5d2674bd$export$99e05a60cac05e86);
    var $WBLbN = parcelRequire("WBLbN");
    var $3roBA = parcelRequire("3roBA");
    const $775b7b0f5d2674bd$export$539e68c09584883a = 240;
    const $775b7b0f5d2674bd$export$b92df8810d2fcd01 = 0;
    const $775b7b0f5d2674bd$var$initialState = {
        isChromeless: false,
        isFullscreen: false,
        banner: {
            height: 0,
            activeBanner: null
        },
        topNavigation: {
            isVisible: true
        },
        leftPanel: {
            isVisible: true,
            width: 0
        },
        rightPanel: {
            isVisible: true,
            width: 0
        },
        bottomRightCorner: {
            container: undefined,
            portals: []
        },
        content: {
            leftSidebar: {
                width: $775b7b0f5d2674bd$export$539e68c09584883a,
                isCollapsed: true,
                isVisible: true,
                isFlyoutOpen: false
            },
            rightSidebar: {
                stackState: []
            }
        }
    };
    const $775b7b0f5d2674bd$export$b8cdfd44cddaf07 = (0, $WBLbN.createStore)({
        initialState: $775b7b0f5d2674bd$var$initialState,
        actions: $3roBA.actions,
        name: 'JiraLayoutStore'
    });
    const $775b7b0f5d2674bd$export$6136bc3b9858cff4 = (0, $WBLbN.createHook)($775b7b0f5d2674bd$export$b8cdfd44cddaf07, {
        selector: null
    });
    const $775b7b0f5d2674bd$var$detailPanelWidthStore = (0, $WBLbN.createStore)({
        name: 'detailPanelWidth',
        initialState: {
            width: 0
        },
        actions: {
            setWidth: (value)=>({ setState: setState })=>{
                    setState({
                        width: value
                    });
                }
        }
    });
    const $775b7b0f5d2674bd$export$95fd7b6da3b9bbb0 = (0, $WBLbN.createHook)($775b7b0f5d2674bd$var$detailPanelWidthStore);
    const $775b7b0f5d2674bd$export$99e05a60cac05e86 = (0, $WBLbN.createActionsHook)($775b7b0f5d2674bd$var$detailPanelWidthStore);
});
parcelRegister("3roBA", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$7de3ed8fccc77236$export$e324594224ef24da);
    var $3OanE = parcelRequire("3OanE");
    var $gDr9R = parcelRequire("gDr9R");
    var $aoZTG = parcelRequire("aoZTG");
    var $c2xTD = parcelRequire("c2xTD");
    var $f9nrb = parcelRequire("f9nrb");
    var $hqpfO = parcelRequire("hqpfO");
    const $7de3ed8fccc77236$export$e324594224ef24da = {
        setIsChromeless: $aoZTG.setIsChromeless,
        setIsFullscreen: $c2xTD.setIsFullscreen,
        showBanner: $3OanE.showBanner,
        dismissCurrentBanner: $3OanE.dismissCurrentBanner,
        setLeftSidebarState: $f9nrb.setLeftSidebarState,
        setRightSidebarState: $hqpfO.setRightSidebarState,
        openRightSidebar: $hqpfO.openRightSidebar,
        closeRightSidebar: $hqpfO.closeRightSidebar,
        closeAllRightSidebar: $hqpfO.closeAllRightSidebar,
        closeCurrentRightSidebar: $hqpfO.closeCurrentRightSidebar,
        minimiseRightSidebar: $hqpfO.minimiseRightSidebar,
        registerBottomRightCornerContainer: $gDr9R.registerBottomRightCornerContainer,
        insertBottomRightCornerPortal: $gDr9R.insertBottomRightCornerPortal,
        removeBottomRightCornerPortal: $gDr9R.removeBottomRightCornerPortal
    };
});
parcelRegister("3OanE", function(module, exports) {
    $parcel$export(module.exports, "showBanner", ()=>$1ca96d140cb009a0$export$f5c0eb035ef26e87);
    $parcel$export(module.exports, "dismissCurrentBanner", ()=>$1ca96d140cb009a0$export$a45bccc0cc9ac424);
    const $1ca96d140cb009a0$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
            setState({
                banner: newState
            });
        };
    const $1ca96d140cb009a0$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
            dispatch($1ca96d140cb009a0$export$f5c0eb035ef26e87({
                height: 0,
                activeBanner: null
            }));
        };
});
parcelRegister("gDr9R", function(module, exports) {
    $parcel$export(module.exports, "registerBottomRightCornerContainer", ()=>$ce70661c3da7d088$export$2992ecf780497763);
    $parcel$export(module.exports, "insertBottomRightCornerPortal", ()=>$ce70661c3da7d088$export$3ed25a6bee272520);
    $parcel$export(module.exports, "removeBottomRightCornerPortal", ()=>$ce70661c3da7d088$export$928bf7e228ce06d2);
    const $ce70661c3da7d088$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    container: ref ?? undefined
                }
            });
        };
    const $ce70661c3da7d088$export$3ed25a6bee272520 = (item)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            const { portals: portals } = bottomRightCorner;
            const sorted = [
                item,
                ...portals
            ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
            const index = sorted.findIndex((portal)=>portal.id === item.id);
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    portals: sorted
                }
            });
            return index;
        };
    const $ce70661c3da7d088$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            const { portals: portals } = bottomRightCorner;
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    portals: portals.filter((portal)=>portal.id !== id)
                }
            });
        };
});
parcelRegister("aoZTG", function(module, exports) {
    $parcel$export(module.exports, "setIsChromeless", ()=>$1199e64f89ce3554$export$1998c4816ad37edb);
    const $1199e64f89ce3554$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
            setState({
                isChromeless: isChromeless
            });
        };
});
parcelRegister("c2xTD", function(module, exports) {
    $parcel$export(module.exports, "setIsFullscreen", ()=>$440583623bc138b8$export$9c73b2f282069160);
    const $440583623bc138b8$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
            setState({
                isFullscreen: isFullscreen
            });
        };
});
parcelRegister("f9nrb", function(module, exports) {
    $parcel$export(module.exports, "setLeftSidebarState", ()=>$a9b20025b1de3529$export$3e0fd2d894ef83c8);
    const $a9b20025b1de3529$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    leftSidebar: {
                        ...content.leftSidebar,
                        ...newState
                    }
                }
            });
        };
});
parcelRegister("hqpfO", function(module, exports) {
    $parcel$export(module.exports, "selectCurrentRightSidebar", ()=>$bea3cfbec26c4bd1$export$57758d0cfaeec2c);
    $parcel$export(module.exports, "setRightSidebarState", ()=>$bea3cfbec26c4bd1$export$f5584170a8c1db02);
    $parcel$export(module.exports, "closeAllRightSidebar", ()=>$bea3cfbec26c4bd1$export$d91a6e55d52aa3e9);
    $parcel$export(module.exports, "closeCurrentRightSidebar", ()=>$bea3cfbec26c4bd1$export$a9a5075d3d1b2165);
    $parcel$export(module.exports, "closeRightSidebar", ()=>$bea3cfbec26c4bd1$export$d7149233c76efb32);
    $parcel$export(module.exports, "minimiseRightSidebar", ()=>$bea3cfbec26c4bd1$export$4eedf7fa26a2749a);
    $parcel$export(module.exports, "openRightSidebar", ()=>$bea3cfbec26c4bd1$export$c8dafe074328c4ca);
    var $hTLlD = parcelRequire("hTLlD");
    const $bea3cfbec26c4bd1$var$arrayMove = (array, oldIndex, newIndex)=>{
        const arrayCopy = [
            ...array
        ];
        const f = arrayCopy.splice(oldIndex, 1)[0];
        arrayCopy.splice(newIndex, 0, f);
        return arrayCopy;
    };
    const $bea3cfbec26c4bd1$var$dedupe = (stackState = [])=>{
        const visited = {};
        return stackState.filter((item)=>{
            if (visited[item.panelId]) return false;
            visited[item.panelId] = true;
            return true;
        });
    };
    const $bea3cfbec26c4bd1$export$57758d0cfaeec2c = (state)=>{
        if (state.stackState.length === 1) return state.stackState[0];
        return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
    };
    const $bea3cfbec26c4bd1$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: $bea3cfbec26c4bd1$var$dedupe(newState.stackState)
                    }
                }
            });
        };
    const $bea3cfbec26c4bd1$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: []
                    }
                }
            });
        };
    const $bea3cfbec26c4bd1$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            if (!currentStack.length) return;
            const currentRightSidebar = $bea3cfbec26c4bd1$export$57758d0cfaeec2c(content.rightSidebar);
            if (!currentRightSidebar) return;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                    }
                }
            });
        };
    const $bea3cfbec26c4bd1$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: currentStack.filter((item)=>item.panelId !== panelId)
                    }
                }
            });
        };
    const $bea3cfbec26c4bd1$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: currentStack.map((item)=>{
                            if (item.panelId !== panelId) return item;
                            return {
                                ...item,
                                isMinimised: true
                            };
                        })
                    }
                }
            });
        };
    const $bea3cfbec26c4bd1$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
                ...content.rightSidebar.stackState.map((item)=>{
                    if (item.panelId === panelId) return {
                        ...item,
                        isMinimised: isMinimised,
                        width: width
                    };
                    return item;
                })
            ] : [];
            const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
            if (matchedPanelIndex >= 0) {
                const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
                tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
                tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
                const newRightSidebarStackStateValue = $bea3cfbec26c4bd1$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
                newRightSidebarStackStateValue[nextIdx].width = width;
                setState({
                    content: {
                        ...content,
                        rightSidebar: {
                            stackState: newRightSidebarStackStateValue
                        }
                    }
                });
                return;
            }
            const newRightSidebarStackStateValue = toTop ? [
                {
                    panelId: panelId,
                    width: width,
                    isCollapsed: false,
                    isMinimised: isMinimised
                },
                ...tempRightSidebarStackStateValue
            ] : [
                ...tempRightSidebarStackStateValue,
                {
                    panelId: panelId,
                    width: width,
                    isCollapsed: false,
                    isMinimised: isMinimised
                }
            ];
            if ((0, ($parcel$interopDefault($hTLlD)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
        };
});
parcelRegister("6FP8W", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4", ()=>$e5b4e2555c56df61$export$f1ce4aa22fe8768a);
    var $eI5EY = parcelRequire("eI5EY");
    var $3NndS = parcelRequire("3NndS");
    var $7gqcr = parcelRequire("7gqcr");
    const $e5b4e2555c56df61$export$f1ce4aa22fe8768a = ()=>(0, $eI5EY.fg)('jira_nav4') && ((0, $3NndS.getWillShowNav4ForDogfooding)() || (0, $7gqcr.getWillShowNav4ForEap)());
});
parcelRegister("3NndS", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4ForDogfooding", ()=>$9b32d569fdd7ede7$export$9ca0d92d31816d4f);
    var $eI5EY = parcelRequire("eI5EY");
    var $6mXXc = parcelRequire("6mXXc");
    var $4w69E = parcelRequire("4w69E");
    const $9b32d569fdd7ede7$export$9ca0d92d31816d4f = ()=>{
        if (!(0, $eI5EY.fg)('jira_nav4_dogfooding')) return false;
        const phase1 = (0, $eI5EY.fg)('jira_nav4_dogfooding_phase-1');
        const phase2 = (0, $eI5EY.fg)('jira_nav4_dogfooding_phase-2');
        const phase3 = !(phase1 || phase2);
        return phase3 || phase2 && !(0, $6mXXc.getIsNav4UserOptOut)() || phase1 && !(0, $6mXXc.getIsNav4UserOptOut)() && !(0, $4w69E.getIsRouteExcludedForDogfoodingPhase1)();
    };
});
parcelRegister("6mXXc", function(module, exports) {
    $parcel$export(module.exports, "getMetaBoolean", ()=>$0f9292b7433a6030$export$9683360b0ae70629);
    $parcel$export(module.exports, "getIsNav4UserOptOut", ()=>$0f9292b7433a6030$export$3fbfe0fdf05e0f9f);
    var $jqvCZ = parcelRequire("jqvCZ");
    var $6rW04 = parcelRequire("6rW04");
    var $73h4w = parcelRequire("73h4w");
    const $0f9292b7433a6030$export$9683360b0ae70629 = (0, ($parcel$interopDefault($jqvCZ)))((name)=>(0, $6rW04.default)(`ajs-${name}`) === 'true');
    const $0f9292b7433a6030$export$7d046765d192af80 = ()=>$0f9292b7433a6030$export$9683360b0ae70629((0, $73h4w.IS_ADMIN));
    const $0f9292b7433a6030$export$ba89637357392be6 = ()=>$0f9292b7433a6030$export$9683360b0ae70629((0, $73h4w.IS_NAV4_USER_OPT_IN));
    const $0f9292b7433a6030$export$3fbfe0fdf05e0f9f = ()=>$0f9292b7433a6030$export$9683360b0ae70629((0, $73h4w.IS_NAV4_USER_OPT_OUT));
});
parcelRegister("73h4w", function(module, exports) {
    $parcel$export(module.exports, "IS_ADMIN", ()=>$189e57aa9da8fba2$export$4261d5d429e288ec);
    $parcel$export(module.exports, "IS_NAV4_USER_OPT_IN", ()=>$189e57aa9da8fba2$export$153ded4d539b820d);
    $parcel$export(module.exports, "IS_NAV4_USER_OPT_OUT", ()=>$189e57aa9da8fba2$export$9c962957701a4fe8);
    $parcel$export(module.exports, "NAV4_ROLLOUT_NONE", ()=>$189e57aa9da8fba2$export$3b602cac1f385c06);
    const $189e57aa9da8fba2$export$4261d5d429e288ec = 'is-admin';
    const $189e57aa9da8fba2$export$153ded4d539b820d = 'is-nav4-user-opt-in';
    const $189e57aa9da8fba2$export$9c962957701a4fe8 = 'is-nav4-user-opt-out';
    const $189e57aa9da8fba2$export$3b602cac1f385c06 = {
        stage: 'none'
    };
    const $189e57aa9da8fba2$export$9cd4b8dc5f7153b8 = {
        NONE: 'none',
        DOGFOODING: 'dogfooding',
        EAP: 'eap',
        BETA: 'beta',
        GA: 'ga'
    };
});
parcelRegister("4w69E", function(module, exports) {
    $parcel$export(module.exports, "getIsRouteExcludedForDogfoodingPhase1", ()=>$a835037471be3efc$export$f0abfe25b95778e3);
    var $1ybV0 = parcelRequire("1ybV0");
    var $eI5EY = parcelRequire("eI5EY");
    const $a835037471be3efc$var$JPD_COLLECTIONS_OVERVIEW_REGEX = new RegExp('^/jira/polaris/roadmaps(/)*$');
    const $a835037471be3efc$export$f0abfe25b95778e3 = ()=>{
        if (false) return false;
        const pathname = $a835037471be3efc$var$getPathname();
        if (!(0, $1ybV0.ff)('polaris.sidebar-v4') && (pathname.includes('/jira/polaris/') || pathname.includes('/secure/JiraProductDiscoveryEmbedded') || pathname.includes('/jira/discovery/'))) return true;
        if (pathname.includes('/jira/polaris/roadmaps')) {
            const isJpdCollectionsOverview = $a835037471be3efc$var$JPD_COLLECTIONS_OVERVIEW_REGEX.test(pathname);
            if (isJpdCollectionsOverview && (0, $eI5EY.fg)('jpd-sidebar-v4-for-roadmaps-overview')) return false;
            if (!(0, $eI5EY.fg)('jpd-sidebar-v4-for-roadmaps')) return true;
        }
        return false;
    };
    const $a835037471be3efc$var$getPathname = ()=>window.location.pathname;
});
parcelRegister("7gqcr", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4ForEap", ()=>$573057de52461800$export$393f53ae320de085);
    var $eI5EY = parcelRequire("eI5EY");
    var $6mXXc = parcelRequire("6mXXc");
    const $573057de52461800$export$393f53ae320de085 = ()=>(0, $eI5EY.fg)('jira_nav4_eap') && !(0, $6mXXc.getIsNav4UserOptOut)();
});
parcelRegister("10fdS", function(module, exports) {
    $parcel$export(module.exports, "useCurrentRoute", ()=>$ddc2f4c28203b504$export$c4b7ea2942f2d0e);
    $parcel$export(module.exports, "useRouteByName", ()=>$ddc2f4c28203b504$export$d69a946e2d0a1c12);
    $parcel$export(module.exports, "usePreviousRouterState", ()=>$ddc2f4c28203b504$export$1e5fb68306bd0b92);
    var $lB25E = parcelRequire("lB25E");
    var $keguF = parcelRequire("keguF");
    const $ddc2f4c28203b504$export$c4b7ea2942f2d0e = (0, $lB25E.createRouterSelector)((state)=>state.route);
    const $ddc2f4c28203b504$export$d69a946e2d0a1c12 = (0, $lB25E.createRouterSelector)((state, routeName)=>state.routes.find(({ name: name })=>name === routeName) ?? null);
    const $ddc2f4c28203b504$export$94b319d3d90420ae = ({ name: name, path: path, query: query, exact: exact })=>({
            name: name,
            path: path,
            query: query,
            exact: exact
        });
    const $ddc2f4c28203b504$export$1e5fb68306bd0b92 = ()=>{
        (0, $lB25E.useRouter)();
        return (0, $keguF.getPreviousRouterState)();
    };
});
parcelRegister("bNe1g", function(module, exports) {
    $parcel$export(module.exports, "useProjectContext", ()=>$a10c8c1f49371370$export$8f31c2503e1efa93);
    $parcel$export(module.exports, "useIsSimplifiedProject", ()=>$a10c8c1f49371370$export$524ef4f6102ed540);
    $parcel$export(module.exports, "ProjectContextProvider", ()=>$a10c8c1f49371370$export$a85f6b5857d2176);
    var $eUqFw = parcelRequire("eUqFw");
    var $iZJHG = parcelRequire("iZJHG");
    var $ixwgj = parcelRequire("ixwgj");
    const $a10c8c1f49371370$export$8f31c2503e1efa93 = (customContext)=>{
        const { data: data, error: error, loading: loading, update: update, key: key } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $ixwgj.projectContextResourceWithCache), customContext);
        const updateCache = (0, $eUqFw.useCallback)((d)=>update(()=>d), [
            update
        ]);
        return {
            data: data,
            error: error,
            loading: loading,
            updateCache: updateCache,
            key: key
        };
    };
    const $a10c8c1f49371370$export$524ef4f6102ed540 = ()=>{
        const { data: data } = $a10c8c1f49371370$export$8f31c2503e1efa93();
        return data?.simplified || false;
    };
    const $a10c8c1f49371370$export$a85f6b5857d2176 = ({ children: children })=>{
        const projectContext = $a10c8c1f49371370$export$8f31c2503e1efa93();
        return children(projectContext);
    };
});
parcelRegister("iZJHG", function(module, exports) {
    $parcel$export(module.exports, "useResourceWithCustomRouterContext", ()=>$8cce526bdc89f636$export$61dad767cf446185);
    var $8LJqN = parcelRequire("8LJqN");
    var $eI5EY = parcelRequire("eI5EY");
    var $lB25E = parcelRequire("lB25E");
    var $dUsMe = parcelRequire("dUsMe");
    const $8cce526bdc89f636$var$DUMMY_ROUTE = {
        name: 'DUMMY_ROUTE_NAME',
        path: '/projects/:projectKey/dummyroute'
    };
    const $8cce526bdc89f636$var$useResourceWithCustomRouterContextOld = (resource, customRouterContext, _ = {})=>{
        let useResourceArgCustomContext;
        if (customRouterContext) {
            const { route: route = $8cce526bdc89f636$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
            if (matchParams && Object.keys(matchParams).length > 0) useResourceArgCustomContext = {
                routerContext: (0, $lB25E.createRouterContext)(route, {
                    params: matchParams
                })
            };
        }
        const resourceResponse = (0, $lB25E.useResource)(resource, useResourceArgCustomContext);
        (0, $dUsMe.useInitFetchResource)(resourceResponse, !customRouterContext);
        return resourceResponse;
    };
    function $8cce526bdc89f636$var$useResourceWithCustomRouterContextWithOptions(resource, customRouterContext, options = {}) {
        let resourceOptions;
        if (customRouterContext) {
            const { route: route = $8cce526bdc89f636$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
            if (matchParams && Object.keys(matchParams).length > 0) resourceOptions = {
                routerContext: (0, $lB25E.createRouterContext)(route, {
                    params: matchParams
                })
            };
        }
        const { shouldPrefetch: shouldPrefetch } = options;
        const resourceResponse = (0, $lB25E.useResource)(resource, resourceOptions);
        (0, $dUsMe.usePrefetchableResource)(resourceResponse, shouldPrefetch ?? Boolean(customRouterContext));
        return resourceResponse;
    }
    const $8cce526bdc89f636$export$61dad767cf446185 = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('fix_useinitresource_data_bug'), $8cce526bdc89f636$var$useResourceWithCustomRouterContextWithOptions, $8cce526bdc89f636$var$useResourceWithCustomRouterContextOld);
});
parcelRegister("8LJqN", function(module, exports) {
    $parcel$export(module.exports, "functionWithCondition", ()=>$96fc75653c9b207d$export$af3c0e82a18fc057);
    $parcel$export(module.exports, "functionUnionWithCondition", ()=>$96fc75653c9b207d$export$c41c28c1d883fcd5);
    function $96fc75653c9b207d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
        const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
        return fnWithCondition;
    }
    function $96fc75653c9b207d$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
        return $96fc75653c9b207d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
    }
});
parcelRegister("dUsMe", function(module, exports) {
    $parcel$export(module.exports, "useInitFetchResource", ()=>$e60431eaa4374b0b$export$5b98692301d8680);
    $parcel$export(module.exports, "usePrefetchableResource", ()=>$e60431eaa4374b0b$export$99f17ace416cfe75);
    var $eUqFw = parcelRequire("eUqFw");
    const $e60431eaa4374b0b$export$5b98692301d8680 = (resource, skipInitFetch = false)=>{
        const { data: data, loading: loading, error: error, refresh: refresh, ...rest } = resource;
        (0, $eUqFw.useEffect)(()=>{
            if (skipInitFetch) return;
            if (!data && !loading && !error && refresh) refresh();
        }, []);
        return {
            data: data,
            loading: loading,
            error: error,
            refresh: refresh,
            ...rest
        };
    };
    function $e60431eaa4374b0b$export$99f17ace416cfe75(resource, shouldPrefetch) {
        (0, $eUqFw.useEffect)(()=>{
            if (!shouldPrefetch) return;
            if ((resource.data === null || resource.data === undefined) && !resource.loading && !resource.error) resource.refresh();
        }, []);
    }
});
parcelRegister("ixwgj", function(module, exports) {
    $parcel$export(module.exports, "projectContextResource", ()=>$97b06b2828b1be93$export$27ad0d75c619be68);
    $parcel$export(module.exports, "projectContextResourceWithCache", ()=>$97b06b2828b1be93$export$d75816e37af81473);
    var $9zYls = parcelRequire("9zYls");
    var $lB25E = parcelRequire("lB25E");
    const $97b06b2828b1be93$var$getDataLoader = ()=>(parcelRequire("8FY9p"));
    const $97b06b2828b1be93$export$27ad0d75c619be68 = (0, $lB25E.createResource)({
        type: (0, $e9754370217fd66e$export$80a60a092d9ab81),
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            return projectKey || projectId;
        },
        getDataLoader: $97b06b2828b1be93$var$getDataLoader,
        maxAge: 1800000
    });
    const $97b06b2828b1be93$export$d75816e37af81473 = $97b06b2828b1be93$export$27ad0d75c619be68;
});
parcelRegister("9zYls", function(module, exports) {
    $parcel$export(module.exports, "getProjectKeyId", ()=>$5d8459da4a60e5c9$export$1f7213d0f9054f06);
    const $5d8459da4a60e5c9$export$1f7213d0f9054f06 = (match, query)=>{
        const projectId = query.selectedProjectId || query.pid || query.projectId || query['project.id'];
        const projectKey = match.params.projectKey || query.projectKey || query['project.key'] || (match.params.issueKey || '').split('-')[0];
        return {
            projectKey: projectKey,
            projectId: projectId
        };
    };
});
const $e9754370217fd66e$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';
parcelRegister("8FY9p", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("cLVTX").then(()=>parcelRequire('6oUEv'));
});
parcelRegister("ddT06", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_METRICS_HISTOGRAM", ()=>$12a3433d60ba6dc8$export$128e24da52662cdd);
    $parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION", ()=>$12a3433d60ba6dc8$export$efdecbe4c9f1cd2c);
    $parcel$export(module.exports, "BOARD_SETTINGS_ARTICLE_ID_CONFIG_DISABLE_SECTION_ANALYTICS_ID", ()=>$12a3433d60ba6dc8$export$7cadd2a48a9ff918);
    $parcel$export(module.exports, "DEFAULT_LEVEL_ONE_NAME", ()=>$12a3433d60ba6dc8$export$a546b6d48878ce6f);
    $parcel$export(module.exports, "BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES", ()=>$12a3433d60ba6dc8$export$8cc83ae2b6885e0);
    $parcel$export(module.exports, "boardSettingsQueryConfigParamValues", ()=>$12a3433d60ba6dc8$export$a9ebdab56bd9c0c3);
    $parcel$export(module.exports, "SETTINGS_CONFIG", ()=>$12a3433d60ba6dc8$export$2a56ee2f9c41b5a7);
    $parcel$export(module.exports, "EDIT_BOARD_CONFIG", ()=>$12a3433d60ba6dc8$export$b893894941c14e43);
    $parcel$export(module.exports, "ADMINISTER_PARENT_PROJECT", ()=>$12a3433d60ba6dc8$export$d14d5a7c294329c5);
    $parcel$export(module.exports, "USER_PICKER_PROJECT_PERMISSION_KEY", ()=>$12a3433d60ba6dc8$export$1e63b013f0e45de0);
    $parcel$export(module.exports, "ADMINISTER_PROJECT_PERMISSION_KEY", ()=>$12a3433d60ba6dc8$export$68030ac1ea4abd4c);
    $parcel$export(module.exports, "BACKLOG_FEATURE_KEY", ()=>$12a3433d60ba6dc8$export$e1671d3447ddd5ad);
    $parcel$export(module.exports, "SPRINTS_FEATURE_KEY", ()=>$12a3433d60ba6dc8$export$46efc2c8d8106cff);
    $parcel$export(module.exports, "FEATURE_ENABLED_STATUS", ()=>$12a3433d60ba6dc8$export$a1046f102eae498);
    const $12a3433d60ba6dc8$export$128e24da52662cdd = '1000_1500_2000_2500_3000_4000';
    const $12a3433d60ba6dc8$export$efdecbe4c9f1cd2c = '2QE2xWf0TpDbYpk4oY9aQr';
    const $12a3433d60ba6dc8$export$7cadd2a48a9ff918 = `${$12a3433d60ba6dc8$export$efdecbe4c9f1cd2c}.config-disabled-section.article.analytics`;
    const $12a3433d60ba6dc8$export$a546b6d48878ce6f = 'Epic';
    const $12a3433d60ba6dc8$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES = [
        'cardColors',
        'cardLayout',
        'columns',
        'default',
        'estimation',
        'filter',
        'swimlanes',
        'time',
        'timelineConfig',
        'quickFilters',
        'insightsConfig',
        'dateFields'
    ];
    const $12a3433d60ba6dc8$export$8cc83ae2b6885e0 = new Set($12a3433d60ba6dc8$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES);
    const $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3 = Object.fromEntries($12a3433d60ba6dc8$var$INTERNAL_BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES.map((key)=>[
            key,
            key
        ]));
    const $12a3433d60ba6dc8$export$2a56ee2f9c41b5a7 = {
        default: {
            configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.filter,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        filter: {
            configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.filter,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        columns: {
            configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.columns,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        swimlanes: {
            configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.swimlanes,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        quickFilters: {
            configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.quickFilters,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        cardColors: {
            configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.cardColors,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        cardLayout: {
            configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.cardLayout,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        estimation: {
            configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.estimation,
            jsmAllowed: false,
            userLocatedBoardAllowed: true,
            kanbanAllowed: false
        },
        time: {
            configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.time,
            jsmAllowed: false,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        },
        timelineConfig: {
            configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.timelineConfig,
            jsmAllowed: false,
            userLocatedBoardAllowed: false,
            kanbanAllowed: true
        },
        insightsConfig: {
            configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.insightsConfig,
            jsmAllowed: false,
            userLocatedBoardAllowed: false,
            kanbanAllowed: false
        },
        dateFields: {
            configQuery: $12a3433d60ba6dc8$export$a9ebdab56bd9c0c3.dateFields,
            jsmAllowed: true,
            userLocatedBoardAllowed: true,
            kanbanAllowed: true
        }
    };
    const $12a3433d60ba6dc8$export$773ca4f5fb67778b = 60000;
    const $12a3433d60ba6dc8$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
    const $12a3433d60ba6dc8$export$d14d5a7c294329c5 = 'ADMINISTER_PARENT_PROJECT';
    const $12a3433d60ba6dc8$export$1e63b013f0e45de0 = 'USER_PICKER';
    const $12a3433d60ba6dc8$export$68030ac1ea4abd4c = 'ADMINISTER';
    const $12a3433d60ba6dc8$export$e1671d3447ddd5ad = 'BACKLOG';
    const $12a3433d60ba6dc8$export$46efc2c8d8106cff = 'SPRINTS';
    const $12a3433d60ba6dc8$export$a1046f102eae498 = 'ENABLED';
    const $12a3433d60ba6dc8$export$450e5ddc9f1ff901 = 'DISABLED';
});
parcelRegister("bEe6y", function(module, exports) {
    $parcel$export(module.exports, "AsyncHorizontalSoftwareProjectNav", ()=>$1f8792707b4b0d16$export$128d5d79815580ca);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $gGtKh = parcelRequire("gGtKh");
    const $1f8792707b4b0d16$var$LazyHorizontalSoftwareProjectNav = (0, $56koX.lazyForPaint)(()=>(parcelRequire("3Lv1i")).then(({ HorizontalSoftwareProjectNav: HorizontalSoftwareProjectNav })=>HorizontalSoftwareProjectNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-software/src/ui/index.tsx"
    });
    const $1f8792707b4b0d16$export$128d5d79815580ca = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "horizontal-software-project-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($1f8792707b4b0d16$var$LazyHorizontalSoftwareProjectNav, null));
});
parcelRegister("3Lv1i", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("eNmuD"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("bnyRr")
    ]).then(()=>parcelRequire('kUyw6'));
});
const $afb3b9e0346cd1fd$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $afb3b9e0346cd1fd$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';
parcelRegister("9zysr", function(module, exports) {
    $parcel$export(module.exports, "componentWithCondition", ()=>$cbf8ee3071697856$export$6e8ea24b15199873);
    var $eUqFw = parcelRequire("eUqFw");
    function $cbf8ee3071697856$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
        const ComponentWithCondition = (0, $eUqFw.forwardRef)((props, ref)=>condition() ? (0, ($parcel$interopDefault($eUqFw))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : (0, ($parcel$interopDefault($eUqFw))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            }));
        if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
        return ComponentWithCondition;
    }
});
parcelRegister("Qx7Xg", function(module, exports) {
    $parcel$export(module.exports, "useIsFullscreen", ()=>$1de01b52c6b501b2$export$d397eccea5f37b0a);
    var $WBLbN = parcelRequire("WBLbN");
    var $53ucm = parcelRequire("53ucm");
    const $1de01b52c6b501b2$export$d397eccea5f37b0a = (0, $WBLbN.createHook)((0, $53ucm.layoutStore), {
        selector: (state)=>state.isFullscreen
    });
});
parcelRegister("cB0s9", function(module, exports) {
    $parcel$export(module.exports, "LayoutRemoteStateUpdater", ()=>$7eb87e9a268eb6a6$export$b9f3a70460995c32);
    var $eUqFw = parcelRequire("eUqFw");
    var $48bs8 = parcelRequire("48bs8");
    var $guiFP = parcelRequire("guiFP");
    var $9zysr = parcelRequire("9zysr");
    var $6FP8W = parcelRequire("6FP8W");
    var $hwyJ1 = parcelRequire("hwyJ1");
    var $1NIhY = parcelRequire("1NIhY");
    var $dxcfv = parcelRequire("dxcfv");
    var $lB25E = parcelRequire("lB25E");
    var $53ucm = parcelRequire("53ucm");
    var $kpmC0 = parcelRequire("kpmC0");
    var $bUi2Q = parcelRequire("bUi2Q");
    var $bXcr7 = parcelRequire("bXcr7");
    const $7eb87e9a268eb6a6$var$LayoutRemoteStateUpdaterOld = ()=>{
        const { leftSidebarState: leftSidebarState } = (0, $hwyJ1.usePageLayoutResize)();
        const { isFlyoutOpen: isFlyoutOpen, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
        const resolvedLeftSidebarWidth = Math.max(leftSidebarWidth, (0, $53ucm.DEFAULT_LEFT_SIDEBAR_WIDTH));
        const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $53ucm.useLayoutStoreActions)();
        const isCollapsed = leftSidebarState.isLeftSidebarCollapsed;
        const rightSidebarState = (0, $bUi2Q.useRightSidebarState)();
        const accountId = (0, $dxcfv.useAccountId)();
        const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)((0, $1NIhY.navigationUiStateResource));
        const isLayoutStateReady = leftSidebarWidth !== 0 && leftSidebarState.lastLeftSidebarWidth !== 0;
        (0, $eUqFw.useEffect)(()=>{
            if (!isLayoutStateReady) return;
            if (error) return;
            setLeftSidebarState({
                width: resolvedLeftSidebarWidth,
                isCollapsed: isCollapsed,
                isFlyoutOpen: isFlyoutOpen,
                isVisible: true
            });
        }, [
            error,
            isCollapsed,
            isFlyoutOpen,
            isLayoutStateReady,
            resolvedLeftSidebarWidth,
            setLeftSidebarState
        ]);
        const updateData = (0, $eUqFw.useCallback)(async ()=>{
            if (loading) return;
            if (error) return;
            if (!isLayoutStateReady) return;
            const remoteData = {
                ...data,
                leftSidebar: {
                    width: resolvedLeftSidebarWidth,
                    isCollapsed: isLeftSidebarCollapsed
                },
                rightSidebar: rightSidebarState
            };
            if (accountId) try {
                await (0, $48bs8.setUserProperties)(accountId, (0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8), JSON.stringify(remoteData));
            } catch (e) {
                (0, $guiFP.default)({
                    error: e,
                    meta: {
                        id: 'updateServerLayoutState',
                        packageName: 'jiraLayoutController',
                        teamName: 'magma'
                    }
                });
            }
        }, [
            accountId,
            data,
            error,
            isLayoutStateReady,
            isLeftSidebarCollapsed,
            loading,
            resolvedLeftSidebarWidth,
            rightSidebarState
        ]);
        (0, $eUqFw.useEffect)(()=>{
            updateData();
        }, [
            isLeftSidebarCollapsed,
            resolvedLeftSidebarWidth,
            updateData
        ]);
        return null;
    };
    const $7eb87e9a268eb6a6$var$LayoutRemoteStateUpdaterNew = ()=>{
        const accountId = (0, $dxcfv.useAccountId)();
        const leftSidebar = (0, $kpmC0.useLeftSidebarState)();
        const rightSidebar = (0, $bUi2Q.useRightSidebarState)();
        const isLeftSidebarCollapsed = leftSidebar.isCollapsed;
        const leftSidebarWidth = leftSidebar.width;
        (0, $eUqFw.useEffect)(()=>{
            if (!accountId) return;
            (0, $bXcr7.setRemoteLayoutState)({
                accountId: accountId,
                state: {
                    rightSidebar: rightSidebar,
                    leftSidebar: {
                        isCollapsed: isLeftSidebarCollapsed,
                        width: leftSidebarWidth
                    }
                }
            });
        }, [
            accountId,
            isLeftSidebarCollapsed,
            leftSidebarWidth,
            rightSidebar
        ]);
        return null;
    };
    const $7eb87e9a268eb6a6$export$b9f3a70460995c32 = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $7eb87e9a268eb6a6$var$LayoutRemoteStateUpdaterNew, $7eb87e9a268eb6a6$var$LayoutRemoteStateUpdaterOld);
});
parcelRegister("48bs8", function(module, exports) {
    $parcel$export(module.exports, "getUserPropertiesUrl", ()=>$016bb9e2a17179ab$export$f474e53c8191800a);
    $parcel$export(module.exports, "setUserProperties", ()=>$016bb9e2a17179ab$export$d0e176862bf869b8);
    $parcel$export(module.exports, "getUserProperty", ()=>$016bb9e2a17179ab$export$b3126db2ef6e34ed);
    var $axhXb = parcelRequire("axhXb");
    var $7byHA = parcelRequire("7byHA");
    const $016bb9e2a17179ab$export$f474e53c8191800a = (accountId, propertyKey)=>`/rest/api/latest/user/properties/${propertyKey}?accountId=${encodeURIComponent(accountId)}`;
    const $016bb9e2a17179ab$export$d0e176862bf869b8 = async (accountId, propertyKey, data)=>fetch($016bb9e2a17179ab$export$f474e53c8191800a(accountId, propertyKey), {
            ...(0, $axhXb.default),
            method: 'PUT',
            body: data
        });
    const $016bb9e2a17179ab$export$b3126db2ef6e34ed = (accountId, propertyKey)=>fetch($016bb9e2a17179ab$export$f474e53c8191800a(accountId, propertyKey), (0, $axhXb.default)).then((res)=>{
            if (res.status === 200) return res.json();
            return res.text().then((errResp)=>{
                throw new (0, $7byHA.default)(res.status, errResp);
            });
        }).then((data)=>data.value);
});
parcelRegister("axhXb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1543ae6d5c00264$export$2e2bcd8739ae039);
    const $d1543ae6d5c00264$var$defaultOptions = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'x-atlassian-force-account-id': 'true',
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ]
        }
    };
    var $d1543ae6d5c00264$export$2e2bcd8739ae039 = $d1543ae6d5c00264$var$defaultOptions;
});
parcelRegister("hwyJ1", function(module, exports) {
    $parcel$export(module.exports, "PageLayout", ()=>$2da01f2b2b9a411b$export$6d1402fb58384e4f);
    $parcel$export(module.exports, "Banner", ()=>$2da01f2b2b9a411b$export$3b4e64e77073e307);
    $parcel$export(module.exports, "TopNavigation", ()=>$2da01f2b2b9a411b$export$8a421bddecb2bf5b);
    $parcel$export(module.exports, "LeftPanel", ()=>$2da01f2b2b9a411b$export$110709f040143804);
    $parcel$export(module.exports, "LeftSidebarWithoutResize", ()=>$2da01f2b2b9a411b$export$43ae342508cf8cc9);
    $parcel$export(module.exports, "LeftSidebar", ()=>$2da01f2b2b9a411b$export$3cabf771c4f2de);
    $parcel$export(module.exports, "Main", ()=>$2da01f2b2b9a411b$export$861edd1ccea2f746);
    $parcel$export(module.exports, "Content", ()=>$2da01f2b2b9a411b$export$7c6e2c02157bb7d2);
    $parcel$export(module.exports, "RightSidebar", ()=>$2da01f2b2b9a411b$export$84d58c19c21f637f);
    $parcel$export(module.exports, "useCustomSkipLink", ()=>$2da01f2b2b9a411b$export$ee6b12c2613bdf8e);
    $parcel$export(module.exports, "useLeftSidebarFlyoutLock", ()=>$2da01f2b2b9a411b$export$94561f6055639ef7);
    $parcel$export(module.exports, "usePageLayoutResize", ()=>$2da01f2b2b9a411b$export$10c7104037a7af62);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", ()=>$2da01f2b2b9a411b$export$991ef8098f87814a);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", ()=>$2da01f2b2b9a411b$export$7eaf986ecb4d5cac);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", ()=>$2da01f2b2b9a411b$export$e95b388ca8c92019);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", ()=>$2da01f2b2b9a411b$export$2ab8b83eed76656c);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", ()=>$2da01f2b2b9a411b$export$ac017575d43f5da);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", ()=>$2da01f2b2b9a411b$export$d697087c06fd5e25);
    var $eUqFw = parcelRequire("eUqFw");
    var $jG2Eu = parcelRequire("jG2Eu");
    var $95yCt = parcelRequire("95yCt");
    var $75Bx4 = parcelRequire("75Bx4");
    var $5zubN = parcelRequire("5zubN");
    var $g6H0B = parcelRequire("g6H0B");
    var $khqN6 = parcelRequire("khqN6");
    var $hl9w3 = parcelRequire("hl9w3");
    var $a0CBX = parcelRequire("a0CBX");
    var $2tmfQ = parcelRequire("2tmfQ");
    var $biWEn = parcelRequire("biWEn");
    var $jBKIh = parcelRequire("jBKIh");
    var $kszDB = parcelRequire("kszDB");
    var $hFQjy = parcelRequire("hFQjy");
    var $ltVyn = parcelRequire("ltVyn");
    var $6FP8W = parcelRequire("6FP8W");
    var $lWkXx = parcelRequire("lWkXx");
    var $aHmxD = parcelRequire("aHmxD");
    var $01noM = parcelRequire("01noM");
    var $5ysAy = parcelRequire("5ysAy");
    var $g3daZ = parcelRequire("g3daZ");
    var $2EYbt = parcelRequire("2EYbt");
    var $hfckm = parcelRequire("hfckm");
    function $2da01f2b2b9a411b$export$6d1402fb58384e4f(props) {
        return (0, $6FP8W.getWillShowNav4)() ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $g3daZ.Root), {
            UNSAFE_dangerouslyHoistSlotSizes: true,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $2tmfQ.default), props);
    }
    function $2da01f2b2b9a411b$export$3b4e64e77073e307(props) {
        return (0, $6FP8W.getWillShowNav4)() ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aHmxD.Banner), {
            UNSAFE_height: props.height,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $95yCt.default), props);
    }
    function $2da01f2b2b9a411b$export$8a421bddecb2bf5b(props) {
        return (0, $6FP8W.getWillShowNav4)() ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hfckm.TopBar), {
            UNSAFE_height: props.height,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $kszDB.default), props);
    }
    function $2da01f2b2b9a411b$export$110709f040143804(props) {
        return (0, $6FP8W.getWillShowNav4)() ? null : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $g6H0B.default), props);
    }
    function $2da01f2b2b9a411b$export$43ae342508cf8cc9(props) {
        return (0, $6FP8W.getWillShowNav4)() ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $2EYbt.SideNav), {
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hl9w3.default), props);
    }
    function $2da01f2b2b9a411b$export$3cabf771c4f2de(props) {
        return (0, $6FP8W.getWillShowNav4)() ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $2EYbt.SideNav), {
            defaultCollapsed: props.collapsedState === 'collapsed',
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $khqN6.default), props);
    }
    function $2da01f2b2b9a411b$export$861edd1ccea2f746(props) {
        return (0, $6FP8W.getWillShowNav4)() ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $01noM.Main), {
            isFixed: props.isFixed,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $a0CBX.default), props);
    }
    function $2da01f2b2b9a411b$export$7c6e2c02157bb7d2(props) {
        return (0, $6FP8W.getWillShowNav4)() ? props.children : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5zubN.default), props);
    }
    function $2da01f2b2b9a411b$export$84d58c19c21f637f(props) {
        return (0, $6FP8W.getWillShowNav4)() ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lWkXx.Aside), {
            isFixed: props.isFixed,
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jBKIh.default), props);
    }
    function $2da01f2b2b9a411b$export$364a989a35814102(props) {
        return (0, $6FP8W.getWillShowNav4)() ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5ysAy.Panel), {
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $biWEn.default), props);
    }
    const $2da01f2b2b9a411b$export$ee6b12c2613bdf8e = (id, title, index)=>(0, $6FP8W.getWillShowNav4)() ? {} : (0, $hFQjy.useCustomSkipLink)(id, title, index);
    const $2da01f2b2b9a411b$export$94561f6055639ef7 = ()=>(0, $6FP8W.getWillShowNav4)() ? {} : (0, $ltVyn.useLeftSidebarFlyoutLock)();
    const $2da01f2b2b9a411b$var$mockPageLayoutResize = {
        isLeftSidebarCollapsed: false,
        expandLeftSidebar: (0, ($parcel$interopDefault($jG2Eu))),
        collapseLeftSidebar: (0, ($parcel$interopDefault($jG2Eu))),
        leftSidebarState: {
            isFlyoutOpen: false,
            isResizing: false,
            isLeftSidebarCollapsed: false,
            leftSidebarWidth: 0,
            lastLeftSidebarWidth: 0,
            flyoutLockCount: 0,
            isFixed: true
        },
        setLeftSidebarState: (0, ($parcel$interopDefault($jG2Eu))),
        toggleLeftSidebar: (0, ($parcel$interopDefault($jG2Eu)))
    };
    const $2da01f2b2b9a411b$export$10c7104037a7af62 = ()=>(0, $6FP8W.getWillShowNav4)() ? $2da01f2b2b9a411b$var$mockPageLayoutResize : (0, $ltVyn.usePageLayoutResize)();
    const $2da01f2b2b9a411b$export$991ef8098f87814a = (0, $75Bx4.BANNER_HEIGHT);
    const $2da01f2b2b9a411b$export$7eaf986ecb4d5cac = (0, $75Bx4.LEFT_PANEL_WIDTH);
    const $2da01f2b2b9a411b$export$e95b388ca8c92019 = (0, $75Bx4.LEFT_SIDEBAR_WIDTH);
    const $2da01f2b2b9a411b$export$2ab8b83eed76656c = (0, $75Bx4.RIGHT_PANEL_WIDTH);
    const $2da01f2b2b9a411b$export$ac017575d43f5da = (0, $75Bx4.RIGHT_SIDEBAR_WIDTH);
    const $2da01f2b2b9a411b$export$d697087c06fd5e25 = (0, $75Bx4.TOP_NAVIGATION_HEIGHT);
});
parcelRegister("95yCt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e197c9d21db11c0d$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $75Bx4 = parcelRequire("75Bx4");
    var $1TdPC = parcelRequire("1TdPC");
    var $hYrzK = parcelRequire("hYrzK");
    var $9F5OS = parcelRequire("9F5OS");
    var $gVnn3 = parcelRequire("gVnn3");
    var $fSdNy = parcelRequire("fSdNy");
    const $e197c9d21db11c0d$var$bannerStyles = (0, $byn9U.css)({
        height: (0, $75Bx4.BANNER_HEIGHT),
        gridArea: (0, $75Bx4.BANNER)
    });
    const $e197c9d21db11c0d$var$bannerFixedStyles = (0, $byn9U.css)({
        position: 'fixed',
        zIndex: 2,
        insetBlockStart: 0,
        insetInlineEnd: (0, $75Bx4.RIGHT_PANEL_WIDTH),
        insetInlineStart: (0, $75Bx4.LEFT_PANEL_WIDTH)
    });
    const $e197c9d21db11c0d$var$Banner = (props)=>{
        const { children: children, height: height = (0, $75Bx4.DEFAULT_BANNER_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
        const bannerHeight = (0, $1TdPC.resolveDimension)((0, $75Bx4.VAR_BANNER_HEIGHT), height, shouldPersistHeight);
        (0, $eUqFw.useEffect)(()=>{
            (0, $hYrzK.default)({
                [(0, $75Bx4.VAR_BANNER_HEIGHT)]: bannerHeight
            });
            return ()=>{
                (0, $hYrzK.default)({
                    [(0, $75Bx4.VAR_BANNER_HEIGHT)]: 0
                });
            };
        }, [
            bannerHeight
        ]);
        (0, $9F5OS.useSkipLink)(id, skipLinkTitle);
        return (0, $byn9U.jsx)((0, $gVnn3.default), null, ({ className: className })=>(0, $byn9U.jsx)("div", {
                css: [
                    $e197c9d21db11c0d$var$bannerStyles,
                    isFixed && $e197c9d21db11c0d$var$bannerFixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, $1TdPC.getPageLayoutSlotSelector)('banner')
            }, (0, $byn9U.jsx)((0, $fSdNy.default), {
                variableName: (0, $75Bx4.VAR_BANNER_HEIGHT),
                value: bannerHeight
            }), children));
    };
    var $e197c9d21db11c0d$export$2e2bcd8739ae039 = $e197c9d21db11c0d$var$Banner;
});
parcelRegister("75Bx4", function(module, exports) {
    $parcel$export(module.exports, "VAR_LEFT_PANEL_WIDTH", ()=>$6a40e3136428ca89$export$cbfb0f5b2869b17b);
    $parcel$export(module.exports, "VAR_LEFT_SIDEBAR_WIDTH", ()=>$6a40e3136428ca89$export$a30f2e00489a8957);
    $parcel$export(module.exports, "VAR_RIGHT_SIDEBAR_WIDTH", ()=>$6a40e3136428ca89$export$c103b605cd368aed);
    $parcel$export(module.exports, "VAR_RIGHT_PANEL_WIDTH", ()=>$6a40e3136428ca89$export$fa34f417972d6341);
    $parcel$export(module.exports, "VAR_TOP_NAVIGATION_HEIGHT", ()=>$6a40e3136428ca89$export$3a6a779d9181047c);
    $parcel$export(module.exports, "VAR_BANNER_HEIGHT", ()=>$6a40e3136428ca89$export$bcd94a6a792e7f96);
    $parcel$export(module.exports, "VAR_LEFT_SIDEBAR_FLYOUT", ()=>$6a40e3136428ca89$export$b6744d31294864fd);
    $parcel$export(module.exports, "DIMENSIONS", ()=>$6a40e3136428ca89$export$d67ac355184b7646);
    $parcel$export(module.exports, "LEFT_PANEL", ()=>$6a40e3136428ca89$export$344062f7cfc9528e);
    $parcel$export(module.exports, "RIGHT_PANEL", ()=>$6a40e3136428ca89$export$c7139cc2d6110b5f);
    $parcel$export(module.exports, "BANNER", ()=>$6a40e3136428ca89$export$238d30785c4bca84);
    $parcel$export(module.exports, "TOP_NAVIGATION", ()=>$6a40e3136428ca89$export$bec6dca2e63de4ae);
    $parcel$export(module.exports, "CONTENT", ()=>$6a40e3136428ca89$export$d1213e82613ff4df);
    $parcel$export(module.exports, "DEFAULT_BANNER_HEIGHT", ()=>$6a40e3136428ca89$export$be83e7118304b28e);
    $parcel$export(module.exports, "DEFAULT_TOP_NAVIGATION_HEIGHT", ()=>$6a40e3136428ca89$export$4a98ee0bd1ae362);
    $parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", ()=>$6a40e3136428ca89$export$539e68c09584883a);
    $parcel$export(module.exports, "DEFAULT_RIGHT_SIDEBAR_WIDTH", ()=>$6a40e3136428ca89$export$b92df8810d2fcd01);
    $parcel$export(module.exports, "DEFAULT_RIGHT_PANEL_WIDTH", ()=>$6a40e3136428ca89$export$c3e41153b9288bcf);
    $parcel$export(module.exports, "DEFAULT_LEFT_PANEL_WIDTH", ()=>$6a40e3136428ca89$export$c4d6152f86ea28f6);
    $parcel$export(module.exports, "COLLAPSED_LEFT_SIDEBAR_WIDTH", ()=>$6a40e3136428ca89$export$46acf8758e9e2636);
    $parcel$export(module.exports, "MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH", ()=>$6a40e3136428ca89$export$70740f5ad8360a78);
    $parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH", ()=>$6a40e3136428ca89$export$991d5285ad765a3d);
    $parcel$export(module.exports, "MIN_LEFT_SIDEBAR_DRAG_THRESHOLD", ()=>$6a40e3136428ca89$export$6949d4f32b161684);
    $parcel$export(module.exports, "MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH", ()=>$6a40e3136428ca89$export$d6e7e8af042815bb);
    $parcel$export(module.exports, "TRANSITION_DURATION", ()=>$6a40e3136428ca89$export$3749e1104328fde4);
    $parcel$export(module.exports, "FLYOUT_DELAY", ()=>$6a40e3136428ca89$export$1074d925b0b82be5);
    $parcel$export(module.exports, "PAGE_LAYOUT_LS_KEY", ()=>$6a40e3136428ca89$export$451e84a45a9e4a75);
    $parcel$export(module.exports, "IS_SIDEBAR_DRAGGING", ()=>$6a40e3136428ca89$export$802bb2c050f3db5c);
    $parcel$export(module.exports, "IS_SIDEBAR_COLLAPSING", ()=>$6a40e3136428ca89$export$5e5e1875c3fd8f4f);
    $parcel$export(module.exports, "GRAB_AREA_LINE_SELECTOR", ()=>$6a40e3136428ca89$export$70c702a8c5895f03);
    $parcel$export(module.exports, "GRAB_AREA_SELECTOR", ()=>$6a40e3136428ca89$export$48a43f91e4becf4e);
    $parcel$export(module.exports, "RESIZE_BUTTON_SELECTOR", ()=>$6a40e3136428ca89$export$dac2fb31a9f6844d);
    $parcel$export(module.exports, "RESIZE_CONTROL_SELECTOR", ()=>$6a40e3136428ca89$export$9ecd22db14e6c70e);
    $parcel$export(module.exports, "PAGE_LAYOUT_SLOT_SELECTOR", ()=>$6a40e3136428ca89$export$5253dd9707b8c3ba);
    $parcel$export(module.exports, "DEFAULT_I18N_PROPS_SKIP_LINKS", ()=>$6a40e3136428ca89$export$206a08f7f8beb554);
    $parcel$export(module.exports, "PAGE_LAYOUT_CONTAINER_SELECTOR", ()=>$6a40e3136428ca89$export$659ee746b31b360d);
    $parcel$export(module.exports, "LEFT_PANEL_WIDTH", ()=>$6a40e3136428ca89$export$f963aecf2d4465bd);
    $parcel$export(module.exports, "RIGHT_PANEL_WIDTH", ()=>$6a40e3136428ca89$export$750459958906793);
    $parcel$export(module.exports, "LEFT_SIDEBAR_WIDTH", ()=>$6a40e3136428ca89$export$f897e1ed9f8ed251);
    $parcel$export(module.exports, "RIGHT_SIDEBAR_WIDTH", ()=>$6a40e3136428ca89$export$b44ab66843c05a69);
    $parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", ()=>$6a40e3136428ca89$export$aeff86a16f13529);
    $parcel$export(module.exports, "BANNER_HEIGHT", ()=>$6a40e3136428ca89$export$ed7cc0d417ee89e);
    $parcel$export(module.exports, "LEFT_SIDEBAR_FLYOUT_WIDTH", ()=>$6a40e3136428ca89$export$d2fa14f05b61e66);
    const $6a40e3136428ca89$export$cbfb0f5b2869b17b = 'leftPanelWidth';
    const $6a40e3136428ca89$export$a30f2e00489a8957 = 'leftSidebarWidth';
    const $6a40e3136428ca89$export$c103b605cd368aed = 'rightSidebarWidth';
    const $6a40e3136428ca89$export$fa34f417972d6341 = 'rightPanelWidth';
    const $6a40e3136428ca89$export$3a6a779d9181047c = 'topNavigationHeight';
    const $6a40e3136428ca89$export$bcd94a6a792e7f96 = 'bannerHeight';
    const $6a40e3136428ca89$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
    const $6a40e3136428ca89$export$d67ac355184b7646 = [
        $6a40e3136428ca89$export$cbfb0f5b2869b17b,
        $6a40e3136428ca89$export$fa34f417972d6341,
        $6a40e3136428ca89$export$bcd94a6a792e7f96,
        $6a40e3136428ca89$export$3a6a779d9181047c,
        $6a40e3136428ca89$export$a30f2e00489a8957,
        $6a40e3136428ca89$export$c103b605cd368aed
    ];
    const $6a40e3136428ca89$export$344062f7cfc9528e = 'left-panel';
    const $6a40e3136428ca89$export$c7139cc2d6110b5f = 'right-panel';
    const $6a40e3136428ca89$export$238d30785c4bca84 = 'banner';
    const $6a40e3136428ca89$export$bec6dca2e63de4ae = 'top-navigation';
    const $6a40e3136428ca89$export$d1213e82613ff4df = 'content';
    const $6a40e3136428ca89$export$2d8180803f50fc5 = 'main';
    const $6a40e3136428ca89$export$50ea883ba6f28ff5 = 'left-sidebar';
    const $6a40e3136428ca89$export$7bf43119a6b49ddb = 'right-sidebar';
    const $6a40e3136428ca89$export$be83e7118304b28e = 56;
    const $6a40e3136428ca89$export$4a98ee0bd1ae362 = 56;
    const $6a40e3136428ca89$export$539e68c09584883a = 240;
    const $6a40e3136428ca89$export$b92df8810d2fcd01 = 280;
    const $6a40e3136428ca89$export$c3e41153b9288bcf = 368;
    const $6a40e3136428ca89$export$c4d6152f86ea28f6 = 368;
    const $6a40e3136428ca89$export$46acf8758e9e2636 = 20;
    const $6a40e3136428ca89$export$70740f5ad8360a78 = 16;
    const $6a40e3136428ca89$export$f562af313cda0684 = 80;
    const $6a40e3136428ca89$export$991d5285ad765a3d = 240;
    const $6a40e3136428ca89$export$6949d4f32b161684 = 200;
    const $6a40e3136428ca89$export$d6e7e8af042815bb = 350;
    const $6a40e3136428ca89$export$3749e1104328fde4 = 300;
    const $6a40e3136428ca89$export$1074d925b0b82be5 = 200;
    const $6a40e3136428ca89$export$24d54fc362d78805 = 'expandedLeftSidebarWidth';
    const $6a40e3136428ca89$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
    const $6a40e3136428ca89$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
    const $6a40e3136428ca89$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
    const $6a40e3136428ca89$export$60b3bc5d4ac00d5e = 'data-is-flyout-open';
    const $6a40e3136428ca89$export$70c702a8c5895f03 = 'data-grab-area-line';
    const $6a40e3136428ca89$export$48a43f91e4becf4e = 'data-grab-area';
    const $6a40e3136428ca89$export$dac2fb31a9f6844d = 'data-resize-button';
    const $6a40e3136428ca89$export$9ecd22db14e6c70e = 'data-resize-control';
    const $6a40e3136428ca89$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
    const $6a40e3136428ca89$export$206a08f7f8beb554 = 'Skip to:';
    const $6a40e3136428ca89$export$659ee746b31b360d = 'data-layout-container';
    const $6a40e3136428ca89$export$f963aecf2d4465bd = `var(--${$6a40e3136428ca89$export$cbfb0f5b2869b17b}, 0px)`;
    const $6a40e3136428ca89$export$750459958906793 = `var(--${$6a40e3136428ca89$export$fa34f417972d6341}, 0px)`;
    const $6a40e3136428ca89$export$f897e1ed9f8ed251 = `var(--${$6a40e3136428ca89$export$a30f2e00489a8957}, 0px)`;
    const $6a40e3136428ca89$export$b44ab66843c05a69 = `var(--${$6a40e3136428ca89$export$c103b605cd368aed}, 0px)`;
    const $6a40e3136428ca89$export$aeff86a16f13529 = `var(--${$6a40e3136428ca89$export$3a6a779d9181047c}, 0px)`;
    const $6a40e3136428ca89$export$ed7cc0d417ee89e = `var(--${$6a40e3136428ca89$export$bcd94a6a792e7f96}, 0px)`;
    const $6a40e3136428ca89$export$d2fa14f05b61e66 = `var(--${$6a40e3136428ca89$export$b6744d31294864fd}, ${$6a40e3136428ca89$export$991d5285ad765a3d}px)`;
});
parcelRegister("1TdPC", function(module, exports) {
    $parcel$export(module.exports, "mergeGridStateIntoStorage", ()=>$b67e4389acf00bcf$export$f8355a2df0f4a946);
    $parcel$export(module.exports, "getGridStateFromStorage", ()=>$b67e4389acf00bcf$export$d95e99d8116d17dc);
    $parcel$export(module.exports, "removeFromGridStateInStorage", ()=>$b67e4389acf00bcf$export$17e3760e0b35f1cd);
    $parcel$export(module.exports, "resolveDimension", ()=>$b67e4389acf00bcf$export$74732e47915c7839);
    $parcel$export(module.exports, "getLeftPanelWidth", ()=>$b67e4389acf00bcf$export$b089e01213f07bd);
    $parcel$export(module.exports, "getLeftSidebarPercentage", ()=>$b67e4389acf00bcf$export$2bca58b6ee823bf7);
    $parcel$export(module.exports, "getPageLayoutSlotSelector", ()=>$b67e4389acf00bcf$export$e895e3e8b708ae2a);
    $parcel$export(module.exports, "getPageLayoutSlotCSSSelector", ()=>$b67e4389acf00bcf$export$218ece2c32b7db0e);
    var $75Bx4 = parcelRequire("75Bx4");
    var $gGD8X = parcelRequire("gGD8X");
    const $b67e4389acf00bcf$export$576dabd404a1ed99 = (0, $75Bx4.DIMENSIONS).reduce((acc, currentValue)=>({
            ...acc,
            [currentValue]: 0
        }), {});
    const $b67e4389acf00bcf$export$f8355a2df0f4a946 = (key, value)=>{
        const storageValue = JSON.parse((0, $gGD8X.default)().getItem((0, $75Bx4.PAGE_LAYOUT_LS_KEY)) || '{}');
        if (value !== null && typeof value === 'object') storageValue[key] = {
            ...storageValue[key],
            ...value
        };
        else storageValue[key] = value;
        (0, $gGD8X.default)().setItem((0, $75Bx4.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
    };
    const $b67e4389acf00bcf$export$d95e99d8116d17dc = (key)=>{
        const storageValue = JSON.parse((0, $gGD8X.default)().getItem((0, $75Bx4.PAGE_LAYOUT_LS_KEY)) || '{}');
        return storageValue[key];
    };
    const $b67e4389acf00bcf$export$17e3760e0b35f1cd = (key, secondKey)=>{
        const storageValue = JSON.parse((0, $gGD8X.default)().getItem((0, $75Bx4.PAGE_LAYOUT_LS_KEY)) || '{}');
        if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
        else delete storageValue[key];
        (0, $gGD8X.default)().setItem((0, $75Bx4.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
    };
    const $b67e4389acf00bcf$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
        if (shouldPersist) {
            const cachedGridState = $b67e4389acf00bcf$export$d95e99d8116d17dc('gridState');
            return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
        }
        return dimension;
    };
    const $b67e4389acf00bcf$export$b089e01213f07bd = ()=>{
        if (typeof window === 'undefined') return 0;
        return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, $75Bx4.LEFT_PANEL_WIDTH)}`), 10) || 0;
    };
    const $b67e4389acf00bcf$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
        const total = (currentWidth - (0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH)) / (maxWidth - (0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH));
        if (total < 0) return 0;
        if (total > 1) return 100;
        return Math.floor(total * 100);
    };
    const $b67e4389acf00bcf$export$e895e3e8b708ae2a = (slotName)=>({
            [(0, $75Bx4.PAGE_LAYOUT_SLOT_SELECTOR)]: slotName
        });
    const $b67e4389acf00bcf$export$218ece2c32b7db0e = (slotName)=>`[${0, $75Bx4.PAGE_LAYOUT_SLOT_SELECTOR}='${slotName}']`;
});
parcelRegister("gGD8X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$060e68ee7aaca5bc$export$2e2bcd8739ae039);
    const $060e68ee7aaca5bc$var$isLocalStorageSupported = ()=>{
        try {
            const testKey = `__test_${Date.now()}__`;
            localStorage.setItem(testKey, testKey);
            localStorage.removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    };
    const $060e68ee7aaca5bc$var$safeLocalStorage = ()=>{
        if ($060e68ee7aaca5bc$var$isLocalStorageSupported()) return localStorage;
        if (typeof window === 'undefined') return {
            getItem: (_key)=>null,
            setItem: (_key, _value)=>null,
            removeItem: (_key)=>null,
            clear: ()=>null,
            key: (_index)=>null,
            get length () {
                return 0;
            }
        };
        if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
        const storageAPI = {
            getItem: (key)=>{
                if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
                return null;
            },
            setItem: (key, value)=>{
                window.__localStorageFallback[key] = String(value);
            },
            removeItem: (key)=>{
                delete window.__localStorageFallback[key];
            },
            clear: ()=>{
                for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
            },
            get length () {
                if (!window.__localStorageFallback) return 0;
                return Object.keys(window.__localStorageFallback).length;
            }
        };
        window.__localStorageFallback = Object.create(storageAPI);
        return window.__localStorageFallback;
    };
    var $060e68ee7aaca5bc$export$2e2bcd8739ae039 = $060e68ee7aaca5bc$var$safeLocalStorage;
});
parcelRegister("hYrzK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$759ece397728eca7$export$2e2bcd8739ae039);
    var $1TdPC = parcelRequire("1TdPC");
    const $759ece397728eca7$var$publishGridState = (gridState)=>{
        Object.entries(gridState).forEach(([slotName, value])=>{
            if (!value) {
                document.documentElement.style.removeProperty(`--${slotName}`);
                (0, $1TdPC.removeFromGridStateInStorage)('gridState', slotName);
                return;
            }
            document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
            (0, $1TdPC.mergeGridStateIntoStorage)('gridState', {
                [slotName]: value
            });
        });
    };
    var $759ece397728eca7$export$2e2bcd8739ae039 = $759ece397728eca7$var$publishGridState;
});
parcelRegister("9F5OS", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksContext", ()=>$7a9861736fd28d58$export$4c5cc3b14c7678a);
    $parcel$export(module.exports, "useSkipLinks", ()=>$7a9861736fd28d58$export$c9d9cb2ee9590f87);
    $parcel$export(module.exports, "useSkipLink", ()=>$7a9861736fd28d58$export$89d9323301efc7d6);
    var $eUqFw = parcelRequire("eUqFw");
    var $4oSDA = parcelRequire("4oSDA");
    const $7a9861736fd28d58$export$4c5cc3b14c7678a = (0, $eUqFw.createContext)({
        skipLinksData: [],
        registerSkipLink: (0, $4oSDA.default),
        unregisterSkipLink: (0, $4oSDA.default)
    });
    const $7a9861736fd28d58$export$c9d9cb2ee9590f87 = ()=>(0, $eUqFw.useContext)($7a9861736fd28d58$export$4c5cc3b14c7678a);
    const $7a9861736fd28d58$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
        const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $7a9861736fd28d58$export$c9d9cb2ee9590f87();
        (0, $eUqFw.useEffect)(()=>{
            if (id && skipLinkTitle) registerSkipLink({
                id: id,
                skipLinkTitle: skipLinkTitle
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        }, [
            id,
            skipLinkTitle,
            registerSkipLink,
            unregisterSkipLink
        ]);
    };
});
parcelRegister("gVnn3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72be43d0a651e980$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    const $72be43d0a651e980$var$focusStyles = (0, $byn9U.css)({
        ':focus': {
            outline: 'none',
            '> div': {
                boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $207acf722dcd432b$export$ecfc1dff386a3e7a)})`}`,
                outline: 'none'
            }
        }
    });
    const $72be43d0a651e980$var$sidebarFocusStyles = (0, $byn9U.css)({
        ':focus': {
            outline: 'none',
            '> div > div': {
                boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $207acf722dcd432b$export$ecfc1dff386a3e7a)})`}`,
                outline: 'none'
            }
        }
    });
    const $72be43d0a651e980$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
        return (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>children({
                className: isSidebar ? css($72be43d0a651e980$var$sidebarFocusStyles) : css($72be43d0a651e980$var$focusStyles)
            }));
    };
    var $72be43d0a651e980$export$2e2bcd8739ae039 = $72be43d0a651e980$var$SlotFocusRing;
});
var $207acf722dcd432b$exports = {};
$parcel$export($207acf722dcd432b$exports, "R50", ()=>$207acf722dcd432b$export$4b84fd0e2c617bd);
$parcel$export($207acf722dcd432b$exports, "R75", ()=>$207acf722dcd432b$export$b34b069eff244586);
$parcel$export($207acf722dcd432b$exports, "R100", ()=>$207acf722dcd432b$export$be802dd0d8b57f35);
$parcel$export($207acf722dcd432b$exports, "R200", ()=>$207acf722dcd432b$export$60847d42f9da92a6);
$parcel$export($207acf722dcd432b$exports, "R300", ()=>$207acf722dcd432b$export$4a7404f376229999);
$parcel$export($207acf722dcd432b$exports, "R400", ()=>$207acf722dcd432b$export$2010d0fb4295b346);
$parcel$export($207acf722dcd432b$exports, "R500", ()=>$207acf722dcd432b$export$2837b5a1a71d5c02);
$parcel$export($207acf722dcd432b$exports, "Y50", ()=>$207acf722dcd432b$export$8d9596b529bbb9cf);
$parcel$export($207acf722dcd432b$exports, "Y75", ()=>$207acf722dcd432b$export$41060a744ab0b7ae);
$parcel$export($207acf722dcd432b$exports, "Y100", ()=>$207acf722dcd432b$export$1cc05bbbf340e559);
$parcel$export($207acf722dcd432b$exports, "Y200", ()=>$207acf722dcd432b$export$5aae31392d72caaa);
$parcel$export($207acf722dcd432b$exports, "Y300", ()=>$207acf722dcd432b$export$c6930421db9fa514);
$parcel$export($207acf722dcd432b$exports, "Y400", ()=>$207acf722dcd432b$export$59619663aa6500fb);
$parcel$export($207acf722dcd432b$exports, "Y500", ()=>$207acf722dcd432b$export$874739ea9e379ab6);
$parcel$export($207acf722dcd432b$exports, "G50", ()=>$207acf722dcd432b$export$8a6341c32b6a3ee6);
$parcel$export($207acf722dcd432b$exports, "G75", ()=>$207acf722dcd432b$export$69a3bf21b9686c2b);
$parcel$export($207acf722dcd432b$exports, "G100", ()=>$207acf722dcd432b$export$afbce1382ec95f73);
$parcel$export($207acf722dcd432b$exports, "G200", ()=>$207acf722dcd432b$export$747d86715d4175de);
$parcel$export($207acf722dcd432b$exports, "G300", ()=>$207acf722dcd432b$export$940e1f69e873f202);
$parcel$export($207acf722dcd432b$exports, "G400", ()=>$207acf722dcd432b$export$a49394138f7b8e85);
$parcel$export($207acf722dcd432b$exports, "G500", ()=>$207acf722dcd432b$export$6fa04827ac68a4fb);
$parcel$export($207acf722dcd432b$exports, "B50", ()=>$207acf722dcd432b$export$226de0355ed012f8);
$parcel$export($207acf722dcd432b$exports, "B75", ()=>$207acf722dcd432b$export$8c13c2ee36917869);
$parcel$export($207acf722dcd432b$exports, "B100", ()=>$207acf722dcd432b$export$ecfc1dff386a3e7a);
$parcel$export($207acf722dcd432b$exports, "B200", ()=>$207acf722dcd432b$export$215b7063051591f1);
$parcel$export($207acf722dcd432b$exports, "B300", ()=>$207acf722dcd432b$export$e62e8919cca44969);
$parcel$export($207acf722dcd432b$exports, "B400", ()=>$207acf722dcd432b$export$b3de0ae08da2ce64);
$parcel$export($207acf722dcd432b$exports, "B500", ()=>$207acf722dcd432b$export$a6ee3d71bc067634);
$parcel$export($207acf722dcd432b$exports, "B600", ()=>$207acf722dcd432b$export$67f15409e87642a1);
$parcel$export($207acf722dcd432b$exports, "B700", ()=>$207acf722dcd432b$export$f0539dbc42dbb067);
$parcel$export($207acf722dcd432b$exports, "P50", ()=>$207acf722dcd432b$export$363e4475840015bb);
$parcel$export($207acf722dcd432b$exports, "P75", ()=>$207acf722dcd432b$export$4b0a4417ed59760f);
$parcel$export($207acf722dcd432b$exports, "P100", ()=>$207acf722dcd432b$export$6011520a64d9a187);
$parcel$export($207acf722dcd432b$exports, "P200", ()=>$207acf722dcd432b$export$a7175d4e9206bc80);
$parcel$export($207acf722dcd432b$exports, "P300", ()=>$207acf722dcd432b$export$b48405b95304b5a1);
$parcel$export($207acf722dcd432b$exports, "P400", ()=>$207acf722dcd432b$export$c71e4279dd54a18d);
$parcel$export($207acf722dcd432b$exports, "P500", ()=>$207acf722dcd432b$export$147899de772240ec);
$parcel$export($207acf722dcd432b$exports, "T50", ()=>$207acf722dcd432b$export$2cf711fe14c66f06);
$parcel$export($207acf722dcd432b$exports, "T75", ()=>$207acf722dcd432b$export$7a8f4d33f6f9772c);
$parcel$export($207acf722dcd432b$exports, "T100", ()=>$207acf722dcd432b$export$776c9c497ef08533);
$parcel$export($207acf722dcd432b$exports, "T200", ()=>$207acf722dcd432b$export$69cb3ca10c1e330e);
$parcel$export($207acf722dcd432b$exports, "T300", ()=>$207acf722dcd432b$export$9dc1ef0f3f48059b);
$parcel$export($207acf722dcd432b$exports, "T400", ()=>$207acf722dcd432b$export$7c835c78b6fcdef8);
$parcel$export($207acf722dcd432b$exports, "T500", ()=>$207acf722dcd432b$export$6036577f95c3877e);
$parcel$export($207acf722dcd432b$exports, "N0", ()=>$207acf722dcd432b$export$29a4f05edc054374);
$parcel$export($207acf722dcd432b$exports, "N10", ()=>$207acf722dcd432b$export$e655ef011c4aa1a2);
$parcel$export($207acf722dcd432b$exports, "N20", ()=>$207acf722dcd432b$export$9fdfb749e33cdf97);
$parcel$export($207acf722dcd432b$exports, "N30", ()=>$207acf722dcd432b$export$3e51e8f1440314ba);
$parcel$export($207acf722dcd432b$exports, "N40", ()=>$207acf722dcd432b$export$1ce2d1575d444ceb);
$parcel$export($207acf722dcd432b$exports, "N50", ()=>$207acf722dcd432b$export$8754fc7e6d8b3000);
$parcel$export($207acf722dcd432b$exports, "N60", ()=>$207acf722dcd432b$export$c2e91cbeada39b8b);
$parcel$export($207acf722dcd432b$exports, "N70", ()=>$207acf722dcd432b$export$5f71e19f3a7ad9de);
$parcel$export($207acf722dcd432b$exports, "N80", ()=>$207acf722dcd432b$export$eaa8c8a70ac22806);
$parcel$export($207acf722dcd432b$exports, "N90", ()=>$207acf722dcd432b$export$7c87d337fb91a97d);
$parcel$export($207acf722dcd432b$exports, "N100", ()=>$207acf722dcd432b$export$d6447c357493214f);
$parcel$export($207acf722dcd432b$exports, "N200", ()=>$207acf722dcd432b$export$f563ee71e9ee74cd);
$parcel$export($207acf722dcd432b$exports, "N300", ()=>$207acf722dcd432b$export$e2ef2124cf4024b1);
$parcel$export($207acf722dcd432b$exports, "N400", ()=>$207acf722dcd432b$export$eece5f492e429f08);
$parcel$export($207acf722dcd432b$exports, "N500", ()=>$207acf722dcd432b$export$c39c0fe0f26207ae);
$parcel$export($207acf722dcd432b$exports, "N600", ()=>$207acf722dcd432b$export$7090862dc3038a9f);
$parcel$export($207acf722dcd432b$exports, "N700", ()=>$207acf722dcd432b$export$ad0bacf983b7ddaa);
$parcel$export($207acf722dcd432b$exports, "N800", ()=>$207acf722dcd432b$export$7d61b15e0da132af);
$parcel$export($207acf722dcd432b$exports, "N900", ()=>$207acf722dcd432b$export$fbda843f0a27fe96);
$parcel$export($207acf722dcd432b$exports, "N10A", ()=>$207acf722dcd432b$export$791e57b27ca738ef);
$parcel$export($207acf722dcd432b$exports, "N20A", ()=>$207acf722dcd432b$export$8d43898f60b96a82);
$parcel$export($207acf722dcd432b$exports, "N30A", ()=>$207acf722dcd432b$export$920c0d5c49070351);
$parcel$export($207acf722dcd432b$exports, "N40A", ()=>$207acf722dcd432b$export$46987b49aab6d1a8);
$parcel$export($207acf722dcd432b$exports, "N50A", ()=>$207acf722dcd432b$export$7d3359664e8bb0e5);
$parcel$export($207acf722dcd432b$exports, "N60A", ()=>$207acf722dcd432b$export$d2d3bedfb276cac0);
$parcel$export($207acf722dcd432b$exports, "N70A", ()=>$207acf722dcd432b$export$6e5e7499ff054f6d);
$parcel$export($207acf722dcd432b$exports, "N80A", ()=>$207acf722dcd432b$export$59264b346c877fa7);
$parcel$export($207acf722dcd432b$exports, "N90A", ()=>$207acf722dcd432b$export$d092757d7c64925c);
$parcel$export($207acf722dcd432b$exports, "N100A", ()=>$207acf722dcd432b$export$486ab785e4bac3c6);
$parcel$export($207acf722dcd432b$exports, "N200A", ()=>$207acf722dcd432b$export$fba592bbc6419fea);
$parcel$export($207acf722dcd432b$exports, "N300A", ()=>$207acf722dcd432b$export$13609db0e6812ab8);
$parcel$export($207acf722dcd432b$exports, "N400A", ()=>$207acf722dcd432b$export$fbae4efaa892d883);
$parcel$export($207acf722dcd432b$exports, "N500A", ()=>$207acf722dcd432b$export$f13946d26f440ce6);
$parcel$export($207acf722dcd432b$exports, "N600A", ()=>$207acf722dcd432b$export$19f58225ac52a306);
$parcel$export($207acf722dcd432b$exports, "N700A", ()=>$207acf722dcd432b$export$6384f09da70e7b62);
$parcel$export($207acf722dcd432b$exports, "N800A", ()=>$207acf722dcd432b$export$d0dccc730683edc2);
$parcel$export($207acf722dcd432b$exports, "DN900", ()=>$207acf722dcd432b$export$2f6319cf7d736c2a);
$parcel$export($207acf722dcd432b$exports, "DN800", ()=>$207acf722dcd432b$export$95126bc8884d6634);
$parcel$export($207acf722dcd432b$exports, "DN700", ()=>$207acf722dcd432b$export$8338d8c35d44ff1);
$parcel$export($207acf722dcd432b$exports, "DN600", ()=>$207acf722dcd432b$export$5368d76ae4fbbda7);
$parcel$export($207acf722dcd432b$exports, "DN500", ()=>$207acf722dcd432b$export$9f0a771d16ec8d36);
$parcel$export($207acf722dcd432b$exports, "DN400", ()=>$207acf722dcd432b$export$abcf8c38338b4aa5);
$parcel$export($207acf722dcd432b$exports, "DN300", ()=>$207acf722dcd432b$export$97e81faa16a182c7);
$parcel$export($207acf722dcd432b$exports, "DN200", ()=>$207acf722dcd432b$export$bfe21c59123ecf33);
$parcel$export($207acf722dcd432b$exports, "DN100", ()=>$207acf722dcd432b$export$ee82aa2ea6a1558);
$parcel$export($207acf722dcd432b$exports, "DN90", ()=>$207acf722dcd432b$export$682927c6ed76be02);
$parcel$export($207acf722dcd432b$exports, "DN80", ()=>$207acf722dcd432b$export$91fd9994c5be9757);
$parcel$export($207acf722dcd432b$exports, "DN70", ()=>$207acf722dcd432b$export$d281fbfe3cff2df6);
$parcel$export($207acf722dcd432b$exports, "DN60", ()=>$207acf722dcd432b$export$3902c91d8b98a753);
$parcel$export($207acf722dcd432b$exports, "DN50", ()=>$207acf722dcd432b$export$8e8133c1ba5845b5);
$parcel$export($207acf722dcd432b$exports, "DN40", ()=>$207acf722dcd432b$export$33ff357f6620b39);
$parcel$export($207acf722dcd432b$exports, "DN30", ()=>$207acf722dcd432b$export$633847cf062b69e0);
$parcel$export($207acf722dcd432b$exports, "DN20", ()=>$207acf722dcd432b$export$9776a6e503bdbf76);
$parcel$export($207acf722dcd432b$exports, "DN10", ()=>$207acf722dcd432b$export$6c813d5160dff5db);
$parcel$export($207acf722dcd432b$exports, "DN0", ()=>$207acf722dcd432b$export$3d4f271a500072a);
$parcel$export($207acf722dcd432b$exports, "DN800A", ()=>$207acf722dcd432b$export$fe151285c22759ec);
$parcel$export($207acf722dcd432b$exports, "DN700A", ()=>$207acf722dcd432b$export$a101c6190d0da34);
$parcel$export($207acf722dcd432b$exports, "DN600A", ()=>$207acf722dcd432b$export$4b16f52932fda51);
$parcel$export($207acf722dcd432b$exports, "DN500A", ()=>$207acf722dcd432b$export$a74bcd7b9845b0d8);
$parcel$export($207acf722dcd432b$exports, "DN400A", ()=>$207acf722dcd432b$export$9209c179316d1751);
$parcel$export($207acf722dcd432b$exports, "DN300A", ()=>$207acf722dcd432b$export$88f55133f636c8dd);
$parcel$export($207acf722dcd432b$exports, "DN200A", ()=>$207acf722dcd432b$export$51126f85d1009512);
$parcel$export($207acf722dcd432b$exports, "DN100A", ()=>$207acf722dcd432b$export$a069b547bd23af78);
$parcel$export($207acf722dcd432b$exports, "DN90A", ()=>$207acf722dcd432b$export$40cce05af3b2600a);
$parcel$export($207acf722dcd432b$exports, "DN80A", ()=>$207acf722dcd432b$export$b78942185925a0d);
$parcel$export($207acf722dcd432b$exports, "DN70A", ()=>$207acf722dcd432b$export$e058fb44b8eaafca);
$parcel$export($207acf722dcd432b$exports, "DN60A", ()=>$207acf722dcd432b$export$92b0b8de26920c18);
$parcel$export($207acf722dcd432b$exports, "DN50A", ()=>$207acf722dcd432b$export$67564f7459d3fc9e);
$parcel$export($207acf722dcd432b$exports, "DN40A", ()=>$207acf722dcd432b$export$77868e1ca884ffa3);
$parcel$export($207acf722dcd432b$exports, "DN30A", ()=>$207acf722dcd432b$export$2afd71d7d3ea2cd5);
$parcel$export($207acf722dcd432b$exports, "DN20A", ()=>$207acf722dcd432b$export$f2a0acaab9972c70);
$parcel$export($207acf722dcd432b$exports, "DN10A", ()=>$207acf722dcd432b$export$9ab70e67d6475361);
$parcel$export($207acf722dcd432b$exports, "T30", ()=>$207acf722dcd432b$export$d2adc5dedf09fced);
$parcel$export($207acf722dcd432b$exports, "L50", ()=>$207acf722dcd432b$export$f51762073d2bb381);
$parcel$export($207acf722dcd432b$exports, "L75", ()=>$207acf722dcd432b$export$95e26d54def96891);
const $207acf722dcd432b$export$4b84fd0e2c617bd = '#FFEBE6';
const $207acf722dcd432b$export$b34b069eff244586 = '#FFBDAD';
const $207acf722dcd432b$export$be802dd0d8b57f35 = '#FF8F73';
const $207acf722dcd432b$export$60847d42f9da92a6 = '#FF7452';
const $207acf722dcd432b$export$4a7404f376229999 = '#FF5630';
const $207acf722dcd432b$export$2010d0fb4295b346 = '#DE350B';
const $207acf722dcd432b$export$2837b5a1a71d5c02 = '#BF2600';
const $207acf722dcd432b$export$8d9596b529bbb9cf = '#FFFAE6';
const $207acf722dcd432b$export$41060a744ab0b7ae = '#FFF0B3';
const $207acf722dcd432b$export$1cc05bbbf340e559 = '#FFE380';
const $207acf722dcd432b$export$5aae31392d72caaa = '#FFC400';
const $207acf722dcd432b$export$c6930421db9fa514 = '#FFAB00';
const $207acf722dcd432b$export$59619663aa6500fb = '#FF991F';
const $207acf722dcd432b$export$874739ea9e379ab6 = '#FF8B00';
const $207acf722dcd432b$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $207acf722dcd432b$export$69a3bf21b9686c2b = '#ABF5D1';
const $207acf722dcd432b$export$afbce1382ec95f73 = '#79F2C0';
const $207acf722dcd432b$export$747d86715d4175de = '#57D9A3';
const $207acf722dcd432b$export$940e1f69e873f202 = '#36B37E';
const $207acf722dcd432b$export$a49394138f7b8e85 = '#00875A';
const $207acf722dcd432b$export$6fa04827ac68a4fb = '#006644';
const $207acf722dcd432b$export$226de0355ed012f8 = '#DEEBFF';
const $207acf722dcd432b$export$8c13c2ee36917869 = '#B3D4FF';
const $207acf722dcd432b$export$ecfc1dff386a3e7a = '#4C9AFF';
const $207acf722dcd432b$export$215b7063051591f1 = '#2684FF';
const $207acf722dcd432b$export$e62e8919cca44969 = '#0065FF';
const $207acf722dcd432b$export$b3de0ae08da2ce64 = '#0052CC';
const $207acf722dcd432b$export$a6ee3d71bc067634 = '#0747A6';
const $207acf722dcd432b$export$67f15409e87642a1 = '#669DF1';
const $207acf722dcd432b$export$f0539dbc42dbb067 = '#8FB8F6';
const $207acf722dcd432b$export$363e4475840015bb = '#EAE6FF';
const $207acf722dcd432b$export$4b0a4417ed59760f = '#C0B6F2';
const $207acf722dcd432b$export$6011520a64d9a187 = '#998DD9';
const $207acf722dcd432b$export$a7175d4e9206bc80 = '#8777D9';
const $207acf722dcd432b$export$b48405b95304b5a1 = '#6554C0';
const $207acf722dcd432b$export$c71e4279dd54a18d = '#5243AA';
const $207acf722dcd432b$export$147899de772240ec = '#403294';
const $207acf722dcd432b$export$2cf711fe14c66f06 = '#E6FCFF';
const $207acf722dcd432b$export$7a8f4d33f6f9772c = '#B3F5FF';
const $207acf722dcd432b$export$776c9c497ef08533 = '#79E2F2';
const $207acf722dcd432b$export$69cb3ca10c1e330e = '#00C7E6';
const $207acf722dcd432b$export$9dc1ef0f3f48059b = '#00B8D9';
const $207acf722dcd432b$export$7c835c78b6fcdef8 = '#00A3BF';
const $207acf722dcd432b$export$6036577f95c3877e = '#008DA6';
const $207acf722dcd432b$export$29a4f05edc054374 = '#FFFFFF';
const $207acf722dcd432b$export$e655ef011c4aa1a2 = '#FAFBFC';
const $207acf722dcd432b$export$9fdfb749e33cdf97 = '#F4F5F7';
const $207acf722dcd432b$export$3e51e8f1440314ba = '#EBECF0';
const $207acf722dcd432b$export$1ce2d1575d444ceb = '#DFE1E6';
const $207acf722dcd432b$export$8754fc7e6d8b3000 = '#C1C7D0';
const $207acf722dcd432b$export$c2e91cbeada39b8b = '#B3BAC5';
const $207acf722dcd432b$export$5f71e19f3a7ad9de = '#A5ADBA';
const $207acf722dcd432b$export$eaa8c8a70ac22806 = '#97A0AF';
const $207acf722dcd432b$export$7c87d337fb91a97d = '#8993A4';
const $207acf722dcd432b$export$d6447c357493214f = '#7A869A';
const $207acf722dcd432b$export$f563ee71e9ee74cd = '#6B778C';
const $207acf722dcd432b$export$e2ef2124cf4024b1 = '#5E6C84';
const $207acf722dcd432b$export$eece5f492e429f08 = '#505F79';
const $207acf722dcd432b$export$c39c0fe0f26207ae = '#42526E';
const $207acf722dcd432b$export$7090862dc3038a9f = '#344563';
const $207acf722dcd432b$export$ad0bacf983b7ddaa = '#253858';
const $207acf722dcd432b$export$7d61b15e0da132af = '#172B4D';
const $207acf722dcd432b$export$fbda843f0a27fe96 = '#091E42';
const $207acf722dcd432b$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $207acf722dcd432b$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $207acf722dcd432b$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $207acf722dcd432b$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $207acf722dcd432b$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $207acf722dcd432b$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $207acf722dcd432b$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $207acf722dcd432b$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $207acf722dcd432b$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $207acf722dcd432b$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $207acf722dcd432b$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $207acf722dcd432b$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $207acf722dcd432b$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $207acf722dcd432b$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $207acf722dcd432b$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $207acf722dcd432b$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $207acf722dcd432b$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $207acf722dcd432b$export$2f6319cf7d736c2a = '#E6EDFA';
const $207acf722dcd432b$export$95126bc8884d6634 = '#DCE5F5';
const $207acf722dcd432b$export$8338d8c35d44ff1 = '#CED9EB';
const $207acf722dcd432b$export$5368d76ae4fbbda7 = '#B8C7E0';
const $207acf722dcd432b$export$9f0a771d16ec8d36 = '#ABBBD6';
const $207acf722dcd432b$export$abcf8c38338b4aa5 = '#9FB0CC';
const $207acf722dcd432b$export$97e81faa16a182c7 = '#8C9CB8';
const $207acf722dcd432b$export$bfe21c59123ecf33 = '#7988A3';
const $207acf722dcd432b$export$ee82aa2ea6a1558 = '#67758F';
const $207acf722dcd432b$export$682927c6ed76be02 = '#56637A';
const $207acf722dcd432b$export$91fd9994c5be9757 = '#455166';
const $207acf722dcd432b$export$d281fbfe3cff2df6 = '#3B475C';
const $207acf722dcd432b$export$3902c91d8b98a753 = '#313D52';
const $207acf722dcd432b$export$8e8133c1ba5845b5 = '#283447';
const $207acf722dcd432b$export$33ff357f6620b39 = '#202B3D';
const $207acf722dcd432b$export$633847cf062b69e0 = '#1B2638';
const $207acf722dcd432b$export$9776a6e503bdbf76 = '#121A29';
const $207acf722dcd432b$export$6c813d5160dff5db = '#0E1624';
const $207acf722dcd432b$export$3d4f271a500072a = '#0D1424';
const $207acf722dcd432b$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $207acf722dcd432b$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $207acf722dcd432b$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $207acf722dcd432b$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $207acf722dcd432b$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $207acf722dcd432b$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $207acf722dcd432b$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $207acf722dcd432b$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $207acf722dcd432b$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $207acf722dcd432b$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $207acf722dcd432b$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $207acf722dcd432b$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $207acf722dcd432b$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $207acf722dcd432b$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $207acf722dcd432b$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $207acf722dcd432b$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $207acf722dcd432b$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $207acf722dcd432b$export$d2adc5dedf09fced = '#292A2E';
const $207acf722dcd432b$export$f51762073d2bb381 = '#94C748';
const $207acf722dcd432b$export$95e26d54def96891 = '#B3DF72';
parcelRegister("fSdNy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45c24482477fc46e$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $jijTN = parcelRequire("jijTN");
    const $45c24482477fc46e$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
        let style = `:root{--${variableName}:${value}px;}`;
        if (mobileValue) style += ` ${(0, $jijTN.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
        return ((0, ($parcel$interopDefault($eUqFw))).createElement("style", null, style));
    };
    var $45c24482477fc46e$export$2e2bcd8739ae039 = $45c24482477fc46e$var$SlotDimensions;
});
parcelRegister("5zubN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a578b0315f0c8bf$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $75Bx4 = parcelRequire("75Bx4");
    const $3a578b0315f0c8bf$var$contentStyles = (0, $byn9U.css)({
        display: 'flex',
        height: '100%',
        position: 'relative',
        gridArea: (0, $75Bx4.CONTENT)
    });
    const $3a578b0315f0c8bf$var$Content = (props)=>{
        const { children: children, testId: testId } = props;
        return (0, $byn9U.jsx)("div", {
            "data-testid": testId,
            css: $3a578b0315f0c8bf$var$contentStyles
        }, children);
    };
    var $3a578b0315f0c8bf$export$2e2bcd8739ae039 = $3a578b0315f0c8bf$var$Content;
});
parcelRegister("g6H0B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69eefdca36853d17$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $75Bx4 = parcelRequire("75Bx4");
    var $1TdPC = parcelRequire("1TdPC");
    var $hYrzK = parcelRequire("hYrzK");
    var $9F5OS = parcelRequire("9F5OS");
    var $gVnn3 = parcelRequire("gVnn3");
    var $fSdNy = parcelRequire("fSdNy");
    const $69eefdca36853d17$var$leftPanelStyles = (0, $byn9U.css)({
        gridArea: (0, $75Bx4.LEFT_PANEL)
    });
    const $69eefdca36853d17$var$leftPanelFixedStyles = (0, $byn9U.css)({
        width: (0, $75Bx4.LEFT_PANEL_WIDTH),
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    });
    const $69eefdca36853d17$var$LeftPanel = (props)=>{
        const { children: children, isFixed: isFixed, width: width = (0, $75Bx4.DEFAULT_LEFT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const leftPanelWidth = (0, $1TdPC.resolveDimension)((0, $75Bx4.VAR_LEFT_PANEL_WIDTH), width, shouldPersistWidth);
        (0, $eUqFw.useEffect)(()=>{
            (0, $hYrzK.default)({
                [(0, $75Bx4.VAR_LEFT_PANEL_WIDTH)]: leftPanelWidth
            });
            return ()=>{
                (0, $hYrzK.default)({
                    [(0, $75Bx4.VAR_LEFT_PANEL_WIDTH)]: 0
                });
            };
        }, [
            leftPanelWidth
        ]);
        (0, $9F5OS.useSkipLink)(id, skipLinkTitle);
        return (0, $byn9U.jsx)((0, $gVnn3.default), null, ({ className: className })=>(0, $byn9U.jsx)("div", {
                css: [
                    $69eefdca36853d17$var$leftPanelStyles,
                    isFixed && $69eefdca36853d17$var$leftPanelFixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, $1TdPC.getPageLayoutSlotSelector)('left-panel')
            }, (0, $byn9U.jsx)((0, $fSdNy.default), {
                variableName: (0, $75Bx4.VAR_LEFT_PANEL_WIDTH),
                value: leftPanelWidth
            }), children));
    };
    var $69eefdca36853d17$export$2e2bcd8739ae039 = $69eefdca36853d17$var$LeftPanel;
});
parcelRegister("khqN6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$75b1fe406f712fa9$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $cho8R = parcelRequire("cho8R");
    var $hHxfS = parcelRequire("hHxfS");
    var $75Bx4 = parcelRequire("75Bx4");
    var $1TdPC = parcelRequire("1TdPC");
    var $hYrzK = parcelRequire("hYrzK");
    var $ltVyn = parcelRequire("ltVyn");
    var $9F5OS = parcelRequire("9F5OS");
    var $id1HL = parcelRequire("id1HL");
    var $81H7L = parcelRequire("81H7L");
    var $2nFNU = parcelRequire("2nFNU");
    var $58Ldm = parcelRequire("58Ldm");
    var $fSdNy = parcelRequire("fSdNy");
    const $75b1fe406f712fa9$var$openBackdropStyles = (0, $byn9U.css)({
        width: '100%',
        height: '100%',
        position: 'absolute',
        background: `var(--ds-blanket, ${(0, $207acf722dcd432b$export$486ab785e4bac3c6)})`,
        opacity: 1
    });
    const $75b1fe406f712fa9$var$hiddenBackdropStyles = (0, $byn9U.css)({
        opacity: 0,
        transition: `opacity ${(0, $75Bx4.TRANSITION_DURATION)}ms ${(0, $cb3878f71492e237$export$57636bb43b1ccbb0)} 0s`
    });
    const $75b1fe406f712fa9$var$LeftSidebar = (props)=>{
        const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
        const flyoutTimerRef = (0, $eUqFw.useRef)();
        const mouseOverEventRef = (0, $eUqFw.useRef)();
        const leftSideBarRef = (0, $eUqFw.useRef)(null);
        const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $eUqFw.useContext)((0, $ltVyn.SidebarResizeContext));
        const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth } = leftSidebarState;
        const isLocked = flyoutLockCount > 0;
        const isLockedRef = (0, $eUqFw.useRef)(isLocked);
        const mouseXRef = (0, $eUqFw.useRef)(0);
        const handlerRef = (0, $eUqFw.useRef)(null);
        (0, $eUqFw.useEffect)(()=>{
            isLockedRef.current = isLocked;
            if (isLocked && !handlerRef.current) {
                handlerRef.current = (event)=>{
                    mouseXRef.current = event.clientX;
                };
                document.addEventListener('mousemove', handlerRef.current);
            }
            if (!isLocked && handlerRef.current) {
                if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                document.removeEventListener('mousemove', handlerRef.current);
                handlerRef.current = null;
            }
            return ()=>{
                if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
            };
        }, [
            isLocked,
            lastLeftSidebarWidth,
            setLeftSidebarState
        ]);
        const _width = Math.max(width || 0, (0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH));
        const collapsedStateOverrideOpen = collapsedState === 'expanded';
        let leftSidebarWidthOnMount;
        if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, $1TdPC.resolveDimension)((0, $75Bx4.VAR_LEFT_SIDEBAR_FLYOUT), _width, !width);
        else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, $75Bx4.COLLAPSED_LEFT_SIDEBAR_WIDTH);
        else leftSidebarWidthOnMount = (0, $1TdPC.resolveDimension)((0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH), _width, !width || !collapsedStateOverrideOpen && (0, $1TdPC.getGridStateFromStorage)('isLeftSidebarCollapsed'));
        (0, $eUqFw.useEffect)(()=>{
            const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, $1TdPC.getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
            const cachedGridState = (0, $1TdPC.getGridStateFromStorage)('gridState') || {};
            let leftSidebarWidth = !width && cachedGridState[0, $75Bx4.VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, $75Bx4.VAR_LEFT_SIDEBAR_FLYOUT], (0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
            const lastLeftSidebarWidth = !width && cachedGridState[0, $75Bx4.VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, $75Bx4.VAR_LEFT_SIDEBAR_FLYOUT], (0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
            if (cachedCollapsedState) leftSidebarWidth = (0, $75Bx4.COLLAPSED_LEFT_SIDEBAR_WIDTH);
            setLeftSidebarState({
                isFlyoutOpen: false,
                isResizing: isResizing,
                isLeftSidebarCollapsed: cachedCollapsedState,
                leftSidebarWidth: leftSidebarWidth,
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                flyoutLockCount: 0,
                isFixed: isFixed
            });
        }, []);
        const notFirstRun = (0, $eUqFw.useRef)(false);
        (0, $eUqFw.useEffect)(()=>{
            if (notFirstRun.current) {
                (0, $hYrzK.default)({
                    [(0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth || leftSidebarWidthOnMount,
                    [(0, $75Bx4.VAR_LEFT_SIDEBAR_FLYOUT)]: lastLeftSidebarWidth
                });
                (0, $1TdPC.mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
            }
            if (!notFirstRun.current) notFirstRun.current = true;
            return ()=>{
                removeMouseOverListener();
            };
        }, [
            isLeftSidebarCollapsed,
            leftSidebarWidth,
            id
        ]);
        const onMouseOver = (event)=>{
            const isMouseOnResizeButton = event.target.matches(`[${(0, $75Bx4.RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, $75Bx4.RESIZE_BUTTON_SELECTOR)}] *`);
            if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
            event.persist();
            flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
            if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
                const leftSidebar = leftSideBarRef.current;
                if (leftSidebar === null || isLockedRef.current) return;
                if (!leftSidebar.contains(event.target)) {
                    flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                    onFlyoutCollapse && onFlyoutCollapse();
                    setLeftSidebarState((current)=>({
                            ...current,
                            isFlyoutOpen: false
                        }));
                    removeMouseOverListener();
                }
            };
            document.addEventListener('mouseover', mouseOverEventRef.current, {
                capture: true,
                passive: true
            });
            flyoutTimerRef.current = setTimeout(()=>{
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: true
                    }));
                onFlyoutExpand && onFlyoutExpand();
            }, (0, $75Bx4.FLYOUT_DELAY));
        };
        const removeMouseOverListener = ()=>{
            mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
                capture: true,
                passive: true
            });
        };
        (0, $9F5OS.useSkipLink)(id, skipLinkTitle);
        const onMouseLeave = (event)=>{
            const isMouseOnResizeButton = event.target.matches(`[${(0, $75Bx4.RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, $75Bx4.RESIZE_BUTTON_SELECTOR)}] *`);
            if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
            onFlyoutCollapse && onFlyoutCollapse();
            setTimeout(()=>{
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
            }, (0, $75Bx4.FLYOUT_DELAY));
        };
        const mobileMediaQuery = (0, $hHxfS.UNSAFE_useMediaQuery)('below.sm');
        const openMobileFlyout = (0, $eUqFw.useCallback)(()=>{
            if (!mobileMediaQuery?.matches) return;
            setLeftSidebarState((current)=>{
                if (current.isFlyoutOpen) return current;
                return {
                    ...current,
                    isFlyoutOpen: true
                };
            });
        }, [
            setLeftSidebarState,
            mobileMediaQuery
        ]);
        const closeMobileFlyout = (0, $eUqFw.useCallback)(()=>{
            if (!mobileMediaQuery?.matches) return;
            setLeftSidebarState((current)=>{
                if (!current.isFlyoutOpen) return current;
                return {
                    ...current,
                    isFlyoutOpen: false
                };
            });
        }, [
            setLeftSidebarState,
            mobileMediaQuery
        ]);
        (0, $hHxfS.UNSAFE_useMediaQuery)('below.sm', (event)=>{
            setLeftSidebarState((current)=>{
                if (event.matches && !current.isLeftSidebarCollapsed) return {
                    ...current,
                    isResizing: false,
                    isLeftSidebarCollapsed: true,
                    leftSidebarWidth: (0, $75Bx4.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: current.leftSidebarWidth,
                    isFlyoutOpen: true
                };
                else if (!event.matches && current.isFlyoutOpen) return {
                    ...current,
                    isResizing: false,
                    isLeftSidebarCollapsed: false,
                    leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH)),
                    isFlyoutOpen: false
                };
                return current;
            });
        });
        (0, $cho8R.default)({
            onClose: closeMobileFlyout,
            isDisabled: !isFlyoutOpen
        });
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, mobileMediaQuery?.matches && (0, $byn9U.jsx)("div", {
            css: [
                $75b1fe406f712fa9$var$hiddenBackdropStyles,
                isFlyoutOpen && $75b1fe406f712fa9$var$openBackdropStyles
            ],
            onClick: closeMobileFlyout
        }), (0, $byn9U.jsx)((0, $2nFNU.default), {
            ref: leftSideBarRef,
            testId: testId,
            onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
            onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
            onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
            id: id,
            isFixed: isFixed
        }, (0, $byn9U.jsx)((0, $fSdNy.default), {
            variableName: (0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH),
            value: notFirstRun.current ? leftSidebarWidth : leftSidebarWidthOnMount,
            mobileValue: (0, $75Bx4.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)
        }), (0, $byn9U.jsx)((0, $81H7L.default), {
            isFixed: isFixed,
            isFlyoutOpen: isFlyoutOpen
        }, (0, $byn9U.jsx)((0, $58Ldm.default), {
            isFlyoutOpen: isFlyoutOpen,
            isLeftSidebarCollapsed: isLeftSidebarCollapsed,
            hasCollapsedState: !notFirstRun.current && collapsedState === 'collapsed',
            testId: testId && `${testId}-resize-children-wrapper`
        }, children), (0, $byn9U.jsx)((0, $id1HL.default), {
            testId: testId,
            valueTextLabel: valueTextLabel,
            resizeGrabAreaLabel: resizeGrabAreaLabel,
            resizeButtonLabel: resizeButtonLabel,
            overrides: overrides,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd
        }))));
    };
    var $75b1fe406f712fa9$export$2e2bcd8739ae039 = $75b1fe406f712fa9$var$LeftSidebar;
});
const $cb3878f71492e237$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $cb3878f71492e237$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $cb3878f71492e237$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
parcelRegister("ltVyn", function(module, exports) {
    $parcel$export(module.exports, "SidebarResizeContext", ()=>$2ce9fc5e43a25986$export$aa5a712eea4c2ae8);
    $parcel$export(module.exports, "usePageLayoutResize", ()=>$2ce9fc5e43a25986$export$10c7104037a7af62);
    $parcel$export(module.exports, "useLeftSidebarFlyoutLock", ()=>$2ce9fc5e43a25986$export$94561f6055639ef7);
    var $eUqFw = parcelRequire("eUqFw");
    var $4oSDA = parcelRequire("4oSDA");
    const $2ce9fc5e43a25986$var$leftSidebarState = {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true
    };
    const $2ce9fc5e43a25986$export$aa5a712eea4c2ae8 = (0, $eUqFw.createContext)({
        isLeftSidebarCollapsed: false,
        expandLeftSidebar: (0, $4oSDA.default),
        collapseLeftSidebar: (0, $4oSDA.default),
        leftSidebarState: $2ce9fc5e43a25986$var$leftSidebarState,
        setLeftSidebarState: (0, $4oSDA.default),
        toggleLeftSidebar: (0, $4oSDA.default)
    });
    const $2ce9fc5e43a25986$export$10c7104037a7af62 = ()=>{
        const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $eUqFw.useContext)($2ce9fc5e43a25986$export$aa5a712eea4c2ae8);
        return context;
    };
    const $2ce9fc5e43a25986$export$94561f6055639ef7 = ()=>{
        const { setLeftSidebarState: setLeftSidebarState } = (0, $eUqFw.useContext)($2ce9fc5e43a25986$export$aa5a712eea4c2ae8);
        (0, $eUqFw.useEffect)(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount + 1
                }));
            return ()=>{
                setLeftSidebarState((current)=>({
                        ...current,
                        flyoutLockCount: current.flyoutLockCount - 1
                    }));
            };
        }, [
            setLeftSidebarState
        ]);
    };
});
parcelRegister("id1HL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3642cf6901b51bb4$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $74BVL = parcelRequire("74BVL");
    var $8yx6O = parcelRequire("8yx6O");
    var $hHxfS = parcelRequire("hHxfS");
    var $75Bx4 = parcelRequire("75Bx4");
    var $1TdPC = parcelRequire("1TdPC");
    var $ltVyn = parcelRequire("ltVyn");
    var $03L7w = parcelRequire("03L7w");
    var $gzLvr = parcelRequire("gzLvr");
    var $5eagr = parcelRequire("5eagr");
    function $3642cf6901b51bb4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3642cf6901b51bb4$var$cssSelector = {
        [(0, $75Bx4.RESIZE_CONTROL_SELECTOR)]: true
    };
    const $3642cf6901b51bb4$var$resizeControlStyles = {
        name: "ow3ovp",
        styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
    };
    const $3642cf6901b51bb4$var$showResizeButtonStyles = {
        name: "1a6byq5",
        styles: "--ds--resize-button--opacity:1"
    };
    const $3642cf6901b51bb4$var$globalResizingStyles = {
        name: "e4avm6",
        styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
    };
    const $3642cf6901b51bb4$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
        const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $eUqFw.useContext)((0, $ltVyn.SidebarResizeContext));
        const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
        const sidebarWidth = (0, $eUqFw.useRef)(leftSidebarState[0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH]);
        const offset = (0, $eUqFw.useRef)(0);
        const keyboardEventTimeout = (0, $eUqFw.useRef)();
        const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $eUqFw.useState)(false);
        const unbindEvents = (0, $eUqFw.useRef)(null);
        const mobileMediaQuery = (0, $hHxfS.UNSAFE_useMediaQuery)('below.sm');
        const stableSidebarState = (0, $eUqFw.useRef)(leftSidebarState);
        (0, $eUqFw.useEffect)(()=>{
            stableSidebarState.current = leftSidebarState;
        }, [
            leftSidebarState
        ]);
        const toggleSideBar = (0, $eUqFw.useCallback)((event)=>{
            event?.stopPropagation();
            toggleLeftSidebar();
        }, [
            toggleLeftSidebar
        ]);
        const onMouseDown = (event)=>{
            if (isLeftSidebarCollapsed) return;
            if (event.button !== 0) return;
            if (leftSidebarState.isResizing) return;
            offset.current = event.clientX - leftSidebarState[0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH] - (0, $1TdPC.getLeftPanelWidth)();
            unbindEvents.current = (0, $74BVL.bindAll)(window, [
                {
                    type: 'mousemove',
                    listener: function(event) {
                        onUpdateResize({
                            clientX: event.clientX
                        });
                    }
                },
                {
                    type: 'mouseup',
                    listener: onFinishResizing
                },
                {
                    type: 'mousedown',
                    listener: (()=>{
                        let hasFramePassed = false;
                        requestAnimationFrame(()=>{
                            hasFramePassed = true;
                        });
                        return function listener() {
                            if (hasFramePassed) onFinishResizing();
                        };
                    })()
                },
                {
                    type: 'visibilitychange',
                    listener: onFinishResizing
                },
                {
                    type: 'click',
                    listener: onFinishResizing
                },
                {
                    type: 'keydown',
                    listener: (event)=>{
                        if (event.key === 'Escape') {
                            sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, $75Bx4.COLLAPSED_LEFT_SIDEBAR_WIDTH));
                            document.documentElement.style.setProperty(`--${(0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
                            onFinishResizing();
                        }
                    }
                }
            ]);
            document.documentElement.setAttribute((0, $75Bx4.IS_SIDEBAR_DRAGGING), 'true');
            const newLeftbarState = {
                ...leftSidebarState,
                isResizing: true
            };
            setLeftSidebarState(newLeftbarState);
            onResizeStart && onResizeStart(newLeftbarState);
        };
        const onResizeOffLeftOfScreen = ()=>{
            onUpdateResize.cancel();
            unbindEvents.current?.();
            unbindEvents.current = null;
            document.documentElement.removeAttribute((0, $75Bx4.IS_SIDEBAR_DRAGGING));
            offset.current = 0;
            collapseLeftSidebar(undefined, true);
        };
        const [onUpdateResize] = (0, $eUqFw.useState)(()=>(0, $8yx6O.default)(({ clientX: clientX })=>{
                const maxWidth = Math.round(window.innerWidth / 2);
                const leftPanelWidth = (0, $1TdPC.getLeftPanelWidth)();
                const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
                const hasResizedOffLeftOfScreen = clientX < 0;
                if (hasResizedOffLeftOfScreen) {
                    onResizeOffLeftOfScreen();
                    return;
                }
                const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, $75Bx4.COLLAPSED_LEFT_SIDEBAR_WIDTH) - leftSidebarWidth - leftPanelWidth);
                sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, $75Bx4.COLLAPSED_LEFT_SIDEBAR_WIDTH));
                document.documentElement.style.setProperty(`--${(0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
            }));
        const onFinishResizing = ()=>{
            if (isLeftSidebarCollapsed) return;
            document.documentElement.removeAttribute((0, $75Bx4.IS_SIDEBAR_DRAGGING));
            let updatedLeftSidebarState = null;
            if (sidebarWidth.current < (0, $75Bx4.MIN_LEFT_SIDEBAR_DRAG_THRESHOLD)) {
                document.documentElement.style.setProperty(`--${(0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $75Bx4.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`);
                collapseLeftSidebar(undefined, true);
            } else if (sidebarWidth.current > (0, $75Bx4.MIN_LEFT_SIDEBAR_DRAG_THRESHOLD) && sidebarWidth.current < (0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH)) {
                document.documentElement.style.setProperty(`--${(0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH)}px`);
                updatedLeftSidebarState = {
                    ...leftSidebarState,
                    isResizing: false,
                    [(0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH)]: (0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: (0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH)
                };
                setLeftSidebarState(updatedLeftSidebarState);
            } else {
                updatedLeftSidebarState = {
                    ...leftSidebarState,
                    isResizing: false,
                    [(0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH)]: sidebarWidth.current,
                    lastLeftSidebarWidth: sidebarWidth.current
                };
                setLeftSidebarState(updatedLeftSidebarState);
            }
            unbindEvents.current?.();
            unbindEvents.current = null;
            onUpdateResize.cancel();
            sidebarWidth.current = 0;
            offset.current = 0;
            requestAnimationFrame(()=>{
                setIsGrabAreaFocused(false);
                onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
            });
        };
        const onKeyDown = (event)=>{
            if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
            const { key: key } = event;
            const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
            const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
            const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
            if (isSpaceOrEnter) {
                toggleSideBar(event);
                event.preventDefault();
            }
            if (isLeftOrTopArrow || isRightOrBottomArrow) {
                event.preventDefault();
                onResizeStart && onResizeStart(leftSidebarState);
                const step = 10;
                const stepValue = isLeftOrTopArrow ? -step : step;
                const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
                const maxWidth = Math.round(window.innerWidth / 2) - (0, $1TdPC.getLeftPanelWidth)();
                const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
                let width = leftSidebarWidth + stepValue;
                if (width <= (0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH)) {
                    width = (0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH);
                    document.documentElement.style.setProperty(`--${(0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH) - 20}px`);
                } else if (width > maxWidth) {
                    width = maxWidth;
                    document.documentElement.style.setProperty(`--${(0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH)}`, `${maxWidth + 20}px`);
                } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH);
                requestAnimationFrame(()=>{
                    keyboardEventTimeout.current = window.setTimeout(()=>{
                        keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                        document.documentElement.style.setProperty(`--${(0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH)}`, `${width}px`);
                        const updatedLeftSidebarState = {
                            ...leftSidebarState,
                            [(0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH)]: width,
                            lastLeftSidebarWidth: width
                        };
                        setLeftSidebarState(updatedLeftSidebarState);
                        onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                    }, 50);
                });
            }
        };
        const onFocus = (0, $eUqFw.useCallback)(()=>{
            setIsGrabAreaFocused(true);
        }, []);
        const onBlur = (0, $eUqFw.useCallback)(()=>{
            setIsGrabAreaFocused(false);
        }, []);
        const resizeButton = {
            render: (Component, props)=>(0, $byn9U.jsx)(Component, props),
            ...overrides && overrides.ResizeButton
        };
        const maxAriaWidth = (0, $eUqFw.useMemo)(()=>{
            const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
            return Math.round(innerWidth / 2) - (0, $1TdPC.getLeftPanelWidth)();
        }, []);
        const leftSidebarPercentageExpanded = (0, $1TdPC.getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("div", {
            ...$3642cf6901b51bb4$var$cssSelector,
            css: [
                $3642cf6901b51bb4$var$resizeControlStyles,
                (isGrabAreaFocused || isLeftSidebarCollapsed) && $3642cf6901b51bb4$var$showResizeButtonStyles
            ]
        }, (0, $byn9U.jsx)((0, $5eagr.default), {
            testId: testId && `${testId}-shadow`
        }), !mobileMediaQuery?.matches && (0, $byn9U.jsx)((0, $03L7w.default), {
            isDisabled: isLeftSidebarCollapsed,
            isLeftSidebarCollapsed: isLeftSidebarCollapsed,
            label: resizeGrabAreaLabel,
            valueTextLabel: valueTextLabel,
            leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            onMouseDown: onMouseDown,
            testId: testId && `${testId}-grab-area`
        }), resizeButton.render((0, $gzLvr.default), {
            isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
            label: resizeButtonLabel,
            onClick: toggleSideBar,
            testId: testId && `${testId}-resize-button`
        })), leftSidebarState.isResizing ? (0, $byn9U.jsx)((0, $byn9U.Global), {
            styles: $3642cf6901b51bb4$var$globalResizingStyles
        }) : null);
    };
    var $3642cf6901b51bb4$export$2e2bcd8739ae039 = $3642cf6901b51bb4$var$ResizeControl;
});
parcelRegister("03L7w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a468b416d15ac8d$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $75Bx4 = parcelRequire("75Bx4");
    function $5a468b416d15ac8d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5a468b416d15ac8d$var$varLineColor = '--ds-line';
    const $5a468b416d15ac8d$var$grabAreaStyles = (0, $byn9U.css)({
        width: "var(--ds-space-200, 16px)",
        height: '100%',
        padding: 0,
        backgroundColor: 'transparent',
        border: 0,
        cursor: 'ew-resize',
        '&::-moz-focus-inner': {
            border: 0
        },
        '&:focus': {
            outline: 0
        },
        '&:enabled:hover, &:enabled:focus, &:enabled:active': {
            [$5a468b416d15ac8d$var$varLineColor]: `var(--ds-border-selected, ${(0, $207acf722dcd432b$export$215b7063051591f1)})`
        }
    });
    const $5a468b416d15ac8d$var$grabAreaCollapsedStyles = (0, $byn9U.css)({
        height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
        padding: 0,
        position: 'absolute',
        backgroundColor: 'transparent',
        border: 0,
        cursor: 'default',
        insetBlockEnd: 0
    });
    const $5a468b416d15ac8d$var$lineStyles = {
        name: "w4swnc",
        styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
    };
    const $5a468b416d15ac8d$var$grabAreaLineSelector = {
        [(0, $75Bx4.GRAB_AREA_LINE_SELECTOR)]: true
    };
    const $5a468b416d15ac8d$var$grabAreaSelector = {
        [(0, $75Bx4.GRAB_AREA_SELECTOR)]: true
    };
    const $5a468b416d15ac8d$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>(0, $byn9U.jsx)("button", {
            ...$5a468b416d15ac8d$var$grabAreaSelector,
            "aria-label": label,
            "data-testid": testId,
            disabled: isDisabled,
            "aria-hidden": isLeftSidebarCollapsed,
            type: "button",
            role: "slider",
            css: [
                $5a468b416d15ac8d$var$grabAreaStyles,
                isLeftSidebarCollapsed && $5a468b416d15ac8d$var$grabAreaCollapsedStyles
            ],
            "aria-orientation": "vertical",
            "aria-valuenow": leftSidebarPercentageExpanded,
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
            onKeyDown: onKeyDown,
            onMouseDown: onMouseDown,
            onFocus: onFocus,
            onBlur: onBlur,
            ...rest
        }, (0, $byn9U.jsx)("span", {
            css: $5a468b416d15ac8d$var$lineStyles,
            ...$5a468b416d15ac8d$var$grabAreaLineSelector
        }));
    var $5a468b416d15ac8d$export$2e2bcd8739ae039 = $5a468b416d15ac8d$var$GrabArea;
});
parcelRegister("gzLvr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ae73fa7b41c1a3e$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $3b8a6 = parcelRequire("3b8a6");
    var $gN8bb = parcelRequire("gN8bb");
    var $jijTN = parcelRequire("jijTN");
    var $75Bx4 = parcelRequire("75Bx4");
    function $2ae73fa7b41c1a3e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2ae73fa7b41c1a3e$var$increaseHitAreaStyles = (0, $byn9U.css)({
        position: 'absolute',
        insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
        insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
        insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
        insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
    });
    const $2ae73fa7b41c1a3e$var$mobileStyles = (0, $byn9U.css)({
        [(0, $jijTN.UNSAFE_media).below.sm]: {
            opacity: 1
        }
    });
    const $2ae73fa7b41c1a3e$var$resizeIconButtonStyles = (0, $byn9U.css)({
        width: 24,
        height: 24,
        padding: "var(--ds-space-0, 0px)",
        position: 'absolute',
        backgroundColor: `var(--ds-surface-overlay, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
        border: 0,
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        boxShadow: `0 0 0 1px ${(0, $207acf722dcd432b$export$920c0d5c49070351)}, 0 2px 4px 1px ${(0, $207acf722dcd432b$export$920c0d5c49070351)}`,
        color: `var(--ds-text-subtle, ${(0, $207acf722dcd432b$export$f563ee71e9ee74cd)})`,
        cursor: 'pointer',
        insetBlockStart: "var(--ds-space-400, 32px)",
        insetInlineStart: 0,
        opacity: `var(--ds--resize-button--opacity,0)`,
        outline: 0,
        transform: 'translateX(-50%)',
        transition: `
    background-color ${(0, $gN8bb.smallDurationMs)}ms linear,
    color ${(0, $gN8bb.smallDurationMs)}ms linear,
    opacity ${(0, $gN8bb.mediumDurationMs)}ms ${(0, $cb3878f71492e237$export$57636bb43b1ccbb0)}
  `,
        ':hover': {
            backgroundColor: `var(--ds-background-selected-bold, ${(0, $207acf722dcd432b$export$ecfc1dff386a3e7a)})`,
            color: `var(--ds-text-inverse, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
            opacity: 1
        },
        ':active, :focus': {
            backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $207acf722dcd432b$export$215b7063051591f1)})`,
            color: `var(--ds-text-inverse, ${(0, $207acf722dcd432b$export$29a4f05edc054374)})`,
            opacity: 1
        }
    });
    const $2ae73fa7b41c1a3e$var$resizeIconButtonExpandedStyles = {
        name: "1bl2513",
        styles: "transform:rotate(180deg);transform-origin:7px"
    };
    const $2ae73fa7b41c1a3e$var$preventDefault = (event)=>event.preventDefault();
    const $2ae73fa7b41c1a3e$var$cssSelector = {
        [(0, $75Bx4.RESIZE_BUTTON_SELECTOR)]: true
    };
    const $2ae73fa7b41c1a3e$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>(0, $byn9U.jsx)("button", {
            ...$2ae73fa7b41c1a3e$var$cssSelector,
            "aria-expanded": !isLeftSidebarCollapsed,
            "aria-label": label,
            type: "button",
            css: [
                $2ae73fa7b41c1a3e$var$resizeIconButtonStyles,
                $2ae73fa7b41c1a3e$var$mobileStyles,
                !isLeftSidebarCollapsed && $2ae73fa7b41c1a3e$var$resizeIconButtonExpandedStyles
            ],
            "data-testid": testId,
            onMouseDown: $2ae73fa7b41c1a3e$var$preventDefault,
            ...props
        }, (0, $byn9U.jsx)((0, ($parcel$interopDefault($3b8a6))), {
            label: "",
            color: "currentColor"
        }), (0, $byn9U.jsx)("span", {
            css: $2ae73fa7b41c1a3e$var$increaseHitAreaStyles
        }));
    var $2ae73fa7b41c1a3e$export$2e2bcd8739ae039 = $2ae73fa7b41c1a3e$var$ResizeButton;
});
parcelRegister("5eagr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$03a1dcd16a58a1f4$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $kdHF2 = parcelRequire("kdHF2");
    const $03a1dcd16a58a1f4$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
    const $03a1dcd16a58a1f4$var$direction = 'to left';
    const $03a1dcd16a58a1f4$var$transitionDuration = '0.22s';
    const $03a1dcd16a58a1f4$var$shadowStyles = (0, $byn9U.css)({
        width: 3,
        position: 'absolute',
        background: `var(--ds-border, ${`linear-gradient(${$03a1dcd16a58a1f4$var$direction}, ${$03a1dcd16a58a1f4$var$colorStops})`})`,
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: -1,
        opacity: 0.5,
        pointerEvents: 'none',
        transitionDuration: $03a1dcd16a58a1f4$var$transitionDuration,
        transitionProperty: 'left, opacity, width',
        transitionTimingFunction: (0, $cb3878f71492e237$export$57636bb43b1ccbb0)
    });
    const $03a1dcd16a58a1f4$var$draggingStyles = (0, $byn9U.css)({
        width: 6,
        background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$03a1dcd16a58a1f4$var$direction}, ${$03a1dcd16a58a1f4$var$colorStops})`})`,
        insetInlineStart: "var(--ds-space-negative-075, -6px)",
        opacity: 0.8
    });
    const $03a1dcd16a58a1f4$var$Shadow = ({ testId: testId })=>{
        const isDragging = (0, $kdHF2.default)();
        return (0, $byn9U.jsx)("div", {
            "data-testid": testId,
            css: [
                $03a1dcd16a58a1f4$var$shadowStyles,
                isDragging && $03a1dcd16a58a1f4$var$draggingStyles
            ]
        });
    };
    var $03a1dcd16a58a1f4$export$2e2bcd8739ae039 = $03a1dcd16a58a1f4$var$Shadow;
});
parcelRegister("kdHF2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2db07e46c2d0c62$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $75Bx4 = parcelRequire("75Bx4");
    const $e2db07e46c2d0c62$var$getIsDragging = ()=>{
        if (typeof document === 'undefined') return false;
        return document.documentElement.getAttribute((0, $75Bx4.IS_SIDEBAR_DRAGGING)) === 'true';
    };
    const $e2db07e46c2d0c62$var$useIsSidebarDragging = ()=>{
        const [isDragging, setIsDragging] = (0, $eUqFw.useState)($e2db07e46c2d0c62$var$getIsDragging);
        (0, $eUqFw.useEffect)(()=>{
            const observer = new MutationObserver(()=>{
                setIsDragging($e2db07e46c2d0c62$var$getIsDragging);
            });
            observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $75Bx4.IS_SIDEBAR_DRAGGING)
                ]
            });
            return ()=>{
                observer.disconnect();
            };
        }, []);
        return isDragging;
    };
    var $e2db07e46c2d0c62$export$2e2bcd8739ae039 = $e2db07e46c2d0c62$var$useIsSidebarDragging;
});
parcelRegister("81H7L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5cab8715d7bc4d3c$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $2oI17 = parcelRequire("2oI17");
    var $jijTN = parcelRequire("jijTN");
    var $75Bx4 = parcelRequire("75Bx4");
    var $kdHF2 = parcelRequire("kdHF2");
    function $5cab8715d7bc4d3c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5cab8715d7bc4d3c$var$prefersReducedMotionStyles = (0, $byn9U.css)((0, $2oI17.prefersReducedMotion)());
    const $5cab8715d7bc4d3c$var$mobileStyles = (0, $byn9U.css)({
        [(0, $jijTN.UNSAFE_media).below.sm]: {
            width: `${(0, $75Bx4.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`,
            position: 'fixed',
            insetBlockEnd: 0,
            insetBlockStart: `calc(${(0, $75Bx4.BANNER_HEIGHT)} + ${(0, $75Bx4.TOP_NAVIGATION_HEIGHT)})`,
            insetInlineStart: `${(0, $75Bx4.LEFT_PANEL_WIDTH)}`,
            transition: `width ${(0, $75Bx4.TRANSITION_DURATION)}ms ${(0, $cb3878f71492e237$export$57636bb43b1ccbb0)} 0s`
        }
    });
    const $5cab8715d7bc4d3c$var$mobileInnerFlyoutStyles = (0, $byn9U.css)({
        [(0, $jijTN.UNSAFE_media).below.sm]: {
            width: `min(90vw, ${(0, $75Bx4.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH)}px)`,
            maxWidth: (0, $75Bx4.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
            transition: `width ${(0, $75Bx4.TRANSITION_DURATION)}ms ${(0, $cb3878f71492e237$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, $75Bx4.TRANSITION_DURATION)}ms ${(0, $cb3878f71492e237$export$57636bb43b1ccbb0)} 0s`
        }
    });
    const $5cab8715d7bc4d3c$var$fixedInnerStyles = (0, $byn9U.css)({
        width: `${(0, $75Bx4.LEFT_SIDEBAR_WIDTH)}`,
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: `calc(${(0, $75Bx4.BANNER_HEIGHT)} + ${(0, $75Bx4.TOP_NAVIGATION_HEIGHT)})`,
        insetInlineStart: `${(0, $75Bx4.LEFT_PANEL_WIDTH)}`,
        transition: `width ${(0, $75Bx4.TRANSITION_DURATION)}ms ${(0, $cb3878f71492e237$export$57636bb43b1ccbb0)} 0s`
    });
    const $5cab8715d7bc4d3c$var$fixedInnerFlyoutStyles = (0, $byn9U.css)({
        width: (0, $75Bx4.LEFT_SIDEBAR_FLYOUT_WIDTH)
    });
    const $5cab8715d7bc4d3c$var$staticInnerStyles = {
        name: "13udsys",
        styles: "height:100%"
    };
    const $5cab8715d7bc4d3c$var$draggingStyles = {
        name: "jlx54q",
        styles: "cursor:ew-resize;transition:none"
    };
    const $5cab8715d7bc4d3c$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
        const isDragging = (0, $kdHF2.default)();
        return (0, $byn9U.jsx)("div", {
            css: [
                $5cab8715d7bc4d3c$var$mobileStyles,
                isFlyoutOpen && $5cab8715d7bc4d3c$var$mobileInnerFlyoutStyles,
                !isFixed && $5cab8715d7bc4d3c$var$staticInnerStyles,
                isFixed && $5cab8715d7bc4d3c$var$fixedInnerStyles,
                isFixed && isFlyoutOpen && $5cab8715d7bc4d3c$var$fixedInnerFlyoutStyles,
                isDragging && $5cab8715d7bc4d3c$var$draggingStyles,
                $5cab8715d7bc4d3c$var$prefersReducedMotionStyles
            ]
        }, children);
    };
    var $5cab8715d7bc4d3c$export$2e2bcd8739ae039 = $5cab8715d7bc4d3c$var$LeftSidebarInner;
});
parcelRegister("2nFNU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0df347964fb6ce4$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $2oI17 = parcelRequire("2oI17");
    var $jijTN = parcelRequire("jijTN");
    var $75Bx4 = parcelRequire("75Bx4");
    var $kdHF2 = parcelRequire("kdHF2");
    var $1TdPC = parcelRequire("1TdPC");
    var $ltVyn = parcelRequire("ltVyn");
    var $gVnn3 = parcelRequire("gVnn3");
    function $a0df347964fb6ce4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a0df347964fb6ce4$var$prefersReducedMotionStyles = (0, $byn9U.css)((0, $2oI17.prefersReducedMotion)());
    const $a0df347964fb6ce4$var$mobileStyles = (0, $byn9U.css)({
        [(0, $jijTN.UNSAFE_media).below.sm]: {
            width: (0, $75Bx4.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH),
            cursor: 'pointer',
            opacity: 1,
            transition: `width ${(0, $75Bx4.TRANSITION_DURATION)}ms ${(0, $cb3878f71492e237$export$57636bb43b1ccbb0)} 0s`,
            '&::after': {
                display: 'inline-block',
                maxWidth: (0, $75Bx4.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
                content: "''"
            }
        }
    });
    const $a0df347964fb6ce4$var$mobileFlyoutStyles = (0, $byn9U.css)({
        [(0, $jijTN.UNSAFE_media).below.sm]: {
            cursor: 'revert'
        }
    });
    const $a0df347964fb6ce4$var$outerStyles = (0, $byn9U.css)({
        width: (0, $75Bx4.LEFT_SIDEBAR_WIDTH),
        position: 'relative',
        zIndex: 1,
        marginInlineStart: "var(--ds-space-0, 0px)",
        transition: `width ${(0, $75Bx4.TRANSITION_DURATION)}ms ${(0, $cb3878f71492e237$export$57636bb43b1ccbb0)} 0s`,
        ':hover': {
            '--ds--resize-button--opacity': 1
        }
    });
    const $a0df347964fb6ce4$var$draggingStyles = {
        name: "jlx54q",
        styles: "cursor:ew-resize;transition:none"
    };
    const $a0df347964fb6ce4$var$fixedStyles = (0, $byn9U.css)({
        '::after': {
            display: 'inline-block',
            width: `${(0, $75Bx4.LEFT_SIDEBAR_WIDTH)}`,
            content: "''"
        }
    });
    const $a0df347964fb6ce4$var$flyoutStyles = (0, $byn9U.css)({
        width: (0, $75Bx4.LEFT_SIDEBAR_FLYOUT_WIDTH)
    });
    const $a0df347964fb6ce4$var$flyoutFixedStyles = (0, $byn9U.css)({
        width: (0, $75Bx4.COLLAPSED_LEFT_SIDEBAR_WIDTH)
    });
    const $a0df347964fb6ce4$var$selector = (0, $1TdPC.getPageLayoutSlotSelector)('left-sidebar');
    const $a0df347964fb6ce4$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
        const isDragging = (0, $kdHF2.default)();
        const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $eUqFw.useContext)((0, $ltVyn.SidebarResizeContext));
        return (0, $byn9U.jsx)((0, $gVnn3.default), {
            isSidebar: true
        }, ({ className: className })=>(0, $byn9U.jsx)("div", {
                css: [
                    $a0df347964fb6ce4$var$mobileStyles,
                    isFlyoutOpen && $a0df347964fb6ce4$var$mobileFlyoutStyles,
                    $a0df347964fb6ce4$var$outerStyles,
                    isFixed && $a0df347964fb6ce4$var$fixedStyles,
                    isFlyoutOpen && $a0df347964fb6ce4$var$flyoutStyles,
                    isFlyoutOpen && isFixed && $a0df347964fb6ce4$var$flyoutFixedStyles,
                    isDragging && $a0df347964fb6ce4$var$draggingStyles,
                    $a0df347964fb6ce4$var$prefersReducedMotionStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                onMouseOver: onMouseOver,
                onMouseLeave: onMouseLeave,
                onClick: onClick,
                ref: ref,
                ...$a0df347964fb6ce4$var$selector
            }, children));
    };
    const $a0df347964fb6ce4$var$LeftSidebarOuter = (0, $eUqFw.forwardRef)($a0df347964fb6ce4$var$LeftSidebarOuterComponent);
    var $a0df347964fb6ce4$export$2e2bcd8739ae039 = $a0df347964fb6ce4$var$LeftSidebarOuter;
});
parcelRegister("58Ldm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2975fee65f7c3613$export$2e2bcd8739ae039);
    var $byn9U = parcelRequire("byn9U");
    var $2oI17 = parcelRequire("2oI17");
    var $75Bx4 = parcelRequire("75Bx4");
    var $602Tq = parcelRequire("602Tq");
    function $2975fee65f7c3613$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2975fee65f7c3613$var$prefersReducedMotionStyles = (0, $byn9U.css)((0, $2oI17.prefersReducedMotion)());
    const $2975fee65f7c3613$var$hideLeftSidebarContentsStyles = (0, $byn9U.css)({
        opacity: 0,
        transition: `opacity 0ms linear, visibility 0ms linear`,
        transitionDelay: `${(0, $75Bx4.TRANSITION_DURATION) - 100}ms`,
        visibility: 'hidden'
    });
    const $2975fee65f7c3613$var$resizableChildrenWrapperStyles = {
        name: "xz78rr",
        styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
    };
    const $2975fee65f7c3613$var$fixedChildrenWrapperStyles = {
        name: "ax3w45",
        styles: "min-width:240px;height:100%"
    };
    const $2975fee65f7c3613$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
        const isCollapsing = (0, $602Tq.default)();
        const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
        const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
        return (0, $byn9U.jsx)("div", {
            css: [
                $2975fee65f7c3613$var$resizableChildrenWrapperStyles,
                isHidden && $2975fee65f7c3613$var$hideLeftSidebarContentsStyles,
                $2975fee65f7c3613$var$prefersReducedMotionStyles
            ],
            "aria-hidden": isHidden,
            "data-testid": testId
        }, (0, $byn9U.jsx)("div", {
            css: $2975fee65f7c3613$var$fixedChildrenWrapperStyles
        }, children));
    };
    var $2975fee65f7c3613$export$2e2bcd8739ae039 = $2975fee65f7c3613$var$ResizableChildrenWrapper;
});
parcelRegister("602Tq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1130286bb4ea2c80$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $75Bx4 = parcelRequire("75Bx4");
    const $1130286bb4ea2c80$var$getIsCollapsing = ()=>{
        if (typeof document === 'undefined') return false;
        return document.documentElement.getAttribute((0, $75Bx4.IS_SIDEBAR_COLLAPSING)) === 'true';
    };
    const $1130286bb4ea2c80$var$useIsSidebarCollapsing = ()=>{
        const [isCollapsing, setIsCollapsing] = (0, $eUqFw.useState)($1130286bb4ea2c80$var$getIsCollapsing);
        (0, $eUqFw.useEffect)(()=>{
            const observer = new MutationObserver(()=>{
                setIsCollapsing($1130286bb4ea2c80$var$getIsCollapsing);
            });
            observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $75Bx4.IS_SIDEBAR_COLLAPSING)
                ]
            });
            return ()=>{
                observer.disconnect();
            };
        }, []);
        return isCollapsing;
    };
    var $1130286bb4ea2c80$export$2e2bcd8739ae039 = $1130286bb4ea2c80$var$useIsSidebarCollapsing;
});
parcelRegister("hl9w3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$409c91f68c8d88e4$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $75Bx4 = parcelRequire("75Bx4");
    var $1TdPC = parcelRequire("1TdPC");
    var $hYrzK = parcelRequire("hYrzK");
    var $9F5OS = parcelRequire("9F5OS");
    var $81H7L = parcelRequire("81H7L");
    var $2nFNU = parcelRequire("2nFNU");
    var $fSdNy = parcelRequire("fSdNy");
    const $409c91f68c8d88e4$var$LeftSidebarWithoutResize = (props)=>{
        const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
        const leftSidebarWidth = (0, $1TdPC.resolveDimension)((0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH), width, shouldPersistWidth);
        (0, $eUqFw.useEffect)(()=>{
            (0, $hYrzK.default)({
                [(0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth
            });
            return ()=>{
                (0, $hYrzK.default)({
                    [(0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH)]: 0
                });
            };
        }, [
            leftSidebarWidth
        ]);
        (0, $9F5OS.useSkipLink)(id, skipLinkTitle);
        return (0, $byn9U.jsx)((0, $2nFNU.default), {
            id: id,
            testId: testId,
            isFixed: isFixed
        }, (0, $byn9U.jsx)((0, $fSdNy.default), {
            variableName: (0, $75Bx4.VAR_LEFT_SIDEBAR_WIDTH),
            value: leftSidebarWidth
        }), (0, $byn9U.jsx)((0, $81H7L.default), {
            isFixed: isFixed
        }, children));
    };
    var $409c91f68c8d88e4$export$2e2bcd8739ae039 = $409c91f68c8d88e4$var$LeftSidebarWithoutResize;
});
parcelRegister("a0CBX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6421fa084a9d6c68$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $2oI17 = parcelRequire("2oI17");
    var $75Bx4 = parcelRequire("75Bx4");
    var $kdHF2 = parcelRequire("kdHF2");
    var $1TdPC = parcelRequire("1TdPC");
    var $ltVyn = parcelRequire("ltVyn");
    var $9F5OS = parcelRequire("9F5OS");
    var $gVnn3 = parcelRequire("gVnn3");
    function $6421fa084a9d6c68$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $6421fa084a9d6c68$var$prefersReducedMotionStyles = (0, $byn9U.css)((0, $2oI17.prefersReducedMotion)());
    const $6421fa084a9d6c68$var$mainStyles = (0, $byn9U.css)({
        minWidth: 0,
        flexGrow: 1,
        marginInlineStart: 0,
        transition: `margin-left ${(0, $75Bx4.TRANSITION_DURATION)}ms ${(0, $cb3878f71492e237$export$57636bb43b1ccbb0)} 0s`
    });
    const $6421fa084a9d6c68$var$draggingStyles = {
        name: "1wx2bp",
        styles: "transition:none"
    };
    const $6421fa084a9d6c68$var$flyoutStyles = (0, $byn9U.css)({
        marginInlineStart: `calc(-1 * var(--${(0, $75Bx4.VAR_LEFT_SIDEBAR_FLYOUT)}, ${(0, $75Bx4.DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH)}px) + ${(0, $75Bx4.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px)`
    });
    const $6421fa084a9d6c68$var$Main = (props)=>{
        const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        (0, $9F5OS.useSkipLink)(id, skipLinkTitle);
        const isDragging = (0, $kdHF2.default)();
        const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $eUqFw.useContext)((0, $ltVyn.SidebarResizeContext));
        return (0, $byn9U.jsx)((0, $gVnn3.default), null, ({ className: className })=>(0, $byn9U.jsx)("main", {
                "data-testid": testId,
                css: [
                    $6421fa084a9d6c68$var$mainStyles,
                    isDragging && $6421fa084a9d6c68$var$draggingStyles,
                    isFlyoutOpen && !isFixed && $6421fa084a9d6c68$var$flyoutStyles,
                    $6421fa084a9d6c68$var$prefersReducedMotionStyles
                ],
                className: className,
                id: id,
                ...(0, $1TdPC.getPageLayoutSlotSelector)('main')
            }, children));
    };
    var $6421fa084a9d6c68$export$2e2bcd8739ae039 = $6421fa084a9d6c68$var$Main;
});
parcelRegister("2tmfQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6223840344d3893f$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $jijTN = parcelRequire("jijTN");
    var $75Bx4 = parcelRequire("75Bx4");
    var $aGhbo = parcelRequire("aGhbo");
    var $2ZDKY = parcelRequire("2ZDKY");
    var $5V8nA = parcelRequire("5V8nA");
    const $6223840344d3893f$var$pageLayoutSelector = {
        [(0, $75Bx4.PAGE_LAYOUT_CONTAINER_SELECTOR)]: true
    };
    const $6223840344d3893f$var$gridTemplateAreasMobile = `
${''}
  "${(0, $75Bx4.LEFT_PANEL)} ${(0, $75Bx4.BANNER)}"
  ${''}
  "${(0, $75Bx4.LEFT_PANEL)} ${(0, $75Bx4.TOP_NAVIGATION)}"
  ${''}
  "${(0, $75Bx4.LEFT_PANEL)} ${(0, $75Bx4.CONTENT)}"
 `;
    const $6223840344d3893f$var$gridTemplateAreas = `
${''}
  "${(0, $75Bx4.LEFT_PANEL)} ${(0, $75Bx4.BANNER)} ${(0, $75Bx4.RIGHT_PANEL)}"
  ${''}
  "${(0, $75Bx4.LEFT_PANEL)} ${(0, $75Bx4.TOP_NAVIGATION)} ${(0, $75Bx4.RIGHT_PANEL)}"
${''}
  "${(0, $75Bx4.LEFT_PANEL)} ${(0, $75Bx4.CONTENT)} ${(0, $75Bx4.RIGHT_PANEL)}"
 `;
    const $6223840344d3893f$var$gridStyles = (0, $byn9U.css)({
        display: 'grid',
        height: '100%',
        gridTemplateAreas: $6223840344d3893f$var$gridTemplateAreas,
        gridTemplateColumns: `${(0, $75Bx4.LEFT_PANEL_WIDTH)} minmax(0, 1fr) ${(0, $75Bx4.RIGHT_PANEL_WIDTH)}`,
        gridTemplateRows: `${(0, $75Bx4.BANNER_HEIGHT)} ${(0, $75Bx4.TOP_NAVIGATION_HEIGHT)} auto`,
        outline: 'none'
    });
    const $6223840344d3893f$var$gridStylesMobileStyles = (0, $byn9U.css)({
        [(0, $jijTN.UNSAFE_media).below.sm]: {
            gridTemplateAreas: $6223840344d3893f$var$gridTemplateAreasMobile,
            gridTemplateColumns: `${(0, $75Bx4.LEFT_PANEL_WIDTH)} minmax(0, 1fr)`
        }
    });
    const $6223840344d3893f$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $75Bx4.DEFAULT_I18N_PROPS_SKIP_LINKS), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)((0, $2ZDKY.SkipLinksController), null, (0, $byn9U.jsx)((0, $5V8nA.SkipLinkWrapper), {
            skipLinksLabel: skipLinksLabel
        }), (0, $byn9U.jsx)("div", {
            ...$6223840344d3893f$var$pageLayoutSelector,
            "data-testid": testId,
            css: [
                $6223840344d3893f$var$gridStyles,
                $6223840344d3893f$var$gridStylesMobileStyles
            ],
            tabIndex: -1,
            "data-vc": "page-layout"
        }, (0, $byn9U.jsx)((0, $aGhbo.SidebarResizeController), {
            onLeftSidebarCollapse: onLeftSidebarCollapse,
            onLeftSidebarExpand: onLeftSidebarExpand
        }, children))));
    };
    var $6223840344d3893f$export$2e2bcd8739ae039 = $6223840344d3893f$var$PageLayout;
});
parcelRegister("aGhbo", function(module, exports) {
    $parcel$export(module.exports, "SidebarResizeController", ()=>$6a3690b908eb6907$export$850bd1bba41f1448);
    var $eUqFw = parcelRequire("eUqFw");
    var $74BVL = parcelRequire("74BVL");
    var $4oSDA = parcelRequire("4oSDA");
    var $2oI17 = parcelRequire("2oI17");
    var $hHxfS = parcelRequire("hHxfS");
    var $75Bx4 = parcelRequire("75Bx4");
    var $1TdPC = parcelRequire("1TdPC");
    var $ltVyn = parcelRequire("ltVyn");
    const $6a3690b908eb6907$var$handleDataAttributesAndCb = (callback = (0, $4oSDA.default), leftSidebarState)=>{
        document.documentElement.removeAttribute((0, $75Bx4.IS_SIDEBAR_COLLAPSING));
        callback(leftSidebarState);
    };
    const $6a3690b908eb6907$var$leftSidebarSelector = (0, $1TdPC.getPageLayoutSlotCSSSelector)('left-sidebar');
    const $6a3690b908eb6907$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
        const [leftSidebarState, setLeftSidebarState] = (0, $eUqFw.useState)({
            isFlyoutOpen: false,
            isResizing: false,
            isLeftSidebarCollapsed: false,
            leftSidebarWidth: 0,
            lastLeftSidebarWidth: 0,
            flyoutLockCount: 0,
            isFixed: true
        });
        const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen } = leftSidebarState;
        const stableRef = (0, $eUqFw.useRef)({
            onExpand: onExpand,
            onCollapse: onCollapse
        });
        (0, $eUqFw.useEffect)(()=>{
            stableRef.current = {
                onExpand: onExpand,
                onCollapse: onCollapse
            };
        }, [
            onExpand,
            onCollapse
        ]);
        const transition = (0, $eUqFw.useRef)(null);
        const mobileMediaQuery = (0, $hHxfS.UNSAFE_useMediaQuery)('below.sm');
        const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
        const expandLeftSidebar = (0, $eUqFw.useCallback)(()=>{
            if (isOpen) return;
            if (mobileMediaQuery?.matches) {
                const flyoutOpenSidebarState = {
                    isResizing: false,
                    isLeftSidebarCollapsed: true,
                    leftSidebarWidth: (0, $75Bx4.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: leftSidebarWidth,
                    isFlyoutOpen: true,
                    flyoutLockCount: 0,
                    isFixed: isFixed
                };
                setLeftSidebarState(flyoutOpenSidebarState);
                transition.current?.complete();
                $6a3690b908eb6907$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
                return;
            }
            if (isResizing || !isLeftSidebarCollapsed || transition.current?.action === 'expand') return;
            transition.current?.complete();
            const width = Math.max(lastLeftSidebarWidth, (0, $75Bx4.DEFAULT_LEFT_SIDEBAR_WIDTH));
            const updatedLeftSidebarState = {
                isLeftSidebarCollapsed: false,
                isFlyoutOpen: false,
                leftSidebarWidth: width,
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isResizing: isResizing,
                flyoutLockCount: flyoutLockCount,
                isFixed: isFixed
            };
            setLeftSidebarState(updatedLeftSidebarState);
            function finish() {
                $6a3690b908eb6907$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
            }
            const sidebar = document.querySelector($6a3690b908eb6907$var$leftSidebarSelector);
            if ((0, $2oI17.isReducedMotion)() || !sidebar) {
                finish();
                return;
            }
            const unbindEvent = (0, $74BVL.bind)(sidebar, {
                type: 'transitionend',
                listener (event) {
                    if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
                }
            });
            const value = {
                action: 'expand',
                complete: ()=>{
                    value.abort();
                    finish();
                },
                abort: ()=>{
                    unbindEvent();
                    transition.current = null;
                }
            };
            transition.current = value;
        }, [
            isOpen,
            mobileMediaQuery,
            isResizing,
            isLeftSidebarCollapsed,
            lastLeftSidebarWidth,
            flyoutLockCount,
            isFixed,
            leftSidebarWidth
        ]);
        const collapseLeftSidebar = (0, $eUqFw.useCallback)((event, collapseWithoutTransition)=>{
            if (!isOpen) return;
            if (mobileMediaQuery?.matches) {
                const flyoutCloseSidebarState = {
                    isResizing: false,
                    isLeftSidebarCollapsed: true,
                    leftSidebarWidth: (0, $75Bx4.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: lastLeftSidebarWidth,
                    isFlyoutOpen: false,
                    flyoutLockCount: 0,
                    isFixed: isFixed
                };
                setLeftSidebarState(flyoutCloseSidebarState);
                transition.current?.complete();
                $6a3690b908eb6907$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
                return;
            }
            if (isResizing || isLeftSidebarCollapsed || transition.current?.action === 'collapse') return;
            transition.current?.complete();
            document.documentElement.setAttribute((0, $75Bx4.IS_SIDEBAR_COLLAPSING), 'true');
            const updatedLeftSidebarState = {
                isLeftSidebarCollapsed: true,
                isFlyoutOpen: false,
                leftSidebarWidth: (0, $75Bx4.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: leftSidebarWidth,
                isResizing: isResizing,
                flyoutLockCount: flyoutLockCount,
                isFixed: isFixed
            };
            setLeftSidebarState(updatedLeftSidebarState);
            function finish() {
                $6a3690b908eb6907$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
            }
            const sidebar = document.querySelector($6a3690b908eb6907$var$leftSidebarSelector);
            if (collapseWithoutTransition || (0, $2oI17.isReducedMotion)() || !sidebar) {
                finish();
                return;
            }
            const unbindEvent = (0, $74BVL.bind)(sidebar, {
                type: 'transitionend',
                listener (event) {
                    if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
                }
            });
            const value = {
                action: 'collapse',
                complete: ()=>{
                    value.abort();
                    finish();
                },
                abort: ()=>{
                    unbindEvent();
                    transition.current = null;
                }
            };
            transition.current = value;
        }, [
            isOpen,
            mobileMediaQuery,
            isResizing,
            isLeftSidebarCollapsed,
            leftSidebarWidth,
            flyoutLockCount,
            isFixed,
            lastLeftSidebarWidth
        ]);
        const toggleLeftSidebar = (0, $eUqFw.useCallback)((event, collapseWithoutTransition)=>{
            if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
            else expandLeftSidebar();
        }, [
            isOpen,
            expandLeftSidebar,
            collapseLeftSidebar
        ]);
        (0, $eUqFw.useEffect)(function mount() {
            return function unmount() {
                transition.current?.abort();
            };
        }, []);
        const context = (0, $eUqFw.useMemo)(()=>({
                isLeftSidebarCollapsed: !isOpen,
                expandLeftSidebar: expandLeftSidebar,
                collapseLeftSidebar: collapseLeftSidebar,
                leftSidebarState: leftSidebarState,
                setLeftSidebarState: setLeftSidebarState,
                toggleLeftSidebar: toggleLeftSidebar
            }), [
            isOpen,
            expandLeftSidebar,
            collapseLeftSidebar,
            leftSidebarState,
            toggleLeftSidebar
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ltVyn.SidebarResizeContext).Provider, {
            value: context
        }, children);
    };
});
parcelRegister("2ZDKY", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksController", ()=>$abc9cf15b88263b5$export$da7be99d6a868f3d);
    var $eUqFw = parcelRequire("eUqFw");
    var $75Bx4 = parcelRequire("75Bx4");
    var $9F5OS = parcelRequire("9F5OS");
    const $abc9cf15b88263b5$var$byDOMOrder = (a, b)=>{
        const elems = Array.from(document.querySelectorAll(`[${(0, $75Bx4.PAGE_LAYOUT_SLOT_SELECTOR)}]`));
        const elemA = document.getElementById(a.id);
        const elemB = document.getElementById(b.id);
        const indexA = a.listIndex ?? elems.indexOf(elemA);
        const indexB = b.listIndex ?? elems.indexOf(elemB);
        if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
    const $abc9cf15b88263b5$export$da7be99d6a868f3d = ({ children: children })=>{
        const [links, setLinks] = (0, $eUqFw.useState)([]);
        const registerSkipLink = (0, $eUqFw.useRef)((skipLinkData)=>{
            setLinks((oldLinks)=>{
                if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
                return [
                    ...oldLinks,
                    skipLinkData
                ].sort($abc9cf15b88263b5$var$byDOMOrder);
            });
        });
        const unregisterSkipLink = (0, $eUqFw.useRef)((id)=>{
            setLinks((links)=>links.filter((link)=>link.id !== id));
        });
        const context = {
            registerSkipLink: registerSkipLink.current,
            skipLinksData: links,
            unregisterSkipLink: unregisterSkipLink.current
        };
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $9F5OS.SkipLinksContext).Provider, {
            value: context
        }, children);
    };
});
parcelRegister("5V8nA", function(module, exports) {
    $parcel$export(module.exports, "SkipLinkWrapper", ()=>$3a45a626e58d2db6$export$4241a460557ba901);
    var $byn9U = parcelRequire("byn9U");
    var $ghFHl = parcelRequire("ghFHl");
    var $2oI17 = parcelRequire("2oI17");
    var $75Bx4 = parcelRequire("75Bx4");
    var $9F5OS = parcelRequire("9F5OS");
    function $3a45a626e58d2db6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3a45a626e58d2db6$var$prefersReducedMotionStyles = (0, $byn9U.css)((0, $2oI17.prefersReducedMotion)());
    const $3a45a626e58d2db6$var$skipLinkStyles = (0, $byn9U.css)({
        margin: "var(--ds-space-250, 10px)",
        padding: '0.8rem 1rem',
        position: 'fixed',
        zIndex: -1,
        background: "var(--ds-surface-overlay, white)",
        border: 'none',
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $207acf722dcd432b$export$920c0d5c49070351)}, 0 2px 10px ${(0, $207acf722dcd432b$export$920c0d5c49070351)}, 0 0 20px -4px ${(0, $207acf722dcd432b$export$d2d3bedfb276cac0)}`})`,
        insetInlineStart: -999999,
        opacity: 0,
        transform: 'translateY(-50%)',
        transition: `transform 0.3s ${(0, $cb3878f71492e237$export$57636bb43b1ccbb0)}`,
        '&:focus-within': {
            zIndex: 2147483640,
            insetInlineStart: 0,
            opacity: 1,
            transform: 'translateY(0%)'
        }
    });
    const $3a45a626e58d2db6$var$skipLinkHeadingStyles = {
        name: "16ceglb",
        styles: "font-weight:600"
    };
    const $3a45a626e58d2db6$var$skipLinkListStyles = {
        name: "1xay72g",
        styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
    };
    const $3a45a626e58d2db6$var$skipLinkListItemStyles = {
        name: "19m435s",
        styles: "margin-block-start:0"
    };
    const $3a45a626e58d2db6$var$assignIndex = (num, arr)=>{
        if (!arr.includes(num)) return num;
        return $3a45a626e58d2db6$var$assignIndex(num + 1, arr);
    };
    const $3a45a626e58d2db6$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
        const { skipLinksData: skipLinksData } = (0, $9F5OS.useSkipLinks)();
        if (skipLinksData.length === 0) return null;
        const sortSkipLinks = (arr)=>{
            const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
            if (customLinks.length === 0) return arr;
            const usedIndexes = customLinks.map((a)=>a.listIndex);
            const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
                const listIndex = $3a45a626e58d2db6$var$assignIndex(idx, usedIndexes);
                usedIndexes.push(listIndex);
                return {
                    ...link,
                    listIndex: listIndex
                };
            });
            return [
                ...customLinks,
                ...regularLinksWithIdx
            ].sort((a, b)=>a.listIndex - b.listIndex);
        };
        const escapeHandler = (event)=>{
            if (event.keyCode === 27) {
                const container = document.querySelector(`[${(0, $75Bx4.PAGE_LAYOUT_CONTAINER_SELECTOR)}="true"]`);
                if (container !== null) container.focus();
            }
        };
        const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
        const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
        const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
        const label = skipLinksLabel || (0, $75Bx4.DEFAULT_I18N_PROPS_SKIP_LINKS);
        return (0, $byn9U.jsx)("div", {
            onFocus: attachEscHandler,
            onBlur: removeEscHandler,
            css: [
                $3a45a626e58d2db6$var$skipLinkStyles,
                $3a45a626e58d2db6$var$prefersReducedMotionStyles
            ],
            "data-skip-link-wrapper": true
        }, emptyLabelOverride ? null : (0, $byn9U.jsx)("p", {
            css: $3a45a626e58d2db6$var$skipLinkHeadingStyles
        }, label), (0, $byn9U.jsx)("ol", {
            css: $3a45a626e58d2db6$var$skipLinkListStyles
        }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>(0, $byn9U.jsx)($3a45a626e58d2db6$export$ef95c37428582a65, {
                key: id,
                href: `#${id}`,
                isFocusable: true
            }, skipLinkTitle))));
    };
    const $3a45a626e58d2db6$var$handleBlur = (event)=>{
        event.target.removeAttribute('tabindex');
        event.target.removeEventListener('blur', $3a45a626e58d2db6$var$handleBlur);
    };
    const $3a45a626e58d2db6$var$focusTargetRef = (href)=>(event)=>{
            event.preventDefault();
            const targetRef = document.querySelector(href);
            const key = event.which || event.keycode;
            if (key && key !== 13 && key !== 32) return;
            if (targetRef) {
                targetRef.setAttribute('tabindex', '-1');
                targetRef.addEventListener('blur', $3a45a626e58d2db6$var$handleBlur);
                targetRef.focus();
                document.activeElement && document.activeElement.scrollIntoView({
                    behavior: 'smooth'
                });
                window.scrollTo(0, 0);
            }
            return false;
        };
    const $3a45a626e58d2db6$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
        return (0, $byn9U.jsx)("li", {
            css: $3a45a626e58d2db6$var$skipLinkListItemStyles
        }, (0, $byn9U.jsx)((0, $ghFHl.default), {
            tabIndex: isFocusable ? 0 : -1,
            href: href,
            onClick: $3a45a626e58d2db6$var$focusTargetRef(href)
        }, children));
    };
});
parcelRegister("biWEn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d1bf0a285ca0ad1$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $75Bx4 = parcelRequire("75Bx4");
    var $1TdPC = parcelRequire("1TdPC");
    var $hYrzK = parcelRequire("hYrzK");
    var $9F5OS = parcelRequire("9F5OS");
    var $gVnn3 = parcelRequire("gVnn3");
    var $fSdNy = parcelRequire("fSdNy");
    const $4d1bf0a285ca0ad1$var$baseStyles = (0, $byn9U.css)({
        gridArea: (0, $75Bx4.RIGHT_PANEL)
    });
    const $4d1bf0a285ca0ad1$var$fixedStyles = (0, $byn9U.css)({
        width: (0, $75Bx4.RIGHT_PANEL_WIDTH),
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineEnd: 0
    });
    const $4d1bf0a285ca0ad1$var$RightPanel = (props)=>{
        const { children: children, isFixed: isFixed, width: width = (0, $75Bx4.DEFAULT_RIGHT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const rightPanelWidth = (0, $1TdPC.resolveDimension)((0, $75Bx4.VAR_RIGHT_PANEL_WIDTH), width, shouldPersistWidth);
        (0, $eUqFw.useEffect)(()=>{
            (0, $hYrzK.default)({
                [(0, $75Bx4.VAR_RIGHT_PANEL_WIDTH)]: rightPanelWidth
            });
            return ()=>{
                (0, $hYrzK.default)({
                    [(0, $75Bx4.VAR_RIGHT_PANEL_WIDTH)]: 0
                });
            };
        }, [
            rightPanelWidth
        ]);
        (0, $9F5OS.useSkipLink)(id, skipLinkTitle);
        return (0, $byn9U.jsx)((0, $gVnn3.default), null, ({ className: className })=>(0, $byn9U.jsx)("div", {
                css: [
                    $4d1bf0a285ca0ad1$var$baseStyles,
                    isFixed && $4d1bf0a285ca0ad1$var$fixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, $1TdPC.getPageLayoutSlotSelector)('right-panel')
            }, (0, $byn9U.jsx)((0, $fSdNy.default), {
                variableName: (0, $75Bx4.VAR_RIGHT_PANEL_WIDTH),
                value: rightPanelWidth
            }), children));
    };
    var $4d1bf0a285ca0ad1$export$2e2bcd8739ae039 = $4d1bf0a285ca0ad1$var$RightPanel;
});
parcelRegister("jBKIh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$481f79cafb48ea1a$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $75Bx4 = parcelRequire("75Bx4");
    var $1TdPC = parcelRequire("1TdPC");
    var $hYrzK = parcelRequire("hYrzK");
    var $9F5OS = parcelRequire("9F5OS");
    var $gVnn3 = parcelRequire("gVnn3");
    var $fSdNy = parcelRequire("fSdNy");
    function $481f79cafb48ea1a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $481f79cafb48ea1a$var$fixedInnerStyles = (0, $byn9U.css)({
        width: (0, $75Bx4.RIGHT_SIDEBAR_WIDTH),
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: `calc(${(0, $75Bx4.BANNER_HEIGHT)} + ${(0, $75Bx4.TOP_NAVIGATION_HEIGHT)})`,
        insetInlineEnd: `calc(${(0, $75Bx4.RIGHT_PANEL_WIDTH)})`
    });
    const $481f79cafb48ea1a$var$staticInnerStyles = {
        name: "13udsys",
        styles: "height:100%"
    };
    const $481f79cafb48ea1a$var$outerStyles = (0, $byn9U.css)({
        width: (0, $75Bx4.RIGHT_SIDEBAR_WIDTH)
    });
    const $481f79cafb48ea1a$var$fixedOuterStyles = (0, $byn9U.css)({
        '&::after': {
            display: 'inline-block',
            width: (0, $75Bx4.RIGHT_SIDEBAR_WIDTH),
            content: "''"
        }
    });
    const $481f79cafb48ea1a$var$RightSidebar = (props)=>{
        const { children: children, width: width = (0, $75Bx4.DEFAULT_RIGHT_SIDEBAR_WIDTH), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const rightSidebarWidth = (0, $1TdPC.resolveDimension)((0, $75Bx4.VAR_RIGHT_SIDEBAR_WIDTH), width, shouldPersistWidth);
        (0, $eUqFw.useEffect)(()=>{
            (0, $hYrzK.default)({
                [(0, $75Bx4.VAR_RIGHT_SIDEBAR_WIDTH)]: rightSidebarWidth
            });
            return ()=>{
                (0, $hYrzK.default)({
                    [(0, $75Bx4.VAR_RIGHT_SIDEBAR_WIDTH)]: 0
                });
            };
        }, [
            rightSidebarWidth,
            id
        ]);
        (0, $9F5OS.useSkipLink)(id, skipLinkTitle);
        return (0, $byn9U.jsx)((0, $gVnn3.default), {
            isSidebar: true
        }, ({ className: className })=>(0, $byn9U.jsx)("div", {
                "data-testid": testId,
                css: [
                    $481f79cafb48ea1a$var$outerStyles,
                    isFixed && $481f79cafb48ea1a$var$fixedOuterStyles
                ],
                className: className,
                id: id,
                ...(0, $1TdPC.getPageLayoutSlotSelector)('right-sidebar')
            }, (0, $byn9U.jsx)((0, $fSdNy.default), {
                variableName: (0, $75Bx4.VAR_RIGHT_SIDEBAR_WIDTH),
                value: rightSidebarWidth
            }), (0, $byn9U.jsx)("div", {
                css: [
                    isFixed && $481f79cafb48ea1a$var$fixedInnerStyles,
                    !isFixed && $481f79cafb48ea1a$var$staticInnerStyles
                ]
            }, children)));
    };
    var $481f79cafb48ea1a$export$2e2bcd8739ae039 = $481f79cafb48ea1a$var$RightSidebar;
});
parcelRegister("kszDB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c839e3ab8586205a$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $75Bx4 = parcelRequire("75Bx4");
    var $1TdPC = parcelRequire("1TdPC");
    var $hYrzK = parcelRequire("hYrzK");
    var $9F5OS = parcelRequire("9F5OS");
    var $gVnn3 = parcelRequire("gVnn3");
    var $fSdNy = parcelRequire("fSdNy");
    const $c839e3ab8586205a$var$topNavigationStyles = (0, $byn9U.css)({
        height: (0, $75Bx4.TOP_NAVIGATION_HEIGHT),
        gridArea: (0, $75Bx4.TOP_NAVIGATION)
    });
    const $c839e3ab8586205a$var$fixedStyles = (0, $byn9U.css)({
        position: 'fixed',
        zIndex: 2,
        insetBlockStart: (0, $75Bx4.BANNER_HEIGHT),
        insetInlineEnd: (0, $75Bx4.RIGHT_PANEL_WIDTH),
        insetInlineStart: (0, $75Bx4.LEFT_PANEL_WIDTH)
    });
    const $c839e3ab8586205a$var$TopNavigation = (props)=>{
        const { children: children, height: height = (0, $75Bx4.DEFAULT_TOP_NAVIGATION_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const topNavigationHeight = (0, $1TdPC.resolveDimension)((0, $75Bx4.VAR_TOP_NAVIGATION_HEIGHT), height, shouldPersistHeight);
        (0, $eUqFw.useEffect)(()=>{
            (0, $hYrzK.default)({
                [(0, $75Bx4.VAR_TOP_NAVIGATION_HEIGHT)]: topNavigationHeight
            });
            return ()=>{
                (0, $hYrzK.default)({
                    [(0, $75Bx4.VAR_TOP_NAVIGATION_HEIGHT)]: 0
                });
            };
        }, [
            topNavigationHeight
        ]);
        (0, $9F5OS.useSkipLink)(id, skipLinkTitle);
        return (0, $byn9U.jsx)((0, $gVnn3.default), null, ({ className: className })=>(0, $byn9U.jsx)("div", {
                css: [
                    $c839e3ab8586205a$var$topNavigationStyles,
                    isFixed && $c839e3ab8586205a$var$fixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, $1TdPC.getPageLayoutSlotSelector)('top-navigation')
            }, (0, $byn9U.jsx)((0, $fSdNy.default), {
                variableName: (0, $75Bx4.VAR_TOP_NAVIGATION_HEIGHT),
                value: topNavigationHeight
            }), children));
    };
    var $c839e3ab8586205a$export$2e2bcd8739ae039 = $c839e3ab8586205a$var$TopNavigation;
});
parcelRegister("hFQjy", function(module, exports) {
    $parcel$export(module.exports, "useCustomSkipLink", ()=>$42c061a4a971aad4$export$ee6b12c2613bdf8e);
    var $eUqFw = parcelRequire("eUqFw");
    var $9F5OS = parcelRequire("9F5OS");
    const $42c061a4a971aad4$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
        const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $9F5OS.useSkipLinks)();
        (0, $eUqFw.useEffect)(()=>{
            registerSkipLink({
                id: id,
                skipLinkTitle: skipLinkTitle,
                listIndex: listIndex
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        }, [
            id,
            listIndex,
            skipLinkTitle,
            registerSkipLink,
            unregisterSkipLink
        ]);
    };
});
parcelRegister("lWkXx", function(module, exports) {
    $parcel$export(module.exports, "Aside", ()=>$2e0ab5fa0d5ba1f5$export$ac3bdfe4cb17f64e);
    var $7JEyt = parcelRequire("7JEyt");
    var $eUqFw = parcelRequire("eUqFw");
    var $lnAMz = parcelRequire("lnAMz");
    var $jijTN = parcelRequire("jijTN");
    var $9Nwj0 = parcelRequire("9Nwj0");
    var $hCJA5 = parcelRequire("hCJA5");
    var $cYVoC = parcelRequire("cYVoC");
    var $3tf9Q = parcelRequire("3tf9Q");
    var $9srM0 = parcelRequire("9srM0");
    var $gtHi1 = parcelRequire("gtHi1");
    const $2e0ab5fa0d5ba1f5$var$panelSplitterResizingVar = '--n_asdRsz';
    const $2e0ab5fa0d5ba1f5$var$asideWidthSlotBounds = {
        min: '0px',
        max: '50vw'
    };
    const $2e0ab5fa0d5ba1f5$var$asideWidthResizeBounds = {
        min: '120px',
        max: '50vw'
    };
    const $2e0ab5fa0d5ba1f5$var$styles = {
        root: "_nd5lns35 _vchhusvi _kqswh2mm _glte1kzp _ndwch9n0",
        fixedContentArea: "_152t1l7u _1reo1wug _18m91wug _165t1run _13wn1if8"
    };
    function $2e0ab5fa0d5ba1f5$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixed, defaultWidth: defaultWidth = 330, label: label = 'Aside', testId: testId, id: id }) {
        const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)((0, $cYVoC.DangerouslyHoistSlotSizes));
        const UID = (0, $gtHi1.usePrefixedUID)();
        const CID = id ? id : UID;
        (0, $9Nwj0.useSkipLink)(CID, label);
        const ref = (0, $eUqFw.useRef)(null);
        const [width, setWidth] = (0, $eUqFw.useState)(defaultWidth);
        const previousWidthProp = (0, $lnAMz.default)(defaultWidth);
        (0, $eUqFw.useEffect)(()=>{
            setWidth(defaultWidth);
        }, [
            defaultWidth
        ]);
        (0, $eUqFw.useEffect)(()=>{}, [
            defaultWidth,
            previousWidthProp
        ]);
        const asideVariableWidth = `clamp(${$2e0ab5fa0d5ba1f5$var$asideWidthSlotBounds.min}, ${width}px, ${$2e0ab5fa0d5ba1f5$var$asideWidthSlotBounds.max})`;
        return (0, ($parcel$interopDefault($eUqFw))).createElement("aside", {
            id: CID,
            "data-layout-slot": true,
            "aria-label": label,
            className: (0, $7JEyt.default)([
                $2e0ab5fa0d5ba1f5$var$styles.root,
                xcss
            ]),
            style: {
                [(0, $hCJA5.asideVar)]: asideVariableWidth
            },
            "data-testid": testId,
            ref: ref
        }, dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3tf9Q.DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, $hCJA5.UNSAFE_asideLayoutVar),
            value: "0px",
            mediaQuery: (0, $jijTN.media).above.md,
            responsiveValue: asideVariableWidth
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $9srM0.PanelSplitterProvider), {
            panelRef: ref,
            panelWidth: width,
            onCompleteResize: setWidth,
            resizeBounds: $2e0ab5fa0d5ba1f5$var$asideWidthResizeBounds,
            resizingCssVar: $2e0ab5fa0d5ba1f5$var$panelSplitterResizingVar,
            position: "start"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                isFixed && $2e0ab5fa0d5ba1f5$var$styles.fixedContentArea
            ])
        }, children)));
    }
});
parcelRegister("9Nwj0", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksContext", ()=>$e6d961377ad58bc0$export$4c5cc3b14c7678a);
    $parcel$export(module.exports, "useSkipLink", ()=>$e6d961377ad58bc0$export$89d9323301efc7d6);
    var $eUqFw = parcelRequire("eUqFw");
    var $4oSDA = parcelRequire("4oSDA");
    const $e6d961377ad58bc0$export$4c5cc3b14c7678a = (0, $eUqFw.createContext)({
        registerSkipLink: (0, $4oSDA.default),
        unregisterSkipLink: (0, $4oSDA.default)
    });
    const $e6d961377ad58bc0$export$c9d9cb2ee9590f87 = ()=>(0, $eUqFw.useContext)($e6d961377ad58bc0$export$4c5cc3b14c7678a);
    const $e6d961377ad58bc0$export$89d9323301efc7d6 = (id, label, listIndex)=>{
        const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $e6d961377ad58bc0$export$c9d9cb2ee9590f87();
        (0, $eUqFw.useEffect)(()=>{
            registerSkipLink({
                id: id,
                label: label,
                listIndex: listIndex
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        }, [
            id,
            label,
            listIndex,
            registerSkipLink,
            unregisterSkipLink
        ]);
    };
});
parcelRegister("hCJA5", function(module, exports) {
    $parcel$export(module.exports, "sideNavVar", ()=>$560bbba0f8793448$export$951bf5156e86d974);
    $parcel$export(module.exports, "asideVar", ()=>$560bbba0f8793448$export$594e6a30db7c057e);
    $parcel$export(module.exports, "panelVar", ()=>$560bbba0f8793448$export$db0c2e1d744fb281);
    $parcel$export(module.exports, "bannerMountedVar", ()=>$560bbba0f8793448$export$515a0b1baafe906c);
    $parcel$export(module.exports, "topBarMountedVar", ()=>$560bbba0f8793448$export$a96e934b2a1eeee);
    $parcel$export(module.exports, "UNSAFE_topBarVar", ()=>$560bbba0f8793448$export$f4afb213f937404c);
    $parcel$export(module.exports, "UNSAFE_bannerVar", ()=>$560bbba0f8793448$export$26354f9814213292);
    $parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", ()=>$560bbba0f8793448$export$6bfc931a04ec5741);
    $parcel$export(module.exports, "UNSAFE_asideLayoutVar", ()=>$560bbba0f8793448$export$bbbace2ff0c7ae1b);
    $parcel$export(module.exports, "UNSAFE_panelLayoutVar", ()=>$560bbba0f8793448$export$753bf7651b25db91);
    $parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", ()=>$560bbba0f8793448$export$6460bd6a2446260);
    $parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", ()=>$560bbba0f8793448$export$3055529fab2b4edf);
    $parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", ()=>$560bbba0f8793448$export$166d8fd766c3eb92);
    const $560bbba0f8793448$export$951bf5156e86d974 = '--n_sNvw';
    const $560bbba0f8793448$export$594e6a30db7c057e = '--n_asDw';
    const $560bbba0f8793448$export$db0c2e1d744fb281 = '--n_pnlW';
    const $560bbba0f8793448$export$515a0b1baafe906c = '--n_bnrM';
    const $560bbba0f8793448$export$a96e934b2a1eeee = '--n_tbrM';
    const $560bbba0f8793448$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tbrM, 0px))`;
    const $560bbba0f8793448$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tbrM, 0px))`;
    const $560bbba0f8793448$export$f4afb213f937404c = '--topNavigationHeight';
    const $560bbba0f8793448$export$26354f9814213292 = '--bannerHeight';
    const $560bbba0f8793448$export$6bfc931a04ec5741 = '--leftSidebarWidth';
    const $560bbba0f8793448$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
    const $560bbba0f8793448$export$753bf7651b25db91 = '--rightPanelWidth';
    const $560bbba0f8793448$export$6460bd6a2446260 = `calc(var(${$560bbba0f8793448$export$26354f9814213292}, 0px) + var(${$560bbba0f8793448$export$f4afb213f937404c}, 0px))`;
    const $560bbba0f8793448$export$3055529fab2b4edf = `var(${$560bbba0f8793448$export$6bfc931a04ec5741}, 0px)`;
    const $560bbba0f8793448$export$166d8fd766c3eb92 = `calc(var(${$560bbba0f8793448$export$bbbace2ff0c7ae1b}, 0px) + var(${$560bbba0f8793448$export$753bf7651b25db91}, 0px))`;
    const $560bbba0f8793448$export$61156ceb1a99f6a0 = {
        topBar: 4,
        banner: 4,
        topBarBorder: 3,
        sideNav: 2,
        contentBlockBorder: 2,
        contentInlineBorder: 1,
        panelSmallViewports: 1
    };
});
parcelRegister("cYVoC", function(module, exports) {
    $parcel$export(module.exports, "DangerouslyHoistSlotSizes", ()=>$7311da6e11c12437$export$66e2c1a0115af861);
    var $eUqFw = parcelRequire("eUqFw");
    const $7311da6e11c12437$export$66e2c1a0115af861 = (0, $eUqFw.createContext)(false);
});
parcelRegister("3tf9Q", function(module, exports) {
    $parcel$export(module.exports, "HoistCssVarToLocalGrid", ()=>$7de340274894a80b$export$cfa3cd08d675e56e);
    $parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", ()=>$7de340274894a80b$export$9f45a1325e3cdfb8);
    var $eUqFw = parcelRequire("eUqFw");
    var $g3daZ = parcelRequire("g3daZ");
    const $7de340274894a80b$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>(0, ($parcel$interopDefault($eUqFw))).createElement("style", null, `#${(0, $g3daZ.gridRootId)} { ${variableName}: ${value}px }`);
    const $7de340274894a80b$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
    const $7de340274894a80b$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
        let style = `:root { ${variableName}: ${$7de340274894a80b$var$getCssStringValue(value)} }`;
        if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$7de340274894a80b$var$getCssStringValue(responsiveValue)} } }`;
        return ((0, ($parcel$interopDefault($eUqFw))).createElement("style", null, style));
    };
});
parcelRegister("g3daZ", function(module, exports) {
    $parcel$export(module.exports, "gridRootId", ()=>$8c0ce154015b4932$export$a6d827031bcb31d1);
    $parcel$export(module.exports, "Root", ()=>$8c0ce154015b4932$export$be92b6f5f03c0fe9);
    var $7JEyt = parcelRequire("7JEyt");
    var $eUqFw = parcelRequire("eUqFw");
    var $4kA4E = parcelRequire("4kA4E");
    var $74Sfh = parcelRequire("74Sfh");
    var $mDO3p = parcelRequire("mDO3p");
    var $cYVoC = parcelRequire("cYVoC");
    var $9VNtx = parcelRequire("9VNtx");
    var $6anSS = parcelRequire("6anSS");
    var $4tTGX = parcelRequire("4tTGX");
    const $8c0ce154015b4932$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
    const $8c0ce154015b4932$var$styles = {
        root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
    };
    function $8c0ce154015b4932$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId }) {
        const ref = (0, $eUqFw.useRef)(null);
        (0, $eUqFw.useEffect)(()=>{
            var child;
        }, []);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4tTGX.SideNavVisibilityProvider), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6anSS.SideNavToggleButtonProvider), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $9VNtx.SideNavFlyoutLockProvider), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $74Sfh.HomeActionsProvider), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYVoC.DangerouslyHoistSlotSizes).Provider, {
            value: UNSAFE_dangerouslyHoistSlotSizes
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $mDO3p.SkipLinksProvider), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4kA4E.SkipLinksContainer), {
            label: skipLinksLabel
        }), (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            ref: ref,
            className: (0, $7JEyt.default)([
                $8c0ce154015b4932$var$styles.root,
                xcss
            ]),
            id: $8c0ce154015b4932$export$a6d827031bcb31d1,
            "data-testid": testId
        }, children)))))));
    }
});
parcelRegister("4kA4E", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksContainer", ()=>$91722a27ebfb834f$export$fce25a0c32fbc1e1);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $2IZkH = parcelRequire("2IZkH");
    var $f8qct = parcelRequire("f8qct");
    var $hi7qi = parcelRequire("hi7qi");
    const $91722a27ebfb834f$var$styles = {
        root: "_18s8v47k _1rjcu2gc _18zr12x7 _kqsw1n9t _1pby1mrw _11q71bhr _2rkoglpi _16qs1cd0 _1e02qkuk _tzy4idpf _t9ec1i34 _1digjh3g _gtjaidpf _1mygkb7n _66dk1kli",
        skipLinkList: "_1x8w11lx _2mzuglyw _1pfh1b66 _bozg1sck"
    };
    const $91722a27ebfb834f$var$handleBlur = (event)=>{
        if (!(event.target instanceof Element)) return;
        event.target.removeAttribute('tabindex');
        event.target.removeEventListener('blur', $91722a27ebfb834f$var$handleBlur);
    };
    const $91722a27ebfb834f$var$escapeHandler = (event)=>{
        if (event.key === 'Escape') {
            const activeElement = document.activeElement;
            if (activeElement !== null) activeElement.blur();
        }
    };
    const $91722a27ebfb834f$var$attachEscHandler = ()=>window.addEventListener('keydown', $91722a27ebfb834f$var$escapeHandler, false);
    const $91722a27ebfb834f$var$removeEscHandler = ()=>window.removeEventListener('keydown', $91722a27ebfb834f$var$escapeHandler, false);
    const $91722a27ebfb834f$export$fce25a0c32fbc1e1 = ({ label: label })=>{
        const sortedSkipLinks = (0, $f8qct.useSortedSkipLinks)();
        if (sortedSkipLinks.length === 0) return null;
        const emptyLabelOverride = !!label?.match(/^\s+$/);
        return $eUqFw.createElement("div", {
            onFocus: $91722a27ebfb834f$var$attachEscHandler,
            onBlur: $91722a27ebfb834f$var$removeEscHandler,
            className: (0, $7JEyt.default)([
                $91722a27ebfb834f$var$styles.root
            ])
        }, emptyLabelOverride ? null : $eUqFw.createElement((0, $2IZkH.default), {
            weight: "medium"
        }, label), $eUqFw.createElement("ol", {
            className: (0, $7JEyt.default)([
                $91722a27ebfb834f$var$styles.skipLinkList
            ])
        }, sortedSkipLinks.map(({ id: id, label: label })=>$eUqFw.createElement((0, $hi7qi.SkipLink), {
                key: id,
                href: `#${id}`,
                isFocusable: true
            }, label))));
    };
});
parcelRegister("f8qct", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksDataContext", ()=>$07a6d2b5d85be790$export$e9ab38ce6147d3d2);
    $parcel$export(module.exports, "useSortedSkipLinks", ()=>$07a6d2b5d85be790$export$b0b0d4fc1b356759);
    var $eUqFw = parcelRequire("eUqFw");
    const $07a6d2b5d85be790$export$e9ab38ce6147d3d2 = (0, $eUqFw.createContext)([]);
    const $07a6d2b5d85be790$var$assignIndex = (num, arr)=>{
        if (!arr.includes(num)) return num;
        return $07a6d2b5d85be790$var$assignIndex(num + 1, arr);
    };
    const $07a6d2b5d85be790$var$sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
            const listIndex = $07a6d2b5d85be790$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const $07a6d2b5d85be790$export$b0b0d4fc1b356759 = ()=>{
        const skipLinksData = (0, $eUqFw.useContext)($07a6d2b5d85be790$export$e9ab38ce6147d3d2);
        return (0, $eUqFw.useMemo)(()=>{
            return $07a6d2b5d85be790$var$sortSkipLinks(skipLinksData);
        }, [
            skipLinksData
        ]);
    };
});
parcelRegister("hi7qi", function(module, exports) {
    $parcel$export(module.exports, "SkipLink", ()=>$c1eedf62cfe33b53$export$ef95c37428582a65);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $a5MxG = parcelRequire("a5MxG");
    const $c1eedf62cfe33b53$var$styles = {
        skipLinkListItem: "_1pfhze3t"
    };
    const $c1eedf62cfe33b53$var$assignIndex = (num, arr)=>{
        if (!arr.includes(num)) return num;
        return $c1eedf62cfe33b53$var$assignIndex(num + 1, arr);
    };
    const $c1eedf62cfe33b53$var$handleBlur = (event)=>{
        event.target.removeAttribute('tabindex');
        event.target.removeEventListener('blur', $c1eedf62cfe33b53$var$handleBlur);
    };
    const $c1eedf62cfe33b53$var$focusTargetRef = (href)=>(event)=>{
            event.preventDefault();
            const targetRef = document.querySelector(href);
            const key = event.which || event.keycode;
            if (key && key !== 13 && key !== 32) return;
            if (targetRef) {
                targetRef.setAttribute('tabindex', '-1');
                targetRef.addEventListener('blur', $c1eedf62cfe33b53$var$handleBlur);
                targetRef.focus();
                document.activeElement && document.activeElement.scrollIntoView({
                    behavior: 'smooth'
                });
                window.scrollTo(0, 0);
            }
            return false;
        };
    const $c1eedf62cfe33b53$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
        return $eUqFw.createElement("li", {
            className: (0, $7JEyt.default)([
                $c1eedf62cfe33b53$var$styles.skipLinkListItem
            ])
        }, $eUqFw.createElement((0, $a5MxG.default), {
            tabIndex: isFocusable ? 0 : -1,
            href: href,
            onClick: $c1eedf62cfe33b53$var$focusTargetRef(href)
        }, children));
    };
});
parcelRegister("74Sfh", function(module, exports) {
    $parcel$export(module.exports, "HomeActionsProvider", ()=>$0013efdb02543124$export$8b9089606266983e);
    var $eUqFw = parcelRequire("eUqFw");
    var $40QEv = parcelRequire("40QEv");
    const $0013efdb02543124$export$8b9089606266983e = ({ children: children })=>{
        const [element, setElement] = (0, $eUqFw.useState)(null);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $40QEv.HomeActionsElement).Provider, {
            value: element
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $40QEv.HomeActionsAttachRef).Provider, {
            value: setElement
        }, children));
    };
});
parcelRegister("40QEv", function(module, exports) {
    $parcel$export(module.exports, "HomeActionsElement", ()=>$ef1f280bd3b4195f$export$4128169e0878a41d);
    $parcel$export(module.exports, "HomeActionsAttachRef", ()=>$ef1f280bd3b4195f$export$762fcfeaa67873eb);
    var $eUqFw = parcelRequire("eUqFw");
    var $4oSDA = parcelRequire("4oSDA");
    const $ef1f280bd3b4195f$export$4128169e0878a41d = (0, $eUqFw.createContext)(null);
    const $ef1f280bd3b4195f$export$762fcfeaa67873eb = (0, $eUqFw.createContext)((0, $4oSDA.default));
});
parcelRegister("mDO3p", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksProvider", ()=>$79634ad01205cd3f$export$fe514f9f7b03d46f);
    var $eUqFw = parcelRequire("eUqFw");
    var $9Nwj0 = parcelRequire("9Nwj0");
    var $f8qct = parcelRequire("f8qct");
    const $79634ad01205cd3f$var$getByDomOrderSortFunction = ()=>{
        const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
        return (a, b)=>{
            const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
            const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
            if (indexA === indexB) {
                if (a.listIndex !== undefined) return -1;
                else return 1;
            }
            return indexA - indexB;
        };
    };
    const $79634ad01205cd3f$export$fe514f9f7b03d46f = ({ children: children })=>{
        const [links, setLinks] = (0, $eUqFw.useState)([]);
        const registerSkipLink = (0, $eUqFw.useCallback)((skipLinkData)=>{
            setLinks((oldLinks)=>{
                if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
                return [
                    ...oldLinks,
                    skipLinkData
                ].sort($79634ad01205cd3f$var$getByDomOrderSortFunction());
            });
        }, []);
        const unregisterSkipLink = (0, $eUqFw.useCallback)((id)=>{
            setLinks((links)=>links.filter((link)=>link.id !== id));
        }, []);
        const contextValue = (0, $eUqFw.useMemo)(()=>{
            const data = {
                registerSkipLink: registerSkipLink,
                unregisterSkipLink: unregisterSkipLink
            };
            return data;
        }, [
            registerSkipLink,
            unregisterSkipLink
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $9Nwj0.SkipLinksContext).Provider, {
            value: contextValue
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $f8qct.SkipLinksDataContext).Provider, {
            value: links
        }, children));
    };
});
parcelRegister("9VNtx", function(module, exports) {
    $parcel$export(module.exports, "SideNavFlyoutLockProvider", ()=>$ffa5ceb1c1160512$export$7003dd76deb92ad);
    var $eUqFw = parcelRequire("eUqFw");
    var $iWwYv = parcelRequire("iWwYv");
    const $ffa5ceb1c1160512$export$7003dd76deb92ad = ({ children: children })=>{
        const [flyoutLock, setFlyoutLock] = (0, $eUqFw.useState)(0);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iWwYv.FlyoutLockCount).Provider, {
            value: flyoutLock
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iWwYv.SetFlyoutLockCount).Provider, {
            value: setFlyoutLock
        }, children));
    };
});
parcelRegister("iWwYv", function(module, exports) {
    $parcel$export(module.exports, "FlyoutLockCount", ()=>$c49fabe729c98b40$export$962eb1e8d553c86f);
    $parcel$export(module.exports, "SetFlyoutLockCount", ()=>$c49fabe729c98b40$export$52e873d56b3942a3);
    var $eUqFw = parcelRequire("eUqFw");
    var $4oSDA = parcelRequire("4oSDA");
    const $c49fabe729c98b40$export$962eb1e8d553c86f = (0, $eUqFw.createContext)(0);
    const $c49fabe729c98b40$export$52e873d56b3942a3 = (0, $eUqFw.createContext)((0, $4oSDA.default));
});
parcelRegister("6anSS", function(module, exports) {
    $parcel$export(module.exports, "SideNavToggleButtonProvider", ()=>$2ccfd3d55fecaebf$export$ceb8e60e9790fc0f);
    var $eUqFw = parcelRequire("eUqFw");
    var $gygCt = parcelRequire("gygCt");
    const $2ccfd3d55fecaebf$export$ceb8e60e9790fc0f = ({ children: children })=>{
        const [element, setElement] = (0, $eUqFw.useState)(null);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gygCt.SideNavToggleButtonElement).Provider, {
            value: element
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gygCt.SideNavToggleButtonAttachRef).Provider, {
            value: setElement
        }, children));
    };
});
parcelRegister("gygCt", function(module, exports) {
    $parcel$export(module.exports, "SideNavToggleButtonElement", ()=>$2f3296f035ecbef1$export$9c1768094bef896);
    $parcel$export(module.exports, "SideNavToggleButtonAttachRef", ()=>$2f3296f035ecbef1$export$fb8fa9a80240785e);
    var $eUqFw = parcelRequire("eUqFw");
    var $4oSDA = parcelRequire("4oSDA");
    const $2f3296f035ecbef1$export$9c1768094bef896 = (0, $eUqFw.createContext)(null);
    const $2f3296f035ecbef1$export$fb8fa9a80240785e = (0, $eUqFw.createContext)((0, $4oSDA.default));
});
parcelRegister("4tTGX", function(module, exports) {
    $parcel$export(module.exports, "SideNavVisibilityProvider", ()=>$1d2cb7d346b33021$export$aac8e996360f6ad9);
    var $eUqFw = parcelRequire("eUqFw");
    var $vlD4r = parcelRequire("vlD4r");
    const $1d2cb7d346b33021$export$aac8e996360f6ad9 = ({ children: children })=>{
        const [visibleOnDesktop, setVisibleOnDesktop] = (0, $eUqFw.useState)(null);
        const [visibleOnMobile, setVisibleOnMobile] = (0, $eUqFw.useState)(false);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $vlD4r.SideNavDesktopVisibility).Provider, {
            value: visibleOnDesktop
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $vlD4r.SetSideNavDesktopVisibility).Provider, {
            value: setVisibleOnDesktop
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $vlD4r.SideNavMobileVisibility).Provider, {
            value: visibleOnMobile
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $vlD4r.SetSideNavMobileVisibility).Provider, {
            value: setVisibleOnMobile
        }, children))));
    };
});
parcelRegister("vlD4r", function(module, exports) {
    $parcel$export(module.exports, "SideNavDesktopVisibility", ()=>$cb0d02e8f0afdff4$export$1771e3b63861d206);
    $parcel$export(module.exports, "SideNavMobileVisibility", ()=>$cb0d02e8f0afdff4$export$c5f483eeea865395);
    $parcel$export(module.exports, "SetSideNavDesktopVisibility", ()=>$cb0d02e8f0afdff4$export$5edca135c5bde4af);
    $parcel$export(module.exports, "SetSideNavMobileVisibility", ()=>$cb0d02e8f0afdff4$export$64be6ca751606276);
    var $eUqFw = parcelRequire("eUqFw");
    var $4oSDA = parcelRequire("4oSDA");
    const $cb0d02e8f0afdff4$export$1771e3b63861d206 = (0, $eUqFw.createContext)(null);
    const $cb0d02e8f0afdff4$export$c5f483eeea865395 = (0, $eUqFw.createContext)(false);
    const $cb0d02e8f0afdff4$export$5edca135c5bde4af = (0, $eUqFw.createContext)((0, $4oSDA.default));
    const $cb0d02e8f0afdff4$export$64be6ca751606276 = (0, $eUqFw.createContext)((0, $4oSDA.default));
});
parcelRegister("9srM0", function(module, exports) {
    $parcel$export(module.exports, "PanelSplitterProvider", ()=>$909c87478fa1d674$export$f662bfb764348932);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $7f6oC = parcelRequire("7f6oC");
    const $909c87478fa1d674$var$styles = {
        panelChildrenWrapper: "_1reo1wug _18m91wug _4t3i1osq _1e0c1txw _2lx21bp4"
    };
    const $909c87478fa1d674$export$f662bfb764348932 = ({ panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, position: position = 'end', isEnabled: isEnabled = true, children: children })=>{
        const portalRef = (0, $eUqFw.useRef)(null);
        const context = (0, $eUqFw.useMemo)(()=>({
                panelWidth: panelWidth,
                onCompleteResize: onCompleteResize,
                resizeBounds: resizeBounds,
                portalRef: portalRef,
                resizingCssVar: resizingCssVar,
                position: position,
                panelRef: panelRef,
                isEnabled: isEnabled
            }), [
            isEnabled,
            onCompleteResize,
            panelRef,
            panelWidth,
            position,
            resizeBounds,
            resizingCssVar
        ]);
        return $eUqFw.createElement((0, $eUqFw.Fragment), null, $eUqFw.createElement((0, $7f6oC.PanelSplitterContext).Provider, {
            value: context
        }, $eUqFw.createElement("div", {
            className: (0, $7JEyt.default)([
                $909c87478fa1d674$var$styles.panelChildrenWrapper
            ])
        }, children)), $eUqFw.createElement("div", {
            ref: portalRef
        }));
    };
});
parcelRegister("7f6oC", function(module, exports) {
    $parcel$export(module.exports, "PanelSplitterContext", ()=>$72b85966633a3548$export$7a4054f2c546f2cd);
    var $eUqFw = parcelRequire("eUqFw");
    const $72b85966633a3548$export$7a4054f2c546f2cd = (0, $eUqFw.createContext)(null);
});
parcelRegister("gtHi1", function(module, exports) {
    $parcel$export(module.exports, "usePrefixedUID", ()=>$4c06f70b52ac826e$export$86433d4fd18455f4);
    var $5aRS9 = parcelRequire("5aRS9");
    const $4c06f70b52ac826e$export$86433d4fd18455f4 = (prefix = 'element')=>`${prefix}-${(0, $5aRS9.useId)()}`;
});
parcelRegister("aHmxD", function(module, exports) {
    $parcel$export(module.exports, "Banner", ()=>$941a2e70ea837305$export$3b4e64e77073e307);
    var $7JEyt = parcelRequire("7JEyt");
    var $eUqFw = parcelRequire("eUqFw");
    var $9Nwj0 = parcelRequire("9Nwj0");
    var $hCJA5 = parcelRequire("hCJA5");
    var $cYVoC = parcelRequire("cYVoC");
    var $3tf9Q = parcelRequire("3tf9Q");
    var $gtHi1 = parcelRequire("gtHi1");
    const $941a2e70ea837305$var$styles = {
        root: "_nd5ldkfm _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat _1reo15vq _18m915vq"
    };
    function $941a2e70ea837305$export$3b4e64e77073e307({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 64, label: label = 'Banner', testId: testId, id: id }) {
        const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)((0, $cYVoC.DangerouslyHoistSlotSizes));
        const UID = (0, $gtHi1.usePrefixedUID)();
        const CID = id ? id : UID;
        (0, $9Nwj0.useSkipLink)(CID, label);
        return (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            id: CID,
            role: "banner",
            "data-layout-slot": true,
            className: (0, $7JEyt.default)([
                $941a2e70ea837305$var$styles.root,
                xcss
            ]),
            "data-testid": testId
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3tf9Q.HoistCssVarToLocalGrid), {
            variableName: (0, $hCJA5.bannerMountedVar),
            value: UNSAFE_height
        }), dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3tf9Q.DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, $hCJA5.UNSAFE_bannerVar),
            value: UNSAFE_height
        }), children);
    }
});
parcelRegister("01noM", function(module, exports) {
    $parcel$export(module.exports, "Main", ()=>$799666e0a68427e4$export$861edd1ccea2f746);
    var $7JEyt = parcelRequire("7JEyt");
    var $eUqFw = parcelRequire("eUqFw");
    var $9Nwj0 = parcelRequire("9Nwj0");
    var $aVI5G = parcelRequire("aVI5G");
    var $gtHi1 = parcelRequire("gtHi1");
    var $lABuN = parcelRequire("lABuN");
    const $799666e0a68427e4$var$styles = {
        root: "_nd5l1gzg _19121cl4 _qwfh1wug",
        mainCurvedCorner: "_1orwi2wt",
        fixedContentArea: "_152t1l7u _1reo1wug _18m91wug _165t1run _13wn1if8"
    };
    const $799666e0a68427e4$var$contentBorderStyles = {
        largeViewportTop: "_vchhusvi _mqm2zgxb _1e0cglyw _p3z31gzg _18911gzg _14611gzg _f0zu1mrw _4t3i1run _152t1l7u _lcxvglyw _kqsw1if8 _1pbycs5v _dm2518uv",
        largeViewportLeft: "_vchhusvi _izbqoyrj _191wzgxb _1s1gi2wt _1e0cglyw _p3z31gzg _18911gzg _14611gzg _f0zu1mrw _4t3i1run _152t1l7u _lcxvglyw _kqsw1if8 _1pbykb7n _dm2518uv",
        curvedBorder: "_1s1gi2wt _h7aloyrj"
    };
    function $799666e0a68427e4$export$861edd1ccea2f746({ children: children, isFixed: isFixed, xcss: xcss, label: label = 'Main Content', testId: testId, id: id }) {
        const UID = (0, $gtHi1.usePrefixedUID)();
        const CID = id ? id : UID;
        const { visibleOnDesktop: isSideNavVisibleOnDesktop } = (0, $aVI5G.useSideNavVisibility)();
        (0, $9Nwj0.useSkipLink)(CID, label);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            id: CID,
            "data-layout-slot": true,
            "aria-label": label,
            className: (0, $7JEyt.default)([
                $799666e0a68427e4$var$styles.root,
                isSideNavVisibleOnDesktop && $799666e0a68427e4$var$styles.mainCurvedCorner,
                isFixed && $799666e0a68427e4$var$styles.fixedContentArea,
                xcss
            ]),
            role: "main",
            "data-testid": testId
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lABuN.MainStickyContext).Provider, {
            value: Boolean(isFixed)
        }, children)), isSideNavVisibleOnDesktop && (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            "data-layout-slot": true,
            className: (0, $7JEyt.default)([
                $799666e0a68427e4$var$contentBorderStyles.largeViewportLeft
            ])
        }), (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            "data-layout-slot": true,
            className: (0, $7JEyt.default)([
                $799666e0a68427e4$var$contentBorderStyles.largeViewportTop,
                isSideNavVisibleOnDesktop && $799666e0a68427e4$var$contentBorderStyles.curvedBorder
            ])
        }));
    }
});
parcelRegister("aVI5G", function(module, exports) {
    $parcel$export(module.exports, "useSideNavVisibility", ()=>$27adab74a574ba19$export$4a602ad7e09bdb2c);
    var $eUqFw = parcelRequire("eUqFw");
    var $74BVL = parcelRequire("74BVL");
    var $vlD4r = parcelRequire("vlD4r");
    const $27adab74a574ba19$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
        const visibleOnDesktop = (0, $eUqFw.useContext)((0, $vlD4r.SideNavDesktopVisibility));
        const setVisibleOnDesktop = (0, $eUqFw.useContext)((0, $vlD4r.SetSideNavDesktopVisibility));
        const visibleOnMobile = (0, $eUqFw.useContext)((0, $vlD4r.SideNavMobileVisibility));
        const setVisibleOnMobile = (0, $eUqFw.useContext)((0, $vlD4r.SetSideNavMobileVisibility));
        const [isSideNavVisible, setIsSideNavVisible] = (0, $eUqFw.useState)(!defaultCollapsed);
        (0, $eUqFw.useEffect)(()=>{
            const isSideNavVisibleOnDesktop = visibleOnDesktop === null ? !defaultCollapsed : visibleOnDesktop;
            const mediaQueryList = window.matchMedia('(min-width: 64rem)');
            setIsSideNavVisible(mediaQueryList.matches ? isSideNavVisibleOnDesktop : visibleOnMobile);
            return (0, $74BVL.bind)(mediaQueryList, {
                type: 'change',
                listener () {
                    setIsSideNavVisible(mediaQueryList.matches ? isSideNavVisibleOnDesktop : visibleOnMobile);
                }
            });
        }, [
            defaultCollapsed,
            visibleOnDesktop,
            visibleOnMobile
        ]);
        const showSideNav = (0, $eUqFw.useCallback)(()=>{
            const { matches: matches } = window.matchMedia('(min-width: 64rem)');
            matches ? setVisibleOnDesktop(true) : setVisibleOnMobile(true);
        }, [
            setVisibleOnDesktop,
            setVisibleOnMobile
        ]);
        return {
            visibleOnDesktop: visibleOnDesktop === null ? !defaultCollapsed : visibleOnDesktop,
            visibleOnMobile: visibleOnMobile,
            setVisibleOnDesktop: setVisibleOnDesktop,
            setVisibleOnMobile: setVisibleOnMobile,
            isSideNavVisible: isSideNavVisible,
            showSideNav: showSideNav
        };
    };
});
parcelRegister("lABuN", function(module, exports) {
    $parcel$export(module.exports, "MainStickyContext", ()=>$d523fe18027f4388$export$3b369e2c6c1ec840);
    var $eUqFw = parcelRequire("eUqFw");
    const $d523fe18027f4388$export$3b369e2c6c1ec840 = (0, $eUqFw.createContext)(false);
});
parcelRegister("5ysAy", function(module, exports) {
    $parcel$export(module.exports, "Panel", ()=>$87ac0dbb5206568a$export$2ddb90ad54e5f587);
    var $7JEyt = parcelRequire("7JEyt");
    var $eUqFw = parcelRequire("eUqFw");
    var $jijTN = parcelRequire("jijTN");
    var $9Nwj0 = parcelRequire("9Nwj0");
    var $hCJA5 = parcelRequire("hCJA5");
    var $cYVoC = parcelRequire("cYVoC");
    var $3tf9Q = parcelRequire("3tf9Q");
    var $9srM0 = parcelRequire("9srM0");
    var $gtHi1 = parcelRequire("gtHi1");
    const $87ac0dbb5206568a$var$panelSplitterResizingVar = '--n_pnlRsz';
    const $87ac0dbb5206568a$var$panelWidthSlotBounds = {
        min: '0px',
        max: '50vw'
    };
    const $87ac0dbb5206568a$var$panelWidthResizeBounds = {
        min: '120px',
        max: '50vw'
    };
    const $87ac0dbb5206568a$var$styles = {
        root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3i1run _kqsw1if8 _152t1l7u _1bsb1adv _14b54rrg _1dhy1c6w _9sns1wug",
        scrollContainer: "_1reo1wug _18m91wug _4t3i1osq"
    };
    function $87ac0dbb5206568a$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365, label: label = 'Panel', testId: testId, id: id, xcss: xcss }) {
        const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)((0, $cYVoC.DangerouslyHoistSlotSizes));
        const UID = (0, $gtHi1.usePrefixedUID)();
        const CID = id ? id : UID;
        (0, $9Nwj0.useSkipLink)(CID, label);
        const ref = (0, $eUqFw.useRef)(null);
        const [width, setWidth] = (0, $eUqFw.useState)(defaultWidth);
        const defaultWidthRef = (0, $eUqFw.useRef)(defaultWidth);
        (0, $eUqFw.useEffect)(()=>{
            if (defaultWidthRef.current === defaultWidth) return;
            defaultWidthRef.current = defaultWidth;
            setWidth(defaultWidth);
        }, [
            defaultWidth
        ]);
        const panelVariableWidth = `clamp(${$87ac0dbb5206568a$var$panelWidthSlotBounds.min}, ${width}px, ${$87ac0dbb5206568a$var$panelWidthSlotBounds.max})`;
        return (0, ($parcel$interopDefault($eUqFw))).createElement("section", {
            id: CID,
            "data-layout-slot": true,
            "aria-label": label,
            className: (0, $7JEyt.default)([
                $87ac0dbb5206568a$var$styles.root,
                xcss
            ]),
            style: {
                [(0, $hCJA5.panelVar)]: panelVariableWidth
            },
            "data-testid": testId,
            ref: ref
        }, dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3tf9Q.DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, $hCJA5.UNSAFE_panelLayoutVar),
            value: "0px",
            mediaQuery: (0, $jijTN.media).above.lg,
            responsiveValue: panelVariableWidth
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $9srM0.PanelSplitterProvider), {
            panelRef: ref,
            panelWidth: width,
            onCompleteResize: setWidth,
            resizeBounds: $87ac0dbb5206568a$var$panelWidthResizeBounds,
            resizingCssVar: $87ac0dbb5206568a$var$panelSplitterResizingVar,
            position: "start"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                $87ac0dbb5206568a$var$styles.scrollContainer
            ])
        }, children)));
    }
});
parcelRegister("2EYbt", function(module, exports) {
    $parcel$export(module.exports, "SideNav", ()=>$fdd618c223af34b0$export$1a35787d6353cf6a);
    var $7JEyt = parcelRequire("7JEyt");
    var $eUqFw = parcelRequire("eUqFw");
    var $74BVL = parcelRequire("74BVL");
    var $1zX5J = parcelRequire("1zX5J");
    var $jb5fU = parcelRequire("jb5fU");
    var $iDwTy = parcelRequire("iDwTy");
    var $jijTN = parcelRequire("jijTN");
    var $4oRGz = parcelRequire("4oRGz");
    var $40QEv = parcelRequire("40QEv");
    var $9Nwj0 = parcelRequire("9Nwj0");
    var $hCJA5 = parcelRequire("hCJA5");
    var $cYVoC = parcelRequire("cYVoC");
    var $3tf9Q = parcelRequire("3tf9Q");
    var $9srM0 = parcelRequire("9srM0");
    var $gtHi1 = parcelRequire("gtHi1");
    var $iWwYv = parcelRequire("iWwYv");
    var $gygCt = parcelRequire("gygCt");
    var $aVI5G = parcelRequire("aVI5G");
    var $fCcAy = parcelRequire("fCcAy");
    var $bq8z9 = parcelRequire("bq8z9");
    const $fdd618c223af34b0$var$panelSplitterResizingVar = '--n_snvRsz';
    const $fdd618c223af34b0$var$widthResizeBounds = {
        min: '160px',
        max: '50vw'
    };
    const $fdd618c223af34b0$var$sideNavFlyoutCloseDelayMs = 400;
    const $fdd618c223af34b0$var$getSideNavState = ({ visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile, isFlyoutVisible: isFlyoutVisible })=>{
        if (visibleOnDesktop && visibleOnMobile) return 'idle';
        if (!visibleOnMobile && visibleOnDesktop) return 'hidden-mobile-only';
        if (!visibleOnDesktop && isFlyoutVisible) return 'flyout';
        if (visibleOnMobile && !visibleOnDesktop) return 'hidden-desktop-only';
        return 'hidden-mobile-and-desktop';
    };
    const $fdd618c223af34b0$var$styles = {
        root: "_bfhk1bhr _16qs1cd0 _nd5l1b6c _4t3i1run _152t1l7u _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _4ap3vuon _scbpglyw _qilnk0mc",
        flyout: "_4ap31bhr _scbp1cd0 _qiln1gzg",
        interactionSurface: "_1bsb1osq _4t3i1osq",
        hiddenMobileAndDesktop: "_1e0cglyw",
        hiddenMobileOnly: "_1e0cglyw _dm2518uv",
        hiddenDesktopOnly: "_dm25glyw"
    };
    function $fdd618c223af34b0$var$SideNavInternalLegacy({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Side Navigation', onExpand: onExpand, onCollapse: onCollapse, id: id }) {
        const UID = (0, $gtHi1.usePrefixedUID)();
        const CID = id ? id : UID;
        (0, $9Nwj0.useSkipLink)(CID, label);
        const { visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile, setVisibleOnDesktop: setVisibleOnDesktop } = (0, $aVI5G.useSideNavVisibility)({
            defaultCollapsed: defaultCollapsed
        });
        const [width, setWidth] = (0, $eUqFw.useState)(defaultWidth);
        const clampedWidth = `clamp(${$fdd618c223af34b0$var$widthResizeBounds.min}, ${width}px, ${$fdd618c223af34b0$var$widthResizeBounds.max})`;
        const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)((0, $cYVoC.DangerouslyHoistSlotSizes));
        const navRef = (0, $eUqFw.useRef)(null);
        const toggleButtonElement = (0, $eUqFw.useContext)((0, $gygCt.SideNavToggleButtonElement));
        const homeActionsElement = (0, $eUqFw.useContext)((0, $40QEv.HomeActionsElement));
        const devTimeOnlyAttributes = {};
        const [isFlyoutActive, setIsFlyoutActive] = (0, $eUqFw.useState)(false);
        const flyoutLockCount = (0, $eUqFw.useContext)((0, $iWwYv.FlyoutLockCount));
        const isFlyoutLocked = flyoutLockCount > 0;
        const isFlyoutVisible = isFlyoutActive || isFlyoutLocked;
        const sideNavState = $fdd618c223af34b0$var$getSideNavState({
            visibleOnDesktop: visibleOnDesktop,
            visibleOnMobile: visibleOnMobile,
            isFlyoutVisible: isFlyoutVisible
        });
        const closeFlyoutTimerRef = (0, $eUqFw.useRef)(null);
        const cancelPendingFlyoutClose = (0, $eUqFw.useCallback)(()=>{
            if (closeFlyoutTimerRef.current) {
                clearTimeout(closeFlyoutTimerRef.current);
                closeFlyoutTimerRef.current = null;
            }
        }, []);
        const openFlyout = (0, $eUqFw.useCallback)(()=>{
            cancelPendingFlyoutClose();
            setIsFlyoutActive(true);
        }, [
            cancelPendingFlyoutClose
        ]);
        const tryStartCloseFlyoutTimer = (0, $eUqFw.useCallback)(()=>{
            if (closeFlyoutTimerRef.current) return;
            closeFlyoutTimerRef.current = setTimeout(()=>{
                closeFlyoutTimerRef.current = null;
                setIsFlyoutActive(false);
            }, $fdd618c223af34b0$var$sideNavFlyoutCloseDelayMs);
        }, []);
        const toggleVisibility = (0, $bq8z9.useToggleSideNav)();
        (0, $eUqFw.useEffect)(()=>{
            setVisibleOnDesktop(visibleOnDesktop);
        }, [
            setVisibleOnDesktop,
            visibleOnDesktop
        ]);
        (0, $fCcAy.useSideNavVisibilityCallbacks)({
            onExpand: onExpand,
            onCollapse: onCollapse,
            visibleOnDesktop: visibleOnDesktop,
            visibleOnMobile: visibleOnMobile
        });
        (0, $eUqFw.useEffect)(()=>{
            const mediaQueryList = window.matchMedia('(min-width: 64rem)');
            return (0, $74BVL.bind)(mediaQueryList, {
                type: 'change',
                listener () {
                    if (mediaQueryList.matches) {
                        if (visibleOnMobile && !visibleOnDesktop) toggleVisibility();
                    }
                }
            });
        }, [
            toggleVisibility,
            visibleOnDesktop,
            visibleOnMobile
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!toggleButtonElement) return;
            return (0, $74BVL.bind)(toggleButtonElement, {
                type: 'mouseenter',
                listener () {
                    if (visibleOnDesktop) return;
                    const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                    if (matches) openFlyout();
                }
            });
        }, [
            openFlyout,
            toggleButtonElement,
            visibleOnDesktop
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!toggleButtonElement) return;
            return (0, $74BVL.bind)(toggleButtonElement, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    tryStartCloseFlyoutTimer();
                }
            });
        }, [
            tryStartCloseFlyoutTimer,
            isFlyoutVisible,
            toggleButtonElement
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!navRef.current) return;
            return (0, $74BVL.bind)(navRef.current, {
                type: 'mouseenter',
                listener () {
                    if (visibleOnDesktop || !isFlyoutVisible) return;
                    cancelPendingFlyoutClose();
                    if (isFlyoutLocked) {
                        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                        if (matches) openFlyout();
                    }
                }
            });
        }, [
            cancelPendingFlyoutClose,
            isFlyoutLocked,
            isFlyoutVisible,
            openFlyout,
            visibleOnDesktop
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!navRef.current) return;
            return (0, $74BVL.bind)(navRef.current, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    tryStartCloseFlyoutTimer();
                }
            });
        }, [
            tryStartCloseFlyoutTimer,
            isFlyoutVisible
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!homeActionsElement || !toggleButtonElement) return;
            return (0, $74BVL.bind)(homeActionsElement, {
                type: 'mouseover',
                listener (event) {
                    if (visibleOnDesktop || !isFlyoutVisible) return;
                    if (event.target === homeActionsElement) {
                        cancelPendingFlyoutClose();
                        return;
                    }
                    if (event.target instanceof Element && toggleButtonElement.contains(event.target)) return;
                    tryStartCloseFlyoutTimer();
                }
            });
        }, [
            cancelPendingFlyoutClose,
            tryStartCloseFlyoutTimer,
            homeActionsElement,
            isFlyoutVisible,
            toggleButtonElement,
            visibleOnDesktop
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!homeActionsElement) return;
            return (0, $74BVL.bind)(homeActionsElement, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    tryStartCloseFlyoutTimer();
                }
            });
        }, [
            cancelPendingFlyoutClose,
            tryStartCloseFlyoutTimer,
            homeActionsElement,
            isFlyoutVisible
        ]);
        (0, $eUqFw.useEffect)(()=>{
            return cancelPendingFlyoutClose;
        }, [
            cancelPendingFlyoutClose
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement("nav", {
            id: CID,
            ...devTimeOnlyAttributes,
            "data-layout-slot": true,
            "aria-label": label,
            style: {
                [(0, $hCJA5.sideNavVar)]: clampedWidth
            },
            ref: navRef,
            "data-testid": testId,
            className: (0, $7JEyt.default)([
                $fdd618c223af34b0$var$styles.root,
                sideNavState === 'hidden-mobile-only' && $fdd618c223af34b0$var$styles.hiddenMobileOnly,
                sideNavState === 'hidden-desktop-only' && $fdd618c223af34b0$var$styles.hiddenDesktopOnly,
                sideNavState === 'hidden-mobile-and-desktop' && $fdd618c223af34b0$var$styles.hiddenMobileAndDesktop,
                sideNavState === 'flyout' && $fdd618c223af34b0$var$styles.flyout
            ])
        }, dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3tf9Q.DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, $hCJA5.UNSAFE_sideNavLayoutVar),
            value: "0px",
            mediaQuery: (0, $jijTN.media).above.md,
            responsiveValue: visibleOnDesktop ? clampedWidth : 0
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4oRGz.InteractionSurface), {
            xcss: $fdd618c223af34b0$var$styles.interactionSurface
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $9srM0.PanelSplitterProvider), {
            panelRef: navRef,
            panelWidth: width,
            onCompleteResize: setWidth,
            resizeBounds: $fdd618c223af34b0$var$widthResizeBounds,
            resizingCssVar: $fdd618c223af34b0$var$panelSplitterResizingVar,
            isEnabled: sideNavState === 'idle' || sideNavState === 'hidden-mobile-only'
        }, children)));
    }
    function $fdd618c223af34b0$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Side Navigation', onExpand: onExpand, onCollapse: onCollapse, id: id }) {
        const UID = (0, $gtHi1.usePrefixedUID)();
        const CID = id ? id : UID;
        (0, $9Nwj0.useSkipLink)(CID, label);
        const { visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile, setVisibleOnDesktop: setVisibleOnDesktop } = (0, $aVI5G.useSideNavVisibility)({
            defaultCollapsed: defaultCollapsed
        });
        const [width, setWidth] = (0, $eUqFw.useState)(defaultWidth);
        const clampedWidth = `clamp(${$fdd618c223af34b0$var$widthResizeBounds.min}, ${width}px, ${$fdd618c223af34b0$var$widthResizeBounds.max})`;
        const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)((0, $cYVoC.DangerouslyHoistSlotSizes));
        const navRef = (0, $eUqFw.useRef)(null);
        const toggleButtonElement = (0, $eUqFw.useContext)((0, $gygCt.SideNavToggleButtonElement));
        const homeActionsElement = (0, $eUqFw.useContext)((0, $40QEv.HomeActionsElement));
        const devTimeOnlyAttributes = {};
        const [isFlyoutVisible, setIsFlyoutVisible] = (0, $eUqFw.useState)(false);
        const openLayerObserver = (0, $jb5fU.useOpenLayerObserver)();
        const flyoutStateRef = (0, $eUqFw.useRef)({
            type: 'not-active'
        });
        const sideNavState = $fdd618c223af34b0$var$getSideNavState({
            visibleOnDesktop: visibleOnDesktop,
            visibleOnMobile: visibleOnMobile,
            isFlyoutVisible: isFlyoutVisible
        });
        const updateFlyoutState = (0, $eUqFw.useCallback)((action)=>{
            if (action === 'open') {
                if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
                flyoutStateRef.current = {
                    type: 'open'
                };
                setIsFlyoutVisible(true);
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, $fdd618c223af34b0$var$sideNavFlyoutCloseDelayMs);
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
            }
            if (action === 'ready-to-close') {
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                if (openLayerObserver.getCount() === 0) {
                    flyoutStateRef.current = {
                        type: 'not-active'
                    };
                    setIsFlyoutVisible(false);
                }
            }
        }, [
            openLayerObserver
        ]);
        const toggleVisibility = (0, $bq8z9.useToggleSideNav)();
        (0, $eUqFw.useEffect)(()=>{
            setVisibleOnDesktop(visibleOnDesktop);
        }, [
            setVisibleOnDesktop,
            visibleOnDesktop
        ]);
        (0, $fCcAy.useSideNavVisibilityCallbacks)({
            onExpand: onExpand,
            onCollapse: onCollapse,
            visibleOnDesktop: visibleOnDesktop,
            visibleOnMobile: visibleOnMobile
        });
        (0, $eUqFw.useEffect)(()=>{
            const mediaQueryList = window.matchMedia('(min-width: 64rem)');
            return (0, $74BVL.bind)(mediaQueryList, {
                type: 'change',
                listener () {
                    if (mediaQueryList.matches) {
                        if (visibleOnMobile && !visibleOnDesktop) toggleVisibility();
                    }
                }
            });
        }, [
            toggleVisibility,
            visibleOnDesktop,
            visibleOnMobile
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!toggleButtonElement) return;
            return (0, $74BVL.bind)(toggleButtonElement, {
                type: 'mouseenter',
                listener () {
                    if (visibleOnDesktop) return;
                    const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                    if (matches) updateFlyoutState('open');
                }
            });
        }, [
            updateFlyoutState,
            toggleButtonElement,
            visibleOnDesktop
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!toggleButtonElement) return;
            return (0, $74BVL.bind)(toggleButtonElement, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            isFlyoutVisible,
            toggleButtonElement,
            updateFlyoutState
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!navRef.current) return;
            return (0, $74BVL.bind)(navRef.current, {
                type: 'mouseenter',
                listener () {
                    if (visibleOnDesktop || !isFlyoutVisible) return;
                    updateFlyoutState('open');
                }
            });
        }, [
            isFlyoutVisible,
            updateFlyoutState,
            visibleOnDesktop
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!navRef.current) return;
            return (0, $74BVL.bind)(navRef.current, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            isFlyoutVisible,
            updateFlyoutState
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!homeActionsElement || !toggleButtonElement) return;
            return (0, $74BVL.bind)(homeActionsElement, {
                type: 'mouseover',
                listener (event) {
                    if (visibleOnDesktop || !isFlyoutVisible) return;
                    if (event.target === homeActionsElement) {
                        updateFlyoutState('open');
                        return;
                    }
                    if (event.target instanceof Element && toggleButtonElement.contains(event.target)) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            homeActionsElement,
            isFlyoutVisible,
            toggleButtonElement,
            visibleOnDesktop,
            updateFlyoutState
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!homeActionsElement) return;
            return (0, $74BVL.bind)(homeActionsElement, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            homeActionsElement,
            isFlyoutVisible,
            updateFlyoutState
        ]);
        (0, $eUqFw.useEffect)(()=>{
            return openLayerObserver.onChange(function onChange({ count: count }) {
                if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) {
                    setIsFlyoutVisible(false);
                    flyoutStateRef.current = {
                        type: 'not-active'
                    };
                }
            });
        }, [
            openLayerObserver,
            updateFlyoutState
        ]);
        (0, $eUqFw.useEffect)(()=>{
            return function cleanupPendingFlyoutClose() {
                if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
            };
        }, []);
        return (0, ($parcel$interopDefault($eUqFw))).createElement("nav", {
            id: CID,
            ...devTimeOnlyAttributes,
            "data-layout-slot": true,
            "aria-label": label,
            style: {
                [(0, $hCJA5.sideNavVar)]: clampedWidth
            },
            ref: navRef,
            "data-testid": testId,
            className: (0, $7JEyt.default)([
                $fdd618c223af34b0$var$styles.root,
                sideNavState === 'hidden-mobile-only' && $fdd618c223af34b0$var$styles.hiddenMobileOnly,
                sideNavState === 'hidden-desktop-only' && $fdd618c223af34b0$var$styles.hiddenDesktopOnly,
                sideNavState === 'hidden-mobile-and-desktop' && $fdd618c223af34b0$var$styles.hiddenMobileAndDesktop,
                sideNavState === 'flyout' && $fdd618c223af34b0$var$styles.flyout
            ])
        }, dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3tf9Q.DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, $hCJA5.UNSAFE_sideNavLayoutVar),
            value: "0px",
            mediaQuery: (0, $jijTN.media).above.md,
            responsiveValue: visibleOnDesktop ? clampedWidth : 0
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4oRGz.InteractionSurface), {
            xcss: $fdd618c223af34b0$var$styles.interactionSurface
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $9srM0.PanelSplitterProvider), {
            panelRef: navRef,
            panelWidth: width,
            onCompleteResize: setWidth,
            resizeBounds: $fdd618c223af34b0$var$widthResizeBounds,
            resizingCssVar: $fdd618c223af34b0$var$panelSplitterResizingVar,
            isEnabled: sideNavState === 'idle' || sideNavState === 'hidden-mobile-only'
        }, children)));
    }
    function $fdd618c223af34b0$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Side Navigation', onExpand: onExpand, onCollapse: onCollapse, id: id }) {
        if ((0, $iDwTy.fg)('platform_design_system_team_layering_observer')) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1zX5J.OpenLayerObserver), null, (0, ($parcel$interopDefault($eUqFw))).createElement($fdd618c223af34b0$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            onExpand: onExpand,
            onCollapse: onCollapse,
            id: id
        }, children));
        return (0, ($parcel$interopDefault($eUqFw))).createElement($fdd618c223af34b0$var$SideNavInternalLegacy, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            onExpand: onExpand,
            onCollapse: onCollapse,
            id: id
        }, children);
    }
});
parcelRegister("1zX5J", function(module, exports) {
    $parcel$export(module.exports, "OpenLayerObserver", ()=>$56299224c5c19433$export$97afddda23bcd287);
    var $eUqFw = parcelRequire("eUqFw");
    var $aQHUY = parcelRequire("aQHUY");
    function $56299224c5c19433$var$createInternalAPI() {
        let count = 0;
        const registry = new Set();
        function onChange(listener) {
            function wrapped(...args) {
                listener(...args);
            }
            registry.add(wrapped);
            return function unsubscribe() {
                registry.delete(wrapped);
            };
        }
        function increment() {
            count += 1;
            Array.from(registry).forEach((listener)=>listener({
                    count: count
                }));
        }
        function decrement() {
            count -= 1;
            Array.from(registry).forEach((listener)=>listener({
                    count: count
                }));
        }
        return {
            getCount () {
                return count;
            },
            onChange: onChange,
            increment: increment,
            decrement: decrement
        };
    }
    function $56299224c5c19433$export$97afddda23bcd287({ children: children }) {
        const [internalAPI] = (0, $eUqFw.useState)(()=>$56299224c5c19433$var$createInternalAPI());
        const parentContext = (0, $eUqFw.useContext)((0, $aQHUY.OpenLayerObserverContext));
        const increment = (0, $eUqFw.useCallback)(()=>{
            internalAPI.increment();
            if (parentContext !== null) parentContext.increment();
        }, [
            internalAPI,
            parentContext
        ]);
        const decrement = (0, $eUqFw.useCallback)(()=>{
            internalAPI.decrement();
            if (parentContext !== null) parentContext.decrement();
        }, [
            internalAPI,
            parentContext
        ]);
        const contextValue = (0, $eUqFw.useMemo)(()=>({
                getCount: internalAPI.getCount,
                onChange: internalAPI.onChange,
                increment: increment,
                decrement: decrement
            }), [
            decrement,
            increment,
            internalAPI.getCount,
            internalAPI.onChange
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aQHUY.OpenLayerObserverContext).Provider, {
            value: contextValue
        }, children);
    }
});
parcelRegister("jb5fU", function(module, exports) {
    $parcel$export(module.exports, "useOpenLayerObserver", ()=>$c84aa832805d66f5$export$750f5b0d6c51617e);
    var $eUqFw = parcelRequire("eUqFw");
    var $8ynlC = parcelRequire("8ynlC");
    var $aQHUY = parcelRequire("aQHUY");
    function $c84aa832805d66f5$export$750f5b0d6c51617e() {
        const context = (0, $eUqFw.useContext)((0, $aQHUY.OpenLayerObserverContext));
        (0, $8ynlC.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
        const publicAPI = (0, $eUqFw.useMemo)(()=>({
                getCount: context.getCount,
                onChange: context.onChange
            }), [
            context.getCount,
            context.onChange
        ]);
        return publicAPI;
    }
});
parcelRegister("4oRGz", function(module, exports) {
    $parcel$export(module.exports, "InteractionSurface", ()=>$c38752366a6ad07a$export$b77883dd274d64b);
    $parcel$export(module.exports, "InteractionConsumer", ()=>$c38752366a6ad07a$export$65f09dabf608e4ae);
    var $7JEyt = parcelRequire("7JEyt");
    var $eUqFw = parcelRequire("eUqFw");
    const $c38752366a6ad07a$var$opacityCssVar = '--n_sfc_o';
    const $c38752366a6ad07a$var$displayCssVar = '--n_sfc_d';
    const $c38752366a6ad07a$var$surfaceStyles = {
        root: "_17lff1ug _2wlvglyw _1ebb1osq _1yth1osq _1s0b1ule _1dle1ule"
    };
    const $c38752366a6ad07a$export$b77883dd274d64b = ({ children: children, xcss: xcss })=>(0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                $c38752366a6ad07a$var$surfaceStyles.root,
                xcss
            ])
        }, children);
    const $c38752366a6ad07a$var$behaviorStyles = {
        hideOnLeave: "_tzy41j9r",
        removeOnLeave: "_1e0c13fu"
    };
    const $c38752366a6ad07a$export$65f09dabf608e4ae = ({ children: children, testId: testId, xcss: xcss, behavior: behavior = 'hideOnLeave' })=>(0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": testId,
            className: (0, $7JEyt.default)([
                behavior === 'hideOnLeave' && $c38752366a6ad07a$var$behaviorStyles.hideOnLeave,
                behavior === 'removeOnLeave' && $c38752366a6ad07a$var$behaviorStyles.removeOnLeave,
                xcss
            ])
        }, children);
});
parcelRegister("fCcAy", function(module, exports) {
    $parcel$export(module.exports, "useSideNavVisibilityCallbacks", ()=>$131484ca5e84017e$export$1904b8f2577aba9a);
    var $eUqFw = parcelRequire("eUqFw");
    var $lnAMz = parcelRequire("lnAMz");
    function $131484ca5e84017e$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile }) {
        const onExpandRef = (0, $eUqFw.useRef)(onExpand);
        const onCollapseRef = (0, $eUqFw.useRef)(onCollapse);
        (0, $eUqFw.useEffect)(()=>{
            onExpandRef.current = onExpand;
            onCollapseRef.current = onCollapse;
        }, [
            onExpand,
            onCollapse
        ]);
        const previousVisibleOnDesktop = (0, $lnAMz.default)(visibleOnDesktop);
        (0, $eUqFw.useEffect)(()=>{
            if (previousVisibleOnDesktop === undefined || previousVisibleOnDesktop === visibleOnDesktop) return;
            if (visibleOnDesktop) onExpandRef.current?.({
                screen: 'desktop'
            });
            else onCollapseRef.current?.({
                screen: 'desktop'
            });
        }, [
            previousVisibleOnDesktop,
            visibleOnDesktop
        ]);
        const previousVisibleOnMobile = (0, $lnAMz.default)(visibleOnMobile);
        (0, $eUqFw.useEffect)(()=>{
            if (previousVisibleOnMobile === undefined || previousVisibleOnMobile === visibleOnMobile) return;
            if (visibleOnMobile) onExpandRef.current?.({
                screen: 'mobile'
            });
            else onCollapseRef.current?.({
                screen: 'mobile'
            });
        }, [
            previousVisibleOnMobile,
            visibleOnMobile
        ]);
    }
});
parcelRegister("bq8z9", function(module, exports) {
    $parcel$export(module.exports, "useToggleSideNav", ()=>$20f97edb4f41d838$export$477ee35601a0a8ce);
    var $eUqFw = parcelRequire("eUqFw");
    var $vlD4r = parcelRequire("vlD4r");
    const $20f97edb4f41d838$export$477ee35601a0a8ce = ()=>{
        const setVisibleOnDesktop = (0, $eUqFw.useContext)((0, $vlD4r.SetSideNavDesktopVisibility));
        const setVisibleOnMobile = (0, $eUqFw.useContext)((0, $vlD4r.SetSideNavMobileVisibility));
        const toggleSideNav = (0, $eUqFw.useCallback)(()=>{
            const { matches: matches } = window.matchMedia('(min-width: 64rem)');
            if (matches) setVisibleOnDesktop((prev)=>!prev);
            else setVisibleOnMobile((prev)=>!prev);
        }, [
            setVisibleOnDesktop,
            setVisibleOnMobile
        ]);
        return toggleSideNav;
    };
});
parcelRegister("hfckm", function(module, exports) {
    $parcel$export(module.exports, "TopBar", ()=>$b5f40f4360d2da01$export$c4e96258f3b6511);
    var $7JEyt = parcelRequire("7JEyt");
    var $eUqFw = parcelRequire("eUqFw");
    var $9Nwj0 = parcelRequire("9Nwj0");
    var $FSQzJ = parcelRequire("FSQzJ");
    var $4i7It = parcelRequire("4i7It");
    var $hCJA5 = parcelRequire("hCJA5");
    var $cYVoC = parcelRequire("cYVoC");
    var $3tf9Q = parcelRequire("3tf9Q");
    var $gtHi1 = parcelRequire("gtHi1");
    const $b5f40f4360d2da01$var$styles = {
        root: "_1e0c11p5 _yv0e1mfv _18zrutpp _zulpu2gc _4cvr1h6o _bfhkvuon _vchhusvi _nd5l8cbt _4t3i2mmk _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi _1rqtc57g"
    };
    const $b5f40f4360d2da01$var$contentBorderStyles = {
        smallViewportTop: "_179rzgxb _nd5l8cbt _152t1nws _lcxvglyw _kqsw1if8 _t9ec2nsj _1pby11wp _dm25glyw"
    };
    function $b5f40f4360d2da01$export$c4e96258f3b6511({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 48, label: label = 'Top Bar', testId: testId, id: id, UNSAFE_theme: UNSAFE_theme }) {
        const dangerouslyHoistSlotSizes = (0, $eUqFw.useContext)((0, $cYVoC.DangerouslyHoistSlotSizes));
        const UID = (0, $gtHi1.usePrefixedUID)();
        const CID = id ? id : UID;
        (0, $9Nwj0.useSkipLink)(CID, label);
        const customTheme = (0, $4i7It.useCustomTheme)(UNSAFE_theme);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $FSQzJ.HasCustomThemeContext).Provider, {
            value: customTheme.isEnabled
        }, (0, ($parcel$interopDefault($eUqFw))).createElement("header", {
            id: CID,
            "data-layout-slot": true,
            className: (0, $7JEyt.default)([
                $b5f40f4360d2da01$var$styles.root,
                xcss
            ]),
            "data-testid": testId,
            style: customTheme.isEnabled ? customTheme.style : undefined
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3tf9Q.HoistCssVarToLocalGrid), {
            variableName: (0, $hCJA5.topBarMountedVar),
            value: UNSAFE_height
        }), dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3tf9Q.DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, $hCJA5.UNSAFE_topBarVar),
            value: UNSAFE_height
        }), children), (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            "data-layout-slot": true,
            className: (0, $7JEyt.default)([
                $b5f40f4360d2da01$var$contentBorderStyles.smallViewportTop
            ])
        }));
    }
});
parcelRegister("4i7It", function(module, exports) {
    $parcel$export(module.exports, "useCustomTheme", ()=>$c7d0ce2b092eade6$export$c0c5f5b297b77726);
    var $eUqFw = parcelRequire("eUqFw");
    var $iDwTy = parcelRequire("iDwTy");
    var $2glt4 = parcelRequire("2glt4");
    function $c7d0ce2b092eade6$export$c0c5f5b297b77726(theme) {
        const style = (0, $eUqFw.useMemo)(()=>{
            if (!(0, $iDwTy.fg)('platform_design_system_nav4_top_bar_theming')) return null;
            if (!theme) return null;
            return (0, $2glt4.getCustomThemeStyles)(theme);
        }, [
            theme
        ]);
        if (!style) return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }
});
parcelRegister("2glt4", function(module, exports) {
    $parcel$export(module.exports, "getCustomThemeStyles", ()=>$56f3e6226dae4b20$export$3986d75fe2da3239);
    var $jOo2r = parcelRequire("jOo2r");
    var $kWJMs = parcelRequire("kWJMs");
    var $5Qb3P = parcelRequire("5Qb3P");
    var $jZkDo = parcelRequire("jZkDo");
    const $56f3e6226dae4b20$var$buttonStyles = {
        light: {
            [(0, $kWJMs.themedButtonBackground)]: 'transparent',
            [(0, $kWJMs.themedButtonBackgroundHovered)]: '#0515240F',
            [(0, $kWJMs.themedButtonBackgroundPressed)]: '#0B120E24',
            [(0, $kWJMs.themedButtonBorder)]: '#0B120E24',
            [(0, $kWJMs.themedButtonSelectedText)]: '#1868DB',
            [(0, $kWJMs.themedButtonSelectedBackground)]: '#E9F2FE',
            [(0, $kWJMs.themedButtonSelectedBackgroundHovered)]: '#CFE1FD',
            [(0, $kWJMs.themedButtonSelectedBackgroundPressed)]: '#8FB8F6'
        },
        dark: {
            [(0, $kWJMs.themedButtonBackground)]: 'transparent',
            [(0, $kWJMs.themedButtonBackgroundHovered)]: '#CECED912',
            [(0, $kWJMs.themedButtonBackgroundPressed)]: '#E3E4F21F',
            [(0, $kWJMs.themedButtonBorder)]: '#E3E4F21F',
            [(0, $kWJMs.themedButtonSelectedText)]: '#669DF1',
            [(0, $kWJMs.themedButtonSelectedBackground)]: '#1C2B42',
            [(0, $kWJMs.themedButtonSelectedBackgroundHovered)]: '#123263',
            [(0, $kWJMs.themedButtonSelectedBackgroundPressed)]: '#1558BC'
        }
    };
    const $56f3e6226dae4b20$var$logoStyles = {
        light: {
            [(0, $jOo2r.themedLogoIcon)]: '#101214',
            [(0, $jOo2r.themedLogoText)]: '#101214'
        },
        dark: {
            [(0, $jOo2r.themedLogoIcon)]: '#FFFFFF',
            [(0, $jOo2r.themedLogoText)]: '#FFFFFF'
        }
    };
    function $56f3e6226dae4b20$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
        const isLightBackground = (0, $5Qb3P.isLight)(backgroundColor);
        const color = (0, $5Qb3P.getTextColor)(backgroundColor);
        const highlightTextColor = (0, $5Qb3P.getTextColor)(highlightColor);
        const highlightRgb = (0, $5Qb3P.hexToRGB)(highlightColor);
        const colorRgb = (0, $5Qb3P.hexToRGB)(color);
        return {
            backgroundColor: backgroundColor,
            color: color,
            ...$56f3e6226dae4b20$var$buttonStyles[isLightBackground ? 'light' : 'dark'],
            ...$56f3e6226dae4b20$var$logoStyles[isLightBackground ? 'light' : 'dark'],
            [(0, $kWJMs.themedButtonPrimaryBackground)]: highlightColor,
            [(0, $kWJMs.themedButtonPrimaryBackgroundHovered)]: (0, $5Qb3P.toRGBAString)(highlightRgb, 0.8),
            [(0, $kWJMs.themedButtonPrimaryBackgroundPressed)]: (0, $5Qb3P.toRGBAString)(highlightRgb, 0.65),
            [(0, $kWJMs.themedButtonPrimaryText)]: highlightTextColor,
            [(0, $jZkDo.themedSearchBorder)]: (0, $5Qb3P.toRGBAString)(colorRgb, 0.5),
            [(0, $jZkDo.themedSearchBorderFocused)]: (0, $5Qb3P.toRGBAString)(highlightRgb, 0.8)
        };
    }
});
parcelRegister("5Qb3P", function(module, exports) {
    $parcel$export(module.exports, "toRGBAString", ()=>$363524aa88ffa5f1$export$b597d7418f37d50a);
    $parcel$export(module.exports, "hexToRGB", ()=>$363524aa88ffa5f1$export$848d71df1f759bc);
    $parcel$export(module.exports, "isLight", ()=>$363524aa88ffa5f1$export$44af652f4cca9039);
    $parcel$export(module.exports, "getTextColor", ()=>$363524aa88ffa5f1$export$5357fe757c335c0d);
    const $363524aa88ffa5f1$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex);
    function $363524aa88ffa5f1$export$b597d7418f37d50a({ r: r, g: g, b: b }, alpha) {
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    function $363524aa88ffa5f1$export$848d71df1f759bc(hex) {
        if (!$363524aa88ffa5f1$var$isValidHex(hex)) throw new Error('Invalid HEX');
        let channels;
        if (hex.length === 4) channels = {
            r: hex[1].repeat(2),
            g: hex[2].repeat(2),
            b: hex[3].repeat(2)
        };
        else channels = {
            r: hex.slice(1, 3),
            g: hex.slice(3, 5),
            b: hex.slice(5, 7)
        };
        return {
            r: parseInt(channels.r, 16),
            g: parseInt(channels.g, 16),
            b: parseInt(channels.b, 16)
        };
    }
    function $363524aa88ffa5f1$var$linearizeRGBChannel(channel) {
        return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }
    function $363524aa88ffa5f1$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
        const normal = {
            r: r / 255,
            g: g / 255,
            b: b / 255
        };
        const linear = {
            r: $363524aa88ffa5f1$var$linearizeRGBChannel(normal.r),
            g: $363524aa88ffa5f1$var$linearizeRGBChannel(normal.g),
            b: $363524aa88ffa5f1$var$linearizeRGBChannel(normal.b)
        };
        const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
        return L;
    }
    function $363524aa88ffa5f1$export$d061e26956a60b0a(foreground, background) {
        if (!$363524aa88ffa5f1$var$isValidHex(foreground) || !$363524aa88ffa5f1$var$isValidHex(background)) throw new Error('Invalid HEX');
        const foregroundRgb = $363524aa88ffa5f1$export$848d71df1f759bc(foreground);
        const backgroundRgb = $363524aa88ffa5f1$export$848d71df1f759bc(background);
        const foregroundLuminance = $363524aa88ffa5f1$var$relativeLuminanceW3C(foregroundRgb);
        const backgroundLuminance = $363524aa88ffa5f1$var$relativeLuminanceW3C(backgroundRgb);
        const brightest = Math.max(foregroundLuminance, backgroundLuminance);
        const darkest = Math.min(foregroundLuminance, backgroundLuminance);
        return (brightest + 0.05) / (darkest + 0.05);
    }
    const $363524aa88ffa5f1$var$flipLuminance = 0.179129;
    function $363524aa88ffa5f1$export$44af652f4cca9039(color) {
        const rgb = $363524aa88ffa5f1$export$848d71df1f759bc(color);
        return $363524aa88ffa5f1$var$relativeLuminanceW3C(rgb) >= $363524aa88ffa5f1$var$flipLuminance;
    }
    function $363524aa88ffa5f1$export$5357fe757c335c0d(backgroundColor) {
        if ($363524aa88ffa5f1$export$44af652f4cca9039(backgroundColor)) return '#000';
        return '#FFF';
    }
});
parcelRegister("jZkDo", function(module, exports) {
    $parcel$export(module.exports, "themedSearchBorder", ()=>$eb17b71ed783a548$export$ae6fbf5ba3a7a784);
    $parcel$export(module.exports, "themedSearchBorderFocused", ()=>$eb17b71ed783a548$export$ee42b8430f4c19bd);
    var $kWJMs = parcelRequire("kWJMs");
    var $FSQzJ = parcelRequire("FSQzJ");
    const $eb17b71ed783a548$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
    const $eb17b71ed783a548$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused';
    const $eb17b71ed783a548$export$7931ecdcbff2536 = {
        default: {
            backgroundColor: 'transparent',
            color: 'currentColor',
            borderColor: `var(${$eb17b71ed783a548$export$ae6fbf5ba3a7a784})`
        },
        focus: {
            color: "var(--ds-text, #172B4D)",
            backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
            borderColor: `var(${$eb17b71ed783a548$export$ee42b8430f4c19bd})`,
            boxShadow: `inset 0px 0px 0px 1px var(${$eb17b71ed783a548$export$ee42b8430f4c19bd})`
        },
        hover: {
            backgroundColor: `var(${(0, $kWJMs.themedButtonBackgroundHovered)})`
        }
    };
    function $eb17b71ed783a548$export$18a29b1ed2212823() {
        const hasCustomTheme = (0, $FSQzJ.useHasCustomTheme)();
        if (hasCustomTheme) return $eb17b71ed783a548$export$7931ecdcbff2536;
        return undefined;
    }
});
parcelRegister("1NIhY", function(module, exports) {
    $parcel$export(module.exports, "navigationUiStateResource", ()=>$f81bf6691f07ea3e$export$14c178691841b423);
    var $5iWql = parcelRequire("5iWql");
    var $lB25E = parcelRequire("lB25E");
    var $jCGD5 = parcelRequire("jCGD5");
    const $f81bf6691f07ea3e$var$getNavigationUiStateMemoized = (0, $5iWql.default)((atlassianAccountId)=>(0, $jCGD5.getNavigationUiState)({
            tenantContext: {
                atlassianAccountId: atlassianAccountId
            }
        }));
    const $f81bf6691f07ea3e$export$14c178691841b423 = (0, $lB25E.createResource)({
        type: 'RESOURCE_TYPE_NAVIGATION_UI',
        getKey: ()=>'state',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId } })=>$f81bf6691f07ea3e$var$getNavigationUiStateMemoized(atlassianAccountId),
        maxAge: Infinity
    });
});
parcelRegister("jCGD5", function(module, exports) {
    $parcel$export(module.exports, "getNavigationUiState", ()=>$db77001cbd8f906b$export$29999268b070c9bd);
    var $48bs8 = parcelRequire("48bs8");
    var $lTttU = parcelRequire("lTttU");
    const $db77001cbd8f906b$export$29999268b070c9bd = async ({ tenantContext: tenantContext })=>{
        const { atlassianAccountId: accountId } = tenantContext;
        let uiState = await (0, $lTttU.queryLocalStorage)();
        if (uiState || !accountId) return uiState;
        try {
            uiState = await (0, $48bs8.getUserProperty)(accountId, (0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8));
            (0, $lTttU.updateLocalStorageData)(uiState);
        } catch (e) {}
        return uiState;
    };
});
const $75b7df28d47cff7a$export$3e8fc5ba7287b4a8 = 'navigation_next_ui_state';
const $75b7df28d47cff7a$export$c63f561360bafed1 = 'navigation-next.providers.ui-state-cache-provider';
parcelRegister("lTttU", function(module, exports) {
    $parcel$export(module.exports, "queryLocalStorage", ()=>$4239519c11764e08$export$e192dcb908272d5);
    $parcel$export(module.exports, "updateLocalStorageData", ()=>$4239519c11764e08$export$ec13c725e067146a);
    var $jG2Eu = parcelRequire("jG2Eu");
    var $gUUjF = parcelRequire("gUUjF");
    const $4239519c11764e08$export$e7db3fa51c63bc5c = ()=>{
        if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') return window.localStorage;
        return {
            setItem: (0, ($parcel$interopDefault($jG2Eu))),
            getItem: (0, ($parcel$interopDefault($jG2Eu)))
        };
    };
    const $4239519c11764e08$var$queryLocalStorageSync = ()=>{
        const localStorage = $4239519c11764e08$export$e7db3fa51c63bc5c();
        const item = localStorage.getItem((0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8));
        if (!false && item) try {
            return JSON.parse(item);
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $75b7df28d47cff7a$export$c63f561360bafed1), 'Fail to parse sync local storage data', e);
        }
    };
    const $4239519c11764e08$export$e192dcb908272d5 = ()=>new Promise((resolve)=>{
            const item = $4239519c11764e08$var$queryLocalStorageSync();
            resolve(item);
        });
    const $4239519c11764e08$export$ec13c725e067146a = (data)=>{
        const localStorage = $4239519c11764e08$export$e7db3fa51c63bc5c();
        localStorage.setItem((0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8), JSON.stringify(data));
    };
});
parcelRegister("dxcfv", function(module, exports) {
    $parcel$export(module.exports, "useAccountId", ()=>$45cd5aaa8359ff91$export$e72033e0f5baa3e);
    var $gd0Sp = parcelRequire("gd0Sp");
    const $45cd5aaa8359ff91$export$e72033e0f5baa3e = ()=>{
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        return tenantContext && tenantContext.atlassianAccountId || null;
    };
});
parcelRegister("kpmC0", function(module, exports) {
    $parcel$export(module.exports, "useLeftSidebarState", ()=>$57fa1b4d662f99dc$export$610d81e163a897b3);
    $parcel$export(module.exports, "useLeftSidebarController", ()=>$57fa1b4d662f99dc$export$900f29014a48fb23);
    var $eUqFw = parcelRequire("eUqFw");
    var $hwyJ1 = parcelRequire("hwyJ1");
    var $WBLbN = parcelRequire("WBLbN");
    var $53ucm = parcelRequire("53ucm");
    const $57fa1b4d662f99dc$var$useSweetStateLeftSidebarState = (0, $WBLbN.createHook)((0, $53ucm.layoutStore), {
        selector: (state)=>({
                ...state.content.leftSidebar,
                shouldRender: !state.isChromeless
            })
    });
    const $57fa1b4d662f99dc$export$610d81e163a897b3 = ()=>{
        const [leftSidebar] = $57fa1b4d662f99dc$var$useSweetStateLeftSidebarState();
        return leftSidebar;
    };
    const $57fa1b4d662f99dc$export$900f29014a48fb23 = ()=>{
        const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $hwyJ1.usePageLayoutResize)();
        return (0, $eUqFw.useMemo)(()=>({
                collapseLeftSidebar: collapseLeftSidebar,
                expandLeftSidebar: expandLeftSidebar
            }), [
            collapseLeftSidebar,
            expandLeftSidebar
        ]);
    };
});
parcelRegister("bUi2Q", function(module, exports) {
    $parcel$export(module.exports, "useActiveRightSidebarState", ()=>$09e77c9f3f7f26ec$export$ba763ab7661c3103);
    $parcel$export(module.exports, "useRightSidebarState", ()=>$09e77c9f3f7f26ec$export$d1828e7f46a4960b);
    $parcel$export(module.exports, "useRightSidebarController", ()=>$09e77c9f3f7f26ec$export$ebe5e907fb0bb63a);
    var $eUqFw = parcelRequire("eUqFw");
    var $WBLbN = parcelRequire("WBLbN");
    var $hqpfO = parcelRequire("hqpfO");
    var $53ucm = parcelRequire("53ucm");
    const $09e77c9f3f7f26ec$var$useActiveRightSidebar = (0, $WBLbN.createHook)((0, $53ucm.layoutStore), {
        selector: (state)=>{
            const rightSidebarState = (0, $hqpfO.selectCurrentRightSidebar)(state.content.rightSidebar);
            if (!rightSidebarState) return null;
            return {
                ...rightSidebarState,
                shouldRender: !state.isChromeless
            };
        }
    });
    const $09e77c9f3f7f26ec$export$ba763ab7661c3103 = ()=>{
        const [rightSidebar] = $09e77c9f3f7f26ec$var$useActiveRightSidebar();
        return rightSidebar;
    };
    const $09e77c9f3f7f26ec$var$useRightSidebar = (0, $WBLbN.createHook)((0, $53ucm.layoutStore), {
        selector: (state)=>state.content.rightSidebar
    });
    const $09e77c9f3f7f26ec$export$d1828e7f46a4960b = ()=>{
        const [rightSidebarState] = $09e77c9f3f7f26ec$var$useRightSidebar();
        return rightSidebarState;
    };
    const $09e77c9f3f7f26ec$export$ebe5e907fb0bb63a = ()=>{
        const [, { setRightSidebarState: setRightSidebarState, openRightSidebar: openRightSidebar, closeRightSidebar: closeRightSidebar, closeCurrentRightSidebar: closeCurrentRightSidebar, closeAllRightSidebar: closeAllRightSidebar, minimiseRightSidebar: minimiseRightSidebar }] = (0, $53ucm.useLayoutStoreActions)();
        return (0, $eUqFw.useMemo)(()=>({
                setRightSidebarState: setRightSidebarState,
                closeRightSidebar: closeRightSidebar,
                openRightSidebar: openRightSidebar,
                closeCurrentRightSidebar: closeCurrentRightSidebar,
                closeAllRightSidebar: closeAllRightSidebar,
                minimiseRightSidebar: minimiseRightSidebar
            }), [
            closeAllRightSidebar,
            closeCurrentRightSidebar,
            closeRightSidebar,
            openRightSidebar,
            setRightSidebarState,
            minimiseRightSidebar
        ]);
    };
});
parcelRegister("bXcr7", function(module, exports) {
    $parcel$export(module.exports, "setRemoteLayoutState", ()=>$5f4bcad3f92fef2e$export$ad53b565e6cd4261);
    var $48bs8 = parcelRequire("48bs8");
    var $guiFP = parcelRequire("guiFP");
    async function $5f4bcad3f92fef2e$export$ad53b565e6cd4261({ accountId: accountId, state: state }) {
        try {
            await (0, $48bs8.setUserProperties)(accountId, (0, $75b7df28d47cff7a$export$3e8fc5ba7287b4a8), JSON.stringify(state));
        } catch (e) {
            (0, $guiFP.default)({
                error: e,
                meta: {
                    id: 'updateServerLayoutState',
                    packageName: 'jiraLayoutController',
                    teamName: 'jfp-team'
                }
            });
        }
    }
});
parcelRegister("b00xW", function(module, exports) {
    $parcel$export(module.exports, "GlobalBottomRightCornerContainer", ()=>$50f1861a2ded8c40$export$715c8d5890c054bb);
    $parcel$export(module.exports, "GlobalBottomRightCornerContainerProvider", ()=>$50f1861a2ded8c40$export$1e86e3484191597c);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $5GxEP = parcelRequire("5GxEP");
    var $jK1pm = parcelRequire("jK1pm");
    var $71g00 = parcelRequire("71g00");
    var $bUi2Q = parcelRequire("bUi2Q");
    var $53ucm = parcelRequire("53ucm");
    function $50f1861a2ded8c40$export$e112b78171de7a6({ bottomOffset: bottomOffset, rightOffset: rightOffset }) {
        const [{ width: width }] = (0, $53ucm.useDetailPanelWidth)();
        const rightSidebar = (0, $bUi2Q.useActiveRightSidebarState)();
        const { registerBottomRightCornerContainer: registerBottomRightCornerContainer } = (0, $71g00.useBottomRightCornerActions)();
        const isSidebarOpen = rightSidebar && !rightSidebar.isCollapsed && !rightSidebar.isMinimised;
        const rightSidebarWidth = isSidebarOpen ? rightSidebar.width : 0;
        return (0, ($parcel$interopDefault($eUqFw))).createElement($50f1861a2ded8c40$var$StyledContainer, {
            ref: registerBottomRightCornerContainer,
            "data-testid": "layout-controller.ui.bottom-right-corner.container.styled-container",
            style: {
                right: `calc(${width + rightOffset + rightSidebarWidth}px + ${"var(--ds-space-300, 24px)"})`,
                bottom: `calc(${"var(--ds-space-300, 24px)"} + ${bottomOffset}px)`
            }
        });
    }
    const $50f1861a2ded8c40$export$715c8d5890c054bb = ({ bottomOffset: bottomOffset = 0, rightOffset: rightOffset = 0 })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
            id: "bottom-right-corner-container",
            packageName: "jira-bottom-right-corner-controller"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($50f1861a2ded8c40$export$e112b78171de7a6, {
            bottomOffset: bottomOffset,
            rightOffset: rightOffset
        }));
    const $50f1861a2ded8c40$export$1e86e3484191597c = ({ children: children })=>{
        const container = (0, $71g00.useBottomRightCornerContainer)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "global-bottom-right-corner"
        }, container && children, (0, ($parcel$interopDefault($eUqFw))).createElement($50f1861a2ded8c40$export$715c8d5890c054bb, null));
    };
    const $50f1861a2ded8c40$var$StyledContainer = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_kqsw1n9t _1e0c1txw _1pbyfjpv _1reoewfl _18m9ewfl _4cvresu3 _lcxvglyw",
                __cmplp.className
            ])
        });
    });
    $50f1861a2ded8c40$var$StyledContainer.displayName = 'StyledContainer';
});
parcelRegister("jK1pm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f6f009785aaee067$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $cm3xn = parcelRequire("cm3xn");
    var $iWLL0 = parcelRequire("iWLL0");
    var $zNBm2 = parcelRequire("zNBm2");
    var $cpY9k = parcelRequire("cpY9k");
    var $6WLCX = parcelRequire("6WLCX");
    function $f6f009785aaee067$var$JiraUFOSegmentWrapper({ children: children }) {
        const interactionContext = (0, $zNBm2.useInteractionContext)();
        const relayProfilerContext = (0, $eUqFw.useMemo)(()=>({
                getInteractionContext: ()=>interactionContext,
                wrapPrepareQueryResource (cb) {
                    return cb();
                },
                retainQuery (info) {
                    this.getInteractionContext().retainQuery(info);
                }
            }), [
            interactionContext
        ]);
        const reactLooselyLazyContext = (0, $eUqFw.useMemo)(()=>{
            const moduleLoadingRequests = {};
            return {
                current: {
                    getInteractionContext () {
                        return interactionContext;
                    },
                    onPreload (moduleId, _priority) {
                        this.getInteractionContext().addPreload((0, $cpY9k.extractModuleName)(moduleId), performance.now());
                    },
                    onLoadStart (info) {
                        const timeoutId = setTimeout(()=>{
                            delete moduleLoadingRequests[info.identifier];
                        }, 30000);
                        const request = {
                            start: performance.now(),
                            timeoutId: timeoutId
                        };
                        moduleLoadingRequests[info.identifier] = request;
                    },
                    onLoadComplete (info) {
                        const request = moduleLoadingRequests[info.identifier];
                        if (request) {
                            clearTimeout(request.timeoutId);
                            delete moduleLoadingRequests[info.identifier];
                            this.getInteractionContext()?.addLoad((0, $cpY9k.extractModuleName)(info.identifier), request.start, performance.now());
                        }
                    },
                    placeholderFallBackMounted (id, name, lazyWait) {
                        if (lazyWait) return;
                        this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                    },
                    placeholderFallBackUnmounted (id, name, lazyWait) {
                        if (lazyWait) return;
                        this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                    }
                }
            };
        }, [
            interactionContext
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.ProfilerContext).Provider, {
            value: relayProfilerContext
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cm3xn.ProfilerContext).Provider, {
            value: reactLooselyLazyContext
        }, children));
    }
    function $f6f009785aaee067$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6WLCX.default), {
            name: segmentName
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($f6f009785aaee067$var$JiraUFOSegmentWrapper, null, children));
    }
});
parcelRegister("71g00", function(module, exports) {
    $parcel$export(module.exports, "useBottomRightCornerContainer", ()=>$6c4868bbefcbb619$export$84542488b6b6c309);
    $parcel$export(module.exports, "useBottomRightCornerActions", ()=>$6c4868bbefcbb619$export$de496fd0e0151c81);
    var $WBLbN = parcelRequire("WBLbN");
    var $53ucm = parcelRequire("53ucm");
    const $6c4868bbefcbb619$export$84542488b6b6c309 = (0, $WBLbN.createStateHook)((0, $53ucm.layoutStore), {
        selector: (state)=>state.bottomRightCorner.container
    });
    const $6c4868bbefcbb619$export$de496fd0e0151c81 = (0, $WBLbN.createActionsHook)((0, $53ucm.layoutStore));
});
const $7688150c048b38d1$export$c9e16a15d65437 = 'navigationNext';
const $7688150c048b38d1$export$b1534bc11f201efd = 'jiraPageContainer';
const $7688150c048b38d1$export$fa4bbc89fd1f1a7 = null;
const $7688150c048b38d1$export$aa6008fe0169b864 = null;
const $7688150c048b38d1$export$39418a21fbb51487 = null;
const $7688150c048b38d1$export$7dfef0177e883b05 = 'entry.jira-spa';
const $7688150c048b38d1$var$PAGE_CONTAINER_MARK = 'jira-spa/spa-shell/page-container';
const $7688150c048b38d1$export$7114284ca03133ee = `_${$7688150c048b38d1$var$PAGE_CONTAINER_MARK}.end`;
const $7688150c048b38d1$export$21473105c510aacc = 'jira-spa/spa-shell/page-layout';
const $7688150c048b38d1$export$898b6208220685b0 = 'jira-spa/spa-shell/global-containers';
const $7688150c048b38d1$export$e2bc63118050de32 = `_${$7688150c048b38d1$export$898b6208220685b0}.start`;
const $7688150c048b38d1$export$59f83d43fe209319 = `_${$7688150c048b38d1$export$898b6208220685b0}.end`;
const $7688150c048b38d1$export$fb9876ab4228d985 = 'jira-spa/spa-shell/global-components';
const $7688150c048b38d1$export$c20831be6f780cb5 = `_${$7688150c048b38d1$export$fb9876ab4228d985}.start`;
const $7688150c048b38d1$export$398df1bca49f9884 = `_${$7688150c048b38d1$export$fb9876ab4228d985}.end`;
const $7688150c048b38d1$export$7048c99f32c60b34 = 'jira-spa/spa-shell/global-containers/app-base';
const $7688150c048b38d1$export$3c2d8af5c7577fe7 = `_${$7688150c048b38d1$export$7048c99f32c60b34}.start`;
const $7688150c048b38d1$export$aac77afee74c49d0 = `_${$7688150c048b38d1$export$7048c99f32c60b34}.end`;
const $7688150c048b38d1$export$4f341d86a3c214 = 'jira-spa/spa-shell/global-containers/router';
const $7688150c048b38d1$export$16e7ead3a8b5c366 = `_${$7688150c048b38d1$export$4f341d86a3c214}.start`;
const $7688150c048b38d1$export$c389f0b50840d5ca = `_${$7688150c048b38d1$export$4f341d86a3c214}.end`;
parcelRegister("14yu2", function(module, exports) {
    $parcel$export(module.exports, "useBannerJsmPackagingUpdates", ()=>$24b811f575c11f96$export$a0dde3f151a99607);
    var $eUqFw = parcelRequire("eUqFw");
    var $7ZZxN = parcelRequire("7ZZxN");
    var $eI5EY = parcelRequire("eI5EY");
    var $10fdS = parcelRequire("10fdS");
    var $bNe1g = parcelRequire("bNe1g");
    var $5inNC = parcelRequire("5inNC");
    var $dxcfv = parcelRequire("dxcfv");
    var $b9kib = parcelRequire("b9kib");
    const $24b811f575c11f96$export$a0dde3f151a99607 = ()=>{
        const currentRoute = (0, $10fdS.useCurrentRoute)();
        const { data: project } = (0, $bNe1g.useProjectContext)();
        const accountId = (0, $dxcfv.useAccountId)();
        const isServiceProject = project?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT);
        const isInJsmBoundary = (0, $eUqFw.useMemo)(()=>(0, $b9kib.isInJsmGlobalSettingsBoundary)(currentRoute.path) || isServiceProject, [
            isServiceProject,
            currentRoute.path
        ]);
        const { shouldShow: shouldShow, dismissAnnouncement: dismissAnnouncement } = (0, $5inNC.useJsmRepackagingAnnouncementResource)(accountId);
        return (0, $eUqFw.useMemo)(()=>({
                isEnabled: isInJsmBoundary && shouldShow && (0, $eI5EY.fg)('jsm-packaging-pricing-changes-announcement'),
                dismissAnnouncement: dismissAnnouncement
            }), [
            dismissAnnouncement,
            isInJsmBoundary,
            shouldShow
        ]);
    };
});
parcelRegister("5inNC", function(module, exports) {
    $parcel$export(module.exports, "useJsmRepackagingAnnouncementResource", ()=>$f4ffcbbf83240e43$export$47d5fef12f2d184b);
    var $eUqFw = parcelRequire("eUqFw");
    var $48bs8 = parcelRequire("48bs8");
    var $guiFP = parcelRequire("guiFP");
    var $lB25E = parcelRequire("lB25E");
    var $abI4C = parcelRequire("abI4C");
    const $f4ffcbbf83240e43$var$getDataLoader = ()=>(parcelRequire("1y5AI"));
    const $f4ffcbbf83240e43$export$750cb6ed3dfc6a3 = (0, $lB25E.createResource)({
        type: 'JSM_REPACKAGING_ANNOUNCEMENT',
        getKey: ()=>'JSM_REPACKAGING_ANNOUNCEMENT',
        getDataLoader: $f4ffcbbf83240e43$var$getDataLoader,
        maxAge: Infinity
    });
    const $f4ffcbbf83240e43$export$47d5fef12f2d184b = (accountId)=>{
        const { data: data, loading: loading, error: error, refresh: refresh, update: update } = (0, $lB25E.useResource)($f4ffcbbf83240e43$export$750cb6ed3dfc6a3);
        const loadingRef = (0, $eUqFw.useRef)(false);
        const errorRef = (0, $eUqFw.useRef)();
        const [userPropertiesError, setUserPropertiesError] = (0, $eUqFw.useState)();
        errorRef.current = userPropertiesError || error;
        const dismissAnnouncement = (0, $eUqFw.useCallback)(()=>{
            const announcementDismissState = {
                shouldShow: false
            };
            update(()=>({
                    announcementDismissState: announcementDismissState
                }));
            if (accountId) {
                if (loadingRef.current) {
                    const err = new Error('User properties is loading');
                    (0, $guiFP.default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                            teamName: '50cent'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setUserPropertiesError(err);
                    return Promise.reject(err);
                }
                loadingRef.current = true;
                return (0, $48bs8.setUserProperties)(accountId, (0, $abI4C.JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY), JSON.stringify(announcementDismissState)).catch((err)=>{
                    setUserPropertiesError(new Error('Error occured while setting user properties'));
                    (0, $guiFP.default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraRouterResourcesJsmRepackagingAnnouncement',
                            teamName: '50cent'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }).finally(()=>{
                    loadingRef.current = false;
                });
            }
        }, [
            accountId,
            update
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            refresh,
            error
        ]);
        return (0, $eUqFw.useMemo)(()=>{
            if (errorRef.current || loading || !data || !accountId) return {
                shouldShow: false,
                dismissAnnouncement: dismissAnnouncement
            };
            const { announcementDismissState: announcementDismissState } = data;
            if (!announcementDismissState) return {
                shouldShow: false,
                dismissAnnouncement: dismissAnnouncement
            };
            return {
                ...announcementDismissState,
                dismissAnnouncement: dismissAnnouncement
            };
        }, [
            loading,
            data,
            accountId,
            dismissAnnouncement
        ]);
    };
});
parcelRegister("abI4C", function(module, exports) {
    $parcel$export(module.exports, "JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE_STORAGE_KEY", ()=>$bdc5420685a01953$export$d2137827dc00e559);
    $parcel$export(module.exports, "DEFAULT_JSM_REPACKAGING_ANNOUNCEMENT_USER_STATE", ()=>$bdc5420685a01953$export$341176bfdf8c92);
    const $bdc5420685a01953$export$d2137827dc00e559 = 'jsm-repackaging-announcement-dismiss-state';
    const $bdc5420685a01953$export$341176bfdf8c92 = {
        shouldShow: true
    };
});
parcelRegister("1y5AI", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("8r39u").then(()=>parcelRequire('2Tdce'));
});
parcelRegister("b9kib", function(module, exports) {
    $parcel$export(module.exports, "isInJsmGlobalSettingsBoundary", ()=>$d62f0498bfab13c2$export$c28a66ae6d31a34b);
    const $d62f0498bfab13c2$var$jsmGlobalSettingsPages = [
        '/jira/settings/products/jira-service-management-configuration',
        '/jira/settings/products/jira-service-management-email-requests',
        '/jira/settings/products/servicedesk/customer-access',
        '/jira/settings/products/servicedesk/authentication',
        '/jira/settings/products/servicedesk/organizations',
        '/jira/settings/products/jira-service-management-incident-management-tools',
        '/jira/settings/products/jira-service-management-compliance',
        '/jira/settings/products/servicedesk/feature-usage'
    ];
    const $d62f0498bfab13c2$var$eocGlobalSettingsPages = [
        '/jira/settings/products/ops/roles',
        '/jira/settings/products/ops/role-assignment',
        '/jira/settings/products/ops/role-based-notifications',
        '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
        '/jira/settings/products/ops/integrations',
        '/jira/settings/products/ops/syncs',
        '/jira/settings/products/ops/policies',
        '/jira/settings/products/ops/maintenance',
        '/jira/settings/products/ops/incoming-call',
        '/jira/settings/products/ops/jira-service-management-audit-logs',
        '/jira/settings/products/ops/reports'
    ];
    const $d62f0498bfab13c2$var$isJsmGlobalSettingsPage = (route)=>$d62f0498bfab13c2$var$jsmGlobalSettingsPages.includes(route);
    const $d62f0498bfab13c2$var$isEocGlobalSettingsPage = (route)=>$d62f0498bfab13c2$var$eocGlobalSettingsPages.includes(route);
    const $d62f0498bfab13c2$export$c28a66ae6d31a34b = (route)=>$d62f0498bfab13c2$var$isJsmGlobalSettingsPage(route) || $d62f0498bfab13c2$var$isEocGlobalSettingsPage(route);
});
parcelRegister("egmX2", function(module, exports) {
    $parcel$export(module.exports, "BannerJsmPackagingUpdateAsync", ()=>$65963d75ada08912$export$76c6ab35aee49900);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $gGtKh = parcelRequire("gGtKh");
    const $65963d75ada08912$var$BannerTransition = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("DNKPr")).then((module)=>module.BannerJsmPackagingUpdate), {
        moduleId: "./src/packages/platform/ui/banners/jsm-packaging-updates/src/ui/banner/index.tsx"
    });
    const $65963d75ada08912$export$76c6ab35aee49900 = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "async-banner-jsm-packaging-updates",
            fallback: null
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($65963d75ada08912$var$BannerTransition, null));
});
parcelRegister("DNKPr", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("9f9jz").then(()=>parcelRequire('e5bbJ'));
});
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("bQiKj", function(module, exports) {
    $parcel$export(module.exports, "sharedLayout", ()=>$9081c29c094d647d$export$5f4dc7c98070d93e);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $2WOJv = parcelRequire("2WOJv");
    var $7ZZxN = parcelRequire("7ZZxN");
    var $gMtJP = parcelRequire("gMtJP");
    var $d3Jbb = parcelRequire("d3Jbb");
    var $69KNw = parcelRequire("69KNw");
    var $2RiaW = parcelRequire("2RiaW");
    var $1ZDON = parcelRequire("1ZDON");
    var $1HzcR = parcelRequire("1HzcR");
    var $6j4bv = parcelRequire("6j4bv");
    var $6xYPC = parcelRequire("6xYPC");
    var $79xbN = parcelRequire("79xbN");
    var $1ybV0 = parcelRequire("1ybV0");
    var $9zysr = parcelRequire("9zysr");
    var $dnJL9 = parcelRequire("dnJL9");
    var $eI5EY = parcelRequire("eI5EY");
    var $j6ken = parcelRequire("j6ken");
    var $jxIns = parcelRequire("jxIns");
    var $eGjiP = parcelRequire("eGjiP");
    var $d8a4z = parcelRequire("d8a4z");
    var $3eqbP = parcelRequire("3eqbP");
    var $gbSuS = parcelRequire("gbSuS");
    var $cPEpP = parcelRequire("cPEpP");
    var $i9XZP = parcelRequire("i9XZP");
    var $2m6cd = parcelRequire("2m6cd");
    var $hEyt5 = parcelRequire("hEyt5");
    var $iOtr0 = parcelRequire("iOtr0");
    var $i0pNS = parcelRequire("i0pNS");
    var $isbb2 = parcelRequire("isbb2");
    var $5EZtQ = parcelRequire("5EZtQ");
    var $cADdB = parcelRequire("cADdB");
    var $dWLk9 = parcelRequire("dWLk9");
    var $lFrSS = parcelRequire("lFrSS");
    var $cLxEl = parcelRequire("cLxEl");
    var $BRKX9 = parcelRequire("BRKX9");
    var $1OfKM = parcelRequire("1OfKM");
    var $6Q9xY = parcelRequire("6Q9xY");
    var $egQj9 = parcelRequire("egQj9");
    const $9081c29c094d647d$var$isTrialEndLockScreenExperimentEnabled = ()=>(0, $1ybV0.ff)('jsm-trial-end-lock-screen-experiment_nowmr') || (0, $1ybV0.ff)('jpd-trial-end-lock-screen-experiment');
    const $9081c29c094d647d$var$isPendoIntegrationEnabled = ()=>(0, $1ybV0.ff)('jira-frontend-pendo-analytics_s6sj5');
    const $9081c29c094d647d$var$Global = (0, $56koX.lazy)(()=>(parcelRequire("1YvhU")), {
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/global/index.tsx"
    });
    const $9081c29c094d647d$var$Navigation = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("9desP")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/navigation/index.tsx"
    });
    const $9081c29c094d647d$var$Trackers = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("bWhFx")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/trackers/index.tsx"
    });
    const $9081c29c094d647d$var$RemoteActions = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("V8FqF")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/remote-actions/index.tsx"
    });
    const $9081c29c094d647d$var$LazyNonCriticalDesShareLinkFlag = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("lJUyT")).then(({ NonCriticalDesShareLinkFlag: NonCriticalDesShareLinkFlag })=>NonCriticalDesShareLinkFlag), {
        ssr: false,
        moduleId: "./src/packages/growth/des-share-link/src/ui/index.tsx"
    });
    const $9081c29c094d647d$var$AfterPaintIssuePreEval = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("gvsYN")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/after-paint-issue-preeval/index.tsx"
    });
    const $9081c29c094d647d$var$AsyncBrowserStorageControlsInit = (0, $56koX.lazy)(()=>(parcelRequire("z8DAf")).then(({ BrowserStorageControlsInit: BrowserStorageControlsInit })=>BrowserStorageControlsInit), {
        moduleId: "./src/packages/platform/ui/layouts/jira-shared-layout/src/ui/browser-storage-controls-init/index.tsx"
    });
    const $9081c29c094d647d$var$runtimeProps = {};
    const $9081c29c094d647d$var$entryPointParams = {};
    const $9081c29c094d647d$export$70b554b486395223 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $cLxEl.upgradeOnboardingExperimentEntryPoint), $9081c29c094d647d$var$entryPointParams);
        (0, $eUqFw.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            id: "growth.upgradeOnboardingExperiment",
            packageName: "issue-view",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $9081c29c094d647d$var$runtimeProps
        });
    };
    const $9081c29c094d647d$export$3859d35c5447350b = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $5EZtQ.rovoVideoModalEntryPoint), $9081c29c094d647d$var$entryPointParams);
        (0, $eUqFw.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            id: "growth.rovoVideoPlayer",
            packageName: "rovo-video-modal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $9081c29c094d647d$var$runtimeProps
        });
    };
    const $9081c29c094d647d$export$3211958f96133af8 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $gbSuS.jiraLossAversionModalEntryPoint), $9081c29c094d647d$var$entryPointParams);
        (0, $eUqFw.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            id: "growth.jiraLossAversion",
            packageName: "jira-loss-aversion-modal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $9081c29c094d647d$var$runtimeProps
        });
    };
    const $9081c29c094d647d$export$bb0d8fff645668ce = ()=>{
        const cloudID = (0, $dWLk9.useCloudId)();
        const { data: project } = (0, $cPEpP.useProject)();
        const projectType = (0, $7ZZxN.toProjectType)(project?.type) || null;
        const productKey = (0, $7ZZxN.projectTypeToCanonicalId)(projectType);
        const deferEditionModalEntryPointParams = (0, $eUqFw.useMemo)(()=>({
                cloudId: cloudID,
                productKey: productKey
            }), [
            cloudID,
            productKey
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $2RiaW.jiraDeferEditionModalEntryPoint), deferEditionModalEntryPointParams);
        const onComplete = (0, $eUqFw.useCallback)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $69KNw.AsyncDeferEditionEPCheckWrapper), {
            onComplete: onComplete
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
            id: "growth.jiraDeferEditionModal",
            packageName: "jira-defer-edition-modal",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: null,
            runtimeProps: $9081c29c094d647d$var$runtimeProps
        }));
    };
    const $9081c29c094d647d$var$DeferEditionModal = (0, $dnJL9.componentWithFG)('cross-flow-defer-edition-communication-gate', $9081c29c094d647d$export$bb0d8fff645668ce, ()=>null);
    const $9081c29c094d647d$var$DeferRovoVideoModal = (0, $dnJL9.componentWithFG)('rovo_video_player_gate', $9081c29c094d647d$export$3859d35c5447350b, ()=>null);
    const $9081c29c094d647d$var$DeferJiraLossAversionModal = (0, $dnJL9.componentWithFG)('jira_loss_aversion_standard_shared_layout_gate', $9081c29c094d647d$export$3211958f96133af8, ()=>null);
    const $9081c29c094d647d$var$DesShareLinkFlag = (0, $dnJL9.componentWithFG)('jira_des_share_link_gate', $9081c29c094d647d$var$LazyNonCriticalDesShareLinkFlag, ()=>null);
    const $9081c29c094d647d$var$AsyncRecommendPremiumToStandardModal = (0, $dnJL9.componentWithFG)('recommend_standard_in_jira_eot_shared_layout_', (0, $i0pNS.AsyncRecommendPremiumToStandardModalWrapper), ()=>null);
    $9081c29c094d647d$var$DeferEditionModal.displayName = 'DeferEditionModal';
    $9081c29c094d647d$var$DeferRovoVideoModal.displayName = 'DeferRovoVideoModal';
    $9081c29c094d647d$var$DeferJiraLossAversionModal.displayName = 'DeferJiraLossAversionModal';
    $9081c29c094d647d$var$DesShareLinkFlag.displayName = 'DesShareLinkFlag';
    $9081c29c094d647d$var$AsyncRecommendPremiumToStandardModal.displayName = 'AsyncRecommendPremiumToStandardModal';
    const $9081c29c094d647d$var$sharedGlobalComponents = [
        ...false ? [] : [
            (0, $2m6cd.MatchedRouteListener),
            (0, $hEyt5.PreviousRouterStateListener),
            (0, $6Q9xY.LoadingPhaseManager),
            (0, $j6ken.LoadingBarUIController),
            (0, $2WOJv.default),
            (0, $1OfKM.BreadcrumbAdapter),
            (0, $iOtr0.default),
            (0, $i9XZP.PageDwellAnalyticsListener),
            (0, $d8a4z.ImperativeAPI),
            (0, $egQj9.TrackClicksBeforeTTI),
            (0, $cADdB.default),
            (0, $lFrSS.AsyncUpflowIframeComponent),
            (0, $BRKX9.JiraHeritageLoader),
            $9081c29c094d647d$var$AsyncBrowserStorageControlsInit,
            ...$9081c29c094d647d$var$isPendoIntegrationEnabled() ? [
                (0, $gMtJP.AsyncPendoAnalyticsWrapper)
            ] : [],
            (0, $6xYPC.default),
            $9081c29c094d647d$var$RemoteActions,
            ...$9081c29c094d647d$var$isTrialEndLockScreenExperimentEnabled() ? [
                (0, $3eqbP.AsyncLockScreenExperimentSharedWrapper)
            ] : [],
            (0, $9zysr.componentWithCondition)(()=>(0, $eI5EY.fg)('jira_upgrade_onboarding'), $9081c29c094d647d$export$70b554b486395223, ()=>null),
            $9081c29c094d647d$var$DeferEditionModal,
            $9081c29c094d647d$var$DeferRovoVideoModal,
            $9081c29c094d647d$var$DeferJiraLossAversionModal,
            (0, $1ZDON.AsyncEndOfTrialMessageSharedWrapper),
            $9081c29c094d647d$var$DesShareLinkFlag,
            $9081c29c094d647d$var$AsyncRecommendPremiumToStandardModal
        ],
        $9081c29c094d647d$var$Global,
        $9081c29c094d647d$var$Navigation,
        $9081c29c094d647d$var$Trackers,
        $9081c29c094d647d$var$AfterPaintIssuePreEval
    ];
    const $9081c29c094d647d$var$SafeEmbeddedConfluencePanelWithExperiments = ()=>{
        const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
        return expConfig.get('cohort', 'not-enrolled') === 'experiment' ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eGjiP.SafeEmbeddedConfluencePanel), null) : null;
    };
    const $9081c29c094d647d$export$5f4dc7c98070d93e = (0, $isbb2.createLayout)({
        rightSidebars: [
            (0, $jxIns.SafeHelpPanel),
            (0, $d3Jbb.SafeConversationAssistantPanel),
            $9081c29c094d647d$var$SafeEmbeddedConfluencePanelWithExperiments
        ],
        globalComponents: $9081c29c094d647d$var$sharedGlobalComponents
    });
});
parcelRegister("2WOJv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f61d7eac9e8a3283$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $dxcfv = parcelRequire("dxcfv");
    var $48k9t = parcelRequire("48k9t");
    const $f61d7eac9e8a3283$var$CacheRegistry = ()=>{
        const accountIdLoggedInUser = (0, $dxcfv.useAccountId)();
        (0, $eUqFw.useEffect)(()=>{
            (0, $48k9t.default).set(accountIdLoggedInUser ?? 'anonymous');
        }, [
            accountIdLoggedInUser
        ]);
        return null;
    };
    var $f61d7eac9e8a3283$export$2e2bcd8739ae039 = $f61d7eac9e8a3283$var$CacheRegistry;
});
parcelRegister("48k9t", function(module, exports) {
    $parcel$export(module.exports, "CACHE_PREFIX", ()=>$619b603377692131$export$69ca515e4489d790);
    $parcel$export(module.exports, "scopeGuard", ()=>$619b603377692131$export$653cd03438bb0386);
    $parcel$export(module.exports, "default", ()=>$619b603377692131$export$2e2bcd8739ae039);
    var $aZaPn = parcelRequire("aZaPn");
    let $619b603377692131$var$resolveCachePromise;
    const $619b603377692131$var$cachePromise = new Promise((resolve)=>{
        $619b603377692131$var$resolveCachePromise = resolve;
    });
    const $619b603377692131$export$27be962d708928a = '__scope_key__';
    const $619b603377692131$export$69ca515e4489d790 = 'cache_prefix';
    const $619b603377692131$var$TIMEOUT = 10000;
    const $619b603377692131$var$promiseWithMaxExecutionTime = (ms, promise)=>{
        let id;
        const timeout = new Promise((resolve, reject)=>{
            id = setTimeout(()=>{
                const storage = (0, $aZaPn.createLocalStorageProvider)($619b603377692131$export$69ca515e4489d790);
                storage.clearAll();
                reject(new Error(`Cache scope was not set within ${$619b603377692131$var$TIMEOUT}ms`));
            }, ms);
        });
        return Promise.race([
            promise,
            timeout
        ]).then((result)=>{
            clearTimeout(id);
            return result;
        });
    };
    const $619b603377692131$export$653cd03438bb0386 = ()=>$619b603377692131$var$promiseWithMaxExecutionTime($619b603377692131$var$TIMEOUT, $619b603377692131$var$cachePromise);
    const $619b603377692131$var$config = {
        devTools: false,
        scopes: {
            prev: null,
            current: null
        },
        set (scopeKey) {
            const storage = (0, $aZaPn.createLocalStorageProvider)($619b603377692131$export$69ca515e4489d790);
            const scopeKeyInStorage = storage.get($619b603377692131$export$27be962d708928a);
            if (this.scopes.prev === null && this.scopes.current === null) {
                if (scopeKeyInStorage) {
                    this.scopes.prev = scopeKeyInStorage;
                    this.scopes.current = scopeKeyInStorage;
                }
            }
            if (this.scopes.current !== scopeKey) {
                if (this.scopes.current !== null) storage.clearAll();
                this.scopes.prev = this.scopes.current;
                this.scopes.current = scopeKey;
                storage.set($619b603377692131$export$27be962d708928a, scopeKey);
            }
            $619b603377692131$var$resolveCachePromise();
        },
        get () {
            return this.scopes.current;
        }
    };
    var $619b603377692131$export$2e2bcd8739ae039 = $619b603377692131$var$config;
});
parcelRegister("aZaPn", function(module, exports) {
    $parcel$export(module.exports, "createLocalStorageProvider", ()=>$e83d7abe46867842$export$697e65b1658f821b);
    $parcel$export(module.exports, "createLocalExpirableStorageProvider", ()=>$e83d7abe46867842$export$59acef2b3ab1df90);
    var $jqvCZ = parcelRequire("jqvCZ");
    var $avHyR = parcelRequire("avHyR");
    var $kkXA4 = parcelRequire("kkXA4");
    const $e83d7abe46867842$export$697e65b1658f821b = (0, ($parcel$interopDefault($jqvCZ)))((appPrefix)=>(0, $avHyR.createStorageProvider)(appPrefix, (0, $kkXA4.makeLocalStore)()));
    const $e83d7abe46867842$export$59acef2b3ab1df90 = (0, ($parcel$interopDefault($jqvCZ)))((appPrefix)=>{
        if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
        const store = (0, $kkXA4.makeLocalExpirableStore)();
        return store.namespace(appPrefix);
    });
});
parcelRegister("avHyR", function(module, exports) {
    $parcel$export(module.exports, "plugins", ()=>$e7af9f5944d51b15$export$8b3ca321c77fdea6);
    $parcel$export(module.exports, "createStorageProvider", ()=>$e7af9f5944d51b15$export$8441605555fbd60c);
    var $2y3XF = parcelRequire("2y3XF");
    var $4b9NC = parcelRequire("4b9NC");
    const $e7af9f5944d51b15$export$8b3ca321c77fdea6 = [
        (0, ($parcel$interopDefault($2y3XF))),
        (0, $4b9NC.default)
    ];
    const $e7af9f5944d51b15$export$8441605555fbd60c = (appPrefix, store)=>store.namespace(appPrefix);
});
parcelRegister("4b9NC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19af1635632d325b$export$2e2bcd8739ae039);
    var $guiFP = parcelRequire("guiFP");
    var $gjqa4 = parcelRequire("gjqa4");
    function $19af1635632d325b$var$cleanUpPlugin() {
        const self = this;
        const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, $gjqa4.NAMESPACE));
        function set(superFn, key, val) {
            try {
                if (!self.hasNamespace((0, $gjqa4.NAMESPACE))) timestamps.set(key, Date.now());
                superFn();
            } catch (e) {
                if (e.code === (0, $gjqa4.LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, $gjqa4.LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                    (0, $guiFP.default)({
                        meta: {
                            id: 'browserLocalStorageFullError',
                            packageName: 'jiraBrowserStorageProviders',
                            teamName: 'magma'
                        },
                        attributes: {
                            namespace: self._namespacePrefix
                        },
                        error: e,
                        skipSentry: true
                    });
                    if (self.cleanWhenFull()) self.set(superFn, key, val);
                } else {
                    (0, $guiFP.default)({
                        meta: {
                            id: 'storageCleanupPluginError',
                            packageName: 'jiraBrowserStorageProviders',
                            teamName: 'magma'
                        },
                        attributes: {
                            isLegacyFunction: false
                        },
                        error: e
                    });
                    throw e;
                }
            }
        }
        function remove(superFn, key) {
            if (!self.hasNamespace((0, $gjqa4.NAMESPACE))) timestamps.remove(key);
            return superFn();
        }
        function getTotalCount() {
            let count = 0;
            self.each(()=>{
                count += 1;
            });
            return count;
        }
        function cleanWhenFull(superFn, minAge = (0, $gjqa4.FOUR_WEEKS)) {
            const currTime = Date.now();
            const numKeysBefore = self.getTotalCount();
            self.each((_value, key)=>{
                const created = !self.hasNamespace((0, $gjqa4.NAMESPACE)) ? timestamps.get(key) : null;
                if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
            });
            const itemsRemovedCount = numKeysBefore - self.getTotalCount();
            if (!itemsRemovedCount && minAge - (0, $gjqa4.ONE_WEEK) >= (0, $gjqa4.ONE_WEEK)) return self.cleanWhenFull(minAge - (0, $gjqa4.ONE_WEEK));
            return itemsRemovedCount === 0;
        }
        return {
            set: set,
            remove: remove,
            cleanWhenFull: cleanWhenFull,
            getTotalCount: getTotalCount
        };
    }
    var $19af1635632d325b$export$2e2bcd8739ae039 = $19af1635632d325b$var$cleanUpPlugin;
});
parcelRegister("gjqa4", function(module, exports) {
    $parcel$export(module.exports, "NAMESPACE", ()=>$cf4854539b53d7dc$export$6aad947bda0f3f46);
    $parcel$export(module.exports, "ONE_WEEK", ()=>$cf4854539b53d7dc$export$8187f416f1cc43d8);
    $parcel$export(module.exports, "FOUR_WEEKS", ()=>$cf4854539b53d7dc$export$6e952fa7d47190cf);
    $parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", ()=>$cf4854539b53d7dc$export$da99ebca8f453abd);
    $parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", ()=>$cf4854539b53d7dc$export$ea28dfd9333cda2d);
    const $cf4854539b53d7dc$export$6aad947bda0f3f46 = 'timestamps';
    const $cf4854539b53d7dc$export$8187f416f1cc43d8 = 604800000;
    const $cf4854539b53d7dc$export$6e952fa7d47190cf = 4 * $cf4854539b53d7dc$export$8187f416f1cc43d8;
    const $cf4854539b53d7dc$export$da99ebca8f453abd = 22;
    const $cf4854539b53d7dc$export$ea28dfd9333cda2d = 1014;
});
parcelRegister("kkXA4", function(module, exports) {
    $parcel$export(module.exports, "makeLocalStore", ()=>$b4e518dc83f214e8$export$b2631085fe8db7af);
    $parcel$export(module.exports, "makeLocalExpirableStore", ()=>$b4e518dc83f214e8$export$cf816b43e73de947);
    var $2y3XF = parcelRequire("2y3XF");
    var $gleLd = parcelRequire("gleLd");
    var $ZGlKn = parcelRequire("ZGlKn");
    var $5rWiD = parcelRequire("5rWiD");
    var $gpWeB = parcelRequire("gpWeB");
    var $avHyR = parcelRequire("avHyR");
    const $b4e518dc83f214e8$export$b2631085fe8db7af = ()=>(0, ($parcel$interopDefault($ZGlKn))).createStore([
            (0, ($parcel$interopDefault($5rWiD))),
            (0, ($parcel$interopDefault($gpWeB)))
        ], (0, $avHyR.plugins));
    const $b4e518dc83f214e8$export$cf816b43e73de947 = ()=>(0, ($parcel$interopDefault($ZGlKn))).createStore([
            (0, ($parcel$interopDefault($5rWiD))),
            (0, ($parcel$interopDefault($gpWeB)))
        ], [
            (0, ($parcel$interopDefault($2y3XF))),
            (0, ($parcel$interopDefault($gleLd)))
        ]);
});
parcelRegister("gMtJP", function(module, exports) {
    $parcel$export(module.exports, "AsyncPendoAnalyticsWrapper", ()=>$b64a74411af401d0$export$1c388e7c464f3699);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $5GxEP = parcelRequire("5GxEP");
    var $aR8n6 = parcelRequire("aR8n6");
    const $b64a74411af401d0$var$AsyncPendoAnalytics = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("axSeT")).then(({ PendoAnalytics: PendoAnalytics })=>PendoAnalytics), {
        moduleId: "./src/packages/platform/services/pendo-analytics/src/index.tsx"
    });
    const $b64a74411af401d0$export$1c388e7c464f3699 = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
            id: "jiraCommonPendoAnalyticsReportErrors",
            packageName: "jiraCommonPendoAnalytics"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
            teamName: "martech",
            id: "jiraCommonPendoAnalyticsReportErrors",
            packageName: "jiraCommonPendoAnalytics"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($b64a74411af401d0$var$AsyncPendoAnalytics, null)));
});
parcelRegister("axSeT", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("dh7j2")
    ]).then(()=>parcelRequire('4Sylr'));
});
parcelRegister("d3Jbb", function(module, exports) {
    $parcel$export(module.exports, "SafeConversationAssistantPanel", ()=>$13a9fb2c9a767804$export$453401d0b697d2db);
    var $eUqFw = parcelRequire("eUqFw");
    var $aKISw = parcelRequire("aKISw");
    var $0cdA8 = parcelRequire("0cdA8");
    var $bUi2Q = parcelRequire("bUi2Q");
    var $1inzG = parcelRequire("1inzG");
    var $6vpb8 = parcelRequire("6vpb8");
    const $13a9fb2c9a767804$var$PanelInLayout = ()=>{
        const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
        const [localPanelId, setLocalPanelId] = (0, $eUqFw.useState)();
        const prevPanelIdRef = (0, $eUqFw.useRef)();
        const delayRef = (0, $eUqFw.useRef)(null);
        const { closeCurrentRightSidebar: closeCurrentRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
        const panelId = rightSidebarCurrentState?.panelId;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        (0, $eUqFw.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, $739c6750b8e21855$export$dffb4ed44e20ea9a)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                    createAnalyticsEvent({
                        action: 'closed',
                        actionSubject: 'aiMatePanel',
                        source: 'AIMate',
                        tags: [
                            'atlaskit',
                            'aiMate'
                        ]
                    }).fire((0, $aKISw.FabricChannel).aiMate);
                }, 310);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            createAnalyticsEvent,
            panelId,
            rightSidebarCurrentState
        ]);
        if (localPanelId !== (0, $739c6750b8e21855$export$dffb4ed44e20ea9a)) return null;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6vpb8.JiraConversationAssistant), {
            onClosePanel: closeCurrentRightSidebar
        });
    };
    const $13a9fb2c9a767804$export$453401d0b697d2db = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            fallback: "unmount",
            id: "right-side-conversation-assistant-panel",
            packageName: "jiraConversationAssistant"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($13a9fb2c9a767804$var$PanelInLayout, null));
});
const $739c6750b8e21855$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $739c6750b8e21855$export$64aee74ba59709e5 = 439;
const $739c6750b8e21855$export$1c07393c5bb1bc27 = 439;
const $739c6750b8e21855$export$aa3478deee7adbeb = 350;
const $739c6750b8e21855$export$21e515a86cd1733b = 'Chat';
parcelRegister("6vpb8", function(module, exports) {
    $parcel$export(module.exports, "JiraConversationAssistant", ()=>$477d20553922474c$export$da8473714271a41d);
    var $eUqFw = parcelRequire("eUqFw");
    var $iDwTy = parcelRequire("iDwTy");
    var $jGR8u = parcelRequire("jGR8u");
    var $fHiYa = parcelRequire("fHiYa");
    var $ipl2q = parcelRequire("ipl2q");
    var $cEN9m = parcelRequire("cEN9m");
    var $1ybV0 = parcelRequire("1ybV0");
    var $6rW04 = parcelRequire("6rW04");
    var $bUi2Q = parcelRequire("bUi2Q");
    var $jMP2a = parcelRequire("jMP2a");
    var $1inzG = parcelRequire("1inzG");
    var $jD3pk = parcelRequire("jD3pk");
    var $4rWQe = parcelRequire("4rWQe");
    var $dWLk9 = parcelRequire("dWLk9");
    const $477d20553922474c$var$SYNTHETIC_HEADER = 'x-issynthetic-traffic';
    const $477d20553922474c$export$da8473714271a41d = ({ onClosePanel: onClosePanel })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        const cloudId = (0, $dWLk9.useCloudId)();
        const activationId = (0, $4rWQe.useActivationId)();
        const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
        const { data: orgId } = (0, $jD3pk.useOrgId)();
        const isSyntheticTenant = (0, $6rW04.default)('ajs-is-synthetic') === 'true' || (0, $1ybV0.ff)('jsw.pollinator.tenants');
        let baseUrl = '/gateway/api/assist';
        if ((0, $1ybV0.ff)('jira.frontend.ai.mate.route.stargate.to.convo.ai')) baseUrl = '/gateway/api/assist-kotlin';
        else if ((0, $iDwTy.getBooleanFF)('platform.jira.frontend.ai.mate_route_stargate_to_stg_west')) baseUrl = '/gateway/api/assist-tester';
        const config = (0, $eUqFw.useMemo)(()=>({
                displaySubmitFlag: true,
                siteId: cloudId,
                activationId: activationId,
                product: 'jira',
                orgId: orgId,
                experienceId: 'ai-mate',
                assistanceServiceConfig: {
                    headers: isSyntheticTenant ? {
                        [$477d20553922474c$var$SYNTHETIC_HEADER]: String(isSyntheticTenant)
                    } : {},
                    baseUrl: baseUrl
                }
            }), [
            cloudId,
            activationId,
            orgId,
            isSyntheticTenant,
            baseUrl
        ]);
        const handleResizeComplete = (0, $eUqFw.useCallback)((width)=>{
            openRightSidebar((0, $739c6750b8e21855$export$dffb4ed44e20ea9a), width);
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'resized',
                actionSubject: 'aiMatePanel'
            }));
        }, [
            openRightSidebar,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cEN9m.ResizeWrapper), {
            onResizeComplete: handleResizeComplete
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $477d20553922474c$var$conversationAssistantWrapperStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ipl2q.default), {
            testId: "conversation-assistant.ui.conversation-assistant",
            onCloseChat: onClosePanel,
            config: config
        })));
    };
    const $477d20553922474c$var$conversationAssistantWrapperStyles = (0, $fHiYa.xcss)({
        width: '100%'
    });
});
parcelRegister("ipl2q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cc1bf52d11bb39a3$export$2e2bcd8739ae039);
    var $bYKiA = parcelRequire("bYKiA");
    var $cc1bf52d11bb39a3$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($bYKiA)))({
        loader: ()=>(parcelRequire("aLBnD")),
        loading: ()=>null
    });
});
parcelRegister("bYKiA", function(module, exports) {
    "use strict";
    var $8b893642f4a42c8a$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    function $8b893642f4a42c8a$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $8b893642f4a42c8a$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $8b893642f4a42c8a$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var $eUqFw = parcelRequire("eUqFw");
    var $1Qivz = parcelRequire("1Qivz");
    var $8b893642f4a42c8a$var$ALL_INITIALIZERS = [];
    var $8b893642f4a42c8a$var$READY_INITIALIZERS = [];
    function $8b893642f4a42c8a$var$isWebpackReady(getModuleIds) {
        if ((typeof __webpack_modules__ === "undefined" ? "undefined" : $8b893642f4a42c8a$var$_typeof(__webpack_modules__)) !== "object") return false;
        return getModuleIds().every(function(moduleId) {
            return typeof moduleId !== "undefined" && typeof __webpack_modules__[moduleId] !== "undefined";
        });
    }
    function $8b893642f4a42c8a$var$load(loader) {
        var promise = loader();
        var state = {
            loading: true,
            loaded: null,
            error: null
        };
        state.promise = promise.then(function(loaded) {
            state.loading = false;
            state.loaded = loaded;
            return loaded;
        }).catch(function(err) {
            state.loading = false;
            state.error = err;
            throw err;
        });
        return state;
    }
    function $8b893642f4a42c8a$var$loadMap(obj) {
        var state = {
            loading: false,
            loaded: {},
            error: null
        };
        var promises = [];
        try {
            Object.keys(obj).forEach(function(key) {
                var result = $8b893642f4a42c8a$var$load(obj[key]);
                if (!result.loading) {
                    state.loaded[key] = result.loaded;
                    state.error = result.error;
                } else state.loading = true;
                promises.push(result.promise);
                result.promise.then(function(res) {
                    state.loaded[key] = res;
                }).catch(function(err) {
                    state.error = err;
                });
            });
        } catch (err) {
            state.error = err;
        }
        state.promise = Promise.all(promises).then(function(res) {
            state.loading = false;
            return res;
        }).catch(function(err) {
            state.loading = false;
            throw err;
        });
        return state;
    }
    function $8b893642f4a42c8a$var$resolve(obj) {
        return obj && obj.__esModule ? obj.default : obj;
    }
    function $8b893642f4a42c8a$var$render(loaded, props) {
        return $eUqFw.createElement($8b893642f4a42c8a$var$resolve(loaded), props);
    }
    function $8b893642f4a42c8a$var$createLoadableComponent(loadFn, options) {
        var _class, _temp;
        if (!options.loading) throw new Error("react-loadable requires a `loading` component");
        var opts = Object.assign({
            loader: null,
            loading: null,
            delay: 200,
            timeout: null,
            render: $8b893642f4a42c8a$var$render,
            webpack: null,
            modules: null
        }, options);
        var res = null;
        function init() {
            if (!res) res = loadFn(opts.loader);
            return res.promise;
        }
        $8b893642f4a42c8a$var$ALL_INITIALIZERS.push(init);
        if (typeof opts.webpack === "function") $8b893642f4a42c8a$var$READY_INITIALIZERS.push(function() {
            if ($8b893642f4a42c8a$var$isWebpackReady(opts.webpack)) return init();
        });
        return _temp = _class = function(_React$Component) {
            $8b893642f4a42c8a$var$_inherits(LoadableComponent, _React$Component);
            function LoadableComponent(props) {
                $8b893642f4a42c8a$var$_classCallCheck(this, LoadableComponent);
                var _this = $8b893642f4a42c8a$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
                _this.retry = function() {
                    _this.setState({
                        error: null,
                        loading: true,
                        timedOut: false
                    });
                    res = loadFn(opts.loader);
                    _this._loadModule();
                };
                init();
                _this.state = {
                    error: res.error,
                    pastDelay: false,
                    timedOut: false,
                    loading: res.loading,
                    loaded: res.loaded
                };
                return _this;
            }
            LoadableComponent.preload = function preload() {
                return init();
            };
            LoadableComponent.prototype.componentWillMount = function componentWillMount() {
                this._mounted = true;
                this._loadModule();
            };
            LoadableComponent.prototype._loadModule = function _loadModule() {
                var _this2 = this;
                if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                    _this2.context.loadable.report(moduleName);
                });
                if (!res.loading) return;
                if (typeof opts.delay === "number") {
                    if (opts.delay === 0) this.setState({
                        pastDelay: true
                    });
                    else this._delay = setTimeout(function() {
                        _this2.setState({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
                if (typeof opts.timeout === "number") this._timeout = setTimeout(function() {
                    _this2.setState({
                        timedOut: true
                    });
                }, opts.timeout);
                var update = function update() {
                    if (!_this2._mounted) return;
                    _this2.setState({
                        error: res.error,
                        loaded: res.loaded,
                        loading: res.loading
                    });
                    _this2._clearTimeouts();
                };
                res.promise.then(function() {
                    update();
                }).catch(function(err) {
                    update();
                });
            };
            LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
                this._mounted = false;
                this._clearTimeouts();
            };
            LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            };
            LoadableComponent.prototype.render = function render() {
                if (this.state.loading || this.state.error) return $eUqFw.createElement(opts.loading, {
                    isLoading: this.state.loading,
                    pastDelay: this.state.pastDelay,
                    timedOut: this.state.timedOut,
                    error: this.state.error,
                    retry: this.retry
                });
                else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
                else return null;
            };
            return LoadableComponent;
        }($eUqFw.Component), _class.contextTypes = {
            loadable: $1Qivz.shape({
                report: $1Qivz.func.isRequired
            })
        }, _temp;
    }
    function $8b893642f4a42c8a$var$Loadable(opts) {
        return $8b893642f4a42c8a$var$createLoadableComponent($8b893642f4a42c8a$var$load, opts);
    }
    function $8b893642f4a42c8a$var$LoadableMap(opts) {
        if (typeof opts.render !== "function") throw new Error("LoadableMap requires a `render(loaded, props)` function");
        return $8b893642f4a42c8a$var$createLoadableComponent($8b893642f4a42c8a$var$loadMap, opts);
    }
    $8b893642f4a42c8a$var$Loadable.Map = $8b893642f4a42c8a$var$LoadableMap;
    var $8b893642f4a42c8a$var$Capture = function(_React$Component2) {
        $8b893642f4a42c8a$var$_inherits(Capture, _React$Component2);
        function Capture() {
            $8b893642f4a42c8a$var$_classCallCheck(this, Capture);
            return $8b893642f4a42c8a$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
        }
        Capture.prototype.getChildContext = function getChildContext() {
            return {
                loadable: {
                    report: this.props.report
                }
            };
        };
        Capture.prototype.render = function render() {
            return $eUqFw.Children.only(this.props.children);
        };
        return Capture;
    }($eUqFw.Component);
    $8b893642f4a42c8a$var$Capture.propTypes = {
        report: $1Qivz.func.isRequired
    };
    $8b893642f4a42c8a$var$Capture.childContextTypes = {
        loadable: $1Qivz.shape({
            report: $1Qivz.func.isRequired
        }).isRequired
    };
    $8b893642f4a42c8a$var$Loadable.Capture = $8b893642f4a42c8a$var$Capture;
    function $8b893642f4a42c8a$var$flushInitializers(initializers) {
        var promises = [];
        while(initializers.length){
            var init = initializers.pop();
            promises.push(init());
        }
        return Promise.all(promises).then(function() {
            if (initializers.length) return $8b893642f4a42c8a$var$flushInitializers(initializers);
        });
    }
    $8b893642f4a42c8a$var$Loadable.preloadAll = function() {
        return new Promise(function(resolve, reject) {
            $8b893642f4a42c8a$var$flushInitializers($8b893642f4a42c8a$var$ALL_INITIALIZERS).then(resolve, reject);
        });
    };
    $8b893642f4a42c8a$var$Loadable.preloadReady = function() {
        return new Promise(function(resolve, reject) {
            $8b893642f4a42c8a$var$flushInitializers($8b893642f4a42c8a$var$READY_INITIALIZERS).then(resolve, resolve);
        });
    };
    module.exports = $8b893642f4a42c8a$var$Loadable;
});
parcelRegister("aLBnD", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("dsiAd"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("8Zm7V")
    ]).then(()=>parcelRequire('gYNmA'));
});
parcelRegister("cEN9m", function(module, exports) {
    $parcel$export(module.exports, "ResizeWrapper", ()=>$b4c097f4c592aca4$export$c7990a6594835e51);
    var $eUqFw = parcelRequire("eUqFw");
    var $74BVL = parcelRequire("74BVL");
    var $75Bx4 = parcelRequire("75Bx4");
    var $jGR8u = parcelRequire("jGR8u");
    var $fHiYa = parcelRequire("fHiYa");
    const $b4c097f4c592aca4$var$rootStyles = (0, $fHiYa.xcss)({
        right: 'space.0',
        display: 'flex',
        position: 'fixed',
        height: `calc(100vh - ${(0, $75Bx4.TOP_NAVIGATION_HEIGHT)} - ${(0, $75Bx4.BANNER_HEIGHT)})`
    });
    const $b4c097f4c592aca4$var$handleStyles = (0, $fHiYa.xcss)({
        cursor: 'ew-resize',
        userSelect: 'none',
        position: 'absolute',
        top: 'space.200',
        bottom: 'space.0',
        left: 'space.0',
        width: '24px',
        borderTopLeftRadius: 'border.radius.200',
        transition: 'border 0.2s ease-in-out',
        borderLeft: '2px solid transparent',
        ':hover': {
            borderLeft: `2px solid ${"var(--ds-background-information-bold-hovered, #0055CC)"}`
        }
    });
    const $b4c097f4c592aca4$var$handleSpacerStyles = (0, $fHiYa.xcss)({
        width: '24px',
        position: 'absolute',
        display: 'block',
        left: '-24px',
        top: 'space.0',
        bottom: 'space.0'
    });
    const $b4c097f4c592aca4$export$c7990a6594835e51 = ({ children: children, onResizeComplete: onResizeComplete, initialWidth: initialWidth = (0, $739c6750b8e21855$export$64aee74ba59709e5), minWidth: minWidth = (0, $739c6750b8e21855$export$64aee74ba59709e5), maxWidth: maxWidth = '50vw' })=>{
        const [width, setWidth] = (0, $eUqFw.useState)(initialWidth);
        const wrapperRef = (0, $eUqFw.useRef)(null);
        const isDraggingRef = (0, $eUqFw.useRef)(false);
        const initialMousePositionRef = (0, $eUqFw.useRef)(0);
        const prevDistanceMovedRef = (0, $eUqFw.useRef)(0);
        const rafRef = (0, $eUqFw.useRef)(null);
        const getWrapperWidth = ()=>{
            return wrapperRef.current?.getBoundingClientRect()?.width || 0;
        };
        const handleMouseMove = (0, $eUqFw.useCallback)((event)=>{
            if (!isDraggingRef.current) return;
            const distanceMoved = event.clientX - initialMousePositionRef.current;
            let updatedWidth;
            const currentWidth = getWrapperWidth();
            if (distanceMoved === prevDistanceMovedRef.current || distanceMoved === 0) return;
            prevDistanceMovedRef.current = distanceMoved;
            if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
            rafRef.current = requestAnimationFrame(()=>{
                if (distanceMoved < 0) {
                    updatedWidth = currentWidth + Math.abs(distanceMoved);
                    if (typeof maxWidth === 'number' && !isNaN(maxWidth)) updatedWidth = Math.min(updatedWidth, maxWidth);
                } else {
                    updatedWidth = currentWidth - distanceMoved;
                    if (typeof minWidth === 'number' && !isNaN(minWidth)) updatedWidth = Math.max(updatedWidth, minWidth);
                }
                setWidth(updatedWidth);
                initialMousePositionRef.current = event.clientX;
            });
        }, [
            maxWidth,
            minWidth
        ]);
        const handleMouseDown = (0, $eUqFw.useCallback)((event)=>{
            isDraggingRef.current = true;
            initialMousePositionRef.current = event.clientX;
        }, []);
        const handleMouseUp = (0, $eUqFw.useCallback)(()=>{
            if (isDraggingRef.current && onResizeComplete) onResizeComplete(wrapperRef.current?.getBoundingClientRect().width || width);
            isDraggingRef.current = false;
        }, [
            onResizeComplete,
            width
        ]);
        (0, $eUqFw.useEffect)(()=>{
            const mouseMoveHandler = (0, $74BVL.bind)(window, {
                type: 'mousemove',
                listener: handleMouseMove
            });
            const mouseUpHandler = (0, $74BVL.bind)(window, {
                type: 'mouseup',
                listener: handleMouseUp
            });
            return ()=>{
                mouseMoveHandler();
                mouseUpHandler();
                if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
            };
        }, [
            handleMouseMove,
            handleMouseUp
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $b4c097f4c592aca4$var$rootStyles,
            ref: wrapperRef,
            role: "presentation",
            testId: "panel-resize-wrapper",
            style: {
                width: width,
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            testId: "panel-resize-handle",
            onMouseDown: handleMouseDown,
            xcss: $b4c097f4c592aca4$var$handleStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $b4c097f4c592aca4$var$handleSpacerStyles
        })), children);
    };
});
parcelRegister("4rWQe", function(module, exports) {
    $parcel$export(module.exports, "useActivationId", ()=>$a2ceb1e21dea3b54$export$43686faa787c943);
    var $gd0Sp = parcelRequire("gd0Sp");
    const $a2ceb1e21dea3b54$export$43686faa787c943 = ()=>{
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        return tenantContext && tenantContext.activationId;
    };
});
parcelRegister("dWLk9", function(module, exports) {
    $parcel$export(module.exports, "useCloudId", ()=>$15ea95bdeaf03a79$export$9da0f7c65f28ed16);
    var $gd0Sp = parcelRequire("gd0Sp");
    const $15ea95bdeaf03a79$export$9da0f7c65f28ed16 = ()=>{
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        return tenantContext && tenantContext.cloudId;
    };
});
parcelRegister("69KNw", function(module, exports) {
    $parcel$export(module.exports, "AsyncDeferEditionEPCheckWrapper", ()=>$d4f7e79a98bf2d89$export$4fa5b26bccc7e3df);
    var $eUqFw = parcelRequire("eUqFw");
    var $5GxEP = parcelRequire("5GxEP");
    var $aR8n6 = parcelRequire("aR8n6");
    var $56koX = parcelRequire("56koX");
    const $d4f7e79a98bf2d89$var$AsyncDeferEditionEPCheck = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("fVtGz")).then(({ EPCheck: EPCheck })=>EPCheck), {
        ssr: false,
        moduleId: "./src/packages/growth/defer-edition-modal/src/async.tsx"
    });
    const $d4f7e79a98bf2d89$export$4fa5b26bccc7e3df = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
            id: "defer-edition-ep-check-async",
            packageName: (0, $9a060b7ebf877081$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
            teamName: (0, $9a060b7ebf877081$export$d57b6b390e78d90f),
            id: "defer-edition-ep-check-async",
            packageName: (0, $9a060b7ebf877081$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($d4f7e79a98bf2d89$var$AsyncDeferEditionEPCheck, props)));
});
const $9a060b7ebf877081$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $9a060b7ebf877081$export$d57b6b390e78d90f = 'transmuters-growth';
const $9a060b7ebf877081$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $9a060b7ebf877081$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $9a060b7ebf877081$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $9a060b7ebf877081$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $9a060b7ebf877081$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $9a060b7ebf877081$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $9a060b7ebf877081$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $9a060b7ebf877081$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';
parcelRegister("fVtGz", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("gBePI")
    ]).then(()=>parcelRequire('cbtdY'));
});
parcelRegister("2RiaW", function(module, exports) {
    $parcel$export(module.exports, "jiraDeferEditionModalEntryPoint", ()=>$4cb205dd87fc0732$export$51f384a783f47807);
    var $kKOBp = parcelRequire("kKOBp");
    var $1ydNb = parcelRequire("1ydNb");
    var $6TOES = parcelRequire("6TOES");
    const $4cb205dd87fc0732$var$Fallback = ()=>null;
    const $4cb205dd87fc0732$export$51f384a783f47807 = (0, $6TOES.createEntryPoint)({
        root: (0, $1ydNb.JSResourceForInteraction)(async ()=>{
            if (!false) return (parcelRequire("hbMlx")).then(({ DeferEditionModalComponent: DeferEditionModalComponent })=>DeferEditionModalComponent);
            return $4cb205dd87fc0732$var$Fallback;
        }, {
            moduleId: "fe342c6b"
        }),
        getPreloadProps: ({ cloudId: cloudId, productKey: productKey })=>({
                queries: {
                    deferEditionModal: {
                        parameters: (0, $kKOBp.default),
                        variables: {
                            cloudId: cloudId,
                            productKey: productKey
                        }
                    }
                }
            })
    });
});
parcelRegister("kKOBp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6bb29fd8ceb1ac78$export$2e2bcd8739ae039);
    const $6bb29fd8ceb1ac78$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "5b10c1496eb58e67afa6cdffdf558adb655a89e468a81592e6c039cccddb07ac",
            "metadata": {},
            "name": "src_DeferEditionModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $6bb29fd8ceb1ac78$export$2e2bcd8739ae039 = $6bb29fd8ceb1ac78$var$node;
});
parcelRegister("hbMlx", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("d1CGm")
    ]).then(()=>parcelRequire('6TGoA'));
});
parcelRegister("1ZDON", function(module, exports) {
    $parcel$export(module.exports, "AsyncEndOfTrialMessageSharedWrapper", ()=>$5baceba59aeb8387$export$ae154a7bf883999f);
    var $eUqFw = parcelRequire("eUqFw");
    var $5GxEP = parcelRequire("5GxEP");
    var $aR8n6 = parcelRequire("aR8n6");
    var $56koX = parcelRequire("56koX");
    var $ejxbt = parcelRequire("ejxbt");
    const $5baceba59aeb8387$var$AsyncEndOfTrialMessageSharedGlobalComponent = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("4sY1W")).then(({ EndOfTrialMessageSharedGlobalComponent: EndOfTrialMessageSharedGlobalComponent })=>EndOfTrialMessageSharedGlobalComponent), {
        moduleId: "./src/packages/growth/end-of-trial/end-of-trial-message-shared-global-component/src/index.tsx"
    });
    const $5baceba59aeb8387$export$ae154a7bf883999f = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
            id: "end-of-trial-message-shared-async",
            packageName: (0, $ejxbt.PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
            teamName: (0, $ejxbt.TEAM_NAME),
            id: "end-of-trial-message-shared-async",
            packageName: (0, $ejxbt.PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($5baceba59aeb8387$var$AsyncEndOfTrialMessageSharedGlobalComponent, null)));
});
parcelRegister("ejxbt", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$f14b50b65c21857b$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$f14b50b65c21857b$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "STARGATE_URL", ()=>$f14b50b65c21857b$export$c7e6a6b283196232);
    $parcel$export(module.exports, "END_OF_TRIAL_MESSAGE_AUDIENCES", ()=>$f14b50b65c21857b$export$1986890201f1a80);
    var $7ZZxN = parcelRequire("7ZZxN");
    const $f14b50b65c21857b$export$b8b9d90f9e5bd72b = '@atlassian/jira-end-of-trial-message-shared-global-component';
    const $f14b50b65c21857b$export$d57b6b390e78d90f = 'transmuters-growth';
    const $f14b50b65c21857b$export$c7e6a6b283196232 = '/gateway/api';
    const $f14b50b65c21857b$export$1986890201f1a80 = {
        [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: [
            'jpd_standard_end_of_trial_message_day_14',
            'jpd_standard_end_of_trial_message_day_13',
            'jpd_standard_end_of_trial_message_day_12',
            'jpd_standard_end_of_trial_message_day_11',
            'jpd_standard_end_of_trial_message_day_10',
            'jpd_standard_end_of_trial_message_day_9',
            'jpd_standard_end_of_trial_message_day_8',
            'jpd_standard_end_of_trial_message_day_7',
            'jpd_standard_end_of_trial_message_day_6',
            'jpd_standard_end_of_trial_message_day_5',
            'jpd_standard_end_of_trial_message_day_4',
            'jpd_standard_end_of_trial_message_day_3',
            'jpd_standard_end_of_trial_message_day_2',
            'jpd_standard_end_of_trial_message_day_1'
        ],
        [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: [
            'jsm_standard_end_of_trial_message_day_14',
            'jsm_standard_end_of_trial_message_day_13',
            'jsm_standard_end_of_trial_message_day_12',
            'jsm_standard_end_of_trial_message_day_11',
            'jsm_standard_end_of_trial_message_day_10',
            'jsm_standard_end_of_trial_message_day_9',
            'jsm_standard_end_of_trial_message_day_8',
            'jsm_standard_end_of_trial_message_day_7',
            'jsm_standard_end_of_trial_message_day_6',
            'jsm_standard_end_of_trial_message_day_5',
            'jsm_standard_end_of_trial_message_day_4',
            'jsm_standard_end_of_trial_message_day_3',
            'jsm_standard_end_of_trial_message_day_2',
            'jsm_standard_end_of_trial_message_day_1'
        ]
    };
});
parcelRegister("4sY1W", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("2lfvs")
    ]).then(()=>parcelRequire('bUM6a'));
});
parcelRegister("1HzcR", function(module, exports) {
    $parcel$export(module.exports, "JiraEntryPointContainer", ()=>$48716810ae87e4eb$export$ee1e46af8fa2fb93);
    var $eUqFw = parcelRequire("eUqFw");
    var $P6D7Q = parcelRequire("P6D7Q");
    var $ioLN0 = parcelRequire("ioLN0");
    const $48716810ae87e4eb$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
        const entryPointReference = (0, $P6D7Q.useEntryPointSubscription)(entryPointReferenceSubject);
        return entryPointReference ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ioLN0.InternalEntryPointContainer), {
            ...containerProps,
            entryPointReference: entryPointReference,
            placeholderName: "jira-entry-point-container"
        }) : null;
    };
    const $48716810ae87e4eb$export$54db9e88249c9162 = (0, $ioLN0.InternalEntryPointContainer);
});
parcelRegister("P6D7Q", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointSubscription", ()=>$f27db5d96682fc65$export$3cd1c81e13390c49);
    var $eUqFw = parcelRequire("eUqFw");
    const $f27db5d96682fc65$export$3cd1c81e13390c49 = (subject)=>{
        const [entryPointReference, setEntryPointReference] = (0, $eUqFw.useState)(subject.getValue);
        (0, $eUqFw.useEffect)(()=>{
            const unsubscribe = subject.subscribe(setEntryPointReference);
            setEntryPointReference(subject.getValue());
            return unsubscribe;
        }, [
            subject
        ]);
        return entryPointReference;
    };
});
parcelRegister("ioLN0", function(module, exports) {
    $parcel$export(module.exports, "InternalEntryPointContainer", ()=>$d11d0c1bfdfee8c0$export$5d4dc37edd8a3adb);
    var $eUqFw = parcelRequire("eUqFw");
    var $iWLL0 = parcelRequire("iWLL0");
    var $0cdA8 = parcelRequire("0cdA8");
    var $gGtKh = parcelRequire("gGtKh");
    var $jK1pm = parcelRequire("jK1pm");
    const $d11d0c1bfdfee8c0$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: id
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: id,
            packageName: packageName,
            teamName: teamName,
            attributes: errorAttributes,
            fallback: errorFallback
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: placeholderName ?? packageName ?? 'internal-entry-point-container',
            fallback: fallback
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
            entryPointReference: entryPointReference,
            props: runtimeProps
        }))));
});
parcelRegister("6j4bv", function(module, exports) {
    $parcel$export(module.exports, "useEntryPoint", ()=>$82c08dfbbf99b106$export$338256068bc140fb);
    var $eUqFw = parcelRequire("eUqFw");
    var $hRw7O = parcelRequire("hRw7O");
    var $80LCQ = parcelRequire("80LCQ");
    var $fn8UB = parcelRequire("fn8UB");
    var $VvIn5 = parcelRequire("VvIn5");
    const $82c08dfbbf99b106$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, $hRw7O.DEFAULT_OPTIONS))=>{
        const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, $fn8UB.useEntryPointLoadManager)(entryPoint, entryPointParams);
        const { startMetric: startMetric, stopMetric: stopMetric } = (0, $VvIn5.useMetricLogger)(metric);
        const entryPointActions = (0, $80LCQ.useEntryPointActions)(loadActions, options, startMetric);
        return (0, $eUqFw.useMemo)(()=>({
                entryPointActions: entryPointActions,
                entryPointReferenceSubject: entryPointReferenceSubject,
                stopMetric: stopMetric
            }), [
            entryPointActions,
            entryPointReferenceSubject,
            stopMetric
        ]);
    };
});
parcelRegister("hRw7O", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_OPTIONS", ()=>$8aa020919bcd63f9$export$93ca5d3f8675ae4c);
    const $8aa020919bcd63f9$export$93ca5d3f8675ae4c = {
        preloadMaxAge: 2000,
        timeToIntent: 200
    };
});
parcelRegister("80LCQ", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointActions", ()=>$5764a513c11cf0da$export$90681c8c3a56f09a);
    var $eUqFw = parcelRequire("eUqFw");
    var $gZ48R = parcelRequire("gZ48R");
    var $hRw7O = parcelRequire("hRw7O");
    const $5764a513c11cf0da$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
    const $5764a513c11cf0da$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, $hRw7O.DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, $hRw7O.DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
        const preloadIntentTimeout = (0, $eUqFw.useRef)();
        const preloadMaxAgeTimeout = (0, $eUqFw.useRef)();
        const preloadLastRequested = (0, $eUqFw.useRef)(0);
        const cancelPreload = (0, $eUqFw.useCallback)(()=>{
            if (!(0, $gZ48R.default)($5764a513c11cf0da$var$PRELOAD_KILLSWITCH)) {
                clearTimeout(preloadIntentTimeout.current);
                clearTimeout(preloadMaxAgeTimeout.current);
            }
        }, []);
        const load = (0, $eUqFw.useCallback)(()=>{
            cancelPreload();
            startMetric(preloadLastRequested.current);
            if (preloadLastRequested.current > 0) commitPreload();
            else loadEntryPoint();
            preloadLastRequested.current = 0;
        }, [
            cancelPreload,
            commitPreload,
            loadEntryPoint,
            startMetric
        ]);
        const preload = (0, $eUqFw.useCallback)(()=>{
            if ((0, $gZ48R.default)($5764a513c11cf0da$var$PRELOAD_KILLSWITCH)) return;
            cancelPreload();
            preloadIntentTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = Date.now();
                loadEntryPoint({
                    isPreload: true
                });
                preloadMaxAgeTimeout.current = setTimeout(()=>{
                    preloadLastRequested.current = 0;
                }, preloadMaxAge);
            }, timeToIntent);
        }, [
            cancelPreload,
            loadEntryPoint,
            preloadMaxAge,
            timeToIntent
        ]);
        (0, $eUqFw.useEffect)(()=>cancelPreload, [
            cancelPreload
        ]);
        return (0, $eUqFw.useMemo)(()=>({
                cancelPreload: cancelPreload,
                load: load,
                preload: preload,
                unload: unloadEntryPoint
            }), [
            cancelPreload,
            load,
            preload,
            unloadEntryPoint
        ]);
    };
});
parcelRegister("fn8UB", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointLoadManager", ()=>$9075a0262fd7a4a5$export$bfae318f9651db2f);
    var $eUqFw = parcelRequire("eUqFw");
    var $iWLL0 = parcelRequire("iWLL0");
    var $ln3W8 = parcelRequire("ln3W8");
    var $boTUp = parcelRequire("boTUp");
    const $9075a0262fd7a4a5$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
        const environmentProvider = (0, $ln3W8.useJiraRelayEnvironmentProvider)();
        const canLoad = (0, $eUqFw.useRef)(true);
        const timer = (0, $eUqFw.useRef)();
        const entryPointReferenceQueue = (0, $eUqFw.useRef)([]);
        const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, $boTUp.useEntryPointReferenceSubject)();
        const setNextUpdate = (0, $eUqFw.useCallback)((nextEntryPointReference)=>{
            setEntryPointReference(nextEntryPointReference);
            timer.current = setTimeout(()=>{
                const { current: currentQueue } = entryPointReferenceQueue;
                entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, $boTUp.removeAll)(currentQueue) : (0, $boTUp.removeInactiveLoads)(currentQueue);
            }, 0);
        }, [
            setEntryPointReference
        ]);
        const load = (0, $eUqFw.useCallback)(({ isPreload: isPreload } = {
            isPreload: false
        })=>{
            if (canLoad.current) {
                const reference = (0, $iWLL0.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
                entryPointReferenceQueue.current.unshift({
                    value: reference,
                    isPreload: isPreload
                });
                if (isPreload) entryPointReferenceQueue.current = (0, $boTUp.removeRedundantPreloads)(entryPointReferenceQueue.current);
                else setNextUpdate(reference);
            }
        }, [
            entryPoint,
            entryPointParams,
            environmentProvider,
            setNextUpdate
        ]);
        const unload = (0, $eUqFw.useCallback)(()=>{
            setNextUpdate(null);
        }, [
            setNextUpdate
        ]);
        const commitPreload = (0, $eUqFw.useCallback)(()=>{
            const [firstItem] = entryPointReferenceQueue.current;
            if (firstItem?.isPreload) {
                firstItem.isPreload = false;
                setNextUpdate(firstItem.value);
            }
        }, [
            setNextUpdate
        ]);
        (0, $eUqFw.useEffect)(()=>()=>{
                clearTimeout(timer.current);
                canLoad.current = false;
                entryPointReferenceQueue.current = (0, $boTUp.removeAll)(entryPointReferenceQueue.current);
            }, []);
        return {
            entryPointReferenceSubject: (0, $eUqFw.useMemo)(()=>({
                    getValue: getValue,
                    subscribe: subscribe
                }), [
                getValue,
                subscribe
            ]),
            loadEntryPoint: load,
            unloadEntryPoint: unload,
            commitPreload: commitPreload
        };
    };
});
parcelRegister("ln3W8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b8bb35ae4ffc3ad$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useJiraRelayEnvironmentProvider", ()=>$8b8bb35ae4ffc3ad$export$83fb48644dee72f0);
    var $eUqFw = parcelRequire("eUqFw");
    var $iWLL0 = parcelRequire("iWLL0");
    var $amu7D = parcelRequire("amu7D");
    function $8b8bb35ae4ffc3ad$export$2e2bcd8739ae039({ children: children }) {
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.RelayEnvironmentProvider), {
            environment: (0, $amu7D.default)()
        }, children);
    }
    function $8b8bb35ae4ffc3ad$export$83fb48644dee72f0() {
        const environment = (0, $iWLL0.useRelayEnvironment)();
        return (0, $eUqFw.useMemo)(()=>({
                getEnvironment () {
                    return environment;
                }
            }), [
            environment
        ]);
    }
});
parcelRegister("amu7D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f68576217aea2baf$export$2e2bcd8739ae039);
    var $cNy9K = parcelRequire("cNy9K");
    var $9GSiX = parcelRequire("9GSiX");
    let $f68576217aea2baf$var$relayEnvironment;
    function $f68576217aea2baf$export$2e2bcd8739ae039() {
        if (!$f68576217aea2baf$var$relayEnvironment) {
            const environmentConfig = (0, $9GSiX.getRelayEnvironmentConfig)();
            $f68576217aea2baf$var$relayEnvironment = new (0, $cNy9K.Environment)(environmentConfig);
        }
        return $f68576217aea2baf$var$relayEnvironment;
    }
});
parcelRegister("9GSiX", function(module, exports) {
    $parcel$export(module.exports, "getRelayEnvironmentConfig", ()=>$b823b5ac69a7954d$export$a451c85db2d1cda3);
    var $9fdRu = parcelRequire("9fdRu");
    var $2vvuk = parcelRequire("2vvuk");
    var $4tM5X = parcelRequire("4tM5X");
    const $b823b5ac69a7954d$export$a451c85db2d1cda3 = ()=>(0, $4tM5X.getDefaultRelayEnvironmentConfig)({
            network: (0, $2vvuk.getNetwork)(),
            log: (0, $9fdRu.default),
            requiredFieldLogger: $9fdRu.requiredFieldLogger
        });
});
parcelRegister("9fdRu", function(module, exports) {
    $parcel$export(module.exports, "requiredFieldLogger", ()=>$c152fc62c06270e5$export$1ab8b98d209afe85);
    $parcel$export(module.exports, "default", ()=>$c152fc62c06270e5$export$2e2bcd8739ae039);
    var $gUUjF = parcelRequire("gUUjF");
    var $gZ48R = parcelRequire("gZ48R");
    var $cpY9k = parcelRequire("cpY9k");
    const $c152fc62c06270e5$var$RELAY_CLIENT_ID = 'AGG';
    const $c152fc62c06270e5$var$LOG_NAMESPACE = `relay.${$c152fc62c06270e5$var$RELAY_CLIENT_ID}.error.graphql`;
    const $c152fc62c06270e5$var$requests = {};
    const $c152fc62c06270e5$var$queries = {};
    const $c152fc62c06270e5$var$resources = {};
    const $c152fc62c06270e5$var$executes = {};
    const $c152fc62c06270e5$var$CLEANUP_TIMEOUT = 300000;
    const $c152fc62c06270e5$export$1ab8b98d209afe85 = (event)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData($c152fc62c06270e5$var$LOG_NAMESPACE, '[relay required field error]', {
            kind: event.kind,
            owner: event.owner,
            fieldPath: event.fieldPath,
            message: event.kind === 'relay_resolver.error' ? event.error?.message : null
        });
    };
    const $c152fc62c06270e5$var$getResponseSize = (resp)=>{
        if (resp.data === undefined) return 0;
        try {
            return JSON.stringify(resp.data).length;
        } catch (e) {
            return 0;
        }
    };
    function $c152fc62c06270e5$export$2e2bcd8739ae039(event) {
        if ((0, $gZ48R.default)('relay_log')) return;
        switch(event.name){
            case 'network.start':
                {
                    const networkStart = performance.now();
                    const { networkRequestId: networkRequestId } = event;
                    const { name: name } = event.params;
                    const requestInfo = $c152fc62c06270e5$var$requests[networkRequestId];
                    if (requestInfo == null) {
                        const newRequestInfo = {
                            name: name,
                            flushes: [],
                            start: networkStart,
                            networkStart: networkStart
                        };
                        $c152fc62c06270e5$var$queries[name] = newRequestInfo;
                        $c152fc62c06270e5$var$requests[networkRequestId] = newRequestInfo;
                        setTimeout(()=>{
                            delete $c152fc62c06270e5$var$requests[networkRequestId];
                            delete $c152fc62c06270e5$var$queries[name];
                        }, $c152fc62c06270e5$var$CLEANUP_TIMEOUT);
                    } else requestInfo.networkStart = networkStart;
                    break;
                }
            case 'network.next':
                {
                    const requestInfo = $c152fc62c06270e5$var$requests[event.networkRequestId];
                    if (requestInfo != null) {
                        const { response: response } = event;
                        const addFlush = (resp)=>{
                            if (resp.data !== null) {
                                const res = resp;
                                const flush = {
                                    label: res.label != null ? res.label : 'root',
                                    time: performance.now(),
                                    size: $c152fc62c06270e5$var$getResponseSize(res)
                                };
                                requestInfo.flushes?.push(flush);
                            }
                        };
                        Array.isArray(response) ? response.forEach(addFlush) : addFlush(response);
                    }
                    break;
                }
            case 'network.error':
                {
                    const info = $c152fc62c06270e5$var$requests[event.networkRequestId];
                    if (info != null) info.error = event.error;
                    break;
                }
            case 'network.info':
                break;
            case 'network.complete':
                {
                    const requestInfo = $c152fc62c06270e5$var$requests[event.networkRequestId];
                    const networkComplete = performance.now();
                    if (requestInfo != null) {
                        const size = requestInfo.flushes.map((f)=>f.size).reduce((p, c)=>p + c, 0);
                        requestInfo.size = size;
                        requestInfo.networkComplete = networkComplete;
                        requestInfo.flushes = [];
                        (0, $cpY9k.addSpanToAll)('relay', requestInfo.name, [
                            {
                                name: 'network'
                            }
                        ], requestInfo.start, requestInfo.networkComplete, size);
                    }
                    break;
                }
            case 'network.unsubscribe':
                break;
            case 'suspense.fragment':
                break;
            case 'suspense.query':
                break;
            case 'queryresource.fetch':
                {
                    const { node: node } = event.operation.root;
                    const fetchStart = performance.now();
                    if (node.name != null) {
                        const { name: name } = node;
                        const requestInfo = $c152fc62c06270e5$var$queries[name];
                        if (requestInfo != null) {
                            requestInfo.fetchStart = fetchStart;
                            $c152fc62c06270e5$var$resources[event.resourceID] = requestInfo;
                        } else {
                            const newRequestInfo = {
                                name: name,
                                flushes: [],
                                start: fetchStart,
                                fetchStart: fetchStart
                            };
                            $c152fc62c06270e5$var$queries[name] = newRequestInfo;
                            $c152fc62c06270e5$var$resources[event.resourceID] = newRequestInfo;
                            setTimeout(()=>{
                                delete $c152fc62c06270e5$var$queries[node.name];
                            }, $c152fc62c06270e5$var$CLEANUP_TIMEOUT);
                        }
                        setTimeout(()=>{
                            delete $c152fc62c06270e5$var$resources[event.resourceID];
                        }, $c152fc62c06270e5$var$CLEANUP_TIMEOUT);
                    }
                    break;
                }
            case 'queryresource.retain':
                {
                    const requestInfo = $c152fc62c06270e5$var$resources[event.resourceID];
                    if (requestInfo != null && event.profilerContext != null) {
                        requestInfo.end = performance.now();
                        const context = event.profilerContext;
                        context?.retainQuery?.(requestInfo);
                    }
                    break;
                }
            case 'execute.start':
                $c152fc62c06270e5$var$executes[event.executeId] = {
                    name: event.params.name,
                    kind: event.params.operationKind,
                    start: performance.now(),
                    duration: 0
                };
                break;
            case 'execute.next':
                $c152fc62c06270e5$var$executes[event.executeId].duration += event.duration;
                break;
            case 'execute.async.module':
                break;
            case 'execute.flight.payload_deserialize':
                break;
            case 'execute.error':
                delete $c152fc62c06270e5$var$executes[event.executeId];
                break;
            case 'execute.complete':
                {
                    const op = $c152fc62c06270e5$var$executes[event.executeId];
                    if (op != null) {
                        op.end = performance.now();
                        delete $c152fc62c06270e5$var$executes[event.executeId];
                    }
                    break;
                }
            case 'store.publish':
                break;
            case 'store.snapshot':
                break;
            case 'store.restore':
                break;
            case 'store.gc':
                break;
            case 'store.notify.start':
                break;
            case 'store.notify.complete':
                break;
            case 'store.notify.subscription':
                break;
            case 'entrypoint.root.consume':
                break;
            default:
                break;
        }
    }
});
parcelRegister("2vvuk", function(module, exports) {
    $parcel$export(module.exports, "getNetwork", ()=>$4d8ddda0e7507868$export$7de4970ebfd8206d);
    var $cNy9K = parcelRequire("cNy9K");
    var $c4LxQ = parcelRequire("c4LxQ");
    var $4aLdW = parcelRequire("4aLdW");
    var $b3wL2 = parcelRequire("b3wL2");
    const $4d8ddda0e7507868$export$7de4970ebfd8206d = ()=>{
        if ((0, $b3wL2.isSSR)()) (0, $cNy9K.Network).create((0, $c4LxQ.fetch));
        return (0, $cNy9K.Network).create((0, $c4LxQ.fetch), (0, $4aLdW.subscribe));
    };
});
parcelRegister("c4LxQ", function(module, exports) {
    $parcel$export(module.exports, "fetch", ()=>$1a035cb2d3f2c948$export$e7aa7bc5c1b3cfb3);
    var $ldoFd = parcelRequire("ldoFd");
    var $2vzCR = parcelRequire("2vzCR");
    var $cNy9K = parcelRequire("cNy9K");
    var $8VURk = parcelRequire("8VURk");
    var $jV8ng = parcelRequire("jV8ng");
    var $fVqUX = parcelRequire("fVqUX");
    var $7byHA = parcelRequire("7byHA");
    var $lRmyA = parcelRequire("lRmyA");
    var $3lpdA = parcelRequire("3lpdA");
    var $5zSUY = parcelRequire("5zSUY");
    var $15ZJO = parcelRequire("15ZJO");
    var $7GiRY = parcelRequire("7GiRY");
    var $c7ifG = parcelRequire("c7ifG");
    var $j7fph = parcelRequire("j7fph");
    var $8tomX = parcelRequire("8tomX");
    var $mk6Qw = parcelRequire("mk6Qw");
    var $51rO4 = parcelRequire("51rO4");
    var $7qse3 = parcelRequire("7qse3");
    var $iuC8B = parcelRequire("iuC8B");
    var $ixYrr = parcelRequire("ixYrr");
    let $1a035cb2d3f2c948$var$redirecting = false;
    const $1a035cb2d3f2c948$var$redirect = ()=>{
        const identity = (0, $8VURk.getATLContextDomain)('id');
        const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
        window.location.href = redirectUrl;
    };
    const $1a035cb2d3f2c948$var$blocklist = [
        'issueAggQuery'
    ];
    const $1a035cb2d3f2c948$export$9dec0f42cc67f6ab = (queryName, operationKind)=>{
        if (operationKind === 'query') return 0, $3lpdA.RETRY_ATTEMPTS_LIMIT;
        return 0;
    };
    const $1a035cb2d3f2c948$var$getTraceIdFromExtensions = ({ extensions: extensions })=>{
        if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.request_id === 'string') return extensions.gateway.request_id;
        return undefined;
    };
    const $1a035cb2d3f2c948$var$generateOptions = (options = {})=>{
        const csrfToken = !false ? (0, $5zSUY.default)() : undefined;
        const csrfTokenHeader = (0, ($parcel$interopDefault($ldoFd)))(csrfToken) ? {} : {
            'atl-xsrf-token': csrfToken
        };
        return (0, ($parcel$interopDefault($2vzCR)))({}, {
            ...(0, $fVqUX.default),
            ...options
        }, {
            headers: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'X-ExperimentalApi': (0, $7GiRY.default).join(','),
                ...csrfTokenHeader
            }
        });
    };
    const $1a035cb2d3f2c948$var$checkAuthentication = ()=>{
        if (!false && !$1a035cb2d3f2c948$var$redirecting) {
            const heartbeatService = (0, $jV8ng.getInstance)();
            if (heartbeatService.isInitialized() && !heartbeatService.isAuthenticated()) {
                $1a035cb2d3f2c948$var$redirect();
                $1a035cb2d3f2c948$var$redirecting = true;
            }
        }
    };
    const $1a035cb2d3f2c948$export$7bfea3c3d460ecd8 = (error)=>{
        if (error instanceof (0, $7byHA.default)) return [
            502,
            503,
            504
        ].includes(error.statusCode);
        return false;
    };
    const $1a035cb2d3f2c948$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig)=>{
        $1a035cb2d3f2c948$var$checkAuthentication();
        if ($1a035cb2d3f2c948$var$redirecting) return (0, $cNy9K.Observable).from(new Promise(()=>{}));
        const { name: queryName, operationKind: operationKind } = request;
        const earlyScriptPromise = !false && (0, $8tomX.claimEarlyScriptPromise)((0, $8tomX.getEarlyScriptPromiseKey)(request, variables)) || undefined;
        const loggingMetadata = {
            queryName: queryName,
            operationKind: operationKind
        };
        const loggingAndMetrics = (0, $ixYrr.getLoggingAndMetricsHelper)(loggingMetadata);
        return (0, $cNy9K.Observable).create((sink)=>{
            try {
                const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
                const endpoint = (0, $51rO4.getAggEndpoint)(request, cacheConfig);
                const body = (0, $51rO4.getRequestBody)(request, variables);
                let ssrCache = null;
                if (!false && requestID != null) ssrCache = (0, $j7fph.QueryResponseCache).get(requestID, variables);
                if (!false && !(0, ($parcel$interopDefault($ldoFd)))(ssrCache)) {
                    sink.next(ssrCache);
                    if (requestID != null) (0, $j7fph.QueryResponseCache).delete(requestID, variables);
                    sink.complete();
                    return;
                }
                const wrappedEarlyScriptPromise = earlyScriptPromise && (0, $3lpdA.retryOnError)(()=>(0, $lRmyA.applyErrorHandling)(earlyScriptPromise), {
                    retryFunc: ()=>(0, $lRmyA.performPostRequest)(endpoint, $1a035cb2d3f2c948$var$generateOptions({
                            body: body
                        })),
                    retryPredicate: $1a035cb2d3f2c948$export$7bfea3c3d460ecd8,
                    retryAttempts: $1a035cb2d3f2c948$export$9dec0f42cc67f6ab(queryName, operationKind),
                    onRetry: loggingAndMetrics.logErrorRetry
                });
                const promise = !false && wrappedEarlyScriptPromise !== undefined ? wrappedEarlyScriptPromise : Promise.resolve((0, $lRmyA.performPostRequestWithRetry)(endpoint, {
                    ...$1a035cb2d3f2c948$var$generateOptions({
                        body: body
                    }),
                    retryPredicate: $1a035cb2d3f2c948$export$7bfea3c3d460ecd8,
                    retryAttempts: $1a035cb2d3f2c948$export$9dec0f42cc67f6ab(queryName, operationKind),
                    onRetry: (error, attempt)=>{
                        loggingAndMetrics.logErrorRetry(error, attempt);
                    }
                }));
                promise.then((response)=>{
                    (0, $7qse3.addTraceId)(queryName, $1a035cb2d3f2c948$var$getTraceIdFromExtensions(response));
                    (0, $mk6Qw.putExtensions)(queryName, response.extensions);
                    const errors = response.errors || undefined;
                    if (errors != null) {
                        const requestId = response?.extensions?.gateway?.request_id;
                        if (!$1a035cb2d3f2c948$var$blocklist.includes(queryName)) loggingAndMetrics.logNonBreakingErrors(errors, requestId);
                        (0, $15ZJO.captureErrors)(errors, {
                            operationName: queryName,
                            requestId: requestId
                        });
                        if ((0, $15ZJO.isUnauthenticated)(errors)) {
                            (0, $iuC8B.showUnauthenticatedFlag)(queryName);
                            return;
                        }
                    }
                    if (response.data && (response.data.jira === null || response.data.customerService === null)) response.data = null;
                    if (false && requestID != null) (0, $j7fph.QueryResponseCache).setWithMetadata(requestID, variables, response, loggingMetadata);
                    sink.next(response);
                    sink.complete();
                }).catch((error)=>{
                    loggingAndMetrics.logError(error);
                    sink.error(error);
                });
                if (requestID != null) (0, $c7ifG.QueryPromisesMap).set(requestID, promise);
            } catch (error) {
                loggingAndMetrics.logError(error);
                sink.error(error);
            }
        });
    };
});
parcelRegister("lRmyA", function(module, exports) {
    $parcel$export(module.exports, "transformValidationErrorFromServer", ()=>$ec20d578245eedba$export$8e9baed7697e4959);
    $parcel$export(module.exports, "applyErrorHandling", ()=>$ec20d578245eedba$export$e174dc943a170ff);
    $parcel$export(module.exports, "performGetRequest", ()=>$ec20d578245eedba$export$4a53ae1be8ec80c7);
    $parcel$export(module.exports, "performPutRequest", ()=>$ec20d578245eedba$export$9ead1f9103e6de6b);
    $parcel$export(module.exports, "performPostRequest", ()=>$ec20d578245eedba$export$692a4d9808143175);
    $parcel$export(module.exports, "performDeleteRequest", ()=>$ec20d578245eedba$export$8ef51cba9d28f819);
    $parcel$export(module.exports, "performPatchRequest", ()=>$ec20d578245eedba$export$52be6ab13d7e758d);
    $parcel$export(module.exports, "performGetRequestWithRetry", ()=>$ec20d578245eedba$export$659b5ee69e6eb976);
    $parcel$export(module.exports, "performPutRequestWithRetry", ()=>$ec20d578245eedba$export$d7b48b2904a5d812);
    $parcel$export(module.exports, "performPostRequestWithRetry", ()=>$ec20d578245eedba$export$a5717cbee13f28b7);
    var $fVqUX = parcelRequire("fVqUX");
    var $1ybV0 = parcelRequire("1ybV0");
    var $gZ48R = parcelRequire("gZ48R");
    var $7byHA = parcelRequire("7byHA");
    var $bH2vr = parcelRequire("bH2vr");
    var $etaBp = parcelRequire("etaBp");
    var $3lpdA = parcelRequire("3lpdA");
    var $jxATW = parcelRequire("jxATW");
    const $ec20d578245eedba$var$transformFieldErrorsFromServer = (fieldErrors)=>Object.keys(fieldErrors).map((field)=>({
                field: field,
                error: fieldErrors[field]
            }));
    const $ec20d578245eedba$export$8e9baed7697e4959 = (json, statusCode, traceId)=>{
        const message = json.errorMessages ? json.errorMessages.join('; ') : 'validation failed';
        const fieldErrorsJson = json.errors ?? json.fieldErrors;
        const fieldErrors = fieldErrorsJson ? $ec20d578245eedba$var$transformFieldErrorsFromServer(fieldErrorsJson) : [];
        return new (0, $7byHA.ValidationError)(message, fieldErrors, statusCode, traceId, json);
    };
    const $ec20d578245eedba$var$putOptions = {
        ...(0, $fVqUX.default),
        method: 'PUT'
    };
    const $ec20d578245eedba$var$postOptions = {
        ...(0, $fVqUX.default),
        method: 'POST'
    };
    const $ec20d578245eedba$var$deleteOptions = {
        ...(0, $fVqUX.default),
        method: 'DELETE'
    };
    const $ec20d578245eedba$var$patchOptions = {
        ...(0, $fVqUX.default),
        method: 'PATCH'
    };
    const $ec20d578245eedba$var$handleNetworkErrors = (err)=>{
        if (err instanceof TypeError) throw new Error('Failed to fetch', {
            cause: err
        });
        throw err;
    };
    const $ec20d578245eedba$var$handleErrors = (response)=>{
        const traceId = (0, $jxATW.getTraceId)(response);
        if ((0, $1c3fbb431a173cc6$export$9de493bcd9b1d977) === response.status || (0, $1ybV0.ff)('issue.details.hard-limits.milestone-1') && (0, $1c3fbb431a173cc6$export$f90ac1df0b60853d) === response.status) return response.json().then((errorContent)=>{
            throw $ec20d578245eedba$export$8e9baed7697e4959(errorContent, response.status, traceId);
        });
        if (!response.ok) {
            if (traceId !== undefined && traceId.length > 0) {
                if ((0, $1ybV0.ff)('enable-returning-the-original-response_xn2bj')) throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, traceId, response);
                else throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, traceId);
            } else {
                if ((0, $1ybV0.ff)('enable-returning-the-original-response_xn2bj')) throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, undefined, response);
                else throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`);
            }
        }
        return response;
    };
    const $ec20d578245eedba$var$processResponseFromServer = (response)=>{
        if (response.status === (0, $1c3fbb431a173cc6$export$3288b14b6745c572)) return Promise.resolve(null);
        return response.text().then((text)=>text ? JSON.parse(text) : null);
    };
    const $ec20d578245eedba$export$e174dc943a170ff = (responsePromise)=>responsePromise.then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
    const $ec20d578245eedba$export$22411cbfb09a5c5c = (url, options)=>{
        const { retryPredicate: retryPredicate, retryAttempts: retryAttempts, onRetry: onRetry, ...requestOptions } = options;
        const executeRequest = ()=>$ec20d578245eedba$export$e174dc943a170ff(fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, requestOptions)));
        if ((0, $gZ48R.default)('platform_fetch_retries')) return executeRequest();
        return (0, $3lpdA.retryOnError)(executeRequest, {
            retryFunc: executeRequest,
            retryPredicate: retryPredicate,
            retryAttempts: retryAttempts,
            onRetry: onRetry
        });
    };
    const $ec20d578245eedba$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
            ...(0, $fVqUX.default),
            ...options
        })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
    const $ec20d578245eedba$export$9ead1f9103e6de6b = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
            ...$ec20d578245eedba$var$putOptions,
            ...options
        })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
    const $ec20d578245eedba$export$692a4d9808143175 = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
            ...$ec20d578245eedba$var$postOptions,
            ...options
        })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
    const $ec20d578245eedba$export$8ef51cba9d28f819 = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
            ...$ec20d578245eedba$var$deleteOptions,
            ...options
        })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
    const $ec20d578245eedba$export$52be6ab13d7e758d = (url, options = {})=>fetch((0, $bH2vr.getReroutableURL)(url), (0, $etaBp.applyObservabilityHeaders)(url, {
            ...$ec20d578245eedba$var$patchOptions,
            ...options
        })).then($ec20d578245eedba$var$handleErrors).then($ec20d578245eedba$var$processResponseFromServer).catch($ec20d578245eedba$var$handleNetworkErrors);
    const $ec20d578245eedba$export$659b5ee69e6eb976 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
            ...(0, $fVqUX.default),
            ...options
        });
    const $ec20d578245eedba$export$d7b48b2904a5d812 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
            ...$ec20d578245eedba$var$putOptions,
            ...options
        });
    const $ec20d578245eedba$export$a5717cbee13f28b7 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
            ...$ec20d578245eedba$var$postOptions,
            ...options
        });
    const $ec20d578245eedba$export$6d01bf1146815b9b = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
            ...$ec20d578245eedba$var$deleteOptions,
            ...options
        });
    const $ec20d578245eedba$export$560989ee94ad2a20 = (url, options)=>$ec20d578245eedba$export$22411cbfb09a5c5c(url, {
            ...$ec20d578245eedba$var$patchOptions,
            ...options
        });
});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;
parcelRegister("3lpdA", function(module, exports) {
    $parcel$export(module.exports, "RETRY_ATTEMPTS_LIMIT", ()=>$689a3993c77053c8$export$81189edc9b923717);
    $parcel$export(module.exports, "retryOnError", ()=>$689a3993c77053c8$export$f859c88bfac2cf2c);
    const $689a3993c77053c8$export$81189edc9b923717 = 1;
    const $689a3993c77053c8$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $689a3993c77053c8$export$81189edc9b923717, onRetry: onRetry })=>{
        const maxAttempts = retryAttempts > $689a3993c77053c8$export$81189edc9b923717 ? $689a3993c77053c8$export$81189edc9b923717 : retryAttempts;
        const execute = async (getPromise, retryAttempt = 0)=>{
            try {
                return await getPromise();
            } catch (error) {
                const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
                if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                    onRetry && onRetry(error, retryAttempt + 1);
                    return execute(retryFunc, retryAttempt + 1);
                }
                throw error;
            }
        };
        return execute(initialPromiseGetter);
    };
});
parcelRegister("15ZJO", function(module, exports) {
    $parcel$export(module.exports, "startCaptureGraphQlErrors", ()=>$2d32667fee5bd79d$export$c211170518c6d0f6);
    $parcel$export(module.exports, "stopCaptureGraphQlErrors", ()=>$2d32667fee5bd79d$export$e0491a0d974dadfa);
    $parcel$export(module.exports, "captureErrors", ()=>$2d32667fee5bd79d$export$7a973c0ff390eb47);
    $parcel$export(module.exports, "isUnauthenticated", ()=>$2d32667fee5bd79d$export$1724ecfee73c4768);
    var $hompL = parcelRequire("hompL");
    const $2d32667fee5bd79d$var$errorCollector = new Map();
    const $2d32667fee5bd79d$export$da396ad2a542b095 = 120000;
    const $2d32667fee5bd79d$var$scheduleCleanup = (key)=>{
        setTimeout(()=>{
            $2d32667fee5bd79d$var$errorCollector.delete(key);
        }, $2d32667fee5bd79d$export$da396ad2a542b095);
    };
    const $2d32667fee5bd79d$export$c211170518c6d0f6 = (key = (0, ($parcel$interopDefault($hompL))).v4())=>{
        $2d32667fee5bd79d$var$errorCollector.set(key, []);
        $2d32667fee5bd79d$var$scheduleCleanup(key);
        return key;
    };
    const $2d32667fee5bd79d$export$e0491a0d974dadfa = (key)=>{
        const errors = $2d32667fee5bd79d$var$errorCollector.get(key);
        $2d32667fee5bd79d$var$errorCollector.delete(key);
        return errors || [];
    };
    const $2d32667fee5bd79d$export$7a973c0ff390eb47 = (errors, meta)=>{
        if (errors) $2d32667fee5bd79d$var$errorCollector.forEach((value, key)=>{
            $2d32667fee5bd79d$var$errorCollector.set(key, [
                ...value,
                {
                    errors: errors,
                    meta: meta
                }
            ]);
        });
    };
    const $2d32667fee5bd79d$export$1724ecfee73c4768 = (errors)=>{
        if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
        return false;
    };
});
parcelRegister("7GiRY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a04fa54516e5a2d1$export$2e2bcd8739ae039);
    var $a04fa54516e5a2d1$export$2e2bcd8739ae039 = [
        'ariGraph',
        'boardCardMove',
        'deleteCard',
        'JiraJqlBuilder',
        'SoftwareCardTypeTransitions',
        'jira-releases-v0',
        'JiraDevOps',
        'JiraDevOpsProviders',
        'createCustomFilter',
        'updateCustomFilter',
        'deleteCustomFilter',
        'customFilters',
        'PermissionScheme',
        'JiraIssue',
        'projectStyle',
        'startSprintPrototype',
        'AddIssuesToFixVersion',
        'JiraVersionResult',
        'JiraIssueConnectionJql',
        'JiraFieldOptionSearching',
        'JiraIssueFieldMutations',
        'JiraIssueDevInfoDetails',
        'JiraIssueDevSummaryCache',
        'JiraVersionWarningConfig',
        'JiraReleaseNotesConfiguration',
        'JiraUpdateReleaseNotesConfiguration',
        'ReleaseNotes',
        'ReleaseNotesOptions',
        'DeploymentsFeaturePrecondition',
        'UpdateVersionWarningConfig',
        'UpdateVersionName',
        'UpdateVersionDescription',
        'UpdateVersionStartDate',
        'UpdateVersionReleaseDate',
        'VersionsForProject',
        'RelatedWork',
        'SuggestedRelatedWorkCategories',
        'setIssueMediaVisibility',
        'toggleBoardFeature',
        'DevOpsProvider',
        'DevOpsSummarisedDeployments',
        'virtual-agent-beta',
        'JiraProject',
        'DevOpsSummarisedEntities',
        'RoadmapsMutation',
        'RoadmapsQuery',
        'JiraApplicationProperties',
        'JiraIssueSearch',
        'JiraFilter',
        'featureGroups',
        'setBoardEstimationType',
        'devOps',
        'softwareBoards',
        'name',
        'AddRelatedWorkToVersion',
        'RemoveRelatedWorkFromVersion',
        'admins',
        'canAdministerBoard',
        'jql',
        'globalCardCreateAdditionalFields',
        'GlobalTimeTrackingSettings',
        'ReleaseNotesOptions',
        'search-experience',
        'MoveOrRemoveIssuesToFixVersion',
        'compass-beta',
        'JiraIssueSearchStatus',
        'Townsquare',
        'JiraNavigationItems',
        'JiraVersionsForProjects',
        'columnConfigs'
    ];
});
parcelRegister("c7ifG", function(module, exports) {
    $parcel$export(module.exports, "QueryPromisesMap", ()=>$a238ea58a6cce413$export$607b80f5bc6e396d);
    const $a238ea58a6cce413$export$607b80f5bc6e396d = new Map();
});
parcelRegister("j7fph", function(module, exports) {
    $parcel$export(module.exports, "QueryResponseCache", ()=>$12adf5474a181883$export$688bd21be71b9e5d);
    var $9LXG4 = parcelRequire("9LXG4");
    var $illlw = parcelRequire("illlw");
    var $cNy9K = parcelRequire("cNy9K");
    var $gUUjF = parcelRequire("gUUjF");
    var $7byHA = parcelRequire("7byHA");
    var $9jJAD = parcelRequire("9jJAD");
    function $12adf5474a181883$export$611736262b635f8d(queryID, variables) {
        return JSON.stringify((0, $cNy9K.stableCopy)({
            queryID: queryID,
            variables: variables
        }));
    }
    function $12adf5474a181883$export$1e65e863cf3a0f21(cacheKey) {
        return JSON.parse(cacheKey).queryID;
    }
    class $12adf5474a181883$export$be21c283b097d175 extends (0, $cNy9K.QueryResponseCache) {
        constructor({ cacheName: cacheName, size: size, ttl: ttl }){
            super({
                size: size,
                ttl: ttl
            });
            const cachedData = false ? {} : window?.SPA_STATE?.[cacheName] || {};
            this.cacheName = cacheName;
            this.requestMetadata = new Map(cachedData.requestMetadata);
            this._responses = new Map(cachedData.responses);
            if (!false) setTimeout(()=>{
                this.logUnusedPayloadErrors();
                this.requestMetadata.clear();
                this._responses.clear();
            }, 60000);
        }
        logUnusedPayloadErrors() {
            const loggedQueries = new Set();
            this._responses.forEach((response, key)=>{
                const queryID = $12adf5474a181883$export$1e65e863cf3a0f21(key);
                const metadata = this.requestMetadata.get(queryID);
                const { queryName: queryName = 'unknown', operationKind: operationKind = 'unknown' } = metadata ?? {
                    queryName: 'unknown',
                    operationKind: 'unknown'
                };
                if (!loggedQueries.has(queryName)) {
                    loggedQueries.add(queryName);
                    const error = new (0, $9jJAD.UnusedRelayResponseError)(queryID);
                    const statusCode = (0, ($parcel$interopDefault($illlw)))(error, [
                        'statusCode'
                    ], null);
                    const errorType = error instanceof (0, $7byHA.default) ? 'network' : 'unknown';
                    (0, $gUUjF.default).safeErrorWithoutCustomerData('relay.AGG.error.graphql', `[${errorType} error]`, {
                        message: `[${(0, ($parcel$interopDefault($9LXG4)))(errorType)} error]: ${error?.message ?? ''}`,
                        errorType: errorType,
                        statusCode: statusCode,
                        queryName: queryName,
                        operationKind: operationKind,
                        errorName: (0, ($parcel$interopDefault($illlw)))(error, [
                            'name'
                        ], null)
                    });
                }
            });
        }
        setWithMetadata(queryID, variables, payload, metadata) {
            this.requestMetadata.set(queryID, metadata);
            this.set(queryID, variables, payload);
        }
        delete(queryID, variables) {
            const cacheKey = $12adf5474a181883$export$611736262b635f8d(queryID, variables);
            return this._responses.delete(cacheKey);
        }
        serialize() {
            return {
                [this.cacheName]: {
                    requestMetadata: Array.from(this.requestMetadata.entries()),
                    responses: Array.from(this._responses.entries())
                }
            };
        }
    }
    const $12adf5474a181883$export$688bd21be71b9e5d = new $12adf5474a181883$export$be21c283b097d175({
        cacheName: 'relay-cache/v2/AGG',
        size: Infinity,
        ttl: Infinity
    });
    const $12adf5474a181883$export$94e535e06b7ade61 = ()=>$12adf5474a181883$export$688bd21be71b9e5d.serialize();
});
parcelRegister("9jJAD", function(module, exports) {
    $parcel$export(module.exports, "UnusedRelayResponseError", ()=>$1b0cdf803f3ea26f$export$8431e42d062de453);
    class $1b0cdf803f3ea26f$export$8431e42d062de453 extends Error {
        constructor(queryID){
            super(`Relay Query ${queryID} was made during SSR but never used in the browser`);
            this.name = 'UnusedRelayResponseError';
        }
    }
});
parcelRegister("8tomX", function(module, exports) {
    $parcel$export(module.exports, "getEarlyScriptPromiseKey", ()=>$da6663b8ee5823ed$export$1102c06c7da91223);
    $parcel$export(module.exports, "claimEarlyScriptPromise", ()=>$da6663b8ee5823ed$export$828ac0325bce4536);
    $parcel$export(module.exports, "earlyFetch", ()=>$da6663b8ee5823ed$export$5b55058781674413);
    var $lLasf = parcelRequire("lLasf");
    var $fqqil = parcelRequire("fqqil");
    var $dvy3D = parcelRequire("dvy3D");
    var $51rO4 = parcelRequire("51rO4");
    const $da6663b8ee5823ed$var$CAPABILITY_HEADER_NAME = 'X-Atlassian-Capability';
    const $da6663b8ee5823ed$export$b5fbc1430cbfd6e1 = (value)=>value;
    const $da6663b8ee5823ed$export$6d670d323806bb37 = new Map();
    const $da6663b8ee5823ed$export$1102c06c7da91223 = (params, variables)=>{
        const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
        const serializedVariables = variables != null ? JSON.stringify(variables, Object.keys(variables).sort()) : '';
        return `${params.name}|${String(queryId)}|${serializedVariables}`;
    };
    const $da6663b8ee5823ed$export$828ac0325bce4536 = (key)=>{
        const result = $da6663b8ee5823ed$export$6d670d323806bb37.get(key);
        if (result != null) $da6663b8ee5823ed$export$6d670d323806bb37.delete(key);
        return result;
    };
    const $da6663b8ee5823ed$export$e1336d32be02faf4 = (key, promise)=>{
        if (!$da6663b8ee5823ed$export$6d670d323806bb37.has(key)) $da6663b8ee5823ed$export$6d670d323806bb37.set(key, promise);
    };
    const $da6663b8ee5823ed$export$5b55058781674413 = (compiledQuery, variables, experimentalApis = [], capability)=>{
        (0, $lLasf.setMark)('jira.fe-spa.early-preload:start');
        const endpoint = (0, $51rO4.getAggEndpoint)(compiledQuery.params);
        const body = (0, $51rO4.getRequestBody)(compiledQuery.params, variables);
        const capabilityHeader = (0, $fqqil.getEnhancedCapabilityHeader)(capability ?? null);
        $da6663b8ee5823ed$export$e1336d32be02faf4($da6663b8ee5823ed$export$1102c06c7da91223(compiledQuery.params, variables), fetch(endpoint, {
            credentials: 'same-origin',
            headers: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'Content-Type': 'application/json',
                Accept: 'application/json,text/javascript,*/*',
                'X-ExperimentalApi': experimentalApis.join(','),
                ...(0, $dvy3D.getActiveTraceHttpRequestHeaders)(endpoint),
                ...capabilityHeader ? {
                    [$da6663b8ee5823ed$var$CAPABILITY_HEADER_NAME]: capabilityHeader
                } : {}
            },
            method: 'POST',
            body: body
        }).then((response)=>{
            (0, $lLasf.setMark)('jira.fe-spa.early-preload:end');
            return response;
        }));
    };
});
parcelRegister("lLasf", function(module, exports) {
    $parcel$export(module.exports, "setMark", ()=>$bbbf8be69ced3a7f$export$f7a1fb90d8604165);
    $parcel$export(module.exports, "getTraceId", ()=>$bbbf8be69ced3a7f$export$e88cb5bfb57ce9c4);
    const $bbbf8be69ced3a7f$export$f7a1fb90d8604165 = (mark)=>{
        if (typeof performance !== 'object' || typeof performance.mark !== 'function') return;
        performance.mark(mark);
    };
    const $bbbf8be69ced3a7f$var$TRACE_ID_HEADER = 'atl-traceid';
    const $bbbf8be69ced3a7f$var$TRACE_ID_HEADER_MICROS = 'x-trace-id';
    const $bbbf8be69ced3a7f$export$e88cb5bfb57ce9c4 = (response)=>response.headers.get($bbbf8be69ced3a7f$var$TRACE_ID_HEADER) || response.headers.get($bbbf8be69ced3a7f$var$TRACE_ID_HEADER_MICROS);
});
parcelRegister("iuC8B", function(module, exports) {
    $parcel$export(module.exports, "showUnauthenticatedFlag", ()=>$768eb5f0fcd8b90f$export$758fcc357484571e);
    var $k8Qyf = parcelRequire("k8Qyf");
    var $3FyZ4 = parcelRequire("3FyZ4");
    var $glrJM = parcelRequire("glrJM");
    const $768eb5f0fcd8b90f$var$reloadPage = ()=>window.location.reload();
    const $768eb5f0fcd8b90f$var$sendAnalyticEvent = (operationName)=>{
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return;
            analyticsClient.sendTrackEvent({
                action: 'showed',
                actionSubject: 'unauthorizedFlag',
                attributes: {
                    operation: operationName
                },
                source: 'jiraRelayFetch'
            });
        });
    };
    const $768eb5f0fcd8b90f$export$758fcc357484571e = (operationName)=>{
        (0, $k8Qyf.showFlag)({
            type: 'error',
            title: (0, $glrJM.default).title,
            description: (0, $glrJM.default).description,
            actions: [
                {
                    content: (0, $glrJM.default).login,
                    onClick: $768eb5f0fcd8b90f$var$reloadPage
                }
            ]
        });
        $768eb5f0fcd8b90f$var$sendAnalyticEvent(operationName);
    };
});
parcelRegister("k8Qyf", function(module, exports) {
    $parcel$export(module.exports, "showFlag", ()=>$eeec0389d5aa91e2$export$e12b2cc6b75b006b);
    $parcel$export(module.exports, "dismissFlag", ()=>$eeec0389d5aa91e2$export$900a08a292ad23cd);
    $parcel$export(module.exports, "flagService", ()=>$eeec0389d5aa91e2$export$dbb055af53fd81a0);
    $parcel$export(module.exports, "useFlagsService", ()=>$eeec0389d5aa91e2$export$eee61a1aafe3884);
    $parcel$export(module.exports, "useFlagService", ()=>$eeec0389d5aa91e2$export$dc4f8132c3090b32);
    $parcel$export(module.exports, "isDismissFlag", ()=>$eeec0389d5aa91e2$export$14b1864d9cf0809f);
    $parcel$export(module.exports, "isFlagComponent", ()=>$eeec0389d5aa91e2$export$d84ce5adcee46025);
    $parcel$export(module.exports, "isBatchAction", ()=>$eeec0389d5aa91e2$export$c126d8b307b8ab86);
    var $8vPhU = parcelRequire("8vPhU");
    var $bbbyK = parcelRequire("bbbyK");
    var $lawuT = parcelRequire("lawuT");
    var $eo17r = parcelRequire("eo17r");
    const $eeec0389d5aa91e2$export$e12b2cc6b75b006b = (0, $bbbyK.default)((0, $lawuT.store).dispatch);
    const $eeec0389d5aa91e2$export$900a08a292ad23cd = (0, $8vPhU.default)((0, $lawuT.store).dispatch);
    const $eeec0389d5aa91e2$var$dismissFlagById = (id)=>{
        $eeec0389d5aa91e2$export$900a08a292ad23cd((0, $8vPhU.dismissFlag)(id));
    };
    const $eeec0389d5aa91e2$var$hasFlag = (id)=>Boolean((0, $lawuT.store).getState().flags.find((flagInstance)=>'id' in flagInstance.flag && flagInstance.flag.id === id));
    const $eeec0389d5aa91e2$export$dbb055af53fd81a0 = {
        showFlag: $eeec0389d5aa91e2$export$e12b2cc6b75b006b,
        dismissFlag: $eeec0389d5aa91e2$export$900a08a292ad23cd
    };
    const $eeec0389d5aa91e2$export$eee61a1aafe3884 = ()=>({
            showFlag: $eeec0389d5aa91e2$export$e12b2cc6b75b006b,
            dismissFlag: $eeec0389d5aa91e2$var$dismissFlagById,
            hasFlag: $eeec0389d5aa91e2$var$hasFlag
        });
    const $eeec0389d5aa91e2$export$dc4f8132c3090b32 = ()=>$eeec0389d5aa91e2$export$dbb055af53fd81a0;
    const $eeec0389d5aa91e2$export$14b1864d9cf0809f = (flag)=>typeof flag === 'object' && 'command' in flag && flag.command === (0, $eo17r.DISMISS_COMMAND);
    const $eeec0389d5aa91e2$export$d84ce5adcee46025 = (flag)=>typeof flag === 'function' && !('type' in flag) && !('render' in flag);
    const $eeec0389d5aa91e2$export$cd5f9f2b991b82d9 = (flag)=>typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';
    const $eeec0389d5aa91e2$export$63ffd7d99470afd4 = (flag)=>!$eeec0389d5aa91e2$export$14b1864d9cf0809f(flag) && !$eeec0389d5aa91e2$export$d84ce5adcee46025(flag) && !$eeec0389d5aa91e2$export$cd5f9f2b991b82d9(flag);
    const $eeec0389d5aa91e2$export$c126d8b307b8ab86 = (action)=>'meta' in action && action.meta && action.meta.batch && 'payload' in action && Array.isArray(action.payload);
});
parcelRegister("8vPhU", function(module, exports) {
    $parcel$export(module.exports, "dismissFlag", ()=>$39af67031ab9f922$export$900a08a292ad23cd);
    $parcel$export(module.exports, "default", ()=>$39af67031ab9f922$export$2e2bcd8739ae039);
    var $bSS3k = parcelRequire("bSS3k");
    var $eo17r = parcelRequire("eo17r");
    const $39af67031ab9f922$export$900a08a292ad23cd = (flagId)=>({
            command: (0, $eo17r.DISMISS_COMMAND),
            id: flagId
        });
    var $39af67031ab9f922$export$2e2bcd8739ae039 = (dispatch)=>(action)=>{
            dispatch((0, $bSS3k.dismissFlagAction)(action.id));
        };
});
parcelRegister("bSS3k", function(module, exports) {
    $parcel$export(module.exports, "SHOW", ()=>$953f8b1833086611$export$9d04158a25ce4cd);
    $parcel$export(module.exports, "show", ()=>$953f8b1833086611$export$57bf213be019eeb0);
    $parcel$export(module.exports, "DISMISS_INSTANCE", ()=>$953f8b1833086611$export$b31a07d2e6382678);
    $parcel$export(module.exports, "dismiss", ()=>$953f8b1833086611$export$abf286bbe7073aba);
    $parcel$export(module.exports, "DISMISS_FLAG", ()=>$953f8b1833086611$export$1eb56620df104bf);
    $parcel$export(module.exports, "dismissFlagAction", ()=>$953f8b1833086611$export$4818b3c52448050d);
    $parcel$export(module.exports, "RESET", ()=>$953f8b1833086611$export$4a991c87e640ef77);
    $parcel$export(module.exports, "reset", ()=>$953f8b1833086611$export$aad8462122ac592b);
    const $953f8b1833086611$export$9d04158a25ce4cd = 'state.SHOW';
    const $953f8b1833086611$export$57bf213be019eeb0 = (payload)=>({
            type: $953f8b1833086611$export$9d04158a25ce4cd,
            payload: payload
        });
    const $953f8b1833086611$export$b31a07d2e6382678 = 'state.DISMISS_INSTANCE';
    const $953f8b1833086611$export$abf286bbe7073aba = (payload)=>({
            type: $953f8b1833086611$export$b31a07d2e6382678,
            payload: payload
        });
    const $953f8b1833086611$export$1eb56620df104bf = 'state.DISMISS_FLAG';
    const $953f8b1833086611$export$4818b3c52448050d = (payload)=>({
            type: $953f8b1833086611$export$1eb56620df104bf,
            payload: payload
        });
    const $953f8b1833086611$export$4a991c87e640ef77 = 'state.RESET';
    const $953f8b1833086611$export$aad8462122ac592b = ()=>({
            type: $953f8b1833086611$export$4a991c87e640ef77
        });
});
parcelRegister("eo17r", function(module, exports) {
    $parcel$export(module.exports, "DISMISS_COMMAND", ()=>$2e7952269e32b2ae$export$e705274c5e156b93);
    $parcel$export(module.exports, "toFlagId", ()=>$2e7952269e32b2ae$export$8184bc29de2aea90);
    $parcel$export(module.exports, "fromFlagId", ()=>$2e7952269e32b2ae$export$188cdb77b72629d7);
    const $2e7952269e32b2ae$export$e705274c5e156b93 = 'DISMISS';
    const $2e7952269e32b2ae$export$8184bc29de2aea90 = (flagId)=>new String(flagId);
    const $2e7952269e32b2ae$export$188cdb77b72629d7 = (flagId)=>flagId.valueOf();
});
parcelRegister("bbbyK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7364d7b2414b4fa5$export$2e2bcd8739ae039);
    var $hompL = parcelRequire("hompL");
    var $bSS3k = parcelRequire("bSS3k");
    var $eo17r = parcelRequire("eo17r");
    var $7364d7b2414b4fa5$export$2e2bcd8739ae039 = (dispatch)=>(flag)=>{
            if (typeof flag === 'function') {
                dispatch((0, $bSS3k.show)(flag));
                return undefined;
            }
            const flagId = flag.id || (0, $eo17r.toFlagId)((0, ($parcel$interopDefault($hompL))).v4());
            const newFlag = {
                ...flag,
                id: flagId
            };
            dispatch((0, $bSS3k.show)(newFlag));
            return flagId;
        };
});
parcelRegister("lawuT", function(module, exports) {
    $parcel$export(module.exports, "store", ()=>$58565b45d694aa17$export$6f57813fe9f31bf9);
    var $l32oR = parcelRequire("l32oR");
    const $58565b45d694aa17$export$6f57813fe9f31bf9 = (0, $l32oR.createStore)();
});
parcelRegister("l32oR", function(module, exports) {
    $parcel$export(module.exports, "createStore", ()=>$ecbe96b78b5bbffc$export$f51a9068ac82ea43);
    var $8FRHo = parcelRequire("8FRHo");
    var $b7i1H = parcelRequire("b7i1H");
    const $ecbe96b78b5bbffc$export$f51a9068ac82ea43 = (rootEpic)=>(0, $8FRHo.default)({
            appName: 'flags',
            rootReducer: $b7i1H.default,
            rootEpic: rootEpic
        });
});
parcelRegister("8FRHo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9cb42e111114ce77$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $huRi7 = parcelRequire("huRi7");
    var $MYW4e = parcelRequire("MYW4e");
    var $bd1K7 = parcelRequire("bd1K7");
    var $lfZsG = parcelRequire("lfZsG");
    var $czGdf = parcelRequire("czGdf");
    var $jQgix = parcelRequire("jQgix");
    var $9cb42e111114ce77$export$2e2bcd8739ae039 = ({ appName: appName, rootReducer: rootReducer, initialState: initialState, rootEpic: rootEpic, rootEpicDependencies: rootEpicDependencies, middlewares: middlewares = [], enhancers: enhancers = [] })=>{
        const actionListenerMiddleware = new (0, $jQgix.default)();
        middlewares.push(actionListenerMiddleware.perform);
        if ((0, $lfZsG.debugEnabled)('redux-logger')) {
            const { logger: logger } = (parcelRequire("iFajX"));
            middlewares.push(logger);
        }
        if (rootEpic) middlewares.push((0, $bd1K7.createEpicMiddleware)(rootEpic, rootEpicDependencies ? {
            dependencies: rootEpicDependencies
        } : undefined));
        const store = (0, $huRi7.createStore)((0, $MYW4e.enableBatching)(rootReducer), initialState, (0, $czGdf.default)({
            name: appName,
            serialize: {
                replacer: (key, value)=>{
                    if ((0, $eUqFw.isValidElement)(value)) {
                        if (value.type && value.type.displayName) return `React Element <${value.type.displayName}>`;
                        return 'React Element';
                    }
                    if (typeof HTMLElement !== 'undefined' && value instanceof HTMLElement) return `HTMLElement<${value.tagName}>`;
                    return value;
                }
            }
        })((0, $huRi7.compose)(...enhancers, (0, $huRi7.applyMiddleware)(...middlewares))));
        store.addActionListener = actionListenerMiddleware.add;
        store.removeActionListener = actionListenerMiddleware.remove;
        return store;
    };
});
parcelRegister("lfZsG", function(module, exports) {
    $parcel$export(module.exports, "debugEnabled", ()=>$bd927ad8c0ea4245$export$342c99cc1e9bc5c6);
    const $bd927ad8c0ea4245$export$342c99cc1e9bc5c6 = (flag)=>''.split(',').includes(flag);
});
parcelRegister("czGdf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$22794e51b2572269$export$2e2bcd8739ae039);
    var $huRi7 = parcelRequire("huRi7");
    var $22794e51b2572269$export$2e2bcd8739ae039 = (devtoolsConfig = {})=>{
        const devtoolsEnhancer = false ? null : window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
        const config = {
            ...devtoolsConfig
        };
        if (config.name != null && config.instanceId == null) config.instanceId = config.name;
        return 0, $huRi7.compose;
    };
});
parcelRegister("jQgix", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a7b4a5dd033617f8$export$2e2bcd8739ae039);
    class $a7b4a5dd033617f8$export$2e2bcd8739ae039 {
        constructor(){
            this.listeners = [];
            this.add = (listener)=>{
                this.listeners.push(listener);
            };
            this.remove = (listener)=>{
                this.listeners = this.listeners.filter((l)=>l !== listener);
            };
            this.perform = (api)=>(next)=>(action)=>{
                        const result = next(action);
                        this.listeners.forEach((listener)=>listener(action, api.getState()));
                        return result;
                    };
        }
    }
});
parcelRegister("b7i1H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2bd228b38d69c07$export$2e2bcd8739ae039);
    var $bwbFz = parcelRequire("bwbFz");
    var $hompL = parcelRequire("hompL");
    var $bSS3k = parcelRequire("bSS3k");
    const $d2bd228b38d69c07$var$defaultState = {
        flags: []
    };
    var $d2bd228b38d69c07$export$2e2bcd8739ae039 = (state = $d2bd228b38d69c07$var$defaultState, action)=>{
        switch(action.type){
            case 0, $bSS3k.SHOW:
                {
                    const [lowPriorityFlags, highPriorityFlags] = (0, ($parcel$interopDefault($bwbFz)))([
                        {
                            id: (0, ($parcel$interopDefault($hompL))).v4(),
                            flag: action.payload
                        },
                        ...state.flags
                    ], ({ flag: flag })=>typeof flag !== 'function' && flag?.isLowPriority);
                    const flags = [
                        ...highPriorityFlags,
                        ...lowPriorityFlags
                    ];
                    return {
                        ...state,
                        flags: flags
                    };
                }
            case 0, $bSS3k.DISMISS_INSTANCE:
                {
                    const id = action.payload;
                    return {
                        ...state,
                        flags: state.flags.filter((flagInstance)=>flagInstance.id !== id)
                    };
                }
            case 0, $bSS3k.DISMISS_FLAG:
                {
                    const id = action.payload;
                    return {
                        ...state,
                        flags: state.flags.filter((flagInstance)=>{
                            if (flagInstance.flag.id) return flagInstance.flag.id !== id;
                            return true;
                        })
                    };
                }
            case 0, $bSS3k.RESET:
                return $d2bd228b38d69c07$var$defaultState;
            default:
                {
                    const _exhaustiveCheck = action;
                    return state;
                }
        }
    };
});
parcelRegister("glrJM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1963f04f48a97eb6$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    var $1963f04f48a97eb6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
        title: {
            "id": "relay-fetch.services.error-flags.title",
            "defaultMessage": "Something's gone wrong"
        },
        description: {
            "id": "relay-fetch.services.error-flags.description",
            "defaultMessage": "Looks like you've been signed out. Try logging in again. "
        },
        login: {
            "id": "relay-fetch.services.error-flags.login",
            "defaultMessage": "Log in"
        }
    });
});
parcelRegister("ixYrr", function(module, exports) {
    $parcel$export(module.exports, "getLoggingAndMetricsHelper", ()=>$39705662ea381df8$export$726e1df8186bb981);
    var $9LXG4 = parcelRequire("9LXG4");
    var $illlw = parcelRequire("illlw");
    var $ldoFd = parcelRequire("ldoFd");
    var $gUUjF = parcelRequire("gUUjF");
    var $7byHA = parcelRequire("7byHA");
    const $39705662ea381df8$var$LOG_NAMESPACE = 'relay.AGG.error.graphql';
    const $39705662ea381df8$export$726e1df8186bb981 = (graphqlDetails)=>{
        const { queryName: queryName, operationKind: operationKind } = graphqlDetails;
        return {
            logNonBreakingErrors: (errors, requestId)=>{
                if (false || (0, ($parcel$interopDefault($ldoFd)))(errors) || !Array.isArray(errors)) return;
                errors.forEach((error)=>{
                    error && (0, $gUUjF.default).safeErrorWithoutCustomerData($39705662ea381df8$var$LOG_NAMESPACE, '[graphql error]', {
                        queryName: queryName,
                        operationKind: operationKind,
                        errorType: 'graphql',
                        message: error.message,
                        requestId: requestId
                    });
                });
            },
            logError: (error)=>{
                const statusCode = (0, ($parcel$interopDefault($illlw)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $7byHA.default) ? 'network' : 'unknown';
                (0, $gUUjF.default).safeErrorWithoutCustomerData($39705662ea381df8$var$LOG_NAMESPACE, `[${errorType} error]`, {
                    message: `[${(0, ($parcel$interopDefault($9LXG4)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, ($parcel$interopDefault($illlw)))(error, [
                        'name'
                    ], null)
                });
            },
            logErrorRetry: (error, retryAttempt)=>{
                const statusCode = (0, ($parcel$interopDefault($illlw)))(error, [
                    'statusCode'
                ], null);
                const errorType = error instanceof (0, $7byHA.default) ? 'network' : 'unknown';
                (0, $gUUjF.default).safeErrorWithoutCustomerData($39705662ea381df8$var$LOG_NAMESPACE, `[${errorType} error]`, {
                    message: `[${(0, ($parcel$interopDefault($9LXG4)))(errorType)} error]: ${error?.message ?? ''}`,
                    errorType: errorType,
                    statusCode: statusCode,
                    queryName: queryName,
                    operationKind: operationKind,
                    errorName: (0, ($parcel$interopDefault($illlw)))(error, [
                        'name'
                    ], null),
                    retryAttempt: retryAttempt
                });
            }
        };
    };
});
parcelRegister("4aLdW", function(module, exports) {
    $parcel$export(module.exports, "subscribe", ()=>$ef96f447a7409c6e$export$ec068583843480e7);
    var $cNy9K = parcelRequire("cNy9K");
    var $guiFP = parcelRequire("guiFP");
    var $dIOaC = parcelRequire("dIOaC");
    var $lE8MM = parcelRequire("lE8MM");
    var $keguF = parcelRequire("keguF");
    const $ef96f447a7409c6e$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $cNy9K.Observable).create((sink)=>{
            const client = (0, $dIOaC.getClient)();
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id
                }
            };
            let requestId;
            return client.subscribe(payload, {
                ...sink,
                next: (value)=>{
                    const aggRequestId = value?.extensions?.agg?.request_id;
                    requestId = aggRequestId ?? requestId;
                    sink.next(value);
                },
                error: (sinkError)=>{
                    const errorInfo = (0, $lE8MM.getSinkError)(sinkError);
                    const attributes = {
                        operationName: operationName,
                        requestId: requestId,
                        userLocation: (0, $keguF.getUserLocation)()
                    };
                    sink.error(errorInfo);
                    (0, $guiFP.default)({
                        meta: {
                            id: 'subscription',
                            packageName: 'jiraRelaySubscription',
                            teamName: 'uip-graphql'
                        },
                        error: errorInfo,
                        attributes: attributes,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        });
});
parcelRegister("dIOaC", function(module, exports) {
    $parcel$export(module.exports, "getClient", ()=>$176ec127fee3e1b6$export$6bb76d6eba7e258c);
    var $9RGox = parcelRequire("9RGox");
    var $gZ48R = parcelRequire("gZ48R");
    var $7GiRY = parcelRequire("7GiRY");
    var $eliQU = parcelRequire("eliQU");
    let $176ec127fee3e1b6$var$client;
    const $176ec127fee3e1b6$export$6bb76d6eba7e258c = ()=>{
        if ((0, $eliQU.isSSR)() || (0, $gZ48R.default)('graphql_subscriptions')) return null;
        if (!$176ec127fee3e1b6$var$client) $176ec127fee3e1b6$var$client = (0, $9RGox.createClient)({
            url: (0, $eliQU.getAggSubscriptionEndpoint)(),
            lazy: true,
            keepAlive: (0, $12457a63a9fa501a$export$8b012b965402e06a),
            retryAttempts: (0, $12457a63a9fa501a$export$bf6cd96e19b2987f),
            connectionParams: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
                'X-ExperimentalApi': (0, $7GiRY.default).join(',')
            }
        });
        return $176ec127fee3e1b6$var$client;
    };
    const $176ec127fee3e1b6$export$2f0afd443356d36f = ()=>{
        $176ec127fee3e1b6$var$client = null;
    };
});
const $12457a63a9fa501a$export$8b012b965402e06a = 580000;
const $12457a63a9fa501a$export$bf6cd96e19b2987f = 100;
const $12457a63a9fa501a$export$1ad8434180c5936c = 300000;
parcelRegister("eliQU", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$dea6d52502362b12$export$48d7c418edadb60c);
    $parcel$export(module.exports, "getAggSubscriptionEndpoint", ()=>$dea6d52502362b12$export$29a72e89601dfc59);
    const $dea6d52502362b12$export$48d7c418edadb60c = ()=>false ?? false;
    const $dea6d52502362b12$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
});
parcelRegister("lE8MM", function(module, exports) {
    $parcel$export(module.exports, "getSinkError", ()=>$8f86032d91fec6de$export$ece4736473c28965);
    const $8f86032d91fec6de$export$ece4736473c28965 = (error)=>{
        let errorInfo;
        if (Array.isArray(error)) [errorInfo] = error;
        else if (error instanceof Error) errorInfo = error;
        else if (typeof error === 'object' && 'type' in error && error.type === 'close') errorInfo = new Error(`CloseEvent: ${error.reason}`);
        else if (error instanceof Event) errorInfo = new Error(`Event: ${error.type}`);
        else errorInfo = new Error(`Unknown sink error: ${error}`);
        return errorInfo;
    };
});
parcelRegister("b3wL2", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$624029006652488f$export$48d7c418edadb60c);
    const $624029006652488f$export$48d7c418edadb60c = ()=>false ?? false;
});
parcelRegister("boTUp", function(module, exports) {
    $parcel$export(module.exports, "removeRedundantPreloads", ()=>$f334fadd26cc659d$export$a5b3b808f05fede2);
    $parcel$export(module.exports, "removeInactiveLoads", ()=>$f334fadd26cc659d$export$ae329fe3ea179cb4);
    $parcel$export(module.exports, "removeAll", ()=>$f334fadd26cc659d$export$1cfc7aad5cb1833b);
    $parcel$export(module.exports, "useEntryPointReferenceSubject", ()=>$f334fadd26cc659d$export$322c8997d351da6a);
    var $eUqFw = parcelRequire("eUqFw");
    var $lEfVV = parcelRequire("lEfVV");
    const $f334fadd26cc659d$export$a5b3b808f05fede2 = (queue)=>{
        const [, ...potentialRedundantItems] = queue;
        potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
            if (isPreload) value.dispose();
        });
        return queue.filter(({ value: value })=>!value.isDisposed);
    };
    const $f334fadd26cc659d$export$ae329fe3ea179cb4 = (queue)=>{
        if (queue.length === 0) return [];
        const [activeItem, ...redundantItems] = queue;
        redundantItems.forEach(({ value: value })=>{
            value.dispose();
        });
        return [
            activeItem
        ];
    };
    const $f334fadd26cc659d$export$1cfc7aad5cb1833b = (queue)=>{
        queue.forEach(({ value: value })=>{
            value.dispose();
        });
        return [];
    };
    const $f334fadd26cc659d$export$322c8997d351da6a = ()=>{
        const value = (0, $eUqFw.useRef)(null);
        const subscribers = (0, $eUqFw.useRef)();
        const subscribe = (0, $eUqFw.useCallback)((subscriber)=>{
            if (!subscribers.current) subscribers.current = new Set();
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current?.delete(subscriber);
            };
        }, []);
        const setEntryPointReference = (0, $eUqFw.useCallback)((entryPointReference)=>{
            value.current = entryPointReference;
            (0, $lEfVV.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        }, []);
        const getValue = (0, $eUqFw.useCallback)(()=>value.current, []);
        (0, $eUqFw.useEffect)(()=>()=>{
                subscribers.current?.clear();
            }, []);
        return {
            getValue: getValue,
            setEntryPointReference: setEntryPointReference,
            subscribe: subscribe
        };
    };
});
parcelRegister("VvIn5", function(module, exports) {
    $parcel$export(module.exports, "useMetricLogger", ()=>$df836dfb6cf1aa5a$export$f291ec7cea728e1);
    var $eUqFw = parcelRequire("eUqFw");
    const $df836dfb6cf1aa5a$export$f291ec7cea728e1 = (metric)=>{
        const preloadStartTime = (0, $eUqFw.useRef)(0);
        const loadStartTime = (0, $eUqFw.useRef)(0);
        const startMetric = (0, $eUqFw.useCallback)((preloadTime = 0)=>{
            if (metric) {
                metric.start();
                preloadStartTime.current = preloadTime;
                loadStartTime.current = Date.now();
            }
        }, [
            metric
        ]);
        const stopMetric = (0, $eUqFw.useCallback)((additionalCustomData)=>{
            if (metric) {
                const preloadData = preloadStartTime.current > 0 ? {
                    preloadToStartDuration: loadStartTime.current - preloadStartTime.current
                } : undefined;
                const metricData = preloadData || additionalCustomData ? {
                    customData: {
                        ...preloadData,
                        ...additionalCustomData
                    }
                } : undefined;
                metric.stop(metricData);
            }
        }, [
            metric
        ]);
        return {
            startMetric: startMetric,
            stopMetric: stopMetric
        };
    };
});
parcelRegister("6xYPC", function(module, exports) {
    $parcel$export(module.exports, "stopLowPriorityEventDelay", ()=>$4b25e5ad6cfac913$export$a928755af449867);
    $parcel$export(module.exports, "startLowPriorityEventDelay", ()=>$4b25e5ad6cfac913$export$8bb8df5a93e9525);
    $parcel$export(module.exports, "default", ()=>$4b25e5ad6cfac913$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $ICvxP = parcelRequire("ICvxP");
    var $6iz4v = parcelRequire("6iz4v");
    var $cbwiM = parcelRequire("cbwiM");
    var $3FyZ4 = parcelRequire("3FyZ4");
    var $epT40 = parcelRequire("epT40");
    var $87isp = parcelRequire("87isp");
    const $4b25e5ad6cfac913$var$STOP_DELAY_TIMEOUT = 10000;
    let $4b25e5ad6cfac913$var$stopDelayTimeout;
    let $4b25e5ad6cfac913$var$lastDelayActionPromise = (0, $3FyZ4.getAnalyticsWebClientPromise)().then((clientWrapper)=>clientWrapper.getInstance());
    const $4b25e5ad6cfac913$export$a928755af449867 = ()=>{
        $4b25e5ad6cfac913$var$lastDelayActionPromise = $4b25e5ad6cfac913$var$lastDelayActionPromise.then((client)=>{
            if (!(0, $cbwiM.isEventDelayActive)()) return client;
            clearTimeout($4b25e5ad6cfac913$var$stopDelayTimeout);
            (0, $6iz4v.setMark)((0, $9f18a423c52d71b6$export$2d91d3eed1108e72));
            (0, $cbwiM.setEventDelayActive)(false);
            client.stopLowPriorityEventDelay();
            return client;
        });
    };
    const $4b25e5ad6cfac913$export$8bb8df5a93e9525 = ()=>{
        $4b25e5ad6cfac913$var$lastDelayActionPromise = $4b25e5ad6cfac913$var$lastDelayActionPromise.then((client)=>{
            if (!(0, $cbwiM.isEventDelayActive)()) {
                (0, $ICvxP.default)((0, $9f18a423c52d71b6$export$358721a9d6125914));
                (0, $6iz4v.setMark)((0, $9f18a423c52d71b6$export$b2122dce85a27912));
            }
            client.startLowPriorityEventDelay();
            (0, $cbwiM.setEventDelayActive)(true);
            clearTimeout($4b25e5ad6cfac913$var$stopDelayTimeout);
            $4b25e5ad6cfac913$var$stopDelayTimeout = setTimeout($4b25e5ad6cfac913$export$a928755af449867, $4b25e5ad6cfac913$var$STOP_DELAY_TIMEOUT);
            return client;
        });
    };
    const $4b25e5ad6cfac913$export$778ebe2a4fab1ba7 = ()=>$4b25e5ad6cfac913$var$lastDelayActionPromise;
    const $4b25e5ad6cfac913$var$EventDelayController = ()=>{
        const [loadedState] = (0, $epT40.default)();
        (0, $eUqFw.useEffect)(()=>{
            if (!loadedState.hasLoaded && (0, $87isp.isAutomaticExposureCollectionEnabled)()) $4b25e5ad6cfac913$export$8bb8df5a93e9525();
        }, [
            loadedState.hasLoaded
        ]);
        return null;
    };
    var $4b25e5ad6cfac913$export$2e2bcd8739ae039 = $4b25e5ad6cfac913$var$EventDelayController;
});
parcelRegister("ICvxP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5dab3f6273aaa3f2$export$2e2bcd8739ae039);
    var $hgcvd = parcelRequire("hgcvd");
    var $5dab3f6273aaa3f2$export$2e2bcd8739ae039 = (prefix)=>{
        if ((0, $hgcvd.default) && (0, $hgcvd.default).getEntries && (0, $hgcvd.default).clearMarks) return (0, $hgcvd.default).getEntries().filter((mark)=>mark.name.startsWith(prefix)).map((mark)=>{
            (0, $hgcvd.default).clearMarks(mark.name);
            return mark;
        });
        return [];
    };
});
parcelRegister("cbwiM", function(module, exports) {
    $parcel$export(module.exports, "setEventDelayActive", ()=>$00304183c2d9ac4d$export$9a4add6d6ddcc1a);
    $parcel$export(module.exports, "isEventDelayActive", ()=>$00304183c2d9ac4d$export$3536b0184fa98d19);
    let $00304183c2d9ac4d$var$eventDelayActive = false;
    const $00304183c2d9ac4d$export$9a4add6d6ddcc1a = (isEventDelayActive)=>{
        $00304183c2d9ac4d$var$eventDelayActive = isEventDelayActive;
    };
    const $00304183c2d9ac4d$export$3536b0184fa98d19 = ()=>$00304183c2d9ac4d$var$eventDelayActive;
});
parcelRegister("epT40", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c9158c027ae7ce81$export$2e2bcd8739ae039);
    var $WBLbN = parcelRequire("WBLbN");
    var $cfLkw = parcelRequire("cfLkw");
    const $c9158c027ae7ce81$export$4a361c7505f72f5c = ({ currentPage: currentPage })=>{
        const { apps: apps } = currentPage;
        const appIds = Object.keys(apps);
        const determineHasLoaded = ()=>{
            if (appIds.length === 1 && appIds[0] === (0, $9c22638d2f17f9db$export$3a54edb6ba4daa82)) return !__SPA__;
            return appIds.length ? appIds.filter((id)=>id !== (0, $9c22638d2f17f9db$export$2ee9e5a3556c1e43)).every((id)=>apps[id].endTime != null || apps[id].timeoutTime) : false;
        };
        const hasLoaded = determineHasLoaded();
        return {
            hasLoaded: hasLoaded
        };
    };
    const $c9158c027ae7ce81$var$usePageLoadedSubscriber = (0, $WBLbN.createHook)((0, $cfLkw.default), {
        selector: $c9158c027ae7ce81$export$4a361c7505f72f5c
    });
    var $c9158c027ae7ce81$export$2e2bcd8739ae039 = $c9158c027ae7ce81$var$usePageLoadedSubscriber;
});
const $9c22638d2f17f9db$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $9c22638d2f17f9db$export$2ee9e5a3556c1e43 = 'SIDEBAR';
const $9f18a423c52d71b6$export$358721a9d6125914 = 'event-delay-controller.';
const $9f18a423c52d71b6$export$b2122dce85a27912 = `${$9f18a423c52d71b6$export$358721a9d6125914}start`;
const $9f18a423c52d71b6$export$2d91d3eed1108e72 = `${$9f18a423c52d71b6$export$358721a9d6125914}end`;
parcelRegister("79xbN", function(module, exports) {
    $parcel$export(module.exports, "expVal", ()=>$2783c762502a41a6$export$9db1624a8af791a4);
    $parcel$export(module.exports, "expValEquals", ()=>$2783c762502a41a6$export$45abdb3f977b5b14);
    $parcel$export(module.exports, "UNSAFE_noExposureExp", ()=>$2783c762502a41a6$export$677f9fa2e1ae6fec);
    var $fPtA6 = parcelRequire("fPtA6");
    var $9bn72 = parcelRequire("9bn72");
    var $apAS2 = parcelRequire("apAS2");
    function $2783c762502a41a6$export$9db1624a8af791a4(experimentName, param, defaultValue) {
        (0, $9bn72.UNSAFE_initIfNeeded)();
        const value = (0, $fPtA6.default).getExperimentValue(experimentName, param, defaultValue);
        (0, $apAS2.addFeatureFlagAccessed)(`${experimentName}:${param}`, value);
        return value;
    }
    function $2783c762502a41a6$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
        return $2783c762502a41a6$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
    }
    class $2783c762502a41a6$var$ExperimentConfig {
        constructor(experimentName, config){
            this._experimentName = experimentName;
            this._config = config;
        }
        get(key, defaultValue, typeGuard) {
            const value = this._config.get(key, defaultValue, typeGuard);
            (0, $apAS2.addFeatureFlagAccessed)(`${this._experimentName}:${key}`, value);
            return value;
        }
    }
    const $2783c762502a41a6$var$cache = new Map();
    function $2783c762502a41a6$export$677f9fa2e1ae6fec(experimentName) {
        let instance = $2783c762502a41a6$var$cache.get(experimentName);
        if (instance == null) {
            (0, $9bn72.UNSAFE_initIfNeeded)();
            const config = (0, $fPtA6.default).getExperiment(experimentName, {
                fireExperimentExposure: false
            });
            const fireExposure = ()=>(0, $fPtA6.default).manuallyLogExperimentExposure(experimentName);
            instance = [
                new $2783c762502a41a6$var$ExperimentConfig(experimentName, config),
                fireExposure
            ];
            $2783c762502a41a6$var$cache.set(experimentName, instance);
        }
        return instance;
    }
});
parcelRegister("dnJL9", function(module, exports) {
    $parcel$export(module.exports, "componentWithFG", ()=>$dcea2fa8766d9cd0$export$cf56d0f54cfcce4);
    var $9zysr = parcelRequire("9zysr");
    var $eI5EY = parcelRequire("eI5EY");
    const $dcea2fa8766d9cd0$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $9zysr.componentWithCondition)(()=>(0, $eI5EY.fg)(gateName), ComponentTrue, ComponentFalse);
});
parcelRegister("j6ken", function(module, exports) {
    $parcel$export(module.exports, "LoadingBarUIController", ()=>$04a03fc02281e1a8$export$39bdf67fc71ce8c8);
    var $eUqFw = parcelRequire("eUqFw");
    var $gUUjF = parcelRequire("gUUjF");
    var $d3ujX = parcelRequire("d3ujX");
    var $epT40 = parcelRequire("epT40");
    var $78d1w = parcelRequire("78d1w");
    var $lB25E = parcelRequire("lB25E");
    var $1Xxlz = parcelRequire("1Xxlz");
    var $cQcOl = parcelRequire("cQcOl");
    const $04a03fc02281e1a8$export$54128ad8de32b897 = ({ startLoading: startLoading, resetLoading: resetLoading, finishLoading: finishLoading })=>{
        const [loadedState] = (0, $epT40.default)();
        (0, $eUqFw.useEffect)(()=>{
            startLoading();
            return ()=>{
                resetLoading();
            };
        }, []);
        (0, $eUqFw.useEffect)(()=>{
            if (loadedState.hasLoaded) finishLoading();
        }, [
            loadedState.hasLoaded
        ]);
        return null;
    };
    const $04a03fc02281e1a8$var$LoadingBarUI = ({ shouldRender: shouldRender, routeIdentifier: routeIdentifier })=>{
        const [actions, setActions] = (0, $eUqFw.useState)({});
        const sheetRef = (0, $eUqFw.useRef)(null);
        (0, $eUqFw.useEffect)(()=>{
            const loadingBarActions = (0, $d3ujX.createLoadingBarActionController)(sheetRef.current);
            setActions(loadingBarActions || {});
        }, []);
        return (0, ($parcel$interopDefault($eUqFw))).createElement("div", null, (0, ($parcel$interopDefault($eUqFw))).createElement("style", {
            ref: sheetRef,
            dangerouslySetInnerHTML: {
                __html: `
                    ${(0, $1Xxlz.LOADER_STYLES_CSS_SELECTOR)} {
                        ${(0, $cQcOl.generateLoadingBarStyles)(0, (0, $1Xxlz.getLoadingBarColor)())}
                    }
                `
            }
        }), shouldRender && actions.START && (0, ($parcel$interopDefault($eUqFw))).createElement($04a03fc02281e1a8$export$54128ad8de32b897, {
            key: routeIdentifier,
            startLoading: actions.START,
            resetLoading: actions.RESET,
            finishLoading: actions.FINISH
        }));
    };
    const $04a03fc02281e1a8$export$e068deb20d61b035 = ()=>{
        let currentTransitionsCount = 0;
        let currentRouteIdentifier = '';
        let currentRouteMatch = '';
        let hasTransitioned = false;
        let key = 0;
        return (transitionsCount, routeIdentifier, routeMatch)=>{
            if (transitionsCount !== currentTransitionsCount) {
                currentTransitionsCount = transitionsCount;
                hasTransitioned = true;
            }
            if (routeIdentifier !== null && routeIdentifier !== currentRouteIdentifier || routeIdentifier === currentRouteIdentifier && routeMatch !== currentRouteMatch) {
                currentRouteIdentifier = routeIdentifier;
                currentRouteMatch = routeMatch;
                if (hasTransitioned) {
                    hasTransitioned = false;
                    key = currentTransitionsCount;
                }
            }
            return key;
        };
    };
    const $04a03fc02281e1a8$var$getUniqueTransitionKey = $04a03fc02281e1a8$export$e068deb20d61b035();
    const $04a03fc02281e1a8$export$39bdf67fc71ce8c8 = ()=>{
        const [routerState] = (0, $lB25E.useRouter)();
        const [{ transitionsCount: transitionsCount }] = (0, $78d1w.useSpaStateTransition)();
        const currentRoute = routerState.route && routerState.route.name;
        const loaderFailedInSSR = !window.JIRA_LOADING_BAR;
        const shouldRender = (0, $1Xxlz.getAllowedRoutes)().includes(currentRoute);
        const routeIdentifier = (0, $eUqFw.useMemo)(()=>$04a03fc02281e1a8$var$getUniqueTransitionKey(transitionsCount, currentRoute, JSON.stringify(routerState.match)), [
            transitionsCount,
            currentRoute,
            routerState.match
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (shouldRender && loaderFailedInSSR) (0, $gUUjF.default).safeWarnWithoutCustomerData('global-loading-bar', 'Loading bar failed to initialise in SSR. This may be because SSR failed or a bug in the loading bar code.');
        }, [
            loaderFailedInSSR
        ]);
        if (loaderFailedInSSR) return (0, ($parcel$interopDefault($eUqFw))).createElement($04a03fc02281e1a8$var$LoadingBarUI, {
            shouldRender: shouldRender,
            routeIdentifier: routeIdentifier
        });
        if (shouldRender && window.JIRA_LOADING_BAR) return (0, ($parcel$interopDefault($eUqFw))).createElement($04a03fc02281e1a8$export$54128ad8de32b897, {
            key: routeIdentifier,
            startLoading: window.JIRA_LOADING_BAR.START,
            resetLoading: window.JIRA_LOADING_BAR.RESET,
            finishLoading: window.JIRA_LOADING_BAR.FINISH
        });
        return null;
    };
});
parcelRegister("d3ujX", function(module, exports) {
    $parcel$export(module.exports, "createLoadingBarActionController", ()=>$e871469dab215262$export$55d67d61d9d2ad3b);
    var $g0c9Y = parcelRequire("g0c9Y");
    const $e871469dab215262$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
    const $e871469dab215262$export$899393f3e23f724b = 15000;
    const $e871469dab215262$export$7868b416d8929c55 = 40000;
    const $e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR = 'body::before';
    const $e871469dab215262$var$EXIT_ANIMATION_SPEED = 300;
    const $e871469dab215262$export$99d4e8974a739853 = ()=>(0, $g0c9Y.getMeta)('ajs-lf-navigation-highlightcolour') || $e871469dab215262$export$53d51cc6d57e44da;
    const $e871469dab215262$export$4fb8742b05de9693 = (duration)=>`
    ${$e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0.99);
        transition-duration: ${duration}ms;
        transition-timing-function: cubic-bezier(0,1,0.5,1);
    }
`;
    const $e871469dab215262$export$5a43e0f09174e553 = ()=>`
    ${$e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(1);
        transition-duration: ${$e871469dab215262$var$EXIT_ANIMATION_SPEED}ms;
        animation: none;
        background-image: none;
    }
`;
    const $e871469dab215262$export$6beef8c645a63156 = ()=>`
    ${$e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR} {
        transform: scaleX(0);
        transition-duration: 0ms;
        animation: none;
        background-image: none;
    }
`;
    const $e871469dab215262$export$610cb442736abf53 = ()=>`
    @keyframes shimmer {
        from {
            left: -80%;
            width: 80%;
        }

        to {
            left: 110%;
            width: 10%;
        }
    }
`;
    const $e871469dab215262$export$959e9e99fba397f1 = (loadingBarColor)=>`
        ${$e871469dab215262$var$LOADER_STYLES_CSS_SELECTOR} {
            transform: scaleX(1);
            transition-duration: 0ms;
            background: ${loadingBarColor};
            animation: shimmer 2s infinite;
        }
    `;
    const $e871469dab215262$var$browserFocusCheck = (action)=>{
        if (document && document.hidden) action();
        else requestAnimationFrame(()=>{
            action();
        });
    };
    const $e871469dab215262$export$55d67d61d9d2ad3b = (stylesheet)=>{
        const { sheet: sheet } = stylesheet || {};
        if (!sheet) return undefined;
        let isRunning = false;
        let isDelayed = false;
        let exitAnimationTimer;
        let delayedAnimationTimer;
        let timeoutTimer;
        return {
            START: (duration = $e871469dab215262$export$899393f3e23f724b)=>{
                if (isRunning) return;
                isRunning = true;
                $e871469dab215262$var$browserFocusCheck(()=>{
                    sheet.insertRule($e871469dab215262$export$4fb8742b05de9693(duration), sheet.cssRules.length);
                });
                delayedAnimationTimer = setTimeout(()=>{
                    if (!isRunning) return;
                    isDelayed = true;
                    $e871469dab215262$var$browserFocusCheck(()=>{
                        sheet.insertRule($e871469dab215262$export$610cb442736abf53(), sheet.cssRules.length);
                        sheet.insertRule($e871469dab215262$export$959e9e99fba397f1($e871469dab215262$export$99d4e8974a739853()), sheet.cssRules.length);
                    });
                }, $e871469dab215262$export$899393f3e23f724b);
                timeoutTimer = setTimeout(()=>{
                    if (!isRunning) return;
                    isRunning = false;
                    isDelayed = false;
                    $e871469dab215262$var$browserFocusCheck(()=>{
                        sheet.insertRule($e871469dab215262$export$6beef8c645a63156(), sheet.cssRules.length);
                    });
                    clearTimeout(exitAnimationTimer);
                    clearTimeout(delayedAnimationTimer);
                    clearTimeout(timeoutTimer);
                }, $e871469dab215262$export$7868b416d8929c55);
            },
            FINISH: ()=>{
                if (!isRunning) return;
                isRunning = false;
                if (isDelayed) {
                    isDelayed = false;
                    clearTimeout(exitAnimationTimer);
                    clearTimeout(timeoutTimer);
                    clearTimeout(delayedAnimationTimer);
                    $e871469dab215262$var$browserFocusCheck(()=>{
                        sheet.insertRule($e871469dab215262$export$6beef8c645a63156(), sheet.cssRules.length);
                    });
                    return;
                }
                $e871469dab215262$var$browserFocusCheck(()=>{
                    sheet.insertRule($e871469dab215262$export$5a43e0f09174e553(), sheet.cssRules.length);
                });
                exitAnimationTimer = setTimeout(()=>{
                    clearTimeout(exitAnimationTimer);
                    clearTimeout(timeoutTimer);
                    clearTimeout(delayedAnimationTimer);
                    $e871469dab215262$var$browserFocusCheck(()=>{
                        sheet.insertRule($e871469dab215262$export$6beef8c645a63156(), sheet.cssRules.length);
                    });
                }, $e871469dab215262$var$EXIT_ANIMATION_SPEED + 500);
            },
            RESET: ()=>{
                isRunning = false;
                isDelayed = false;
                clearTimeout(exitAnimationTimer);
                clearTimeout(delayedAnimationTimer);
                clearTimeout(timeoutTimer);
                $e871469dab215262$var$browserFocusCheck(()=>{
                    sheet.insertRule($e871469dab215262$export$6beef8c645a63156(), sheet.cssRules.length);
                });
            }
        };
    };
    const $e871469dab215262$var$setupLoadingBarActionController = ()=>{
        const LOADER_STYLESHEET_ID = 'loaderStylesheet';
        const styleSheet = document.getElementById(LOADER_STYLESHEET_ID);
        if (!styleSheet || !styleSheet.sheet) return;
        window.JIRA_LOADING_BAR = $e871469dab215262$export$55d67d61d9d2ad3b(styleSheet);
        if (window.JIRA_LOADING_BAR && window.JIRA_LOADING_BAR.START) window.JIRA_LOADING_BAR.START();
    };
    $e871469dab215262$var$setupLoadingBarActionController();
});
parcelRegister("g0c9Y", function(module, exports) {
    $parcel$export(module.exports, "getMeta", ()=>$974e6ffaf05907b7$export$c47913ca32a5c6f7);
    const $974e6ffaf05907b7$export$c47913ca32a5c6f7 = (name)=>{
        const node = document.querySelector(`meta[name="${name}"]`);
        const metaValue = node && node.getAttribute('content');
        return metaValue !== undefined ? metaValue : null;
    };
});
parcelRegister("78d1w", function(module, exports) {
    $parcel$export(module.exports, "useSpaStateTransition", ()=>$7f5c686fb18f00a1$export$4d1974344641a2c9);
    $parcel$export(module.exports, "default", ()=>$7f5c686fb18f00a1$export$2e2bcd8739ae039);
    var $hgcvd = parcelRequire("hgcvd");
    var $WBLbN = parcelRequire("WBLbN");
    var $cfLkw = parcelRequire("cfLkw");
    const $7f5c686fb18f00a1$var$getNavigationStart = ()=>{
        const timestamp = (0, $hgcvd.default) && (0, $hgcvd.default).timing && (0, $hgcvd.default).timing.navigationStart;
        return timestamp ? new Date(timestamp).toISOString() : undefined;
    };
    const $7f5c686fb18f00a1$var$getLastTransition = (currentPage, visitedPages)=>{
        if (visitedPages.length === 0) return undefined;
        const collectAppNames = (page)=>Object.keys(page.apps || {}).sort();
        const appNamesToStr = (appNames)=>appNames.join('+') || '?';
        const prevPage = appNamesToStr(collectAppNames(visitedPages.slice(-1)[0]));
        const currPage = appNamesToStr(collectAppNames(currentPage));
        return `${prevPage} > ${currPage}`;
    };
    const $7f5c686fb18f00a1$var$getLastTransitionStartTime = (currentPage, visitedPages)=>{
        if (visitedPages.length === 0) return undefined;
        return currentPage.startTime;
    };
    const $7f5c686fb18f00a1$export$aea217a45095ce11 = ({ visitedPages: visitedPages, currentPage: currentPage })=>({
            isInitialRender: visitedPages.length === 0,
            transitionsCount: visitedPages.length,
            lastTransition: $7f5c686fb18f00a1$var$getLastTransition(currentPage, visitedPages),
            lastTransitionStartTime: $7f5c686fb18f00a1$var$getLastTransitionStartTime(currentPage, visitedPages),
            navigationStart: $7f5c686fb18f00a1$var$getNavigationStart(),
            currentPageId: currentPage.uuid
        });
    const $7f5c686fb18f00a1$var$SpaStateTransitionStateSubscriber = (0, $WBLbN.createSubscriber)((0, $cfLkw.default), {
        displayName: 'SpaStateTransitionStateSubscriber',
        selector: $7f5c686fb18f00a1$export$aea217a45095ce11
    });
    const $7f5c686fb18f00a1$export$4d1974344641a2c9 = (0, $WBLbN.createHook)((0, $cfLkw.default), {
        selector: $7f5c686fb18f00a1$export$aea217a45095ce11
    });
    var $7f5c686fb18f00a1$export$2e2bcd8739ae039 = $7f5c686fb18f00a1$var$SpaStateTransitionStateSubscriber;
});
parcelRegister("1Xxlz", function(module, exports) {
    $parcel$export(module.exports, "LOADER_STYLES_CSS_SELECTOR", ()=>$687b423c2ce28206$export$2a3dd4ccb7b0a764);
    $parcel$export(module.exports, "LOADER_STYLESHEET_ID", ()=>$687b423c2ce28206$export$79456f717d4431da);
    $parcel$export(module.exports, "getAllowedRoutes", ()=>$687b423c2ce28206$export$c82eb262b97a76f1);
    $parcel$export(module.exports, "getLoadingBarColor", ()=>$687b423c2ce28206$export$cf3a5ed89e041425);
    var $5iWql = parcelRequire("5iWql");
    var $exb0h = parcelRequire("exb0h");
    var $6rW04 = parcelRequire("6rW04");
    const $687b423c2ce28206$var$FIRST_RELEASE_ROUTES = [
        (0, $exb0h.ROUTE_NAMES_ISSUE),
        (0, $exb0h.ROUTE_NAMES_ISSUE_EMBED),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT),
        (0, $exb0h.ROUTE_NAMES_YOUR_WORK),
        (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY),
        (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA),
        (0, $exb0h.ROUTE_NAMES_BOARDS_DIRECTORY),
        (0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY),
        (0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY_SECURE),
        (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY),
        (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE),
        (0, $exb0h.ROUTE_NAMES_PROJECT_COMPONENTS),
        (0, $exb0h.ROUTE_NAMES_PROJECT_PAGES),
        (0, $exb0h.ROUTE_NAMES_PROJECT_VERSIONS),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_BACKLOG),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_ROADMAP),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
        (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        (0, $exb0h.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
        (0, $exb0h.ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT)
    ];
    const $687b423c2ce28206$export$2a3dd4ccb7b0a764 = 'body::before';
    const $687b423c2ce28206$export$79456f717d4431da = 'loaderStylesheet';
    const $687b423c2ce28206$export$53d51cc6d57e44da = 'rgb(76, 154, 255)';
    const $687b423c2ce28206$export$c82eb262b97a76f1 = (0, $5iWql.default)(()=>{
        const ALLOWED_ROUTES = $687b423c2ce28206$var$FIRST_RELEASE_ROUTES;
        return ALLOWED_ROUTES;
    });
    const $687b423c2ce28206$export$cf3a5ed89e041425 = (0, $5iWql.default)(()=>(0, $6rW04.default)('ajs-lf-navigation-highlightcolour') || $687b423c2ce28206$export$53d51cc6d57e44da);
});
parcelRegister("cQcOl", function(module, exports) {
    $parcel$export(module.exports, "generateLoadingBarStyles", ()=>$1e0ebc570d6f522b$export$3036104bc81246b1);
    var $c9TLT = parcelRequire("c9TLT");
    var $1Xxlz = parcelRequire("1Xxlz");
    const $1e0ebc570d6f522b$export$3036104bc81246b1 = (initalProgressValue, loadingBarColor)=>`
    content: '';
    display: block;
    background: ${loadingBarColor};
    height: 3px;
    z-index: ${(0, $c9TLT.layers).navigation + 10};
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    transform: scaleX(${initalProgressValue});
    transform-origin: 0 0;
    will-change: transform;
`;
    const $1e0ebc570d6f522b$export$85e33a4b3d661500 = (initialProgressValue = 0.3)=>`
        <style id=${0, $1Xxlz.LOADER_STYLESHEET_ID}>
            ${0, $1Xxlz.LOADER_STYLES_CSS_SELECTOR} {${$1e0ebc570d6f522b$export$3036104bc81246b1(initialProgressValue, (0, $1Xxlz.getLoadingBarColor)())}}
        </style>`;
});
parcelRegister("c9TLT", function(module, exports) {
    $parcel$export(module.exports, "gridSize", ()=>$d7c0be4143e494a4$export$6d8204c2cb2e06b8);
    $parcel$export(module.exports, "borderRadius", ()=>$d7c0be4143e494a4$export$7a57f79000377ca2);
    $parcel$export(module.exports, "fontSize", ()=>$d7c0be4143e494a4$export$85e3c3ca0c6fb93);
    $parcel$export(module.exports, "fontFamily", ()=>$d7c0be4143e494a4$export$a5975749f0374264);
    $parcel$export(module.exports, "codeFontFamily", ()=>$d7c0be4143e494a4$export$356129969ee49c55);
    $parcel$export(module.exports, "contentHorizontalSpacing", ()=>$d7c0be4143e494a4$export$22dec01f2c854397);
    $parcel$export(module.exports, "layers", ()=>$d7c0be4143e494a4$export$7be255094ccdc533);
    $parcel$export(module.exports, "layout", ()=>$d7c0be4143e494a4$export$b3219800bda33a1f);
    var $h04Oa = parcelRequire("h04Oa");
    const $d7c0be4143e494a4$export$6d8204c2cb2e06b8 = (0, $h04Oa.gridSize)();
    const $d7c0be4143e494a4$export$7a57f79000377ca2 = (0, $h04Oa.borderRadius)();
    const $d7c0be4143e494a4$export$85e3c3ca0c6fb93 = (0, $h04Oa.fontSize)();
    const $d7c0be4143e494a4$export$a5975749f0374264 = (0, $h04Oa.fontFamily)();
    const $d7c0be4143e494a4$export$356129969ee49c55 = (0, $h04Oa.codeFontFamily)();
    const $d7c0be4143e494a4$export$22dec01f2c854397 = 40;
    const $d7c0be4143e494a4$export$dab5ea164c6f81a = 100;
    const $d7c0be4143e494a4$export$7be255094ccdc533 = {
        banner: (0, $h04Oa.layers).navigation(),
        card: (0, $h04Oa.layers).card(),
        dialog: (0, $h04Oa.layers).dialog(),
        navigation: (0, $h04Oa.layers).navigation(),
        leftSidebar: (0, $h04Oa.layers).navigation() - 1,
        rightSidebar: (0, $h04Oa.layers).navigation() - 1,
        layer: (0, $h04Oa.layers).layer(),
        blanket: (0, $h04Oa.layers).blanket(),
        modal: (0, $h04Oa.layers).modal(),
        flag: (0, $h04Oa.layers).flag(),
        spotlight: (0, $h04Oa.layers).spotlight(),
        tooltip: (0, $h04Oa.layers).tooltip(),
        mobileBanner: $d7c0be4143e494a4$export$dab5ea164c6f81a
    };
    const $d7c0be4143e494a4$export$b3219800bda33a1f = {
        issueIconSize: $d7c0be4143e494a4$export$6d8204c2cb2e06b8 * 2
    };
});
parcelRegister("jxIns", function(module, exports) {
    $parcel$export(module.exports, "SafeHelpPanel", ()=>$3dbb567424a9f7a3$export$cd2ada2fb14048fc);
    var $eUqFw = parcelRequire("eUqFw");
    var $48bs8 = parcelRequire("48bs8");
    var $0cdA8 = parcelRequire("0cdA8");
    var $f2Poq = parcelRequire("f2Poq");
    var $1zRTT = parcelRequire("1zRTT");
    var $antaP = parcelRequire("antaP");
    var $3xHvd = parcelRequire("3xHvd");
    var $bUi2Q = parcelRequire("bUi2Q");
    var $dxcfv = parcelRequire("dxcfv");
    const $3dbb567424a9f7a3$var$HelpPanel = ()=>{
        const [{ navigationData: navigationData, releaseNotesNotifications: releaseNotesNotifications }, { setNavigationData: setNavigationData, setReleaseNotesNotifications: setReleaseNotesNotifications }] = (0, $1zRTT.useHelpPanel)();
        const { closeRightSidebar: closeRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
        const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
        const accountId = (0, $dxcfv.useAccountId)();
        (0, $eUqFw.useEffect)(()=>{
            const restoreReleaseNotesNotifications = async ()=>{
                if (accountId) try {
                    const { helpPanel: userPropertiesHelpPanelValue } = await (0, $48bs8.getUserProperty)(accountId, (0, $119e8efb1068ef73$export$783d7c02e3a0cbf));
                    setReleaseNotesNotifications(userPropertiesHelpPanelValue.releaseNotesNotifications);
                } catch (err) {
                    setReleaseNotesNotifications(0);
                }
                else setReleaseNotesNotifications(0);
            };
            restoreReleaseNotesNotifications();
        }, []);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $antaP.RemoteStateUpdater), null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3xHvd.LazyHelpPanel), {
            isOpen: !rightSidebarCurrentState?.isCollapsed,
            navigationData: navigationData,
            releaseNotesNotifications: releaseNotesNotifications,
            setNavigationData: setNavigationData,
            releaseNotesNotificationsSetter: setReleaseNotesNotifications,
            hasBeenRendered: !rightSidebarCurrentState?.isCollapsed,
            onCloseHelpPanel: closeRightSidebar
        }));
    };
    const $3dbb567424a9f7a3$var$HelpPanelInLayout = ()=>{
        const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
        const [localPanelId, setLocalPanelId] = (0, $eUqFw.useState)();
        const prevPanelIdRef = (0, $eUqFw.useRef)();
        const delayRef = (0, $eUqFw.useRef)(null);
        const panelId = rightSidebarCurrentState?.panelId;
        (0, $eUqFw.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, $f2Poq.HELP_PANEL_ID)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                }, 310);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            panelId,
            rightSidebarCurrentState
        ]);
        if (localPanelId !== (0, $f2Poq.HELP_PANEL_ID)) return null;
        return (0, ($parcel$interopDefault($eUqFw))).createElement($3dbb567424a9f7a3$var$HelpPanel, null);
    };
    const $3dbb567424a9f7a3$export$cd2ada2fb14048fc = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            fallback: "unmount",
            id: "right-side-help-panel",
            packageName: "@atlassian/jira-help-panel-right-sidebar"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($3dbb567424a9f7a3$var$HelpPanelInLayout, null));
});
parcelRegister("f2Poq", function(module, exports) {
    $parcel$export(module.exports, "HELP_PANEL_VERSION", ()=>$482b44340b421724$export$c43c7444da662fa1);
    $parcel$export(module.exports, "HELP_PANEL_ID", ()=>$482b44340b421724$export$e99efa3985fa3c26);
    $parcel$export(module.exports, "HELP_PANEL_WIDTH", ()=>$482b44340b421724$export$23aa6670f346c214);
    var $c9TLT = parcelRequire("c9TLT");
    const $482b44340b421724$export$c43c7444da662fa1 = '1';
    const $482b44340b421724$export$e99efa3985fa3c26 = 'helpPanel';
    const $482b44340b421724$export$23aa6670f346c214 = (0, $c9TLT.gridSize) * 46;
});
parcelRegister("1zRTT", function(module, exports) {
    $parcel$export(module.exports, "useHelpPanel", ()=>$6594f144c6f69b94$export$3fe94d66377a53b8);
    $parcel$export(module.exports, "useHelpPanelActions", ()=>$6594f144c6f69b94$export$c61f56f4797e22db);
    var $WBLbN = parcelRequire("WBLbN");
    var $kEkov = parcelRequire("kEkov");
    const $6594f144c6f69b94$export$3fe94d66377a53b8 = (0, $WBLbN.createHook)((0, $kEkov.default));
    const $6594f144c6f69b94$export$c61f56f4797e22db = (0, $WBLbN.createHook)((0, $kEkov.default), {
        selector: null
    });
    const $6594f144c6f69b94$export$513717a84f55db1a = (0, $WBLbN.createSubscriber)((0, $kEkov.default), {
        displayName: 'HelpPanelSubscriber'
    });
    const $6594f144c6f69b94$export$5f4de38bd79f4446 = (0, $WBLbN.createSubscriber)((0, $kEkov.default), {
        displayName: 'HelpPanelActionsSubscriber',
        selector: null
    });
});
parcelRegister("kEkov", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4af29a8a37667189$export$2e2bcd8739ae039);
    var $89bO2 = parcelRequire("89bO2");
    var $WBLbN = parcelRequire("WBLbN");
    var $47e0j = parcelRequire("47e0j");
    const $4af29a8a37667189$var$iphStorage = (0, $89bO2.createSessionStorageProvider)('iph');
    const $4af29a8a37667189$var$initialState = {
        navigationData: {
            articleId: {
                id: '',
                type: 'HELP_ARTICLE'
            },
            history: $4af29a8a37667189$var$iphStorage.get('history') || []
        },
        releaseNotesNotifications: 100
    };
    var $4af29a8a37667189$export$2e2bcd8739ae039 = (0, $WBLbN.createStore)({
        name: 'help-panel',
        initialState: $4af29a8a37667189$var$initialState,
        actions: $47e0j
    });
});
parcelRegister("89bO2", function(module, exports) {
    $parcel$export(module.exports, "createSessionStorageProvider", ()=>$eaaf8012779da3f6$export$a922b987e648d2fa);
    $parcel$export(module.exports, "createSessionExpirableStorageProvider", ()=>$eaaf8012779da3f6$export$e0a2e9a062c6a695);
    var $jqvCZ = parcelRequire("jqvCZ");
    var $avHyR = parcelRequire("avHyR");
    var $8zsxt = parcelRequire("8zsxt");
    const $eaaf8012779da3f6$export$a922b987e648d2fa = (0, ($parcel$interopDefault($jqvCZ)))((appPrefix)=>(0, $avHyR.createStorageProvider)(appPrefix, (0, $8zsxt.makeSessionStore)()));
    const $eaaf8012779da3f6$export$e0a2e9a062c6a695 = (0, ($parcel$interopDefault($jqvCZ)))((appPrefix)=>{
        if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
        const store = (0, $8zsxt.makeSessionExpirableStore)();
        return store.namespace(appPrefix);
    });
});
parcelRegister("8zsxt", function(module, exports) {
    $parcel$export(module.exports, "makeSessionStore", ()=>$dffa4c0ba19d0eb7$export$fb690882d627b3b5);
    $parcel$export(module.exports, "makeSessionExpirableStore", ()=>$dffa4c0ba19d0eb7$export$a8f626c8ded9a06c);
    var $2y3XF = parcelRequire("2y3XF");
    var $gleLd = parcelRequire("gleLd");
    var $ZGlKn = parcelRequire("ZGlKn");
    var $gpWeB = parcelRequire("gpWeB");
    var $lyUHD = parcelRequire("lyUHD");
    var $avHyR = parcelRequire("avHyR");
    const $dffa4c0ba19d0eb7$export$fb690882d627b3b5 = ()=>(0, ($parcel$interopDefault($ZGlKn))).createStore([
            (0, ($parcel$interopDefault($lyUHD))),
            (0, ($parcel$interopDefault($gpWeB)))
        ], (0, $avHyR.plugins));
    const $dffa4c0ba19d0eb7$export$a8f626c8ded9a06c = ()=>(0, ($parcel$interopDefault($ZGlKn))).createStore([
            (0, ($parcel$interopDefault($lyUHD))),
            (0, ($parcel$interopDefault($gpWeB)))
        ], [
            (0, ($parcel$interopDefault($2y3XF))),
            (0, ($parcel$interopDefault($gleLd)))
        ]);
});
parcelRegister("47e0j", function(module, exports) {
    $parcel$export(module.exports, "setNavigationData", ()=>$a35d570ea28382ca$export$ab1b80f40ca898ed);
    $parcel$export(module.exports, "setReleaseNotesNotifications", ()=>$a35d570ea28382ca$export$cdabe01d01a8da1e);
    var $89bO2 = parcelRequire("89bO2");
    const $a35d570ea28382ca$var$iphStorage = (0, $89bO2.createSessionStorageProvider)('iph');
    const $a35d570ea28382ca$export$ab1b80f40ca898ed = (navigationData)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                navigationData: {
                    articleId: navigationData.articleId ? navigationData.articleId : currentState.navigationData.articleId,
                    history: navigationData.history ? navigationData.history : currentState.navigationData.history
                }
            });
            $a35d570ea28382ca$var$iphStorage.set('history', []);
        };
    const $a35d570ea28382ca$export$cdabe01d01a8da1e = (releaseNotesNotifications)=>({ setState: setState })=>{
            setState({
                releaseNotesNotifications: releaseNotesNotifications
            });
        };
});
const $119e8efb1068ef73$export$783d7c02e3a0cbf = 'help_panel_ui_state';
parcelRegister("antaP", function(module, exports) {
    $parcel$export(module.exports, "RemoteStateUpdater", ()=>$5b20896496afe0c7$export$3db011870dd4330f);
    var $eUqFw = parcelRequire("eUqFw");
    var $cNGJr = parcelRequire("cNGJr");
    var $48bs8 = parcelRequire("48bs8");
    var $guiFP = parcelRequire("guiFP");
    var $dxcfv = parcelRequire("dxcfv");
    var $1zRTT = parcelRequire("1zRTT");
    const $5b20896496afe0c7$var$DEBOUNCE_TIME = 1000;
    const $5b20896496afe0c7$export$3db011870dd4330f = ()=>{
        const [{ releaseNotesNotifications: releaseNotesNotifications }] = (0, $1zRTT.useHelpPanel)();
        const [releaseNotesNotificationsTemp, setReleaseNotesNotificationsTemp] = (0, $eUqFw.useState)(releaseNotesNotifications);
        const accountId = (0, $dxcfv.useAccountId)();
        const [debouncedUpdateData] = (0, $cNGJr.default)(async (newReleaseNotesNotifications)=>{
            const remoteData = {
                helpPanel: {
                    releaseNotesNotifications: newReleaseNotesNotifications
                }
            };
            if (accountId) try {
                await (0, $48bs8.setUserProperties)(accountId, (0, $119e8efb1068ef73$export$783d7c02e3a0cbf), JSON.stringify(remoteData));
            } catch (e) {
                (0, $guiFP.default)({
                    error: e,
                    meta: {
                        id: 'updateServerHelpPanelState',
                        packageName: 'jiraHelpPanelServices',
                        teamName: 'self-help-experiences'
                    }
                });
            }
        }, $5b20896496afe0c7$var$DEBOUNCE_TIME);
        (0, $eUqFw.useEffect)(()=>{
            if (releaseNotesNotificationsTemp !== releaseNotesNotifications) {
                setReleaseNotesNotificationsTemp(releaseNotesNotifications);
                debouncedUpdateData(releaseNotesNotifications);
            }
        }, [
            debouncedUpdateData,
            releaseNotesNotifications,
            releaseNotesNotificationsTemp
        ]);
        return null;
    };
});
parcelRegister("cNGJr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$951b3551010b091a$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    function $951b3551010b091a$export$2e2bcd8739ae039(callback, delay, options) {
        if (options === void 0) options = {};
        var maxWait = options.maxWait;
        var maxWaitHandler = (0, $eUqFw.useRef)(null);
        var maxWaitArgs = (0, $eUqFw.useRef)([]);
        var leading = options.leading;
        var trailing = options.trailing === undefined ? true : options.trailing;
        var leadingCall = (0, $eUqFw.useRef)(false);
        var functionTimeoutHandler = (0, $eUqFw.useRef)(null);
        var isComponentUnmounted = (0, $eUqFw.useRef)(false);
        var debouncedFunction = (0, $eUqFw.useRef)(callback);
        debouncedFunction.current = callback;
        var cancelDebouncedCallback = (0, $eUqFw.useCallback)(function() {
            clearTimeout(functionTimeoutHandler.current);
            clearTimeout(maxWaitHandler.current);
            maxWaitHandler.current = null;
            maxWaitArgs.current = [];
            functionTimeoutHandler.current = null;
            leadingCall.current = false;
        }, []);
        (0, $eUqFw.useEffect)(function() {
            return function() {
                isComponentUnmounted.current = true;
            };
        }, []);
        var debouncedCallback = (0, $eUqFw.useCallback)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            maxWaitArgs.current = args;
            clearTimeout(functionTimeoutHandler.current);
            if (leadingCall.current) leadingCall.current = false;
            if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
                debouncedFunction.current.apply(debouncedFunction, args);
                leadingCall.current = true;
            }
            functionTimeoutHandler.current = setTimeout(function() {
                var shouldCallFunction = true;
                if (leading && leadingCall.current) shouldCallFunction = false;
                cancelDebouncedCallback();
                if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
            }, delay);
            if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
                var args = maxWaitArgs.current;
                cancelDebouncedCallback();
                if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
            }, maxWait);
        }, [
            maxWait,
            delay,
            cancelDebouncedCallback,
            leading,
            trailing
        ]);
        var callPending = (0, $eUqFw.useCallback)(function() {
            if (!functionTimeoutHandler.current) return;
            debouncedFunction.current.apply(null, maxWaitArgs.current);
            cancelDebouncedCallback();
        }, [
            cancelDebouncedCallback
        ]);
        return [
            debouncedCallback,
            cancelDebouncedCallback,
            callPending
        ];
    }
});
parcelRegister("3xHvd", function(module, exports) {
    $parcel$export(module.exports, "LazyHelpPanel", ()=>$a88134428dafae47$export$51c79455aef7d178);
    var $eUqFw = parcelRequire("eUqFw");
    var $hSQSo = parcelRequire("hSQSo");
    var $5GxEP = parcelRequire("5GxEP");
    var $aR8n6 = parcelRequire("aR8n6");
    var $79xbN = parcelRequire("79xbN");
    var $gGtKh = parcelRequire("gGtKh");
    var $cWiVr = parcelRequire("cWiVr");
    var $8WuJm = parcelRequire("8WuJm");
    var $enMj3 = parcelRequire("enMj3");
    var $rqehi = parcelRequire("rqehi");
    var $bZhE6 = parcelRequire("bZhE6");
    const $a88134428dafae47$export$51c79455aef7d178 = ({ navigationData: { articleId: articleId, history: history }, setNavigationData: setNavigationData, releaseNotesNotifications: releaseNotesNotifications, releaseNotesNotificationsSetter: releaseNotesNotificationsSetter, isOpen: isOpen, onCloseHelpPanel: onCloseHelpPanel, hasBeenRendered: hasBeenRendered, routeGroup: routeGroup, routeName: routeName })=>{
        const user = (0, $cWiVr.useCurrentUser)();
        const IPH_USE_HELP_AGGREGATOR_FLAG = (0, $79xbN.expVal)('20240422_self_help_iph_ms3_expt', 'iph_ms3_experience_display_flag', false);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
            id: "help-panel",
            packageName: "jiraHelpPanel",
            render: ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $enMj3.default), {
                    loadingArticle: articleId.id !== ''
                })
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
            id: "root",
            packageName: "jiraHelpPanel",
            teamName: "self-help-experiences"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $rqehi.SearchContextProvider), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            tags: [
                'iph'
            ],
            sourceName: "jiraHelpPanel",
            sourceType: (0, $41ea3621645e2acc$export$9d2de6eebf7462b5),
            attributes: {
                searchService: IPH_USE_HELP_AGGREGATOR_FLAG ? 'help-aggregator' : 'algolia',
                routeGroup: routeGroup,
                routeName: routeName,
                userId: user?.data?.user?.accountId
            }
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hSQSo.LazyWait), {
            until: hasBeenRendered
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "async-lazy-help-panel",
            fallback: isOpen ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $enMj3.default), {
                loadingArticle: articleId.id !== ''
            }) : null
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $bZhE6.AsyncLazyHelpPanel), {
            navigationData: {
                articleId: articleId,
                history: history
            },
            releaseNotesNotificationsSetter: releaseNotesNotificationsSetter,
            releaseNotesNotifications: releaseNotesNotifications,
            setNavigationData: setNavigationData,
            isOpen: isOpen,
            onCloseHelpPanel: onCloseHelpPanel,
            routeGroup: routeGroup,
            routeName: routeName
        })))))));
    };
});
parcelRegister("cWiVr", function(module, exports) {
    $parcel$export(module.exports, "useCurrentUser", ()=>$59f9598ada60a2a8$export$3901076af3749fa9);
    var $eUqFw = parcelRequire("eUqFw");
    var $ao0hp = parcelRequire("ao0hp");
    var $gd0Sp = parcelRequire("gd0Sp");
    var $lGLse = parcelRequire("lGLse");
    const $59f9598ada60a2a8$var$useCurrentUserBasic = ()=>{
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        return (0, $eUqFw.useMemo)(()=>({
                data: {
                    user: {
                        accountId: tenantContext.atlassianAccountId,
                        isAdmin: tenantContext.isAdmin,
                        isAnonymous: tenantContext.isAnonymous,
                        isSiteAdmin: tenantContext.isSiteAdmin,
                        locale: tenantContext.locale || (0, $ao0hp.defaultLocale),
                        siteAdminStatus: tenantContext.siteAdminStatus,
                        userFullname: tenantContext.userFullname || ''
                    }
                },
                loading: false,
                error: null
            }), [
            tenantContext.atlassianAccountId,
            tenantContext.isAdmin,
            tenantContext.isAnonymous,
            tenantContext.isSiteAdmin,
            tenantContext.locale,
            tenantContext.siteAdminStatus,
            tenantContext.userFullname
        ]);
    };
    const $59f9598ada60a2a8$var$useCurrentUserFull = ()=>{
        const { data: dataBasic } = $59f9598ada60a2a8$var$useCurrentUserBasic();
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $lGLse.useUserSubscriber)();
        (0, $eUqFw.useEffect)(()=>{
            tenantContext.atlassianAccountId && fetch({
                params: {
                    accountId: tenantContext.atlassianAccountId
                }
            }, false);
        }, [
            fetch,
            tenantContext.atlassianAccountId
        ]);
        return (0, $eUqFw.useMemo)(()=>({
                data: {
                    ...dataBasic,
                    user: {
                        ...dataBasic.user,
                        ...data
                    }
                },
                loading: loading,
                error: error
            }), [
            data,
            dataBasic,
            error,
            loading
        ]);
    };
    const $59f9598ada60a2a8$export$3901076af3749fa9 = ()=>(0, $gd0Sp.useTenantContext)().isAnonymous ? $59f9598ada60a2a8$var$useCurrentUserBasic() : $59f9598ada60a2a8$var$useCurrentUserFull();
    const $59f9598ada60a2a8$export$6414ebbbfff99d4c = ({ children: children })=>{
        const result = $59f9598ada60a2a8$export$3901076af3749fa9();
        return children(result);
    };
});
parcelRegister("lGLse", function(module, exports) {
    $parcel$export(module.exports, "UserContainer", ()=>$033cdb69b2583281$export$7ff085589970ee0a);
    $parcel$export(module.exports, "useUserSubscriber", ()=>$033cdb69b2583281$export$4e61bbf568682a96);
    var $WBLbN = parcelRequire("WBLbN");
    var $kdNL5 = parcelRequire("kdNL5");
    const $033cdb69b2583281$var$initialState = {
        data: null,
        loading: false,
        error: null
    };
    const $033cdb69b2583281$var$Store = (0, $WBLbN.createStore)({
        name: 'user',
        initialState: $033cdb69b2583281$var$initialState,
        actions: $kdNL5
    });
    const $033cdb69b2583281$export$7ff085589970ee0a = (0, $WBLbN.createContainer)($033cdb69b2583281$var$Store);
    const $033cdb69b2583281$export$4e61bbf568682a96 = (0, $WBLbN.createHook)($033cdb69b2583281$var$Store);
});
parcelRegister("kdNL5", function(module, exports) {
    $parcel$export(module.exports, "fetch", ()=>$dd4efebc20057365$export$e7aa7bc5c1b3cfb3);
    var $1TLNE = parcelRequire("1TLNE");
    const $dd4efebc20057365$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (!params || currentState.loading || currentState.data && !forceRefetch) return;
            setState({
                loading: true
            });
            try {
                const data = await (0, $1TLNE.fetchData)({
                    params: params,
                    header: header
                });
                setState({
                    data: data,
                    loading: false,
                    error: null
                });
            } catch (err) {
                setState({
                    error: err,
                    loading: false
                });
            }
        };
});
parcelRegister("1TLNE", function(module, exports) {
    $parcel$export(module.exports, "fetchData", ()=>$7f578fc13a1a3e40$export$8134c072fddab6a5);
    var $53ciZ = parcelRequire("53ciZ");
    var $lRmyA = parcelRequire("lRmyA");
    const $7f578fc13a1a3e40$export$8134c072fddab6a5 = ({ params: params, header: header })=>{
        const queryParams = {
            ...params,
            expand: Object.keys(params.expand || {}).filter((key)=>params.expand && params.expand[key])
        };
        const query = (0, $53ciZ.stringify)(queryParams, {
            arrayFormat: 'none'
        });
        const queryString = query ? `?${query}` : '';
        const requestUrl = `/rest/api/2/user${queryString}`;
        return (0, $lRmyA.performGetRequest)(requestUrl, header ? {
            headers: header
        } : {});
    };
});
parcelRegister("enMj3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9dc15b871bc1035e$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $9t7rW = parcelRequire("9t7rW");
    var $8BCWs = parcelRequire("8BCWs");
    const $9dc15b871bc1035e$var$HelpPanelLoading = ({ loadingArticle: loadingArticle = false })=>loadingArticle ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8BCWs.HelpPanelContainerV2), null, (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$HeaderLoading, null), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingContent, null, (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            role: "img",
            "aria-label": "help panel loading"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-250, 20px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "90%"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "80%"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "70%"
        })))) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8BCWs.HelpPanelContainerV2), null, (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$HeaderLoading, null), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingContent, null, (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-500, 40px)",
            marginTop: "var(--ds-space-100, 8px)"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadignArticleList, {
            role: "img"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadignArticleListItem, null, (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-150, 12px)",
            contentWidth: "var(--ds-space-800, 64px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-150, 12px)"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        })), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadignArticleListItem, null, (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-150, 12px)",
            contentWidth: "var(--ds-space-800, 64px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-150, 12px)"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        })), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadignArticleListItem, null, (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentHeight: "var(--ds-space-150, 12px)",
            contentWidth: "var(--ds-space-800, 64px)",
            marginTop: "var(--ds-space-0, 0px)"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-150, 12px)"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement($9dc15b871bc1035e$var$LoadingRectangle, {
            contentWidth: "100%",
            marginTop: "var(--ds-space-050, 4px)"
        })))));
    var $9dc15b871bc1035e$export$2e2bcd8739ae039 = $9dc15b871bc1035e$var$HelpPanelLoading;
    const $9dc15b871bc1035e$var$LoadingContent = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_1yt4pxbi _kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $9dc15b871bc1035e$var$HeaderLoading = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_4t3ixncg _bfhk10nm _n7zlxs90 _1bah1yb4 _kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $9dc15b871bc1035e$var$shimmer = null;
    const $9dc15b871bc1035e$var$LoadingRectangle = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { contentHeight: contentHeight, marginTop: marginTop, contentWidth: contentWidth, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_l7mdyr": (0, $9t7rW.default)(__cmplp.contentHeight),
                "--_1fj4wta": (0, $9t7rW.default)(__cmplp.marginTop),
                "--_7n1eiw": (0, $9t7rW.default)(__cmplp.contentWidth)
            },
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_kqswh2mm _2rkov77o _5sag126j _1o51q7pw _tip812c5 _j7hq1en8 _1pglp3kn _bfhk134c _1itk15g1 _12vemgnk",
                __cmplp.contentHeight != null ? "_4t3i6c59" : "_4t3ipxbi",
                __cmplp.marginTop != null ? "_19pkmye1" : "_19pku2gc",
                __cmplp.contentWidth != null ? "_1bsbwd3v" : "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $9dc15b871bc1035e$var$LoadignArticleList = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_1bsb1osq _18s8v0yc _1yt4ze3t _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $9dc15b871bc1035e$var$LoadignArticleListItem = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_1e0c1ule _1bsb1osq _1yt4u2gc _vchhusvi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8BCWs", function(module, exports) {
    $parcel$export(module.exports, "HelpPanelContainer", ()=>$03325f336784369d$export$37cd645d7678f7d4);
    $parcel$export(module.exports, "HelpPanelContainerV2", ()=>$03325f336784369d$export$1df7e3ebfc4c9b06);
    $parcel$export(module.exports, "HelpPanelSectionMessageContainer", ()=>$03325f336784369d$export$9f6251c714594f23);
    $parcel$export(module.exports, "HelpPanelContentContainer", ()=>$03325f336784369d$export$1cdb922eed7271d1);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    const $03325f336784369d$export$37cd645d7678f7d4 = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $eUqFw.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_vchhusvi _16jlkb7n _1o9zkb7n _i0dlf1ug _1kl71osx _1reo15vq _18m915vq _2lx21bp4 _1bsb1feq _4t3i1osq _kqsw1n9t",
                __cmplp.className
            ])
        });
    });
    const $03325f336784369d$export$1df7e3ebfc4c9b06 = (0, $eUqFw.forwardRef)(({ as: C = $03325f336784369d$export$37cd645d7678f7d4, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $eUqFw.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_4t3i1i8v _11q71bhr",
                __cmplp.className
            ])
        });
    });
    const $03325f336784369d$export$9f6251c714594f23 = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $eUqFw.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_kqswh2mm _1yt41rfa _1bsb1osq _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $03325f336784369d$export$1cdb922eed7271d1 = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $eUqFw.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_16jlkb7n _1tkeidpf _kqswh2mm _18m91wug _1reo15vq _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ae4v1fhb _4cvr1y6m",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("rqehi", function(module, exports) {
    $parcel$export(module.exports, "useSearchContext", ()=>$0775421d423c6e01$export$67b98b1b880a048b);
    $parcel$export(module.exports, "SearchContextProvider", ()=>$0775421d423c6e01$export$6bd70292443463a4);
    var $eUqFw = parcelRequire("eUqFw");
    var $b8VQt = parcelRequire("b8VQt");
    const [$0775421d423c6e01$export$67b98b1b880a048b, $0775421d423c6e01$export$70af50e847ce290a] = (0, $b8VQt.createCtx)();
    const $0775421d423c6e01$export$6bd70292443463a4 = ({ children: children })=>{
        const [searchContext, setSearchContext] = (0, $eUqFw.useState)({});
        const addClickedArticleIds = (0, $eUqFw.useCallback)((query, clickedArticleId)=>{
            setSearchContext((prev)=>({
                    ...prev,
                    [query]: {
                        ...prev[query],
                        clickedArticleIds: prev[query]?.clickedArticleIds ? [
                            ...prev[query].clickedArticleIds,
                            clickedArticleId
                        ] : [
                            clickedArticleId
                        ]
                    }
                }));
        }, []);
        const addFetchedArticleIds = (0, $eUqFw.useCallback)((query, fetchedArticles)=>{
            setSearchContext((prev)=>({
                    ...prev,
                    [query]: {
                        ...prev[query],
                        fetchedArticleIds: fetchedArticles
                    }
                }));
        }, []);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($0775421d423c6e01$export$70af50e847ce290a, {
            value: {
                searchContext: searchContext,
                addClickedArticleIds: addClickedArticleIds,
                addFetchedArticleIds: addFetchedArticleIds
            }
        }, children);
    };
});
parcelRegister("b8VQt", function(module, exports) {
    $parcel$export(module.exports, "createCtx", ()=>$911944d6c4e559cb$export$d653a1a643c9a98c);
    var $eUqFw = parcelRequire("eUqFw");
    function $911944d6c4e559cb$export$d653a1a643c9a98c() {
        const ctx = (0, $eUqFw.createContext)(undefined);
        function useCtx() {
            const c = (0, $eUqFw.useContext)(ctx);
            if (!c) throw new Error('useCtx must be inside a Provider with a value');
            return c;
        }
        return [
            useCtx,
            ctx.Provider
        ];
    }
});
parcelRegister("bZhE6", function(module, exports) {
    $parcel$export(module.exports, "AsyncLazyHelpPanel", ()=>$8726324405ab1f9c$export$7ff46d33d0f13518);
    var $56koX = parcelRequire("56koX");
    const $8726324405ab1f9c$export$7ff46d33d0f13518 = (0, $56koX.lazyForPaint)(()=>(parcelRequire("8Rkdk")).then(({ HelpPanel: HelpPanel })=>HelpPanel), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/help-panel/src/ui/index.tsx"
    });
});
parcelRegister("8Rkdk", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("8Av70")
    ]).then(()=>parcelRequire('lwEqL'));
});
parcelRegister("eGjiP", function(module, exports) {
    $parcel$export(module.exports, "SafeEmbeddedConfluencePanel", ()=>$3730299ad39def57$export$2d901a489872dd0d);
    var $eUqFw = parcelRequire("eUqFw");
    var $jGR8u = parcelRequire("jGR8u");
    var $fHiYa = parcelRequire("fHiYa");
    var $cGCxH = parcelRequire("cGCxH");
    var $fYx5D = parcelRequire("fYx5D");
    var $0cdA8 = parcelRequire("0cdA8");
    var $bUi2Q = parcelRequire("bUi2Q");
    var $ih3cb = parcelRequire("ih3cb");
    const $3730299ad39def57$var$DELAY = 310;
    const $3730299ad39def57$export$2db0a2e0275af8b8 = ()=>{
        const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
        const [{ panel: isOpen }] = (0, $fYx5D.useEmbeddedConfluenceSidePanel)();
        const [localPanelId, setLocalPanelId] = (0, $eUqFw.useState)();
        const prevPanelIdRef = (0, $eUqFw.useRef)();
        const delayRef = (0, $eUqFw.useRef)(null);
        const panelId = rightSidebarCurrentState?.panelId;
        const { entryPointActions: entryPointActions, entryPoint: entryPoint } = (0, $ih3cb.useEmbeddedPanelEntryPoint)();
        (0, $eUqFw.useEffect)(()=>{
            if (isOpen) entryPointActions?.load();
        }, [
            isOpen,
            entryPointActions,
            localPanelId
        ]);
        (0, $eUqFw.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, $cGCxH.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                }, $3730299ad39def57$var$DELAY);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            panelId,
            rightSidebarCurrentState
        ]);
        if (localPanelId !== (0, $cGCxH.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)) return null;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $3730299ad39def57$var$panelStyles
        }, entryPoint);
    };
    const $3730299ad39def57$export$2d901a489872dd0d = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            fallback: "unmount",
            id: "right-side-embedded-confluence-panel",
            packageName: "jiraIssueCreateConfluenceContent"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $fYx5D.EmbeddedConfluenceSidepanelContainer), null, (0, ($parcel$interopDefault($eUqFw))).createElement($3730299ad39def57$export$2db0a2e0275af8b8, null)));
    const $3730299ad39def57$var$panelStyles = (0, $fHiYa.xcss)({
        padding: 'space.100',
        height: 'calc(100vh - (var(--topNavigationHeight, 0px) + var(--bannerHeight, 0px)))'
    });
});
parcelRegister("cGCxH", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceFeatureKeys", ()=>$8c4704bc755a9560$export$746d4746bf07dd70);
    $parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_KEY", ()=>$8c4704bc755a9560$export$6247c7e19b71f4e);
    $parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_KEY", ()=>$8c4704bc755a9560$export$e34c4c923d934e7a);
    $parcel$export(module.exports, "CONFLUENCE_CONTROLS_STORAGE_PROVIDER_KEY", ()=>$8c4704bc755a9560$export$ffe60197eb59ca73);
    $parcel$export(module.exports, "CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY", ()=>$8c4704bc755a9560$export$8d0c4a26241944b8);
    $parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID", ()=>$8c4704bc755a9560$export$a497288e64e9a343);
    const $8c4704bc755a9560$export$746d4746bf07dd70 = {
        ENABLE_CONFLUENCE_SIGNUP: 'jira.admin.confluence.enable-integrations',
        SPRINT_RETRO: 'jira.admin.confluence.enable-sprint-retros',
        CREATE_MENU_TOP_ACTIONS: 'jira.admin.confluence.enable-content-creation-issue-top-actions',
        CREATE_MENU_CONFLUENCE_CONTENT: 'jira.admin.confluence.enable-content-creation-issue-confluence-content'
    };
    const $8c4704bc755a9560$export$6247c7e19b71f4e = 'confluence-integration-controls';
    const $8c4704bc755a9560$export$e34c4c923d934e7a = 'user-confluence-access';
    const $8c4704bc755a9560$export$ffe60197eb59ca73 = 'confluence-integration-controls-session-storage';
    const $8c4704bc755a9560$export$8d0c4a26241944b8 = 'confluence-permissions-session-storage';
    const $8c4704bc755a9560$export$a497288e64e9a343 = 'embedded-confluence-panel-container';
});
parcelRegister("fYx5D", function(module, exports) {
    $parcel$export(module.exports, "EmbeddedConfluenceSidepanelContainer", ()=>$57bfebfe29c272f2$export$a5c1c168018f0f16);
    $parcel$export(module.exports, "useEmbeddedConfluenceSidePanel", ()=>$57bfebfe29c272f2$export$518aeea31a00450e);
    var $eUqFw = parcelRequire("eUqFw");
    var $79xbN = parcelRequire("79xbN");
    var $hJ992 = parcelRequire("hJ992");
    var $bUi2Q = parcelRequire("bUi2Q");
    var $WBLbN = parcelRequire("WBLbN");
    var $cGCxH = parcelRequire("cGCxH");
    var $kesKZ = parcelRequire("kesKZ");
    var $9pYcd = parcelRequire("9pYcd");
    var $02qo9 = parcelRequire("02qo9");
    const $57bfebfe29c272f2$var$Container = (0, $WBLbN.createContainer)();
    const $57bfebfe29c272f2$var$DefaultStore = (0, $WBLbN.createStore)({
        actions: $kesKZ.actions,
        containedBy: $57bfebfe29c272f2$var$Container,
        initialState: $kesKZ.initialState,
        name: (0, $cGCxH.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
    });
    const $57bfebfe29c272f2$var$NonContainerStore = (0, $WBLbN.createStore)({
        actions: $kesKZ.actions,
        initialState: $kesKZ.initialState,
        name: (0, $cGCxH.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID)
    });
    const $57bfebfe29c272f2$export$a5c1c168018f0f16 = ({ children: children })=>{
        const issueKey = (0, $hJ992.useIssueKey)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement($57bfebfe29c272f2$var$Container, {
            scope: `embedded-confluence-sidepanel-${issueKey}`
        }, children);
    };
    const $57bfebfe29c272f2$var$defaultStoreHook = (0, $WBLbN.createHook)($57bfebfe29c272f2$var$DefaultStore);
    const $57bfebfe29c272f2$var$nonContainerStoreHook = (0, $WBLbN.createHook)($57bfebfe29c272f2$var$NonContainerStore);
    const $57bfebfe29c272f2$export$518aeea31a00450e = (embeddedConfluenceSource)=>{
        const [embedConfluenceSidepanelConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jira_issue_view_side_by_side_modeless_ep_exp');
        const isInExperiment = embedConfluenceSidepanelConfig.get('cohort', 'not-enrolled') === 'experiment';
        const [state, { setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection, setDeferredSpaceName: setDeferredSpaceName, openSidePanel: openSidePanelAction, closeSidePanel: closeSidePanelAction }] = isInExperiment ? $57bfebfe29c272f2$var$defaultStoreHook() : $57bfebfe29c272f2$var$nonContainerStoreHook();
        const { closeRightSidebar: closeRightSidebar, openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
        const openSidePanel = (0, $eUqFw.useCallback)(({ contentId: contentId, contentType: contentType, data: data, hostname: hostname, isDraft: isDraft, isLive: isLive, onLinkPage: onLinkPage, onPublish: onPublish, openInModal: openInModal, mode: mode, url: url, title: title })=>{
            const { initialWidth: initialWidth, displayType: displayType } = (0, $02qo9.getDisplayInformation)();
            const shouldOpenPanel = displayType === (0, $9pYcd.DisplayTypes).PANEL;
            if (shouldOpenPanel) {
                openSidePanelAction({
                    contentId: contentId,
                    contentType: contentType,
                    embeddedConfluenceSource: embeddedConfluenceSource,
                    data: data,
                    displayType: displayType,
                    initialWidth: initialWidth,
                    hostname: hostname,
                    isDraft: isDraft,
                    isLive: isLive,
                    mode: mode,
                    onLinkPage: onLinkPage,
                    onPublish: onPublish,
                    shouldOpenModal: !shouldOpenPanel,
                    url: url,
                    title: title
                });
                openRightSidebar((0, $cGCxH.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID), initialWidth, false, true);
            } else openInModal();
        }, [
            embeddedConfluenceSource,
            openRightSidebar,
            openSidePanelAction
        ]);
        const closeSidePanel = (0, $eUqFw.useCallback)(()=>{
            closeRightSidebar((0, $cGCxH.EMBEDDED_CONFLUENCE_SIDEPANEL_CONTAINER_ID));
            closeSidePanelAction();
        }, [
            closeRightSidebar,
            closeSidePanelAction
        ]);
        return [
            state,
            {
                openSidePanel: openSidePanel,
                closeSidePanel: closeSidePanel,
                setDeferredSpaceName: setDeferredSpaceName,
                setIsLoadingForDeferSpaceSelection: setIsLoadingForDeferSpaceSelection
            }
        ];
    };
});
parcelRegister("hJ992", function(module, exports) {
    $parcel$export(module.exports, "useChildIssuesLimit", ()=>$7e3614f655e5103c$export$8d75f312eaa63aec);
    $parcel$export(module.exports, "useChildIssuesIssueLimitUrl", ()=>$7e3614f655e5103c$export$65a59acd1ffc5bba);
    $parcel$export(module.exports, "useIsModal", ()=>$7e3614f655e5103c$export$9ce8428ff198804a);
    $parcel$export(module.exports, "useIssueKey", ()=>$7e3614f655e5103c$export$22108eca27445997);
    $parcel$export(module.exports, "useIssueId", ()=>$7e3614f655e5103c$export$9df8176b5ffce5ab);
    $parcel$export(module.exports, "useIsArchived", ()=>$7e3614f655e5103c$export$7cd1821433aafaee);
    $parcel$export(module.exports, "useIsClassifyEditEnabled", ()=>$7e3614f655e5103c$export$b23b36ed5c42e920);
    $parcel$export(module.exports, "useProjectKey", ()=>$7e3614f655e5103c$export$f87be37f8e8be65);
    $parcel$export(module.exports, "useAnalyticsSource", ()=>$7e3614f655e5103c$export$aad3917152559b87);
    $parcel$export(module.exports, "useIssueContextActions", ()=>$7e3614f655e5103c$export$d6ec1293313f49ac);
    $parcel$export(module.exports, "useRapidViewMap", ()=>$7e3614f655e5103c$export$4d204e800e4e0be7);
    $parcel$export(module.exports, "useEstimationStatistic", ()=>$7e3614f655e5103c$export$5b20e30ee6db56e9);
    $parcel$export(module.exports, "useViewMode", ()=>$7e3614f655e5103c$export$3a7c3e259b6adb93);
    $parcel$export(module.exports, "useBackButtonUrl", ()=>$7e3614f655e5103c$export$cfe64a334903927c);
    $parcel$export(module.exports, "useIssueNavigatorData", ()=>$7e3614f655e5103c$export$aa008a00bae7e7ab);
    $parcel$export(module.exports, "useOnIssueKeyChange", ()=>$7e3614f655e5103c$export$52c975cf0b623556);
    $parcel$export(module.exports, "useRapidViewId", ()=>$7e3614f655e5103c$export$b34d0ea0bf41fee);
    $parcel$export(module.exports, "useViewScreenId", ()=>$7e3614f655e5103c$export$7c142b5701b4c3f9);
    $parcel$export(module.exports, "useHasSoftwareAccess", ()=>$7e3614f655e5103c$export$dcc0d1c3cd4bd9fb);
    $parcel$export(module.exports, "useIsFullPageIssueView", ()=>$7e3614f655e5103c$export$2e131fc4108f9106);
    $parcel$export(module.exports, "useIsEmbedPageIssueView", ()=>$7e3614f655e5103c$export$4596c26005fbb859);
    $parcel$export(module.exports, "useIsAiOptInEnabled", ()=>$7e3614f655e5103c$export$b131d9f6da853161);
    $parcel$export(module.exports, "useIsJiraIssue", ()=>$7e3614f655e5103c$export$cf5fc815f761fb4b);
    var $eUqFw = parcelRequire("eUqFw");
    var $7ZZxN = parcelRequire("7ZZxN");
    var $e91YZ = parcelRequire("e91YZ");
    var $guDlK = parcelRequire("guDlK");
    var $6vrw7 = parcelRequire("6vrw7");
    var $7HKaW = parcelRequire("7HKaW");
    var $jBTMs = parcelRequire("jBTMs");
    var $j3FUN = parcelRequire("j3FUN");
    var $hWdjG = parcelRequire("hWdjG");
    const $7e3614f655e5103c$export$8d75f312eaa63aec = ()=>{
        const [childIssuesLimit] = (0, $hWdjG.useIssueContextStoreChildIssuesLimit)();
        return childIssuesLimit;
    };
    const $7e3614f655e5103c$export$cc6e0a43a2a9b17a = ()=>{
        const [childIssuesIssueLimitUrls] = (0, $hWdjG.useIssueContextStoreChildIssuesIssueLimitUrls)();
        return childIssuesIssueLimitUrls;
    };
    const $7e3614f655e5103c$export$65a59acd1ffc5bba = (fieldId)=>{
        const childIssuesIssueLimitUrls = $7e3614f655e5103c$export$cc6e0a43a2a9b17a();
        return childIssuesIssueLimitUrls?.[fieldId];
    };
    const $7e3614f655e5103c$export$9ce8428ff198804a = ()=>{
        const [isModal] = (0, $hWdjG.useIssueContextStoreIsModal)();
        return isModal;
    };
    const $7e3614f655e5103c$export$22108eca27445997 = ()=>{
        const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
        return issueKey;
    };
    const $7e3614f655e5103c$export$9df8176b5ffce5ab = ()=>{
        const [issueId] = (0, $hWdjG.useIssueContextStoreIssueId)();
        return issueId;
    };
    const $7e3614f655e5103c$export$7cd1821433aafaee = ()=>{
        const [isArchived] = (0, $hWdjG.useIssueContextStoreIsArchived)();
        return isArchived;
    };
    const $7e3614f655e5103c$export$b23b36ed5c42e920 = ()=>{
        const [isClassifyEditEnabled] = (0, $hWdjG.useIssueContextStoreIsClassifyEditEnabled)();
        return isClassifyEditEnabled;
    };
    const $7e3614f655e5103c$export$f87be37f8e8be65 = ()=>{
        const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
        return (0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
    };
    const $7e3614f655e5103c$export$aad3917152559b87 = ()=>{
        const [analyticsSource] = (0, $hWdjG.useIssueContextStoreAnalyticsSource)();
        return analyticsSource;
    };
    const $7e3614f655e5103c$export$d6ec1293313f49ac = ()=>{
        const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $hWdjG.useIssueContextStoreActions)();
        const actions = (0, $eUqFw.useMemo)(()=>({
                setIssueContext: setIssueContext,
                mergeIssueContext: mergeIssueContext,
                getChildIssuesLimit: getChildIssuesLimit,
                getMaxTokenLength: getMaxTokenLength,
                getIsLoadedWithPage: getIsLoadedWithPage,
                getBackButtonUrl: getBackButtonUrl,
                getIsSpaEnabled: getIsSpaEnabled,
                getIssueKey: getIssueKey,
                setDetailViewAsModal: setDetailViewAsModal,
                setDetailViewAsSidebar: setDetailViewAsSidebar,
                resetDetailView: resetDetailView
            }), [
            setIssueContext,
            mergeIssueContext,
            getChildIssuesLimit,
            getMaxTokenLength,
            getIsLoadedWithPage,
            getBackButtonUrl,
            getIsSpaEnabled,
            getIssueKey,
            setDetailViewAsModal,
            setDetailViewAsSidebar,
            resetDetailView
        ]);
        return [
            undefined,
            actions
        ];
    };
    const $7e3614f655e5103c$export$4d204e800e4e0be7 = ()=>{
        const [rapidViewMap] = (0, $hWdjG.useIssueContextRapidViewMap)();
        return rapidViewMap;
    };
    const $7e3614f655e5103c$export$e0d7666ae716c88a = ()=>{
        const [maxTokenLength] = (0, $hWdjG.useIssueContextStoreMaxTokenLength)();
        return maxTokenLength;
    };
    const $7e3614f655e5103c$export$b4199f923267161e = ()=>{
        const [isLoadedWithPage] = (0, $hWdjG.useIssueContextStoreIsLoadedWithPage)();
        return isLoadedWithPage;
    };
    const $7e3614f655e5103c$export$5b20e30ee6db56e9 = ()=>{
        const [estimationStatistic] = (0, $hWdjG.useIssueContextStoreEstimationStatistic)();
        return estimationStatistic;
    };
    const $7e3614f655e5103c$export$4dface15d86304a4 = ()=>{
        const [isLoading] = (0, $hWdjG.useIssueContextStoreIsLoading)();
        return isLoading;
    };
    const $7e3614f655e5103c$export$3a7c3e259b6adb93 = ()=>{
        const [viewMode] = (0, $hWdjG.useIssueContextStoreViewMode)();
        return viewMode;
    };
    const $7e3614f655e5103c$export$cfe64a334903927c = ()=>{
        const [backButtonUrl] = (0, $hWdjG.useIssueContextStoreBackButtonUrl)();
        return backButtonUrl;
    };
    const $7e3614f655e5103c$export$aa008a00bae7e7ab = ()=>{
        const [issueNavigatorData] = (0, $hWdjG.useIssueContextStoreIssueNavigatorData)();
        return issueNavigatorData;
    };
    const $7e3614f655e5103c$export$b49754504c41149f = ()=>{
        const [boardId] = (0, $hWdjG.useIssueContextStoreBoardId)();
        return boardId;
    };
    const $7e3614f655e5103c$export$91aab984882a2a2c = ()=>{
        const [boardType] = (0, $hWdjG.useIssueContextStoreBoardType)();
        return boardType;
    };
    const $7e3614f655e5103c$export$dbad9dbd4871f2e9 = ()=>{
        const [isSpaEnabled] = (0, $hWdjG.useIssueContextStoreIsSpaEnabled)();
        return isSpaEnabled;
    };
    const $7e3614f655e5103c$export$7be495880d433ab9 = ()=>{
        const [loginRedirectUrl] = (0, $hWdjG.useIssueContextStoreLoginRedirctUrl)();
        return loginRedirectUrl;
    };
    const $7e3614f655e5103c$export$52c975cf0b623556 = ()=>{
        const [onIssueKeyChange] = (0, $hWdjG.useIssueContextStoreOnIssueKeyChange)();
        return onIssueKeyChange;
    };
    const $7e3614f655e5103c$export$b34d0ea0bf41fee = ()=>{
        const [rapidViewId] = (0, $hWdjG.useIssueContextStoreRapidViewId)();
        return rapidViewId;
    };
    const $7e3614f655e5103c$export$7c142b5701b4c3f9 = ()=>{
        const [viewScreenId] = (0, $hWdjG.useIssueContextStoreViewScreenId)();
        return viewScreenId;
    };
    const $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb = ()=>{
        const licensedProducts = (0, $j3FUN.useLicensedProducts)();
        const licenseStates = (0, $jBTMs.useLicenseStates)();
        const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $7HKaW.LICENSE_STATE_ACTIVE);
        return licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
    };
    const $7e3614f655e5103c$export$2e131fc4108f9106 = ()=>{
        const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
        return analyticsSource === (0, $0100842672acae20$export$b19f949fb9713614);
    };
    const $7e3614f655e5103c$export$4596c26005fbb859 = ()=>{
        const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
        return analyticsSource === (0, $0100842672acae20$export$a5132300c5214280);
    };
    const $7e3614f655e5103c$export$b131d9f6da853161 = ()=>{
        const [isAiOptInEnabled] = (0, $hWdjG.useIssueContextIsAiOptInEnabled)();
        return isAiOptInEnabled;
    };
    const $7e3614f655e5103c$export$cf5fc815f761fb4b = ()=>{
        const issueKey = $7e3614f655e5103c$export$22108eca27445997();
        const projectKey = (0, $guDlK.useProjectKey)(issueKey);
        const projectType = (0, $guDlK.useProjectType)(projectKey);
        return [
            (0, $7ZZxN.SOFTWARE_PROJECT),
            (0, $7ZZxN.CORE_PROJECT)
        ].some((type)=>type === projectType);
    };
});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$5e91e17726e54450 = 'jiraCalendar';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';
parcelRegister("guDlK", function(module, exports) {
    $parcel$export(module.exports, "useProjectKey", ()=>$598d4d607d97d3ec$export$f87be37f8e8be65);
    $parcel$export(module.exports, "useProjectContextActions", ()=>$598d4d607d97d3ec$export$bd73624ca941f105);
    $parcel$export(module.exports, "useProjectType", ()=>$598d4d607d97d3ec$export$6de29d851c914935);
    $parcel$export(module.exports, "useProjectContext", ()=>$598d4d607d97d3ec$export$8f31c2503e1efa93);
    $parcel$export(module.exports, "useApplication", ()=>$598d4d607d97d3ec$export$aaf75bb403fe1fb5);
    $parcel$export(module.exports, "useEdition", ()=>$598d4d607d97d3ec$export$d56c02945cf5a9e5);
    $parcel$export(module.exports, "useIsSimplifiedProject", ()=>$598d4d607d97d3ec$export$524ef4f6102ed540);
    $parcel$export(module.exports, "useIsClassicProject", ()=>$598d4d607d97d3ec$export$e2cf96f40a8867ce);
    $parcel$export(module.exports, "useProjectId", ()=>$598d4d607d97d3ec$export$16d1475ed6c26568);
    $parcel$export(module.exports, "useProjectStatus", ()=>$598d4d607d97d3ec$export$30f16f2782a4113b);
    $parcel$export(module.exports, "useProjectConfiguration", ()=>$598d4d607d97d3ec$export$af19ad68b52fa1a6);
    $parcel$export(module.exports, "useProjectIssueTypes", ()=>$598d4d607d97d3ec$export$80bef597b440cf71);
    var $eUqFw = parcelRequire("eUqFw");
    var $eIp1n = parcelRequire("eIp1n");
    var $6WXNs = parcelRequire("6WXNs");
    var $6vrw7 = parcelRequire("6vrw7");
    var $gd0Sp = parcelRequire("gd0Sp");
    var $lbuGg = parcelRequire("lbuGg");
    var $9ZB9O = parcelRequire("9ZB9O");
    const $598d4d607d97d3ec$export$f87be37f8e8be65 = (issueKey)=>(0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
    const $598d4d607d97d3ec$export$bd73624ca941f105 = ()=>{
        const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $lbuGg.useProjectContextActionStore)();
        const actions = (0, $eUqFw.useMemo)(()=>({
                setProjectContext: setProjectContext,
                mergeProjectProperty: mergeProjectProperty
            }), [
            setProjectContext,
            mergeProjectProperty
        ]);
        return [
            null,
            actions
        ];
    };
    const $598d4d607d97d3ec$export$6de29d851c914935 = (projectKey)=>{
        const [projectType] = (0, $lbuGg.useProjectContextProjectTypeStore)({
            projectKey: projectKey
        });
        return projectType;
    };
    const $598d4d607d97d3ec$export$8f31c2503e1efa93 = (projectKey)=>{
        const [projectContext] = (0, $lbuGg.useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext;
    };
    const $598d4d607d97d3ec$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
        const projectType = $598d4d607d97d3ec$export$6de29d851c914935(projectKey);
        if (projectType === undefined) {
            if (failSafely) return undefined;
            throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
        }
        return (0, $eIp1n.getApplicationForProject)(projectType);
    };
    const $598d4d607d97d3ec$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
        const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
        const application = $598d4d607d97d3ec$export$aaf75bb403fe1fb5(projectKey, failSafely);
        if (!application) return undefined;
        return (0, $6WXNs.getEdition)(application, appEditions);
    };
    const $598d4d607d97d3ec$export$524ef4f6102ed540 = (projectKey)=>{
        const [projectContext] = (0, $lbuGg.useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.isSimplified || false;
    };
    const $598d4d607d97d3ec$export$e2cf96f40a8867ce = (projectKey)=>{
        const [projectContext] = (0, $lbuGg.useProjectContextStore)({
            projectKey: projectKey
        });
        return !projectContext?.isSimplified;
    };
    const $598d4d607d97d3ec$export$16d1475ed6c26568 = (projectKey)=>{
        const [projectContext] = (0, $lbuGg.useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.projectId;
    };
    const $598d4d607d97d3ec$export$30f16f2782a4113b = (projectKey)=>{
        const [projectContext] = (0, $lbuGg.useProjectContextStore)({
            projectKey: projectKey
        });
        return projectContext?.projectStatus;
    };
    const $598d4d607d97d3ec$export$af19ad68b52fa1a6 = (projectKey)=>{
        const projectType = $598d4d607d97d3ec$export$6de29d851c914935(projectKey);
        const isSimplified = $598d4d607d97d3ec$export$524ef4f6102ed540(projectKey);
        return (0, $9ZB9O.getIssueConfiguration)({
            isSimplified: isSimplified,
            projectType: projectType
        });
    };
    const $598d4d607d97d3ec$export$654dd2c557853fbe = (projectKey)=>{
        const [projectName] = (0, $lbuGg.useProjectContextProjectNameStore)({
            projectKey: projectKey
        });
        return projectName;
    };
    const $598d4d607d97d3ec$export$80bef597b440cf71 = (projectKey)=>{
        const [issueTypes] = (0, $lbuGg.useProjectContextIssueTypesStore)({
            projectKey: projectKey
        });
        return issueTypes;
    };
});
parcelRegister("lbuGg", function(module, exports) {
    $parcel$export(module.exports, "useProjectContextActionStore", ()=>$4715ac6bc4ce2fb7$export$9afb89c1fe103bbe);
    $parcel$export(module.exports, "useProjectContextStore", ()=>$4715ac6bc4ce2fb7$export$8b09478b33186ec);
    $parcel$export(module.exports, "useProjectContextProjectTypeStore", ()=>$4715ac6bc4ce2fb7$export$f2e1ed3b2b4707cb);
    $parcel$export(module.exports, "useProjectContextProjectNameStore", ()=>$4715ac6bc4ce2fb7$export$9469fde70658518);
    $parcel$export(module.exports, "useProjectContextIssueTypesStore", ()=>$4715ac6bc4ce2fb7$export$f73e9904779f6be5);
    var $WBLbN = parcelRequire("WBLbN");
    var $bAXOf = parcelRequire("bAXOf");
    const $4715ac6bc4ce2fb7$var$initialState = {};
    const $4715ac6bc4ce2fb7$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
        name: 'project-context',
        initialState: $4715ac6bc4ce2fb7$var$initialState,
        actions: $bAXOf
    });
    const $4715ac6bc4ce2fb7$export$9afb89c1fe103bbe = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
        selector: null
    });
    const $4715ac6bc4ce2fb7$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
    const $4715ac6bc4ce2fb7$export$8b09478b33186ec = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
        selector: $4715ac6bc4ce2fb7$var$getProjectContext
    });
    const $4715ac6bc4ce2fb7$var$getProjectType = (state, { projectKey: projectKey })=>{
        const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.projectType;
    };
    const $4715ac6bc4ce2fb7$export$f2e1ed3b2b4707cb = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
        selector: $4715ac6bc4ce2fb7$var$getProjectType
    });
    const $4715ac6bc4ce2fb7$var$getProjectName = (state, { projectKey: projectKey })=>{
        const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.projectName;
    };
    const $4715ac6bc4ce2fb7$export$9469fde70658518 = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
        selector: $4715ac6bc4ce2fb7$var$getProjectName
    });
    const $4715ac6bc4ce2fb7$var$getIssueTypes = (state, { projectKey: projectKey })=>{
        const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
            projectKey: projectKey
        });
        return projectContext?.issueTypes;
    };
    const $4715ac6bc4ce2fb7$export$f73e9904779f6be5 = (0, $WBLbN.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
        selector: $4715ac6bc4ce2fb7$var$getIssueTypes
    });
});
parcelRegister("bAXOf", function(module, exports) {
    $parcel$export(module.exports, "setProjectContext", ()=>$f8fc64b164fe014a$export$d64151aab9ae5f09);
    $parcel$export(module.exports, "mergeProjectProperty", ()=>$f8fc64b164fe014a$export$78f1c6052937615f);
    const $f8fc64b164fe014a$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
            setState({
                [key]: projectContext
            });
        };
    const $f8fc64b164fe014a$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const currentProjectContext = currentState[key];
            const newProjectContext = {
                ...currentProjectContext,
                ...projectContext
            };
            setState({
                [key]: newProjectContext
            });
        };
});
parcelRegister("9ZB9O", function(module, exports) {
    $parcel$export(module.exports, "getIssueConfiguration", ()=>$78bf57e6f575c3aa$export$902f6c5cc939598a);
    var $2wUFy = parcelRequire("2wUFy");
    var $7ZZxN = parcelRequire("7ZZxN");
    const $78bf57e6f575c3aa$export$cdbd1eb3b05729e0 = 'flagActions';
    const $78bf57e6f575c3aa$export$c161a774ec2e7e56 = 'cardCoverActions';
    const $78bf57e6f575c3aa$export$a52507e68e7aeeb = ()=>({
            issueActions: []
        });
    const $78bf57e6f575c3aa$export$381ce08838c53afa = ()=>({
            applicationKey: (0, $2wUFy.default).CORE_ISSUE,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $78bf57e6f575c3aa$export$27e0678365e5dcff = ()=>({
            applicationKey: (0, $2wUFy.default).SOFTWARE_ISSUE,
            issueActions: [
                $78bf57e6f575c3aa$export$cdbd1eb3b05729e0
            ],
            ecosystemEnabled: true
        });
    const $78bf57e6f575c3aa$export$aebf676dfa727a1c = ()=>({
            applicationKey: (0, $2wUFy.default).SIMPLE_SOFTWARE_BOARD,
            issueActions: [
                $78bf57e6f575c3aa$export$cdbd1eb3b05729e0,
                $78bf57e6f575c3aa$export$c161a774ec2e7e56
            ],
            ecosystemEnabled: true
        });
    const $78bf57e6f575c3aa$export$1afca4d3eb6b218b = ()=>({
            applicationKey: (0, $2wUFy.default).STANDARD_ROADMAP_ISSUE,
            issueActions: [
                $78bf57e6f575c3aa$export$cdbd1eb3b05729e0
            ],
            ecosystemEnabled: true
        });
    const $78bf57e6f575c3aa$export$8a060ed6f66c43b0 = ()=>({
            applicationKey: (0, $2wUFy.default).BITBUCKET_ISSUE,
            issueActions: []
        });
    const $78bf57e6f575c3aa$export$78a2cb921e46f5eb = ()=>({
            applicationKey: (0, $2wUFy.default).MOBILE_ISSUE,
            issueActions: []
        });
    const $78bf57e6f575c3aa$export$db1115186532f6d5 = ()=>({
            applicationKey: (0, $2wUFy.default).SERVICE_DESK,
            issueActions: [],
            ecosystemEnabled: true
        });
    const $78bf57e6f575c3aa$export$902f6c5cc939598a = (config)=>{
        if (config) switch(config.projectType){
            case 0, $7ZZxN.SOFTWARE_PROJECT:
                if (config.isSimplified) return $78bf57e6f575c3aa$export$aebf676dfa727a1c();
                return $78bf57e6f575c3aa$export$27e0678365e5dcff();
            case 0, $7ZZxN.CORE_PROJECT:
                return $78bf57e6f575c3aa$export$381ce08838c53afa();
            case 0, $7ZZxN.SERVICE_DESK_PROJECT:
                return $78bf57e6f575c3aa$export$db1115186532f6d5();
            default:
                return $78bf57e6f575c3aa$export$27e0678365e5dcff();
        }
        return $78bf57e6f575c3aa$export$27e0678365e5dcff();
    };
});
parcelRegister("2wUFy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78d48529cb7f139c$export$2e2bcd8739ae039);
    const $78d48529cb7f139c$var$keys = {
        CONNECT_ISSUE: 'connect-issue',
        BITBUCKET_ISSUE: 'bitbucket-issue',
        CORE_ISSUE: 'core-issue',
        MOBILE_ISSUE: 'mobile-issue',
        SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
        SOFTWARE_ISSUE: 'software-issue',
        STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
        SERVICE_DESK: 'service-desk',
        EMPTY_APPLICATION_KEY: ''
    };
    var $78d48529cb7f139c$export$2e2bcd8739ae039 = $78d48529cb7f139c$var$keys;
});
parcelRegister("jBTMs", function(module, exports) {
    $parcel$export(module.exports, "useLicenseStates", ()=>$0a5df676eadd90b5$export$268651a63abe408a);
    var $gd0Sp = parcelRequire("gd0Sp");
    const $0a5df676eadd90b5$export$268651a63abe408a = ()=>{
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        return tenantContext && tenantContext.licenseStates;
    };
});
parcelRegister("j3FUN", function(module, exports) {
    $parcel$export(module.exports, "useLicensedProducts", ()=>$02df0e5ac33ae573$export$54d534cc91e54850);
    var $gd0Sp = parcelRequire("gd0Sp");
    const $02df0e5ac33ae573$export$54d534cc91e54850 = ()=>{
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        return tenantContext && tenantContext.licensedProducts || {};
    };
});
parcelRegister("hWdjG", function(module, exports) {
    $parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", ()=>$c495211a89197754$export$abdbea56d86b4aac);
    $parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", ()=>$c495211a89197754$export$326ff2b963d51c5c);
    $parcel$export(module.exports, "useIssueContextStoreIssueKey", ()=>$c495211a89197754$export$44bcaaabb74e402b);
    $parcel$export(module.exports, "useIssueContextStoreIssueId", ()=>$c495211a89197754$export$332dcee0cf9f4e45);
    $parcel$export(module.exports, "useIssueContextStoreIsArchived", ()=>$c495211a89197754$export$c940355b1fc6e1c4);
    $parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", ()=>$c495211a89197754$export$b9eebaa1da421997);
    $parcel$export(module.exports, "useIssueContextStoreIsModal", ()=>$c495211a89197754$export$daa47fd600e43a32);
    $parcel$export(module.exports, "useIssueContextStoreViewScreenId", ()=>$c495211a89197754$export$ba2e9546ab5ba6f);
    $parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", ()=>$c495211a89197754$export$74d38d6c437efc1b);
    $parcel$export(module.exports, "useIssueContextRapidViewMap", ()=>$c495211a89197754$export$2092528ee170d9e7);
    $parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", ()=>$c495211a89197754$export$57898374e6239a5a);
    $parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", ()=>$c495211a89197754$export$ff0264ec4c015dc1);
    $parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", ()=>$c495211a89197754$export$6c8b81f6dca8c23d);
    $parcel$export(module.exports, "useIssueContextStoreIsLoading", ()=>$c495211a89197754$export$fe7085456138f0fc);
    $parcel$export(module.exports, "useIssueContextStoreViewMode", ()=>$c495211a89197754$export$c339e36468c12443);
    $parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", ()=>$c495211a89197754$export$ef3bfa2642bb98cd);
    $parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", ()=>$c495211a89197754$export$8accd063c74cd455);
    $parcel$export(module.exports, "useIssueContextStoreBoardId", ()=>$c495211a89197754$export$e7edffc2a20027e7);
    $parcel$export(module.exports, "useIssueContextStoreBoardType", ()=>$c495211a89197754$export$48aaa3a6bc2085d7);
    $parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", ()=>$c495211a89197754$export$4a4b96bcf5166327);
    $parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", ()=>$c495211a89197754$export$bbd8ba0180545556);
    $parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", ()=>$c495211a89197754$export$aaa89627762c7d00);
    $parcel$export(module.exports, "useIssueContextStoreRapidViewId", ()=>$c495211a89197754$export$796589b0ec52848a);
    $parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", ()=>$c495211a89197754$export$7e70ee570119a0a7);
    $parcel$export(module.exports, "IssueContextContainer", ()=>$c495211a89197754$export$93db6a8f3342dddf);
    $parcel$export(module.exports, "useIssueContextStoreActions", ()=>$c495211a89197754$export$965360ae27fcae98);
    var $6vrw7 = parcelRequire("6vrw7");
    var $WBLbN = parcelRequire("WBLbN");
    var $8d785 = parcelRequire("8d785");
    var $hHM8F = parcelRequire("hHM8F");
    var $fhgeS = parcelRequire("fhgeS");
    const $c495211a89197754$export$d4c72bab9d6cc13a = {
        childIssuesLimit: undefined,
        childIssuesIssueLimitUrls: undefined,
        issueKey: (0, $6vrw7.toIssueKey)(''),
        isArchived: false,
        isClassifyEditEnabled: false,
        isModal: false,
        maxTokenLength: 0,
        isLoadedWithPage: false,
        rapidViewMap: undefined,
        estimationStatistic: undefined,
        isLoading: false,
        viewMode: (0, $fhgeS.getViewModeFromLocalStorage)(),
        analyticsSource: undefined,
        backButtonUrl: undefined,
        issueNavigatorData: undefined,
        boardId: undefined,
        boardType: undefined,
        isSpaEnabled: false,
        loginRedirectUrl: undefined,
        onIssueKeyChange: undefined,
        rapidViewId: undefined,
        viewScreenId: undefined,
        isAiOptInEnabled: false
    };
    const $c495211a89197754$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
        name: 'issue-context',
        initialState: $c495211a89197754$export$d4c72bab9d6cc13a,
        actions: $8d785.actions
    });
    const $c495211a89197754$var$getIssueContext = (state)=>state;
    const $c495211a89197754$var$getIsModal = (state)=>state.isModal;
    const $c495211a89197754$var$getIssueKey = (state)=>state.issueKey;
    const $c495211a89197754$var$getIsArchived = (state)=>state.isArchived;
    const $c495211a89197754$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
    const $c495211a89197754$var$getIssueId = (state)=>state.issueId;
    const $c495211a89197754$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
    const $c495211a89197754$var$getRapidViewMap = (state)=>state.rapidViewMap;
    const $c495211a89197754$var$getMaxTokenLength = (state)=>state.maxTokenLength;
    const $c495211a89197754$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
    const $c495211a89197754$var$getEstimationStatistic = (state)=>state.estimationStatistic;
    const $c495211a89197754$var$getIsLoading = (state)=>state.isLoading;
    const $c495211a89197754$var$getViewMode = (state)=>state.viewMode;
    const $c495211a89197754$var$getBackButtonUrl = (state)=>state.backButtonUrl;
    const $c495211a89197754$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
    const $c495211a89197754$var$getBoardId = (state)=>state.boardId;
    const $c495211a89197754$var$getBoardType = (state)=>state.boardType;
    const $c495211a89197754$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
    const $c495211a89197754$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
    const $c495211a89197754$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
    const $c495211a89197754$var$getRapidViewId = (state)=>state.rapidViewId;
    const $c495211a89197754$var$getViewScreenId = (state)=>state.viewScreenId;
    const $c495211a89197754$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
    const $c495211a89197754$export$f6e0a3ee03299fbc = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getIssueContext
    });
    const $c495211a89197754$export$abdbea56d86b4aac = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: (0, $hHM8F.getChildIssuesLimit)
    });
    const $c495211a89197754$export$326ff2b963d51c5c = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: (0, $hHM8F.getChildIssuesIssueLimitUrls)
    });
    const $c495211a89197754$export$44bcaaabb74e402b = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getIssueKey
    });
    const $c495211a89197754$export$332dcee0cf9f4e45 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getIssueId
    });
    const $c495211a89197754$export$c940355b1fc6e1c4 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getIsArchived
    });
    const $c495211a89197754$export$b9eebaa1da421997 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getIsClassifyEditEnabled
    });
    const $c495211a89197754$export$daa47fd600e43a32 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getIsModal
    });
    const $c495211a89197754$export$ba2e9546ab5ba6f = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getViewScreenId
    });
    const $c495211a89197754$export$74d38d6c437efc1b = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getAnalyticsSource
    });
    const $c495211a89197754$export$2092528ee170d9e7 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getRapidViewMap
    });
    const $c495211a89197754$export$57898374e6239a5a = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getMaxTokenLength
    });
    const $c495211a89197754$export$ff0264ec4c015dc1 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getIsLoadedWithPage
    });
    const $c495211a89197754$export$6c8b81f6dca8c23d = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getEstimationStatistic
    });
    const $c495211a89197754$export$fe7085456138f0fc = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getIsLoading
    });
    const $c495211a89197754$export$c339e36468c12443 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getViewMode
    });
    const $c495211a89197754$export$ef3bfa2642bb98cd = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getBackButtonUrl
    });
    const $c495211a89197754$export$8accd063c74cd455 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getIssueNavigatorData
    });
    const $c495211a89197754$export$e7edffc2a20027e7 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getBoardId
    });
    const $c495211a89197754$export$48aaa3a6bc2085d7 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getBoardType
    });
    const $c495211a89197754$export$4a4b96bcf5166327 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getIsSpaEnabled
    });
    const $c495211a89197754$export$bbd8ba0180545556 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getLoginRedirectUrl
    });
    const $c495211a89197754$export$aaa89627762c7d00 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getOnIssueKeyChange
    });
    const $c495211a89197754$export$796589b0ec52848a = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getRapidViewId
    });
    const $c495211a89197754$export$7e70ee570119a0a7 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: $c495211a89197754$var$getIsAiOptInEnabled
    });
    const $c495211a89197754$export$93db6a8f3342dddf = (0, $WBLbN.createContainer)($c495211a89197754$export$6f57813fe9f31bf9);
    const $c495211a89197754$export$965360ae27fcae98 = (0, $WBLbN.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
        selector: null
    });
});
parcelRegister("8d785", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$0a3f8ba487c482e8$export$e324594224ef24da);
    var $7LyiF = parcelRequire("7LyiF");
    var $hHM8F = parcelRequire("hHM8F");
    var $fhgeS = parcelRequire("fhgeS");
    const $0a3f8ba487c482e8$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
            const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
            if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
                ...issueContext,
                issueId: undefined,
                viewMode: issueContext.viewMode || getState().viewMode
            });
            else setState({
                ...issueContext,
                viewMode: issueContext.viewMode || getState().viewMode
            });
        };
    const $0a3f8ba487c482e8$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
            const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
            if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
                ...getState(),
                ...partialIssueContext,
                issueId: undefined
            });
            else setState({
                ...getState(),
                ...partialIssueContext
            });
        };
    const $0a3f8ba487c482e8$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $hHM8F.getChildIssuesLimit)(getState());
    const $0a3f8ba487c482e8$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
    const $0a3f8ba487c482e8$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
    const $0a3f8ba487c482e8$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
    const $0a3f8ba487c482e8$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
    const $0a3f8ba487c482e8$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
    const $0a3f8ba487c482e8$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
    const $0a3f8ba487c482e8$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
            if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), 'MODAL');
            setState({
                viewMode: 'MODAL'
            });
        };
    const $0a3f8ba487c482e8$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
            if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), 'SIDEBAR');
            setState({
                viewMode: 'SIDEBAR'
            });
        };
    const $0a3f8ba487c482e8$export$75007d125f198b78 = ()=>({ setState: setState })=>{
            setState({
                viewMode: (0, $fhgeS.getViewModeFromLocalStorage)()
            });
        };
    const $0a3f8ba487c482e8$export$e324594224ef24da = {
        setIssueContext: $0a3f8ba487c482e8$export$784a03c4b74da53e,
        mergeIssueContext: $0a3f8ba487c482e8$export$666ee48e0eaf4f13,
        getChildIssuesLimit: $0a3f8ba487c482e8$export$89b6937a83edcaa6,
        getMaxTokenLength: $0a3f8ba487c482e8$export$e40f2acaf1a50b00,
        getIsLoadedWithPage: $0a3f8ba487c482e8$export$2fe981b90be13483,
        getBackButtonUrl: $0a3f8ba487c482e8$export$afce556782490aae,
        getIsSpaEnabled: $0a3f8ba487c482e8$export$711dfa096bf81f2d,
        getIssueKey: $0a3f8ba487c482e8$export$4a030f6192bebe03,
        getIsArchived: $0a3f8ba487c482e8$export$b41341ac6c74ca6,
        setDetailViewAsModal: $0a3f8ba487c482e8$export$77ec0de2f63f10c4,
        setDetailViewAsSidebar: $0a3f8ba487c482e8$export$b303af51de56a0e,
        resetDetailView: $0a3f8ba487c482e8$export$75007d125f198b78
    };
});
parcelRegister("7LyiF", function(module, exports) {
    $parcel$export(module.exports, "LOG_LOCATION", ()=>$7643f341d271ccc9$export$25a759e49d5049db);
    $parcel$export(module.exports, "localStorage", ()=>$7643f341d271ccc9$export$c2ed3351cac403d1);
    $parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", ()=>$7643f341d271ccc9$export$a13f7f627010bccd);
    var $aZaPn = parcelRequire("aZaPn");
    const $7643f341d271ccc9$export$25a759e49d5049db = 'issue.issue-context-service';
    const $7643f341d271ccc9$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_issue_view');
    const $7643f341d271ccc9$export$a13f7f627010bccd = 'view-mode';
});
parcelRegister("hHM8F", function(module, exports) {
    $parcel$export(module.exports, "getChildIssuesLimit", ()=>$a9a8c93b5bcca8ab$export$89b6937a83edcaa6);
    $parcel$export(module.exports, "getChildIssuesIssueLimitUrls", ()=>$a9a8c93b5bcca8ab$export$8f43520910e8128c);
    var $gUUjF = parcelRequire("gUUjF");
    var $7LyiF = parcelRequire("7LyiF");
    const $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
    const $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $7LyiF.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
        return $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT;
    };
    const $a9a8c93b5bcca8ab$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
    const $a9a8c93b5bcca8ab$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;
});
parcelRegister("fhgeS", function(module, exports) {
    $parcel$export(module.exports, "getViewModeFromLocalStorage", ()=>$49ad189ccd6ad8c9$export$cae7c4c591dcc261);
    var $7LyiF = parcelRequire("7LyiF");
    const $49ad189ccd6ad8c9$export$cae7c4c591dcc261 = ()=>(0, $7LyiF.localStorage).get((0, $7LyiF.VIEW_MODE_STORAGE_KEY)) || 'DEFAULT';
});
parcelRegister("kesKZ", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$793b6123392d83ee$export$d4c72bab9d6cc13a);
    $parcel$export(module.exports, "actions", ()=>$793b6123392d83ee$export$e324594224ef24da);
    var $jHUwu = parcelRequire("jHUwu");
    var $9pYcd = parcelRequire("9pYcd");
    const $793b6123392d83ee$export$d4c72bab9d6cc13a = {
        confluenceData: {
            contentId: '',
            contentUrl: '',
            contentData: null,
            mode: (0, $jHUwu.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            isDraft: false,
            isLive: false
        },
        contentActions: {},
        contentType: (0, $9pYcd.ConfluenceContentTypes).PAGE,
        embeddedConfluenceSource: '',
        displayType: (0, $9pYcd.DisplayTypes).PANEL,
        panel: {
            initialWidth: 0,
            isOpen: false,
            isLoading: false
        },
        modal: {
            isOpen: false
        }
    };
    const $793b6123392d83ee$export$aa5d06fef96639ba = ({ contentId: contentId, contentType: contentType, embeddedConfluenceSource: embeddedConfluenceSource, data: data, displayType: displayType, initialWidth: initialWidth, hostname: hostname, isDraft: isDraft, isLive: isLive, mode: mode, onLinkPage: onLinkPage, onPublish: onPublish, shouldOpenModal: shouldOpenModal, url: url, title: title })=>({ setState: setState })=>{
            setState({
                confluenceData: {
                    contentId: contentId,
                    contentUrl: url,
                    contentData: data,
                    hostname: hostname,
                    mode: mode,
                    isDraft: isDraft,
                    isLive: isLive,
                    title: title
                },
                contentActions: {
                    onLinkPage: onLinkPage,
                    onPublish: onPublish
                },
                embeddedConfluenceSource: embeddedConfluenceSource,
                contentType: contentType,
                displayType: displayType,
                panel: {
                    initialWidth: initialWidth,
                    isOpen: !shouldOpenModal
                },
                modal: {
                    isOpen: shouldOpenModal
                }
            });
        };
    const $793b6123392d83ee$export$e81b26ab493ca52a = ()=>({ setState: setState })=>{
            setState($793b6123392d83ee$export$d4c72bab9d6cc13a);
        };
    const $793b6123392d83ee$export$1a38f537b5932219 = (deferredSpaceName)=>({ setState: setState, getState: getState })=>{
            const { confluenceData: confluenceData, ...prevState } = getState();
            setState({
                confluenceData: {
                    ...confluenceData,
                    deferredSpaceName: deferredSpaceName
                },
                ...prevState
            });
        };
    const $793b6123392d83ee$export$db9852cd4946540a = ({ isLoading: isLoading, isDeferSpaceSelection: isDeferSpaceSelection })=>({ setState: setState, getState: getState })=>{
            const { panel: panel, ...prevState } = getState();
            setState({
                ...prevState,
                isDeferSpaceSelection: isDeferSpaceSelection,
                panel: {
                    ...panel,
                    isLoading: isLoading
                }
            });
        };
    const $793b6123392d83ee$export$e324594224ef24da = {
        closeSidePanel: $793b6123392d83ee$export$e81b26ab493ca52a,
        setDeferredSpaceName: $793b6123392d83ee$export$1a38f537b5932219,
        openSidePanel: $793b6123392d83ee$export$aa5d06fef96639ba,
        setIsLoadingForDeferSpaceSelection: $793b6123392d83ee$export$db9852cd4946540a
    };
});
parcelRegister("jHUwu", function(module, exports) {
    $parcel$export(module.exports, "EMBEDDED_CONFLUENCE_MODE", ()=>$30e96c81a87ca84d$export$816ef638e478449a);
    var $30e96c81a87ca84d$export$816ef638e478449a;
    (function(EMBEDDED_CONFLUENCE_MODE) {
        EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
        EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    })($30e96c81a87ca84d$export$816ef638e478449a || ($30e96c81a87ca84d$export$816ef638e478449a = {}));
});
parcelRegister("9pYcd", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceContentTypes", ()=>$39eb515aa687d2a5$export$b39616d00ee96d40);
    $parcel$export(module.exports, "DisplayTypes", ()=>$39eb515aa687d2a5$export$c294d3f3727c1a0);
    const $39eb515aa687d2a5$export$b39616d00ee96d40 = {
        WHITEBOARD: 'whiteboard',
        PAGE: 'page'
    };
    const $39eb515aa687d2a5$export$c294d3f3727c1a0 = {
        MODAL: 'modal',
        PANEL: 'panel'
    };
});
parcelRegister("02qo9", function(module, exports) {
    $parcel$export(module.exports, "getDisplayInformation", ()=>$b84672c547e7927b$export$ee79869f97207574);
    var $9pYcd = parcelRequire("9pYcd");
    const $b84672c547e7927b$export$37e31995727dc8d7 = 0.5;
    const $b84672c547e7927b$export$ee79869f97207574 = ()=>{
        const screenWidth = window.innerWidth;
        if (screenWidth >= 1024) return {
            initialWidth: screenWidth * $b84672c547e7927b$export$37e31995727dc8d7,
            displayType: (0, $9pYcd.DisplayTypes).PANEL
        };
        return {
            initialWidth: 0,
            displayType: (0, $9pYcd.DisplayTypes).MODAL
        };
    };
});
parcelRegister("ih3cb", function(module, exports) {
    $parcel$export(module.exports, "useEmbeddedPanelEntryPoint", ()=>$8cde58005f26c88b$export$75ef2f025ecbf1de);
    var $eUqFw = parcelRequire("eUqFw");
    var $fjjRQ = parcelRequire("fjjRQ");
    var $5GK0h = parcelRequire("5GK0h");
    var $fYx5D = parcelRequire("fYx5D");
    var $1HzcR = parcelRequire("1HzcR");
    var $6j4bv = parcelRequire("6j4bv");
    var $1ybV0 = parcelRequire("1ybV0");
    var $5JgJ2 = parcelRequire("5JgJ2");
    var $aGJM1 = parcelRequire("aGJM1");
    var $bczMu = parcelRequire("bczMu");
    var $eq2dV = parcelRequire("eq2dV");
    var $dMGT3 = parcelRequire("dMGT3");
    const $8cde58005f26c88b$var$entryPointParams = {};
    const $8cde58005f26c88b$export$75ef2f025ecbf1de = ()=>{
        const { locale: locale } = (0, $5JgJ2.default)();
        const [state, actions] = (0, $fYx5D.useEmbeddedConfluenceSidePanel)();
        const { contentType: contentType, confluenceData: { contentId: contentId, contentUrl: contentUrl, hostname: hostname, isLive: isLive, isDraft: isDraft, title: title, mode: mode }, isDeferSpaceSelection: isDeferSpaceSelection, contentActions: { onLinkPage: onLinkPage }, panel: { isOpen: isOpen }, embeddedConfluenceSource: embeddedConfluenceSource } = state;
        const parentProduct = (0, $dMGT3.useParentProduct)();
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $aGJM1.embeddedPanelEntrypoint), $8cde58005f26c88b$var$entryPointParams);
        const embeddedConfluenceSourceForPanel = `${embeddedConfluenceSource}Panel`;
        const deferSpaceToast = (0, $1ybV0.ff)('toast_defer_space_ntufi');
        const isTemplateBrowserEnabled = (0, $1ybV0.ff)('jira.issue-view.create-confluence-page.template-browser');
        const fireAnalyticsEvent = (0, $eq2dV.useEmbeddedPageTracking)();
        const themeState = (0, $fjjRQ.default)();
        const contentHostname = (0, $bczMu.setHostnameForContent)(contentUrl, hostname);
        const onContentAction = (0, $eUqFw.useCallback)((action, eventName)=>{
            fireAnalyticsEvent({
                action: action,
                eventName: eventName,
                embeddedConfluenceSource: embeddedConfluenceSourceForPanel
            });
        }, [
            fireAnalyticsEvent,
            embeddedConfluenceSourceForPanel
        ]);
        const onClose = (0, $eUqFw.useCallback)(()=>{
            fireAnalyticsEvent({
                action: 'clicked',
                eventName: 'closeEmbeddedConfluencePanel',
                embeddedConfluenceSource: embeddedConfluenceSourceForPanel
            });
            entryPointActions.unload();
            actions.closeSidePanel();
        }, [
            actions,
            fireAnalyticsEvent,
            entryPointActions,
            embeddedConfluenceSourceForPanel
        ]);
        const editAllowedFeatures = (0, $eUqFw.useMemo)(()=>[
                ...isDeferSpaceSelection ? [
                    'publish-modal'
                ] : [],
                ...isTemplateBrowserEnabled ? [
                    'template-browser'
                ] : []
            ], [
            isDeferSpaceSelection,
            isTemplateBrowserEnabled
        ]);
        const shouldApplyEditFeatures = editAllowedFeatures.length > 0 && isDraft;
        const shouldOpenPanel = isOpen && contentUrl;
        const runtimeProps = (0, $eUqFw.useMemo)(()=>({
                locale: locale,
                hasFooterLogo: false,
                isDraft: isDraft,
                isLive: isLive,
                hostname: contentHostname,
                panelTitle: title,
                navigationPolicy: undefined,
                onClose: onClose,
                onContentAction: onContentAction,
                parentProduct: parentProduct,
                spaceKey: (0, $5GK0h.parseUrl)(contentUrl)?.spaceKey,
                themeState: themeState,
                url: contentUrl,
                mode: mode,
                embeddedConfluenceSource: embeddedConfluenceSourceForPanel,
                contentId: contentId,
                contentType: contentType,
                ...deferSpaceToast && {
                    onPublish: actions.setDeferredSpaceName
                },
                allowedFeatures: {
                    view: [
                        'byline-contributors',
                        'byline-extensions',
                        'page-comments',
                        'page-reactions',
                        'inline-comments',
                        'non-licensed-share'
                    ],
                    ...shouldApplyEditFeatures && {
                        edit: editAllowedFeatures
                    }
                },
                linkConfluencePage: onLinkPage
            }), [
            actions.setDeferredSpaceName,
            contentId,
            contentType,
            contentUrl,
            deferSpaceToast,
            editAllowedFeatures,
            embeddedConfluenceSourceForPanel,
            contentHostname,
            isDraft,
            isLive,
            locale,
            title,
            mode,
            onClose,
            onContentAction,
            onLinkPage,
            parentProduct,
            themeState,
            shouldApplyEditFeatures
        ]);
        return shouldOpenPanel ? {
            entryPointActions: entryPointActions,
            entryPoint: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                id: "epPanelEntrypointContainer",
                packageName: "@atlassian/jira-issue-create-confluence-content",
                teamName: "confluence-better-together",
                runtimeProps: runtimeProps
            })
        } : {
            ref: undefined,
            entryPoint: null
        };
    };
});
parcelRegister("5GK0h", function(module, exports) {
    $parcel$export(module.exports, "parsePageProps", ()=>$57419abcc1676350$export$41eb0a358b69a9df);
    $parcel$export(module.exports, "parseUrl", ()=>$57419abcc1676350$export$7a5253c0f62e0150);
    var $78Ywx = parcelRequire("78Ywx");
    var $1d3eD = parcelRequire("1d3eD");
    var $1VCZT = parcelRequire("1VCZT");
    var $gCnjT = parcelRequire("gCnjT");
    var $jHUwu = parcelRequire("jHUwu");
    var $ebeAz = parcelRequire("ebeAz");
    function $57419abcc1676350$export$41eb0a358b69a9df(props) {
        let { contentId: contentId = '', hostname: hostname, parentProduct: parentProduct = '', spaceKey: spaceKey, url: url, allowedFeatures: allowedFeatures, mode: mode, draftShareId: draftShareId, hash: hash, themeState: themeState, ...passThroughProps } = props;
        const parsedAllowedFeatures = $57419abcc1676350$export$350c411f568eceb9(allowedFeatures);
        if (!url) return {
            contentId: contentId,
            hostname: hostname,
            parentProduct: parentProduct,
            spaceKey: spaceKey,
            protocol: 'https:',
            mode: mode ?? (0, $jHUwu.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE,
            allowedFeatures: parsedAllowedFeatures,
            draftShareId: draftShareId,
            hash: hash,
            themeState: themeState,
            ...passThroughProps
        };
        const parsedProps = $57419abcc1676350$export$7a5253c0f62e0150(url);
        if (!parsedProps) return {
            hostname: hostname,
            contentId: contentId,
            spaceKey: spaceKey,
            parentProduct: parentProduct,
            mode: mode,
            protocol: 'https:',
            allowedFeatures: parsedAllowedFeatures,
            draftShareId: draftShareId,
            hash: hash,
            themeState: themeState,
            ...passThroughProps
        };
        const themeStateParsedObject = parsedProps.themeState ? (0, $1VCZT.themeStringToObject)(decodeURIComponent(parsedProps.themeState)) : undefined;
        contentId = contentId || parsedProps.contentId;
        parentProduct = parentProduct || parsedProps.parentProduct;
        hostname = hostname || parsedProps.hostname || window.location.hostname;
        spaceKey = spaceKey || parsedProps.spaceKey;
        draftShareId = draftShareId || parsedProps.draftShareId;
        hash = hash || parsedProps.hash;
        themeState = themeState || themeStateParsedObject;
        let modeFromUrl;
        switch(parsedProps.route){
            case (0, $ebeAz.VIEW_PAGE).name:
            case (0, $ebeAz.VIEW_BLOG).name:
            case (0, $ebeAz.VIEW_BLOG_DATE_LEGACY).name:
                modeFromUrl = (0, $jHUwu.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE;
                break;
            case (0, $ebeAz.EDIT_PAGE_EMBED).name:
            case (0, $ebeAz.EDIT_PAGE_V2).name:
                modeFromUrl = (0, $jHUwu.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE;
        }
        return {
            allowedFeatures: $57419abcc1676350$export$350c411f568eceb9(allowedFeatures),
            contentId: contentId,
            draftShareId: draftShareId,
            hash: hash,
            hostname: hostname,
            mode: mode || modeFromUrl,
            parentProduct: parentProduct,
            protocol: parsedProps.protocol,
            spaceKey: spaceKey,
            themeState: themeState,
            ...passThroughProps
        };
    }
    function $57419abcc1676350$export$7a5253c0f62e0150(url) {
        if (!url) return null;
        const matchedRoute = $57419abcc1676350$var$findAndMatchRoute((0, $ebeAz.namedRoutes), url);
        if (!matchedRoute) return null;
        const { routeName: routeName, ...match } = matchedRoute;
        return {
            route: routeName,
            hostname: match.host,
            protocol: match.protocol,
            contentId: match.params.contentId || '',
            spaceKey: match.params.spaceKey || '',
            hash: match.hash,
            parentProduct: Array.isArray(match.query.parentProduct) ? match.query.parentProduct[0] : match.query.parentProduct || '',
            draftShareId: Array.isArray(match.query.draftShareId) ? match.query.draftShareId[0] : match.query.draftShareId,
            themeState: match.query.themeState
        };
    }
    function $57419abcc1676350$var$findAndMatchRoute(routes, url) {
        for (const routeName of Object.keys(routes)){
            const pattern = routes[routeName].pattern;
            const match = $57419abcc1676350$var$matchUrl(pattern, url);
            if (match) return {
                routeName: routeName,
                ...match
            };
        }
    }
    function $57419abcc1676350$var$matchUrl(pattern, url) {
        const parsed = (0, ($parcel$interopDefault($78Ywx))).parse(url, true);
        const pathname = parsed.pathname || '';
        let match = (0, $1d3eD.default)(pathname, {
            path: pattern,
            exact: true
        });
        if (!match) match = (0, $1d3eD.default)(`${pathname}${parsed.search}`, {
            path: pattern,
            exact: true
        });
        if (!match) return null;
        const decodedParams = {};
        if (match && match.params) for (const [key, value] of Object.entries(match.params))decodedParams[key] = value;
        return {
            url: url,
            protocol: parsed?.protocol || 'https:',
            host: parsed?.host || '',
            pathname: pathname,
            search: parsed.search || '',
            hash: parsed.hash || '',
            pattern: pattern,
            params: decodedParams,
            query: parsed.query || ''
        };
    }
    function $57419abcc1676350$export$350c411f568eceb9(allowedFeatures) {
        let parsedAllowedFeatures = {
            view: allowedFeatures?.view,
            edit: allowedFeatures?.edit
        };
        if (!allowedFeatures?.view) parsedAllowedFeatures.view = [
            ...(0, $gCnjT.DEFAULT_ALLOWED_FEATURES).view,
            'edit'
        ];
        else if (Array.isArray(allowedFeatures?.view)) parsedAllowedFeatures.view = [
            ...allowedFeatures?.view,
            'edit'
        ];
        return parsedAllowedFeatures;
    }
});
parcelRegister("1d3eD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e1983bddd0ee331$export$2e2bcd8739ae039);
    var $43pB1 = parcelRequire("43pB1");
    var $0e1983bddd0ee331$var$patternCache = {};
    var $0e1983bddd0ee331$var$cacheLimit = 10000;
    var $0e1983bddd0ee331$var$cacheCount = 0;
    var $0e1983bddd0ee331$var$compilePath = function compilePath(pattern, options) {
        var cacheKey = "" + options.end + options.strict + options.sensitive;
        var cache = $0e1983bddd0ee331$var$patternCache[cacheKey] || ($0e1983bddd0ee331$var$patternCache[cacheKey] = {});
        if (cache[pattern]) return cache[pattern];
        var keys = [];
        var re = (0, ($parcel$interopDefault($43pB1)))(pattern, keys, options);
        var compiledPattern = {
            re: re,
            keys: keys
        };
        if ($0e1983bddd0ee331$var$cacheCount < $0e1983bddd0ee331$var$cacheLimit) {
            cache[pattern] = compiledPattern;
            $0e1983bddd0ee331$var$cacheCount++;
        }
        return compiledPattern;
    };
    var $0e1983bddd0ee331$var$matchPath = function matchPath(pathname) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var parent = arguments[2];
        if (typeof options === "string") options = {
            path: options
        };
        var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === undefined ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === undefined ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === undefined ? false : _options$sensitive;
        if (path == null) return parent;
        var _compilePath = $0e1983bddd0ee331$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), re = _compilePath.re, keys = _compilePath.keys;
        var match = re.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            url: path === "/" && url === "" ? "/" : url,
            isExact: isExact,
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    };
    var $0e1983bddd0ee331$export$2e2bcd8739ae039 = $0e1983bddd0ee331$var$matchPath;
});
parcelRegister("43pB1", function(module, exports) {
    var $e4Chz = parcelRequire("e4Chz");
    module.exports = $2f3b4c1d8f9b78ef$var$pathToRegexp;
    module.exports.parse = $2f3b4c1d8f9b78ef$var$parse;
    module.exports.compile = $2f3b4c1d8f9b78ef$var$compile;
    module.exports.tokensToFunction = $2f3b4c1d8f9b78ef$var$tokensToFunction;
    module.exports.tokensToRegExp = $2f3b4c1d8f9b78ef$var$tokensToRegExp;
    var $2f3b4c1d8f9b78ef$var$PATH_REGEXP = new RegExp([
        '(\\\\.)',
        '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
    ].join('|'), 'g');
    function $2f3b4c1d8f9b78ef$var$parse(str, options) {
        var tokens = [];
        var key = 0;
        var index = 0;
        var path = '';
        var defaultDelimiter = options && options.delimiter || '/';
        var res;
        while((res = $2f3b4c1d8f9b78ef$var$PATH_REGEXP.exec(str)) != null){
            var m = res[0];
            var escaped = res[1];
            var offset = res.index;
            path += str.slice(index, offset);
            index = offset + m.length;
            if (escaped) {
                path += escaped[1];
                continue;
            }
            var next = str[index];
            var prefix = res[2];
            var name = res[3];
            var capture = res[4];
            var group = res[5];
            var modifier = res[6];
            var asterisk = res[7];
            if (path) {
                tokens.push(path);
                path = '';
            }
            var partial = prefix != null && next != null && next !== prefix;
            var repeat = modifier === '+' || modifier === '*';
            var optional = modifier === '?' || modifier === '*';
            var delimiter = prefix || defaultDelimiter;
            var pattern = capture || group;
            var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
            tokens.push({
                name: name || key++,
                prefix: prefix || '',
                delimiter: delimiter,
                optional: optional,
                repeat: repeat,
                partial: partial,
                asterisk: !!asterisk,
                pattern: pattern ? $2f3b4c1d8f9b78ef$var$escapeGroup(pattern) : asterisk ? '.*' : $2f3b4c1d8f9b78ef$var$restrictBacktrack(delimiter, prevText)
            });
        }
        if (index < str.length) path += str.substr(index);
        if (path) tokens.push(path);
        return tokens;
    }
    function $2f3b4c1d8f9b78ef$var$restrictBacktrack(delimiter, prevText) {
        if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $2f3b4c1d8f9b78ef$var$escapeString(delimiter) + ']+?';
        return $2f3b4c1d8f9b78ef$var$escapeString(prevText) + '|(?:(?!' + $2f3b4c1d8f9b78ef$var$escapeString(prevText) + ')[^' + $2f3b4c1d8f9b78ef$var$escapeString(delimiter) + '])+?';
    }
    function $2f3b4c1d8f9b78ef$var$compile(str, options) {
        return $2f3b4c1d8f9b78ef$var$tokensToFunction($2f3b4c1d8f9b78ef$var$parse(str, options), options);
    }
    function $2f3b4c1d8f9b78ef$var$encodeURIComponentPretty(str) {
        return encodeURI(str).replace(/[\/?#]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
    }
    function $2f3b4c1d8f9b78ef$var$encodeAsterisk(str) {
        return encodeURI(str).replace(/[?#]/g, function(c) {
            return '%' + c.charCodeAt(0).toString(16).toUpperCase();
        });
    }
    function $2f3b4c1d8f9b78ef$var$tokensToFunction(tokens, options) {
        var matches = new Array(tokens.length);
        for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $2f3b4c1d8f9b78ef$var$flags(options));
        return function(obj, opts) {
            var path = '';
            var data = obj || {};
            var options = opts || {};
            var encode = options.pretty ? $2f3b4c1d8f9b78ef$var$encodeURIComponentPretty : encodeURIComponent;
            for(var i = 0; i < tokens.length; i++){
                var token = tokens[i];
                if (typeof token === 'string') {
                    path += token;
                    continue;
                }
                var value = data[token.name];
                var segment;
                if (value == null) {
                    if (token.optional) {
                        if (token.partial) path += token.prefix;
                        continue;
                    } else throw new TypeError('Expected "' + token.name + '" to be defined');
                }
                if ($e4Chz(value)) {
                    if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                    if (value.length === 0) {
                        if (token.optional) continue;
                        else throw new TypeError('Expected "' + token.name + '" to not be empty');
                    }
                    for(var j = 0; j < value.length; j++){
                        segment = encode(value[j]);
                        if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                        path += (j === 0 ? token.prefix : token.delimiter) + segment;
                    }
                    continue;
                }
                segment = token.asterisk ? $2f3b4c1d8f9b78ef$var$encodeAsterisk(value) : encode(value);
                if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
                path += token.prefix + segment;
            }
            return path;
        };
    }
    function $2f3b4c1d8f9b78ef$var$escapeString(str) {
        return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
    }
    function $2f3b4c1d8f9b78ef$var$escapeGroup(group) {
        return group.replace(/([=!:$\/()])/g, '\\$1');
    }
    function $2f3b4c1d8f9b78ef$var$attachKeys(re, keys) {
        re.keys = keys;
        return re;
    }
    function $2f3b4c1d8f9b78ef$var$flags(options) {
        return options && options.sensitive ? '' : 'i';
    }
    function $2f3b4c1d8f9b78ef$var$regexpToRegexp(path, keys) {
        var groups = path.source.match(/\((?!\?)/g);
        if (groups) for(var i = 0; i < groups.length; i++)keys.push({
            name: i,
            prefix: null,
            delimiter: null,
            optional: false,
            repeat: false,
            partial: false,
            asterisk: false,
            pattern: null
        });
        return $2f3b4c1d8f9b78ef$var$attachKeys(path, keys);
    }
    function $2f3b4c1d8f9b78ef$var$arrayToRegexp(path, keys, options) {
        var parts = [];
        for(var i = 0; i < path.length; i++)parts.push($2f3b4c1d8f9b78ef$var$pathToRegexp(path[i], keys, options).source);
        var regexp = new RegExp('(?:' + parts.join('|') + ')', $2f3b4c1d8f9b78ef$var$flags(options));
        return $2f3b4c1d8f9b78ef$var$attachKeys(regexp, keys);
    }
    function $2f3b4c1d8f9b78ef$var$stringToRegexp(path, keys, options) {
        return $2f3b4c1d8f9b78ef$var$tokensToRegExp($2f3b4c1d8f9b78ef$var$parse(path, options), keys, options);
    }
    function $2f3b4c1d8f9b78ef$var$tokensToRegExp(tokens, keys, options) {
        if (!$e4Chz(keys)) {
            options = keys || options;
            keys = [];
        }
        options = options || {};
        var strict = options.strict;
        var end = options.end !== false;
        var route = '';
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') route += $2f3b4c1d8f9b78ef$var$escapeString(token);
            else {
                var prefix = $2f3b4c1d8f9b78ef$var$escapeString(token.prefix);
                var capture = '(?:' + token.pattern + ')';
                keys.push(token);
                if (token.repeat) capture += '(?:' + prefix + capture + ')*';
                if (token.optional) {
                    if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                    else capture = prefix + '(' + capture + ')?';
                } else capture = prefix + '(' + capture + ')';
                route += capture;
            }
        }
        var delimiter = $2f3b4c1d8f9b78ef$var$escapeString(options.delimiter || '/');
        var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
        if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
        if (end) route += '$';
        else route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
        return $2f3b4c1d8f9b78ef$var$attachKeys(new RegExp('^' + route, $2f3b4c1d8f9b78ef$var$flags(options)), keys);
    }
    function $2f3b4c1d8f9b78ef$var$pathToRegexp(path, keys, options) {
        if (!$e4Chz(keys)) {
            options = keys || options;
            keys = [];
        }
        options = options || {};
        if (path instanceof RegExp) return $2f3b4c1d8f9b78ef$var$regexpToRegexp(path, keys);
        if ($e4Chz(path)) return $2f3b4c1d8f9b78ef$var$arrayToRegexp(path, keys, options);
        return $2f3b4c1d8f9b78ef$var$stringToRegexp(path, keys, options);
    }
});
parcelRegister("e4Chz", function(module, exports) {
    module.exports = Array.isArray || function(arr) {
        return Object.prototype.toString.call(arr) == '[object Array]';
    };
});
parcelRegister("gCnjT", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_ALLOWED_FEATURES", ()=>$b179781f3d7da943$export$a33327ada3a6ee4a);
    $parcel$export(module.exports, "getAllowedFeatures", ()=>$b179781f3d7da943$export$3207c60940c4a9b0);
    var $701v1 = parcelRequire("701v1");
    var $jHUwu = parcelRequire("jHUwu");
    var $b179781f3d7da943$export$241b9888a4d565c9;
    (function(ALLOWED_FEATURES_TYPE) {
        ALLOWED_FEATURES_TYPE["VIEW"] = "view";
        ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
        ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    })($b179781f3d7da943$export$241b9888a4d565c9 || ($b179781f3d7da943$export$241b9888a4d565c9 = {}));
    const $b179781f3d7da943$export$a3fda3dcee62e1cc = {
        view: [
            'byline-contributors',
            'byline-extensions',
            'delete',
            'edit',
            'inline-comments',
            'page-comments',
            'page-reactions',
            'sticky-header',
            'disable-login-flow',
            'disable-share',
            'non-licensed-share'
        ],
        edit: [
            'delete-draft',
            'disable-login-flow',
            'template-browser',
            'inline-comments'
        ],
        whiteboard: [
            'disable-login-flow',
            'copy',
            'favorite',
            'restrictions',
            'more-actions'
        ]
    };
    const $b179781f3d7da943$export$a33327ada3a6ee4a = {
        view: [
            'byline-contributors',
            'byline-extensions',
            'page-comments',
            'page-reactions',
            'inline-comments'
        ],
        edit: [
            'inline-comments'
        ],
        whiteboard: [
            'copy',
            'favorite',
            'restrictions',
            'more-actions'
        ]
    };
    const $b179781f3d7da943$var$pageAllowedFeatures = {
        [(0, $jHUwu.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $b179781f3d7da943$export$a3fda3dcee62e1cc.edit,
        [(0, $jHUwu.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $b179781f3d7da943$export$a3fda3dcee62e1cc.view
    };
    const $b179781f3d7da943$var$blogPostAllowedFeatures = {
        [(0, $jHUwu.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $b179781f3d7da943$export$a3fda3dcee62e1cc.edit,
        [(0, $jHUwu.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $b179781f3d7da943$export$a3fda3dcee62e1cc.view
    };
    const $b179781f3d7da943$var$whiteboardAllowedFeatures = {
        [(0, $jHUwu.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $b179781f3d7da943$export$a3fda3dcee62e1cc.whiteboard,
        [(0, $jHUwu.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $b179781f3d7da943$export$a3fda3dcee62e1cc.whiteboard
    };
    const $b179781f3d7da943$var$contentTypeAllowedFeatures = {
        [(0, $701v1.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $b179781f3d7da943$var$pageAllowedFeatures,
        [(0, $701v1.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $b179781f3d7da943$var$blogPostAllowedFeatures,
        [(0, $701v1.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $b179781f3d7da943$var$whiteboardAllowedFeatures
    };
    const $b179781f3d7da943$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $jHUwu.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$b179781f3d7da943$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
});
parcelRegister("701v1", function(module, exports) {
    $parcel$export(module.exports, "EMBEDDED_CONFLUENCE_CONTENT_TYPE", ()=>$4cc5ecf7014166be$export$942a5fac9b8c9dc2);
    var $4cc5ecf7014166be$export$942a5fac9b8c9dc2;
    (function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
        EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
        EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
        EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    })($4cc5ecf7014166be$export$942a5fac9b8c9dc2 || ($4cc5ecf7014166be$export$942a5fac9b8c9dc2 = {}));
});
parcelRegister("ebeAz", function(module, exports) {
    $parcel$export(module.exports, "EDIT_PAGE_EMBED", ()=>$e38a283cb761fb66$export$e63a462ee45b57cf);
    $parcel$export(module.exports, "EDIT_PAGE_V2", ()=>$e38a283cb761fb66$export$7b1285e36c635f1f);
    $parcel$export(module.exports, "VIEW_PAGE", ()=>$e38a283cb761fb66$export$9257b5b55c8e2555);
    $parcel$export(module.exports, "VIEW_BLOG", ()=>$e38a283cb761fb66$export$91f49e7b30a9d34);
    $parcel$export(module.exports, "VIEW_BLOG_DATE_LEGACY", ()=>$e38a283cb761fb66$export$bd2c9bb170b3681d);
    $parcel$export(module.exports, "namedRoutes", ()=>$e38a283cb761fb66$export$d4971375353d0454);
    $parcel$export(module.exports, "EMBEDDED_PARENT_PRODUCTS", ()=>$e38a283cb761fb66$export$5c59aa0922e65f1a);
    const $e38a283cb761fb66$export$e63a462ee45b57cf = {
        name: 'EDIT_PAGE_EMBED',
        pattern: '/wiki/spaces/:spaceKey/:contentType(pages)/edit-embed/:contentId(\\d+)/:contentSlug?'
    };
    const $e38a283cb761fb66$export$7b1285e36c635f1f = {
        name: 'EDIT_PAGE_V2',
        pattern: '/wiki/spaces/:spaceKey/:contentType(pages)/edit-v2/:contentId(\\d+)/:contentSlug?'
    };
    const $e38a283cb761fb66$export$65b723bb995d4fb6 = {
        name: 'SPACE_OVERVIEW',
        pattern: '/wiki/spaces/:spaceKey/overview'
    };
    const $e38a283cb761fb66$export$9257b5b55c8e2555 = {
        name: 'VIEW_PAGE',
        pattern: '/wiki/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?'
    };
    const $e38a283cb761fb66$export$91f49e7b30a9d34 = {
        name: 'VIEW_BLOG',
        pattern: '/wiki/spaces/:spaceKey/blog/:contentId(\\d+)/:contentSlug?'
    };
    const $e38a283cb761fb66$export$bd2c9bb170b3681d = {
        name: 'VIEW_BLOG_DATE_LEGACY',
        pattern: '/wiki/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?'
    };
    const $e38a283cb761fb66$export$d4971375353d0454 = {
        EDIT_PAGE_EMBED: $e38a283cb761fb66$export$e63a462ee45b57cf,
        EDIT_PAGE_V2: $e38a283cb761fb66$export$7b1285e36c635f1f,
        SPACE_OVERVIEW: $e38a283cb761fb66$export$65b723bb995d4fb6,
        VIEW_PAGE: $e38a283cb761fb66$export$9257b5b55c8e2555,
        VIEW_BLOG: $e38a283cb761fb66$export$91f49e7b30a9d34,
        VIEW_BLOG_DATE_LEGACY: $e38a283cb761fb66$export$bd2c9bb170b3681d
    };
    const $e38a283cb761fb66$export$5c59aa0922e65f1a = {
        JSM_PORTAL: 'JSM-Portal',
        JSM: 'JSM',
        JSW: 'JSW',
        JWM: 'JWM'
    };
});
parcelRegister("aGJM1", function(module, exports) {
    $parcel$export(module.exports, "embeddedPanelEntrypoint", ()=>$f4fee34f61d7147e$export$32561f984de7bece);
    var $1ydNb = parcelRequire("1ydNb");
    var $6TOES = parcelRequire("6TOES");
    const $f4fee34f61d7147e$export$32561f984de7bece = (0, $6TOES.createEntryPoint)({
        root: (0, $1ydNb.JSResourceForInteraction)(()=>(parcelRequire("iJY8A")), {
            moduleId: "293c24d0"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("iJY8A", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("wcQ1n")
    ]).then(()=>parcelRequire('8snz3'));
});
parcelRegister("bczMu", function(module, exports) {
    $parcel$export(module.exports, "createActivePageUrl", ()=>$13c13bf829800cbb$export$83c6318baef117fe);
    $parcel$export(module.exports, "getURLFromConfluencePageResponse", ()=>$13c13bf829800cbb$export$e87b28852220b5cd);
    $parcel$export(module.exports, "setHostnameForContent", ()=>$13c13bf829800cbb$export$8ccd4cc378896990);
    $parcel$export(module.exports, "constructUrlIfCustomDomain", ()=>$13c13bf829800cbb$export$a63ef4c6a1286e2a);
    $parcel$export(module.exports, "createLinkCreatePayload", ()=>$13c13bf829800cbb$export$af98278c506da0f4);
    var $fEdG4 = parcelRequire("fEdG4");
    var $2XxeS = parcelRequire("2XxeS");
    const $13c13bf829800cbb$export$f31b9480a5e4fdcf = (uri)=>{
        if (!uri || uri === '') return '';
        const matches = uri.match(/draftShareId=([^&])*/g);
        return matches ? matches[0].split('=')[1] : '';
    };
    const $13c13bf829800cbb$export$be3b1ed3560ef0e6 = ({ url: url, spaceId: spaceId, spaceKey: spaceKey })=>{
        if (!(url && spaceId && spaceKey)) return '';
        return url.replace(`spaces/${spaceId}`, `spaces/${spaceKey}`);
    };
    const $13c13bf829800cbb$export$83c6318baef117fe = (createPayload)=>{
        const { data: data, url: url } = createPayload;
        const links = data?.links;
        const spaceKey = data?.spaceKey;
        const spaceId = data?.spaceId;
        const linkableUrl = $13c13bf829800cbb$export$be3b1ed3560ef0e6({
            url: url,
            spaceId: spaceId,
            spaceKey: spaceKey
        });
        if (data?.subType === 'live') return `${linkableUrl}`;
        return `${linkableUrl}?draftShareId=${$13c13bf829800cbb$export$f31b9480a5e4fdcf(links?.editui)}`;
    };
    const $13c13bf829800cbb$export$e87b28852220b5cd = ({ id: id, spaceKey: spaceKey, hostname: hostname })=>`${hostname}/wiki/spaces/${spaceKey}/pages/edit-v2/${id}/`;
    const $13c13bf829800cbb$var$isUrlCustomDomain = (parentHost, url)=>{
        const hostname = (0, $fEdG4.getHostnameFromUrl)(url);
        return (0, $2XxeS.isCustomDomain)(parentHost) || hostname && (0, $2XxeS.isCustomDomain)(hostname);
    };
    const $13c13bf829800cbb$export$8ccd4cc378896990 = (url, hostname)=>{
        const parentHost = window?.location?.origin || '';
        const contentHost = hostname ?? (0, $fEdG4.getHostnameFromUrl)(url);
        return $13c13bf829800cbb$var$isUrlCustomDomain(parentHost, url) ? (0, $fEdG4.getHostnameFromUrl)(parentHost) : contentHost;
    };
    const $13c13bf829800cbb$export$a63ef4c6a1286e2a = ({ id: id, originalDomain: originalDomain, originalUrl: originalUrl, spaceKey: spaceKey, systemConfluenceAppLinkUrl: systemConfluenceAppLinkUrl })=>{
        const currentHostname = window?.location?.origin || '';
        const hostnameFromUrl = (0, $fEdG4.getHostnameFromUrl)(originalDomain);
        const systemHostName = (0, $fEdG4.getHostnameFromUrl)(systemConfluenceAppLinkUrl);
        if (systemHostName !== hostnameFromUrl && $13c13bf829800cbb$var$isUrlCustomDomain(currentHostname, originalDomain)) return $13c13bf829800cbb$export$e87b28852220b5cd({
            id: id,
            spaceKey: spaceKey,
            hostname: currentHostname
        });
        return originalUrl;
    };
    const $13c13bf829800cbb$export$af98278c506da0f4 = (createResponse, url, space, cloudId)=>({
            url: url,
            ari: `ari:cloud:confluence:${cloudId}:page/${createResponse.id}`,
            objectId: createResponse.id,
            objectType: 'page',
            data: {
                spaceId: space.spaceId,
                spaceKey: space.spaceKey,
                spaceName: space.spaceName,
                status: createResponse.status,
                subType: createResponse.subType,
                links: createResponse._links
            }
        });
});
parcelRegister("fEdG4", function(module, exports) {
    $parcel$export(module.exports, "getHostnameFromUrl", ()=>$ee5f489954b592fe$export$280e79c794cf814e);
    var $4YFgD = parcelRequire("4YFgD");
    const $ee5f489954b592fe$export$280e79c794cf814e = (url)=>(0, $4YFgD.isValidUrl)(url) ? new URL(url)?.hostname : '';
});
parcelRegister("4YFgD", function(module, exports) {
    $parcel$export(module.exports, "isValidUrl", ()=>$b579652caee60b2f$export$bef94a5618bf18bf);
    const $b579652caee60b2f$export$bef94a5618bf18bf = (urlString)=>{
        if (typeof urlString !== 'string') return false;
        try {
            return Boolean(new URL(urlString));
        } catch (e) {
            return false;
        }
    };
});
parcelRegister("2XxeS", function(module, exports) {
    $parcel$export(module.exports, "isCustomDomain", ()=>$114e25cd3035a797$export$97f4c254b641e719);
    const $114e25cd3035a797$var$atlassianDomains = [
        '.atlassian.com',
        '.atlassian.net',
        '.jira-dev.com',
        '.jira.com',
        '.atlassian-stg-fedm.net',
        '.atlassian-us-gov-mod.net',
        '.atlassian-us-gov-mod.com'
    ];
    const $114e25cd3035a797$export$97f4c254b641e719 = (hostname)=>!$114e25cd3035a797$var$atlassianDomains.some((domain)=>hostname.endsWith(domain));
});
parcelRegister("eq2dV", function(module, exports) {
    $parcel$export(module.exports, "useEmbeddedPageTracking", ()=>$471d338f836f9c77$export$9fcd107e4ed1de75);
    var $eUqFw = parcelRequire("eUqFw");
    var $hJ992 = parcelRequire("hJ992");
    var $1inzG = parcelRequire("1inzG");
    var $gd0Sp = parcelRequire("gd0Sp");
    var $ls5tj = parcelRequire("ls5tj");
    var $6myYy = parcelRequire("6myYy");
    const $471d338f836f9c77$export$9fcd107e4ed1de75 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        const source = (0, $hJ992.useAnalyticsSource)();
        const trackEmbeddedConfluence = (0, $eUqFw.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct, linkObjectType: linkObjectType })=>{
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject ?? `${eventName}`
            });
            const attributes = {
                parentProduct: (0, $ls5tj.getParentProduct)(projectType),
                tenantEditions: tenantContext?.appEditions,
                productEntitlementDetails: tenantContext?.productEntitlementDetails,
                embeddedConfluenceSource: embeddedConfluenceSource,
                jiraIssueSurfaceArea: source,
                userHasConfluenceAccess: userHasConfluenceAccess,
                tenantHasConfluence: tenantHasConfluence,
                crossJoinStatus: crossJoinStatus,
                originProduct: originProduct,
                requestedProduct: requestedProduct,
                isSiteAdmin: tenantContext?.isSiteAdmin,
                linkObjectType: linkObjectType
            };
            (0, $6myYy.fireEmbeddedConfluenceAnalytics)({
                analyticsEvent: analyticsEvent,
                attributes: attributes,
                eventType: eventType,
                eventName: `${actionSubject ?? eventName} ${action}`
            });
        }, [
            source,
            tenantContext,
            createAnalyticsEvent
        ]);
        return trackEmbeddedConfluence;
    };
});
parcelRegister("ls5tj", function(module, exports) {
    $parcel$export(module.exports, "ACCESS_REQUEST_CAPABILITIES", ()=>$f8a0c629383095b7$export$b4e6d6efc113ca5);
    $parcel$export(module.exports, "VALID_DIRECT_ACCESS_STATUS", ()=>$f8a0c629383095b7$export$bf1e31028b579014);
    $parcel$export(module.exports, "ACCESS_DENIED_STATUSES", ()=>$f8a0c629383095b7$export$2fe5bb2d968b01fc);
    $parcel$export(module.exports, "LICENCE_EXCEEDED_STATUS", ()=>$f8a0c629383095b7$export$56360b096b4b4439);
    $parcel$export(module.exports, "getParentProduct", ()=>$f8a0c629383095b7$export$e873edb2560a07ef);
    var $7ZZxN = parcelRequire("7ZZxN");
    const $f8a0c629383095b7$export$b4e6d6efc113ca5 = {
        ACCESS_GRANTED: 'ACCESS_GRANTED',
        ACCESS_EXISTS: 'ACCESS_EXISTS',
        DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
        DIRECT_ACCESS: 'DIRECT_ACCESS',
        FORBIDDEN: 'FORBIDDEN',
        PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
        REQUEST_ACCESS: 'REQUEST_ACCESS'
    };
    const $f8a0c629383095b7$export$bf1e31028b579014 = [
        $f8a0c629383095b7$export$b4e6d6efc113ca5.ACCESS_EXISTS,
        $f8a0c629383095b7$export$b4e6d6efc113ca5.ACCESS_GRANTED,
        $f8a0c629383095b7$export$b4e6d6efc113ca5.PENDING_REQUEST_EXISTS
    ];
    const $f8a0c629383095b7$export$2fe5bb2d968b01fc = [
        $f8a0c629383095b7$export$b4e6d6efc113ca5.FORBIDDEN,
        $f8a0c629383095b7$export$b4e6d6efc113ca5.DENIED_REQUEST_EXISTS
    ];
    const $f8a0c629383095b7$export$56360b096b4b4439 = 'licence-exceeded';
    const $f8a0c629383095b7$export$e873edb2560a07ef = (projectType)=>{
        switch(projectType){
            case 0, $7ZZxN.SERVICE_DESK_PROJECT:
                return 'JSM';
            case 0, $7ZZxN.SOFTWARE_PROJECT:
                return 'JSW';
            case 0, $7ZZxN.CORE_PROJECT:
                return 'JWM';
            default:
                return 'JSW';
        }
    };
});
parcelRegister("6myYy", function(module, exports) {
    $parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", ()=>$be7aa4fcf32865f7$export$864bc2da9014e8e9);
    var $jMP2a = parcelRequire("jMP2a");
    const $be7aa4fcf32865f7$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
        switch(eventType){
            case 'ui':
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
                break;
            case 'operational':
                (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
                break;
            case 'track':
                (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
                break;
            default:
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
                break;
        }
    };
});
parcelRegister("dMGT3", function(module, exports) {
    $parcel$export(module.exports, "useParentProduct", ()=>$e70d73b8efede62e$export$1b09c6e3737c8eb7);
    var $bNe1g = parcelRequire("bNe1g");
    var $ls5tj = parcelRequire("ls5tj");
    const $e70d73b8efede62e$export$1b09c6e3737c8eb7 = ()=>{
        const { data: data } = (0, $bNe1g.useProjectContext)();
        const projectType = data?.projectType;
        return (0, $ls5tj.getParentProduct)(projectType);
    };
});
parcelRegister("d8a4z", function(module, exports) {
    $parcel$export(module.exports, "ImperativeAPI", ()=>$1e92f89157195fce$export$e2ad0ff52e7f8c84);
    var $eUqFw = parcelRequire("eUqFw");
    var $6oi2X = parcelRequire("6oi2X");
    var $jwtcO = parcelRequire("jwtcO");
    const $1e92f89157195fce$export$e2ad0ff52e7f8c84 = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $6oi2X.Consumer), null, ({ getManager: getManager })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $jwtcO.ImperativeAPI), {
                getItemManager: getManager
            }));
});
parcelRegister("6oi2X", function(module, exports) {
    $parcel$export(module.exports, "Provider", ()=>$786b8f2349f4f371$export$2881499e37b75b9a);
    $parcel$export(module.exports, "Consumer", ()=>$786b8f2349f4f371$export$b3bffd4bb7da6b8f);
    var $eUqFw = parcelRequire("eUqFw");
    var $kFGm5 = parcelRequire("kFGm5");
    var $aptld = parcelRequire("aptld");
    var $hIu0M = parcelRequire("hIu0M");
    const $786b8f2349f4f371$var$Context = (0, $aptld.default)('ItemManagers');
    const $786b8f2349f4f371$export$275138de3066e8b3 = 30000;
    class $786b8f2349f4f371$export$2881499e37b75b9a extends (0, $eUqFw.Component) {
        render() {
            return (0, ($parcel$interopDefault($eUqFw))).createElement($786b8f2349f4f371$var$Context.Provider, {
                value: this.manager
            }, this.props.children);
        }
        constructor(...args){
            super(...args);
            this.state = {
                managers: {}
            };
            this.getManager = (managerKey)=>{
                const { managers: managers } = this.state;
                const manager = managers[managerKey];
                if (manager) return manager;
                return new Promise((resolve, reject)=>{
                    const message = `Timeout. "${(0, $hIu0M.fromManagerKey)(managerKey)}" wasn't registered after ${$786b8f2349f4f371$export$275138de3066e8b3}ms`;
                    const rejectTimeoutId = setTimeout(()=>reject(new Error(message)), $786b8f2349f4f371$export$275138de3066e8b3);
                    const { pendingManagers: pendingManagers } = this;
                    pendingManagers[managerKey] || (pendingManagers[managerKey] = []);
                    pendingManagers[managerKey].push((methods)=>{
                        clearTimeout(rejectTimeoutId);
                        resolve(methods);
                    });
                });
            };
            this.registerManager = (managerKey, methods)=>{
                this.setState((previousState)=>{
                    if (methods == null) return {
                        managers: (0, ($parcel$interopDefault($kFGm5)))(previousState.managers, managerKey)
                    };
                    const managerResolvers = this.pendingManagers[managerKey];
                    if (managerResolvers && managerResolvers.length) {
                        managerResolvers.forEach((resolve)=>resolve(methods));
                        managerResolvers.length = 0;
                    }
                    return {
                        managers: {
                            ...previousState.managers,
                            [managerKey]: Promise.resolve(methods)
                        }
                    };
                });
            };
            this.pendingManagers = {};
            this.manager = {
                getManager: this.getManager,
                registerManager: this.registerManager
            };
        }
    }
    const { Consumer: $786b8f2349f4f371$export$b3bffd4bb7da6b8f } = $786b8f2349f4f371$var$Context;
});
parcelRegister("aptld", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7bb544ea99791963$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $7bb544ea99791963$export$2e2bcd8739ae039 = (name)=>{
        const contextObjName = name || '';
        const defaultGetter = ()=>{
            throw new Error(`The Consumer for ${contextObjName} Context Object does not have a correct value. Maybe, it needs to be wrapped in its corresponding Provider`);
        };
        const Context = (0, $eUqFw.createContext)(defaultGetter);
        const ContextConsumer = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement(Context.Consumer, null, (getValue)=>{
                const value = getValue();
                return props.children(value);
            });
        const ContextProvider = ({ value: value, children: children })=>{
            const getValue = ()=>value;
            return (0, ($parcel$interopDefault($eUqFw))).createElement(Context.Provider, {
                value: getValue
            }, children);
        };
        ContextProvider.displayName = `${contextObjName}SafeProvider`;
        ContextConsumer.displayName = `${contextObjName}SafeConsumer`;
        return {
            Provider: ContextProvider,
            Consumer: ContextConsumer
        };
    };
});
parcelRegister("hIu0M", function(module, exports) {
    $parcel$export(module.exports, "fromManagerKey", ()=>$e9a42c652dd768fc$export$fef172a673b3ef47);
    const $e9a42c652dd768fc$export$e6ee4c5f89b06a38 = (managerKey)=>managerKey;
    const $e9a42c652dd768fc$export$fef172a673b3ef47 = (managerKey)=>String(managerKey);
});
parcelRegister("jwtcO", function(module, exports) {
    $parcel$export(module.exports, "ImperativeAPI", ()=>$cf3dc24e124a7b2d$export$e2ad0ff52e7f8c84);
    var $eUqFw = parcelRequire("eUqFw");
    var $ds5Im = parcelRequire("ds5Im");
    var $gUUjF = parcelRequire("gUUjF");
    var $4u2Iz = parcelRequire("4u2Iz");
    var $26xrR = parcelRequire("26xrR");
    var $kpmC0 = parcelRequire("kpmC0");
    var $2futN = parcelRequire("2futN");
    var $hbusP = parcelRequire("hbusP");
    var $hIu0M = parcelRequire("hIu0M");
    var $lB25E = parcelRequire("lB25E");
    var $3mRDR = parcelRequire("3mRDR");
    const $cf3dc24e124a7b2d$var$ERROR_LOCATION = 'legacy.imperative-api';
    const $cf3dc24e124a7b2d$export$e2ad0ff52e7f8c84 = ({ getItemManager: getItemManager })=>{
        const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, $kpmC0.useLeftSidebarController)();
        const { refresh: refresh } = (0, $2futN.useProjectSidebarNavigation)();
        const { push: push } = (0, $lB25E.useRouterActions)();
        const sidebarState = (0, $kpmC0.useLeftSidebarState)();
        const sidebarRef = (0, $eUqFw.useRef)(sidebarState);
        const refreshSidebarRef = (0, $eUqFw.useRef)(refresh);
        const imperativeAPIRef = (0, $eUqFw.useRef)({
            viewIds: $3mRDR.viewIds,
            itemIds: $3mRDR.itemIds,
            expand: expandLeftSidebar,
            collapse: collapseLeftSidebar,
            isCollapsed: ()=>sidebarRef.current.isCollapsed,
            onCollapse: ()=>undefined,
            onCollapseStart: ()=>undefined,
            onCollapseEnd: ()=>undefined,
            onExpand: ()=>undefined,
            onExpandStart: ()=>undefined,
            onExpandEnd: ()=>undefined,
            onItemClick: ()=>undefined,
            setView: ()=>undefined,
            updateActiveView: ()=>undefined,
            setProjectRootView: ()=>undefined,
            getActiveViewItems: ()=>[],
            isInProjectContext: ()=>false,
            updateContext: ()=>undefined,
            updateData: ()=>{
                refreshSidebarRef.current();
            },
            getItemManager: (itemManagerKey)=>getItemManager(itemManagerKey).catch((e)=>{
                    (0, $gUUjF.default).safeErrorWithoutCustomerData($cf3dc24e124a7b2d$var$ERROR_LOCATION, `There was a problem getting "${(0, $hIu0M.fromManagerKey)(itemManagerKey)}" item manager`, e);
                    throw e;
                }),
            createBoard: ()=>{
                (0, $26xrR.default)();
            },
            modalOpen: ()=>undefined,
            modalClose: ()=>undefined,
            navigate: (url)=>push(url)
        });
        sidebarRef.current = sidebarState;
        refreshSidebarRef.current = refresh;
        (0, $eUqFw.useEffect)(()=>{
            (0, $ds5Im.loadBridgeWeak)({
                name: 'jira/navigation/bridge'
            }).then((bridge)=>{
                bridge(imperativeAPIRef.current);
            });
            (0, $4u2Iz.provideNavigationApi)({
                navigate: push
            });
        }, [
            push
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hbusP.NavigationUIContainer), {
            isGlobal: true
        });
    };
});
parcelRegister("ds5Im", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeWeak", ()=>$1b3123f198513ce0$export$3cefda82396756a1);
    var $1gau4 = parcelRequire("1gau4");
    let $1b3123f198513ce0$var$pollingSingleton = null;
    const $1b3123f198513ce0$export$3cefda82396756a1 = ({ name: name })=>{
        const getter = $1b3123f198513ce0$var$pollingSingleton ?? (0, $1gau4.createPollingCollection)((v)=>window.require(v), 100);
        $1b3123f198513ce0$var$pollingSingleton = getter;
        return getter(name);
    };
});
parcelRegister("1gau4", function(module, exports) {
    $parcel$export(module.exports, "createPollingCollection", ()=>$9f3ee0cd5dcb553b$export$f163446a982a8077);
    var $asu8X = parcelRequire("asu8X");
    var $eFUPR = parcelRequire("eFUPR");
    const $9f3ee0cd5dcb553b$export$f163446a982a8077 = (fn, timeout)=>{
        (0, $asu8X.di)(setTimeout);
        let isPolling = false;
        const deferredMap = new Map();
        const promiseMap = new Map();
        const evaluateForKey = (key)=>{
            let result;
            try {
                result = fn(key);
            } catch (error) {
                return;
            }
            const deferred = deferredMap.get(key);
            if (deferred instanceof (0, $eFUPR.default)) {
                deferred.resolve(result);
                deferredMap.delete(key);
            }
        };
        const maybePoll = ()=>{
            if (!isPolling && deferredMap.size > 0) {
                isPolling = true;
                setTimeout(()=>{
                    isPolling = false;
                    [
                        ...deferredMap.keys()
                    ].forEach(evaluateForKey);
                    maybePoll();
                }, timeout);
            }
        };
        const getter = (key)=>{
            if (!promiseMap.has(key)) {
                const deferred = new (0, $eFUPR.default)();
                const promise = deferred.then((v)=>v);
                deferredMap.set(key, deferred);
                promiseMap.set(key, promise);
                evaluateForKey(key);
                maybePoll();
            }
            return promiseMap.get(key);
        };
        return getter;
    };
});
parcelRegister("eFUPR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8bee8fab77b1b942$export$2e2bcd8739ae039);
    class $8bee8fab77b1b942$export$2e2bcd8739ae039 extends Promise {
        static resolve(v) {
            const instance = new $8bee8fab77b1b942$export$2e2bcd8739ae039();
            instance.resolve(v);
            return instance;
        }
        static reject(e) {
            const instance = new $8bee8fab77b1b942$export$2e2bcd8739ae039();
            instance.reject(e);
            return instance;
        }
        constructor(){
            const [fn] = Array.prototype.slice.call(arguments);
            const callbacks = [];
            super(fn ?? callbacks.push.bind(callbacks));
            this.#resolve = callbacks[0];
            this.#reject = callbacks[1];
        }
        #resolve;
        #reject;
        resolve(v) {
            this.#resolve?.(v);
        }
        reject(e) {
            this.#reject?.(e);
        }
    }
});
parcelRegister("4u2Iz", function(module, exports) {
    $parcel$export(module.exports, "provideNavigationApi", ()=>$c85bf289a3ab5991$export$26d28e8849b2805f);
    $parcel$export(module.exports, "isInIframe", ()=>$c85bf289a3ab5991$export$9f140ed41af5108c);
    $parcel$export(module.exports, "canSpaTransition", ()=>$c85bf289a3ab5991$export$59e771495885068f);
    $parcel$export(module.exports, "getContainerApi", ()=>$c85bf289a3ab5991$export$91ed870fd8df2bcb);
    $parcel$export(module.exports, "getNavigationApi", ()=>$c85bf289a3ab5991$export$da4e5a44286a0dd0);
    let $c85bf289a3ab5991$var$containerApi = null;
    let $c85bf289a3ab5991$var$navigationApi = null;
    const $c85bf289a3ab5991$export$3927fb5df700a968 = (api)=>{
        $c85bf289a3ab5991$var$containerApi = api;
    };
    const $c85bf289a3ab5991$export$26d28e8849b2805f = (api)=>{
        $c85bf289a3ab5991$var$navigationApi = api;
    };
    const $c85bf289a3ab5991$export$9f140ed41af5108c = ()=>$c85bf289a3ab5991$var$containerApi !== null;
    const $c85bf289a3ab5991$export$59e771495885068f = ()=>$c85bf289a3ab5991$var$navigationApi !== null;
    const $c85bf289a3ab5991$export$91ed870fd8df2bcb = ()=>$c85bf289a3ab5991$var$containerApi;
    const $c85bf289a3ab5991$export$da4e5a44286a0dd0 = ()=>$c85bf289a3ab5991$var$navigationApi;
    const $c85bf289a3ab5991$export$6ba42130b045ede1 = ()=>{
        $c85bf289a3ab5991$var$containerApi = null;
        $c85bf289a3ab5991$var$navigationApi = null;
    };
});
parcelRegister("26xrR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a46b7497e8a8ccc2$export$2e2bcd8739ae039);
    var $2BvS3 = parcelRequire("2BvS3");
    const $a46b7497e8a8ccc2$var$amdModuleName = 'jira-agile/sidebar/create-board-adg3';
    var $a46b7497e8a8ccc2$export$2e2bcd8739ae039 = async ()=>{
        const module = await (0, $2BvS3.loadBridge)({
            name: $a46b7497e8a8ccc2$var$amdModuleName
        });
        return module.openCreateBoardModal();
    };
});
parcelRegister("2BvS3", function(module, exports) {
    $parcel$export(module.exports, "loadBridge", ()=>$95487c8e7b3a155f$export$df8409da353bde5a);
    $parcel$export(module.exports, "loadBridgeStrict", ()=>(parcelRequire("2TjwK")).loadBridgeStrict);
    var $2m1eH = parcelRequire("2m1eH");
    var $9kx8M = parcelRequire("9kx8M");
    var $e1Ms3 = parcelRequire("e1Ms3");
    var $2TjwK = parcelRequire("2TjwK");
    var $ds5Im = parcelRequire("ds5Im");
    var $4DtuZ = parcelRequire("4DtuZ");
    var $beITa = parcelRequire("beITa");
    var $dPoeR = parcelRequire("dPoeR");
    const $95487c8e7b3a155f$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, $2m1eH.MAX_RETRIES), timeout: timeout = (0, $2m1eH.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR) })=>{
        if (wrmKeys != null) return (0, $2TjwK.loadBridgeStrict)({
            name: name,
            wrmKeys: [].concat(wrmKeys),
            shouldLogError: shouldLogError
        });
        if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
        if (tentatives <= 1) return (0, $9kx8M.loadBridgeBail)({
            name: name,
            shouldLogError: shouldLogError
        });
        return (0, $e1Ms3.loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError,
            timeout: (tentatives - 1) * timeout
        });
    };
});
parcelRegister("2m1eH", function(module, exports) {
    $parcel$export(module.exports, "safeErrorWithoutCustomerData", ()=>$b8b11bd252d35c6e$export$f19a2d31722e3428);
    $parcel$export(module.exports, "MAX_RETRIES", ()=>$b8b11bd252d35c6e$export$1f86472c1374185a);
    $parcel$export(module.exports, "DEFAULT_TIMEOUT", ()=>$b8b11bd252d35c6e$export$7bd623b29ec8e1eb);
    $parcel$export(module.exports, "SHOULD_LOG_ERROR", ()=>$b8b11bd252d35c6e$export$37f20f0ff732fcd7);
    var $gUUjF = parcelRequire("gUUjF");
    const { safeErrorWithoutCustomerData: $b8b11bd252d35c6e$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $b8b11bd252d35c6e$export$ea810ce67e3c8eac } = (0, $gUUjF.default);
    const $b8b11bd252d35c6e$export$1f86472c1374185a = 40;
    const $b8b11bd252d35c6e$export$7bd623b29ec8e1eb = 500;
    const $b8b11bd252d35c6e$export$37f20f0ff732fcd7 = true;
});
parcelRegister("9kx8M", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeBail", ()=>$91c93182e2e49d7f$export$a036f92c2465504e);
    var $a0ZIR = parcelRequire("a0ZIR");
    var $2m1eH = parcelRequire("2m1eH");
    const $91c93182e2e49d7f$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR) })=>{
        try {
            return window.require(name);
        } catch (error) {
            if (shouldLogError) (0, $2m1eH.safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, $a0ZIR.safeStringify)(error) ?? ''}`, {
                isSpa: __SPA__,
                name: name,
                error: (0, $a0ZIR.safeStringify)(error)
            });
            throw new Error(`Unable to load bridge "${name}"`, {
                cause: error
            });
        }
    };
});
parcelRegister("a0ZIR", function(module, exports) {
    $parcel$export(module.exports, "safeStringify", ()=>$6efa0e8ff5a3a43a$export$56831a8b9cb27763);
    const $6efa0e8ff5a3a43a$export$56831a8b9cb27763 = (object)=>{
        if (!object) return '';
        if (object instanceof Error) return object.stack || object.message;
        return JSON.stringify(object, Object.getOwnPropertyNames(object));
    };
});
parcelRegister("e1Ms3", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeRace", ()=>$7f4fa2d1428c50fa$export$20c32b4579d78b92);
    var $9kx8M = parcelRequire("9kx8M");
    var $ds5Im = parcelRequire("ds5Im");
    var $2m1eH = parcelRequire("2m1eH");
    const $7f4fa2d1428c50fa$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, $2m1eH.DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR) })=>Promise.race([
            (0, $ds5Im.loadBridgeWeak)({
                name: name
            }),
            new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, $9kx8M.loadBridgeBail)({
                    name: name,
                    shouldLogError: shouldLogError
                }))
        ]);
});
parcelRegister("2TjwK", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeStrict", ()=>$b1e39bbe8c29913e$export$eba600d28decc4ac);
    var $7ho7Q = parcelRequire("7ho7Q");
    var $e1Ms3 = parcelRequire("e1Ms3");
    var $99I0s = parcelRequire("99I0s");
    var $2m1eH = parcelRequire("2m1eH");
    const $b1e39bbe8c29913e$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR) })=>{
        (0, $7ho7Q.saveStats)(name, wrmKeys);
        try {
            return window.require(name);
        } catch (error) {
            await (0, $99I0s.loadWrmResources)({
                wrmKeys: wrmKeys,
                shouldLogError: shouldLogError
            });
            return (0, $e1Ms3.loadBridgeRace)({
                name: name,
                shouldLogError: shouldLogError
            });
        }
    };
});
parcelRegister("7ho7Q", function(module, exports) {
    $parcel$export(module.exports, "saveStats", ()=>$4597ad555104d20c$export$9ea3ff7978093559);
    const $4597ad555104d20c$var$incrementResourceStats = (resource, stats)=>{
        if (stats[resource] == null) stats[resource] = 1;
        else stats[resource] += 1;
    };
    const $4597ad555104d20c$var$getEmptyLoadBridgeStats = ()=>({
            requests: 0,
            amdModules: {},
            wrmKeys: {}
        });
    const $4597ad555104d20c$var$initStats = ()=>{
        if (window.__WRM_INTERNAL_STATS__ == null) window.__WRM_INTERNAL_STATS__ = {
            loadBridge: $4597ad555104d20c$var$getEmptyLoadBridgeStats()
        };
        else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) window.__WRM_INTERNAL_STATS__.loadBridge = $4597ad555104d20c$var$getEmptyLoadBridgeStats();
        return window.__WRM_INTERNAL_STATS__.loadBridge;
    };
    const $4597ad555104d20c$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
    const $4597ad555104d20c$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
        try {
            const stats = $4597ad555104d20c$var$initStats();
            if ($4597ad555104d20c$var$isPageInteractive()) return;
            stats.requests += 1;
            $4597ad555104d20c$var$incrementResourceStats(amdModuleName, stats.amdModules);
            if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$4597ad555104d20c$var$incrementResourceStats(wrmKey, stats.wrmKeys));
            else if (wrmKeys != null) $4597ad555104d20c$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
        } catch (e) {}
    };
});
parcelRegister("99I0s", function(module, exports) {
    $parcel$export(module.exports, "loadWrmResources", ()=>$ddc8a5e8a3946ea4$export$6cda16b6eff75f59);
    var $a0ZIR = parcelRequire("a0ZIR");
    var $6uXwV = parcelRequire("6uXwV");
    var $ds5Im = parcelRequire("ds5Im");
    var $2m1eH = parcelRequire("2m1eH");
    const $ddc8a5e8a3946ea4$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
        const isPrefetch = 'batchUrl' in options;
        let newWrmKeys = wrmKeys;
        try {
            const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
            const wrmRequireModule = await (0, $ds5Im.loadBridgeWeak)({
                name: name
            });
            const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
            newWrmKeys = (0, $6uXwV.prependSuperBatchDepsOnce)(wrmKeys);
            if (isPrefetch) return await new Promise((resolve, reject)=>wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
            return await new Promise((resolve, reject)=>wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        } catch (error) {
            if (shouldLogError) (0, $2m1eH.safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
                isSpa: __SPA__,
                wrmKeys: JSON.stringify(newWrmKeys),
                error: (0, $a0ZIR.safeStringify)(error)
            });
            throw new Error('Unable to load wrm resource', {
                cause: error
            });
        }
    };
});
parcelRegister("6uXwV", function(module, exports) {
    $parcel$export(module.exports, "prependSuperBatchDepsOnce", ()=>$94847501863943b7$export$93d9db5fbabad1b0);
    var $8loyD = parcelRequire("8loyD");
    let $94847501863943b7$var$isSuperBatchDependenciesLoaded = false;
    const $94847501863943b7$var$isOnRapidBoardsPage = ()=>{
        const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
        const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
        const { pathname: pathname } = window.location;
        return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || window.location.href.includes('secure/RapidBoard.jspa');
    };
    const $94847501863943b7$export$93d9db5fbabad1b0 = (wrmKeys)=>{
        if ($94847501863943b7$var$isSuperBatchDependenciesLoaded || $94847501863943b7$var$isOnRapidBoardsPage()) return wrmKeys;
        $94847501863943b7$var$isSuperBatchDependenciesLoaded = true;
        return (0, $8loyD.jiraSuperBatchDependencies).concat(wrmKeys);
    };
});
parcelRegister("8loyD", function(module, exports) {
    $parcel$export(module.exports, "jiraSuperBatchDependencies", ()=>$1708e80b7caf4372$export$f14a6b583ce9e077);
    const $1708e80b7caf4372$export$f14a6b583ce9e077 = [
        'wrc!jira.webresources:skate',
        'wrc!jira.webresources:util-lite',
        'wrc!jira.webresources:util',
        'wrc!jira.webresources:feature-flags',
        'wrc!jira.webresources:dialogs',
        'wrc!jira.webresources:jira-global',
        'wrc!com.atlassian.auiplugin:aui-spinner'
    ];
});
parcelRegister("4DtuZ", function(module, exports) {
    $parcel$export(module.exports, "waitForHeritage", ()=>$c6610675329f7ce1$export$c61060338d026f78);
    var $eFUPR = parcelRequire("eFUPR");
    const $c6610675329f7ce1$export$c61060338d026f78 = ()=>{
        if (false) return null;
        if (!__SPA__) return Promise.resolve();
        if (!window.__WAIT_FOR_HERITAGE__) window.__WAIT_FOR_HERITAGE__ = new (0, $eFUPR.default)();
        return window.__WAIT_FOR_HERITAGE__;
    };
});
parcelRegister("beITa", function(module, exports) {
    $parcel$export(module.exports, "wrmRequire", ()=>$fc3a6026d4692cae$export$cc9d8f51375ef66a);
    var $99I0s = parcelRequire("99I0s");
    var $2m1eH = parcelRequire("2m1eH");
    const $fc3a6026d4692cae$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR))=>(0, $99I0s.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
});
parcelRegister("dPoeR", function(module, exports) {
    $parcel$export(module.exports, "wrmRequireWithPrefetch", ()=>$6e9ac89e6d17a22d$export$e53a5db19a39ed2f);
    var $99I0s = parcelRequire("99I0s");
    var $2m1eH = parcelRequire("2m1eH");
    const $6e9ac89e6d17a22d$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, $2m1eH.SHOULD_LOG_ERROR))=>(0, $99I0s.loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError,
            batchUrl: batchUrl
        });
});
parcelRegister("2futN", function(module, exports) {
    $parcel$export(module.exports, "useProjectSidebarNavigation", ()=>$e6824b09c7b48982$export$5a85006c180fb373);
    $parcel$export(module.exports, "useProjectSidebarConnectNavigation", ()=>$e6824b09c7b48982$export$2bed15cd7d167db5);
    $parcel$export(module.exports, "useProjectReportsSidebarConnectNavigation", ()=>$e6824b09c7b48982$export$a9d05fc2c1d94895);
    $parcel$export(module.exports, "useProjectSettingsSidebarConnectNavigation", ()=>$e6824b09c7b48982$export$d48e3c3556894533);
    $parcel$export(module.exports, "useJSMProjectConnectQueuesNavigation", ()=>$e6824b09c7b48982$export$24a781cd863077aa);
    $parcel$export(module.exports, "useJiraWorkmanagementProjectNavigation", ()=>$e6824b09c7b48982$export$e16ecd2512eb0dc7);
    $parcel$export(module.exports, "useJiraSoftwareProjectNavigation", ()=>$e6824b09c7b48982$export$68dc0ecbea8211d2);
    $parcel$export(module.exports, "useJiraServiceManagementProjectNavigation", ()=>$e6824b09c7b48982$export$5cf90b625d0e1248);
    $parcel$export(module.exports, "useJiraProductDiscoveryProjectNavigation", ()=>$e6824b09c7b48982$export$d63d92edebe543d9);
    var $eUqFw = parcelRequire("eUqFw");
    var $7wRIc = parcelRequire("7wRIc");
    var $cbmC6 = parcelRequire("cbmC6");
    var $kKeF6 = parcelRequire("kKeF6");
    var $iivTa = parcelRequire("iivTa");
    var $kXWpU = parcelRequire("kXWpU");
    var $iZJHG = parcelRequire("iZJHG");
    var $lB25E = parcelRequire("lB25E");
    var $cLNfQ = parcelRequire("cLNfQ");
    const $e6824b09c7b48982$export$5a85006c180fb373 = (customContext)=>{
        const { data: navResponse, loading: loading, error: error, refresh: refresh, clearAll: clearAll, ...rest } = (0, $iZJHG.useResourceWithCustomRouterContext)((0, $kXWpU.staticProjectSidebarNavigationResource), customContext);
        const memoizedResponse = (0, $eUqFw.useMemo)(()=>navResponse, [
            navResponse
        ]);
        (0, $cLNfQ.useJiraSoftwareCMPNavigationSynchronizer)(memoizedResponse);
        return {
            data: memoizedResponse,
            loading: memoizedResponse != null ? false : loading,
            refresh: refresh,
            clearAll: clearAll,
            error: error,
            ...rest
        };
    };
    const $e6824b09c7b48982$export$2bed15cd7d167db5 = ()=>(0, $lB25E.useResource)((0, $cbmC6.staticProjectSidebarConnectAddonsNavigationResource));
    const $e6824b09c7b48982$export$a9d05fc2c1d94895 = ()=>(0, $lB25E.useResource)((0, $kKeF6.staticProjectReportsSidebarConnectAddonsNavigationResource));
    const $e6824b09c7b48982$export$d48e3c3556894533 = ()=>(0, $lB25E.useResource)((0, $iivTa.staticProjectSettingsSidebarConnectAddonsNavigationResource));
    const $e6824b09c7b48982$export$24a781cd863077aa = ()=>(0, $lB25E.useResource)((0, $7wRIc.staticJSMProjectConnectAddonsNavigationResource));
    const $e6824b09c7b48982$export$e16ecd2512eb0dc7 = ()=>{
        const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
        const response = data?.jiraWorkManagementNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $e6824b09c7b48982$export$68dc0ecbea8211d2 = ()=>{
        const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
        const response = data?.jiraSoftwareNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $e6824b09c7b48982$export$5cf90b625d0e1248 = (customContext)=>{
        const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373(customContext);
        const response = data?.jiraServiceManagementNavData || null;
        return {
            data: response,
            ...rest
        };
    };
    const $e6824b09c7b48982$export$d63d92edebe543d9 = ()=>{
        const { data: data, ...rest } = $e6824b09c7b48982$export$5a85006c180fb373();
        const response = data?.jiraProductDiscoveryNavData || null;
        return {
            data: response,
            ...rest
        };
    };
});
parcelRegister("7wRIc", function(module, exports) {
    $parcel$export(module.exports, "staticJSMProjectConnectAddonsNavigationResource", ()=>$1da568058e8dfab8$export$fab84295e18e9246);
    var $9zYls = parcelRequire("9zYls");
    var $lB25E = parcelRequire("lB25E");
    var $76v64 = parcelRequire("76v64");
    const $1da568058e8dfab8$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $1da568058e8dfab8$export$fab84295e18e9246 = (0, $lB25E.createResource)({
        type: 'NAVIGATION_SIDEBAR_JSM_PROJECT_CONNECT_ADDONS_QUEUES_RESOURCE',
        getKey: ({ match: match, query: query })=>$1da568058e8dfab8$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $1da568058e8dfab8$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'jsm_queues');
            return navInfo;
        },
        maxAge: 300000
    });
});
parcelRegister("76v64", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectSidebarConnectNavigationInfo", ()=>$c603d0485f5d33bd$export$b15f9f5cf6db359e);
    var $lRmyA = parcelRequire("lRmyA");
    const $c603d0485f5d33bd$export$b15f9f5cf6db359e = (projectKeyOrId, sidebarType)=>{
        if (projectKeyOrId == null) throw new Error('invalid identifier specified');
        return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar/project/${projectKeyOrId}/addons?type=${sidebarType}`);
    };
});
parcelRegister("cbmC6", function(module, exports) {
    $parcel$export(module.exports, "staticProjectSidebarConnectAddonsNavigationResource", ()=>$9d72696b0f8eb1a8$export$b8c6e2666f12f4bb);
    var $9zYls = parcelRequire("9zYls");
    var $lB25E = parcelRequire("lB25E");
    var $76v64 = parcelRequire("76v64");
    const $9d72696b0f8eb1a8$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $9d72696b0f8eb1a8$export$b8c6e2666f12f4bb = (0, $lB25E.createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$9d72696b0f8eb1a8$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $9d72696b0f8eb1a8$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const projectHomeAddonNavInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'home');
            return projectHomeAddonNavInfo;
        },
        maxAge: 300000
    });
});
parcelRegister("kKeF6", function(module, exports) {
    $parcel$export(module.exports, "staticProjectReportsSidebarConnectAddonsNavigationResource", ()=>$5a0ad956b22e7be5$export$b662f3f877add30d);
    var $9zYls = parcelRequire("9zYls");
    var $lB25E = parcelRequire("lB25E");
    var $76v64 = parcelRequire("76v64");
    const $5a0ad956b22e7be5$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $5a0ad956b22e7be5$export$b662f3f877add30d = (0, $lB25E.createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_REPORTS_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$5a0ad956b22e7be5$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $5a0ad956b22e7be5$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'reports');
            return navInfo;
        },
        maxAge: 300000
    });
});
parcelRegister("iivTa", function(module, exports) {
    $parcel$export(module.exports, "staticProjectSettingsSidebarConnectAddonsNavigationResource", ()=>$a5660a56dfe8a855$export$e4bf33528101348c);
    $parcel$export(module.exports, "useProjectSettingsSidebarConnectAddonsNavigationResource", ()=>$a5660a56dfe8a855$export$2d5a704ae6f6b050);
    var $9zYls = parcelRequire("9zYls");
    var $lB25E = parcelRequire("lB25E");
    var $76v64 = parcelRequire("76v64");
    const $a5660a56dfe8a855$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $a5660a56dfe8a855$export$e4bf33528101348c = (0, $lB25E.createResource)({
        type: 'NAVIGATION_SIDEBAR_PROJECT_SETTINGS_CONNECT_ADDONS_RESOURCE',
        getKey: ({ match: match, query: query })=>$a5660a56dfe8a855$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $a5660a56dfe8a855$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            const navInfo = await (0, $76v64.fetchProjectSidebarConnectNavigationInfo)(projectKeyOrId, 'settings');
            return navInfo;
        },
        maxAge: 300000
    });
    const $a5660a56dfe8a855$export$2d5a704ae6f6b050 = ()=>(0, $lB25E.useResource)($a5660a56dfe8a855$export$e4bf33528101348c);
});
parcelRegister("kXWpU", function(module, exports) {
    $parcel$export(module.exports, "getIdentifier", ()=>$4181ab9f0d3720b7$export$adb27ddab077e944);
    $parcel$export(module.exports, "staticProjectSidebarNavigationResource", ()=>$4181ab9f0d3720b7$export$f2dfc0f7b2d92691);
    $parcel$export(module.exports, "useSidebarNavigationResource", ()=>$4181ab9f0d3720b7$export$b692cfadccf4e047);
    var $exb0h = parcelRequire("exb0h");
    var $kdp9J = parcelRequire("kdp9J");
    var $ElVpH = parcelRequire("ElVpH");
    var $9zYls = parcelRequire("9zYls");
    var $lB25E = parcelRequire("lB25E");
    var $LWmvk = parcelRequire("LWmvk");
    const $4181ab9f0d3720b7$export$adb27ddab077e944 = (routeName, match, query)=>{
        if (routeName === (0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS) || routeName === (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR) || query['servicedesk.serviceDeskId']) {
            const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
            return (0, $kdp9J.getScopeIdentifier)({
                projectKey: projectKey,
                projectId: projectId
            });
        }
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        const boardId = (0, $ElVpH.getBoardId)(match, query);
        return (0, $kdp9J.getScopeIdentifier)({
            projectKey: projectKey,
            projectId: projectId,
            boardId: boardId
        });
    };
    const $4181ab9f0d3720b7$var$getRouterKey = (routeName, match, query)=>{
        const { identifierType: identifierType, identifierValue: identifierValue } = $4181ab9f0d3720b7$export$adb27ddab077e944(routeName, match, query);
        if (match.url.includes('/software/projects/')) return `projectKey-${match.params.projectKey || ''}`;
        return identifierType == null || identifierValue == null ? 'none' : `${identifierType}-${identifierValue}`;
    };
    const $4181ab9f0d3720b7$export$f2dfc0f7b2d92691 = (0, $lB25E.createResource)({
        type: 'NAVIGATION_SIDEBAR_JIRA_PROJECT',
        getKey: ({ match: match, query: query, route: { name: name } })=>$4181ab9f0d3720b7$var$getRouterKey(name, match, query),
        getData: async ({ match: match, query: query, route: { name: name } })=>{
            const scopeIdentifier = $4181ab9f0d3720b7$export$adb27ddab077e944(name, match, query);
            if (scopeIdentifier.identifierType == null || scopeIdentifier.identifierValue == null) return null;
            const navInfo = await (0, $LWmvk.fetchProjectSidebarNavInfo)(scopeIdentifier);
            return navInfo;
        },
        maxAge: 300000
    });
    const $4181ab9f0d3720b7$export$b692cfadccf4e047 = ()=>(0, $lB25E.useResource)($4181ab9f0d3720b7$export$f2dfc0f7b2d92691);
});
parcelRegister("kdp9J", function(module, exports) {
    $parcel$export(module.exports, "getScopeIdentifier", ()=>$004bd39330a8812e$export$68278f7cf66944f9);
    const $004bd39330a8812e$export$68278f7cf66944f9 = (scope)=>{
        const identifierValue = scope.boardId || scope.projectKey || scope.projectId;
        let identifierType = null;
        if (scope.boardId) identifierType = (0, $718a877cd35f74b2$export$929d50f83189406c);
        else if (scope.projectKey) identifierType = (0, $718a877cd35f74b2$export$b5a308a17bc991f3);
        else if (scope.projectId) identifierType = (0, $718a877cd35f74b2$export$da6f46390e1a426f);
        return {
            identifierValue: identifierValue,
            identifierType: identifierType
        };
    };
});
const $718a877cd35f74b2$export$b5a308a17bc991f3 = 'projectKey';
const $718a877cd35f74b2$export$929d50f83189406c = 'boardId';
const $718a877cd35f74b2$export$da6f46390e1a426f = 'projectId';
parcelRegister("ElVpH", function(module, exports) {
    $parcel$export(module.exports, "getBoardId", ()=>$478ce79be34a38cd$export$557c2f222778cea6);
    const $478ce79be34a38cd$export$557c2f222778cea6 = (match, query)=>match.params.boardId || query.rapidView || query['board.id'];
});
parcelRegister("LWmvk", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectSidebarNavInfo", ()=>$586cfcaef75ec717$export$8a51470472777e11);
    var $lRmyA = parcelRequire("lRmyA");
    const $586cfcaef75ec717$export$8a51470472777e11 = (scopeIdentifier)=>{
        const { identifierType: identifierType, identifierValue: identifierValue } = scopeIdentifier;
        if (identifierType == null || identifierValue == null) throw new Error('invalid identifier specified');
        let queryParam = '';
        switch(identifierType){
            case 'boardId':
                queryParam = `boardId=${identifierValue}`;
                break;
            case 'projectKey':
            case 'projectId':
                queryParam = `projectIdOrKey=${identifierValue}`;
                break;
            default:
                break;
        }
        return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar?${queryParam}`);
    };
});
parcelRegister("cLNfQ", function(module, exports) {
    $parcel$export(module.exports, "useJiraSoftwareCMPNavigationSynchronizer", ()=>$1154a45446083a64$export$780174995da89d60);
    var $eUqFw = parcelRequire("eUqFw");
    var $hTLlD = parcelRequire("hTLlD");
    var $kXWpU = parcelRequire("kXWpU");
    var $lB25E = parcelRequire("lB25E");
    const $1154a45446083a64$export$90dbde7e33e6e21 = ()=>null;
    const $1154a45446083a64$export$d647718555c2fdd8 = (projectKey)=>projectKey ? (0, $lB25E.createRouterContext)({
            name: 'software',
            path: '/dummyroute/c/projects/:projectKey/dummyroute',
            component: $1154a45446083a64$export$90dbde7e33e6e21
        }, {
            params: {
                projectKey: projectKey
            }
        }) : undefined;
    const $1154a45446083a64$export$19001bab9e4b7f8f = (projectKey)=>{
        const { data: data, update: update } = (0, $lB25E.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource), {
            routerContext: $1154a45446083a64$export$d647718555c2fdd8(projectKey)
        });
        return {
            data: data,
            update: update
        };
    };
    const $1154a45446083a64$export$23dc6491016cabdc = (boardId)=>boardId != null ? (0, $lB25E.createRouterContext)({
            name: 'software',
            path: '/dummyroute/c/projects/boards/:boardId/dummyroute',
            component: $1154a45446083a64$export$90dbde7e33e6e21
        }, {
            params: {
                boardId: `${boardId}`
            }
        }) : undefined;
    const $1154a45446083a64$export$e2bb7877e6cec3eb = (boardId)=>{
        const { data: data, update: update } = (0, $lB25E.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource), {
            routerContext: $1154a45446083a64$export$23dc6491016cabdc(boardId)
        });
        return {
            data: data,
            update: update
        };
    };
    const $1154a45446083a64$export$780174995da89d60 = (latestNavInfo)=>{
        const [{ match: match, query: query, route: { name: name } }] = (0, $lB25E.useRouter)();
        const isOnBoardBasedRoute = (0, $kXWpU.getIdentifier)(name, match, query)?.identifierType === 'boardId';
        const isSoftwareCMP = latestNavInfo?.jiraSoftwareNavData?.project?.simplified === false;
        const pKey = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.project?.key || null;
        const boardId = isSoftwareCMP && latestNavInfo?.jiraSoftwareNavData?.boardInfo?.id || null;
        const { data: projectRouteNavInfo, update: updateProjectRoute } = $1154a45446083a64$export$19001bab9e4b7f8f(pKey);
        const { data: boardRouteNavInfo, update: updateBoardRoute } = $1154a45446083a64$export$e2bb7877e6cec3eb(boardId);
        (0, $eUqFw.useEffect)(()=>{
            if (latestNavInfo != null && isSoftwareCMP) {
                if (isOnBoardBasedRoute && !(0, ($parcel$interopDefault($hTLlD)))(latestNavInfo, projectRouteNavInfo)) updateProjectRoute(()=>latestNavInfo);
                else if (!(0, ($parcel$interopDefault($hTLlD)))(latestNavInfo, boardRouteNavInfo)) updateBoardRoute(()=>latestNavInfo);
            }
        }, [
            isOnBoardBasedRoute,
            latestNavInfo,
            updateProjectRoute,
            updateBoardRoute,
            projectRouteNavInfo,
            boardRouteNavInfo,
            isSoftwareCMP
        ]);
    };
});
parcelRegister("hbusP", function(module, exports) {
    $parcel$export(module.exports, "NavigationUISubscriber", ()=>$5256aede416e5446$export$d3dc1c18cfde5ddd);
    $parcel$export(module.exports, "NavigationUIContainer", ()=>$5256aede416e5446$export$339ec9ca159ad81f);
    var $WBLbN = parcelRequire("WBLbN");
    var $9LrYi = parcelRequire("9LrYi");
    const $5256aede416e5446$export$d3dc1c18cfde5ddd = (0, $WBLbN.createSubscriber)((0, $9LrYi.default), {
        displayName: 'NavigationUISubscriber',
        selector: null
    });
    const $5256aede416e5446$export$339ec9ca159ad81f = (0, $WBLbN.createContainer)((0, $9LrYi.default));
});
parcelRegister("9LrYi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$073edb176276dfc0$export$2e2bcd8739ae039);
    var $WBLbN = parcelRequire("WBLbN");
    var $k9kmE = parcelRequire("k9kmE");
    const $073edb176276dfc0$var$initialState = {
        collapseStart: new Set(),
        collapseEnd: new Set(),
        expandStart: new Set(),
        expandEnd: new Set()
    };
    var $073edb176276dfc0$export$2e2bcd8739ae039 = (0, $WBLbN.createStore)({
        name: 'navigation-ui',
        initialState: $073edb176276dfc0$var$initialState,
        actions: $k9kmE.default
    });
});
parcelRegister("k9kmE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e9459e5329f7e4e$export$2e2bcd8739ae039);
    var $kAdm2 = parcelRequire("kAdm2");
    var $d4PbU = parcelRequire("d4PbU");
    var $85FUs = parcelRequire("85FUs");
    var $20oC5 = parcelRequire("20oC5");
    const $0e9459e5329f7e4e$var$actions = {
        collapseStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($kAdm2.default('collapseStart', cb)),
        collapseStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($85FUs.default('collapseStart', cb)),
        collapseStartClear: ()=>({ dispatch: dispatch })=>dispatch($d4PbU.default('collapseStart')),
        collapseStartRun: ()=>({ dispatch: dispatch })=>dispatch($20oC5.default('collapseStart')),
        collapseEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($kAdm2.default('collapseEnd', cb)),
        collapseEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($85FUs.default('collapseEnd', cb)),
        collapseEndClear: ()=>({ dispatch: dispatch })=>dispatch($d4PbU.default('collapseEnd')),
        collapseEndRun: (cb)=>({ dispatch: dispatch })=>dispatch($20oC5.default('collapseEnd', cb)),
        expandStartAdd: (cb)=>({ dispatch: dispatch })=>dispatch($kAdm2.default('expandStart', cb)),
        expandStartRemove: (cb)=>({ dispatch: dispatch })=>dispatch($85FUs.default('expandStart', cb)),
        expandStartClear: ()=>({ dispatch: dispatch })=>dispatch($d4PbU.default('expandStart')),
        expandStartRun: (cb)=>({ dispatch: dispatch })=>dispatch($20oC5.default('expandStart', cb)),
        expandEndAdd: (cb)=>({ dispatch: dispatch })=>dispatch($kAdm2.default('expandEnd', cb)),
        expandEndRemove: (cb)=>({ dispatch: dispatch })=>dispatch($85FUs.default('expandEnd', cb)),
        expandEndClear: ()=>({ dispatch: dispatch })=>dispatch($d4PbU.default('expandEnd')),
        expandEndRun: (cb)=>({ dispatch: dispatch })=>dispatch($20oC5.default('expandEnd', cb)),
        clearAll: ()=>({ dispatch: dispatch })=>{
                dispatch($0e9459e5329f7e4e$var$actions.collapseStartClear());
                dispatch($0e9459e5329f7e4e$var$actions.collapseEndClear());
                dispatch($0e9459e5329f7e4e$var$actions.expandStartClear());
                dispatch($0e9459e5329f7e4e$var$actions.expandEndClear());
            }
    };
    var $0e9459e5329f7e4e$export$2e2bcd8739ae039 = $0e9459e5329f7e4e$var$actions;
});
parcelRegister("kAdm2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ae4d62e75c39d6ec$export$2e2bcd8739ae039);
    var $85FUs = parcelRequire("85FUs");
    var $ae4d62e75c39d6ec$export$2e2bcd8739ae039 = (key, callback)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            setState({
                [key]: new Set(getState()[key]).add(callback)
            });
            return ()=>dispatch((0, $85FUs.default)(key, callback));
        };
});
parcelRegister("85FUs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3b2c6d695815dbd$export$2e2bcd8739ae039);
    var $b3b2c6d695815dbd$export$2e2bcd8739ae039 = (key, callback)=>({ setState: setState, getState: getState })=>{
            if (!getState()[key]) return;
            const slice = new Set(getState()[key]);
            slice.delete(callback);
            setState({
                [key]: slice
            });
        };
});
parcelRegister("d4PbU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$912d7a599c33dfa4$export$2e2bcd8739ae039);
    var $912d7a599c33dfa4$export$2e2bcd8739ae039 = (key)=>({ setState: setState })=>setState({
                [key]: new Set()
            });
});
parcelRegister("20oC5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c664f49a6b0027bd$export$2e2bcd8739ae039);
    var $c664f49a6b0027bd$export$2e2bcd8739ae039 = (key, ...args)=>({ getState: getState })=>(getState()[key] || new Set()).forEach((cb)=>cb(...args));
});
parcelRegister("3mRDR", function(module, exports) {
    $parcel$export(module.exports, "itemIds", ()=>$8615713aedf1e792$export$443ec49e59de3663);
    $parcel$export(module.exports, "viewIds", ()=>$8615713aedf1e792$export$8ee2fd038785d9dc);
    var $dYFw9 = parcelRequire("dYFw9");
    const $8615713aedf1e792$var$ROOT = 'root/index';
    const $8615713aedf1e792$var$ISSUES = 'root/issues';
    const $8615713aedf1e792$var$DASHBOARDS = 'root/dashboards';
    const $8615713aedf1e792$var$PORTFOLIO = 'root/portfolio';
    const $8615713aedf1e792$var$WORK_SCRUM = 'work-scrum';
    const $8615713aedf1e792$var$PLAN_SCRUM = 'plan-scrum';
    const $8615713aedf1e792$var$WORK_KANBAN = 'work-kanban';
    const $8615713aedf1e792$var$PLAN_KANBAN = 'plan-kanban';
    const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES = 'pin-filter-myopenissues';
    const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES = 'pin-filter-reportedbyme';
    const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES = 'pin-filter-allissues';
    const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES = 'pin-filter-allopenissues';
    const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES = 'pin-filter-doneissues';
    const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES = 'pin-filter-recentlyviewed';
    const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES = 'pin-filter-addedrecently';
    const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES = 'pin-filter-resolvedrecently';
    const $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES = 'pin-filter-updatedrecently';
    const $8615713aedf1e792$var$AGILITY = 'project/agility/index';
    const $8615713aedf1e792$var$BUSINESS = 'project/business/index';
    const $8615713aedf1e792$var$OPS = 'project/ops/index';
    const $8615713aedf1e792$var$SOFTWARE = 'project/software/index';
    const $8615713aedf1e792$var$SOFTWARE_ISSUES = 'project/software/issues';
    const $8615713aedf1e792$var$SOFTWARE_REPORTS = 'project/software/reports';
    const $8615713aedf1e792$var$USER = 'user/index';
    const $8615713aedf1e792$var$USER_REPORTS = 'user/reports';
    const $8615713aedf1e792$var$rootProjectViewIds = {
        AGILITY: $8615713aedf1e792$var$AGILITY,
        SERVICE_DESK: $dYFw9.SERVICE_DESK,
        OPS: $8615713aedf1e792$var$OPS,
        BUSINESS: $8615713aedf1e792$var$BUSINESS,
        SOFTWARE: $8615713aedf1e792$var$SOFTWARE
    };
    const $8615713aedf1e792$var$rootViewIds = {
        ROOT: $8615713aedf1e792$var$ROOT,
        ISSUES: $8615713aedf1e792$var$ISSUES,
        DASHBOARDS: $8615713aedf1e792$var$DASHBOARDS,
        PORTFOLIO: $8615713aedf1e792$var$PORTFOLIO
    };
    const $8615713aedf1e792$export$443ec49e59de3663 = {
        WORK_SCRUM: $8615713aedf1e792$var$WORK_SCRUM,
        PLAN_SCRUM: $8615713aedf1e792$var$PLAN_SCRUM,
        WORK_KANBAN: $8615713aedf1e792$var$WORK_KANBAN,
        PLAN_KANBAN: $8615713aedf1e792$var$PLAN_KANBAN,
        PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES,
        PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES: $8615713aedf1e792$var$PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES,
        ...(0, $dYFw9.SERVICE_DESK_ITEMS)
    };
    const $8615713aedf1e792$export$8ee2fd038785d9dc = {
        ...$8615713aedf1e792$var$rootViewIds,
        ...$8615713aedf1e792$var$rootProjectViewIds,
        SOFTWARE_ISSUES: $8615713aedf1e792$var$SOFTWARE_ISSUES,
        SOFTWARE_REPORTS: $8615713aedf1e792$var$SOFTWARE_REPORTS,
        SERVICE_DESK_ISSUES: $dYFw9.SERVICE_DESK_ISSUES,
        SERVICE_DESK_QUEUES: $dYFw9.SERVICE_DESK_QUEUES,
        SERVICE_DESK_REPORTS: $dYFw9.SERVICE_DESK_REPORTS,
        SERVICE_DESK_SETTINGS: $dYFw9.SERVICE_DESK_SETTINGS,
        SERVICE_DESK_LANGUAGES: $dYFw9.SERVICE_DESK_LANGUAGES,
        SERVICE_DESK_LEGACY_TICKET_TYPES: $dYFw9.SERVICE_DESK_LEGACY_TICKET_TYPES,
        SERVICE_DESK_TRANSLATIONS: $dYFw9.SERVICE_DESK_TRANSLATIONS,
        SERVICE_DESK_AUTOMATION_SUB_NAV: $dYFw9.SERVICE_DESK_AUTOMATION_SUB_NAV,
        SERVICE_DESK_KNOWLEDGE_HUB: $dYFw9.SERVICE_DESK_KNOWLEDGE_HUB,
        USER: $8615713aedf1e792$var$USER,
        USER_REPORTS: $8615713aedf1e792$var$USER_REPORTS
    };
});
parcelRegister("dYFw9", function(module, exports) {
    $parcel$export(module.exports, "REPORTS_IDS", ()=>$890d2e79149b5a80$export$1f70a76cb421b107);
    $parcel$export(module.exports, "HOME_ITEMS_IDS", ()=>$890d2e79149b5a80$export$9afbea2cbd37e16d);
    $parcel$export(module.exports, "SETTINGS_IDS", ()=>$890d2e79149b5a80$export$5fd6685a693e1064);
    $parcel$export(module.exports, "PRACTICES_IDS", ()=>$890d2e79149b5a80$export$a37f4f7add086a3);
    $parcel$export(module.exports, "SERVICE_DESK_ITEMS", ()=>$890d2e79149b5a80$export$2108a7f32cd0bb12);
    $parcel$export(module.exports, "REQUEST_TYPE_PRACTICE_NAV_ONBOARDING", ()=>$890d2e79149b5a80$export$712b4b205a2bcf1e);
    $parcel$export(module.exports, "TEAM_PRIORITY_QUEUE_ADMIN_SPOTLIGHT", ()=>$890d2e79149b5a80$export$aaffd3035e9d6c2d);
    $parcel$export(module.exports, "STARRED_QUEUE_SPOTLIGHT", ()=>$890d2e79149b5a80$export$e2d46b728fe0a15a);
    $parcel$export(module.exports, "SERVICE_DESK", ()=>$890d2e79149b5a80$export$c8c1c8c3f8ddba61);
    $parcel$export(module.exports, "SERVICE_DESK_ISSUES", ()=>$890d2e79149b5a80$export$51fa1147c138a6ed);
    $parcel$export(module.exports, "SERVICE_DESK_QUEUES", ()=>$890d2e79149b5a80$export$456b3cfbf5e37bd8);
    $parcel$export(module.exports, "SERVICE_DESK_KNOWLEDGE_HUB", ()=>$890d2e79149b5a80$export$9ccc8d85b210b219);
    $parcel$export(module.exports, "SERVICE_DESK_REPORTS", ()=>$890d2e79149b5a80$export$707771f2f7e60575);
    $parcel$export(module.exports, "SERVICE_DESK_SETTINGS", ()=>$890d2e79149b5a80$export$a87fc635598d2d50);
    $parcel$export(module.exports, "SERVICE_DESK_LEGACY_TICKET_TYPES", ()=>$890d2e79149b5a80$export$b6bda26b77269209);
    $parcel$export(module.exports, "SERVICE_DESK_LANGUAGES", ()=>$890d2e79149b5a80$export$776199f9e99c88e2);
    $parcel$export(module.exports, "SERVICE_DESK_TRANSLATIONS", ()=>$890d2e79149b5a80$export$d70ba5c124463035);
    $parcel$export(module.exports, "SERVICE_DESK_AUTOMATION_SUB_NAV", ()=>$890d2e79149b5a80$export$9a6deaa9c1af559f);
    const $890d2e79149b5a80$var$HOME_QUEUES = 'queues';
    const $890d2e79149b5a80$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT = 'all-itsm-queues-spotlight';
    const $890d2e79149b5a80$var$HOME_ALL_TICKETS_SPOTLIGHT = 'all-tickets-spotlight';
    const $890d2e79149b5a80$var$HOME_TICKET_CATEGORIES_SPOTLIGHT = 'ticket-categories-spotlight';
    const $890d2e79149b5a80$var$HOME_SERVICE_REQUESTS = 'service-requests';
    const $890d2e79149b5a80$var$HOME_INCIDENTS = 'incidents';
    const $890d2e79149b5a80$var$HOME_CHANGES = 'changes';
    const $890d2e79149b5a80$var$HOME_PROBLEMS = 'problems';
    const $890d2e79149b5a80$var$HOME_POST_INCIDENT_REVIEWS = 'post-incident-reviews';
    const $890d2e79149b5a80$var$HOME_CUSTOMERS = 'customers';
    const $890d2e79149b5a80$var$HOME_REPORTS = 'reports';
    const $890d2e79149b5a80$var$HOME_RAISE_REQUEST = 'raise-request';
    const $890d2e79149b5a80$var$HOME_ISSUES = 'issues';
    const $890d2e79149b5a80$var$HOME_CUSTOMER_CHANNELS = 'customer-channels';
    const $890d2e79149b5a80$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT = 'customer-channels-spotlight';
    const $890d2e79149b5a80$var$HOME_JSD_CHANNELS_DIALOG = 'jsd-channels-dialog';
    const $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE = 'knowledge-base';
    const $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE_HUB = 'knowledge-hub';
    const $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE_HUB_NESTED = 'knowledge-hub-nested';
    const $890d2e79149b5a80$var$HOME_INVITE_TEAM = 'invite-team';
    const $890d2e79149b5a80$var$HOME_GIVE_FEEDBACK = 'give-feedback';
    const $890d2e79149b5a80$var$HOME_SERVICES = 'services';
    const $890d2e79149b5a80$var$HOME_SERVICES_SPOTLIGHT = 'services-spotlight';
    const $890d2e79149b5a80$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT = 'alerts-and-on-call-spotlight';
    const $890d2e79149b5a80$var$HOME_CHANGE_CALENDAR_SPOTLIGHT = 'change-calendar-spotlight';
    const $890d2e79149b5a80$export$1f70a76cb421b107 = {
        REPORTS_CUSTOM: 'sd-reports-custom',
        REPORTS_ADDONS: 'sd-reports-addons',
        REPORTS_NAV_CUSTOM_ACTIONS: 'sd-reports-nav-custom-actions',
        REPORTS_NAV_TEAM: 'sd-reports-nav-team',
        REPORTS_NAV_KB: 'sd-reports-nav-kb'
    };
    const $890d2e79149b5a80$export$9afbea2cbd37e16d = {
        QUEUES: $890d2e79149b5a80$var$HOME_QUEUES,
        ALL_ITSM_QUEUES_SPOTLIGHT: $890d2e79149b5a80$var$HOME_ALL_ITSM_QUEUES_SPOTLIGHT,
        ALL_TICKETS_SPOTLIGHT: $890d2e79149b5a80$var$HOME_ALL_TICKETS_SPOTLIGHT,
        TICKET_CATEGORIES_SPOTLIGHT: $890d2e79149b5a80$var$HOME_TICKET_CATEGORIES_SPOTLIGHT,
        SERVICE_REQUEST: $890d2e79149b5a80$var$HOME_SERVICE_REQUESTS,
        INCIDENTS: $890d2e79149b5a80$var$HOME_INCIDENTS,
        CHANGES: $890d2e79149b5a80$var$HOME_CHANGES,
        PROBLEMS: $890d2e79149b5a80$var$HOME_PROBLEMS,
        CUSTOMERS: $890d2e79149b5a80$var$HOME_CUSTOMERS,
        POST_INCIDENT_REVIEWS: $890d2e79149b5a80$var$HOME_POST_INCIDENT_REVIEWS,
        REPORTS: $890d2e79149b5a80$var$HOME_REPORTS,
        RAISE_REQUEST: $890d2e79149b5a80$var$HOME_RAISE_REQUEST,
        ISSUES: $890d2e79149b5a80$var$HOME_ISSUES,
        CUSTOMER_CHANNELS: $890d2e79149b5a80$var$HOME_CUSTOMER_CHANNELS,
        CUSTOMER_CHANNELS_SPOTLIGHT: $890d2e79149b5a80$var$HOME_CUSTOMER_CHANNELS_SPOTLIGHT,
        JSD_CHANNELS_DIALOG: $890d2e79149b5a80$var$HOME_JSD_CHANNELS_DIALOG,
        KNOWLEDGE_BASE: $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE,
        KNOWLEDGE_BASE_HUB: $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE_HUB,
        KNOWLEDGE_BASE_HUB_NESTED: $890d2e79149b5a80$var$HOME_KNOWLEDGE_BASE_HUB_NESTED,
        INVITE_TEAM: $890d2e79149b5a80$var$HOME_INVITE_TEAM,
        GIVE_FEEDBACK: $890d2e79149b5a80$var$HOME_GIVE_FEEDBACK,
        SERVICES: $890d2e79149b5a80$var$HOME_SERVICES,
        SERVICES_SPOTLIGHT: $890d2e79149b5a80$var$HOME_SERVICES_SPOTLIGHT,
        ALERTS_AND_ON_CALL_SPOTLIGHT: $890d2e79149b5a80$var$HOME_ALERTS_AND_ON_CALL_SPOTLIGHT,
        CHANGE_CALENDAR_SPOTLIGHT: $890d2e79149b5a80$var$HOME_CHANGE_CALENDAR_SPOTLIGHT
    };
    const $890d2e79149b5a80$export$304aefafb7155b23 = {
        TOP_ACTIONS: 'knowledge-hub-top-actions',
        ALL_ARTICLES: 'knowledge-hub-all-articles',
        CATEGORIES: 'knowledge-hub-categories',
        CATEGORIES_CONTEXT: 'knowledge-hub-categories-context',
        BOTTOM_ACTIONS: 'knowledge-hub-bottom-actions',
        ADD_CATEGORY: 'knowledge-hub-new-category',
        LEAVE_FEEDBACK: 'knowledge-hub-leave-feedback'
    };
    const $890d2e79149b5a80$export$5fd6685a693e1064 = {
        DETAILS: 'details',
        PEOPLE: 'people',
        ITSM_FEATURES: 'itsm-features',
        SUMMARY: 'summary',
        DELETE_PROJECT: 'delete-project',
        ISSUE_TYPES: 'issue-types',
        FEATURES: 'features',
        REQUEST_TYPES: 'sd-request-types',
        TICKET_TYPES: 'sd-ticket-types',
        CUSTOMER_PERMISSIONS: 'sd-customer-permissions',
        LANGUAGE_SUPPORT: 'sd-language-support',
        PORTAL_SETTINGS: 'sd-portal-settings',
        EMAIL_REQUESTS: 'sd-email-requests',
        CUSTOMER_NOTIFICATIONS: 'sd-customer-notifications',
        PROJECT_WIDGET_ADDON: 'sd-project-widget-addon',
        PROJECT_WIDGET_ADDON_INSTALLER: 'sd-project-widget-addon-installer',
        PROJECT_ASSETS_AD: 'sd-project-assets-ad',
        SATISFACTION_SETTINGS: 'sd-satisfaction-settings',
        KNOWLEDGE_BASE: 'sd-knowledge-base',
        SLAS: 'sd-slas',
        AUTOMATION: 'sd-automation',
        PLAYBOOKS: 'playbooks',
        JIRA_AUTOMATION: 'jira-automation',
        AUTOMATION_SUB_NAV: 'sd-automation-sub-nav',
        JSD_APP_DISCOVERY: 'sd-app-discovery',
        JSD_INCIDENT_MANAGEMENT: 'sd-incident-management',
        JSD_CHANGE_MANAGEMENT: 'sd-change-management',
        WORKFLOWS: 'workflows',
        SCREENS: 'screens',
        FIELDS: 'fields',
        VERSIONS: 'versions',
        COMPONENTS: 'components',
        PERMISSIONS: 'permissions',
        ISSUE_SECURITY: 'issue-security',
        NOTIFICATIONS: 'notifications',
        HIPCHAT: 'hipchat',
        ISSUE_COLLECTORS: 'issue-collectors'
    };
    const $890d2e79149b5a80$export$50b1b8fc419aca98 = {
        QUEUE_NEW: 'queue-new',
        QUEUE_MANAGE: 'queue-manage',
        QUEUES_ADDONS: 'sd-queues-addons',
        QUEUES_CUSTOM_ACTIONS: 'sd-queues-custom-actions',
        SD_QUEUES_CUSTOM: 'sd-queues-custom'
    };
    const $890d2e79149b5a80$export$a37f4f7add086a3 = {
        ADDITIONAL_ITEMS: 'sd-practices-additional-items',
        CHANGES_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-changes-queue-title-spotlight',
        CHANGES_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-changes-queue-items-spotlight',
        INCIDENTS_QUEUE_TITLE_SPOTLIGHT: 'sd-practices-incidents-queue-title-spotlight',
        INCIDENTS_QUEUE_ITEMS_SPOTLIGHT: 'sd-practices-incidents-queue-items-spotlight'
    };
    const $890d2e79149b5a80$export$2108a7f32cd0bb12 = {
        SERVICE_DESK: {
            HOME: $890d2e79149b5a80$export$9afbea2cbd37e16d,
            KNOWLEDGE_BASE: $890d2e79149b5a80$export$304aefafb7155b23,
            SETTINGS: $890d2e79149b5a80$export$5fd6685a693e1064,
            QUEUES: $890d2e79149b5a80$export$50b1b8fc419aca98,
            REPORTS: $890d2e79149b5a80$export$1f70a76cb421b107
        }
    };
    const $890d2e79149b5a80$export$712b4b205a2bcf1e = {
        PRACTICE_NAV_SPOTLIGHT: 'request-type-practice-nav-spotlight',
        UNASSIGNED_NAV_SPOTLIGHT: 'request-type-unassgined-nav-spotlight'
    };
    const $890d2e79149b5a80$export$aaffd3035e9d6c2d = 'jsm-team-priority-queue-admin-onboarding';
    const $890d2e79149b5a80$export$e2d46b728fe0a15a = 'jsm-team-starred-onboarding';
    const $890d2e79149b5a80$export$c8c1c8c3f8ddba61 = 'project/service-desk/index';
    const $890d2e79149b5a80$export$51fa1147c138a6ed = 'project/service-desk/issues';
    const $890d2e79149b5a80$export$456b3cfbf5e37bd8 = 'project/service-desk/queues';
    const $890d2e79149b5a80$export$9ccc8d85b210b219 = 'project/service-desk/knowledge-hub';
    const $890d2e79149b5a80$export$707771f2f7e60575 = 'project/service-desk/reports';
    const $890d2e79149b5a80$export$a87fc635598d2d50 = 'project/service-desk/settings';
    const $890d2e79149b5a80$export$b6bda26b77269209 = 'project/service-desk/legacy-ticket-types';
    const $890d2e79149b5a80$export$776199f9e99c88e2 = 'project/service-desk/languages';
    const $890d2e79149b5a80$export$d70ba5c124463035 = 'project/service-desk/translations';
    const $890d2e79149b5a80$export$9a6deaa9c1af559f = 'project/service-desk/settings/automation-sub-nav';
});
parcelRegister("3eqbP", function(module, exports) {
    $parcel$export(module.exports, "AsyncLockScreenExperimentSharedWrapper", ()=>$cc6580f6fb3ff169$export$129bdc881130bc9);
    var $eUqFw = parcelRequire("eUqFw");
    var $5GxEP = parcelRequire("5GxEP");
    var $aR8n6 = parcelRequire("aR8n6");
    var $56koX = parcelRequire("56koX");
    const $cc6580f6fb3ff169$var$AsyncLockScreenExperimentShared = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("eAemQ")).then(({ LockScreenExperimentShared: LockScreenExperimentShared })=>LockScreenExperimentShared), {
        moduleId: "./src/packages/growth/end-of-trial/lock-screen-experiment-shared/src/index.tsx"
    });
    const $cc6580f6fb3ff169$export$129bdc881130bc9 = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
            id: "lock-screen-experiment-shared-async",
            packageName: (0, $a733f78220833320$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
            teamName: (0, $a733f78220833320$export$d57b6b390e78d90f),
            id: "lock-screen-experiment-shared-async",
            packageName: (0, $a733f78220833320$export$b8b9d90f9e5bd72b)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($cc6580f6fb3ff169$var$AsyncLockScreenExperimentShared, null)));
});
const $a733f78220833320$export$b8b9d90f9e5bd72b = '@atlassian/jira-lock-screen-experiment-shared';
const $a733f78220833320$export$d57b6b390e78d90f = 'transmuters-growth';
parcelRegister("eAemQ", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("4aVsP").then(()=>parcelRequire('fm5VO'));
});
parcelRegister("gbSuS", function(module, exports) {
    $parcel$export(module.exports, "jiraLossAversionModalEntryPoint", ()=>$d3b21b0cf851a9c6$export$e224c255d72cf9b5);
    var $1ydNb = parcelRequire("1ydNb");
    var $6TOES = parcelRequire("6TOES");
    const $d3b21b0cf851a9c6$export$e224c255d72cf9b5 = (0, $6TOES.createEntryPoint)({
        root: (0, $1ydNb.JSResourceForInteraction)(async ()=>(parcelRequire("eyEhh")).then(({ JiraLossAversionExperiment: JiraLossAversionExperiment })=>JiraLossAversionExperiment), {
            moduleId: "35d17363"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("eyEhh", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("h1TP1")
    ]).then(()=>parcelRequire('6wI7U'));
});
parcelRegister("cPEpP", function(module, exports) {
    $parcel$export(module.exports, "useProject", ()=>$681442ce6e3ade0b$export$51b1383ef8844a7);
    var $eUqFw = parcelRequire("eUqFw");
    var $eWsAG = parcelRequire("eWsAG");
    var $2futN = parcelRequire("2futN");
    const $681442ce6e3ade0b$export$51b1383ef8844a7 = (customContext)=>{
        const { data: data, loading: loading, error: error } = (0, $2futN.useProjectSidebarNavigation)(customContext);
        const project = (0, $eUqFw.useMemo)(()=>data && (0, $eWsAG.extractData)(data), [
            data
        ]);
        return {
            data: project,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("eWsAG", function(module, exports) {
    $parcel$export(module.exports, "getStyle", ()=>$994f1ddfe6829bdc$export$3d2f074408bd1b82);
    $parcel$export(module.exports, "extractData", ()=>$994f1ddfe6829bdc$export$9df5fa0a366163d2);
    var $7ZZxN = parcelRequire("7ZZxN");
    const $994f1ddfe6829bdc$export$3d2f074408bd1b82 = (isSimplifiedProject)=>isSimplifiedProject ? (0, $7ZZxN.ProjectStyle).NEXT_GEN : (0, $7ZZxN.ProjectStyle).CLASSIC;
    const $994f1ddfe6829bdc$var$getProject = (project)=>({
            avatarUrl: project.avatarUrls['48x48'],
            id: Number(project.id),
            isSimplified: project.simplified,
            key: project.key,
            name: project.name,
            style: $994f1ddfe6829bdc$export$3d2f074408bd1b82(project.simplified),
            type: project.projectTypeKey
        });
    const $994f1ddfe6829bdc$export$9df5fa0a366163d2 = (data)=>{
        const { projectType: projectType, jiraWorkManagementNavData: jiraWorkManagementNavData, jiraSoftwareNavData: jiraSoftwareNavData, jiraServiceManagementNavData: jiraServiceManagementNavData, jiraProductDiscoveryNavData: jiraProductDiscoveryNavData } = data || {};
        switch(projectType){
            case 'jira_work_management':
                return jiraWorkManagementNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraWorkManagementNavData.project) : null;
            case 'jira_software':
                return jiraSoftwareNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraSoftwareNavData.project) : null;
            case 'jira_service_management':
            case 'jira_customer_service':
                return jiraServiceManagementNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraServiceManagementNavData.project) : null;
            case 'jira_product_discovery':
                return jiraProductDiscoveryNavData?.project ? $994f1ddfe6829bdc$var$getProject(jiraProductDiscoveryNavData.project) : null;
            case null:
            default:
                return null;
        }
    };
});
parcelRegister("i9XZP", function(module, exports) {
    $parcel$export(module.exports, "PageDwellAnalyticsListener", ()=>$f3c89b23479724f1$export$6cf89f098b551dad);
    var $eUqFw = parcelRequire("eUqFw");
    var $kpmC0 = parcelRequire("kpmC0");
    var $10fdS = parcelRequire("10fdS");
    var $jMP2a = parcelRequire("jMP2a");
    var $1inzG = parcelRequire("1inzG");
    var $bNe1g = parcelRequire("bNe1g");
    var $h3mHU = parcelRequire("h3mHU");
    var $98uAm = parcelRequire("98uAm");
    const $f3c89b23479724f1$var$WAIT_DURATION = 5000;
    const $f3c89b23479724f1$export$6cf89f098b551dad = ()=>{
        const [hasFired, setHasFired] = (0, $eUqFw.useState)(false);
        const route = (0, $10fdS.useCurrentRoute)();
        const routeName = route.name;
        const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
        const isVisible = (0, $98uAm.usePageVisibility)();
        const interval = (0, $eUqFw.useRef)(null);
        const { data: projectData } = (0, $bNe1g.useProjectContext)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        const { isCollapsed: isLeftSidebarCollapsed } = (0, $kpmC0.useLeftSidebarState)();
        (0, $eUqFw.useEffect)(()=>{
            setHasFired(false);
        }, [
            routeName
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (!isReady) {
                interval.current = null;
                return;
            }
            if (isVisible && !hasFired) interval.current = setTimeout(()=>{
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'page dwelled', routeName, {
                    containerId: projectData?.projectId,
                    containerType: projectData?.projectType,
                    isLeftSidebarCollapsed: isLeftSidebarCollapsed
                });
                setHasFired(true);
            }, $f3c89b23479724f1$var$WAIT_DURATION);
            return ()=>{
                interval.current = clearTimeout(interval.current);
            };
        }, [
            createAnalyticsEvent,
            hasFired,
            isReady,
            isVisible,
            routeName,
            projectData?.projectId,
            projectData?.projectType,
            isLeftSidebarCollapsed
        ]);
        return null;
    };
});
parcelRegister("98uAm", function(module, exports) {
    $parcel$export(module.exports, "usePageVisibility", ()=>$628deecc3f05d159$export$6c98eb2f12f4ec61);
    var $eUqFw = parcelRequire("eUqFw");
    var $fEYK5 = parcelRequire("fEYK5");
    const $628deecc3f05d159$export$6c98eb2f12f4ec61 = ()=>{
        const [isVisible, setIsVisible] = (0, $eUqFw.useState)((0, $fEYK5.isPageVisible)());
        (0, $eUqFw.useEffect)(()=>{
            const onVisibilityChange = ()=>setIsVisible((0, $fEYK5.isPageVisible)());
            document.addEventListener('visibilitychange', onVisibilityChange);
            return ()=>{
                document.removeEventListener('visibilitychange', onVisibilityChange);
            };
        }, []);
        return isVisible;
    };
});
parcelRegister("fEYK5", function(module, exports) {
    $parcel$export(module.exports, "supportedVisiblityEvent", ()=>$72bec4f04bbd1d44$export$f7132cb36c80dad);
    $parcel$export(module.exports, "isPageVisible", ()=>$72bec4f04bbd1d44$export$ae4f9b990bc70f70);
    const $72bec4f04bbd1d44$var$visibilityMap = {
        hidden: 'visibilitychange',
        mozHidden: 'mozvisibilitychange',
        msHidden: 'msvisibilitychange',
        webkitHidden: 'webkitvisibilitychange'
    };
    const $72bec4f04bbd1d44$var$supportedHiddenKey = Object.keys($72bec4f04bbd1d44$var$visibilityMap).find((key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
    const $72bec4f04bbd1d44$export$f7132cb36c80dad = $72bec4f04bbd1d44$var$visibilityMap[$72bec4f04bbd1d44$var$supportedHiddenKey];
    const $72bec4f04bbd1d44$export$ae4f9b990bc70f70 = ()=>typeof document !== 'undefined' && !document[$72bec4f04bbd1d44$var$supportedHiddenKey];
});
parcelRegister("2m6cd", function(module, exports) {
    $parcel$export(module.exports, "MatchedRouteListener", ()=>$adf6545c3ff6605a$export$c6d9204abc182c3b);
    var $eUqFw = parcelRequire("eUqFw");
    var $keguF = parcelRequire("keguF");
    var $lB25E = parcelRequire("lB25E");
    const $adf6545c3ff6605a$export$c6d9204abc182c3b = ()=>{
        const [{ route: route, match: match }] = (0, $lB25E.useRouter)();
        (0, $eUqFw.useMemo)(()=>(0, $keguF.setMatchedRoute)(route, match), [
            route,
            match
        ]);
        return null;
    };
});
parcelRegister("hEyt5", function(module, exports) {
    $parcel$export(module.exports, "PreviousRouterStateListener", ()=>$e9e95a1ddd50ffec$export$49e28489f2124002);
    var $eUqFw = parcelRequire("eUqFw");
    var $hzcvF = parcelRequire("hzcvF");
    var $keguF = parcelRequire("keguF");
    var $lB25E = parcelRequire("lB25E");
    const $e9e95a1ddd50ffec$export$3fd5ddd6b8e9a200 = ({ routerState: routerState })=>{
        const previousRouterState = (0, $hzcvF.usePrevious)(routerState);
        (0, $eUqFw.useEffect)(()=>{
            (0, $keguF.setPreviousRouterState)(previousRouterState ?? null);
        }, [
            previousRouterState
        ]);
        return null;
    };
    const $e9e95a1ddd50ffec$export$49e28489f2124002 = (0, $eUqFw.memo)(()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterSubscriber), null, (routerState)=>(0, ($parcel$interopDefault($eUqFw))).createElement($e9e95a1ddd50ffec$export$3fd5ddd6b8e9a200, {
                routerState: routerState
            })));
    $e9e95a1ddd50ffec$export$49e28489f2124002.displayName = 'PreviousRouterStateListener';
});
parcelRegister("hzcvF", function(module, exports) {
    $parcel$export(module.exports, "usePrevious", ()=>$42dfce76254176f5$export$5cae361ad82dce8b);
    $parcel$export(module.exports, "usePreviousWithInitial", ()=>$42dfce76254176f5$export$23fbbb2e62c4a911);
    var $eUqFw = parcelRequire("eUqFw");
    const $42dfce76254176f5$export$5cae361ad82dce8b = (value)=>{
        const ref = (0, $eUqFw.useRef)();
        (0, $eUqFw.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    const $42dfce76254176f5$export$23fbbb2e62c4a911 = (value)=>{
        const ref = (0, $eUqFw.useRef)(value);
        (0, $eUqFw.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
});
parcelRegister("iOtr0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6aa3a3761ea48b01$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $53ciZ = parcelRequire("53ciZ");
    var $lgxha = parcelRequire("lgxha");
    var $5omJE = parcelRequire("5omJE");
    var $8WuJm = parcelRequire("8WuJm");
    var $d6f6c = parcelRequire("d6f6c");
    var $lB25E = parcelRequire("lB25E");
    var $js5iW = parcelRequire("js5iW");
    const $6aa3a3761ea48b01$var$QueryStringNotifier = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
            sourceName: "querystringNotifications"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5omJE.default), null, (flagService)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterSubscriber), null, ({ location: { search: search } })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lB25E.RouterActions), null, ({ replace: replace })=>{
                    const { showFlag: showFlag, ...query } = (0, ($parcel$interopDefault($53ciZ))).parse(search);
                    if (!showFlag) return null;
                    return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, $js5iW.default)[showFlag] ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
                        eventName: "querystringNotification shown",
                        componentName: "flag",
                        attributes: {
                            showFlag: showFlag
                        }
                    }) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireOperationalAnalytics), {
                        eventName: "querystringNotification notFound",
                        componentName: "flag",
                        attributes: {
                            showFlag: showFlag
                        }
                    }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
                        op: ()=>{
                            if ((0, $js5iW.default)[showFlag]) flagService.showFlag((0, $js5iW.default)[showFlag]);
                            replace(`?${(0, ($parcel$interopDefault($53ciZ))).stringify(query)}`);
                        }
                    }));
                }))));
    var $6aa3a3761ea48b01$export$2e2bcd8739ae039 = $6aa3a3761ea48b01$var$QueryStringNotifier;
});
parcelRegister("lgxha", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c6fb1eab8416e3f$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    class $7c6fb1eab8416e3f$var$OpTrigger extends (0, $eUqFw.Component) {
        static{
            this.defaultProps = {
                args: []
            };
        }
        componentDidMount() {
            this.props.op(...this.props.args);
        }
        render() {
            return null;
        }
    }
    var $7c6fb1eab8416e3f$export$2e2bcd8739ae039 = $7c6fb1eab8416e3f$var$OpTrigger;
});
parcelRegister("5omJE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e16a0c982e8c9d5$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $k8Qyf = parcelRequire("k8Qyf");
    const $7e16a0c982e8c9d5$var$FlagServiceSubscriber = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, props.children((0, $k8Qyf.flagService)));
    var $7e16a0c982e8c9d5$export$2e2bcd8739ae039 = $7e16a0c982e8c9d5$var$FlagServiceSubscriber;
});
parcelRegister("d6f6c", function(module, exports) {
    $parcel$export(module.exports, "FireUiAnalytics", ()=>$6c42ad247d2b6151$export$5a67e7291fd4569e);
    $parcel$export(module.exports, "FireTrackAnalytics", ()=>$6c42ad247d2b6151$export$5f0d7aae8dfa8b86);
    $parcel$export(module.exports, "FireOperationalAnalytics", ()=>$6c42ad247d2b6151$export$b71c3ada5d4ec5da);
    $parcel$export(module.exports, "FireScreenAnalytics", ()=>$6c42ad247d2b6151$export$2ccf161b817b43b);
    var $eUqFw = parcelRequire("eUqFw");
    var $iQC4h = parcelRequire("iQC4h");
    var $jMP2a = parcelRequire("jMP2a");
    class $6c42ad247d2b6151$var$FireComponent extends (0, $eUqFw.Component) {
        componentDidMount() {
            const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
            if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
            if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
            const eventNameSplit = eventName ? eventName.split(' ') : [];
            const action = actionProps || eventNameSplit[1];
            const actionSubject = actionSubjectProps || eventNameSplit[0];
            if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
            const actionSubjectId = actionSubjectIdProps || componentName;
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: action
            });
            (0, $jMP2a.fireAnalytics)(analyticsEvent, type, {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                attributes: attributes
            });
        }
        render() {
            return null;
        }
    }
    const $6c42ad247d2b6151$export$64eb47d7b94ba089 = (0, $iQC4h.default)()($6c42ad247d2b6151$var$FireComponent);
    const $6c42ad247d2b6151$export$5a67e7291fd4569e = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $41ea3621645e2acc$export$a1562d08625f5d7e)
        });
    const $6c42ad247d2b6151$export$5f0d7aae8dfa8b86 = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $41ea3621645e2acc$export$947dac6c72b26f81)
        });
    const $6c42ad247d2b6151$export$b71c3ada5d4ec5da = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $41ea3621645e2acc$export$12346a674644c156)
        });
    const $6c42ad247d2b6151$export$2ccf161b817b43b = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement($6c42ad247d2b6151$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $41ea3621645e2acc$export$f1d537d508d2945a),
            eventName: "screen viewed"
        });
});
parcelRegister("js5iW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da00c22705b8222e$export$2e2bcd8739ae039);
    var $eo17r = parcelRequire("eo17r");
    var $7mirP = parcelRequire("7mirP");
    const $da00c22705b8222e$var$notificationMessages = {
        'jsw.board-not-found': {
            id: (0, $eo17r.toFlagId)('jsw.board-not-found'),
            type: 'error',
            title: (0, $7mirP.default).boardNotFound,
            description: (0, $7mirP.default).boardNotFoundDescription
        },
        'jsw.project-not-found': {
            id: (0, $eo17r.toFlagId)('jsw.project-not-found'),
            type: 'error',
            title: (0, $7mirP.default).projectNotFound,
            description: (0, $7mirP.default).projectNotFoundDescription
        }
    };
    var $da00c22705b8222e$export$2e2bcd8739ae039 = $da00c22705b8222e$var$notificationMessages;
});
parcelRegister("7mirP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fecba56a8f0fa28c$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    const $fecba56a8f0fa28c$var$messages = (0, $90IgZ.defineMessages)({
        boardNotFound: {
            "id": "query-string-notifier.common.board-not-found",
            "defaultMessage": "Board not found"
        },
        boardNotFoundDescription: {
            "id": "query-string-notifier.common.board-not-found-description",
            "defaultMessage": "You tried to access a board that doesn't exist or that you don't have permission to see."
        },
        projectNotFound: {
            "id": "query-string-notifier.common.project-not-found",
            "defaultMessage": "Project not found"
        },
        projectNotFoundDescription: {
            "id": "query-string-notifier.common.project-not-found-description",
            "defaultMessage": "You tried to access a project that doesn't exist or that you don't have permission to see."
        }
    });
    var $fecba56a8f0fa28c$export$2e2bcd8739ae039 = $fecba56a8f0fa28c$var$messages;
});
parcelRegister("i0pNS", function(module, exports) {
    $parcel$export(module.exports, "AsyncRecommendPremiumToStandardModalWrapper", ()=>$a7f9bc79f0d4187d$export$2a43717c77dd3a56);
    var $eUqFw = parcelRequire("eUqFw");
    var $5GxEP = parcelRequire("5GxEP");
    var $aR8n6 = parcelRequire("aR8n6");
    var $56koX = parcelRequire("56koX");
    var $fX0ox = parcelRequire("fX0ox");
    const $a7f9bc79f0d4187d$var$AsyncRecommendPremiumToStandardModalComponent = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("kGzY6")).then(({ RecommendPremiumToStandardModalComponent: RecommendPremiumToStandardModalComponent })=>RecommendPremiumToStandardModalComponent), {
        moduleId: "./src/packages/growth/recommend-premium-to-standard-modal/src/index.tsx"
    });
    const $a7f9bc79f0d4187d$export$2a43717c77dd3a56 = ()=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
            id: "recommend-premium-to-standard-modal-async",
            packageName: (0, $fX0ox.PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
            teamName: (0, $fX0ox.TEAM_NAME),
            id: "recommend-premium-to-standard-modal-async",
            packageName: (0, $fX0ox.PACKAGE_NAME)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($a7f9bc79f0d4187d$var$AsyncRecommendPremiumToStandardModalComponent, null)));
    };
});
parcelRegister("fX0ox", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$28d8bce3ded44043$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$28d8bce3ded44043$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "ANALYTICS_SOURCE_NAME", ()=>$28d8bce3ded44043$export$48e1d3fa57b0a2d5);
    $parcel$export(module.exports, "STARGATE_URL", ()=>$28d8bce3ded44043$export$c7e6a6b283196232);
    $parcel$export(module.exports, "RECC_STANDARD_MESSAGE_ID", ()=>$28d8bce3ded44043$export$de9f5b160db96e26);
    const $28d8bce3ded44043$export$b8b9d90f9e5bd72b = '@atlassian/jira-recommend-premium-to-standard-modal';
    const $28d8bce3ded44043$export$d57b6b390e78d90f = 'growth-tako';
    const $28d8bce3ded44043$export$48e1d3fa57b0a2d5 = 'recommendPremiumToStandard';
    const $28d8bce3ded44043$export$c7e6a6b283196232 = '/gateway/api';
    const $28d8bce3ded44043$export$de9f5b160db96e26 = new Map([
        [
            5,
            'prj-grace-period-recc-standard-message-1'
        ],
        [
            3,
            'prj-grace-period-recc-standard-message-2'
        ],
        [
            1,
            'prj-grace-period-recc-standard-message-3'
        ]
    ]);
});
parcelRegister("kGzY6", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("aHrtt").then(()=>parcelRequire('9yvl1'));
});
parcelRegister("isbb2", function(module, exports) {
    $parcel$export(module.exports, "coalesce", ()=>$7465cd989816140c$export$6e5538615c060df7);
    $parcel$export(module.exports, "renderGlobalComponents", ()=>$7465cd989816140c$export$fc28c9563350e5b8);
    $parcel$export(module.exports, "createLayout", ()=>$7465cd989816140c$export$3dd437ade36ede40);
    $parcel$export(module.exports, "composeLayouts", ()=>$7465cd989816140c$export$6c041b39c370853f);
    $parcel$export(module.exports, "withProjectContext", ()=>$7465cd989816140c$export$e97a7da67a5b8ce4);
    var $eUqFw = parcelRequire("eUqFw");
    var $cPEpP = parcelRequire("cPEpP");
    var $gGtKh = parcelRequire("gGtKh");
    const $7465cd989816140c$export$6e5538615c060df7 = (maybeString)=>maybeString == null || maybeString === '' ? undefined : maybeString;
    const $7465cd989816140c$export$fc28c9563350e5b8 = (components)=>components.map((Component, i)=>{
            const { displayName: displayName, name: name } = Component;
            const key = $7465cd989816140c$export$6e5538615c060df7(displayName) ?? $7465cd989816140c$export$6e5538615c060df7(name) ?? i;
            return ((0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
                name: key?.toString(),
                fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null),
                key: key
            }, (0, ($parcel$interopDefault($eUqFw))).createElement(Component, null)));
        });
    const $7465cd989816140c$export$3dd437ade36ede40 = ({ globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false } = {})=>({
            isChromeless: isChromeless,
            globalComponents: Array.from(new Set(globalComponents)),
            rightSidebars: Array.from(new Set(rightSidebars))
        });
    const $7465cd989816140c$export$6c041b39c370853f = (...layouts)=>{
        if (layouts.length === 1) return $7465cd989816140c$export$3dd437ade36ede40(layouts[0]);
        const layout = layouts.reduce((l, { globalComponents: globalComponents = [], rightSidebars: rightSidebars = [], isChromeless: isChromeless = false })=>({
                isChromeless: isChromeless,
                globalComponents: [
                    ...l.globalComponents,
                    ...globalComponents
                ],
                rightSidebars: [
                    ...l.rightSidebars,
                    ...rightSidebars
                ]
            }), {
            globalComponents: [],
            rightSidebars: [],
            isChromeless: false
        });
        return $7465cd989816140c$export$3dd437ade36ede40(layout);
    };
    const $7465cd989816140c$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
    const $7465cd989816140c$var$formatPrefix = (style, type)=>{
        if (!style && !type) return 'Empty';
        if (style === 'any' && type === 'any') return 'Any';
        const formattedStyle = $7465cd989816140c$var$capitalize(style === 'next-gen' ? 'nextGen' : style ?? '');
        if (type === 'any') return formattedStyle;
        const formattedType = $7465cd989816140c$var$capitalize(type === 'service_desk' ? 'service' : type ?? '');
        if (style === 'any') return formattedType;
        return `${formattedStyle}${formattedType}`;
    };
    const $7465cd989816140c$export$e97a7da67a5b8ce4 = (Component, options)=>{
        const { project: expectedProject } = options;
        const ScopedComponent = ()=>{
            const { data: project, loading: loading } = (0, $cPEpP.useProject)();
            if (loading) return null;
            if ((expectedProject?.type === 'any' ? !project : project?.type !== expectedProject?.type) || (expectedProject?.style === 'any' ? !project : project?.style !== expectedProject?.style)) return null;
            return (0, ($parcel$interopDefault($eUqFw))).createElement(Component, null);
        };
        const name = $7465cd989816140c$export$6e5538615c060df7(Component.displayName) ?? $7465cd989816140c$export$6e5538615c060df7(Component.name) ?? 'Component';
        const prefix = $7465cd989816140c$var$formatPrefix(expectedProject?.style, expectedProject?.type);
        ScopedComponent.displayName = `with${prefix}ProjectContext(${name})`;
        return ScopedComponent;
    };
});
parcelRegister("5EZtQ", function(module, exports) {
    $parcel$export(module.exports, "rovoVideoModalEntryPoint", ()=>$295188a6a3871459$export$2f67fedc6d5555a5);
    var $1ydNb = parcelRequire("1ydNb");
    var $6TOES = parcelRequire("6TOES");
    const $295188a6a3871459$export$2f67fedc6d5555a5 = (0, $6TOES.createEntryPoint)({
        root: (0, $1ydNb.JSResourceForInteraction)(async ()=>(parcelRequire("l5cI4")).then(({ RovoVideoModal: RovoVideoModal })=>RovoVideoModal), {
            moduleId: "3a307b00"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("l5cI4", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("aVqgB")
    ]).then(()=>parcelRequire('63tmB'));
});
parcelRegister("cADdB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4a03ce1abcffd5c$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $k4nIh = parcelRequire("k4nIh");
    var $d6f6c = parcelRequire("d6f6c");
    var $ixwgj = parcelRequire("ixwgj");
    var $lB25E = parcelRequire("lB25E");
    const $e4a03ce1abcffd5c$var$ProjectKeyRedirect = ({ FireOperationalAnalytics: FireOperationalAnalytics = (0, $d6f6c.FireOperationalAnalytics), Redirect: Redirect = (0, $lB25E.Redirect), useResource: useResource = (0, $lB25E.useResource), useRouter: useRouter = (0, $lB25E.useRouter) })=>{
        const [{ location: location, match: { params: params, url: url }, query: query }] = useRouter();
        const projectKey = params.projectKey ?? query.projectKey;
        const { data: projectContext } = useResource((0, $ixwgj.projectContextResource));
        if (!projectKey || !projectContext?.projectKey) return null;
        if (projectKey === projectContext.projectKey) return null;
        const search = {
            ...query,
            ...query.projectKey ? {
                projectKey: projectContext.projectKey
            } : {}
        };
        const queryString = (0, $k4nIh.qs).stringify(search, Object.entries(search).length > 0);
        const path = params.projectKey != null ? url.replace(projectKey, projectContext.projectKey) : url;
        const to = `${path}${queryString}`;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement(FireOperationalAnalytics, {
            eventName: "ProjectKeyRedirect loaded",
            componentName: "ProjectKeyRedirect",
            attributes: {
                location: location,
                projectContext: projectContext
            }
        }), (0, ($parcel$interopDefault($eUqFw))).createElement(Redirect, {
            to: to
        }));
    };
    var $e4a03ce1abcffd5c$export$2e2bcd8739ae039 = $e4a03ce1abcffd5c$var$ProjectKeyRedirect;
});
parcelRegister("lFrSS", function(module, exports) {
    $parcel$export(module.exports, "AsyncUpflowIframeComponent", ()=>$d356d361dffc7fd3$export$7f34679273a30171);
    var $56koX = parcelRequire("56koX");
    const $d356d361dffc7fd3$export$7f34679273a30171 = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("87BxR")).then((exportedModule)=>exportedModule.UpflowIframeComponent), {
        ssr: false,
        moduleId: "./src/packages/growth/up-flow/upflow-iframe-plugin/src/main.tsx"
    });
});
parcelRegister("87BxR", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("2zJry").then(()=>parcelRequire('7B2m0'));
});
parcelRegister("cLxEl", function(module, exports) {
    $parcel$export(module.exports, "upgradeOnboardingExperimentEntryPoint", ()=>$6d97522dd833edb7$export$94ad1b5fd850909f);
    var $1ydNb = parcelRequire("1ydNb");
    var $6TOES = parcelRequire("6TOES");
    const $6d97522dd833edb7$export$94ad1b5fd850909f = (0, $6TOES.createEntryPoint)({
        root: (0, $1ydNb.JSResourceForInteraction)(async ()=>(parcelRequire("irf3v")).then(({ UpgradeOnboardingExperiment: UpgradeOnboardingExperiment })=>UpgradeOnboardingExperiment), {
            moduleId: "86e9ce71"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("irf3v", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("gOc4U")
    ]).then(()=>parcelRequire('bvwqZ'));
});
parcelRegister("BRKX9", function(module, exports) {
    $parcel$export(module.exports, "JiraHeritageLoader", ()=>$49eb3c5692df3dbe$export$9499deca9933db5b);
    var $eUqFw = parcelRequire("eUqFw");
    var $4DtuZ = parcelRequire("4DtuZ");
    var $8loyD = parcelRequire("8loyD");
    var $10fdS = parcelRequire("10fdS");
    var $h3mHU = parcelRequire("h3mHU");
    var $16kIm = parcelRequire("16kIm");
    var $8jPVO = parcelRequire("8jPVO");
    var $kQZhv = parcelRequire("kQZhv");
    const $49eb3c5692df3dbe$export$9499deca9933db5b = ()=>{
        const route = (0, $10fdS.useCurrentRoute)();
        const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
        const [hasHeritageDownloaded, setHasHeritageDownloaded] = (0, $eUqFw.useState)(false);
        (0, $kQZhv.useWrmStatsEffects)();
        const loadJiraHeritageDependencies = (0, $eUqFw.useCallback)(()=>{
            setHasHeritageDownloaded(true);
            (0, $16kIm.asyncWrmRequire)([
                ...(0, $8loyD.jiraSuperBatchDependencies),
                ...(0, $8jPVO.getJiraHeritageDependencies)()
            ]).then(()=>(0, $4DtuZ.waitForHeritage)()?.resolve?.());
        }, []);
        (0, $eUqFw.useEffect)(()=>{
            if (isReady && !hasHeritageDownloaded) loadJiraHeritageDependencies();
        }, [
            hasHeritageDownloaded,
            isReady,
            loadJiraHeritageDependencies,
            route
        ]);
        return null;
    };
    $49eb3c5692df3dbe$export$9499deca9933db5b.displayName = 'JiraHeritageLoader';
});
parcelRegister("16kIm", function(module, exports) {
    $parcel$export(module.exports, "asyncWrmRequire", ()=>$0ab2873dadb9f6da$export$1024fe099ca05f05);
    $parcel$export(module.exports, "asyncWrmRequireWithPrefetch", ()=>$0ab2873dadb9f6da$export$3ca0de203efa570e);
    var $beITa = parcelRequire("beITa");
    var $dPoeR = parcelRequire("dPoeR");
    const $0ab2873dadb9f6da$export$1024fe099ca05f05 = (resourcesToRequire)=>(0, $beITa.wrmRequire)(resourcesToRequire);
    const $0ab2873dadb9f6da$export$3ca0de203efa570e = (resourcesToRequire, batchUrl)=>(0, $dPoeR.wrmRequireWithPrefetch)(resourcesToRequire, batchUrl);
});
parcelRegister("8jPVO", function(module, exports) {
    $parcel$export(module.exports, "getJiraHeritageDependencies", ()=>$f6b7e29d2a8831d9$export$e8f6d7acd5817fa2);
    const $f6b7e29d2a8831d9$export$e8f6d7acd5817fa2 = ()=>[
            'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
            'wrc!jira.webresources:key-commands',
            'wrc!jira.webresources:header',
            'wrc!com.atlassian.administration.atlassian-admin-quicksearch-jira:admin-quicksearch-webresources',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
            'wrc!jira.webresources:global-static',
            'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
            'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
            'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources-init',
            'wrc!com.pyxis.greenhopper.jira:gh-create-board-adg3-no-condition',
            'wrc!com.atlassian.analytics.analytics-client:js-events',
            'wrc!com.atlassian.jira.jira-atlaskit-plugin:global-cache',
            'wrc!com.atlassian.crowd.user-provisioning-vertigo-plugin:impersonation-resources',
            'wrc!jira.webresources:spam-protection-flags',
            'wrc!com.atlassian.pas:pas-everypage-static',
            'wrc!com.atlassian.jira.jira-fileviewer-plugin:fileviewer',
            'wrc!com.atlassian.auiplugin:dialog2',
            'wrc!com.atlassian.jira.jira-fileviewer-plugin:atlassian-fileviewer',
            'wrc!com.atlassian.jira.jira-issue-nav-plugin:stylesheets'
        ];
});
parcelRegister("kQZhv", function(module, exports) {
    $parcel$export(module.exports, "useWrmStatsEffects", ()=>$daca76ea3608ba43$export$7ff53723d9d2886d);
    var $eUqFw = parcelRequire("eUqFw");
    var $h3mHU = parcelRequire("h3mHU");
    var $78d1w = parcelRequire("78d1w");
    const $daca76ea3608ba43$export$7ff53723d9d2886d = ()=>{
        const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
        const [{ transitionsCount: transitionsCount }] = (0, $78d1w.useSpaStateTransition)();
        (0, $eUqFw.useEffect)(()=>{
            if (isReady && window.__WRM_INTERNAL_STATS__ && !window.__WRM_INTERNAL_STATS__.isPageInteractive) window.__WRM_INTERNAL_STATS__.isPageInteractive = true;
        }, [
            isReady
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (transitionsCount > 0) window.__WRM_INTERNAL_STATS__ = {};
        }, [
            transitionsCount
        ]);
    };
});
parcelRegister("1OfKM", function(module, exports) {
    $parcel$export(module.exports, "BreadcrumbAdapter", ()=>$f4d7bdf212cdca0f$export$2255367d5c9162b3);
    var $eUqFw = parcelRequire("eUqFw");
    var $bAoTi = parcelRequire("bAoTi");
    const $f4d7bdf212cdca0f$export$2255367d5c9162b3 = ()=>{
        const baseUrl = '';
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $bAoTi.default), {
            baseUrl: baseUrl
        });
    };
});
parcelRegister("bAoTi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34d9050e380aaae9$export$2e2bcd8739ae039);
    var $knPb9 = parcelRequire("knPb9");
    var $3532a = parcelRequire("3532a");
    var $7H4Eg = parcelRequire("7H4Eg");
    var $8Of3p = parcelRequire("8Of3p");
    var $l02Yw = parcelRequire("l02Yw");
    var $jU94X = parcelRequire("jU94X");
    var $34d9050e380aaae9$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $3532a.default), {
        LegacyApiBridge: $7H4Eg.default,
        LegacyBreadcrumbConnector: $8Of3p.default,
        LegacyBreadcrumbState: $jU94X.default,
        LegacyBreadcrumbRenderer: $l02Yw.default
    });
});
parcelRegister("knPb9", function(module, exports) {
    $parcel$export(module.exports, "getDisplayName", ()=>$e1b771d5f606c17c$export$be63e0664592e141);
    $parcel$export(module.exports, "default", ()=>$e1b771d5f606c17c$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    const $e1b771d5f606c17c$export$be63e0664592e141 = (WrappedComponent)=>{
        if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
        if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
        return 'Component';
    };
    const $e1b771d5f606c17c$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
        const WithInjectedProps = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...injectedProps,
                ...props
            });
        WithInjectedProps.displayName = `withInjectedProps(${$e1b771d5f606c17c$export$be63e0664592e141(WrappedComponent)})`;
        return WithInjectedProps;
    };
    var $e1b771d5f606c17c$export$2e2bcd8739ae039 = $e1b771d5f606c17c$var$withInjectedProps;
});
parcelRegister("3532a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff6ade52479ed891$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $hFmdR = parcelRequire("hFmdR");
    var $5GxEP = parcelRequire("5GxEP");
    const $ff6ade52479ed891$var$LegacyBreadcrumbAdapter = ({ LegacyBreadcrumbRenderer: LegacyBreadcrumbRenderer, LegacyBreadcrumbState: LegacyBreadcrumbState, LegacyApiBridge: LegacyApiBridge, LegacyBreadcrumbConnector: LegacyBreadcrumbConnector })=>(0, ($parcel$interopDefault($eUqFw))).createElement(LegacyBreadcrumbState, null, ({ api: api, state: state })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement(LegacyApiBridge, {
                onInsertItem: api.insertItem,
                onRemoveItem: api.removeItem,
                onSetRenderTarget: api.setTargetElement
            }), state.targetElement && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
                id: "legacy-breadcrumb-adapter"
            }, (0, ($parcel$interopDefault($eUqFw))).createElement(LegacyBreadcrumbConnector, {
                legacyTrail: state.trail
            }), (0, ($parcel$interopDefault($eUqFw))).createElement(LegacyBreadcrumbRenderer, {
                targetElement: state.targetElement
            }))));
    var $ff6ade52479ed891$export$2e2bcd8739ae039 = (0, $hFmdR.AnalyticsSource)('legacyBreadcrumbs', (0, $41ea3621645e2acc$export$f636b5b56f1d624a))($ff6ade52479ed891$var$LegacyBreadcrumbAdapter);
});
parcelRegister("hFmdR", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsSource", ()=>$3d95c57ea565c569$export$6890652a1aff7d1c);
    $parcel$export(module.exports, "AnalyticsSubject", ()=>$3d95c57ea565c569$export$ec9f54bd4341ceb);
    var $eyoVQ = parcelRequire("eyoVQ");
    const $3d95c57ea565c569$export$6890652a1aff7d1c = (name, type)=>(WrappedComponent)=>(0, $eyoVQ.default)({
                source: `${name}${type}`
            })(WrappedComponent);
    const $3d95c57ea565c569$export$ec9f54bd4341ceb = (name, attributes)=>(WrappedComponent)=>(0, $eyoVQ.default)({
                actionSubject: name,
                attributes: attributes
            })(WrappedComponent);
});
parcelRegister("7H4Eg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$078bdb0aa485f642$export$2e2bcd8739ae039);
    var $2Enn0 = parcelRequire("2Enn0");
    var $knPb9 = parcelRequire("knPb9");
    var $jmX5T = parcelRequire("jmX5T");
    const $078bdb0aa485f642$var$analyticsEvents = {
        onInsertItemFired: (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'insertItem'
                }
            }),
        onRemoveItemFired: (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'removeItem'
                }
            }),
        onSetRenderTargetFired: (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'render'
                }
            }),
        onOnBreadCrumbsUpdateFired: (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
                attributes: {
                    method: 'onBreadCrumbsUpdate'
                }
            })
    };
    var $078bdb0aa485f642$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $jmX5T.default), $078bdb0aa485f642$var$analyticsEvents);
});
parcelRegister("2Enn0", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalAnalytics", ()=>$3ee3ca60c3a36803$export$79f423cc3fd39762);
    var $3LiTJ = parcelRequire("3LiTJ");
    var $guiFP = parcelRequire("guiFP");
    var $etqm0 = parcelRequire("etqm0");
    var $klunD = parcelRequire("klunD");
    const $3ee3ca60c3a36803$var$isNotUndefined = (a)=>a !== undefined;
    const $3ee3ca60c3a36803$var$mapPayload = (payload)=>{
        const context = (0, $klunD.default)(payload);
        const { name: name } = payload;
        return (0, ($parcel$interopDefault($3LiTJ)))({
            ...context,
            ...context.attributes,
            attributes: undefined,
            name: name
        }, $3ee3ca60c3a36803$var$isNotUndefined);
    };
    const $3ee3ca60c3a36803$export$79f423cc3fd39762 = (event, payload)=>{
        try {
            event.update({
                ...$3ee3ca60c3a36803$var$mapPayload(payload),
                analyticsType: (0, $etqm0.OPERATIONAL_EVENT_TYPE)
            }).fire();
        } catch (e) {
            (0, $guiFP.default)({
                event: event,
                error: e,
                meta: {
                    id: 'fireOperationalAnalytics',
                    packageName: 'jiraAnalyticsWebReact',
                    teamName: 'legacy-jfp-team-do-not-use'
                }
            });
        }
    };
});
parcelRegister("klunD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0af4980e66497eeb$export$2e2bcd8739ae039);
    var $kkgbD = parcelRequire("kkgbD");
    var $i7Fym = parcelRequire("i7Fym");
    var $0af4980e66497eeb$export$2e2bcd8739ae039 = (payload)=>{
        const { tags: tags, containerId: containerId, containers: containers, containerType: containerType, objectId: objectId, objectType: objectType, attributes: attributes } = payload;
        return (0, ($parcel$interopDefault($i7Fym)))({
            tags: tags,
            containerId: containerId,
            containers: containers,
            containerType: containerType,
            objectId: objectId,
            objectType: objectType,
            attributes: attributes
        }, (0, ($parcel$interopDefault($kkgbD))));
    };
});
parcelRegister("jmX5T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c37f23517b903b52$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $3JafE = parcelRequire("3JafE");
    parcelRequire("8jBvP");
    var $eGI9v = parcelRequire("eGI9v");
    var $bDtAc = parcelRequire("bDtAc");
    class $c37f23517b903b52$var$LegacyApiBridge extends (0, $eUqFw.Component) {
        componentDidMount() {
            const { onInsertItem: onInsertItem, onRemoveItem: onRemoveItem, onSetRenderTarget: onSetRenderTarget, onBreadCrumbsUpdate: onBreadCrumbsUpdate } = this;
            (0, $bDtAc.default)({
                insertItem: onInsertItem,
                removeItem: onRemoveItem,
                render: onSetRenderTarget,
                onBreadCrumbsUpdate: onBreadCrumbsUpdate
            });
        }
        render() {
            return null;
        }
        constructor(...args){
            super(...args);
            this.onInsertItem = (item)=>{
                const { onInsertItem: onInsertItem, onInsertItemFired: onInsertItemFired } = this.props;
                onInsertItemFired();
                onInsertItem(item);
            };
            this.onRemoveItem = (itemId)=>{
                const { onRemoveItem: onRemoveItem, onRemoveItemFired: onRemoveItemFired } = this.props;
                onRemoveItemFired();
                onRemoveItem(itemId);
            };
            this.onSetRenderTarget = (element)=>{
                const { onSetRenderTarget: onSetRenderTarget, onSetRenderTargetFired: onSetRenderTargetFired } = this.props;
                onSetRenderTargetFired();
                onSetRenderTarget(element);
            };
            this.onBreadCrumbsUpdate = ()=>{
                const { onOnBreadCrumbsUpdateFired: onOnBreadCrumbsUpdateFired } = this.props;
                onOnBreadCrumbsUpdateFired();
                return (0, $3JafE.Observable).empty();
            };
        }
    }
    var $c37f23517b903b52$export$2e2bcd8739ae039 = (0, $eGI9v.default)('legacyApiBridge', {
        onInsertItemFired: 'apiMethodCalled',
        onRemoveItemFired: 'apiMethodCalled',
        onSetRenderTargetFired: 'apiMethodCalled',
        onOnBreadCrumbsUpdateFired: 'apiMethodCalled'
    })($c37f23517b903b52$var$LegacyApiBridge);
});
parcelRegister("eGI9v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9208d82098460921$export$2e2bcd8739ae039);
    var $eyoVQ = parcelRequire("eyoVQ");
    var $iQC4h = parcelRequire("iQC4h");
    const $9208d82098460921$export$871de8747c9eaa88 = (props)=>Object.keys(props).reduce((result, key)=>({
                ...result,
                [key]: {
                    action: props[key]
                }
            }), {});
    function $9208d82098460921$var$componentWithAnalytics(componentName, eventActions) {
        return function(WrappedComponent) {
            return (0, $eyoVQ.default)({
                componentName: componentName
            })((0, $iQC4h.default)($9208d82098460921$export$871de8747c9eaa88(eventActions))(WrappedComponent));
        };
    }
    var $9208d82098460921$export$2e2bcd8739ae039 = $9208d82098460921$var$componentWithAnalytics;
});
parcelRegister("bDtAc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$801e164601d3872a$export$2e2bcd8739ae039);
    var $ds5Im = parcelRequire("ds5Im");
    var $gUUjF = parcelRequire("gUUjF");
    var $801e164601d3872a$export$2e2bcd8739ae039 = (legacyAPI)=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/globalnavigator/breadcrumbs/bridge'
        }).then((bridge)=>{
            bridge(legacyAPI);
        }).catch((err)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('breadcrumbs.v2.bridge', err.toString()));
});
parcelRegister("8Of3p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5de6401c7e8172f3$export$2e2bcd8739ae039);
    var $knPb9 = parcelRequire("knPb9");
    var $aTgXo = parcelRequire("aTgXo");
    var $hCPt9 = parcelRequire("hCPt9");
    var $dpXKE = parcelRequire("dpXKE");
    var $5c2C3 = parcelRequire("5c2C3");
    var $1bzuc = parcelRequire("1bzuc");
    var $i7f3H = parcelRequire("i7f3H");
    var $5de6401c7e8172f3$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $1bzuc.default), {
        Breadcrumb: $aTgXo.default,
        ProjectBreadcrumb: $dpXKE.default,
        BoardBreadcrumb: $hCPt9.default,
        UserBreadcrumb: $5c2C3.default,
        ContextProvider: $i7f3H.default
    });
});
parcelRegister("aTgXo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dd5d72148724b95b$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $hTLlD = parcelRequire("hTLlD");
    var $hompL = parcelRequire("hompL");
    var $bfY8R = parcelRequire("bfY8R");
    class $dd5d72148724b95b$var$BreadcrumbOps extends (0, $eUqFw.Component) {
        constructor(props){
            super(props);
            this.id = '';
            this.id = (0, ($parcel$interopDefault($hompL))).v4();
            if (false) this.onPushBreadcrumb();
        }
        componentDidMount() {
            this.onPushBreadcrumb();
        }
        componentDidUpdate(prevProps) {
            const { breadcrumb: prevBreadcrumb } = prevProps;
            const { api: api, breadcrumb: breadcrumb } = this.props;
            if (!(0, ($parcel$interopDefault($hTLlD)))(prevBreadcrumb, breadcrumb)) api.updateBreadcrumb({
                id: this.id,
                ...breadcrumb
            });
        }
        componentWillUnmount() {
            const { api: api } = this.props;
            api.popBreadcrumb();
        }
        onPushBreadcrumb() {
            const { api: api, breadcrumb: breadcrumb } = this.props;
            api.pushBreadcrumb({
                id: this.id,
                ...breadcrumb
            });
        }
        render() {
            return null;
        }
    }
    const $dd5d72148724b95b$var$Breadcrumb = ({ breadcrumb: breadcrumb, children: children })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $bfY8R.BreadcrumbActions), null, (__, actions)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement($dd5d72148724b95b$var$BreadcrumbOps, {
                api: actions,
                breadcrumb: breadcrumb
            }), children));
    $dd5d72148724b95b$var$Breadcrumb.defaultProps = {
        children: null
    };
    var $dd5d72148724b95b$export$2e2bcd8739ae039 = $dd5d72148724b95b$var$Breadcrumb;
});
parcelRegister("bfY8R", function(module, exports) {
    $parcel$export(module.exports, "useBreadcrumbs", ()=>$3e01453c51fda3d9$export$8cefe241bd876ca0);
    $parcel$export(module.exports, "BreadcrumbActions", ()=>$3e01453c51fda3d9$export$9862c338ec0a6884);
    $parcel$export(module.exports, "BreadcrumbContainer", ()=>$3e01453c51fda3d9$export$c7432936d9c50db7);
    var $WBLbN = parcelRequire("WBLbN");
    const $3e01453c51fda3d9$var$initialState = {
        trail: []
    };
    const $3e01453c51fda3d9$export$e324594224ef24da = {
        pushBreadcrumb: (breadcrumb)=>({ setState: setState, getState: getState })=>{
                setState({
                    trail: [
                        ...getState().trail,
                        breadcrumb
                    ]
                });
            },
        popBreadcrumb: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    trail: getState().trail.slice(0, -1)
                });
            },
        updateBreadcrumb: (breadcrumb)=>({ setState: setState, getState: getState })=>{
                const newTrail = getState().trail.map((item)=>item.id === breadcrumb.id ? breadcrumb : item);
                setState({
                    trail: newTrail
                });
            }
    };
    const $3e01453c51fda3d9$var$Store = (0, $WBLbN.createStore)({
        initialState: $3e01453c51fda3d9$var$initialState,
        actions: $3e01453c51fda3d9$export$e324594224ef24da,
        name: 'BreadcrumbSweetState'
    });
    const $3e01453c51fda3d9$var$_BreadcrumbSubscriber = (0, $WBLbN.createSubscriber)($3e01453c51fda3d9$var$Store);
    const $3e01453c51fda3d9$export$8cefe241bd876ca0 = (0, $WBLbN.createHook)($3e01453c51fda3d9$var$Store);
    const $3e01453c51fda3d9$export$9862c338ec0a6884 = (0, $WBLbN.createSubscriber)($3e01453c51fda3d9$var$Store, {
        selector: null
    });
    const $3e01453c51fda3d9$export$c7432936d9c50db7 = (0, $WBLbN.createContainer)($3e01453c51fda3d9$var$Store);
});
parcelRegister("hCPt9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$75a50236b83a41ea$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $aTgXo = parcelRequire("aTgXo");
    var $5IARc = parcelRequire("5IARc");
    const $75a50236b83a41ea$var$BoardBreadcrumb = ({ children: children, boardId: boardId, boardName: boardName, isSimplifiedProject: isSimplifiedProject, projectId: projectId })=>{
        const breadcrumb = {
            href: (0, $5IARc.createBoardUrl)(boardId),
            text: boardName,
            type: 'boardName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToSubProject',
                containerId: projectId,
                containerType: 'project'
            }
        };
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
            breadcrumb: breadcrumb
        }, children);
    };
    $75a50236b83a41ea$var$BoardBreadcrumb.defaultProps = {
        children: null,
        isSimplifiedProject: false,
        projectId: undefined
    };
    var $75a50236b83a41ea$export$2e2bcd8739ae039 = $75a50236b83a41ea$var$BoardBreadcrumb;
});
parcelRegister("5IARc", function(module, exports) {
    $parcel$export(module.exports, "createProjectUrl", ()=>$f5b81aae15d86847$export$1bdb1f038c5a2a90);
    $parcel$export(module.exports, "createProjectSettingsUrl", ()=>$f5b81aae15d86847$export$c435fcb42a65af32);
    $parcel$export(module.exports, "createBoardUrl", ()=>$f5b81aae15d86847$export$7037e05c8c7af6dc);
    var $cqJw8 = parcelRequire("cqJw8");
    const $f5b81aae15d86847$export$1bdb1f038c5a2a90 = (projectKey)=>`/browse/${encodeURIComponent(projectKey)}`;
    const $f5b81aae15d86847$export$c435fcb42a65af32 = (projectKey, projectType, isSimplified)=>{
        if (isSimplified) return (0, $cqJw8.getNextgenSettingsUrl)(projectType, projectKey);
        return `/projects/${projectKey}/settings`;
    };
    const $f5b81aae15d86847$export$7037e05c8c7af6dc = (boardId)=>`/secure/RapidBoard.jspa?rapidView=${boardId}`;
});
parcelRegister("cqJw8", function(module, exports) {
    $parcel$export(module.exports, "getNextgenSettingsUrl", ()=>$8bf9744795c994e7$export$26432406821aa7bf);
    $parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", ()=>$8bf9744795c994e7$export$defee92e506aa306);
    $parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", ()=>$8bf9744795c994e7$export$9133e09a98a043dc);
    $parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", ()=>$8bf9744795c994e7$export$b0d20d18e0230e83);
    $parcel$export(module.exports, "getClassicJSWSettingsUrl", ()=>$8bf9744795c994e7$export$ff0a17aa36a000df);
    $parcel$export(module.exports, "getProjectSettingsDetailsUrl", ()=>$8bf9744795c994e7$export$16d52b9357bb73ab);
    $parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", ()=>$8bf9744795c994e7$export$d531a9788343348f);
    $parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", ()=>$8bf9744795c994e7$export$dad567762dae162e);
    $parcel$export(module.exports, "getJcsRequestTypeLayoutSettingsUrl", ()=>$8bf9744795c994e7$export$8b304050f4836b59);
    var $7ZZxN = parcelRequire("7ZZxN");
    var $6bYiA = parcelRequire("6bYiA");
    var $6ZTsa = parcelRequire("6ZTsa");
    var $avawr = parcelRequire("avawr");
    const $8bf9744795c994e7$export$26432406821aa7bf = (projectType, projectKey)=>{
        const products = {
            [(0, $7ZZxN.CORE_PROJECT)]: 'core',
            [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: 'servicedesk',
            [(0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)]: 'customerservice',
            [(0, $7ZZxN.SOFTWARE_PROJECT)]: 'software',
            [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
        };
        const product = products[projectType];
        if (!product) {
            (0, $avawr.logError)((0, $6bYiA.PACKAGE_NAME), (0, $6ZTsa.toErrorId)('urls'), (0, $6ZTsa.toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
            return `/projects/${projectKey}/settings`;
        }
        if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
        return `/jira/${product}/projects/${projectKey}/settings`;
    };
    const $8bf9744795c994e7$var$serializeBackLink = (backLink)=>{
        if (backLink == null) return '';
        const { url: url, title: title } = backLink;
        return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
    };
    const $8bf9744795c994e7$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
        if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}`;
        return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;
    };
    const $8bf9744795c994e7$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
        if (projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
        return `${$8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
    };
    const $8bf9744795c994e7$export$b0d20d18e0230e83 = (projectKey)=>`${$8bf9744795c994e7$export$26432406821aa7bf((0, $7ZZxN.SERVICE_DESK_PROJECT), projectKey)}/automation`;
    const $8bf9744795c994e7$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
    const $8bf9744795c994e7$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
        const urlBase = projectType === (0, $7ZZxN.SOFTWARE_PROJECT) && !isSimplified ? $8bf9744795c994e7$export$ff0a17aa36a000df(projectKey) : $8bf9744795c994e7$export$26432406821aa7bf(projectType, projectKey);
        return `${urlBase}/details`;
    };
    const $8bf9744795c994e7$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;
    const $8bf9744795c994e7$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;
    const $8bf9744795c994e7$export$8b304050f4836b59 = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/helpcenter/projects/${projectKey}/settings/request-types/unassigned/request-type/${requestTypeId}${$8bf9744795c994e7$var$serializeBackLink(backLink)}`;
});
parcelRegister("6bYiA", function(module, exports) {
    $parcel$export(module.exports, "TASK", ()=>$b6aeae99b4bfc5a4$export$9355e489ad16f98e);
    $parcel$export(module.exports, "BUG", ()=>$b6aeae99b4bfc5a4$export$bcf558c186108044);
    $parcel$export(module.exports, "STORY", ()=>$b6aeae99b4bfc5a4$export$1ea39a3ae330045);
    $parcel$export(module.exports, "EPIC", ()=>$b6aeae99b4bfc5a4$export$3cb4a99a332e4186);
    $parcel$export(module.exports, "SUB_TASK", ()=>$b6aeae99b4bfc5a4$export$a06f889861f6537d);
    $parcel$export(module.exports, "CUSTOM", ()=>$b6aeae99b4bfc5a4$export$952581bc40160893);
    $parcel$export(module.exports, "TEMPLATES_WHITELIST", ()=>$b6aeae99b4bfc5a4$export$dff1da4a9bab6d3e);
    $parcel$export(module.exports, "TEXT_AREA_CF_TYPE", ()=>$b6aeae99b4bfc5a4$export$39cd48613b53ce2f);
    $parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$56eae1056efd4899);
    $parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$ca61f05d869b2ea3);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", ()=>$b6aeae99b4bfc5a4$export$2ec42920a0df6b9a);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", ()=>$b6aeae99b4bfc5a4$export$40c10ba35ceb5c6b);
    $parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", ()=>$b6aeae99b4bfc5a4$export$a11dccbf88784c62);
    $parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", ()=>$b6aeae99b4bfc5a4$export$f35dc2e6deb1692e);
    $parcel$export(module.exports, "JIRA_APP_NAME", ()=>$b6aeae99b4bfc5a4$export$ec5d0e43836cb3c7);
    $parcel$export(module.exports, "toPackageName", ()=>$b6aeae99b4bfc5a4$export$f31a652635bd75fe);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$b6aeae99b4bfc5a4$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", ()=>$b6aeae99b4bfc5a4$export$a2231d79966e0ccc);
    $parcel$export(module.exports, "RADIO_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$28a4bdf7d9b6f9);
    $parcel$export(module.exports, "USERPICKER_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$9d758b3e8c6e0ed1);
    $parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$b0e37d421e006913);
    $parcel$export(module.exports, "SELECT_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$d77765147749db6b);
    $parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$42ef68d6bd555a8d);
    $parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$4db6eb15b3c529cf);
    $parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$ee975373b7797e8a);
    $parcel$export(module.exports, "TEXT_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$aa99342cc6a8ced5);
    $parcel$export(module.exports, "NUMBER_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$6f327bf99e20320);
    $parcel$export(module.exports, "DATETIME_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$dc64bdfdf9660a05);
    $parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$e6d73ed745b9a04);
    $parcel$export(module.exports, "DATE_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$d8b50f59220c7580);
    $parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$3a6f0a44478f1d2);
    $parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$68b76ef93df5a880);
    $parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$e7773fccbeec45e6);
    $parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$b45487b145c52a37);
    $parcel$export(module.exports, "VERSION_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$48548129a6d117f5);
    $parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$722c271a9e11cb94);
    $parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", ()=>$b6aeae99b4bfc5a4$export$33dbe2a903610aa1);
    $parcel$export(module.exports, "emptyTenantContext", ()=>$b6aeae99b4bfc5a4$export$ac655f5b3ff7b929);
    var $ao0hp = parcelRequire("ao0hp");
    var $lO4Or = parcelRequire("lO4Or");
    var $6WXNs = parcelRequire("6WXNs");
    var $6vrw7 = parcelRequire("6vrw7");
    var $7HKaW = parcelRequire("7HKaW");
    var $38OPi = parcelRequire("38OPi");
    const $b6aeae99b4bfc5a4$export$9355e489ad16f98e = 'task';
    const $b6aeae99b4bfc5a4$export$bcf558c186108044 = 'bug';
    const $b6aeae99b4bfc5a4$export$1ea39a3ae330045 = 'story';
    const $b6aeae99b4bfc5a4$export$3cb4a99a332e4186 = 'epic';
    const $b6aeae99b4bfc5a4$export$a06f889861f6537d = 'subtask';
    const $b6aeae99b4bfc5a4$export$952581bc40160893 = 'custom';
    const $b6aeae99b4bfc5a4$export$dff1da4a9bab6d3e = [
        $b6aeae99b4bfc5a4$export$9355e489ad16f98e,
        $b6aeae99b4bfc5a4$export$bcf558c186108044,
        $b6aeae99b4bfc5a4$export$1ea39a3ae330045,
        $b6aeae99b4bfc5a4$export$3cb4a99a332e4186
    ];
    const $b6aeae99b4bfc5a4$export$39cd48613b53ce2f = (0, $lO4Or.TEXT_AREA_CF_TYPE);
    const $b6aeae99b4bfc5a4$export$56eae1056efd4899 = (0, $lO4Or.DESCRIPTION_TYPE);
    const $b6aeae99b4bfc5a4$export$ca61f05d869b2ea3 = (0, $lO4Or.ENVIRONMENT_TYPE);
    const $b6aeae99b4bfc5a4$export$2ec42920a0df6b9a = 'Story point estimate';
    const $b6aeae99b4bfc5a4$export$40c10ba35ceb5c6b = 'storyPointEstimate';
    const $b6aeae99b4bfc5a4$export$a4d3702d4c7481d6 = 44;
    const $b6aeae99b4bfc5a4$export$8a6a961f6caf7a8b = [
        $b6aeae99b4bfc5a4$export$56eae1056efd4899,
        $b6aeae99b4bfc5a4$export$39cd48613b53ce2f,
        $b6aeae99b4bfc5a4$export$ca61f05d869b2ea3
    ];
    const $b6aeae99b4bfc5a4$export$e27914436cc13e3c = 'Jira Software';
    const $b6aeae99b4bfc5a4$export$a11dccbf88784c62 = 'Jira Service Management';
    const $b6aeae99b4bfc5a4$export$9f4aa232cbb6be46 = 'Jira Work Management';
    const $b6aeae99b4bfc5a4$export$b3c4739240716eb6 = 'Jira Ops';
    const $b6aeae99b4bfc5a4$export$f35dc2e6deb1692e = 'Jira Product Discovery';
    const $b6aeae99b4bfc5a4$export$ec5d0e43836cb3c7 = 'Jira';
    const $b6aeae99b4bfc5a4$export$f31a652635bd75fe = (packageName)=>packageName;
    const $b6aeae99b4bfc5a4$export$b8b9d90f9e5bd72b = $b6aeae99b4bfc5a4$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
    const $b6aeae99b4bfc5a4$export$a2231d79966e0ccc = 'NEW_';
    const $b6aeae99b4bfc5a4$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
    const $b6aeae99b4bfc5a4$export$28a4bdf7d9b6f9 = 'radio';
    const $b6aeae99b4bfc5a4$export$9d758b3e8c6e0ed1 = 'userpicker';
    const $b6aeae99b4bfc5a4$export$b0e37d421e006913 = 'multiuserpicker';
    const $b6aeae99b4bfc5a4$export$d77765147749db6b = 'select';
    const $b6aeae99b4bfc5a4$export$42ef68d6bd555a8d = 'cascadingselect';
    const $b6aeae99b4bfc5a4$export$4db6eb15b3c529cf = 'multiselect';
    const $b6aeae99b4bfc5a4$export$ee975373b7797e8a = 'checkbox';
    const $b6aeae99b4bfc5a4$export$aa99342cc6a8ced5 = 'text';
    const $b6aeae99b4bfc5a4$export$6f327bf99e20320 = 'number';
    const $b6aeae99b4bfc5a4$export$dc64bdfdf9660a05 = 'datetime';
    const $b6aeae99b4bfc5a4$export$e6d73ed745b9a04 = 'projectpicker';
    const $b6aeae99b4bfc5a4$export$d8b50f59220c7580 = 'date';
    const $b6aeae99b4bfc5a4$export$3a6f0a44478f1d2 = 'assetspicker';
    const $b6aeae99b4bfc5a4$export$68b76ef93df5a880 = 'labelpicker';
    const $b6aeae99b4bfc5a4$export$e7773fccbeec45e6 = 'grouppicker';
    const $b6aeae99b4bfc5a4$export$b45487b145c52a37 = 'multigrouppicker';
    const $b6aeae99b4bfc5a4$export$48548129a6d117f5 = 'version';
    const $b6aeae99b4bfc5a4$export$722c271a9e11cb94 = 'multiversion';
    const $b6aeae99b4bfc5a4$export$33dbe2a903610aa1 = 'textarea';
    const $b6aeae99b4bfc5a4$export$ac655f5b3ff7b929 = ()=>({
            appEditions: (0, $6WXNs.populateApplicationEditions)(),
            appPermissions: (0, $38OPi.populateApplicationPermissions)(),
            applicationKey: null,
            areProductSuggestionsEnabled: false,
            appUpdatesAvailable: null,
            atlassianAccountId: null,
            baseUrl: (0, $6vrw7.toBaseUrl)(''),
            cloudId: (0, $6vrw7.toCloudId)(''),
            activationId: (0, $6vrw7.toActivationId)(''),
            cloudName: (0, $6vrw7.toCloudName)(''),
            devopsProjectSignupSource: (0, $6vrw7.toDevopsProjectSignupSource)(''),
            environment: null,
            fabricActivityUrl: null,
            fabricNotificationLogUrl: null,
            fabricPfDirUrl: null,
            firstActivationDateMs: null,
            isAdmin: false,
            isAnonymous: false,
            isDevMode: false,
            isDevopsProjectCreationScenario: false,
            isMarketingOptOut: false,
            isSiteAdmin: false,
            languageTag: null,
            licenseStates: (0, $7HKaW.populateApplicationLicenseStates)(),
            licensedProducts: {},
            locale: (0, $ao0hp.defaultLocale),
            loggedInUser: null,
            productCrossSellConfig: 'unknown',
            productEntitlementDetails: null,
            productPermissionGated: {
                core: false,
                software: false,
                serviceDesk: false,
                productDiscovery: false
            },
            siteAdminStatus: 'unknown',
            userFullname: null,
            xsrfToken: null,
            hasDlpEnabled: false,
            avpWorkspaceId: null
        });
});
parcelRegister("lO4Or", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_LINK_SEARCH", ()=>$4eac1b8021be0c88$export$b144116dae474c88);
    $parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", ()=>$4eac1b8021be0c88$export$bc917bc699b25f75);
    $parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", ()=>$4eac1b8021be0c88$export$5f26ca419fdffbe7);
    $parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", ()=>$4eac1b8021be0c88$export$ce9bfd823c7e1a6d);
    $parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", ()=>$4eac1b8021be0c88$export$346b72b1f7cd6d5a);
    $parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", ()=>$4eac1b8021be0c88$export$b20fbcacd7942c2a);
    $parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", ()=>$4eac1b8021be0c88$export$a2e8554bffc61ece);
    $parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", ()=>$4eac1b8021be0c88$export$f25cd4907cbb25b9);
    $parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", ()=>$4eac1b8021be0c88$export$5600354b43577e17);
    $parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", ()=>$4eac1b8021be0c88$export$5dbc9917f72d0d2a);
    $parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", ()=>$4eac1b8021be0c88$export$253649f07fb55948);
    $parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", ()=>$4eac1b8021be0c88$export$eb39592ba5247ee7);
    $parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", ()=>$4eac1b8021be0c88$export$f48a9be226105736);
    $parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", ()=>$4eac1b8021be0c88$export$42e2e93fc721df5d);
    $parcel$export(module.exports, "APPROVALS_PANEL_TYPE", ()=>$4eac1b8021be0c88$export$7773375e72c953ed);
    $parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", ()=>$4eac1b8021be0c88$export$80ad0037098f3919);
    $parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", ()=>$4eac1b8021be0c88$export$6875c7efa3a5e380);
    $parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", ()=>$4eac1b8021be0c88$export$7c1a5c7d37b8f968);
    $parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", ()=>$4eac1b8021be0c88$export$c5931a5d7dbfb40b);
    $parcel$export(module.exports, "BOOLEAN_GQL_FIELD", ()=>$4eac1b8021be0c88$export$c979d9c548c05133);
    $parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$ff25e7412c4ae9c7);
    $parcel$export(module.exports, "CHECKBOX_GQL_FIELD", ()=>$4eac1b8021be0c88$export$16dbdf57e34e8d63);
    $parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$1bf8bec92e6e84df);
    $parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$c32f5d822fe5ea95);
    $parcel$export(module.exports, "CMDB_GQL_FIELD", ()=>$4eac1b8021be0c88$export$b0deb225eed90fbd);
    $parcel$export(module.exports, "COLOR_GQL_FIELD", ()=>$4eac1b8021be0c88$export$add3775cfea8fde3);
    $parcel$export(module.exports, "COMPONENTS_GQL_FIELD", ()=>$4eac1b8021be0c88$export$9631d4098abab3eb);
    $parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", ()=>$4eac1b8021be0c88$export$ee42bc16c09ee564);
    $parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", ()=>$4eac1b8021be0c88$export$fbcebbdce821f712);
    $parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$41dd2eb1f33d3042);
    $parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$f4e3e72a3be84e5b);
    $parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$d6738c8a6d1a735d);
    $parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$79a75502a3f0c4c4);
    $parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", ()=>$4eac1b8021be0c88$export$ed2eabcf0931df31);
    $parcel$export(module.exports, "DATE_TIME_GQL_FIELD", ()=>$4eac1b8021be0c88$export$1f17904e959f2f0b);
    $parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", ()=>$4eac1b8021be0c88$export$6d8da4497234455);
    $parcel$export(module.exports, "FLAG_GQL_FIELD", ()=>$4eac1b8021be0c88$export$9bcfac568e4fa59c);
    $parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", ()=>$4eac1b8021be0c88$export$dd84cd6c957c6f5e);
    $parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", ()=>$4eac1b8021be0c88$export$5cc7c39d7d1cf6d5);
    $parcel$export(module.exports, "LABEL_GQL_FIELD", ()=>$4eac1b8021be0c88$export$810709f0c5c2e9db);
    $parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$82cb6735134c23a2);
    $parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", ()=>$4eac1b8021be0c88$export$85e04e9a3a81ee1);
    $parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", ()=>$4eac1b8021be0c88$export$24c916a8a33ed20c);
    $parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", ()=>$4eac1b8021be0c88$export$c049920d930c3b8a);
    $parcel$export(module.exports, "NUMBER_GQL_FIELD", ()=>$4eac1b8021be0c88$export$3b6d7fc1833bf7da);
    $parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", ()=>$4eac1b8021be0c88$export$bd3e2fe853319c13);
    $parcel$export(module.exports, "PARENT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$6dfd3fc78bc751a0);
    $parcel$export(module.exports, "PEOPLE_GQL_FIELD", ()=>$4eac1b8021be0c88$export$31aea7548807c6b5);
    $parcel$export(module.exports, "PRIORITY_GQL_FIELD", ()=>$4eac1b8021be0c88$export$e89fbbf3983c0219);
    $parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", ()=>$4eac1b8021be0c88$export$f5e2fb1022ff7912);
    $parcel$export(module.exports, "PROJECT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$12f54499c6252188);
    $parcel$export(module.exports, "RADIO_GQL_FIELD", ()=>$4eac1b8021be0c88$export$8e4293d806f435e0);
    $parcel$export(module.exports, "REPORTER_GQL_FIELD", ()=>$4eac1b8021be0c88$export$c69486dd643dfb69);
    $parcel$export(module.exports, "RESOLUTION_GQL_FIELD", ()=>$4eac1b8021be0c88$export$1e4faa0d6dc58a81);
    $parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$37f4daaa7b409554);
    $parcel$export(module.exports, "SECURITY_GQL_FIELD", ()=>$4eac1b8021be0c88$export$ca57cccd6d7bf97c);
    $parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", ()=>$4eac1b8021be0c88$export$bea889616fd5bdab);
    $parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$ab5cecc580898d1c);
    $parcel$export(module.exports, "SPRINT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$bb63813d13e8eaf7);
    $parcel$export(module.exports, "STATUS_GQL_FIELD", ()=>$4eac1b8021be0c88$export$e40f819979b3881d);
    $parcel$export(module.exports, "TEAM_GQL_FIELD", ()=>$4eac1b8021be0c88$export$6c243704a22baffe);
    $parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", ()=>$4eac1b8021be0c88$export$6c32429bac235203);
    $parcel$export(module.exports, "TEXT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$61b514b470cbbf07);
    $parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", ()=>$4eac1b8021be0c88$export$e4bcb1729da5683);
    $parcel$export(module.exports, "URL_GQL_FIELD", ()=>$4eac1b8021be0c88$export$37ccd11f08a93ccb);
    $parcel$export(module.exports, "USER_PICKER_GQL_FIELD", ()=>$4eac1b8021be0c88$export$abf1bf8c1106ba7d);
    $parcel$export(module.exports, "VERSION_GQL_FIELD", ()=>$4eac1b8021be0c88$export$b55604041ae7179e);
    $parcel$export(module.exports, "VOTES_GQL_FIELD", ()=>$4eac1b8021be0c88$export$c8bf66d62e74cdd2);
    $parcel$export(module.exports, "WATCHES_GQL_FIELD", ()=>$4eac1b8021be0c88$export$aa815aaa741ae18);
    $parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", ()=>$4eac1b8021be0c88$export$e805f89b15d2abf4);
    $parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", ()=>$4eac1b8021be0c88$export$5bfd36acd96f04c2);
    $parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", ()=>$4eac1b8021be0c88$export$695423a2bc8a9ac4);
    $parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", ()=>$4eac1b8021be0c88$export$d29b0ba0d80bc129);
    $parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", ()=>$4eac1b8021be0c88$export$ac6c7b30703608d6);
    $parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", ()=>$4eac1b8021be0c88$export$478b546dccd33e1e);
    $parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", ()=>$4eac1b8021be0c88$export$f90c042e9eb983e7);
    $parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", ()=>$4eac1b8021be0c88$export$753ca4fb34ff3f2b);
    $parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$b7aed9efb4a9154b);
    $parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", ()=>$4eac1b8021be0c88$export$1763713d718f7ef0);
    $parcel$export(module.exports, "FORGE_USER_GQL_FIELD", ()=>$4eac1b8021be0c88$export$ebb0caa2a98dcf9e);
    $parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", ()=>$4eac1b8021be0c88$export$671131ba12d94144);
    $parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", ()=>$4eac1b8021be0c88$export$c48132adab502d6b);
    $parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", ()=>$4eac1b8021be0c88$export$6cd83226f31c7072);
    $parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", ()=>$4eac1b8021be0c88$export$7de726bd6d97a9a7);
    $parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", ()=>$4eac1b8021be0c88$export$8e4b538f77340a05);
    $parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", ()=>$4eac1b8021be0c88$export$10ba8c0d74470907);
    $parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", ()=>$4eac1b8021be0c88$export$1756bb4eff1cc3c6);
    $parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", ()=>$4eac1b8021be0c88$export$5876b4be3c4407b);
    $parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", ()=>$4eac1b8021be0c88$export$e7fe49e6f36c7154);
    $parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", ()=>$4eac1b8021be0c88$export$aeed3395a6bca18b);
    $parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", ()=>$4eac1b8021be0c88$export$9b725a1eafd02e4f);
    $parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", ()=>$4eac1b8021be0c88$export$699805cbca2c41d);
    $parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", ()=>$4eac1b8021be0c88$export$f658d5c0f0b5dbc2);
    $parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", ()=>$4eac1b8021be0c88$export$e469bcb2060000af);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", ()=>$4eac1b8021be0c88$export$f10e53e8928b61bd);
    $parcel$export(module.exports, "GOALS_GQL_FIELD", ()=>$4eac1b8021be0c88$export$bfcb1a91094f113a);
    $parcel$export(module.exports, "DURATION_GQL_FIELD", ()=>$4eac1b8021be0c88$export$db0bd6c04eb7d04a);
    $parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", ()=>$4eac1b8021be0c88$export$798d2f5814884447);
    $parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", ()=>$4eac1b8021be0c88$export$269d70c1b1c9fb80);
    $parcel$export(module.exports, "APPROVALS_CF_TYPE", ()=>$4eac1b8021be0c88$export$f0f17ef462331df4);
    $parcel$export(module.exports, "CATEGORY_TYPE", ()=>$4eac1b8021be0c88$export$3c7d8923295a5199);
    $parcel$export(module.exports, "PEOPLE_CF_TYPE", ()=>$4eac1b8021be0c88$export$fb431e758c9252df);
    $parcel$export(module.exports, "NUMBER_CF_TYPE", ()=>$4eac1b8021be0c88$export$c7faa96db185cfc6);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", ()=>$4eac1b8021be0c88$export$492b0fa4fe201a22);
    $parcel$export(module.exports, "URL_CF_TYPE", ()=>$4eac1b8021be0c88$export$60f0bd6e4b582fe6);
    $parcel$export(module.exports, "TEXT_CF_TYPE", ()=>$4eac1b8021be0c88$export$68c7e01d5460d298);
    $parcel$export(module.exports, "TEXT_AREA_CF_TYPE", ()=>$4eac1b8021be0c88$export$39cd48613b53ce2f);
    $parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", ()=>$4eac1b8021be0c88$export$977db5973ce73e44);
    $parcel$export(module.exports, "LABELS_CF_TYPE", ()=>$4eac1b8021be0c88$export$ad4eb83f78528e13);
    $parcel$export(module.exports, "DATE_CF_TYPE", ()=>$4eac1b8021be0c88$export$ff745f432984005d);
    $parcel$export(module.exports, "DATETIME_CF_TYPE", ()=>$4eac1b8021be0c88$export$42d097f7b1622ef1);
    $parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", ()=>$4eac1b8021be0c88$export$65524be5675e57e6);
    $parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", ()=>$4eac1b8021be0c88$export$5280e5501a801dc0);
    $parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", ()=>$4eac1b8021be0c88$export$c5d13ea26562d57a);
    $parcel$export(module.exports, "SELECT_CF_TYPE", ()=>$4eac1b8021be0c88$export$22ac48a51c014e4b);
    $parcel$export(module.exports, "EPIC_STATUS_TYPE", ()=>$4eac1b8021be0c88$export$6769c2c97b828e11);
    $parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", ()=>$4eac1b8021be0c88$export$39866626496bbfc8);
    $parcel$export(module.exports, "VERSION_CF_TYPE", ()=>$4eac1b8021be0c88$export$24382b4e8c58336b);
    $parcel$export(module.exports, "GROUP_CF_TYPE", ()=>$4eac1b8021be0c88$export$b075907882e80160);
    $parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", ()=>$4eac1b8021be0c88$export$b600addfa3355c57);
    $parcel$export(module.exports, "USER_CF_TYPE", ()=>$4eac1b8021be0c88$export$c491a4b98394028e);
    $parcel$export(module.exports, "MULTI_USER_CF_TYPE", ()=>$4eac1b8021be0c88$export$5365f2d3fac5261a);
    $parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", ()=>$4eac1b8021be0c88$export$cc8ffff49170b0f4);
    $parcel$export(module.exports, "FLAGGED_CF_TYPE", ()=>$4eac1b8021be0c88$export$b7178f601d7373f9);
    $parcel$export(module.exports, "TEAM_CF_TYPE", ()=>$4eac1b8021be0c88$export$eb1f1dca13a0f02d);
    $parcel$export(module.exports, "PARENT_CF_TYPE", ()=>$4eac1b8021be0c88$export$3e71e11f80203acb);
    $parcel$export(module.exports, "BASELINE_START_CF_TYPE", ()=>$4eac1b8021be0c88$export$d10d66823a65e688);
    $parcel$export(module.exports, "BASELINE_END_CF_TYPE", ()=>$4eac1b8021be0c88$export$dfc6da4a9963d5dc);
    $parcel$export(module.exports, "COLOR_CF_TYPE", ()=>$4eac1b8021be0c88$export$b4a1fbc1cf0059cf);
    $parcel$export(module.exports, "EPIC_COLOR_TYPE", ()=>$4eac1b8021be0c88$export$4838a8a8d62a64fd);
    $parcel$export(module.exports, "ASSETS_CF_TYPE", ()=>$4eac1b8021be0c88$export$ed2de20ab8b7ad3d);
    $parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", ()=>$4eac1b8021be0c88$export$b755e97dbfa92610);
    $parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", ()=>$4eac1b8021be0c88$export$1be1ecd4dfc06fab);
    $parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", ()=>$4eac1b8021be0c88$export$34317c2d84a93553);
    $parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", ()=>$4eac1b8021be0c88$export$555b4f35f98a3210);
    $parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", ()=>$4eac1b8021be0c88$export$1f2859a3ef701a14);
    $parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", ()=>$4eac1b8021be0c88$export$68f62eb762e4157f);
    $parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", ()=>$4eac1b8021be0c88$export$6da975fce1fbd38e);
    $parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", ()=>$4eac1b8021be0c88$export$c6dd874aae21e51f);
    $parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", ()=>$4eac1b8021be0c88$export$c3c9f8a8a8dc0b30);
    $parcel$export(module.exports, "RANK_CF_TYPE", ()=>$4eac1b8021be0c88$export$af89c0396aaf23e3);
    $parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", ()=>$4eac1b8021be0c88$export$3b5a62bb34372404);
    $parcel$export(module.exports, "READ_ONLY_CF_TYPE", ()=>$4eac1b8021be0c88$export$247829aef464243f);
    $parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", ()=>$4eac1b8021be0c88$export$65a6076c0927d413);
    $parcel$export(module.exports, "RESPONDERS_CF_TYPE", ()=>$4eac1b8021be0c88$export$bcf83e1d934501c9);
    $parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", ()=>$4eac1b8021be0c88$export$ae0eeec12e90a01e);
    $parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", ()=>$4eac1b8021be0c88$export$c23f6b40da18371a);
    $parcel$export(module.exports, "SENTIMENT_CF_TYPE", ()=>$4eac1b8021be0c88$export$c23cfbdf83daa90d);
    $parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", ()=>$4eac1b8021be0c88$export$21dda64db57e4883);
    $parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", ()=>$4eac1b8021be0c88$export$45700f3bf92a003a);
    $parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", ()=>$4eac1b8021be0c88$export$2d75b47d12efc812);
    $parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", ()=>$4eac1b8021be0c88$export$7b79405842547ccb);
    $parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", ()=>$4eac1b8021be0c88$export$fc276d6ccf118a14);
    $parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", ()=>$4eac1b8021be0c88$export$8b0718167d092603);
    $parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", ()=>$4eac1b8021be0c88$export$904b40dd2afd17a2);
    $parcel$export(module.exports, "GOALS_CF_TYPE", ()=>$4eac1b8021be0c88$export$2bbb7f69c97ea279);
    $parcel$export(module.exports, "ASSIGNEE_TYPE", ()=>$4eac1b8021be0c88$export$fba8634fd401ba8b);
    $parcel$export(module.exports, "REPORTER_TYPE", ()=>$4eac1b8021be0c88$export$a91aea2438afcce8);
    $parcel$export(module.exports, "DUE_DATE_TYPE", ()=>$4eac1b8021be0c88$export$b159f8b8f27aae4c);
    $parcel$export(module.exports, "PRIORITY_TYPE", ()=>$4eac1b8021be0c88$export$34740f8d07d23ac0);
    $parcel$export(module.exports, "LABELS_TYPE", ()=>$4eac1b8021be0c88$export$43b6e33ec70f2272);
    $parcel$export(module.exports, "CREATED", ()=>$4eac1b8021be0c88$export$ff39ebd4bb12b718);
    $parcel$export(module.exports, "UPDATED", ()=>$4eac1b8021be0c88$export$cd8e68094cb5c3cb);
    $parcel$export(module.exports, "RESOLUTION_DATE", ()=>$4eac1b8021be0c88$export$6a052efb0b4ec5d2);
    $parcel$export(module.exports, "COMPONENTS_TYPE", ()=>$4eac1b8021be0c88$export$37abf56f13f61ec5);
    $parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", ()=>$4eac1b8021be0c88$export$aef0c22aecd16996);
    $parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", ()=>$4eac1b8021be0c88$export$cff5b6d1e7135679);
    $parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", ()=>$4eac1b8021be0c88$export$791007408faf42f4);
    $parcel$export(module.exports, "DEV_SUMMARY_TYPE", ()=>$4eac1b8021be0c88$export$827a1c600bac12a3);
    $parcel$export(module.exports, "RELEASES_TYPE", ()=>$4eac1b8021be0c88$export$e9ba671d077969f8);
    $parcel$export(module.exports, "SPRINT_TYPE", ()=>$4eac1b8021be0c88$export$3d37701ba6fb68ec);
    $parcel$export(module.exports, "STORY_POINTS_TYPE", ()=>$4eac1b8021be0c88$export$36fd22f47020f37b);
    $parcel$export(module.exports, "EPIC_TYPE", ()=>$4eac1b8021be0c88$export$9f2fedcd916d2a79);
    $parcel$export(module.exports, "EPIC_NAME_TYPE", ()=>$4eac1b8021be0c88$export$dfc63737b8c0150d);
    $parcel$export(module.exports, "FIX_VERSIONS_TYPE", ()=>$4eac1b8021be0c88$export$a5c9f63aadcb220);
    $parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", ()=>$4eac1b8021be0c88$export$94009605902e4fe5);
    $parcel$export(module.exports, "DESCRIPTION_TYPE", ()=>$4eac1b8021be0c88$export$5e7324042f1d6b31);
    $parcel$export(module.exports, "ENVIRONMENT_TYPE", ()=>$4eac1b8021be0c88$export$113281d03e6830ef);
    $parcel$export(module.exports, "WATCHES_TYPE", ()=>$4eac1b8021be0c88$export$5ff798870a3dffbf);
    $parcel$export(module.exports, "SUMMARY_TYPE", ()=>$4eac1b8021be0c88$export$907219511d14ba3d);
    $parcel$export(module.exports, "PROFORMA_FORMS", ()=>$4eac1b8021be0c88$export$d09aa6a4f3538063);
    $parcel$export(module.exports, "RESOLUTION_TYPE", ()=>$4eac1b8021be0c88$export$3aca8c91b58a42e2);
    $parcel$export(module.exports, "TIME_TRACKING_TYPE", ()=>$4eac1b8021be0c88$export$ccb5ffefbf8b987c);
    $parcel$export(module.exports, "TIME_ESTIMATE_TYPE", ()=>$4eac1b8021be0c88$export$c8bedad98a5e7f5f);
    $parcel$export(module.exports, "STATUS_TYPE", ()=>$4eac1b8021be0c88$export$358267065be1e);
    $parcel$export(module.exports, "STATUS_CATEGORY_TYPE", ()=>$4eac1b8021be0c88$export$dcaa788c7ada56de);
    $parcel$export(module.exports, "ISSUE_TYPE", ()=>$4eac1b8021be0c88$export$ebb48b08205007c5);
    $parcel$export(module.exports, "ISSUE_KEY_TYPE", ()=>$4eac1b8021be0c88$export$5e91047fe9955d0e);
    $parcel$export(module.exports, "CHILDREN_ISSUES", ()=>$4eac1b8021be0c88$export$3b3d0889022c85b3);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", ()=>$4eac1b8021be0c88$export$335851d83a79891);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", ()=>$4eac1b8021be0c88$export$7b76bbcb87d41695);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", ()=>$4eac1b8021be0c88$export$297b67ac63f09f72);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", ()=>$4eac1b8021be0c88$export$ae87161126086be);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", ()=>$4eac1b8021be0c88$export$6a88420fc2f6901d);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", ()=>$4eac1b8021be0c88$export$ef1a0421bd42c0e4);
    $parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", ()=>$4eac1b8021be0c88$export$dd695c8c5ab62f9d);
    $parcel$export(module.exports, "SLA_PANEL_TYPE", ()=>$4eac1b8021be0c88$export$7b3d247435a784fa);
    $parcel$export(module.exports, "LINKED_ALERTS_TYPE", ()=>$4eac1b8021be0c88$export$17b7080ed1fe8cfd);
    $parcel$export(module.exports, "CHAT_CHANNEL_TYPE", ()=>$4eac1b8021be0c88$export$29fe745131dad7ba);
    $parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", ()=>$4eac1b8021be0c88$export$9c245100c3091ec3);
    $parcel$export(module.exports, "ZOOM_MEETING_TYPE", ()=>$4eac1b8021be0c88$export$51eb15cea47a37ba);
    $parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", ()=>$4eac1b8021be0c88$export$c7ae0622b0bd5d56);
    $parcel$export(module.exports, "CONFERENCE_CALL_TYPE", ()=>$4eac1b8021be0c88$export$f7dcde9e9e88aff2);
    $parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", ()=>$4eac1b8021be0c88$export$b5358afda8ff335e);
    $parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", ()=>$4eac1b8021be0c88$export$63cf6f392da16c25);
    $parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", ()=>$4eac1b8021be0c88$export$22f61ccc2730431f);
    $parcel$export(module.exports, "SUBTASKS_TYPE", ()=>$4eac1b8021be0c88$export$8bbb446f57294715);
    $parcel$export(module.exports, "VOTES_TYPE", ()=>$4eac1b8021be0c88$export$34fcd7cb291a1e4d);
    $parcel$export(module.exports, "PARENT_TYPE", ()=>$4eac1b8021be0c88$export$5e93f2a57cc4ca3a);
    $parcel$export(module.exports, "PROJECT_TYPE", ()=>$4eac1b8021be0c88$export$91a9dba2d38d9a6f);
    $parcel$export(module.exports, "TIME_SPENT_TYPE", ()=>$4eac1b8021be0c88$export$ede0a4c20124ec85);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", ()=>$4eac1b8021be0c88$export$3eeb79d48fb5f667);
    $parcel$export(module.exports, "SENTIMENT_TYPE", ()=>$4eac1b8021be0c88$export$45e72c9a63ab61ab);
    $parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", ()=>$4eac1b8021be0c88$export$99ad62164189f781);
    $parcel$export(module.exports, "FORGE_GLANCE_TYPE", ()=>$4eac1b8021be0c88$export$7719ef6e9283671);
    $parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", ()=>$4eac1b8021be0c88$export$bfebea5ce2e1887a);
    $parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", ()=>$4eac1b8021be0c88$export$84e5674890d55030);
    $parcel$export(module.exports, "SECURITY_LEVEL_TYPE", ()=>$4eac1b8021be0c88$export$326a5522a485e43d);
    $parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", ()=>$4eac1b8021be0c88$export$c9f3f01e2c535302);
    $parcel$export(module.exports, "TEAM_TYPE", ()=>$4eac1b8021be0c88$export$66519f3bbff1796a);
    $parcel$export(module.exports, "ESTIMATE_TYPE", ()=>$4eac1b8021be0c88$export$a4ee0bca77cc8463);
    $parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", ()=>$4eac1b8021be0c88$export$fed53408e89e0497);
    $parcel$export(module.exports, "TARGET_START_TYPE", ()=>$4eac1b8021be0c88$export$d53c26f9ce31f56b);
    $parcel$export(module.exports, "TARGET_END_TYPE", ()=>$4eac1b8021be0c88$export$48f82d653f85e459);
    $parcel$export(module.exports, "START_DATE_TYPE", ()=>$4eac1b8021be0c88$export$ea5a888f39f722c7);
    $parcel$export(module.exports, "COLOR_TYPE", ()=>$4eac1b8021be0c88$export$f245bbec12cc0e40);
    $parcel$export(module.exports, "ATTACHMENT_TYPE", ()=>$4eac1b8021be0c88$export$aed630b4b7114a59);
    $parcel$export(module.exports, "ISSUE_LINKS_TYPE", ()=>$4eac1b8021be0c88$export$b50c1a8fef07104);
    $parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", ()=>$4eac1b8021be0c88$export$ea3d72f4bb7738ba);
    $parcel$export(module.exports, "COMMENT_TYPE", ()=>$4eac1b8021be0c88$export$a4cab0124760d860);
    $parcel$export(module.exports, "WORK_LOG_TYPE", ()=>$4eac1b8021be0c88$export$734929aef118d7e2);
    $parcel$export(module.exports, "PARENT_FIELD_TYPE", ()=>$4eac1b8021be0c88$export$ffbacacb07c1d46d);
    $parcel$export(module.exports, "getLayoutFieldTypes", ()=>$4eac1b8021be0c88$export$3c3e26aadbfa2c32);
    var $5iWql = parcelRequire("5iWql");
    var $1ybV0 = parcelRequire("1ybV0");
    var $eI5EY = parcelRequire("eI5EY");
    const $4eac1b8021be0c88$export$b144116dae474c88 = 'issue-link-search';
    const $4eac1b8021be0c88$export$bc917bc699b25f75 = 'number';
    const $4eac1b8021be0c88$export$5f26ca419fdffbe7 = 'string';
    const $4eac1b8021be0c88$export$ce9bfd823c7e1a6d = 'datetime';
    const $4eac1b8021be0c88$export$346b72b1f7cd6d5a = 'date';
    const $4eac1b8021be0c88$export$b20fbcacd7942c2a = 'option2';
    const $4eac1b8021be0c88$export$20737ab0ca5fa93f = 'option';
    const $4eac1b8021be0c88$export$a2e8554bffc61ece = 'any';
    const $4eac1b8021be0c88$export$f25cd4907cbb25b9 = 'array';
    const $4eac1b8021be0c88$export$5600354b43577e17 = 'user';
    const $4eac1b8021be0c88$export$5dbc9917f72d0d2a = 'group';
    const $4eac1b8021be0c88$export$253649f07fb55948 = 'object';
    const $4eac1b8021be0c88$export$eb39592ba5247ee7 = 'group-list';
    const $4eac1b8021be0c88$export$f48a9be226105736 = 'array-string';
    const $4eac1b8021be0c88$export$42e2e93fc721df5d = 'version';
    const $4eac1b8021be0c88$export$a603eef6fee2a5f0 = 'parent-issues';
    const $4eac1b8021be0c88$export$7773375e72c953ed = 'approval-panel';
    const $4eac1b8021be0c88$export$80ad0037098f3919 = 'project';
    const $4eac1b8021be0c88$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
    const $4eac1b8021be0c88$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
    const $4eac1b8021be0c88$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
    const $4eac1b8021be0c88$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
    const $4eac1b8021be0c88$export$c979d9c548c05133 = 'JiraBooleanField';
    const $4eac1b8021be0c88$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
    const $4eac1b8021be0c88$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
    const $4eac1b8021be0c88$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
    const $4eac1b8021be0c88$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
    const $4eac1b8021be0c88$export$b0deb225eed90fbd = 'JiraCMDBField';
    const $4eac1b8021be0c88$export$add3775cfea8fde3 = 'JiraColorField';
    const $4eac1b8021be0c88$export$9631d4098abab3eb = 'JiraComponentsField';
    const $4eac1b8021be0c88$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
    const $4eac1b8021be0c88$export$fbcebbdce821f712 = 'JiraConnectNumberField';
    const $4eac1b8021be0c88$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
    const $4eac1b8021be0c88$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
    const $4eac1b8021be0c88$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
    const $4eac1b8021be0c88$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
    const $4eac1b8021be0c88$export$ed2eabcf0931df31 = 'JiraDatePickerField';
    const $4eac1b8021be0c88$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
    const $4eac1b8021be0c88$export$6d8da4497234455 = 'JiraEpicLinkField';
    const $4eac1b8021be0c88$export$9bcfac568e4fa59c = 'JiraFlagField';
    const $4eac1b8021be0c88$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
    const $4eac1b8021be0c88$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
    const $4eac1b8021be0c88$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
    const $4eac1b8021be0c88$export$810709f0c5c2e9db = 'JiraLabelsField';
    const $4eac1b8021be0c88$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
    const $4eac1b8021be0c88$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
    const $4eac1b8021be0c88$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
    const $4eac1b8021be0c88$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
    const $4eac1b8021be0c88$export$3b6d7fc1833bf7da = 'JiraNumberField';
    const $4eac1b8021be0c88$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
    const $4eac1b8021be0c88$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
    const $4eac1b8021be0c88$export$31aea7548807c6b5 = 'JiraPeopleField';
    const $4eac1b8021be0c88$export$e89fbbf3983c0219 = 'JiraPriorityField';
    const $4eac1b8021be0c88$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
    const $4eac1b8021be0c88$export$12f54499c6252188 = 'JiraProjectField';
    const $4eac1b8021be0c88$export$8e4293d806f435e0 = 'JiraRadioSelectField';
    const $4eac1b8021be0c88$export$c69486dd643dfb69 = 'JiraReporterField';
    const $4eac1b8021be0c88$export$1e18a858257aca2f = 'JiraRequestTypeField';
    const $4eac1b8021be0c88$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
    const $4eac1b8021be0c88$export$37f4daaa7b409554 = 'JiraRichTextField';
    const $4eac1b8021be0c88$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
    const $4eac1b8021be0c88$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
    const $4eac1b8021be0c88$export$ab5cecc580898d1c = 'JiraSingleSelectField';
    const $4eac1b8021be0c88$export$bb63813d13e8eaf7 = 'JiraSprintField';
    const $4eac1b8021be0c88$export$e40f819979b3881d = 'JiraStatusField';
    const $4eac1b8021be0c88$export$6c243704a22baffe = 'JiraTeamField';
    const $4eac1b8021be0c88$export$6c32429bac235203 = 'JiraTeamViewField';
    const $4eac1b8021be0c88$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
    const $4eac1b8021be0c88$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
    const $4eac1b8021be0c88$export$37ccd11f08a93ccb = 'JiraUrlField';
    const $4eac1b8021be0c88$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
    const $4eac1b8021be0c88$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
    const $4eac1b8021be0c88$export$c8bf66d62e74cdd2 = 'JiraVotesField';
    const $4eac1b8021be0c88$export$aa815aaa741ae18 = 'JiraWatchesField';
    const $4eac1b8021be0c88$export$e805f89b15d2abf4 = 'JiraAssetField';
    const $4eac1b8021be0c88$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
    const $4eac1b8021be0c88$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
    const $4eac1b8021be0c88$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
    const $4eac1b8021be0c88$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
    const $4eac1b8021be0c88$export$478b546dccd33e1e = 'JiraForgeNumberField';
    const $4eac1b8021be0c88$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
    const $4eac1b8021be0c88$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
    const $4eac1b8021be0c88$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
    const $4eac1b8021be0c88$export$1763713d718f7ef0 = 'JiraForgeGroupField';
    const $4eac1b8021be0c88$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
    const $4eac1b8021be0c88$export$671131ba12d94144 = 'JiraForgeGroupsField';
    const $4eac1b8021be0c88$export$c48132adab502d6b = 'JiraForgeUsersField';
    const $4eac1b8021be0c88$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
    const $4eac1b8021be0c88$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
    const $4eac1b8021be0c88$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
    const $4eac1b8021be0c88$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
    const $4eac1b8021be0c88$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
    const $4eac1b8021be0c88$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
    const $4eac1b8021be0c88$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
    const $4eac1b8021be0c88$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
    const $4eac1b8021be0c88$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
    const $4eac1b8021be0c88$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
    const $4eac1b8021be0c88$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
    const $4eac1b8021be0c88$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
    const $4eac1b8021be0c88$export$f10e53e8928b61bd = 'JiraDataClassificationField';
    const $4eac1b8021be0c88$export$bfcb1a91094f113a = 'JiraGoalsField';
    const $4eac1b8021be0c88$export$db0bd6c04eb7d04a = 'JiraDurationField';
    const $4eac1b8021be0c88$export$798d2f5814884447 = 'forgeCustomField';
    const $4eac1b8021be0c88$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
    const $4eac1b8021be0c88$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
    const $4eac1b8021be0c88$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
    const $4eac1b8021be0c88$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
    const $4eac1b8021be0c88$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
    const $4eac1b8021be0c88$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
    const $4eac1b8021be0c88$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
    const $4eac1b8021be0c88$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
    const $4eac1b8021be0c88$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
    const $4eac1b8021be0c88$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
    const $4eac1b8021be0c88$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
    const $4eac1b8021be0c88$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
    const $4eac1b8021be0c88$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
    const $4eac1b8021be0c88$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
    const $4eac1b8021be0c88$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
    const $4eac1b8021be0c88$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
    const $4eac1b8021be0c88$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
    const $4eac1b8021be0c88$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
    const $4eac1b8021be0c88$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
    const $4eac1b8021be0c88$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
    const $4eac1b8021be0c88$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
    const $4eac1b8021be0c88$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
    const $4eac1b8021be0c88$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
    const $4eac1b8021be0c88$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
    const $4eac1b8021be0c88$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
    const $4eac1b8021be0c88$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
    const $4eac1b8021be0c88$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
    const $4eac1b8021be0c88$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
    const $4eac1b8021be0c88$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
    const $4eac1b8021be0c88$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
    const $4eac1b8021be0c88$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
    const $4eac1b8021be0c88$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
    const $4eac1b8021be0c88$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
    const $4eac1b8021be0c88$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
    const $4eac1b8021be0c88$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
    const $4eac1b8021be0c88$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
    const $4eac1b8021be0c88$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
    const $4eac1b8021be0c88$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
    const $4eac1b8021be0c88$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
    const $4eac1b8021be0c88$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
    const $4eac1b8021be0c88$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
    const $4eac1b8021be0c88$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
    const $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
    const $4eac1b8021be0c88$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
    const $4eac1b8021be0c88$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
    const $4eac1b8021be0c88$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
    const $4eac1b8021be0c88$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
    const $4eac1b8021be0c88$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
    const $4eac1b8021be0c88$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
    const $4eac1b8021be0c88$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
    const $4eac1b8021be0c88$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
    const $4eac1b8021be0c88$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
    const $4eac1b8021be0c88$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
    const $4eac1b8021be0c88$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
    const $4eac1b8021be0c88$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
    const $4eac1b8021be0c88$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
    const $4eac1b8021be0c88$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
    const $4eac1b8021be0c88$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
    const $4eac1b8021be0c88$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
    const $4eac1b8021be0c88$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
    const $4eac1b8021be0c88$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
    const $4eac1b8021be0c88$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
    const $4eac1b8021be0c88$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
    const $4eac1b8021be0c88$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
    const $4eac1b8021be0c88$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
    const $4eac1b8021be0c88$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
    const $4eac1b8021be0c88$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
    const $4eac1b8021be0c88$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
    const $4eac1b8021be0c88$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
    const $4eac1b8021be0c88$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
    const $4eac1b8021be0c88$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
    const $4eac1b8021be0c88$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
    const $4eac1b8021be0c88$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
    const $4eac1b8021be0c88$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
    const $4eac1b8021be0c88$export$fba8634fd401ba8b = 'assignee';
    const $4eac1b8021be0c88$export$a91aea2438afcce8 = 'reporter';
    const $4eac1b8021be0c88$export$b159f8b8f27aae4c = 'duedate';
    const $4eac1b8021be0c88$export$34740f8d07d23ac0 = 'priority';
    const $4eac1b8021be0c88$export$43b6e33ec70f2272 = 'labels';
    const $4eac1b8021be0c88$export$ff39ebd4bb12b718 = 'created';
    const $4eac1b8021be0c88$export$cd8e68094cb5c3cb = 'updated';
    const $4eac1b8021be0c88$export$6a052efb0b4ec5d2 = 'resolutiondate';
    const $4eac1b8021be0c88$export$37abf56f13f61ec5 = 'components';
    const $4eac1b8021be0c88$export$aef0c22aecd16996 = 'servicedesk-approvals';
    const $4eac1b8021be0c88$export$cff5b6d1e7135679 = 'servicedesk-practices';
    const $4eac1b8021be0c88$export$d925edcf818f4885 = 'servicedesk-incident-linking';
    const $4eac1b8021be0c88$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
    const $4eac1b8021be0c88$export$791007408faf42f4 = 'servicedesk-incident-management';
    const $4eac1b8021be0c88$export$827a1c600bac12a3 = 'devSummary';
    const $4eac1b8021be0c88$export$e9ba671d077969f8 = 'releases';
    const $4eac1b8021be0c88$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
    const $4eac1b8021be0c88$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
    const $4eac1b8021be0c88$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
    const $4eac1b8021be0c88$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
    const $4eac1b8021be0c88$export$a5c9f63aadcb220 = 'fixVersions';
    const $4eac1b8021be0c88$export$94009605902e4fe5 = 'versions';
    const $4eac1b8021be0c88$export$5e7324042f1d6b31 = 'description';
    const $4eac1b8021be0c88$export$113281d03e6830ef = 'environment';
    const $4eac1b8021be0c88$export$5ff798870a3dffbf = 'watches';
    const $4eac1b8021be0c88$export$907219511d14ba3d = 'summary';
    const $4eac1b8021be0c88$export$d09aa6a4f3538063 = 'proforma-forms';
    const $4eac1b8021be0c88$export$3aca8c91b58a42e2 = 'resolution';
    const $4eac1b8021be0c88$export$ccb5ffefbf8b987c = 'timetracking';
    const $4eac1b8021be0c88$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
    const $4eac1b8021be0c88$export$358267065be1e = 'status';
    const $4eac1b8021be0c88$export$dcaa788c7ada56de = 'statusCategory';
    const $4eac1b8021be0c88$export$ebb48b08205007c5 = 'issuetype';
    const $4eac1b8021be0c88$export$5e91047fe9955d0e = 'issuekey';
    const $4eac1b8021be0c88$export$3b3d0889022c85b3 = 'children-issues';
    const $4eac1b8021be0c88$export$aba22e09a66f6826 = 'portfolio-child-issues';
    const $4eac1b8021be0c88$export$8fe3d5be8cb17459 = 'epic-issues';
    const $4eac1b8021be0c88$export$335851d83a79891 = 'hierarchy-level-below';
    const $4eac1b8021be0c88$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
    const $4eac1b8021be0c88$export$297b67ac63f09f72 = 'hierarchy-level-above';
    const $4eac1b8021be0c88$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
    const $4eac1b8021be0c88$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
    const $4eac1b8021be0c88$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
    const $4eac1b8021be0c88$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
    const $4eac1b8021be0c88$export$7b3d247435a784fa = 'SLA_PANEL';
    const $4eac1b8021be0c88$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
    const $4eac1b8021be0c88$export$29fe745131dad7ba = 'CHAT_CHANNEL';
    const $4eac1b8021be0c88$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
    const $4eac1b8021be0c88$export$51eb15cea47a37ba = 'ZOOM_MEETING';
    const $4eac1b8021be0c88$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
    const $4eac1b8021be0c88$export$f7dcde9e9e88aff2 = 'CONFERENCE_CALL';
    const $4eac1b8021be0c88$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
    const $4eac1b8021be0c88$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
    const $4eac1b8021be0c88$export$22f61ccc2730431f = 'similar-issues';
    const $4eac1b8021be0c88$export$8bbb446f57294715 = 'subtasks';
    const $4eac1b8021be0c88$export$34fcd7cb291a1e4d = 'votes';
    const $4eac1b8021be0c88$export$5e93f2a57cc4ca3a = 'parent';
    const $4eac1b8021be0c88$export$be3891c8b47ab821 = 'parent-issue';
    const $4eac1b8021be0c88$export$91a9dba2d38d9a6f = 'project';
    const $4eac1b8021be0c88$export$df36fc05622c402 = 'worklog';
    const $4eac1b8021be0c88$export$ede0a4c20124ec85 = 'timespent';
    const $4eac1b8021be0c88$export$3eeb79d48fb5f667 = 'dataclassification';
    const $4eac1b8021be0c88$export$45e72c9a63ab61ab = 'SENTIMENT';
    const $4eac1b8021be0c88$export$99ad62164189f781 = 'ecosystemGlance';
    const $4eac1b8021be0c88$export$7719ef6e9283671 = 'forgeGlance';
    const $4eac1b8021be0c88$export$bfebea5ce2e1887a = 'ecosystemContext';
    const $4eac1b8021be0c88$export$be8e68fb1aed253e = 'forgeContext';
    const $4eac1b8021be0c88$export$84e5674890d55030 = 'issuerestriction';
    const $4eac1b8021be0c88$export$326a5522a485e43d = 'security';
    const $4eac1b8021be0c88$export$c9f3f01e2c535302 = 'securitylevel';
    const $4eac1b8021be0c88$export$35e5652f764785bd = 'creator';
    const $4eac1b8021be0c88$export$66519f3bbff1796a = 'team';
    const $4eac1b8021be0c88$export$a4ee0bca77cc8463 = 'estimate';
    const $4eac1b8021be0c88$export$fed53408e89e0497 = 'dueDate';
    const $4eac1b8021be0c88$export$d53c26f9ce31f56b = 'targetStart';
    const $4eac1b8021be0c88$export$48f82d653f85e459 = 'targetEnd';
    const $4eac1b8021be0c88$export$ea5a888f39f722c7 = 'startDate';
    const $4eac1b8021be0c88$export$f245bbec12cc0e40 = 'color';
    const $4eac1b8021be0c88$export$aed630b4b7114a59 = 'attachment';
    const $4eac1b8021be0c88$export$b50c1a8fef07104 = 'issuelinks';
    const $4eac1b8021be0c88$export$ea3d72f4bb7738ba = 'timeestimate';
    const $4eac1b8021be0c88$export$a4cab0124760d860 = 'comment';
    const $4eac1b8021be0c88$export$734929aef118d7e2 = 'worklog';
    const $4eac1b8021be0c88$export$ffbacacb07c1d46d = 'parent';
    const $4eac1b8021be0c88$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
    const $4eac1b8021be0c88$export$278c072e2f9176ab = 'aggregatetimespent';
    const $4eac1b8021be0c88$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
    const $4eac1b8021be0c88$export$fbc5ebe2e580bf8b = 'progress';
    const $4eac1b8021be0c88$export$aa3b37e271efd578 = 'aggregateprogress';
    const $4eac1b8021be0c88$export$444bffe6526fb5f2 = 'workratio';
    const $4eac1b8021be0c88$var$getLayoutFieldTypesNonMemoized = ()=>{
        const types = {
            ASSIGNEE_TYPE: $4eac1b8021be0c88$export$fba8634fd401ba8b,
            DUE_DATE_TYPE: $4eac1b8021be0c88$export$b159f8b8f27aae4c,
            PRIORITY_TYPE: $4eac1b8021be0c88$export$34740f8d07d23ac0,
            REPORTER_TYPE: $4eac1b8021be0c88$export$a91aea2438afcce8,
            DESCRIPTION_TYPE: $4eac1b8021be0c88$export$5e7324042f1d6b31,
            LABELS_TYPE: $4eac1b8021be0c88$export$43b6e33ec70f2272,
            COMPONENTS_TYPE: $4eac1b8021be0c88$export$37abf56f13f61ec5,
            SPRINT_TYPE: $4eac1b8021be0c88$export$3d37701ba6fb68ec,
            STORY_POINTS_TYPE: $4eac1b8021be0c88$export$36fd22f47020f37b,
            TEAMS_PLATFORM_CF_TYPE: $4eac1b8021be0c88$export$269d70c1b1c9fb80,
            EPIC_TYPE: $4eac1b8021be0c88$export$9f2fedcd916d2a79,
            FIX_VERSIONS_TYPE: $4eac1b8021be0c88$export$a5c9f63aadcb220,
            AFFECTS_VERSIONS_TYPE: $4eac1b8021be0c88$export$94009605902e4fe5,
            TIME_ESTIMATE_TYPE: $4eac1b8021be0c88$export$c8bedad98a5e7f5f,
            TIME_TRACKING_TYPE: $4eac1b8021be0c88$export$ccb5ffefbf8b987c,
            ENVIRONMENT_TYPE: $4eac1b8021be0c88$export$113281d03e6830ef,
            DEV_SUMMARY_TYPE: $4eac1b8021be0c88$export$827a1c600bac12a3,
            APPROVALS_PANEL_TYPE: $4eac1b8021be0c88$export$7773375e72c953ed,
            KNOWLEDGE_BASE_TYPE: $4eac1b8021be0c88$export$b5358afda8ff335e,
            SLA_PANEL_TYPE: $4eac1b8021be0c88$export$7b3d247435a784fa,
            LINKED_ALERTS_TYPE: $4eac1b8021be0c88$export$17b7080ed1fe8cfd,
            CHAT_CHANNEL_TYPE: $4eac1b8021be0c88$export$29fe745131dad7ba,
            MSTEAMS_CHANNEL_TYPE: $4eac1b8021be0c88$export$9c245100c3091ec3,
            ZOOM_MEETING_TYPE: $4eac1b8021be0c88$export$51eb15cea47a37ba,
            MANAGE_STAKEHOLDERS_TYPE: $4eac1b8021be0c88$export$c7ae0622b0bd5d56,
            CONFERENCE_CALL_TYPE: $4eac1b8021be0c88$export$f7dcde9e9e88aff2,
            ASSETS_CF_TYPE: $4eac1b8021be0c88$export$ed2de20ab8b7ad3d,
            RESPONDERS_CF_TYPE: $4eac1b8021be0c88$export$bcf83e1d934501c9,
            MAJOR_INCIDENT_CF_TYPE: $4eac1b8021be0c88$export$ae0eeec12e90a01e,
            COLOR_CF_TYPE: $4eac1b8021be0c88$export$b4a1fbc1cf0059cf,
            EPIC_COLOR_TYPE: $4eac1b8021be0c88$export$4838a8a8d62a64fd,
            RELEASES_TYPE: $4eac1b8021be0c88$export$e9ba671d077969f8,
            PARENT_CF_TYPE: $4eac1b8021be0c88$export$3e71e11f80203acb,
            BASELINE_START_CF_TYPE: $4eac1b8021be0c88$export$d10d66823a65e688,
            BASELINE_END_CF_TYPE: $4eac1b8021be0c88$export$dfc6da4a9963d5dc,
            LABELS_CF_TYPE: $4eac1b8021be0c88$export$ad4eb83f78528e13,
            TEXT_CF_TYPE: $4eac1b8021be0c88$export$68c7e01d5460d298,
            MULTI_USER_CF_TYPE: $4eac1b8021be0c88$export$5365f2d3fac5261a,
            PARTICIPANTS_CF_TYPE: $4eac1b8021be0c88$export$cc8ffff49170b0f4,
            URL_CF_TYPE: $4eac1b8021be0c88$export$60f0bd6e4b582fe6,
            NUMBER_CF_TYPE: $4eac1b8021be0c88$export$c7faa96db185cfc6,
            STORY_POINT_ESTIMATE_CF_TYPE: $4eac1b8021be0c88$export$492b0fa4fe201a22,
            SELECT_CF_TYPE: $4eac1b8021be0c88$export$22ac48a51c014e4b,
            EPIC_STATUS_TYPE: $4eac1b8021be0c88$export$6769c2c97b828e11,
            MULTI_SELECT_CF_TYPE: $4eac1b8021be0c88$export$c5d13ea26562d57a,
            ECOSYSTEM_GLANCE_TYPE: $4eac1b8021be0c88$export$99ad62164189f781,
            FORGE_CUSTOM_FIELD_TYPE: $4eac1b8021be0c88$export$798d2f5814884447,
            ISSUE_FIELD_USER_CF_TYPE: $4eac1b8021be0c88$export$5600354b43577e17,
            ISSUE_FIELD_GROUPS_CF_TYPE: $4eac1b8021be0c88$export$eb39592ba5247ee7,
            ISSUE_FIELD_STRINGS_CF_TYPE: $4eac1b8021be0c88$export$f48a9be226105736,
            FORGE_GLANCE_TYPE: $4eac1b8021be0c88$export$7719ef6e9283671,
            TEXT_AREA_CF_TYPE: $4eac1b8021be0c88$export$39cd48613b53ce2f,
            MULTI_VERSION_CF_TYPE: $4eac1b8021be0c88$export$39866626496bbfc8,
            VERSION_CF_TYPE: $4eac1b8021be0c88$export$24382b4e8c58336b,
            DATE_CF_TYPE: $4eac1b8021be0c88$export$ff745f432984005d,
            GROUP_CF_TYPE: $4eac1b8021be0c88$export$b075907882e80160,
            MULTI_GROUP_CF_TYPE: $4eac1b8021be0c88$export$b600addfa3355c57,
            USER_CF_TYPE: $4eac1b8021be0c88$export$c491a4b98394028e,
            DATETIME_CF_TYPE: $4eac1b8021be0c88$export$42d097f7b1622ef1,
            MULTI_CHECKBOXES_CF_TYPE: $4eac1b8021be0c88$export$5280e5501a801dc0,
            RADIO_BUTTONS_CF_TYPE: $4eac1b8021be0c88$export$65524be5675e57e6,
            TEAM_CF_TYPE: $4eac1b8021be0c88$export$eb1f1dca13a0f02d,
            ISSUE_FIELD_NUMBER_CF_TYPE: $4eac1b8021be0c88$export$bc917bc699b25f75,
            ISSUE_FIELD_DATETIME_CF_TYPE: $4eac1b8021be0c88$export$ce9bfd823c7e1a6d,
            ISSUE_FIELD_STRING_CF_TYPE: $4eac1b8021be0c88$export$5f26ca419fdffbe7,
            ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $4eac1b8021be0c88$export$b20fbcacd7942c2a,
            ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $4eac1b8021be0c88$export$f25cd4907cbb25b9,
            REQUEST_TYPE_CF_TYPE: $4eac1b8021be0c88$export$6da975fce1fbd38e,
            SERVICE_ENTITY_CF_TYPE: $4eac1b8021be0c88$export$b755e97dbfa92610,
            REQUEST_PARTICIPANTS_CF_TYPE: $4eac1b8021be0c88$export$1be1ecd4dfc06fab,
            ORGANIZATIONS_CF_TYPE: $4eac1b8021be0c88$export$34317c2d84a93553,
            REQUEST_FEEDBACK_CF_TYPE: $4eac1b8021be0c88$export$1f2859a3ef701a14,
            PEOPLE_CF_TYPE: $4eac1b8021be0c88$export$fb431e758c9252df,
            REQUEST_LANGUAGE_CF_TYPE: $4eac1b8021be0c88$export$555b4f35f98a3210,
            ASSET_ONBOARDING_TYPE: $4eac1b8021be0c88$export$63cf6f392da16c25,
            APPROVERS_LIST_CF_TYPE: $4eac1b8021be0c88$export$c6dd874aae21e51f,
            CASCADING_SELECT_CF_TYPE: $4eac1b8021be0c88$export$c3c9f8a8a8dc0b30,
            PROJECT_PICKER_CF_TYPE: $4eac1b8021be0c88$export$65a6076c0927d413,
            CMDB_OBJECT_CF_TYPE: $4eac1b8021be0c88$export$3b5a62bb34372404,
            READ_ONLY_CF_TYPE: $4eac1b8021be0c88$export$247829aef464243f,
            MESSAGE_VIEW_CF_TYPE: $4eac1b8021be0c88$export$21dda64db57e4883,
            MESSAGE_EDIT_CF_TYPE: $4eac1b8021be0c88$export$45700f3bf92a003a,
            EPIC_NAME_TYPE: $4eac1b8021be0c88$export$dfc63737b8c0150d,
            ECOSYSTEM_CONTEXT_TYPE: $4eac1b8021be0c88$export$bfebea5ce2e1887a,
            CATEGORY_TYPE: $4eac1b8021be0c88$export$3c7d8923295a5199,
            ENTITLEMENT_CF_TYPE: $4eac1b8021be0c88$export$c23f6b40da18371a,
            GOALS_CF_TYPE: $4eac1b8021be0c88$export$2bbb7f69c97ea279
        };
        Object.assign(types, {
            FORGE_CONTEXT_TYPE: $4eac1b8021be0c88$export$be8e68fb1aed253e
        });
        if ((0, $1ybV0.ff)('parent-field-in-issue-view_x4zn4')) Object.assign(types, {
            PARENT_TYPE: $4eac1b8021be0c88$export$5e93f2a57cc4ca3a
        });
        if ((0, $eI5EY.fg)('jsm-sentiment-analysis')) Object.assign(types, {
            SENTIMENT_TYPE: $4eac1b8021be0c88$export$45e72c9a63ab61ab
        });
        Object.assign(types, {
            SENTIMENT_CF_TYPE: $4eac1b8021be0c88$export$c23cfbdf83daa90d
        });
        return types;
    };
    const $4eac1b8021be0c88$export$3c3e26aadbfa2c32 = (0, $5iWql.default)($4eac1b8021be0c88$var$getLayoutFieldTypesNonMemoized);
});
parcelRegister("6ZTsa", function(module, exports) {
    $parcel$export(module.exports, "toErrorId", ()=>$36a0a2a2a499297e$export$706bbe4209d93dfe);
    $parcel$export(module.exports, "toErrorMessage", ()=>$36a0a2a2a499297e$export$95506c204c060a3);
    const $36a0a2a2a499297e$export$706bbe4209d93dfe = (id)=>id;
    const $36a0a2a2a499297e$export$95506c204c060a3 = (message)=>message;
});
parcelRegister("avawr", function(module, exports) {
    $parcel$export(module.exports, "logError", ()=>$f57ea56200106b95$export$58da9968c3170cb1);
    var $gUUjF = parcelRequire("gUUjF");
    var $guiFP = parcelRequire("guiFP");
    const $f57ea56200106b95$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: errorId,
                teamName: 'morphinecake'
            },
            attributes: {
                ...attributes,
                message: message
            },
            error: error
        });
        const location = `${packageName}.${errorId}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, message, error);
    };
});
parcelRegister("dpXKE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e24a038ddb34e953$export$2e2bcd8739ae039);
    var $giAhk = parcelRequire("giAhk");
    var $cM35R = parcelRequire("cM35R");
    var $e24a038ddb34e953$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $cM35R.default));
});
parcelRegister("giAhk", function(module, exports) {
    $parcel$export(module.exports, "injectIntlV2", ()=>$208f42a3fdc9fe2c$export$440265f0ca78e98e);
    var $eUqFw = parcelRequire("eUqFw");
    var $lxchL = parcelRequire("lxchL");
    var $5JgJ2 = parcelRequire("5JgJ2");
    const $208f42a3fdc9fe2c$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
    function $208f42a3fdc9fe2c$var$getDisplayName(Component) {
        if ($208f42a3fdc9fe2c$var$isDisplayableString(Component.displayName)) return Component.displayName;
        if ($208f42a3fdc9fe2c$var$isDisplayableString(Component.name)) return Component.name;
        return 'Component';
    }
    const $208f42a3fdc9fe2c$export$440265f0ca78e98e = (WrappedComponent, options)=>{
        const { withRef: withRef = false } = options || {};
        const WithIntl = (props)=>{
            const intl = (0, $5JgJ2.default)();
            const intlRef = (0, $eUqFw.useRef)(null);
            if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
            if (!intlRef.current) intlRef.current = {
                now: ()=>Date.now(),
                messages: intl.messages,
                locale: intl.locale,
                formats: intl.formats,
                formatDate: intl.formatDate,
                formatMessage: intl.formatMessage,
                formatNumber: intl.formatNumber,
                formatPlural: intl.formatPlural,
                formatTime: intl.formatTime
            };
            return (0, ($parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                intl: intlRef.current,
                ref: withRef ? props.forwardedRef : null
            });
        };
        WithIntl.displayName = `InjectIntl(${$208f42a3fdc9fe2c$var$getDisplayName(WrappedComponent)})`;
        WithIntl.WrappedComponent = WrappedComponent;
        if (withRef) return (0, ($parcel$interopDefault($lxchL)))((0, $eUqFw.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($eUqFw))).createElement(WithIntl, {
                ...props,
                forwardedRef: ref
            })), WrappedComponent);
        return (0, ($parcel$interopDefault($lxchL)))(WithIntl, WrappedComponent);
    };
});
parcelRegister("cM35R", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa15d60f2ab7426b$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $aTgXo = parcelRequire("aTgXo");
    var $5IARc = parcelRequire("5IARc");
    var $6ulBk = parcelRequire("6ulBk");
    const $fa15d60f2ab7426b$var$ProjectBreadcrumb = ({ isSimplifiedProject: isSimplifiedProject, children: children, projectKey: projectKey, projectName: projectName, projectId: projectId, intl: { formatMessage: formatMessage } })=>{
        const ProjectsBreadcrumb = {
            href: '/jira/projects',
            text: formatMessage((0, $6ulBk.default).projectsTitle),
            type: 'projectsDirectory',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToProjectsList'
            }
        };
        if (projectKey != null && projectName != null) {
            const breadcrumb = {
                href: (0, $5IARc.createProjectUrl)(projectKey),
                text: projectName,
                type: 'projectName',
                analyticsAttributes: {
                    nextGenProject: isSimplifiedProject,
                    projectConfig: isSimplifiedProject !== undefined && isSimplifiedProject === true ? 'next-gen' : 'classic'
                },
                analyticsFields: {
                    name: 'navigateToProject',
                    containerId: projectId,
                    containerType: 'project'
                }
            };
            const ProjectNameBreadcrumb = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
                breadcrumb: breadcrumb
            }, children);
            return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
                breadcrumb: ProjectsBreadcrumb
            }, ProjectNameBreadcrumb);
        }
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
            breadcrumb: ProjectsBreadcrumb
        }, children);
    };
    $fa15d60f2ab7426b$var$ProjectBreadcrumb.defaultProps = {
        children: null,
        isSimplifiedProject: false,
        projectId: undefined,
        projectKey: undefined,
        projectName: undefined
    };
    var $fa15d60f2ab7426b$export$2e2bcd8739ae039 = $fa15d60f2ab7426b$var$ProjectBreadcrumb;
});
parcelRegister("6ulBk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9cb70b0ebc38fe07$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    var $9cb70b0ebc38fe07$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
        projectsTitle: {
            "id": "platform.ui.breadcrumbs.common-breadcrumbs.project.projects-title",
            "defaultMessage": "Projects"
        }
    });
});
parcelRegister("5c2C3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a95e6e6f9b00b47$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $aTgXo = parcelRequire("aTgXo");
    const $4a95e6e6f9b00b47$var$UserBreadcrumb = ({ children: children, name: name, profileUrl: profileUrl })=>{
        const breadcrumb = {
            href: profileUrl,
            text: name,
            type: 'userName'
        };
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
            breadcrumb: breadcrumb
        }, children);
    };
    var $4a95e6e6f9b00b47$export$2e2bcd8739ae039 = $4a95e6e6f9b00b47$var$UserBreadcrumb;
});
parcelRegister("1bzuc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$75132222441dd418$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    const $75132222441dd418$var$toBreadcrumbData = ({ id: id, index: index, ...legacyCrumb })=>({
            ...legacyCrumb,
            legacyId: id,
            type: 'legacy'
        });
    const $75132222441dd418$var$ContextBreadcrumbs = ({ ContextProvider: ContextProvider, ProjectBreadcrumb: ProjectBreadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, children: children })=>(0, ($parcel$interopDefault($eUqFw))).createElement(ContextProvider, null, ({ data: data })=>{
            if (!data) return children;
            const boardBreadcrumb = data.scope ? (0, ($parcel$interopDefault($eUqFw))).createElement(BoardBreadcrumb, {
                boardId: data.scope.id,
                boardName: data.scope.name || 'Board'
            }, children) : children;
            return data.contextType === 'user' ? (0, ($parcel$interopDefault($eUqFw))).createElement(UserBreadcrumb, {
                profileUrl: data.user.profileUrl,
                name: data.user.name
            }, boardBreadcrumb) : (0, ($parcel$interopDefault($eUqFw))).createElement(ProjectBreadcrumb, {
                projectKey: data.project.key,
                projectName: data.project.name,
                projectId: data.project.id,
                isSimplifiedProject: data.project.isSimplified
            }, boardBreadcrumb);
        });
    const $75132222441dd418$var$LegacyBreadcrumbConnector = ({ legacyTrail: legacyTrail, Breadcrumb: Breadcrumb, BoardBreadcrumb: BoardBreadcrumb, UserBreadcrumb: UserBreadcrumb, ProjectBreadcrumb: ProjectBreadcrumb, ContextProvider: ContextProvider })=>{
        const accumulateBreadcrumb = (accumulatedCrumbs, currentCrumb)=>(0, ($parcel$interopDefault($eUqFw))).createElement(Breadcrumb, {
                breadcrumb: currentCrumb
            }, accumulatedCrumbs);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($75132222441dd418$var$ContextBreadcrumbs, {
            BoardBreadcrumb: BoardBreadcrumb,
            ProjectBreadcrumb: ProjectBreadcrumb,
            UserBreadcrumb: UserBreadcrumb,
            ContextProvider: ContextProvider
        }, legacyTrail.map($75132222441dd418$var$toBreadcrumbData).reverse().reduce(accumulateBreadcrumb, null));
    };
    var $75132222441dd418$export$2e2bcd8739ae039 = $75132222441dd418$var$LegacyBreadcrumbConnector;
});
parcelRegister("i7f3H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$797e4a145a4e40c7$export$2e2bcd8739ae039);
    var $kFGm5 = parcelRequire("kFGm5");
    var $SEaoU = parcelRequire("SEaoU");
    var $lB25E = parcelRequire("lB25E");
    const $797e4a145a4e40c7$export$9f27bc3417b4524d = ({ children: children })=>{
        const [boardId] = (0, $lB25E.usePathParam)('boardId');
        const [rapidView] = (0, $lB25E.useQueryParam)('rapidView');
        const [{ data: ctxData, loading: loading, error: error }] = (0, $SEaoU.useContainerContext)();
        const data = ctxData == null || boardId != null || rapidView != null ? ctxData : (0, ($parcel$interopDefault($kFGm5)))(ctxData, 'scope');
        return children({
            data: data,
            loading: loading,
            error: error
        });
    };
    var $797e4a145a4e40c7$export$2e2bcd8739ae039 = $797e4a145a4e40c7$export$9f27bc3417b4524d;
});
parcelRegister("SEaoU", function(module, exports) {
    $parcel$export(module.exports, "useContainerContext", ()=>$753bd1908e635680$export$c7066c2d215990cf);
    $parcel$export(module.exports, "ContainerContextSubscriber", ()=>$753bd1908e635680$export$5b87a78c45d5dd17);
    var $eUqFw = parcelRequire("eUqFw");
    var $4MmfV = parcelRequire("4MmfV");
    var $kXWpU = parcelRequire("kXWpU");
    var $lB25E = parcelRequire("lB25E");
    var $e8UKN = parcelRequire("e8UKN");
    const $753bd1908e635680$var$useProjectContext = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)((0, $kXWpU.staticProjectSidebarNavigationResource));
        const projectContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getProjectContext)(data), [
            data
        ]);
        return [
            {
                data: projectContext,
                error: error,
                loading: loading
            },
            {
                fetch: refresh,
                refetch: refresh
            }
        ];
    };
    const $753bd1908e635680$var$useUserBoardContext = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)((0, $4MmfV.staticJSWUserBoardSidebarNavigationResource));
        const userContext = (0, $eUqFw.useMemo)(()=>data && (0, $e8UKN.getUserContext)(data), [
            data
        ]);
        return [
            {
                data: userContext,
                error: error,
                loading: loading
            },
            {
                fetch: refresh,
                refetch: refresh
            }
        ];
    };
    const $753bd1908e635680$export$c7066c2d215990cf = ()=>{
        const projectContext = $753bd1908e635680$var$useProjectContext();
        const userBoardContext = $753bd1908e635680$var$useUserBoardContext();
        if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
        return projectContext;
    };
    const $753bd1908e635680$export$5b87a78c45d5dd17 = (props)=>{
        const [data, actions] = $753bd1908e635680$export$c7066c2d215990cf();
        return props.children(data, actions);
    };
    $753bd1908e635680$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';
});
parcelRegister("4MmfV", function(module, exports) {
    $parcel$export(module.exports, "staticJSWUserBoardSidebarNavigationResource", ()=>$ca35414721fafc7a$export$5839dd8142de842e);
    var $gUUjF = parcelRequire("gUUjF");
    var $ElVpH = parcelRequire("ElVpH");
    var $lB25E = parcelRequire("lB25E");
    var $9SjeY = parcelRequire("9SjeY");
    const $ca35414721fafc7a$export$5839dd8142de842e = (0, $lB25E.createResource)({
        type: 'JIRA_USER_BOARD_NAVIGATION_RESOURCE',
        getKey: ({ match: match, query: query })=>{
            const boardId = (0, $ElVpH.getBoardId)(match, query);
            return boardId ? `board-${boardId}` : 'none';
        },
        getData: async ({ match: match, query: query })=>{
            const boardId = (0, $ElVpH.getBoardId)(match, query);
            if (boardId == null) return null;
            try {
                const response = await (0, $9SjeY.fetchUserBoardNavigationData)(boardId);
                return response;
            } catch (e) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('navigation-apps.resources.static-jsw-userboard-sidebar', 'Fail to fetch user board', e);
                return null;
            }
        },
        maxAge: 300000
    });
});
parcelRegister("9SjeY", function(module, exports) {
    $parcel$export(module.exports, "fetchUserBoardNavigationData", ()=>$7d7ff3f2c7ca5c69$export$306fb49fca60b34);
    var $lRmyA = parcelRequire("lRmyA");
    const $7d7ff3f2c7ca5c69$export$306fb49fca60b34 = (boardId)=>{
        if (boardId == null) throw new Error('invalid boardId');
        return (0, $lRmyA.performGetRequest)(`/rest/navigation/4/sidebar/people/boards/${boardId}`);
    };
});
parcelRegister("e8UKN", function(module, exports) {
    $parcel$export(module.exports, "getUserContext", ()=>$4c7bf04e2602d89a$export$114c35c2c23732ab);
    $parcel$export(module.exports, "getProjectContext", ()=>$4c7bf04e2602d89a$export$d17fffd59c7b3c60);
    var $7ZZxN = parcelRequire("7ZZxN");
    var $eWsAG = parcelRequire("eWsAG");
    const $4c7bf04e2602d89a$export$114c35c2c23732ab = (userBoardNavData)=>{
        const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
        return {
            contextType: 'user',
            user: {
                id: owner.id,
                name: owner.name,
                avatarUrl: owner.avatarUrl,
                profileUrl: owner.profileUrl,
                accountId: owner.accountId
            },
            scope: {
                id: boardInfo.id,
                type: boardInfo.type,
                name: boardInfo.name
            }
        };
    };
    const $4c7bf04e2602d89a$var$getScope = (projectNavInfo)=>{
        if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
            const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
            return {
                id: boardInfo.id,
                type: boardInfo.type,
                name: boardInfo.name
            };
        }
        return undefined;
    };
    const $4c7bf04e2602d89a$var$getProjectType = (projectType)=>{
        switch(projectType){
            case 'business':
                return 0, $7ZZxN.CORE_PROJECT;
            case 'software':
                return 0, $7ZZxN.SOFTWARE_PROJECT;
            case 'service_desk':
                return 0, $7ZZxN.SERVICE_DESK_PROJECT;
            case 'product_discovery':
                return 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT;
            default:
                return null;
        }
    };
    const $4c7bf04e2602d89a$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
        const project = (0, $eWsAG.extractData)(projectNavInfo);
        const scope = $4c7bf04e2602d89a$var$getScope(projectNavInfo);
        if (project) {
            const projectType = $4c7bf04e2602d89a$var$getProjectType(project.type);
            if (projectType) return {
                contextType: 'project',
                project: {
                    key: project.key,
                    id: project.id,
                    name: project.name,
                    type: projectType,
                    isSimplified: project.isSimplified,
                    avatarUrl: project.avatarUrl,
                    style: (0, $eWsAG.getStyle)(project.isSimplified)
                },
                scope: scope
            };
        }
        return null;
    };
});
parcelRegister("l02Yw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01f727a32ba5bcb5$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $lEfVV = parcelRequire("lEfVV");
    var $gUUjF = parcelRequire("gUUjF");
    var $c76ap = parcelRequire("c76ap");
    const $01f727a32ba5bcb5$var$LOCATION = 'breadcrumbs.legacy-adapter.legacy-renderer';
    class $01f727a32ba5bcb5$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
        componentDidCatch(error) {
            const { targetElement: targetElement } = this.props;
            const targetId = targetElement ? targetElement.id : 'not-found';
            (0, $gUUjF.default).safeErrorWithoutCustomerData($01f727a32ba5bcb5$var$LOCATION, `Failed to createPortal on ${targetId}`, error);
        }
        render() {
            const { targetElement: targetElement } = this.props;
            return (0, $lEfVV.createPortal)((0, ($parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null), targetElement);
        }
    }
});
parcelRegister("c76ap", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$157232e24a15a7c6$export$2e2bcd8739ae039);
    var $2Enn0 = parcelRequire("2Enn0");
    var $knPb9 = parcelRequire("knPb9");
    var $gd0Sp = parcelRequire("gd0Sp");
    var $7Eg4C = parcelRequire("7Eg4C");
    const $157232e24a15a7c6$var$fireAnalytics = (analyticsEvent)=>(0, $2Enn0.fireOperationalAnalytics)(analyticsEvent, {
            name: 'breadcrumbRendererMounted'
        });
    var $157232e24a15a7c6$export$2e2bcd8739ae039 = (0, $knPb9.default)((0, $7Eg4C.default), {
        onMount: $157232e24a15a7c6$var$fireAnalytics,
        TenantContextSubscriber: $gd0Sp.TenantContextSubscriber
    });
});
parcelRegister("7Eg4C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c269d0ea4cb311cb$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $eGI9v = parcelRequire("eGI9v");
    var $eI5EY = parcelRequire("eI5EY");
    var $6RcYY = parcelRequire("6RcYY");
    var $6FP8W = parcelRequire("6FP8W");
    var $bfY8R = parcelRequire("bfY8R");
    const $c269d0ea4cb311cb$var$mapTrailToBreadcrumbItems = (trail)=>trail.map((crumb)=>({
                ...crumb,
                target: crumb.target || '_self'
            }));
    const $c269d0ea4cb311cb$var$BreadcrumbRenderer = ({ onMount: onMount })=>{
        const [{ trail: trail }] = (0, $bfY8R.useBreadcrumbs)();
        const items = (0, $eUqFw.useMemo)(()=>$c269d0ea4cb311cb$var$mapTrailToBreadcrumbItems(trail), [
            trail
        ]);
        (0, $eUqFw.useEffect)(onMount, []);
        if ((0, $6FP8W.getWillShowNav4)() && (0, $eI5EY.fg)('jira_nav4_eap_drop_1')) return (0, ($parcel$interopDefault($eUqFw))).createElement($c269d0ea4cb311cb$var$BreadcrumbsWrapper, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6RcYY.default), {
            isVisible: true,
            items: items
        }));
        return (0, ($parcel$interopDefault($eUqFw))).createElement($c269d0ea4cb311cb$var$BreadcrumbsWrapperOld, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6RcYY.default), {
            isVisible: true,
            items: items
        }));
    };
    var $c269d0ea4cb311cb$export$2e2bcd8739ae039 = (0, $eGI9v.default)('breadcrumbsRenderer', {
        onMount: 'mounted'
    })($c269d0ea4cb311cb$var$BreadcrumbRenderer);
    const $c269d0ea4cb311cb$var$BreadcrumbsWrapperOld = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_1tke1tcg",
                __cmplp.className
            ])
        });
    });
    const $c269d0ea4cb311cb$var$BreadcrumbsWrapper = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_1tke1tcg _nwukkwex _1o8hu22k",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6RcYY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f4d601e3e8e4661b$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $5BRby = parcelRequire("5BRby");
    var $hNmmb = parcelRequire("hNmmb");
    function $f4d601e3e8e4661b$export$2e2bcd8739ae039(props) {
        const { isVisible: isVisible, items: items } = props;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hNmmb.default), {
            isVisible: isVisible,
            items: items
        }));
    }
});
parcelRegister("hNmmb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dce70756fb908cd7$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $8blac = parcelRequire("8blac");
    var $jG2Eu = parcelRequire("jG2Eu");
    var $6RwIf = parcelRequire("6RwIf");
    var $8SFtj = parcelRequire("8SFtj");
    var $5JgJ2 = parcelRequire("5JgJ2");
    var $lB25E = parcelRequire("lB25E");
    var $5ivsr = parcelRequire("5ivsr");
    var $5bE8c = parcelRequire("5bE8c");
    const $dce70756fb908cd7$export$67abef37aa2929b0 = (0, $eUqFw.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
            ...props,
            ref: ref,
            type: "a"
        }));
    function $dce70756fb908cd7$export$2e2bcd8739ae039(props) {
        const { isVisible: isVisible, items: items } = props;
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        return isVisible ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8SFtj.default), {
            onExpand: (0, ($parcel$interopDefault($jG2Eu)))
        }, (0, ($parcel$interopDefault($8blac)))(items) ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6RwIf.default), {
            text: "",
            "aria-label": formatMessage((0, $5bE8c.default).breadcrumbsLabel)
        }) : items.map((breadcrumb, index)=>{
            const breadcrumbItem = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5ivsr.default), {
                key: index,
                index: index,
                hasSeparator: true,
                text: breadcrumb.text,
                target: __SPA__ ? undefined : breadcrumb.target,
                href: breadcrumb.href,
                component: __SPA__ ? $dce70756fb908cd7$export$67abef37aa2929b0 : undefined,
                legacyId: breadcrumb.legacyId,
                type: breadcrumb.type,
                analyticsAttributes: breadcrumb.analyticsAttributes,
                analyticsFields: breadcrumb.analyticsFields
            });
            return breadcrumbItem;
        }))) : null;
    }
});
parcelRegister("6RwIf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f83fd518aec6307a$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $cmipe = parcelRequire("cmipe");
    var $4rANH = parcelRequire("4rANH");
    var $hhb6o = parcelRequire("hhb6o");
    function $f83fd518aec6307a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f83fd518aec6307a$var$itemWrapperStyles = (0, $byn9U.css)({
        display: 'flex',
        boxSizing: 'border-box',
        maxWidth: '100%',
        height: `${24 / 14}em`,
        margin: "var(--ds-space-0, 0px)",
        padding: "var(--ds-space-0, 0px)",
        flexDirection: 'row',
        '&:not(:last-child)::after': {
            width: '8px',
            flexShrink: 0,
            content: '"/"',
            paddingBlock: "var(--ds-space-025, 2px)",
            paddingInline: "var(--ds-space-100, 8px)",
            textAlign: 'center'
        }
    });
    const $f83fd518aec6307a$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
    const $f83fd518aec6307a$var$ICON_WIDTH_ESTIMATE = 24;
    const $f83fd518aec6307a$var$staticItemStyles = {
        name: "16sxe12",
        styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-025, 2px)"
    };
    const $f83fd518aec6307a$var$staticItemWithTruncationStyles = (0, $byn9U.css)({
        maxWidth: `var(${$f83fd518aec6307a$var$VAR_STEP_TRUNCATION_WIDTH})`
    });
    const $f83fd518aec6307a$var$staticItemWithoutTruncationStyles = {
        name: "1t1nv0p",
        styles: "min-width:0;flex-shrink:1"
    };
    const $f83fd518aec6307a$var$BreadcrumbsItem = (0, $eUqFw.memo)((props)=>{
        const buttonRef = (0, $eUqFw.useRef)(null);
        const { truncationWidth: truncationWidth, text: text, onTooltipShown: onTooltipShown, ...restButtonProps } = props;
        let iconWidthAllowance = 0;
        if (props.iconBefore) iconWidthAllowance += $f83fd518aec6307a$var$ICON_WIDTH_ESTIMATE;
        if (props.iconAfter) iconWidthAllowance += $f83fd518aec6307a$var$ICON_WIDTH_ESTIMATE;
        const [hasOverflow, showTooltip] = (0, $hhb6o.default)(truncationWidth, buttonRef.current, iconWidthAllowance);
        const buttonProps = {
            ...restButtonProps,
            ref: buttonRef,
            hasOverflow: hasOverflow
        };
        const dynamicItemStyles = {
            [$f83fd518aec6307a$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
        };
        const step = truncationWidth ? (0, $byn9U.jsx)((0, $4rANH.default), {
            ...buttonProps,
            css: [
                $f83fd518aec6307a$var$staticItemStyles,
                $f83fd518aec6307a$var$staticItemWithTruncationStyles
            ],
            style: dynamicItemStyles
        }, text) : (0, $byn9U.jsx)((0, $4rANH.default), {
            ...buttonProps,
            css: [
                $f83fd518aec6307a$var$staticItemStyles,
                $f83fd518aec6307a$var$staticItemWithoutTruncationStyles
            ]
        }, text);
        return (0, $byn9U.jsx)("li", {
            css: $f83fd518aec6307a$var$itemWrapperStyles
        }, showTooltip ? (0, $byn9U.jsx)((0, $cmipe.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown
        }, step) : step);
    });
    var $f83fd518aec6307a$export$2e2bcd8739ae039 = $f83fd518aec6307a$var$BreadcrumbsItem;
});
parcelRegister("4rANH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98d3c4940453c487$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $kRXtb = parcelRequire("kRXtb");
    var $lNqwd = parcelRequire("lNqwd");
    var $4oSDA = parcelRequire("4oSDA");
    const $98d3c4940453c487$var$analyticsAttributes = {
        componentName: 'breadcrumbsItem',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $98d3c4940453c487$var$noop = (0, $4oSDA.default);
    const $98d3c4940453c487$var$Step = (0, ($parcel$interopDefault($eUqFw))).forwardRef(({ hasOverflow: hasOverflow = true, href: href = '#', onClick: onClickProvided = $98d3c4940453c487$var$noop, analyticsContext: analyticsContext, iconBefore: iconBefore, iconAfter: iconAfter, ...props }, ref)=>{
        const handleClicked = (0, $kRXtb.usePlatformLeafEventHandler)({
            fn: onClickProvided,
            action: 'clicked',
            analyticsData: analyticsContext,
            ...$98d3c4940453c487$var$analyticsAttributes
        });
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lNqwd.default), {
            appearance: "subtle-link",
            spacing: "none",
            iconAfter: hasOverflow ? undefined : iconAfter,
            iconBefore: hasOverflow ? undefined : iconBefore,
            onClick: handleClicked,
            ref: ref,
            href: href,
            ...props
        });
    });
    var $98d3c4940453c487$export$2e2bcd8739ae039 = $98d3c4940453c487$var$Step;
});
parcelRegister("hhb6o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1548f1ce2b726c92$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    function $1548f1ce2b726c92$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
        const [hasOverflow, setOverflow] = (0, $eUqFw.useState)(true);
        const [showTooltip, setShowTooltip] = (0, $eUqFw.useState)(false);
        (0, $eUqFw.useEffect)(()=>{
            if (truncationWidth && buttonRefCurrent) {
                const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
                const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
                setOverflow(shouldOverflow);
                setShowTooltip(shouldShowTooltip);
            } else {
                setOverflow(false);
                setShowTooltip(false);
            }
        }, [
            truncationWidth,
            buttonRefCurrent,
            iconWidthAllowance
        ]);
        return [
            hasOverflow,
            showTooltip
        ];
    }
});
parcelRegister("8SFtj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$645f16e7292912d6$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $kRXtb = parcelRequire("kRXtb");
    var $9xS6A = parcelRequire("9xS6A");
    var $4oSDA = parcelRequire("4oSDA");
    var $crxO7 = parcelRequire("crxO7");
    var $kjWSg = parcelRequire("kjWSg");
    function $645f16e7292912d6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $645f16e7292912d6$var$defaultMaxItems = 8;
    const $645f16e7292912d6$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
    const $645f16e7292912d6$var$defaultEllipsisLabel = 'Show more breadcrumbs';
    const { toArray: $645f16e7292912d6$var$toArray } = (0, ($parcel$interopDefault($eUqFw))).Children;
    const $645f16e7292912d6$var$analyticsAttributes = {
        componentName: 'breadcrumbs',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $645f16e7292912d6$var$noop = (0, $4oSDA.default);
    const $645f16e7292912d6$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
    const $645f16e7292912d6$var$breadcrumbStyles = {
        name: "m6vsls",
        styles: "display:flex;margin:var(--ds-space-0, 0px);padding:var(--ds-space-0, 0px);flex-wrap:wrap"
    };
    const $645f16e7292912d6$var$InnerBreadcrumbs = (0, $eUqFw.forwardRef)((props, ref)=>{
        const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $645f16e7292912d6$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $645f16e7292912d6$var$noop, analyticsContext: analyticsContext, label: label = $645f16e7292912d6$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $645f16e7292912d6$var$defaultEllipsisLabel } = props;
        const [expanded, setExpanse] = (0, $eUqFw.useState)(defaultExpanded);
        const [isClickedBySpace, setExpansionTrigger] = (0, $eUqFw.useState)(false);
        const wrapperRef = (0, $eUqFw.useRef)(null);
        const isControlled = typeof isExpanded !== 'undefined';
        const isExpansionHandled = providedExpanse !== $645f16e7292912d6$var$noop;
        const shouldExpand = isControlled ? isExpanded : expanded;
        const focusFirstRevealed = ()=>{
            if (wrapperRef.current) {
                const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
                const interactiveElements = listItems.map((li)=>li.querySelector($645f16e7292912d6$var$interactiveElementSelector));
                const elementToFocus = interactiveElements[itemsBeforeCollapse];
                const firstInteractiveElement = interactiveElements[0];
                if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
                else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
                else wrapperRef.current.focus();
            }
            setExpansionTrigger(false);
        };
        (0, $kjWSg.useOnRevealed)(focusFirstRevealed, {
            isExpanded: shouldExpand,
            isDisabled: !isClickedBySpace
        });
        const handleExpansion = (0, $kRXtb.usePlatformLeafEventHandler)({
            fn: (event, analyticsEvent)=>{
                if (!isControlled) setExpanse((expanded)=>!expanded);
                if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
                return providedExpanse(event, analyticsEvent);
            },
            action: 'expanded',
            analyticsData: analyticsContext,
            ...$645f16e7292912d6$var$analyticsAttributes
        });
        const childrenArray = $645f16e7292912d6$var$toArray(children);
        const breadcrumbsArray = (0, ($parcel$interopDefault($eUqFw))).Children.map(childrenArray, (child, index)=>{
            if (typeof child === 'string') return child;
            return childrenArray.length - 1 === index ? (0, ($parcel$interopDefault($eUqFw))).cloneElement(child, {
                'aria-current': 'page'
            }) : child;
        });
        const renderItemsWithEllipsis = ()=>{
            const allItems = breadcrumbsArray;
            if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
            const beforeItems = allItems.slice(0, itemsBeforeCollapse);
            const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
            return [
                ...beforeItems,
                (0, $byn9U.jsx)((0, $crxO7.default), {
                    key: "ellipsis",
                    testId: testId && `${testId}--breadcrumb-ellipsis`,
                    onClick: handleExpansion,
                    label: ellipsisLabel
                }),
                ...afterItems
            ];
        };
        const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
        const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
        return (0, $byn9U.jsx)("nav", {
            "aria-label": label,
            ref: (0, $9xS6A.default)([
                ref,
                wrapperRef
            ]),
            tabIndex: -1
        }, (0, $byn9U.jsx)("ol", {
            "data-testid": testId,
            css: $645f16e7292912d6$var$breadcrumbStyles,
            style: {
                color: `var(--ds-text-subtlest, ${(0, $207acf722dcd432b$export$f563ee71e9ee74cd)})`
            }
        }, breadcrumbsItems));
    });
    const $645f16e7292912d6$var$Breadcrumbs = (0, $eUqFw.memo)((0, $eUqFw.forwardRef)((props, ref)=>{
        return (0, $byn9U.jsx)($645f16e7292912d6$var$InnerBreadcrumbs, {
            ...props,
            ref: ref
        });
    }));
    var $645f16e7292912d6$export$2e2bcd8739ae039 = $645f16e7292912d6$var$Breadcrumbs;
});
parcelRegister("crxO7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$824bfed9861225d4$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $lNqwd = parcelRequire("lNqwd");
    var $4oSDA = parcelRequire("4oSDA");
    function $824bfed9861225d4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $824bfed9861225d4$var$noop = (0, $4oSDA.default);
    const $824bfed9861225d4$var$itemWrapperStyles = (0, $byn9U.css)({
        display: 'flex',
        boxSizing: 'border-box',
        maxWidth: '100%',
        height: `${24 / 14}em`,
        margin: "var(--ds-space-0, 0px)",
        padding: "var(--ds-space-0, 0px)",
        flexDirection: 'row',
        '&:not(:last-child)::after': {
            width: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            content: '"/"',
            paddingBlock: "var(--ds-space-025, 2px)",
            paddingInline: "var(--ds-space-100, 8px)",
            textAlign: 'center'
        }
    });
    const $824bfed9861225d4$var$staticItemStyles = {
        name: "16sxe12",
        styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-block:var(--ds-space-025, 2px)"
    };
    const $824bfed9861225d4$var$EllipsisItem = (0, $eUqFw.memo)((props)=>{
        const { onClick: onClick = $824bfed9861225d4$var$noop, testId: testId, label: label } = props;
        return (0, $byn9U.jsx)("li", {
            css: $824bfed9861225d4$var$itemWrapperStyles
        }, (0, $byn9U.jsx)((0, $lNqwd.default), {
            appearance: "subtle-link",
            spacing: "none",
            testId: testId,
            onClick: onClick,
            "aria-label": label,
            css: $824bfed9861225d4$var$staticItemStyles
        }, "\u2026"));
    });
    var $824bfed9861225d4$export$2e2bcd8739ae039 = $824bfed9861225d4$var$EllipsisItem;
});
parcelRegister("kjWSg", function(module, exports) {
    $parcel$export(module.exports, "useOnRevealed", ()=>$c7d98d5bb713ce33$export$e9c4922b2ecf808a);
    var $eUqFw = parcelRequire("eUqFw");
    var $lnAMz = parcelRequire("lnAMz");
    function $c7d98d5bb713ce33$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
        const prevExtended = (0, $lnAMz.default)(isExpanded);
        (0, $eUqFw.useEffect)(()=>{
            const hasBeenRevealed = !prevExtended && isExpanded;
            if (!isDisabled && hasBeenRevealed) callback();
        }, [
            isExpanded,
            isDisabled,
            callback,
            prevExtended
        ]);
    }
});
parcelRegister("5ivsr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a590e2f2ad7c58d3$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $6RwIf = parcelRequire("6RwIf");
    var $iMMQz = parcelRequire("iMMQz");
    class $a590e2f2ad7c58d3$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
        static{
            this.defaultProps = {
                href: undefined,
                legacyId: undefined,
                type: 'unspecified',
                analyticsAttributes: {},
                analyticsFields: {}
            };
        }
        render() {
            const { index: index, text: text, target: target, href: href, component: component } = this.props;
            return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6RwIf.default), {
                key: index,
                text: text,
                onClick: this.onBreadCrumbClick,
                target: target,
                href: href,
                component: component
            });
        }
        constructor(...args){
            super(...args);
            this.onBreadCrumbClick = (event, analyticsEvent)=>{
                const { legacyId: legacyId, index: index, type: type, analyticsAttributes: analyticsAttributes, analyticsFields: analyticsFields } = this.props;
                (0, $iMMQz.fireUiAnalytics)(analyticsEvent, {
                    name: '',
                    attributes: {
                        legacyId: legacyId,
                        depth: index + 1,
                        type: type,
                        ...analyticsAttributes
                    },
                    ...analyticsFields
                });
            };
        }
    }
});
parcelRegister("iMMQz", function(module, exports) {
    $parcel$export(module.exports, "fireUiAnalytics", ()=>$087b448d474fca07$export$4909253b5bf1eed7);
    var $3LiTJ = parcelRequire("3LiTJ");
    var $etqm0 = parcelRequire("etqm0");
    var $klunD = parcelRequire("klunD");
    const $087b448d474fca07$var$isNotUndefined = (a)=>a !== undefined;
    const $087b448d474fca07$var$mapPayload = (payload)=>{
        const context = (0, $klunD.default)(payload);
        const { name: name } = payload;
        return (0, ($parcel$interopDefault($3LiTJ)))({
            ...context,
            ...context.attributes,
            attributes: undefined,
            name: name
        }, $087b448d474fca07$var$isNotUndefined);
    };
    const $087b448d474fca07$export$4909253b5bf1eed7 = (event, payload)=>{
        event.update({
            ...$087b448d474fca07$var$mapPayload(payload),
            analyticsType: (0, $etqm0.UI_EVENT_TYPE)
        }).fire();
    };
});
parcelRegister("5bE8c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19d3cfff259c7c19$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    var $19d3cfff259c7c19$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
        breadcrumbsLabel: {
            "id": "navigation-apps.breadcrumbs.aria-label",
            "defaultMessage": "Empty Breadcrumbs item"
        }
    });
});
parcelRegister("jU94X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1fec23ecbb70be91$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    const $1fec23ecbb70be91$var$compareBreadcrumbs = (a, b)=>a.index - b.index;
    const $1fec23ecbb70be91$var$defaultInitialState = {
        trail: [],
        targetElement: null
    };
    class $1fec23ecbb70be91$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
        static{
            this.defaultProps = {
                initialState: $1fec23ecbb70be91$var$defaultInitialState
            };
        }
        constructor(props){
            super(props);
            this.onInsertItem = (item)=>{
                this.setState((state)=>({
                        trail: [
                            ...state.trail,
                            item
                        ].sort($1fec23ecbb70be91$var$compareBreadcrumbs)
                    }));
            };
            this.onRemoveItem = (id)=>{
                this.setState((state)=>({
                        trail: state.trail.filter((b)=>b.id !== id)
                    }));
            };
            this.onTargetSet = (targetElement)=>{
                this.setState({
                    targetElement: targetElement
                });
            };
            this.api = {
                setTargetElement: this.onTargetSet,
                insertItem: this.onInsertItem,
                removeItem: this.onRemoveItem
            };
            this.state = props.initialState;
        }
        render() {
            const { children: children } = this.props;
            return children({
                state: this.state,
                api: this.api
            });
        }
    }
});
parcelRegister("6Q9xY", function(module, exports) {
    $parcel$export(module.exports, "LoadingPhaseManager", ()=>$00e2f5c25335239e$export$6e4bfef9e80c7eb0);
    var $eUqFw = parcelRequire("eUqFw");
    var $gAS98 = parcelRequire("gAS98");
    var $epT40 = parcelRequire("epT40");
    const $00e2f5c25335239e$export$6e4bfef9e80c7eb0 = ()=>{
        const [{ hasLoaded: hasLoaded }] = (0, $epT40.default)();
        const { resetPhase: resetPhase, startNextPhase: startNextPhase } = (0, $gAS98.useLazyPhase)();
        (0, $eUqFw.useEffect)(()=>{
            if (hasLoaded) {
                performance.mark('rll-after-paint-phase');
                startNextPhase();
            } else resetPhase();
        }, [
            hasLoaded,
            resetPhase,
            startNextPhase
        ]);
        return null;
    };
});
parcelRegister("egQj9", function(module, exports) {
    $parcel$export(module.exports, "TrackClicksBeforeTTI", ()=>$8480cc5e657aa91b$export$2846c12b8c092470);
    var $eUqFw = parcelRequire("eUqFw");
    var $jMP2a = parcelRequire("jMP2a");
    var $1inzG = parcelRequire("1inzG");
    var $h3mHU = parcelRequire("h3mHU");
    const $8480cc5e657aa91b$var$cleanUrl = (pathname)=>{
        let url = pathname.replace(/\/$/, '');
        if (/\/browse\/\w+$/.test(url)) url = 'browse';
        if (/[A-Z][A-Z0-9]+(-[\d]+)*/g.test(url)) url = url.replace(/[A-Z][A-Z0-9]+(-[\d]+)*/g, 'XX');
        return url;
    };
    const $8480cc5e657aa91b$export$2846c12b8c092470 = ()=>{
        const [{ isReady: isReady }] = (0, $h3mHU.useSpaStatePageReady)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        (0, $eUqFw.useEffect)(()=>{
            if (!isReady) return;
            try {
                const sessionStorageItems = sessionStorage.getItem('clicks-before-tti');
                if (sessionStorageItems == null || sessionStorageItems === '') return;
                const items = JSON.parse(sessionStorageItems);
                items.forEach((item)=>{
                    let extras = {
                        elementId: item.dataId,
                        currentUrl: $8480cc5e657aa91b$var$cleanUrl(item.currentUrl),
                        bundleId: item.bundleId,
                        time: item.time
                    };
                    if (item.redirectUrl !== '') extras = {
                        ...extras,
                        redirectUrl: $8480cc5e657aa91b$var$cleanUrl(item.redirectUrl)
                    };
                    (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                        action: 'clicked'
                    }), 'nonInteractiveElement clicked', '', extras);
                });
                sessionStorage.removeItem('clicks-before-tti');
            } catch (error) {
                console.error(error);
            }
        }, [
            createAnalyticsEvent,
            isReady
        ]);
        return null;
    };
});
parcelRegister("1YvhU", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("aCUnj")
    ]).then(()=>parcelRequire('es1Wq'));
});
parcelRegister("9desP", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("fV06J").then(()=>parcelRequire('ePK6n'));
});
parcelRegister("bWhFx", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("hwGR4").then(()=>parcelRequire('l6iDs'));
});
parcelRegister("V8FqF", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("1QTcH").then(()=>parcelRequire('4y252'));
});
parcelRegister("lJUyT", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("a7aUZ")
    ]).then(()=>parcelRequire('2J0VA'));
});
parcelRegister("gvsYN", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("jZhM1").then(()=>parcelRequire('lG0uN'));
});
parcelRegister("z8DAf", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("fAZBS").then(()=>parcelRequire('1r7p7'));
});
parcelRegister("69Ipc", function(module, exports) {
    $parcel$export(module.exports, "Banner", ()=>$bc08f35853510f48$export$3b4e64e77073e307);
    var $eUqFw = parcelRequire("eUqFw");
    var $c9TLT = parcelRequire("c9TLT");
    var $6e8MH = parcelRequire("6e8MH");
    var $1ybV0 = parcelRequire("1ybV0");
    var $9zysr = parcelRequire("9zysr");
    var $eI5EY = parcelRequire("eI5EY");
    var $4IEye = parcelRequire("4IEye");
    var $4Txs1 = parcelRequire("4Txs1");
    var $6FP8W = parcelRequire("6FP8W");
    var $hwyJ1 = parcelRequire("hwyJ1");
    var $ksulR = parcelRequire("ksulR");
    var $NzrZv = parcelRequire("NzrZv");
    var $7Rdn2 = parcelRequire("7Rdn2");
    var $bFh4f = parcelRequire("bFh4f");
    var $imSzy = parcelRequire("imSzy");
    var $j3cff = parcelRequire("j3cff");
    var $8fKcN = parcelRequire("8fKcN");
    var $bBqV2 = parcelRequire("bBqV2");
    var $4E80X = parcelRequire("4E80X");
    var $jK1pm = parcelRequire("jK1pm");
    var $3EdDr = parcelRequire("3EdDr");
    const $bc08f35853510f48$var$TEST_ID = 'page-layout.banner';
    const $bc08f35853510f48$export$496ffd8dda3bf451 = ()=>{
        const banner = (0, $ksulR.useBanner)();
        return banner.isEnabled ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "banner"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.Banner), {
            height: banner.height,
            testId: $bc08f35853510f48$var$TEST_ID
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($bc08f35853510f48$var$BannerContent, {
            bannerName: banner.name
        }))) : null;
    };
    const $bc08f35853510f48$export$b5cfff585ada92ce = ()=>{
        const banner = (0, $ksulR.useBanner)();
        return banner.isEnabled ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "banner"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3EdDr.ZIndexWrapper), {
            zIndex: (0, $c9TLT.layers).banner
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.Banner), {
            height: banner.height
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($bc08f35853510f48$var$BannerContent, {
            bannerName: banner.name
        })))) : null;
    };
    const $bc08f35853510f48$var$BannerContent = ({ bannerName: bannerName })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, bannerName === (0, $NzrZv.NAME) && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7Rdn2.BannerAnnouncementAsync), null), bannerName === (0, $4IEye.BANNER_NAME) && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4Txs1.IPBlocklistingBannerAsync), null), bannerName === (0, $bBqV2.BANNER_NAME) && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4E80X.ReturnToMobileBanner), null), bannerName === (0, $539c74e86514eccc$export$41956b146268af93) && (0, $eI5EY.fg)('jfp-magma-cookie-controls-banner-show') && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6e8MH.CookieConsentBannerAsync), null), (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && bannerName === (0, $bFh4f.BANNER_NAME) && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $imSzy.BannerTransitionAsync), null), bannerName === (0, $j3cff.BANNER_NAME) && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8fKcN.MailExpiryBannerAsync), null));
    const $bc08f35853510f48$export$3b4e64e77073e307 = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $bc08f35853510f48$export$496ffd8dda3bf451, $bc08f35853510f48$export$b5cfff585ada92ce);
});
const $539c74e86514eccc$export$41956b146268af93 = 'COOKIE_CONSENT_BANNER';
const $539c74e86514eccc$export$ed7cc0d417ee89e = 74;
const $539c74e86514eccc$export$ff6e18f7d82b549c = 320;
parcelRegister("6e8MH", function(module, exports) {
    $parcel$export(module.exports, "CookieConsentBannerAsync", ()=>$6ae4df6ce003b8ba$export$f110a9cbbbd3fa3a);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $jGR8u = parcelRequire("jGR8u");
    var $fHiYa = parcelRequire("fHiYa");
    var $0cdA8 = parcelRequire("0cdA8");
    var $gGtKh = parcelRequire("gGtKh");
    const $6ae4df6ce003b8ba$var$LazyCookieConsentBanner = (0, $56koX.lazy)(()=>(parcelRequire("4sLoh")).then(({ CookieConsentBanner: CookieConsentBanner })=>CookieConsentBanner), {
        moduleId: "./src/packages/platform/ui/banners/cookie-consent/src/ui/banner/index.tsx"
    });
    const $6ae4df6ce003b8ba$export$f110a9cbbbd3fa3a = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $6ae4df6ce003b8ba$var$boxStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "async-cookie-consent-banner",
            packageName: "jiraCookieConsentBanner",
            teamName: "Magma"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "async-cookie-consent-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($6ae4df6ce003b8ba$var$LazyCookieConsentBanner, null))));
    const $6ae4df6ce003b8ba$var$boxStyles = (0, $fHiYa.xcss)({
        backgroundColor: 'elevation.surface.sunken',
        height: '100%'
    });
});
parcelRegister("4sLoh", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("kL0QP")
    ]).then(()=>parcelRequire('lEX9v'));
});
parcelRegister("4IEye", function(module, exports) {
    $parcel$export(module.exports, "bannerHeight", ()=>$fcd3ab7edefdaf4a$export$86047f02632f9f5b);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$fcd3ab7edefdaf4a$export$41956b146268af93);
    var $c9TLT = parcelRequire("c9TLT");
    const $fcd3ab7edefdaf4a$export$86047f02632f9f5b = (0, $c9TLT.gridSize) * 7;
    const $fcd3ab7edefdaf4a$export$41956b146268af93 = 'IP_BLOCK_LISTING_BANNER';
});
parcelRegister("4Txs1", function(module, exports) {
    $parcel$export(module.exports, "IPBlocklistingBannerAsync", ()=>$2ebc627ad20df82b$export$fafc306b802ab39d);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $gGtKh = parcelRequire("gGtKh");
    const $2ebc627ad20df82b$var$IPBlocklistingBannerComp = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("67Q6Y")).then((m)=>m.IPBlocklistingBanner), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/ip-block-listing-banner/src/main.tsx"
    });
    const $2ebc627ad20df82b$export$fafc306b802ab39d = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "async-ip-block-listing-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($2ebc627ad20df82b$var$IPBlocklistingBannerComp, null));
});
parcelRegister("67Q6Y", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("dHXbi")
    ]).then(()=>parcelRequire('4hBj3'));
});
parcelRegister("ksulR", function(module, exports) {
    $parcel$export(module.exports, "useBanner", ()=>$1c81254a40e33e49$export$de40f69ba30f2376);
    var $eUqFw = parcelRequire("eUqFw");
    var $N5dQV = parcelRequire("N5dQV");
    var $1ybV0 = parcelRequire("1ybV0");
    var $eI5EY = parcelRequire("eI5EY");
    var $dFuN9 = parcelRequire("dFuN9");
    var $4u3Wx = parcelRequire("4u3Wx");
    var $4kPIV = parcelRequire("4kPIV");
    var $itibb = parcelRequire("itibb");
    var $9lf1N = parcelRequire("9lf1N");
    var $8NAHO = parcelRequire("8NAHO");
    const $1c81254a40e33e49$var$noBanner = {
        name: null,
        height: 0,
        isEnabled: false
    };
    const $1c81254a40e33e49$export$de40f69ba30f2376 = ()=>{
        const [isChromeless] = (0, $4u3Wx.useIsChromeless)();
        const announcement = (0, $4kPIV.useBannerAnnouncement)();
        const transition = (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') ? (0, $itibb.useBannerEocTransition)() : undefined;
        const returnToMobile = (0, $8NAHO.useBannerReturnToMobile)();
        const IPBlocklisting = (0, $dFuN9.useBannerIPBlocklisting)();
        const cookieConsent = (0, $eI5EY.fg)('jfp-magma-cookie-controls-banner-show') ? (0, $N5dQV.useBannerCookieConsent)() : undefined;
        const mailExpiry = (0, $9lf1N.useBannerMailExpiry)();
        return (0, $eUqFw.useMemo)(()=>{
            if (cookieConsent?.isEnabled) return cookieConsent;
            if (isChromeless) return $1c81254a40e33e49$var$noBanner;
            if (IPBlocklisting.isEnabled) return IPBlocklisting;
            if (returnToMobile.isEnabled) return returnToMobile;
            if (announcement.isEnabled) return announcement;
            if (transition?.isEnabled) return transition;
            if (mailExpiry?.isEnabled) return mailExpiry;
            return $1c81254a40e33e49$var$noBanner;
        }, [
            cookieConsent,
            isChromeless,
            IPBlocklisting,
            returnToMobile,
            announcement,
            transition,
            mailExpiry
        ]);
    };
});
parcelRegister("N5dQV", function(module, exports) {
    $parcel$export(module.exports, "useBannerCookieConsent", ()=>$42e2ac81d60d8dce$export$c7a51b5ee06f5794);
    var $eUqFw = parcelRequire("eUqFw");
    var $3cif2 = parcelRequire("3cif2");
    var $hM2VL = parcelRequire("hM2VL");
    var $aqZcy = parcelRequire("aqZcy");
    var $1ybV0 = parcelRequire("1ybV0");
    var $8LJqN = parcelRequire("8LJqN");
    var $8yXY1 = parcelRequire("8yXY1");
    var $4zIA4 = parcelRequire("4zIA4");
    const $42e2ac81d60d8dce$export$5503c67b1001ec45 = (data)=>{
        try {
            const shouldShowBannerBit = (0, $aqZcy.getCookie)((0, $3cif2.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
            const shouldShowBannerBitState = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
            return data && (0, $hM2VL.shouldRenderBannerPrefetched)(data) || shouldShowBannerBitState;
        } catch (e) {
            return true;
        }
    };
    const $42e2ac81d60d8dce$var$useBannerCookieConsentV2 = ()=>{
        const [{ isDismissed: isDismissed, height: height }, { onShow: onShow }] = (0, $4zIA4.useCookieConsentBannerSettings)();
        const { data: data } = (0, $8yXY1.useConsentBannerUserPreferencesResource)();
        (0, $eUqFw.useEffect)(()=>{
            const shouldRender = $42e2ac81d60d8dce$export$5503c67b1001ec45(data);
            if (shouldRender && !(0, $4zIA4.isInIframe)()) onShow();
        }, [
            data,
            onShow
        ]);
        return (0, $eUqFw.useMemo)(()=>({
                isEnabled: !isDismissed,
                name: (0, $539c74e86514eccc$export$41956b146268af93),
                height: height
            }), [
            isDismissed,
            height
        ]);
    };
    const $42e2ac81d60d8dce$var$useBannerCookieConsentV1 = ()=>{
        const [{ isDismissed: isDismissed, height: height }] = (0, $4zIA4.useCookieConsentBannerSettings)();
        return (0, $eUqFw.useMemo)(()=>({
                isEnabled: !isDismissed,
                name: (0, $539c74e86514eccc$export$41956b146268af93),
                height: height
            }), [
            isDismissed,
            height
        ]);
    };
    const $42e2ac81d60d8dce$export$c7a51b5ee06f5794 = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('platform.moonjelly.browser-storage-controls-v2'), $42e2ac81d60d8dce$var$useBannerCookieConsentV2, $42e2ac81d60d8dce$var$useBannerCookieConsentV1);
});
parcelRegister("3cif2", function(module, exports) {
    $parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", ()=>$2540a478abb0fbf1$export$10d7db8e1a856fd8);
    $parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", ()=>$2540a478abb0fbf1$export$435de28e5b000487);
    $parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", ()=>$2540a478abb0fbf1$export$4b17acc0e875ba2a);
    $parcel$export(module.exports, "ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY", ()=>$2540a478abb0fbf1$export$f57af01b64fc97b8);
    $parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", ()=>$2540a478abb0fbf1$export$23a1e02c3c0b0d08);
    $parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", ()=>$2540a478abb0fbf1$export$37073d560ecebada);
    $parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", ()=>$2540a478abb0fbf1$export$b28b5d760fe14a21);
    $parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", ()=>$2540a478abb0fbf1$export$4a12f9e99971760a);
    $parcel$export(module.exports, "DEFAULT_PREFERENCES", ()=>$2540a478abb0fbf1$export$f0fd1d13ec1d48f2);
    $parcel$export(module.exports, "V001_SCHEMA_KEY", ()=>$2540a478abb0fbf1$export$f95182b7aa141c57);
    $parcel$export(module.exports, "V002_SCHEMA_KEY", ()=>$2540a478abb0fbf1$export$1f25427b34f9c405);
    $parcel$export(module.exports, "V003_SCHEMA_KEY", ()=>$2540a478abb0fbf1$export$31deaeaebce525bb);
    var $3K9DW = parcelRequire("3K9DW");
    const $2540a478abb0fbf1$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
    const $2540a478abb0fbf1$export$435de28e5b000487 = 'atl-bsc-consent-token';
    const $2540a478abb0fbf1$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
    const $2540a478abb0fbf1$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
    const $2540a478abb0fbf1$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
    const $2540a478abb0fbf1$export$37073d560ecebada = 'atl-testing-consents';
    const $2540a478abb0fbf1$export$b28b5d760fe14a21 = {
        [(0, $3K9DW.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $3K9DW.PreferenceCategory).Functional]: true,
        [(0, $3K9DW.PreferenceCategory).Marketing]: true,
        [(0, $3K9DW.PreferenceCategory).Analytics]: true,
        [(0, $3K9DW.PreferenceCategory).Unknown]: true
    };
    const $2540a478abb0fbf1$export$4a12f9e99971760a = {
        [(0, $3K9DW.PreferenceCategory).StrictlyNecessary]: true,
        [(0, $3K9DW.PreferenceCategory).Functional]: false,
        [(0, $3K9DW.PreferenceCategory).Marketing]: false,
        [(0, $3K9DW.PreferenceCategory).Analytics]: false,
        [(0, $3K9DW.PreferenceCategory).Unknown]: false
    };
    const $2540a478abb0fbf1$export$f0fd1d13ec1d48f2 = {
        ...$2540a478abb0fbf1$export$4a12f9e99971760a,
        [(0, $3K9DW.ContextualConsentProperty).ConsentsAreDefault]: true,
        [(0, $3K9DW.ContextualConsentProperty).UserIsAuthenticated]: false,
        [(0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable]: true
    };
    const $2540a478abb0fbf1$export$f95182b7aa141c57 = '001';
    const $2540a478abb0fbf1$export$1f25427b34f9c405 = '002';
    const $2540a478abb0fbf1$export$31deaeaebce525bb = '003';
});
parcelRegister("3K9DW", function(module, exports) {
    $parcel$export(module.exports, "PreferenceCategory", ()=>$2b9d25e8678c97bc$export$ba064dbfe4bb66d7);
    $parcel$export(module.exports, "ConsentPreferenceV2", ()=>$2b9d25e8678c97bc$export$cdef20bac194f235);
    $parcel$export(module.exports, "ContextualConsentProperty", ()=>$2b9d25e8678c97bc$export$fac80ad19b60e313);
    $parcel$export(module.exports, "PrefetchedPreferenceState", ()=>$2b9d25e8678c97bc$export$5d6594a0bba4ab8a);
    $parcel$export(module.exports, "CachedKeysDataProperty", ()=>$2b9d25e8678c97bc$export$cd5dd043a4a3cfee);
    $parcel$export(module.exports, "Status", ()=>$2b9d25e8678c97bc$export$96e9906d6d93a972);
    let $2b9d25e8678c97bc$export$ba064dbfe4bb66d7 = function(PreferenceCategory) {
        PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
        PreferenceCategory["Functional"] = "FUNCTIONAL";
        PreferenceCategory["Marketing"] = "MARKETING";
        PreferenceCategory["Analytics"] = "ANALYTICS";
        PreferenceCategory["Unknown"] = "UNKNOWN";
        return PreferenceCategory;
    }({});
    let $2b9d25e8678c97bc$export$cdef20bac194f235 = function(ConsentPreferenceV2) {
        ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
        ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
        ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
        ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
        ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
        return ConsentPreferenceV2;
    }({});
    let $2b9d25e8678c97bc$export$fac80ad19b60e313 = function(ContextualConsentProperty) {
        ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
        ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
        ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
        return ContextualConsentProperty;
    }({});
    let $2b9d25e8678c97bc$export$5d6594a0bba4ab8a = function(PrefetchedPreferenceState) {
        PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
        return PrefetchedPreferenceState;
    }({});
    let $2b9d25e8678c97bc$export$cd5dd043a4a3cfee = function(CachedKeysDataProperty) {
        CachedKeysDataProperty["LocalStorage"] = "localStorageKeys";
        CachedKeysDataProperty["SessionStorage"] = "sessionStorageKeys";
        CachedKeysDataProperty["Cookies"] = "keys";
        CachedKeysDataProperty["ThirdParty"] = "thirdPartyKeys";
        return CachedKeysDataProperty;
    }({});
    let $2b9d25e8678c97bc$export$96e9906d6d93a972 = function(Status) {
        Status["SUCCESS"] = "SUCCESS";
        Status["BLOCKED"] = "BLOCKED";
        Status["FAILED"] = "FAILED";
        return Status;
    }({});
});
parcelRegister("hM2VL", function(module, exports) {
    $parcel$export(module.exports, "shouldRenderBannerPrefetched", ()=>$cf093153155f39d8$export$6406464aa126433e);
    var $cRRop = parcelRequire("cRRop");
    var $aiuhL = parcelRequire("aiuhL");
    var $jiA3Z = parcelRequire("jiA3Z");
    const $cf093153155f39d8$export$6406464aa126433e = (prefetchedPreferencesData)=>{
        if (!prefetchedPreferencesData) return true;
        if ('consentToken' in prefetchedPreferencesData) {
            const { isValid: isValid } = (0, $aiuhL.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
            return isValid ? (0, $jiA3Z.getBannerVisibility)(prefetchedPreferencesData) : true;
        }
        const consentPrefsData = (0, $cRRop.buildConsentPreferences)(prefetchedPreferencesData);
        return (0, $jiA3Z.getBannerVisibility)(consentPrefsData);
    };
});
parcelRegister("cRRop", function(module, exports) {
    $parcel$export(module.exports, "buildConsentPreferences", ()=>$95e3d9ee806ee37f$export$bd9f5bcbf9cd947c);
    $parcel$export(module.exports, "fetchConsentPreferences", ()=>$95e3d9ee806ee37f$export$86467566615ab85e);
    $parcel$export(module.exports, "saveConsentPreferences", ()=>$95e3d9ee806ee37f$export$f8422650c3dec8b2);
    var $8nVWJ = parcelRequire("8nVWJ");
    var $jeGRo = parcelRequire("jeGRo");
    const $95e3d9ee806ee37f$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
    const $95e3d9ee806ee37f$var$POST_CONSENTS_URL = `${$95e3d9ee806ee37f$var$BASE_CONSENTS_URL}/user`;
    const $95e3d9ee806ee37f$var$GET_CONSENTS_URL = `${$95e3d9ee806ee37f$var$POST_CONSENTS_URL}/consents/cookies`;
    const $95e3d9ee806ee37f$export$bd9f5bcbf9cd947c = (consentData)=>{
        if (consentData) {
            const serializedConsents = (0, $jeGRo.serializeConsents)(consentData);
            const consentTimestamp = (0, $jeGRo.getConsentTimestamp)(consentData);
            return {
                consentToken: serializedConsents,
                consentTimestamp: consentTimestamp
            };
        }
        return {
            consentToken: (0, $jeGRo.serializeConsents)({}),
            consentHubInaccessible: true
        };
    };
    const $95e3d9ee806ee37f$export$86467566615ab85e = async ()=>{
        const { origin: origin } = window.location;
        const getFromConsentHubURL = `${origin}${$95e3d9ee806ee37f$var$GET_CONSENTS_URL}`;
        try {
            const response = await fetch(getFromConsentHubURL, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
            const consentData = await response.json();
            return $95e3d9ee806ee37f$export$bd9f5bcbf9cd947c(consentData);
        } catch (err) {
            (0, $8nVWJ.Logger).errorWithOperationalEvent({
                action: 'fetchConsentPreferencesError',
                message: err.message || ''
            });
            return $95e3d9ee806ee37f$export$bd9f5bcbf9cd947c();
        }
    };
    const $95e3d9ee806ee37f$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
        const { origin: origin, pathname: pathname } = window.location;
        const deserializedConsents = (0, $jeGRo.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
        const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
        const consentRequestBody = {
            action: action,
            consents: deserializedConsents,
            formUrl: `${origin}${pathname}`,
            locale: 'UNKNOWN',
            site: 'atlassian',
            source: 'COOKIE_PREFERENCES'
        };
        return JSON.stringify(consentRequestBody);
    };
    const $95e3d9ee806ee37f$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
        const saveToConsentHubURL = `${window.location.origin}${$95e3d9ee806ee37f$var$POST_CONSENTS_URL}`;
        try {
            const response = await fetch(saveToConsentHubURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: $95e3d9ee806ee37f$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
            });
            if (!response.ok || response.status !== 202 && response.status !== 200) {
                const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
                const errWithStatusCode = new (0, $jeGRo.StatusCodeError)(errMsg, response.status);
                throw errWithStatusCode;
            }
        } catch (err) {
            (0, $8nVWJ.Logger).errorWithOperationalEvent({
                action: 'saveConsentPreferencesError',
                message: err.message || ''
            });
            throw err;
        }
    };
});
parcelRegister("jeGRo", function(module, exports) {
    $parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", ()=>$e010923ef8ffa7b3$export$42b0ca8aba2631e4);
    $parcel$export(module.exports, "checkIfTokenIsDefault", ()=>$e010923ef8ffa7b3$export$497a647f0eb30ef4);
    $parcel$export(module.exports, "serializeConsents", ()=>$e010923ef8ffa7b3$export$92ba0b2fe50f90df);
    $parcel$export(module.exports, "deserializeConsents", ()=>$e010923ef8ffa7b3$export$bfa0c91662787fb0);
    $parcel$export(module.exports, "getConsentTimestamp", ()=>$e010923ef8ffa7b3$export$13e4cff933f26b03);
    $parcel$export(module.exports, "checkIfConsentsAreStale", ()=>$e010923ef8ffa7b3$export$3387347b75450ae1);
    $parcel$export(module.exports, "StatusCodeError", ()=>$e010923ef8ffa7b3$export$a79c0ea3d7c2444a);
    var $fpgay = parcelRequire("fpgay");
    var $3cif2 = parcelRequire("3cif2");
    var $k4bKv = parcelRequire("k4bKv");
    var $3K9DW = parcelRequire("3K9DW");
    var $eHbAt = parcelRequire("eHbAt");
    const $e010923ef8ffa7b3$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
        const version = consentToken[0] + consentToken[1] + consentToken[2];
        const isV2Schema = version === (0, $3cif2.V002_SCHEMA_KEY);
        return isV2Schema;
    };
    const $e010923ef8ffa7b3$var$isLegacyV1Token = (consentToken)=>{
        const version = consentToken[0] + consentToken[1] + consentToken[2];
        const isV1Schema = version === (0, $3cif2.V001_SCHEMA_KEY);
        return isV1Schema;
    };
    const $e010923ef8ffa7b3$export$42b0ca8aba2631e4 = (consentToken)=>{
        if ($e010923ef8ffa7b3$var$isLegacyGeoTargetingV2Token(consentToken)) {
            const consentedUnderGDPR = consentToken[8] === '1';
            const consentedUnderCPRA = consentToken[9] === '1';
            const consentedUnderLGPD = consentToken[10] === '1';
            const consentedUnderFADP = consentToken[11] === '1';
            const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
            return hasConsentedPreviously;
        }
        return false;
    };
    const $e010923ef8ffa7b3$export$497a647f0eb30ef4 = (consentToken)=>{
        const isLegacyV2ConsentToken = $e010923ef8ffa7b3$var$isLegacyGeoTargetingV2Token(consentToken);
        const isLegacyV1ConsentToken = $e010923ef8ffa7b3$var$isLegacyV1Token(consentToken);
        if (isLegacyV2ConsentToken) {
            const legacyTokenHasConsents = $e010923ef8ffa7b3$export$42b0ca8aba2631e4(consentToken);
            return !legacyTokenHasConsents;
        }
        if (isLegacyV1ConsentToken) return false;
        const isDefaultToken = (0, $fpgay.getBoolFromBitValue)(consentToken[7]);
        return isDefaultToken;
    };
    const $e010923ef8ffa7b3$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
        const version = (0, $3cif2.V003_SCHEMA_KEY);
        const serializedBits = Object.entries((0, $3cif2.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
            if (key === (0, $3K9DW.PreferenceCategory).StrictlyNecessary) return acc;
            if (key === (0, $3K9DW.ContextualConsentProperty).UserIsAuthenticated) {
                const userIsAuthed = !consentsUnavailable;
                return acc + (0, $fpgay.getBitValueFromBool)(userIsAuthed);
            }
            if (key === (0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable) return acc + (0, $fpgay.getBitValueFromBool)(!!consentsUnavailable);
            return acc + (0, $fpgay.getBitValueFromBool)(val);
        }, '');
        return `${version}${serializedBits}`;
    };
    const $e010923ef8ffa7b3$export$42a0b3fb1e53e7b9 = (consents)=>{
        var _consents$find, _consents$find2, _consents$find3, _consents$find4;
        const version = (0, $3cif2.V003_SCHEMA_KEY);
        const functionalConsent = (0, $fpgay.getBitValueFromBool)(!!((_consents$find = consents.find((key)=>key.key === (0, $eHbAt.ConsentHubKey).Functional)) !== null && _consents$find !== void 0 && _consents$find.granted));
        const analyticsConsent = (0, $fpgay.getBitValueFromBool)(!!((_consents$find2 = consents.find((key)=>key.key === (0, $eHbAt.ConsentHubKey).Analytics)) !== null && _consents$find2 !== void 0 && _consents$find2.granted));
        const marketingConsent = (0, $fpgay.getBitValueFromBool)(!!((_consents$find3 = consents.find((key)=>key.key === (0, $eHbAt.ConsentHubKey).Marketing)) !== null && _consents$find3 !== void 0 && _consents$find3.granted));
        const unknownConsent = (0, $fpgay.getBitValueFromBool)(!!((_consents$find4 = consents.find((key)=>key.key === (0, $eHbAt.ConsentHubKey).Unknown)) !== null && _consents$find4 !== void 0 && _consents$find4.granted));
        const isDefaultToken = 0;
        const userIsAuthenticated = 1;
        const consentHubDataUnavailable = 0;
        return [
            version,
            functionalConsent,
            analyticsConsent,
            marketingConsent,
            unknownConsent,
            isDefaultToken,
            userIsAuthenticated,
            consentHubDataUnavailable
        ].join('');
    };
    const $e010923ef8ffa7b3$export$92ba0b2fe50f90df = ({ consents: consents })=>{
        if (!consents) {
            const existingFallbackToken = (0, $k4bKv.getCookie)((0, $3cif2.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
            if (existingFallbackToken) return existingFallbackToken;
            return $e010923ef8ffa7b3$export$c42e1a74e60f4d73(true);
        } else if (consents.length === 0) return $e010923ef8ffa7b3$export$c42e1a74e60f4d73();
        else return $e010923ef8ffa7b3$export$42a0b3fb1e53e7b9(consents);
    };
    const $e010923ef8ffa7b3$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
        const validConsentHubCookieConsents = [
            (0, $3K9DW.PreferenceCategory).StrictlyNecessary,
            (0, $3K9DW.PreferenceCategory).Functional,
            (0, $3K9DW.PreferenceCategory).Analytics,
            (0, $3K9DW.PreferenceCategory).Marketing,
            (0, $3K9DW.PreferenceCategory).Unknown
        ];
        const consentKeyMap = {
            [(0, $3K9DW.PreferenceCategory).StrictlyNecessary]: (0, $eHbAt.ConsentHubKey).StrictlyNecessary,
            [(0, $3K9DW.PreferenceCategory).Functional]: (0, $eHbAt.ConsentHubKey).Functional,
            [(0, $3K9DW.PreferenceCategory).Analytics]: (0, $eHbAt.ConsentHubKey).Analytics,
            [(0, $3K9DW.PreferenceCategory).Marketing]: (0, $eHbAt.ConsentHubKey).Marketing,
            [(0, $3K9DW.PreferenceCategory).Unknown]: (0, $eHbAt.ConsentHubKey).Unknown
        };
        const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
            const key = consentKeyMap[consentKey];
            return {
                key: key,
                granted: !!unpackedUserPreferences[consentKey],
                gatheredTs: new Date().toISOString(),
                displayedText: displayedTextMap[consentKey]
            };
        });
        return consentRecords;
    };
    const $e010923ef8ffa7b3$export$13e4cff933f26b03 = ({ consents: consents })=>{
        if (consents && consents.length) {
            const timestamps = consents.map((consent)=>{
                return new Date(consent.updatedTs).getTime();
            });
            const maxTimestamp = Math.max(...timestamps);
            const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
            return mostRecentConsentTimestamp;
        }
    };
    const $e010923ef8ffa7b3$export$3387347b75450ae1 = (consentTimestamp)=>{
        let consentedOverAYearAgo = false;
        if (consentTimestamp) {
            const oneYearAgo = new Date();
            oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
            consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
        }
        return consentedOverAYearAgo;
    };
    class $e010923ef8ffa7b3$export$a79c0ea3d7c2444a extends Error {
        constructor(message, status){
            super(message);
            this.status = status;
            Object.setPrototypeOf(this, $e010923ef8ffa7b3$export$a79c0ea3d7c2444a.prototype);
            if (Error.captureStackTrace) Error.captureStackTrace(this, $e010923ef8ffa7b3$export$a79c0ea3d7c2444a);
            this.name = 'StatusCodeError';
        }
    }
});
parcelRegister("fpgay", function(module, exports) {
    $parcel$export(module.exports, "getBitValueFromBool", ()=>$b375bbafcb145913$export$929f1500428a1fc8);
    $parcel$export(module.exports, "getBoolFromBitValue", ()=>$b375bbafcb145913$export$27647458f3cf29d2);
    const $b375bbafcb145913$export$929f1500428a1fc8 = (value)=>{
        return Number(value).toString();
    };
    const $b375bbafcb145913$export$27647458f3cf29d2 = (bitValue)=>{
        if (bitValue) return !!Number(bitValue);
    };
});
parcelRegister("eHbAt", function(module, exports) {
    $parcel$export(module.exports, "ConsentHubKey", ()=>$ab2e11dae8c3acb7$export$31140359b1e505cf);
    let $ab2e11dae8c3acb7$export$31140359b1e505cf = function(ConsentHubKey) {
        ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
        ConsentHubKey["Functional"] = "functionalCookies";
        ConsentHubKey["Analytics"] = "performanceCookies";
        ConsentHubKey["Marketing"] = "targetingCookies";
        ConsentHubKey["Unknown"] = "unknownCookies";
        return ConsentHubKey;
    }({});
});
parcelRegister("aiuhL", function(module, exports) {
    $parcel$export(module.exports, "checkTokenVersionValidity", ()=>$77f313df9adbbb1f$export$64b31470e8522819);
    $parcel$export(module.exports, "packUserPreferences", ()=>$77f313df9adbbb1f$export$3199823fec979bd1);
    $parcel$export(module.exports, "unpackUserPreferencesCookie", ()=>$77f313df9adbbb1f$export$8d213cb390bab4fa);
    $parcel$export(module.exports, "initialPreferencesAreMissing", ()=>$77f313df9adbbb1f$export$67f70eb55341bd29);
    $parcel$export(module.exports, "initializePreferencesData", ()=>$77f313df9adbbb1f$export$7962405c3ca274b1);
    var $iDwTy = parcelRequire("iDwTy");
    var $fpgay = parcelRequire("fpgay");
    var $3cif2 = parcelRequire("3cif2");
    var $jeGRo = parcelRequire("jeGRo");
    var $3K9DW = parcelRequire("3K9DW");
    const $77f313df9adbbb1f$export$64b31470e8522819 = (consentToken)=>{
        if (consentToken.length < 3) return {
            isValid: false,
            isV001: false,
            isV002: false,
            isV003: false
        };
        const version = consentToken[0] + consentToken[1] + consentToken[2];
        const isV001 = version === (0, $3cif2.V001_SCHEMA_KEY) && consentToken.length === 7;
        const isV002 = version === (0, $3cif2.V002_SCHEMA_KEY) && consentToken.length === 12;
        const isV003 = version === (0, $3cif2.V003_SCHEMA_KEY) && consentToken.length === 10;
        const isSupportedVersion = [
            (0, $3cif2.V001_SCHEMA_KEY),
            (0, $3cif2.V002_SCHEMA_KEY),
            (0, $3cif2.V003_SCHEMA_KEY)
        ].includes(version);
        const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
        return {
            isValid: isValid,
            isV001: isV001,
            isV002: isV002,
            isV003: isV003
        };
    };
    const $77f313df9adbbb1f$var$packPrefsVersion001 = (userPreferences)=>{
        const version = (0, $3cif2.V001_SCHEMA_KEY);
        return [
            version,
            (0, $fpgay.getBitValueFromBool)(userPreferences.FUNCTIONAL),
            (0, $fpgay.getBitValueFromBool)(userPreferences.ANALYTICS),
            (0, $fpgay.getBitValueFromBool)(userPreferences.MARKETING),
            (0, $fpgay.getBitValueFromBool)(userPreferences.UNKNOWN)
        ].join('');
    };
    const $77f313df9adbbb1f$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
        if (userPreferencesCookie.length !== 7) return;
        return {
            [(0, $3K9DW.PreferenceCategory).StrictlyNecessary]: true,
            [(0, $3K9DW.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
            [(0, $3K9DW.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
            [(0, $3K9DW.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
            [(0, $3K9DW.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
        };
    };
    const $77f313df9adbbb1f$var$packPrefsVersion002 = (userPreferences)=>{
        const version = (0, $3cif2.V003_SCHEMA_KEY);
        const hasConsentedPreviously = userPreferences[(0, $3K9DW.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $3K9DW.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $3K9DW.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $3K9DW.ConsentPreferenceV2).ConsentedUnderFADP];
        const isDefaultConsentBit = !hasConsentedPreviously;
        const existingConsentDataUnavailableBit = userPreferences[(0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable];
        const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
        return [
            version,
            (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Functional]),
            (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Analytics]),
            (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Marketing]),
            (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Unknown]),
            (0, $fpgay.getBitValueFromBool)(isDefaultConsentBit),
            (0, $fpgay.getBitValueFromBool)(userIsAuthenticatedBit),
            (0, $fpgay.getBitValueFromBool)(existingConsentDataUnavailableBit)
        ].join('');
    };
    const $77f313df9adbbb1f$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
        const isADefaultConsentToken = (0, $jeGRo.checkIfTokenIsDefault)(userPreferencesCookie);
        const consentDataUnavailable = userPreferencesCookie[7] === '1';
        const userIsDeemedAuthenticated = !consentDataUnavailable;
        return {
            ...$77f313df9adbbb1f$var$unpackPrefsVersion003(userPreferencesCookie),
            [(0, $3K9DW.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
            [(0, $3K9DW.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
            [(0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
        };
    };
    const $77f313df9adbbb1f$var$packPrefsVersion003 = (userPreferences)=>{
        const version = (0, $3cif2.V003_SCHEMA_KEY);
        return [
            version,
            (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Functional]),
            (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Analytics]),
            (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Marketing]),
            (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.PreferenceCategory).Unknown]),
            (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.ContextualConsentProperty).ConsentsAreDefault]),
            (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.ContextualConsentProperty).UserIsAuthenticated]),
            (0, $fpgay.getBitValueFromBool)(userPreferences[(0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable])
        ].join('');
    };
    const $77f313df9adbbb1f$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
        return {
            [(0, $3K9DW.PreferenceCategory).StrictlyNecessary]: true,
            [(0, $3K9DW.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
            [(0, $3K9DW.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
            [(0, $3K9DW.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
            [(0, $3K9DW.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
            [(0, $3K9DW.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
            [(0, $3K9DW.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
            [(0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
        };
    };
    const $77f313df9adbbb1f$var$V002SpecificBitKeys = [
        (0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable,
        (0, $3K9DW.ConsentPreferenceV2).ConsentedUnderGDPR,
        (0, $3K9DW.ConsentPreferenceV2).ConsentedUnderCPRA,
        (0, $3K9DW.ConsentPreferenceV2).ConsentedUnderLGPD,
        (0, $3K9DW.ConsentPreferenceV2).ConsentedUnderFADP
    ];
    const $77f313df9adbbb1f$var$V003SpecificBitKeys = [
        (0, $3K9DW.ContextualConsentProperty).ConsentsAreDefault,
        (0, $3K9DW.ContextualConsentProperty).UserIsAuthenticated,
        (0, $3K9DW.ContextualConsentProperty).ConsentDataUnavailable
    ];
    function $77f313df9adbbb1f$export$3199823fec979bd1(userPreferences) {
        if (!(0, $iDwTy.fg)('platform.moonjelly.browser-storage-controls-v2')) return $77f313df9adbbb1f$var$packPrefsVersion001(userPreferences);
        const isV002 = $77f313df9adbbb1f$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
        if (isV002) return $77f313df9adbbb1f$var$packPrefsVersion002(userPreferences);
        const isV003 = $77f313df9adbbb1f$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
        if (isV003) return $77f313df9adbbb1f$var$packPrefsVersion003(userPreferences);
        return $77f313df9adbbb1f$var$packPrefsVersion001(userPreferences);
    }
    function $77f313df9adbbb1f$export$8d213cb390bab4fa(userPreferencesCookie) {
        if (!(0, $iDwTy.fg)('platform.moonjelly.browser-storage-controls-v2')) {
            if (userPreferencesCookie.length < 3) return;
            const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
            if (version === (0, $3cif2.V001_SCHEMA_KEY)) return $77f313df9adbbb1f$var$unpackPrefsVersion001(userPreferencesCookie);
            return;
        }
        const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $77f313df9adbbb1f$export$64b31470e8522819(userPreferencesCookie);
        if (!isValid) return;
        if (isV001) return $77f313df9adbbb1f$var$unpackPrefsVersion001(userPreferencesCookie);
        if (isV002) return $77f313df9adbbb1f$var$unpackPrefsVersion002(userPreferencesCookie);
        if (isV003) return $77f313df9adbbb1f$var$unpackPrefsVersion003(userPreferencesCookie);
    }
    const $77f313df9adbbb1f$export$67f70eb55341bd29 = (initialPreferences)=>{
        if (!initialPreferences) return true;
        const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
        return prefExistButAreEmpty;
    };
    const $77f313df9adbbb1f$export$7962405c3ca274b1 = (initialPreferences)=>{
        if (initialPreferences !== (0, $3K9DW.PrefetchedPreferenceState).INTERNAL) {
            if ($77f313df9adbbb1f$export$67f70eb55341bd29(initialPreferences)) return {
                prefs: undefined,
                isPrefetchedPrefsInternalState: true
            };
            const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
            if (consentToken) {
                const unpackedExistingPrefs = $77f313df9adbbb1f$export$8d213cb390bab4fa(consentToken);
                return {
                    prefs: unpackedExistingPrefs,
                    isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
                };
            }
            if (initialPreferences && 'consents' in initialPreferences) {
                const serializedPrefetchedConsentToken = (0, $jeGRo.serializeConsents)(initialPreferences);
                const unpackedPrefetchedPrefs = $77f313df9adbbb1f$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
                return {
                    prefs: unpackedPrefetchedPrefs,
                    isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
                };
            }
        }
        if (initialPreferences === (0, $3K9DW.PrefetchedPreferenceState).INTERNAL) return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: false
        };
    };
});
parcelRegister("jiA3Z", function(module, exports) {
    $parcel$export(module.exports, "getBannerVisibility", ()=>$e0cbac3259c12cbf$export$bfdb9f82a9194c1e);
    var $jyzhV = parcelRequire("jyzhV");
    var $fpgay = parcelRequire("fpgay");
    var $3cif2 = parcelRequire("3cif2");
    var $jeGRo = parcelRequire("jeGRo");
    var $k4bKv = parcelRequire("k4bKv");
    var $aiuhL = parcelRequire("aiuhL");
    const $e0cbac3259c12cbf$var$getUserIsAuthenticatedBit = (consentToken)=>{
        const { isV002: isV002 } = (0, $aiuhL.checkTokenVersionValidity)(consentToken);
        let userIsAuthenticatedBit = consentToken[8];
        if (isV002) {
            const legacyV2ConsentDataUnavailableBit = consentToken[7];
            userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
        }
        return userIsAuthenticatedBit;
    };
    const $e0cbac3259c12cbf$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
        if (fallbackConsentToken) {
            const fallbackUserIsAuthenticatedBit = $e0cbac3259c12cbf$var$getUserIsAuthenticatedBit(fallbackConsentToken);
            const isLoggedOutFallbackConsents = !(0, $fpgay.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
            const fallbackTokenHasGenuineConsents = !(0, $jeGRo.checkIfTokenIsDefault)(fallbackConsentToken);
            const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
            if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
            const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
            if (loggedOutUserPreviouslyConsentedWhileLoggedIn) return false;
        }
        return true;
    };
    const $e0cbac3259c12cbf$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
        const tokenIsADefaultConsent = !!(0, $jeGRo.checkIfTokenIsDefault)(consentToken);
        if (tokenIsADefaultConsent) return $e0cbac3259c12cbf$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
        const localOnlyUserHasConsented = (0, $jeGRo.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
        if (localOnlyUserHasConsented) return fallbackConsentToken ? false : true;
        return true;
    };
    const $e0cbac3259c12cbf$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
        if (fallbackConsentToken) {
            const fallbackUserIsAuthenticatedBit = $e0cbac3259c12cbf$var$getUserIsAuthenticatedBit(fallbackConsentToken);
            const isLoggedOutFallbackConsents = !(0, $fpgay.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
            const fallbackTokenHasGenuineConsents = !(0, $jeGRo.checkIfTokenIsDefault)(fallbackConsentToken);
            if (fallbackTokenHasGenuineConsents) {
                if (isLoggedOutFallbackConsents) return true;
                return false;
            }
            return true;
        }
        return true;
    };
    const $e0cbac3259c12cbf$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
        const tokenIsADefaultConsent = !!(0, $jeGRo.checkIfTokenIsDefault)(consentToken);
        if (tokenIsADefaultConsent) return $e0cbac3259c12cbf$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
        if (consentTimestamp) {
            const showBannerIfStale = (0, $jeGRo.checkIfConsentsAreStale)(consentTimestamp);
            return showBannerIfStale;
        }
        return fallbackConsentToken ? false : true;
    };
    const $e0cbac3259c12cbf$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents })=>{
        const fallbackConsentToken = (0, $jyzhV.isSSR)() ? fallbackConsents : fallbackConsents || (0, $k4bKv.getCookie)((0, $3cif2.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        let userIsAuthenticatedBit = $e0cbac3259c12cbf$var$getUserIsAuthenticatedBit(consentToken);
        const isLoggedOutConsentToken = !(0, $fpgay.getBoolFromBitValue)(userIsAuthenticatedBit);
        let isBannerVisible = true;
        if (isLoggedOutConsentToken) isBannerVisible = $e0cbac3259c12cbf$var$shouldShowBannerForLoggedOutUser({
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken
        });
        else isBannerVisible = $e0cbac3259c12cbf$var$shouldShowBannerForLoggedInUser({
            consentToken: consentToken,
            fallbackConsentToken: fallbackConsentToken,
            consentTimestamp: consentTimestamp
        });
        return isBannerVisible;
    };
});
parcelRegister("8yXY1", function(module, exports) {
    $parcel$export(module.exports, "consentBannerUserPreferencesResource", ()=>$9d378f53ff5588a3$export$785c22104b6f2285);
    $parcel$export(module.exports, "useConsentBannerUserPreferencesResource", ()=>$9d378f53ff5588a3$export$5bc7e83e85567fb4);
    var $3cif2 = parcelRequire("3cif2");
    var $aqZcy = parcelRequire("aqZcy");
    var $eI5EY = parcelRequire("eI5EY");
    var $lRmyA = parcelRequire("lRmyA");
    var $lB25E = parcelRequire("lB25E");
    const $9d378f53ff5588a3$export$785c22104b6f2285 = (0, $lB25E.createResource)({
        type: (0, $915023b8afa83aa8$export$c5397b7748ed6c7b),
        getKey: ()=>(0, $915023b8afa83aa8$export$4a9dd42dbc707155),
        getData: async ()=>{
            const consentToken = (0, $aqZcy.getCookie)((0, $3cif2.ATLASSIAN_CONSENT_COOKIE_KEY));
            const fallbackConsentToken = (0, $aqZcy.getCookie)((0, $3cif2.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
            if ((0, $eI5EY.fg)('jfp-magma-browser-storage-bump-3')) {
                if (consentToken) return {
                    consentToken: consentToken,
                    fallbackConsentToken: fallbackConsentToken
                };
            } else {
                const currentLocale = (0, $aqZcy.getCookie)((0, $3cif2.ATLASSIAN_CURRENT_LOCALE_COOKIE_KEY));
                if (consentToken && currentLocale) return {
                    consentToken: consentToken,
                    currentLocale: currentLocale,
                    fallbackConsentToken: fallbackConsentToken
                };
            }
            const data = await (0, $lRmyA.performGetRequest)('/gateway/api/consenthub/session/user/consents/cookies');
            return data;
        },
        maxAge: 900000,
        isBrowserOnly: true
    });
    const $9d378f53ff5588a3$export$5bc7e83e85567fb4 = ()=>(0, $lB25E.useResource)($9d378f53ff5588a3$export$785c22104b6f2285);
});
const $915023b8afa83aa8$export$c5397b7748ed6c7b = 'CONSENT_BANNER_USER_PREFERENCES';
const $915023b8afa83aa8$export$4a9dd42dbc707155 = 'CONSENT_BANNER_USER_PREFERENCES_KEY';
parcelRegister("4zIA4", function(module, exports) {
    $parcel$export(module.exports, "isInIframe", ()=>$1e803e8843969244$export$9f140ed41af5108c);
    $parcel$export(module.exports, "useCookieConsentBannerSettings", ()=>$1e803e8843969244$export$ae97931560f092a4);
    $parcel$export(module.exports, "useCookieConsentBannerSettingsActions", ()=>$1e803e8843969244$export$ecbab4dc5f9ad844);
    var $k4bKv = parcelRequire("k4bKv");
    var $3cif2 = parcelRequire("3cif2");
    var $1ybV0 = parcelRequire("1ybV0");
    var $WBLbN = parcelRequire("WBLbN");
    function $1e803e8843969244$export$8d213cb390bab4fa(userPreferencesCookie) {
        if (userPreferencesCookie.length < 3) return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version !== '001') return;
        if (userPreferencesCookie.length !== 7) return;
        return {
            STRICTLY_NECESSARY: true,
            FUNCTIONAL: userPreferencesCookie[3] === '1',
            ANALYTICS: userPreferencesCookie[4] === '1',
            MARKETING: userPreferencesCookie[5] === '1',
            UNKNOWN: userPreferencesCookie[6] === '1'
        };
    }
    const $1e803e8843969244$export$1de6a888ae076ff8 = ()=>{
        if (false) return undefined;
        const packedPrefs = (0, $k4bKv.getCookie)((0, $3cif2.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return $1e803e8843969244$export$8d213cb390bab4fa(packedPrefs);
    };
    const $1e803e8843969244$export$9f140ed41af5108c = ()=>{
        if (false) return false;
        return window !== window.top;
    };
    const $1e803e8843969244$export$aa1483cc2e197f6e = ()=>{
        if (false) return false;
        if ((0, $1ybV0.ff)('platform.moonjelly.browser-storage-controls-v2')) return true;
        return $1e803e8843969244$export$1de6a888ae076ff8() !== undefined || $1e803e8843969244$export$9f140ed41af5108c();
    };
    const $1e803e8843969244$export$d4c72bab9d6cc13a = {
        isDismissed: $1e803e8843969244$export$aa1483cc2e197f6e(),
        height: 0
    };
    const $1e803e8843969244$export$e324594224ef24da = {
        onShow: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isDismissed: false
                });
            },
        onDismiss: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isDismissed: true
                });
            },
        setHeight: (height)=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    height: height
                });
            }
    };
    const $1e803e8843969244$var$Store = (0, $WBLbN.createStore)({
        name: 'cookie-consent-banner',
        initialState: $1e803e8843969244$export$d4c72bab9d6cc13a,
        actions: $1e803e8843969244$export$e324594224ef24da
    });
    const $1e803e8843969244$export$ae97931560f092a4 = (0, $WBLbN.createHook)($1e803e8843969244$var$Store);
    const $1e803e8843969244$export$ecbab4dc5f9ad844 = (0, $WBLbN.createActionsHook)($1e803e8843969244$var$Store);
});
parcelRegister("dFuN9", function(module, exports) {
    $parcel$export(module.exports, "useBannerIPBlocklisting", ()=>$819d943e99d1c80d$export$564412c1d9cd4ccc);
    var $eUqFw = parcelRequire("eUqFw");
    var $ds5Im = parcelRequire("ds5Im");
    var $4IEye = parcelRequire("4IEye");
    const $819d943e99d1c80d$export$564412c1d9cd4ccc = ()=>{
        const [shouldShowBanner, setBannerState] = (0, $eUqFw.useState)(false);
        (0, $eUqFw.useEffect)(()=>{
            (0, $ds5Im.loadBridgeWeak)({
                name: 'jira/global-components/ipblocklisting/bridge'
            }).then((bridge)=>{
                bridge({
                    showIPBlocklistBanner: ()=>setBannerState(true),
                    hideIPBlocklistBanner: ()=>setBannerState(false)
                });
            });
        }, []);
        return (0, $eUqFw.useMemo)(()=>({
                isEnabled: shouldShowBanner,
                name: (0, $4IEye.BANNER_NAME),
                height: (0, $4IEye.bannerHeight)
            }), [
            shouldShowBanner
        ]);
    };
});
parcelRegister("4kPIV", function(module, exports) {
    $parcel$export(module.exports, "useBannerAnnouncement", ()=>$3578e31f85c09ba1$export$1e775b1ab04f2888);
    var $eUqFw = parcelRequire("eUqFw");
    var $a5Lgz = parcelRequire("a5Lgz");
    var $6yplV = parcelRequire("6yplV");
    var $NzrZv = parcelRequire("NzrZv");
    const $3578e31f85c09ba1$export$1e775b1ab04f2888 = ()=>{
        const { data: data } = (0, $a5Lgz.useAnnouncementBannerSettingsV4Resource)();
        const isAnonymous = (0, $6yplV.useIsAnonymous)();
        return (0, $eUqFw.useMemo)(()=>({
                isEnabled: Boolean(data?.isEnabled) && !data?.isDismissed && (data?.visibility === 'private' && !isAnonymous || data?.visibility === 'public'),
                name: (0, $NzrZv.NAME),
                height: (0, $NzrZv.HEIGHT)
            }), [
            data?.isDismissed,
            data?.isEnabled,
            data?.visibility,
            isAnonymous
        ]);
    };
});
parcelRegister("a5Lgz", function(module, exports) {
    $parcel$export(module.exports, "announcementBannerSettingsV4Resource", ()=>$7a3ce10da4ecebac$export$8fbe7f8de07afffd);
    $parcel$export(module.exports, "useAnnouncementBannerSettingsV4Resource", ()=>$7a3ce10da4ecebac$export$6fb72f4a0c177494);
    var $lB25E = parcelRequire("lB25E");
    var $iXfYO = parcelRequire("iXfYO");
    var $jF6Sk = parcelRequire("jF6Sk");
    var $6abiR = parcelRequire("6abiR");
    const $7a3ce10da4ecebac$export$2a421cd16fa9a95a = (0, $lB25E.createResource)({
        type: 'ANNOUNCEMENT_BANNER_SETTINGS',
        getKey: ()=>'settings',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
            const [settings, hashIdLastDimissed] = await Promise.all([
                (0, $jF6Sk.get)(),
                (0, $6abiR.get)(atlassianAccountId)
            ]);
            return {
                ...settings,
                isDismissable: isAnonymous ? false : settings?.isDismissable,
                isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
            };
        },
        maxAge: 900000
    });
    const $7a3ce10da4ecebac$export$8fbe7f8de07afffd = (0, $lB25E.createResource)({
        type: 'ANNOUNCEMENT_BANNER_SETTINGS_V4',
        getKey: ()=>'settings',
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } })=>{
            const [settings, hashIdLastDimissed] = await Promise.all([
                (0, $iXfYO.get)(),
                (0, $6abiR.get)(atlassianAccountId)
            ]);
            return {
                ...settings,
                isDismissable: isAnonymous ? false : settings?.isDismissable,
                isDismissed: isAnonymous ? false : settings?.hashId === hashIdLastDimissed
            };
        },
        maxAge: 900000
    });
    const $7a3ce10da4ecebac$export$43d4950a3e443fd3 = ()=>(0, $lB25E.useResource)($7a3ce10da4ecebac$export$2a421cd16fa9a95a);
    const $7a3ce10da4ecebac$export$6fb72f4a0c177494 = ()=>(0, $lB25E.useResource)($7a3ce10da4ecebac$export$8fbe7f8de07afffd);
});
parcelRegister("iXfYO", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$58a9dca49db86568$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$58a9dca49db86568$export$adaa4cf7ef1b65be);
    var $guiFP = parcelRequire("guiFP");
    var $lRmyA = parcelRequire("lRmyA");
    const $58a9dca49db86568$export$3988ae62b71be9a3 = async ()=>{
        try {
            return await (0, $lRmyA.performGetRequest)('/rest/internal/4/announcement-banner');
        } catch (error) {
            if (error.statusCode === 403) return {
                content: '',
                bgColor: 'grey',
                isEnabled: false,
                isDismissable: false,
                visibility: 'private',
                hashId: ''
            };
            (0, $guiFP.default)({
                meta: {
                    id: 'settingsV4Get',
                    packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                    teamName: 'jira-cosmos'
                },
                error: error
            });
            throw error;
        }
    };
    const $58a9dca49db86568$export$adaa4cf7ef1b65be = async (body)=>{
        try {
            return await (0, $lRmyA.performPostRequest)('/rest/internal/4/announcement-banner', {
                body: JSON.stringify(body)
            });
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'settingsV4Set',
                    packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
                    teamName: 'jira-cosmos'
                },
                error: error
            });
            throw error;
        }
    };
});
parcelRegister("jF6Sk", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$baaff1b2e6f1885b$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$baaff1b2e6f1885b$export$adaa4cf7ef1b65be);
    var $guiFP = parcelRequire("guiFP");
    var $lRmyA = parcelRequire("lRmyA");
    const $baaff1b2e6f1885b$export$3988ae62b71be9a3 = async ()=>{
        try {
            return await (0, $lRmyA.performGetRequest)('/rest/internal/3/announcement-banner');
        } catch (error) {
            if (error.statusCode === 403) return {
                message: '',
                isEnabled: false,
                isDismissable: false,
                visibility: 'private',
                hashId: ''
            };
            (0, $guiFP.trackFetchErrors)({
                error: error,
                id: 'settingsGet',
                packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
    const $baaff1b2e6f1885b$export$adaa4cf7ef1b65be = async (body)=>{
        try {
            return await (0, $lRmyA.performPostRequest)('/rest/internal/3/announcement-banner', {
                body: JSON.stringify(body)
            });
        } catch (error) {
            (0, $guiFP.trackFetchErrors)({
                error: error,
                id: 'settingsSet',
                packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
});
const $6015420733166380$export$b8b9d90f9e5bd72b = '@atlassian/jira-admin-pages-system-ui-announcement-banner-resources';
const $6015420733166380$export$5e0c0e8c940630f8 = 'private';
const $6015420733166380$export$1d5a5b6462188eb3 = 'public';
parcelRegister("6abiR", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$5e6a63cc908ec028$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$5e6a63cc908ec028$export$adaa4cf7ef1b65be);
    var $48bs8 = parcelRequire("48bs8");
    var $guiFP = parcelRequire("guiFP");
    const $5e6a63cc908ec028$var$key = 'announcementBannerDismissedLast';
    const $5e6a63cc908ec028$export$3988ae62b71be9a3 = async (accoundId)=>{
        try {
            return accoundId != null ? (await (0, $48bs8.getUserProperty)(accoundId, $5e6a63cc908ec028$var$key)).hashId : null;
        } catch (error) {
            if (error.statusCode === 404) return null;
            (0, $guiFP.trackFetchErrors)({
                error: error,
                id: 'userDismissGet',
                packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
    const $5e6a63cc908ec028$export$adaa4cf7ef1b65be = async (accoundId, hashId)=>{
        try {
            return await (0, $48bs8.setUserProperties)(accoundId, $5e6a63cc908ec028$var$key, JSON.stringify({
                hashId: hashId
            }));
        } catch (error) {
            (0, $guiFP.trackFetchErrors)({
                error: error,
                id: 'userDismissSet',
                packageName: (0, $6015420733166380$export$b8b9d90f9e5bd72b)
            });
            throw error;
        }
    };
});
parcelRegister("6yplV", function(module, exports) {
    $parcel$export(module.exports, "useIsAnonymous", ()=>$650b84b1a3eacbd8$export$bf7b5d502f6d6d3b);
    var $gd0Sp = parcelRequire("gd0Sp");
    const $650b84b1a3eacbd8$export$bf7b5d502f6d6d3b = ()=>{
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        return tenantContext && tenantContext.isAnonymous;
    };
});
parcelRegister("NzrZv", function(module, exports) {
    $parcel$export(module.exports, "HEIGHT", ()=>$ed164e6dadc08c71$export$809d2b099693a9a8);
    $parcel$export(module.exports, "NAME", ()=>$ed164e6dadc08c71$export$3c5e605ca7ade9f2);
    var $c9TLT = parcelRequire("c9TLT");
    const $ed164e6dadc08c71$export$809d2b099693a9a8 = (0, $c9TLT.gridSize) * 8;
    const $ed164e6dadc08c71$export$3c5e605ca7ade9f2 = 'ANNOUNCEMENT';
});
parcelRegister("itibb", function(module, exports) {
    $parcel$export(module.exports, "useBannerEocTransition", ()=>$60fbf3301c9b1d1e$export$b6539a8209f95b48);
    var $eUqFw = parcelRequire("eUqFw");
    var $hhjRL = parcelRequire("hhjRL");
    var $9z07y = parcelRequire("9z07y");
    var $h4Fhh = parcelRequire("h4Fhh");
    var $c7H0g = parcelRequire("c7H0g");
    var $1R3n5 = parcelRequire("1R3n5");
    var $bFh4f = parcelRequire("bFh4f");
    const $60fbf3301c9b1d1e$export$b6539a8209f95b48 = ()=>{
        const { data: data, error: error } = (0, $hhjRL.useOgConsolidationUserState)();
        const isAdmin = (0, $c7H0g.useIsAdmin)();
        const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
        const { isTransitionEligible: isTransitionEligible, error: tenantInfoError } = (0, $h4Fhh.useOgTenantInfo)();
        const isEnabled = Boolean((isAdmin || isSiteAdmin) && !tenantInfoError && isTransitionEligible && !error && data && (!data.isTransitionBannerDismissed || (0, $9z07y.shouldRenderBenefitModal)({
            bannerDismissedAt: data.transitionBannerDismissedAt,
            isDismissed: data.isBenefitModalDismissed
        })));
        return (0, $eUqFw.useMemo)(()=>({
                isEnabled: isEnabled,
                name: (0, $bFh4f.BANNER_NAME),
                height: data && (0, $9z07y.shouldRenderBenefitModal)({
                    bannerDismissedAt: data.transitionBannerDismissedAt
                }) ? 0 : (0, $bFh4f.HEIGHT)
            }), [
            data,
            isEnabled
        ]);
    };
});
parcelRegister("hhjRL", function(module, exports) {
    $parcel$export(module.exports, "useOgConsolidationUserState", ()=>$372e7078171e8517$export$c35632c02599163f);
    var $eUqFw = parcelRequire("eUqFw");
    var $48bs8 = parcelRequire("48bs8");
    var $guiFP = parcelRequire("guiFP");
    var $k8Qyf = parcelRequire("k8Qyf");
    var $5JgJ2 = parcelRequire("5JgJ2");
    var $hlO97 = parcelRequire("hlO97");
    var $9EQcI = parcelRequire("9EQcI");
    var $gd0Sp = parcelRequire("gd0Sp");
    var $lB25E = parcelRequire("lB25E");
    var $3bkB6 = parcelRequire("3bkB6");
    const $372e7078171e8517$export$c35632c02599163f = ()=>{
        const errorRef = (0, $eUqFw.useRef)();
        const loadingRef = (0, $eUqFw.useRef)(false);
        const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
        const { data: data, update: updateTransitionResource, error: transitionResourceError } = (0, $lB25E.useResource)((0, $hlO97.consolidationUserStateResource));
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        const [userPropertiesError, setUserPropertiesError] = (0, $eUqFw.useState)();
        errorRef.current = userPropertiesError || transitionResourceError;
        const { atlassianAccountId: accountId } = (0, $gd0Sp.useTenantContext)();
        const update = (0, $eUqFw.useCallback)((newState)=>{
            if (errorRef.current) return Promise.reject(errorRef.current);
            let updatedData = {};
            updateTransitionResource((oldState)=>{
                updatedData = {
                    ...oldState,
                    ...newState
                };
                return updatedData;
            });
            if (accountId) {
                if (loadingRef.current) {
                    const err = new Error('User properties is loading');
                    (0, $guiFP.default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraEocChangeboarding',
                            teamName: 'alexstrasza'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setUserPropertiesError(err);
                    return Promise.reject(err);
                }
                loadingRef.current = true;
                return (0, $48bs8.setUserProperties)(accountId, (0, $9EQcI.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY), JSON.stringify(updatedData)).catch((err)=>{
                    setUserPropertiesError(new Error('Error occured while setting user properties'));
                    showFlag({
                        type: 'error',
                        isAutoDismiss: true,
                        title: formatMessage((0, $3bkB6.default).errorFlagTitle)
                    });
                    (0, $guiFP.default)({
                        meta: {
                            id: 'useOgConsolidationUserPreference-update',
                            packageName: 'jiraEocChangeboarding',
                            teamName: 'alexstrasza'
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }).finally(()=>{
                    loadingRef.current = false;
                });
            }
            return Promise.resolve();
        }, [
            updateTransitionResource,
            accountId,
            formatMessage,
            showFlag
        ]);
        const reopenTransitionLozenge = (0, $eUqFw.useCallback)(()=>{
            update({
                isTransitionHomeHidden: false
            });
        }, [
            update
        ]);
        return {
            data: data,
            update: update,
            error: errorRef.current,
            reopenTransitionLozenge: reopenTransitionLozenge
        };
    };
});
parcelRegister("hlO97", function(module, exports) {
    $parcel$export(module.exports, "consolidationUserStateResource", ()=>$df22f4299975551a$export$4b870505c49999ef);
    var $guiFP = parcelRequire("guiFP");
    var $lB25E = parcelRequire("lB25E");
    var $e70K7 = parcelRequire("e70K7");
    const $df22f4299975551a$var$RESOURCE_KEY = 'RESOURCE_TYPE_EOC_OG_CONSOLIDATION_USER_STATE';
    const $df22f4299975551a$export$4b870505c49999ef = (0, $lB25E.createResource)({
        type: $df22f4299975551a$var$RESOURCE_KEY,
        getKey: ()=>$df22f4299975551a$var$RESOURCE_KEY,
        getData: (_, { tenantContext: { atlassianAccountId: accountId } })=>(0, $e70K7.getOgConsolidationUserState)(accountId).catch((error)=>{
                (0, $guiFP.default)({
                    meta: {
                        id: 'consolidationUserStateResource',
                        packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                        teamName: 'alexstrasza'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }),
        maxAge: Infinity
    });
});
parcelRegister("e70K7", function(module, exports) {
    $parcel$export(module.exports, "getOgConsolidationUserState", ()=>$f1438afaaf09dc03$export$df7594d56c9ebe57);
    var $48bs8 = parcelRequire("48bs8");
    var $guiFP = parcelRequire("guiFP");
    var $7byHA = parcelRequire("7byHA");
    var $9EQcI = parcelRequire("9EQcI");
    const $f1438afaaf09dc03$export$df7594d56c9ebe57 = (accountId)=>{
        if (!accountId) return Promise.resolve((0, $9EQcI.ERROR_CONSOLIDATION_USER_STATE));
        return (0, $48bs8.getUserProperty)(accountId, (0, $9EQcI.OG_CONSOLIDATION_USER_STATE_STORAGE_KEY)).then((val)=>{
            if (!val || typeof val !== 'object') {
                (0, $guiFP.default)({
                    meta: {
                        id: 'getUserProperty',
                        packageName: 'jiraRouterResourcesEocOgConsolidationUserState',
                        teamName: 'alexstrasza'
                    },
                    error: new (0, $7byHA.ValidationError)('User property is not an object. It must be changed outside of the automated flow.'),
                    sendToPrivacyUnsafeSplunk: true
                });
                return 0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE;
            }
            if (!Object.keys(val).every((key)=>Object.prototype.hasOwnProperty.call((0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE), key))) return {
                ...(0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE),
                ...Object.fromEntries(Object.entries(val).filter(([key])=>Object.prototype.hasOwnProperty.call((0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE), key)))
            };
            if (!Object.keys((0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE)).every((key)=>Object.prototype.hasOwnProperty.call(val, key))) return {
                ...(0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE),
                ...val
            };
            return val;
        }).catch((error)=>{
            if (error instanceof (0, $7byHA.default) && error.statusCode === 404) return 0, $9EQcI.DEFAULT_CONSOLIDATION_USER_STATE;
            throw error;
        });
    };
});
parcelRegister("9EQcI", function(module, exports) {
    $parcel$export(module.exports, "OG_CONSOLIDATION_USER_STATE_STORAGE_KEY", ()=>$ede4833892459008$export$1980758e2622af02);
    $parcel$export(module.exports, "DEFAULT_CONSOLIDATION_USER_STATE", ()=>$ede4833892459008$export$51d9907e9d716d);
    $parcel$export(module.exports, "ERROR_CONSOLIDATION_USER_STATE", ()=>$ede4833892459008$export$23da4710c3a29eae);
    const $ede4833892459008$export$1980758e2622af02 = 'eoc_consolidation_user_state';
    const $ede4833892459008$export$51d9907e9d716d = {
        isPromotionBannerDismissed: false,
        isWelcomeModalDisplayed: false,
        isTransitionHomeHidden: false,
        isTransitionBannerDismissed: false,
        isBroadcastWidgetDismissed: false,
        transitionBannerDismissedAt: null,
        isBenefitModalDismissed: false
    };
    const $ede4833892459008$export$23da4710c3a29eae = {
        isPromotionBannerDismissed: true,
        isWelcomeModalDisplayed: true,
        isTransitionHomeHidden: true,
        isTransitionBannerDismissed: true,
        isBroadcastWidgetDismissed: true,
        transitionBannerDismissedAt: null,
        isBenefitModalDismissed: true
    };
});
parcelRegister("3bkB6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd71b9db670388a5$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    var $cd71b9db670388a5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
        errorFlagTitle: {
            "id": "eoc-changeboarding.controllers.use-og-consolidation-user-state.error-flag-title",
            "defaultMessage": "Something went wrong while updating user properties."
        }
    });
});
parcelRegister("9z07y", function(module, exports) {
    $parcel$export(module.exports, "shouldRenderBenefitModal", ()=>$6567c5fc28457e2a$export$25a52eb2dc74e2f9);
    const $6567c5fc28457e2a$export$25a52eb2dc74e2f9 = ({ isDismissed: isDismissed, bannerDismissedAt: bannerDismissedAt })=>{
        if (!bannerDismissedAt || isDismissed) return false;
        return Math.ceil((new Date().getTime() - bannerDismissedAt) / 1000 / 60 / 60 / 24) >= 14;
    };
});
parcelRegister("h4Fhh", function(module, exports) {
    $parcel$export(module.exports, "useOgTenantInfo", ()=>$15a83583aeb31ef0$export$990ea9ff15ca04f7);
    var $eUqFw = parcelRequire("eUqFw");
    var $1ybV0 = parcelRequire("1ybV0");
    var $eI5EY = parcelRequire("eI5EY");
    var $dAKwA = parcelRequire("dAKwA");
    var $fz8wa = parcelRequire("fz8wa");
    var $lB25E = parcelRequire("lB25E");
    var $jf8p7 = parcelRequire("jf8p7");
    const $15a83583aeb31ef0$var$useConsolidationStateResourceRefresh = (tenantInfoResource)=>{
        const enabled = (0, $eI5EY.fg)('refresh_tenant_info_on_client_for_ssr_error');
        const { data: data, loading: loading, refresh: refresh } = tenantInfoResource;
        const isRefreshed = (0, $eUqFw.useRef)(false);
        (0, $eUqFw.useEffect)(()=>{
            if (enabled && data === null && loading === false && isRefreshed.current === false) {
                refresh();
                isRefreshed.current = true;
            }
        }, [
            data,
            loading,
            refresh,
            enabled
        ]);
    };
    const $15a83583aeb31ef0$export$990ea9ff15ca04f7 = ()=>{
        const tenantInfoResource = (0, $lB25E.useResource)((0, $dAKwA.getConsolidationStateResource)());
        const applicationPermissions = (0, $fz8wa.useApplicationPermissions)();
        $15a83583aeb31ef0$var$useConsolidationStateResourceRefresh(tenantInfoResource);
        if (!(0, $eI5EY.fg)('refresh_tenant_info_on_client_for_ssr_error') && tenantInfoResource.data === null && tenantInfoResource.loading === false && tenantInfoResource.error === null) tenantInfoResource.refresh();
        return {
            loading: tenantInfoResource.loading,
            error: tenantInfoResource.error,
            shouldUseJSM: (0, $jf8p7.checkShouldUseJSM)(tenantInfoResource.data),
            isConsolidated: (0, $jf8p7.checkIsConsolidated)(tenantInfoResource.data),
            isTransitioning: (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && (0, $jf8p7.checkIsTransitioning)(tenantInfoResource.data),
            isTransitioned: (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && (0, $jf8p7.checkIsTransitioned)(tenantInfoResource.data),
            isTransitionEligible: (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && applicationPermissions.hasServiceDeskAccess && (0, $jf8p7.checkIsTransitionEligible)(tenantInfoResource.data),
            shouldAccessUnlockOperations: (0, $1ybV0.ff)('opsgenie-consolidation-transitioning-state_d7vm9') && applicationPermissions.hasServiceDeskAccess && (0, $jf8p7.checkShouldAccessUnlockOperations)(tenantInfoResource.data),
            cohort: typeof tenantInfoResource.data === 'string' ? undefined : tenantInfoResource.data?.cohortInfo
        };
    };
});
parcelRegister("dAKwA", function(module, exports) {
    $parcel$export(module.exports, "getConsolidationStateResource", ()=>$59d64f3d4fc6187b$export$a6cf5054d4f9f5dd);
    var $fmDRS = parcelRequire("fmDRS");
    var $1ybV0 = parcelRequire("1ybV0");
    var $eI5EY = parcelRequire("eI5EY");
    var $lB25E = parcelRequire("lB25E");
    var $lPDOE = parcelRequire("lPDOE");
    const $59d64f3d4fc6187b$export$de6c19ae237c1eb9 = (cloudId, appPermissions)=>{
        let url = '/internal/v1/customers/tenant-info';
        if (cloudId) url = `${url}/${cloudId}`;
        else throw new Error('No tenant info exists.');
        let promise;
        if (appPermissions && appPermissions.hasServiceDeskAccess === false) {
            promise = new Promise((resolve)=>{
                resolve({
                    consolidationState: (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED
                });
            });
            return promise;
        }
        if (false) promise = (0, $fmDRS.eocFetch)(url, {
            exactUrl: true,
            headers: {
                'x-ssr-service-name': (0, $eI5EY.fg)('tenant-info-issuer-change') ? 'og-customer-int-api' : 'og-apigw-atlassian-gw'
            }
        });
        else promise = (0, $fmDRS.eocFetch)('/v1/customers/tenant-info').then(({ data: data })=>data);
        if ((0, $1ybV0.ff)('eoc-tenant-info-hook_dq6ke')) return promise;
        return promise.then((response)=>response.consolidationState);
    };
    const $59d64f3d4fc6187b$export$a6cf5054d4f9f5dd = (forceBrowser = false)=>(0, $lB25E.createResource)({
            type: (0, $02315c431173f662$export$25ee35b01de9d734),
            getKey: ()=>'tenantInformation',
            getData: (_, { tenantContext: { cloudId: cloudId, appPermissions: appPermissions } })=>$59d64f3d4fc6187b$export$de6c19ae237c1eb9(cloudId, appPermissions),
            maxAge: Infinity,
            isBrowserOnly: forceBrowser
        });
});
parcelRegister("fmDRS", function(module, exports) {
    $parcel$export(module.exports, "eocFetch", ()=>$d9532061aeb5ee82$export$212b9c60150b5a0a);
    var $6HOrw = parcelRequire("6HOrw");
    var $cpY9k = parcelRequire("cpY9k");
    var $ctLQP = parcelRequire("ctLQP");
    const $d9532061aeb5ee82$export$212b9c60150b5a0a = (input, init)=>{
        let headers = init?.headers ?? {};
        let body = init?.body;
        if (!(window.Blob && body instanceof Blob || window.Int8Array && body instanceof Int8Array || window.Uint8Array && body instanceof Uint8Array || window.Uint8ClampedArray && body instanceof Uint8ClampedArray || window.Int16Array && body instanceof Int16Array || window.Uint16Array && body instanceof Uint16Array || window.Int32Array && body instanceof Int32Array || window.Uint32Array && body instanceof Uint32Array || window.Float32Array && body instanceof Float32Array || window.Float64Array && body instanceof Float64Array || window.ArrayBuffer && body instanceof ArrayBuffer || window.BigInt64Array && body instanceof BigInt64Array || window.BigUint64Array && body instanceof BigUint64Array || window.FormData && body instanceof FormData || window.URLSearchParams && body instanceof URLSearchParams || window.ReadableStream && body instanceof ReadableStream || window.Array && headers instanceof Array || typeof body === 'string') && headers['Content-Type'] === undefined && headers['content-type'] === undefined) {
            body = JSON.stringify(body);
            headers['Content-Type'] = 'application/json';
        }
        if (typeof input === 'string') input = (0, $ctLQP.withPrefix)(input, init);
        else input = {
            ...input,
            url: (0, $ctLQP.withPrefix)(input.url, init)
        };
        const errorTransformer = init?.errorTransformer ?? (0, $ctLQP.defaultErrorTransformer);
        const startTime = performance.now();
        return fetch(input, {
            headers: headers,
            ...init,
            body: body
        }).catch((error)=>{
            throw new (0, $6HOrw.NetworkError)(error.name, error);
        }).then((response)=>{
            if (!response.ok) throw new (0, $6HOrw.HTTPError)(response);
            const sanitizedUrl = (0, $ctLQP.sanitizeUrlString)((0, $ctLQP.getRequestUrl)(input));
            (0, $cpY9k.addSpanToAll)('fetch', sanitizedUrl, [
                {
                    name: 'network'
                }
            ], startTime, performance.now());
            switch(init?.responseType){
                case undefined:
                case 'json':
                    return response.json();
                case 'blob':
                    return response.blob();
                case 'text':
                    return response.text();
                case 'headers':
                    return response;
            }
        }).catch((error)=>{
            if ((0, $6HOrw.isNetworkError)(error)) {
                const transformerResult = errorTransformer(error);
                if (transformerResult instanceof Promise) return transformerResult.then((finalError)=>{
                    throw finalError;
                });
                else throw transformerResult;
            }
            throw error;
        });
    };
});
parcelRegister("6HOrw", function(module, exports) {
    $parcel$export(module.exports, "NetworkError", ()=>$4bc63844f6277e72$export$bae979e68e4dc802);
    $parcel$export(module.exports, "HTTPError", ()=>$4bc63844f6277e72$export$aa9d629c530f62a7);
    $parcel$export(module.exports, "StreamedHTTPError", ()=>$4bc63844f6277e72$export$c30b5b02747d791c);
    $parcel$export(module.exports, "isHTTPError", ()=>$4bc63844f6277e72$export$6b7a49ce9c98a2f);
    $parcel$export(module.exports, "isNetworkError", ()=>$4bc63844f6277e72$export$476aa014e2fd89d5);
    $parcel$export(module.exports, "isStreamedHTTPError", ()=>$4bc63844f6277e72$export$4f52fcea95c8f97d);
    var $7ax5k = parcelRequire("7ax5k");
    class $4bc63844f6277e72$export$bae979e68e4dc802 extends Error {
        constructor(name, cause){
            super('Network Error!');
            this.name = name;
            this.cause = cause;
        }
    }
    class $4bc63844f6277e72$export$aa9d629c530f62a7 extends $4bc63844f6277e72$export$bae979e68e4dc802 {
        constructor(response){
            super((0, $7ax5k.ERROR_NAMES).HTTPError);
            this.message = `HTTP Status Error: ${response.status} ${response.statusText}`;
            this.response = response;
        }
    }
    class $4bc63844f6277e72$export$c30b5b02747d791c extends $4bc63844f6277e72$export$aa9d629c530f62a7 {
        constructor(cause, data, message){
            super(cause.response);
            this.cause = cause;
            this.data = data;
            this.message = message;
            this.message = message;
            this.name = (0, $7ax5k.ERROR_NAMES).StreamedHTTPError;
        }
    }
    const $4bc63844f6277e72$export$6b7a49ce9c98a2f = (candidate)=>candidate instanceof $4bc63844f6277e72$export$aa9d629c530f62a7 || [
            (0, $7ax5k.ERROR_NAMES).HTTPError,
            (0, $7ax5k.ERROR_NAMES).StreamedHTTPError
        ].includes(candidate.name);
    const $4bc63844f6277e72$export$476aa014e2fd89d5 = (candidate)=>candidate instanceof $4bc63844f6277e72$export$bae979e68e4dc802 || [
            (0, $7ax5k.ERROR_NAMES).NetworkError,
            (0, $7ax5k.ERROR_NAMES).HTTPError,
            (0, $7ax5k.ERROR_NAMES).StreamedHTTPError
        ].includes(candidate.name);
    const $4bc63844f6277e72$export$4f52fcea95c8f97d = (candidate)=>candidate instanceof $4bc63844f6277e72$export$c30b5b02747d791c || candidate?.name === (0, $7ax5k.ERROR_NAMES).StreamedHTTPError;
});
parcelRegister("7ax5k", function(module, exports) {
    $parcel$export(module.exports, "ERROR_NAMES", ()=>$db013f815ffcf153$export$daceac3b97803ce1);
    var $db013f815ffcf153$export$daceac3b97803ce1;
    (function(ERROR_NAMES) {
        ERROR_NAMES["HTTPError"] = "HTTPError";
        ERROR_NAMES["StreamedHTTPError"] = "StreamedHTTPError";
        ERROR_NAMES["NetworkError"] = "NetworkError";
    })($db013f815ffcf153$export$daceac3b97803ce1 || ($db013f815ffcf153$export$daceac3b97803ce1 = {}));
});
parcelRegister("ctLQP", function(module, exports) {
    $parcel$export(module.exports, "getMeta", ()=>$953e297de11148e6$export$c47913ca32a5c6f7);
    $parcel$export(module.exports, "withPrefix", ()=>$953e297de11148e6$export$44188c5f179c4553);
    $parcel$export(module.exports, "defaultErrorTransformer", ()=>$953e297de11148e6$export$270fcc0e5df09fdd);
    $parcel$export(module.exports, "jsmErrorTransformer", ()=>$953e297de11148e6$export$994cc82144d28ded);
    $parcel$export(module.exports, "getRequestUrl", ()=>$953e297de11148e6$export$14619c0eed01a470);
    $parcel$export(module.exports, "sanitizeUrlString", ()=>$953e297de11148e6$export$ceb09b958e605eff);
    var $gpaVp = parcelRequire("gpaVp");
    var $6HOrw = parcelRequire("6HOrw");
    let $953e297de11148e6$var$metaCloudId;
    let $953e297de11148e6$var$isJSMAvailable = true;
    function $953e297de11148e6$export$c47913ca32a5c6f7(name) {
        const globalVariable = window ?? $parcel$global;
        if ((0, $gpaVp.isServer)() && globalVariable.ssr__metadata) return globalVariable.ssr__metadata[name];
        if ($953e297de11148e6$var$metaCloudId) return $953e297de11148e6$var$metaCloudId;
        if ($953e297de11148e6$var$isJSMAvailable) {
            const element = document.querySelector(`meta[name="${name}"]`);
            $953e297de11148e6$var$metaCloudId = element?.getAttribute('content') ?? undefined;
            $953e297de11148e6$var$isJSMAvailable = !!$953e297de11148e6$var$metaCloudId;
        }
        return $953e297de11148e6$var$metaCloudId;
    }
    function $953e297de11148e6$export$5a75f4aeb58ba80f(id) {
        $953e297de11148e6$var$metaCloudId = id;
    }
    function $953e297de11148e6$export$44188c5f179c4553(input, init) {
        if (init?.exactUrl) return input;
        if (window.__OG__) return '/webapi' + input;
        const cloudId = $953e297de11148e6$export$c47913ca32a5c6f7('ajs-cloud-id');
        if (cloudId) return (0, $d48de35bb62b3c10$export$3414665826fa030e) + cloudId + input;
        return input;
    }
    const $953e297de11148e6$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8))))/i;
    const $953e297de11148e6$export$270fcc0e5df09fdd = (e)=>{
        if (e instanceof (0, $6HOrw.HTTPError)) {
            const contentType = e.response.headers.get('Content-Type');
            if (contentType && $953e297de11148e6$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, $6HOrw.StreamedHTTPError)(e, data, data.errorMessage ?? data.message));
            return e.response.text().then((message)=>new (0, $6HOrw.StreamedHTTPError)(e, message, message));
        }
        return e;
    };
    const $953e297de11148e6$export$994cc82144d28ded = (error)=>{
        if (error instanceof (0, $6HOrw.HTTPError)) {
            const contentType = error.response.headers.get('Content-Type');
            if (contentType && $953e297de11148e6$var$mediaTypeRegex.test(contentType)) return error.response.json().then((data)=>new (0, $6HOrw.StreamedHTTPError)(error, data, data.errorMessages.join(',')));
            return error.response.text().then((message)=>new (0, $6HOrw.StreamedHTTPError)(error, message, message));
        }
        return error;
    };
    const $953e297de11148e6$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
    const $953e297de11148e6$export$ceb09b958e605eff = (url)=>{
        const urlWithoutQueryParams = url.replace(/\?.*$/, '');
        const urlWithoutUUIDs = urlWithoutQueryParams.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(-[0-9a-f]{13})?/gi, '<uuid>');
        return urlWithoutUUIDs;
    };
});
parcelRegister("gpaVp", function(module, exports) {
    $parcel$export(module.exports, "isServer", ()=>$cc8a7adc4bd1c3e0$export$6acf61af03e62db);
    const $cc8a7adc4bd1c3e0$export$6acf61af03e62db = ()=>{
        try {
            return false;
        } catch (error) {
            return globalThis.false ?? false;
        }
    };
});
const $d48de35bb62b3c10$export$3414665826fa030e = '/gateway/api/jsm/ops/web/';
parcelRegister("lPDOE", function(module, exports) {
    $parcel$export(module.exports, "ConsolidationState", ()=>$1d60cf44e0c38c08$export$9ef498b0a11fd37d);
    const $1d60cf44e0c38c08$export$9ef498b0a11fd37d = {
        NOT_CONSOLIDATED: 'NOT_CONSOLIDATED',
        TRANSITIONING: 'TRANSITIONING',
        TRANSITIONED: 'TRANSITIONED',
        CONSOLIDATED: 'CONSOLIDATED'
    };
});
const $02315c431173f662$export$25ee35b01de9d734 = 'EOC_TENANT';
parcelRegister("fz8wa", function(module, exports) {
    $parcel$export(module.exports, "ApplicationPermissionsSubscriber", ()=>$d53bf78e5b3b7ada$export$d8c76f7e52d0a856);
    $parcel$export(module.exports, "useApplicationPermissions", ()=>$d53bf78e5b3b7ada$export$4d9cadb4042acc1b);
    var $df4Sl = parcelRequire("df4Sl");
    var $WBLbN = parcelRequire("WBLbN");
    var $k4yit = parcelRequire("k4yit");
    var $gd0Sp = parcelRequire("gd0Sp");
    const $d53bf78e5b3b7ada$var$selector = (0, $df4Sl.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
            data: {
                applicationPermissions: applicationPermissions
            }
        }));
    const $d53bf78e5b3b7ada$export$d8c76f7e52d0a856 = (0, $WBLbN.createSubscriber)((0, $k4yit.default), {
        displayName: 'ApplicationPermissionsSubscriber',
        selector: $d53bf78e5b3b7ada$var$selector
    });
    const $d53bf78e5b3b7ada$export$4d9cadb4042acc1b = ()=>{
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        return tenantContext && tenantContext.appPermissions;
    };
});
parcelRegister("jf8p7", function(module, exports) {
    $parcel$export(module.exports, "checkShouldUseJSM", ()=>$77654e10ad778a08$export$5e0f3a0d8463fa21);
    $parcel$export(module.exports, "checkIsTransitioning", ()=>$77654e10ad778a08$export$d2f281fd4bf10855);
    $parcel$export(module.exports, "checkIsConsolidated", ()=>$77654e10ad778a08$export$57f75aebff17dd1e);
    $parcel$export(module.exports, "checkIsTransitioned", ()=>$77654e10ad778a08$export$b6461b23ee0e1471);
    $parcel$export(module.exports, "checkIsTransitionEligible", ()=>$77654e10ad778a08$export$24040115cac5fdc3);
    $parcel$export(module.exports, "checkShouldAccessUnlockOperations", ()=>$77654e10ad778a08$export$cd227238525e8d57);
    var $lPDOE = parcelRequire("lPDOE");
    const $77654e10ad778a08$export$5e0f3a0d8463fa21 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo !== (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED : tenantInfo.consolidationState !== (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED;
    };
    const $77654e10ad778a08$export$d2f281fd4bf10855 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, $lPDOE.ConsolidationState).TRANSITIONING : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).TRANSITIONING;
    };
    const $77654e10ad778a08$export$57f75aebff17dd1e = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, $lPDOE.ConsolidationState).CONSOLIDATED : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).CONSOLIDATED;
    };
    const $77654e10ad778a08$export$b6461b23ee0e1471 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? tenantInfo === (0, $lPDOE.ConsolidationState).TRANSITIONED : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).TRANSITIONED;
    };
    const $77654e10ad778a08$export$24040115cac5fdc3 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState === (0, $lPDOE.ConsolidationState).NOT_CONSOLIDATED && tenantInfo.cohortInfo === (0, $9e5329fbcc13ca2e$export$650f6934db1290c1);
    };
    const $77654e10ad778a08$export$cd227238525e8d57 = (tenantInfo)=>{
        if (!tenantInfo) return false;
        return typeof tenantInfo === 'string' ? false : tenantInfo.consolidationState !== (0, $lPDOE.ConsolidationState).CONSOLIDATED && (tenantInfo.cohortInfo === (0, $9e5329fbcc13ca2e$export$650f6934db1290c1) || tenantInfo.cohortInfo === (0, $9e5329fbcc13ca2e$export$a101f3562b5f0742));
    };
});
const $9e5329fbcc13ca2e$export$650f6934db1290c1 = 'cohort3';
const $9e5329fbcc13ca2e$export$a101f3562b5f0742 = 'cohort3.5';
parcelRegister("c7H0g", function(module, exports) {
    $parcel$export(module.exports, "useIsAdmin", ()=>$b4b4ffdc2519fb85$export$99a5e4bc80d231ca);
    var $gd0Sp = parcelRequire("gd0Sp");
    const $b4b4ffdc2519fb85$export$99a5e4bc80d231ca = ()=>{
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        return tenantContext && tenantContext.isAdmin || false;
    };
});
parcelRegister("1R3n5", function(module, exports) {
    $parcel$export(module.exports, "useIsSiteAdmin", ()=>$ae5c0c470cafb895$export$f9f8a5cdb0c565ef);
    var $gd0Sp = parcelRequire("gd0Sp");
    const $ae5c0c470cafb895$export$f9f8a5cdb0c565ef = ()=>{
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        return tenantContext && tenantContext.isSiteAdmin || false;
    };
});
parcelRegister("bFh4f", function(module, exports) {
    $parcel$export(module.exports, "HEIGHT", ()=>$9b35bda76dc8f581$export$809d2b099693a9a8);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$9b35bda76dc8f581$export$41956b146268af93);
    var $c9TLT = parcelRequire("c9TLT");
    const $9b35bda76dc8f581$export$809d2b099693a9a8 = (0, $c9TLT.gridSize) * 6;
    const $9b35bda76dc8f581$export$41956b146268af93 = 'EOC_TRANSITION';
});
parcelRegister("9lf1N", function(module, exports) {
    $parcel$export(module.exports, "useBannerMailExpiry", ()=>$459c8882dc5ea0c1$export$3906461ac9b87d2);
    var $eUqFw = parcelRequire("eUqFw");
    var $8Osbm = parcelRequire("8Osbm");
    var $j3cff = parcelRequire("j3cff");
    var $hNg3b = parcelRequire("hNg3b");
    const $459c8882dc5ea0c1$export$3906461ac9b87d2 = ()=>{
        const { responseStatus: responseStatus, state: state } = (0, $8Osbm.useIncomingMailExpiryStatus)();
        const { onStateFetch: onStateFetch } = (0, $hNg3b.useBannerActions)();
        const { isBannerShown: isBannerShown } = (0, $hNg3b.useBannerState)();
        (0, $eUqFw.useEffect)(()=>{
            if (responseStatus === 'error') {
                onStateFetch((0, $8Osbm.DEFAULT_RESPONSE));
                return;
            }
            if (responseStatus === 'success') onStateFetch(state);
        }, [
            onStateFetch,
            responseStatus,
            state
        ]);
        return (0, $eUqFw.useMemo)(()=>({
                isEnabled: isBannerShown,
                name: (0, $j3cff.BANNER_NAME),
                height: (0, $j3cff.HEIGHT)
            }), [
            isBannerShown
        ]);
    };
});
parcelRegister("8Osbm", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_RESPONSE", ()=>$c9c7ef93c34099a4$export$32d9db53927095d3);
    $parcel$export(module.exports, "incomingMailServerExpiryStatusResource", ()=>$c9c7ef93c34099a4$export$369caf52ed1ad2b1);
    $parcel$export(module.exports, "useIncomingMailExpiryStatus", ()=>$c9c7ef93c34099a4$export$283aa034b7d4e2a0);
    var $eUqFw = parcelRequire("eUqFw");
    var $guiFP = parcelRequire("guiFP");
    var $lRmyA = parcelRequire("lRmyA");
    var $lB25E = parcelRequire("lB25E");
    const $c9c7ef93c34099a4$var$fetchGetIncomingMailServerExpiryStatus = async ()=>(0, $lRmyA.performGetRequest)((0, $6a195a4b7e83469e$export$5bf8eb915287f5f4));
    const $c9c7ef93c34099a4$export$32d9db53927095d3 = {
        isAdmin: false,
        showBanner: true,
        OauthTypes: [
            'GMAIL_OAUTH'
        ]
    };
    const $c9c7ef93c34099a4$export$369caf52ed1ad2b1 = (0, $lB25E.createResource)({
        type: (0, $6a195a4b7e83469e$export$3b9494e0dfc4de09),
        getKey: ()=>(0, $6a195a4b7e83469e$export$f2f2f265ccc09f82),
        getData: async ()=>{
            let incomingMailServerExpiryStatus = null;
            try {
                incomingMailServerExpiryStatus = await $c9c7ef93c34099a4$var$fetchGetIncomingMailServerExpiryStatus();
            } catch (error) {
                if (error.statusCode === 404) (0, $guiFP.default)({
                    error: error,
                    meta: {
                        id: 'incomingMailServerExpiryStatus',
                        packageName: 'jiraRouterResourcesIncomingMailExpiryStatus',
                        teamName: 'maverick'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                incomingMailServerExpiryStatus: incomingMailServerExpiryStatus ?? $c9c7ef93c34099a4$export$32d9db53927095d3
            };
        },
        maxAge: 3600000
    });
    const $c9c7ef93c34099a4$export$283aa034b7d4e2a0 = ()=>{
        const { data: data, loading: loadingGetResource, error: errorGetResource } = (0, $lB25E.useResource)($c9c7ef93c34099a4$export$369caf52ed1ad2b1);
        const [incomingMailServerExpiryStatus, setIncomingMailServerExpiryStatus] = (0, $eUqFw.useState)(()=>{
            if (data?.incomingMailServerExpiryStatus) return data.incomingMailServerExpiryStatus;
            return $c9c7ef93c34099a4$export$32d9db53927095d3;
        });
        const [responseStatusGet, setResponseStatusGet] = (0, $eUqFw.useState)('not started');
        (0, $eUqFw.useEffect)(()=>{
            if (loadingGetResource) {
                setResponseStatusGet('loading');
                return;
            }
            if (errorGetResource) {
                setResponseStatusGet('error');
                return;
            }
            if (data?.incomingMailServerExpiryStatus) {
                setResponseStatusGet('success');
                setIncomingMailServerExpiryStatus(data.incomingMailServerExpiryStatus);
            }
        }, [
            loadingGetResource,
            errorGetResource,
            data?.incomingMailServerExpiryStatus
        ]);
        return {
            responseStatus: responseStatusGet,
            state: incomingMailServerExpiryStatus
        };
    };
});
const $6a195a4b7e83469e$export$3b9494e0dfc4de09 = 'mail_server_expiring';
const $6a195a4b7e83469e$export$f2f2f265ccc09f82 = 'is_oauth_mail_server_expiring';
const $6a195a4b7e83469e$export$5bf8eb915287f5f4 = '/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';
parcelRegister("j3cff", function(module, exports) {
    $parcel$export(module.exports, "HEIGHT", ()=>$9b9b396a0fb8763d$export$809d2b099693a9a8);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$9b9b396a0fb8763d$export$41956b146268af93);
    var $c9TLT = parcelRequire("c9TLT");
    const $9b9b396a0fb8763d$export$809d2b099693a9a8 = (0, $c9TLT.gridSize) * 6;
    const $9b9b396a0fb8763d$export$41956b146268af93 = 'MAIL_EXPIRY_REMINDER';
});
parcelRegister("hNg3b", function(module, exports) {
    $parcel$export(module.exports, "useBannerActions", ()=>$8ca9b6dc949a6871$export$664f3e2467f0f5af);
    $parcel$export(module.exports, "useBannerState", ()=>$8ca9b6dc949a6871$export$fa4ffa872ee90bd0);
    var $WBLbN = parcelRequire("WBLbN");
    const $8ca9b6dc949a6871$export$d4c72bab9d6cc13a = {
        isBannerShown: false,
        isAdmin: false,
        OauthTypes: [
            'GMAIL_OAUTH'
        ]
    };
    const $8ca9b6dc949a6871$export$e324594224ef24da = {
        onDismiss: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isBannerShown: false
                });
            },
        onStateFetch: ({ showBanner: showBanner, isAdmin: isAdmin, OauthTypes: OauthTypes = [
            'GMAIL_OAUTH'
        ] })=>({ getState: getState, setState: setState })=>{
                setState({
                    ...getState(),
                    isBannerShown: showBanner && isAdmin,
                    isAdmin: isAdmin,
                    OauthTypes: OauthTypes
                });
            }
    };
    const $8ca9b6dc949a6871$var$Store = (0, $WBLbN.createStore)({
        name: 'mail-expiry-banner',
        initialState: $8ca9b6dc949a6871$export$d4c72bab9d6cc13a,
        actions: $8ca9b6dc949a6871$export$e324594224ef24da
    });
    const $8ca9b6dc949a6871$export$664f3e2467f0f5af = (0, $WBLbN.createActionsHook)($8ca9b6dc949a6871$var$Store);
    const $8ca9b6dc949a6871$export$fa4ffa872ee90bd0 = (0, $WBLbN.createStateHook)($8ca9b6dc949a6871$var$Store);
});
parcelRegister("8NAHO", function(module, exports) {
    $parcel$export(module.exports, "useBannerReturnToMobileState", ()=>$b273a992a16fb1c6$export$571311559507e90);
    $parcel$export(module.exports, "useBannerReturnToMobile", ()=>$b273a992a16fb1c6$export$a898dd7b7ec9917a);
    var $eUqFw = parcelRequire("eUqFw");
    var $8q0kG = parcelRequire("8q0kG");
    var $WBLbN = parcelRequire("WBLbN");
    var $bBqV2 = parcelRequire("bBqV2");
    const $b273a992a16fb1c6$var$initialState = {
        isEnabled: (0, $8q0kG.shouldShowReturnToMobileBanner)()
    };
    const $b273a992a16fb1c6$var$actions = {
        disable: ()=>({ setState: setState })=>{
                setState({
                    isEnabled: false
                });
            }
    };
    const $b273a992a16fb1c6$var$store = (0, $WBLbN.createStore)({
        initialState: $b273a992a16fb1c6$var$initialState,
        actions: $b273a992a16fb1c6$var$actions
    });
    const $b273a992a16fb1c6$export$571311559507e90 = (0, $WBLbN.createHook)($b273a992a16fb1c6$var$store);
    const $b273a992a16fb1c6$export$a898dd7b7ec9917a = ()=>{
        const [{ isEnabled: isEnabled }] = $b273a992a16fb1c6$export$571311559507e90();
        return (0, $eUqFw.useMemo)(()=>({
                isEnabled: isEnabled,
                name: (0, $bBqV2.BANNER_NAME),
                height: (0, $bBqV2.mobileBannerHeight)
            }), [
            isEnabled
        ]);
    };
});
parcelRegister("bBqV2", function(module, exports) {
    $parcel$export(module.exports, "mobileBannerHeight", ()=>$0bcd02d2e3eab317$export$aa875602f5712b77);
    $parcel$export(module.exports, "BANNER_NAME", ()=>$0bcd02d2e3eab317$export$41956b146268af93);
    $parcel$export(module.exports, "ENCODED_APPLE_APP_STORE_URL", ()=>$0bcd02d2e3eab317$export$698c82a2c8445300);
    var $c9TLT = parcelRequire("c9TLT");
    const $0bcd02d2e3eab317$export$aa875602f5712b77 = (0, $c9TLT.gridSize) * 6;
    const $0bcd02d2e3eab317$export$41956b146268af93 = 'RETURN_TO_MOBILE_BANNER';
    const $0bcd02d2e3eab317$export$698c82a2c8445300 = encodeURIComponent('https://itunes.apple.com/app/apple-store/id1006972087');
});
parcelRegister("7Rdn2", function(module, exports) {
    $parcel$export(module.exports, "BannerAnnouncementAsync", ()=>$3bcbd6a43f5bed00$export$aa03f7909e0828ec);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $gGtKh = parcelRequire("gGtKh");
    const $3bcbd6a43f5bed00$var$BannerAnnouncement = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("2M7hi")).then((module)=>module.BannerAnnouncement), {
        ssr: true,
        moduleId: "./src/packages/platform/ui/banners/announcement/src/ui/banner-v2/index.tsx"
    });
    const $3bcbd6a43f5bed00$export$aa03f7909e0828ec = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "async-platform-ui-banners-announcement",
            fallback: null
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($3bcbd6a43f5bed00$var$BannerAnnouncement, null));
});
parcelRegister("2M7hi", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("5okUl")
    ]).then(()=>parcelRequire('2JP8d'));
});
parcelRegister("imSzy", function(module, exports) {
    $parcel$export(module.exports, "BannerTransitionAsync", ()=>$9423afe095590d92$export$8bf182764b9d2eb8);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $gGtKh = parcelRequire("gGtKh");
    const $9423afe095590d92$var$BannerTransition = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("CTXO4")).then((module)=>module.BannerTransition), {
        moduleId: "./src/packages/platform/ui/banners/eoc-transition/src/ui/banner/index.tsx"
    });
    const $9423afe095590d92$export$8bf182764b9d2eb8 = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "async-banner-eoc-transition",
            fallback: null
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($9423afe095590d92$var$BannerTransition, null));
});
parcelRegister("CTXO4", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("fqvm5").then(()=>parcelRequire('gIqiW'));
});
parcelRegister("8fKcN", function(module, exports) {
    $parcel$export(module.exports, "MailExpiryBannerAsync", ()=>$964736e7e618d7bf$export$11a26ffa2d1b48ed);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $0cdA8 = parcelRequire("0cdA8");
    var $gGtKh = parcelRequire("gGtKh");
    const $964736e7e618d7bf$var$LazyMailExpiryBanner = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("1poNk")).then(({ MailExpiryReminder: MailExpiryReminder })=>MailExpiryReminder), {
        moduleId: "./src/packages/platform/ui/banners/mail-expiry-reminder/src/ui/view.tsx"
    });
    const $964736e7e618d7bf$export$11a26ffa2d1b48ed = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "async-mail-expiry-banner",
            packageName: "jiraPlatformUiMailExpiryReminder",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "async-mail-expiry-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($964736e7e618d7bf$var$LazyMailExpiryBanner, null)));
});
parcelRegister("1poNk", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("9GC8O")
    ]).then(()=>parcelRequire('8U4NP'));
});
parcelRegister("4E80X", function(module, exports) {
    $parcel$export(module.exports, "ReturnToMobileBanner", ()=>$07b98091c81653c4$export$81c4f1e869d5a87);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $gGtKh = parcelRequire("gGtKh");
    const $07b98091c81653c4$var$LazyReturnToMobileBanner = (0, $56koX.lazy)(()=>(parcelRequire("fJNOQ")).then(({ ReturnToMobileBanner: ReturnToMobileBanner })=>ReturnToMobileBanner), {
        moduleId: "./src/packages/platform/ui/return-to-mobile-banner/src/main.tsx"
    });
    const $07b98091c81653c4$export$81c4f1e869d5a87 = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "async-return-to-mobile-banner",
            fallback: null
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($07b98091c81653c4$var$LazyReturnToMobileBanner, null));
});
parcelRegister("fJNOQ", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("1RB2w")
    ]).then(()=>parcelRequire('KEN32'));
});
parcelRegister("3EdDr", function(module, exports) {
    $parcel$export(module.exports, "ZIndexWrapper", ()=>$30c13a56fc17fb62$export$6bdda512681a5774);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $9t7rW = parcelRequire("9t7rW");
    const $30c13a56fc17fb62$export$6bdda512681a5774 = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { zIndex: zIndex, top: top, ...__cmpldp } = __cmplp;
        return $eUqFw.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_w6mvmh": (0, $9t7rW.default)(__cmplp.zIndex),
                "--_1vj9tq": (0, $9t7rW.default)(__cmplp.top)
            },
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_1pby1fcb _kqswh2mm _154i1ter",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5Wexj", function(module, exports) {
    $parcel$export(module.exports, "GlobalComponents", ()=>$3828c60179ae7edc$export$461c2ed3163c74ff);
    var $eUqFw = parcelRequire("eUqFw");
    var $h97Af = parcelRequire("h97Af");
    var $0cdA8 = parcelRequire("0cdA8");
    var $10fdS = parcelRequire("10fdS");
    var $isbb2 = parcelRequire("isbb2");
    var $2B87Z = parcelRequire("2B87Z");
    var $idiDE = parcelRequire("idiDE");
    const $3828c60179ae7edc$var$routeComponents = [];
    const $3828c60179ae7edc$var$RouteGlobalComponents = ()=>{
        const route = (0, $10fdS.useCurrentRoute)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, $isbb2.renderGlobalComponents)(route.layout?.globalComponents || $3828c60179ae7edc$var$routeComponents));
    };
    const $3828c60179ae7edc$var$SharedGlobalComponents = ({ sharedGlobalComponents: sharedGlobalComponents })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, $isbb2.renderGlobalComponents)(sharedGlobalComponents));
    const $3828c60179ae7edc$export$461c2ed3163c74ff = ({ sharedGlobalComponents: sharedGlobalComponents })=>{
        const globalComponentsPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
            (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$fb9876ab4228d985), (0, $7688150c048b38d1$export$c20831be6f780cb5), (0, $7688150c048b38d1$export$398df1bca49f9884), true, true);
        }, []);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $7688150c048b38d1$export$c20831be6f780cb5)
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            fallback: "unmount",
            id: "shared-global-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
            name: "shared-global-components"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($3828c60179ae7edc$var$SharedGlobalComponents, {
            sharedGlobalComponents: sharedGlobalComponents
        }))), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            fallback: "unmount",
            id: "route-global-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
            name: "route-global-components"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($3828c60179ae7edc$var$RouteGlobalComponents, null))), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $7688150c048b38d1$export$398df1bca49f9884),
            onSet: globalComponentsPerformanceTiming
        }));
    };
});
parcelRegister("idiDE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8ff5844edbd42f4$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $cm3xn = parcelRequire("cm3xn");
    var $iWLL0 = parcelRequire("iWLL0");
    var $zNBm2 = parcelRequire("zNBm2");
    var $7o5cs = parcelRequire("7o5cs");
    const $b8ff5844edbd42f4$var$newContextWithUfoContext = (context, interactionContext)=>context && interactionContext && {
            ...context,
            getInteractionContext: ()=>interactionContext
        };
    const $b8ff5844edbd42f4$var$flowRight = (functionList)=>(arg)=>functionList.reduceRight((acc, fn)=>fn(acc), arg);
    const $b8ff5844edbd42f4$var$renderContextProviderIfNonNull = (Context, contextValue)=>(node)=>contextValue ? (0, ($parcel$interopDefault($eUqFw))).createElement(Context.Provider, {
                value: contextValue
            }, node) : node;
    function $b8ff5844edbd42f4$var$JiraUFOLabelWrapper({ children: children }) {
        const context = (0, $zNBm2.useInteractionContext)();
        const rllProfilerContext = (0, $eUqFw.useContext)((0, $cm3xn.ProfilerContext));
        const relayProfilerContext = (0, $eUqFw.useContext)((0, $iWLL0.ProfilerContext));
        const newRllProfilerContext = (0, $eUqFw.useMemo)(()=>({
                current: $b8ff5844edbd42f4$var$newContextWithUfoContext(rllProfilerContext?.current, context)
            }), [
            context,
            rllProfilerContext
        ]);
        const newRelayProfilerContext = (0, $eUqFw.useMemo)(()=>$b8ff5844edbd42f4$var$newContextWithUfoContext(relayProfilerContext, context), [
            context,
            relayProfilerContext
        ]);
        return $b8ff5844edbd42f4$var$flowRight([
            $b8ff5844edbd42f4$var$renderContextProviderIfNonNull((0, $iWLL0.ProfilerContext), newRelayProfilerContext),
            $b8ff5844edbd42f4$var$renderContextProviderIfNonNull((0, $cm3xn.ProfilerContext), newRllProfilerContext)
        ])((0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children));
    }
    function $b8ff5844edbd42f4$export$2e2bcd8739ae039({ name: name, children: children }) {
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7o5cs.default), {
            name: name
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($b8ff5844edbd42f4$var$JiraUFOLabelWrapper, null, children));
    }
});
parcelRegister("7o5cs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$be6c36639cd46b8b$export$2e2bcd8739ae039);
    var $a2h7P = parcelRequire("a2h7P");
    var $be6c36639cd46b8b$export$2e2bcd8739ae039 = (0, $a2h7P.default);
});
parcelRegister("a2h7P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7210a26a17ff1fc8$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $zNBm2 = parcelRequire("zNBm2");
    function $7210a26a17ff1fc8$export$2e2bcd8739ae039({ name: name, children: children }) {
        const context = (0, $zNBm2.useInteractionContext)();
        const newContext = (0, $eUqFw.useMemo)(()=>{
            if (context) return {
                ...context,
                labelStack: context.labelStack == null ? [
                    {
                        name: name
                    }
                ] : [
                    ...context.labelStack,
                    {
                        name: name
                    }
                ]
            };
            else return context;
        }, [
            context,
            name
        ]);
        return context ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $zNBm2.default).Provider, {
            value: newContext
        }, children) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children);
    }
});
parcelRegister("jG5np", function(module, exports) {
    $parcel$export(module.exports, "GlobalContainers", ()=>$00841c043dae2742$export$3b677a7048d7ae0);
    var $eUqFw = parcelRequire("eUqFw");
    var $hoQ8t = parcelRequire("hoQ8t");
    var $3fQGY = parcelRequire("3fQGY");
    var $5BRby = parcelRequire("5BRby");
    var $9EHc8 = parcelRequire("9EHc8");
    var $h97Af = parcelRequire("h97Af");
    var $fb5Sn = parcelRequire("fb5Sn");
    var $6rW04 = parcelRequire("6rW04");
    var $18Cd3 = parcelRequire("18Cd3");
    var $6FP8W = parcelRequire("6FP8W");
    var $gXEQH = parcelRequire("gXEQH");
    var $cH5Wq = parcelRequire("cH5Wq");
    var $cajdb = parcelRequire("cajdb");
    var $ln3W8 = parcelRequire("ln3W8");
    var $jD3pk = parcelRequire("jD3pk");
    var $2B87Z = parcelRequire("2B87Z");
    var $gd0Sp = parcelRequire("gd0Sp");
    var $hzkQm = parcelRequire("hzkQm");
    var $emTse = parcelRequire("emTse");
    var $zyR9K = parcelRequire("zyR9K");
    var $6mtpk = parcelRequire("6mtpk");
    var $agGRi = parcelRequire("agGRi");
    var $hK0Sb = parcelRequire("hK0Sb");
    var $f9UOp = parcelRequire("f9UOp");
    const $00841c043dae2742$export$3b677a7048d7ae0 = ({ id: id, children: children, baseUrl: baseUrl, locale: locale, messages: messages, Router: Router, routerLinkComponent: routerLinkComponent })=>{
        const globalContainersPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
            (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$4f341d86a3c214), (0, $7688150c048b38d1$export$16e7ead3a8b5c366), (0, $7688150c048b38d1$export$c389f0b50840d5ca), true, true);
            (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$7048c99f32c60b34), (0, $7688150c048b38d1$export$3c2d8af5c7577fe7), (0, $7688150c048b38d1$export$aac77afee74c49d0), true, true);
        }, []);
        const { data: orgId } = (0, $jD3pk.useOrgId)();
        const MonolithStyleOverride = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement("style", {
                dangerouslySetInnerHTML: {
                    __html: `
                        body#jira {
                            overflow-x: hidden;
                            overflow-y: auto;
                        }

                        #jira-frontend {
                            background: ${"var(--ds-surface, white)"};
                        }

                        #jira_request_timing_info {
                            margin: 0;
                        }
                    `
                }
            });
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $emTse.IntlProviders), {
            messages: messages,
            locale: locale
        }, __SPA__ && (0, ($parcel$interopDefault($eUqFw))).createElement(MonolithStyleOverride, null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextContainer), {
            isGlobal: true,
            getMeta: (0, $6rW04.default)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3fQGY.default), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $fb5Sn.default), {
            orgId: orgId
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
            analyticsSource: (0, $7688150c048b38d1$export$c9e16a15d65437),
            experience: (0, $7688150c048b38d1$export$b1534bc11f201efd),
            experienceId: (0, $7688150c048b38d1$export$fa4bbc89fd1f1a7),
            application: (0, $7688150c048b38d1$export$aa6008fe0169b864),
            edition: (0, $7688150c048b38d1$export$39418a21fbb51487),
            additionalAttributes: (0, $gXEQH.routeAnalyticsAttributes)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hzkQm.ErrorBoundary), {
            id: id,
            withExperienceTracker: true
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $7688150c048b38d1$export$16e7ead3a8b5c366)
        }), (0, ($parcel$interopDefault($eUqFw))).createElement(Router, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hoQ8t.default), {
            UNSAFE_isThemingDisabled: true,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $7688150c048b38d1$export$c389f0b50840d5ca)
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $agGRi.PageConfigContainers), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $zyR9K.MetricsContainers), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ln3W8.default), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6mtpk.NavigationContainers), {
            baseUrl: baseUrl
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $f9UOp.UserContainers), {
            baseUrl: baseUrl
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hK0Sb.UiManagers), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $7688150c048b38d1$export$3c2d8af5c7577fe7)
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cH5Wq.PostOfficeRouterListener), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
            id: "page-container-v2.nav-v3.app-base",
            hasErrorBoundary: false
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $7688150c048b38d1$export$aac77afee74c49d0),
            onSet: globalContainersPerformanceTiming
        }), (0, $6FP8W.getWillShowNav4)() ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $18Cd3.SidebarNav4ControllerProvider), null, children) : children)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cajdb.ScreenSpaceFlagsPlacement), null)))))))))))))));
    };
});
parcelRegister("hoQ8t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1da0e47b014f1d59$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $fynTZ = parcelRequire("fynTZ");
    var $1UaYj = parcelRequire("1UaYj");
    const $1da0e47b014f1d59$var$InsideAppProviderContext = (0, $eUqFw.createContext)(false);
    function $1da0e47b014f1d59$export$c7dacf3845253dcf({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
        const isInsideAppProvider = (0, $eUqFw.useContext)($1da0e47b014f1d59$var$InsideAppProviderContext);
        if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
        const routerLinkProvider = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $fynTZ.default), {
            routerLinkComponent: routerLinkComponent
        }, children);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($1da0e47b014f1d59$var$InsideAppProviderContext.Provider, {
            value: true
        }, UNSAFE_isThemingDisabled ? routerLinkProvider : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1UaYj.default), {
            defaultColorMode: defaultColorMode,
            defaultTheme: defaultTheme
        }, routerLinkProvider));
    }
    var $1da0e47b014f1d59$export$2e2bcd8739ae039 = $1da0e47b014f1d59$export$c7dacf3845253dcf;
});
parcelRegister("9EHc8", function(module, exports) {
    $parcel$export(module.exports, "ViewExperienceTrackingProvider", ()=>$617962e6a5e395d0$export$a5efa46877be148f);
    $parcel$export(module.exports, "SubExperienceTrackingProvider", ()=>$617962e6a5e395d0$export$e0241c84ce5db240);
    var $eUqFw = parcelRequire("eUqFw");
    var $gUUjF = parcelRequire("gUUjF");
    var $1YJkI = parcelRequire("1YJkI");
    var $8yne0 = parcelRequire("8yne0");
    var $8nLP2 = parcelRequire("8nLP2");
    const $617962e6a5e395d0$export$a5efa46877be148f = ({ isExperienceReady: isExperienceReady, experience: experience, experienceId: experienceId, analyticsSource: analyticsSource, application: application, edition: edition, additionalAttributes: additionalAttributes, children: children })=>false ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8nLP2.default), {
            isExperienceReady: isExperienceReady,
            experience: experience,
            experienceId: experienceId,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            additionalAttributes: additionalAttributes
        }, children);
    $617962e6a5e395d0$export$a5efa46877be148f.defaultProps = {
        isExperienceReady: true,
        experienceId: null,
        additionalAttributes: {}
    };
    var $617962e6a5e395d0$export$2e2bcd8739ae039 = $617962e6a5e395d0$export$a5efa46877be148f;
    const $617962e6a5e395d0$export$e0241c84ce5db240 = ({ children: children, location: location, parentProviders: parentProviders })=>false ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1YJkI.default).Consumer, null, (context)=>{
            if (context == null) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('experience-sub-provider.missing-provider', 'Experience sub-provider rendered without a parent provider');
                return children;
            }
            const { experienceId: experienceId } = context;
            return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8yne0.ExperienceTracker), {
                location: location,
                parentProviders: parentProviders
            }, (trackerCallbacks)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $8nLP2.default), {
                    parentTrackerCallbacks: trackerCallbacks,
                    experience: location,
                    experienceId: experienceId,
                    analyticsSource: null,
                    application: null,
                    edition: null,
                    isExperienceReady: true
                }, children));
        });
    $617962e6a5e395d0$export$e0241c84ce5db240.defaultProps = {
        parentProviders: null
    };
});
parcelRegister("8nLP2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$392c2e4759c6c8b5$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $9lmTX = parcelRequire("9lmTX");
    var $1YJkI = parcelRequire("1YJkI");
    class $392c2e4759c6c8b5$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
        static{
            this.defaultProps = {
                parentTrackerCallbacks: null,
                additionalAttributes: {}
            };
        }
        constructor(props){
            super(props);
            this.onPending = ()=>{
                this.pendingCount += 1;
                this.shouldTrackExperience = true;
                this.checkAndStartTimer();
            };
            this.onSuccess = ()=>{
                this.pendingCount -= 1;
                this.checkAndStartTimer();
            };
            this.onFailure = (location, additionalAttributes)=>{
                this.trackExperience({
                    wasExperienceSuccesful: false,
                    location: location,
                    additionalAttributes: additionalAttributes
                });
            };
            this.onAbort = (location, additionalAttributes)=>{
                this.trackExperience({
                    wasExperienceSuccesful: false,
                    action: (0, $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8),
                    location: location,
                    additionalAttributes: additionalAttributes
                });
            };
            this.resetExperience();
        }
        componentDidMount() {
            this.checkAndStartTimer();
        }
        componentDidUpdate(prevProps) {
            if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
        }
        componentDidCatch(error) {
            this.trackExperience({
                wasExperienceSuccesful: false,
                location: 'error-reached-provider',
                additionalAttributes: {
                    errorMessage: error.message,
                    errorName: error.name
                }
            });
            throw error;
        }
        componentWillUnmount() {
            clearTimeout(this.timerId);
        }
        checkAndStartTimer() {
            if (this.shouldTrackExperience && this.props.isExperienceReady) this.startTimer();
        }
        startTimer() {
            clearTimeout(this.timerId);
            this.timerId = setTimeout(()=>{
                if (this.pendingCount === 0) this.trackExperience({
                    wasExperienceSuccesful: true
                });
            }, 1000);
        }
        resetExperience() {
            clearTimeout(this.timerId);
            this.timerId = undefined;
            this.shouldTrackExperience = false;
            this.hasTrackedExperience = false;
            this.pendingCount = 0;
            this.memoizedContext = {
                consumerCallbacks: {
                    onPending: this.onPending,
                    onSuccess: this.onSuccess,
                    onFailure: this.onFailure,
                    onAbort: this.onAbort
                },
                experienceId: this.props.experienceId,
                experience: this.props.experience
            };
        }
        trackExperience({ wasExperienceSuccesful: wasExperienceSuccesful, action: action, location: location, additionalAttributes: additionalAttributes }) {
            if (this.hasTrackedExperience) return;
            this.hasTrackedExperience = true;
            const { parentTrackerCallbacks: parentTrackerCallbacks, additionalAttributes: additionalAttributesFromProps } = this.props;
            if (parentTrackerCallbacks) {
                if (wasExperienceSuccesful) parentTrackerCallbacks.onExperienceSuccess();
                else parentTrackerCallbacks.onExperienceFailure(location, {
                    ...additionalAttributesFromProps,
                    ...additionalAttributes
                });
            } else {
                const { experience: experience } = this.memoizedContext;
                const { analyticsSource: analyticsSource, application: application, edition: edition } = this.props;
                analyticsSource && (0, $9lmTX.default)({
                    experience: experience,
                    action: action,
                    wasExperienceSuccesful: wasExperienceSuccesful,
                    location: location,
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    additionalAttributes: {
                        ...additionalAttributesFromProps,
                        ...additionalAttributes
                    }
                });
            }
        }
        checkExperienceIdForExperienceReset() {
            if (this.memoizedContext.experienceId !== this.props.experienceId) this.resetExperience();
        }
        render() {
            this.checkExperienceIdForExperienceReset();
            return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1YJkI.default).Provider, {
                value: this.memoizedContext
            }, this.props.children);
        }
    }
});
const $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a = 'taskSuccess';
const $99e7a4e4cbcb5db0$export$b48b3d1872522384 = 'taskFail';
const $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8 = 'taskAbort';
parcelRegister("18Cd3", function(module, exports) {
    $parcel$export(module.exports, "SidebarNav4ControllerProvider", ()=>$35192d3debbc289e$export$ec25d268893d889d);
    $parcel$export(module.exports, "useSidebarNav4Controller", ()=>$35192d3debbc289e$export$641950c86d73374);
    var $eUqFw = parcelRequire("eUqFw");
    var $7uCfF = parcelRequire("7uCfF");
    const $35192d3debbc289e$var$SidebarNav4ControllerContext = (0, $eUqFw.createContext)(null);
    function $35192d3debbc289e$export$ec25d268893d889d(props) {
        const { children: children, controlledPath: initialControlledPath = null } = props;
        const [controlledPath, setControlledPath] = (0, $eUqFw.useState)(initialControlledPath);
        const sidebarNav4Controller = (0, $eUqFw.useMemo)(()=>({
                isControlledNav: controlledPath !== null,
                isControlledPath: (0, $7uCfF.isSelectedPath)(controlledPath ?? []),
                setControlledPath: setControlledPath
            }), [
            controlledPath
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($35192d3debbc289e$var$SidebarNav4ControllerContext.Provider, {
            value: sidebarNav4Controller
        }, children);
    }
    function $35192d3debbc289e$export$641950c86d73374() {
        const context = (0, $eUqFw.useContext)($35192d3debbc289e$var$SidebarNav4ControllerContext);
        if (context == null) throw new Error('useSidebarNav4Controller must be used inside a SidebarNav4ControllerContext');
        return context;
    }
});
parcelRegister("7uCfF", function(module, exports) {
    $parcel$export(module.exports, "isSelectedPath", ()=>$62c21b20ac5de9fc$export$cdcd6885320eec31);
    var $hZ5um = parcelRequire("hZ5um");
    function $62c21b20ac5de9fc$export$cdcd6885320eec31(path, ...args) {
        const next = (menuId)=>{
            return (0, $hZ5um.isMenuIdList)(menuId) ? (0, $hZ5um.toMenuIdList)(menuId).some((id)=>path.includes(id)) : path.includes(menuId);
        };
        if (args.length === 0) return next;
        return next(args[0]);
    }
});
parcelRegister("hZ5um", function(module, exports) {
    $parcel$export(module.exports, "toMenuIdFromMenuIdList", ()=>$0aa74a7539989c0c$export$253323efd0c41e72);
    $parcel$export(module.exports, "isMenuIdList", ()=>$0aa74a7539989c0c$export$abdb8aa7ce9ed1ed);
    $parcel$export(module.exports, "toMenuIdList", ()=>$0aa74a7539989c0c$export$d8e017f58178e379);
    const $0aa74a7539989c0c$var$MENU_ID_DELIM = '   ';
    function $0aa74a7539989c0c$export$253323efd0c41e72(menuIds) {
        return menuIds.join($0aa74a7539989c0c$var$MENU_ID_DELIM);
    }
    function $0aa74a7539989c0c$export$abdb8aa7ce9ed1ed(maybeMenuIdList) {
        return maybeMenuIdList.indexOf($0aa74a7539989c0c$var$MENU_ID_DELIM) !== -1;
    }
    function $0aa74a7539989c0c$export$d8e017f58178e379(menuIdList) {
        return menuIdList.split($0aa74a7539989c0c$var$MENU_ID_DELIM);
    }
});
parcelRegister("cH5Wq", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeProvider", ()=>$a7b18f936fd35517$export$fb465b6e855c1e85);
    $parcel$export(module.exports, "PostOfficeRouterListener", ()=>$a7b18f936fd35517$export$9f8d3084fd3d5fc0);
    var $eUqFw = parcelRequire("eUqFw");
    var $cPGDt = parcelRequire("cPGDt");
    var $5GxEP = parcelRequire("5GxEP");
    var $eI5EY = parcelRequire("eI5EY");
    var $gZ48R = parcelRequire("gZ48R");
    var $cPEpP = parcelRequire("cPEpP");
    var $jD3pk = parcelRequire("jD3pk");
    var $4rWQe = parcelRequire("4rWQe");
    var $ab6rA = parcelRequire("ab6rA");
    var $dWLk9 = parcelRequire("dWLk9");
    var $3e9vj = parcelRequire("3e9vj");
    var $1R3n5 = parcelRequire("1R3n5");
    var $4xHig = parcelRequire("4xHig");
    var $ir3nM = parcelRequire("ir3nM");
    var $fAMhH = parcelRequire("fAMhH");
    var $lB25E = parcelRequire("lB25E");
    const $a7b18f936fd35517$var$subproductToEdition = (subproduct, editions)=>{
        switch(subproduct){
            case 'core':
                return editions.core;
            case 'software':
                return editions.software;
            case 'customerService':
                return editions.customerService;
            case 'serviceDesk':
                return editions.serviceDesk;
            default:
                undefined;
        }
    };
    const $a7b18f936fd35517$var$JiraPostOfficeProvider = ({ children: children })=>{
        const { data: data } = (0, $cPEpP.useProject)();
        const isSiteAdmin = (0, $1R3n5.useIsSiteAdmin)();
        const cloudId = (0, $dWLk9.useCloudId)();
        const activationId = (0, $4rWQe.useActivationId)();
        const locale = (0, $4xHig.useLocale)();
        const environment = (0, $3e9vj.useEnvironment)();
        const { data: orgId } = (0, $jD3pk.useOrgId)();
        const editions = (0, $ab6rA.useAppEditions)();
        const subproduct = data?.type;
        const edition = $a7b18f936fd35517$var$subproductToEdition(subproduct, editions);
        const workspaceAri = (0, $cPGDt.JiraWorkspaceAri).create({
            activationId: activationId,
            siteId: cloudId
        }).toString();
        const context = (0, $eUqFw.useMemo)(()=>({
                product: 'jira',
                tenantId: cloudId,
                workspaceAri: workspaceAri,
                workspaceId: activationId,
                orgId: orgId,
                subproduct: subproduct,
                isSiteAdmin: isSiteAdmin,
                locale: locale,
                productEdition: edition
            }), [
            cloudId,
            orgId,
            activationId,
            subproduct,
            isSiteAdmin,
            locale,
            workspaceAri,
            edition
        ]);
        const env = (0, $eUqFw.useMemo)(()=>$a7b18f936fd35517$export$cfacfecb20987ff1(environment), [
            environment
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ir3nM.PostOfficeProvider), {
            context: {
                current: context
            },
            environment: {
                env: env
            }
        }, children);
    };
    const $a7b18f936fd35517$export$fb465b6e855c1e85 = ({ children: children })=>{
        const isPostOfficeEnabled = !(0, $gZ48R.default)('killswitch_post_office_in_jira');
        return isPostOfficeEnabled ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
            id: "postOfficeJiraProvider",
            render: ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($a7b18f936fd35517$var$JiraPostOfficeProvider, null, children)) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children);
    };
    const $a7b18f936fd35517$var$ReactResourceRouterListener = ({ children: children })=>{
        const [route] = (0, $lB25E.useRouter)();
        (0, $fAMhH.usePostOfficeRouteUpdate)([
            route.basePath,
            route.location.pathname
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children);
    };
    const $a7b18f936fd35517$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
        const isPostOfficeEnabled = !(0, $gZ48R.default)('killswitch_post_office_in_jira');
        const isScreenSpaceFlagsEnabled = (0, $eI5EY.fg)('post-office-screen-space-overlay-jfe');
        return isPostOfficeEnabled && isScreenSpaceFlagsEnabled ? (0, ($parcel$interopDefault($eUqFw))).createElement($a7b18f936fd35517$var$ReactResourceRouterListener, null, children) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children);
    };
    const $a7b18f936fd35517$export$cfacfecb20987ff1 = (environment)=>{
        switch(environment){
            case 'dev':
            case 'staging':
                return 'staging';
            case 'prod':
                return 'production';
            case 'local':
                return 'local';
            default:
                return 'local';
        }
    };
});
parcelRegister("cPGDt", function(module, exports) {
    $parcel$export(module.exports, "JiraWorkspaceAri", ()=>$95f709ad54a54828$export$d4d0794234e3fd53);
    var $5pMX4 = parcelRequire("5pMX4");
    var $v8cEo = parcelRequire("v8cEo");
    var $hkoEN = parcelRequire("hkoEN");
    var $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
        resourceOwner: (0, $5pMX4.JiraWorkspaceAriResourceOwner),
        resourceType: (0, $5pMX4.JiraWorkspaceAriResourceType),
        resourceIdSlug: "{activationId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/
        }
    };
    var $95f709ad54a54828$export$d4d0794234e3fd53 = class _JiraWorkspaceAri extends (0, $v8cEo.RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts.qualifier,
                platformQualifier: $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts.resourceOwner,
                resourceType: $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts.resourceType,
                resourceId: `${opts.activationId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId
                }
            }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts);
            return new _JiraWorkspaceAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $95f709ad54a54828$var$jiraWorkspaceAriStaticOpts);
            return new _JiraWorkspaceAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId
            };
        }
    };
});
parcelRegister("5pMX4", function(module, exports) {
    $parcel$export(module.exports, "JiraWorkspaceAriResourceOwner", ()=>$cffaa0f78943566d$export$e52ccdf6abac8896);
    $parcel$export(module.exports, "JiraWorkspaceAriResourceType", ()=>$cffaa0f78943566d$export$669cd5f7b3746bb);
    var $cffaa0f78943566d$export$e52ccdf6abac8896 = "jira", $cffaa0f78943566d$export$669cd5f7b3746bb = "workspace";
});
parcelRegister("ab6rA", function(module, exports) {
    $parcel$export(module.exports, "useAppEditions", ()=>$75e408c194026ea5$export$92ed15881fc090d7);
    var $gd0Sp = parcelRequire("gd0Sp");
    const $75e408c194026ea5$export$92ed15881fc090d7 = ()=>{
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        return tenantContext && tenantContext.appEditions;
    };
});
parcelRegister("3e9vj", function(module, exports) {
    $parcel$export(module.exports, "useEnvironment", ()=>$f75608ebab912e29$export$ea7ed2425832167d);
    $parcel$export(module.exports, "useIsStagingOrDevOrLocal", ()=>$f75608ebab912e29$export$b0d8f74f433a09c9);
    var $gd0Sp = parcelRequire("gd0Sp");
    const $f75608ebab912e29$var$ENVIRONMENT = {
        STAGING: 'staging',
        DEV: 'dev',
        LOCAL: 'local',
        PROD: 'prod'
    };
    const $f75608ebab912e29$export$ea7ed2425832167d = ()=>{
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        return tenantContext?.environment || $f75608ebab912e29$var$ENVIRONMENT.PROD;
    };
    const $f75608ebab912e29$export$b0d8f74f433a09c9 = ()=>{
        const env = $f75608ebab912e29$export$ea7ed2425832167d();
        return env === $f75608ebab912e29$var$ENVIRONMENT.STAGING || env === $f75608ebab912e29$var$ENVIRONMENT.DEV || env === $f75608ebab912e29$var$ENVIRONMENT.LOCAL;
    };
});
parcelRegister("4xHig", function(module, exports) {
    $parcel$export(module.exports, "useLocale", ()=>$d8981c42d4d07028$export$43bb16f9c6d9e3f7);
    $parcel$export(module.exports, "useNativeLocale", ()=>$d8981c42d4d07028$export$31652d9c30d7d3f3);
    var $eUqFw = parcelRequire("eUqFw");
    var $ao0hp = parcelRequire("ao0hp");
    var $gd0Sp = parcelRequire("gd0Sp");
    const $d8981c42d4d07028$export$43bb16f9c6d9e3f7 = ()=>{
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        return tenantContext && tenantContext.locale || (0, $ao0hp.defaultLocale);
    };
    const $d8981c42d4d07028$export$31652d9c30d7d3f3 = ()=>{
        const locale = $d8981c42d4d07028$export$43bb16f9c6d9e3f7();
        const standardizedLocale = (0, $eUqFw.useMemo)(()=>(0, $ao0hp.standardizeLocale)(locale), [
            locale
        ]);
        return standardizedLocale;
    };
});
parcelRegister("ir3nM", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeProvider", ()=>$1b5d247f91c459d5$export$fb465b6e855c1e85);
    var $eUqFw = parcelRequire("eUqFw");
    var $kd0cS = parcelRequire("kd0cS");
    var $2vzCR = parcelRequire("2vzCR");
    var $j3kUo = parcelRequire("j3kUo");
    var $1nkI5 = parcelRequire("1nkI5");
    var $fAMhH = parcelRequire("fAMhH");
    var $4YrL8 = parcelRequire("4YrL8");
    var $6u0yW = parcelRequire("6u0yW");
    var $f2j1u = parcelRequire("f2j1u");
    var $4gIhL = parcelRequire("4gIhL");
    const $1b5d247f91c459d5$export$fb465b6e855c1e85 = ({ environment: envWithOverrides, context: context, children: children })=>{
        const stableEnvironment = (0, $6u0yW.useStableObject)((0, $4gIhL.generateEnvironmentConfigWithOverrides)((0, $1nkI5.defaultEnvironmentValues), envWithOverrides));
        const stableContext = (0, $6u0yW.useStableObject)($1b5d247f91c459d5$var$composeConfig((0, $j3kUo.defaultPostOfficeContextValue), context.current));
        const memoizedMessagePlacementValues = (0, $eUqFw.useMemo)(()=>(0, $f2j1u.createMessagePlacementValues)(), []);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1nkI5.PostOfficeEnvironmentProvider), {
            value: stableEnvironment
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $j3kUo.InternalPostOfficeContextProvider), {
            value: stableContext
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4YrL8.PostOfficeScreenContextProvider), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $f2j1u.MessagePlacementProvider), {
            value: memoizedMessagePlacementValues
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $fAMhH.RouteListenerProvider), null, children)))));
    };
    const $1b5d247f91c459d5$var$composeConfig = (base, ...rest)=>rest.reduce((a, v)=>(0, ($parcel$interopDefault($2vzCR)))(a, v), (0, ($parcel$interopDefault($kd0cS)))(base));
});
parcelRegister("j3kUo", function(module, exports) {
    $parcel$export(module.exports, "defaultPostOfficeContextValue", ()=>$996ba8e1ae6f2499$export$da5dc9062cba6715);
    $parcel$export(module.exports, "InternalPostOfficeContextProvider", ()=>$996ba8e1ae6f2499$export$3a10495c2cd2db0c);
    $parcel$export(module.exports, "PostOfficeContextProvider", ()=>$996ba8e1ae6f2499$export$b77983be89bb0a4e);
    $parcel$export(module.exports, "usePostOfficeContext", ()=>$996ba8e1ae6f2499$export$5bd9099e0ae94a43);
    var $eUqFw = parcelRequire("eUqFw");
    const $996ba8e1ae6f2499$export$da5dc9062cba6715 = {
        product: undefined,
        subproduct: undefined,
        locale: undefined,
        isSiteAdmin: undefined,
        tenantId: undefined,
        workspaceAri: 'no-workspace-ari-available',
        workspaceId: undefined,
        orgId: undefined,
        productEdition: undefined
    };
    const $996ba8e1ae6f2499$export$a228be81fcb77b42 = (0, $eUqFw.createContext)($996ba8e1ae6f2499$export$da5dc9062cba6715);
    const $996ba8e1ae6f2499$export$3a10495c2cd2db0c = $996ba8e1ae6f2499$export$a228be81fcb77b42.Provider;
    const $996ba8e1ae6f2499$export$b77983be89bb0a4e = $996ba8e1ae6f2499$export$3a10495c2cd2db0c;
    const $996ba8e1ae6f2499$export$5bd9099e0ae94a43 = ()=>(0, $eUqFw.useContext)($996ba8e1ae6f2499$export$a228be81fcb77b42);
});
parcelRegister("1nkI5", function(module, exports) {
    $parcel$export(module.exports, "defaultEnvironmentValues", ()=>$6dcf5e4b14f36e04$export$b4ede87479bfcf09);
    $parcel$export(module.exports, "PostOfficeEnvironmentProvider", ()=>$6dcf5e4b14f36e04$export$604607f913ef367c);
    $parcel$export(module.exports, "usePostOfficeEnvironment", ()=>$6dcf5e4b14f36e04$export$877b97169cc75e8b);
    var $eUqFw = parcelRequire("eUqFw");
    const $6dcf5e4b14f36e04$export$b4ede87479bfcf09 = {
        currentEnv: 'local',
        envConfigs: {
            test: {
                remoteModule: {
                    origin: (0, $fea0859bee7d3c4f$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $fea0859bee7d3c4f$export$1e9fed4c0197724c),
                    pathname: (0, $fea0859bee7d3c4f$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            local: {
                remoteModule: {
                    origin: (0, $fea0859bee7d3c4f$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $fea0859bee7d3c4f$export$1e9fed4c0197724c),
                    pathname: (0, $fea0859bee7d3c4f$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            dev: {
                remoteModule: {
                    origin: (0, $fea0859bee7d3c4f$export$67be2569ef5d7666),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $fea0859bee7d3c4f$export$1e9fed4c0197724c),
                    pathname: (0, $fea0859bee7d3c4f$export$919a9569bce66f17),
                    searchParams: undefined
                }
            },
            staging: {
                remoteModule: {
                    origin: (0, $fea0859bee7d3c4f$export$b49738b89db261cd),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $fea0859bee7d3c4f$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            'stg-fedm-east': {
                remoteModule: {
                    origin: (0, $fea0859bee7d3c4f$export$b49738b89db261cd),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $fea0859bee7d3c4f$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            production: {
                remoteModule: {
                    origin: (0, $fea0859bee7d3c4f$export$bbd96cd490b0df63),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $fea0859bee7d3c4f$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            },
            'prod-fedm-east': {
                remoteModule: {
                    origin: (0, $fea0859bee7d3c4f$export$bbd96cd490b0df63),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $fea0859bee7d3c4f$export$d4fe3482c88e73a8),
                    searchParams: undefined
                }
            }
        }
    };
    const $6dcf5e4b14f36e04$export$fceca2c399b32565 = (0, $eUqFw.createContext)($6dcf5e4b14f36e04$export$b4ede87479bfcf09);
    const $6dcf5e4b14f36e04$export$604607f913ef367c = $6dcf5e4b14f36e04$export$fceca2c399b32565.Provider;
    const $6dcf5e4b14f36e04$export$877b97169cc75e8b = ()=>(0, $eUqFw.useContext)($6dcf5e4b14f36e04$export$fceca2c399b32565);
});
var $fea0859bee7d3c4f$exports = {};
$parcel$export($fea0859bee7d3c4f$exports, "API_ORIGIN_LOCAL", ()=>$fea0859bee7d3c4f$export$1e9fed4c0197724c);
$parcel$export($fea0859bee7d3c4f$exports, "API_PATHNAME_LOCAL", ()=>$fea0859bee7d3c4f$export$919a9569bce66f17);
$parcel$export($fea0859bee7d3c4f$exports, "API_PATHNAME_STG_PROD", ()=>$fea0859bee7d3c4f$export$d4fe3482c88e73a8);
$parcel$export($fea0859bee7d3c4f$exports, "REMOTE_MODULE_URI_LOCAL", ()=>$fea0859bee7d3c4f$export$67be2569ef5d7666);
$parcel$export($fea0859bee7d3c4f$exports, "REMOTE_MODULE_URI_STG", ()=>$fea0859bee7d3c4f$export$b49738b89db261cd);
$parcel$export($fea0859bee7d3c4f$exports, "REMOTE_MODULE_URI_PROD", ()=>$fea0859bee7d3c4f$export$bbd96cd490b0df63);
const $fea0859bee7d3c4f$export$1e9fed4c0197724c = 'http://localhost:8081';
const $fea0859bee7d3c4f$export$919a9569bce66f17 = '/api/v1/placements/';
const $fea0859bee7d3c4f$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $fea0859bee7d3c4f$export$67be2569ef5d7666 = 'http://localhost:9009';
const $fea0859bee7d3c4f$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $fea0859bee7d3c4f$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';
parcelRegister("fAMhH", function(module, exports) {
    $parcel$export(module.exports, "usePostOfficeRouteUpdate", ()=>$1292a94470acda10$export$bb606326acdd1a64);
    $parcel$export(module.exports, "RouteListenerProvider", ()=>$1292a94470acda10$export$31986273b686f5ea);
    var $eUqFw = parcelRequire("eUqFw");
    var $1lYvF = parcelRequire("1lYvF");
    var $3ddpf = parcelRequire("3ddpf");
    const $1292a94470acda10$var$noop = ()=>{};
    const $1292a94470acda10$var$RouteListenerContext = (0, $eUqFw.createContext)({
        update: $1292a94470acda10$var$noop
    });
    const $1292a94470acda10$export$7a2084f4baac29a7 = ()=>(0, $1lYvF.createSimplePubSub)();
    const $1292a94470acda10$export$72fd8977abf03d60 = ()=>(0, $eUqFw.useContext)($1292a94470acda10$var$RouteListenerContext);
    const $1292a94470acda10$export$755edb1665399d41 = ()=>{
        const ref = (0, $eUqFw.useRef)();
        if (!ref.current) ref.current = $1292a94470acda10$export$7a2084f4baac29a7();
        const [routeSubscriber, updateRoute] = ref.current;
        const routeConfig = (0, $eUqFw.useMemo)(()=>({
                initialUrl: new URL(window.location.href),
                routeSubscriber: routeSubscriber
            }), [
            routeSubscriber
        ]);
        const routeUpdater = (0, $eUqFw.useMemo)(()=>({
                update: updateRoute
            }), [
            updateRoute
        ]);
        return [
            routeConfig,
            routeUpdater
        ];
    };
    const $1292a94470acda10$export$bb606326acdd1a64 = (deps)=>{
        const { update: update } = $1292a94470acda10$export$72fd8977abf03d60();
        (0, $eUqFw.useEffect)(()=>{
            if (typeof window === 'undefined') return;
            update({
                next: new URL(window.location.href)
            });
        }, deps);
    };
    const $1292a94470acda10$export$31986273b686f5ea = ({ children: children })=>{
        const [route, routeUpdater] = $1292a94470acda10$export$755edb1665399d41();
        return (0, ($parcel$interopDefault($eUqFw))).createElement($1292a94470acda10$var$RouteListenerContext.Provider, {
            value: routeUpdater
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3ddpf.PostOfficeRouteProvider), route, children));
    };
});
parcelRegister("1lYvF", function(module, exports) {
    $parcel$export(module.exports, "createSimplePubSub", ()=>$aaa4a445550645e2$export$92469b55607f005b);
    const $aaa4a445550645e2$export$92469b55607f005b = ()=>{
        const subscribers = new Map();
        const subscribe = (subscriber)=>{
            subscribers.set(subscriber, subscriber);
            return ()=>{
                subscribers.delete(subscriber);
            };
        };
        const publish = (payload)=>{
            subscribers.forEach((callback)=>callback(payload));
        };
        return [
            subscribe,
            publish
        ];
    };
});
parcelRegister("3ddpf", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeRouteContext", ()=>$9eb215490539274f$export$f7f47a74e8b47b1f);
    $parcel$export(module.exports, "PostOfficeRouteProvider", ()=>$9eb215490539274f$export$89eadc6b3e5f4e9e);
    $parcel$export(module.exports, "usePostOfficeRoute", ()=>$9eb215490539274f$export$79301b66f7808cd8);
    var $eUqFw = parcelRequire("eUqFw");
    var $7GDOq = parcelRequire("7GDOq");
    var $6u0yW = parcelRequire("6u0yW");
    const $9eb215490539274f$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
        let state = $9eb215490539274f$var$initializeState({
            initialUrl: initialUrl
        });
        const handleUpdate = (routeChange)=>{
            const next = routeChange.next?.toString();
            if (next === state.current) return;
            state = {
                previous: state.current,
                current: next
            };
        };
        const subscribe = (next)=>routeSubscriber((routeChange)=>{
                handleUpdate(routeChange);
                next();
            });
        const getSnapshot = ()=>{
            return state;
        };
        return {
            subscribe: subscribe,
            getSnapshot: getSnapshot
        };
    };
    const $9eb215490539274f$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
        const route = (0, $7GDOq.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
        return (0, $6u0yW.useStableObject)(route);
    };
    const $9eb215490539274f$var$initialState = {
        previous: undefined,
        current: undefined
    };
    const $9eb215490539274f$var$initializeState = ({ initialUrl: initialUrl })=>({
            ...$9eb215490539274f$var$initialState,
            current: initialUrl ? initialUrl?.toString() : undefined
        });
    const $9eb215490539274f$export$f7f47a74e8b47b1f = (0, $eUqFw.createContext)($9eb215490539274f$var$initialState);
    const $9eb215490539274f$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
        const ref = (0, $eUqFw.useRef)();
        if (!ref.current) ref.current = $9eb215490539274f$export$98c77e1bd702ed15(props);
        const route = $9eb215490539274f$var$usePostOfficeRouteStore(ref.current);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($9eb215490539274f$export$f7f47a74e8b47b1f.Provider, {
            value: route
        }, children);
    };
    const $9eb215490539274f$export$79301b66f7808cd8 = ()=>(0, $eUqFw.useContext)($9eb215490539274f$export$f7f47a74e8b47b1f);
});
parcelRegister("6u0yW", function(module, exports) {
    $parcel$export(module.exports, "useStableObject", ()=>$67961c771f81dd47$export$ed02d4adf2068b08);
    var $eUqFw = parcelRequire("eUqFw");
    function $67961c771f81dd47$export$cdf98ded28406f69(obj) {
        return Object.entries(obj).sort().flatMap((v)=>v);
    }
    function $67961c771f81dd47$export$ed02d4adf2068b08(obj) {
        return (0, $eUqFw.useMemo)(()=>obj, $67961c771f81dd47$export$cdf98ded28406f69(obj));
    }
});
parcelRegister("4YrL8", function(module, exports) {
    $parcel$export(module.exports, "PostOfficeScreenContextProvider", ()=>$6be97672f10126f7$export$ca77a8cbe94108fe);
    $parcel$export(module.exports, "usePostOfficeScreenPlacement", ()=>$6be97672f10126f7$export$f51d04a086368016);
    var $eUqFw = parcelRequire("eUqFw");
    var $kwSzI = parcelRequire("kwSzI");
    const $6be97672f10126f7$var$initialPlacementState = {
        currentlyMounted: [],
        hasMounted: []
    };
    const $6be97672f10126f7$var$PostOfficeScreenContext = (0, $eUqFw.createContext)({
        placements: $6be97672f10126f7$var$initialPlacementState
    });
    const $6be97672f10126f7$export$70e19226ddeaf957 = ()=>(0, $eUqFw.useContext)($6be97672f10126f7$var$PostOfficeScreenContext);
    const $6be97672f10126f7$var$PostOfficeScreenUpdateContext = (0, $eUqFw.createContext)({
        placementMount: ()=>{},
        placementUnmount: ()=>{}
    });
    const $6be97672f10126f7$export$5d27c0ee02be2a23 = ()=>(0, $eUqFw.useContext)($6be97672f10126f7$var$PostOfficeScreenUpdateContext);
    const $6be97672f10126f7$export$ca77a8cbe94108fe = ({ children: children })=>{
        const [placements, setPlacements] = (0, $eUqFw.useState)($6be97672f10126f7$var$initialPlacementState);
        const placementMount = (0, $eUqFw.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                    ...state,
                    currentlyMounted: (0, $kwSzI.uniqueArray)([
                        ...state.currentlyMounted,
                        placementId
                    ]),
                    hasMounted: (0, $kwSzI.uniqueArray)([
                        ...state.hasMounted,
                        placementId
                    ])
                }), []);
        const placementUnmount = (0, $eUqFw.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                    ...state,
                    currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
                }), []);
        const postOfficeScreenUpdateContext = (0, $eUqFw.useMemo)(()=>({
                placementMount: placementMount,
                placementUnmount: placementUnmount
            }), [
            placementMount,
            placementUnmount
        ]);
        const postOfficeScreenContext = (0, $eUqFw.useMemo)(()=>({
                placements: placements
            }), [
            placements
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($6be97672f10126f7$var$PostOfficeScreenUpdateContext.Provider, {
            value: postOfficeScreenUpdateContext
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($6be97672f10126f7$var$PostOfficeScreenContext.Provider, {
            value: postOfficeScreenContext
        }, children));
    };
    const $6be97672f10126f7$export$f51d04a086368016 = ({ placementId: placementId })=>{
        const { placementMount: placementMount, placementUnmount: placementUnmount } = $6be97672f10126f7$export$5d27c0ee02be2a23();
        (0, $eUqFw.useEffect)(()=>{
            if (!placementId) return;
            placementMount({
                placementId: placementId
            });
            return ()=>{
                placementUnmount({
                    placementId: placementId
                });
            };
        }, [
            placementId,
            placementMount,
            placementUnmount
        ]);
    };
});
parcelRegister("kwSzI", function(module, exports) {
    $parcel$export(module.exports, "uniqueArray", ()=>$19682a0f1948624d$export$bbd17ecb0679edd7);
    const $19682a0f1948624d$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());
});
parcelRegister("f2j1u", function(module, exports) {
    $parcel$export(module.exports, "createMessagePlacementValues", ()=>$3fdb1b383df5f9b1$export$a28a0c048b24fc5a);
    $parcel$export(module.exports, "MessagePlacementProvider", ()=>$3fdb1b383df5f9b1$export$c7535f8ebc5b75a9);
    $parcel$export(module.exports, "useMessagePlacementHooks", ()=>$3fdb1b383df5f9b1$export$89f8e1f623d8f5ac);
    var $eUqFw = parcelRequire("eUqFw");
    const $3fdb1b383df5f9b1$var$createPubSub = ()=>{
        const subscribers = new Map();
        const subscribe = (subscriber)=>{
            subscribers.set(subscriber, subscriber);
            return ()=>{
                subscribers.delete(subscriber);
            };
        };
        const publish = (payload)=>{
            subscribers.forEach((cb)=>cb(payload));
        };
        return [
            subscribe,
            publish
        ];
    };
    const $3fdb1b383df5f9b1$export$a28a0c048b24fc5a = ()=>{
        const [onMessageDismiss, dismissMessageFromPlacement] = $3fdb1b383df5f9b1$var$createPubSub();
        const [onMessageRead, markReadFromPlacement] = $3fdb1b383df5f9b1$var$createPubSub();
        const [onMessageViewed, markViewedFromPlacement] = $3fdb1b383df5f9b1$var$createPubSub();
        const [onMessageClicked, markClickedFromPlacement] = $3fdb1b383df5f9b1$var$createPubSub();
        return {
            onMessageDismiss: onMessageDismiss,
            dismissMessageFromPlacement: dismissMessageFromPlacement,
            onMessageRead: onMessageRead,
            markReadFromPlacement: markReadFromPlacement,
            onMessageViewed: onMessageViewed,
            markViewedFromPlacement: markViewedFromPlacement,
            onMessageClicked: onMessageClicked,
            markClickedFromPlacement: markClickedFromPlacement
        };
    };
    const $3fdb1b383df5f9b1$export$ea58328f3ceee4d4 = (0, $eUqFw.createContext)($3fdb1b383df5f9b1$export$a28a0c048b24fc5a());
    const $3fdb1b383df5f9b1$export$c7535f8ebc5b75a9 = $3fdb1b383df5f9b1$export$ea58328f3ceee4d4.Provider;
    const $3fdb1b383df5f9b1$export$c4b5cec0911af177 = ()=>({ children: children })=>(0, ($parcel$interopDefault($eUqFw))).createElement($3fdb1b383df5f9b1$export$c7535f8ebc5b75a9, {
                value: $3fdb1b383df5f9b1$export$a28a0c048b24fc5a()
            }, children);
    const $3fdb1b383df5f9b1$export$89f8e1f623d8f5ac = ()=>(0, $eUqFw.useContext)($3fdb1b383df5f9b1$export$ea58328f3ceee4d4);
});
parcelRegister("4gIhL", function(module, exports) {
    $parcel$export(module.exports, "generateEnvironmentConfigWithOverrides", ()=>$14bbe57358845344$export$ae3dab16eb1fc2cc);
    const $14bbe57358845344$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
        const { env: env, overrides: overrides } = environmentWithOverrides;
        return {
            currentEnv: env,
            envConfigs: {
                ...defaultEnvironmentValues.envConfigs,
                [env]: {
                    remoteModule: {
                        origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                        pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                        searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                    },
                    api: {
                        origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                        pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                        searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                    }
                }
            }
        };
    };
});
parcelRegister("cajdb", function(module, exports) {
    $parcel$export(module.exports, "ScreenSpaceFlagsPlacement", ()=>$e7a37d5e7fd181fa$export$f6564e60882bdf90);
    var $eUqFw = parcelRequire("eUqFw");
    var $l1JmV = parcelRequire("l1JmV");
    var $eI5EY = parcelRequire("eI5EY");
    var $gZ48R = parcelRequire("gZ48R");
    var $hRUsD = parcelRequire("hRUsD");
    const $e7a37d5e7fd181fa$export$f6564e60882bdf90 = ()=>{
        return !false && !(0, $gZ48R.default)((0, $bfe8fff5e78bf213$export$37d4bb5bc0e315db)) && (0, $eI5EY.fg)('post-office-screen-space-overlay-jfe') ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hRUsD.default), {
            placementId: "screen-space-flags",
            PlacementComponent: (0, $l1JmV.default),
            disableInitialData: true
        }) : null;
    };
});
parcelRegister("l1JmV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cce3271587881c2b$export$2e2bcd8739ae039);
    var $lHkHI = parcelRequire("lHkHI");
    var $eUqFw = parcelRequire("eUqFw");
    var $fPtA6 = parcelRequire("fPtA6");
    var $5PkPo = parcelRequire("5PkPo");
    var $f2j1u = parcelRequire("f2j1u");
    var $1UrNB = parcelRequire("1UrNB");
    var $7gqVz = parcelRequire("7gqVz");
    var $ivWKN = parcelRequire("ivWKN");
    var $kDAdd = parcelRequire("kDAdd");
    var $bYHfN = parcelRequire("bYHfN");
    var $iA29T = parcelRequire("iA29T");
    const $cce3271587881c2b$export$c60b43809441c5b0 = (0, $iA29T.withScreenSpaceFlagsIntlProvider)((0, $1UrNB.createPlacementComponent)((0, $56bbe7d3a0ddb9e6$export$a5cfae247d8360ef), ({ initialData: initialData })=>{
        const [localMessageState, setLocalMessageState] = (0, $eUqFw.useState)();
        (0, $7gqVz.useInitialData)(initialData);
        const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked } = (0, $f2j1u.useMessagePlacementHooks)();
        const handleDismiss = ({ messageInstanceId: messageInstanceId })=>{
            setLocalMessageState((current)=>current ? current.filter((e)=>e.messageInstanceId !== messageInstanceId) : undefined);
        };
        (0, $eUqFw.useEffect)(()=>onMessageDismiss(handleDismiss), [
            onMessageDismiss
        ]);
        (0, $eUqFw.useEffect)(()=>onMessageClicked(handleDismiss), [
            onMessageClicked
        ]);
        const activeScopes = (0, $5PkPo.usePostOfficeContextScope)({
            scopes: $kDAdd.scopes
        });
        const messagesState = (0, $ivWKN.usePlacementApi)('/update-messages', {
            requestOptions: {
                method: 'POST',
                body: JSON.stringify(activeScopes)
            },
            throttleTime: 100,
            autoRefetch: {
                isEnabled: !!activeScopes.updateKey && typeof localMessageState === 'undefined',
                updateKey: activeScopes.updateKey ?? ''
            }
        });
        (0, $eUqFw.useEffect)(()=>{
            if (messagesState?.data?.messages?.length) setLocalMessageState(messagesState.data.messages);
        }, [
            messagesState.data
        ]);
        return (0, $fPtA6.default).checkGate('post-office-screen-space-flags-shadow') ? (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
            children: localMessageState?.slice(0, 1).map(({ messageInstanceId: messageInstanceId, ...props })=>(0, $eUqFw.createElement)((0, $bYHfN.MessageRenderer), {
                    ...props,
                    key: messageInstanceId,
                    id: messageInstanceId,
                    messageInstanceId: messageInstanceId,
                    onDismissed: ()=>setLocalMessageState([])
                }))
        }) : null;
    }));
    var $cce3271587881c2b$export$2e2bcd8739ae039 = $cce3271587881c2b$export$c60b43809441c5b0;
});
parcelRegister("lHkHI", function(module, exports) {
    'use strict';
    module.exports = (parcelRequire("4SRlw"));
});
parcelRegister("4SRlw", function(module, exports) {
    $parcel$export(module.exports, "Fragment", ()=>$38e595fef2d7b104$export$ffb0004e005737fa, (v)=>$38e595fef2d7b104$export$ffb0004e005737fa = v);
    $parcel$export(module.exports, "jsx", ()=>$38e595fef2d7b104$export$34b9dba7ce09269b, (v)=>$38e595fef2d7b104$export$34b9dba7ce09269b = v);
    $parcel$export(module.exports, "jsxs", ()=>$38e595fef2d7b104$export$25062201e9e25d76, (v)=>$38e595fef2d7b104$export$25062201e9e25d76 = v);
    var $38e595fef2d7b104$export$ffb0004e005737fa;
    var $38e595fef2d7b104$export$34b9dba7ce09269b;
    var $38e595fef2d7b104$export$25062201e9e25d76;
    'use strict';
    var $eUqFw = parcelRequire("eUqFw");
    var $38e595fef2d7b104$var$k = Symbol.for("react.element"), $38e595fef2d7b104$var$l = Symbol.for("react.fragment"), $38e595fef2d7b104$var$m = Object.prototype.hasOwnProperty, $38e595fef2d7b104$var$n = $eUqFw.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $38e595fef2d7b104$var$p = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
    };
    function $38e595fef2d7b104$var$q(c, a, g) {
        var b, d = {}, e = null, h = null;
        void 0 !== g && (e = "" + g);
        void 0 !== a.key && (e = "" + a.key);
        void 0 !== a.ref && (h = a.ref);
        for(b in a)$38e595fef2d7b104$var$m.call(a, b) && !$38e595fef2d7b104$var$p.hasOwnProperty(b) && (d[b] = a[b]);
        if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
        return {
            $$typeof: $38e595fef2d7b104$var$k,
            type: c,
            key: e,
            ref: h,
            props: d,
            _owner: $38e595fef2d7b104$var$n.current
        };
    }
    $38e595fef2d7b104$export$ffb0004e005737fa = $38e595fef2d7b104$var$l;
    $38e595fef2d7b104$export$34b9dba7ce09269b = $38e595fef2d7b104$var$q;
    $38e595fef2d7b104$export$25062201e9e25d76 = $38e595fef2d7b104$var$q;
});
parcelRegister("5PkPo", function(module, exports) {
    $parcel$export(module.exports, "usePostOfficeContextScope", ()=>$cc36f0be83612f7a$export$daf66a67c26dc848);
    var $eUqFw = parcelRequire("eUqFw");
    var $bqxFG = parcelRequire("bqxFG");
    var $j3kUo = parcelRequire("j3kUo");
    var $3ddpf = parcelRequire("3ddpf");
    var $1lYvF = parcelRequire("1lYvF");
    const $cc36f0be83612f7a$export$daf66a67c26dc848 = (config)=>{
        const scopeNames = $cc36f0be83612f7a$var$scopesNamesAsString(config.scopes);
        const matchScopes = (0, $eUqFw.useCallback)((input)=>$cc36f0be83612f7a$export$ec890b48cae4cc1c(config)(input), [
            scopeNames
        ]);
        const [state, setState] = (0, $eUqFw.useState)($cc36f0be83612f7a$var$initialState);
        const route = (0, $3ddpf.usePostOfficeRoute)();
        const context = (0, $j3kUo.usePostOfficeContext)();
        const next = matchScopes({
            route: route,
            context: context
        });
        $cc36f0be83612f7a$var$usePostOfficeScopeSpy(state, config);
        (0, $eUqFw.useEffect)(()=>{
            if ($cc36f0be83612f7a$export$fcc046cb16c47539({
                next: next,
                state: state
            })) setState(({ current: current })=>({
                    updateKey: Math.random().toString(36).substring(2),
                    current: next,
                    previous: current
                }));
        }, [
            $cc36f0be83612f7a$var$scopesNamesAsString(next)
        ]);
        return state;
    };
    const $cc36f0be83612f7a$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
    const $cc36f0be83612f7a$var$initialState = {
        updateKey: undefined,
        current: [],
        previous: []
    };
    const $cc36f0be83612f7a$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
            const contextMatch = route?.current ? {
                route: $cc36f0be83612f7a$var$extractRelevantUrlFields(route.current),
                context: context
            } : {
                route: undefined,
                context: context
            };
            const inputMatch = input.when;
            return $cc36f0be83612f7a$var$matchScope({
                contextMatch: contextMatch,
                inputMatch: inputMatch
            });
        };
    const $cc36f0be83612f7a$var$extractRelevantUrlFields = (route)=>{
        const { hostname: hostname, pathname: pathname } = new URL(route);
        return {
            hostname: hostname,
            pathname: pathname
        };
    };
    const $cc36f0be83612f7a$var$matchScope = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, ($parcel$interopDefault($bqxFG)))(contextMatch, inputMatch, (contextValue, inputValue)=>$cc36f0be83612f7a$var$isValueMatchDeep({
                contextValue: contextValue,
                inputValue: inputValue
            }));
    const $cc36f0be83612f7a$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
        if (!contextValue || !inputValue) return false;
        if (typeof inputValue === 'string') return contextValue === inputValue;
        if (inputValue?.equals) return contextValue === inputValue.equals;
        if (!inputValue?.matches) return false;
        if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
        return new RegExp(inputValue.matches).test(contextValue);
    };
    const $cc36f0be83612f7a$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $cc36f0be83612f7a$var$matchScope({
            contextMatch: contextValue,
            inputMatch: inputValue
        }) : $cc36f0be83612f7a$var$isValueMatch({
            contextValue: contextValue,
            inputValue: inputValue
        });
    const $cc36f0be83612f7a$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($cc36f0be83612f7a$var$createMatchScope(input)).map((scope)=>({
                    name: scope.name
                }));
    const $cc36f0be83612f7a$export$fcc046cb16c47539 = ({ next: next, state: state })=>{
        const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
        const nextSet = Array.from(new Set(next.map((e)=>e.name)));
        if (nextSet.length !== currentSet.length) return true;
        return !nextSet.every((e)=>currentSet.includes(e));
    };
    const $cc36f0be83612f7a$var$usePostOfficeScopeSpy = (state, config)=>{
        if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
            const [listen, update] = (0, $1lYvF.createSimplePubSub)();
            window.postOffice = {
                ...window.postOffice,
                scopes: {
                    [config?.consoleSpy.name]: {
                        listen: listen,
                        update: update,
                        list: config.scopes
                    }
                }
            };
        }
        (0, $eUqFw.useEffect)(()=>{
            if (!config?.consoleSpy) return;
            if (!window.postOffice?.scopes) return;
            window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
        }, [
            $cc36f0be83612f7a$var$scopesNamesAsString(state.current)
        ]);
    };
});
parcelRegister("bqxFG", function(module, exports) {
    var $fEi2Q = parcelRequire("fEi2Q");
    var $lBs6Q = parcelRequire("lBs6Q");
    function $851c3ddb809f167c$var$isMatchWith(object, source, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined;
        return $fEi2Q(object, source, $lBs6Q(source), customizer);
    }
    module.exports = $851c3ddb809f167c$var$isMatchWith;
});
parcelRegister("1UrNB", function(module, exports) {
    $parcel$export(module.exports, "createPlacementComponent", ()=>$765ce6b325c41b27$export$8a57effc6307f916);
    var $lHkHI = parcelRequire("lHkHI");
    var $6u0yW = parcelRequire("6u0yW");
    var $9y9F6 = parcelRequire("9y9F6");
    var $6kUkm = parcelRequire("6kUkm");
    var $5Cisc = parcelRequire("5Cisc");
    var $bzAIh = parcelRequire("bzAIh");
    var $h90gO = parcelRequire("h90gO");
    const $765ce6b325c41b27$export$eaeb39efb2b24b52 = (placementId, Component)=>(0, $h90gO.withErrorBoundary)((props)=>{
            const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, ...componentProps } = props;
            const { postOfficeRoute: route, ...context } = contextWithRoute;
            const stableContext = (0, $6u0yW.useStableObject)(context);
            return (0, $lHkHI.jsx)((0, $5Cisc.PerformanceTracking), {
                initialData: initialData,
                onEvent: onEvent,
                children: (0, $lHkHI.jsx)((0, $bzAIh.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    children: (0, $lHkHI.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            });
        });
    const $765ce6b325c41b27$export$8a57effc6307f916 = (placementId, Component)=>{
        const placement = $765ce6b325c41b27$export$eaeb39efb2b24b52(placementId, Component);
        return (props)=>{
            const { onError: onError, fallbackRender: fallbackRender } = (0, $6kUkm.useComponentErrorHandling)(props);
            return placement({
                ...props,
                errorBoundaryLocation: (0, $9y9F6.ERROR_BOUNDARY_LOCATION),
                onError: onError,
                fallbackRender: fallbackRender
            });
        };
    };
});
parcelRegister("9y9F6", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_CONTEXT", ()=>$c9f3ff78d1819974$export$9c542858adf7dcd0);
    $parcel$export(module.exports, "ERROR_BOUNDARY_LOCATION", ()=>$c9f3ff78d1819974$export$71ff7382870ef1b0);
    const $c9f3ff78d1819974$export$9c542858adf7dcd0 = {
        isSiteAdmin: undefined,
        locale: undefined,
        product: undefined,
        subproduct: undefined,
        tenantId: undefined,
        workspaceAri: 'no-workspace-ari-available',
        workspaceId: undefined,
        orgId: undefined,
        productEdition: undefined
    };
    const $c9f3ff78d1819974$export$71ff7382870ef1b0 = 'create-placement-component';
});
parcelRegister("6kUkm", function(module, exports) {
    $parcel$export(module.exports, "useComponentErrorHandling", ()=>$90621067804b3831$export$3d127465d22fe4e5);
    var $eUqFw = parcelRequire("eUqFw");
    const $90621067804b3831$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
        const internalOnError = (0, $eUqFw.useCallback)((error, info)=>{
            onEvent?.({
                type: 'component-error',
                error: error
            });
            onError?.(error, info);
        }, [
            onEvent,
            onError
        ]);
        const internalFallbackRender = fallbackRender ?? errorFallback;
        return {
            onError: internalOnError,
            fallbackRender: internalFallbackRender
        };
    };
});
parcelRegister("5Cisc", function(module, exports) {
    $parcel$export(module.exports, "PerformanceTracking", ()=>$82f463ccd096157f$export$9a335a42ce02bdb8);
    var $lHkHI = parcelRequire("lHkHI");
    var $fPtA6 = parcelRequire("fPtA6");
    var $empal = parcelRequire("empal");
    var $cLtT7 = parcelRequire("cLtT7");
    var $7j87h = parcelRequire("7j87h");
    const $82f463ccd096157f$export$9a335a42ce02bdb8 = ({ children: children, ...props })=>{
        const isUFOEnabled = (0, $fPtA6.default).checkGate('enable_ufo_tracking_in_post_office');
        const { isLoading: isLoading, onMount: onMount } = (0, $7j87h.usePerformanceTracking)(props);
        return (0, $lHkHI.jsxs)((0, $empal.UFOv2).UFOSegment, {
            name: (0, $empal.UFOv2).SegmentNames.PLACEMENT,
            children: [
                isUFOEnabled && isLoading && (0, $lHkHI.jsx)((0, $empal.UFOv2).UFOLoadHold, {
                    name: (0, $empal.UFOv2).HoldNames.PLACEMENT
                }),
                (0, $lHkHI.jsx)((0, $cLtT7.TrackMount), {
                    onMount: onMount,
                    children: children
                })
            ]
        });
    };
});
parcelRegister("empal", function(module, exports) {
    $parcel$export(module.exports, "UFOv2", ()=>$ce6fdd8d6c94dfe2$export$c91b09caa8ecbab1);
    var $i4dIm = parcelRequire("i4dIm");
    var $6WLCX = parcelRequire("6WLCX");
    const $ce6fdd8d6c94dfe2$export$c91b09caa8ecbab1 = {
        SegmentNames: {
            REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
            PLACEMENT: 'post-office-placement',
            MESSAGE: 'post-office-message'
        },
        HoldNames: {
            REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
            PLACEMENT: 'post-office-placement-loading',
            MESSAGE: 'post-office-message-loading'
        },
        UFOLoadHold: $i4dIm.default,
        UFOSegment: $6WLCX.default
    };
});
parcelRegister("cLtT7", function(module, exports) {
    $parcel$export(module.exports, "TrackMount", ()=>$10a148881b5890c1$export$21b400a8c8ebc91a);
    var $lHkHI = parcelRequire("lHkHI");
    var $eUqFw = parcelRequire("eUqFw");
    const $10a148881b5890c1$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
        (0, $eUqFw.useEffect)(()=>{
            const onUnmount = onMount();
            return onUnmount;
        }, []);
        return (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
            children: children
        });
    };
});
parcelRegister("7j87h", function(module, exports) {
    $parcel$export(module.exports, "usePerformanceTracking", ()=>$00c9026e9028823e$export$317d52099614f316);
    var $eUqFw = parcelRequire("eUqFw");
    const $00c9026e9028823e$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
        const [isLoading, setIsLoading] = (0, $eUqFw.useState)(true);
        const onMount = (0, $eUqFw.useCallback)(()=>{
            return ()=>onEvent?.({
                    type: 'unmount'
                });
        }, [
            onEvent
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (initialData) initialData.then(()=>{
                onEvent?.({
                    type: 'initial-data-complete'
                });
            }).catch((error)=>{
                onEvent?.({
                    type: 'initial-data-error',
                    error: error
                });
            }).finally(()=>{
                setIsLoading(false);
            });
            else setIsLoading(false);
        }, [
            initialData,
            onEvent
        ]);
        const onComponentError = (0, $eUqFw.useCallback)((error)=>{
            onEvent?.({
                type: 'component-error',
                error: error
            });
        }, [
            onEvent
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (isLoading === false) onEvent?.({
                type: 'component-ready'
            });
        }, [
            isLoading
        ]);
        return {
            onMount: onMount,
            isLoading: isLoading,
            onComponentError: onComponentError
        };
    };
});
parcelRegister("bzAIh", function(module, exports) {
    $parcel$export(module.exports, "StableProviders", ()=>$f1e72e76f85e55c3$export$2b6596bcb1383a71);
    var $lHkHI = parcelRequire("lHkHI");
    var $1QTQv = parcelRequire("1QTQv");
    var $eqTiY = parcelRequire("eqTiY");
    var $j51pQ = parcelRequire("j51pQ");
    var $iOtaf = parcelRequire("iOtaf");
    var $33JlM = parcelRequire("33JlM");
    var $5Cisc = parcelRequire("5Cisc");
    const $f1e72e76f85e55c3$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route })=>(0, $lHkHI.jsx)((0, $j51pQ.StableContextProvider), {
            context: context,
            children: (0, $lHkHI.jsx)((0, $iOtaf.StablePlacementProvider), {
                placement: placement,
                children: (0, $lHkHI.jsx)((0, $33JlM.StableRouteProvider), {
                    route: route,
                    children: (0, $lHkHI.jsx)((0, $1QTQv.StableAnaltyicsProvider), {
                        children: (0, $lHkHI.jsx)((0, $eqTiY.StableChoreographerProvider), {
                            children: children
                        })
                    })
                })
            })
        });
});
parcelRegister("1QTQv", function(module, exports) {
    $parcel$export(module.exports, "StableAnaltyicsProvider", ()=>$4b6819cde28b8976$export$5a66cdc9893b43e);
    var $lHkHI = parcelRequire("lHkHI");
    var $9VkvA = parcelRequire("9VkvA");
    const $4b6819cde28b8976$var$postOfficeAnalyticsContextData = {
        attributes: {
            build: {
                c: undefined,
                b: undefined,
                t: undefined
            }
        }
    };
    const $4b6819cde28b8976$export$5a66cdc9893b43e = ({ children: children })=>{
        return (0, $lHkHI.jsx)((0, $9VkvA.PostOfficeAnalyticsContext), {
            data: $4b6819cde28b8976$var$postOfficeAnalyticsContextData,
            children: children
        });
    };
});
parcelRegister("eqTiY", function(module, exports) {
    $parcel$export(module.exports, "StableChoreographerProvider", ()=>$bdb958e36f4c62c4$export$e68b2c75bfb5682a);
    $parcel$export(module.exports, "useChoreographerContext", ()=>$bdb958e36f4c62c4$export$cab5a8adbabcee23);
    var $lHkHI = parcelRequire("lHkHI");
    var $j3kUo = parcelRequire("j3kUo");
    var $1nkI5 = parcelRequire("1nkI5");
    var $eUqFw = parcelRequire("eUqFw");
    var $8RF0c = parcelRequire("8RF0c");
    const $bdb958e36f4c62c4$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
    const $bdb958e36f4c62c4$var$defaultContext = {
        choreographerEnabled: $bdb958e36f4c62c4$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
        setChoreographerEnabled: ()=>{},
        factory: undefined
    };
    const $bdb958e36f4c62c4$var$ChoreographerContext = (0, $eUqFw.createContext)($bdb958e36f4c62c4$var$defaultContext);
    const $bdb958e36f4c62c4$export$e68b2c75bfb5682a = ({ children: children })=>{
        const [choreographerEnabled, setChoreographerEnabled] = (0, $eUqFw.useState)($bdb958e36f4c62c4$var$defaultContext.choreographerEnabled);
        const environmentContext = (0, $1nkI5.usePostOfficeEnvironment)();
        const context = (0, $j3kUo.usePostOfficeContext)();
        const choreographerFactory = new (0, $8RF0c.default)(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory();
        const stableChoreographerContext = (0, $eUqFw.useMemo)(()=>({
                factory: choreographerFactory,
                choreographerEnabled: choreographerEnabled,
                setChoreographerEnabled: setChoreographerEnabled
            }), [
            choreographerFactory,
            choreographerEnabled,
            setChoreographerEnabled
        ]);
        return (0, $lHkHI.jsx)($bdb958e36f4c62c4$var$ChoreographerContext.Provider, {
            value: stableChoreographerContext,
            children: children
        });
    };
    const $bdb958e36f4c62c4$export$cab5a8adbabcee23 = ()=>(0, $eUqFw.useContext)($bdb958e36f4c62c4$var$ChoreographerContext);
});
parcelRegister("8RF0c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92c47341de3bf614$export$2e2bcd8739ae039);
    var $6fplD = parcelRequire("6fplD");
    var $gIvAV = parcelRequire("gIvAV");
    var $1nBQ6 = parcelRequire("1nBQ6");
    const $92c47341de3bf614$var$mapEnvToAnalyticsEnv = (env)=>{
        switch(env){
            case 'test':
            case 'local':
                return (0, $1nBQ6.envType).LOCAL;
            case 'dev':
                return (0, $1nBQ6.envType).DEV;
            case 'staging':
            case 'stg-fedm-east':
                return (0, $1nBQ6.envType).STAGING;
            case 'production':
            case 'prod-fedm-east':
                return (0, $1nBQ6.envType).PROD;
            default:
                return (0, $1nBQ6.envType).DEV;
        }
    };
    class $92c47341de3bf614$var$ChoreographerRegistry {
        constructor(product, environment){
            this.product = product;
            this.environment = environment;
        }
        getPostOfficeChoreographerFactory() {
            if (window.choreographerRegistry === undefined) window.choreographerRegistry = new Map();
            const maybeChoreographerFactory = window.choreographerRegistry.get((0, $gIvAV.ProductIds).POST_OFFICE);
            if (maybeChoreographerFactory) return maybeChoreographerFactory;
            const factory = (0, $6fplD.choreographerFactory)((0, $gIvAV.ProductIds).POST_OFFICE, $92c47341de3bf614$var$mapEnvToAnalyticsEnv(this.environment), {
                sourceProductId: this.product
            });
            window.choreographerRegistry.set((0, $gIvAV.ProductIds).POST_OFFICE, factory);
            return factory;
        }
    }
    var $92c47341de3bf614$export$2e2bcd8739ae039 = $92c47341de3bf614$var$ChoreographerRegistry;
});
parcelRegister("j51pQ", function(module, exports) {
    $parcel$export(module.exports, "StableContextProvider", ()=>$c92be545cd63a532$export$d4982c0a28b18f63);
    var $lHkHI = parcelRequire("lHkHI");
    var $j3kUo = parcelRequire("j3kUo");
    var $6u0yW = parcelRequire("6u0yW");
    var $9y9F6 = parcelRequire("9y9F6");
    const $c92be545cd63a532$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
        const stableContext = (0, $6u0yW.useStableObject)({
            ...(0, $9y9F6.DEFAULT_CONTEXT),
            ...context
        });
        return (0, $lHkHI.jsx)((0, $j3kUo.PostOfficeContextProvider), {
            value: stableContext,
            children: children
        });
    };
});
parcelRegister("iOtaf", function(module, exports) {
    $parcel$export(module.exports, "StablePlacementProvider", ()=>$7727b9fc0bee6da2$export$e9fd288527498af6);
    var $lHkHI = parcelRequire("lHkHI");
    var $6u0yW = parcelRequire("6u0yW");
    var $iHPFP = parcelRequire("iHPFP");
    const $7727b9fc0bee6da2$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
        const stableValue = (0, $6u0yW.useStableObject)(placement);
        return (0, $lHkHI.jsx)((0, $iHPFP.PlacementProvider), {
            value: stableValue,
            children: children
        });
    };
});
parcelRegister("iHPFP", function(module, exports) {
    $parcel$export(module.exports, "PlacementProvider", ()=>$3e5f1571f9b6b14a$export$6272e220478c7f1d);
    $parcel$export(module.exports, "usePlacementContext", ()=>$3e5f1571f9b6b14a$export$4fc0446ee742ad80);
    var $lHkHI = parcelRequire("lHkHI");
    var $9VkvA = parcelRequire("9VkvA");
    var $4YrL8 = parcelRequire("4YrL8");
    var $eUqFw = parcelRequire("eUqFw");
    const $3e5f1571f9b6b14a$export$6394bf86db095a8 = (0, $eUqFw.createContext)({
        placementId: undefined
    });
    const $3e5f1571f9b6b14a$export$6272e220478c7f1d = ({ value: value, children: children })=>{
        const memoizedValue = (0, $eUqFw.useMemo)(()=>({
                placementId: value.placementId
            }), [
            value.placementId
        ]);
        (0, $4YrL8.usePostOfficeScreenPlacement)(memoizedValue);
        return (0, $lHkHI.jsx)($3e5f1571f9b6b14a$export$6394bf86db095a8.Provider, {
            value: memoizedValue,
            children: (0, $lHkHI.jsx)((0, $9VkvA.PostOfficeAnalyticsContext), {
                data: memoizedValue,
                children: children
            })
        });
    };
    const $3e5f1571f9b6b14a$export$4fc0446ee742ad80 = ()=>(0, $eUqFw.useContext)($3e5f1571f9b6b14a$export$6394bf86db095a8);
});
parcelRegister("33JlM", function(module, exports) {
    $parcel$export(module.exports, "StableRouteProvider", ()=>$feb597fbba762c0e$export$ce13d00e696dfc96);
    var $lHkHI = parcelRequire("lHkHI");
    var $3ddpf = parcelRequire("3ddpf");
    var $6u0yW = parcelRequire("6u0yW");
    var $gAm4R = parcelRequire("gAm4R");
    const $feb597fbba762c0e$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
        const href = (0, $gAm4R.useLocationHref)();
        const stableRoute = (0, $6u0yW.useStableObject)(route ?? {
            previous: href,
            current: href
        });
        return (0, $lHkHI.jsx)((0, $3ddpf.PostOfficeRouteContext).Provider, {
            value: stableRoute,
            children: children
        });
    };
});
parcelRegister("gAm4R", function(module, exports) {
    $parcel$export(module.exports, "useLocationHref", ()=>$a4a52229c8fd5d38$export$49fc3f3d8c7f99);
    const $a4a52229c8fd5d38$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
    const $a4a52229c8fd5d38$export$49fc3f3d8c7f99 = ()=>{
        return $a4a52229c8fd5d38$var$isLocationAvailable() ? globalThis.location.href : undefined;
    };
});
parcelRegister("h90gO", function(module, exports) {
    $parcel$export(module.exports, "withErrorBoundary", ()=>$8c2bef55b28fda9a$export$f0c7a449e0cfaec7);
    var $lHkHI = parcelRequire("lHkHI");
    var $dwiXA = parcelRequire("dwiXA");
    var $j8FYN = parcelRequire("j8FYN");
    const $8c2bef55b28fda9a$export$f0c7a449e0cfaec7 = (Component)=>({ errorBoundaryLocation: errorBoundaryLocation, fallbackRender: fallbackRender, onError: onError, ...data })=>{
            const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dwiXA.useFirePostOfficeAnalyticsEvents)();
            const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                    if (onError) onError(error, info);
                    fireAnalyticsEvent({
                        eventType: (0, $394220419f57a1b4$export$12346a674644c156),
                        action: 'caughtError',
                        actionSubject: 'PostOfficeErrorBoundary',
                        actionSubjectId: additionalAnalytics.errorBoundaryLocation
                    }, {
                        error: error,
                        info: info
                    });
                };
            const internalFallbackRender = (FallbackRender)=>(props)=>{
                    if (FallbackRender) return (0, $lHkHI.jsx)(FallbackRender, {
                        ...props
                    });
                    return null;
                };
            return (0, $lHkHI.jsx)((0, $j8FYN.ErrorBoundary), {
                fallbackRender: internalFallbackRender(fallbackRender),
                onError: internalOnError({
                    errorBoundaryLocation: errorBoundaryLocation
                }, onError),
                children: (0, $lHkHI.jsx)(Component, {
                    ...data
                })
            });
        };
});
const $394220419f57a1b4$export$a1562d08625f5d7e = 'ui';
const $394220419f57a1b4$export$947dac6c72b26f81 = 'track';
const $394220419f57a1b4$export$f1d537d508d2945a = 'screen';
const $394220419f57a1b4$export$12346a674644c156 = 'operational';
const $394220419f57a1b4$export$b055de0e665cb20c = 'unknown';
parcelRegister("dwiXA", function(module, exports) {
    $parcel$export(module.exports, "useFirePostOfficeAnalyticsEvents", ()=>$b29e538fb91e4212$export$57d19d18d6e255a5);
    var $1inzG = parcelRequire("1inzG");
    var $eUqFw = parcelRequire("eUqFw");
    const $b29e538fb91e4212$export$85183a312807388d = 'postOffice';
    const $b29e538fb91e4212$export$57d19d18d6e255a5 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        const fireAnalyticsEvent = (0, $eUqFw.useCallback)((event, attributes)=>{
            createAnalyticsEvent({
                ...event,
                side: 'client',
                attributes: {
                    ...event.attributes,
                    ...attributes
                }
            }).fire($b29e538fb91e4212$export$85183a312807388d);
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireAnalyticsEvent: fireAnalyticsEvent
        };
    };
});
parcelRegister("j8FYN", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$deef53f34e6cf8b4$export$e926676385687eaf);
    var $eUqFw = parcelRequire("eUqFw");
    'use client';
    const $deef53f34e6cf8b4$export$b16d9fb1a22de840 = (0, $eUqFw.createContext)(null);
    const $deef53f34e6cf8b4$var$initialState = {
        didCatch: false,
        error: null
    };
    class $deef53f34e6cf8b4$export$e926676385687eaf extends (0, $eUqFw.Component) {
        constructor(props){
            super(props);
            this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
            this.state = $deef53f34e6cf8b4$var$initialState;
        }
        static getDerivedStateFromError(error) {
            return {
                didCatch: true,
                error: error
            };
        }
        resetErrorBoundary() {
            const { error: error } = this.state;
            if (error !== null) {
                var _this$props$onReset, _this$props;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                    args: args,
                    reason: "imperative-api"
                });
                this.setState($deef53f34e6cf8b4$var$initialState);
            }
        }
        componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
        }
        componentDidUpdate(prevProps, prevState) {
            const { didCatch: didCatch } = this.state;
            const { resetKeys: resetKeys } = this.props;
            if (didCatch && prevState.error !== null && $deef53f34e6cf8b4$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
                var _this$props$onReset2, _this$props3;
                (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                    next: resetKeys,
                    prev: prevProps.resetKeys,
                    reason: "keys"
                });
                this.setState($deef53f34e6cf8b4$var$initialState);
            }
        }
        render() {
            const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
            const { didCatch: didCatch, error: error } = this.state;
            let childToRender = children;
            if (didCatch) {
                const props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
                else if (FallbackComponent) childToRender = (0, $eUqFw.createElement)(FallbackComponent, props);
                else if (fallback === null || (0, $eUqFw.isValidElement)(fallback)) childToRender = fallback;
                else throw error;
            }
            return (0, $eUqFw.createElement)($deef53f34e6cf8b4$export$b16d9fb1a22de840.Provider, {
                value: {
                    didCatch: didCatch,
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                }
            }, childToRender);
        }
    }
    function $deef53f34e6cf8b4$var$hasArrayChanged() {
        let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
    }
    function $deef53f34e6cf8b4$var$assertErrorBoundaryContext(value) {
        if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
    }
    function $deef53f34e6cf8b4$export$c052f6604b7d51fe() {
        const context = (0, $eUqFw.useContext)($deef53f34e6cf8b4$export$b16d9fb1a22de840);
        $deef53f34e6cf8b4$var$assertErrorBoundaryContext(context);
        const [state, setState] = (0, $eUqFw.useState)({
            error: null,
            hasError: false
        });
        const memoized = (0, $eUqFw.useMemo)(()=>({
                resetBoundary: ()=>{
                    context.resetErrorBoundary();
                    setState({
                        error: null,
                        hasError: false
                    });
                },
                showBoundary: (error)=>setState({
                        error: error,
                        hasError: true
                    })
            }), [
            context.resetErrorBoundary
        ]);
        if (state.hasError) throw state.error;
        return memoized;
    }
    function $deef53f34e6cf8b4$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
        const Wrapped = (0, $eUqFw.forwardRef)((props, ref)=>(0, $eUqFw.createElement)($deef53f34e6cf8b4$export$e926676385687eaf, errorBoundaryProps, (0, $eUqFw.createElement)(component, {
                ...props,
                ref: ref
            })));
        const name = component.displayName || component.name || "Unknown";
        Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
        return Wrapped;
    }
});
parcelRegister("7gqVz", function(module, exports) {
    $parcel$export(module.exports, "useInitialData", ()=>$b245a0977a99ba26$export$5523c5f3222291d0);
    var $eUqFw = parcelRequire("eUqFw");
    var $fo3on = parcelRequire("fo3on");
    const $b245a0977a99ba26$export$5523c5f3222291d0 = (initialData)=>{
        const initialDataCallback = (0, $eUqFw.useMemo)(()=>{
            if (typeof initialData === 'undefined') return undefined;
            return ()=>initialData;
        }, [
            initialData
        ]);
        return (0, $fo3on.useData)(initialDataCallback, {
            analytics: {
                name: 'initialData'
            }
        });
    };
});
parcelRegister("fo3on", function(module, exports) {
    $parcel$export(module.exports, "AlreadyRunningError", ()=>$682fb060bfe2c235$export$8c5224d3af2f3c8b);
    $parcel$export(module.exports, "useData", ()=>$682fb060bfe2c235$export$c1cf1cf4c5d51937);
    var $dwiXA = parcelRequire("dwiXA");
    var $aISWN = parcelRequire("aISWN");
    var $eUqFw = parcelRequire("eUqFw");
    var $8NcGQ = parcelRequire("8NcGQ");
    class $682fb060bfe2c235$export$8c5224d3af2f3c8b extends Error {
        constructor(){
            super('Request is already running.');
            this.name = 'AlreadyRunningError';
        }
    }
    const $682fb060bfe2c235$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
        const [state, setState] = (0, $eUqFw.useState)((0, $8NcGQ.toLoading)());
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dwiXA.useFirePostOfficeAnalyticsEvents)();
        const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
            name: 'unknown'
        };
        (0, $eUqFw.useEffect)(()=>{
            if (typeof promiseToResolve !== 'function') return;
            const abortController = new AbortController();
            const { signal: signal } = abortController;
            promiseToResolve({
                signal: signal
            }).then((0, $8NcGQ.assertResponseIsOk)).then((res)=>res.json()).then((data)=>{
                setState((0, $8NcGQ.toData)(data));
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, $aISWN.camelCase)(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }).catch((err)=>{
                if (err instanceof $682fb060bfe2c235$export$8c5224d3af2f3c8b || signal.aborted) return;
                const errorState = (0, $8NcGQ.toError)(err);
                fireAnalyticsEvent({
                    action: 'rejected',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, $aISWN.camelCase)(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes,
                        errorName: errorState.error.name ?? 'unknown',
                        errorMessage: errorState.error.message ?? 'unknown'
                    }
                });
                setState(errorState);
            });
            return ()=>{
                abortController.abort();
            };
        }, [
            promiseToResolve
        ]);
        return state;
    };
});
parcelRegister("aISWN", function(module, exports) {
    (function() {
        var undefined;
        var VERSION = '4.17.21';
        var LARGE_ARRAY_SIZE = 200;
        var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
        var HASH_UNDEFINED = '__lodash_hash_undefined__';
        var MAX_MEMOIZE_SIZE = 500;
        var PLACEHOLDER = '__lodash_placeholder__';
        var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
        var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
        var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
        var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
        var HOT_COUNT = 800, HOT_SPAN = 16;
        var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
        var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
        var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
        var wrapFlags = [
            [
                'ary',
                WRAP_ARY_FLAG
            ],
            [
                'bind',
                WRAP_BIND_FLAG
            ],
            [
                'bindKey',
                WRAP_BIND_KEY_FLAG
            ],
            [
                'curry',
                WRAP_CURRY_FLAG
            ],
            [
                'curryRight',
                WRAP_CURRY_RIGHT_FLAG
            ],
            [
                'flip',
                WRAP_FLIP_FLAG
            ],
            [
                'partial',
                WRAP_PARTIAL_FLAG
            ],
            [
                'partialRight',
                WRAP_PARTIAL_RIGHT_FLAG
            ],
            [
                'rearg',
                WRAP_REARG_FLAG
            ]
        ];
        var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
        var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
        var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
        var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
        var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
        var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
        var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
        var reTrimStart = /^\s+/;
        var reWhitespace = /\s/;
        var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
        var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
        var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
        var reEscapeChar = /\\(\\)?/g;
        var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
        var reFlags = /\w*$/;
        var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
        var reIsBinary = /^0b[01]+$/i;
        var reIsHostCtor = /^\[object .+?Constructor\]$/;
        var reIsOctal = /^0o[0-7]+$/i;
        var reIsUint = /^(?:0|[1-9]\d*)$/;
        var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
        var reNoMatch = /($^)/;
        var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
        var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
        var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
        var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
            rsNonAstral,
            rsRegional,
            rsSurrPair
        ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
            rsDingbat,
            rsRegional,
            rsSurrPair
        ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
            rsNonAstral + rsCombo + '?',
            rsCombo,
            rsRegional,
            rsSurrPair,
            rsAstral
        ].join('|') + ')';
        var reApos = RegExp(rsApos, 'g');
        var reComboMark = RegExp(rsCombo, 'g');
        var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
        var reUnicodeWord = RegExp([
            rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
                rsBreak,
                rsUpper,
                '$'
            ].join('|') + ')',
            rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
                rsBreak,
                rsUpper + rsMiscLower,
                '$'
            ].join('|') + ')',
            rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
            rsUpper + '+' + rsOptContrUpper,
            rsOrdUpper,
            rsOrdLower,
            rsDigits,
            rsEmoji
        ].join('|'), 'g');
        var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
        var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
        var contextProps = [
            'Array',
            'Buffer',
            'DataView',
            'Date',
            'Error',
            'Float32Array',
            'Float64Array',
            'Function',
            'Int8Array',
            'Int16Array',
            'Int32Array',
            'Map',
            'Math',
            'Object',
            'Promise',
            'RegExp',
            'Set',
            'String',
            'Symbol',
            'TypeError',
            'Uint8Array',
            'Uint8ClampedArray',
            'Uint16Array',
            'Uint32Array',
            'WeakMap',
            '_',
            'clearTimeout',
            'isFinite',
            'parseInt',
            'setTimeout'
        ];
        var templateCounter = -1;
        var typedArrayTags = {};
        typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
        typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
        var cloneableTags = {};
        cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
        cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
        var deburredLetters = {
            '\xc0': 'A',
            '\xc1': 'A',
            '\xc2': 'A',
            '\xc3': 'A',
            '\xc4': 'A',
            '\xc5': 'A',
            '\xe0': 'a',
            '\xe1': 'a',
            '\xe2': 'a',
            '\xe3': 'a',
            '\xe4': 'a',
            '\xe5': 'a',
            '\xc7': 'C',
            '\xe7': 'c',
            '\xd0': 'D',
            '\xf0': 'd',
            '\xc8': 'E',
            '\xc9': 'E',
            '\xca': 'E',
            '\xcb': 'E',
            '\xe8': 'e',
            '\xe9': 'e',
            '\xea': 'e',
            '\xeb': 'e',
            '\xcc': 'I',
            '\xcd': 'I',
            '\xce': 'I',
            '\xcf': 'I',
            '\xec': 'i',
            '\xed': 'i',
            '\xee': 'i',
            '\xef': 'i',
            '\xd1': 'N',
            '\xf1': 'n',
            '\xd2': 'O',
            '\xd3': 'O',
            '\xd4': 'O',
            '\xd5': 'O',
            '\xd6': 'O',
            '\xd8': 'O',
            '\xf2': 'o',
            '\xf3': 'o',
            '\xf4': 'o',
            '\xf5': 'o',
            '\xf6': 'o',
            '\xf8': 'o',
            '\xd9': 'U',
            '\xda': 'U',
            '\xdb': 'U',
            '\xdc': 'U',
            '\xf9': 'u',
            '\xfa': 'u',
            '\xfb': 'u',
            '\xfc': 'u',
            '\xdd': 'Y',
            '\xfd': 'y',
            '\xff': 'y',
            '\xc6': 'Ae',
            '\xe6': 'ae',
            '\xde': 'Th',
            '\xfe': 'th',
            '\xdf': 'ss',
            '\u0100': 'A',
            '\u0102': 'A',
            '\u0104': 'A',
            '\u0101': 'a',
            '\u0103': 'a',
            '\u0105': 'a',
            '\u0106': 'C',
            '\u0108': 'C',
            '\u010a': 'C',
            '\u010c': 'C',
            '\u0107': 'c',
            '\u0109': 'c',
            '\u010b': 'c',
            '\u010d': 'c',
            '\u010e': 'D',
            '\u0110': 'D',
            '\u010f': 'd',
            '\u0111': 'd',
            '\u0112': 'E',
            '\u0114': 'E',
            '\u0116': 'E',
            '\u0118': 'E',
            '\u011a': 'E',
            '\u0113': 'e',
            '\u0115': 'e',
            '\u0117': 'e',
            '\u0119': 'e',
            '\u011b': 'e',
            '\u011c': 'G',
            '\u011e': 'G',
            '\u0120': 'G',
            '\u0122': 'G',
            '\u011d': 'g',
            '\u011f': 'g',
            '\u0121': 'g',
            '\u0123': 'g',
            '\u0124': 'H',
            '\u0126': 'H',
            '\u0125': 'h',
            '\u0127': 'h',
            '\u0128': 'I',
            '\u012a': 'I',
            '\u012c': 'I',
            '\u012e': 'I',
            '\u0130': 'I',
            '\u0129': 'i',
            '\u012b': 'i',
            '\u012d': 'i',
            '\u012f': 'i',
            '\u0131': 'i',
            '\u0134': 'J',
            '\u0135': 'j',
            '\u0136': 'K',
            '\u0137': 'k',
            '\u0138': 'k',
            '\u0139': 'L',
            '\u013b': 'L',
            '\u013d': 'L',
            '\u013f': 'L',
            '\u0141': 'L',
            '\u013a': 'l',
            '\u013c': 'l',
            '\u013e': 'l',
            '\u0140': 'l',
            '\u0142': 'l',
            '\u0143': 'N',
            '\u0145': 'N',
            '\u0147': 'N',
            '\u014a': 'N',
            '\u0144': 'n',
            '\u0146': 'n',
            '\u0148': 'n',
            '\u014b': 'n',
            '\u014c': 'O',
            '\u014e': 'O',
            '\u0150': 'O',
            '\u014d': 'o',
            '\u014f': 'o',
            '\u0151': 'o',
            '\u0154': 'R',
            '\u0156': 'R',
            '\u0158': 'R',
            '\u0155': 'r',
            '\u0157': 'r',
            '\u0159': 'r',
            '\u015a': 'S',
            '\u015c': 'S',
            '\u015e': 'S',
            '\u0160': 'S',
            '\u015b': 's',
            '\u015d': 's',
            '\u015f': 's',
            '\u0161': 's',
            '\u0162': 'T',
            '\u0164': 'T',
            '\u0166': 'T',
            '\u0163': 't',
            '\u0165': 't',
            '\u0167': 't',
            '\u0168': 'U',
            '\u016a': 'U',
            '\u016c': 'U',
            '\u016e': 'U',
            '\u0170': 'U',
            '\u0172': 'U',
            '\u0169': 'u',
            '\u016b': 'u',
            '\u016d': 'u',
            '\u016f': 'u',
            '\u0171': 'u',
            '\u0173': 'u',
            '\u0174': 'W',
            '\u0175': 'w',
            '\u0176': 'Y',
            '\u0177': 'y',
            '\u0178': 'Y',
            '\u0179': 'Z',
            '\u017b': 'Z',
            '\u017d': 'Z',
            '\u017a': 'z',
            '\u017c': 'z',
            '\u017e': 'z',
            '\u0132': 'IJ',
            '\u0133': 'ij',
            '\u0152': 'Oe',
            '\u0153': 'oe',
            '\u0149': "'n",
            '\u017f': 's'
        };
        var htmlEscapes = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
        };
        var htmlUnescapes = {
            '&amp;': '&',
            '&lt;': '<',
            '&gt;': '>',
            '&quot;': '"',
            '&#39;': "'"
        };
        var stringEscapes = {
            '\\': '\\',
            "'": "'",
            '\n': 'n',
            '\r': 'r',
            '\u2028': 'u2028',
            '\u2029': 'u2029'
        };
        var freeParseFloat = parseFloat, freeParseInt = parseInt;
        var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
        var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
        var root = freeGlobal || freeSelf || Function('return this')();
        var freeExports = exports && !exports.nodeType && exports;
        var freeModule = freeExports && true && module && !module.nodeType && module;
        var moduleExports = freeModule && freeModule.exports === freeExports;
        var freeProcess = moduleExports && freeGlobal.process;
        var nodeUtil = function() {
            try {
                var types = freeModule && freeModule.require && freeModule.require('util').types;
                if (types) return types;
                return freeProcess && freeProcess.binding && freeProcess.binding('util');
            } catch (e) {}
        }();
        var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
        function apply(func, thisArg, args) {
            switch(args.length){
                case 0:
                    return func.call(thisArg);
                case 1:
                    return func.call(thisArg, args[0]);
                case 2:
                    return func.call(thisArg, args[0], args[1]);
                case 3:
                    return func.call(thisArg, args[0], args[1], args[2]);
            }
            return func.apply(thisArg, args);
        }
        function arrayAggregator(array, setter, iteratee, accumulator) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                var value = array[index];
                setter(accumulator, value, iteratee(value), array);
            }
            return accumulator;
        }
        function arrayEach(array, iteratee) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (iteratee(array[index], index, array) === false) break;
            }
            return array;
        }
        function arrayEachRight(array, iteratee) {
            var length = array == null ? 0 : array.length;
            while(length--){
                if (iteratee(array[length], length, array) === false) break;
            }
            return array;
        }
        function arrayEvery(array, predicate) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (!predicate(array[index], index, array)) return false;
            }
            return true;
        }
        function arrayFilter(array, predicate) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) result[resIndex++] = value;
            }
            return result;
        }
        function arrayIncludes(array, value) {
            var length = array == null ? 0 : array.length;
            return !!length && baseIndexOf(array, value, 0) > -1;
        }
        function arrayIncludesWith(array, value, comparator) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (comparator(value, array[index])) return true;
            }
            return false;
        }
        function arrayMap(array, iteratee) {
            var index = -1, length = array == null ? 0 : array.length, result = Array(length);
            while(++index < length)result[index] = iteratee(array[index], index, array);
            return result;
        }
        function arrayPush(array, values) {
            var index = -1, length = values.length, offset = array.length;
            while(++index < length)array[offset + index] = values[index];
            return array;
        }
        function arrayReduce(array, iteratee, accumulator, initAccum) {
            var index = -1, length = array == null ? 0 : array.length;
            if (initAccum && length) accumulator = array[++index];
            while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
            return accumulator;
        }
        function arrayReduceRight(array, iteratee, accumulator, initAccum) {
            var length = array == null ? 0 : array.length;
            if (initAccum && length) accumulator = array[--length];
            while(length--)accumulator = iteratee(accumulator, array[length], length, array);
            return accumulator;
        }
        function arraySome(array, predicate) {
            var index = -1, length = array == null ? 0 : array.length;
            while(++index < length){
                if (predicate(array[index], index, array)) return true;
            }
            return false;
        }
        var asciiSize = baseProperty('length');
        function asciiToArray(string) {
            return string.split('');
        }
        function asciiWords(string) {
            return string.match(reAsciiWord) || [];
        }
        function baseFindKey(collection, predicate, eachFunc) {
            var result;
            eachFunc(collection, function(value, key, collection) {
                if (predicate(value, key, collection)) {
                    result = key;
                    return false;
                }
            });
            return result;
        }
        function baseFindIndex(array, predicate, fromIndex, fromRight) {
            var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
            while(fromRight ? index-- : ++index < length){
                if (predicate(array[index], index, array)) return index;
            }
            return -1;
        }
        function baseIndexOf(array, value, fromIndex) {
            return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
        }
        function baseIndexOfWith(array, value, fromIndex, comparator) {
            var index = fromIndex - 1, length = array.length;
            while(++index < length){
                if (comparator(array[index], value)) return index;
            }
            return -1;
        }
        function baseIsNaN(value) {
            return value !== value;
        }
        function baseMean(array, iteratee) {
            var length = array == null ? 0 : array.length;
            return length ? baseSum(array, iteratee) / length : NAN;
        }
        function baseProperty(key) {
            return function(object) {
                return object == null ? undefined : object[key];
            };
        }
        function basePropertyOf(object) {
            return function(key) {
                return object == null ? undefined : object[key];
            };
        }
        function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
            eachFunc(collection, function(value, index, collection) {
                accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
            });
            return accumulator;
        }
        function baseSortBy(array, comparer) {
            var length = array.length;
            array.sort(comparer);
            while(length--)array[length] = array[length].value;
            return array;
        }
        function baseSum(array, iteratee) {
            var result, index = -1, length = array.length;
            while(++index < length){
                var current = iteratee(array[index]);
                if (current !== undefined) result = result === undefined ? current : result + current;
            }
            return result;
        }
        function baseTimes(n, iteratee) {
            var index = -1, result = Array(n);
            while(++index < n)result[index] = iteratee(index);
            return result;
        }
        function baseToPairs(object, props) {
            return arrayMap(props, function(key) {
                return [
                    key,
                    object[key]
                ];
            });
        }
        function baseTrim(string) {
            return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
        }
        function baseUnary(func) {
            return function(value) {
                return func(value);
            };
        }
        function baseValues(object, props) {
            return arrayMap(props, function(key) {
                return object[key];
            });
        }
        function cacheHas(cache, key) {
            return cache.has(key);
        }
        function charsStartIndex(strSymbols, chrSymbols) {
            var index = -1, length = strSymbols.length;
            while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
            return index;
        }
        function charsEndIndex(strSymbols, chrSymbols) {
            var index = strSymbols.length;
            while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
            return index;
        }
        function countHolders(array, placeholder) {
            var length = array.length, result = 0;
            while(length--)if (array[length] === placeholder) ++result;
            return result;
        }
        var deburrLetter = basePropertyOf(deburredLetters);
        var escapeHtmlChar = basePropertyOf(htmlEscapes);
        function escapeStringChar(chr) {
            return '\\' + stringEscapes[chr];
        }
        function getValue(object, key) {
            return object == null ? undefined : object[key];
        }
        function hasUnicode(string) {
            return reHasUnicode.test(string);
        }
        function hasUnicodeWord(string) {
            return reHasUnicodeWord.test(string);
        }
        function iteratorToArray(iterator) {
            var data, result = [];
            while(!(data = iterator.next()).done)result.push(data.value);
            return result;
        }
        function mapToArray(map) {
            var index = -1, result = Array(map.size);
            map.forEach(function(value, key) {
                result[++index] = [
                    key,
                    value
                ];
            });
            return result;
        }
        function overArg(func, transform) {
            return function(arg) {
                return func(transform(arg));
            };
        }
        function replaceHolders(array, placeholder) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value === placeholder || value === PLACEHOLDER) {
                    array[index] = PLACEHOLDER;
                    result[resIndex++] = index;
                }
            }
            return result;
        }
        function setToArray(set) {
            var index = -1, result = Array(set.size);
            set.forEach(function(value) {
                result[++index] = value;
            });
            return result;
        }
        function setToPairs(set) {
            var index = -1, result = Array(set.size);
            set.forEach(function(value) {
                result[++index] = [
                    value,
                    value
                ];
            });
            return result;
        }
        function strictIndexOf(array, value, fromIndex) {
            var index = fromIndex - 1, length = array.length;
            while(++index < length){
                if (array[index] === value) return index;
            }
            return -1;
        }
        function strictLastIndexOf(array, value, fromIndex) {
            var index = fromIndex + 1;
            while(index--){
                if (array[index] === value) return index;
            }
            return index;
        }
        function stringSize(string) {
            return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
        }
        function stringToArray(string) {
            return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
        }
        function trimmedEndIndex(string) {
            var index = string.length;
            while(index-- && reWhitespace.test(string.charAt(index)));
            return index;
        }
        var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
        function unicodeSize(string) {
            var result = reUnicode.lastIndex = 0;
            while(reUnicode.test(string))++result;
            return result;
        }
        function unicodeToArray(string) {
            return string.match(reUnicode) || [];
        }
        function unicodeWords(string) {
            return string.match(reUnicodeWord) || [];
        }
        var runInContext = function runInContext(context) {
            context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
            var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
            var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
            var coreJsData = context['__core-js_shared__'];
            var funcToString = funcProto.toString;
            var hasOwnProperty = objectProto.hasOwnProperty;
            var idCounter = 0;
            var maskSrcKey = function() {
                var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
                return uid ? 'Symbol(src)_1.' + uid : '';
            }();
            var nativeObjectToString = objectProto.toString;
            var objectCtorString = funcToString.call(Object1);
            var oldDash = root._;
            var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
            var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
            var defineProperty = function() {
                try {
                    var func = getNative(Object1, 'defineProperty');
                    func({}, '', {});
                    return func;
                } catch (e) {}
            }();
            var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
            var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
            var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
            var metaMap = WeakMap && new WeakMap;
            var realNames = {};
            var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
            var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
            function lodash(value) {
                if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                    if (value instanceof LodashWrapper) return value;
                    if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
                }
                return new LodashWrapper(value);
            }
            var baseCreate = function() {
                function object() {}
                return function(proto) {
                    if (!isObject(proto)) return {};
                    if (objectCreate) return objectCreate(proto);
                    object.prototype = proto;
                    var result = new object;
                    object.prototype = undefined;
                    return result;
                };
            }();
            function baseLodash() {}
            function LodashWrapper(value, chainAll) {
                this.__wrapped__ = value;
                this.__actions__ = [];
                this.__chain__ = !!chainAll;
                this.__index__ = 0;
                this.__values__ = undefined;
            }
            lodash.templateSettings = {
                'escape': reEscape,
                'evaluate': reEvaluate,
                'interpolate': reInterpolate,
                'variable': '',
                'imports': {
                    '_': lodash
                }
            };
            lodash.prototype = baseLodash.prototype;
            lodash.prototype.constructor = lodash;
            LodashWrapper.prototype = baseCreate(baseLodash.prototype);
            LodashWrapper.prototype.constructor = LodashWrapper;
            function LazyWrapper(value) {
                this.__wrapped__ = value;
                this.__actions__ = [];
                this.__dir__ = 1;
                this.__filtered__ = false;
                this.__iteratees__ = [];
                this.__takeCount__ = MAX_ARRAY_LENGTH;
                this.__views__ = [];
            }
            function lazyClone() {
                var result = new LazyWrapper(this.__wrapped__);
                result.__actions__ = copyArray(this.__actions__);
                result.__dir__ = this.__dir__;
                result.__filtered__ = this.__filtered__;
                result.__iteratees__ = copyArray(this.__iteratees__);
                result.__takeCount__ = this.__takeCount__;
                result.__views__ = copyArray(this.__views__);
                return result;
            }
            function lazyReverse() {
                if (this.__filtered__) {
                    var result = new LazyWrapper(this);
                    result.__dir__ = -1;
                    result.__filtered__ = true;
                } else {
                    result = this.clone();
                    result.__dir__ *= -1;
                }
                return result;
            }
            function lazyValue() {
                var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
                if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
                var result = [];
                outer: while(length-- && resIndex < takeCount){
                    index += dir;
                    var iterIndex = -1, value = array[index];
                    while(++iterIndex < iterLength){
                        var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                        if (type == LAZY_MAP_FLAG) value = computed;
                        else if (!computed) {
                            if (type == LAZY_FILTER_FLAG) continue outer;
                            else break outer;
                        }
                    }
                    result[resIndex++] = value;
                }
                return result;
            }
            LazyWrapper.prototype = baseCreate(baseLodash.prototype);
            LazyWrapper.prototype.constructor = LazyWrapper;
            function Hash(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function hashClear() {
                this.__data__ = nativeCreate ? nativeCreate(null) : {};
                this.size = 0;
            }
            function hashDelete(key) {
                var result = this.has(key) && delete this.__data__[key];
                this.size -= result ? 1 : 0;
                return result;
            }
            function hashGet(key) {
                var data = this.__data__;
                if (nativeCreate) {
                    var result = data[key];
                    return result === HASH_UNDEFINED ? undefined : result;
                }
                return hasOwnProperty.call(data, key) ? data[key] : undefined;
            }
            function hashHas(key) {
                var data = this.__data__;
                return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
            }
            function hashSet(key, value) {
                var data = this.__data__;
                this.size += this.has(key) ? 0 : 1;
                data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
                return this;
            }
            Hash.prototype.clear = hashClear;
            Hash.prototype['delete'] = hashDelete;
            Hash.prototype.get = hashGet;
            Hash.prototype.has = hashHas;
            Hash.prototype.set = hashSet;
            function ListCache(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function listCacheClear() {
                this.__data__ = [];
                this.size = 0;
            }
            function listCacheDelete(key) {
                var data = this.__data__, index = assocIndexOf(data, key);
                if (index < 0) return false;
                var lastIndex = data.length - 1;
                if (index == lastIndex) data.pop();
                else splice.call(data, index, 1);
                --this.size;
                return true;
            }
            function listCacheGet(key) {
                var data = this.__data__, index = assocIndexOf(data, key);
                return index < 0 ? undefined : data[index][1];
            }
            function listCacheHas(key) {
                return assocIndexOf(this.__data__, key) > -1;
            }
            function listCacheSet(key, value) {
                var data = this.__data__, index = assocIndexOf(data, key);
                if (index < 0) {
                    ++this.size;
                    data.push([
                        key,
                        value
                    ]);
                } else data[index][1] = value;
                return this;
            }
            ListCache.prototype.clear = listCacheClear;
            ListCache.prototype['delete'] = listCacheDelete;
            ListCache.prototype.get = listCacheGet;
            ListCache.prototype.has = listCacheHas;
            ListCache.prototype.set = listCacheSet;
            function MapCache(entries) {
                var index = -1, length = entries == null ? 0 : entries.length;
                this.clear();
                while(++index < length){
                    var entry = entries[index];
                    this.set(entry[0], entry[1]);
                }
            }
            function mapCacheClear() {
                this.size = 0;
                this.__data__ = {
                    'hash': new Hash,
                    'map': new (Map || ListCache),
                    'string': new Hash
                };
            }
            function mapCacheDelete(key) {
                var result = getMapData(this, key)['delete'](key);
                this.size -= result ? 1 : 0;
                return result;
            }
            function mapCacheGet(key) {
                return getMapData(this, key).get(key);
            }
            function mapCacheHas(key) {
                return getMapData(this, key).has(key);
            }
            function mapCacheSet(key, value) {
                var data = getMapData(this, key), size = data.size;
                data.set(key, value);
                this.size += data.size == size ? 0 : 1;
                return this;
            }
            MapCache.prototype.clear = mapCacheClear;
            MapCache.prototype['delete'] = mapCacheDelete;
            MapCache.prototype.get = mapCacheGet;
            MapCache.prototype.has = mapCacheHas;
            MapCache.prototype.set = mapCacheSet;
            function SetCache(values) {
                var index = -1, length = values == null ? 0 : values.length;
                this.__data__ = new MapCache;
                while(++index < length)this.add(values[index]);
            }
            function setCacheAdd(value) {
                this.__data__.set(value, HASH_UNDEFINED);
                return this;
            }
            function setCacheHas(value) {
                return this.__data__.has(value);
            }
            SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
            SetCache.prototype.has = setCacheHas;
            function Stack(entries) {
                var data = this.__data__ = new ListCache(entries);
                this.size = data.size;
            }
            function stackClear() {
                this.__data__ = new ListCache;
                this.size = 0;
            }
            function stackDelete(key) {
                var data = this.__data__, result = data['delete'](key);
                this.size = data.size;
                return result;
            }
            function stackGet(key) {
                return this.__data__.get(key);
            }
            function stackHas(key) {
                return this.__data__.has(key);
            }
            function stackSet(key, value) {
                var data = this.__data__;
                if (data instanceof ListCache) {
                    var pairs = data.__data__;
                    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                        pairs.push([
                            key,
                            value
                        ]);
                        this.size = ++data.size;
                        return this;
                    }
                    data = this.__data__ = new MapCache(pairs);
                }
                data.set(key, value);
                this.size = data.size;
                return this;
            }
            Stack.prototype.clear = stackClear;
            Stack.prototype['delete'] = stackDelete;
            Stack.prototype.get = stackGet;
            Stack.prototype.has = stackHas;
            Stack.prototype.set = stackSet;
            function arrayLikeKeys(value, inherited) {
                var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
                for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isBuff && (key == 'offset' || key == 'parent') || isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || isIndex(key, length)))) result.push(key);
                return result;
            }
            function arraySample(array) {
                var length = array.length;
                return length ? array[baseRandom(0, length - 1)] : undefined;
            }
            function arraySampleSize(array, n) {
                return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
            }
            function arrayShuffle(array) {
                return shuffleSelf(copyArray(array));
            }
            function assignMergeValue(object, key, value) {
                if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
            }
            function assignValue(object, key, value) {
                var objValue = object[key];
                if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
            }
            function assocIndexOf(array, key) {
                var length = array.length;
                while(length--){
                    if (eq(array[length][0], key)) return length;
                }
                return -1;
            }
            function baseAggregator(collection, setter, iteratee, accumulator) {
                baseEach(collection, function(value, key, collection) {
                    setter(accumulator, value, iteratee(value), collection);
                });
                return accumulator;
            }
            function baseAssign(object, source) {
                return object && copyObject(source, keys(source), object);
            }
            function baseAssignIn(object, source) {
                return object && copyObject(source, keysIn(source), object);
            }
            function baseAssignValue(object, key, value) {
                if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                    'configurable': true,
                    'enumerable': true,
                    'value': value,
                    'writable': true
                });
                else object[key] = value;
            }
            function baseAt(object, paths) {
                var index = -1, length = paths.length, result = Array1(length), skip = object == null;
                while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
                return result;
            }
            function baseClamp(number, lower, upper) {
                if (number === number) {
                    if (upper !== undefined) number = number <= upper ? number : upper;
                    if (lower !== undefined) number = number >= lower ? number : lower;
                }
                return number;
            }
            function baseClone(value, bitmask, customizer, key, object, stack) {
                var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
                if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
                if (result !== undefined) return result;
                if (!isObject(value)) return value;
                var isArr = isArray(value);
                if (isArr) {
                    result = initCloneArray(value);
                    if (!isDeep) return copyArray(value, result);
                } else {
                    var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                    if (isBuffer(value)) return cloneBuffer(value, isDeep);
                    if (tag == objectTag || tag == argsTag || isFunc && !object) {
                        result = isFlat || isFunc ? {} : initCloneObject(value);
                        if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                    } else {
                        if (!cloneableTags[tag]) return object ? value : {};
                        result = initCloneByTag(value, tag, isDeep);
                    }
                }
                stack || (stack = new Stack);
                var stacked = stack.get(value);
                if (stacked) return stacked;
                stack.set(value, result);
                if (isSet(value)) value.forEach(function(subValue) {
                    result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
                });
                else if (isMap(value)) value.forEach(function(subValue, key) {
                    result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
                });
                var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
                var props = isArr ? undefined : keysFunc(value);
                arrayEach(props || value, function(subValue, key) {
                    if (props) {
                        key = subValue;
                        subValue = value[key];
                    }
                    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
                });
                return result;
            }
            function baseConforms(source) {
                var props = keys(source);
                return function(object) {
                    return baseConformsTo(object, source, props);
                };
            }
            function baseConformsTo(object, source, props) {
                var length = props.length;
                if (object == null) return !length;
                object = Object1(object);
                while(length--){
                    var key = props[length], predicate = source[key], value = object[key];
                    if (value === undefined && !(key in object) || !predicate(value)) return false;
                }
                return true;
            }
            function baseDelay(func, wait, args) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return setTimeout(function() {
                    func.apply(undefined, args);
                }, wait);
            }
            function baseDifference(array, values, iteratee, comparator) {
                var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
                if (!length) return result;
                if (iteratee) values = arrayMap(values, baseUnary(iteratee));
                if (comparator) {
                    includes = arrayIncludesWith;
                    isCommon = false;
                } else if (values.length >= LARGE_ARRAY_SIZE) {
                    includes = cacheHas;
                    isCommon = false;
                    values = new SetCache(values);
                }
                outer: while(++index < length){
                    var value = array[index], computed = iteratee == null ? value : iteratee(value);
                    value = comparator || value !== 0 ? value : 0;
                    if (isCommon && computed === computed) {
                        var valuesIndex = valuesLength;
                        while(valuesIndex--){
                            if (values[valuesIndex] === computed) continue outer;
                        }
                        result.push(value);
                    } else if (!includes(values, computed, comparator)) result.push(value);
                }
                return result;
            }
            var baseEach = createBaseEach(baseForOwn);
            var baseEachRight = createBaseEach(baseForOwnRight, true);
            function baseEvery(collection, predicate) {
                var result = true;
                baseEach(collection, function(value, index, collection) {
                    result = !!predicate(value, index, collection);
                    return result;
                });
                return result;
            }
            function baseExtremum(array, iteratee, comparator) {
                var index = -1, length = array.length;
                while(++index < length){
                    var value = array[index], current = iteratee(value);
                    if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
                }
                return result;
            }
            function baseFill(array, value, start, end) {
                var length = array.length;
                start = toInteger(start);
                if (start < 0) start = -start > length ? 0 : length + start;
                end = end === undefined || end > length ? length : toInteger(end);
                if (end < 0) end += length;
                end = start > end ? 0 : toLength(end);
                while(start < end)array[start++] = value;
                return array;
            }
            function baseFilter(collection, predicate) {
                var result = [];
                baseEach(collection, function(value, index, collection) {
                    if (predicate(value, index, collection)) result.push(value);
                });
                return result;
            }
            function baseFlatten(array, depth, predicate, isStrict, result) {
                var index = -1, length = array.length;
                predicate || (predicate = isFlattenable);
                result || (result = []);
                while(++index < length){
                    var value = array[index];
                    if (depth > 0 && predicate(value)) {
                        if (depth > 1) baseFlatten(value, depth - 1, predicate, isStrict, result);
                        else arrayPush(result, value);
                    } else if (!isStrict) result[result.length] = value;
                }
                return result;
            }
            var baseFor = createBaseFor();
            var baseForRight = createBaseFor(true);
            function baseForOwn(object, iteratee) {
                return object && baseFor(object, iteratee, keys);
            }
            function baseForOwnRight(object, iteratee) {
                return object && baseForRight(object, iteratee, keys);
            }
            function baseFunctions(object, props) {
                return arrayFilter(props, function(key) {
                    return isFunction(object[key]);
                });
            }
            function baseGet(object, path) {
                path = castPath(path, object);
                var index = 0, length = path.length;
                while(object != null && index < length)object = object[toKey(path[index++])];
                return index && index == length ? object : undefined;
            }
            function baseGetAllKeys(object, keysFunc, symbolsFunc) {
                var result = keysFunc(object);
                return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
            }
            function baseGetTag(value) {
                if (value == null) return value === undefined ? undefinedTag : nullTag;
                return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
            }
            function baseGt(value, other) {
                return value > other;
            }
            function baseHas(object, key) {
                return object != null && hasOwnProperty.call(object, key);
            }
            function baseHasIn(object, key) {
                return object != null && key in Object1(object);
            }
            function baseInRange(number, start, end) {
                return number >= nativeMin(start, end) && number < nativeMax(start, end);
            }
            function baseIntersection(arrays, iteratee, comparator) {
                var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
                while(othIndex--){
                    var array = arrays[othIndex];
                    if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                    maxLength = nativeMin(array.length, maxLength);
                    caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
                }
                array = arrays[0];
                var index = -1, seen = caches[0];
                outer: while(++index < length && result.length < maxLength){
                    var value = array[index], computed = iteratee ? iteratee(value) : value;
                    value = comparator || value !== 0 ? value : 0;
                    if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                        othIndex = othLength;
                        while(--othIndex){
                            var cache = caches[othIndex];
                            if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                        }
                        if (seen) seen.push(computed);
                        result.push(value);
                    }
                }
                return result;
            }
            function baseInverter(object, setter, iteratee, accumulator) {
                baseForOwn(object, function(value, key, object) {
                    setter(accumulator, iteratee(value), key, object);
                });
                return accumulator;
            }
            function baseInvoke(object, path, args) {
                path = castPath(path, object);
                object = parent(object, path);
                var func = object == null ? object : object[toKey(last(path))];
                return func == null ? undefined : apply(func, object, args);
            }
            function baseIsArguments(value) {
                return isObjectLike(value) && baseGetTag(value) == argsTag;
            }
            function baseIsArrayBuffer(value) {
                return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
            }
            function baseIsDate(value) {
                return isObjectLike(value) && baseGetTag(value) == dateTag;
            }
            function baseIsEqual(value, other, bitmask, customizer, stack) {
                if (value === other) return true;
                if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
                return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
            }
            function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
                var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
                objTag = objTag == argsTag ? objectTag : objTag;
                othTag = othTag == argsTag ? objectTag : othTag;
                var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
                if (isSameTag && isBuffer(object)) {
                    if (!isBuffer(other)) return false;
                    objIsArr = true;
                    objIsObj = false;
                }
                if (isSameTag && !objIsObj) {
                    stack || (stack = new Stack);
                    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
                }
                if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                    if (objIsWrapped || othIsWrapped) {
                        var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                        stack || (stack = new Stack);
                        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                    }
                }
                if (!isSameTag) return false;
                stack || (stack = new Stack);
                return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
            }
            function baseIsMap(value) {
                return isObjectLike(value) && getTag(value) == mapTag;
            }
            function baseIsMatch(object, source, matchData, customizer) {
                var index = matchData.length, length = index, noCustomizer = !customizer;
                if (object == null) return !length;
                object = Object1(object);
                while(index--){
                    var data = matchData[index];
                    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
                }
                while(++index < length){
                    data = matchData[index];
                    var key = data[0], objValue = object[key], srcValue = data[1];
                    if (noCustomizer && data[2]) {
                        if (objValue === undefined && !(key in object)) return false;
                    } else {
                        var stack = new Stack;
                        if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                        if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                    }
                }
                return true;
            }
            function baseIsNative(value) {
                if (!isObject(value) || isMasked(value)) return false;
                var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
                return pattern.test(toSource(value));
            }
            function baseIsRegExp(value) {
                return isObjectLike(value) && baseGetTag(value) == regexpTag;
            }
            function baseIsSet(value) {
                return isObjectLike(value) && getTag(value) == setTag;
            }
            function baseIsTypedArray(value) {
                return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
            }
            function baseIteratee(value) {
                if (typeof value == 'function') return value;
                if (value == null) return identity;
                if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
                return property(value);
            }
            function baseKeys(object) {
                if (!isPrototype(object)) return nativeKeys(object);
                var result = [];
                for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
                return result;
            }
            function baseKeysIn(object) {
                if (!isObject(object)) return nativeKeysIn(object);
                var isProto = isPrototype(object), result = [];
                for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
                return result;
            }
            function baseLt(value, other) {
                return value < other;
            }
            function baseMap(collection, iteratee) {
                var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
                baseEach(collection, function(value, key, collection) {
                    result[++index] = iteratee(value, key, collection);
                });
                return result;
            }
            function baseMatches(source) {
                var matchData = getMatchData(source);
                if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
                return function(object) {
                    return object === source || baseIsMatch(object, source, matchData);
                };
            }
            function baseMatchesProperty(path, srcValue) {
                if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
                return function(object) {
                    var objValue = get(object, path);
                    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
                };
            }
            function baseMerge(object, source, srcIndex, customizer, stack) {
                if (object === source) return;
                baseFor(source, function(srcValue, key) {
                    stack || (stack = new Stack);
                    if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                    else {
                        var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                        if (newValue === undefined) newValue = srcValue;
                        assignMergeValue(object, key, newValue);
                    }
                }, keysIn);
            }
            function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
                var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
                if (stacked) {
                    assignMergeValue(object, key, stacked);
                    return;
                }
                var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
                var isCommon = newValue === undefined;
                if (isCommon) {
                    var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                    newValue = srcValue;
                    if (isArr || isBuff || isTyped) {
                        if (isArray(objValue)) newValue = objValue;
                        else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                        else if (isBuff) {
                            isCommon = false;
                            newValue = cloneBuffer(srcValue, true);
                        } else if (isTyped) {
                            isCommon = false;
                            newValue = cloneTypedArray(srcValue, true);
                        } else newValue = [];
                    } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                        newValue = objValue;
                        if (isArguments(objValue)) newValue = toPlainObject(objValue);
                        else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                    } else isCommon = false;
                }
                if (isCommon) {
                    stack.set(srcValue, newValue);
                    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                    stack['delete'](srcValue);
                }
                assignMergeValue(object, key, newValue);
            }
            function baseNth(array, n) {
                var length = array.length;
                if (!length) return;
                n += n < 0 ? length : 0;
                return isIndex(n, length) ? array[n] : undefined;
            }
            function baseOrderBy(collection, iteratees, orders) {
                if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                    if (isArray(iteratee)) return function(value) {
                        return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                    };
                    return iteratee;
                });
                else iteratees = [
                    identity
                ];
                var index = -1;
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                var result = baseMap(collection, function(value, key, collection) {
                    var criteria = arrayMap(iteratees, function(iteratee) {
                        return iteratee(value);
                    });
                    return {
                        'criteria': criteria,
                        'index': ++index,
                        'value': value
                    };
                });
                return baseSortBy(result, function(object, other) {
                    return compareMultiple(object, other, orders);
                });
            }
            function basePick(object, paths) {
                return basePickBy(object, paths, function(value, path) {
                    return hasIn(object, path);
                });
            }
            function basePickBy(object, paths, predicate) {
                var index = -1, length = paths.length, result = {};
                while(++index < length){
                    var path = paths[index], value = baseGet(object, path);
                    if (predicate(value, path)) baseSet(result, castPath(path, object), value);
                }
                return result;
            }
            function basePropertyDeep(path) {
                return function(object) {
                    return baseGet(object, path);
                };
            }
            function basePullAll(array, values, iteratee, comparator) {
                var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
                if (array === values) values = copyArray(values);
                if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
                while(++index < length){
                    var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                    while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                        if (seen !== array) splice.call(seen, fromIndex, 1);
                        splice.call(array, fromIndex, 1);
                    }
                }
                return array;
            }
            function basePullAt(array, indexes) {
                var length = array ? indexes.length : 0, lastIndex = length - 1;
                while(length--){
                    var index = indexes[length];
                    if (length == lastIndex || index !== previous) {
                        var previous = index;
                        if (isIndex(index)) splice.call(array, index, 1);
                        else baseUnset(array, index);
                    }
                }
                return array;
            }
            function baseRandom(lower, upper) {
                return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
            }
            function baseRange(start, end, step, fromRight) {
                var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
                while(length--){
                    result[fromRight ? length : ++index] = start;
                    start += step;
                }
                return result;
            }
            function baseRepeat(string, n) {
                var result = '';
                if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
                do {
                    if (n % 2) result += string;
                    n = nativeFloor(n / 2);
                    if (n) string += string;
                }while (n)
                return result;
            }
            function baseRest(func, start) {
                return setToString(overRest(func, start, identity), func + '');
            }
            function baseSample(collection) {
                return arraySample(values(collection));
            }
            function baseSampleSize(collection, n) {
                var array = values(collection);
                return shuffleSelf(array, baseClamp(n, 0, array.length));
            }
            function baseSet(object, path, value, customizer) {
                if (!isObject(object)) return object;
                path = castPath(path, object);
                var index = -1, length = path.length, lastIndex = length - 1, nested = object;
                while(nested != null && ++index < length){
                    var key = toKey(path[index]), newValue = value;
                    if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                    if (index != lastIndex) {
                        var objValue = nested[key];
                        newValue = customizer ? customizer(objValue, key, nested) : undefined;
                        if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                    }
                    assignValue(nested, key, newValue);
                    nested = nested[key];
                }
                return object;
            }
            var baseSetData = !metaMap ? identity : function(func, data) {
                metaMap.set(func, data);
                return func;
            };
            var baseSetToString = !defineProperty ? identity : function(func, string) {
                return defineProperty(func, 'toString', {
                    'configurable': true,
                    'enumerable': false,
                    'value': constant(string),
                    'writable': true
                });
            };
            function baseShuffle(collection) {
                return shuffleSelf(values(collection));
            }
            function baseSlice(array, start, end) {
                var index = -1, length = array.length;
                if (start < 0) start = -start > length ? 0 : length + start;
                end = end > length ? length : end;
                if (end < 0) end += length;
                length = start > end ? 0 : end - start >>> 0;
                start >>>= 0;
                var result = Array1(length);
                while(++index < length)result[index] = array[index + start];
                return result;
            }
            function baseSome(collection, predicate) {
                var result;
                baseEach(collection, function(value, index, collection) {
                    result = predicate(value, index, collection);
                    return !result;
                });
                return !!result;
            }
            function baseSortedIndex(array, value, retHighest) {
                var low = 0, high = array == null ? low : array.length;
                if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                    while(low < high){
                        var mid = low + high >>> 1, computed = array[mid];
                        if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                        else high = mid;
                    }
                    return high;
                }
                return baseSortedIndexBy(array, value, identity, retHighest);
            }
            function baseSortedIndexBy(array, value, iteratee, retHighest) {
                var low = 0, high = array == null ? 0 : array.length;
                if (high === 0) return 0;
                value = iteratee(value);
                var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
                while(low < high){
                    var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                    if (valIsNaN) var setLow = retHighest || othIsReflexive;
                    else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                    else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                    else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                    else if (othIsNull || othIsSymbol) setLow = false;
                    else setLow = retHighest ? computed <= value : computed < value;
                    if (setLow) low = mid + 1;
                    else high = mid;
                }
                return nativeMin(high, MAX_ARRAY_INDEX);
            }
            function baseSortedUniq(array, iteratee) {
                var index = -1, length = array.length, resIndex = 0, result = [];
                while(++index < length){
                    var value = array[index], computed = iteratee ? iteratee(value) : value;
                    if (!index || !eq(computed, seen)) {
                        var seen = computed;
                        result[resIndex++] = value === 0 ? 0 : value;
                    }
                }
                return result;
            }
            function baseToNumber(value) {
                if (typeof value == 'number') return value;
                if (isSymbol(value)) return NAN;
                return +value;
            }
            function baseToString(value) {
                if (typeof value == 'string') return value;
                if (isArray(value)) return arrayMap(value, baseToString) + '';
                if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
                var result = value + '';
                return result == '0' && 1 / value == -INFINITY ? '-0' : result;
            }
            function baseUniq(array, iteratee, comparator) {
                var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
                if (comparator) {
                    isCommon = false;
                    includes = arrayIncludesWith;
                } else if (length >= LARGE_ARRAY_SIZE) {
                    var set = iteratee ? null : createSet(array);
                    if (set) return setToArray(set);
                    isCommon = false;
                    includes = cacheHas;
                    seen = new SetCache;
                } else seen = iteratee ? [] : result;
                outer: while(++index < length){
                    var value = array[index], computed = iteratee ? iteratee(value) : value;
                    value = comparator || value !== 0 ? value : 0;
                    if (isCommon && computed === computed) {
                        var seenIndex = seen.length;
                        while(seenIndex--){
                            if (seen[seenIndex] === computed) continue outer;
                        }
                        if (iteratee) seen.push(computed);
                        result.push(value);
                    } else if (!includes(seen, computed, comparator)) {
                        if (seen !== result) seen.push(computed);
                        result.push(value);
                    }
                }
                return result;
            }
            function baseUnset(object, path) {
                path = castPath(path, object);
                object = parent(object, path);
                return object == null || delete object[toKey(last(path))];
            }
            function baseUpdate(object, path, updater, customizer) {
                return baseSet(object, path, updater(baseGet(object, path)), customizer);
            }
            function baseWhile(array, predicate, isDrop, fromRight) {
                var length = array.length, index = fromRight ? length : -1;
                while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
                return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
            }
            function baseWrapperValue(value, actions) {
                var result = value;
                if (result instanceof LazyWrapper) result = result.value();
                return arrayReduce(actions, function(result, action) {
                    return action.func.apply(action.thisArg, arrayPush([
                        result
                    ], action.args));
                }, result);
            }
            function baseXor(arrays, iteratee, comparator) {
                var length = arrays.length;
                if (length < 2) return length ? baseUniq(arrays[0]) : [];
                var index = -1, result = Array1(length);
                while(++index < length){
                    var array = arrays[index], othIndex = -1;
                    while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
                }
                return baseUniq(baseFlatten(result, 1), iteratee, comparator);
            }
            function baseZipObject(props, values, assignFunc) {
                var index = -1, length = props.length, valsLength = values.length, result = {};
                while(++index < length){
                    var value = index < valsLength ? values[index] : undefined;
                    assignFunc(result, props[index], value);
                }
                return result;
            }
            function castArrayLikeObject(value) {
                return isArrayLikeObject(value) ? value : [];
            }
            function castFunction(value) {
                return typeof value == 'function' ? value : identity;
            }
            function castPath(value, object) {
                if (isArray(value)) return value;
                return isKey(value, object) ? [
                    value
                ] : stringToPath(toString(value));
            }
            var castRest = baseRest;
            function castSlice(array, start, end) {
                var length = array.length;
                end = end === undefined ? length : end;
                return !start && end >= length ? array : baseSlice(array, start, end);
            }
            var clearTimeout = ctxClearTimeout || function(id) {
                return root.clearTimeout(id);
            };
            function cloneBuffer(buffer, isDeep) {
                if (isDeep) return buffer.slice();
                var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
                buffer.copy(result);
                return result;
            }
            function cloneArrayBuffer(arrayBuffer) {
                var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
                new Uint8Array(result).set(new Uint8Array(arrayBuffer));
                return result;
            }
            function cloneDataView(dataView, isDeep) {
                var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
                return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
            }
            function cloneRegExp(regexp) {
                var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
                result.lastIndex = regexp.lastIndex;
                return result;
            }
            function cloneSymbol(symbol) {
                return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
            }
            function cloneTypedArray(typedArray, isDeep) {
                var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
                return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
            }
            function compareAscending(value, other) {
                if (value !== other) {
                    var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                    var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
                }
                return 0;
            }
            function compareMultiple(object, other, orders) {
                var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
                while(++index < length){
                    var result = compareAscending(objCriteria[index], othCriteria[index]);
                    if (result) {
                        if (index >= ordersLength) return result;
                        var order = orders[index];
                        return result * (order == 'desc' ? -1 : 1);
                    }
                }
                return object.index - other.index;
            }
            function composeArgs(args, partials, holders, isCurried) {
                var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
                while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
                while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
                while(rangeLength--)result[leftIndex++] = args[argsIndex++];
                return result;
            }
            function composeArgsRight(args, partials, holders, isCurried) {
                var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
                while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
                var offset = argsIndex;
                while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
                while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
                return result;
            }
            function copyArray(source, array) {
                var index = -1, length = source.length;
                array || (array = Array1(length));
                while(++index < length)array[index] = source[index];
                return array;
            }
            function copyObject(source, props, object, customizer) {
                var isNew = !object;
                object || (object = {});
                var index = -1, length = props.length;
                while(++index < length){
                    var key = props[index];
                    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                    if (newValue === undefined) newValue = source[key];
                    if (isNew) baseAssignValue(object, key, newValue);
                    else assignValue(object, key, newValue);
                }
                return object;
            }
            function copySymbols(source, object) {
                return copyObject(source, getSymbols(source), object);
            }
            function copySymbolsIn(source, object) {
                return copyObject(source, getSymbolsIn(source), object);
            }
            function createAggregator(setter, initializer) {
                return function(collection, iteratee) {
                    var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                    return func(collection, setter, getIteratee(iteratee, 2), accumulator);
                };
            }
            function createAssigner(assigner) {
                return baseRest(function(object, sources) {
                    var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                        customizer = length < 3 ? undefined : customizer;
                        length = 1;
                    }
                    object = Object1(object);
                    while(++index < length){
                        var source = sources[index];
                        if (source) assigner(object, source, index, customizer);
                    }
                    return object;
                });
            }
            function createBaseEach(eachFunc, fromRight) {
                return function(collection, iteratee) {
                    if (collection == null) return collection;
                    if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                    var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                    while(fromRight ? index-- : ++index < length){
                        if (iteratee(iterable[index], index, iterable) === false) break;
                    }
                    return collection;
                };
            }
            function createBaseFor(fromRight) {
                return function(object, iteratee, keysFunc) {
                    var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                    while(length--){
                        var key = props[fromRight ? length : ++index];
                        if (iteratee(iterable[key], key, iterable) === false) break;
                    }
                    return object;
                };
            }
            function createBind(func, bitmask, thisArg) {
                var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
                function wrapper() {
                    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    return fn.apply(isBind ? thisArg : this, arguments);
                }
                return wrapper;
            }
            function createCaseFirst(methodName) {
                return function(string) {
                    string = toString(string);
                    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                    return chr[methodName]() + trailing;
                };
            }
            function createCompounder(callback) {
                return function(string) {
                    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
                };
            }
            function createCtor(Ctor) {
                return function() {
                    var args = arguments;
                    switch(args.length){
                        case 0:
                            return new Ctor;
                        case 1:
                            return new Ctor(args[0]);
                        case 2:
                            return new Ctor(args[0], args[1]);
                        case 3:
                            return new Ctor(args[0], args[1], args[2]);
                        case 4:
                            return new Ctor(args[0], args[1], args[2], args[3]);
                        case 5:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                        case 6:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                        case 7:
                            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                    }
                    var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                    return isObject(result) ? result : thisBinding;
                };
            }
            function createCurry(func, bitmask, arity) {
                var Ctor = createCtor(func);
                function wrapper() {
                    var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                    while(index--)args[index] = arguments[index];
                    var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                    length -= holders.length;
                    if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                    var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    return apply(fn, this, args);
                }
                return wrapper;
            }
            function createFind(findIndexFunc) {
                return function(collection, predicate, fromIndex) {
                    var iterable = Object1(collection);
                    if (!isArrayLike(collection)) {
                        var iteratee = getIteratee(predicate, 3);
                        collection = keys(collection);
                        predicate = function(key) {
                            return iteratee(iterable[key], key, iterable);
                        };
                    }
                    var index = findIndexFunc(collection, predicate, fromIndex);
                    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
                };
            }
            function createFlow(fromRight) {
                return flatRest(function(funcs) {
                    var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                    if (fromRight) funcs.reverse();
                    while(index--){
                        var func = funcs[index];
                        if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                        if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                    }
                    index = wrapper ? index : length;
                    while(++index < length){
                        func = funcs[index];
                        var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                        if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                        else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                    }
                    return function() {
                        var args = arguments, value = args[0];
                        if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                        var index = 0, result = length ? funcs[index].apply(this, args) : value;
                        while(++index < length)result = funcs[index].call(this, result);
                        return result;
                    };
                });
            }
            function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
                var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
                function wrapper() {
                    var length = arguments.length, args = Array1(length), index = length;
                    while(index--)args[index] = arguments[index];
                    if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                    if (partials) args = composeArgs(args, partials, holders, isCurried);
                    if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                    length -= holdersCount;
                    if (isCurried && length < arity) {
                        var newHolders = replaceHolders(args, placeholder);
                        return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                    }
                    var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                    length = args.length;
                    if (argPos) args = reorder(args, argPos);
                    else if (isFlip && length > 1) args.reverse();
                    if (isAry && ary < length) args.length = ary;
                    if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                    return fn.apply(thisBinding, args);
                }
                return wrapper;
            }
            function createInverter(setter, toIteratee) {
                return function(object, iteratee) {
                    return baseInverter(object, setter, toIteratee(iteratee), {});
                };
            }
            function createMathOperation(operator, defaultValue) {
                return function(value, other) {
                    var result;
                    if (value === undefined && other === undefined) return defaultValue;
                    if (value !== undefined) result = value;
                    if (other !== undefined) {
                        if (result === undefined) return other;
                        if (typeof value == 'string' || typeof other == 'string') {
                            value = baseToString(value);
                            other = baseToString(other);
                        } else {
                            value = baseToNumber(value);
                            other = baseToNumber(other);
                        }
                        result = operator(value, other);
                    }
                    return result;
                };
            }
            function createOver(arrayFunc) {
                return flatRest(function(iteratees) {
                    iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                    return baseRest(function(args) {
                        var thisArg = this;
                        return arrayFunc(iteratees, function(iteratee) {
                            return apply(iteratee, thisArg, args);
                        });
                    });
                });
            }
            function createPadding(length, chars) {
                chars = chars === undefined ? ' ' : baseToString(chars);
                var charsLength = chars.length;
                if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
                var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
                return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
            }
            function createPartial(func, bitmask, thisArg, partials) {
                var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
                function wrapper() {
                    var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                    while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                    while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                    return apply(fn, isBind ? thisArg : this, args);
                }
                return wrapper;
            }
            function createRange(fromRight) {
                return function(start, end, step) {
                    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                    start = toFinite(start);
                    if (end === undefined) {
                        end = start;
                        start = 0;
                    } else end = toFinite(end);
                    step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                    return baseRange(start, end, step, fromRight);
                };
            }
            function createRelationalOperation(operator) {
                return function(value, other) {
                    if (!(typeof value == 'string' && typeof other == 'string')) {
                        value = toNumber(value);
                        other = toNumber(other);
                    }
                    return operator(value, other);
                };
            }
            function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
                var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
                bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
                bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
                if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
                var newData = [
                    func,
                    bitmask,
                    thisArg,
                    newPartials,
                    newHolders,
                    newPartialsRight,
                    newHoldersRight,
                    argPos,
                    ary,
                    arity
                ];
                var result = wrapFunc.apply(undefined, newData);
                if (isLaziable(func)) setData(result, newData);
                result.placeholder = placeholder;
                return setWrapToString(result, func, bitmask);
            }
            function createRound(methodName) {
                var func = Math[methodName];
                return function(number, precision) {
                    number = toNumber(number);
                    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                    if (precision && nativeIsFinite(number)) {
                        var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                        pair = (toString(value) + 'e').split('e');
                        return +(pair[0] + 'e' + (+pair[1] - precision));
                    }
                    return func(number);
                };
            }
            var createSet = !(Set && 1 / setToArray(new Set([
                ,
                -0
            ]))[1] == INFINITY) ? noop : function(values) {
                return new Set(values);
            };
            function createToPairs(keysFunc) {
                return function(object) {
                    var tag = getTag(object);
                    if (tag == mapTag) return mapToArray(object);
                    if (tag == setTag) return setToPairs(object);
                    return baseToPairs(object, keysFunc(object));
                };
            }
            function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
                var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
                if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                var length = partials ? partials.length : 0;
                if (!length) {
                    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                    partials = holders = undefined;
                }
                ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
                arity = arity === undefined ? arity : toInteger(arity);
                length -= holders ? holders.length : 0;
                if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                    var partialsRight = partials, holdersRight = holders;
                    partials = holders = undefined;
                }
                var data = isBindKey ? undefined : getData(func);
                var newData = [
                    func,
                    bitmask,
                    thisArg,
                    partials,
                    holders,
                    partialsRight,
                    holdersRight,
                    argPos,
                    ary,
                    arity
                ];
                if (data) mergeData(newData, data);
                func = newData[0];
                bitmask = newData[1];
                thisArg = newData[2];
                partials = newData[3];
                holders = newData[4];
                arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
                if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
                if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
                else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
                else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
                else result = createHybrid.apply(undefined, newData);
                var setter = data ? baseSetData : setData;
                return setWrapToString(setter(result, newData), func, bitmask);
            }
            function customDefaultsAssignIn(objValue, srcValue, key, object) {
                if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
                return objValue;
            }
            function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
                if (isObject(objValue) && isObject(srcValue)) {
                    stack.set(srcValue, objValue);
                    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                    stack['delete'](srcValue);
                }
                return objValue;
            }
            function customOmitClone(value) {
                return isPlainObject(value) ? undefined : value;
            }
            function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
                if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
                var arrStacked = stack.get(array);
                var othStacked = stack.get(other);
                if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
                var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
                stack.set(array, other);
                stack.set(other, array);
                while(++index < arrLength){
                    var arrValue = array[index], othValue = other[index];
                    if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                    if (compared !== undefined) {
                        if (compared) continue;
                        result = false;
                        break;
                    }
                    if (seen) {
                        if (!arraySome(other, function(othValue, othIndex) {
                            if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                        })) {
                            result = false;
                            break;
                        }
                    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                        result = false;
                        break;
                    }
                }
                stack['delete'](array);
                stack['delete'](other);
                return result;
            }
            function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
                switch(tag){
                    case dataViewTag:
                        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                        object = object.buffer;
                        other = other.buffer;
                    case arrayBufferTag:
                        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                        return true;
                    case boolTag:
                    case dateTag:
                    case numberTag:
                        return eq(+object, +other);
                    case errorTag:
                        return object.name == other.name && object.message == other.message;
                    case regexpTag:
                    case stringTag:
                        return object == other + '';
                    case mapTag:
                        var convert = mapToArray;
                    case setTag:
                        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                        convert || (convert = setToArray);
                        if (object.size != other.size && !isPartial) return false;
                        var stacked = stack.get(object);
                        if (stacked) return stacked == other;
                        bitmask |= COMPARE_UNORDERED_FLAG;
                        stack.set(object, other);
                        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                        stack['delete'](object);
                        return result;
                    case symbolTag:
                        if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
                }
                return false;
            }
            function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
                if (objLength != othLength && !isPartial) return false;
                var index = objLength;
                while(index--){
                    var key = objProps[index];
                    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
                }
                var objStacked = stack.get(object);
                var othStacked = stack.get(other);
                if (objStacked && othStacked) return objStacked == other && othStacked == object;
                var result = true;
                stack.set(object, other);
                stack.set(other, object);
                var skipCtor = isPartial;
                while(++index < objLength){
                    key = objProps[index];
                    var objValue = object[key], othValue = other[key];
                    if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                        result = false;
                        break;
                    }
                    skipCtor || (skipCtor = key == 'constructor');
                }
                if (result && !skipCtor) {
                    var objCtor = object.constructor, othCtor = other.constructor;
                    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
                }
                stack['delete'](object);
                stack['delete'](other);
                return result;
            }
            function flatRest(func) {
                return setToString(overRest(func, undefined, flatten), func + '');
            }
            function getAllKeys(object) {
                return baseGetAllKeys(object, keys, getSymbols);
            }
            function getAllKeysIn(object) {
                return baseGetAllKeys(object, keysIn, getSymbolsIn);
            }
            var getData = !metaMap ? noop : function(func) {
                return metaMap.get(func);
            };
            function getFuncName(func) {
                var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
                while(length--){
                    var data = array[length], otherFunc = data.func;
                    if (otherFunc == null || otherFunc == func) return data.name;
                }
                return result;
            }
            function getHolder(func) {
                var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
                return object.placeholder;
            }
            function getIteratee() {
                var result = lodash.iteratee || iteratee;
                result = result === iteratee ? baseIteratee : result;
                return arguments.length ? result(arguments[0], arguments[1]) : result;
            }
            function getMapData(map, key) {
                var data = map.__data__;
                return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
            }
            function getMatchData(object) {
                var result = keys(object), length = result.length;
                while(length--){
                    var key = result[length], value = object[key];
                    result[length] = [
                        key,
                        value,
                        isStrictComparable(value)
                    ];
                }
                return result;
            }
            function getNative(object, key) {
                var value = getValue(object, key);
                return baseIsNative(value) ? value : undefined;
            }
            function getRawTag(value) {
                var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
                try {
                    value[symToStringTag] = undefined;
                    var unmasked = true;
                } catch (e) {}
                var result = nativeObjectToString.call(value);
                if (unmasked) {
                    if (isOwn) value[symToStringTag] = tag;
                    else delete value[symToStringTag];
                }
                return result;
            }
            var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
                if (object == null) return [];
                object = Object1(object);
                return arrayFilter(nativeGetSymbols(object), function(symbol) {
                    return propertyIsEnumerable.call(object, symbol);
                });
            };
            var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
                var result = [];
                while(object){
                    arrayPush(result, getSymbols(object));
                    object = getPrototype(object);
                }
                return result;
            };
            var getTag = baseGetTag;
            if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
                var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
                if (ctorString) switch(ctorString){
                    case dataViewCtorString:
                        return dataViewTag;
                    case mapCtorString:
                        return mapTag;
                    case promiseCtorString:
                        return promiseTag;
                    case setCtorString:
                        return setTag;
                    case weakMapCtorString:
                        return weakMapTag;
                }
                return result;
            };
            function getView(start, end, transforms) {
                var index = -1, length = transforms.length;
                while(++index < length){
                    var data = transforms[index], size = data.size;
                    switch(data.type){
                        case 'drop':
                            start += size;
                            break;
                        case 'dropRight':
                            end -= size;
                            break;
                        case 'take':
                            end = nativeMin(end, start + size);
                            break;
                        case 'takeRight':
                            start = nativeMax(start, end - size);
                            break;
                    }
                }
                return {
                    'start': start,
                    'end': end
                };
            }
            function getWrapDetails(source) {
                var match = source.match(reWrapDetails);
                return match ? match[1].split(reSplitDetails) : [];
            }
            function hasPath(object, path, hasFunc) {
                path = castPath(path, object);
                var index = -1, length = path.length, result = false;
                while(++index < length){
                    var key = toKey(path[index]);
                    if (!(result = object != null && hasFunc(object, key))) break;
                    object = object[key];
                }
                if (result || ++index != length) return result;
                length = object == null ? 0 : object.length;
                return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
            }
            function initCloneArray(array) {
                var length = array.length, result = new array.constructor(length);
                if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                    result.index = array.index;
                    result.input = array.input;
                }
                return result;
            }
            function initCloneObject(object) {
                return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
            }
            function initCloneByTag(object, tag, isDeep) {
                var Ctor = object.constructor;
                switch(tag){
                    case arrayBufferTag:
                        return cloneArrayBuffer(object);
                    case boolTag:
                    case dateTag:
                        return new Ctor(+object);
                    case dataViewTag:
                        return cloneDataView(object, isDeep);
                    case float32Tag:
                    case float64Tag:
                    case int8Tag:
                    case int16Tag:
                    case int32Tag:
                    case uint8Tag:
                    case uint8ClampedTag:
                    case uint16Tag:
                    case uint32Tag:
                        return cloneTypedArray(object, isDeep);
                    case mapTag:
                        return new Ctor;
                    case numberTag:
                    case stringTag:
                        return new Ctor(object);
                    case regexpTag:
                        return cloneRegExp(object);
                    case setTag:
                        return new Ctor;
                    case symbolTag:
                        return cloneSymbol(object);
                }
            }
            function insertWrapDetails(source, details) {
                var length = details.length;
                if (!length) return source;
                var lastIndex = length - 1;
                details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
                details = details.join(length > 2 ? ', ' : ' ');
                return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
            }
            function isFlattenable(value) {
                return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
            }
            function isIndex(value, length) {
                var type = typeof value;
                length = length == null ? MAX_SAFE_INTEGER : length;
                return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
            }
            function isIterateeCall(value, index, object) {
                if (!isObject(object)) return false;
                var type = typeof index;
                if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
                return false;
            }
            function isKey(value, object) {
                if (isArray(value)) return false;
                var type = typeof value;
                if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
                return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
            }
            function isKeyable(value) {
                var type = typeof value;
                return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
            }
            function isLaziable(func) {
                var funcName = getFuncName(func), other = lodash[funcName];
                if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
                if (func === other) return true;
                var data = getData(other);
                return !!data && func === data[0];
            }
            function isMasked(func) {
                return !!maskSrcKey && maskSrcKey in func;
            }
            var isMaskable = coreJsData ? isFunction : stubFalse;
            function isPrototype(value) {
                var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
                return value === proto;
            }
            function isStrictComparable(value) {
                return value === value && !isObject(value);
            }
            function matchesStrictComparable(key, srcValue) {
                return function(object) {
                    if (object == null) return false;
                    return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
                };
            }
            function memoizeCapped(func) {
                var result = memoize(func, function(key) {
                    if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                    return key;
                });
                var cache = result.cache;
                return result;
            }
            function mergeData(data, source) {
                var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
                var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
                if (!(isCommon || isCombo)) return data;
                if (srcBitmask & WRAP_BIND_FLAG) {
                    data[2] = source[2];
                    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
                }
                var value = source[3];
                if (value) {
                    var partials = data[3];
                    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
                }
                value = source[5];
                if (value) {
                    partials = data[5];
                    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
                }
                value = source[7];
                if (value) data[7] = value;
                if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
                if (data[9] == null) data[9] = source[9];
                data[0] = source[0];
                data[1] = newBitmask;
                return data;
            }
            function nativeKeysIn(object) {
                var result = [];
                if (object != null) for(var key in Object1(object))result.push(key);
                return result;
            }
            function objectToString(value) {
                return nativeObjectToString.call(value);
            }
            function overRest(func, start, transform) {
                start = nativeMax(start === undefined ? func.length - 1 : start, 0);
                return function() {
                    var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                    while(++index < length)array[index] = args[start + index];
                    index = -1;
                    var otherArgs = Array1(start + 1);
                    while(++index < start)otherArgs[index] = args[index];
                    otherArgs[start] = transform(array);
                    return apply(func, this, otherArgs);
                };
            }
            function parent(object, path) {
                return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
            }
            function reorder(array, indexes) {
                var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
                while(length--){
                    var index = indexes[length];
                    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
                }
                return array;
            }
            function safeGet(object, key) {
                if (key === 'constructor' && typeof object[key] === 'function') return;
                if (key == '__proto__') return;
                return object[key];
            }
            var setData = shortOut(baseSetData);
            var setTimeout = ctxSetTimeout || function(func, wait) {
                return root.setTimeout(func, wait);
            };
            var setToString = shortOut(baseSetToString);
            function setWrapToString(wrapper, reference, bitmask) {
                var source = reference + '';
                return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
            }
            function shortOut(func) {
                var count = 0, lastCalled = 0;
                return function() {
                    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                    lastCalled = stamp;
                    if (remaining > 0) {
                        if (++count >= HOT_COUNT) return arguments[0];
                    } else count = 0;
                    return func.apply(undefined, arguments);
                };
            }
            function shuffleSelf(array, size) {
                var index = -1, length = array.length, lastIndex = length - 1;
                size = size === undefined ? length : size;
                while(++index < size){
                    var rand = baseRandom(index, lastIndex), value = array[rand];
                    array[rand] = array[index];
                    array[index] = value;
                }
                array.length = size;
                return array;
            }
            var stringToPath = memoizeCapped(function(string) {
                var result = [];
                if (string.charCodeAt(0) === 46) result.push('');
                string.replace(rePropName, function(match, number, quote, subString) {
                    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
                });
                return result;
            });
            function toKey(value) {
                if (typeof value == 'string' || isSymbol(value)) return value;
                var result = value + '';
                return result == '0' && 1 / value == -INFINITY ? '-0' : result;
            }
            function toSource(func) {
                if (func != null) {
                    try {
                        return funcToString.call(func);
                    } catch (e) {}
                    try {
                        return func + '';
                    } catch (e) {}
                }
                return '';
            }
            function updateWrapDetails(details, bitmask) {
                arrayEach(wrapFlags, function(pair) {
                    var value = '_.' + pair[0];
                    if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
                });
                return details.sort();
            }
            function wrapperClone(wrapper) {
                if (wrapper instanceof LazyWrapper) return wrapper.clone();
                var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
                result.__actions__ = copyArray(wrapper.__actions__);
                result.__index__ = wrapper.__index__;
                result.__values__ = wrapper.__values__;
                return result;
            }
            function chunk(array, size, guard) {
                if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
                else size = nativeMax(toInteger(size), 0);
                var length = array == null ? 0 : array.length;
                if (!length || size < 1) return [];
                var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
                while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
                return result;
            }
            function compact(array) {
                var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
                while(++index < length){
                    var value = array[index];
                    if (value) result[resIndex++] = value;
                }
                return result;
            }
            function concat() {
                var length = arguments.length;
                if (!length) return [];
                var args = Array1(length - 1), array = arguments[0], index = length;
                while(index--)args[index - 1] = arguments[index];
                return arrayPush(isArray(array) ? copyArray(array) : [
                    array
                ], baseFlatten(args, 1));
            }
            var difference = baseRest(function(array, values) {
                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
            });
            var differenceBy = baseRest(function(array, values) {
                var iteratee = last(values);
                if (isArrayLikeObject(iteratee)) iteratee = undefined;
                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
            });
            var differenceWith = baseRest(function(array, values) {
                var comparator = last(values);
                if (isArrayLikeObject(comparator)) comparator = undefined;
                return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
            });
            function drop(array, n, guard) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                return baseSlice(array, n < 0 ? 0 : n, length);
            }
            function dropRight(array, n, guard) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                n = length - n;
                return baseSlice(array, 0, n < 0 ? 0 : n);
            }
            function dropRightWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
            }
            function dropWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
            }
            function fill(array, value, start, end) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                    start = 0;
                    end = length;
                }
                return baseFill(array, value, start, end);
            }
            function findIndex(array, predicate, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = fromIndex == null ? 0 : toInteger(fromIndex);
                if (index < 0) index = nativeMax(length + index, 0);
                return baseFindIndex(array, getIteratee(predicate, 3), index);
            }
            function findLastIndex(array, predicate, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = length - 1;
                if (fromIndex !== undefined) {
                    index = toInteger(fromIndex);
                    index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
                }
                return baseFindIndex(array, getIteratee(predicate, 3), index, true);
            }
            function flatten(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseFlatten(array, 1) : [];
            }
            function flattenDeep(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseFlatten(array, INFINITY) : [];
            }
            function flattenDepth(array, depth) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                depth = depth === undefined ? 1 : toInteger(depth);
                return baseFlatten(array, depth);
            }
            function fromPairs(pairs) {
                var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
                while(++index < length){
                    var pair = pairs[index];
                    result[pair[0]] = pair[1];
                }
                return result;
            }
            function head(array) {
                return array && array.length ? array[0] : undefined;
            }
            function indexOf(array, value, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = fromIndex == null ? 0 : toInteger(fromIndex);
                if (index < 0) index = nativeMax(length + index, 0);
                return baseIndexOf(array, value, index);
            }
            function initial(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseSlice(array, 0, -1) : [];
            }
            var intersection = baseRest(function(arrays) {
                var mapped = arrayMap(arrays, castArrayLikeObject);
                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
            });
            var intersectionBy = baseRest(function(arrays) {
                var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
                if (iteratee === last(mapped)) iteratee = undefined;
                else mapped.pop();
                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
            });
            var intersectionWith = baseRest(function(arrays) {
                var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
                comparator = typeof comparator == 'function' ? comparator : undefined;
                if (comparator) mapped.pop();
                return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
            });
            function join(array, separator) {
                return array == null ? '' : nativeJoin.call(array, separator);
            }
            function last(array) {
                var length = array == null ? 0 : array.length;
                return length ? array[length - 1] : undefined;
            }
            function lastIndexOf(array, value, fromIndex) {
                var length = array == null ? 0 : array.length;
                if (!length) return -1;
                var index = length;
                if (fromIndex !== undefined) {
                    index = toInteger(fromIndex);
                    index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
                }
                return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
            }
            function nth(array, n) {
                return array && array.length ? baseNth(array, toInteger(n)) : undefined;
            }
            var pull = baseRest(pullAll);
            function pullAll(array, values) {
                return array && array.length && values && values.length ? basePullAll(array, values) : array;
            }
            function pullAllBy(array, values, iteratee) {
                return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
            }
            function pullAllWith(array, values, comparator) {
                return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
            }
            var pullAt = flatRest(function(array, indexes) {
                var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
                basePullAt(array, arrayMap(indexes, function(index) {
                    return isIndex(index, length) ? +index : index;
                }).sort(compareAscending));
                return result;
            });
            function remove(array, predicate) {
                var result = [];
                if (!(array && array.length)) return result;
                var index = -1, indexes = [], length = array.length;
                predicate = getIteratee(predicate, 3);
                while(++index < length){
                    var value = array[index];
                    if (predicate(value, index, array)) {
                        result.push(value);
                        indexes.push(index);
                    }
                }
                basePullAt(array, indexes);
                return result;
            }
            function reverse(array) {
                return array == null ? array : nativeReverse.call(array);
            }
            function slice(array, start, end) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                    start = 0;
                    end = length;
                } else {
                    start = start == null ? 0 : toInteger(start);
                    end = end === undefined ? length : toInteger(end);
                }
                return baseSlice(array, start, end);
            }
            function sortedIndex(array, value) {
                return baseSortedIndex(array, value);
            }
            function sortedIndexBy(array, value, iteratee) {
                return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
            }
            function sortedIndexOf(array, value) {
                var length = array == null ? 0 : array.length;
                if (length) {
                    var index = baseSortedIndex(array, value);
                    if (index < length && eq(array[index], value)) return index;
                }
                return -1;
            }
            function sortedLastIndex(array, value) {
                return baseSortedIndex(array, value, true);
            }
            function sortedLastIndexBy(array, value, iteratee) {
                return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
            }
            function sortedLastIndexOf(array, value) {
                var length = array == null ? 0 : array.length;
                if (length) {
                    var index = baseSortedIndex(array, value, true) - 1;
                    if (eq(array[index], value)) return index;
                }
                return -1;
            }
            function sortedUniq(array) {
                return array && array.length ? baseSortedUniq(array) : [];
            }
            function sortedUniqBy(array, iteratee) {
                return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
            }
            function tail(array) {
                var length = array == null ? 0 : array.length;
                return length ? baseSlice(array, 1, length) : [];
            }
            function take(array, n, guard) {
                if (!(array && array.length)) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                return baseSlice(array, 0, n < 0 ? 0 : n);
            }
            function takeRight(array, n, guard) {
                var length = array == null ? 0 : array.length;
                if (!length) return [];
                n = guard || n === undefined ? 1 : toInteger(n);
                n = length - n;
                return baseSlice(array, n < 0 ? 0 : n, length);
            }
            function takeRightWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
            }
            function takeWhile(array, predicate) {
                return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
            }
            var union = baseRest(function(arrays) {
                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
            });
            var unionBy = baseRest(function(arrays) {
                var iteratee = last(arrays);
                if (isArrayLikeObject(iteratee)) iteratee = undefined;
                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
            });
            var unionWith = baseRest(function(arrays) {
                var comparator = last(arrays);
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
            });
            function uniq(array) {
                return array && array.length ? baseUniq(array) : [];
            }
            function uniqBy(array, iteratee) {
                return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
            }
            function uniqWith(array, comparator) {
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return array && array.length ? baseUniq(array, undefined, comparator) : [];
            }
            function unzip(array) {
                if (!(array && array.length)) return [];
                var length = 0;
                array = arrayFilter(array, function(group) {
                    if (isArrayLikeObject(group)) {
                        length = nativeMax(group.length, length);
                        return true;
                    }
                });
                return baseTimes(length, function(index) {
                    return arrayMap(array, baseProperty(index));
                });
            }
            function unzipWith(array, iteratee) {
                if (!(array && array.length)) return [];
                var result = unzip(array);
                if (iteratee == null) return result;
                return arrayMap(result, function(group) {
                    return apply(iteratee, undefined, group);
                });
            }
            var without = baseRest(function(array, values) {
                return isArrayLikeObject(array) ? baseDifference(array, values) : [];
            });
            var xor = baseRest(function(arrays) {
                return baseXor(arrayFilter(arrays, isArrayLikeObject));
            });
            var xorBy = baseRest(function(arrays) {
                var iteratee = last(arrays);
                if (isArrayLikeObject(iteratee)) iteratee = undefined;
                return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
            });
            var xorWith = baseRest(function(arrays) {
                var comparator = last(arrays);
                comparator = typeof comparator == 'function' ? comparator : undefined;
                return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
            });
            var zip = baseRest(unzip);
            function zipObject(props, values) {
                return baseZipObject(props || [], values || [], assignValue);
            }
            function zipObjectDeep(props, values) {
                return baseZipObject(props || [], values || [], baseSet);
            }
            var zipWith = baseRest(function(arrays) {
                var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
                iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
                return unzipWith(arrays, iteratee);
            });
            function chain(value) {
                var result = lodash(value);
                result.__chain__ = true;
                return result;
            }
            function tap(value, interceptor) {
                interceptor(value);
                return value;
            }
            function thru(value, interceptor) {
                return interceptor(value);
            }
            var wrapperAt = flatRest(function(paths) {
                var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                    return baseAt(object, paths);
                };
                if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
                value = value.slice(start, +start + (length ? 1 : 0));
                value.__actions__.push({
                    'func': thru,
                    'args': [
                        interceptor
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(value, this.__chain__).thru(function(array) {
                    if (length && !array.length) array.push(undefined);
                    return array;
                });
            });
            function wrapperChain() {
                return chain(this);
            }
            function wrapperCommit() {
                return new LodashWrapper(this.value(), this.__chain__);
            }
            function wrapperNext() {
                if (this.__values__ === undefined) this.__values__ = toArray(this.value());
                var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
                return {
                    'done': done,
                    'value': value
                };
            }
            function wrapperToIterator() {
                return this;
            }
            function wrapperPlant(value) {
                var result, parent = this;
                while(parent instanceof baseLodash){
                    var clone = wrapperClone(parent);
                    clone.__index__ = 0;
                    clone.__values__ = undefined;
                    if (result) previous.__wrapped__ = clone;
                    else result = clone;
                    var previous = clone;
                    parent = parent.__wrapped__;
                }
                previous.__wrapped__ = value;
                return result;
            }
            function wrapperReverse() {
                var value = this.__wrapped__;
                if (value instanceof LazyWrapper) {
                    var wrapped = value;
                    if (this.__actions__.length) wrapped = new LazyWrapper(this);
                    wrapped = wrapped.reverse();
                    wrapped.__actions__.push({
                        'func': thru,
                        'args': [
                            reverse
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(wrapped, this.__chain__);
                }
                return this.thru(reverse);
            }
            function wrapperValue() {
                return baseWrapperValue(this.__wrapped__, this.__actions__);
            }
            var countBy = createAggregator(function(result, value, key) {
                if (hasOwnProperty.call(result, key)) ++result[key];
                else baseAssignValue(result, key, 1);
            });
            function every(collection, predicate, guard) {
                var func = isArray(collection) ? arrayEvery : baseEvery;
                if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
                return func(collection, getIteratee(predicate, 3));
            }
            function filter(collection, predicate) {
                var func = isArray(collection) ? arrayFilter : baseFilter;
                return func(collection, getIteratee(predicate, 3));
            }
            var find = createFind(findIndex);
            var findLast = createFind(findLastIndex);
            function flatMap(collection, iteratee) {
                return baseFlatten(map(collection, iteratee), 1);
            }
            function flatMapDeep(collection, iteratee) {
                return baseFlatten(map(collection, iteratee), INFINITY);
            }
            function flatMapDepth(collection, iteratee, depth) {
                depth = depth === undefined ? 1 : toInteger(depth);
                return baseFlatten(map(collection, iteratee), depth);
            }
            function forEach(collection, iteratee) {
                var func = isArray(collection) ? arrayEach : baseEach;
                return func(collection, getIteratee(iteratee, 3));
            }
            function forEachRight(collection, iteratee) {
                var func = isArray(collection) ? arrayEachRight : baseEachRight;
                return func(collection, getIteratee(iteratee, 3));
            }
            var groupBy = createAggregator(function(result, value, key) {
                if (hasOwnProperty.call(result, key)) result[key].push(value);
                else baseAssignValue(result, key, [
                    value
                ]);
            });
            function includes(collection, value, fromIndex, guard) {
                collection = isArrayLike(collection) ? collection : values(collection);
                fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
                var length = collection.length;
                if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
                return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
            }
            var invokeMap = baseRest(function(collection, path, args) {
                var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
                baseEach(collection, function(value) {
                    result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
                });
                return result;
            });
            var keyBy = createAggregator(function(result, value, key) {
                baseAssignValue(result, key, value);
            });
            function map(collection, iteratee) {
                var func = isArray(collection) ? arrayMap : baseMap;
                return func(collection, getIteratee(iteratee, 3));
            }
            function orderBy(collection, iteratees, orders, guard) {
                if (collection == null) return [];
                if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                    iteratees
                ];
                orders = guard ? undefined : orders;
                if (!isArray(orders)) orders = orders == null ? [] : [
                    orders
                ];
                return baseOrderBy(collection, iteratees, orders);
            }
            var partition = createAggregator(function(result, value, key) {
                result[key ? 0 : 1].push(value);
            }, function() {
                return [
                    [],
                    []
                ];
            });
            function reduce(collection, iteratee, accumulator) {
                var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
                return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
            }
            function reduceRight(collection, iteratee, accumulator) {
                var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
                return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
            }
            function reject(collection, predicate) {
                var func = isArray(collection) ? arrayFilter : baseFilter;
                return func(collection, negate(getIteratee(predicate, 3)));
            }
            function sample(collection) {
                var func = isArray(collection) ? arraySample : baseSample;
                return func(collection);
            }
            function sampleSize(collection, n, guard) {
                if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
                else n = toInteger(n);
                var func = isArray(collection) ? arraySampleSize : baseSampleSize;
                return func(collection, n);
            }
            function shuffle(collection) {
                var func = isArray(collection) ? arrayShuffle : baseShuffle;
                return func(collection);
            }
            function size(collection) {
                if (collection == null) return 0;
                if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
                var tag = getTag(collection);
                if (tag == mapTag || tag == setTag) return collection.size;
                return baseKeys(collection).length;
            }
            function some(collection, predicate, guard) {
                var func = isArray(collection) ? arraySome : baseSome;
                if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
                return func(collection, getIteratee(predicate, 3));
            }
            var sortBy = baseRest(function(collection, iteratees) {
                if (collection == null) return [];
                var length = iteratees.length;
                if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
                else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                    iteratees[0]
                ];
                return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
            });
            var now = ctxNow || function() {
                return root.Date.now();
            };
            function after(n, func) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                n = toInteger(n);
                return function() {
                    if (--n < 1) return func.apply(this, arguments);
                };
            }
            function ary(func, n, guard) {
                n = guard ? undefined : n;
                n = func && n == null ? func.length : n;
                return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
            }
            function before(n, func) {
                var result;
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                n = toInteger(n);
                return function() {
                    if (--n > 0) result = func.apply(this, arguments);
                    if (n <= 1) func = undefined;
                    return result;
                };
            }
            var bind = baseRest(function(func, thisArg, partials) {
                var bitmask = WRAP_BIND_FLAG;
                if (partials.length) {
                    var holders = replaceHolders(partials, getHolder(bind));
                    bitmask |= WRAP_PARTIAL_FLAG;
                }
                return createWrap(func, bitmask, thisArg, partials, holders);
            });
            var bindKey = baseRest(function(object, key, partials) {
                var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
                if (partials.length) {
                    var holders = replaceHolders(partials, getHolder(bindKey));
                    bitmask |= WRAP_PARTIAL_FLAG;
                }
                return createWrap(key, bitmask, object, partials, holders);
            });
            function curry(func, arity, guard) {
                arity = guard ? undefined : arity;
                var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
                result.placeholder = curry.placeholder;
                return result;
            }
            function curryRight(func, arity, guard) {
                arity = guard ? undefined : arity;
                var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
                result.placeholder = curryRight.placeholder;
                return result;
            }
            function debounce(func, wait, options) {
                var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                wait = toNumber(wait) || 0;
                if (isObject(options)) {
                    leading = !!options.leading;
                    maxing = 'maxWait' in options;
                    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                    trailing = 'trailing' in options ? !!options.trailing : trailing;
                }
                function invokeFunc(time) {
                    var args = lastArgs, thisArg = lastThis;
                    lastArgs = lastThis = undefined;
                    lastInvokeTime = time;
                    result = func.apply(thisArg, args);
                    return result;
                }
                function leadingEdge(time) {
                    lastInvokeTime = time;
                    timerId = setTimeout(timerExpired, wait);
                    return leading ? invokeFunc(time) : result;
                }
                function remainingWait(time) {
                    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
                }
                function shouldInvoke(time) {
                    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
                }
                function timerExpired() {
                    var time = now();
                    if (shouldInvoke(time)) return trailingEdge(time);
                    timerId = setTimeout(timerExpired, remainingWait(time));
                }
                function trailingEdge(time) {
                    timerId = undefined;
                    if (trailing && lastArgs) return invokeFunc(time);
                    lastArgs = lastThis = undefined;
                    return result;
                }
                function cancel() {
                    if (timerId !== undefined) clearTimeout(timerId);
                    lastInvokeTime = 0;
                    lastArgs = lastCallTime = lastThis = timerId = undefined;
                }
                function flush() {
                    return timerId === undefined ? result : trailingEdge(now());
                }
                function debounced() {
                    var time = now(), isInvoking = shouldInvoke(time);
                    lastArgs = arguments;
                    lastThis = this;
                    lastCallTime = time;
                    if (isInvoking) {
                        if (timerId === undefined) return leadingEdge(lastCallTime);
                        if (maxing) {
                            clearTimeout(timerId);
                            timerId = setTimeout(timerExpired, wait);
                            return invokeFunc(lastCallTime);
                        }
                    }
                    if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                    return result;
                }
                debounced.cancel = cancel;
                debounced.flush = flush;
                return debounced;
            }
            var defer = baseRest(function(func, args) {
                return baseDelay(func, 1, args);
            });
            var delay = baseRest(function(func, wait, args) {
                return baseDelay(func, toNumber(wait) || 0, args);
            });
            function flip(func) {
                return createWrap(func, WRAP_FLIP_FLAG);
            }
            function memoize(func, resolver) {
                if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                var memoized = function() {
                    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                    if (cache.has(key)) return cache.get(key);
                    var result = func.apply(this, args);
                    memoized.cache = cache.set(key, result) || cache;
                    return result;
                };
                memoized.cache = new (memoize.Cache || MapCache);
                return memoized;
            }
            memoize.Cache = MapCache;
            function negate(predicate) {
                if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return function() {
                    var args = arguments;
                    switch(args.length){
                        case 0:
                            return !predicate.call(this);
                        case 1:
                            return !predicate.call(this, args[0]);
                        case 2:
                            return !predicate.call(this, args[0], args[1]);
                        case 3:
                            return !predicate.call(this, args[0], args[1], args[2]);
                    }
                    return !predicate.apply(this, args);
                };
            }
            function once(func) {
                return before(2, func);
            }
            var overArgs = castRest(function(func, transforms) {
                transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
                var funcsLength = transforms.length;
                return baseRest(function(args) {
                    var index = -1, length = nativeMin(args.length, funcsLength);
                    while(++index < length)args[index] = transforms[index].call(this, args[index]);
                    return apply(func, this, args);
                });
            });
            var partial = baseRest(function(func, partials) {
                var holders = replaceHolders(partials, getHolder(partial));
                return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
            });
            var partialRight = baseRest(function(func, partials) {
                var holders = replaceHolders(partials, getHolder(partialRight));
                return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
            });
            var rearg = flatRest(function(func, indexes) {
                return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
            });
            function rest(func, start) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                start = start === undefined ? start : toInteger(start);
                return baseRest(func, start);
            }
            function spread(func, start) {
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                start = start == null ? 0 : nativeMax(toInteger(start), 0);
                return baseRest(function(args) {
                    var array = args[start], otherArgs = castSlice(args, 0, start);
                    if (array) arrayPush(otherArgs, array);
                    return apply(func, this, otherArgs);
                });
            }
            function throttle(func, wait, options) {
                var leading = true, trailing = true;
                if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                if (isObject(options)) {
                    leading = 'leading' in options ? !!options.leading : leading;
                    trailing = 'trailing' in options ? !!options.trailing : trailing;
                }
                return debounce(func, wait, {
                    'leading': leading,
                    'maxWait': wait,
                    'trailing': trailing
                });
            }
            function unary(func) {
                return ary(func, 1);
            }
            function wrap(value, wrapper) {
                return partial(castFunction(wrapper), value);
            }
            function castArray() {
                if (!arguments.length) return [];
                var value = arguments[0];
                return isArray(value) ? value : [
                    value
                ];
            }
            function clone(value) {
                return baseClone(value, CLONE_SYMBOLS_FLAG);
            }
            function cloneWith(value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
            }
            function cloneDeep(value) {
                return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
            }
            function cloneDeepWith(value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
            }
            function conformsTo(object, source) {
                return source == null || baseConformsTo(object, source, keys(source));
            }
            function eq(value, other) {
                return value === other || value !== value && other !== other;
            }
            var gt = createRelationalOperation(baseGt);
            var gte = createRelationalOperation(function(value, other) {
                return value >= other;
            });
            var isArguments = baseIsArguments(function() {
                return arguments;
            }()) ? baseIsArguments : function(value) {
                return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
            };
            var isArray = Array1.isArray;
            var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
            function isArrayLike(value) {
                return value != null && isLength(value.length) && !isFunction(value);
            }
            function isArrayLikeObject(value) {
                return isObjectLike(value) && isArrayLike(value);
            }
            function isBoolean(value) {
                return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
            }
            var isBuffer = nativeIsBuffer || stubFalse;
            var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
            function isElement(value) {
                return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
            }
            function isEmpty(value) {
                if (value == null) return true;
                if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
                var tag = getTag(value);
                if (tag == mapTag || tag == setTag) return !value.size;
                if (isPrototype(value)) return !baseKeys(value).length;
                for(var key in value){
                    if (hasOwnProperty.call(value, key)) return false;
                }
                return true;
            }
            function isEqual(value, other) {
                return baseIsEqual(value, other);
            }
            function isEqualWith(value, other, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                var result = customizer ? customizer(value, other) : undefined;
                return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
            }
            function isError(value) {
                if (!isObjectLike(value)) return false;
                var tag = baseGetTag(value);
                return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
            }
            function isFinite(value) {
                return typeof value == 'number' && nativeIsFinite(value);
            }
            function isFunction(value) {
                if (!isObject(value)) return false;
                var tag = baseGetTag(value);
                return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
            }
            function isInteger(value) {
                return typeof value == 'number' && value == toInteger(value);
            }
            function isLength(value) {
                return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
            }
            function isObject(value) {
                var type = typeof value;
                return value != null && (type == 'object' || type == 'function');
            }
            function isObjectLike(value) {
                return value != null && typeof value == 'object';
            }
            var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
            function isMatch(object, source) {
                return object === source || baseIsMatch(object, source, getMatchData(source));
            }
            function isMatchWith(object, source, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return baseIsMatch(object, source, getMatchData(source), customizer);
            }
            function isNaN(value) {
                return isNumber(value) && value != +value;
            }
            function isNative(value) {
                if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
                return baseIsNative(value);
            }
            function isNull(value) {
                return value === null;
            }
            function isNil(value) {
                return value == null;
            }
            function isNumber(value) {
                return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
            }
            function isPlainObject(value) {
                if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
                var proto = getPrototype(value);
                if (proto === null) return true;
                var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
                return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
            }
            var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
            function isSafeInteger(value) {
                return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
            }
            var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
            function isString(value) {
                return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
            }
            function isSymbol(value) {
                return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
            }
            var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
            function isUndefined(value) {
                return value === undefined;
            }
            function isWeakMap(value) {
                return isObjectLike(value) && getTag(value) == weakMapTag;
            }
            function isWeakSet(value) {
                return isObjectLike(value) && baseGetTag(value) == weakSetTag;
            }
            var lt = createRelationalOperation(baseLt);
            var lte = createRelationalOperation(function(value, other) {
                return value <= other;
            });
            function toArray(value) {
                if (!value) return [];
                if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
                if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
                var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
                return func(value);
            }
            function toFinite(value) {
                if (!value) return value === 0 ? value : 0;
                value = toNumber(value);
                if (value === INFINITY || value === -INFINITY) {
                    var sign = value < 0 ? -1 : 1;
                    return sign * MAX_INTEGER;
                }
                return value === value ? value : 0;
            }
            function toInteger(value) {
                var result = toFinite(value), remainder = result % 1;
                return result === result ? remainder ? result - remainder : result : 0;
            }
            function toLength(value) {
                return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
            }
            function toNumber(value) {
                if (typeof value == 'number') return value;
                if (isSymbol(value)) return NAN;
                if (isObject(value)) {
                    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                    value = isObject(other) ? other + '' : other;
                }
                if (typeof value != 'string') return value === 0 ? value : +value;
                value = baseTrim(value);
                var isBinary = reIsBinary.test(value);
                return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
            }
            function toPlainObject(value) {
                return copyObject(value, keysIn(value));
            }
            function toSafeInteger(value) {
                return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
            }
            function toString(value) {
                return value == null ? '' : baseToString(value);
            }
            var assign = createAssigner(function(object, source) {
                if (isPrototype(source) || isArrayLike(source)) {
                    copyObject(source, keys(source), object);
                    return;
                }
                for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
            });
            var assignIn = createAssigner(function(object, source) {
                copyObject(source, keysIn(source), object);
            });
            var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
                copyObject(source, keysIn(source), object, customizer);
            });
            var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
                copyObject(source, keys(source), object, customizer);
            });
            var at = flatRest(baseAt);
            function create(prototype, properties) {
                var result = baseCreate(prototype);
                return properties == null ? result : baseAssign(result, properties);
            }
            var defaults = baseRest(function(object, sources) {
                object = Object1(object);
                var index = -1;
                var length = sources.length;
                var guard = length > 2 ? sources[2] : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
                while(++index < length){
                    var source = sources[index];
                    var props = keysIn(source);
                    var propsIndex = -1;
                    var propsLength = props.length;
                    while(++propsIndex < propsLength){
                        var key = props[propsIndex];
                        var value = object[key];
                        if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                    }
                }
                return object;
            });
            var defaultsDeep = baseRest(function(args) {
                args.push(undefined, customDefaultsMerge);
                return apply(mergeWith, undefined, args);
            });
            function findKey(object, predicate) {
                return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
            }
            function findLastKey(object, predicate) {
                return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
            }
            function forIn(object, iteratee) {
                return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
            }
            function forInRight(object, iteratee) {
                return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
            }
            function forOwn(object, iteratee) {
                return object && baseForOwn(object, getIteratee(iteratee, 3));
            }
            function forOwnRight(object, iteratee) {
                return object && baseForOwnRight(object, getIteratee(iteratee, 3));
            }
            function functions(object) {
                return object == null ? [] : baseFunctions(object, keys(object));
            }
            function functionsIn(object) {
                return object == null ? [] : baseFunctions(object, keysIn(object));
            }
            function get(object, path, defaultValue) {
                var result = object == null ? undefined : baseGet(object, path);
                return result === undefined ? defaultValue : result;
            }
            function has(object, path) {
                return object != null && hasPath(object, path, baseHas);
            }
            function hasIn(object, path) {
                return object != null && hasPath(object, path, baseHasIn);
            }
            var invert = createInverter(function(result, value, key) {
                if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
                result[value] = key;
            }, constant(identity));
            var invertBy = createInverter(function(result, value, key) {
                if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
                if (hasOwnProperty.call(result, value)) result[value].push(key);
                else result[value] = [
                    key
                ];
            }, getIteratee);
            var invoke = baseRest(baseInvoke);
            function keys(object) {
                return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
            }
            function keysIn(object) {
                return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
            }
            function mapKeys(object, iteratee) {
                var result = {};
                iteratee = getIteratee(iteratee, 3);
                baseForOwn(object, function(value, key, object) {
                    baseAssignValue(result, iteratee(value, key, object), value);
                });
                return result;
            }
            function mapValues(object, iteratee) {
                var result = {};
                iteratee = getIteratee(iteratee, 3);
                baseForOwn(object, function(value, key, object) {
                    baseAssignValue(result, key, iteratee(value, key, object));
                });
                return result;
            }
            var merge = createAssigner(function(object, source, srcIndex) {
                baseMerge(object, source, srcIndex);
            });
            var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
                baseMerge(object, source, srcIndex, customizer);
            });
            var omit = flatRest(function(object, paths) {
                var result = {};
                if (object == null) return result;
                var isDeep = false;
                paths = arrayMap(paths, function(path) {
                    path = castPath(path, object);
                    isDeep || (isDeep = path.length > 1);
                    return path;
                });
                copyObject(object, getAllKeysIn(object), result);
                if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
                var length = paths.length;
                while(length--)baseUnset(result, paths[length]);
                return result;
            });
            function omitBy(object, predicate) {
                return pickBy(object, negate(getIteratee(predicate)));
            }
            var pick = flatRest(function(object, paths) {
                return object == null ? {} : basePick(object, paths);
            });
            function pickBy(object, predicate) {
                if (object == null) return {};
                var props = arrayMap(getAllKeysIn(object), function(prop) {
                    return [
                        prop
                    ];
                });
                predicate = getIteratee(predicate);
                return basePickBy(object, props, function(value, path) {
                    return predicate(value, path[0]);
                });
            }
            function result(object, path, defaultValue) {
                path = castPath(path, object);
                var index = -1, length = path.length;
                if (!length) {
                    length = 1;
                    object = undefined;
                }
                while(++index < length){
                    var value = object == null ? undefined : object[toKey(path[index])];
                    if (value === undefined) {
                        index = length;
                        value = defaultValue;
                    }
                    object = isFunction(value) ? value.call(object) : value;
                }
                return object;
            }
            function set(object, path, value) {
                return object == null ? object : baseSet(object, path, value);
            }
            function setWith(object, path, value, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return object == null ? object : baseSet(object, path, value, customizer);
            }
            var toPairs = createToPairs(keys);
            var toPairsIn = createToPairs(keysIn);
            function transform(object, iteratee, accumulator) {
                var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
                iteratee = getIteratee(iteratee, 4);
                if (accumulator == null) {
                    var Ctor = object && object.constructor;
                    if (isArrLike) accumulator = isArr ? new Ctor : [];
                    else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                    else accumulator = {};
                }
                (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                    return iteratee(accumulator, value, index, object);
                });
                return accumulator;
            }
            function unset(object, path) {
                return object == null ? true : baseUnset(object, path);
            }
            function update(object, path, updater) {
                return object == null ? object : baseUpdate(object, path, castFunction(updater));
            }
            function updateWith(object, path, updater, customizer) {
                customizer = typeof customizer == 'function' ? customizer : undefined;
                return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
            }
            function values(object) {
                return object == null ? [] : baseValues(object, keys(object));
            }
            function valuesIn(object) {
                return object == null ? [] : baseValues(object, keysIn(object));
            }
            function clamp(number, lower, upper) {
                if (upper === undefined) {
                    upper = lower;
                    lower = undefined;
                }
                if (upper !== undefined) {
                    upper = toNumber(upper);
                    upper = upper === upper ? upper : 0;
                }
                if (lower !== undefined) {
                    lower = toNumber(lower);
                    lower = lower === lower ? lower : 0;
                }
                return baseClamp(toNumber(number), lower, upper);
            }
            function inRange(number, start, end) {
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                number = toNumber(number);
                return baseInRange(number, start, end);
            }
            function random(lower, upper, floating) {
                if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
                if (floating === undefined) {
                    if (typeof upper == 'boolean') {
                        floating = upper;
                        upper = undefined;
                    } else if (typeof lower == 'boolean') {
                        floating = lower;
                        lower = undefined;
                    }
                }
                if (lower === undefined && upper === undefined) {
                    lower = 0;
                    upper = 1;
                } else {
                    lower = toFinite(lower);
                    if (upper === undefined) {
                        upper = lower;
                        lower = 0;
                    } else upper = toFinite(upper);
                }
                if (lower > upper) {
                    var temp = lower;
                    lower = upper;
                    upper = temp;
                }
                if (floating || lower % 1 || upper % 1) {
                    var rand = nativeRandom();
                    return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
                }
                return baseRandom(lower, upper);
            }
            var camelCase = createCompounder(function(result, word, index) {
                word = word.toLowerCase();
                return result + (index ? capitalize(word) : word);
            });
            function capitalize(string) {
                return upperFirst(toString(string).toLowerCase());
            }
            function deburr(string) {
                string = toString(string);
                return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
            }
            function endsWith(string, target, position) {
                string = toString(string);
                target = baseToString(target);
                var length = string.length;
                position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
                var end = position;
                position -= target.length;
                return position >= 0 && string.slice(position, end) == target;
            }
            function escape(string) {
                string = toString(string);
                return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
            }
            function escapeRegExp(string) {
                string = toString(string);
                return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
            }
            var kebabCase = createCompounder(function(result, word, index) {
                return result + (index ? '-' : '') + word.toLowerCase();
            });
            var lowerCase = createCompounder(function(result, word, index) {
                return result + (index ? ' ' : '') + word.toLowerCase();
            });
            var lowerFirst = createCaseFirst('toLowerCase');
            function pad(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;
                if (!length || strLength >= length) return string;
                var mid = (length - strLength) / 2;
                return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
            }
            function padEnd(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;
                return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
            }
            function padStart(string, length, chars) {
                string = toString(string);
                length = toInteger(length);
                var strLength = length ? stringSize(string) : 0;
                return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
            }
            function parseInt1(string, radix, guard) {
                if (guard || radix == null) radix = 0;
                else if (radix) radix = +radix;
                return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
            }
            function repeat(string, n, guard) {
                if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
                else n = toInteger(n);
                return baseRepeat(toString(string), n);
            }
            function replace() {
                var args = arguments, string = toString(args[0]);
                return args.length < 3 ? string : string.replace(args[1], args[2]);
            }
            var snakeCase = createCompounder(function(result, word, index) {
                return result + (index ? '_' : '') + word.toLowerCase();
            });
            function split(string, separator, limit) {
                if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
                limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
                if (!limit) return [];
                string = toString(string);
                if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                    separator = baseToString(separator);
                    if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
                }
                return string.split(separator, limit);
            }
            var startCase = createCompounder(function(result, word, index) {
                return result + (index ? ' ' : '') + upperFirst(word);
            });
            function startsWith(string, target, position) {
                string = toString(string);
                position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
                target = baseToString(target);
                return string.slice(position, position + target.length) == target;
            }
            function template(string, options, guard) {
                var settings = lodash.templateSettings;
                if (guard && isIterateeCall(string, options, guard)) options = undefined;
                string = toString(string);
                options = assignInWith({}, options, settings, customDefaultsAssignIn);
                var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
                var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
                var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
                var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
                string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                    interpolateValue || (interpolateValue = esTemplateValue);
                    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                    if (escapeValue) {
                        isEscaping = true;
                        source += "' +\n__e(" + escapeValue + ") +\n'";
                    }
                    if (evaluateValue) {
                        isEvaluating = true;
                        source += "';\n" + evaluateValue + ";\n__p += '";
                    }
                    if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                    index = offset + match.length;
                    return match;
                });
                source += "';\n";
                var variable = hasOwnProperty.call(options, 'variable') && options.variable;
                if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
                else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
                source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
                source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
                var result = attempt(function() {
                    return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
                });
                result.source = source;
                if (isError(result)) throw result;
                return result;
            }
            function toLower(value) {
                return toString(value).toLowerCase();
            }
            function toUpper(value) {
                return toString(value).toUpperCase();
            }
            function trim(string, chars, guard) {
                string = toString(string);
                if (string && (guard || chars === undefined)) return baseTrim(string);
                if (!string || !(chars = baseToString(chars))) return string;
                var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
                return castSlice(strSymbols, start, end).join('');
            }
            function trimEnd(string, chars, guard) {
                string = toString(string);
                if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
                if (!string || !(chars = baseToString(chars))) return string;
                var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
                return castSlice(strSymbols, 0, end).join('');
            }
            function trimStart(string, chars, guard) {
                string = toString(string);
                if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
                if (!string || !(chars = baseToString(chars))) return string;
                var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
                return castSlice(strSymbols, start).join('');
            }
            function truncate(string, options) {
                var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
                if (isObject(options)) {
                    var separator = 'separator' in options ? options.separator : separator;
                    length = 'length' in options ? toInteger(options.length) : length;
                    omission = 'omission' in options ? baseToString(options.omission) : omission;
                }
                string = toString(string);
                var strLength = string.length;
                if (hasUnicode(string)) {
                    var strSymbols = stringToArray(string);
                    strLength = strSymbols.length;
                }
                if (length >= strLength) return string;
                var end = length - stringSize(omission);
                if (end < 1) return omission;
                var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
                if (separator === undefined) return result + omission;
                if (strSymbols) end += result.length - end;
                if (isRegExp(separator)) {
                    if (string.slice(end).search(separator)) {
                        var match, substring = result;
                        if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                        separator.lastIndex = 0;
                        while(match = separator.exec(substring))var newEnd = match.index;
                        result = result.slice(0, newEnd === undefined ? end : newEnd);
                    }
                } else if (string.indexOf(baseToString(separator), end) != end) {
                    var index = result.lastIndexOf(separator);
                    if (index > -1) result = result.slice(0, index);
                }
                return result + omission;
            }
            function unescape(string) {
                string = toString(string);
                return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
            }
            var upperCase = createCompounder(function(result, word, index) {
                return result + (index ? ' ' : '') + word.toUpperCase();
            });
            var upperFirst = createCaseFirst('toUpperCase');
            function words(string, pattern, guard) {
                string = toString(string);
                pattern = guard ? undefined : pattern;
                if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
                return string.match(pattern) || [];
            }
            var attempt = baseRest(function(func, args) {
                try {
                    return apply(func, undefined, args);
                } catch (e) {
                    return isError(e) ? e : new Error(e);
                }
            });
            var bindAll = flatRest(function(object, methodNames) {
                arrayEach(methodNames, function(key) {
                    key = toKey(key);
                    baseAssignValue(object, key, bind(object[key], object));
                });
                return object;
            });
            function cond(pairs) {
                var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
                pairs = !length ? [] : arrayMap(pairs, function(pair) {
                    if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    return [
                        toIteratee(pair[0]),
                        pair[1]
                    ];
                });
                return baseRest(function(args) {
                    var index = -1;
                    while(++index < length){
                        var pair = pairs[index];
                        if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                    }
                });
            }
            function conforms(source) {
                return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
            }
            function constant(value) {
                return function() {
                    return value;
                };
            }
            function defaultTo(value, defaultValue) {
                return value == null || value !== value ? defaultValue : value;
            }
            var flow = createFlow();
            var flowRight = createFlow(true);
            function identity(value) {
                return value;
            }
            function iteratee(func) {
                return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
            }
            function matches(source) {
                return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
            }
            function matchesProperty(path, srcValue) {
                return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
            }
            var method = baseRest(function(path, args) {
                return function(object) {
                    return baseInvoke(object, path, args);
                };
            });
            var methodOf = baseRest(function(object, args) {
                return function(path) {
                    return baseInvoke(object, path, args);
                };
            });
            function mixin(object, source, options) {
                var props = keys(source), methodNames = baseFunctions(source, props);
                if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                    options = source;
                    source = object;
                    object = this;
                    methodNames = baseFunctions(source, keys(source));
                }
                var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
                arrayEach(methodNames, function(methodName) {
                    var func = source[methodName];
                    object[methodName] = func;
                    if (isFunc) object.prototype[methodName] = function() {
                        var chainAll = this.__chain__;
                        if (chain || chainAll) {
                            var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                            actions.push({
                                'func': func,
                                'args': arguments,
                                'thisArg': object
                            });
                            result.__chain__ = chainAll;
                            return result;
                        }
                        return func.apply(object, arrayPush([
                            this.value()
                        ], arguments));
                    };
                });
                return object;
            }
            function noConflict() {
                if (root._ === this) root._ = oldDash;
                return this;
            }
            function noop() {}
            function nthArg(n) {
                n = toInteger(n);
                return baseRest(function(args) {
                    return baseNth(args, n);
                });
            }
            var over = createOver(arrayMap);
            var overEvery = createOver(arrayEvery);
            var overSome = createOver(arraySome);
            function property(path) {
                return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
            }
            function propertyOf(object) {
                return function(path) {
                    return object == null ? undefined : baseGet(object, path);
                };
            }
            var range = createRange();
            var rangeRight = createRange(true);
            function stubArray() {
                return [];
            }
            function stubFalse() {
                return false;
            }
            function stubObject() {
                return {};
            }
            function stubString() {
                return '';
            }
            function stubTrue() {
                return true;
            }
            function times(n, iteratee) {
                n = toInteger(n);
                if (n < 1 || n > MAX_SAFE_INTEGER) return [];
                var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
                iteratee = getIteratee(iteratee);
                n -= MAX_ARRAY_LENGTH;
                var result = baseTimes(length, iteratee);
                while(++index < n)iteratee(index);
                return result;
            }
            function toPath(value) {
                if (isArray(value)) return arrayMap(value, toKey);
                return isSymbol(value) ? [
                    value
                ] : copyArray(stringToPath(toString(value)));
            }
            function uniqueId(prefix) {
                var id = ++idCounter;
                return toString(prefix) + id;
            }
            var add = createMathOperation(function(augend, addend) {
                return augend + addend;
            }, 0);
            var ceil = createRound('ceil');
            var divide = createMathOperation(function(dividend, divisor) {
                return dividend / divisor;
            }, 1);
            var floor = createRound('floor');
            function max(array) {
                return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
            }
            function maxBy(array, iteratee) {
                return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
            }
            function mean(array) {
                return baseMean(array, identity);
            }
            function meanBy(array, iteratee) {
                return baseMean(array, getIteratee(iteratee, 2));
            }
            function min(array) {
                return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
            }
            function minBy(array, iteratee) {
                return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
            }
            var multiply = createMathOperation(function(multiplier, multiplicand) {
                return multiplier * multiplicand;
            }, 1);
            var round = createRound('round');
            var subtract = createMathOperation(function(minuend, subtrahend) {
                return minuend - subtrahend;
            }, 0);
            function sum(array) {
                return array && array.length ? baseSum(array, identity) : 0;
            }
            function sumBy(array, iteratee) {
                return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
            }
            lodash.after = after;
            lodash.ary = ary;
            lodash.assign = assign;
            lodash.assignIn = assignIn;
            lodash.assignInWith = assignInWith;
            lodash.assignWith = assignWith;
            lodash.at = at;
            lodash.before = before;
            lodash.bind = bind;
            lodash.bindAll = bindAll;
            lodash.bindKey = bindKey;
            lodash.castArray = castArray;
            lodash.chain = chain;
            lodash.chunk = chunk;
            lodash.compact = compact;
            lodash.concat = concat;
            lodash.cond = cond;
            lodash.conforms = conforms;
            lodash.constant = constant;
            lodash.countBy = countBy;
            lodash.create = create;
            lodash.curry = curry;
            lodash.curryRight = curryRight;
            lodash.debounce = debounce;
            lodash.defaults = defaults;
            lodash.defaultsDeep = defaultsDeep;
            lodash.defer = defer;
            lodash.delay = delay;
            lodash.difference = difference;
            lodash.differenceBy = differenceBy;
            lodash.differenceWith = differenceWith;
            lodash.drop = drop;
            lodash.dropRight = dropRight;
            lodash.dropRightWhile = dropRightWhile;
            lodash.dropWhile = dropWhile;
            lodash.fill = fill;
            lodash.filter = filter;
            lodash.flatMap = flatMap;
            lodash.flatMapDeep = flatMapDeep;
            lodash.flatMapDepth = flatMapDepth;
            lodash.flatten = flatten;
            lodash.flattenDeep = flattenDeep;
            lodash.flattenDepth = flattenDepth;
            lodash.flip = flip;
            lodash.flow = flow;
            lodash.flowRight = flowRight;
            lodash.fromPairs = fromPairs;
            lodash.functions = functions;
            lodash.functionsIn = functionsIn;
            lodash.groupBy = groupBy;
            lodash.initial = initial;
            lodash.intersection = intersection;
            lodash.intersectionBy = intersectionBy;
            lodash.intersectionWith = intersectionWith;
            lodash.invert = invert;
            lodash.invertBy = invertBy;
            lodash.invokeMap = invokeMap;
            lodash.iteratee = iteratee;
            lodash.keyBy = keyBy;
            lodash.keys = keys;
            lodash.keysIn = keysIn;
            lodash.map = map;
            lodash.mapKeys = mapKeys;
            lodash.mapValues = mapValues;
            lodash.matches = matches;
            lodash.matchesProperty = matchesProperty;
            lodash.memoize = memoize;
            lodash.merge = merge;
            lodash.mergeWith = mergeWith;
            lodash.method = method;
            lodash.methodOf = methodOf;
            lodash.mixin = mixin;
            lodash.negate = negate;
            lodash.nthArg = nthArg;
            lodash.omit = omit;
            lodash.omitBy = omitBy;
            lodash.once = once;
            lodash.orderBy = orderBy;
            lodash.over = over;
            lodash.overArgs = overArgs;
            lodash.overEvery = overEvery;
            lodash.overSome = overSome;
            lodash.partial = partial;
            lodash.partialRight = partialRight;
            lodash.partition = partition;
            lodash.pick = pick;
            lodash.pickBy = pickBy;
            lodash.property = property;
            lodash.propertyOf = propertyOf;
            lodash.pull = pull;
            lodash.pullAll = pullAll;
            lodash.pullAllBy = pullAllBy;
            lodash.pullAllWith = pullAllWith;
            lodash.pullAt = pullAt;
            lodash.range = range;
            lodash.rangeRight = rangeRight;
            lodash.rearg = rearg;
            lodash.reject = reject;
            lodash.remove = remove;
            lodash.rest = rest;
            lodash.reverse = reverse;
            lodash.sampleSize = sampleSize;
            lodash.set = set;
            lodash.setWith = setWith;
            lodash.shuffle = shuffle;
            lodash.slice = slice;
            lodash.sortBy = sortBy;
            lodash.sortedUniq = sortedUniq;
            lodash.sortedUniqBy = sortedUniqBy;
            lodash.split = split;
            lodash.spread = spread;
            lodash.tail = tail;
            lodash.take = take;
            lodash.takeRight = takeRight;
            lodash.takeRightWhile = takeRightWhile;
            lodash.takeWhile = takeWhile;
            lodash.tap = tap;
            lodash.throttle = throttle;
            lodash.thru = thru;
            lodash.toArray = toArray;
            lodash.toPairs = toPairs;
            lodash.toPairsIn = toPairsIn;
            lodash.toPath = toPath;
            lodash.toPlainObject = toPlainObject;
            lodash.transform = transform;
            lodash.unary = unary;
            lodash.union = union;
            lodash.unionBy = unionBy;
            lodash.unionWith = unionWith;
            lodash.uniq = uniq;
            lodash.uniqBy = uniqBy;
            lodash.uniqWith = uniqWith;
            lodash.unset = unset;
            lodash.unzip = unzip;
            lodash.unzipWith = unzipWith;
            lodash.update = update;
            lodash.updateWith = updateWith;
            lodash.values = values;
            lodash.valuesIn = valuesIn;
            lodash.without = without;
            lodash.words = words;
            lodash.wrap = wrap;
            lodash.xor = xor;
            lodash.xorBy = xorBy;
            lodash.xorWith = xorWith;
            lodash.zip = zip;
            lodash.zipObject = zipObject;
            lodash.zipObjectDeep = zipObjectDeep;
            lodash.zipWith = zipWith;
            lodash.entries = toPairs;
            lodash.entriesIn = toPairsIn;
            lodash.extend = assignIn;
            lodash.extendWith = assignInWith;
            mixin(lodash, lodash);
            lodash.add = add;
            lodash.attempt = attempt;
            lodash.camelCase = camelCase;
            lodash.capitalize = capitalize;
            lodash.ceil = ceil;
            lodash.clamp = clamp;
            lodash.clone = clone;
            lodash.cloneDeep = cloneDeep;
            lodash.cloneDeepWith = cloneDeepWith;
            lodash.cloneWith = cloneWith;
            lodash.conformsTo = conformsTo;
            lodash.deburr = deburr;
            lodash.defaultTo = defaultTo;
            lodash.divide = divide;
            lodash.endsWith = endsWith;
            lodash.eq = eq;
            lodash.escape = escape;
            lodash.escapeRegExp = escapeRegExp;
            lodash.every = every;
            lodash.find = find;
            lodash.findIndex = findIndex;
            lodash.findKey = findKey;
            lodash.findLast = findLast;
            lodash.findLastIndex = findLastIndex;
            lodash.findLastKey = findLastKey;
            lodash.floor = floor;
            lodash.forEach = forEach;
            lodash.forEachRight = forEachRight;
            lodash.forIn = forIn;
            lodash.forInRight = forInRight;
            lodash.forOwn = forOwn;
            lodash.forOwnRight = forOwnRight;
            lodash.get = get;
            lodash.gt = gt;
            lodash.gte = gte;
            lodash.has = has;
            lodash.hasIn = hasIn;
            lodash.head = head;
            lodash.identity = identity;
            lodash.includes = includes;
            lodash.indexOf = indexOf;
            lodash.inRange = inRange;
            lodash.invoke = invoke;
            lodash.isArguments = isArguments;
            lodash.isArray = isArray;
            lodash.isArrayBuffer = isArrayBuffer;
            lodash.isArrayLike = isArrayLike;
            lodash.isArrayLikeObject = isArrayLikeObject;
            lodash.isBoolean = isBoolean;
            lodash.isBuffer = isBuffer;
            lodash.isDate = isDate;
            lodash.isElement = isElement;
            lodash.isEmpty = isEmpty;
            lodash.isEqual = isEqual;
            lodash.isEqualWith = isEqualWith;
            lodash.isError = isError;
            lodash.isFinite = isFinite;
            lodash.isFunction = isFunction;
            lodash.isInteger = isInteger;
            lodash.isLength = isLength;
            lodash.isMap = isMap;
            lodash.isMatch = isMatch;
            lodash.isMatchWith = isMatchWith;
            lodash.isNaN = isNaN;
            lodash.isNative = isNative;
            lodash.isNil = isNil;
            lodash.isNull = isNull;
            lodash.isNumber = isNumber;
            lodash.isObject = isObject;
            lodash.isObjectLike = isObjectLike;
            lodash.isPlainObject = isPlainObject;
            lodash.isRegExp = isRegExp;
            lodash.isSafeInteger = isSafeInteger;
            lodash.isSet = isSet;
            lodash.isString = isString;
            lodash.isSymbol = isSymbol;
            lodash.isTypedArray = isTypedArray;
            lodash.isUndefined = isUndefined;
            lodash.isWeakMap = isWeakMap;
            lodash.isWeakSet = isWeakSet;
            lodash.join = join;
            lodash.kebabCase = kebabCase;
            lodash.last = last;
            lodash.lastIndexOf = lastIndexOf;
            lodash.lowerCase = lowerCase;
            lodash.lowerFirst = lowerFirst;
            lodash.lt = lt;
            lodash.lte = lte;
            lodash.max = max;
            lodash.maxBy = maxBy;
            lodash.mean = mean;
            lodash.meanBy = meanBy;
            lodash.min = min;
            lodash.minBy = minBy;
            lodash.stubArray = stubArray;
            lodash.stubFalse = stubFalse;
            lodash.stubObject = stubObject;
            lodash.stubString = stubString;
            lodash.stubTrue = stubTrue;
            lodash.multiply = multiply;
            lodash.nth = nth;
            lodash.noConflict = noConflict;
            lodash.noop = noop;
            lodash.now = now;
            lodash.pad = pad;
            lodash.padEnd = padEnd;
            lodash.padStart = padStart;
            lodash.parseInt = parseInt1;
            lodash.random = random;
            lodash.reduce = reduce;
            lodash.reduceRight = reduceRight;
            lodash.repeat = repeat;
            lodash.replace = replace;
            lodash.result = result;
            lodash.round = round;
            lodash.runInContext = runInContext;
            lodash.sample = sample;
            lodash.size = size;
            lodash.snakeCase = snakeCase;
            lodash.some = some;
            lodash.sortedIndex = sortedIndex;
            lodash.sortedIndexBy = sortedIndexBy;
            lodash.sortedIndexOf = sortedIndexOf;
            lodash.sortedLastIndex = sortedLastIndex;
            lodash.sortedLastIndexBy = sortedLastIndexBy;
            lodash.sortedLastIndexOf = sortedLastIndexOf;
            lodash.startCase = startCase;
            lodash.startsWith = startsWith;
            lodash.subtract = subtract;
            lodash.sum = sum;
            lodash.sumBy = sumBy;
            lodash.template = template;
            lodash.times = times;
            lodash.toFinite = toFinite;
            lodash.toInteger = toInteger;
            lodash.toLength = toLength;
            lodash.toLower = toLower;
            lodash.toNumber = toNumber;
            lodash.toSafeInteger = toSafeInteger;
            lodash.toString = toString;
            lodash.toUpper = toUpper;
            lodash.trim = trim;
            lodash.trimEnd = trimEnd;
            lodash.trimStart = trimStart;
            lodash.truncate = truncate;
            lodash.unescape = unescape;
            lodash.uniqueId = uniqueId;
            lodash.upperCase = upperCase;
            lodash.upperFirst = upperFirst;
            lodash.each = forEach;
            lodash.eachRight = forEachRight;
            lodash.first = head;
            mixin(lodash, function() {
                var source = {};
                baseForOwn(lodash, function(func, methodName) {
                    if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
                });
                return source;
            }(), {
                'chain': false
            });
            lodash.VERSION = VERSION;
            arrayEach([
                'bind',
                'bindKey',
                'curry',
                'curryRight',
                'partial',
                'partialRight'
            ], function(methodName) {
                lodash[methodName].placeholder = lodash;
            });
            arrayEach([
                'drop',
                'take'
            ], function(methodName, index) {
                LazyWrapper.prototype[methodName] = function(n) {
                    n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                    var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                    if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                    else result.__views__.push({
                        'size': nativeMin(n, MAX_ARRAY_LENGTH),
                        'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                    });
                    return result;
                };
                LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                    return this.reverse()[methodName](n).reverse();
                };
            });
            arrayEach([
                'filter',
                'map',
                'takeWhile'
            ], function(methodName, index) {
                var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
                LazyWrapper.prototype[methodName] = function(iteratee) {
                    var result = this.clone();
                    result.__iteratees__.push({
                        'iteratee': getIteratee(iteratee, 3),
                        'type': type
                    });
                    result.__filtered__ = result.__filtered__ || isFilter;
                    return result;
                };
            });
            arrayEach([
                'head',
                'last'
            ], function(methodName, index) {
                var takeName = 'take' + (index ? 'Right' : '');
                LazyWrapper.prototype[methodName] = function() {
                    return this[takeName](1).value()[0];
                };
            });
            arrayEach([
                'initial',
                'tail'
            ], function(methodName, index) {
                var dropName = 'drop' + (index ? '' : 'Right');
                LazyWrapper.prototype[methodName] = function() {
                    return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
                };
            });
            LazyWrapper.prototype.compact = function() {
                return this.filter(identity);
            };
            LazyWrapper.prototype.find = function(predicate) {
                return this.filter(predicate).head();
            };
            LazyWrapper.prototype.findLast = function(predicate) {
                return this.reverse().find(predicate);
            };
            LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
                if (typeof path == 'function') return new LazyWrapper(this);
                return this.map(function(value) {
                    return baseInvoke(value, path, args);
                });
            });
            LazyWrapper.prototype.reject = function(predicate) {
                return this.filter(negate(getIteratee(predicate)));
            };
            LazyWrapper.prototype.slice = function(start, end) {
                start = toInteger(start);
                var result = this;
                if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
                if (start < 0) result = result.takeRight(-start);
                else if (start) result = result.drop(start);
                if (end !== undefined) {
                    end = toInteger(end);
                    result = end < 0 ? result.dropRight(-end) : result.take(end - start);
                }
                return result;
            };
            LazyWrapper.prototype.takeRightWhile = function(predicate) {
                return this.reverse().takeWhile(predicate).reverse();
            };
            LazyWrapper.prototype.toArray = function() {
                return this.take(MAX_ARRAY_LENGTH);
            };
            baseForOwn(LazyWrapper.prototype, function(func, methodName) {
                var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
                if (!lodashFunc) return;
                lodash.prototype[methodName] = function() {
                    var value = this.__wrapped__, args = isTaker ? [
                        1
                    ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                    var interceptor = function(value) {
                        var result = lodashFunc.apply(lodash, arrayPush([
                            value
                        ], args));
                        return isTaker && chainAll ? result[0] : result;
                    };
                    if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) isLazy = useLazy = false;
                    var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                    if (!retUnwrapped && useLazy) {
                        value = onlyLazy ? value : new LazyWrapper(this);
                        var result = func.apply(value, args);
                        result.__actions__.push({
                            'func': thru,
                            'args': [
                                interceptor
                            ],
                            'thisArg': undefined
                        });
                        return new LodashWrapper(result, chainAll);
                    }
                    if (isUnwrapped && onlyLazy) return func.apply(this, args);
                    result = this.thru(interceptor);
                    return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
                };
            });
            arrayEach([
                'pop',
                'push',
                'shift',
                'sort',
                'splice',
                'unshift'
            ], function(methodName) {
                var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
                lodash.prototype[methodName] = function() {
                    var args = arguments;
                    if (retUnwrapped && !this.__chain__) {
                        var value = this.value();
                        return func.apply(isArray(value) ? value : [], args);
                    }
                    return this[chainName](function(value) {
                        return func.apply(isArray(value) ? value : [], args);
                    });
                };
            });
            baseForOwn(LazyWrapper.prototype, function(func, methodName) {
                var lodashFunc = lodash[methodName];
                if (lodashFunc) {
                    var key = lodashFunc.name + '';
                    if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                    realNames[key].push({
                        'name': methodName,
                        'func': lodashFunc
                    });
                }
            });
            realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
                {
                    'name': 'wrapper',
                    'func': undefined
                }
            ];
            LazyWrapper.prototype.clone = lazyClone;
            LazyWrapper.prototype.reverse = lazyReverse;
            LazyWrapper.prototype.value = lazyValue;
            lodash.prototype.at = wrapperAt;
            lodash.prototype.chain = wrapperChain;
            lodash.prototype.commit = wrapperCommit;
            lodash.prototype.next = wrapperNext;
            lodash.prototype.plant = wrapperPlant;
            lodash.prototype.reverse = wrapperReverse;
            lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
            lodash.prototype.first = lodash.prototype.head;
            if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
            return lodash;
        };
        var _ = runInContext();
        if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
            root._ = _;
            define(function() {
                return _;
            });
        } else if (freeModule) {
            (freeModule.exports = _)._ = _;
            freeExports._ = _;
        } else root._ = _;
    }).call(this);
});
parcelRegister("8NcGQ", function(module, exports) {
    $parcel$export(module.exports, "assertResponseIsOk", ()=>$ca0e4ff226c04dc7$export$b3732c8ff6f9c463);
    $parcel$export(module.exports, "toLoading", ()=>$ca0e4ff226c04dc7$export$f9a5bd0ffba29ffc);
    $parcel$export(module.exports, "toError", ()=>$ca0e4ff226c04dc7$export$cc3b967c039ed3e7);
    $parcel$export(module.exports, "toData", ()=>$ca0e4ff226c04dc7$export$24a6b176bdc41ce5);
    const $ca0e4ff226c04dc7$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
            status: status,
            statusText: statusText
        });
    const $ca0e4ff226c04dc7$export$b3732c8ff6f9c463 = (res)=>{
        if (res.ok) return res;
        throw new Error($ca0e4ff226c04dc7$export$18a0019e5439b209(res));
    };
    const $ca0e4ff226c04dc7$export$f9a5bd0ffba29ffc = ()=>({
            isLoading: true,
            data: undefined,
            error: undefined
        });
    const $ca0e4ff226c04dc7$export$cc3b967c039ed3e7 = (error)=>({
            isLoading: false,
            error: error instanceof Error ? error : Error(String(error)),
            data: undefined
        });
    const $ca0e4ff226c04dc7$export$24a6b176bdc41ce5 = (data)=>({
            isLoading: false,
            error: undefined,
            data: data
        });
});
parcelRegister("ivWKN", function(module, exports) {
    $parcel$export(module.exports, "usePlacementApi", ()=>$f5e4c89b84dc5493$export$201bbce8187a6e3c);
    var $j3kUo = parcelRequire("j3kUo");
    var $iGc4W = parcelRequire("iGc4W");
    var $iHPFP = parcelRequire("iHPFP");
    var $h5aU6 = parcelRequire("h5aU6");
    var $eUqFw = parcelRequire("eUqFw");
    const $f5e4c89b84dc5493$export$201bbce8187a6e3c = (path, config)=>{
        const { placementId: placementId } = (0, $iHPFP.usePlacementContext)();
        const context = (0, $j3kUo.usePostOfficeContext)();
        const fetcher = (0, $h5aU6.usePlacementFetchingContext)();
        const placementApi = (0, ($parcel$interopDefault($eUqFw))).useMemo(()=>{
            if (!placementId) return ()=>({
                    isLoading: false,
                    data: undefined,
                    error: new Error('No placementId found, make this is used as a child of PlacementProvider')
                });
            return (0, $iGc4W.createUsePlacement)(placementId, fetcher);
        }, [
            placementId,
            fetcher
        ]);
        return placementApi(path, context, config?.requestOptions, {
            throttleTime: config?.throttleTime,
            isEnabled: config?.autoRefetch?.isEnabled,
            deps: [
                config?.autoRefetch?.updateKey
            ]
        });
    };
});
parcelRegister("iGc4W", function(module, exports) {
    $parcel$export(module.exports, "createUsePlacement", ()=>$9566b4b7e067f409$export$ee1d67e435d25cb5);
    var $hchXc = parcelRequire("hchXc");
    var $eUqFw = parcelRequire("eUqFw");
    var $fo3on = parcelRequire("fo3on");
    const $9566b4b7e067f409$var$depsIsValid = (deps)=>Array.isArray(deps);
    const $9566b4b7e067f409$export$ee1d67e435d25cb5 = (placementId, fetcher = {
        fetch: (...args)=>globalThis.fetch(...args)
    })=>{
        if (!fetcher.fetch) throw new Error('No fetcher found. If you are using usePlacement outside or a browser you must supply a fetcher yourself');
        return (path, context, requestOptions, config)=>{
            const dependencyList = $9566b4b7e067f409$var$depsIsValid(config?.deps) ? [
                ...config.deps,
                config?.isEnabled
            ] : [
                path,
                config?.isEnabled
            ];
            const timerRef = (0, $eUqFw.useRef)();
            const isRunningPromise = (0, $eUqFw.useRef)(false);
            (0, $eUqFw.useEffect)(()=>{
                return ()=>{
                    if (timerRef.current) clearTimeout(timerRef.current);
                };
            }, []);
            const promiseToResolve = (0, $eUqFw.useMemo)(()=>{
                if (config?.isEnabled === false) return undefined;
                return ({ signal: signal })=>{
                    if (isRunningPromise.current) return Promise.reject(new (0, $fo3on.AlreadyRunningError)());
                    isRunningPromise.current = true;
                    timerRef.current = setTimeout(()=>{
                        isRunningPromise.current = false;
                    }, config?.throttleTime ?? 0);
                    return (0, $hchXc.fetchPlacementData)(placementId, path, context, fetcher, {
                        ...requestOptions,
                        signal: signal
                    });
                };
            }, dependencyList);
            return (0, $fo3on.useData)(promiseToResolve, {
                analytics: {
                    name: placementId,
                    path: path
                }
            });
        };
    };
});
parcelRegister("hchXc", function(module, exports) {
    $parcel$export(module.exports, "fetchPlacementData", ()=>$26b80c1bb7fcf675$export$ce743d02f83ee521);
    const $26b80c1bb7fcf675$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
    const $26b80c1bb7fcf675$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
    const $26b80c1bb7fcf675$var$stringifyObjectValues = (input)=>{
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, value])=>$26b80c1bb7fcf675$var$isNotEmpty(value)).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    };
    const $26b80c1bb7fcf675$export$ce743d02f83ee521 = (placementId, path, context, fetcher, requestOptions)=>{
        const defaultHeaders = {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json'
        };
        const normalizedPath = `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
        const contextAsSearchParams = new URLSearchParams($26b80c1bb7fcf675$var$stringifyObjectValues(context)).toString();
        const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
        const url = encodeURI(`${$26b80c1bb7fcf675$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
        return fetcher.fetch(url, {
            ...requestOptions,
            headers: {
                ...defaultHeaders,
                ...requestOptions?.headers
            }
        });
    };
});
parcelRegister("h5aU6", function(module, exports) {
    $parcel$export(module.exports, "usePlacementFetchingContext", ()=>$0226a23659438a80$export$e1e2cdb0425a9fa8);
    var $eUqFw = parcelRequire("eUqFw");
    const $0226a23659438a80$export$afec669dc416ee7e = (0, $eUqFw.createContext)({
        fetch: (...args)=>globalThis.fetch(...args)
    });
    const $0226a23659438a80$export$e1e2cdb0425a9fa8 = ()=>(0, $eUqFw.useContext)($0226a23659438a80$export$afec669dc416ee7e);
    const $0226a23659438a80$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
        const value = (0, $eUqFw.useMemo)(()=>({
                fetch: fetch
            }), [
            fetch
        ]);
        return React.createElement($0226a23659438a80$export$afec669dc416ee7e.Provider, {
            value: value
        }, children);
    };
});
parcelRegister("kDAdd", function(module, exports) {
    $parcel$export(module.exports, "scopes", ()=>$7a99aa26482002c3$export$54a06e3f4a159ad8);
    const $7a99aa26482002c3$export$54a06e3f4a159ad8 = [
        {
            name: 'all',
            when: {
                route: {
                    pathname: {
                        matches: '.*'
                    }
                }
            }
        },
        {
            name: 'jira/all',
            when: {
                context: {
                    product: 'jira'
                }
            }
        },
        {
            name: 'jira/kanban',
            when: {
                context: {
                    product: 'jira'
                },
                route: {
                    pathname: {
                        matches: 'boards'
                    }
                }
            }
        },
        {
            name: 'confluence/all',
            when: {
                context: {
                    product: 'confluence'
                }
            }
        },
        {
            name: 'pop3/all',
            when: {
                context: {
                    product: 'pop3'
                }
            }
        },
        {
            name: 'admin/all',
            when: {
                context: {
                    product: 'admin'
                }
            }
        },
        {
            name: 'pop3/send-it',
            when: {
                context: {
                    product: 'pop3'
                },
                route: {
                    pathname: {
                        matches: 'send-it'
                    }
                }
            }
        },
        {
            name: 'admin/products',
            when: {
                context: {
                    product: 'admin'
                },
                route: {
                    pathname: {
                        matches: 'products'
                    }
                }
            }
        },
        {
            name: 'trello/all',
            when: {
                context: {
                    product: 'trello'
                }
            }
        }
    ];
});
parcelRegister("bYHfN", function(module, exports) {
    $parcel$export(module.exports, "MessageRenderer", ()=>$a34bf6d3f7f9ba01$export$2df1250b8f917a59);
    var $59iH2 = parcelRequire("59iH2");
    var $1u3An = parcelRequire("1u3An");
    var $3NpAn = parcelRequire("3NpAn");
    var $2OlCV = parcelRequire("2OlCV");
    const $a34bf6d3f7f9ba01$export$e30378e28ad3e6ab = {
        ...(0, $1u3An.default),
        ...(0, $3NpAn.default),
        ...(0, $2OlCV.default)
    };
    const { initializeMessageRenderer: $a34bf6d3f7f9ba01$export$bce4e5106d86e473, MessageRenderer: $a34bf6d3f7f9ba01$export$2df1250b8f917a59 } = (0, $59iH2.asMessageRenderer)($a34bf6d3f7f9ba01$export$e30378e28ad3e6ab);
});
parcelRegister("59iH2", function(module, exports) {
    $parcel$export(module.exports, "asMessageRenderer", ()=>$8864cf54bd4e357d$export$7b7e5a348ef9a7c1);
    var $lHkHI = parcelRequire("lHkHI");
    var $fPtA6 = parcelRequire("fPtA6");
    var $6EPi0 = parcelRequire("6EPi0");
    var $empal = parcelRequire("empal");
    var $dpw7W = parcelRequire("dpw7W");
    var $DbjOV = parcelRequire("DbjOV");
    var $ktQdG = parcelRequire("ktQdG");
    var $5LLHE = parcelRequire("5LLHE");
    var $eUqFw = parcelRequire("eUqFw");
    var $9SGvH = parcelRequire("9SGvH");
    var $cLtT7 = parcelRequire("cLtT7");
    var $h90gO = parcelRequire("h90gO");
    const $8864cf54bd4e357d$export$14fe1fc3395b6e3f = ({ children: children })=>{
        const { messageViewed: messageViewed } = (0, $ktQdG.useMessageEvent)();
        const messageViewedVoidFunction = (0, $eUqFw.useCallback)(()=>{
            messageViewed();
        }, [
            messageViewed
        ]);
        return (0, $lHkHI.jsx)((0, $cLtT7.TrackMount), {
            onMount: messageViewedVoidFunction,
            children: children
        });
    };
    const $8864cf54bd4e357d$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
        const initializeMessageRenderer = ()=>{
            return ({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, ...data })=>{
                const isUFOEnabled = (0, $fPtA6.default).checkGate('enable_ufo_tracking_in_post_office');
                const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $eUqFw.useMemo)(()=>{
                    const messagePerformanceTracker = isUFOEnabled ? new (0, $6EPi0.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                    const onMessageSuccess = ()=>{
                        messagePerformanceTracker?.markSuccess();
                    };
                    const markMessageFailed = (onError)=>(error, info)=>{
                            messagePerformanceTracker?.markFailure(error);
                            onError && onError(error, info);
                        };
                    return {
                        markMessageUnmounted: messagePerformanceTracker?.abort,
                        markMessageFailed: markMessageFailed,
                        messageSuccessComponent: (0, $lHkHI.jsx)((0, $cLtT7.TrackMount), {
                            onMount: onMessageSuccess
                        })
                    };
                }, [
                    messageTemplateId
                ]);
                (0, $eUqFw.useEffect)(()=>{
                    return ()=>{
                        markMessageUnmounted?.();
                    };
                }, [
                    markMessageUnmounted
                ]);
                const Core = ()=>{
                    const Component = messageComponents?.[messageTemplateId];
                    if (!Component) throw new (0, $dpw7W.InvalidMessageTemplateIdError)(JSON.stringify({
                        messageTemplateId: messageTemplateId,
                        messageInstanceId: messageInstanceId
                    }));
                    let validatedMessage;
                    if (messageValidator) {
                        validatedMessage = messageValidator(data);
                        if (!validatedMessage) throw new (0, $dpw7W.MessageRendererEmptyValidationResponseError)();
                    }
                    const loadingComponent = (0, $eUqFw.useMemo)(()=>isUFOEnabled ? (0, $lHkHI.jsx)((0, $empal.UFOv2).UFOLoadHold, {
                            name: (0, $empal.UFOv2).HoldNames.MESSAGE,
                            children: loadingFallback ?? null
                        }) : (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
                            children: loadingFallback ?? null
                        }), [
                        loadingFallback,
                        isUFOEnabled
                    ]);
                    const componentProps = messageValidator ? validatedMessage : data;
                    if (!Component) return null;
                    return (0, $lHkHI.jsx)((0, $9SGvH.ChoreographerWrapper), {
                        messageId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        messageCategory: messageCategory,
                        children: (0, $lHkHI.jsx)($8864cf54bd4e357d$var$FeatureFlaggedUfoWrapper, {
                            messageTemplateId: messageTemplateId,
                            isEnabled: isUFOEnabled,
                            children: (0, $lHkHI.jsx)((0, $DbjOV.MessageContextProvider), {
                                value: {
                                    messageInstanceId: messageInstanceId,
                                    messageTemplateId: messageTemplateId,
                                    transactionAccountId: componentProps.transactionAccountId,
                                    analyticsDetails: postOffice?.analyticsDetails
                                },
                                children: (0, $lHkHI.jsx)((0, $5LLHE.RecommendationProvider), {
                                    value: recommendationSession ?? {},
                                    children: (0, $lHkHI.jsx)((0, $eUqFw.Suspense), {
                                        fallback: loadingComponent,
                                        children: (0, $lHkHI.jsxs)($8864cf54bd4e357d$export$14fe1fc3395b6e3f, {
                                            children: [
                                                messageSuccessComponent,
                                                (0, $lHkHI.jsx)(Component, {
                                                    ...componentProps
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    });
                };
                return (0, $h90gO.withErrorBoundary)(Core)({
                    errorBoundaryLocation: 'placement-message-renderer-component',
                    fallbackRender: fallbackRender,
                    onError: markMessageFailed(onError)
                });
            };
        };
        return {
            initializeMessageRenderer: initializeMessageRenderer,
            MessageRenderer: initializeMessageRenderer()
        };
    };
    const $8864cf54bd4e357d$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
        if (isEnabled) return (0, $lHkHI.jsx)((0, $empal.UFOv2).UFOSegment, {
            name: (0, $empal.UFOv2).SegmentNames.MESSAGE,
            children: (0, $lHkHI.jsx)((0, $empal.UFOv2).UFOSegment, {
                name: `${(0, $empal.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
                children: children
            })
        });
        return (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
            children: children
        });
    };
});
parcelRegister("6EPi0", function(module, exports) {
    $parcel$export(module.exports, "UFOv1", ()=>$fede45fe5d1c541c$export$96236906ebaa7f87);
    var $7JEqv = parcelRequire("7JEqv");
    var $3G8OL = parcelRequire("3G8OL");
    const $fede45fe5d1c541c$export$96236906ebaa7f87 = {
        MessagePerformanceTracker: $7JEqv.MessagePerformanceTracker,
        PlacementPerformanceTracker: $3G8OL.PlacementPerformanceTracker
    };
});
parcelRegister("7JEqv", function(module, exports) {
    $parcel$export(module.exports, "MessagePerformanceTracker", ()=>$1ed57496f0e7208c$export$ae5c73c7c4f454e6);
    var $kZ1Xe = parcelRequire("kZ1Xe");
    var $gNeWw = parcelRequire("gNeWw");
    var $bYioE = parcelRequire("bYioE");
    class $1ed57496f0e7208c$export$ae5c73c7c4f454e6 {
        constructor(messageTemplateId){
            this.metadata = {};
            this.markSuccess = ()=>{
                for (const experience of this.experiences)experience.success({
                    metadata: this.metadata
                });
            };
            this.markFailure = (error)=>{
                for (const experience of this.experiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.abort = ()=>{
                for (const experience of this.experiences)experience.abort({
                    metadata: this.metadata
                });
            };
            this.aggregatedExperience = new (0, $gNeWw.UFOExperience)((0, $bYioE.UFOExperienceNames).MESSAGE, {
                performanceType: (0, $kZ1Xe.ExperiencePerformanceTypes).PageSegmentLoad,
                type: (0, $kZ1Xe.ExperienceTypes).Load,
                platform: {
                    component: (0, $bYioE.POST_OFFICE_PLATFORM_NAME)
                }
            });
            this.messageSpecificExperience = new (0, $gNeWw.UFOExperience)(`${(0, $bYioE.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
                performanceType: (0, $kZ1Xe.ExperiencePerformanceTypes).PageSegmentLoad,
                type: (0, $kZ1Xe.ExperienceTypes).Load,
                platform: {
                    component: (0, $bYioE.POST_OFFICE_PLATFORM_NAME)
                }
            });
            this.experiences = [
                this.aggregatedExperience,
                this.messageSpecificExperience
            ];
            this.experiences.forEach((experience)=>experience.start());
            this.metadata = {
                messageTemplateId: messageTemplateId
            };
        }
    }
});
parcelRegister("bYioE", function(module, exports) {
    $parcel$export(module.exports, "UFOExperienceNames", ()=>$c7d2f26ad1c217ab$export$cc7ddf8ca628f6f1);
    $parcel$export(module.exports, "POST_OFFICE_PLATFORM_NAME", ()=>$c7d2f26ad1c217ab$export$6d482cfa20c9d220);
    const $c7d2f26ad1c217ab$export$cc7ddf8ca628f6f1 = {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    };
    const $c7d2f26ad1c217ab$export$6d482cfa20c9d220 = 'post-office';
});
parcelRegister("3G8OL", function(module, exports) {
    $parcel$export(module.exports, "PlacementPerformanceTracker", ()=>$a223d96c25eda993$export$8b48c2105ba0b35a);
    var $kZ1Xe = parcelRequire("kZ1Xe");
    var $gNeWw = parcelRequire("gNeWw");
    var $bYioE = parcelRequire("bYioE");
    const $a223d96c25eda993$var$STEPS = {
        RML_FETCH: 'rml-fetch',
        RML_RENDER: 'rml-render',
        INITIAL_DATA: 'initial-data-load',
        COMPONENT_READY: 'component-ready'
    };
    const $a223d96c25eda993$var$UFO_EXPERIENCE_CONFIG = {
        performanceType: (0, $kZ1Xe.ExperiencePerformanceTypes).PageSegmentLoad,
        type: (0, $kZ1Xe.ExperienceTypes).Load,
        platform: {
            component: (0, $bYioE.POST_OFFICE_PLATFORM_NAME)
        },
        timings: [
            {
                key: `${$a223d96c25eda993$var$STEPS.RML_FETCH}-complete`,
                endMark: `${$a223d96c25eda993$var$STEPS.RML_FETCH}-complete`
            },
            {
                key: `${$a223d96c25eda993$var$STEPS.RML_RENDER}-complete`,
                endMark: `${$a223d96c25eda993$var$STEPS.RML_RENDER}-complete`
            },
            {
                key: `${$a223d96c25eda993$var$STEPS.INITIAL_DATA}-complete`,
                endMark: `${$a223d96c25eda993$var$STEPS.INITIAL_DATA}-complete`
            },
            {
                key: `${$a223d96c25eda993$var$STEPS.INITIAL_DATA}-error`,
                endMark: `${$a223d96c25eda993$var$STEPS.INITIAL_DATA}-error`
            }
        ]
    };
    class $a223d96c25eda993$export$8b48c2105ba0b35a {
        constructor(placementId, consumptionType = 'remote'){
            this.placementExperiences = [];
            this.metadata = {};
            this.markFetchComplete = ()=>{
                for (const experience of this.placementExperiences)experience.mark(`${$a223d96c25eda993$var$STEPS.RML_FETCH}-complete`);
            };
            this.markRenderComplete = ()=>{
                for (const experience of this.placementExperiences)experience.mark(`${$a223d96c25eda993$var$STEPS.RML_RENDER}-complete`);
            };
            this.markInitialDataComplete = ()=>{
                for (const experience of this.placementExperiences)experience.mark(`${$a223d96c25eda993$var$STEPS.INITIAL_DATA}-complete`);
            };
            this.markComponentReady = ()=>{
                for (const experience of this.placementExperiences)experience.success({
                    metadata: this.metadata
                });
            };
            this.markFetchFailure = (error)=>{
                for (const experience of this.placementExperiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        failedDuring: $a223d96c25eda993$var$STEPS.RML_FETCH,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.markRenderFailure = (error)=>{
                for (const experience of this.placementExperiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        failedDuring: $a223d96c25eda993$var$STEPS.RML_RENDER,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.markInitialDataFailure = (_)=>{
                for (const experience of this.placementExperiences)experience.mark(`${$a223d96c25eda993$var$STEPS.INITIAL_DATA}-error`);
            };
            this.markComponentFailure = (error)=>{
                for (const experience of this.placementExperiences)experience.failure({
                    metadata: {
                        ...this.metadata,
                        failedDuring: $a223d96c25eda993$var$STEPS.COMPONENT_READY,
                        error: JSON.stringify(error)
                    }
                });
            };
            this.markComponentAborted = ()=>{
                for (const experience of this.placementExperiences)experience.abort({
                    metadata: this.metadata
                });
            };
            this.aggregatedExperience = new (0, $gNeWw.UFOExperience)((0, $bYioE.UFOExperienceNames).PLACEMENT, $a223d96c25eda993$var$UFO_EXPERIENCE_CONFIG);
            this.placementSpecificExperience = new (0, $gNeWw.UFOExperience)(`${(0, $bYioE.UFOExperienceNames).PLACEMENT}.${placementId}`, $a223d96c25eda993$var$UFO_EXPERIENCE_CONFIG);
            this.placementExperiences = [
                this.aggregatedExperience,
                this.placementSpecificExperience
            ];
            for (const experience of this.placementExperiences)experience.start();
            this.metadata = {
                placementId: placementId,
                consumptionType: consumptionType
            };
        }
    }
});
parcelRegister("dpw7W", function(module, exports) {
    $parcel$export(module.exports, "InvalidMessageTemplateIdError", ()=>$f3f5be06f5e85991$export$19cb89dd679394cb);
    $parcel$export(module.exports, "MessageRendererEmptyValidationResponseError", ()=>$f3f5be06f5e85991$export$3dfc27a8d3942f4d);
    var $f3f5be06f5e85991$export$b9722560029694e7;
    (function(PostOfficeErrorCodes) {
        PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
        PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
        PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
        PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
        PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
        PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
        PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
        PostOfficeErrorCodes["HandlerValidationError"] = "HandlerValidationError";
        PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
        PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
        PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
        PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
        PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
        PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
        PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
        PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
        PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
        PostOfficeErrorCodes["UnsupportedEmailError"] = "UnsupportedEmailError";
        PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
        PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
        PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
        PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
        PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
        PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
        PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
        PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
        PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
        PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
        PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
        PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
        PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
        PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
        PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    })($f3f5be06f5e85991$export$b9722560029694e7 || ($f3f5be06f5e85991$export$b9722560029694e7 = {}));
    class $f3f5be06f5e85991$export$46f86d28cd0a5d38 extends Error {
    }
    class $f3f5be06f5e85991$export$627bc00a5ef5f6ae extends Error {
    }
    class $f3f5be06f5e85991$export$d145ea5319863172 extends Error {
        constructor(message, code){
            super(message);
            this.code = code;
        }
    }
    class $f3f5be06f5e85991$export$f649da38897d27f7 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "NotAbleToProcessRecipientExpansionInputError");
            this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$c2852c1c4d9aba3e extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "RecipientExpansionProcessingError");
            this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$4b7b4e09547e4bb3 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "RecipientExpansionMethodInvocationError");
            this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$360a094a97597d87 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message){
            super(message, "RecipientExpansionManagerError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$4d068b43eb55165b extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message, input){
            super(message, "NotAbleToProcessRecipientExpansionInputError");
            this.input = input;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$ac007ee150add337 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message){
            super(message, "ReceiverInputValidationError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$b79ba63f8ae791e0 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message){
            super(message, "HandlerValidationError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$19cb89dd679394cb extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message){
            super(message, "InvalidMessageTemplateIdError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$78651662ad470cc5 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(){
            super('Message Template not found', "MessageTemplateNotFoundError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$913b8e68dc7ae8fe extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(){
            super('Placement not found', "PlacementNotFoundError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$3dfc27a8d3942f4d extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(){
            super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$e5ccdf8bbfead7a2 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(){
            super('Failed to send some events', "IngestionHandlerFailedSendError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$823733742d803ae6 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(){
            super('Failed to send some events', "OrchestrationHandlerFailedSendError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$a6f2aad8fa094b39 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(accountId){
            super('Unable to get user details for the given account ID', "UnableToGetUserDetailsError");
            this.accountId = accountId;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$2f1e27130c2bf271 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message, payloadSize){
            super(message, "InvalidPayloadError");
            this.name = this.constructor.name;
            this.payloadSize = payloadSize;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$d0dc094613469f2b extends $f3f5be06f5e85991$export$46f86d28cd0a5d38 {
        constructor(message, workspaceId){
            super(message);
            this.name = this.constructor.name;
            this.workspaceId = workspaceId;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$5603eab37ce562f5 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(fileType){
            super('The attachment file is not supported', "UnsupportedAttachmentType");
            this.name = this.constructor.name;
            this.fileType = fileType;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$b35ca1cf49054efc extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message, email){
            super(message, "UnsupportedEmailError");
            this.name = this.constructor.name;
            this.email = email;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$e0e9aa0e9c6b37ff extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message, error){
            super(message, "InvalidEmailRequestHeader");
            this.name = this.constructor.name;
            this.error = error;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$3ad818f64601e141 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message){
            super(message, "NonProdEmailDomainError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$25470bb6cba4fba0 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
            super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
            this.name = this.constructor.name;
            this.messageTemplateId = messageTemplateId;
            this.placementId = placementId;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$ce14d445679448b6 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
            super(message, "HydrationFailureAtPlacementError");
            this.name = this.constructor.name;
            this.messageTemplateId = messageTemplateId;
            this.messageInstanceId = messageInstanceId;
            this.placementId = placementId;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$8ab4fb362168b928 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(){
            super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$2afd69f57fe5285f extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(){
            super('Recipient expander not found for mapper', "UnusedValidateError");
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$7635d2b1a281d626 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message, errors){
            super(message, "GrowthRecRecommendationsError");
            this.errors = errors;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$9e1c6d00e675bc86 extends $f3f5be06f5e85991$export$d145ea5319863172 {
        constructor(message, recipient){
            super(message, "RichRecipientError");
            this.name = this.constructor.name;
            this.recipient = recipient;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$90bef7fa95eca3fa extends Error {
        constructor(status){
            super('Posting Mobile Notifications message failed');
            this.status = status;
            this.status = status;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$6d1a4929f6ff1a32 extends $f3f5be06f5e85991$export$46f86d28cd0a5d38 {
        constructor(message){
            super(message);
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$89bf5f64fbf0698 extends $f3f5be06f5e85991$export$46f86d28cd0a5d38 {
        constructor(message, error){
            super(message, {
                ...error ? {
                    cause: error
                } : {}
            });
            this.error = error;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$c19fc5e8aa4e064d extends Error {
        constructor(){
            super('Ingestion source is required when custom profile is specified');
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$2d3a68dab93b8cc4 extends Error {
        constructor(){
            super('A renderRedacted function is required when redactionLevel is set to a non-null value');
            this.name = this.constructor.name;
        }
    }
    class $f3f5be06f5e85991$export$175c1dbb0d7c238a extends Error {
        constructor(status){
            super('Enqueueing email failed');
            this.status = status;
            this.status = status;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
    class $f3f5be06f5e85991$export$23fab744b3076342 extends Error {
        constructor(message, status){
            super(message);
            this.message = message;
            this.status = status;
            this.name = this.constructor.name;
            Error.captureStackTrace(this, this.constructor);
        }
    }
});
parcelRegister("DbjOV", function(module, exports) {
    $parcel$export(module.exports, "MessageContextProvider", ()=>$18ac9e3ed30f4dc7$export$42de33f7652dc3de);
    $parcel$export(module.exports, "useMessageContext", ()=>$18ac9e3ed30f4dc7$export$a5b6d14a2e25725a);
    var $eUqFw = parcelRequire("eUqFw");
    const $18ac9e3ed30f4dc7$var$initialValue = {};
    const $18ac9e3ed30f4dc7$export$b060d577040138d8 = (0, $eUqFw.createContext)($18ac9e3ed30f4dc7$var$initialValue);
    const $18ac9e3ed30f4dc7$export$42de33f7652dc3de = $18ac9e3ed30f4dc7$export$b060d577040138d8.Provider;
    const $18ac9e3ed30f4dc7$export$a5b6d14a2e25725a = ()=>(0, $eUqFw.useContext)($18ac9e3ed30f4dc7$export$b060d577040138d8);
});
parcelRegister("ktQdG", function(module, exports) {
    $parcel$export(module.exports, "useMessageEvent", ()=>$ed82ba36540d0a22$export$3cbbf1e81e2ecb39);
    var $f2j1u = parcelRequire("f2j1u");
    var $j3kUo = parcelRequire("j3kUo");
    var $DbjOV = parcelRequire("DbjOV");
    var $iHPFP = parcelRequire("iHPFP");
    var $5LLHE = parcelRequire("5LLHE");
    var $cQBxJ = parcelRequire("cQBxJ");
    var $7TH0X = parcelRequire("7TH0X");
    var $8AyuG = parcelRequire("8AyuG");
    const $ed82ba36540d0a22$export$3cbbf1e81e2ecb39 = ()=>{
        if (!window.postOfficeMessageEventClient) window.postOfficeMessageEventClient = new (0, $7TH0X.MessageEventClient)();
        const client = window.postOfficeMessageEventClient;
        const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement } = (0, $f2j1u.useMessagePlacementHooks)();
        const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $DbjOV.useMessageContext)();
        const { placementId: placementId } = (0, $iHPFP.usePlacementContext)();
        const browserContext = (0, $j3kUo.usePostOfficeContext)();
        const recommendationContext = (0, $5LLHE.useRecommendationContext)();
        const context = {
            browser: browserContext,
            recommendation: recommendationContext
        };
        return {
            markAllAsRead: async (messages)=>{
                const messagesEventPostPayload = messages.map((message)=>{
                    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
                    if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cQBxJ.MessageLifecycleContextError)();
                    return {
                        messageInstanceId: message['messageInstanceId'],
                        messageTemplateId: message['messageTemplateId'],
                        type: (0, $8AyuG.InAppMessageEventType).Read,
                        placement: placementId,
                        createdAt: Date.now(),
                        analyticsDetails: analyticsDetails,
                        context: context
                    };
                });
                try {
                    await client.markAllAsReadEvent(messagesEventPostPayload);
                } catch (error) {
                    throw new (0, $cQBxJ.MessageLifecycleClientError)();
                }
            },
            messageRead: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cQBxJ.MessageLifecycleContextError)();
                markReadFromPlacement({
                    messageInstanceId: messageInstanceId
                });
                try {
                    await client.sendEvent({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        type: (0, $8AyuG.InAppMessageEventType).Read,
                        placement: placementId,
                        createdAt: Date.now(),
                        analyticsDetails: analyticsDetails,
                        context: context
                    });
                } catch (error) {
                    throw new (0, $cQBxJ.MessageLifecycleClientError)();
                }
            },
            messageUnread: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cQBxJ.MessageLifecycleContextError)();
                try {
                    await client.sendEvent({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        type: (0, $8AyuG.InAppMessageEventType).Unread,
                        placement: placementId,
                        createdAt: Date.now(),
                        context: context,
                        analyticsDetails: analyticsDetails
                    });
                } catch (error) {
                    throw new (0, $cQBxJ.MessageLifecycleClientError)();
                }
            },
            messageViewed: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cQBxJ.MessageLifecycleContextError)();
                markViewedFromPlacement({
                    messageInstanceId: messageInstanceId
                });
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $8AyuG.InAppMessageEventType).Viewed,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            },
            messageClicked: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cQBxJ.MessageLifecycleContextError)();
                markClickedFromPlacement({
                    messageInstanceId: messageInstanceId
                });
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $8AyuG.InAppMessageEventType).Clicked,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            },
            messageClickedSecondary: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cQBxJ.MessageLifecycleContextError)();
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $8AyuG.InAppMessageEventType).ClickedSecondary,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            },
            messageAcknowledged: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cQBxJ.MessageLifecycleContextError)();
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $8AyuG.InAppMessageEventType).Acknowledged,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            },
            messageDismissed: async ()=>{
                if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $cQBxJ.MessageLifecycleContextError)();
                dismissMessageFromPlacement({
                    messageInstanceId: messageInstanceId
                });
                client.batchSendEvent({
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    transactionAccountId: transactionAccountId,
                    type: (0, $8AyuG.InAppMessageEventType).Dismissed,
                    placement: placementId,
                    createdAt: Date.now(),
                    analyticsDetails: analyticsDetails,
                    context: context
                });
            }
        };
    };
});
parcelRegister("5LLHE", function(module, exports) {
    $parcel$export(module.exports, "RecommendationProvider", ()=>$fcfa568273b213e7$export$f60e87d7b5f59562);
    $parcel$export(module.exports, "useRecommendationContext", ()=>$fcfa568273b213e7$export$3321c0b02f750bcc);
    var $lHkHI = parcelRequire("lHkHI");
    var $9IDnR = parcelRequire("9IDnR");
    var $eUqFw = parcelRequire("eUqFw");
    const $fcfa568273b213e7$export$ba2f44035effd9c1 = (0, $eUqFw.createContext)({
        sessionId: undefined,
        entityId: undefined
    });
    const $fcfa568273b213e7$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
        return (0, $lHkHI.jsx)($fcfa568273b213e7$export$ba2f44035effd9c1.Provider, {
            value: value,
            children: (0, $lHkHI.jsx)((0, $9IDnR.default), {
                data: value,
                children: children
            })
        });
    };
    const $fcfa568273b213e7$export$3321c0b02f750bcc = ()=>(0, $eUqFw.useContext)($fcfa568273b213e7$export$ba2f44035effd9c1);
});
parcelRegister("cQBxJ", function(module, exports) {
    $parcel$export(module.exports, "MessageLifecycleContextError", ()=>$4add1304c1c5cdb6$export$12bb62b204112f55);
    $parcel$export(module.exports, "MessageLifecycleClientError", ()=>$4add1304c1c5cdb6$export$44f397e2afeb89e0);
    class $4add1304c1c5cdb6$export$12bb62b204112f55 extends Error {
        constructor(){
            super('useMessageLifecycle must be used inside a Message template render component.');
        }
    }
    class $4add1304c1c5cdb6$export$44f397e2afeb89e0 extends Error {
        constructor(){
            super('API call to /messages failed due to an error');
        }
    }
});
parcelRegister("7TH0X", function(module, exports) {
    $parcel$export(module.exports, "MessageEventClient", ()=>$d556fe7ad2058aae$export$ae86a6dabe385178);
    const $d556fe7ad2058aae$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
    const $d556fe7ad2058aae$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
    const $d556fe7ad2058aae$var$MESSAGE_EVENTS_BATCH_SIZE = 250;
    if (typeof fetch === 'undefined') (parcelRequire("eGvYe"));
    class $d556fe7ad2058aae$export$ae86a6dabe385178 {
        async sendEvent(event) {
            const url = `${this.endpointUrl}`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(event)
            });
            if (!response.ok) console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
        }
        batchSendEvent(event) {
            this.batchEvents.push(event);
            if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.flushBatchEvents.bind(this), $d556fe7ad2058aae$var$FLUSH_BATCH_EVENTS_TIMEOUT);
        }
        async markAllAsReadEvent(messages) {
            this.batchEvents.push(...messages);
            await this.flushBatchEvents();
        }
        async sendMessageEvents(events) {
            const url = `${this.endpointUrl}/bulk`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(events)
            });
            if (!response.ok) console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
        }
        async flushBatchEvents() {
            if (this.batchEvents.length === 0) return;
            if (this.batchEvents.length > $d556fe7ad2058aae$var$MESSAGE_EVENTS_BATCH_SIZE) {
                const batch = this.batchEvents.slice(0, $d556fe7ad2058aae$var$MESSAGE_EVENTS_BATCH_SIZE);
                await this.sendMessageEvents(batch);
                if (this.scheduledTimeout !== null) window.clearTimeout(this.scheduledTimeout);
                this.batchEvents = this.batchEvents.slice($d556fe7ad2058aae$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
                this.scheduledTimeout = window.setTimeout(this.flushBatchEvents.bind(this), $d556fe7ad2058aae$var$FLUSH_BATCH_EVENTS_TIMEOUT);
                return;
            }
            await this.sendMessageEvents(this.batchEvents);
            this.batchEvents = [];
            if (this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        }
        constructor(){
            this.endpointUrl = $d556fe7ad2058aae$var$DEFAULT_PATH;
            this.scheduledTimeout = null;
            this.batchEvents = [];
        }
    }
});
parcelRegister("eGvYe", function(module, exports) {
    $parcel$export(module.exports, "Headers", ()=>$ab0dc99bfac00606$export$79b704688b15c0f4);
    $parcel$export(module.exports, "Request", ()=>$ab0dc99bfac00606$export$7fa6c5b6f8193917);
    $parcel$export(module.exports, "Response", ()=>$ab0dc99bfac00606$export$9f633d56d7ec90d3);
    $parcel$export(module.exports, "DOMException", ()=>$ab0dc99bfac00606$export$fe58bcf938607f6a);
    $parcel$export(module.exports, "fetch", ()=>$ab0dc99bfac00606$export$e7aa7bc5c1b3cfb3);
    var $ab0dc99bfac00606$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global || {};
    var $ab0dc99bfac00606$var$support = {
        searchParams: 'URLSearchParams' in $ab0dc99bfac00606$var$g,
        iterable: 'Symbol' in $ab0dc99bfac00606$var$g && 'iterator' in Symbol,
        blob: 'FileReader' in $ab0dc99bfac00606$var$g && 'Blob' in $ab0dc99bfac00606$var$g && function() {
            try {
                new Blob();
                return true;
            } catch (e) {
                return false;
            }
        }(),
        formData: 'FormData' in $ab0dc99bfac00606$var$g,
        arrayBuffer: 'ArrayBuffer' in $ab0dc99bfac00606$var$g
    };
    function $ab0dc99bfac00606$var$isDataView(obj) {
        return obj && DataView.prototype.isPrototypeOf(obj);
    }
    if ($ab0dc99bfac00606$var$support.arrayBuffer) {
        var $ab0dc99bfac00606$var$viewClasses = [
            '[object Int8Array]',
            '[object Uint8Array]',
            '[object Uint8ClampedArray]',
            '[object Int16Array]',
            '[object Uint16Array]',
            '[object Int32Array]',
            '[object Uint32Array]',
            '[object Float32Array]',
            '[object Float64Array]'
        ];
        var $ab0dc99bfac00606$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
            return obj && $ab0dc99bfac00606$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
        };
    }
    function $ab0dc99bfac00606$var$normalizeName(name) {
        if (typeof name !== 'string') name = String(name);
        if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
        return name.toLowerCase();
    }
    function $ab0dc99bfac00606$var$normalizeValue(value) {
        if (typeof value !== 'string') value = String(value);
        return value;
    }
    function $ab0dc99bfac00606$var$iteratorFor(items) {
        var iterator = {
            next: function() {
                var value = items.shift();
                return {
                    done: value === undefined,
                    value: value
                };
            }
        };
        if ($ab0dc99bfac00606$var$support.iterable) iterator[Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    }
    function $ab0dc99bfac00606$export$79b704688b15c0f4(headers) {
        this.map = {};
        if (headers instanceof $ab0dc99bfac00606$export$79b704688b15c0f4) headers.forEach(function(value, name) {
            this.append(name, value);
        }, this);
        else if (Array.isArray(headers)) headers.forEach(function(header) {
            if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
            this.append(header[0], header[1]);
        }, this);
        else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
            this.append(name, headers[name]);
        }, this);
    }
    $ab0dc99bfac00606$export$79b704688b15c0f4.prototype.append = function(name, value) {
        name = $ab0dc99bfac00606$var$normalizeName(name);
        value = $ab0dc99bfac00606$var$normalizeValue(value);
        var oldValue = this.map[name];
        this.map[name] = oldValue ? oldValue + ', ' + value : value;
    };
    $ab0dc99bfac00606$export$79b704688b15c0f4.prototype['delete'] = function(name) {
        delete this.map[$ab0dc99bfac00606$var$normalizeName(name)];
    };
    $ab0dc99bfac00606$export$79b704688b15c0f4.prototype.get = function(name) {
        name = $ab0dc99bfac00606$var$normalizeName(name);
        return this.has(name) ? this.map[name] : null;
    };
    $ab0dc99bfac00606$export$79b704688b15c0f4.prototype.has = function(name) {
        return this.map.hasOwnProperty($ab0dc99bfac00606$var$normalizeName(name));
    };
    $ab0dc99bfac00606$export$79b704688b15c0f4.prototype.set = function(name, value) {
        this.map[$ab0dc99bfac00606$var$normalizeName(name)] = $ab0dc99bfac00606$var$normalizeValue(value);
    };
    $ab0dc99bfac00606$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
        for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
    };
    $ab0dc99bfac00606$export$79b704688b15c0f4.prototype.keys = function() {
        var items = [];
        this.forEach(function(value, name) {
            items.push(name);
        });
        return $ab0dc99bfac00606$var$iteratorFor(items);
    };
    $ab0dc99bfac00606$export$79b704688b15c0f4.prototype.values = function() {
        var items = [];
        this.forEach(function(value) {
            items.push(value);
        });
        return $ab0dc99bfac00606$var$iteratorFor(items);
    };
    $ab0dc99bfac00606$export$79b704688b15c0f4.prototype.entries = function() {
        var items = [];
        this.forEach(function(value, name) {
            items.push([
                name,
                value
            ]);
        });
        return $ab0dc99bfac00606$var$iteratorFor(items);
    };
    if ($ab0dc99bfac00606$var$support.iterable) $ab0dc99bfac00606$export$79b704688b15c0f4.prototype[Symbol.iterator] = $ab0dc99bfac00606$export$79b704688b15c0f4.prototype.entries;
    function $ab0dc99bfac00606$var$consumed(body) {
        if (body._noBody) return;
        if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
        body.bodyUsed = true;
    }
    function $ab0dc99bfac00606$var$fileReaderReady(reader) {
        return new Promise(function(resolve, reject) {
            reader.onload = function() {
                resolve(reader.result);
            };
            reader.onerror = function() {
                reject(reader.error);
            };
        });
    }
    function $ab0dc99bfac00606$var$readBlobAsArrayBuffer(blob) {
        var reader = new FileReader();
        var promise = $ab0dc99bfac00606$var$fileReaderReady(reader);
        reader.readAsArrayBuffer(blob);
        return promise;
    }
    function $ab0dc99bfac00606$var$readBlobAsText(blob) {
        var reader = new FileReader();
        var promise = $ab0dc99bfac00606$var$fileReaderReady(reader);
        var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
        var encoding = match ? match[1] : 'utf-8';
        reader.readAsText(blob, encoding);
        return promise;
    }
    function $ab0dc99bfac00606$var$readArrayBufferAsText(buf) {
        var view = new Uint8Array(buf);
        var chars = new Array(view.length);
        for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
        return chars.join('');
    }
    function $ab0dc99bfac00606$var$bufferClone(buf) {
        if (buf.slice) return buf.slice(0);
        else {
            var view = new Uint8Array(buf.byteLength);
            view.set(new Uint8Array(buf));
            return view.buffer;
        }
    }
    function $ab0dc99bfac00606$var$Body() {
        this.bodyUsed = false;
        this._initBody = function(body) {
            this.bodyUsed = this.bodyUsed;
            this._bodyInit = body;
            if (!body) {
                this._noBody = true;
                this._bodyText = '';
            } else if (typeof body === 'string') this._bodyText = body;
            else if ($ab0dc99bfac00606$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
            else if ($ab0dc99bfac00606$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
            else if ($ab0dc99bfac00606$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
            else if ($ab0dc99bfac00606$var$support.arrayBuffer && $ab0dc99bfac00606$var$support.blob && $ab0dc99bfac00606$var$isDataView(body)) {
                this._bodyArrayBuffer = $ab0dc99bfac00606$var$bufferClone(body.buffer);
                this._bodyInit = new Blob([
                    this._bodyArrayBuffer
                ]);
            } else if ($ab0dc99bfac00606$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $ab0dc99bfac00606$var$isArrayBufferView(body))) this._bodyArrayBuffer = $ab0dc99bfac00606$var$bufferClone(body);
            else this._bodyText = body = Object.prototype.toString.call(body);
            if (!this.headers.get('content-type')) {
                if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                else if ($ab0dc99bfac00606$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
        };
        if ($ab0dc99bfac00606$var$support.blob) this.blob = function() {
            var rejected = $ab0dc99bfac00606$var$consumed(this);
            if (rejected) return rejected;
            if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
            else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                this._bodyArrayBuffer
            ]));
            else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
            else return Promise.resolve(new Blob([
                this._bodyText
            ]));
        };
        this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
                var isConsumed = $ab0dc99bfac00606$var$consumed(this);
                if (isConsumed) return isConsumed;
                else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                else return Promise.resolve(this._bodyArrayBuffer);
            } else if ($ab0dc99bfac00606$var$support.blob) return this.blob().then($ab0dc99bfac00606$var$readBlobAsArrayBuffer);
            else throw new Error('could not read as ArrayBuffer');
        };
        this.text = function() {
            var rejected = $ab0dc99bfac00606$var$consumed(this);
            if (rejected) return rejected;
            if (this._bodyBlob) return $ab0dc99bfac00606$var$readBlobAsText(this._bodyBlob);
            else if (this._bodyArrayBuffer) return Promise.resolve($ab0dc99bfac00606$var$readArrayBufferAsText(this._bodyArrayBuffer));
            else if (this._bodyFormData) throw new Error('could not read FormData body as text');
            else return Promise.resolve(this._bodyText);
        };
        if ($ab0dc99bfac00606$var$support.formData) this.formData = function() {
            return this.text().then($ab0dc99bfac00606$var$decode);
        };
        this.json = function() {
            return this.text().then(JSON.parse);
        };
        return this;
    }
    var $ab0dc99bfac00606$var$methods = [
        'CONNECT',
        'DELETE',
        'GET',
        'HEAD',
        'OPTIONS',
        'PATCH',
        'POST',
        'PUT',
        'TRACE'
    ];
    function $ab0dc99bfac00606$var$normalizeMethod(method) {
        var upcased = method.toUpperCase();
        return $ab0dc99bfac00606$var$methods.indexOf(upcased) > -1 ? upcased : method;
    }
    function $ab0dc99bfac00606$export$7fa6c5b6f8193917(input, options) {
        if (!(this instanceof $ab0dc99bfac00606$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        options = options || {};
        var body = options.body;
        if (input instanceof $ab0dc99bfac00606$export$7fa6c5b6f8193917) {
            if (input.bodyUsed) throw new TypeError('Already read');
            this.url = input.url;
            this.credentials = input.credentials;
            if (!options.headers) this.headers = new $ab0dc99bfac00606$export$79b704688b15c0f4(input.headers);
            this.method = input.method;
            this.mode = input.mode;
            this.signal = input.signal;
            if (!body && input._bodyInit != null) {
                body = input._bodyInit;
                input.bodyUsed = true;
            }
        } else this.url = String(input);
        this.credentials = options.credentials || this.credentials || 'same-origin';
        if (options.headers || !this.headers) this.headers = new $ab0dc99bfac00606$export$79b704688b15c0f4(options.headers);
        this.method = $ab0dc99bfac00606$var$normalizeMethod(options.method || this.method || 'GET');
        this.mode = options.mode || this.mode || null;
        this.signal = options.signal || this.signal || function() {
            if ('AbortController' in $ab0dc99bfac00606$var$g) {
                var ctrl = new AbortController();
                return ctrl.signal;
            }
        }();
        this.referrer = null;
        if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
        this._initBody(body);
        if (this.method === 'GET' || this.method === 'HEAD') {
            if (options.cache === 'no-store' || options.cache === 'no-cache') {
                var reParamSearch = /([?&])_=[^&]*/;
                if (reParamSearch.test(this.url)) this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                else {
                    var reQueryString = /\?/;
                    this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                }
            }
        }
    }
    $ab0dc99bfac00606$export$7fa6c5b6f8193917.prototype.clone = function() {
        return new $ab0dc99bfac00606$export$7fa6c5b6f8193917(this, {
            body: this._bodyInit
        });
    };
    function $ab0dc99bfac00606$var$decode(body) {
        var form = new FormData();
        body.trim().split('&').forEach(function(bytes) {
            if (bytes) {
                var split = bytes.split('=');
                var name = split.shift().replace(/\+/g, ' ');
                var value = split.join('=').replace(/\+/g, ' ');
                form.append(decodeURIComponent(name), decodeURIComponent(value));
            }
        });
        return form;
    }
    function $ab0dc99bfac00606$var$parseHeaders(rawHeaders) {
        var headers = new $ab0dc99bfac00606$export$79b704688b15c0f4();
        var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
        preProcessedHeaders.split('\r').map(function(header) {
            return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
        }).forEach(function(line) {
            var parts = line.split(':');
            var key = parts.shift().trim();
            if (key) {
                var value = parts.join(':').trim();
                try {
                    headers.append(key, value);
                } catch (error) {
                    console.warn('Response ' + error.message);
                }
            }
        });
        return headers;
    }
    $ab0dc99bfac00606$var$Body.call($ab0dc99bfac00606$export$7fa6c5b6f8193917.prototype);
    function $ab0dc99bfac00606$export$9f633d56d7ec90d3(bodyInit, options) {
        if (!(this instanceof $ab0dc99bfac00606$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
        if (!options) options = {};
        this.type = 'default';
        this.status = options.status === undefined ? 200 : options.status;
        if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
        this.ok = this.status >= 200 && this.status < 300;
        this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
        this.headers = new $ab0dc99bfac00606$export$79b704688b15c0f4(options.headers);
        this.url = options.url || '';
        this._initBody(bodyInit);
    }
    $ab0dc99bfac00606$var$Body.call($ab0dc99bfac00606$export$9f633d56d7ec90d3.prototype);
    $ab0dc99bfac00606$export$9f633d56d7ec90d3.prototype.clone = function() {
        return new $ab0dc99bfac00606$export$9f633d56d7ec90d3(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new $ab0dc99bfac00606$export$79b704688b15c0f4(this.headers),
            url: this.url
        });
    };
    $ab0dc99bfac00606$export$9f633d56d7ec90d3.error = function() {
        var response = new $ab0dc99bfac00606$export$9f633d56d7ec90d3(null, {
            status: 200,
            statusText: ''
        });
        response.ok = false;
        response.status = 0;
        response.type = 'error';
        return response;
    };
    var $ab0dc99bfac00606$var$redirectStatuses = [
        301,
        302,
        303,
        307,
        308
    ];
    $ab0dc99bfac00606$export$9f633d56d7ec90d3.redirect = function(url, status) {
        if ($ab0dc99bfac00606$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
        return new $ab0dc99bfac00606$export$9f633d56d7ec90d3(null, {
            status: status,
            headers: {
                location: url
            }
        });
    };
    var $ab0dc99bfac00606$export$fe58bcf938607f6a = $ab0dc99bfac00606$var$g.DOMException;
    try {
        new $ab0dc99bfac00606$export$fe58bcf938607f6a();
    } catch (err) {
        $ab0dc99bfac00606$export$fe58bcf938607f6a = function(message, name) {
            this.message = message;
            this.name = name;
            var error = Error(message);
            this.stack = error.stack;
        };
        $ab0dc99bfac00606$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
        $ab0dc99bfac00606$export$fe58bcf938607f6a.prototype.constructor = $ab0dc99bfac00606$export$fe58bcf938607f6a;
    }
    function $ab0dc99bfac00606$export$e7aa7bc5c1b3cfb3(input, init) {
        return new Promise(function(resolve, reject) {
            var request = new $ab0dc99bfac00606$export$7fa6c5b6f8193917(input, init);
            if (request.signal && request.signal.aborted) return reject(new $ab0dc99bfac00606$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            var xhr = new XMLHttpRequest();
            function abortXhr() {
                xhr.abort();
            }
            xhr.onload = function() {
                var options = {
                    statusText: xhr.statusText,
                    headers: $ab0dc99bfac00606$var$parseHeaders(xhr.getAllResponseHeaders() || '')
                };
                if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                else options.status = xhr.status;
                options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                var body = 'response' in xhr ? xhr.response : xhr.responseText;
                setTimeout(function() {
                    resolve(new $ab0dc99bfac00606$export$9f633d56d7ec90d3(body, options));
                }, 0);
            };
            xhr.onerror = function() {
                setTimeout(function() {
                    reject(new TypeError('Network request failed'));
                }, 0);
            };
            xhr.ontimeout = function() {
                setTimeout(function() {
                    reject(new TypeError('Network request timed out'));
                }, 0);
            };
            xhr.onabort = function() {
                setTimeout(function() {
                    reject(new $ab0dc99bfac00606$export$fe58bcf938607f6a('Aborted', 'AbortError'));
                }, 0);
            };
            function fixUrl(url) {
                try {
                    return url === '' && $ab0dc99bfac00606$var$g.location.href ? $ab0dc99bfac00606$var$g.location.href : url;
                } catch (e) {
                    return url;
                }
            }
            xhr.open(request.method, fixUrl(request.url), true);
            if (request.credentials === 'include') xhr.withCredentials = true;
            else if (request.credentials === 'omit') xhr.withCredentials = false;
            if ('responseType' in xhr) {
                if ($ab0dc99bfac00606$var$support.blob) xhr.responseType = 'blob';
                else if ($ab0dc99bfac00606$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
            }
            if (init && typeof init.headers === 'object' && !(init.headers instanceof $ab0dc99bfac00606$export$79b704688b15c0f4 || $ab0dc99bfac00606$var$g.Headers && init.headers instanceof $ab0dc99bfac00606$var$g.Headers)) {
                var names = [];
                Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                    names.push($ab0dc99bfac00606$var$normalizeName(name));
                    xhr.setRequestHeader(name, $ab0dc99bfac00606$var$normalizeValue(init.headers[name]));
                });
                request.headers.forEach(function(value, name) {
                    if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                });
            } else request.headers.forEach(function(value, name) {
                xhr.setRequestHeader(name, value);
            });
            if (request.signal) {
                request.signal.addEventListener('abort', abortXhr);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                };
            }
            xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
        });
    }
    $ab0dc99bfac00606$export$e7aa7bc5c1b3cfb3.polyfill = true;
    if (!$ab0dc99bfac00606$var$g.fetch) {
        $ab0dc99bfac00606$var$g.fetch = $ab0dc99bfac00606$export$e7aa7bc5c1b3cfb3;
        $ab0dc99bfac00606$var$g.Headers = $ab0dc99bfac00606$export$79b704688b15c0f4;
        $ab0dc99bfac00606$var$g.Request = $ab0dc99bfac00606$export$7fa6c5b6f8193917;
        $ab0dc99bfac00606$var$g.Response = $ab0dc99bfac00606$export$9f633d56d7ec90d3;
    }
});
parcelRegister("8AyuG", function(module, exports) {
    $parcel$export(module.exports, "InAppMessageEventType", ()=>$e9bacf0a29b37ed8$export$b31ffc6f7c85f1b);
    var $e9bacf0a29b37ed8$export$b31ffc6f7c85f1b;
    (function(InAppMessageEventType) {
        InAppMessageEventType["Viewed"] = "viewed";
        InAppMessageEventType["Acknowledged"] = "acknowledged";
        InAppMessageEventType["Clicked"] = "clicked";
        InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
        InAppMessageEventType["Dismissed"] = "dismissed";
        InAppMessageEventType["Read"] = "read";
        InAppMessageEventType["Unread"] = "unread";
    })($e9bacf0a29b37ed8$export$b31ffc6f7c85f1b || ($e9bacf0a29b37ed8$export$b31ffc6f7c85f1b = {}));
});
parcelRegister("9SGvH", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerWrapper", ()=>$75c0ce5230ca69b2$export$8db7ba034addcd65);
    var $lHkHI = parcelRequire("lHkHI");
    var $fPtA6 = parcelRequire("fPtA6");
    var $dwiXA = parcelRequire("dwiXA");
    var $eUqFw = parcelRequire("eUqFw");
    var $eqTiY = parcelRequire("eqTiY");
    const $75c0ce5230ca69b2$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
        const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
        const shouldRender = useChoreographedRender({
            messageId: messageId
        });
        if (shouldRender) return (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
            children: children
        });
        return null;
    };
    const $75c0ce5230ca69b2$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
        const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $eqTiY.useChoreographerContext)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dwiXA.useFirePostOfficeAnalyticsEvents)();
        (0, $eUqFw.useEffect)(()=>{
            const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $fPtA6.default).checkGate('enable_tracking_choreographed_post_office_messages');
            if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
                eventType: 'operational',
                action: 'maybeChoreographed',
                actionSubject: 'postOfficeMessage'
            }, {
                messageTemplateId: messageTemplateId,
                messageCategory: messageCategory
            });
        }, [
            fireAnalyticsEvent
        ]);
        const isChoreographedPostOfficeMessagesEnabled = (0, $fPtA6.default).checkGate('enable_choreographed_post_office_messages');
        if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled && factory) {
            const { shouldBeChoreographed: shouldBeChoreographed } = factory;
            const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
            if (shouldBeChoreographed({
                messageType: messageType
            })) return (0, $lHkHI.jsx)($75c0ce5230ca69b2$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: messageId,
                children: children
            });
        }
        return (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
            children: children
        });
    };
});
parcelRegister("1u3An", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c43180f10f032c78$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $c43180f10f032c78$export$2e2bcd8739ae039 = {
        'marketing-screen-space-flag-contentful-usecase': (0, $eUqFw.lazy)(()=>(parcelRequire("8HrpF")))
    };
});
parcelRegister("8HrpF", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("44egG")
    ]).then(()=>parcelRequire('14c3c'));
});
parcelRegister("3NpAn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$101c3efdfd40f09b$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $101c3efdfd40f09b$export$2e2bcd8739ae039 = {
        'message-template-template': (0, $eUqFw.lazy)(()=>(parcelRequire("7DAhf")))
    };
});
parcelRegister("7DAhf", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("aDxx7").then(()=>parcelRequire('i0IUm'));
});
parcelRegister("2OlCV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0787fa7409a96fa$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $e0787fa7409a96fa$export$2e2bcd8739ae039 = {
        'test-message-inapp': (0, $eUqFw.lazy)(()=>(parcelRequire("fF82v"))),
        'test-message-inapp-implicit-pendo': (0, $eUqFw.lazy)(()=>(parcelRequire("fPBNZ")))
    };
});
parcelRegister("fF82v", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("jRRqj").then(()=>parcelRequire('cGA68'));
});
parcelRegister("fPBNZ", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("fpSqe").then(()=>parcelRequire('aK6hY'));
});
const $56bbe7d3a0ddb9e6$export$a5cfae247d8360ef = 'screen-space-flags';
parcelRegister("iA29T", function(module, exports) {
    $parcel$export(module.exports, "withScreenSpaceFlagsIntlProvider", ()=>$25903913c876bc88$export$b0eee5de066b2bf5);
    var $aUZZF = parcelRequire("aUZZF");
    var $8LB88 = parcelRequire("8LB88");
    var $4EIV3 = parcelRequire("4EIV3");
    var $eqmGb = parcelRequire("eqmGb");
    const $25903913c876bc88$var$loadMessagesByTeam = async (locale)=>{
        return Promise.allSettled([
            (0, $8LB88.messagesLoader)(locale),
            (0, $4EIV3.messagesLoader)(locale),
            (0, $eqmGb.messagesLoader)(locale)
        ]).then((results)=>{
            return results.reduce((acc, result)=>{
                if (result.status === 'fulfilled') return {
                    messages: {
                        ...acc.messages,
                        ...result.value
                    },
                    errors: [
                        ...acc.errors
                    ]
                };
                else if (result.status === 'rejected') return {
                    messages: {
                        ...acc.messages
                    },
                    errors: [
                        ...acc.errors,
                        `Failed to load translations with ${result.reason}`
                    ]
                };
                return acc;
            }, {
                messages: {},
                errors: []
            });
        });
    };
    const $25903913c876bc88$export$b0eee5de066b2bf5 = (Component)=>{
        return (0, $aUZZF.withIntlProvider)({
            messagesLoader: $25903913c876bc88$var$loadMessagesByTeam
        }, Component);
    };
});
parcelRegister("aUZZF", function(module, exports) {
    $parcel$export(module.exports, "withIntlProvider", ()=>$6ce3818d758d6768$export$a5d940130f33be3f);
    var $lHkHI = parcelRequire("lHkHI");
    var $6l6sk = parcelRequire("6l6sk");
    const $6ce3818d758d6768$export$a5d940130f33be3f = (intlProviderProps, Component)=>(props)=>(0, $lHkHI.jsx)((0, $6l6sk.default), {
                ...intlProviderProps,
                children: (0, $lHkHI.jsx)(Component, {
                    ...props
                })
            });
});
parcelRegister("6l6sk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99fdaee7a65d9784$export$2e2bcd8739ae039);
    var $lHkHI = parcelRequire("lHkHI");
    var $dwiXA = parcelRequire("dwiXA");
    var $3dpxL = parcelRequire("3dpxL");
    var $5JgJ2 = parcelRequire("5JgJ2");
    var $eH3Io = parcelRequire("eH3Io");
    function $99fdaee7a65d9784$var$useFetchLocale() {
        let locale = 'en';
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dwiXA.useFirePostOfficeAnalyticsEvents)();
        try {
            const { locale: intlLocale } = (0, $5JgJ2.default)();
            locale = intlLocale;
        } catch (err) {
            fireAnalyticsEvent({
                action: 'errored',
                actionSubject: 'intlProvider',
                eventType: 'operational',
                attributes: {
                    errorMessage: err
                }
            });
        }
        return {
            locale: locale
        };
    }
    function $99fdaee7a65d9784$export$2e2bcd8739ae039(props) {
        const { locale: locale } = $99fdaee7a65d9784$var$useFetchLocale();
        const messages = (0, $eH3Io.useIntlMessages)(locale, props.messagesLoader);
        return (0, $lHkHI.jsx)((0, $3dpxL.default), {
            locale: locale,
            messages: messages,
            children: props.children
        });
    }
});
parcelRegister("eH3Io", function(module, exports) {
    $parcel$export(module.exports, "useIntlMessages", ()=>$0d12d209d28b023b$export$2641ec9a2025a81f);
    var $dwiXA = parcelRequire("dwiXA");
    var $eUqFw = parcelRequire("eUqFw");
    const $0d12d209d28b023b$export$2641ec9a2025a81f = (locale, messageLoader)=>{
        const [messages, setMessages] = (0, $eUqFw.useState)();
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dwiXA.useFirePostOfficeAnalyticsEvents)();
        (0, $eUqFw.useEffect)(()=>{
            messageLoader(locale).then((loadedMessages)=>{
                if (loadedMessages && loadedMessages.messages) setMessages(loadedMessages.messages);
                if (loadedMessages?.errors?.length > 0) fireAnalyticsEvent({
                    action: 'errored',
                    actionSubject: 'intlMessagesLoader',
                    eventType: 'operational',
                    attributes: {
                        locale: locale,
                        errorMessage: loadedMessages.errors
                    }
                });
            }).catch(console.error);
        }, [
            locale
        ]);
        return messages;
    };
});
parcelRegister("8LB88", function(module, exports) {
    $parcel$export(module.exports, "messagesLoader", ()=>$078fc28645a479c6$export$720676d8cac8fbb);
    var $fYthl = parcelRequire("fYthl");
    var $35P7p = parcelRequire("35P7p");
    const $078fc28645a479c6$export$720676d8cac8fbb = async (locale)=>{
        const normalizedLocale = (0, $35P7p.default)(locale);
        switch(normalizedLocale){
            case 'cs':
                return (await (parcelRequire("8FtU6"))).default;
            case 'da':
                return (await (parcelRequire("7FGav"))).default;
            case 'de':
                return (await (parcelRequire("hQRJB"))).default;
            case 'en-GB':
                return (await (parcelRequire("eJl1H"))).default;
            case 'en-US':
                return (await (parcelRequire("iOmqC"))).default;
            case 'en-XA':
                return (await (parcelRequire("elMTw"))).default;
            case 'en-XB':
                return (await (parcelRequire("48OJ5"))).default;
            case 'en-ZZ':
                return (await (parcelRequire("1p17D"))).default;
            case 'en':
                return (await Promise.resolve((parcelRequire("fYthl")))).default;
            case 'es':
                return (await (parcelRequire("7jM3N"))).default;
            case 'et':
                return (await (parcelRequire("ftZoT"))).default;
            case 'fi':
                return (await (parcelRequire("hJPP9"))).default;
            case 'fr':
                return (await (parcelRequire("irMOY"))).default;
            case 'hu':
                return (await (parcelRequire("lBq7j"))).default;
            case 'it':
                return (await (parcelRequire("876y4"))).default;
            case 'ja':
                return (await (parcelRequire("gTfFQ"))).default;
            case 'ko':
                return (await (parcelRequire("2ENLW"))).default;
            case 'nb':
                return (await (parcelRequire("fq1rI"))).default;
            case 'nl':
                return (await (parcelRequire("8Dstn"))).default;
            case 'pl':
                return (await (parcelRequire("6K8xW"))).default;
            case 'pt-BR':
                return (await (parcelRequire("jkn8X"))).default;
            case 'ro':
                return (await (parcelRequire("4tUVO"))).default;
            case 'ru':
                return (await (parcelRequire("9YJsy"))).default;
            case 'sv':
                return (await (parcelRequire("8lif9"))).default;
            case 'th':
                return (await (parcelRequire("hwKip"))).default;
            case 'tr':
                return (await (parcelRequire("clv79"))).default;
            case 'uk':
                return (await (parcelRequire("ljNQ0"))).default;
            case 'vi':
                return (await (parcelRequire("3ATV0"))).default;
            case 'zh-CN':
                return (await (parcelRequire("lYftJ"))).default;
            case 'zh-TW':
                return (await (parcelRequire("adFRW"))).default;
            default:
                return 0, ($parcel$interopDefault($fYthl));
        }
    };
});
parcelRegister("fYthl", function(module, exports) {
    module.exports = JSON.parse("{\"post-office.components.in-app.step-context.default-next-button.main\":[{\"type\":0,\"value\":\"Next\"}],\"post-office.components.in-app.step-context.default-previous-button.main\":[{\"type\":0,\"value\":\"Back\"}],\"post-office.components.in-app.step-context.next-button.step-state\":[{\"type\":1,\"value\":\"currentStep\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}]}");
});
parcelRegister("8FtU6", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("8G4hp").then(()=>parcelRequire('kDsat'));
});
parcelRegister("7FGav", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("ah7Iu").then(()=>parcelRequire('7vshZ'));
});
parcelRegister("hQRJB", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("cWMmo").then(()=>parcelRequire('3yzyz'));
});
parcelRegister("eJl1H", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("jUZF5").then(()=>parcelRequire('644XE'));
});
parcelRegister("iOmqC", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("2t9Zr").then(()=>parcelRequire('8Feg7'));
});
parcelRegister("elMTw", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("csxbe").then(()=>parcelRequire('iGP8H'));
});
parcelRegister("48OJ5", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("cgRzW").then(()=>parcelRequire('dpzRP'));
});
parcelRegister("1p17D", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("cCTHF").then(()=>parcelRequire('g7psm'));
});
parcelRegister("7jM3N", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("bp8JG").then(()=>parcelRequire('hsYev'));
});
parcelRegister("ftZoT", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("b8l3d").then(()=>parcelRequire('9ljBS'));
});
parcelRegister("hJPP9", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("9KC5K").then(()=>parcelRequire('kjBns'));
});
parcelRegister("irMOY", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("lX9Vh").then(()=>parcelRequire('eGfjG'));
});
parcelRegister("lBq7j", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("7WtaF").then(()=>parcelRequire('7NCHS'));
});
parcelRegister("876y4", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("b0RM6").then(()=>parcelRequire('c10lN'));
});
parcelRegister("gTfFQ", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("764JL").then(()=>parcelRequire('a7lx0'));
});
parcelRegister("2ENLW", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("2usrk").then(()=>parcelRequire('9CNgN'));
});
parcelRegister("fq1rI", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("9kDyc").then(()=>parcelRequire('9bA6h'));
});
parcelRegister("8Dstn", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("coijR").then(()=>parcelRequire('8ldUE'));
});
parcelRegister("6K8xW", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("2YEDG").then(()=>parcelRequire('lsNXw'));
});
parcelRegister("jkn8X", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("8S7tt").then(()=>parcelRequire('hkeYR'));
});
parcelRegister("4tUVO", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("fELCi").then(()=>parcelRequire('Qt5Fj'));
});
parcelRegister("9YJsy", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("ggvSQ").then(()=>parcelRequire('9vKOv'));
});
parcelRegister("8lif9", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("jlNPf").then(()=>parcelRequire('iiXch'));
});
parcelRegister("hwKip", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("8dbJw").then(()=>parcelRequire('gE5kE'));
});
parcelRegister("clv79", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("7VBvt").then(()=>parcelRequire('ipPwo'));
});
parcelRegister("ljNQ0", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("fbNjo").then(()=>parcelRequire('auUFN'));
});
parcelRegister("3ATV0", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("575pq").then(()=>parcelRequire('83gM2'));
});
parcelRegister("lYftJ", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("c57iS").then(()=>parcelRequire('8OwYp'));
});
parcelRegister("adFRW", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("6oxNH").then(()=>parcelRequire('5fM5D'));
});
parcelRegister("4EIV3", function(module, exports) {
    $parcel$export(module.exports, "messagesLoader", ()=>$fed16125d42cc4cc$export$720676d8cac8fbb);
    var $h8C1z = parcelRequire("h8C1z");
    var $35P7p = parcelRequire("35P7p");
    const $fed16125d42cc4cc$export$720676d8cac8fbb = async (locale)=>{
        const normalizedLocale = (0, $35P7p.default)(locale);
        switch(normalizedLocale){
            case 'cs':
                return (await (parcelRequire("aEAzc"))).default;
            case 'da':
                return (await (parcelRequire("eBGMi"))).default;
            case 'de':
                return (await (parcelRequire("6cm1r"))).default;
            case 'en-GB':
                return (await (parcelRequire("71LMa"))).default;
            case 'en-US':
                return (await (parcelRequire("6ysqM"))).default;
            case 'en-XA':
                return (await (parcelRequire("2jLil"))).default;
            case 'en-XB':
                return (await (parcelRequire("5pghg"))).default;
            case 'en-ZZ':
                return (await (parcelRequire("kBYtM"))).default;
            case 'en':
                return (await Promise.resolve((parcelRequire("h8C1z")))).default;
            case 'es':
                return (await (parcelRequire("eAAqJ"))).default;
            case 'et':
                return (await (parcelRequire("9AvcF"))).default;
            case 'fi':
                return (await (parcelRequire("g5Jbl"))).default;
            case 'fr':
                return (await (parcelRequire("cC6eO"))).default;
            case 'hu':
                return (await (parcelRequire("1GmdU"))).default;
            case 'it':
                return (await (parcelRequire("lLf1p"))).default;
            case 'ja':
                return (await (parcelRequire("1A0Ux"))).default;
            case 'ko':
                return (await (parcelRequire("bOBmh"))).default;
            case 'nb':
                return (await (parcelRequire("dWas2"))).default;
            case 'nl':
                return (await (parcelRequire("eCqAJ"))).default;
            case 'pl':
                return (await (parcelRequire("dw8md"))).default;
            case 'pt-BR':
                return (await (parcelRequire("8lRbR"))).default;
            case 'ro':
                return (await (parcelRequire("c4brx"))).default;
            case 'ru':
                return (await (parcelRequire("6Z6dg"))).default;
            case 'sv':
                return (await (parcelRequire("6jVw2"))).default;
            case 'th':
                return (await (parcelRequire("imzX6"))).default;
            case 'tr':
                return (await (parcelRequire("9lEyQ"))).default;
            case 'uk':
                return (await (parcelRequire("gvdhZ"))).default;
            case 'vi':
                return (await (parcelRequire("jBKJd"))).default;
            case 'zh-CN':
                return (await (parcelRequire("7LcbC"))).default;
            case 'zh-TW':
                return (await (parcelRequire("i07tF"))).default;
            default:
                return 0, ($parcel$interopDefault($h8C1z));
        }
    };
});
parcelRegister("h8C1z", function(module, exports) {
    module.exports = JSON.parse("{\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");
});
parcelRegister("aEAzc", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("ctZYx").then(()=>parcelRequire('kEF08'));
});
parcelRegister("eBGMi", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("l5JKu").then(()=>parcelRequire('hFXpG'));
});
parcelRegister("6cm1r", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("aNHCo").then(()=>parcelRequire('lduQ9'));
});
parcelRegister("71LMa", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("bgxdS").then(()=>parcelRequire('fcser'));
});
parcelRegister("6ysqM", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("7TJLR").then(()=>parcelRequire('5TIVX'));
});
parcelRegister("2jLil", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("1ioUj").then(()=>parcelRequire('91K2G'));
});
parcelRegister("5pghg", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("dnImh").then(()=>parcelRequire('3rplu'));
});
parcelRegister("kBYtM", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("iigZp").then(()=>parcelRequire('jrqrk'));
});
parcelRegister("eAAqJ", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("6FbPb").then(()=>parcelRequire('7k53w'));
});
parcelRegister("9AvcF", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("g6hoz").then(()=>parcelRequire('6CZvP'));
});
parcelRegister("g5Jbl", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("49JGi").then(()=>parcelRequire('j7qX4'));
});
parcelRegister("cC6eO", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("iGB50").then(()=>parcelRequire('1mmNU'));
});
parcelRegister("1GmdU", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("dKKVk").then(()=>parcelRequire('1TbGg'));
});
parcelRegister("lLf1p", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("hBJuW").then(()=>parcelRequire('1iLty'));
});
parcelRegister("1A0Ux", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("iffbI").then(()=>parcelRequire('gwTQB'));
});
parcelRegister("bOBmh", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("jF8ZQ").then(()=>parcelRequire('jTfxZ'));
});
parcelRegister("dWas2", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("f1wLC").then(()=>parcelRequire('45nG7'));
});
parcelRegister("eCqAJ", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("6Fx6J").then(()=>parcelRequire('cCk68'));
});
parcelRegister("dw8md", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("78zW2").then(()=>parcelRequire('5FfKg'));
});
parcelRegister("8lRbR", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("dlusA").then(()=>parcelRequire('bVkuQ'));
});
parcelRegister("c4brx", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("gJCMI").then(()=>parcelRequire('eQ958'));
});
parcelRegister("6Z6dg", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("eQEQb").then(()=>parcelRequire('bWq8k'));
});
parcelRegister("6jVw2", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("dYUfx").then(()=>parcelRequire('80572'));
});
parcelRegister("imzX6", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("egTAi").then(()=>parcelRequire('47xh4'));
});
parcelRegister("9lEyQ", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("fEoeA").then(()=>parcelRequire('iYEal'));
});
parcelRegister("gvdhZ", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("hfd4U").then(()=>parcelRequire('1Jf4z'));
});
parcelRegister("jBKJd", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("ic4fv").then(()=>parcelRequire('lk4IY'));
});
parcelRegister("7LcbC", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("gfBQD").then(()=>parcelRequire('l84yy'));
});
parcelRegister("i07tF", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("8vqxt").then(()=>parcelRequire('jS7IB'));
});
parcelRegister("eqmGb", function(module, exports) {
    $parcel$export(module.exports, "messagesLoader", ()=>$19b790cc45251fa2$export$720676d8cac8fbb);
    var $doEYH = parcelRequire("doEYH");
    var $35P7p = parcelRequire("35P7p");
    const $19b790cc45251fa2$export$720676d8cac8fbb = async (locale)=>{
        const normalizedLocale = (0, $35P7p.default)(locale);
        switch(normalizedLocale){
            case 'cs':
                return (await (parcelRequire("e8tbq"))).default;
            case 'da':
                return (await (parcelRequire("bH0Ov"))).default;
            case 'de':
                return (await (parcelRequire("jymMD"))).default;
            case 'en-GB':
                return (await (parcelRequire("jHAHb"))).default;
            case 'en-US':
                return (await (parcelRequire("lAdls"))).default;
            case 'en-XA':
                return (await (parcelRequire("7ULx6"))).default;
            case 'en-XB':
                return (await (parcelRequire("9RqKD"))).default;
            case 'en-ZZ':
                return (await (parcelRequire("4C2ky"))).default;
            case 'en':
                return (await Promise.resolve((parcelRequire("doEYH")))).default;
            case 'es':
                return (await (parcelRequire("hkOMf"))).default;
            case 'et':
                return (await (parcelRequire("cdqzM"))).default;
            case 'fi':
                return (await (parcelRequire("fwM7X"))).default;
            case 'fr':
                return (await (parcelRequire("fpVVG"))).default;
            case 'hu':
                return (await (parcelRequire("h37Gg"))).default;
            case 'it':
                return (await (parcelRequire("jNdXM"))).default;
            case 'ja':
                return (await (parcelRequire("02gtn"))).default;
            case 'ko':
                return (await (parcelRequire("gayj0"))).default;
            case 'nb':
                return (await (parcelRequire("4zJgI"))).default;
            case 'nl':
                return (await (parcelRequire("8Pbj8"))).default;
            case 'pl':
                return (await (parcelRequire("doajD"))).default;
            case 'pt-BR':
                return (await (parcelRequire("kfX7O"))).default;
            case 'ro':
                return (await (parcelRequire("6Aj7Y"))).default;
            case 'ru':
                return (await (parcelRequire("1dYzF"))).default;
            case 'sv':
                return (await (parcelRequire("gzNCs"))).default;
            case 'th':
                return (await (parcelRequire("60NlJ"))).default;
            case 'tr':
                return (await (parcelRequire("f6CMQ"))).default;
            case 'uk':
                return (await (parcelRequire("2rmmU"))).default;
            case 'vi':
                return (await (parcelRequire("fIQ9j"))).default;
            case 'zh-CN':
                return (await (parcelRequire("i9KPM"))).default;
            case 'zh-TW':
                return (await (parcelRequire("5AlMF"))).default;
            default:
                return 0, ($parcel$interopDefault($doEYH));
        }
    };
});
parcelRegister("doEYH", function(module, exports) {
    module.exports = JSON.parse("{\"admin-hub.ci-test.message-template-template-hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"ci-generation.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"ci-generation.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"ci-generation.email.body.img.alt\":[{\"type\":0,\"value\":\"This is the alt text for the image\"}],\"ci-generation.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"ci-generation.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"ci-generation.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"ci-generation.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.test-message.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\".\"}],\"post-office.test-messages.test-message-mobile-push.greeting.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}],\"post-office.test-slack-notification.sample-hello-message\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"product-store-personal-use-case.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}],\"test-messages.app-switcher-discovery-section.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"test-messages.app-switcher-discovery-section.test-content\":[{\"type\":0,\"value\":\"This is a test message.\"}],\"test-messages.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.in-app-example.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.jira-navigation-topbar-edition-awareness.hello-world\":[{\"type\":0,\"value\":\"Hello \"},{\"type\":1,\"value\":\"propA\"},{\"type\":0,\"value\":\". Is is a lovely \"},{\"type\":1,\"value\":\"propB\"}],\"test-messages.redacted-email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-cdn.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-cdn.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-cdn.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-cdn.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-cdn.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-email-mfc.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-email-mfc.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-grouped-recipients.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hello\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-grouped-recipients.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-marketing.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-marketing.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"test-messages.test-message-marketing.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-marketing.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message-persona-email.message-template-template.email.body.img.alt\":[{\"type\":0,\"value\":\"Description of image\"}],\"test-messages.test-message-persona-email.message-template.email.subject\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"test-messages.test-message-persona-email.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"test-messages.test-message-persona-email.test-message.email.body.regards\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"test-messages.test-message-persona-email.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message-persona-email.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.app.img.alt.large\":[{\"type\":0,\"value\":\"test image 2\"}],\"test-messages.test-message.app.img.alt.plant\":[{\"type\":0,\"value\":\"test image 1\"}],\"test-messages.test-message.email.body\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"test-messages.test-message.redacted-email.body\":[{\"type\":0,\"value\":\"This is the redacted version of the test email message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment. \"},{\"type\":1,\"value\":\"additionalBody\"}],\"test-messages.test-message.redacted-email.body.hello\":[{\"type\":0,\"value\":\"Hi Atlassian,\"}],\"test-messages.test-message.redacted-email.body.img.alt\":[{\"type\":0,\"value\":\"this is the alt for the test-message-email message template\"}],\"test-messages.test-message.redacted-email.body.signoff\":[{\"type\":0,\"value\":\"Regards,\"}],\"test-messages.test-message.redacted-email.unsubscribe.text\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"wac-global-nav-product-recommendation.hello-world\":[{\"type\":0,\"value\":\"Hello. Is is a lovely\"}]}");
});
parcelRegister("e8tbq", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("hvMZ2").then(()=>parcelRequire('2bHIf'));
});
parcelRegister("bH0Ov", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("enKqU").then(()=>parcelRequire('aDdIV'));
});
parcelRegister("jymMD", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("lrzzd").then(()=>parcelRequire('bkpKj'));
});
parcelRegister("jHAHb", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("7nrVz").then(()=>parcelRequire('i5Hbw'));
});
parcelRegister("lAdls", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("jM5NZ").then(()=>parcelRequire('aAzAx'));
});
parcelRegister("7ULx6", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("hfm0E").then(()=>parcelRequire('axaMs'));
});
parcelRegister("9RqKD", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("k3cwc").then(()=>parcelRequire('kTldq'));
});
parcelRegister("4C2ky", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("5LkmZ").then(()=>parcelRequire('cjoVw'));
});
parcelRegister("hkOMf", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("gw6r2").then(()=>parcelRequire('2iVJg'));
});
parcelRegister("cdqzM", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("96Ck4").then(()=>parcelRequire('9R2m1'));
});
parcelRegister("fwM7X", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("hbk1f").then(()=>parcelRequire('8qHC0'));
});
parcelRegister("fpVVG", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("4faqp").then(()=>parcelRequire('13zgQ'));
});
parcelRegister("h37Gg", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("2Qnit").then(()=>parcelRequire('lgnou'));
});
parcelRegister("jNdXM", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("dooKa").then(()=>parcelRequire('1Bwl2'));
});
parcelRegister("02gtn", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("dWPzz").then(()=>parcelRequire('3zwjH'));
});
parcelRegister("gayj0", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("7v2Op").then(()=>parcelRequire('gUOzT'));
});
parcelRegister("4zJgI", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("ekkOT").then(()=>parcelRequire('bdmSF'));
});
parcelRegister("8Pbj8", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("l3j8u").then(()=>parcelRequire('9YaB2'));
});
parcelRegister("doajD", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("hhTYd").then(()=>parcelRequire('7JYtc'));
});
parcelRegister("kfX7O", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("fsGGS").then(()=>parcelRequire('krbd1'));
});
parcelRegister("6Aj7Y", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("aicgo").then(()=>parcelRequire('aDsK8'));
});
parcelRegister("1dYzF", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("44stP").then(()=>parcelRequire('570g7'));
});
parcelRegister("gzNCs", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("9kXYo").then(()=>parcelRequire('arrtg'));
});
parcelRegister("60NlJ", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("kXDok").then(()=>parcelRequire('htnIF'));
});
parcelRegister("f6CMQ", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("e9bEP").then(()=>parcelRequire('f1ogH'));
});
parcelRegister("2rmmU", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("ejsNS").then(()=>parcelRequire('2vBIG'));
});
parcelRegister("fIQ9j", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("esW93").then(()=>parcelRequire('8M2sh'));
});
parcelRegister("i9KPM", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("9KKsm").then(()=>parcelRequire('i2oQJ'));
});
parcelRegister("5AlMF", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("e45fz").then(()=>parcelRequire('hdKiM'));
});
parcelRegister("hRUsD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$94050e169979482a$export$2e2bcd8739ae039);
    var $lHkHI = parcelRequire("lHkHI");
    var $6u0yW = parcelRequire("6u0yW");
    var $9UUeB = parcelRequire("9UUeB");
    var $1UrNB = parcelRequire("1UrNB");
    var $eUqFw = parcelRequire("eUqFw");
    var $7Al6L = parcelRequire("7Al6L");
    const $94050e169979482a$var$STABLE_OBJECT = {};
    const $94050e169979482a$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, Fallback: Fallback = null, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
        const MemoizedPlacement = (0, $eUqFw.useMemo)(()=>(0, $1UrNB.createPlacementComponent)(placementId, PlacementComponent), [
            placementId,
            PlacementComponent
        ]);
        const stableLocalPlacementProps = (0, $6u0yW.useStableObject)(placementProps ?? $94050e169979482a$var$STABLE_OBJECT);
        return (0, $lHkHI.jsx)((0, $9UUeB.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>(0, $lHkHI.jsx)((0, $7Al6L.default), {
                    analyticsChannel: (0, $e8ad09931457cff6$export$85183a312807388d),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: (0, $lHkHI.jsx)((0, $eUqFw.Suspense), {
                        fallback: Fallback,
                        children: (0, $lHkHI.jsx)(MemoizedPlacement, {
                            initialData: initialData,
                            context: context,
                            errorFallback: ErrorFallback,
                            ...stableLocalPlacementProps,
                            children: children
                        })
                    })
                })
        });
    };
    var $94050e169979482a$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($94050e169979482a$var$Placement);
});
parcelRegister("9UUeB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$456426bcbc864830$export$2e2bcd8739ae039);
    var $lHkHI = parcelRequire("lHkHI");
    var $9VkvA = parcelRequire("9VkvA");
    var $fPtA6 = parcelRequire("fPtA6");
    var $j3kUo = parcelRequire("j3kUo");
    var $3ddpf = parcelRequire("3ddpf");
    var $6u0yW = parcelRequire("6u0yW");
    var $6EPi0 = parcelRequire("6EPi0");
    var $empal = parcelRequire("empal");
    var $eUqFw = parcelRequire("eUqFw");
    var $6xLbX = parcelRequire("6xLbX");
    var $jgko8 = parcelRequire("jgko8");
    var $jr6Sm = parcelRequire("jr6Sm");
    const $456426bcbc864830$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
        return (0, $eUqFw.useMemo)(()=>disableInitialData ? undefined : (0, $6xLbX.requestInitialData)(placementId, context, $parcel$global.fetch, {
                baseUrl: baseUrl,
                path: path
            }), [
            disableInitialData,
            baseUrl,
            path,
            placementId,
            context
        ]);
    };
    const $456426bcbc864830$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
        const isUFOEnabled = (0, $fPtA6.default).checkGate('enable_ufo_tracking_in_post_office');
        const postOfficeRoute = (0, $3ddpf.usePostOfficeRoute)();
        const context = (0, $j3kUo.usePostOfficeContext)();
        const { baseUrl: baseUrl, path: path } = (0, $jgko8.useBuildBasePath)();
        const stableContextWithRoute = (0, $6u0yW.useStableObject)({
            ...context,
            postOfficeRoute: postOfficeRoute
        });
        const ufoV1PlacementTracker = (0, $eUqFw.useMemo)(()=>isUFOEnabled ? new (0, $6EPi0.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
            isUFOEnabled,
            placementId,
            consumptionType
        ]);
        const remoteComponentOnEvent = (0, $eUqFw.useCallback)(({ type: type, error: error })=>{
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure(error);
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure(error);
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure(error);
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure(error);
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }, [
            placementOnEvent,
            ufoV1PlacementTracker
        ]);
        const initialData = $456426bcbc864830$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
        const placementAnalyticsContext = (0, $eUqFw.useMemo)(()=>({
                source: (0, $25fb0f806604770e$export$f7109619a5e9e0d6),
                componentName: `Placement`,
                attributes: {
                    placementId: placementId,
                    channel: 'in-app',
                    postOfficeFrontendVersion: $jr6Sm.version
                }
            }), [
            placementId
        ]);
        return (0, $lHkHI.jsx)($456426bcbc864830$var$FeatureFlaggedUfoWrapper, {
            placementId: placementId,
            isEnabled: isUFOEnabled,
            children: (0, $lHkHI.jsx)((0, $9VkvA.PostOfficeAnalyticsContext), {
                data: placementAnalyticsContext,
                children: children({
                    initialData: initialData,
                    context: stableContextWithRoute,
                    onEvent: remoteComponentOnEvent
                })
            })
        });
    };
    var $456426bcbc864830$export$2e2bcd8739ae039 = $456426bcbc864830$var$Placement;
    const $456426bcbc864830$var$FeatureFlaggedUfoWrapper = ({ isEnabled: isEnabled, placementId: placementId, children: children })=>{
        if (isEnabled) return (0, $lHkHI.jsx)((0, $empal.UFOv2).UFOSegment, {
            name: (0, $empal.UFOv2).SegmentNames.PLACEMENT,
            children: (0, $lHkHI.jsx)((0, $empal.UFOv2).UFOSegment, {
                name: `${(0, $empal.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
                children: children
            })
        });
        return (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
            children: children
        });
    };
});
const $25fb0f806604770e$export$85183a312807388d = 'postOffice';
const $25fb0f806604770e$export$f7109619a5e9e0d6 = 'post-office-frontend';
parcelRegister("6xLbX", function(module, exports) {
    $parcel$export(module.exports, "requestInitialData", ()=>$78a14ebab5178d87$export$c4c39037cc4b06ab);
    const $78a14ebab5178d87$var$defaultFetcher = (url)=>fetch(url, {
            headers: {
                credentials: 'include',
                mode: 'cors',
                'Content-Type': 'application/json'
            }
        });
    const $78a14ebab5178d87$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $78a14ebab5178d87$var$defaultFetcher, options)=>{
        const baseUrl = options.baseUrl;
        const path = options.path;
        const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
        function stringifyObjectValues(input) {
            const entries = Object.entries(input);
            const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                    key,
                    String(value)
                ]);
            return Object.fromEntries(stringifiedEntries);
        }
        const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context)).toString();
        const url = encodeURI(`${requestUrl}${placementId}?${contextAsSearchParams}`);
        return fetcher(url);
    };
});
parcelRegister("jgko8", function(module, exports) {
    $parcel$export(module.exports, "useBuildBasePath", ()=>$04376ccad76d39e1$export$83d6c58b7ab7ae67);
    var $ajsDn = parcelRequire("ajsDn");
    var $1nkI5 = parcelRequire("1nkI5");
    var $eUqFw = parcelRequire("eUqFw");
    const $04376ccad76d39e1$export$83d6c58b7ab7ae67 = ()=>{
        const { currentEnv: currentEnv, envConfigs: envConfigs } = (0, $1nkI5.usePostOfficeEnvironment)();
        return (0, $eUqFw.useMemo)(()=>{
            const baseUrl = envConfigs[currentEnv].api.origin;
            const path = envConfigs[currentEnv].api.pathname ?? (0, $ajsDn.API_PATHNAME_STG_PROD);
            return {
                baseUrl: baseUrl,
                path: path
            };
        }, [
            currentEnv,
            envConfigs
        ]);
    };
});
parcelRegister("ajsDn", function(module, exports) {
    $parcel$export(module.exports, "API_PATHNAME_STG_PROD", ()=>$08b46e00ecad8659$export$d4fe3482c88e73a8);
    var $j3kUo = parcelRequire("j3kUo");
    var $1nkI5 = parcelRequire("1nkI5");
    var $6u0yW = parcelRequire("6u0yW");
    var $5PkPo = parcelRequire("5PkPo");
    var $f2j1u = parcelRequire("f2j1u");
    var $ir3nM = parcelRequire("ir3nM");
    var $fAMhH = parcelRequire("fAMhH");
    var $3ddpf = parcelRequire("3ddpf");
    var $4YrL8 = parcelRequire("4YrL8");
    const { REMOTE_MODULE_URI_LOCAL: $08b46e00ecad8659$export$67be2569ef5d7666, REMOTE_MODULE_URI_PROD: $08b46e00ecad8659$export$bbd96cd490b0df63, REMOTE_MODULE_URI_STG: $08b46e00ecad8659$export$b49738b89db261cd, API_ORIGIN_LOCAL: $08b46e00ecad8659$export$1e9fed4c0197724c, API_PATHNAME_LOCAL: $08b46e00ecad8659$export$919a9569bce66f17, API_PATHNAME_STG_PROD: $08b46e00ecad8659$export$d4fe3482c88e73a8 } = $fea0859bee7d3c4f$exports;
});
parcelRegister("jr6Sm", function(module, exports) {
    module.exports = JSON.parse("{\"name\":\"@atlassian/post-office-placement-shared\",\"version\":\"0.3.0\",\"packageManager\":\"yarn@4.2.2\",\"sideEffects\":false,\"source\":\"./src/index.ts\",\"main\":\"./dist/cjs/index.js\",\"module\":\"./dist/esm/index.js\",\"types\":\"./dist/types/index.d.ts\",\"exports\":{\".\":\"./src/index.ts\"},\"publishConfig\":{\"exports\":{\"import\":\"./dist/esm/index.js\",\"require\":\"./dist/cjs/index.js\",\"types\":\"./dist/types/index.d.ts\"}},\"repository\":{\"type\":\"git\",\"url\":\"git+https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/post-office.git\",\"directory\":\"packages/post-office-clients/post-office-placement-shared\"},\"files\":[\"README.md\",\"dist\"],\"scripts\":{\"prepack\":\"atlas packages permission grant && yarn exec parcel build\",\"publish:patch\":\"yarn version patch && yarn npm publish\",\"publish:minor\":\"yarn version minor && yarn npm publish\"},\"peerDependencies\":{\"react\":\"^16.8.0 || ^17.0.0 || ^18.2.0\",\"react-dom\":\"^16.8.0 || ^17.0.0 || ^18.2.0\"},\"dependencies\":{\"@atlaskit/analytics-namespaced-context\":\"workspace:^\",\"@atlaskit/feature-gate-js-client\":\"workspace:^\",\"@atlassian/post-office-context\":\"workspace:^\",\"@atlassian/post-office-frontend-performance-tracking\":\"workspace:^\",\"@compiled/react\":\"^0.17.3\"},\"devDependencies\":{\"@testing-library/jest-dom\":\"^6.4.2\",\"@testing-library/react\":\"14.2.1\",\"@testing-library/react-hooks\":\"^8.0.1\",\"@types/node\":\"^20.11.27\",\"@types/react\":\"^18.2.33\",\"@types/react-dom\":\"^18.2.14\",\"eslint\":\"^8.57.0\",\"jest\":\"^29.7.0\",\"jest-environment-jsdom\":\"^29.7.0\",\"npm-run-all2\":\"^5.0.0\",\"parcel\":\"^2.6.0\",\"react\":\"^18.2.0\",\"typescript\":\"~5.4.2\"},\"targets\":{\"main\":{\"optimize\":true},\"module\":{\"optimize\":true}}}");
});
parcelRegister("7Al6L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6265227b0e5ba009$export$2e2bcd8739ae039);
    var $lHkHI = parcelRequire("lHkHI");
    var $iQC4h = parcelRequire("iQC4h");
    var $eUqFw = parcelRequire("eUqFw");
    class $6265227b0e5ba009$var$ErrorBoundary extends (0, ($parcel$interopDefault($eUqFw))).Component {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        componentDidCatch(error, errorInfo) {
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: 'handled',
                actionSubject: 'error',
                actionSubjectId: 'postOfficePlacementErrorBoundary',
                attributes: {
                    error: error?.message,
                    errorInfo: errorInfo,
                    placementId: this.props.placementId
                }
            });
            analyticsEvent.fire(this.props.analyticsChannel);
            this.props.onError({
                error: error,
                type: 'render-error'
            });
            this.setState({
                hasError: true
            });
        }
        render() {
            if (this.state.hasError) return this.props.fallback ? (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
                children: this.props.fallback
            }) : null;
            return this.props.children;
        }
    }
    var $6265227b0e5ba009$export$2e2bcd8739ae039 = (0, $iQC4h.default)()($6265227b0e5ba009$var$ErrorBoundary);
});
const $e8ad09931457cff6$export$85183a312807388d = 'postOffice';
const $bfe8fff5e78bf213$export$37d4bb5bc0e315db = 'killswitch_post_office_in_jira';
parcelRegister("hzkQm", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$ab1cafd93f3f60c8$export$e926676385687eaf);
    var $eUqFw = parcelRequire("eUqFw");
    var $0cdA8 = parcelRequire("0cdA8");
    var $5GxEP = parcelRequire("5GxEP");
    const $ab1cafd93f3f60c8$export$e926676385687eaf = ({ children: children, id: id, withExperienceTracker: withExperienceTracker })=>{
        if (false) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
            id: id
        }, children);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: id,
            packageName: "jiraEntry",
            fallback: "page",
            withExperienceTracker: withExperienceTracker
        }, children);
    };
});
parcelRegister("emTse", function(module, exports) {
    $parcel$export(module.exports, "IntlProviders", ()=>$16e82b5829d91fbb$export$c9d8cd4516cc55a8);
    var $eUqFw = parcelRequire("eUqFw");
    var $ao0hp = parcelRequire("ao0hp");
    var $7LFzI = parcelRequire("7LFzI");
    const $16e82b5829d91fbb$export$c9d8cd4516cc55a8 = ({ children: children, locale: locale, messages: messages })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $7LFzI.IntlProvider), {
            messages: messages,
            locale: (0, $ao0hp.standardizeLocale)(locale)
        }, children);
});
parcelRegister("7LFzI", function(module, exports) {
    $parcel$export(module.exports, "IntlProvider", ()=>$deabbabd1db0af3b$export$480518999dfc4151);
    var $eUqFw = parcelRequire("eUqFw");
    var $3dpxL = parcelRequire("3dpxL");
    const $deabbabd1db0af3b$export$480518999dfc4151 = ({ children: children, ...props })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
            ...props,
            defaultLocale: props.locale
        }, children);
});
parcelRegister("zyR9K", function(module, exports) {
    $parcel$export(module.exports, "MetricsContainers", ()=>$d84d4b40df0a6094$export$2d1617bc0040e5d9);
    var $eUqFw = parcelRequire("eUqFw");
    var $0cdA8 = parcelRequire("0cdA8");
    var $eX2O4 = parcelRequire("eX2O4");
    var $gXEQH = parcelRequire("gXEQH");
    var $8WuJm = parcelRequire("8WuJm");
    var $1RPrZ = parcelRequire("1RPrZ");
    const $d84d4b40df0a6094$export$2d1617bc0040e5d9 = ({ children: children })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            attributes: (0, $gXEQH.routeAnalyticsAttributes)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eX2O4.ExperienceTrackerProvider), null, !false && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            fallback: "unmount",
            id: "metrics-containers-subproduct-updater",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1RPrZ.SubProductUpdater), null)), children));
});
parcelRegister("eX2O4", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTrackerProvider", ()=>$ac9adb88a32f4483$export$6f49c95a810d59fa);
    var $eUqFw = parcelRequire("eUqFw");
    var $9nqoF = parcelRequire("9nqoF");
    var $b57En = parcelRequire("b57En");
    var $Xah93 = parcelRequire("Xah93");
    const $ac9adb88a32f4483$var$useUnmount = (callback)=>(0, $eUqFw.useEffect)(()=>callback, [
            callback
        ]);
    const $ac9adb88a32f4483$export$6f49c95a810d59fa = ({ children: children })=>{
        const [experienceTracker] = (0, $eUqFw.useState)(new (0, $9nqoF.ExperienceTracker)());
        const [cleanupSliSub] = (0, $eUqFw.useState)(()=>experienceTracker.subscribe((0, $Xah93.sliSubscriber)));
        const cleanup = (0, $eUqFw.useCallback)(()=>{
            cleanupSliSub();
        }, [
            cleanupSliSub
        ]);
        $ac9adb88a32f4483$var$useUnmount(cleanup);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $b57En.ExperienceTrackerContext).Provider, {
            value: experienceTracker
        }, children);
    };
});
parcelRegister("Xah93", function(module, exports) {
    $parcel$export(module.exports, "sliSubscriber", ()=>$29a12df906341fa5$export$db0b99fe17114899);
    var $3FyZ4 = parcelRequire("3FyZ4");
    var $eIp1n = parcelRequire("eIp1n");
    var $6WXNs = parcelRequire("6WXNs");
    const $29a12df906341fa5$var$transformApplication = (application)=>{
        switch(application){
            case 0, $eIp1n.JIRA_SOFTWARE:
                return 'jira-software';
            case 0, $eIp1n.JIRA_PRODUCT_DISCOVERY:
                return 'jira-product-discovery';
            case 0, $eIp1n.JIRA_CORE:
                return 'jira-core';
            case 0, $eIp1n.JIRA_SERVICE_DESK:
                return 'jira-servicedesk';
            case 0, $eIp1n.JIRA_PORTFOLIO:
                return 'jira-portfolio';
            default:
                return 'unknown';
        }
    };
    const $29a12df906341fa5$var$transformEdition = (edition)=>{
        switch(edition){
            case 0, $6WXNs.FREE_EDITION:
                return 'jedi';
            case 0, $6WXNs.STANDARD_EDITION:
                return 'standard';
            case 0, $6WXNs.PREMIUM_EDITION:
                return 'premium';
            case 0, $6WXNs.UNLICENSED:
                return 'unlicensed';
            default:
                return 'unknown';
        }
    };
    const $29a12df906341fa5$var$createAnalyticsEvent = ({ experience: experience, action: action, location: location, analyticsSource: analyticsSource, application: application, edition: edition, errorMessage: errorMessage, additionalAttributes: additionalAttributes })=>({
            source: 'ui',
            action: action,
            actionSubject: 'ui',
            attributes: {
                ...additionalAttributes,
                task: experience,
                reason: location,
                analyticsSource: analyticsSource,
                application: $29a12df906341fa5$var$transformApplication(application),
                edition: $29a12df906341fa5$var$transformEdition(edition),
                ...errorMessage && {
                    errorMessage: errorMessage
                }
            }
        });
    const $29a12df906341fa5$var$reportSli = (experienceDescription)=>{
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            const event = $29a12df906341fa5$var$createAnalyticsEvent(experienceDescription);
            const clientInstance = client.getInstance();
            clientInstance.sendOperationalEvent(event);
        });
    };
    const $29a12df906341fa5$export$db0b99fe17114899 = (event)=>{
        const { name: name, action: action } = event;
        const { disableSli: disableSli, analyticsSource: analyticsSource, application: application, edition: edition, location: location, ...additionalAttributes } = event.attributes || {};
        if (disableSli) return;
        switch(action){
            case 0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a:
                $29a12df906341fa5$var$reportSli({
                    experience: name,
                    action: (0, $99e7a4e4cbcb5db0$export$627ef4c1ed2d7a9a),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    additionalAttributes: additionalAttributes
                });
                break;
            case 0, $99e7a4e4cbcb5db0$export$b48b3d1872522384:
                $29a12df906341fa5$var$reportSli({
                    experience: name,
                    action: (0, $99e7a4e4cbcb5db0$export$b48b3d1872522384),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    location: location,
                    ...event.error && {
                        errorMessage: String(event.error)
                    },
                    additionalAttributes: additionalAttributes
                });
                break;
            case 0, $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8:
                $29a12df906341fa5$var$reportSli({
                    experience: name,
                    action: (0, $99e7a4e4cbcb5db0$export$aeeb00d0845d24d8),
                    analyticsSource: analyticsSource,
                    application: application,
                    edition: edition,
                    location: location,
                    additionalAttributes: additionalAttributes
                });
                break;
            default:
        }
    };
});
parcelRegister("1RPrZ", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$570251e3e96e8c6c$export$eb40d3df56aa5c53);
    var $eUqFw = parcelRequire("eUqFw");
    var $keguF = parcelRequire("keguF");
    var $dWlsy = parcelRequire("dWlsy");
    const $570251e3e96e8c6c$export$eb40d3df56aa5c53 = ()=>{
        const subProduct = (0, $dWlsy.useSubProduct)();
        (0, $eUqFw.useEffect)(()=>{
            (0, $keguF.setSubProduct)(subProduct);
        }, [
            subProduct
        ]);
        return null;
    };
});
parcelRegister("dWlsy", function(module, exports) {
    $parcel$export(module.exports, "subProductFromProjectType", ()=>$04e11956b03ab7c2$export$246e1e2a5c86a633);
    $parcel$export(module.exports, "useSubProduct", ()=>$04e11956b03ab7c2$export$16aa2ad52cd8992a);
    var $SEaoU = parcelRequire("SEaoU");
    const $04e11956b03ab7c2$export$246e1e2a5c86a633 = (projectType)=>{
        switch(projectType){
            case 'business':
                return 'core';
            case 'product_discovery':
            case 'software':
                return 'software';
            case 'service_desk':
                return 'serviceDesk';
            default:
                projectType;
                return 'unknown';
        }
    };
    const $04e11956b03ab7c2$export$16aa2ad52cd8992a = ()=>{
        const [{ data: data }] = (0, $SEaoU.useContainerContext)();
        if (!data?.project) return null;
        return $04e11956b03ab7c2$export$246e1e2a5c86a633(data.project.type);
    };
});
parcelRegister("6mtpk", function(module, exports) {
    $parcel$export(module.exports, "NavigationContainers", ()=>$8e55b2de8860aa3e$export$36f9ed697cae18ae);
    var $eUqFw = parcelRequire("eUqFw");
    var $asu8X = parcelRequire("asu8X");
    var $aZ9Tb = parcelRequire("aZ9Tb");
    let $8e55b2de8860aa3e$var$Containers = ({ children: children })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children);
    if (!false) $8e55b2de8860aa3e$var$Containers = (0, $aZ9Tb.ClientOnlyNavigationContainers);
    const $8e55b2de8860aa3e$export$36f9ed697cae18ae = ({ baseUrl: baseUrl, children: children })=>{
        (0, $asu8X.di)($8e55b2de8860aa3e$var$Containers);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($8e55b2de8860aa3e$var$Containers, {
            baseUrl: baseUrl
        }, children);
    };
});
parcelRegister("aZ9Tb", function(module, exports) {
    $parcel$export(module.exports, "ClientOnlyNavigationContainers", ()=>$6d5f905fa11e966d$export$68d7c1e44acfd599);
    var $eUqFw = parcelRequire("eUqFw");
    var $6oi2X = parcelRequire("6oi2X");
    const $6d5f905fa11e966d$export$68d7c1e44acfd599 = ({ children: children })=>{
        if (!false) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6oi2X.Provider), null, children);
        return null;
    };
});
parcelRegister("agGRi", function(module, exports) {
    $parcel$export(module.exports, "PageConfigContainers", ()=>$56522c3977944126$export$9c661932489b4130);
    var $eUqFw = parcelRequire("eUqFw");
    var $7fSR6 = parcelRequire("7fSR6");
    var $6rW04 = parcelRequire("6rW04");
    var $1TtYL = parcelRequire("1TtYL");
    var $3fq1f = parcelRequire("3fq1f");
    const $56522c3977944126$export$9c661932489b4130 = ({ children: children })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $7fSR6.ThemeContainer), {
            isGlobal: true,
            getMeta: (0, $6rW04.default)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleContainer), {
            titleSuffix: (0, $3fq1f.ripTitleTemplateFromMeta)((0, $6rW04.default))
        }, children));
});
parcelRegister("7fSR6", function(module, exports) {
    $parcel$export(module.exports, "useTheme", ()=>$d3617e68561cf32c$export$93d4e7f90805808f);
    $parcel$export(module.exports, "ThemeContainer", ()=>$d3617e68561cf32c$export$11eb671888ed6e7d);
    var $WBLbN = parcelRequire("WBLbN");
    var $g1FfP = parcelRequire("g1FfP");
    const $d3617e68561cf32c$var$initialState = {
        navigationTheme: {
            shouldShowTitle: false,
            logoUrl: '',
            usesCustomColours: false,
            backgroundColor: '',
            highlightColor: ''
        }
    };
    const $d3617e68561cf32c$var$Store = (0, $WBLbN.createStore)({
        name: 'theme',
        initialState: $d3617e68561cf32c$var$initialState,
        actions: $g1FfP
    });
    const $d3617e68561cf32c$export$74e6aa5aeff5e82e = (0, $WBLbN.createSubscriber)($d3617e68561cf32c$var$Store);
    const $d3617e68561cf32c$export$93d4e7f90805808f = (0, $WBLbN.createHook)($d3617e68561cf32c$var$Store);
    const $d3617e68561cf32c$export$11eb671888ed6e7d = (0, $WBLbN.createContainer)($d3617e68561cf32c$var$Store, {
        onInit: $g1FfP.bootstrap
    });
});
parcelRegister("g1FfP", function(module, exports) {
    $parcel$export(module.exports, "bootstrap", ()=>$74d45e3f7106acfe$export$36aff1fbb4f5dfc6);
    $parcel$export(module.exports, "update", ()=>$74d45e3f7106acfe$export$722fbec263ad908a);
    const $74d45e3f7106acfe$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState }, { getMeta: getMeta })=>{
            const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
            const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
            const hasNavv3CustomColors = ajsBackgroundColor != null && ajsHighlightColor != null && (ajsBackgroundColor !== (0, $207acf722dcd432b$exports).N0 || ajsHighlightColor !== (0, $207acf722dcd432b$exports).B400);
            const navigationTheme = {
                shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
                logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
                usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
                backgroundColor: ajsBackgroundColor || `var(--ds-background-inverse-subtle, ${(0, $207acf722dcd432b$exports).N0})`,
                highlightColor: ajsHighlightColor || `var(--ds-text-brand, ${(0, $207acf722dcd432b$exports).B400})`
            };
            if (hasNavv3CustomColors) navigationTheme.usesCustomColours = true;
            setState({
                navigationTheme: navigationTheme
            });
        };
    const $74d45e3f7106acfe$export$722fbec263ad908a = (item)=>({ setState: setState, getState: getState })=>{
            const navigationTheme = {
                ...getState().navigationTheme,
                ...item
            };
            setState({
                navigationTheme: navigationTheme
            });
        };
});
parcelRegister("1TtYL", function(module, exports) {
    $parcel$export(module.exports, "useDocumentTitleActions", ()=>$d28b8ffe196ad843$export$57c0fda036e12d67);
    $parcel$export(module.exports, "DocumentTitleContainer", ()=>$d28b8ffe196ad843$export$1aad43993172f16f);
    $parcel$export(module.exports, "DocumentTitleSubscriber", ()=>$d28b8ffe196ad843$export$b88d5abf3e0bec8c);
    $parcel$export(module.exports, "DocumentTitleHelper", ()=>$d28b8ffe196ad843$export$573bf8d2ae7d60dc);
    var $eUqFw = parcelRequire("eUqFw");
    var $WBLbN = parcelRequire("WBLbN");
    var $98Lej = parcelRequire("98Lej");
    var $3fq1f = parcelRequire("3fq1f");
    const $d28b8ffe196ad843$var$initialState = {
        title: '',
        defaultTitle: '',
        contextArray: []
    };
    const $d28b8ffe196ad843$var$Store = (0, $WBLbN.createStore)({
        name: 'document-title',
        initialState: $d28b8ffe196ad843$var$initialState,
        actions: $98Lej
    });
    const $d28b8ffe196ad843$export$57c0fda036e12d67 = (0, $WBLbN.createActionsHook)($d28b8ffe196ad843$var$Store);
    const $d28b8ffe196ad843$export$1aad43993172f16f = (0, $WBLbN.createContainer)($d28b8ffe196ad843$var$Store, {
        displayName: 'DocumentTitleContainer'
    });
    const $d28b8ffe196ad843$export$b88d5abf3e0bec8c = (0, $WBLbN.createSubscriber)($d28b8ffe196ad843$var$Store, {
        displayName: 'DocumentTitleSubscriber'
    });
    class $d28b8ffe196ad843$export$573bf8d2ae7d60dc extends (0, $eUqFw.Component) {
        constructor(props){
            super(props);
            this.myself = Symbol('document title identifier');
            this.props.addDocumentTitle(this.myself);
        }
        componentDidMount() {
            this.updateTitle();
        }
        componentDidUpdate() {
            this.updateTitle();
        }
        componentWillUnmount() {
            this.props.removeDocumentTitle(this.myself);
            this.updateTitle();
        }
        updateTitle() {
            if ((0, $3fq1f.checkDocumentTitle)(this.myself, this.props.contextArray)) this.props.setTitle(this.props.title);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("98Lej", function(module, exports) {
    $parcel$export(module.exports, "setTitle", ()=>(parcelRequire("hzX2Z")).default);
    $parcel$export(module.exports, "addDocumentTitle", ()=>(parcelRequire("aIEib")).addDocumentTitle);
    $parcel$export(module.exports, "removeDocumentTitle", ()=>(parcelRequire("h3oaR")).removeDocumentTitle);
    var $hzX2Z = parcelRequire("hzX2Z");
    var $aIEib = parcelRequire("aIEib");
    var $h3oaR = parcelRequire("h3oaR");
});
parcelRegister("hzX2Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$badd7a809fe968ef$export$2e2bcd8739ae039);
    var $3fq1f = parcelRequire("3fq1f");
    var $badd7a809fe968ef$export$2e2bcd8739ae039 = (title)=>({ setState: setState, getState: getState }, { titleSuffix: titleSuffix })=>{
            const state = getState();
            const titleTemplate = titleSuffix ? `%s - ${titleSuffix}` : '%s - Jira';
            const newTitle = (0, $3fq1f.createTitleFromTemplate)(title, titleTemplate);
            document.title = newTitle;
            setState({
                ...state,
                title: newTitle
            });
        };
});
parcelRegister("3fq1f", function(module, exports) {
    $parcel$export(module.exports, "createTitleFromTemplate", ()=>$5992d599a50ec92a$export$3795256dd54a9c9d);
    $parcel$export(module.exports, "ripTitleTemplateFromMeta", ()=>$5992d599a50ec92a$export$b7d18105f80195c);
    $parcel$export(module.exports, "checkDocumentTitle", ()=>$5992d599a50ec92a$export$7f8be70a0bed1bae);
    const $5992d599a50ec92a$export$3795256dd54a9c9d = (title, template)=>template.replace(/%s/, title);
    const $5992d599a50ec92a$export$b7d18105f80195c = (getMeta)=>getMeta('ajs-app-title');
    const $5992d599a50ec92a$export$7f8be70a0bed1bae = (title, contextArray)=>{
        if (contextArray[contextArray.length - 1] === title) return true;
        return false;
    };
});
parcelRegister("aIEib", function(module, exports) {
    $parcel$export(module.exports, "addDocumentTitle", ()=>$65d14c1ffc455bbb$export$a0c188c0ea474bb8);
    const $65d14c1ffc455bbb$export$a0c188c0ea474bb8 = (title)=>({ setState: setState, getState: getState })=>{
            const { contextArray: contextArray } = getState();
            contextArray.push(title);
            setState({
                contextArray: contextArray
            });
        };
});
parcelRegister("h3oaR", function(module, exports) {
    $parcel$export(module.exports, "removeDocumentTitle", ()=>$06c2c915252a36d1$export$e844009b77f80a72);
    const $06c2c915252a36d1$export$e844009b77f80a72 = (title)=>({ setState: setState, getState: getState })=>{
            const { contextArray: contextArray } = getState();
            setState({
                contextArray: contextArray.filter((symbol)=>symbol !== title)
            });
        };
});
parcelRegister("hK0Sb", function(module, exports) {
    $parcel$export(module.exports, "UiManagers", ()=>$9e6e4a1178661ec4$export$41286c339a88ca24);
    var $eUqFw = parcelRequire("eUqFw");
    var $asu8X = parcelRequire("asu8X");
    var $7ehAr = parcelRequire("7ehAr");
    var $e20LE = parcelRequire("e20LE");
    var $8e3ho = parcelRequire("8e3ho");
    let $9e6e4a1178661ec4$var$ClientUiManagers = (0, $eUqFw.Fragment);
    if (!false) $9e6e4a1178661ec4$var$ClientUiManagers = (0, $8e3ho.ClientUiManagers);
    const $9e6e4a1178661ec4$export$41286c339a88ca24 = ({ children: children })=>{
        (0, $asu8X.di)($9e6e4a1178661ec4$var$ClientUiManagers);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $e20LE.LayoutManager), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7ehAr.BreadcrumbManager), null, (0, ($parcel$interopDefault($eUqFw))).createElement($9e6e4a1178661ec4$var$ClientUiManagers, null, children)));
    };
});
parcelRegister("7ehAr", function(module, exports) {
    $parcel$export(module.exports, "BreadcrumbManager", ()=>$fb73611fabb3f59f$export$cd5073909dd92c28);
    var $eUqFw = parcelRequire("eUqFw");
    var $bfY8R = parcelRequire("bfY8R");
    const $fb73611fabb3f59f$export$cd5073909dd92c28 = ({ children: children })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $bfY8R.BreadcrumbContainer), null, children);
});
parcelRegister("e20LE", function(module, exports) {
    $parcel$export(module.exports, "LayoutManager", ()=>$631e215ae14481e0$export$4a04ad01c410b415);
    var $eUqFw = parcelRequire("eUqFw");
    var $1NIhY = parcelRequire("1NIhY");
    var $lB25E = parcelRequire("lB25E");
    var $WBLbN = parcelRequire("WBLbN");
    var $3roBA = parcelRequire("3roBA");
    var $53ucm = parcelRequire("53ucm");
    const $631e215ae14481e0$var$LayoutContainer = (0, $WBLbN.createContainer)((0, $53ucm.layoutStore), {
        displayName: 'JiraLayoutContainer',
        onInit: ()=>({ dispatch: dispatch }, { leftSidebar: leftSidebar, rightSidebar: rightSidebar, isChromeless: isChromeless })=>{
                dispatch((0, $3roBA.actions).setIsChromeless(isChromeless));
                dispatch((0, $3roBA.actions).setLeftSidebarState(leftSidebar));
                dispatch((0, $3roBA.actions).setRightSidebarState(rightSidebar));
            },
        onUpdate: ()=>({ dispatch: dispatch }, { isChromeless: isChromeless })=>{
                dispatch((0, $3roBA.actions).setIsChromeless(isChromeless));
            }
    });
    const $631e215ae14481e0$var$DEFFAULT_RIGHT_SIDEBAR_STATE = {
        stackState: []
    };
    const $631e215ae14481e0$var$useIsChromeless = (0, $lB25E.createRouterSelector)((state)=>state.route.layout?.isChromeless === true || state.route.entryPoint?.()?.toString() === 'ChromelessEntryPoint');
    const $631e215ae14481e0$export$4a04ad01c410b415 = ({ children: children })=>{
        const { data: data } = (0, $lB25E.useResource)((0, $1NIhY.navigationUiStateResource));
        const isChromeless = $631e215ae14481e0$var$useIsChromeless();
        const isLeftSidebarCollapsed = data?.leftSidebar?.isCollapsed ?? false;
        const leftSidebarWidth = data?.leftSidebar?.width ?? (0, $53ucm.DEFAULT_LEFT_SIDEBAR_WIDTH);
        const leftSidebar = (0, $eUqFw.useMemo)(()=>({
                isVisible: true,
                isCollapsed: isLeftSidebarCollapsed,
                width: leftSidebarWidth,
                isFlyoutOpen: false
            }), [
            isLeftSidebarCollapsed,
            leftSidebarWidth
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($631e215ae14481e0$var$LayoutContainer, {
            isGlobal: true,
            isChromeless: isChromeless,
            leftSidebar: leftSidebar,
            rightSidebar: $631e215ae14481e0$var$DEFFAULT_RIGHT_SIDEBAR_STATE
        }, children);
    };
});
parcelRegister("8e3ho", function(module, exports) {
    $parcel$export(module.exports, "ClientUiManagers", ()=>$3490141dc4535941$export$d1db6ae5bf84e489);
    var $eUqFw = parcelRequire("eUqFw");
    var $75FXO = parcelRequire("75FXO");
    var $plbOU = parcelRequire("plbOU");
    var $dQZ5c = parcelRequire("dQZ5c");
    var $k8Qyf = parcelRequire("k8Qyf");
    var $jvfW6 = parcelRequire("jvfW6");
    var $cH5Wq = parcelRequire("cH5Wq");
    var $lbttE = parcelRequire("lbttE");
    const $3490141dc4535941$export$d1db6ae5bf84e489 = ({ children: children })=>{
        const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $plbOU.CrossFlowProvider), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cH5Wq.PostOfficeProvider), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lbttE.ProjectCreateDrawerProvider), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $dQZ5c.FavoriteChangeProvider), {
            onShowFlag: showFlag
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $75FXO.default), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jvfW6.ModalContextProvider), null, children))))));
    };
});
parcelRegister("plbOU", function(module, exports) {
    $parcel$export(module.exports, "CrossFlowProvider", ()=>$cd07cb8d277928e5$export$d900e4062895cd7c);
    var $eUqFw = parcelRequire("eUqFw");
    var $qj1ki = parcelRequire("qj1ki");
    var $3FyZ4 = parcelRequire("3FyZ4");
    var $gd0Sp = parcelRequire("gd0Sp");
    var $4Vji8 = parcelRequire("4Vji8");
    var $iPzab = parcelRequire("iPzab");
    const $cd07cb8d277928e5$var$getAnalyticsInstance = ()=>false ? Promise.resolve({
            sendUIEvent: ()=>{},
            sendOperationalEvent: ()=>{},
            sendTrackEvent: ()=>{},
            sendScreenEvent: ()=>{}
        }) : (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
    const $cd07cb8d277928e5$export$d900e4062895cd7c = ({ children: children })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: { cloudId: cloudId, locale: locale } })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $qj1ki.default), {
                cloudId: cloudId,
                analyticsClient: $cd07cb8d277928e5$var$getAnalyticsInstance(),
                locale: locale,
                plugins: [
                    (0, $4Vji8.getContainersPlugin),
                    (0, $iPzab.getUsersPlugin)
                ]
            }, children));
});
parcelRegister("qj1ki", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f435f972d8260f2$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $epnG6 = parcelRequire("epnG6");
    var $bcR4J = parcelRequire("bcR4J");
    const $2f435f972d8260f2$var$JiraProvider = (props)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $epnG6.CrossFlowProvider), {
            ...props,
            originProduct: "jira"
        });
    };
    var $2f435f972d8260f2$export$2e2bcd8739ae039 = $2f435f972d8260f2$var$JiraProvider;
});
parcelRegister("epnG6", function(module, exports) {
    $parcel$export(module.exports, "CrossFlowProvider", ()=>$667560f64c0844f5$export$d900e4062895cd7c);
    var $eUqFw = parcelRequire("eUqFw");
    var $gMnrE = parcelRequire("gMnrE");
    var $exMfg = parcelRequire("exMfg");
    var $fPtA6 = parcelRequire("fPtA6");
    var $8g9VP = parcelRequire("8g9VP");
    var $gU9Ei = parcelRequire("gU9Ei");
    var $6zD3Y = parcelRequire("6zD3Y");
    var $6oc7N = parcelRequire("6oc7N");
    var $67qL5 = parcelRequire("67qL5");
    var $3yJND = parcelRequire("3yJND");
    var $6ay3w = parcelRequire("6ay3w");
    const $667560f64c0844f5$var$IntegrationView = (0, ($parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("jUxP4")));
    const $667560f64c0844f5$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
            const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
            const tblz852ExperimentCohort = (0, $fPtA6.default).getExperimentValue('product_store_personal_use_case', 'cohort', 'not-enrolled', {
                fireExperimentExposure: false
            });
            const isInTblz852ExperimentCohort = tblz852ExperimentCohort === 'variation';
            const onCloseResolver = (0, $eUqFw.useRef)();
            const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $eUqFw.useState)(false);
            const fireEvent = (0, $eUqFw.useMemo)(()=>(0, $8g9VP.analyticsWrapper)(analyticsClient), [
                analyticsClient
            ]);
            const [requestOptions, setRequestOptions] = (0, $eUqFw.useState)();
            const onAnalyticsEvent = (0, $eUqFw.useCallback)((payload)=>{
                const gasV3Event = (0, $gU9Ei.transformEvent)(payload);
                if (gasV3Event) {
                    const enrichedEvent = (0, $3yJND.enrichWithRequestOptions)((0, $67qL5.enrichWithPackageDetails)(gasV3Event), requestOptions);
                    fireEvent(enrichedEvent);
                }
            }, [
                fireEvent,
                requestOptions
            ]);
            const onHandShake = (0, $eUqFw.useCallback)((appName)=>{
                if (!firstHandshakeReceived) {
                    onAnalyticsEvent({
                        payload: {
                            eventType: (0, $394220419f57a1b4$export$12346a674644c156),
                            action: (0, $6ay3w.uiInitialized),
                            actionSubject: (0, $6ay3w.crossFlowActionSubject),
                            attributes: {
                                appName: appName
                            }
                        },
                        context: [
                            {
                                source: $6ay3w.source
                            }
                        ]
                    });
                    setFirstHandshakeReceived(true);
                }
            }, [
                firstHandshakeReceived,
                onAnalyticsEvent
            ]);
            const onOpen = (0, $eUqFw.useCallback)((options)=>{
                setFirstHandshakeReceived(false);
                const analyticsEvent = {
                    payload: (0, $3yJND.enrichWithRequestOptions)({
                        eventType: (0, $394220419f57a1b4$export$12346a674644c156),
                        action: (0, $6ay3w.openInvoked),
                        actionSubject: (0, $6ay3w.crossFlowActionSubject)
                    }, options),
                    context: [
                        {
                            source: $6ay3w.source
                        }
                    ]
                };
                onAnalyticsEvent(analyticsEvent);
                if (options.journey === (0, $gMnrE.Journeys).GET_STARTED && redirectToWac) {
                    (0, $6zD3Y.setProductSignUpLocation)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                    const completionStatus = {};
                    return Promise.resolve(completionStatus);
                }
                const updatedExperimentalOptions = {
                    ...globalExperimentalOptions || {},
                    ...options.experimentalOptions || {}
                };
                options.experimentalOptions = updatedExperimentalOptions;
                setRequestOptions(options);
                return new Promise((resolve)=>{
                    onCloseResolver.current = resolve;
                });
            }, [
                onAnalyticsEvent,
                env,
                redirectToWac,
                globalExperimentalOptions
            ]);
            const onClose = (0, $eUqFw.useCallback)((completionStatus)=>{
                setFirstHandshakeReceived(false);
                setRequestOptions(undefined);
                onCloseResolver.current && onCloseResolver.current(completionStatus);
            }, []);
            const { colorMode: colorMode } = (0, $exMfg.default)();
            return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gMnrE.BaseCrossFlowApiProvider), {
                onOpen: onOpen
            }, children, requestOptions && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6oc7N.ErrorBoundary), {
                onAnalyticsEvent: onAnalyticsEvent,
                onError: onError
            }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
                fallback: null
            }, (0, ($parcel$interopDefault($eUqFw))).createElement(IntegrationView, {
                ...baseProviderProps,
                ...requestOptions,
                onAnalyticsEvent: onAnalyticsEvent,
                originProduct: originProduct,
                theme: colorMode,
                onClose: onClose,
                onHandShake: onHandShake,
                plugins: plugins,
                env: env,
                redirectToWac: redirectToWac,
                isInTblz852ExperimentCohort: isInTblz852ExperimentCohort,
                zIndex: requestOptions.zIndex ?? 1000
            }))));
        };
    const $667560f64c0844f5$export$d900e4062895cd7c = $667560f64c0844f5$export$79d79d8dd8574306($667560f64c0844f5$var$IntegrationView);
});
parcelRegister("8g9VP", function(module, exports) {
    $parcel$export(module.exports, "analyticsWrapper", ()=>$d65ce684b59ad080$export$91b4dd3bfc301325);
    const $d65ce684b59ad080$export$91b4dd3bfc301325 = (analyticsClient)=>{
        return (event)=>{
            return Promise.resolve(analyticsClient).then((client)=>{
                switch(event.eventType){
                    case 0, $394220419f57a1b4$export$a1562d08625f5d7e:
                        client.sendUIEvent(event);
                        break;
                    case 0, $394220419f57a1b4$export$947dac6c72b26f81:
                        client.sendTrackEvent(event);
                        break;
                    case 0, $394220419f57a1b4$export$12346a674644c156:
                        client.sendOperationalEvent(event);
                        break;
                    case 0, $394220419f57a1b4$export$f1d537d508d2945a:
                        client.sendScreenEvent(event);
                        break;
                }
            });
        };
    };
});
parcelRegister("gU9Ei", function(module, exports) {
    $parcel$export(module.exports, "transformEvent", ()=>$18c17241fe54e823$export$3f40e8c44448be30);
    const $18c17241fe54e823$var$GROWTH_TAG = 'growth';
    const $18c17241fe54e823$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
            propertyNames.forEach((propertyName)=>{
                const navContextProp = contextItem ? contextItem[propertyName] : null;
                acc.push(navContextProp || contextItem[propertyName]);
            });
            return acc;
        }, []).filter(Boolean);
    const $18c17241fe54e823$var$getSources = (context)=>$18c17241fe54e823$var$extractFromEventContext([
            'source'
        ], context);
    const $18c17241fe54e823$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
            const newAttributes = {
                ...ans,
                ...contextProps
            };
            return attributes ? {
                ...newAttributes,
                ...attributes
            } : newAttributes;
        }, {});
    const $18c17241fe54e823$var$getPackageInfo = (context)=>context.map((contextItem)=>({
                packageName: contextItem.packageName,
                packageVersion: contextItem.packageVersion
            })).filter((p)=>p.packageName);
    const $18c17241fe54e823$var$last = (values)=>values[values.length - 1];
    const $18c17241fe54e823$export$3f40e8c44448be30 = (event)=>{
        const { context: context, payload: payload } = event;
        if (!payload) return null;
        const sources = $18c17241fe54e823$var$getSources(context);
        const source = $18c17241fe54e823$var$last(sources) || (0, $394220419f57a1b4$export$b055de0e665cb20c);
        const extraAttributes = $18c17241fe54e823$var$getExtraAttributes(context);
        const { packageName: packageName, packageVersion: packageVersion } = $18c17241fe54e823$var$last($18c17241fe54e823$var$getPackageInfo(context)) || {};
        const { eventType: eventType = (0, $394220419f57a1b4$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
        const attributes = {
            packageName: packageName,
            packageVersion: packageVersion,
            ...extraAttributes,
            ...payloadAttributes
        };
        const tags = payload.tags || [];
        tags.push($18c17241fe54e823$var$GROWTH_TAG);
        switch(eventType){
            case 0, $394220419f57a1b4$export$a1562d08625f5d7e:
            case 0, $394220419f57a1b4$export$12346a674644c156:
            case 0, $394220419f57a1b4$export$947dac6c72b26f81:
                return {
                    eventType: eventType,
                    source: source,
                    actionSubject: actionSubject,
                    action: action,
                    actionSubjectId: actionSubjectId,
                    attributes: attributes,
                    tags: tags.slice(0)
                };
            case 0, $394220419f57a1b4$export$f1d537d508d2945a:
                return {
                    eventType: eventType,
                    name: name,
                    attributes: attributes,
                    source: source,
                    tags: tags.slice(0)
                };
            default:
                break;
        }
        return null;
    };
});
parcelRegister("6zD3Y", function(module, exports) {
    $parcel$export(module.exports, "setProductSignUpLocation", ()=>$0413cf3fa1cf59c7$export$2827e2473cb9a346);
    var $2OGBt = parcelRequire("2OGBt");
    var $9XVXP = parcelRequire("9XVXP");
    const $0413cf3fa1cf59c7$var$utmCampaignMap = {
        'atlassian-switcher': (0, $9XVXP.UtmCampaign)['atlassian-switcher']
    };
    const $0413cf3fa1cf59c7$var$isBundledProduct = (productKey)=>{
        return [
            (0, $2OGBt.Targets).JIRA_SOFTWARE,
            (0, $2OGBt.Targets).JIRA_SERVICE_DESK,
            (0, $2OGBt.Targets).JIRA_CORE,
            (0, $2OGBt.Targets).CONFLUENCE
        ].includes(productKey);
    };
    const $0413cf3fa1cf59c7$var$getBundleSignUpParams = (productKey)=>{
        const bundles = {
            [(0, $2OGBt.Targets).JIRA_SOFTWARE]: 'jira-software',
            [(0, $2OGBt.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
            [(0, $2OGBt.Targets).JIRA_CORE]: 'jira-core',
            [(0, $2OGBt.Targets).CONFLUENCE]: 'confluence'
        };
        return `bundle=${bundles[productKey]}&edition=free`;
    };
    const $0413cf3fa1cf59c7$var$isProductWithCustomSignUpPath = (productKey)=>{
        return [
            (0, $2OGBt.Targets).OPSGENIE
        ].includes(productKey);
    };
    const $0413cf3fa1cf59c7$var$getProductCustomSignUpPath = (productKey)=>{
        const links = {
            [(0, $2OGBt.Targets).OPSGENIE]: (0, $e320346c779631de$export$fb1e43fdafe12e9b)
        };
        return links[productKey];
    };
    const $0413cf3fa1cf59c7$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
        return Boolean($0413cf3fa1cf59c7$var$utmCampaignMap[sourceComponent]);
    };
    const $0413cf3fa1cf59c7$var$getUtmParams = (sourceComponent, sourceContext)=>{
        let utmParams = '';
        if (sourceComponent && $0413cf3fa1cf59c7$var$isSourceComponentWithUtmParams(sourceComponent)) {
            utmParams = utmParams + `utm_campaign=${$0413cf3fa1cf59c7$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
            if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
        }
        return utmParams;
    };
    const $0413cf3fa1cf59c7$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
        const wacUrl = env === 'staging' ? (0, $e320346c779631de$export$c37558e5c67d2b01) : (0, $e320346c779631de$export$f199baf8dfc7621e);
        const utmParams = $0413cf3fa1cf59c7$var$getUtmParams(sourceComponent, sourceContext);
        let queryParams = '';
        let bundleParams = '';
        let path = (0, $e320346c779631de$export$2a45a00073911255);
        if ($0413cf3fa1cf59c7$var$isBundledProduct(productKey)) {
            path = (0, $e320346c779631de$export$e6c04a1dd86d1c14);
            bundleParams = $0413cf3fa1cf59c7$var$getBundleSignUpParams(productKey);
        } else if ($0413cf3fa1cf59c7$var$isProductWithCustomSignUpPath(productKey)) path = $0413cf3fa1cf59c7$var$getProductCustomSignUpPath(productKey);
        if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
        if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
        return wacUrl + path + queryParams;
    };
    const $0413cf3fa1cf59c7$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
        const url = $0413cf3fa1cf59c7$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
        window.open(url, '_blank');
    };
});
const $e320346c779631de$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $e320346c779631de$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $e320346c779631de$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $e320346c779631de$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $e320346c779631de$export$2a45a00073911255 = '/software';
parcelRegister("9XVXP", function(module, exports) {
    $parcel$export(module.exports, "UtmCampaign", ()=>$9164f502c57739bb$export$fc604aa353a97e10);
    var $9164f502c57739bb$export$fc604aa353a97e10;
    (function(UtmCampaign) {
        UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    })($9164f502c57739bb$export$fc604aa353a97e10 || ($9164f502c57739bb$export$fc604aa353a97e10 = {}));
});
parcelRegister("6oc7N", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$2bdbe87b8f3fc0b8$export$e926676385687eaf);
    var $eUqFw = parcelRequire("eUqFw");
    var $6ay3w = parcelRequire("6ay3w");
    const $2bdbe87b8f3fc0b8$var$name = "platform-pkg";
    const $2bdbe87b8f3fc0b8$var$version = "0.0.0-use.local";
    const $2bdbe87b8f3fc0b8$var$payload = {
        eventType: (0, $394220419f57a1b4$export$12346a674644c156),
        action: (0, $6ay3w.errorBoundaryAction),
        actionSubject: (0, $6ay3w.errorBoundaryActionSubject)
    };
    const $2bdbe87b8f3fc0b8$var$context = [
        {
            source: $6ay3w.source
        },
        {
            packageName: $2bdbe87b8f3fc0b8$var$name,
            packageVersion: $2bdbe87b8f3fc0b8$var$version
        }
    ];
    class $2bdbe87b8f3fc0b8$export$e926676385687eaf extends (0, $eUqFw.Component) {
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        componentDidCatch(error) {
            this.props.onAnalyticsEvent({
                payload: $2bdbe87b8f3fc0b8$var$payload,
                context: $2bdbe87b8f3fc0b8$var$context
            });
            if (this.props.onError) this.props.onError(error);
        }
        render() {
            if (this.state.hasError) return null;
            return this.props.children;
        }
        constructor(...args){
            super(...args);
            this.state = {
                hasError: false
            };
        }
    }
});
parcelRegister("6ay3w", function(module, exports) {
    $parcel$export(module.exports, "source", ()=>$05f0801acb9f743d$export$b4d5da5f34fb77ad);
    $parcel$export(module.exports, "errorBoundaryAction", ()=>$05f0801acb9f743d$export$9d8252a268f4fa72);
    $parcel$export(module.exports, "errorBoundaryActionSubject", ()=>$05f0801acb9f743d$export$1045419caf49b395);
    $parcel$export(module.exports, "crossFlowActionSubject", ()=>$05f0801acb9f743d$export$d54c183f56e39aa5);
    $parcel$export(module.exports, "uiInitialized", ()=>$05f0801acb9f743d$export$e5c2c058fa8068a6);
    $parcel$export(module.exports, "openInvoked", ()=>$05f0801acb9f743d$export$e67cdcb8867a3bd0);
    $parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", ()=>$394220419f57a1b4$export$12346a674644c156);
    const $05f0801acb9f743d$export$b4d5da5f34fb77ad = 'crossFlowProvider';
    const $05f0801acb9f743d$export$9d8252a268f4fa72 = 'errorCaught';
    const $05f0801acb9f743d$export$1045419caf49b395 = 'errorBoundary';
    const $05f0801acb9f743d$export$d54c183f56e39aa5 = 'crossFlowSupport';
    const $05f0801acb9f743d$export$e5c2c058fa8068a6 = 'uiInitialized';
    const $05f0801acb9f743d$export$e67cdcb8867a3bd0 = 'openInvoked';
});
parcelRegister("67qL5", function(module, exports) {
    $parcel$export(module.exports, "enrichWithPackageDetails", ()=>$6a303423f20701e9$export$59518efab336a8b5);
    const $6a303423f20701e9$var$version = "0.0.0-use.local";
    const $6a303423f20701e9$export$84f9cf7ef89d4c26 = {
        version: $6a303423f20701e9$var$version
    };
    const $6a303423f20701e9$export$59518efab336a8b5 = (event)=>{
        const attributes = {
            ...event.attributes || {},
            crossFlowSupport: $6a303423f20701e9$export$84f9cf7ef89d4c26
        };
        return {
            ...event,
            attributes: attributes
        };
    };
});
parcelRegister("3yJND", function(module, exports) {
    $parcel$export(module.exports, "enrichWithRequestOptions", ()=>$6c5e96b5c084b7eb$export$a5a156dc5df42f0);
    const $6c5e96b5c084b7eb$export$a5a156dc5df42f0 = (event, requestOptions)=>{
        if (!requestOptions) return event;
        const attributes = {
            ...requestOptions.extraAnalyticsAttributes || {},
            ...event.attributes || {},
            sourceComponent: requestOptions.sourceComponent,
            sourceContext: requestOptions.sourceContext
        };
        return {
            ...event,
            attributes: attributes
        };
    };
});
parcelRegister("jUxP4", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("eNmuD"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("kfke1")
    ]).then(()=>parcelRequire('4KoWn'));
});
parcelRegister("4Vji8", function(module, exports) {
    $parcel$export(module.exports, "getContainersPlugin", ()=>$d5a247609f17a49b$export$81d1d40061d190bc);
    parcelRequire("deEva");
    var $fmilT = parcelRequire("fmilT");
    var $deEva = parcelRequire("deEva");
    var $e91YZ = parcelRequire("e91YZ");
    const $d5a247609f17a49b$var$getCloudId = async ()=>{
        const { cloudName: cloudName, cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        const containers = [
            {
                id: cloudId,
                displayName: cloudName,
                type: (0, $fmilT.ContainerTypes).ATLASSIAN_CLOUD_ID
            }
        ];
        return {
            type: (0, $fmilT.ContainerTypes).ATLASSIAN_CLOUD_ID,
            containers: containers
        };
    };
    const $d5a247609f17a49b$export$81d1d40061d190bc = (0, $deEva.createGetContainersPlugin)($d5a247609f17a49b$var$getCloudId);
});
parcelRegister("deEva", function(module, exports) {
    $parcel$export(module.exports, "createGetContainersPlugin", ()=>$98d38bd80c51ade1$export$76378b0f825c024c);
    $parcel$export(module.exports, "createGetUsersPlugin", ()=>$98d38bd80c51ade1$export$8feb7eae83cf8cd5);
    $parcel$export(module.exports, "ContainerTypes", ()=>(parcelRequire("fmilT")).ContainerTypes);
    $parcel$export(module.exports, "UserIdTypes", ()=>(parcelRequire("fmilT")).UserIdTypes);
    var $fmilT = parcelRequire("fmilT");
    const $98d38bd80c51ade1$export$76378b0f825c024c = (fetch)=>{
        return [
            (0, $fmilT.PluginTypes).GetContainers,
            fetch
        ];
    };
    const $98d38bd80c51ade1$export$8feb7eae83cf8cd5 = (fetch)=>{
        return [
            (0, $fmilT.PluginTypes).GetUsers,
            fetch
        ];
    };
    const $98d38bd80c51ade1$export$21d120847be2aff4 = (fetch)=>{
        return [
            (0, $fmilT.PluginTypes).GetSuggestedSiteNames,
            fetch
        ];
    };
    const $98d38bd80c51ade1$export$d7c1699c6a2ca18a = (fetch)=>{
        return [
            (0, $fmilT.PluginTypes).GetAvailableSites,
            fetch
        ];
    };
});
parcelRegister("fmilT", function(module, exports) {
    $parcel$export(module.exports, "PluginTypes", ()=>$3d94a775b5b302e3$export$a235a73f7b906dce);
    $parcel$export(module.exports, "ContainerTypes", ()=>$3d94a775b5b302e3$export$6e383182a26455ff);
    $parcel$export(module.exports, "UserIdTypes", ()=>$3d94a775b5b302e3$export$e391bab95adb8396);
    const $3d94a775b5b302e3$export$a235a73f7b906dce = {
        GetContainers: 'GetContainers',
        GetUsers: 'GetUsers',
        GetSuggestedSiteNames: 'GetSuggestedSiteNames',
        GetAvailableSites: 'GetAvailableSites'
    };
    const $3d94a775b5b302e3$export$6e383182a26455ff = {
        BITBUCKET_WORKSPACE: 'bitbucket-workspace',
        ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
        JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
    };
    const $3d94a775b5b302e3$export$e391bab95adb8396 = {
        ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
        TRELLO_ID: 'TRELLO_ID'
    };
    const $3d94a775b5b302e3$export$4f378ba35c571906 = {
        JIRA_BUSINESS: 'JIRA_BUSINESS',
        JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
        JIRA_SOFTWARE: 'JIRA_SOFTWARE',
        CONFLUENCE: 'CONFLUENCE',
        OPSGENIE: 'OPSGENIE',
        BITBUCKET: 'BITBUCKET',
        STATUSPAGE: 'STATUSPAGE',
        TRELLO: 'TRELLO',
        COMPASS: 'COMPASS'
    };
});
parcelRegister("iPzab", function(module, exports) {
    $parcel$export(module.exports, "getUsersPlugin", ()=>$f595b9c40464a5a8$export$7c44908d2777db01);
    var $deEva = parcelRequire("deEva");
    var $fmilT = parcelRequire("fmilT");
    const $f595b9c40464a5a8$var$getUsers = async (containerId)=>{
        const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
        try {
            const response = await fetch(getUsersUrl, {
                credentials: 'same-origin'
            });
            if (response.ok) {
                const data = await response.json();
                return data.map((value)=>({
                        id: value.id,
                        idType: (0, $fmilT.UserIdTypes).ATLASSIAN_ACCOUNT_ID,
                        displayName: value.displayName
                    }));
            }
            throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
        } catch (error) {
            throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
        }
    };
    const $f595b9c40464a5a8$export$7c44908d2777db01 = (0, $deEva.createGetUsersPlugin)($f595b9c40464a5a8$var$getUsers);
});
parcelRegister("dQZ5c", function(module, exports) {
    $parcel$export(module.exports, "FavoriteChangeContext", ()=>$5cd604b288cea09a$export$a5d258b9665ce94b);
    $parcel$export(module.exports, "FavoriteChangeProvider", ()=>$5cd604b288cea09a$export$b06b5ce59fd5e408);
    $parcel$export(module.exports, "FavoriteChangeConsumer", ()=>$5cd604b288cea09a$export$f227cdfbb355444a);
    $parcel$export(module.exports, "useChangeFavorite", ()=>$5cd604b288cea09a$export$cfa169f3278459e8);
    var $aN2eF = parcelRequire("aN2eF");
    var $eUqFw = parcelRequire("eUqFw");
    var $jG2Eu = parcelRequire("jG2Eu");
    var $iWLL0 = parcelRequire("iWLL0");
    var $cNy9K = parcelRequire("cNy9K");
    var $guiFP = parcelRequire("guiFP");
    var $huI7r = parcelRequire("huI7r");
    var $jMP2a = parcelRequire("jMP2a");
    var $dWLk9 = parcelRequire("dWLk9");
    var $wWL8n = parcelRequire("wWL8n");
    var $4PS9K = parcelRequire("4PS9K");
    var $7rOmF = parcelRequire("7rOmF");
    var $jrdvV = parcelRequire("jrdvV");
    var $cfElQ = parcelRequire("cfElQ");
    var $duxfp = parcelRequire("duxfp");
    const $5cd604b288cea09a$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
                ...state,
                [item.type]: {
                    ...state[item.type],
                    [item.id]: item
                }
            });
    const $5cd604b288cea09a$export$72b8c6d38aa6195b = (item)=>(state)=>({
                ...state,
                items: {
                    ...state.items,
                    [item.type]: {
                        ...state.items[item.type],
                        [item.id]: item
                    }
                }
            });
    const $5cd604b288cea09a$export$b212ddc707077772 = {
        items: {
            boards: {},
            filters: {},
            issues: {},
            dashboards: {},
            projects: {},
            queues: {},
            plans: {}
        },
        changeFavorite: ()=>new Promise((0, ($parcel$interopDefault($jG2Eu)))),
        changeFavoriteMutation: (0, ($parcel$interopDefault($jG2Eu))),
        emitChangedFavorite: (0, ($parcel$interopDefault($jG2Eu))),
        emitChangedFavoriteMutation: (0, ($parcel$interopDefault($jG2Eu))),
        updateFavoriteState: (0, ($parcel$interopDefault($jG2Eu)))
    };
    const $5cd604b288cea09a$export$a5d258b9665ce94b = (0, $eUqFw.createContext)($5cd604b288cea09a$export$b212ddc707077772);
    const $5cd604b288cea09a$var$useRelayFavoriteUpdate = ()=>{
        const environment = (0, $iWLL0.useRelayEnvironment)();
        const cloudId = (0, $dWLk9.useCloudId)();
        const commitUpdate = (0, $eUqFw.useCallback)(({ id: id, type: type, value: value })=>{
            if (type === (0, $jrdvV.PROJECTS_ITEM_TYPE)) (0, $cNy9K.commitLocalUpdate)(environment, (store)=>{
                const ari = (0, $huI7r.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'project',
                    resourceId: id,
                    cloudId: cloudId
                });
                const projectRecordId = (0, $wWL8n.default)({
                    id: ari
                }, 'JiraProject');
                if (projectRecordId) {
                    const projectRecord = store.get(projectRecordId);
                    const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(value, 'isFavourite');
                }
            });
        }, [
            cloudId,
            environment
        ]);
        return {
            commitUpdate: commitUpdate
        };
    };
    const $5cd604b288cea09a$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
        const { commitUpdate: commitUpdate } = $5cd604b288cea09a$var$useRelayFavoriteUpdate();
        const [items, setItems] = (0, $eUqFw.useState)({
            boards: {},
            filters: {},
            dashboards: {},
            issues: {},
            projects: {},
            queues: {},
            plans: {}
        });
        const onChangeStart = (0, $eUqFw.useCallback)((item)=>{
            setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
                ...item,
                pending: true
            }));
        }, []);
        const onChangeSuccess = (0, $eUqFw.useCallback)((item, analyticsEvent)=>{
            setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
                ...item,
                pending: false
            }));
            if (analyticsEvent) (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
        }, []);
        const onChangeFail = (0, $eUqFw.useCallback)((item, analyticsId, error)=>{
            setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
                ...item,
                value: !item.value,
                pending: false
            }));
            if (onShowFlag) onShowFlag((0, $duxfp.errorFlag)());
            (0, $guiFP.default)({
                meta: {
                    id: analyticsId,
                    packageName: 'jiraFavouriteChangeProvider',
                    teamName: 'empanada'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            onShowFlag
        ]);
        const changeFavorite = (0, $eUqFw.useCallback)(async (item, analyticsEvent)=>{
            const performChange = async ()=>{
                onChangeStart(item);
                try {
                    commitUpdate({
                        type: item.type,
                        id: item.id,
                        value: item.value
                    });
                    await (0, $cfElQ.default)(item);
                    const typename = (0, $4PS9K.favoriteTypeToTypename)(item.type, item.id);
                    if (typename) (0, $7rOmF.publishFavorite)(typename, {
                        type: 'REST',
                        entityId: item.id,
                        isFavourite: item.value
                    });
                    onChangeSuccess(item, analyticsEvent);
                } catch (error) {
                    commitUpdate({
                        type: item.type,
                        id: item.id,
                        value: !item.value
                    });
                    onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
                }
            };
            return performChange();
        }, [
            commitUpdate,
            onChangeStart,
            onChangeSuccess,
            onChangeFail
        ]);
        const [commitMutation] = (0, $iWLL0.useMutation)((0, $aN2eF.default));
        const changeFavoriteMutation = (0, $eUqFw.useCallback)((payload, analyticsEvent)=>{
            const dataId = (0, $wWL8n.default)({
                id: payload.id
            }, payload.typename);
            const restItem = (0, $4PS9K.favoriteMutationToRestPayload)(payload);
            const onUpdate = (store, isOptimistic)=>{
                if (!dataId) return;
                (0, $7rOmF.publishFavorite)(payload.typename, {
                    type: 'MUTATION',
                    store: store,
                    dataId: dataId,
                    entityId: payload.id,
                    isFavourite: payload.value,
                    isOptimistic: isOptimistic
                });
                const record = store.get(dataId);
                if (record) {
                    if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                    if (isOptimistic) {
                        const favoriteRecord = record.getLinkedRecord('favouriteValue');
                        favoriteRecord?.setValue(payload.value, 'isFavourite');
                    }
                }
            };
            onChangeStart(restItem);
            commitMutation({
                variables: {
                    input: {
                        entityId: payload.id,
                        isFavourite: payload.value,
                        beforeEntityId: payload.beforeEntity?.id ?? null
                    }
                },
                optimisticUpdater: (store)=>{
                    onUpdate(store, true);
                },
                updater: (store, response)=>{
                    if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
                },
                onCompleted: (response)=>{
                    if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                    else onChangeFail(restItem, 'changeFavoriteMutation');
                },
                onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
            });
        }, [
            commitMutation,
            onChangeStart,
            onChangeSuccess,
            onChangeFail
        ]);
        const updateFavoriteState = (0, $eUqFw.useCallback)((item)=>{
            setItems($5cd604b288cea09a$export$4fe337ef5f0ceb74({
                ...item,
                pending: false
            }));
        }, []);
        const emitChangedFavorite = (0, $eUqFw.useCallback)((payload, analyticsEvent)=>{
            onChangeSuccess(payload, analyticsEvent);
            const typeName = (0, $4PS9K.favoriteTypeToTypename)(payload.type, payload.id);
            if (typeName) (0, $7rOmF.publishFavorite)(typeName, {
                type: 'REST',
                entityId: payload.id,
                isFavourite: payload.value
            });
        }, [
            onChangeSuccess
        ]);
        const emitChangedFavoriteMutation = (0, $eUqFw.useCallback)((payload, store, analyticsEvent)=>{
            const dataId = (0, $wWL8n.default)({
                id: payload.id
            }, payload.typename) ?? '';
            const restItem = (0, $4PS9K.favoriteMutationToRestPayload)(payload);
            onChangeSuccess(restItem, analyticsEvent);
            (0, $7rOmF.publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: false
            });
        }, [
            onChangeSuccess
        ]);
        const providerValue = (0, $eUqFw.useMemo)(()=>({
                items: items,
                changeFavorite: changeFavorite,
                changeFavoriteMutation: changeFavoriteMutation,
                emitChangedFavorite: emitChangedFavorite,
                emitChangedFavoriteMutation: emitChangedFavoriteMutation,
                updateFavoriteState: updateFavoriteState
            }), [
            items,
            changeFavorite,
            changeFavoriteMutation,
            emitChangedFavorite,
            emitChangedFavoriteMutation,
            updateFavoriteState
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($5cd604b288cea09a$export$a5d258b9665ce94b.Provider, {
            value: providerValue
        }, children);
    };
    const $5cd604b288cea09a$export$f227cdfbb355444a = $5cd604b288cea09a$export$a5d258b9665ce94b.Consumer;
    const $5cd604b288cea09a$export$61944ffe37754ff2 = (WrappedComponent)=>{
        const WithFavoriteChangeConsumer = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement($5cd604b288cea09a$export$f227cdfbb355444a, null, (favoriteChangeContext)=>(0, ($parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...props,
                    favoriteChangeContext: favoriteChangeContext
                }));
        const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
        return WithFavoriteChangeConsumer;
    };
    const $5cd604b288cea09a$export$cfa169f3278459e8 = ()=>(0, $eUqFw.useContext)($5cd604b288cea09a$export$a5d258b9665ce94b);
});
parcelRegister("aN2eF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53c140edf81067bf$export$2e2bcd8739ae039);
    const $53c140edf81067bf$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "concreteType": "JiraMutation",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "input",
                                "variableName": "input"
                            }
                        ],
                        "concreteType": "JiraSetIsFavouritePayload",
                        "kind": "LinkedField",
                        "name": "setEntityIsFavourite",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "success"
                            },
                            {
                                "concreteType": "JiraFavouriteValue",
                                "kind": "LinkedField",
                                "name": "favouriteValue",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isFavourite"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "viewSetFavouriteMutation",
                "selections": v1,
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "viewSetFavouriteMutation",
                "selections": v1
            },
            "params": {
                "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
                "metadata": {},
                "name": "viewSetFavouriteMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $53c140edf81067bf$var$node.hash = "af74e48c451986374e11a5b801d5009f";
    var $53c140edf81067bf$export$2e2bcd8739ae039 = $53c140edf81067bf$var$node;
});
parcelRegister("huI7r", function(module, exports) {
    $parcel$export(module.exports, "isAri", ()=>$c148d923211ffae9$export$8e68286aef4c3a8b);
    $parcel$export(module.exports, "createAri", ()=>$c148d923211ffae9$export$594d18a0ad2e0e57);
    $parcel$export(module.exports, "toAri", ()=>$c148d923211ffae9$export$24b47820a324e614);
    $parcel$export(module.exports, "toAriOrDefault", ()=>$c148d923211ffae9$export$e2789192113e8b07);
    $parcel$export(module.exports, "parseAri", ()=>$c148d923211ffae9$export$f8e7d14b19dc8ba5);
    $parcel$export(module.exports, "getAriConfig", ()=>$c148d923211ffae9$export$3d8d7031a11613fd);
    const $c148d923211ffae9$var$ARI_REG_EXP = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/(?<resourceId>[\w.~_-]+)$/;
    const $c148d923211ffae9$var$ARI_REG_EXP_ACTIVATION = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<resourceId>[\w.~_-]+)$/;
    const $c148d923211ffae9$var$ARI_REG_EXP_WORKSPACE = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>.{0}):(?<resourceType>[a-z.-]+)(\/(?<workspaceId>[\w.~_-]+)?)\/(?<resourceId>[\w.~_-]+)$/;
    const $c148d923211ffae9$var$ARI_REG_EXP_PROVIDER_CONTAINER = /^ari:cloud:(?<resourceOwner>[a-z.-]+):(?<cloudId>[\w-]*):(?<resourceType>[a-z.-]+)\/activation\/(?<activationId>[\w-]*)\/(?<providerAppId>[\w.~_-]+)\/(?<resourceId>[\w.~_/-]+)$/;
    const $c148d923211ffae9$export$8e68286aef4c3a8b = (ari)=>$c148d923211ffae9$var$ARI_REG_EXP.test(ari) || $c148d923211ffae9$var$ARI_REG_EXP_WORKSPACE.test(ari) || $c148d923211ffae9$var$ARI_REG_EXP_ACTIVATION.test(ari) || $c148d923211ffae9$var$ARI_REG_EXP_PROVIDER_CONTAINER.test(ari);
    const $c148d923211ffae9$export$594d18a0ad2e0e57 = ({ resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId })=>{
        if (workspaceId != null) return `ari:cloud:${resourceOwner}::${resourceType}/${workspaceId}/${resourceId}`;
        if (activationId != null) return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/activation/${activationId}/${resourceId}`;
        return `ari:cloud:${resourceOwner}:${cloudId || ''}:${resourceType}/${resourceId}`;
    };
    const $c148d923211ffae9$export$24b47820a324e614 = (ari)=>{
        if ($c148d923211ffae9$export$8e68286aef4c3a8b(ari)) return ari;
        return undefined;
    };
    const $c148d923211ffae9$export$e2789192113e8b07 = (ari, defaultValue = '')=>$c148d923211ffae9$export$24b47820a324e614(ari) ?? defaultValue;
    const $c148d923211ffae9$export$f8e7d14b19dc8ba5 = (ari)=>{
        if ($c148d923211ffae9$export$8e68286aef4c3a8b(ari)) {
            const parts = $c148d923211ffae9$var$ARI_REG_EXP.exec(ari) || $c148d923211ffae9$var$ARI_REG_EXP_WORKSPACE.exec(ari) || $c148d923211ffae9$var$ARI_REG_EXP_ACTIVATION.exec(ari) || $c148d923211ffae9$var$ARI_REG_EXP_PROVIDER_CONTAINER.exec(ari);
            if (parts?.groups) {
                const { resourceOwner: resourceOwner, cloudId: cloudId, resourceType: resourceType, workspaceId: workspaceId, resourceId: resourceId, activationId: activationId } = parts.groups;
                return {
                    resourceOwner: resourceOwner,
                    cloudId: cloudId,
                    resourceType: resourceType,
                    workspaceId: workspaceId,
                    resourceId: resourceId,
                    activationId: activationId
                };
            }
        }
        return undefined;
    };
    const $c148d923211ffae9$export$3d8d7031a11613fd = (ari)=>{
        const config = $c148d923211ffae9$export$f8e7d14b19dc8ba5(ari);
        if (config === undefined) throw Error('Invalid ARI - this should only be possible if there is a bug in `toAri`');
        return config;
    };
});
parcelRegister("4PS9K", function(module, exports) {
    $parcel$export(module.exports, "favoriteTypeToTypename", ()=>$e37d9393195ce810$export$b98f76d96728a853);
    $parcel$export(module.exports, "favoriteMutationToRestPayload", ()=>$e37d9393195ce810$export$717886a1047f1287);
    var $haZ9d = parcelRequire("haZ9d");
    var $jDNSq = parcelRequire("jDNSq");
    var $aZApM = parcelRequire("aZApM");
    var $3zsgO = parcelRequire("3zsgO");
    var $csxeI = parcelRequire("csxeI");
    var $8npnf = parcelRequire("8npnf");
    function $e37d9393195ce810$var$assertUnreachable(_) {
        throw new Error('Unexpected entity type');
    }
    const $e37d9393195ce810$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
    const $e37d9393195ce810$export$b98f76d96728a853 = (type, resourceId)=>{
        switch(type){
            case 'projects':
                return 'JiraProject';
            case 'filters':
                return $e37d9393195ce810$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
            case 'dashboards':
                return 'JiraDashboard';
            case 'plans':
                return 'JiraPlan';
            case 'boards':
                return 'JiraBoard';
            case 'queues':
                return 'JiraServiceManagementQueue';
            default:
                return undefined;
        }
    };
    const $e37d9393195ce810$var$favoriteAriToId = (typename, ari)=>{
        switch(typename){
            case 'JiraProject':
                return (0, $8npnf.JiraProjectAri).parse(ari).projectId;
            case 'JiraCustomFilter':
            case 'JiraSystemFilter':
                return (0, $3zsgO.JiraFilterAri).parse(ari).filterId;
            case 'JiraDashboard':
                return (0, $aZApM.JiraDashboardAri).parse(ari).dashboardId;
            case 'JiraPlan':
                return (0, $csxeI.JiraPlanAri).parse(ari).planId;
            case 'JiraBoard':
                return (0, $jDNSq.JiraSoftwareBoardAri).parse(ari).boardId;
            case 'JiraServiceManagementQueue':
                return (0, $haZ9d.JiraServicedeskQueueAri).parse(ari).queueId;
            default:
                $e37d9393195ce810$var$assertUnreachable(typename);
        }
    };
    const $e37d9393195ce810$var$favoriteTypenameToType = (typename)=>{
        switch(typename){
            case 'JiraProject':
                return 'projects';
            case 'JiraCustomFilter':
            case 'JiraSystemFilter':
                return 'filters';
            case 'JiraDashboard':
                return 'dashboards';
            case 'JiraPlan':
                return 'plans';
            case 'JiraBoard':
                return 'boards';
            case 'JiraServiceManagementQueue':
                return 'queues';
            default:
                $e37d9393195ce810$var$assertUnreachable(typename);
        }
    };
    const $e37d9393195ce810$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
            id: $e37d9393195ce810$var$favoriteAriToId(typename, id),
            type: $e37d9393195ce810$var$favoriteTypenameToType(typename),
            value: value,
            beforeEntity: beforeEntity ? {
                id: $e37d9393195ce810$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
                type: $e37d9393195ce810$var$favoriteTypenameToType(beforeEntity.typename)
            } : undefined
        });
});
parcelRegister("7rOmF", function(module, exports) {
    $parcel$export(module.exports, "publishFavorite", ()=>$5b205dfeb5d81b94$export$229a24253fb568e1);
    $parcel$export(module.exports, "useSubscribeToFavorite", ()=>$5b205dfeb5d81b94$export$eb04bf805f6b8fb2);
    var $eUqFw = parcelRequire("eUqFw");
    class $5b205dfeb5d81b94$var$FavoritePubSub {
        constructor(){
            this.subscribers = {};
            this.subscribe = (typename, subscriber)=>{
                this.subscribers[typename] = [
                    ...this.subscribers[typename] ?? [],
                    subscriber
                ];
                return ()=>{
                    this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
                };
            };
            this.publish = (typename, payload)=>{
                this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
            };
        }
    }
    const $5b205dfeb5d81b94$var$favoritePubSub = new $5b205dfeb5d81b94$var$FavoritePubSub();
    const $5b205dfeb5d81b94$export$229a24253fb568e1 = $5b205dfeb5d81b94$var$favoritePubSub.publish;
    const $5b205dfeb5d81b94$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
        (0, $eUqFw.useEffect)(()=>{
            const typenames = Array.isArray(typename) ? typename : [
                typename
            ];
            const unsubscribes = typenames.map((val)=>$5b205dfeb5d81b94$var$favoritePubSub.subscribe(val, subscriber));
            return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
        }, [
            typename,
            subscriber
        ]);
    };
});
parcelRegister("jrdvV", function(module, exports) {
    $parcel$export(module.exports, "BOARDS_ITEM_TYPE", ()=>$0f4349785a7b5234$export$aade82542e73ffc8);
    $parcel$export(module.exports, "FILTERS_ITEM_TYPE", ()=>$0f4349785a7b5234$export$a448ebfa10cebc74);
    $parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", ()=>$0f4349785a7b5234$export$f8099f229527572c);
    $parcel$export(module.exports, "ISSUES_ITEM_TYPE", ()=>$0f4349785a7b5234$export$8e58083dcbb878d);
    $parcel$export(module.exports, "PLANS_ITEM_TYPE", ()=>$0f4349785a7b5234$export$2fd44a6cb58b66cb);
    $parcel$export(module.exports, "PROJECTS_ITEM_TYPE", ()=>$0f4349785a7b5234$export$8e2cd98172988d7e);
    $parcel$export(module.exports, "QUEUES_ITEM_TYPE", ()=>$0f4349785a7b5234$export$6b0c8e47d2c7f1d9);
    $parcel$export(module.exports, "VALID_ITEM_TYPES", ()=>$0f4349785a7b5234$export$9c8cfad65800ddfb);
    $parcel$export(module.exports, "VALID_ITEM_TYPENAMES", ()=>$0f4349785a7b5234$export$2d63a9c2e78633c8);
    const $0f4349785a7b5234$export$aade82542e73ffc8 = 'boards';
    const $0f4349785a7b5234$export$a448ebfa10cebc74 = 'filters';
    const $0f4349785a7b5234$export$f8099f229527572c = 'dashboards';
    const $0f4349785a7b5234$export$8e58083dcbb878d = 'issues';
    const $0f4349785a7b5234$export$2fd44a6cb58b66cb = 'plans';
    const $0f4349785a7b5234$export$8e2cd98172988d7e = 'projects';
    const $0f4349785a7b5234$export$6b0c8e47d2c7f1d9 = 'queues';
    const $0f4349785a7b5234$export$9c8cfad65800ddfb = [
        $0f4349785a7b5234$export$aade82542e73ffc8,
        $0f4349785a7b5234$export$f8099f229527572c,
        $0f4349785a7b5234$export$a448ebfa10cebc74,
        $0f4349785a7b5234$export$8e58083dcbb878d,
        $0f4349785a7b5234$export$2fd44a6cb58b66cb,
        $0f4349785a7b5234$export$8e2cd98172988d7e,
        $0f4349785a7b5234$export$6b0c8e47d2c7f1d9
    ];
    const $0f4349785a7b5234$export$2d63a9c2e78633c8 = [
        'JiraProject',
        'JiraCustomFilter',
        'JiraSystemFilter',
        'JiraDashboard',
        'JiraPlan',
        'JiraBoard',
        'JiraServiceManagementQueue'
    ];
});
parcelRegister("cfElQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b6607d4d7fa618f$export$2e2bcd8739ae039);
    var $10sp5 = parcelRequire("10sp5");
    var $8b6607d4d7fa618f$export$2e2bcd8739ae039 = async (request)=>(0, $10sp5.updateFavorite)(request);
});
parcelRegister("10sp5", function(module, exports) {
    $parcel$export(module.exports, "updateFavorite", ()=>$13472629d630871e$export$8c2f00130cc945dc);
    var $lRmyA = parcelRequire("lRmyA");
    const $13472629d630871e$export$8c2f00130cc945dc = async (request)=>{
        if (request.value) return (0, $lRmyA.performPostRequest)('/rest/internal/2/favourites', {
            body: JSON.stringify({
                entity: {
                    id: request.id,
                    type: request.type
                },
                beforeEntityPosition: request.beforeEntity || null
            })
        });
        return (0, $lRmyA.performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
    };
});
parcelRegister("duxfp", function(module, exports) {
    $parcel$export(module.exports, "errorFlag", ()=>$bec77f1a045d66e4$export$b9a7f1ebeaa76953);
    var $jsurv = parcelRequire("jsurv");
    const $bec77f1a045d66e4$export$b9a7f1ebeaa76953 = ()=>({
            type: 'error',
            ...(0, $jsurv.default)
        });
});
parcelRegister("jsurv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$973c51bdbf11215e$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    var $973c51bdbf11215e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
        title: {
            "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
            "defaultMessage": "Something\u2019s gone wrong"
        },
        description: {
            "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
            "defaultMessage": "You cannot star items right now due to an error."
        }
    });
});
parcelRegister("jvfW6", function(module, exports) {
    $parcel$export(module.exports, "ModalContextProvider", ()=>$3b08d5b0f7ce801d$export$7c9538f5f3c365e9);
    var $eUqFw = parcelRequire("eUqFw");
    var $eUJtf = parcelRequire("eUJtf");
    var $3qf87 = parcelRequire("3qf87");
    function $3b08d5b0f7ce801d$export$7c9538f5f3c365e9({ children: children }) {
        const id = (0, $eUqFw.useRef)(1);
        const [modals, setModals] = (0, $eUqFw.useState)([]);
        const modalContext = (0, $eUqFw.useMemo)(()=>({
                openModal: (component)=>{
                    const key = String(id.current++);
                    const close = ()=>{
                        setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                    };
                    setModals((mdls)=>[
                            ...mdls,
                            {
                                close: close,
                                component: component,
                                key: key
                            }
                        ]);
                }
            }), []);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3qf87.ModalContext).Provider, {
            value: modalContext
        }, children, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eUJtf.default), null, modals.map((modal)=>(0, ($parcel$interopDefault($eUqFw))).createElement(modal.component, {
                key: modal.key,
                onClose: modal.close
            }))));
    }
});
parcelRegister("3qf87", function(module, exports) {
    $parcel$export(module.exports, "ModalContext", ()=>$454708699096dc24$export$ab57792b9b6974a6);
    var $eUqFw = parcelRequire("eUqFw");
    const $454708699096dc24$export$ab57792b9b6974a6 = (0, $eUqFw.createContext)({
        openModal: ()=>{}
    });
});
parcelRegister("lbttE", function(module, exports) {
    $parcel$export(module.exports, "ProjectCreateDrawerProvider", ()=>$3fbad164cde8fff4$export$9a1c5dbd93c42bca);
    $parcel$export(module.exports, "ProjectCreateDrawerConsumer", ()=>$3fbad164cde8fff4$export$9a8662cd60931de1);
    $parcel$export(module.exports, "useProjectCreateDrawer", ()=>$3fbad164cde8fff4$export$8172ff4ed0f75a1e);
    var $eUqFw = parcelRequire("eUqFw");
    var $jG2Eu = parcelRequire("jG2Eu");
    var $9CmwD = parcelRequire("9CmwD");
    var $9EFi5 = parcelRequire("9EFi5");
    var $lB25E = parcelRequire("lB25E");
    var $cTTDV = parcelRequire("cTTDV");
    const $3fbad164cde8fff4$var$Context = (0, $eUqFw.createContext)({
        data: {
            shouldRenderDrawer: false,
            isOpen: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined
        },
        methods: {
            open: (0, ($parcel$interopDefault($jG2Eu))),
            close: (0, ($parcel$interopDefault($jG2Eu))),
            onSuccess: (0, ($parcel$interopDefault($jG2Eu))),
            onCreateStarted: (0, ($parcel$interopDefault($jG2Eu))),
            setOnCloseCallback: (0, ($parcel$interopDefault($jG2Eu))),
            clearOnCloseCallback: (0, ($parcel$interopDefault($jG2Eu)))
        }
    });
    const $3fbad164cde8fff4$export$839a70d8fbc9d356 = class ProjectCreateDrawerProvider extends (0, $eUqFw.Component) {
        render() {
            const { children: children } = this.props;
            const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId } = this.state;
            return (0, ($parcel$interopDefault($eUqFw))).createElement($3fbad164cde8fff4$var$Context.Provider, {
                value: {
                    data: {
                        isOpen: isOpen,
                        isNextGen: isNextGen,
                        source: source,
                        showExperienceSelection: showExperienceSelection,
                        shouldRenderDrawer: shouldRenderDrawer,
                        recommendedTemplate: recommendedTemplate,
                        defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                        isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                        isImportProjectOpenInitially: isImportProjectOpenInitially,
                        selectedProjectType: selectedProjectType,
                        recommendationSessionId: recommendationSessionId
                    },
                    methods: {
                        open: this.open,
                        close: this.close,
                        onSuccess: this.onSuccess,
                        onCreateStarted: this.onCreateStarted,
                        setOnCloseCallback: this.setOnCloseCallback,
                        clearOnCloseCallback: this.clearOnCloseCallback
                    }
                }
            }, children);
        }
        constructor(...args){
            super(...args);
            this.state = {
                isOpen: false,
                shouldRenderDrawer: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                isImportProjectOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined,
                onCloseCallback: (0, ($parcel$interopDefault($jG2Eu)))
            };
            this.onSuccess = (projectKey)=>{
                if (projectKey) {
                    this.props.setLocation(projectKey.returnUrl);
                    this.close(true);
                } else this.close(false);
            };
            this.setOnCloseCallback = (callback)=>{
                this.setState({
                    onCloseCallback: callback
                });
            };
            this.clearOnCloseCallback = ()=>{
                this.setState({
                    onCloseCallback: (0, ($parcel$interopDefault($jG2Eu)))
                });
            };
            this.open = (attributes = {})=>{
                this.setState({
                    isOpen: true,
                    shouldRenderDrawer: true,
                    ...attributes
                });
            };
            this.close = (projectCreated)=>{
                const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
                this.setState({
                    isOpen: false,
                    isNextGen: false,
                    showExperienceSelection: true,
                    recommendedTemplate: undefined,
                    defaultSelectedTemplateKey: '',
                    source: '',
                    isTemplatePickerOpenInitially: false,
                    isImportProjectOpenInitially: false,
                    selectedProjectType: null,
                    recommendationSessionId: undefined
                });
                if (callOnCloseCallBack) this.state.onCloseCallback();
            };
            this.closeOld = ()=>{
                this.setState({
                    isOpen: false,
                    isNextGen: false,
                    showExperienceSelection: true,
                    recommendedTemplate: undefined,
                    defaultSelectedTemplateKey: '',
                    source: '',
                    isTemplatePickerOpenInitially: false,
                    selectedProjectType: null,
                    recommendationSessionId: undefined
                });
                this.state.onCloseCallback();
            };
            this.onCreateStarted = (projectKey, templateKey)=>{
                if ((0, $9CmwD.getIsJsmBlankProjectTemplate)(templateKey)) (0, $9EFi5.LazyComponent).preload();
                (0, $cTTDV.clearResourcesAssociatedWithProjectKey)(projectKey);
            };
        }
    };
    const $3fbad164cde8fff4$export$9a1c5dbd93c42bca = (props)=>{
        const { push: push } = (0, $lB25E.useRouterActions)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement($3fbad164cde8fff4$export$839a70d8fbc9d356, {
            ...props,
            setLocation: push
        });
    };
    const { Consumer: $3fbad164cde8fff4$export$9a8662cd60931de1 } = $3fbad164cde8fff4$var$Context;
    $3fbad164cde8fff4$var$Context.displayName = 'ProjectCreateDrawerConsumer';
    const $3fbad164cde8fff4$export$8172ff4ed0f75a1e = ()=>{
        const projectCreateDrawer = (0, $eUqFw.useContext)($3fbad164cde8fff4$var$Context);
        if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
        return projectCreateDrawer;
    };
});
parcelRegister("9CmwD", function(module, exports) {
    $parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", ()=>$9672b8899ab98e98$export$f40a08fc76eb112d);
    $parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", ()=>$9672b8899ab98e98$export$e3844688f2693533);
    $parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", ()=>$9672b8899ab98e98$export$e3cec071fcb2fbd3);
    $parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", ()=>$9672b8899ab98e98$export$21783d461e3ef6d);
    $parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", ()=>$9672b8899ab98e98$export$6cd1c1b2ba0f6e2d);
    $parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", ()=>$9672b8899ab98e98$export$57d877f2e01e0029);
    $parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", ()=>$9672b8899ab98e98$export$6f4213a3addc3fdb);
    $parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", ()=>$9672b8899ab98e98$export$7492b6cc3ef89883);
    $parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$9672b8899ab98e98$export$7d9a4e0ef5194fe1);
    $parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$9672b8899ab98e98$export$477ca3550da12e43);
    $parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", ()=>$9672b8899ab98e98$export$b5ab111fb8825075);
    $parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$9672b8899ab98e98$export$14139f0ec41d437e);
    $parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$9672b8899ab98e98$export$ebf7af45376deb8b);
    $parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$9672b8899ab98e98$export$7b6945581ccdab4a);
    $parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$9672b8899ab98e98$export$310a9ac5c28d65f6);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$9672b8899ab98e98$export$4d29ee0c00eb5df4);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$9672b8899ab98e98$export$6278b41164dbde6c);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", ()=>$9672b8899ab98e98$export$17a2f771efabf02f);
    $parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", ()=>$9672b8899ab98e98$export$bd14946bcde77195);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", ()=>$9672b8899ab98e98$export$e8df553a3f519284);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", ()=>$9672b8899ab98e98$export$97fc32bd703bb4d1);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", ()=>$9672b8899ab98e98$export$8eecdf6acea9494);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", ()=>$9672b8899ab98e98$export$ff16be7794ed4222);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", ()=>$9672b8899ab98e98$export$9917830b560a2f4);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", ()=>$9672b8899ab98e98$export$b0928b02ffab3875);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", ()=>$9672b8899ab98e98$export$fd75f6abc7861439);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_TEAM_MANAGED_KEY", ()=>$9672b8899ab98e98$export$fb658bddae7f81bb);
    $parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", ()=>$9672b8899ab98e98$export$87a8fff98b5bc81);
    $parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", ()=>$9672b8899ab98e98$export$7c567eb725bd36f);
    $parcel$export(module.exports, "getIsJsmBlankProjectTemplate", ()=>$9672b8899ab98e98$export$73fd025e86012868);
    $parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", ()=>$9672b8899ab98e98$export$a062badd78c9993);
    const $9672b8899ab98e98$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
    const $9672b8899ab98e98$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
    const $9672b8899ab98e98$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
    const $9672b8899ab98e98$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
    const $9672b8899ab98e98$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
    const $9672b8899ab98e98$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
    const $9672b8899ab98e98$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
    const $9672b8899ab98e98$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
    const $9672b8899ab98e98$export$7d9a4e0ef5194fe1 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
    const $9672b8899ab98e98$export$477ca3550da12e43 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
    const $9672b8899ab98e98$export$7c0307155b744916 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
    const $9672b8899ab98e98$export$b5ab111fb8825075 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
    const $9672b8899ab98e98$export$14139f0ec41d437e = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
    const $9672b8899ab98e98$export$ebf7af45376deb8b = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
    const $9672b8899ab98e98$export$7b6945581ccdab4a = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
    const $9672b8899ab98e98$export$310a9ac5c28d65f6 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
    const $9672b8899ab98e98$export$136d17feb2f4285d = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
    const $9672b8899ab98e98$export$e288f4758e94a8cc = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
    const $9672b8899ab98e98$export$4e9ac1417ba54bba = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
    const $9672b8899ab98e98$export$560c9f6765bf9af4 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
    const $9672b8899ab98e98$export$14d4c6dbbb62a127 = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
    const $9672b8899ab98e98$export$1367ee12532c525f = `${$9672b8899ab98e98$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
    const $9672b8899ab98e98$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
    const $9672b8899ab98e98$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
    const $9672b8899ab98e98$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
    const $9672b8899ab98e98$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
    const $9672b8899ab98e98$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
    const $9672b8899ab98e98$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
    const $9672b8899ab98e98$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
    const $9672b8899ab98e98$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
    const $9672b8899ab98e98$export$9e38ad41d19608ee = 'jsm.blank-service-management';
    const $9672b8899ab98e98$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
    const $9672b8899ab98e98$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
    const $9672b8899ab98e98$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
    const $9672b8899ab98e98$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
    const $9672b8899ab98e98$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
    const $9672b8899ab98e98$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
    const $9672b8899ab98e98$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
    const $9672b8899ab98e98$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
    const $9672b8899ab98e98$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
    const $9672b8899ab98e98$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
    const $9672b8899ab98e98$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
    const $9672b8899ab98e98$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
    const $9672b8899ab98e98$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
    const $9672b8899ab98e98$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
    const $9672b8899ab98e98$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
    const $9672b8899ab98e98$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
    const $9672b8899ab98e98$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
    const $9672b8899ab98e98$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
    const $9672b8899ab98e98$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
    const $9672b8899ab98e98$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
    const $9672b8899ab98e98$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
    const $9672b8899ab98e98$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
    const $9672b8899ab98e98$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
    const $9672b8899ab98e98$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
    const $9672b8899ab98e98$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
    const $9672b8899ab98e98$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
    const $9672b8899ab98e98$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
    const $9672b8899ab98e98$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
    const $9672b8899ab98e98$export$87a8fff98b5bc81 = 'initial.project.template.name';
    const $9672b8899ab98e98$export$7c567eb725bd36f = 'jira.polaris:discovery';
    const $9672b8899ab98e98$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
    const $9672b8899ab98e98$export$f9776303073903dd = 'jira.polaris:roadmap';
    const $9672b8899ab98e98$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
    const $9672b8899ab98e98$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $9672b8899ab98e98$export$e8df553a3f519284 || T4JTemplateKey === $9672b8899ab98e98$export$8eecdf6acea9494 || T4JTemplateKey === $9672b8899ab98e98$export$9e38ad41d19608ee;
    const $9672b8899ab98e98$export$a062badd78c9993 = {
        [$9672b8899ab98e98$export$e82092c4fb277f9b]: $9672b8899ab98e98$export$b0928b02ffab3875,
        [$9672b8899ab98e98$export$fd75f6abc7861439]: $9672b8899ab98e98$export$b0928b02ffab3875,
        [$9672b8899ab98e98$export$5eddf3b31dd1858f]: $9672b8899ab98e98$export$50478ee5ecbf7a4d,
        [$9672b8899ab98e98$export$fb658bddae7f81bb]: $9672b8899ab98e98$export$50478ee5ecbf7a4d
    };
});
parcelRegister("9EFi5", function(module, exports) {
    $parcel$export(module.exports, "LazyComponent", ()=>$6ae11cc3f6e45a93$export$31f1740ae531af94);
    $parcel$export(module.exports, "AsyncProjectBuilderDrawer", ()=>$6ae11cc3f6e45a93$export$54a4eade9eae9473);
    $parcel$export(module.exports, "canUseProjectBuilder", ()=>$6ae11cc3f6e45a93$export$ff317c5d87147a19);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $0cdA8 = parcelRequire("0cdA8");
    var $gGtKh = parcelRequire("gGtKh");
    var $iVSJI = parcelRequire("iVSJI");
    const $6ae11cc3f6e45a93$export$31f1740ae531af94 = (0, $56koX.lazy)(()=>(parcelRequire("hig9W")), {
        ssr: false,
        moduleId: "./src/packages/servicedesk/project-builder/src/ui/index.tsx"
    });
    const $6ae11cc3f6e45a93$export$54a4eade9eae9473 = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "bundle-async-project-builder",
            packageName: "jira-servicedesk-project-builder",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            fallback: null,
            name: "jsm-project-builder"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iVSJI.ServiceDeskAnalyticsContext), null, (0, ($parcel$interopDefault($eUqFw))).createElement($6ae11cc3f6e45a93$export$31f1740ae531af94, {
            isOpenInitial: !!props.isOpenInitial,
            ...props
        }))));
    const $6ae11cc3f6e45a93$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;
});
parcelRegister("iVSJI", function(module, exports) {
    $parcel$export(module.exports, "ServiceDeskAnalyticsContext", ()=>$98f32c00711ff158$export$ac31f8f3368d6881);
    var $eUqFw = parcelRequire("eUqFw");
    var $8WuJm = parcelRequire("8WuJm");
    var $SEaoU = parcelRequire("SEaoU");
    var $kJ81T = parcelRequire("kJ81T");
    const $98f32c00711ff158$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
        const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
        const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
        if ((0, $eUqFw.Children).count(children) > 0) {
            const loading = containerContextLoading || analyticsContextLoading;
            const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
            if (!shouldRenderChildren) return null;
            const context = {};
            if (containerContextData && containerContextData.project) {
                const { id: id, type: type } = containerContextData.project;
                context.containerType = 'project';
                context.containerId = `${id}`;
                context.containers = {
                    project: {
                        id: `${id}`,
                        type: type
                    }
                };
                if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
            }
            return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), context, children);
        }
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, children);
    };
    $98f32c00711ff158$export$ac31f8f3368d6881.defaultProps = {
        forceRenderWhileLoading: false,
        useServiceDeskAnalyticsContext: (0, $kJ81T.useServiceDeskAnalyticsContext),
        useContainerContext: (0, $SEaoU.useContainerContext)
    };
});
parcelRegister("kJ81T", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskAnalyticsContextResource", ()=>$f5a87dd3d6d3f919$export$d6f4f0483916919f);
    $parcel$export(module.exports, "useServiceDeskAnalyticsContext", ()=>$f5a87dd3d6d3f919$export$bc2de1c42df30b10);
    var $eUqFw = parcelRequire("eUqFw");
    var $8hg3R = parcelRequire("8hg3R");
    var $lB25E = parcelRequire("lB25E");
    const $f5a87dd3d6d3f919$var$getDataLoader = ()=>(parcelRequire("jmi1c"));
    const $f5a87dd3d6d3f919$var$ONE_DAY_IN_MILLIS = 86400000;
    const $f5a87dd3d6d3f919$export$d6f4f0483916919f = (0, $lB25E.createResource)({
        type: (0, $76d1e4a47c4d6ee4$export$285b47583a5bdd0f),
        getKey: ({ match: match })=>(0, $8hg3R.getProjectKeyOrId)(match),
        getDataLoader: $f5a87dd3d6d3f919$var$getDataLoader,
        maxAge: $f5a87dd3d6d3f919$var$ONE_DAY_IN_MILLIS
    });
    const $f5a87dd3d6d3f919$export$bc2de1c42df30b10 = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $lB25E.useResource)($f5a87dd3d6d3f919$export$d6f4f0483916919f);
        (0, $eUqFw.useEffect)(()=>{
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            error,
            refresh
        ]);
        return (0, $eUqFw.useMemo)(()=>({
                data: data,
                loading: loading,
                error: error
            }), [
            data,
            loading,
            error
        ]);
    };
});
parcelRegister("8hg3R", function(module, exports) {
    $parcel$export(module.exports, "getProjectKeyOrId", ()=>$07950346cbbaf790$export$43cde151f667c69e);
    $parcel$export(module.exports, "getProjectKeyOrIdFromMatchAndQuery", ()=>$07950346cbbaf790$export$b87af5b274141bd6);
    var $9zYls = parcelRequire("9zYls");
    const $07950346cbbaf790$export$43cde151f667c69e = (match)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, match.query);
        return projectKey || projectId || '';
    };
    const $07950346cbbaf790$export$b87af5b274141bd6 = ({ match: match, query: query })=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
});
const $76d1e4a47c4d6ee4$export$285b47583a5bdd0f = 'SERVICEDESK_ANALYTICS_CONTEXT';
parcelRegister("jmi1c", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("6G5Ft").then(()=>parcelRequire('eUv3W'));
});
parcelRegister("hig9W", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("eNmuD"),
        $d1Cng("kWrFZ"),
        $d1Cng("92sUi"),
        $d1Cng("i5RRW"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("6Nc34")
    ]).then(()=>parcelRequire('1USrr'));
});
parcelRegister("cTTDV", function(module, exports) {
    $parcel$export(module.exports, "clearResourcesAssociatedWithProjectKey", ()=>$6e401ba3b3d297e1$export$c0c81c1828c7638c);
    var $guiFP = parcelRequire("guiFP");
    var $lB25E = parcelRequire("lB25E");
    const $6e401ba3b3d297e1$export$c0c81c1828c7638c = (projectKey)=>{
        try {
            const { storeState: storeState } = (0, $lB25E.getResourceStore)();
            const prevState = storeState.getState();
            storeState.setState({
                ...prevState,
                data: Object.fromEntries(Object.entries(prevState?.data).map(([resourceType, value])=>{
                    const { [projectKey]: _, ...rest } = value;
                    return [
                        resourceType,
                        rest
                    ];
                }))
            });
        } catch (e) {
            (0, $guiFP.default)({
                meta: {
                    id: 'clearResourcesAssociatedWithProjectKey',
                    packageName: 'jiraProjectCreateDrawerContext',
                    teamName: 'helix'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: e instanceof Error ? e : new Error('Error occured in clearResourcesAssociatedWithProjectKey')
            });
        }
    };
});
parcelRegister("f9UOp", function(module, exports) {
    $parcel$export(module.exports, "UserContainers", ()=>$8d4848b02de0c2ee$export$c1b371eec908681a);
    var $eUqFw = parcelRequire("eUqFw");
    var $6L2se = parcelRequire("6L2se");
    var $lGLse = parcelRequire("lGLse");
    const $8d4848b02de0c2ee$export$c1b371eec908681a = ({ baseUrl: baseUrl, children: children })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lGLse.UserContainer), {
            isGlobal: true,
            baseUrl: baseUrl
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6L2se.UserPreferencesContainer), {
            isGlobal: true
        }, children));
});
parcelRegister("6L2se", function(module, exports) {
    $parcel$export(module.exports, "UserPreferencesContainer", ()=>$39c7f00c5ab3f451$export$aa278641ded1adf);
    var $WBLbN = parcelRequire("WBLbN");
    var $dsC4d = parcelRequire("dsC4d");
    const $39c7f00c5ab3f451$export$be74e04eaea4530 = (0, $WBLbN.createSubscriber)((0, $dsC4d.default), {
        displayName: 'UserPreferencesSubscriber'
    });
    const $39c7f00c5ab3f451$export$aa278641ded1adf = (0, $WBLbN.createContainer)((0, $dsC4d.default));
});
parcelRegister("dsC4d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$961f40ab8b3e4548$export$2e2bcd8739ae039);
    var $WBLbN = parcelRequire("WBLbN");
    var $9z14H = parcelRequire("9z14H");
    const $961f40ab8b3e4548$var$initialState = {
        'issue-view-experiment': {
            data: {
                value: false
            },
            loading: false,
            error: null
        }
    };
    var $961f40ab8b3e4548$export$2e2bcd8739ae039 = (0, $WBLbN.createStore)({
        name: 'user-preference',
        initialState: $961f40ab8b3e4548$var$initialState,
        actions: $9z14H
    });
});
parcelRegister("9z14H", function(module, exports) {
    $parcel$export(module.exports, "fetch", ()=>(parcelRequire("h9epI")).default);
    $parcel$export(module.exports, "fetchIssueCreate", ()=>(parcelRequire("7Pq3h")).default);
    $parcel$export(module.exports, "updateExperiment", ()=>(parcelRequire("bZIav")).default);
    var $h9epI = parcelRequire("h9epI");
    var $7Pq3h = parcelRequire("7Pq3h");
    var $bZIav = parcelRequire("bZIav");
});
parcelRegister("h9epI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3fe76d2a970114ff$export$2e2bcd8739ae039);
    var $h5sT2 = parcelRequire("h5sT2");
    var $3fe76d2a970114ff$export$2e2bcd8739ae039 = (preferenceKey)=>async ({ setState: setState, getState: getState }, { baseUrl: baseUrl })=>{
            const currentState = getState();
            if (currentState[preferenceKey] && currentState[preferenceKey].loading) return;
            setState({
                [preferenceKey]: {
                    data: currentState.data,
                    loading: true,
                    error: null
                }
            });
            try {
                const data = await (0, $h5sT2.default)({
                    baseUrl: baseUrl,
                    preferenceKey: preferenceKey
                });
                setState({
                    [preferenceKey]: {
                        data: data,
                        loading: false,
                        error: null
                    }
                });
            } catch (err) {
                setState({
                    [preferenceKey]: {
                        data: getState().data,
                        loading: false,
                        error: err
                    }
                });
            }
        };
});
parcelRegister("h5sT2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63687d4b54057aad$export$2e2bcd8739ae039);
    var $9CiFV = parcelRequire("9CiFV");
    var $63687d4b54057aad$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, preferenceKey: preferenceKey })=>{
        try {
            const result = await (0, $9CiFV.default)(baseUrl, preferenceKey);
            return {
                value: result
            };
        } catch (e) {
            if (e.statusCode === 404) return {
                value: undefined
            };
            throw e;
        }
    };
});
parcelRegister("9CiFV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca4afe9581c5212d$export$2e2bcd8739ae039);
    var $lRmyA = parcelRequire("lRmyA");
    var $ca4afe9581c5212d$export$2e2bcd8739ae039 = (baseUrl, key)=>{
        const requestUrl = `${baseUrl}/rest/api/3/mypreferences?key=${key}`;
        return (0, $lRmyA.performGetRequest)(requestUrl);
    };
});
parcelRegister("7Pq3h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5c5efcd31332e13$export$2e2bcd8739ae039);
    var $h9epI = parcelRequire("h9epI");
    var $f5c5efcd31332e13$export$2e2bcd8739ae039 = ()=>(0, $h9epI.default)('issue-create');
});
parcelRegister("bZIav", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1122b82eba9b9cfc$export$2e2bcd8739ae039);
    var $1122b82eba9b9cfc$export$2e2bcd8739ae039 = (experimentKey, value)=>({ setState: setState })=>{
            setState({
                [experimentKey]: {
                    data: {
                        value: value
                    },
                    loading: false,
                    error: null
                }
            });
        };
});
parcelRegister("kqXZB", function(module, exports) {
    $parcel$export(module.exports, "HorizontalNav", ()=>$cf6ef4bc9cecc99d$export$3821fe730064297d);
    $parcel$export(module.exports, "HorizontalNavWrapper", ()=>$cf6ef4bc9cecc99d$export$8798384053a023ae);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $dWu0t = parcelRequire("dWu0t");
    var $dJOhP = parcelRequire("dJOhP");
    var $ghXjN = parcelRequire("ghXjN");
    const $cf6ef4bc9cecc99d$var$NavErrorBoundaryFallback = ()=>null;
    const $cf6ef4bc9cecc99d$export$3821fe730064297d = ()=>{
        const HorizontalNavComponent = (0, $dWu0t.useHorizontalNavComponent)();
        return HorizontalNavComponent && $eUqFw.createElement((0, $dJOhP.NavErrorBoundary), {
            packageName: "page-container",
            id: "spa-horizontal-nav",
            fallback: $cf6ef4bc9cecc99d$var$NavErrorBoundaryFallback
        }, $eUqFw.createElement((0, $dJOhP.NavErrorBoundary), {
            packageName: "page-container",
            id: "projectNavigationSkipLink",
            fallback: "unmount"
        }, $eUqFw.createElement((0, $ghXjN.ProjectViewNavigationSkipLink), null)), $eUqFw.createElement(HorizontalNavComponent, null));
    };
    const $cf6ef4bc9cecc99d$export$8798384053a023ae = ({ children: children, navComponent: HorizontalNavComponent })=>{
        return $eUqFw.createElement($cf6ef4bc9cecc99d$var$ThemedContainer, null, $eUqFw.createElement((0, $dJOhP.NavErrorBoundary), {
            packageName: "page-container",
            id: "spa-horizontal-nav",
            fallback: $cf6ef4bc9cecc99d$var$NavErrorBoundaryFallback
        }, $eUqFw.createElement((0, $dJOhP.NavErrorBoundary), {
            packageName: "page-container",
            id: "projectNavigationSkipLink",
            fallback: "unmount"
        }, $eUqFw.createElement((0, $ghXjN.ProjectViewNavigationSkipLink), null)), $eUqFw.createElement(HorizontalNavComponent, null)), children);
    };
    const $cf6ef4bc9cecc99d$var$ThemedContainer = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $eUqFw.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_11q71o10 _11q31r52 _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dJOhP", function(module, exports) {
    $parcel$export(module.exports, "NavErrorBoundary", ()=>$fc92a101a1384c46$export$afc779e659fd533f);
    var $eUqFw = parcelRequire("eUqFw");
    var $0cdA8 = parcelRequire("0cdA8");
    var $guiFP = parcelRequire("guiFP");
    var $9zysr = parcelRequire("9zysr");
    var $eI5EY = parcelRequire("eI5EY");
    var $6FP8W = parcelRequire("6FP8W");
    function $fc92a101a1384c46$export$35c1e8d8e59e87e7() {
        return [
            [
                'jira_nav4',
                (0, $eI5EY.fg)('jira_nav4')
            ],
            [
                'jira_nav4_dogfooding',
                (0, $eI5EY.fg)('jira_nav4_dogfooding')
            ],
            [
                'jira_nav4_dogfooding_phase-1',
                (0, $eI5EY.fg)('jira_nav4_dogfooding_phase-1')
            ],
            [
                'jira_nav4_dogfooding_phase-2',
                (0, $eI5EY.fg)('jira_nav4_dogfooding_phase-2')
            ]
        ];
    }
    const $fc92a101a1384c46$export$1d1321d2b374d697 = ()=>{
        if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
        if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
        return false;
    };
    function $fc92a101a1384c46$var$inferNavRevision() {
        return (0, $6FP8W.getWillShowNav4)() ? 'v4' : 'v3';
    }
    function $fc92a101a1384c46$var$getExtraAttributes(_error) {
        const attributes = {
            ffs: $fc92a101a1384c46$export$35c1e8d8e59e87e7().filter(([, value])=>value).map(([key])=>key).join(),
            rev: $fc92a101a1384c46$var$inferNavRevision()
        };
        return attributes;
    }
    function $fc92a101a1384c46$var$getAnalyticsPayload(error, meta, navRevision) {
        const payload = {
            error: error,
            meta: {
                id: 'logic',
                packageName: 'JiraNav'
            },
            attributes: {
                ...$fc92a101a1384c46$var$getExtraAttributes(error),
                pkg: meta.packageName,
                id: meta.id,
                ...navRevision && {
                    rev: navRevision
                }
            },
            skipSentry: true
        };
        return payload;
    }
    const $fc92a101a1384c46$export$5ac21f1e947e70d6 = (props)=>{
        const { id: id, packageName: packageName, navRevision: navRevision } = props;
        const onError = (0, $eUqFw.useMemo)(()=>{
            const meta = {
                id: id,
                packageName: packageName
            };
            const _onError = (...args)=>{
                if ($fc92a101a1384c46$export$1d1321d2b374d697()) return;
                const [_, error] = args;
                (0, $guiFP.default)($fc92a101a1384c46$var$getAnalyticsPayload(error, meta, navRevision));
            };
            return _onError;
        }, [
            id,
            packageName,
            navRevision
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            ...props,
            onError: onError
        });
    };
    const $fc92a101a1384c46$export$afc779e659fd533f = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement($fc92a101a1384c46$export$5ac21f1e947e70d6, props), (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), props));
});
parcelRegister("ghXjN", function(module, exports) {
    $parcel$export(module.exports, "TopNavigationSkipLink", ()=>$e6fff404e2b2ee46$export$47de2191d46337b7);
    $parcel$export(module.exports, "LeftSidebarSkipLink", ()=>$e6fff404e2b2ee46$export$46697df0d7c5e8be);
    $parcel$export(module.exports, "ProjectViewNavigationSkipLink", ()=>$e6fff404e2b2ee46$export$2e2fc9c237996c06);
    $parcel$export(module.exports, "MainContentSkipLink", ()=>$e6fff404e2b2ee46$export$b1498dd122ea3284);
    var $5JgJ2 = parcelRequire("5JgJ2");
    var $hwyJ1 = parcelRequire("hwyJ1");
    var $16pq9 = parcelRequire("16pq9");
    const $e6fff404e2b2ee46$export$47de2191d46337b7 = ()=>{
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        (0, $hwyJ1.useCustomSkipLink)('ak-jira-navigation', formatMessage((0, $16pq9.default).skipToJiraNavigation), 0);
        return null;
    };
    const $e6fff404e2b2ee46$export$46697df0d7c5e8be = ()=>{
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        (0, $hwyJ1.useCustomSkipLink)('ak-side-navigation', formatMessage((0, $16pq9.default).skipToSideNavigation), 1);
        return null;
    };
    const $e6fff404e2b2ee46$export$2e2fc9c237996c06 = ()=>{
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        (0, $hwyJ1.useCustomSkipLink)('ak-project-view-navigation', formatMessage((0, $16pq9.default).skipToProjectViewNavigation), 2);
        return null;
    };
    const $e6fff404e2b2ee46$export$b1498dd122ea3284 = ()=>{
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        (0, $hwyJ1.useCustomSkipLink)('ak-main-content', formatMessage((0, $16pq9.default).skipToMainContent), 3);
        return null;
    };
});
parcelRegister("16pq9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$28122dc87949ce0e$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    var $28122dc87949ce0e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
        skipToJiraNavigation: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-jira-navigation",
            "defaultMessage": "Skip to Jira Navigation"
        },
        skipToSideNavigation: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-side-navigation",
            "defaultMessage": "Skip to Side Navigation"
        },
        skipToProjectViewNavigation: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-project-view-navigation",
            "defaultMessage": "Skip to View Navigation"
        },
        skipToMainContent: {
            "id": "page-container-v2.common.page-container.page-container-skip-links.skip-to-main-content",
            "defaultMessage": "Skip to Main Content"
        }
    });
});
parcelRegister("l8xBK", function(module, exports) {
    $parcel$export(module.exports, "RightSidebar", ()=>$e236e5cdaab70156$export$84d58c19c21f637f);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $iWLL0 = parcelRequire("iWLL0");
    var $1FAd1 = parcelRequire("1FAd1");
    var $8R80x = parcelRequire("8R80x");
    var $0cdA8 = parcelRequire("0cdA8");
    var $1ybV0 = parcelRequire("1ybV0");
    var $9zysr = parcelRequire("9zysr");
    var $bUi2Q = parcelRequire("bUi2Q");
    var $6FP8W = parcelRequire("6FP8W");
    var $hwyJ1 = parcelRequire("hwyJ1");
    var $10fdS = parcelRequire("10fdS");
    var $jMP2a = parcelRequire("jMP2a");
    var $1inzG = parcelRequire("1inzG");
    var $isbb2 = parcelRequire("isbb2");
    var $bQiKj = parcelRequire("bQiKj");
    var $2uiE3 = parcelRequire("2uiE3");
    var $jK1pm = parcelRequire("jK1pm");
    const $e236e5cdaab70156$var$TEST_ID = 'page-layout.aside';
    const $e236e5cdaab70156$var$routeComponents = [];
    const $e236e5cdaab70156$var$SharedRightSidebars = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, $isbb2.renderGlobalComponents)((0, $bQiKj.sharedLayout).rightSidebars));
    const $e236e5cdaab70156$var$RightSidebarRouteComponents = ()=>{
        const route = (0, $10fdS.useCurrentRoute)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, $isbb2.renderGlobalComponents)(route.layout?.rightSidebars || $e236e5cdaab70156$var$routeComponents));
    };
    const $e236e5cdaab70156$var$RightSidebarThroughEntrypoint = ()=>{
        const rightSideBarEntryPoint = (0, $1FAd1.usePageLayoutEntryPoint)((0, $d619e185f38e9ae8$export$7bf43119a6b49ddb));
        const route = (0, $10fdS.useCurrentRoute)();
        const entrypoint = (0, $eUqFw.useMemo)(()=>route.entryPoint?.(), [
            route
        ]);
        if (!entrypoint || !rightSideBarEntryPoint) return null;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "right-sidebar-through-entrypoint"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-through-entrypoint",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholder), {
            name: "right-sidebar-through-entrypoint",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $2uiE3.ProjectListSidebarSkeleton), null),
            entryPoint: entrypoint
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
            entryPointReference: rightSideBarEntryPoint,
            props: {}
        }))));
    };
    const $e236e5cdaab70156$var$NewRightSidebar = ()=>{
        const lastPanelIdRef = (0, $eUqFw.useRef)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
        (0, $eUqFw.useEffect)(()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
                panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
                isClosed: rightSidebarCurrentState?.panelId == null,
                isMinimised: !!rightSidebarCurrentState?.isMinimised,
                isCollapsed: !!rightSidebarCurrentState?.isCollapsed
            });
            lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
        }, [
            createAnalyticsEvent,
            rightSidebarCurrentState?.panelId,
            rightSidebarCurrentState?.isMinimised,
            rightSidebarCurrentState?.isCollapsed
        ]);
        if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "right-sidebar"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.RightSidebar), {
            width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0,
            testId: $e236e5cdaab70156$var$TEST_ID
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            fallback: "unmount",
            id: "shared-right-sidebars",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$SharedRightSidebars, null)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-route-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$RightSidebarRouteComponents, null)), (0, $1ybV0.ff)('server-render-projects-directory-sidebar_rj9ki') && (0, ($parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$RightSidebarThroughEntrypoint, null))));
    };
    const $e236e5cdaab70156$var$OldRightSidebar = ()=>{
        const lastPanelIdRef = (0, $eUqFw.useRef)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        const rightSidebarCurrentState = (0, $bUi2Q.useActiveRightSidebarState)();
        (0, $eUqFw.useEffect)(()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'rightSidebar change', {
                panelId: rightSidebarCurrentState?.panelId || lastPanelIdRef.current,
                isClosed: rightSidebarCurrentState?.panelId == null,
                isMinimised: !!rightSidebarCurrentState?.isMinimised,
                isCollapsed: !!rightSidebarCurrentState?.isCollapsed
            });
            lastPanelIdRef.current = rightSidebarCurrentState?.panelId;
        }, [
            createAnalyticsEvent,
            rightSidebarCurrentState?.panelId,
            rightSidebarCurrentState?.isMinimised,
            rightSidebarCurrentState?.isCollapsed
        ]);
        if (rightSidebarCurrentState && !rightSidebarCurrentState.shouldRender) return null;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "right-sidebar"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$RightSidebarPanelWrapper, {
            id: "right-sidebar-panel-wrapper"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.RightSidebar), {
            width: rightSidebarCurrentState && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised ? rightSidebarCurrentState.width : 0
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            fallback: "unmount",
            id: "shared-right-sidebars",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$SharedRightSidebars, null)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-route-components",
            packageName: "page-container"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$RightSidebarRouteComponents, null)), (0, $1ybV0.ff)('server-render-projects-directory-sidebar_rj9ki') && (0, ($parcel$interopDefault($eUqFw))).createElement($e236e5cdaab70156$var$RightSidebarThroughEntrypoint, null)))));
    };
    const $e236e5cdaab70156$var$RightSidebarPanelWrapper = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_1e0c1bgi _1ej2b4wl _iu1g1fl4",
                __cmplp.className
            ])
        });
    });
    const $e236e5cdaab70156$export$84d58c19c21f637f = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $e236e5cdaab70156$var$NewRightSidebar, $e236e5cdaab70156$var$OldRightSidebar);
});
parcelRegister("1FAd1", function(module, exports) {
    $parcel$export(module.exports, "usePageLayoutEntryPoint", ()=>$569433a5f969d51a$export$fe1c839e8baf4110);
    var $399tN = parcelRequire("399tN");
    var $10fdS = parcelRequire("10fdS");
    const $569433a5f969d51a$export$fe1c839e8baf4110 = (layoutField)=>{
        const route = (0, $10fdS.useCurrentRoute)();
        const entryPointReference = (0, $399tN.useRouteEntryPoint)({
            route: route
        });
        return entryPointReference?.entryPoints[layoutField];
    };
});
parcelRegister("399tN", function(module, exports) {
    $parcel$export(module.exports, "useRouteEntryPoint", ()=>$94d21b8ebec2d194$export$c96377f800cdddb4);
    var $gglAH = parcelRequire("gglAH");
    const $94d21b8ebec2d194$export$c96377f800cdddb4 = ({ route: route })=>{
        const [lastLoadedRoute] = (0, $gglAH.useLastLoadedRoute)();
        if (lastLoadedRoute && lastLoadedRoute.entryPointReference && lastLoadedRoute.route === route) return lastLoadedRoute.entryPointReference;
        return null;
    };
});
parcelRegister("gglAH", function(module, exports) {
    $parcel$export(module.exports, "useLastLoadedRoute", ()=>$200515d1f24b1bb9$export$895238443fc3eae4);
    $parcel$export(module.exports, "getEntryPointsStore", ()=>$200515d1f24b1bb9$export$fe654a734624d17f);
    $parcel$export(module.exports, "getLastLoadedRoute", ()=>$200515d1f24b1bb9$export$5763b2305b3056df);
    $parcel$export(module.exports, "getPrefetchingRoute", ()=>$200515d1f24b1bb9$export$7e18f3e3cbd04326);
    var $WBLbN = parcelRequire("WBLbN");
    const $200515d1f24b1bb9$export$1cec83a23d40a9fa = ({ route: route, entryPointReference: entryPointReference })=>({ setState: setState })=>{
            setState({
                lastLoadedRoute: {
                    route: route,
                    entryPointReference: entryPointReference
                }
            });
        };
    const $200515d1f24b1bb9$export$bb3dc9c55f78173e = ({ routerContext: routerContext, entryPointReference: entryPointReference, expiresAt: expiresAt })=>({ setState: setState })=>{
            setState({
                prefetchingRoute: {
                    routerContext: routerContext,
                    expiresAt: expiresAt,
                    entryPointReference: entryPointReference
                }
            });
        };
    const $200515d1f24b1bb9$var$actions = {
        setLastLoadedRoute: $200515d1f24b1bb9$export$1cec83a23d40a9fa,
        setPrefetchingRoute: $200515d1f24b1bb9$export$bb3dc9c55f78173e
    };
    const $200515d1f24b1bb9$var$EntryPointsStore = (0, $WBLbN.createStore)({
        initialState: {
            lastLoadedRoute: null,
            prefetchingRoute: null
        },
        actions: $200515d1f24b1bb9$var$actions,
        name: 'react-resource-router/entry-points'
    });
    const $200515d1f24b1bb9$export$895238443fc3eae4 = (0, $WBLbN.createHook)($200515d1f24b1bb9$var$EntryPointsStore, {
        selector: (state)=>state.lastLoadedRoute
    });
    const $200515d1f24b1bb9$export$fe654a734624d17f = ()=>(0, $WBLbN.defaultRegistry).getStore($200515d1f24b1bb9$var$EntryPointsStore);
    const $200515d1f24b1bb9$export$b28ecd0e4705f6b7 = ()=>$200515d1f24b1bb9$export$fe654a734624d17f().storeState.getState();
    const $200515d1f24b1bb9$export$5763b2305b3056df = ()=>$200515d1f24b1bb9$export$b28ecd0e4705f6b7().lastLoadedRoute;
    const $200515d1f24b1bb9$export$7e18f3e3cbd04326 = ()=>$200515d1f24b1bb9$export$b28ecd0e4705f6b7().prefetchingRoute;
});
const $d619e185f38e9ae8$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $d619e185f38e9ae8$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $d619e185f38e9ae8$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $d619e185f38e9ae8$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $d619e185f38e9ae8$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';
parcelRegister("2uiE3", function(module, exports) {
    $parcel$export(module.exports, "ProjectListSidebarSkeleton", ()=>$7cd5cfa2bb5d5ee4$export$808c25bcc6102427);
    var $7JEyt = parcelRequire("7JEyt");
    var $eUqFw = parcelRequire("eUqFw");
    var $8ICxF = parcelRequire("8ICxF");
    var $hn0yl = parcelRequire("hn0yl");
    const $7cd5cfa2bb5d5ee4$var$customCssStyles = null;
    const $7cd5cfa2bb5d5ee4$var$sidebarCssStyles = null;
    const $7cd5cfa2bb5d5ee4$export$808c25bcc6102427 = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                "_4t3i1osq _1bsb1gwv _1yt41ejb _1kl71hdd _1h6db5v6 _bfhkvuon _vchhusvi"
            ])
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8ICxF.AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($hn0yl))),
            className: (0, $7JEyt.default)([
                "_t6vdidpf _hr4jidpf"
            ])
        }));
});
parcelRegister("8ICxF", function(module, exports) {
    $parcel$export(module.exports, "AppSkeletonImage", ()=>$f467e6485d9792e8$export$45b107c5dc7b51a5);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $5JgJ2 = parcelRequire("5JgJ2");
    var $i4dIm = parcelRequire("i4dIm");
    var $h1hCM = parcelRequire("h1hCM");
    const $f467e6485d9792e8$var$skeletonImageStyles = null;
    const $f467e6485d9792e8$export$45b107c5dc7b51a5 = ({ src: src, className: className, containerStyles: containerStyles })=>{
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $i4dIm.default), {
            name: "app-skeleton"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($f467e6485d9792e8$var$SkeletonWrapper, {
            style: containerStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement("img", {
            src: src,
            alt: `${formatMessage((0, $h1hCM.default).loading)}...`,
            className: (0, $7JEyt.default)([
                "_1e0c1ule _vchhusvi _1bsb1osq _1dqonqa1 _1h6d3acm _t6vd1ylp _hr4j1ylp _l82tgktf _j7o0gktf",
                className
            ])
        })));
    };
    const $f467e6485d9792e8$var$SkeletonWrapper = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _yksp1ssb _1b421ssb _s8ks18ws _u1wz1nty",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("h1hCM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0b5b2a6284984f9f$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    var $0b5b2a6284984f9f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
        loading: {
            "id": "skeletons.common.loading",
            "defaultMessage": "Loading"
        }
    });
});
parcelRegister("hn0yl", function(module, exports) {
    module.exports = new URL("project-list-sidebar-app-skeleton.tpl.35da4e26.svg", import.meta.url).toString();
});
parcelRegister("eymfV", function(module, exports) {
    $parcel$export(module.exports, "Sidebar", ()=>$fa1d85c5358105db$export$1ba59dacbcbf90fe);
    var $bckG1 = parcelRequire("bckG1");
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $9t7rW = parcelRequire("9t7rW");
    var $hTLlD = parcelRequire("hTLlD");
    var $iWLL0 = parcelRequire("iWLL0");
    var $jGR8u = parcelRequire("jGR8u");
    var $fHiYa = parcelRequire("fHiYa");
    var $8fxTv = parcelRequire("8fxTv");
    var $7webZ = parcelRequire("7webZ");
    var $c9TLT = parcelRequire("c9TLT");
    var $0cdA8 = parcelRequire("0cdA8");
    var $9zysr = parcelRequire("9zysr");
    var $4ksts = parcelRequire("4ksts");
    var $kpmC0 = parcelRequire("kpmC0");
    var $53ucm = parcelRequire("53ucm");
    var $7zhpa = parcelRequire("7zhpa");
    var $u0mbR = parcelRequire("u0mbR");
    var $7BqbB = parcelRequire("7BqbB");
    var $kpmO3 = parcelRequire("kpmO3");
    var $6FP8W = parcelRequire("6FP8W");
    var $bdfGI = parcelRequire("bdfGI");
    var $4QXXR = parcelRequire("4QXXR");
    var $hwyJ1 = parcelRequire("hwyJ1");
    var $2W91Z = parcelRequire("2W91Z");
    var $gGtKh = parcelRequire("gGtKh");
    var $10fdS = parcelRequire("10fdS");
    var $buJlM = parcelRequire("buJlM");
    var $inC6u = parcelRequire("inC6u");
    var $8C1im = parcelRequire("8C1im");
    var $6yplV = parcelRequire("6yplV");
    var $jK1pm = parcelRequire("jK1pm");
    var $4rBDy = parcelRequire("4rBDy");
    var $2EYbt = parcelRequire("2EYbt");
    var $ghXjN = parcelRequire("ghXjN");
    var $2D8YV = parcelRequire("2D8YV");
    var $j6voN = parcelRequire("j6voN");
    const $fa1d85c5358105db$var$SidebarNew = ()=>{
        const isAnonymous = (0, $6yplV.useIsAnonymous)();
        const { queryReference: queryReference } = (0, $buJlM.useRelayResource)((0, $7zhpa.sidebarNav4UiStateResource));
        if (isAnonymous) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "nav4.sidebar.anonymous"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "sidebar.anonymous"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($fa1d85c5358105db$var$SidebarInternalAnonymous, null)));
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "nav4.sidebar"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "sidebar"
        }, queryReference ? (0, ($parcel$interopDefault($eUqFw))).createElement($fa1d85c5358105db$var$SidebarInternal, {
            queryReference: queryReference
        }) : null));
    };
    const $fa1d85c5358105db$var$SidebarInternalAnonymous = ()=>{
        const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
        const defaultCollapsed = false;
        const defaultWidth = 340;
        const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $53ucm.useLayoutStoreActions)();
        const onExpand = (0, $eUqFw.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: false
            });
        }, [
            setLeftSidebarState
        ]);
        const onCollapse = (0, $eUqFw.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: true
            });
        }, [
            setLeftSidebarState
        ]);
        const onResizeEnd = (0, $eUqFw.useCallback)(({ finalWidth: finalWidth })=>{
            setLeftSidebarState({
                width: finalWidth
            });
        }, [
            setLeftSidebarState
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $kpmO3.SidebarNav4ContextProvider), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $2EYbt.SideNav), {
            testId: $fa1d85c5358105db$var$TEST_ID,
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            onExpand: onExpand,
            onCollapse: onCollapse
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $bdfGI.SidebarSelector), null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4rBDy.PanelSplitter), {
            label: formatMessage((0, $2D8YV.messages).sideBarPanelSplitterLabel),
            onResizeEnd: onResizeEnd
        })));
    };
    const $fa1d85c5358105db$var$TEST_ID = 'page-layout.sidebar';
    const $fa1d85c5358105db$var$SidebarInternal = ({ queryReference: queryReference })=>{
        const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
        const data = (0, $iWLL0.usePreloadedQuery)((0, $bckG1.default), queryReference);
        const defaultCollapsed = data?.jira?.navigationUIState?.isLeftSidebarCollapsed ?? (0, $7BqbB.IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT);
        const defaultWidth = data?.jira?.navigationUIState?.leftSidebarWidth ?? (0, $7BqbB.LEFT_SIDEBAR_EXPANDED_MIN_WIDTH);
        const [, { setLeftSidebarState: setLeftSidebarState }] = (0, $53ucm.useLayoutStoreActions)();
        const onExpand = (0, $eUqFw.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: false
            });
        }, [
            setLeftSidebarState
        ]);
        const onCollapse = (0, $eUqFw.useCallback)(({ screen: screen })=>{
            if (screen === 'desktop') setLeftSidebarState({
                isCollapsed: true
            });
        }, [
            setLeftSidebarState
        ]);
        const onResizeEnd = (0, $eUqFw.useCallback)(({ finalWidth: finalWidth })=>{
            setLeftSidebarState({
                width: finalWidth
            });
        }, [
            setLeftSidebarState
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $kpmO3.SidebarNav4ContextProvider), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $2EYbt.SideNav), {
            testId: $fa1d85c5358105db$var$TEST_ID,
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            onExpand: onExpand,
            onCollapse: onCollapse
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $bdfGI.SidebarSelector), null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $fa1d85c5358105db$var$feedbackButtonContainerStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8C1im.SidebarFeedbackButton), null)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4rBDy.PanelSplitter), {
            label: formatMessage((0, $2D8YV.messages).sideBarPanelSplitterLabel),
            onResizeEnd: onResizeEnd
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $2W91Z.AsyncNudgeBundledUsersFlagContainer), null)));
    };
    const $fa1d85c5358105db$var$SIDEBAR_TEST_ID = 'ContextualNavigation';
    const $fa1d85c5358105db$var$SIDEBAR_TRACE_KEY = 'sidebar';
    const $fa1d85c5358105db$var$sidebarOverrides = {
        ResizeButton: {
            render: (Component, props)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
                    id: "sidebar-resize-tooltip",
                    packageName: "page-container",
                    fallback: ()=>(0, ($parcel$interopDefault($eUqFw))).createElement(Component, props)
                }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
                    name: "side_bar_button",
                    fallback: (0, ($parcel$interopDefault($eUqFw))).createElement(Component, props)
                }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $j6voN.AsyncResizeButtonTooltip), {
                    isLeftSidebarCollapsed: props.isLeftSidebarCollapsed
                }, (0, ($parcel$interopDefault($eUqFw))).createElement(Component, props))))
        }
    };
    const $fa1d85c5358105db$var$SidebarInternalOld = ({ sidebar: sidebar })=>{
        const { width: width, isCollapsed: isCollapsed } = (0, $kpmC0.useLeftSidebarState)();
        const route = (0, $10fdS.useCurrentRoute)();
        const intl = (0, $4ksts.useIntlV2)();
        const shouldNotRenderSidebarInServerSide = false && isCollapsed;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "left-sidebar"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($fa1d85c5358105db$var$SidebarStyleOverrides, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "leftSidebarSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.LeftSidebarSkipLink), null)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.LeftSidebar), {
            isFixed: true,
            width: width,
            testId: $fa1d85c5358105db$var$SIDEBAR_TEST_ID,
            resizeButtonLabel: intl.formatMessage((0, $2D8YV.messages).sidebarNavigation),
            collapsedState: isCollapsed ? 'collapsed' : 'expanded',
            overrides: $fa1d85c5358105db$var$sidebarOverrides,
            id: "ak-side-navigation"
        }, !shouldNotRenderSidebarInServerSide && (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, route !== null && (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $u0mbR.SidebarStart), null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
            type: "start",
            traceKey: $fa1d85c5358105db$var$SIDEBAR_TRACE_KEY
        })), sidebar, route !== null && (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarSSRPerformanceMark), {
            metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
            type: "end",
            traceKey: $fa1d85c5358105db$var$SIDEBAR_TRACE_KEY
        }))))));
    };
    const $fa1d85c5358105db$var$SidebarInternalOldMemo = (0, $eUqFw.memo)($fa1d85c5358105db$var$SidebarInternalOld, (0, ($parcel$interopDefault($hTLlD))));
    const $fa1d85c5358105db$var$renderChildren = (sidebar)=>sidebar !== null ? (0, ($parcel$interopDefault($eUqFw))).createElement($fa1d85c5358105db$var$SidebarInternalOldMemo, {
            sidebar: sidebar
        }) : null;
    const $fa1d85c5358105db$var$SidebarOld = ()=>{
        const { shouldRender: shouldRender } = (0, $kpmC0.useLeftSidebarState)();
        const route = (0, $10fdS.useCurrentRoute)();
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4QXXR.SidebarSelectorProvider), {
            sidebar: route.navigation?.sidebar ?? null
        }, $fa1d85c5358105db$var$renderChildren);
    };
    const $fa1d85c5358105db$export$1ba59dacbcbf90fe = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $fa1d85c5358105db$var$SidebarNew, $fa1d85c5358105db$var$SidebarOld);
    const $fa1d85c5358105db$var$SidebarStyleOverrides = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1d7w7yr": (0, $9t7rW.default)((0, $c9TLT.layers).leftSidebar)
            },
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_kqswh2mm _1pbyg9ti _14c1glyw",
                __cmplp.className
            ])
        });
    });
    const $fa1d85c5358105db$var$feedbackButtonContainerStyles = (0, $fHiYa.xcss)({
        position: 'sticky',
        insetBlockEnd: 'space.0',
        marginBlockStart: 'auto'
    });
});
parcelRegister("bckG1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$135252e9d486cd82$export$2e2bcd8739ae039);
    const $135252e9d486cd82$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "isLeftSidebarCollapsed"
        }, v3 = {
            "kind": "ScalarField",
            "name": "leftSidebarWidth"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "sidebarSelectorQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1,
                                    "concreteType": "JiraNavigationUIStateUserProperty",
                                    "kind": "LinkedField",
                                    "name": "navigationUIState",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v2,
                                            "action": "THROW",
                                            "path": "jira.navigationUIState.isLeftSidebarCollapsed"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v3,
                                            "action": "THROW",
                                            "path": "jira.navigationUIState.leftSidebarWidth"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "sidebarSelectorQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraNavigationUIStateUserProperty",
                                "kind": "LinkedField",
                                "name": "navigationUIState",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "2b594593303f12c91ba380135535d6cde24ab3377ce6133c443e711b338621c8",
                "metadata": {},
                "name": "sidebarSelectorQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $135252e9d486cd82$var$node.hash = "e5c64c6d4b80524f3da4efcb8ecca3f4";
    var $135252e9d486cd82$export$2e2bcd8739ae039 = $135252e9d486cd82$var$node;
});
parcelRegister("8fxTv", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_TOP_DROPDOWN_MARKS", ()=>$0e0908bb9731ec35$export$8df02628d98cae7e);
    $parcel$export(module.exports, "pageSegmentStore", ()=>$0e0908bb9731ec35$export$26cadbe0bcaabcde);
    $parcel$export(module.exports, "useNavPerformanceMetrics", ()=>$0e0908bb9731ec35$export$906025848d54198d);
    $parcel$export(module.exports, "NavTopPerformanceMark", ()=>$0e0908bb9731ec35$export$b7f4caa65b0906fc);
    $parcel$export(module.exports, "NavTopSSRPerformanceMark", ()=>$0e0908bb9731ec35$export$2c4a101f2cde4fc2);
    $parcel$export(module.exports, "NavTopPerformanceReport", ()=>$0e0908bb9731ec35$export$c64b31449a6177d);
    $parcel$export(module.exports, "NavSidebarPerformanceMark", ()=>$0e0908bb9731ec35$export$35b2aeea5cbc963e);
    $parcel$export(module.exports, "NavSidebarSSRPerformanceMark", ()=>$0e0908bb9731ec35$export$14f711a2cb6a655a);
    $parcel$export(module.exports, "NavSidebarPerformanceReport", ()=>$0e0908bb9731ec35$export$a018e347341b3640);
    var $eUqFw = parcelRequire("eUqFw");
    var $illlw = parcelRequire("illlw");
    var $i8ojO = parcelRequire("i8ojO");
    var $keguF = parcelRequire("keguF");
    var $inC6u = parcelRequire("inC6u");
    var $7webZ = parcelRequire("7webZ");
    const $0e0908bb9731ec35$var$createTopNavPageSegment = ()=>(0, $i8ojO.metrics).pageSegmentLoad({
            key: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME),
            timings: [
                {
                    key: 'ttic',
                    startMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderStart,
                    endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderEnd
                },
                {
                    key: 'tti',
                    endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderEnd
                },
                {
                    key: 'ttr',
                    endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrEnd
                },
                {
                    key: 'ttrc',
                    startMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrStart,
                    endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrEnd
                },
                {
                    key: 'bundle-load',
                    startMark: (0, $7webZ.NAVIGATION_TOP_MARKS).bundleLoadStart,
                    endMark: (0, $7webZ.NAVIGATION_TOP_MARKS).renderStart
                }
            ],
            histogram: {
                initial: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '4000_4500_5000_6000_7000_8000_9000'
                },
                transition: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '2500_3000_3500_4000_5000_6000'
                }
            }
        });
    const $0e0908bb9731ec35$export$8df02628d98cae7e = {
        ADDONS: (0, $i8ojO.metrics).interaction({
            key: 'navigation-top.addons-dropdown-opened'
        })
    };
    const $0e0908bb9731ec35$var$createSidebarPageSegment = ()=>(0, $i8ojO.metrics).pageSegmentLoad({
            key: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME),
            timings: [
                {
                    key: 'renderAttempt',
                    startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderAttempt,
                    endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderAttempt
                },
                {
                    key: 'ttic',
                    startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderStart,
                    endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderEnd
                },
                {
                    key: 'tti',
                    endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderEnd
                },
                {
                    key: 'ttr',
                    endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
                },
                {
                    key: 'ttrc',
                    startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrStart,
                    endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrEnd
                },
                {
                    key: 'load',
                    startMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadStart,
                    endMark: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadEnd
                }
            ],
            histogram: {
                initial: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '4000_4500_5000_6000_7000_8000_9000'
                },
                transition: {
                    fmp: '2500_3000_3500_4000_5000_6000',
                    tti: '2500_3000_3500_4000_5000_6000'
                }
            }
        });
    const $0e0908bb9731ec35$export$26cadbe0bcaabcde = (()=>{
        const segmentConstructors = {
            [(0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)]: $0e0908bb9731ec35$var$createTopNavPageSegment,
            [(0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)]: $0e0908bb9731ec35$var$createSidebarPageSegment
        };
        const segments = {};
        return {
            getSegment: (key)=>{
                if (!segments[key]) {
                    if (!segmentConstructors[key]) throw new Error(`Segment constructor for ${key} is not defined.`);
                    segments[key] = segmentConstructors[key]();
                }
                return segments[key];
            }
        };
    })();
    const $0e0908bb9731ec35$export$906025848d54198d = (segmentKey = (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME))=>{
        const startedRef = (0, $eUqFw.useRef)(false);
        const segment = (0, $eUqFw.useRef)($0e0908bb9731ec35$export$26cadbe0bcaabcde.getSegment(segmentKey)).current;
        if (!false && !startedRef.current) {
            segment && segment.startFromPageLoad();
            startedRef.current = true;
        }
        return (0, $eUqFw.useMemo)(()=>Object.assign(segment, {
                markSSR: (metricKey)=>{
                    const tmpSsrMetricKey = `${(0, $7webZ.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
                    if (window.SPA_STATE) {
                        const { startTime: startTime = 0, duration: duration = 0 } = (0, ($parcel$interopDefault($illlw)))((0, $inC6u.getRenderTraceFromSSRGlobal)(), [
                            'traces',
                            `render/${tmpSsrMetricKey}`
                        ]) || {};
                        const markTime = startTime + duration;
                        markTime && markTime > 0 && segment.mark(metricKey, markTime);
                    }
                }
            }), [
            segment
        ]);
    };
    const $0e0908bb9731ec35$var$NavigationPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
        const navSegment = $0e0908bb9731ec35$export$906025848d54198d(segmentKey);
        (0, $eUqFw.useEffect)(()=>navSegment.mark(metricKey), []);
        return null;
    };
    const $0e0908bb9731ec35$var$NavigationSSRPerformanceMark = ({ segmentKey: segmentKey, metricKey: metricKey })=>{
        const tmpSsrMetricKey = `${(0, $7webZ.NAVIGATION_SSR_MARK_PREFIX)}.${metricKey}`;
        const navSegment = $0e0908bb9731ec35$export$906025848d54198d(segmentKey);
        (0, $eUqFw.useEffect)(()=>navSegment.markSSR(metricKey), []);
        return false ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
            type: "end",
            traceKey: tmpSsrMetricKey
        }) : null;
    };
    const $0e0908bb9731ec35$var$NavigationPerformanceReport = ({ segmentKey: segmentKey, customData: customData })=>{
        const navSegment = $0e0908bb9731ec35$export$906025848d54198d(segmentKey);
        (0, $eUqFw.useEffect)(()=>{
            navSegment.stop({
                customData: {
                    ...customData,
                    userLocation: (0, $keguF.getUserLocation)()
                }
            });
            navSegment.clear();
        }, []);
        return null;
    };
    const $0e0908bb9731ec35$export$b7f4caa65b0906fc = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceMark, {
            ...props,
            segmentKey: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $0e0908bb9731ec35$export$2c4a101f2cde4fc2 = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationSSRPerformanceMark, {
            ...props,
            segmentKey: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $0e0908bb9731ec35$export$c64b31449a6177d = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceReport, {
            ...props,
            segmentKey: (0, $7webZ.NAVIGATION_TOP_SEGMENT_NAME)
        });
    const $0e0908bb9731ec35$export$35b2aeea5cbc963e = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceMark, {
            ...props,
            segmentKey: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
    const $0e0908bb9731ec35$export$14f711a2cb6a655a = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationSSRPerformanceMark, {
            ...props,
            segmentKey: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
    const $0e0908bb9731ec35$export$a018e347341b3640 = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement($0e0908bb9731ec35$var$NavigationPerformanceReport, {
            ...props,
            segmentKey: (0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME)
        });
});
parcelRegister("inC6u", function(module, exports) {
    $parcel$export(module.exports, "RenderTracerMark", ()=>$eba039e5967c438d$export$54c89059bb435049);
    $parcel$export(module.exports, "getRenderTraceFromSSRGlobal", ()=>$eba039e5967c438d$export$345f21b0287f67e5);
    var $eUqFw = parcelRequire("eUqFw");
    var $aeTOI = parcelRequire("aeTOI");
    var $illlw = parcelRequire("illlw");
    var $9I5Lq = parcelRequire("9I5Lq");
    var $WBLbN = parcelRequire("WBLbN");
    const $eba039e5967c438d$var$initialState = {
        start: undefined,
        traces: {}
    };
    let $eba039e5967c438d$var$currentTraces = {};
    const $eba039e5967c438d$export$2365ecd8218e21c7 = ()=>$eba039e5967c438d$var$currentTraces;
    const $eba039e5967c438d$export$5c757eaa1990d0d7 = (key)=>{
        if ($eba039e5967c438d$var$currentTraces[key]) return;
        $eba039e5967c438d$var$currentTraces[key] = {
            startTime: (0, $9I5Lq.performance).now()
        };
    };
    const $eba039e5967c438d$export$16854dc18f8d976 = (key)=>{
        if (!$eba039e5967c438d$var$currentTraces[key] || $eba039e5967c438d$var$currentTraces[key].duration != null) return;
        $eba039e5967c438d$var$currentTraces[key].duration = (0, $9I5Lq.performance).now() - $eba039e5967c438d$var$currentTraces[key].startTime;
    };
    const $eba039e5967c438d$var$actions = {
        startTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
                const { start: start, traces: traces } = getState();
                if (start === undefined) return;
                const key = name === startKey ? name : `${startKey}/${name}`;
                if (traces[key]) return;
                setState({
                    traces: (0, ($parcel$interopDefault($aeTOI)))({}, traces, {
                        [key]: {
                            startTime: time
                        }
                    })
                });
            },
        endTrace: (name, time)=>({ setState: setState, getState: getState }, { startKey: startKey })=>{
                const { start: start, traces: traces } = getState();
                if (start === undefined) return;
                const key = name === startKey ? name : `${startKey}/${name}`;
                const trace = traces[key] || {
                    startTime: 0
                };
                setState({
                    traces: (0, ($parcel$interopDefault($aeTOI)))({}, traces, {
                        [key]: {
                            ...trace,
                            duration: time - trace.startTime
                        }
                    })
                });
                $eba039e5967c438d$var$currentTraces = Object.assign($eba039e5967c438d$var$currentTraces, getState().traces);
            }
    };
    const $eba039e5967c438d$var$Store = (0, $WBLbN.createStore)({
        name: 'jira-render-tracer',
        initialState: $eba039e5967c438d$var$initialState,
        actions: $eba039e5967c438d$var$actions
    });
    const $eba039e5967c438d$var$RenderTracerActions = (0, $WBLbN.createSubscriber)($eba039e5967c438d$var$Store, {
        selector: null
    });
    const $eba039e5967c438d$export$719a95758870be58 = (0, $WBLbN.createHook)($eba039e5967c438d$var$Store, {
        selector: null
    });
    const $eba039e5967c438d$var$RenderTracerContainerBase = (0, $WBLbN.createContainer)($eba039e5967c438d$var$Store, {
        onInit: ()=>({ setState: setState }, { startKey: startKey, startTime: startTime })=>{
                setState({
                    start: startTime,
                    traces: {
                        [startKey]: {
                            startTime: (0, $9I5Lq.performance).now()
                        }
                    }
                });
            }
    });
    const $eba039e5967c438d$export$37d31bee41ca1401 = ({ children: children, startKey: startKey, startTime: startTime })=>(0, ($parcel$interopDefault($eUqFw))).createElement($eba039e5967c438d$var$RenderTracerContainerBase, {
            startKey: startKey,
            startTime: startTime
        }, children, (0, ($parcel$interopDefault($eUqFw))).createElement($eba039e5967c438d$export$54c89059bb435049, {
            traceKey: startKey,
            type: "end"
        }));
    const $eba039e5967c438d$export$54c89059bb435049 = ({ traceKey: traceKey, type: type })=>(0, ($parcel$interopDefault($eUqFw))).createElement($eba039e5967c438d$var$RenderTracerActions, null, (_, { startTrace: startTrace, endTrace: endTrace })=>{
            if (type === 'start') startTrace(traceKey, (0, $9I5Lq.performance).now());
            else if (type === 'end') endTrace(traceKey, (0, $9I5Lq.performance).now());
            return null;
        });
    const $eba039e5967c438d$export$cba8addc8743389c = (appName = 'unknown', traces = $eba039e5967c438d$var$currentTraces)=>({
            [(0, $98d270000c5bb498$export$3c96fa14fb694e11)]: {
                data: {
                    traces: traces,
                    routeName: appName
                }
            }
        });
    const $eba039e5967c438d$export$345f21b0287f67e5 = ()=>(0, ($parcel$interopDefault($illlw)))(window.SPA_STATE || window.SKELETON_NAVIGATION || {}, [
            (0, $98d270000c5bb498$export$3c96fa14fb694e11),
            'data'
        ], {});
});
parcelRegister("9I5Lq", function(module, exports) {
    $parcel$export(module.exports, "performance", ()=>$cb19fd4c8632f94b$export$f2d2284f5fec51f8);
    const $cb19fd4c8632f94b$var$now = ()=>false ? Date.now() : $parcel$global.performance.now();
    class $cb19fd4c8632f94b$export$9a0dbed22cbf63be {
        start() {
            if (false) this.startAt = $cb19fd4c8632f94b$var$now();
        }
        now() {
            if (false) return $cb19fd4c8632f94b$var$now() - this.startAt;
            return $cb19fd4c8632f94b$var$now();
        }
        constructor(){
            this.startAt = $cb19fd4c8632f94b$var$now();
        }
    }
    const $cb19fd4c8632f94b$export$f2d2284f5fec51f8 = new $cb19fd4c8632f94b$export$9a0dbed22cbf63be();
});
const $98d270000c5bb498$export$3c96fa14fb694e11 = 'ssr/detail_render_trace';
parcelRegister("7webZ", function(module, exports) {
    $parcel$export(module.exports, "NAVIGATION_TOP_SEGMENT_NAME", ()=>$ba1c37c8f1f8f79b$export$6635720e40ea7a7a);
    $parcel$export(module.exports, "NAVIGATION_SIDEBAR_SEGMENT_NAME", ()=>$ba1c37c8f1f8f79b$export$1d3c3cb357af0e86);
    $parcel$export(module.exports, "NAVIGATION_SSR_MARK_PREFIX", ()=>$ba1c37c8f1f8f79b$export$e7a14fa81b3c6488);
    $parcel$export(module.exports, "NAVIGATION_TOP_MARKS", ()=>$ba1c37c8f1f8f79b$export$ad760bb9734bf93f);
    $parcel$export(module.exports, "NAVIGATION_SIDEBAR_MARKS", ()=>$ba1c37c8f1f8f79b$export$1d10ee0c85c3cb21);
    const $ba1c37c8f1f8f79b$export$6635720e40ea7a7a = 'navigation.top';
    const $ba1c37c8f1f8f79b$export$1d3c3cb357af0e86 = 'navigation.sidebar';
    const $ba1c37c8f1f8f79b$export$e7a14fa81b3c6488 = 'nav-ssr-mark';
    const $ba1c37c8f1f8f79b$export$ad760bb9734bf93f = {
        renderStart: 'navigation-top.render.start',
        renderEnd: 'navigation-top.render.end',
        renderSsrStart: 'navigation-top.render.ssr.start',
        renderSsrEnd: 'navigation-top.render.ssr.end',
        bundleLoadStart: 'navigation-top.bundle-load.start'
    };
    const $ba1c37c8f1f8f79b$export$1d10ee0c85c3cb21 = {
        renderAttempt: 'navigation-sidebar.render.attempt',
        renderStart: 'navigation-sidebar.render.start',
        renderEnd: 'navigation-sidebar.render.end',
        renderSsrStart: 'navigation-sidebar.render.ssr.start',
        renderSsrEnd: 'navigation-sidebar.render.ssr.end',
        loadStart: 'navigation-sidebar.load.start',
        loadEnd: 'navigation-sidebar.load.end'
    };
});
parcelRegister("4ksts", function(module, exports) {
    $parcel$export(module.exports, "useIntlV2", ()=>$32efc9cfc8f5c011$export$d82607073b68786);
    var $eUqFw = parcelRequire("eUqFw");
    var $5JgJ2 = parcelRequire("5JgJ2");
    const $32efc9cfc8f5c011$export$d82607073b68786 = ()=>{
        const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, $5JgJ2.default)();
        const memoisedIntl = (0, $eUqFw.useMemo)(()=>{
            const modifiedIntl = {
                now: ()=>Date.now(),
                messages: messages,
                locale: locale,
                formats: formats,
                formatDate: formatDate,
                formatMessage: formatMessage,
                formatNumber: formatNumber,
                formatPlural: formatPlural,
                formatTime: formatTime
            };
            return modifiedIntl;
        }, [
            formatDate,
            formatMessage,
            formatPlural,
            formatTime,
            formatNumber,
            formats,
            locale,
            messages
        ]);
        return memoisedIntl;
    };
});
parcelRegister("7zhpa", function(module, exports) {
    $parcel$export(module.exports, "sidebarNav4Resource", ()=>$57db5858a67a5074$export$7648dc6f76f4f83d);
    $parcel$export(module.exports, "sidebarNav4UiStateResource", ()=>$57db5858a67a5074$export$a46129bd512544d7);
    var $4ursw = parcelRequire("4ursw");
    var $4ZjUB = parcelRequire("4ZjUB");
    var $7uCfF = parcelRequire("7uCfF");
    var $buJlM = parcelRequire("buJlM");
    var $hkmE9 = parcelRequire("hkmE9");
    var $bckG1 = parcelRequire("bckG1");
    const $57db5858a67a5074$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY = 'SIDEBAR_V2_RELAY';
    const $57db5858a67a5074$export$7648dc6f76f4f83d = (0, $buJlM.createRelayResource)({
        type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_${$57db5858a67a5074$var$RESOURCE_TYPE_SIDEBAR_V2_RELAY}`,
        getQuery: (routerContext, { tenantContext: { cloudId: cloudId } })=>{
            const initialSelectedPath = (0, $4ZjUB.getInitialSelectedPath)(routerContext);
            return {
                parameters: (0, $hkmE9.default),
                variables: {
                    cloudId: cloudId,
                    isAppsExpanded: (0, $7uCfF.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_APPS)),
                    isDashboardsExpanded: (0, $7uCfF.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_DASHBOARDS)),
                    isFiltersExpanded: (0, $7uCfF.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_FILTERS)),
                    isPlansExpanded: (0, $7uCfF.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_PLANS)),
                    isProjectsExpanded: (0, $7uCfF.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_PROJECTS)),
                    isOperationsExpanded: (0, $7uCfF.isSelectedPath)(initialSelectedPath, (0, $4ursw.MENU_ID_OPERATIONS))
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
    const $57db5858a67a5074$export$a46129bd512544d7 = (0, $buJlM.createRelayResource)({
        type: `${(0, $buJlM.RELAY_RESOURCE_TYPE)}_SIDEBAR_V2_UI_STATE_RELAY`,
        getQuery: (_, { tenantContext: { cloudId: cloudId } })=>({
                parameters: (0, $bckG1.default),
                variables: {
                    cloudId: cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("4ursw", function(module, exports) {
    $parcel$export(module.exports, "CONFIGURABLE_MENU_ID", ()=>$520542fb506bd92b$export$7838b734e4cd5e8d);
    $parcel$export(module.exports, "ENTITY_ID", ()=>$520542fb506bd92b$export$103ff18fe29ee1b);
    $parcel$export(module.exports, "MENU_ID_APPS", ()=>$520542fb506bd92b$export$441cd608ea3204f4);
    $parcel$export(module.exports, "MENU_ID_APP_MARKETPLACE_DISCOVER", ()=>$520542fb506bd92b$export$5baa9c2e3c3931c5);
    $parcel$export(module.exports, "MENU_ID_ASSETS", ()=>$520542fb506bd92b$export$75c65bfc98b3a6e1);
    $parcel$export(module.exports, "MENU_ID_ASSETS_SCHEMAS", ()=>$520542fb506bd92b$export$8a0af92d49f1d13d);
    $parcel$export(module.exports, "MENU_ID_ASSETS_REPORTS", ()=>$520542fb506bd92b$export$a09300d15acc958a);
    $parcel$export(module.exports, "MENU_ID_BOARDS_VIEW_ALL", ()=>$520542fb506bd92b$export$4d718fbd418eef5c);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS", ()=>$520542fb506bd92b$export$dd009509c2dabb5e);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL", ()=>$520542fb506bd92b$export$d3da0455b4200fb2);
    $parcel$export(module.exports, "MENU_ID_DASHBOARDS_VIEW_ALL_STARRED", ()=>$520542fb506bd92b$export$b9dd2b5309d19763);
    $parcel$export(module.exports, "MENU_ID_FILTERS", ()=>$520542fb506bd92b$export$3d81af172a8e3c57);
    $parcel$export(module.exports, "MENU_ID_FILTERS_SEARCH", ()=>$520542fb506bd92b$export$1e2599eaf0039a97);
    $parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL", ()=>$520542fb506bd92b$export$53d274d993c9d5b5);
    $parcel$export(module.exports, "MENU_ID_FILTERS_VIEW_ALL_STARRED", ()=>$520542fb506bd92b$export$7661ea763be69cfa);
    $parcel$export(module.exports, "MENU_ID_GOALS", ()=>$520542fb506bd92b$export$47c6ce6a83a59eab);
    $parcel$export(module.exports, "MENU_ID_OPERATIONS", ()=>$520542fb506bd92b$export$ef89639b7d9c162a);
    $parcel$export(module.exports, "MENU_ID_OPS_ALERTS", ()=>$520542fb506bd92b$export$af4ab6d4e920522a);
    $parcel$export(module.exports, "MENU_ID_OPS_OVERVIEW", ()=>$520542fb506bd92b$export$25c40acb2c53a294);
    $parcel$export(module.exports, "MENU_ID_OPS_REPORTS", ()=>$520542fb506bd92b$export$c7d8892f1628b844);
    $parcel$export(module.exports, "MENU_ID_OPS_ON_CALL", ()=>$520542fb506bd92b$export$bb19a52e3df99541);
    $parcel$export(module.exports, "MENU_ID_OVERVIEWS", ()=>$520542fb506bd92b$export$3bd12c092f8db11b);
    $parcel$export(module.exports, "MENU_ID_PLANS", ()=>$520542fb506bd92b$export$f2533da33c749933);
    $parcel$export(module.exports, "MENU_ID_PLANS_VIEW_ALL", ()=>$520542fb506bd92b$export$8468c5b6648f4f1f);
    $parcel$export(module.exports, "MENU_ID_PROJECT_APPS", ()=>$520542fb506bd92b$export$fed17b4c0866b97d);
    $parcel$export(module.exports, "MENU_ID_PROJECTS", ()=>$520542fb506bd92b$export$9c5278bd360a285);
    $parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL", ()=>$520542fb506bd92b$export$85389c606bb641dd);
    $parcel$export(module.exports, "MENU_ID_PROJECTS_VIEW_ALL_STARRED", ()=>$520542fb506bd92b$export$4a1974b63c858e9c);
    $parcel$export(module.exports, "MENU_ID_RECENT", ()=>$520542fb506bd92b$export$692b796030a796f3);
    $parcel$export(module.exports, "MENU_ID_ROADMAPS", ()=>$520542fb506bd92b$export$cdc80d4b5ce0c6a);
    $parcel$export(module.exports, "MENU_ID_STARRED", ()=>$520542fb506bd92b$export$5637ca42a4d77f32);
    $parcel$export(module.exports, "MENU_ID_TEAMS", ()=>$520542fb506bd92b$export$d4f6fcf571f9c50);
    $parcel$export(module.exports, "MENU_ID_YOUR_WORK", ()=>$520542fb506bd92b$export$80dc576e446bdb6b);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_ACCESS", ()=>$520542fb506bd92b$export$79c15668ed799a1b);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT", ()=>$520542fb506bd92b$export$e299bb06c4370c0d);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES", ()=>$520542fb506bd92b$export$713b9b0a69a79cf9);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_AUTOMATION", ()=>$520542fb506bd92b$export$f1d9c0f27216aa1c);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE", ()=>$520542fb506bd92b$export$45763fa331781074);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_NOTIFICATIONS", ()=>$520542fb506bd92b$export$6ee20c845dbab3e3);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_APPS", ()=>$520542fb506bd92b$export$b3815dd180ce5e61);
    $parcel$export(module.exports, "MENU_ID_SD_SETTINGS_OPERATIONS", ()=>$520542fb506bd92b$export$100a1a639a0db980);
    const $520542fb506bd92b$export$7838b734e4cd5e8d = {
        APPS: 'jira.sidebar.apps',
        ASSETS: 'jira.sidebar.assets',
        DASHBOARDS: 'jira.sidebar.dashboards',
        FILTERS: 'jira.sidebar.filters',
        GOALS: 'jira.sidebar.goals',
        OPERATIONS: 'jira.sidebar.operations',
        OVERVIEWS: 'jira.sidebar.overviews',
        PLANS: 'jira.sidebar.plans',
        PROJECTS: 'jira.sidebar.projects',
        RECENT: 'jira.sidebar.recent',
        STARRED: 'jira.sidebar.starred',
        TEAMS: 'jira.sidebar.teams',
        ROADMAPS: 'jira.sidebar.roadmaps'
    };
    const $520542fb506bd92b$export$103ff18fe29ee1b = {
        ALARM_QUEUE: (id)=>`alrm_${id}`,
        APP: (id)=>`app_${id}`,
        BOARD: (id)=>`boar_${id}`,
        DASHBOARD: (id)=>`dash_${id}`,
        FILTER: (id)=>`filt_${id}`,
        FORM: (id)=>`form_${id}`,
        OVERVIEW: (id)=>`over_${id}`,
        PLAN: (id)=>`plan_${id}`,
        PROJECT: (id)=>`proj_${id}`,
        PROJECT_CALENDAR: (projectKey)=>`proj-${projectKey}-cal`,
        PROJECT_CHANGE_CALENDAR: (projectKey)=>`proj-${projectKey}-chgcal`,
        PROJECT_ESCALATIONS: (projectKey)=>`proj-${projectKey}-escl`,
        PROJECT_DIRECTORY: (projectKey)=>`proj-${projectKey}-dir`,
        PROJECT_FILTERS: (projectKey)=>`proj-${projectKey}-filters`,
        PROJECT_ISSUE_FILTER: (projectKey, filterId)=>`proj-${projectKey}-issf-${filterId}`,
        PROJECT_JSM_GETTING_STARTED: (projectKey)=>`proj-${projectKey}-jsm-gtst`,
        PROJECT_KNOWLEDGE_BASE: (projectKey)=>`proj-${projectKey}-kb`,
        PROJECT_NOTIFICATION_LOGS: (projectKey)=>`proj-${projectKey}-nlog`,
        PROJECT_ONCALL_SCHEDULE: (projectKey)=>`proj-${projectKey}-oncs`,
        PROJECT_PRACTICE_QUEUE: (projectKey, practice)=>`proj-${projectKey}-pract-${practice}`,
        PROJECT_QUEUES: (projectKey)=>`proj-${projectKey}-queues`,
        PROJECT_REPORTS: (projectKey)=>`proj-${projectKey}-rprt`,
        PROJECT_SERVICES: (projectKey)=>`proj-${projectKey}-srvc`,
        PROJECT_SUMMARY: (projectKey)=>`proj-${projectKey}-summary`,
        PROJECT_VIEWS: (projectKey)=>`proj-${projectKey}-views`,
        QUEUE: (id)=>`queu_${id}`
    };
    const $520542fb506bd92b$export$441cd608ea3204f4 = $520542fb506bd92b$export$7838b734e4cd5e8d.APPS;
    const $520542fb506bd92b$export$5baa9c2e3c3931c5 = 'app_mrkt';
    const $520542fb506bd92b$export$75c65bfc98b3a6e1 = $520542fb506bd92b$export$7838b734e4cd5e8d.ASSETS;
    const $520542fb506bd92b$export$8a0af92d49f1d13d = 'asst_schm';
    const $520542fb506bd92b$export$a09300d15acc958a = 'asst_rprt';
    const $520542fb506bd92b$export$4d718fbd418eef5c = 'board-view-all';
    const $520542fb506bd92b$export$dd009509c2dabb5e = $520542fb506bd92b$export$7838b734e4cd5e8d.DASHBOARDS;
    const $520542fb506bd92b$export$d3da0455b4200fb2 = 'dash-view';
    const $520542fb506bd92b$export$b9dd2b5309d19763 = 'dash-view-starred';
    const $520542fb506bd92b$export$3d81af172a8e3c57 = $520542fb506bd92b$export$7838b734e4cd5e8d.FILTERS;
    const $520542fb506bd92b$export$1e2599eaf0039a97 = 'filt-search';
    const $520542fb506bd92b$export$53d274d993c9d5b5 = 'filt-view-all';
    const $520542fb506bd92b$export$7661ea763be69cfa = 'filt-view-starred';
    const $520542fb506bd92b$export$47c6ce6a83a59eab = $520542fb506bd92b$export$7838b734e4cd5e8d.GOALS;
    const $520542fb506bd92b$export$ef89639b7d9c162a = $520542fb506bd92b$export$7838b734e4cd5e8d.OPERATIONS;
    const $520542fb506bd92b$export$af4ab6d4e920522a = 'ops-alrt';
    const $520542fb506bd92b$export$25c40acb2c53a294 = 'ops-over';
    const $520542fb506bd92b$export$c7d8892f1628b844 = 'ops-rprt';
    const $520542fb506bd92b$export$bb19a52e3df99541 = 'ops-oncl';
    const $520542fb506bd92b$export$3bd12c092f8db11b = $520542fb506bd92b$export$7838b734e4cd5e8d.OVERVIEWS;
    const $520542fb506bd92b$export$f2533da33c749933 = $520542fb506bd92b$export$7838b734e4cd5e8d.PLANS;
    const $520542fb506bd92b$export$8468c5b6648f4f1f = 'plan-view-all';
    const $520542fb506bd92b$export$fed17b4c0866b97d = 'proj-app';
    const $520542fb506bd92b$export$e682260eda678e61 = 'proj-dir';
    const $520542fb506bd92b$export$9c5278bd360a285 = $520542fb506bd92b$export$7838b734e4cd5e8d.PROJECTS;
    const $520542fb506bd92b$export$85389c606bb641dd = 'proj-view-all';
    const $520542fb506bd92b$export$4a1974b63c858e9c = 'proj-view-starred';
    const $520542fb506bd92b$export$692b796030a796f3 = $520542fb506bd92b$export$7838b734e4cd5e8d.RECENT;
    const $520542fb506bd92b$export$cdc80d4b5ce0c6a = $520542fb506bd92b$export$7838b734e4cd5e8d.ROADMAPS;
    const $520542fb506bd92b$export$5637ca42a4d77f32 = $520542fb506bd92b$export$7838b734e4cd5e8d.STARRED;
    const $520542fb506bd92b$export$d4f6fcf571f9c50 = $520542fb506bd92b$export$7838b734e4cd5e8d.TEAMS;
    const $520542fb506bd92b$export$80dc576e446bdb6b = 'yrwk';
    const $520542fb506bd92b$export$79c15668ed799a1b = 'sd-sett-acc';
    const $520542fb506bd92b$export$e299bb06c4370c0d = 'sd-sett-req-man';
    const $520542fb506bd92b$export$713b9b0a69a79cf9 = 'sd-sett-req-typs';
    const $520542fb506bd92b$export$f1d9c0f27216aa1c = 'sd-sett-aut';
    const $520542fb506bd92b$export$45763fa331781074 = 'sd-sett-ch-slf-srv';
    const $520542fb506bd92b$export$6ee20c845dbab3e3 = 'sd-sett-not';
    const $520542fb506bd92b$export$b3815dd180ce5e61 = 'sd-sett-apps';
    const $520542fb506bd92b$export$100a1a639a0db980 = 'sd-sett-ops';
});
parcelRegister("4ZjUB", function(module, exports) {
    $parcel$export(module.exports, "getInitialSelectedPath", ()=>$bb18282f63f50e0f$export$39f409bc5f59c5e);
    var $6l6Xk = parcelRequire("6l6Xk");
    var $5RIdI = parcelRequire("5RIdI");
    const $bb18282f63f50e0f$export$39f409bc5f59c5e = (0, ($parcel$interopDefault($6l6Xk)))((0, $5RIdI.routeToSelectedPath));
});
parcelRegister("5RIdI", function(module, exports) {
    $parcel$export(module.exports, "routeToSelectedPath", ()=>$1411adde11c4da4f$export$a92474c098a1fd13);
    var $eI5EY = parcelRequire("eI5EY");
    var $lFKDm = parcelRequire("lFKDm");
    var $75qb3 = parcelRequire("75qb3");
    var $g2zoD = parcelRequire("g2zoD");
    var $9SW3e = parcelRequire("9SW3e");
    var $9jOdG = parcelRequire("9jOdG");
    var $3MZLo = parcelRequire("3MZLo");
    var $8LvEn = parcelRequire("8LvEn");
    var $7BjZJ = parcelRequire("7BjZJ");
    var $hOEfe = parcelRequire("hOEfe");
    var $aDEwR = parcelRequire("aDEwR");
    var $aR7J8 = parcelRequire("aR7J8");
    function $1411adde11c4da4f$export$a92474c098a1fd13(routeContext) {
        const routeName = routeContext.route.name;
        if ((0, $3MZLo.topLevelConverter).routes.has(routeName)) return (0, $3MZLo.topLevelConverter).convert(routeContext);
        if ((0, $lFKDm.appsConverter).routes.has(routeName)) return (0, $lFKDm.appsConverter).convert(routeContext);
        if ((0, $75qb3.assetsConverter).routes.has(routeName)) return (0, $75qb3.assetsConverter).convert(routeContext);
        if ((0, $g2zoD.dashboardsConverter).routes.has(routeName)) return (0, $g2zoD.dashboardsConverter).convert(routeContext);
        if ((0, $9SW3e.filtersConverter).routes.has(routeName)) return (0, $9SW3e.filtersConverter).convert(routeContext);
        if ((0, $9jOdG.operationsConverter).routes.has(routeName)) return (0, $9jOdG.operationsConverter).convert(routeContext);
        if ((0, $8LvEn.overviewsConverter).routes.has(routeName)) return (0, $8LvEn.overviewsConverter).convert(routeContext);
        if ((0, $8LvEn.overviewsConverter).routes.has(routeName)) return (0, $8LvEn.overviewsConverter).convert(routeContext);
        if ((0, $7BjZJ.plansConverter).routes.has(routeName)) return (0, $7BjZJ.plansConverter).convert(routeContext);
        if ((0, $hOEfe.projectsConverter).routes.has(routeName)) return (0, $hOEfe.projectsConverter).convert(routeContext);
        if ((0, $aDEwR.roadmapsConverter).routes.has(routeName)) return (0, $aDEwR.roadmapsConverter).convert(routeContext);
        if ((0, $eI5EY.fg)('jira_nav4_eap_drop_1')) {
            if ((0, $aR7J8.serviceManagementProjectSettingsConverter).routes.has(routeName)) return (0, $aR7J8.serviceManagementProjectSettingsConverter).convert(routeContext);
        }
        return [];
    }
});
parcelRegister("lFKDm", function(module, exports) {
    $parcel$export(module.exports, "appsConverter", ()=>$c2789d7f7235d366$export$d017a63045c88c47);
    var $exb0h = parcelRequire("exb0h");
    var $4ursw = parcelRequire("4ursw");
    const $c2789d7f7235d366$var$UNCERTAIN_APPS_SECTION_ROUTES = [
        (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL),
        (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_INVALID),
        (0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_GENERAL),
        (0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
        (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
        (0, $exb0h.ROUTE_NAMES_CONNECT_PROJECT)
    ];
    const $c2789d7f7235d366$var$CERTAIN_APPS_SECTION_ROUTES = [
        (0, $exb0h.ROUTE_NAMES_FORGE_GLOBAL),
        (0, $exb0h.ROUTE_NAMES_MARKETPLACE_INDEX)
    ];
    const $c2789d7f7235d366$export$66b32f6f30eb4b4 = new Set([
        ...$c2789d7f7235d366$var$UNCERTAIN_APPS_SECTION_ROUTES,
        ...$c2789d7f7235d366$var$CERTAIN_APPS_SECTION_ROUTES
    ]);
    function $c2789d7f7235d366$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, $4ursw.MENU_ID_APPS)
        ];
        switch(routeName){
            case 0, $exb0h.ROUTE_NAMES_MARKETPLACE_INDEX:
                path.push((0, $4ursw.MENU_ID_APP_MARKETPLACE_DISCOVER));
                break;
            case 0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL:
            case 0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_INVALID:
            case 0, $exb0h.ROUTE_NAMES_FORGE_GLOBAL:
            case 0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_GENERAL:
                path.push((0, $4ursw.ENTITY_ID).APP(match.url.replace(/\/$/, '')));
                break;
            case 0, $exb0h.ROUTE_NAMES_CONNECT_PROJECT:
            case 0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_PROJECT:
                {
                    const { projectKey: projectKey } = match.params;
                    return [
                        (0, $4ursw.MENU_ID_PROJECTS),
                        (0, $4ursw.ENTITY_ID).PROJECT(projectKey || '')
                    ];
                }
            case 0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT:
                {
                    const { projectKey: projectKey } = query;
                    return [
                        (0, $4ursw.MENU_ID_PROJECTS),
                        (0, $4ursw.ENTITY_ID).PROJECT(projectKey || '')
                    ];
                }
            default:
                break;
        }
        return path;
    }
    const $c2789d7f7235d366$export$d017a63045c88c47 = {
        routes: $c2789d7f7235d366$export$66b32f6f30eb4b4,
        convert: $c2789d7f7235d366$var$convert
    };
});
parcelRegister("75qb3", function(module, exports) {
    $parcel$export(module.exports, "assetsConverter", ()=>$0d6ff1587c3c6377$export$6cfeba0849032a84);
    var $exb0h = parcelRequire("exb0h");
    var $4ursw = parcelRequire("4ursw");
    const $0d6ff1587c3c6377$var$routes = new Set([
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_LANDING_PAGE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION)
    ]);
    function $0d6ff1587c3c6377$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [
            (0, $4ursw.MENU_ID_ASSETS)
        ];
        switch(routeName){
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION:
                path.push((0, $4ursw.MENU_ID_ASSETS_SCHEMAS));
                break;
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION:
                path.push((0, $4ursw.MENU_ID_ASSETS_SCHEMAS));
                break;
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE:
                path.push((0, $4ursw.MENU_ID_ASSETS_REPORTS));
                break;
            default:
                break;
        }
        return path;
    }
    const $0d6ff1587c3c6377$export$6cfeba0849032a84 = {
        routes: $0d6ff1587c3c6377$var$routes,
        convert: $0d6ff1587c3c6377$var$convert
    };
});
parcelRegister("g2zoD", function(module, exports) {
    $parcel$export(module.exports, "dashboardsConverter", ()=>$d7c859492cb29c5d$export$6468819b4be328b1);
    var $exb0h = parcelRequire("exb0h");
    var $4ursw = parcelRequire("4ursw");
    const $d7c859492cb29c5d$var$routes = new Set([
        (0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY),
        (0, $exb0h.ROUTE_NAMES_DASHBOARD_EDIT),
        (0, $exb0h.ROUTE_NAMES_DASHBOARD_VIEW),
        (0, $exb0h.ROUTE_NAMES_DASHBOARD_WALLBOARD)
    ]);
    function $d7c859492cb29c5d$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, $4ursw.MENU_ID_DASHBOARDS)
        ];
        switch(routeName){
            case 0, $exb0h.ROUTE_NAMES_DASHBOARDS_DIRECTORY:
                path.push((0, $4ursw.MENU_ID_DASHBOARDS_VIEW_ALL));
                break;
            case 0, $exb0h.ROUTE_NAMES_DASHBOARD_WALLBOARD:
                query.dashboardId && path.push((0, $4ursw.ENTITY_ID).DASHBOARD(query.dashboardId));
                break;
            default:
                {
                    const dashboardId = match.params.dashboardId;
                    if (dashboardId === 'last-visited') path.push((0, $4ursw.MENU_ID_DASHBOARDS_VIEW_ALL));
                    else dashboardId && path.push((0, $4ursw.ENTITY_ID).DASHBOARD(dashboardId));
                    break;
                }
        }
        return path;
    }
    const $d7c859492cb29c5d$export$6468819b4be328b1 = {
        routes: $d7c859492cb29c5d$var$routes,
        convert: $d7c859492cb29c5d$var$convert
    };
});
parcelRegister("9SW3e", function(module, exports) {
    $parcel$export(module.exports, "filtersConverter", ()=>$d5c0946d693dd4a7$export$6e91331b5debb7c8);
    var $exb0h = parcelRequire("exb0h");
    var $4ursw = parcelRequire("4ursw");
    const $d5c0946d693dd4a7$var$routes = new Set([
        (0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY),
        (0, $exb0h.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        (0, $exb0h.ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT),
        (0, $exb0h.ROUTE_NAMES_ISSUE),
        (0, $exb0h.ROUTE_NAMES_LEGACY_GIN),
        (0, $exb0h.ROUTE_NAMES_LEGACY_GIN_ISSUE),
        (0, $exb0h.ROUTE_NAMES_LEGACY_GIN_SUBSCRIPTIONS)
    ]);
    function $d5c0946d693dd4a7$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { query: query, match: match } = routeContext;
        const path = [
            (0, $4ursw.MENU_ID_FILTERS)
        ];
        switch(routeName){
            case 0, $exb0h.ROUTE_NAMES_FILTERS_DIRECTORY:
                path.push((0, $4ursw.MENU_ID_FILTERS_VIEW_ALL));
                break;
            case 0, $exb0h.ROUTE_NAMES_ISSUE:
                {
                    const filterId = query.filter || query.filterId;
                    if (filterId) path.push((0, $4ursw.ENTITY_ID).FILTER(filterId));
                    else if (match.params?.issueKey) {
                        const [projectKey] = (match.params?.issueKey || '').split('-');
                        return [
                            (0, $4ursw.MENU_ID_PROJECTS),
                            (0, $4ursw.ENTITY_ID).PROJECT(projectKey)
                        ];
                    }
                    break;
                }
            default:
                {
                    const filterId = query.filter || query.filterId;
                    if (filterId === undefined) path.push((0, $4ursw.MENU_ID_FILTERS_SEARCH));
                    else path.push((0, $4ursw.ENTITY_ID).FILTER(filterId));
                    break;
                }
        }
        return path;
    }
    const $d5c0946d693dd4a7$export$6e91331b5debb7c8 = {
        routes: $d5c0946d693dd4a7$var$routes,
        convert: $d5c0946d693dd4a7$var$convert
    };
});
parcelRegister("9jOdG", function(module, exports) {
    $parcel$export(module.exports, "operationsConverter", ()=>$75fe864bd94cd3f5$export$7fc92455d5020e1);
    var $exb0h = parcelRequire("exb0h");
    var $4ursw = parcelRequire("4ursw");
    const $75fe864bd94cd3f5$var$routes = new Set([
        (0, $exb0h.ROUTE_NAMES_EOC_AUTOMATIONS),
        (0, $exb0h.ROUTE_NAMES_EOC_CUSTOM_ROLES),
        (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_ALERTS),
        (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL),
        (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL),
        (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_REPORTS),
        (0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD),
        (0, $exb0h.ROUTE_NAMES_EOC_HEARTBEATS),
        (0, $exb0h.ROUTE_NAMES_EOC_MAINTENANCE),
        (0, $exb0h.ROUTE_NAMES_EOC_ON_CALL),
        (0, $exb0h.ROUTE_NAMES_EOC_ON_CALL_REDIRECT),
        (0, $exb0h.ROUTE_NAMES_EOC_OVERVIEW),
        (0, $exb0h.ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS),
        (0, $exb0h.ROUTE_NAMES_EOC_PERMISSIONS),
        (0, $exb0h.ROUTE_NAMES_EOC_REPORTS),
        (0, $exb0h.ROUTE_NAMES_EOC_REPORTS_TEAM),
        (0, $exb0h.ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE),
        (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERTS),
        (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS),
        (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING),
        (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE),
        (0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL),
        (0, $exb0h.ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL),
        (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATIONS),
        (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE),
        (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL),
        (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST),
        (0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG),
        (0, $exb0h.ROUTE_NAMES_EOC_TEAM_POLICIES),
        (0, $exb0h.ROUTE_NAMES_EOC_WHO_IS_ON_CALL)
    ]);
    function $75fe864bd94cd3f5$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { query: query } = routeContext;
        const path = [
            (0, $4ursw.MENU_ID_OPERATIONS)
        ];
        switch(routeName){
            case 0, $exb0h.ROUTE_NAMES_EOC_WHO_IS_ON_CALL:
                path.push((0, $4ursw.MENU_ID_OPS_ON_CALL));
                break;
            case 0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_ALERTS:
            case 0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL:
                {
                    path.push((0, $4ursw.MENU_ID_OPS_ALERTS));
                    const { query: alarmQueue = '', view: view } = query;
                    view && path.push((0, $4ursw.ENTITY_ID).ALARM_QUEUE(alarmQueue));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_REPORTS:
            case 0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD:
            case 0, $exb0h.ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE:
                path.push((0, $4ursw.MENU_ID_OPS_REPORTS));
                break;
            case 0, $exb0h.ROUTE_NAMES_EOC_AUTOMATIONS:
            case 0, $exb0h.ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL:
            case 0, $exb0h.ROUTE_NAMES_EOC_HEARTBEATS:
            case 0, $exb0h.ROUTE_NAMES_EOC_MAINTENANCE:
            case 0, $exb0h.ROUTE_NAMES_EOC_PERMISSIONS:
            case 0, $exb0h.ROUTE_NAMES_EOC_ON_CALL:
            case 0, $exb0h.ROUTE_NAMES_EOC_ON_CALL_REDIRECT:
            case 0, $exb0h.ROUTE_NAMES_EOC_OVERVIEW:
            case 0, $exb0h.ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS:
            case 0, $exb0h.ROUTE_NAMES_EOC_REPORTS:
            case 0, $exb0h.ROUTE_NAMES_EOC_REPORTS_TEAM:
            case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL:
            case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERTS:
            case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS:
            case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_POLICIES:
            case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING:
            case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE:
            case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL:
            case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATIONS:
            case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE:
            case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL:
            case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST:
            case 0, $exb0h.ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG:
                path.push((0, $4ursw.MENU_ID_OPS_OVERVIEW));
                break;
            default:
                break;
        }
        return path;
    }
    const $75fe864bd94cd3f5$export$7fc92455d5020e1 = {
        routes: $75fe864bd94cd3f5$var$routes,
        convert: $75fe864bd94cd3f5$var$convert
    };
});
parcelRegister("3MZLo", function(module, exports) {
    $parcel$export(module.exports, "topLevelConverter", ()=>$402f0b0f1023de30$export$a33f2d74a674bf8a);
    var $exb0h = parcelRequire("exb0h");
    var $4ursw = parcelRequire("4ursw");
    const $402f0b0f1023de30$var$routes = new Set([
        (0, $exb0h.ROUTE_NAMES_YOUR_WORK),
        (0, $exb0h.ROUTE_NAMES_PEOPLE_INDEX)
    ]);
    function $402f0b0f1023de30$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [];
        switch(routeName){
            case 0, $exb0h.ROUTE_NAMES_YOUR_WORK:
                path.push((0, $4ursw.MENU_ID_YOUR_WORK));
                break;
            case 0, $exb0h.ROUTE_NAMES_PEOPLE_INDEX:
                path.push((0, $4ursw.MENU_ID_TEAMS));
                break;
            default:
        }
        return path;
    }
    const $402f0b0f1023de30$export$a33f2d74a674bf8a = {
        routes: $402f0b0f1023de30$var$routes,
        convert: $402f0b0f1023de30$var$convert
    };
});
parcelRegister("8LvEn", function(module, exports) {
    $parcel$export(module.exports, "overviewsConverter", ()=>$3ba3852524f3e101$export$5469f6c6536ca9c5);
    var $exb0h = parcelRequire("exb0h");
    var $4ursw = parcelRequire("4ursw");
    const $3ba3852524f3e101$var$routes = new Set([
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE)
    ]);
    function $3ba3852524f3e101$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match } = routeContext;
        const path = [
            (0, $4ursw.MENU_ID_OVERVIEWS)
        ];
        routeName;
        {
            const { overviewId: overviewId } = match.params;
            overviewId && path.push((0, $4ursw.ENTITY_ID).OVERVIEW(overviewId));
        }
        return path;
    }
    const $3ba3852524f3e101$export$5469f6c6536ca9c5 = {
        routes: $3ba3852524f3e101$var$routes,
        convert: $3ba3852524f3e101$var$convert
    };
});
parcelRegister("7BjZJ", function(module, exports) {
    $parcel$export(module.exports, "plansConverter", ()=>$d3b6f17b8e8d1e0a$export$3bde637b58016d1);
    var $exb0h = parcelRequire("exb0h");
    var $4ursw = parcelRequire("4ursw");
    const $d3b6f17b8e8d1e0a$var$routes = new Set([
        (0, $exb0h.ROUTE_NAMES_PLANS_DIRECTORY),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_RELEASES),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_TEAMS),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE),
        (0, $exb0h.ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK)
    ]);
    function $d3b6f17b8e8d1e0a$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match } = routeContext;
        const path = [
            (0, $4ursw.MENU_ID_PLANS)
        ];
        switch(routeName){
            case 0, $exb0h.ROUTE_NAMES_PLANS_DIRECTORY:
            case 0, $exb0h.ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT:
                path.push((0, $4ursw.MENU_ID_PLANS_VIEW_ALL));
                break;
            case 0, $exb0h.ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK:
                break;
            default:
                {
                    const { planId: planId } = match.params;
                    planId && path.push((0, $4ursw.ENTITY_ID).PLAN(planId));
                }
        }
        return path;
    }
    const $d3b6f17b8e8d1e0a$export$3bde637b58016d1 = {
        routes: $d3b6f17b8e8d1e0a$var$routes,
        convert: $d3b6f17b8e8d1e0a$var$convert
    };
});
parcelRegister("hOEfe", function(module, exports) {
    $parcel$export(module.exports, "projectsConverter", ()=>$b1a5de79b6d642fd$export$c41b724886e5872b);
    var $exb0h = parcelRequire("exb0h");
    var $4ursw = parcelRequire("4ursw");
    const $b1a5de79b6d642fd$var$routes = new Set([
        (0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
        (0, $exb0h.ROUTE_NAMES_LEGACY_ALL_REPORTS),
        (0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY),
        (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
        (0, $exb0h.ROUTE_NAMES_PROJECT_COMPONENTS),
        (0, $exb0h.ROUTE_NAMES_PROJECT_NOT_FOUND),
        (0, $exb0h.ROUTE_NAMES_PROJECT_VERSIONS),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
        (0, $exb0h.ROUTE_NAMES_FORGE_PROJECT),
        (0, $exb0h.ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE),
        (0, $exb0h.ROUTE_NAMES_POLARIS_IDEAS),
        (0, $exb0h.ROUTE_NAMES_POLARIS_ONBOARDING),
        (0, $exb0h.ROUTE_NAMES_OPSGENIE_SCHEDULE),
        (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_PROJECT_PAGES),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD),
        (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_BACKLOG),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_BOARDS),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_CODE),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_CODE_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_BUILDER),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_SUBMIT),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_GOALS),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_INCIDENTS),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_PERISCOPE),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REQUESTS),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
        (0, $exb0h.ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED),
        (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES),
        (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR),
        (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY),
        (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES),
        (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES),
        (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE),
        (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY),
        (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE),
        (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS),
        (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS),
        (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_LANDING),
        (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH),
        (0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SETUP),
        (0, $exb0h.ROUTE_NAMES_NOTIFICATION_LOGS),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR_EAP),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ISSUE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ISSUES),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_NEW),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICES),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_ONBOARDING_GET_STARTED)
    ]);
    function $b1a5de79b6d642fd$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const { match: match, query: query } = routeContext;
        const path = [
            (0, $4ursw.MENU_ID_PROJECTS)
        ];
        switch(routeName){
            case 0, $exb0h.ROUTE_NAMES_POLARIS_ONBOARDING:
                break;
            case 0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY:
                path.push((0, $4ursw.MENU_ID_PROJECTS_VIEW_ALL));
                break;
            case 0, $exb0h.ROUTE_NAMES_FORGE_PROJECT:
            case 0, $exb0h.ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE:
                {
                    const { projectKey: projectKey, appId: appId } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    path.push((0, $4ursw.MENU_ID_PROJECT_APPS));
                    appId && path.push((0, $4ursw.ENTITY_ID).APP(appId));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES:
            case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR:
            case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY:
            case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES:
            case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES:
            case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE:
            case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY:
            case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE:
            case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS:
            case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS:
            case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_LANDING:
            case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH:
            case 0, $exb0h.ROUTE_NAMES_KNOWLEDGE_HUB_SETUP:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_KNOWLEDGE_BASE(projectKey));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_JSM_GETTING_STARTED(projectKey));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_NOTIFICATION_LOGS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_NOTIFICATION_LOGS(projectKey));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_SUMMARY(projectKey));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS:
                {
                    const { projectKey: projectKey, boardId: boardId } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_VIEWS(projectKey));
                    boardId && path.push((0, $4ursw.ENTITY_ID).BOARD(boardId));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CALENDAR_EAP:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_VIEWS(projectKey));
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_CALENDAR(projectKey));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_CHANGE_CALENDAR(projectKey));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_DIRECTORY(projectKey));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_ESCALATIONS(projectKey));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_REPORTS(projectKey));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_ONCALL_SCHEDULE(projectKey));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ISSUES:
                {
                    const { projectKey: projectKey } = match.params;
                    const filterId = query.filter || query.filterId;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    if (projectKey && filterId) {
                        path.push((0, $4ursw.ENTITY_ID).PROJECT_FILTERS(projectKey));
                        path.push((0, $4ursw.ENTITY_ID).PROJECT_ISSUE_FILTER(projectKey, filterId));
                    }
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW:
                {
                    const { projectKey: projectKey, practiceType: practiceType, queueId: queueId } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    projectKey && practiceType && path.push((0, $4ursw.ENTITY_ID).PROJECT_PRACTICE_QUEUE(projectKey, practiceType));
                    queueId && path.push((0, $4ursw.ENTITY_ID).QUEUE(queueId));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_QUEUES_NEW:
                {
                    const { projectKey: projectKey, queueId: queueId } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_QUEUES(projectKey));
                    queueId && path.push((0, $4ursw.ENTITY_ID).QUEUE(queueId));
                    break;
                }
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICES:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS:
                {
                    const { projectKey: projectKey } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT_SERVICES(projectKey));
                    break;
                }
            default:
                {
                    const { projectKey: projectKey, boardId: boardId, formId: formId } = match.params;
                    projectKey && path.push((0, $4ursw.ENTITY_ID).PROJECT(projectKey));
                    boardId && path.push((0, $4ursw.ENTITY_ID).BOARD(boardId));
                    formId && path.push((0, $4ursw.ENTITY_ID).FORM(formId));
                }
        }
        return path;
    }
    const $b1a5de79b6d642fd$export$c41b724886e5872b = {
        routes: $b1a5de79b6d642fd$var$routes,
        convert: $b1a5de79b6d642fd$var$convert
    };
});
parcelRegister("aDEwR", function(module, exports) {
    $parcel$export(module.exports, "roadmapsConverter", ()=>$f25eff9fe0f71c8f$export$5761942b1e0c2dd0);
    var $exb0h = parcelRequire("exb0h");
    var $4ursw = parcelRequire("4ursw");
    const $f25eff9fe0f71c8f$var$routes = new Set([
        (0, $exb0h.ROUTE_NAMES_POLARIS_COLLECTIONS)
    ]);
    function $f25eff9fe0f71c8f$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [];
        switch(routeName){
            case 0, $exb0h.ROUTE_NAMES_POLARIS_COLLECTIONS:
                path.push((0, $4ursw.MENU_ID_ROADMAPS));
                break;
            default:
        }
        return path;
    }
    const $f25eff9fe0f71c8f$export$5761942b1e0c2dd0 = {
        routes: $f25eff9fe0f71c8f$var$routes,
        convert: $f25eff9fe0f71c8f$var$convert
    };
});
parcelRegister("aR7J8", function(module, exports) {
    $parcel$export(module.exports, "serviceManagementProjectSettingsConverter", ()=>$daf43b36be2916dc$export$dd307ede503fe0e);
    var $exb0h = parcelRequire("exb0h");
    var $EFSBh = parcelRequire("EFSBh");
    var $fkRbQ = parcelRequire("fkRbQ");
    var $eKJh0 = parcelRequire("eKJh0");
    var $39wMP = parcelRequire("39wMP");
    var $4AXWs = parcelRequire("4AXWs");
    var $1HCPc = parcelRequire("1HCPc");
    var $4ursw = parcelRequire("4ursw");
    const $daf43b36be2916dc$var$routes = new Set([
        (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS),
        (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY),
        (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES),
        (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS),
        (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
        (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS),
        (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS),
        (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS),
        (0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE),
        (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
        (0, $EFSBh.routeGroupsProjectSettingsLegacyAutomationRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskAccessRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskFeedbackRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskFieldsRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskChatRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskEmailRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskExternalLinksRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskPortalSettingsRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskWidgetRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskChangeManagementRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskIncidentManagementRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskClassicAppsRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsVirtualAgentSettingsRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsChatRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsWidgetRoute).name,
        (0, $EFSBh.virtualAgentConversationsRoute).name,
        (0, $EFSBh.virtualAgentIntentsRoute).name,
        (0, $EFSBh.virtualAgentSettingsRoute).name,
        (0, $EFSBh.virtualAgentStandardFlowsRoute).name,
        (0, $EFSBh.projectSettingsServicedeskNotificationsEmailRoute).name,
        (0, $EFSBh.projectSettingsServicedeskNotificationsNotificationEmailRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskAppsFieldsRoute).name,
        (0, $fkRbQ.routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute).name,
        (0, $fkRbQ.routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute).name,
        (0, $eKJh0.routeGroupsProjectSettingsServicedeskKbRoute).name,
        (0, $4AXWs.routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).name,
        (0, $4AXWs.routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute).name,
        (0, $1HCPc.routeGroupsProjectSettingsWorkflowSchemeConfigRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskIssuetypesRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsPortalRoute).name,
        (0, $EFSBh.projectSettingsServicedeskAutomationRoute).name,
        (0, $39wMP.servicedeskSlaSettingsRoute).name,
        (0, $EFSBh.routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute).name
    ]);
    function $daf43b36be2916dc$var$convert(routeContext) {
        const routeName = routeContext.route.name;
        const path = [];
        switch(routeName){
            case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskAccessRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute).name:
            case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS:
            case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY:
                path.push((0, $4ursw.MENU_ID_SD_SETTINGS_ACCESS));
                break;
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory).name:
            case (0, $4AXWs.routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute).name:
                path.push((0, $4ursw.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT), (0, $4ursw.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT_REQUEST_TYPES));
                break;
            case (0, $4AXWs.routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute).name:
            case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS:
            case (0, $1HCPc.routeGroupsProjectSettingsWorkflowSchemeConfigRoute).name:
            case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS_ASSOCIATE:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS:
            case (0, $39wMP.servicedeskSlaSettingsRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskFeedbackRoute).name:
            case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskIssuetypesRoute).name:
            case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskFieldsRoute).name:
            case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS:
                path.push((0, $4ursw.MENU_ID_SD_SETTINGS_REQUEST_MANAGEMENT));
                break;
            case 0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION:
            case (0, $EFSBh.routeGroupsProjectSettingsLegacyAutomationRoute).name:
            case (0, $EFSBh.projectSettingsServicedeskAutomationRoute).name:
                path.push((0, $4ursw.MENU_ID_SD_SETTINGS_AUTOMATION));
                break;
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskPortalSettingsRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsPortalRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskEmailRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskChatRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskWidgetRoute).name:
            case (0, $eKJh0.routeGroupsProjectSettingsServicedeskKbRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskExternalLinksRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsChatRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskChannelsWidgetRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsVirtualAgentSettingsRoute).name:
            case (0, $EFSBh.virtualAgentIntentsRoute).name:
            case (0, $EFSBh.virtualAgentStandardFlowsRoute).name:
            case (0, $EFSBh.virtualAgentConversationsRoute).name:
            case (0, $EFSBh.virtualAgentSettingsRoute).name:
                path.push((0, $4ursw.MENU_ID_SD_SETTINGS_CHANNELS_AND_SELF_SERVICE));
                break;
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskChangeManagementRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskIncidentManagementRoute).name:
                path.push((0, $4ursw.MENU_ID_SD_SETTINGS_OPERATIONS));
                break;
            case 0, $exb0h.ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS:
            case (0, $fkRbQ.routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute).name:
            case (0, $fkRbQ.routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute).name:
            case (0, $EFSBh.projectSettingsServicedeskNotificationsEmailRoute).name:
            case (0, $EFSBh.projectSettingsServicedeskNotificationsNotificationEmailRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute).name:
                path.push((0, $4ursw.MENU_ID_SD_SETTINGS_NOTIFICATIONS));
                break;
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskClassicAppsRoute).name:
            case (0, $EFSBh.routeGroupsProjectSettingsServicedeskAppsFieldsRoute).name:
                path.push((0, $4ursw.MENU_ID_SD_SETTINGS_APPS));
                break;
            default:
                break;
        }
        return path;
    }
    const $daf43b36be2916dc$export$dd307ede503fe0e = {
        routes: $daf43b36be2916dc$var$routes,
        convert: $daf43b36be2916dc$var$convert
    };
});
parcelRegister("EFSBh", function(module, exports) {
    $parcel$export(module.exports, "getJsmProjectSettingsUrl", ()=>$47655043d641f00b$export$b7cec47cdf9c76f1);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIssuetypesRoute", ()=>$47655043d641f00b$export$666cdeccf1f430a6);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIssuetypesWorkflowRoute", ()=>$47655043d641f00b$export$5ed718db41f9c966);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskRequestTypesWorkCategory", ()=>$47655043d641f00b$export$60b14f135c03f9c7);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFieldsRoute", ()=>$47655043d641f00b$export$87914ccacd42ab35);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAppsFieldsRoute", ()=>$47655043d641f00b$export$e382068c2b8a7b9f);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskApps1Route", ()=>$47655043d641f00b$export$7ae67c73ac5367a8);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskDetailsRoute", ()=>$47655043d641f00b$export$b237f4f6820b26e9);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAccessRoute", ()=>$47655043d641f00b$export$f7e149bf217bbb2c);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAccessRedirectRoute", ()=>$47655043d641f00b$export$eb1177fbc6c41b97);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute", ()=>$47655043d641f00b$export$f919d82b98f9257a);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskProformaJiraFormBuilderRoute", ()=>$47655043d641f00b$export$ce59d5cb98345f8e);
    $parcel$export(module.exports, "projectSettingsServicedeskAutomationRoute", ()=>$47655043d641f00b$export$1a2228d5e07202a0);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskDataClassificationsRoute", ()=>$47655043d641f00b$export$1596046a0b047934);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskClassicAppsRoute", ()=>$47655043d641f00b$export$3ab501c22b91462b);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskItsmFeaturesRoute", ()=>$47655043d641f00b$export$324e5a618f1ac5a1);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute", ()=>$47655043d641f00b$export$e6f711e47860f891);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute", ()=>$47655043d641f00b$export$4ef3eecacde57780);
    $parcel$export(module.exports, "projectSettingsServicedeskNotificationsNotificationEmailRoute", ()=>$47655043d641f00b$export$40539cb16771014e);
    $parcel$export(module.exports, "projectSettingsServicedeskNotificationsEmailRoute", ()=>$47655043d641f00b$export$1f37a1aff4f594af);
    $parcel$export(module.exports, "projectSettingsServicedeskNotifications1Route", ()=>$47655043d641f00b$export$18c6f3890d9fd8b8);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskLanguageKeyRoute", ()=>$47655043d641f00b$export$d195c572a6155c05);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskLanguage1Route", ()=>$47655043d641f00b$export$8152b460f5961d94);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute", ()=>$47655043d641f00b$export$e184fa302b6981b6);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute", ()=>$47655043d641f00b$export$dd22cfc45fe86c35);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsEmailNextGenRoute", ()=>$47655043d641f00b$export$b03f0a1a580a902f);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskEmailRoute", ()=>$47655043d641f00b$export$d29fa1140db9296d);
    $parcel$export(module.exports, "routeGroupsProjectSettingsLegacyAutomationRoute", ()=>$47655043d641f00b$export$abc6508b4dce2d9b);
    $parcel$export(module.exports, "routeGroupsProjectSettingsVirtualAgentSettingsRoute", ()=>$47655043d641f00b$export$680ccfe6e5af63a8);
    $parcel$export(module.exports, "virtualAgentIntentsRoute", ()=>$47655043d641f00b$export$1e70273fc2a407f5);
    $parcel$export(module.exports, "virtualAgentStandardFlowsRoute", ()=>$47655043d641f00b$export$f45c942ecfcc5682);
    $parcel$export(module.exports, "virtualAgentConversationsRoute", ()=>$47655043d641f00b$export$837f003bb6f40f9);
    $parcel$export(module.exports, "virtualAgentSettingsRoute", ()=>$47655043d641f00b$export$80422a49e17dfd6b);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsPortalRoute", ()=>$47655043d641f00b$export$394d5ca6ce9e5949);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskPortalSettingsRoute", ()=>$47655043d641f00b$export$e856498dc02e46e8);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskExternalLinksRoute", ()=>$47655043d641f00b$export$d0198d2da30de212);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsWidgetRoute", ()=>$47655043d641f00b$export$fe54e02c94ff5613);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskWidgetRoute", ()=>$47655043d641f00b$export$164572fb58075291);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChangeManagementRoute", ()=>$47655043d641f00b$export$10089d339d8e30d1);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskIncidentManagementRoute", ()=>$47655043d641f00b$export$ff20eaee6cf19401);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannelsChatRoute", ()=>$47655043d641f00b$export$8e2543080acfc7c2);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChatRoute", ()=>$47655043d641f00b$export$3a3e70b8651d8d57);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskChannels5Route", ()=>$47655043d641f00b$export$77d19d35e71558b3);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskFeedbackRoute", ()=>$47655043d641f00b$export$cd46cad965f517e2);
    $parcel$export(module.exports, "projectSettingsServicedeskForgeAppsRoute", ()=>$47655043d641f00b$export$10bafd1256118bb8);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskRedirectRoute", ()=>$47655043d641f00b$export$43b5b901d4988763);
    var $exb0h = parcelRequire("exb0h");
    const $47655043d641f00b$var$SERVICE_DESK_PRODUCT = 'servicedesk';
    const $47655043d641f00b$export$b7cec47cdf9c76f1 = (projectKey)=>`/jira/${$47655043d641f00b$var$SERVICE_DESK_PRODUCT}/projects/${projectKey || ':projectKey'}/settings`;
    const $47655043d641f00b$var$jsmProjectSettingsUrl = $47655043d641f00b$export$b7cec47cdf9c76f1();
    const $47655043d641f00b$export$666cdeccf1f430a6 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/issuetypes/:issueTypeId?`,
        exact: true
    };
    const $47655043d641f00b$export$5ed718db41f9c966 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes-workflow`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/issuetypes/:issueTypeId/:initialSection(workflow)`,
        exact: true
    };
    const $47655043d641f00b$export$60b14f135c03f9c7 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-request-types-work-category`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/request-types/category/:practice`,
        exact: true
    };
    const $47655043d641f00b$export$87914ccacd42ab35 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-fields`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/fields`,
        exact: true
    };
    const $47655043d641f00b$export$e382068c2b8a7b9f = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-apps-fields`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/apps/app-fields`,
        exact: true
    };
    const $47655043d641f00b$export$7ae67c73ac5367a8 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-apps`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/apps/:appId?`,
        exact: true
    };
    const $47655043d641f00b$export$b237f4f6820b26e9 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_DETAILS),
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/details`,
        exact: true
    };
    const $47655043d641f00b$export$f7e149bf217bbb2c = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-access`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/access`,
        exact: true
    };
    const $47655043d641f00b$export$eb1177fbc6c41b97 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-access-redirect`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/people`,
        exact: true
    };
    const $47655043d641f00b$export$f919d82b98f9257a = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-proforma-project-forms`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/forms`,
        exact: true
    };
    const $47655043d641f00b$export$ce59d5cb98345f8e = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-proforma-jira-form-builder`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/forms/form/:templateFormId/edit`,
        exact: true
    };
    const $47655043d641f00b$export$1a2228d5e07202a0 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/automate`
    };
    const $47655043d641f00b$export$1596046a0b047934 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-data-classifications`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/data-classifications`,
        exact: true
    };
    const $47655043d641f00b$export$3ab501c22b91462b = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-classic-apps`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/apps`,
        exact: true
    };
    const $47655043d641f00b$export$324e5a618f1ac5a1 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-features`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/itsm-features`,
        exact: true
    };
    const $47655043d641f00b$export$e6f711e47860f891 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-notifications-internal-notifications`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/notifications/internal-notifications`
    };
    const $47655043d641f00b$export$4ef3eecacde57780 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN),
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/internal-notifications`
    };
    const $47655043d641f00b$export$40539cb16771014e = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS_NOTIFICATION_EMAIL),
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/notifications/notification-email`,
        exact: true
    };
    const $47655043d641f00b$export$1f37a1aff4f594af = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATION_EMAIL),
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/notification-email`,
        exact: true
    };
    const $47655043d641f00b$export$18c6f3890d9fd8b8 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_NOTIFICATIONS),
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/notifications`,
        exact: true
    };
    const $47655043d641f00b$export$d195c572a6155c05 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-language-key`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/language/:languageKey/:sidebarItemKey?`
    };
    const $47655043d641f00b$export$8152b460f5961d94 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-language`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/language`,
        exact: true
    };
    const $47655043d641f00b$export$e184fa302b6981b6 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-permissions-next-gen`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/channels/customer-permissions`,
        exact: true
    };
    const $47655043d641f00b$export$dd22cfc45fe86c35 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_PERMISSIONS),
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/customer-permissions`,
        exact: true
    };
    const $47655043d641f00b$export$b03f0a1a580a902f = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-email-next-gen`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/channels/email`,
        exact: true
    };
    const $47655043d641f00b$export$d29fa1140db9296d = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_EMAIL_SETTINGS),
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/email`,
        exact: true
    };
    const $47655043d641f00b$export$abc6508b4dce2d9b = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/automation`,
        exact: true
    };
    const $47655043d641f00b$export$680ccfe6e5af63a8 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/virtual-agent`,
        exact: true
    };
    const $47655043d641f00b$export$1e70273fc2a407f5 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-intents`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/virtual-agent/intents`,
        exact: true
    };
    const $47655043d641f00b$export$f45c942ecfcc5682 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-standard-flows`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/virtual-agent/standard-flows`,
        exact: true
    };
    const $47655043d641f00b$export$837f003bb6f40f9 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-conversations`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/virtual-agent/conversations`,
        exact: true
    };
    const $47655043d641f00b$export$80422a49e17dfd6b = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtual-agent-settings`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/virtual-agent/settings`,
        exact: true
    };
    const $47655043d641f00b$export$394d5ca6ce9e5949 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-portal`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/channels/portal-settings`,
        exact: true
    };
    const $47655043d641f00b$export$e856498dc02e46e8 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_PORTAL_SETTINGS),
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/portal-settings/:subPath(portal-groups)?`,
        exact: true
    };
    const $47655043d641f00b$export$d0198d2da30de212 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-external-links`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/external-links`,
        exact: true
    };
    const $47655043d641f00b$export$fe54e02c94ff5613 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-widget`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/channels/widget`,
        exact: true
    };
    const $47655043d641f00b$export$164572fb58075291 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_WIDGET_SETTINGS),
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/widget`,
        exact: true
    };
    const $47655043d641f00b$export$10089d339d8e30d1 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-change-management`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/change-management`,
        exact: true
    };
    const $47655043d641f00b$export$ff20eaee6cf19401 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-incident-management`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/incident-management`,
        exact: true
    };
    const $47655043d641f00b$export$8e2543080acfc7c2 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels-chat`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/channels/chat`,
        exact: true
    };
    const $47655043d641f00b$export$3a3e70b8651d8d57 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CHAT),
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/chat`,
        exact: true
    };
    const $47655043d641f00b$export$77d19d35e71558b3 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-channels`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/channels`,
        exact: true
    };
    const $47655043d641f00b$export$cd46cad965f517e2 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-feedback`,
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/feedback-settings`
    };
    const $47655043d641f00b$export$10bafd1256118bb8 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_FORGE_APPS),
        path: `${$47655043d641f00b$var$jsmProjectSettingsUrl}/apps/:appId/:envId/:route?`
    };
    const $47655043d641f00b$export$43b5b901d4988763 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-redirect`,
        path: $47655043d641f00b$var$jsmProjectSettingsUrl
    };
});
parcelRegister("fkRbQ", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute", ()=>$3cae002c727972f0$export$7fc567ce6cdc6b52);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute", ()=>$3cae002c727972f0$export$688d2c8abd7b3661);
    var $exb0h = parcelRequire("exb0h");
    const $3cae002c727972f0$export$5575497f0592ee94 = 'servicedesk';
    const $3cae002c727972f0$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $3cae002c727972f0$export$7fc567ce6cdc6b52 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, $exb0h.ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_CUSTOMER_NOTIFICATIONS),
        path: `${$3cae002c727972f0$var$projectSettingsUrl($3cae002c727972f0$export$5575497f0592ee94)}/customer-notifications`
    };
    const $3cae002c727972f0$export$688d2c8abd7b3661 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-notifications-customer-notifications`,
        path: `${$3cae002c727972f0$var$projectSettingsUrl($3cae002c727972f0$export$5575497f0592ee94)}/notifications/customer-notifications`
    };
});
parcelRegister("eKJh0", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskKbRoute", ()=>$33a9059fcebe7f73$export$8855316927afaed1);
    var $exb0h = parcelRequire("exb0h");
    const $33a9059fcebe7f73$export$5575497f0592ee94 = 'servicedesk';
    const $33a9059fcebe7f73$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $33a9059fcebe7f73$export$8855316927afaed1 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-kb`,
        path: `${$33a9059fcebe7f73$var$projectSettingsUrl($33a9059fcebe7f73$export$5575497f0592ee94)}/confluence-kb`,
        exact: true
    };
});
parcelRegister("39wMP", function(module, exports) {
    $parcel$export(module.exports, "servicedeskSlaSettingsRoute", ()=>$b7932788ec438e72$export$bfbf66468910573e);
    var $exb0h = parcelRequire("exb0h");
    const $b7932788ec438e72$export$5575497f0592ee94 = 'servicedesk';
    const $b7932788ec438e72$export$bfbf66468910573e = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, $exb0h.ROUTE_NAMES_SERVICEDESK_SLA_SETTINGS),
        path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?'
    };
});
parcelRegister("4AXWs", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute", ()=>$9ded92290a75756e$export$cd0f363eecbc2379);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskItsmTicketTypesConfigRoute", ()=>$9ded92290a75756e$export$96fd54e139924473);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute", ()=>$9ded92290a75756e$export$1eebd582a7db1c90);
    var $exb0h = parcelRequire("exb0h");
    const $9ded92290a75756e$export$5575497f0592ee94 = 'servicedesk';
    const $9ded92290a75756e$export$cd0f363eecbc2379 = {
        exact: true,
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-unassigned-ticket-types-config`,
        path: `/jira/${$9ded92290a75756e$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/unassigned`
    };
    const $9ded92290a75756e$export$96fd54e139924473 = {
        exact: true,
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-ticket-types-config`,
        path: `/jira/${$9ded92290a75756e$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/category/:practice`
    };
    const $9ded92290a75756e$export$1eebd582a7db1c90 = {
        exact: true,
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-ticket-types-config`,
        path: `/jira/${$9ded92290a75756e$export$5575497f0592ee94}/projects/:projectKey/settings/request-types`
    };
});
parcelRegister("1HCPc", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsWorkflowSchemeConfigRoute", ()=>$dc22772ba6709c2c$export$ad30542ae2fd7196);
    var $exb0h = parcelRequire("exb0h");
    const $dc22772ba6709c2c$export$ad30542ae2fd7196 = {
        group: (0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, $exb0h.ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-workflow-scheme-config`,
        path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
        exact: true
    };
});
parcelRegister("buJlM", function(module, exports) {
    $parcel$export(module.exports, "RELAY_RESOURCE_TYPE", ()=>$485f6c69495cf127$export$c6c8c12c0f1d8e54);
    $parcel$export(module.exports, "createRelayResource", ()=>$485f6c69495cf127$export$1cc887c62079ea32);
    $parcel$export(module.exports, "useRelayResource", ()=>$485f6c69495cf127$export$42ca7b248c7aaee);
    var $iWLL0 = parcelRequire("iWLL0");
    var $cNy9K = parcelRequire("cNy9K");
    var $6iz4v = parcelRequire("6iz4v");
    var $eI5EY = parcelRequire("eI5EY");
    var $amu7D = parcelRequire("amu7D");
    var $15ZJO = parcelRequire("15ZJO");
    var $c7ifG = parcelRequire("c7ifG");
    var $lB25E = parcelRequire("lB25E");
    var $7qse3 = parcelRequire("7qse3");
    const $485f6c69495cf127$export$c6c8c12c0f1d8e54 = 'RELAY_RESOURCE_TYPE';
    const $485f6c69495cf127$var$getDataOld = async ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
        const measureName = `relay_resource_get_data:${type}`;
        const startMark = `relay_resource_get_data:${type}:start`;
        const endMark = `relay_resource_get_data:${type}:end`;
        (0, $6iz4v.setMark)(startMark);
        const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
        const query = parameters ?? await loadParameters?.();
        const queryReference = (0, $6iz4v.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $iWLL0.loadQuery)((0, $amu7D.default)(), query, variables || {}, options));
        if (false && queryReference.id != null) await (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
        if (queryReference.id != null) (0, $c7ifG.QueryPromisesMap).get(queryReference.id)?.then(()=>{
            (0, $6iz4v.setMark)(endMark);
            (0, $6iz4v.setMeasure)(measureName, startMark, endMark);
        });
        if (captureErrors) (0, $15ZJO.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
        if (captureTraceIds) (0, $7qse3.startCapturingTraceIds)(queryReference.name);
        return queryReference;
    };
    const $485f6c69495cf127$var$getDataNew = ({ routerContext: routerContext, customContext: customContext, type: type, getQuery: getQuery, captureErrors: captureErrors, captureTraceIds: captureTraceIds })=>{
        const measureName = `relay_resource_get_data:${type}`;
        const startMark = `relay_resource_get_data:${type}:start`;
        const endMark = `relay_resource_get_data:${type}:end`;
        (0, $6iz4v.setMark)(startMark);
        const { parameters: parameters, variables: variables, options: options } = getQuery(routerContext, customContext);
        const queryReference = (0, $6iz4v.measureFunc)(`relay_resource_load_query:${type}`, ()=>(0, $iWLL0.loadQuery)((0, $amu7D.default)(), parameters, variables || {}, options));
        if (false && queryReference.id != null) {
            const promise = (0, $c7ifG.QueryPromisesMap).get(queryReference.id);
            if (promise) return promise.then(()=>{
                (0, $6iz4v.setMark)(endMark);
                (0, $6iz4v.setMeasure)(measureName, startMark, endMark);
                if (captureErrors) (0, $15ZJO.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
                if (captureTraceIds) (0, $7qse3.startCapturingTraceIds)(queryReference.name);
                return queryReference;
            });
        }
        if (queryReference.id != null) (0, $c7ifG.QueryPromisesMap).get(queryReference.id)?.then(()=>{
            (0, $6iz4v.setMark)(endMark);
            (0, $6iz4v.setMeasure)(measureName, startMark, endMark);
        });
        if (captureErrors) (0, $15ZJO.startCaptureGraphQlErrors)(queryReference.fetchKey.toString());
        if (captureTraceIds) (0, $7qse3.startCapturingTraceIds)(queryReference.name);
        return queryReference;
    };
    const $485f6c69495cf127$var$createRelayResourceImpl = ({ type: type, isBrowserOnly: isBrowserOnly, getQuery: getQuery, loadParameters: loadParameters, captureErrors: captureErrors = false, captureTraceIds: captureTraceIds = false })=>(0, $lB25E.createResource)({
            type: `${$485f6c69495cf127$export$c6c8c12c0f1d8e54}_${type}`,
            getKey: (routerContext, customContext)=>{
                const { parameters: preloadableRequest, variables: variables } = getQuery(routerContext, customContext);
                if (!preloadableRequest) return JSON.stringify(variables || {});
                let queryId;
                let params;
                if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
                    const preloadableConcreteRequest = preloadableRequest;
                    ({ params: params } = preloadableConcreteRequest);
                    ({ id: queryId } = params);
                } else {
                    const graphQlTaggedNode = preloadableRequest;
                    const request = (0, $cNy9K.getRequest)(graphQlTaggedNode);
                    params = request.params;
                    queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
                }
                return `${String(queryId)}${JSON.stringify(variables || {})}`;
            },
            getData: (routerContext, customContext)=>{
                if ((0, $eI5EY.fg)('blu-3813-improve-ssr-hydration-of-relay')) return $485f6c69495cf127$var$getDataNew({
                    routerContext: routerContext,
                    customContext: customContext,
                    type: type,
                    getQuery: getQuery,
                    captureErrors: captureErrors,
                    captureTraceIds: captureTraceIds
                });
                return $485f6c69495cf127$var$getDataOld({
                    routerContext: routerContext,
                    customContext: customContext,
                    type: type,
                    loadParameters: loadParameters,
                    getQuery: getQuery,
                    captureErrors: captureErrors,
                    captureTraceIds: captureTraceIds
                });
            },
            maxAge: 0,
            isBrowserOnly: isBrowserOnly
        });
    const $485f6c69495cf127$export$1cc887c62079ea32 = $485f6c69495cf127$var$createRelayResourceImpl;
    const $485f6c69495cf127$export$bbe949b85c06f763 = $485f6c69495cf127$var$createRelayResourceImpl;
    const $485f6c69495cf127$export$42ca7b248c7aaee = (resource, options)=>{
        const { data: queryReference, loading: loading, promise: promise } = (0, $lB25E.useResource)(resource);
        if (options?.suspendWhenLoading && loading) throw promise;
        return {
            queryReference: queryReference
        };
    };
});
parcelRegister("hkmE9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$85ac2903ab7cc20b$export$2e2bcd8739ae039);
    const $85ac2903ab7cc20b$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isAppsExpanded"
        }, v2 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isDashboardsExpanded"
        }, v3 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isFiltersExpanded"
        }, v4 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isOperationsExpanded"
        }, v5 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isPlansExpanded"
        }, v6 = {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isProjectsExpanded"
        }, v7 = {
            "kind": "ScalarField",
            "name": "id"
        }, v8 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v9 = [
            v8
        ], v10 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v11 = {
            "kind": "ScalarField",
            "name": "label"
        }, v12 = {
            "kind": "ScalarField",
            "name": "styleClass"
        }, v13 = {
            "kind": "ScalarField",
            "name": "url"
        }, v14 = {
            "order": "DESC"
        }, v15 = {
            "kind": "Literal",
            "name": "first",
            "value": 15
        }, v16 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v17 = {
            "kind": "ScalarField",
            "name": "name"
        }, v18 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v19 = {
            "kind": "InlineFragment",
            "selections": [
                v7
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v20 = [
            {
                "kind": "Literal",
                "name": "type",
                "value": "EDIT_PROJECT_CONFIG"
            }
        ], v21 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v22 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v23 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v10,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v7,
                            {
                                "alias": "projectKey",
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectType"
                            },
                            {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "large"
                                    }
                                ]
                            },
                            v17,
                            {
                                "kind": "ScalarField",
                                "name": "projectId"
                            },
                            v18,
                            {
                                "kind": "LinkedField",
                                "name": "defaultNavigationItem",
                                "plural": false,
                                "selections": [
                                    v10,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "typeKey"
                                            }
                                        ],
                                        "type": "JiraNavigationItem",
                                        "abstractKey": "__isJiraNavigationItem"
                                    },
                                    v19
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "navigationMetadata",
                                "plural": false,
                                "selections": [
                                    v10,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "boardId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isSimpleBoard"
                                            },
                                            v7
                                        ],
                                        "type": "JiraSoftwareProjectNavigationMetadata"
                                    }
                                ]
                            },
                            {
                                "alias": "editProjectConfig",
                                "args": v20,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v21,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "projectStyle"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "webUrl"
                            },
                            {
                                "alias": "canEditProjectConfig",
                                "args": v20,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v21,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "alias": "canViewProjectConfig",
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "VIEW_PROJECT_CONFIG"
                                    }
                                ],
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v21,
                                "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                            },
                            v22,
                            {
                                "args": v20,
                                "concreteType": "JiraProjectAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": v21,
                                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "softwareBoardCount"
                            }
                        ],
                        "type": "JiraProject"
                    },
                    v19
                ]
            }
        ], v24 = {
            "kind": "Literal",
            "name": "first",
            "value": 20
        }, v25 = {
            "kind": "ScalarField",
            "name": "filterId"
        }, v26 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v27 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                },
                {
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                        v10,
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        v7
                    ]
                }
            ],
            "type": "JiraCustomFilter"
        }, v28 = {
            "kind": "ScalarField",
            "name": "title"
        }, v29 = {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                v18,
                v7
            ]
        }, v30 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v10,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v7,
                            {
                                "kind": "ScalarField",
                                "name": "planId"
                            },
                            v28,
                            {
                                "kind": "ScalarField",
                                "name": "isReadOnly"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "planStatus"
                            },
                            v29,
                            {
                                "concreteType": "JiraScenario",
                                "kind": "LinkedField",
                                "name": "scenario",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "scenarioId"
                                    },
                                    v7
                                ]
                            }
                        ],
                        "type": "JiraPlan"
                    },
                    v19
                ]
            }
        ], v31 = [
            {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                    v10,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v7,
                            {
                                "kind": "ScalarField",
                                "name": "dashboardId"
                            },
                            v28,
                            v29
                        ],
                        "type": "JiraDashboard"
                    },
                    v19
                ]
            }
        ], v32 = [
            v7,
            v17,
            {
                "kind": "ScalarField",
                "name": "alertSearchQuery"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6
                ],
                "kind": "Fragment",
                "name": "L1MenuItemsQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "ConfigurableMenuItems"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v5,
                    v6,
                    v4
                ],
                "kind": "Operation",
                "name": "L1MenuItemsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudID",
                                        "variableName": "cloudId"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "navKey",
                                        "value": "NAV_SIDEBAR"
                                    }
                                ],
                                "concreteType": "JiraUserNavigationConfiguration",
                                "kind": "LinkedField",
                                "name": "userNavigationConfiguration",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfigurableNavigationItem",
                                        "kind": "LinkedField",
                                        "name": "navItems",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "menuId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isVisible"
                                            }
                                        ]
                                    },
                                    v7
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "canCreateProject",
                                "args": [
                                    v8,
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "CREATE_PROJECT"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "canPerform"
                            },
                            {
                                "condition": "isAppsExpanded",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": v9,
                                        "concreteType": "JiraNavigationItemConnection",
                                        "kind": "LinkedField",
                                        "name": "globalAppNavigationItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraNavigationItemEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v10,
                                                            v7,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v11,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "appId"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "appType"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "envLabel"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "iconUrl"
                                                                    },
                                                                    v12,
                                                                    {
                                                                        "concreteType": "JiraAppSection",
                                                                        "kind": "LinkedField",
                                                                        "name": "sections",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v11,
                                                                            {
                                                                                "concreteType": "JiraAppNavigationItemNestedLink",
                                                                                "kind": "LinkedField",
                                                                                "name": "links",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v11,
                                                                                    v13,
                                                                                    v12
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "settingsUrl"
                                                                    },
                                                                    v13
                                                                ],
                                                                "type": "JiraAppNavigationItem"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v9,
                                "concreteType": "JiraAdvancedRoadmapsNavigation",
                                "kind": "LinkedField",
                                "name": "advancedRoadmapsNavigation",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasEditPermissions"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasCreateSamplePlanPermissions"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "hasGlobalPlansAdminPermissions"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isProjectsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouriteProjects",
                                        "args": [
                                            v8,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v14,
                                                    "type": "PROJECT"
                                                }
                                            },
                                            v15
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v16,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v23
                                            },
                                            v22
                                        ]
                                    },
                                    {
                                        "alias": "recentProjects",
                                        "args": [
                                            v8,
                                            v24,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "PROJECT"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v23
                                            },
                                            v22
                                        ]
                                    },
                                    {
                                        "args": v9,
                                        "concreteType": "JiraWorkManagementLicensing",
                                        "kind": "LinkedField",
                                        "name": "jwmLicensing",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "currentUserSeatEdition"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isFiltersExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouriteFilters",
                                        "args": [
                                            v8,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v14,
                                                    "type": "FILTER"
                                                }
                                            },
                                            v15
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v16,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v10,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v25,
                                                                    v17,
                                                                    v7,
                                                                    v18,
                                                                    v26,
                                                                    v27
                                                                ],
                                                                "type": "JiraFilter",
                                                                "abstractKey": "__isJiraFilter"
                                                            },
                                                            v19
                                                        ]
                                                    }
                                                ]
                                            },
                                            v22
                                        ]
                                    },
                                    {
                                        "alias": "recentFilters",
                                        "args": [
                                            v8,
                                            v24,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "FILTER"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v10,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v25,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v17,
                                                                            v7,
                                                                            v18,
                                                                            v26,
                                                                            v27
                                                                        ],
                                                                        "type": "JiraFilter",
                                                                        "abstractKey": "__isJiraFilter"
                                                                    }
                                                                ],
                                                                "type": "JiraCustomFilter"
                                                            },
                                                            v19
                                                        ]
                                                    }
                                                ]
                                            },
                                            v22
                                        ]
                                    },
                                    {
                                        "args": v9,
                                        "concreteType": "JiraSystemFilterConnection",
                                        "kind": "LinkedField",
                                        "name": "systemFilters",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSystemFilterEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraSystemFilter",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v25,
                                                            v7,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v17,
                                                                    v10,
                                                                    v18,
                                                                    v26,
                                                                    v27
                                                                ],
                                                                "type": "JiraFilter",
                                                                "abstractKey": "__isJiraFilter"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isPlansExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "favouritePlans",
                                        "args": [
                                            v8,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v14,
                                                    "type": "PLAN"
                                                }
                                            },
                                            v15
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v30
                                            },
                                            v22
                                        ]
                                    },
                                    {
                                        "alias": "recentPlans",
                                        "args": [
                                            v8,
                                            v24,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "PLAN"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v30
                                            },
                                            v22
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isDashboardsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": "dashboardFavourites",
                                        "args": [
                                            v8,
                                            {
                                                "kind": "Literal",
                                                "name": "filter",
                                                "value": {
                                                    "sort": v14,
                                                    "type": "DASHBOARD"
                                                }
                                            },
                                            v15
                                        ],
                                        "concreteType": "JiraFavouriteConnection",
                                        "kind": "LinkedField",
                                        "name": "favourites",
                                        "plural": false,
                                        "selections": [
                                            v16,
                                            {
                                                "concreteType": "JiraFavouriteEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v31
                                            },
                                            v22
                                        ]
                                    },
                                    {
                                        "alias": "dashboardRecents",
                                        "args": [
                                            v8,
                                            v24,
                                            {
                                                "kind": "Literal",
                                                "name": "types",
                                                "value": [
                                                    "DASHBOARD"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraSearchableEntityConnection",
                                        "kind": "LinkedField",
                                        "name": "recentItems",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSearchableEntityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v31
                                            },
                                            v22
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "isOperationsExpanded",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "OpsgenieQuery",
                                "kind": "LinkedField",
                                "name": "opsgenie",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v9,
                                        "concreteType": "OpsgenieSavedSearches",
                                        "kind": "LinkedField",
                                        "name": "savedSearches",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "OpsgenieSavedSearch",
                                                "kind": "LinkedField",
                                                "name": "sharedWithMe",
                                                "plural": true,
                                                "selections": v32
                                            },
                                            {
                                                "concreteType": "OpsgenieSavedSearch",
                                                "kind": "LinkedField",
                                                "name": "createdByMe",
                                                "plural": true,
                                                "selections": v32
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "a1a0d3f1f06e24b9bacb1d1457e2544e05e12f69cd919d3dec153fc44ad26259",
                "metadata": {},
                "name": "L1MenuItemsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $85ac2903ab7cc20b$var$node.hash = "301906cf56b46d61420af572d827d1a7";
    var $85ac2903ab7cc20b$export$2e2bcd8739ae039 = $85ac2903ab7cc20b$var$node;
});
parcelRegister("u0mbR", function(module, exports) {
    $parcel$export(module.exports, "SidebarStart", ()=>$b1949a81125e9848$export$6738d1299dc79710);
    $parcel$export(module.exports, "SidebarRenderStart", ()=>$b1949a81125e9848$export$ba19e3624956e66);
    $parcel$export(module.exports, "SidebarReady", ()=>$b1949a81125e9848$export$a06ecbbe5820282);
    $parcel$export(module.exports, "useSidebarFail", ()=>$b1949a81125e9848$export$661ed14c8f75da9f);
    $parcel$export(module.exports, "useSidebarSuccess", ()=>$b1949a81125e9848$export$ddb17534fdfb7dc6);
    var $eUqFw = parcelRequire("eUqFw");
    var $8fxTv = parcelRequire("8fxTv");
    var $7webZ = parcelRequire("7webZ");
    var $4qhD6 = parcelRequire("4qhD6");
    var $bDhRl = parcelRequire("bDhRl");
    var $fDZ6r = parcelRequire("fDZ6r");
    var $jmt32 = parcelRequire("jmt32");
    var $10fdS = parcelRequire("10fdS");
    var $jMP2a = parcelRequire("jMP2a");
    var $1inzG = parcelRequire("1inzG");
    var $3O0Td = parcelRequire("3O0Td");
    var $lB25E = parcelRequire("lB25E");
    var $bgNoL = parcelRequire("bgNoL");
    const { useValue: $b1949a81125e9848$var$useSidebarId } = (0, $jmt32.createValueController)('sidebar-id');
    const $b1949a81125e9848$var$EXPERIENCE_SUCCESS_ATTRIBUTES = {
        experience: (0, $bgNoL.SIDEBAR_EXPERIENCE),
        attributes: {
            sidebar: 'v3'
        }
    };
    const $b1949a81125e9848$export$6738d1299dc79710 = ()=>{
        const [{ route: route, match: match }] = (0, $lB25E.useRouter)();
        const pageId = (0, $3O0Td.usePageId)();
        const startRef = (0, $eUqFw.useRef)(Date.now());
        const onStartExperience = (0, $bDhRl.useExperienceStart)({
            experienceId: pageId,
            experience: (0, $bgNoL.SIDEBAR_EXPERIENCE),
            analyticsSource: 'Sidebar'
        });
        (0, $eUqFw.useMemo)(()=>{
            if (route.isRedirect ?? false) return;
            onStartExperience();
            startRef.current = Date.now();
        }, [
            route,
            match
        ]);
        return null;
    };
    const $b1949a81125e9848$export$ba19e3624956e66 = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceMark), {
            metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderStart
        });
    const $b1949a81125e9848$export$a06ecbbe5820282 = ({ id: id })=>{
        const [, setSidebarId] = $b1949a81125e9848$var$useSidebarId();
        const route = (0, $10fdS.useCurrentRoute)();
        const routeName = route.name ?? route.group ?? 'UNKNOWN';
        const onSuccess = (0, $fDZ6r.useExperienceSuccess)($b1949a81125e9848$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
        (0, $eUqFw.useEffect)(()=>{
            setSidebarId(id);
            return ()=>setSidebarId();
        }, [
            setSidebarId,
            id
        ]);
        (0, $eUqFw.useLayoutEffect)(()=>{
            if (route.isRedirect ?? false) return;
            onSuccess();
        }, [
            onSuccess,
            route
        ]);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        (0, $eUqFw.useEffect)(()=>{
            window.__POLLINATOR__ = {
                ...window.__POLLINATOR__,
                routeName: routeName
            };
            const event = createAnalyticsEvent({
                action: 'ready',
                actionSubject: 'sidebar',
                meta: {
                    teamName: 'endeavour'
                }
            });
            (0, $jMP2a.fireUIAnalytics)(event, 'Sidebar Ready', {
                route: routeName
            });
        }, [
            createAnalyticsEvent,
            routeName
        ]);
        const customData = (0, $eUqFw.useMemo)(()=>({
                route: routeName,
                sidebarId: id
            }), [
            routeName,
            id
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceMark), {
            metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderEnd
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceReport), {
            customData: customData
        }));
    };
    const $b1949a81125e9848$export$661ed14c8f75da9f = ()=>{
        const onFail = (0, $4qhD6.useExperienceFail)({
            experience: (0, $bgNoL.SIDEBAR_EXPERIENCE)
        });
        return (0, $eUqFw.useCallback)((location, error)=>{
            onFail(location, error);
        }, [
            onFail
        ]);
    };
    const $b1949a81125e9848$export$ddb17534fdfb7dc6 = ()=>(0, $fDZ6r.useExperienceSuccess)($b1949a81125e9848$var$EXPERIENCE_SUCCESS_ATTRIBUTES);
});
parcelRegister("4qhD6", function(module, exports) {
    $parcel$export(module.exports, "useExperienceFail", ()=>$2f159cb06c119de7$export$606da7704d8eaf06);
    var $eUqFw = parcelRequire("eUqFw");
    var $lXcGv = parcelRequire("lXcGv");
    var $JRB5w = parcelRequire("JRB5w");
    var $gtrMw = parcelRequire("gtrMw");
    const $2f159cb06c119de7$export$606da7704d8eaf06 = ({ experience: experience, attributes: attributes })=>{
        const experienceTracker = (0, $gtrMw.useExperienceContext)();
        const self = (0, $eUqFw.useRef)({
            name: experience,
            attributes: attributes,
            experienceTracker: experienceTracker
        });
        self.current.name = experience;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        return (0, $eUqFw.useCallback)((location, error, extraAttributes = {})=>{
            const { current: current } = self;
            if ((0, $lXcGv.isLoaderError)(error) && error.name === 'ChunkLoadError' || (0, $JRB5w.isClientFetchError)(error)) return;
            current.experienceTracker.fail({
                name: current.name,
                error: error,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes,
                    location: location
                }
            });
        }, [
            self
        ]);
    };
});
parcelRegister("gtrMw", function(module, exports) {
    $parcel$export(module.exports, "useExperienceContext", ()=>$b35642cd91fe7353$export$be8ec22ac9208049);
    var $eUqFw = parcelRequire("eUqFw");
    var $b57En = parcelRequire("b57En");
    const $b35642cd91fe7353$export$be8ec22ac9208049 = ()=>{
        const context = (0, $eUqFw.useContext)((0, $b57En.ExperienceTrackerContext));
        return context;
    };
});
parcelRegister("bDhRl", function(module, exports) {
    $parcel$export(module.exports, "useExperienceStart", ()=>$61606509e9879b1e$export$675e0d25df38d426);
    $parcel$export(module.exports, "ExperienceStart", ()=>$61606509e9879b1e$export$f20b867e738a222c);
    var $eUqFw = parcelRequire("eUqFw");
    var $10fdS = parcelRequire("10fdS");
    var $gtrMw = parcelRequire("gtrMw");
    const $61606509e9879b1e$export$675e0d25df38d426 = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect = ()=>undefined })=>{
        const route = (0, $10fdS.useCurrentRoute)();
        const experienceTracker = (0, $gtrMw.useExperienceContext)();
        const userLocation = `${route.group ?? 'unknown'}:${route.name}`;
        const self = (0, $eUqFw.useRef)({
            experienceId: experienceId,
            experience: experience,
            timeout: timeout,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            experienceTracker: experienceTracker,
            disableSli: disableSli,
            userLocation: userLocation,
            collect: collect
        });
        self.current.experienceId = experienceId;
        self.current.experience = experience;
        self.current.timeout = timeout;
        self.current.analyticsSource = analyticsSource;
        self.current.application = application;
        self.current.edition = edition;
        self.current.experienceTracker = experienceTracker;
        self.current.userLocation = userLocation;
        self.current.collect = collect;
        return (0, $eUqFw.useCallback)(()=>{
            const { current: current } = self;
            current.experienceTracker.start({
                id: current.experienceId,
                name: current.experience,
                timeout: current.timeout,
                attributes: {
                    analyticsSource: current.analyticsSource,
                    experience: current.experience,
                    experienceId: current.experienceId,
                    application: current.application,
                    edition: current.edition,
                    disableSli: current.disableSli,
                    userLocation: current.userLocation
                },
                collect: current.collect,
                onSuccess: ()=>undefined
            });
        }, [
            self
        ]);
    };
    const $61606509e9879b1e$export$f20b867e738a222c = ({ experienceId: experienceId, experience: experience, timeout: timeout, analyticsSource: analyticsSource, application: application, edition: edition, disableSli: disableSli = false, collect: collect })=>{
        const onStart = $61606509e9879b1e$export$675e0d25df38d426({
            experienceId: experienceId,
            experience: experience,
            timeout: timeout,
            analyticsSource: analyticsSource,
            application: application,
            edition: edition,
            disableSli: disableSli,
            collect: collect
        });
        (0, $eUqFw.useMemo)(()=>{
            onStart();
        }, [
            onStart,
            experienceId,
            experience,
            timeout,
            analyticsSource,
            application,
            edition,
            disableSli,
            collect
        ]);
        return null;
    };
});
parcelRegister("fDZ6r", function(module, exports) {
    $parcel$export(module.exports, "useExperienceSuccess", ()=>$62a77bba99475ca2$export$e94f0da4fc0603c6);
    $parcel$export(module.exports, "ExperienceSuccess", ()=>$62a77bba99475ca2$export$4962f3898bd5c829);
    var $eUqFw = parcelRequire("eUqFw");
    var $10fdS = parcelRequire("10fdS");
    var $gtrMw = parcelRequire("gtrMw");
    const $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT = {};
    const $62a77bba99475ca2$export$e94f0da4fc0603c6 = ({ experience: experience, attributes: attributes = $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT })=>{
        const experienceTracker = (0, $gtrMw.useExperienceContext)();
        const route = (0, $10fdS.useCurrentRoute)();
        const self = (0, $eUqFw.useRef)({
            experience: experience,
            attributes: attributes,
            experienceTracker: experienceTracker,
            route: route
        });
        self.current.route = route;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        self.current.experience = experience;
        return (0, $eUqFw.useCallback)((extraAttributes = {})=>{
            const { current: current } = self;
            if (current.route && current.route.isRedirect === true) return;
            current.experienceTracker.succeed({
                name: current.experience,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes
                }
            });
        }, [
            self
        ]);
    };
    const $62a77bba99475ca2$export$4962f3898bd5c829 = ({ experience: experience, attributes: attributes = $62a77bba99475ca2$var$STABLE_EMPTY_OBJECT })=>{
        const onExperienceSuccess = $62a77bba99475ca2$export$e94f0da4fc0603c6({
            experience: experience,
            attributes: attributes
        });
        (0, $eUqFw.useEffect)(()=>{
            onExperienceSuccess();
        }, [
            attributes,
            onExperienceSuccess
        ]);
        (0, $eUqFw.useMemo)(()=>{
            if (false) onExperienceSuccess();
        }, [
            onExperienceSuccess
        ]);
        return null;
    };
});
parcelRegister("jmt32", function(module, exports) {
    $parcel$export(module.exports, "createValueController", ()=>$23eae1bf65d6e5ee$export$ff0ab9dd4ceb4a93);
    var $WBLbN = parcelRequire("WBLbN");
    const $23eae1bf65d6e5ee$export$ff0ab9dd4ceb4a93 = (name, defaultValue)=>{
        const actions = {
            setValue: (value)=>({ setState: setState })=>setState({
                        value: value
                    })
        };
        const initialState = {
            value: defaultValue
        };
        const store = (0, $WBLbN.createStore)({
            name: name,
            initialState: initialState,
            actions: actions
        });
        const ValueContainer = (0, $WBLbN.createContainer)(store);
        const selector = (state)=>state.value;
        const useValueInternal = (0, $WBLbN.createHook)(store, {
            selector: selector
        });
        const useValue = ()=>{
            const [value, { setValue: setValue }] = useValueInternal();
            return [
                value,
                setValue
            ];
        };
        return {
            ValueContainer: ValueContainer,
            useValue: useValue
        };
    };
});
parcelRegister("3O0Td", function(module, exports) {
    $parcel$export(module.exports, "usePageId", ()=>$8b00509e9968a84b$export$3434ba5eadb360dc);
    var $WBLbN = parcelRequire("WBLbN");
    var $cfLkw = parcelRequire("cfLkw");
    const $8b00509e9968a84b$var$useSweetStatePageId = (0, $WBLbN.createHook)((0, $cfLkw.default), {
        selector: (state)=>state.currentPage.uuid
    });
    const $8b00509e9968a84b$export$3434ba5eadb360dc = ()=>{
        const [pageId] = $8b00509e9968a84b$var$useSweetStatePageId();
        return pageId;
    };
});
parcelRegister("bgNoL", function(module, exports) {
    $parcel$export(module.exports, "REPO_TYPE", ()=>$425fbadb5891ec48$export$399c7e6858236b4);
    $parcel$export(module.exports, "LINK_TYPE", ()=>$425fbadb5891ec48$export$58125ce2bb1c3378);
    $parcel$export(module.exports, "EMOJI_REGEX", ()=>$425fbadb5891ec48$export$c79ed2783644934c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES", ()=>$425fbadb5891ec48$export$25ae65041c800c9);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES", ()=>$425fbadb5891ec48$export$e03c9beea817d44b);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES", ()=>$425fbadb5891ec48$export$3d575bdf28c0d17c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES", ()=>$425fbadb5891ec48$export$af84baced6970a17);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES", ()=>$425fbadb5891ec48$export$c767f253046b1ea7);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES", ()=>$425fbadb5891ec48$export$265b9384cc2dfbd4);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES", ()=>$425fbadb5891ec48$export$2de77b357e71c7a7);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES", ()=>$425fbadb5891ec48$export$7de7abb92169d6c);
    $parcel$export(module.exports, "PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES", ()=>$425fbadb5891ec48$export$fd7df8bd7600c65c);
    $parcel$export(module.exports, "GLOBAL_NAV_CREATE_BUTTON_SPOTLIGHT_ID", ()=>$425fbadb5891ec48$export$dde074e512e80dff);
    $parcel$export(module.exports, "REPORTS_IDS", ()=>$425fbadb5891ec48$export$1f70a76cb421b107);
    $parcel$export(module.exports, "SIDEBAR_EXPERIENCE", ()=>$425fbadb5891ec48$export$71aaf2625ee54d10);
    $parcel$export(module.exports, "staticLegacyIds", ()=>$425fbadb5891ec48$export$f57650e6e7be03dc);
    const $425fbadb5891ec48$export$399c7e6858236b4 = 'source.code.link';
    const $425fbadb5891ec48$export$58125ce2bb1c3378 = 'project.shortcut.default.link';
    const $425fbadb5891ec48$export$c79ed2783644934c = /^(?:[\u2600-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/;
    const $425fbadb5891ec48$export$25ae65041c800c9 = 'pin-filter-myopenissues';
    const $425fbadb5891ec48$export$e03c9beea817d44b = 'pin-filter-reportedbyme';
    const $425fbadb5891ec48$export$3d575bdf28c0d17c = 'pin-filter-allissues';
    const $425fbadb5891ec48$export$af84baced6970a17 = 'pin-filter-allopenissues';
    const $425fbadb5891ec48$export$c767f253046b1ea7 = 'pin-filter-doneissues';
    const $425fbadb5891ec48$export$265b9384cc2dfbd4 = 'pin-filter-recentlyviewed';
    const $425fbadb5891ec48$export$2de77b357e71c7a7 = 'pin-filter-addedrecently';
    const $425fbadb5891ec48$export$7de7abb92169d6c = 'pin-filter-resolvedrecently';
    const $425fbadb5891ec48$export$fd7df8bd7600c65c = 'pin-filter-updatedrecently';
    const $425fbadb5891ec48$export$dde074e512e80dff = 'global-create-spotlight';
    const $425fbadb5891ec48$export$1f70a76cb421b107 = {
        REPORTS_ADDONS: 'sd-reports-addons'
    };
    const $425fbadb5891ec48$export$83016cff6318a5dd = Object.freeze({
        CODE_TAB: 'CODE_TAB',
        ONCALL_TAB: 'ONCALL_TAB',
        PAGES_TAB: 'PAGES_TAB'
    });
    const $425fbadb5891ec48$export$f371b4c263b142af = {
        [$425fbadb5891ec48$export$83016cff6318a5dd.CODE_TAB]: 'code',
        [$425fbadb5891ec48$export$83016cff6318a5dd.ONCALL_TAB]: 'opsgenie',
        [$425fbadb5891ec48$export$83016cff6318a5dd.PAGES_TAB]: 'pages'
    };
    const $425fbadb5891ec48$export$b66c40cadee12a0b = 'project/agility/index';
    const $425fbadb5891ec48$export$6f454e69bce3a691 = 'project/business/index';
    const $425fbadb5891ec48$export$3a0f7f7a8a0b306b = 'project/ops/index';
    const $425fbadb5891ec48$export$1346c9aa3cbb477d = 'project/software/index';
    const $425fbadb5891ec48$export$4598dd67943205cf = 'project/software/issues';
    const $425fbadb5891ec48$export$8f36e85c5afae5 = 'project/software/reports';
    const $425fbadb5891ec48$export$8151e5564c0016a1 = 'attachments';
    const $425fbadb5891ec48$export$4acd0d06a25e56b5 = 'eventtypes';
    const $425fbadb5891ec48$export$211ab01804585e09 = 'webhooks-admin';
    const $425fbadb5891ec48$export$294b9ab8545a9f36 = 'services';
    const $425fbadb5891ec48$export$665efe695022359b = 'greenhopper-lexorank-manage';
    const $425fbadb5891ec48$export$47fbefc73055eb9d = 'admin-helper-admin-section';
    const $425fbadb5891ec48$export$76e6bd729450de52 = 'advanced_section';
    const $425fbadb5891ec48$export$ac928a90c0d3daa8 = 'collectors';
    const $425fbadb5891ec48$export$309ac0136b7d5dfa = 'dark_features';
    const $425fbadb5891ec48$export$998f1706a6ca29b = 'general_configuration';
    const $425fbadb5891ec48$export$e9af81a594543847 = 'import_export_section';
    const $425fbadb5891ec48$export$bbf19cc23216c6b = 'mail_section';
    const $425fbadb5891ec48$export$693dd06b18660b78 = 'security_section';
    const $425fbadb5891ec48$export$c6d1221ea0bce75e = 'shared_section';
    const $425fbadb5891ec48$export$c7d7c0d436dd54b1 = 'troubleshooting_and_support';
    const $425fbadb5891ec48$export$af156d8e27fc5458 = 'user_interface';
    const $425fbadb5891ec48$export$71aaf2625ee54d10 = 'viewSidebarNavigation';
    const $425fbadb5891ec48$export$f57650e6e7be03dc = [
        'general_configuration',
        'dark_features',
        'troubleshooting_and_support',
        'view_auditing',
        'pluginViewer',
        'pluginViewer',
        'system_info',
        'integrity_checker',
        'logging_profiling',
        'scheduler_details',
        'security_section',
        'project_role_browser',
        'global_permissions',
        'collectors',
        'user_interface',
        'user_defaults',
        'edit_default_dashboard',
        'lookandfeel',
        'com.atlassian.pas:pas-admin-link-jira',
        'import_export_section',
        'vertigo_export',
        'external_import',
        'vertigo_import',
        'vertigo_import_jira_cloud',
        'vertigo_import_jira_server',
        'mail_section',
        'global_mail_settings',
        'outgoing_mail',
        'incoming_mail',
        'send_email',
        'admin-helper-admin-section',
        'permissionhelper-admin-page',
        'notificationhelper-admin-page',
        'shared_section',
        'shared_filters',
        'shared_dashboards',
        'advanced_section',
        'attachments',
        'eventtypes',
        'webhooks-admin',
        'services',
        'manage_dashboards',
        'manage_filters',
        'greenhopper-lexorank-manage',
        'jira.webfragments.view.project.operations:edit_project',
        'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
        'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
        'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
        'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
        'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
        'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
        'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
        'com.atlassian.jira.jira-projects-plugin:administer_project_components',
        'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
        'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
        'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
        'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
        'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
        'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
        'com.atlassian.jira.jira-projects-plugin:administer_project_code',
        'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
        'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
        'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
        'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
        'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
        'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
        'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
        'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
        'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
        'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
        'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
        'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
        'com.codebarrel.addons.automation__cb-automation'
    ];
});
parcelRegister("7BqbB", function(module, exports) {
    $parcel$export(module.exports, "CONFIGURABLE_MENU_IDS_AS_STRINGS", ()=>$c230ed31b77458b3$export$f5a7bd7eb586e4e8);
    $parcel$export(module.exports, "CONFIGURABLE_MESSAGE_AND_ICON_MAP", ()=>$c230ed31b77458b3$export$6a976dc7193b8a18);
    $parcel$export(module.exports, "LEFT_SIDEBAR_EXPANDED_MIN_WIDTH", ()=>$c230ed31b77458b3$export$9fcc53f3b36e0949);
    $parcel$export(module.exports, "IS_LEFT_SIDEBAR_COLLAPSED_DEFAULT", ()=>$c230ed31b77458b3$export$2eb8dda9e83d33ff);
    $parcel$export(module.exports, "NAV4_OPT_OUT_FEEDBACK_GROUP_ID", ()=>$c230ed31b77458b3$export$9cf873ba2e9a3ce0);
    $parcel$export(module.exports, "NAV4_GENERAL_FEEDBACK_GROUP_ID", ()=>$c230ed31b77458b3$export$a495ba70b16d4d90);
    $parcel$export(module.exports, "NO_OF_BOARDS_TO_SHOW", ()=>$c230ed31b77458b3$export$89de709e88232646);
    var $3VGd6 = parcelRequire("3VGd6");
    var $6Qsnf = parcelRequire("6Qsnf");
    var $9uiJD = parcelRequire("9uiJD");
    var $5sYNt = parcelRequire("5sYNt");
    var $2rj72 = parcelRequire("2rj72");
    var $iaWeA = parcelRequire("iaWeA");
    var $dxEgU = parcelRequire("dxEgU");
    var $3Kfqr = parcelRequire("3Kfqr");
    var $3CUCs = parcelRequire("3CUCs");
    var $jMd51 = parcelRequire("jMd51");
    var $hRfSp = parcelRequire("hRfSp");
    var $eKHa6 = parcelRequire("eKHa6");
    var $4ursw = parcelRequire("4ursw");
    var $2LZsU = parcelRequire("2LZsU");
    var $5jfU2 = parcelRequire("5jfU2");
    const $c230ed31b77458b3$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Common';
    const $c230ed31b77458b3$export$d57b6b390e78d90f = 'jira-cosmos';
    const $c230ed31b77458b3$export$421b92818c76ee2d = Object.values((0, $4ursw.CONFIGURABLE_MENU_ID));
    const $c230ed31b77458b3$export$f5a7bd7eb586e4e8 = $c230ed31b77458b3$export$421b92818c76ee2d;
    const $c230ed31b77458b3$export$6a976dc7193b8a18 = {
        [(0, $5jfU2.L1_MENU_ID).APPS]: {
            message: (0, $2LZsU.default).apps,
            Icon: (0, ($parcel$interopDefault($3VGd6)))
        },
        [(0, $5jfU2.L1_MENU_ID).GOALS]: {
            message: (0, $2LZsU.default).goals,
            Icon: (0, ($parcel$interopDefault($dxEgU)))
        },
        [(0, $5jfU2.L1_MENU_ID).ROADMAPS]: {
            message: (0, $2LZsU.default).roadmaps,
            Icon: (0, ($parcel$interopDefault($iaWeA)))
        },
        [(0, $5jfU2.L1_MENU_ID).PLANS]: {
            message: (0, $2LZsU.default).plans,
            Icon: (0, ($parcel$interopDefault($3CUCs)))
        },
        [(0, $5jfU2.L1_MENU_ID).PROJECTS]: {
            message: (0, $2LZsU.default).projects,
            Icon: (0, ($parcel$interopDefault($3Kfqr)))
        },
        [(0, $5jfU2.L1_MENU_ID).FILTERS]: {
            message: (0, $2LZsU.default).filters,
            Icon: (0, ($parcel$interopDefault($2rj72)))
        },
        [(0, $5jfU2.L1_MENU_ID).DASHBOARDS]: {
            message: (0, $2LZsU.default).dashboards,
            Icon: (0, ($parcel$interopDefault($5sYNt)))
        },
        [(0, $5jfU2.L1_MENU_ID).OVERVIEWS]: {
            message: (0, $2LZsU.default).operations,
            Icon: (0, ($parcel$interopDefault($3VGd6)))
        },
        [(0, $5jfU2.L1_MENU_ID).OPERATIONS]: {
            message: (0, $2LZsU.default).operations,
            Icon: (0, ($parcel$interopDefault($jMd51)))
        },
        [(0, $5jfU2.L1_MENU_ID).ASSETS]: {
            message: (0, $2LZsU.default).assets,
            Icon: (0, ($parcel$interopDefault($6Qsnf)))
        },
        [(0, $5jfU2.L1_MENU_ID).TEAMS]: {
            message: (0, $2LZsU.default).teams,
            Icon: (0, ($parcel$interopDefault($eKHa6)))
        },
        [(0, $5jfU2.L1_MENU_ID).RECENT]: {
            message: (0, $2LZsU.default).recent,
            Icon: (0, ($parcel$interopDefault($9uiJD)))
        },
        [(0, $5jfU2.L1_MENU_ID).STARRED]: {
            message: (0, $2LZsU.default).starred,
            Icon: (0, ($parcel$interopDefault($hRfSp)))
        }
    };
    const $c230ed31b77458b3$export$9fcc53f3b36e0949 = 240;
    const $c230ed31b77458b3$export$6621cd553335536a = 320;
    const $c230ed31b77458b3$export$2eb8dda9e83d33ff = false;
    const $c230ed31b77458b3$export$b4b2658405615c86 = 'TEAM_MANAGED_PROJECT';
    const $c230ed31b77458b3$export$2336313834642df = 'COMPANY_MANAGED_PROJECT';
    const $c230ed31b77458b3$export$9cf873ba2e9a3ce0 = 'nav4-opt-out';
    const $c230ed31b77458b3$export$a495ba70b16d4d90 = 'nav4-sidebar';
    const $c230ed31b77458b3$export$89de709e88232646 = 25;
});
parcelRegister("6Qsnf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4fbd9be0dbc53f51$var$_react = $4fbd9be0dbc53f51$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $4fbd9be0dbc53f51$var$_UNSAFE_baseNew = $4fbd9be0dbc53f51$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $4fbd9be0dbc53f51$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4fbd9be0dbc53f51$var$AssetsIcon = (props)=>$4fbd9be0dbc53f51$var$_react.default.createElement($4fbd9be0dbc53f51$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.59 6.409a2.25 2.25 0 0 1 0 3.182m0-3.182a2.25 2.25 0 0 0-3.181 0m3.182 0 2.598-2.598M9.591 9.59a2.25 2.25 0 0 1-3.182 0m3.182 0 2.598 2.598M6.41 9.591a2.25 2.25 0 0 1 0-3.182m0 3.182-2.6 2.598m2.598-5.78L3.81 3.811m8.378 0a1.5 1.5 0 1 0 2.122-2.122 1.5 1.5 0 0 0-2.122 2.122Zm0 8.378a1.5 1.5 0 1 0 2.122 2.122 1.5 1.5 0 0 0-2.122-2.122ZM3.811 3.811a1.5 1.5 0 1 0-2.122-2.122 1.5 1.5 0 0 0 2.122 2.122Zm0 8.378a1.5 1.5 0 1 1-2.122 2.122 1.5 1.5 0 0 1 2.122-2.122Z"/>`
        }, props));
    $4fbd9be0dbc53f51$var$AssetsIcon.displayName = 'AssetsIcon';
    var $4fbd9be0dbc53f51$var$_default = module.exports.default = $4fbd9be0dbc53f51$var$AssetsIcon;
});
parcelRegister("iaWeA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d3b65549546f7fe5$var$_react = $d3b65549546f7fe5$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $d3b65549546f7fe5$var$_UNSAFE_baseNew = $d3b65549546f7fe5$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $d3b65549546f7fe5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d3b65549546f7fe5$var$FolderOpenIcon = (props)=>$d3b65549546f7fe5$var$_react.default.createElement($d3b65549546f7fe5$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 14.25a1 1 0 0 1-1-1V3c0-.69.56-1.25 1.25-1.25h3.25L7 3.5h5c.69 0 1.25.56 1.25 1.25v2m-11.5 7.5 2.116-7.055a.625.625 0 0 1 .599-.445h8.785m-11.5 7.5h10.57a1.25 1.25 0 0 0 1.197-.89l1.742-5.805a.625.625 0 0 0-.599-.805h-1.41"/>`
        }, props));
    $d3b65549546f7fe5$var$FolderOpenIcon.displayName = 'FolderOpenIcon';
    var $d3b65549546f7fe5$var$_default = module.exports.default = $d3b65549546f7fe5$var$FolderOpenIcon;
});
parcelRegister("dxEgU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9dbd988d2c83e8aa$var$_react = $9dbd988d2c83e8aa$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $9dbd988d2c83e8aa$var$_UNSAFE_baseNew = $9dbd988d2c83e8aa$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $9dbd988d2c83e8aa$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9dbd988d2c83e8aa$var$GoalIcon = (props)=>$9dbd988d2c83e8aa$var$_react.default.createElement($9dbd988d2c83e8aa$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 15.25A7.25 7.25 0 1 0 8 .75a7.25 7.25 0 0 0 0 14.5Z"/><path stroke="currentcolor" stroke-width="1.5" d="M8 11.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Z"/>`
        }, props));
    $9dbd988d2c83e8aa$var$GoalIcon.displayName = 'GoalIcon';
    var $9dbd988d2c83e8aa$var$_default = module.exports.default = $9dbd988d2c83e8aa$var$GoalIcon;
});
parcelRegister("3CUCs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2a40d71cbe401831$var$_react = $2a40d71cbe401831$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $2a40d71cbe401831$var$_UNSAFE_baseNew = $2a40d71cbe401831$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $2a40d71cbe401831$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2a40d71cbe401831$var$RoadmapIcon = (props)=>$2a40d71cbe401831$var$_react.default.createElement($2a40d71cbe401831$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M.75 4c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H2C1.31 6.25.75 5.69.75 5zm3 7c0-.69.56-1.25 1.25-1.25h9c.69 0 1.25.56 1.25 1.25v1c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25z"/>`
        }, props));
    $2a40d71cbe401831$var$RoadmapIcon.displayName = 'RoadmapIcon';
    var $2a40d71cbe401831$var$_default = module.exports.default = $2a40d71cbe401831$var$RoadmapIcon;
});
parcelRegister("jMd51", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e65ca56befef608f$var$_react = $e65ca56befef608f$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $e65ca56befef608f$var$_UNSAFE_baseNew = $e65ca56befef608f$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $e65ca56befef608f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e65ca56befef608f$var$ShieldIcon = (props)=>$e65ca56befef608f$var$_react.default.createElement($e65ca56befef608f$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M14.25 4.5S10.75 3.5 8 .75C5.25 3.5 1.75 4.5 1.75 4.5 1.75 12.75 8 15.125 8 15.125S14.25 12.75 14.25 4.5Z"/>`
        }, props));
    $e65ca56befef608f$var$ShieldIcon.displayName = 'ShieldIcon';
    var $e65ca56befef608f$var$_default = module.exports.default = $e65ca56befef608f$var$ShieldIcon;
});
parcelRegister("2LZsU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb3d27ef5aae58cc$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    var $bb3d27ef5aae58cc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
        projects: {
            "id": "navigation-apps-sidebar-nav4-common.common.projects",
            "defaultMessage": "Projects"
        },
        filters: {
            "id": "navigation-apps-sidebar-nav4-common.common.filters",
            "defaultMessage": "Filters"
        },
        dashboards: {
            "id": "navigation-apps-sidebar-nav4-common.common.dashboards",
            "defaultMessage": "Dashboards"
        },
        teams: {
            "id": "navigation-apps-sidebar-nav4-common.common.teams",
            "defaultMessage": "Teams"
        },
        assets: {
            "id": "navigation-apps-sidebar-nav4-common.common.assets",
            "defaultMessage": "Assets"
        },
        plans: {
            "id": "navigation-apps-sidebar-nav4-common.common.plans",
            "defaultMessage": "Plans"
        },
        apps: {
            "id": "navigation-apps-sidebar-nav4-common.common.apps",
            "defaultMessage": "Apps"
        },
        operations: {
            "id": "navigation-apps-sidebar-nav4-common.common.operations",
            "defaultMessage": "Operations"
        },
        goals: {
            "id": "navigation-apps-sidebar-nav4-common.common.goals",
            "defaultMessage": "Goals"
        },
        recent: {
            "id": "navigation-apps-sidebar-nav4-common.common.recent",
            "defaultMessage": "Recent"
        },
        starred: {
            "id": "navigation-apps-sidebar-nav4-common.common.starred",
            "defaultMessage": "Starred"
        },
        roadmaps: {
            "id": "navigation-apps-sidebar-nav4-common.common.roadmaps",
            "defaultMessage": "Roadmaps"
        }
    });
});
parcelRegister("5jfU2", function(module, exports) {
    $parcel$export(module.exports, "L1_MENU_ID", ()=>$379c098b2ef9e0bc$export$918aea3cf024d90b);
    var $4ursw = parcelRequire("4ursw");
    const $379c098b2ef9e0bc$export$f263c05bb04cefc9 = {
        OPERATIONS_ALERT_SAVED_SEARCH_SHARED_WITH_ME: 'jira.sidebar.operations.alert.savedSearches.sharedWithMe',
        OPERATIONS_ALERT_SAVED_SEARCH_CREATED_BY_ME: 'jira.sidebar.operations.alert.savedSearches.createdByMe'
    };
    const $379c098b2ef9e0bc$export$bb47524d7f3cb1f8 = {
        ...(0, $4ursw.CONFIGURABLE_MENU_ID),
        BOARDS: 'jira.sidebar.boards',
        QUEUES: 'jira.sidebar.queues',
        ALL: 'jira.sidebar.all'
    };
    const $379c098b2ef9e0bc$export$918aea3cf024d90b = {
        YOUR_WORK: 'jira.sidebar.yourWork',
        ...(0, $4ursw.CONFIGURABLE_MENU_ID),
        ...$379c098b2ef9e0bc$export$f263c05bb04cefc9
    };
});
parcelRegister("kpmO3", function(module, exports) {
    $parcel$export(module.exports, "SidebarNav4ContextProvider", ()=>$3330e369861b2dca$export$ebf7cdfc2e83bcef);
    $parcel$export(module.exports, "useSidebarNav4", ()=>$3330e369861b2dca$export$dc46c14934833db2);
    var $eUqFw = parcelRequire("eUqFw");
    var $lB25E = parcelRequire("lB25E");
    var $4ZjUB = parcelRequire("4ZjUB");
    var $7uCfF = parcelRequire("7uCfF");
    var $5RIdI = parcelRequire("5RIdI");
    const $3330e369861b2dca$var$SidebarNav4Context = (0, $eUqFw.createContext)(null);
    function $3330e369861b2dca$export$ebf7cdfc2e83bcef(props) {
        const { children: children, isInitialSelectedPath: isInitialSelectedPath } = props;
        const [routerContext] = (0, $lB25E.useRouter)();
        const initialSelectedPath = (0, $4ZjUB.getInitialSelectedPath)(routerContext);
        const [selectedPath, setSelectedPath] = (0, $eUqFw.useState)(initialSelectedPath);
        (0, $eUqFw.useLayoutEffect)(()=>{
            setSelectedPath((currentPath)=>{
                const newPath = (0, $5RIdI.routeToSelectedPath)(routerContext);
                return currentPath.toString() === newPath.toString() ? currentPath : newPath;
            });
        }, [
            routerContext
        ]);
        const sidebarNav4Controller = (0, $eUqFw.useMemo)(()=>({
                isInitialSelectedPath: isInitialSelectedPath ?? (0, $7uCfF.isSelectedPath)(initialSelectedPath),
                isSelectedPath: (0, $7uCfF.isSelectedPath)(selectedPath)
            }), [
            initialSelectedPath,
            isInitialSelectedPath,
            selectedPath
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($3330e369861b2dca$var$SidebarNav4Context.Provider, {
            value: sidebarNav4Controller
        }, children);
    }
    function $3330e369861b2dca$export$dc46c14934833db2() {
        const context = (0, $eUqFw.useContext)($3330e369861b2dca$var$SidebarNav4Context);
        if (context == null) throw new Error('useSidebarNav4 must be used inside a SidebarNav4ContextProvider');
        return context;
    }
});
parcelRegister("bdfGI", function(module, exports) {
    $parcel$export(module.exports, "SidebarSelector", ()=>$33aa06698882b6b7$export$7937e2d32a777fcb);
    var $eUqFw = parcelRequire("eUqFw");
    var $7ZZxN = parcelRequire("7ZZxN");
    var $exb0h = parcelRequire("exb0h");
    var $h4Fhh = parcelRequire("h4Fhh");
    var $1ybV0 = parcelRequire("1ybV0");
    var $eI5EY = parcelRequire("eI5EY");
    var $7vTKl = parcelRequire("7vTKl");
    var $kAidm = parcelRequire("kAidm");
    var $lRIdH = parcelRequire("lRIdH");
    var $6cv5X = parcelRequire("6cv5X");
    var $fGNgi = parcelRequire("fGNgi");
    var $upajt = parcelRequire("upajt");
    var $6DM93 = parcelRequire("6DM93");
    var $lWmpu = parcelRequire("lWmpu");
    var $8BRHO = parcelRequire("8BRHO");
    var $hI8UJ = parcelRequire("hI8UJ");
    var $Me4cl = parcelRequire("Me4cl");
    var $aBzna = parcelRequire("aBzna");
    var $fu7hM = parcelRequire("fu7hM");
    var $bRT5F = parcelRequire("bRT5F");
    var $dAUnM = parcelRequire("dAUnM");
    var $34zVc = parcelRequire("34zVc");
    var $kmEf6 = parcelRequire("kmEf6");
    var $4tYWR = parcelRequire("4tYWR");
    var $6WLSW = parcelRequire("6WLSW");
    var $9F5X0 = parcelRequire("9F5X0");
    var $92Zmd = parcelRequire("92Zmd");
    var $jq6Xe = parcelRequire("jq6Xe");
    var $aPW8a = parcelRequire("aPW8a");
    var $gBUa5 = parcelRequire("gBUa5");
    var $8WuJm = parcelRequire("8WuJm");
    var $bNe1g = parcelRequire("bNe1g");
    var $ddT06 = parcelRequire("ddT06");
    var $lB25E = parcelRequire("lB25E");
    const $33aa06698882b6b7$var$ProjectSettingsSidebarSelector = ()=>{
        const { data: project, loading: loading, error: error } = (0, $bNe1g.useProjectContext)();
        let sidebar = null;
        if (loading) sidebar = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null);
        if (project?.projectType === (0, $7ZZxN.CORE_PROJECT)) sidebar = project.simplified ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lRIdH.default), {
            project: project
        }) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $kAidm.default), {
            project: project
        });
        if (project?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT)) sidebar = project.simplified ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gBUa5.default), {
            project: project
        }) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aPW8a.default), {
            project: project
        });
        if (project?.projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) sidebar = project.simplified ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $fGNgi.AsyncJsmTmpProjectSettingsSidebar), {
            project: project
        }) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6cv5X.AsyncJsmCmpProjectSettingsSidebar), {
            project: project
        });
        if (project?.projectType === (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)) sidebar = (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hI8UJ.default), {
            project: project
        });
        if (project?.projectType === (0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)) sidebar = project.simplified ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $fGNgi.AsyncJsmTmpProjectSettingsSidebar), {
            project: project
        }) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6cv5X.AsyncJsmCmpProjectSettingsSidebar), {
            project: project
        });
        if (error) throw error;
        if (!sidebar) throw new Error(`No project settings sidebar found for the project type: ${project?.projectType}`);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            containerId: project ? String(project.projectId) : undefined,
            containerType: "project"
        }, sidebar);
    };
    const $33aa06698882b6b7$var$REDIRECT_ROUTES_NAMES = new Set([
        (0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
        (0, $exb0h.ROUTE_NAMES_SERVICEDESK_REDIRECT)
    ]);
    const $33aa06698882b6b7$var$InternalSidebarSelector = ()=>{
        const [{ match: { params: params }, route: route, location: location, query: query }] = (0, $lB25E.useRouter)();
        const { saveCurrentRoute: saveCurrentRoute } = (0, $aBzna.useNavigateBack)();
        const { isActive: isGlobalAppsSettingsConnectItemActive } = (0, $dAUnM.useGlobalAppsSettingsConnectItemActive)();
        const { isActive: isGlobalSystemSettingsConnectItemActive } = (0, $9F5X0.useGlobalSystemSettingsConnectItemActive)();
        const { isActive: isProjectSettingsConnectAppActive } = (0, $8BRHO.useIsConnectAppActive)();
        const { shouldUseJSM: shouldUseJSM } = (0, $h4Fhh.useOgTenantInfo)();
        switch(route.navigation?.sidebarId){
            case (0, $7vTKl.SIDEBAR_ID).PLAN_SETTINGS:
                return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6DM93.default), null);
            case (0, $7vTKl.SIDEBAR_ID).GLOBAL_APPS_SETTINGS:
                if (!location.pathname.includes('/discover')) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $34zVc.default), null);
                break;
            case (0, $7vTKl.SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS:
                return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6WLSW.default), null);
            case (0, $7vTKl.SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS:
                return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $kmEf6.default), null);
            case (0, $7vTKl.SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS:
                if (location.pathname.includes('/jira-service-management-chatops-and-video-tools') && shouldUseJSM && (0, $eI5EY.fg)('fix_chatops_new_nav_bug')) break;
                return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4tYWR.default), null);
            case (0, $7vTKl.SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS:
                return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $92Zmd.default), null);
            case (0, $7vTKl.SIDEBAR_ID).PERSONAL_SETTINGS:
                return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $upajt.default), null);
            case (0, $7vTKl.SIDEBAR_ID).HELP_CENTER_SETTINGS:
                return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jq6Xe.default), null);
            case (0, $7vTKl.SIDEBAR_ID).PROJECT_SETTINGS:
                return (0, ($parcel$interopDefault($eUqFw))).createElement($33aa06698882b6b7$var$ProjectSettingsSidebarSelector, null);
            default:
                break;
        }
        if (route.name === (0, $exb0h.ROUTE_NAMES_POLARIS_IDEAS) && params.section === 'settings' || isProjectSettingsConnectAppActive) return (0, ($parcel$interopDefault($eUqFw))).createElement($33aa06698882b6b7$var$ProjectSettingsSidebarSelector, null);
        if (route.group === (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE) && (0, $ddT06.BOARD_SETTINGS_CONFIG_QUERY_PARAM_VALUES).has(query.config) && (0, $1ybV0.ff)('simplified-boards-milestone-2_07hbk')) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $bRT5F.default), null);
        if (isGlobalAppsSettingsConnectItemActive) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $34zVc.default), null);
        if (isGlobalSystemSettingsConnectItemActive) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $92Zmd.default), null);
        if ($33aa06698882b6b7$var$REDIRECT_ROUTES_NAMES.has(route.name) && (0, $eI5EY.fg)('jira_nav4_eap_drop_2')) return null;
        saveCurrentRoute();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $fu7hM.default), null);
    };
    const $33aa06698882b6b7$export$7937e2d32a777fcb = ()=>{
        const attributes = (0, $eUqFw.useMemo)(()=>({
                navigationLayer: (0, $98a42a181453f01b$export$17ff3f7e02c6ac22),
                navigationContainer: (0, $8d9d60709cf91bf0$export$2ee9e5a3556c1e43),
                navState: (0, $04b88667038db790$export$2bd315ece9f68967),
                stage: (0, $Me4cl.getNav4Rollout)().stage
            }), []);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $aBzna.NavigateBackProvider), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            attributes: attributes
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($33aa06698882b6b7$var$InternalSidebarSelector, null)));
    };
});
parcelRegister("7vTKl", function(module, exports) {
    $parcel$export(module.exports, "ADDON_ID", ()=>$d4390c4ef90a66f3$export$6c4866a933650d1d);
    $parcel$export(module.exports, "MENU_ID", ()=>$d4390c4ef90a66f3$export$d4cd258d01c03112);
    $parcel$export(module.exports, "SIDEBAR_ID", ()=>$d4390c4ef90a66f3$export$adf978edbdfaf080);
    const $d4390c4ef90a66f3$export$6c4866a933650d1d = {
        DISCOVER: 'com.atlassian.jira.emcee__enduser-discover'
    };
    const $d4390c4ef90a66f3$export$d4cd258d01c03112 = {
        ADDONS: 'ADDONS',
        APP_SWITCHER: 'APP_SWITCHER',
        DASHBOARDS: 'DASHBOARDS',
        FILTERS: 'FILTERS',
        HELP: 'HELP',
        HOME: 'HOME',
        INSIGHT: 'INSIGHT',
        NOTIFICATIONS: 'NOTIFICATIONS',
        PEOPLE: 'PEOPLE',
        PLANS: 'PLANS',
        PROFILE: 'PROFILE',
        PROJECTS: 'PROJECTS',
        ROADMAPS: 'ROADMAPS',
        SEARCH: 'SEARCH',
        SERVICE_HUB: 'SERVICE_HUB',
        SETTINGS: 'SETTINGS',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
    };
    const $d4390c4ef90a66f3$export$adf978edbdfaf080 = {
        BOARD_SETTINGS: 'BOARD_SETTINGS',
        GLOBAL_APPS_SETTINGS: 'GLOBAL_APPS_SETTINGS',
        GLOBAL_ISSUES_SETTINGS: 'GLOBAL_ISSUES_SETTINGS',
        GLOBAL_PRODUCTS_SETTINGS: 'GLOBAL_PRODUCTS_SETTINGS',
        GLOBAL_PROJECTS_SETTINGS: 'GLOBAL_PROJECTS_SETTINGS',
        GLOBAL_SYSTEM_SETTINGS: 'GLOBAL_SYSTEM_SETTINGS',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS',
        PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
        PLAN_SETTINGS: 'PLAN_SETTINGS',
        PROJECT_SETTINGS: 'PROJECT_SETTINGS'
    };
});
const $04b88667038db790$export$d2aa6c54a5925f01 = 'v3';
const $04b88667038db790$export$2bd315ece9f68967 = 'v4';
const $8d9d60709cf91bf0$export$2ee9e5a3556c1e43 = 'sidebar';
const $8d9d60709cf91bf0$export$793ed84f5e13fedc = 'top';
const $8d9d60709cf91bf0$export$f1c9dd0f5207dd5e = 'tab';
const $8d9d60709cf91bf0$export$b83d0ee9325a2d0a = 'projectTitle';
const $98a42a181453f01b$export$17ff3f7e02c6ac22 = 'global';
const $98a42a181453f01b$export$33d8c916a600c5e9 = 'container';
parcelRegister("kAidm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d22e3a8d8df3fc2$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $lShkl = parcelRequire("lShkl");
    var $lWmpu = parcelRequire("lWmpu");
    var $gGtKh = parcelRequire("gGtKh");
    const $3d22e3a8d8df3fc2$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("97zde")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/business/company-managed/src/ui/main.tsx"
    });
    const $3d22e3a8d8df3fc2$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.project-settings.business.company-managed",
            packageName: "jiraNavigationAppsSidebarNav4BusinessCompanyManagedProjectSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.project-settings.business.company-managed",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($3d22e3a8d8df3fc2$var$LazySidebarContent, {
            project: project
        })));
    var $3d22e3a8d8df3fc2$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($3d22e3a8d8df3fc2$var$AsyncSidebar);
});
parcelRegister("lShkl", function(module, exports) {
    $parcel$export(module.exports, "SidebarBoundary", ()=>$0d3c97c1767991d9$export$1edc778464f08256);
    var $eUqFw = parcelRequire("eUqFw");
    var $0cdA8 = parcelRequire("0cdA8");
    var $1Fr7E = parcelRequire("1Fr7E");
    var $4qhD6 = parcelRequire("4qhD6");
    var $keguF = parcelRequire("keguF");
    var $dQMmq = parcelRequire("dQMmq");
    var $41rEp = parcelRequire("41rEp");
    const $0d3c97c1767991d9$export$1edc778464f08256 = ({ children: children, id: id, packageName: packageName, teamName: teamName })=>{
        const { experience: experience, attributes: attributes } = (0, $dQMmq.useSidebarExperience)();
        const onFail = (0, $4qhD6.useExperienceFail)({
            experience: experience,
            attributes: attributes
        });
        const onAbort = (0, $1Fr7E.useExperienceAbort)({
            experience: experience,
            attributes: attributes
        });
        const userLocation = (0, $keguF.getUserLocation)();
        const isNotSSR = !false;
        const extraEventData = (0, $eUqFw.useMemo)(()=>({
                userLocation: userLocation
            }), [
            userLocation
        ]);
        const fallback = (0, $eUqFw.useCallback)(({ error: error })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $41rEp.Fallback), {
                error: error
            }), []);
        const handleError = (0, $eUqFw.useCallback)((location, error)=>{
            const { statusCode: statusCode } = error;
            if (statusCode >= 400 && statusCode < 500) onAbort('Sidebar failed with validation error', {
                error: error
            });
            else onFail(location, error);
        }, [
            onAbort,
            onFail
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: id,
            packageName: packageName,
            extraEventData: extraEventData,
            fallback: fallback,
            teamName: teamName,
            onError: handleError
        }, isNotSSR && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $dQMmq.SidebarStart), null), children);
    };
});
parcelRegister("1Fr7E", function(module, exports) {
    $parcel$export(module.exports, "useExperienceAbort", ()=>$f0f298b79da53f61$export$cc92b7ce453f4403);
    var $eUqFw = parcelRequire("eUqFw");
    var $gtrMw = parcelRequire("gtrMw");
    const $f0f298b79da53f61$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
        const experienceTracker = (0, $gtrMw.useExperienceContext)();
        const self = (0, $eUqFw.useRef)({
            name: experience,
            attributes: attributes,
            experienceTracker: experienceTracker
        });
        self.current.name = experience;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        return (0, $eUqFw.useCallback)((reason, extraAttributes = {})=>{
            const { current: current } = self;
            current.experienceTracker.abort({
                name: current.name,
                reason: reason,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes
                }
            });
        }, [
            self
        ]);
    };
});
parcelRegister("dQMmq", function(module, exports) {
    $parcel$export(module.exports, "useSidebarExperience", ()=>$4c5fa2af35d08faf$export$d4fa533dfe4d7583);
    $parcel$export(module.exports, "SidebarStart", ()=>$4c5fa2af35d08faf$export$6738d1299dc79710);
    $parcel$export(module.exports, "SidebarReady", ()=>$4c5fa2af35d08faf$export$a06ecbbe5820282);
    var $eUqFw = parcelRequire("eUqFw");
    var $bDhRl = parcelRequire("bDhRl");
    var $fDZ6r = parcelRequire("fDZ6r");
    var $10fdS = parcelRequire("10fdS");
    var $jMP2a = parcelRequire("jMP2a");
    var $1inzG = parcelRequire("1inzG");
    var $3O0Td = parcelRequire("3O0Td");
    var $2gkxn = parcelRequire("2gkxn");
    const $4c5fa2af35d08faf$export$d4fa533dfe4d7583 = ()=>{
        const pageId = (0, $3O0Td.usePageId)();
        return (0, $eUqFw.useMemo)(()=>({
                experience: 'viewSidebarNavigation',
                experienceId: pageId,
                analyticsSource: 'Sidebar',
                attributes: {
                    sidebar: 'v4'
                }
            }), [
            pageId
        ]);
    };
    const $4c5fa2af35d08faf$export$6738d1299dc79710 = ()=>{
        const route = (0, $10fdS.useCurrentRoute)();
        const { experience: experience, experienceId: experienceId, analyticsSource: analyticsSource } = $4c5fa2af35d08faf$export$d4fa533dfe4d7583();
        const onStartExperience = (0, $bDhRl.useExperienceStart)({
            experience: experience,
            experienceId: experienceId,
            analyticsSource: analyticsSource
        });
        (0, $eUqFw.useEffect)(()=>{
            if (route.isRedirect) return;
            onStartExperience();
        }, [
            onStartExperience,
            route
        ]);
        return null;
    };
    const $4c5fa2af35d08faf$export$a06ecbbe5820282 = ()=>{
        const route = (0, $10fdS.useCurrentRoute)();
        const { experience: experience, attributes: attributes } = $4c5fa2af35d08faf$export$d4fa533dfe4d7583();
        const onSuccessfulExperience = (0, $fDZ6r.useExperienceSuccess)({
            experience: experience,
            attributes: attributes
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        const routeName = route.name ?? route.group ?? 'UNKNOWN';
        const doNotRunEffects = route.isRedirect || false;
        const sidebarId = route.navigation?.sidebarId ?? 'default';
        (0, $eUqFw.useEffect)(()=>{
            if (doNotRunEffects) return;
            const event = createAnalyticsEvent({
                action: 'ready',
                actionSubject: 'sidebar',
                meta: {
                    teamName: 'endeavour'
                }
            });
            (0, $jMP2a.fireUIAnalytics)(event, 'Sidebar Ready', {
                route: routeName
            });
        }, [
            createAnalyticsEvent,
            doNotRunEffects,
            routeName
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (doNotRunEffects) return;
            onSuccessfulExperience();
        }, [
            doNotRunEffects,
            onSuccessfulExperience,
            route
        ]);
        const customData = (0, $eUqFw.useMemo)(()=>({
                sidebarType: sidebarId
            }), [
            sidebarId
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $2gkxn.default), {
            data: customData
        });
    };
});
parcelRegister("2gkxn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$67fe37675032c5aa$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "addUFOCustomData", ()=>$67fe37675032c5aa$export$d12f56a472cdbe6c);
    var $eUqFw = parcelRequire("eUqFw");
    var $zNBm2 = parcelRequire("zNBm2");
    var $fIUvl = parcelRequire("fIUvl");
    var $cpY9k = parcelRequire("cpY9k");
    function $67fe37675032c5aa$export$2e2bcd8739ae039({ data: data }) {
        const interactionContext = (0, $eUqFw.useContext)((0, $zNBm2.default));
        (0, $eUqFw.useMemo)(()=>{
            if (!interactionContext) return;
            interactionContext.addCustomData(data);
        }, [
            data,
            interactionContext
        ]);
        return null;
    }
    function $67fe37675032c5aa$export$d12f56a472cdbe6c(data) {
        const interactionId = (0, $fIUvl.getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        (0, $cpY9k.addCustomData)(currentInteractionId, [], data);
    }
});
parcelRegister("41rEp", function(module, exports) {
    $parcel$export(module.exports, "Fallback", ()=>$22c37e9ffaeb8603$export$fb8d7f40caaeea67);
    var $eUqFw = parcelRequire("eUqFw");
    var $ld5Wr = parcelRequire("ld5Wr");
    var $jGR8u = parcelRequire("jGR8u");
    var $cYsCT = parcelRequire("cYsCT");
    var $2IZkH = parcelRequire("2IZkH");
    var $iH6c1 = parcelRequire("iH6c1");
    var $ijwdS = parcelRequire("ijwdS");
    var $5JgJ2 = parcelRequire("5JgJ2");
    var $gQtE8 = parcelRequire("gQtE8");
    const $22c37e9ffaeb8603$var$styles = {
        wrapper: "_bfhkm7j4 _syaz1gjq _1yt4pxbi _y3gn1h6o _4cvr1h6o _zulpu2gc",
        error: "_2rkogqwt _bfhk1v33 _syaz131l _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66"
    };
    const $22c37e9ffaeb8603$export$fb8d7f40caaeea67 = ({ error: error })=>{
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            xcss: $22c37e9ffaeb8603$var$styles.wrapper
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ijwdS.default), {
            width: "40px",
            alt: ""
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ld5Wr.default), {
            size: "xsmall"
        }, formatMessage((0, $gQtE8.default).errorHeading)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $2IZkH.default), null, formatMessage((0, $gQtE8.default).errorBody)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $22c37e9ffaeb8603$var$styles.error
        }, "ERROR: ", (0, $iH6c1.getErrorHash)(error)));
    };
});
parcelRegister("ijwdS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d511833b787fbc99$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("33cBa")))));
    $parcel$export(module.exports, "srcDark", ()=>($parcel$interopDefault((parcelRequire("jo9w7")))));
    var $9TZf5 = parcelRequire("9TZf5");
    var $jo9w7 = parcelRequire("jo9w7");
    var $33cBa = parcelRequire("33cBa");
    const $d511833b787fbc99$var$Illustration = (0, $9TZf5.createIllustration)({
        srcLight: ($parcel$interopDefault($33cBa)),
        srcDark: ($parcel$interopDefault($jo9w7))
    });
    var $d511833b787fbc99$export$2e2bcd8739ae039 = $d511833b787fbc99$var$Illustration;
    const $d511833b787fbc99$export$a179c88182cb9d56 = [
        0,
        0,
        164,
        212
    ];
});
parcelRegister("9TZf5", function(module, exports) {
    $parcel$export(module.exports, "Illustration", ()=>$a7efac7c92ef32a3$export$d43c2e2ca9b2c105);
    $parcel$export(module.exports, "createIllustration", ()=>$a7efac7c92ef32a3$export$4d00e7be716a0093);
    var $eUqFw = parcelRequire("eUqFw");
    var $evtC7 = parcelRequire("evtC7");
    function $a7efac7c92ef32a3$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $evtC7.AsImg), props);
    }
    function $a7efac7c92ef32a3$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
        return (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement($a7efac7c92ef32a3$export$d43c2e2ca9b2c105, {
                srcLight: srcLight,
                srcDark: srcDark,
                autoDark: autoDark,
                ...props
            });
    }
});
parcelRegister("evtC7", function(module, exports) {
    $parcel$export(module.exports, "AsImg", ()=>$e7036c28dfac32f8$export$75e378065cb7d6c0);
    var $7JEyt = parcelRequire("7JEyt");
    var $eUqFw = parcelRequire("eUqFw");
    var $fjjRQ = parcelRequire("fjjRQ");
    const $e7036c28dfac32f8$var$defaultStyles = null;
    const $e7036c28dfac32f8$var$fillStyles = null;
    const $e7036c28dfac32f8$var$autoDarkModeStyles = null;
    function $e7036c28dfac32f8$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
        const { colorMode: colorMode } = (0, $fjjRQ.default)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement("img", {
            src: colorMode === 'dark' ? srcDark : srcLight,
            alt: alt,
            "data-testid": testId,
            ...imgProps,
            className: (0, $7JEyt.default)([
                "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
                fill && "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq",
                colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
            ])
        });
    }
});
parcelRegister("jo9w7", function(module, exports) {
    module.exports = new URL("generic-error-darkmode.3646797f.svg", import.meta.url).toString();
});
parcelRegister("33cBa", function(module, exports) {
    module.exports = new URL("generic-error.f200ded6.svg", import.meta.url).toString();
});
parcelRegister("gQtE8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2ea66bf42a2d887$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    var $d2ea66bf42a2d887$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
        errorHeading: {
            "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-heading",
            "defaultMessage": "Something went wrong"
        },
        errorBody: {
            "id": "navigation-apps-sidebar-nav4-common.sidebar-boundary.fallback.error-body",
            "defaultMessage": "Try refreshing or navigating to another page."
        }
    });
});
parcelRegister("lWmpu", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$654b8fa168689c64$export$8f31e4c4a37b8e9c);
    var $eUqFw = parcelRequire("eUqFw");
    var $jGR8u = parcelRequire("jGR8u");
    var $6k5Uz = parcelRequire("6k5Uz");
    var $43iGG = parcelRequire("43iGG");
    var $cYsCT = parcelRequire("cYsCT");
    var $fHiYa = parcelRequire("fHiYa");
    const $654b8fa168689c64$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.200",
            xcss: $654b8fa168689c64$var$containerStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6k5Uz.default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $654b8fa168689c64$var$backButton
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $654b8fa168689c64$var$headingSkeleton
        })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $43iGG.default), {
            columnGap: "space.100",
            rowGap: "space.050",
            alignItems: "center",
            templateAreas: [
                'avatar name',
                'avatar type'
            ],
            templateColumns: "min-content 1fr",
            xcss: $654b8fa168689c64$var$projectHeading
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $654b8fa168689c64$var$projectAvatar,
            style: {
                gridArea: 'avatar'
            }
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $654b8fa168689c64$var$projectName,
            style: {
                gridArea: 'name'
            }
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $654b8fa168689c64$var$projectType,
            style: {
                gridArea: 'type'
            }
        })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $654b8fa168689c64$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $654b8fa168689c64$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $654b8fa168689c64$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $654b8fa168689c64$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $654b8fa168689c64$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $654b8fa168689c64$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $654b8fa168689c64$var$menuItem
        })));
    const $654b8fa168689c64$var$containerStyles = (0, $fHiYa.xcss)({
        height: '100%',
        padding: 'space.200'
    });
    const $654b8fa168689c64$var$backButton = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $654b8fa168689c64$var$headingSkeleton = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $654b8fa168689c64$var$projectHeading = (0, $fHiYa.xcss)({
        marginTop: 'space.100',
        marginBottom: 'space.100'
    });
    const $654b8fa168689c64$var$projectAvatar = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $654b8fa168689c64$var$projectName = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-200, 16px)",
        borderRadius: 'border.radius.100'
    });
    const $654b8fa168689c64$var$projectType = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-100, 8px)",
        borderRadius: 'border.radius.100'
    });
    const $654b8fa168689c64$var$menuItem = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("97zde", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("eFpn4")
    ]).then(()=>parcelRequire('6K5Jn'));
});
parcelRegister("lRIdH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72f3e3afcf63138a$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $lShkl = parcelRequire("lShkl");
    var $lWmpu = parcelRequire("lWmpu");
    var $gGtKh = parcelRequire("gGtKh");
    const $72f3e3afcf63138a$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("4Pq5e")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/business/team-managed/src/ui/main.tsx"
    });
    const $72f3e3afcf63138a$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.project-settings.business.team-managed",
            packageName: "jiraNavigationAppsSidebarNav4BusinessTeamManagedProjectSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.project-settings.business.team-managed",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($72f3e3afcf63138a$var$LazySidebarContent, {
            project: project
        })));
    var $72f3e3afcf63138a$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($72f3e3afcf63138a$var$AsyncSidebar);
});
parcelRegister("4Pq5e", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("gYnAk")
    ]).then(()=>parcelRequire('PCihN'));
});
parcelRegister("6cv5X", function(module, exports) {
    $parcel$export(module.exports, "AsyncJsmCmpProjectSettingsSidebar", ()=>$3d1f0cda58e163e2$export$2ce6ad449436c545);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $hzZWH = parcelRequire("hzZWH");
    var $lShkl = parcelRequire("lShkl");
    var $lWmpu = parcelRequire("lWmpu");
    var $i2U8X = parcelRequire("i2U8X");
    var $gGtKh = parcelRequire("gGtKh");
    const $3d1f0cda58e163e2$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("cbV2A")).then(({ JSMCmpProjectSettingsSidebar: JSMCmpProjectSettingsSidebar })=>JSMCmpProjectSettingsSidebar), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/jsm-cmp-project-settings/src/main.tsx"
    });
    const $3d1f0cda58e163e2$var$analyticsAttributes = {
        navVersion: '4',
        projectType: 'cmp'
    };
    const $3d1f0cda58e163e2$export$2ce6ad449436c545 = (0, $eUqFw.memo)(({ project: project })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.jsm-cmp-project-settings",
            packageName: "jiraNavigationAppsSidebarNav4JsmCmpProjectSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hzZWH.ContextualAnalyticsData), {
            menuId: (0, $i2U8X.MENU_ID_JSM_SETTINGS),
            attributes: $3d1f0cda58e163e2$var$analyticsAttributes
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.jsm-cmp-project-settings.loading-lazy",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($3d1f0cda58e163e2$var$LazySidebarContent, {
            project: project
        })))));
});
parcelRegister("hzZWH", function(module, exports) {
    $parcel$export(module.exports, "ContextualAnalyticsData", ()=>$9c9a74070e1186f3$export$198470770171c65);
    $parcel$export(module.exports, "IssuesContextualAnalyticsData", ()=>$9c9a74070e1186f3$export$bc7f6eebc16e6127);
    var $eUqFw = parcelRequire("eUqFw");
    var $7ZZxN = parcelRequire("7ZZxN");
    var $8WuJm = parcelRequire("8WuJm");
    var $cPEpP = parcelRequire("cPEpP");
    var $eEZvV = parcelRequire("eEZvV");
    const $9c9a74070e1186f3$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            ...rest,
            attributes: {
                navVersion: '3',
                viewId: (0, $eEZvV.generateViewId)(menuId, ...stack),
                navigationLayer: 'container',
                ...attributes
            }
        });
    const $9c9a74070e1186f3$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, $cPEpP.useProject), ...rest })=>{
        const { data: project } = useProject();
        const projectConfig = (project?.isSimplified ? (0, $7ZZxN.ProjectStyle).NEXT_GEN : (0, $7ZZxN.ProjectStyle).CLASSIC) || undefined;
        const projectType = project?.type || undefined;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            ...rest,
            attributes: {
                ...attributes,
                projectConfig: projectConfig,
                projectType: projectType,
                navigatorScope: navigatorScope
            }
        });
    };
});
parcelRegister("eEZvV", function(module, exports) {
    $parcel$export(module.exports, "generateViewId", ()=>$ff2c3a925d418d98$export$5b5545ed894dc47a);
    const $ff2c3a925d418d98$export$5b5545ed894dc47a = (...ids)=>ids.join('/');
});
parcelRegister("i2U8X", function(module, exports) {
    $parcel$export(module.exports, "MENU_ID_JSM_SETTINGS", ()=>$4bf27e77e236c402$export$4c5fa21d31710030);
    $parcel$export(module.exports, "COMMON_ANALYTICS_ATTRIBUTES", ()=>$4bf27e77e236c402$export$f21504b774272faa);
    const $4bf27e77e236c402$export$4c5fa21d31710030 = 'project/service-desk/settings';
    const $4bf27e77e236c402$export$f21504b774272faa = {
        actionSubjectId: 'projectSettingsNavigationMenuItem',
        componentType: 'fixedItem',
        level: 1
    };
});
parcelRegister("cbV2A", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("3ZXB6")
    ]).then(()=>parcelRequire('lMLib'));
});
parcelRegister("fGNgi", function(module, exports) {
    $parcel$export(module.exports, "AsyncJsmTmpProjectSettingsSidebar", ()=>$5767d2f1363a3d66$export$dadf0f8c840cb26d);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $hzZWH = parcelRequire("hzZWH");
    var $lShkl = parcelRequire("lShkl");
    var $lWmpu = parcelRequire("lWmpu");
    var $i2U8X = parcelRequire("i2U8X");
    var $gGtKh = parcelRequire("gGtKh");
    const $5767d2f1363a3d66$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("jT7JS")).then(({ JSMTmpProjectSettingsSidebar: JSMTmpProjectSettingsSidebar })=>JSMTmpProjectSettingsSidebar), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/jsm-tmp-project-settings/src/main.tsx"
    });
    const $5767d2f1363a3d66$var$analyticsAttributes = {
        navVersion: '4',
        projectType: 'tmp'
    };
    const $5767d2f1363a3d66$export$dadf0f8c840cb26d = (0, $eUqFw.memo)(({ project: project })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.jsm-tmp-project-settings",
            packageName: "jiraNavigationAppsSidebarNav4JsmTmpProjectSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hzZWH.ContextualAnalyticsData), {
            menuId: (0, $i2U8X.MENU_ID_JSM_SETTINGS),
            attributes: $5767d2f1363a3d66$var$analyticsAttributes
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.jsm-tmp-project-settings.loading-lazy",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($5767d2f1363a3d66$var$LazySidebarContent, {
            project: project
        })))));
});
parcelRegister("jT7JS", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("9zj7j")
    ]).then(()=>parcelRequire('kKInm'));
});
parcelRegister("upajt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c052b2690ab9d4d$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $lShkl = parcelRequire("lShkl");
    var $gGtKh = parcelRequire("gGtKh");
    var $kx8ra = parcelRequire("kx8ra");
    const $6c052b2690ab9d4d$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("ae7r0")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/personal-settings/src/ui/main.tsx"
    });
    const $6c052b2690ab9d4d$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.personal-settings",
            packageName: "jiraNavigationAppsSidebarNav4PersonalSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.personal-settings",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $kx8ra.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($6c052b2690ab9d4d$var$LazySidebarContent, null)));
    var $6c052b2690ab9d4d$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($6c052b2690ab9d4d$var$AsyncSidebar);
});
parcelRegister("kx8ra", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$ecdb6441e8b8a4f3$export$8f31e4c4a37b8e9c);
    var $eUqFw = parcelRequire("eUqFw");
    var $jGR8u = parcelRequire("jGR8u");
    var $6k5Uz = parcelRequire("6k5Uz");
    var $cYsCT = parcelRequire("cYsCT");
    var $fHiYa = parcelRequire("fHiYa");
    const $ecdb6441e8b8a4f3$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $ecdb6441e8b8a4f3$var$containerStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6k5Uz.default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $ecdb6441e8b8a4f3$var$backButton
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $ecdb6441e8b8a4f3$var$headingSkeleton
        })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $ecdb6441e8b8a4f3$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $ecdb6441e8b8a4f3$var$menuItem
        })));
    const $ecdb6441e8b8a4f3$var$containerStyles = (0, $fHiYa.xcss)({
        paddingBlock: 'space.200',
        paddingInline: 'space.200'
    });
    const $ecdb6441e8b8a4f3$var$backButton = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $ecdb6441e8b8a4f3$var$headingSkeleton = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $ecdb6441e8b8a4f3$var$menuItem = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("ae7r0", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("amXpr")
    ]).then(()=>parcelRequire('deFgL'));
});
parcelRegister("6DM93", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b6bf3c085c37346$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $48TMA = parcelRequire("48TMA");
    var $gGtKh = parcelRequire("gGtKh");
    var $lauHq = parcelRequire("lauHq");
    const $9b6bf3c085c37346$var$LazyPlanSettingsSidebar = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("57npr")).then(({ PlanSettingsSidebar: PlanSettingsSidebar })=>PlanSettingsSidebar), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/plan-settings/src/ui/main.tsx"
    });
    const $9b6bf3c085c37346$var$AsyncSidebar = ({ store: store })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $48TMA.SidebarContainer), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "asyncSidebarPlanSettings",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lauHq.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($9b6bf3c085c37346$var$LazyPlanSettingsSidebar, {
            store: store
        })));
    var $9b6bf3c085c37346$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($9b6bf3c085c37346$var$AsyncSidebar);
});
parcelRegister("48TMA", function(module, exports) {
    $parcel$export(module.exports, "SidebarContainer", ()=>$0f2d4b2633604022$export$f39f3f768bc98e3d);
    var $eUqFw = parcelRequire("eUqFw");
    var $cYsCT = parcelRequire("cYsCT");
    var $fHiYa = parcelRequire("fHiYa");
    const $0f2d4b2633604022$export$f39f3f768bc98e3d = ({ children: children })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.200",
            xcss: $0f2d4b2633604022$var$containerStyles
        }, children);
    const $0f2d4b2633604022$var$containerStyles = (0, $fHiYa.xcss)({
        height: '100%',
        padding: 'space.200'
    });
});
parcelRegister("lauHq", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$4b26b6b266a549df$export$8f31e4c4a37b8e9c);
    var $eUqFw = parcelRequire("eUqFw");
    var $jGR8u = parcelRequire("jGR8u");
    var $6k5Uz = parcelRequire("6k5Uz");
    var $cYsCT = parcelRequire("cYsCT");
    var $fHiYa = parcelRequire("fHiYa");
    const $4b26b6b266a549df$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.200"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6k5Uz.default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$backButton
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$headingSkeleton
        })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6k5Uz.default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$titleSkeleton
        })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$subtitleItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$menuItem
        })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$subtitleItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$menuItem
        })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$subtitleItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$menuItem
        })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$subtitleItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $4b26b6b266a549df$var$menuItem
        })));
    const $4b26b6b266a549df$var$titleSkeleton = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-800, 64px)",
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
    const $4b26b6b266a549df$var$backButton = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-400, 32px)",
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
    const $4b26b6b266a549df$var$headingSkeleton = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $4b26b6b266a549df$var$menuItem = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $4b26b6b266a549df$var$subtitleItem = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-200, 16px)",
        width: "var(--ds-space-1000, 80px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("57npr", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("i5Fwo")
    ]).then(()=>parcelRequire('6JPBu'));
});
parcelRegister("8BRHO", function(module, exports) {
    $parcel$export(module.exports, "useIsConnectAppActive", ()=>$d87ad2d423214fae$export$249b2e8512031cae);
    var $eUqFw = parcelRequire("eUqFw");
    var $aPhAZ = parcelRequire("aPhAZ");
    var $lB25E = parcelRequire("lB25E");
    var $7vxFY = parcelRequire("7vxFY");
    const $d87ad2d423214fae$export$249b2e8512031cae = ()=>{
        const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
        const { data: connectApps, error: error, loading: loading } = (0, $7vxFY.useConnectApps)();
        const isActive = (0, $eUqFw.useMemo)(()=>Boolean((0, $aPhAZ.findItemAndStack)(connectApps, route.name, location)?.selected), [
            connectApps,
            location,
            route.name
        ]);
        return {
            isActive: isActive,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("aPhAZ", function(module, exports) {
    $parcel$export(module.exports, "findItemAndStack", ()=>$975956fa8580f4db$export$751e2e6237002565);
    var $hTLlD = parcelRequire("hTLlD");
    var $elGVw = parcelRequire("elGVw");
    const $975956fa8580f4db$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
    const $975956fa8580f4db$var$isSameQuery = (locationQuery, itemQuery)=>(0, ($parcel$interopDefault($hTLlD)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, ($parcel$interopDefault($hTLlD)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
    const $975956fa8580f4db$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
        let found = null;
        if (!(0, $elGVw.CONNECT_ROUTES_SET).has(routeName)) return found;
        const locationQuery = $975956fa8580f4db$var$splitRelevantQs(location.search);
        items.some((item)=>{
            const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
            const itemQuery = $975956fa8580f4db$var$splitRelevantQs(itemQs);
            const sameQuery = $975956fa8580f4db$var$isSameQuery(locationQuery, itemQuery);
            if (item.section !== true && itemPath === location.pathname && sameQuery) {
                found = {
                    stack: parentStack,
                    selected: item
                };
                return true;
            }
            if (item.items) {
                const stack = item.section === true ? parentStack : parentStack.concat(item.id);
                found = $975956fa8580f4db$export$751e2e6237002565(item.items, routeName, location, stack);
            }
            return Boolean(found);
        });
        return found;
    };
});
parcelRegister("elGVw", function(module, exports) {
    $parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", ()=>$8ed378d04165c01c$export$a8aac2ba4dc1f57);
    $parcel$export(module.exports, "CONNECT_ROUTES_SET", ()=>$8ed378d04165c01c$export$c47bf667d3008c53);
    var $exb0h = parcelRequire("exb0h");
    const $8ed378d04165c01c$export$a8aac2ba4dc1f57 = new Set([
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE),
        (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT)
    ]);
    const $8ed378d04165c01c$export$c47bf667d3008c53 = new Set([
        (0, $exb0h.ROUTE_NAMES_CONNECT_PROJECT),
        (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL),
        (0, $exb0h.ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
        (0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
        (0, $exb0h.ROUTE_NAMES_LEGACY_CONNECT_GENERAL)
    ]);
});
parcelRegister("7vxFY", function(module, exports) {
    $parcel$export(module.exports, "useConnectApps", ()=>$ae62cc34f2dfff3a$export$4864478dcab77643);
    var $eUqFw = parcelRequire("eUqFw");
    var $iivTa = parcelRequire("iivTa");
    var $fcFGd = parcelRequire("fcFGd");
    var $dRX6p = parcelRequire("dRX6p");
    const $ae62cc34f2dfff3a$export$4864478dcab77643 = ()=>{
        const { data: connectResourceItems, error: error, loading: loading } = (0, $iivTa.useProjectSettingsSidebarConnectAddonsNavigationResource)();
        const connectApps = (0, $eUqFw.useMemo)(()=>{
            if (connectResourceItems == null) return [];
            const transformedConnectApps = [];
            for (const item of connectResourceItems){
                const transformedItem = (0, $fcFGd.transformLinkV4)(item);
                if (transformedItem && !(0, $dRX6p.LEGACY_CONNECT_ITEM_IDS).has(transformedItem.id)) transformedConnectApps.push(transformedItem);
            }
            return transformedConnectApps;
        }, [
            connectResourceItems
        ]);
        return {
            data: connectApps,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("fcFGd", function(module, exports) {
    $parcel$export(module.exports, "transformLink", ()=>$a0f0f23c4ab645d6$export$5a32dc366b1d641f);
    $parcel$export(module.exports, "transformLinkV4", ()=>$a0f0f23c4ab645d6$export$27267b6b6650eaa5);
    const $a0f0f23c4ab645d6$export$5a32dc366b1d641f = (link)=>{
        const items = link.links && link.links.length ? link.links.map($a0f0f23c4ab645d6$export$5a32dc366b1d641f).filter(Boolean) : undefined;
        if (link.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(link.name)
            };
            return {
                id: link.id,
                name: String(link.name),
                section: !!link.section,
                items: items
            };
        }
        return {
            id: link.id,
            name: String(link.name),
            url: link.url,
            iconUrl: link.iconUrl || '',
            styleClass: link.styleClass || '',
            items: items
        };
    };
    const $a0f0f23c4ab645d6$export$27267b6b6650eaa5 = (data)=>{
        const items = data.links && data.links.length ? data.links.map($a0f0f23c4ab645d6$export$27267b6b6650eaa5).filter(Boolean) : undefined;
        if (data.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(data.name)
            };
            return {
                id: data.id,
                name: String(data.name),
                section: !!data.section,
                items: items
            };
        }
        return {
            id: data.id,
            name: String(data.name),
            url: data.url,
            iconUrl: data.iconUrl || '',
            styleClass: data.styleClass || '',
            items: items
        };
    };
});
parcelRegister("dRX6p", function(module, exports) {
    $parcel$export(module.exports, "LEGACY_CONNECT_ITEM_IDS", ()=>$808535a038b46717$export$911a3d81a5d162b6);
    const $808535a038b46717$export$911a3d81a5d162b6 = new Set([
        'general_configuration',
        'dark_features',
        'troubleshooting_and_support',
        'view_auditing',
        'pluginViewer',
        'pluginViewer',
        'system_info',
        'integrity_checker',
        'logging_profiling',
        'scheduler_details',
        'security_section',
        'project_role_browser',
        'global_permissions',
        'collectors',
        'user_interface',
        'user_defaults',
        'edit_default_dashboard',
        'lookandfeel',
        'com.atlassian.pas:pas-admin-link-jira',
        'import_export_section',
        'vertigo_export',
        'external_import',
        'vertigo_import',
        'vertigo_import_jira_cloud',
        'vertigo_import_jira_server',
        'mail_section',
        'global_mail_settings',
        'outgoing_mail',
        'incoming_mail',
        'send_email',
        'admin-helper-admin-section',
        'permissionhelper-admin-page',
        'notificationhelper-admin-page',
        'shared_section',
        'shared_filters',
        'shared_dashboards',
        'advanced_section',
        'attachments',
        'eventtypes',
        'webhooks-admin',
        'services',
        'manage_dashboards',
        'manage_filters',
        'greenhopper-lexorank-manage',
        'jira.webfragments.view.project.operations:edit_project',
        'com.atlassian.jira.jira-project-config-plugin:users-and-roles',
        'com.atlassian.jira.jira-project-config-plugin:view_project_summary',
        'com.atlassian.jira.jira-project-config-plugin:view_delete_project',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuetypes',
        'com.atlassian.jira.jira-project-config-plugin:view_project_workflows',
        'com.atlassian.jira.jira-project-config-plugin:view_project_screens',
        'com.atlassian.jira.jira-project-config-plugin:view_project_fields',
        'com.atlassian.jira.jira-projects-plugin:administer_project_versions',
        'com.atlassian.jira.jira-projects-plugin:administer_project_components',
        'com.atlassian.jira.jira-project-config-plugin:view_project_permissions',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuesecurity',
        'com.atlassian.jira.jira-project-config-plugin:view_project_notifications',
        'com.atlassian.jira.jira-project-config-plugin:project-opsgenie-association',
        'com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:view_issue_collectors',
        'com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-admin-page-link',
        'com.atlassian.plugins.atlassian-connect-plugin:com.codebarrel.addons.automation__cb-automation-project-config',
        'com.atlassian.jira.jira-project-config-plugin:view_project_issuelayout',
        'com.atlassian.jira.jira-projects-plugin:administer_project_code',
        'com.atlassian.jira.jira-projects-plugin:administer_project_deployments',
        'com.atlassian.servicedesk.project-ui:sd-project-change-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-request-types-item',
        'com.atlassian.servicedesk.project-ui:sd-project-customer-permissions-item',
        'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-project-language-support-settings-item-adg3',
        'com.atlassian.servicedesk.project-ui:sd-project-portal-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-email-settings-item',
        'com.atlassian.servicedesk.servicedesk-notifications-plugin:sd-project-outgoing-email-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-widget-addon-installer-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded__settings',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.servicedesk.embedded-dev__settings',
        'com.atlassian.servicedesk.project-ui:sd-project-assets-ad-item',
        'com.atlassian.servicedesk.project-ui:sd-project-feedback-settings-item',
        'com.atlassian.servicedesk.project-ui:sd-project-confluence-kb-item',
        'com.atlassian.servicedesk.project-ui:sd-project-sla-item',
        'com.atlassian.servicedesk.project-ui:sd-project-automation-item',
        'com.atlassian.servicedesk.project-ui:sd-project-app-discovery-item',
        'com.atlassian.servicedesk.project-ui:sd-project-incident-management-item',
        'com.atlassian.servicedesk.project-ui:sd-project-itsm-features-item',
        'com.atlassian.servicedesk.project-ui:sd-project-external-links-item',
        'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.atlas.jira__goals-project-page',
        'com.codebarrel.addons.automation__cb-automation'
    ]);
});
parcelRegister("hI8UJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13a9a6189146b74c$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $lShkl = parcelRequire("lShkl");
    var $lWmpu = parcelRequire("lWmpu");
    var $gGtKh = parcelRequire("gGtKh");
    const $13a9a6189146b74c$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("7fiea")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/product-discovery/src/ui/main.tsx"
    });
    const $13a9a6189146b74c$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.project-settings.jpd-settings",
            packageName: "jiraNavigationAppsSidebarNav4ProjectSettingsJpdSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.project-settings.jpd-settings",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($13a9a6189146b74c$var$LazySidebarContent, {
            project: project
        })));
    var $13a9a6189146b74c$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($13a9a6189146b74c$var$AsyncSidebar);
});
parcelRegister("7fiea", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("7e35E")
    ]).then(()=>parcelRequire('0UUjB'));
});
parcelRegister("Me4cl", function(module, exports) {
    $parcel$export(module.exports, "getNav4Rollout", ()=>$91a40f512dd6cfb8$export$84a05d3b37ec5d2);
    var $Pa86f = parcelRequire("Pa86f");
    var $CAsD5 = parcelRequire("CAsD5");
    var $79FCd = parcelRequire("79FCd");
    var $eI5EY = parcelRequire("eI5EY");
    var $73h4w = parcelRequire("73h4w");
    var $h5JTd = parcelRequire("h5JTd");
    var $aOLta = parcelRequire("aOLta");
    const $91a40f512dd6cfb8$export$84a05d3b37ec5d2 = (0, ($parcel$interopDefault($Pa86f)))([
        [
            ()=>!(0, $eI5EY.fg)('jira_nav4'),
            (0, ($parcel$interopDefault($CAsD5)))((0, $73h4w.NAV4_ROLLOUT_NONE))
        ],
        [
            ()=>(0, $eI5EY.fg)('jira_nav4_dogfooding'),
            (0, $h5JTd.getNav4RolloutForDogfooding)
        ],
        [
            ()=>(0, $eI5EY.fg)('jira_nav4_eap'),
            (0, $aOLta.getNav4RolloutForEap)
        ],
        [
            (0, ($parcel$interopDefault($79FCd))),
            (0, ($parcel$interopDefault($CAsD5)))((0, $73h4w.NAV4_ROLLOUT_NONE))
        ]
    ]);
});
parcelRegister("Pa86f", function(module, exports) {
    var $5VdlS = parcelRequire("5VdlS");
    var $kJvGp = parcelRequire("kJvGp");
    var $7qARj = parcelRequire("7qARj");
    var $9eFtX = parcelRequire("9eFtX");
    var $099c9f12218d31c6$var$FUNC_ERROR_TEXT = 'Expected a function';
    function $099c9f12218d31c6$var$cond(pairs) {
        var length = pairs == null ? 0 : pairs.length, toIteratee = $7qARj;
        pairs = !length ? [] : $kJvGp(pairs, function(pair) {
            if (typeof pair[1] != 'function') throw new TypeError($099c9f12218d31c6$var$FUNC_ERROR_TEXT);
            return [
                toIteratee(pair[0]),
                pair[1]
            ];
        });
        return $9eFtX(function(args) {
            var index = -1;
            while(++index < length){
                var pair = pairs[index];
                if ($5VdlS(pair[0], this, args)) return $5VdlS(pair[1], this, args);
            }
        });
    }
    module.exports = $099c9f12218d31c6$var$cond;
});
parcelRegister("79FCd", function(module, exports) {
    function $5359a7a39025697e$var$stubTrue() {
        return true;
    }
    module.exports = $5359a7a39025697e$var$stubTrue;
});
parcelRegister("h5JTd", function(module, exports) {
    $parcel$export(module.exports, "getNav4RolloutForDogfooding", ()=>$f6e00cb3a2c92713$export$f1e751a9a9d68fb5);
    var $Pa86f = parcelRequire("Pa86f");
    var $79FCd = parcelRequire("79FCd");
    var $eI5EY = parcelRequire("eI5EY");
    var $6mXXc = parcelRequire("6mXXc");
    const $f6e00cb3a2c92713$var$dogfoodingPhase = (phase)=>()=>phase !== 3 ? {
                stage: 'dogfooding',
                phase: phase,
                isUserOptOut: (0, $6mXXc.getIsNav4UserOptOut)()
            } : {
                stage: 'dogfooding',
                phase: phase
            };
    const $f6e00cb3a2c92713$export$f1e751a9a9d68fb5 = (0, ($parcel$interopDefault($Pa86f)))([
        [
            ()=>(0, $eI5EY.fg)('jira_nav4_dogfooding_phase-2'),
            $f6e00cb3a2c92713$var$dogfoodingPhase(2)
        ],
        [
            ()=>(0, $eI5EY.fg)('jira_nav4_dogfooding_phase-1'),
            $f6e00cb3a2c92713$var$dogfoodingPhase(1)
        ],
        [
            (0, ($parcel$interopDefault($79FCd))),
            $f6e00cb3a2c92713$var$dogfoodingPhase(3)
        ]
    ]);
});
parcelRegister("aOLta", function(module, exports) {
    $parcel$export(module.exports, "getNav4RolloutForEap", ()=>$464a54351f32367b$export$42dd8c002a342b8);
    var $6mXXc = parcelRequire("6mXXc");
    const $464a54351f32367b$export$42dd8c002a342b8 = ()=>({
            stage: 'eap',
            isUserOptOut: (0, $6mXXc.getIsNav4UserOptOut)()
        });
});
parcelRegister("aBzna", function(module, exports) {
    $parcel$export(module.exports, "useNavigateBack", ()=>$182cd1806f8e4ce8$export$7ce1f551d78f9130);
    $parcel$export(module.exports, "NavigateBackProvider", ()=>$182cd1806f8e4ce8$export$e1e76f4ee7f8174d);
    var $eUqFw = parcelRequire("eUqFw");
    var $g08Zs = parcelRequire("g08Zs");
    var $lB25E = parcelRequire("lB25E");
    var $8yhIn = parcelRequire("8yhIn");
    const $182cd1806f8e4ce8$var$STORAGE_KEY = 'back-button-url';
    const $182cd1806f8e4ce8$var$NavigateBackContext = (0, $eUqFw.createContext)(undefined);
    const $182cd1806f8e4ce8$export$7ce1f551d78f9130 = ()=>{
        const context = (0, $eUqFw.useContext)($182cd1806f8e4ce8$var$NavigateBackContext);
        if (!context) throw new Error('useNavigateBack must be used within a NavigateBackProvider');
        return context;
    };
    const $182cd1806f8e4ce8$export$e1e76f4ee7f8174d = ({ children: children })=>{
        const { push: push } = (0, $lB25E.useRouterActions)();
        const [previousUrl, setPreviousUrl] = (0, $eUqFw.useState)(()=>(0, $8yhIn.storageProvider).get($182cd1806f8e4ce8$var$STORAGE_KEY));
        const saveCurrentRoute = (0, $eUqFw.useCallback)(()=>{
            const url = `${window.location.pathname}${window.location.search}${window.location.hash}`;
            setPreviousUrl(url);
            (0, $8yhIn.storageProvider).set($182cd1806f8e4ce8$var$STORAGE_KEY, url);
        }, []);
        const goBack = (0, $eUqFw.useCallback)(()=>push(previousUrl ?? (0, $g08Zs.jiraHomeRoute).path), [
            previousUrl,
            push
        ]);
        const value = (0, $eUqFw.useMemo)(()=>({
                saveCurrentRoute: saveCurrentRoute,
                goBack: goBack
            }), [
            saveCurrentRoute,
            goBack
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement($182cd1806f8e4ce8$var$NavigateBackContext.Provider, {
            value: value
        }, children);
    };
});
parcelRegister("g08Zs", function(module, exports) {
    $parcel$export(module.exports, "jiraHomeRoute", ()=>$6e7a6dff76357b07$export$11ebbd6d4e57759c);
    var $exb0h = parcelRequire("exb0h");
    const $6e7a6dff76357b07$export$11ebbd6d4e57759c = {
        group: (0, $exb0h.ROUTE_GROUPS_HOME),
        name: (0, $exb0h.ROUTE_NAMES_YOUR_WORK),
        path: '/jira/your-work'
    };
});
parcelRegister("8yhIn", function(module, exports) {
    $parcel$export(module.exports, "storageProvider", ()=>$e8f940483c944f4b$export$ce7751641b93537d);
    var $89bO2 = parcelRequire("89bO2");
    const $e8f940483c944f4b$export$ce7751641b93537d = (0, $89bO2.createSessionStorageProvider)('sidebar-navigation');
});
parcelRegister("fu7hM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e126bf6d7a059cc2$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $lShkl = parcelRequire("lShkl");
    var $gGtKh = parcelRequire("gGtKh");
    const $e126bf6d7a059cc2$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("eHWgV")).then(({ SidebarContent: SidebarContent })=>SidebarContent), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/content/core/src/index.tsx"
    });
    const $e126bf6d7a059cc2$var$AsyncSidebarContent = (0, $eUqFw.memo)(()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "asyncSidebarContent",
            packageName: "jiraNavigationAppsSidebarNav4SidebarContent",
            teamName: "jira-cosmos"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "lazySidebarContent"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($e126bf6d7a059cc2$var$LazySidebarContent, null))));
    $e126bf6d7a059cc2$var$AsyncSidebarContent.displayName = 'AsyncSidebarContent';
    var $e126bf6d7a059cc2$export$2e2bcd8739ae039 = $e126bf6d7a059cc2$var$AsyncSidebarContent;
});
parcelRegister("eHWgV", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("6NVk7")),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("ny9KK")
    ]).then(()=>parcelRequire('76wzi'));
});
parcelRegister("bRT5F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad292fe394c3d387$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $lShkl = parcelRequire("lShkl");
    var $gGtKh = parcelRequire("gGtKh");
    var $af5or = parcelRequire("af5or");
    const $ad292fe394c3d387$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("39auu")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/board/src/ui/main.tsx"
    });
    const $ad292fe394c3d387$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.board-settings",
            packageName: "jiraNavigationAppsSidebarNav4BoardSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.board-settings",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $af5or.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($ad292fe394c3d387$var$LazySidebarContent, null)));
    var $ad292fe394c3d387$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($ad292fe394c3d387$var$AsyncSidebar);
});
parcelRegister("af5or", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$3e267f52e5fdc3f5$export$8f31e4c4a37b8e9c);
    var $eUqFw = parcelRequire("eUqFw");
    var $jGR8u = parcelRequire("jGR8u");
    var $6k5Uz = parcelRequire("6k5Uz");
    var $cYsCT = parcelRequire("cYsCT");
    var $fHiYa = parcelRequire("fHiYa");
    const $3e267f52e5fdc3f5$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $3e267f52e5fdc3f5$var$containerStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6k5Uz.default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $3e267f52e5fdc3f5$var$backButton
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $3e267f52e5fdc3f5$var$headingSkeleton
        })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $3e267f52e5fdc3f5$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $3e267f52e5fdc3f5$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $3e267f52e5fdc3f5$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $3e267f52e5fdc3f5$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $3e267f52e5fdc3f5$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $3e267f52e5fdc3f5$var$menuItem
        })));
    const $3e267f52e5fdc3f5$var$containerStyles = (0, $fHiYa.xcss)({
        paddingBlock: 'space.200',
        paddingInline: 'space.200'
    });
    const $3e267f52e5fdc3f5$var$backButton = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $3e267f52e5fdc3f5$var$headingSkeleton = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $3e267f52e5fdc3f5$var$menuItem = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("39auu", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("iEy4s")
    ]).then(()=>parcelRequire('fb97x'));
});
parcelRegister("dAUnM", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSettingsConnectItems", ()=>$41d652e03711b107$export$f0785b98c99d344c);
    $parcel$export(module.exports, "useIsAppsSettingsConnectAppModule", ()=>$41d652e03711b107$export$8dd86b1eb9fdf786);
    $parcel$export(module.exports, "useGlobalAppsSettingsConnectItemActive", ()=>$41d652e03711b107$export$83008eebb9fccef3);
    var $eUqFw = parcelRequire("eUqFw");
    var $aPhAZ = parcelRequire("aPhAZ");
    var $6nvum = parcelRequire("6nvum");
    var $fcFGd = parcelRequire("fcFGd");
    var $5neED = parcelRequire("5neED");
    var $aoOGZ = parcelRequire("aoOGZ");
    var $lB25E = parcelRequire("lB25E");
    const $41d652e03711b107$var$getItems = (d)=>(0, $6nvum.getLinks)(d, [
            'admin_plugins_menu'
        ], {
            skipFilter: true
        }).filter((v)=>![
                'upm_section',
                'jpo-ws-admin'
            ].includes(v.id)).map((0, $fcFGd.transformLink)).filter(Boolean);
    const $41d652e03711b107$export$f0785b98c99d344c = ()=>{
        const { data: data, loading: loading, error: error } = (0, $5neED.useNavigationGlobalResource)();
        const items = (0, $eUqFw.useMemo)(()=>data && $41d652e03711b107$var$getItems(data), [
            data
        ]);
        return {
            data: items,
            loading: loading,
            error: error
        };
    };
    const $41d652e03711b107$export$ae997bf97ec22b71 = new Set([
        'configurePage',
        'postInstallPage'
    ]);
    const $41d652e03711b107$export$8dd86b1eb9fdf786 = ()=>{
        const { data: data, loading: loading, error: error } = (0, $aoOGZ.useConnectGeneralResource)();
        return {
            isActive: $41d652e03711b107$export$ae997bf97ec22b71.has(data?.moduleType),
            loading: loading,
            error: error
        };
    };
    const $41d652e03711b107$export$83008eebb9fccef3 = ()=>{
        const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
        const { data: data, loading: loading, error: error } = $41d652e03711b107$export$f0785b98c99d344c();
        const { isActive: isAppsSettingsConnectAppModuleActive, loading: isAppsSettingsConnectAppModuleLoading, error: isAppsSettingsConnectAppModuleError } = $41d652e03711b107$export$8dd86b1eb9fdf786();
        const isActive = (0, $eUqFw.useMemo)(()=>Boolean(route && data && (0, $aPhAZ.findItemAndStack)(data, route.name, location)?.selected), [
            data,
            route,
            location
        ]);
        return {
            isActive: isActive || isAppsSettingsConnectAppModuleActive,
            loading: loading || isAppsSettingsConnectAppModuleLoading,
            error: error || isAppsSettingsConnectAppModuleError
        };
    };
});
parcelRegister("6nvum", function(module, exports) {
    $parcel$export(module.exports, "getLinks", ()=>$1528aa118566e94c$export$8054dcb2b42da45c);
    var $fOTKa = parcelRequire("fOTKa");
    const $1528aa118566e94c$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
            if (item.id === legacyId) return item.links;
            return item.links && $1528aa118566e94c$var$findChildLinks(item.links, legacyId);
        }).find(Boolean);
    const $1528aa118566e94c$var$getLinksFromSidebar = (sidebarConfig, legacyId)=>{
        const links = legacyId != null ? $1528aa118566e94c$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
        return links || [];
    };
    const $1528aa118566e94c$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
        const acc = [];
        locations.forEach((location)=>{
            const links = $1528aa118566e94c$var$getLinksFromSidebar(sidebarConfig, location);
            if (omitSections === true) {
                Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
                return;
            }
            Array.prototype.push.apply(acc, links);
        });
        return acc.filter((item)=>{
            if (!item) return false;
            if (skipFilter === true) return true;
            const hasConnectPrefix = item.id && item.id.includes((0, $fOTKa.connectPrefix));
            if (hasConnectPrefix) return true;
            const isConnectSection = (0, $fOTKa.connectSections).includes(item.id);
            if (isConnectSection) return true;
            const isJsdConnectSection = item.id && item.id.includes((0, $fOTKa.jsdConnectPrefix));
            if (isJsdConnectSection) return true;
            return false;
        });
    };
});
parcelRegister("fOTKa", function(module, exports) {
    $parcel$export(module.exports, "connectPrefix", ()=>$e4f66a9371848a2c$export$196d83ebd873fb40);
    $parcel$export(module.exports, "jsdConnectPrefix", ()=>$e4f66a9371848a2c$export$7fac8f726f52d70);
    $parcel$export(module.exports, "connectSections", ()=>$e4f66a9371848a2c$export$b1c2c1fc5d10280);
    var $dYFw9 = parcelRequire("dYFw9");
    const $e4f66a9371848a2c$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
    const $e4f66a9371848a2c$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
    const $e4f66a9371848a2c$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
    const $e4f66a9371848a2c$var$jsdQueuesConnectSection = 'sd-queues-addons';
    const $e4f66a9371848a2c$export$b1c2c1fc5d10280 = [
        $e4f66a9371848a2c$var$legacyAddonPanelLinkId,
        (0, $dYFw9.REPORTS_IDS).REPORTS_ADDONS,
        $e4f66a9371848a2c$var$jsdQueuesConnectSection
    ];
});
parcelRegister("5neED", function(module, exports) {
    $parcel$export(module.exports, "useNavigationGlobalResource", ()=>$e9dba7fce6b826be$export$1e1c317ed5b99faa);
    var $9CFDS = parcelRequire("9CFDS");
    var $lB25E = parcelRequire("lB25E");
    const $e9dba7fce6b826be$export$1e1c317ed5b99faa = ()=>{
        const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)((0, $9CFDS.navigationSidebarGlobalResource));
        return {
            data: data && data.response,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("9CFDS", function(module, exports) {
    $parcel$export(module.exports, "navigationSidebarGlobalResource", ()=>$979e04dcc1e8ef35$export$44e7ad3c66a3f25f);
    var $hdKL9 = parcelRequire("hdKL9");
    var $9zYls = parcelRequire("9zYls");
    var $lB25E = parcelRequire("lB25E");
    const $979e04dcc1e8ef35$export$44e7ad3c66a3f25f = (0, $lB25E.createResource)({
        type: (0, $892a51daa0b1294e$export$fa5743fc6a1da5d8),
        getKey: ({ match: match, query: query })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
            return projectKey || projectId || '__state';
        },
        getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { baseUrl: baseUrl } = tenantContext;
            const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
            const scope = {
                projectKey: projectKey,
                projectId: projectId
            };
            const response = await (0, $hdKL9.fetchSidebarConfig)(baseUrl, scope, false);
            return {
                response: response,
                scope: scope
            };
        },
        maxAge: 300000
    });
});
parcelRegister("hdKL9", function(module, exports) {
    $parcel$export(module.exports, "fetchSidebarConfig", ()=>$7f8c4b071371acc8$export$d1d13c4b972a22f1);
    var $gUUjF = parcelRequire("gUUjF");
    var $2OdyW = parcelRequire("2OdyW");
    const $7f8c4b071371acc8$var$LOGGER_LOCATION = 'navigation-next.baskets.navigation.utils';
    const $7f8c4b071371acc8$var$fetchUsingProtobuf = async (url)=>{
        try {
            const fetchProtobuf = await (parcelRequire("9sh4S"));
            if (!fetchProtobuf) (0, $gUUjF.default).safeErrorWithoutCustomerData($7f8c4b071371acc8$var$LOGGER_LOCATION, 'Error dynamically loading protobuf fetch function');
            return fetchProtobuf.default(url);
        } catch (err) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData($7f8c4b071371acc8$var$LOGGER_LOCATION, 'Error fetching Sidebar Configuration protocol buffer message', err);
            throw err;
        }
    };
    const $7f8c4b071371acc8$export$94e808b2557f52e = (baseUrl, requestQuery, version = '2', queryParams)=>{
        const { pageType: pageType, identifierValue: identifierValue, identifierType: identifierType, exclude: exclude } = requestQuery || {};
        const params = {
            exclude: [
                'webItems.reports',
                'webItems.home',
                'webItems.gin',
                exclude
            ].filter(Boolean).join(',')
        };
        let path = '';
        if (pageType && identifierValue != null) path = `${pageType}/${identifierValue}`;
        else if (identifierType === 'boardId' && identifierValue != null) path = `board/${identifierValue}`;
        else if (identifierValue != null) path = `project/${identifierValue}`;
        else {
            path = 'product';
            const { projectId: projectId, projectKey: projectKey } = requestQuery || {};
            const projectIdOrKey = projectId || projectKey;
            if (projectIdOrKey) params.projectIdOrKey = projectIdOrKey;
        }
        const queryString = [
            new URLSearchParams(params).toString(),
            queryParams
        ].filter(Boolean).join('&');
        return `${baseUrl}/rest/navigation/${version}/${path}?${queryString}`;
    };
    const $7f8c4b071371acc8$export$d1d13c4b972a22f1 = async (baseUrl, requestQuery, isServer, queryParams)=>{
        if (isServer) {
            const protoUrl = $7f8c4b071371acc8$export$94e808b2557f52e(baseUrl, requestQuery, '2.1', queryParams);
            return $7f8c4b071371acc8$var$fetchUsingProtobuf(protoUrl);
        }
        const sidebarUrl = $7f8c4b071371acc8$export$94e808b2557f52e(baseUrl, requestQuery, undefined, queryParams);
        return (0, $2OdyW.default)(sidebarUrl);
    };
});
parcelRegister("9sh4S", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("ioYkw").then(()=>parcelRequire('bHKJS'));
});
const $892a51daa0b1294e$export$fa5743fc6a1da5d8 = 'NAVIGATION_SIDEBAR_GLOBAL';
parcelRegister("aoOGZ", function(module, exports) {
    $parcel$export(module.exports, "connectGeneralResources", ()=>$64e1806c7cddf26f$export$f34ab0d904621847);
    $parcel$export(module.exports, "useConnectGeneralResource", ()=>$64e1806c7cddf26f$export$53479840ec6d4024);
    var $lB25E = parcelRequire("lB25E");
    const $64e1806c7cddf26f$export$f34ab0d904621847 = (0, $lB25E.createResource)({
        type: (0, $4bb561a7936efe46$export$d5eed449bb62d4c1),
        getKey: ({ match: { params: { addonKey: addonKey, moduleKey: moduleKey } } })=>{
            if (addonKey !== null && addonKey !== undefined && moduleKey !== null && moduleKey !== undefined) return `${addonKey}-${moduleKey}`;
            return 'state';
        },
        getDataLoader: ()=>(parcelRequire("kw0Ar"))
    });
    const $64e1806c7cddf26f$export$53479840ec6d4024 = ()=>(0, $lB25E.useResource)($64e1806c7cddf26f$export$f34ab0d904621847);
});
const $4bb561a7936efe46$export$d5eed449bb62d4c1 = 'CONNECT_GENERAL';
parcelRegister("kw0Ar", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("5H5no").then(()=>parcelRequire('aSOAb'));
});
parcelRegister("34zVc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5039b64641be55e4$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $lShkl = parcelRequire("lShkl");
    var $cUHBb = parcelRequire("cUHBb");
    var $QnfMY = parcelRequire("QnfMY");
    var $gGtKh = parcelRequire("gGtKh");
    const $5039b64641be55e4$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("bvuD3")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/apps/src/ui/main.tsx"
    });
    const $5039b64641be55e4$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.global-settings.apps-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsAppsSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cUHBb.SidebarContent), {
            currentPageName: "apps"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.global-settings.apps-settings",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $QnfMY.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($5039b64641be55e4$var$LazySidebarContent, null))));
    var $5039b64641be55e4$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($5039b64641be55e4$var$AsyncSidebar);
});
parcelRegister("cUHBb", function(module, exports) {
    $parcel$export(module.exports, "SidebarContent", ()=>$12b0a1c127d27daa$export$49e8f7b58a4df4ea);
    var $eUqFw = parcelRequire("eUqFw");
    var $ld5Wr = parcelRequire("ld5Wr");
    var $jGR8u = parcelRequire("jGR8u");
    var $1AHzd = parcelRequire("1AHzd");
    var $cYsCT = parcelRequire("cYsCT");
    var $fHiYa = parcelRequire("fHiYa");
    var $5JgJ2 = parcelRequire("5JgJ2");
    var $lG0Ma = parcelRequire("lG0Ma");
    var $ka8bs = parcelRequire("ka8bs");
    var $72HD7 = parcelRequire("72HD7");
    var $3z8wI = parcelRequire("3z8wI");
    const $12b0a1c127d27daa$export$49e8f7b58a4df4ea = ({ children: children, currentPageName: currentPageName })=>{
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.200",
            xcss: $12b0a1c127d27daa$var$settingsHeading
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1AHzd.default), {
            alignBlock: "center",
            grow: "hug",
            space: "space.100",
            testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content.header"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lG0Ma.BackButton), null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ld5Wr.default), {
            size: "small",
            as: "h2"
        }, formatMessage((0, $3z8wI.default).heading))), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $72HD7.AsyncPageSwitcher), {
            currentPageName: currentPageName
        })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $12b0a1c127d27daa$var$contentStyles,
            testId: "navigation-apps-sidebar-nav4-sidebars-settings-global-common.ui.sidebar-content"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ka8bs.MenuList), null, children)));
    };
    const $12b0a1c127d27daa$var$settingsHeading = (0, $fHiYa.xcss)({
        position: 'sticky',
        top: 'space.0',
        paddingInline: 'space.200',
        paddingBlockStart: 'space.200',
        paddingBlockEnd: 'space.100',
        backgroundColor: 'elevation.surface',
        zIndex: 1
    });
    const $12b0a1c127d27daa$var$contentStyles = (0, $fHiYa.xcss)({
        paddingBlockStart: 'space.100',
        paddingBlockEnd: 'space.200',
        paddingInline: 'space.200'
    });
});
parcelRegister("lG0Ma", function(module, exports) {
    $parcel$export(module.exports, "BackButton", ()=>$cf107329162a3248$export$e0d897ee21382f67);
    var $eUqFw = parcelRequire("eUqFw");
    var $ipmlN = parcelRequire("ipmlN");
    var $fTVzv = parcelRequire("fTVzv");
    var $cmipe = parcelRequire("cmipe");
    var $5JgJ2 = parcelRequire("5JgJ2");
    var $jMP2a = parcelRequire("jMP2a");
    var $1inzG = parcelRequire("1inzG");
    var $aBzna = parcelRequire("aBzna");
    var $kPgxJ = parcelRequire("kPgxJ");
    const $cf107329162a3248$export$e0d897ee21382f67 = ()=>{
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        const { goBack: goBack } = (0, $aBzna.useNavigateBack)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cmipe.default), {
            content: formatMessage((0, $kPgxJ.default).tooltip),
            hideTooltipOnMouseDown: true
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ipmlN.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: (0, ($parcel$interopDefault($fTVzv))),
            label: formatMessage((0, $kPgxJ.default).label),
            onClick: ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'sidebarBackButton');
                goBack();
            }
        }));
    };
});
parcelRegister("fTVzv", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b938a69b604a7c58$var$_react = $b938a69b604a7c58$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $b938a69b604a7c58$var$_UNSAFE_baseNew = $b938a69b604a7c58$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $b938a69b604a7c58$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b938a69b604a7c58$var$ArrowLeftIcon = (props)=>$b938a69b604a7c58$var$_react.default.createElement($b938a69b604a7c58$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
        }, props));
    $b938a69b604a7c58$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
    var $b938a69b604a7c58$var$_default = module.exports.default = $b938a69b604a7c58$var$ArrowLeftIcon;
});
parcelRegister("kPgxJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$255fdb38950f2d8d$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    var $255fdb38950f2d8d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
        tooltip: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.tooltip",
            "defaultMessage": "Go back"
        },
        label: {
            "id": "navigation-apps-sidebar-nav4-sidebars-common-back-button.back-button.label",
            "defaultMessage": "Navigate back to the previous page"
        }
    });
});
parcelRegister("ka8bs", function(module, exports) {
    $parcel$export(module.exports, "MenuList", ()=>$1f0c37ef266ca6f3$export$d4c4e98c5044dc8);
    var $ehZB6 = parcelRequire("ehZB6");
    const $1f0c37ef266ca6f3$export$d4c4e98c5044dc8 = (0, $ehZB6.List);
});
parcelRegister("ehZB6", function(module, exports) {
    $parcel$export(module.exports, "List", ()=>$bb62ea9cd85d2cbb$export$54c2e3dc7acea9f5);
    var $eUqFw = parcelRequire("eUqFw");
    var $9xS6A = parcelRequire("9xS6A");
    function $bb62ea9cd85d2cbb$var$_List({ children: children, xcss: xcss }, forwardedRef) {
        const internalRef = (0, $eUqFw.useRef)(null);
        (0, $eUqFw.useEffect)(()=>{
            var child;
        }, []);
        const ref = (0, $9xS6A.default)([
            internalRef,
            forwardedRef
        ]);
        return ($eUqFw.createElement("div", {
            role: "list",
            ref: ref,
            className: xcss
        }, children));
    }
    const $bb62ea9cd85d2cbb$export$54c2e3dc7acea9f5 = (0, $eUqFw.forwardRef)($bb62ea9cd85d2cbb$var$_List);
    function $bb62ea9cd85d2cbb$var$isValidChild(element) {
        if (element.tagName === 'STYLE' || element.tagName === 'SCRIPT') return true;
        if (element.tagName === 'DIV' && element.getAttribute('role') === null) return Array.from(element.children).every($bb62ea9cd85d2cbb$var$isValidChild);
        return element.getAttribute('role') === 'listitem';
    }
});
parcelRegister("72HD7", function(module, exports) {
    $parcel$export(module.exports, "AsyncPageSwitcher", ()=>$6c80d8969b7507dc$export$3130bd98029942c);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $jGR8u = parcelRequire("jGR8u");
    var $cYsCT = parcelRequire("cYsCT");
    var $fHiYa = parcelRequire("fHiYa");
    var $gGtKh = parcelRequire("gGtKh");
    const $6c80d8969b7507dc$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $6c80d8969b7507dc$var$headingSkeleton
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $6c80d8969b7507dc$var$dropdownSkeleton
        }));
    const $6c80d8969b7507dc$var$LazyPageSwitcher = (0, $56koX.lazyForPaint)(()=>(parcelRequire("afgC5")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/common/src/common/ui/page-switcher/main.tsx"
    });
    const $6c80d8969b7507dc$export$3130bd98029942c = (props)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.global-settings.page-switcher",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement($6c80d8969b7507dc$export$8f31e4c4a37b8e9c, null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($6c80d8969b7507dc$var$LazyPageSwitcher, props));
    const $6c80d8969b7507dc$var$headingSkeleton = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        width: '50%',
        height: "var(--ds-space-200, 16px)",
        borderRadius: 'border.radius.100'
    });
    const $6c80d8969b7507dc$var$dropdownSkeleton = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("afgC5", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("793fj")
    ]).then(()=>parcelRequire('8fdHr'));
});
parcelRegister("3z8wI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e9eb69a3778100b7$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    var $e9eb69a3778100b7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
        heading: {
            "id": "navigation-apps-sidebar-nav4-sidebars-settings-global-common.sidebar-content.heading",
            "defaultMessage": "Jira admin settings"
        }
    });
});
parcelRegister("QnfMY", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$d0d5f7370b633018$export$8f31e4c4a37b8e9c);
    var $eUqFw = parcelRequire("eUqFw");
    var $jGR8u = parcelRequire("jGR8u");
    var $cYsCT = parcelRequire("cYsCT");
    var $fHiYa = parcelRequire("fHiYa");
    const $d0d5f7370b633018$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $d0d5f7370b633018$var$sectionHeading
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $d0d5f7370b633018$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $d0d5f7370b633018$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $d0d5f7370b633018$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $d0d5f7370b633018$var$sectionHeading
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $d0d5f7370b633018$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $d0d5f7370b633018$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $d0d5f7370b633018$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $d0d5f7370b633018$var$menuItem
        }));
    const $d0d5f7370b633018$var$sectionHeading = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        width: '50%',
        height: "var(--ds-space-200, 16px)",
        borderRadius: 'border.radius.100',
        marginTop: 'space.100'
    });
    const $d0d5f7370b633018$var$menuItem = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("bvuD3", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("4AXY8")
    ]).then(()=>parcelRequire('7lWnK'));
});
parcelRegister("kmEf6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$476e30e62a087ca9$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $lShkl = parcelRequire("lShkl");
    var $cUHBb = parcelRequire("cUHBb");
    var $QnfMY = parcelRequire("QnfMY");
    var $gGtKh = parcelRequire("gGtKh");
    const $476e30e62a087ca9$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("1wyjN")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/issues/src/ui/main.tsx"
    });
    const $476e30e62a087ca9$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.global-settings.issues-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsIssuesSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cUHBb.SidebarContent), {
            currentPageName: "issues"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.global-settings.issues-settings",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $QnfMY.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($476e30e62a087ca9$var$LazySidebarContent, null))));
    var $476e30e62a087ca9$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($476e30e62a087ca9$var$AsyncSidebar);
});
parcelRegister("1wyjN", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("5BIdK")
    ]).then(()=>parcelRequire('bRuxW'));
});
parcelRegister("4tYWR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f1b95b5088aa97e5$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $lShkl = parcelRequire("lShkl");
    var $cUHBb = parcelRequire("cUHBb");
    var $QnfMY = parcelRequire("QnfMY");
    var $gGtKh = parcelRequire("gGtKh");
    const $f1b95b5088aa97e5$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("lqgcb")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/products/src/ui/main.tsx"
    });
    const $f1b95b5088aa97e5$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.global-settings.products-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProductsSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cUHBb.SidebarContent), {
            currentPageName: "products"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.global-settings.products-settings",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $QnfMY.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($f1b95b5088aa97e5$var$LazySidebarContent, null))));
    var $f1b95b5088aa97e5$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($f1b95b5088aa97e5$var$AsyncSidebar);
});
parcelRegister("lqgcb", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("byhZn")
    ]).then(()=>parcelRequire('5lK5p'));
});
parcelRegister("6WLSW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b2df53e500ae7e1$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $lShkl = parcelRequire("lShkl");
    var $cUHBb = parcelRequire("cUHBb");
    var $QnfMY = parcelRequire("QnfMY");
    var $gGtKh = parcelRequire("gGtKh");
    const $1b2df53e500ae7e1$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("cqRYK")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/projects/src/ui/main.tsx"
    });
    const $1b2df53e500ae7e1$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.global-settings.projects-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsProjectsSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cUHBb.SidebarContent), {
            currentPageName: "projects"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.global-settings.projects-settings",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $QnfMY.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($1b2df53e500ae7e1$var$LazySidebarContent, null))));
    var $1b2df53e500ae7e1$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($1b2df53e500ae7e1$var$AsyncSidebar);
});
parcelRegister("cqRYK", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("1jvGc")
    ]).then(()=>parcelRequire('eQtcl'));
});
parcelRegister("9F5X0", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSystemSettingsConnectItems", ()=>$1144fe1f38e08ee0$export$68950d4e14439158);
    $parcel$export(module.exports, "useGlobalSystemSettingsConnectItemActive", ()=>$1144fe1f38e08ee0$export$5efb701a2106707a);
    var $eUqFw = parcelRequire("eUqFw");
    var $hHbj7 = parcelRequire("hHbj7");
    var $aPhAZ = parcelRequire("aPhAZ");
    var $6nvum = parcelRequire("6nvum");
    var $fcFGd = parcelRequire("fcFGd");
    var $5neED = parcelRequire("5neED");
    var $aoOGZ = parcelRequire("aoOGZ");
    var $lB25E = parcelRequire("lB25E");
    const $1144fe1f38e08ee0$var$getItems = (d)=>(0, $6nvum.getLinks)(d, [
            'admin_system_menu'
        ], {
            skipFilter: true
        }).map((0, $fcFGd.transformLink)).filter(Boolean);
    const $1144fe1f38e08ee0$export$68950d4e14439158 = (0, $hHbj7.withThrowOnError)(()=>{
        const { data: data, loading: loading, error: error } = (0, $5neED.useNavigationGlobalResource)();
        const items = (0, $eUqFw.useMemo)(()=>data && $1144fe1f38e08ee0$var$getItems(data), [
            data
        ]);
        return {
            data: items,
            loading: loading,
            error: error
        };
    });
    const $1144fe1f38e08ee0$export$5efb701a2106707a = ()=>{
        const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
        const { data: data, loading: loading, error: error } = $1144fe1f38e08ee0$export$68950d4e14439158();
        const { data: connectGeneralData, loading: connectGeneralResourceLoading, error: connectGeneralResourceError } = (0, $aoOGZ.useConnectGeneralResource)();
        const isActive = (0, $eUqFw.useMemo)(()=>Boolean(route && data && (0, $aPhAZ.findItemAndStack)(data, route.name, location)?.selected), [
            data,
            route,
            location
        ]);
        return {
            isActive: isActive || connectGeneralData?.moduleType === 'adminPages',
            loading: loading || connectGeneralResourceLoading,
            error: error || connectGeneralResourceError
        };
    };
});
parcelRegister("hHbj7", function(module, exports) {
    $parcel$export(module.exports, "withThrowOnError", ()=>$5c8abedc1df9715b$export$a018832f2ec4dc91);
    var $asu8X = parcelRequire("asu8X");
    const $5c8abedc1df9715b$var$isDataEmpty = (data)=>data == null;
    function $5c8abedc1df9715b$export$a018832f2ec4dc91(theHook) {
        return (...args)=>{
            (0, $asu8X.di)(theHook);
            const result = theHook(...args);
            if (!false && $5c8abedc1df9715b$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
            return result;
        };
    }
});
parcelRegister("92Zmd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e92f2f5982a74b52$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $lShkl = parcelRequire("lShkl");
    var $cUHBb = parcelRequire("cUHBb");
    var $QnfMY = parcelRequire("QnfMY");
    var $gGtKh = parcelRequire("gGtKh");
    const $e92f2f5982a74b52$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("gekP6")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/global/system/src/ui/main.tsx"
    });
    const $e92f2f5982a74b52$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.global-settings.system-settings",
            packageName: "jiraNavigationAppsSidebarNav4GlobalSettingsSystemSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cUHBb.SidebarContent), {
            currentPageName: "system"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.global-settings.system-settings",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $QnfMY.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($e92f2f5982a74b52$var$LazySidebarContent, null))));
    var $e92f2f5982a74b52$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($e92f2f5982a74b52$var$AsyncSidebar);
});
parcelRegister("gekP6", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("ceXlX")
    ]).then(()=>parcelRequire('77EGT'));
});
parcelRegister("jq6Xe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f8d8658113235b9$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $lShkl = parcelRequire("lShkl");
    var $48TMA = parcelRequire("48TMA");
    var $gGtKh = parcelRequire("gGtKh");
    var $cKF63 = parcelRequire("cKF63");
    const $4f8d8658113235b9$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("j8fPs")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/sidebars/settings/help-center/src/ui/main.tsx"
    });
    const $4f8d8658113235b9$var$AsyncSidebar = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.help-center-settings",
            packageName: "jiraNavigationAppsSidebarNav4HelpCenterSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $48TMA.SidebarContainer), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.help-center-settings",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cKF63.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($4f8d8658113235b9$var$LazySidebarContent, null))));
    var $4f8d8658113235b9$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($4f8d8658113235b9$var$AsyncSidebar);
});
parcelRegister("cKF63", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$9c4c2dd87b529409$export$8f31e4c4a37b8e9c);
    var $eUqFw = parcelRequire("eUqFw");
    var $jGR8u = parcelRequire("jGR8u");
    var $6k5Uz = parcelRequire("6k5Uz");
    var $cYsCT = parcelRequire("cYsCT");
    var $fHiYa = parcelRequire("fHiYa");
    const $9c4c2dd87b529409$export$8f31e4c4a37b8e9c = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6k5Uz.default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $9c4c2dd87b529409$var$backButton
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $9c4c2dd87b529409$var$headingSkeleton
        })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cYsCT.default), {
            space: "space.100",
            grow: "hug"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $9c4c2dd87b529409$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $9c4c2dd87b529409$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $9c4c2dd87b529409$var$menuItem
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $9c4c2dd87b529409$var$menuItem
        })));
    const $9c4c2dd87b529409$var$backButton = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100'
    });
    const $9c4c2dd87b529409$var$headingSkeleton = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-300, 24px)",
        borderRadius: 'border.radius.100',
        flex: 1
    });
    const $9c4c2dd87b529409$var$menuItem = (0, $fHiYa.xcss)({
        backgroundColor: 'color.skeleton',
        height: "var(--ds-space-400, 32px)",
        borderRadius: 'border.radius.100'
    });
});
parcelRegister("j8fPs", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("kjPEX")
    ]).then(()=>parcelRequire('dbxzr'));
});
parcelRegister("aPW8a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d04876580b04a5ef$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $lShkl = parcelRequire("lShkl");
    var $lWmpu = parcelRequire("lWmpu");
    var $gGtKh = parcelRequire("gGtKh");
    const $d04876580b04a5ef$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("eHLHT")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/software/company-managed/src/ui/main.tsx"
    });
    const $d04876580b04a5ef$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.project-settings.software.company-managed",
            packageName: "jiraNavigationAppsSidebarNav4SoftwareCompanyManagedProjectSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.project-settings.software.company-managed",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($d04876580b04a5ef$var$LazySidebarContent, {
            project: project
        })));
    var $d04876580b04a5ef$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($d04876580b04a5ef$var$AsyncSidebar);
});
parcelRegister("eHLHT", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("Q7U4x")
    ]).then(()=>parcelRequire('eKUup'));
});
parcelRegister("gBUa5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fcbb7b7d2a385bc0$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $lShkl = parcelRequire("lShkl");
    var $lWmpu = parcelRequire("lWmpu");
    var $gGtKh = parcelRequire("gGtKh");
    const $fcbb7b7d2a385bc0$var$LazySidebarContent = (0, $56koX.lazyForPaint)(()=>(parcelRequire("7m8XZ")), {
        moduleId: "./src/packages/navigation-apps/sidebar-nav4/project-settings/software/team-managed/src/ui/main.tsx"
    });
    const $fcbb7b7d2a385bc0$var$AsyncSidebar = ({ project: project })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lShkl.SidebarBoundary), {
            id: "nav4.sidebar.project-settings.software.team-managed",
            packageName: "jiraNavigationAppsSidebarNav4SoftwareTeamManagedProjectSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav4.sidebar.project-settings.software.team-managed",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lWmpu.Skeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($fcbb7b7d2a385bc0$var$LazySidebarContent, {
            project: project
        })));
    var $fcbb7b7d2a385bc0$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($fcbb7b7d2a385bc0$var$AsyncSidebar);
});
parcelRegister("7m8XZ", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("2XyHk")
    ]).then(()=>parcelRequire('hmJNm'));
});
parcelRegister("4QXXR", function(module, exports) {
    $parcel$export(module.exports, "SidebarSelectorProvider", ()=>$2fdc1a9dd738acc8$export$6af584355cfb32c6);
    var $eUqFw = parcelRequire("eUqFw");
    var $hTLlD = parcelRequire("hTLlD");
    var $7ZZxN = parcelRequire("7ZZxN");
    var $cPEpP = parcelRequire("cPEpP");
    var $7Fu43 = parcelRequire("7Fu43");
    var $497qU = parcelRequire("497qU");
    var $1ykEC = parcelRequire("1ykEC");
    var $jGUct = parcelRequire("jGUct");
    var $hTlnZ = parcelRequire("hTlnZ");
    var $h2JwC = parcelRequire("h2JwC");
    var $fpWGf = parcelRequire("fpWGf");
    var $2RJCt = parcelRequire("2RJCt");
    var $2jFgb = parcelRequire("2jFgb");
    var $buaC1 = parcelRequire("buaC1");
    var $6cIOm = parcelRequire("6cIOm");
    var $jAMQL = parcelRequire("jAMQL");
    var $5w4hM = parcelRequire("5w4hM");
    var $hUM03 = parcelRequire("hUM03");
    var $bt7QT = parcelRequire("bt7QT");
    var $lWODs = parcelRequire("lWODs");
    var $iOOlt = parcelRequire("iOOlt");
    var $29Nmz = parcelRequire("29Nmz");
    var $bSRyW = parcelRequire("bSRyW");
    var $iTYGl = parcelRequire("iTYGl");
    var $2Fzrk = parcelRequire("2Fzrk");
    var $8rBPw = parcelRequire("8rBPw");
    var $aoOGZ = parcelRequire("aoOGZ");
    var $lB25E = parcelRequire("lB25E");
    const $2fdc1a9dd738acc8$var$renderProjectSidebar = ({ data: project, loading: loading })=>{
        if (loading) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), {
            isFull: true
        });
        if (!project) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8rBPw.default), null);
        switch(project.type){
            case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            case 0, $7ZZxN.CUSTOMER_SERVICE_PROJECT:
                return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iTYGl.default), null);
            case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
                return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $bSRyW.default), null);
            case 0, $7ZZxN.SOFTWARE_PROJECT:
                if (project.isSimplified) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iOOlt.default), null);
                return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $2Fzrk.default), null);
            case 0, $7ZZxN.CORE_PROJECT:
                return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $buaC1.default), null);
            default:
                return null;
        }
    };
    const $2fdc1a9dd738acc8$var$ProjectSidebar = (0, $eUqFw.memo)($2fdc1a9dd738acc8$var$renderProjectSidebar, (0, ($parcel$interopDefault($hTLlD))));
    const $2fdc1a9dd738acc8$export$6af584355cfb32c6 = ({ sidebar: sidebar, children: children })=>{
        const projectState = (0, $cPEpP.useProject)();
        const isInsightMenuSelected = (0, $h2JwC.useInsight)();
        const shouldRenderInsightObjectSchemaSidebar = (0, $h2JwC.useInsightObjectSchemaSidebar)();
        const { selected: pSelected, loading: pLoading } = (0, $2jFgb.useProjectConnectItems)();
        const { selected: prSelected, loading: prLoading } = (0, $fpWGf.useProjectReportsConnectItems)();
        const { selected: psSelected, loading: psLoading } = (0, $2RJCt.useProjectSettingsConnectItems)();
        const { selected: gSelected, loading: gLoading } = (0, $hTlnZ.useGlobalConnectItems)();
        const { selected: gsSelected, loading: gsLoading } = (0, $jGUct.useGlobalSettingsConnectItems)();
        const { selected: gssSelected, loading: gssLoading } = (0, $1ykEC.useGlobalSettingsSystemConnectItems)();
        const { data: gresData, loading: gresLoading } = (0, $lB25E.useResource)((0, $aoOGZ.connectGeneralResources));
        const { sections: fgSections, loading: fgLoading } = (0, $jAMQL.useForgeGlobalPageItems)();
        if (shouldRenderInsightObjectSchemaSidebar) return children((0, ($parcel$interopDefault($eUqFw))).createElement((0, $lWODs.default), null));
        if (isInsightMenuSelected) return null;
        if (sidebar === (0, $29Nmz.default)) return children((0, ($parcel$interopDefault($eUqFw))).createElement((0, $29Nmz.default), null));
        if (sidebar === (0, $6cIOm.default)) {
            if (fgLoading) return children((0, ($parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), {
                isFull: true
            }));
            if (fgSections?.length) return children((0, ($parcel$interopDefault($eUqFw))).createElement((0, $6cIOm.default), null));
            return children(null);
        }
        if (!Array.isArray(sidebar)) {
            const Sidebar = sidebar;
            return children(Sidebar != null ? (0, ($parcel$interopDefault($eUqFw))).createElement(Sidebar, null) : null);
        }
        if (sidebar === (0, $5w4hM.genericConnectSidebars)) {
            const foundInProject = pSelected || prSelected || psSelected || [
                'jiraProjectAdminTabPanels'
            ].includes(gresData?.moduleType);
            const foundSomewhere = foundInProject || gSelected || gsSelected || gssSelected;
            const stillLoading = pLoading || prLoading || psLoading || gLoading || gsLoading || gssLoading || gresLoading;
            if (stillLoading && !foundSomewhere) return children((0, ($parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), {
                isFull: true
            }));
            if (foundInProject) {
                const projectSidebar = (0, ($parcel$interopDefault($eUqFw))).createElement($2fdc1a9dd738acc8$var$ProjectSidebar, projectState);
                return children(projectSidebar);
            }
            if (gSelected) return children((0, ($parcel$interopDefault($eUqFw))).createElement((0, $497qU.default), null));
            if (gsSelected || [
                'configurePage',
                'postInstallPage'
            ].includes(gresData?.moduleType)) return children((0, ($parcel$interopDefault($eUqFw))).createElement((0, $hUM03.default), null));
            if (gssSelected || [
                'adminPages'
            ].includes(gresData?.moduleType)) return children((0, ($parcel$interopDefault($eUqFw))).createElement((0, $bt7QT.default), null));
            return children(null);
        }
        const projectSidebar = (0, ($parcel$interopDefault($eUqFw))).createElement($2fdc1a9dd738acc8$var$ProjectSidebar, projectState);
        return children(projectSidebar);
    };
});
parcelRegister("7Fu43", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$64b74158f6952660$export$8f31e4c4a37b8e9c);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $bNimE = parcelRequire("bNimE");
    var $l85cb = parcelRequire("l85cb");
    var $i4dIm = parcelRequire("i4dIm");
    const $64b74158f6952660$export$8f31e4c4a37b8e9c = ({ isFull: isFull = false })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $i4dIm.default), {
            name: "sidebar-skeleton"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($64b74158f6952660$var$BackgroundedWrapper, null, isFull && (0, ($parcel$interopDefault($eUqFw))).createElement($64b74158f6952660$var$HeadingWrapper, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $l85cb.default), {
            hasIcon: true
        })), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $bNimE.default), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $l85cb.default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $l85cb.default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $l85cb.default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $l85cb.default), {
            hasIcon: isFull
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $l85cb.default), {
            hasIcon: isFull
        }))));
    const $64b74158f6952660$var$BackgroundedWrapper = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_4t3i1tem _1yt4s5g3",
                __cmplp.className
            ])
        });
    });
    const $64b74158f6952660$var$HeadingWrapper = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($eUqFw))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_1yt41k9c",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bNimE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d029afacfb59429$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $7wSSY = parcelRequire("7wSSY");
    var $d0ETh = parcelRequire("d0ETh");
    var $3qoTC = parcelRequire("3qoTC");
    const $7d029afacfb59429$var$Section = (0, $eUqFw.forwardRef)((props, ref)=>{
        const { shouldRender: shouldRender } = (0, $3qoTC.useShouldNestedElementRender)();
        if (!shouldRender) return props.children;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7wSSY.default), {
            ...props,
            ref: ref,
            overrides: {
                HeadingItem: {
                    cssFn: (0, $d0ETh.sectionHeaderSpacingStyles)
                }
            }
        });
    });
    var $7d029afacfb59429$export$2e2bcd8739ae039 = $7d029afacfb59429$var$Section;
});
parcelRegister("d0ETh", function(module, exports) {
    $parcel$export(module.exports, "overrideStyleFunction", ()=>$d7041ed6bcedcaf2$export$505cedac1a39aacf);
    $parcel$export(module.exports, "baseSideNavItemStyle", ()=>$d7041ed6bcedcaf2$export$aed216a85ec468ac);
    $parcel$export(module.exports, "sectionHeaderSpacingStyles", ()=>$d7041ed6bcedcaf2$export$a5c27bed78cfecb9);
    const $d7041ed6bcedcaf2$export$505cedac1a39aacf = (baseStyle, newStyle = ()=>({}))=>{
        return (state)=>{
            return [
                baseStyle(state),
                newStyle(state)
            ];
        };
    };
    const $d7041ed6bcedcaf2$var$defaultStyles = {
        '&:hover': {
            color: `var(--ds-text-subtle, ${(0, $207acf722dcd432b$export$c39c0fe0f26207ae)})`,
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $207acf722dcd432b$export$3e51e8f1440314ba)})`
        },
        '&:active': {
            color: `var(--ds-text-subtle, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`,
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $207acf722dcd432b$export$226de0355ed012f8)})`
        }
    };
    const $d7041ed6bcedcaf2$var$selectedStyles = {
        backgroundColor: `var(--ds-background-selected, ${(0, $207acf722dcd432b$export$3e51e8f1440314ba)})`,
        color: `var(--ds-text-selected, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`,
        ':visited': {
            color: `var(--ds-text-selected, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $207acf722dcd432b$export$3e51e8f1440314ba)})`,
            color: `var(--ds-text-selected, ${(0, $207acf722dcd432b$export$c39c0fe0f26207ae)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $207acf722dcd432b$export$226de0355ed012f8)})`,
            color: `var(--ds-text-selected, ${(0, $207acf722dcd432b$export$b3de0ae08da2ce64)})`
        }
    };
    const $d7041ed6bcedcaf2$export$aed216a85ec468ac = ({ isSelected: isSelected, isDisabled: isDisabled })=>{
        return {
            paddingBlock: "var(--ds-space-100, 8px)",
            paddingInline: "var(--ds-space-100, 8px)",
            borderRadius: "var(--ds-border-radius, 3px)",
            backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
            ...!isDisabled && !isSelected && $d7041ed6bcedcaf2$var$defaultStyles,
            ...!isDisabled && isSelected && $d7041ed6bcedcaf2$var$selectedStyles,
            ['& [data-item-elem-before]']: {
                height: '1.5rem',
                width: '1.5rem'
            }
        };
    };
    const $d7041ed6bcedcaf2$export$a5c27bed78cfecb9 = ()=>{
        return {
            paddingInline: "var(--ds-space-100, 8px)"
        };
    };
});
parcelRegister("l85cb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ce4b095dd3a968e$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $4MFrg = parcelRequire("4MFrg");
    var $d0ETh = parcelRequire("d0ETh");
    var $3qoTC = parcelRequire("3qoTC");
    const $7ce4b095dd3a968e$var$SkeletonItem = (props)=>{
        const { shouldRender: shouldRender } = (0, $3qoTC.useShouldNestedElementRender)();
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4MFrg.default), {
            cssFn: ()=>({
                    ...(0, $d0ETh.sectionHeaderSpacingStyles)(),
                    '&&::before': {
                        height: '1.5rem',
                        marginRight: "var(--ds-space-200, 16px)",
                        width: '1.5rem'
                    }
                }),
            ...props
        });
    };
    var $7ce4b095dd3a968e$export$2e2bcd8739ae039 = $7ce4b095dd3a968e$var$SkeletonItem;
});
parcelRegister("497qU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$113f60a6a5bc48c3$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $9RvDp = parcelRequire("9RvDp");
    var $av9ef = parcelRequire("av9ef");
    const $113f60a6a5bc48c3$var$LazyConnectSidebar = (0, $56koX.lazyAfterPaint)(()=>{
        (0, $av9ef.setPerformanceMarkLoadStart)();
        return (parcelRequire("20902")).then((bundle)=>{
            (0, $av9ef.setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/connect/src/index.tsx"
    });
    const $113f60a6a5bc48c3$var$ConnectSidebar = (0, $eUqFw.memo)(()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
            id: "connect"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($113f60a6a5bc48c3$var$LazyConnectSidebar, null)));
    $113f60a6a5bc48c3$var$ConnectSidebar.displayName = 'ConnectSidebar';
    var $113f60a6a5bc48c3$export$2e2bcd8739ae039 = $113f60a6a5bc48c3$var$ConnectSidebar;
});
parcelRegister("9RvDp", function(module, exports) {
    $parcel$export(module.exports, "SidebarBoundary", ()=>$a0579ef23379c6d1$export$1edc778464f08256);
    var $eUqFw = parcelRequire("eUqFw");
    var $8fxTv = parcelRequire("8fxTv");
    var $7webZ = parcelRequire("7webZ");
    var $gGtKh = parcelRequire("gGtKh");
    var $4C6RK = parcelRequire("4C6RK");
    var $u0mbR = parcelRequire("u0mbR");
    var $7Fu43 = parcelRequire("7Fu43");
    const $a0579ef23379c6d1$export$1edc778464f08256 = ({ children: children, id: id })=>{
        const onFail = (0, $u0mbR.useSidebarFail)();
        const onSuccess = (0, $u0mbR.useSidebarSuccess)();
        const onError = (0, $eUqFw.useCallback)((location, error)=>{
            const { statusCode: statusCode } = error;
            if (statusCode != null && statusCode >= 400 && statusCode < 500) onSuccess();
            else onFail(location, error);
        }, [
            onFail,
            onSuccess
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4C6RK.SidebarErrorBoundary), {
            id: id,
            packageName: "jiraSpaAppsSidebarCommon",
            onError: onError
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarPerformanceMark), {
            metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderAttempt
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavSidebarSSRPerformanceMark), {
            metricKey: (0, $7webZ.NAVIGATION_SIDEBAR_MARKS).renderSsrStart
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nav-sidebar",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7Fu43.Skeleton), {
                isFull: true
            })
        }, children));
    };
});
parcelRegister("4C6RK", function(module, exports) {
    $parcel$export(module.exports, "SidebarErrorBoundary", ()=>$5b97a95fb0135b37$export$62853c5766dad0c4);
    var $eUqFw = parcelRequire("eUqFw");
    var $0cdA8 = parcelRequire("0cdA8");
    var $keguF = parcelRequire("keguF");
    var $gq8Ge = parcelRequire("gq8Ge");
    const $5b97a95fb0135b37$export$62853c5766dad0c4 = (props)=>{
        const userLocation = (0, $keguF.getUserLocation)();
        const extraEventData = (0, $eUqFw.useMemo)(()=>({
                ...props.extraEventData,
                userLocation: userLocation
            }), [
            props.extraEventData,
            userLocation
        ]);
        const fallback = (0, $eUqFw.useCallback)(({ error: error })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $gq8Ge.Fallback), {
                error: error
            }), []);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            ...props,
            extraEventData: extraEventData,
            fallback: fallback
        });
    };
});
parcelRegister("gq8Ge", function(module, exports) {
    $parcel$export(module.exports, "Fallback", ()=>$ca78cb141c4c2211$export$fb8d7f40caaeea67);
    var $7JEyt = parcelRequire("7JEyt");
    var $eUqFw = parcelRequire("eUqFw");
    var $ld5Wr = parcelRequire("ld5Wr");
    var $iH6c1 = parcelRequire("iH6c1");
    var $5JgJ2 = parcelRequire("5JgJ2");
    var $4EIGo = parcelRequire("4EIGo");
    var $gnvfi = parcelRequire("gnvfi");
    const $ca78cb141c4c2211$var$styles = {
        wrapper: "_bfhk1jdc _syaz1mjl _1yt4pxbi _y3gn1h6o _4cvr1h6o _zulpu2gc _1e0c1txw _2lx21bp4",
        error: "_2rko9j3y _1wybqk37 _syaz131l _bfhk1v33 _ca0qv77o _n3tdv77o _19bv1b66 _u5f31b66",
        image: "_4t3i12am"
    };
    const $ca78cb141c4c2211$export$fb8d7f40caaeea67 = (props)=>{
        const { error: error } = props;
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $7JEyt.default)([
                $ca78cb141c4c2211$var$styles.wrapper
            ])
        }, (0, ($parcel$interopDefault($eUqFw))).createElement("img", {
            alt: "",
            src: (0, ($parcel$interopDefault($4EIGo))),
            className: (0, $7JEyt.default)([
                $ca78cb141c4c2211$var$styles.image
            ])
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ld5Wr.default), {
            size: "xsmall"
        }, formatMessage((0, $gnvfi.default).errorHeading)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $gnvfi.default).errorBody)), (0, ($parcel$interopDefault($eUqFw))).createElement("code", {
            className: (0, $7JEyt.default)([
                $ca78cb141c4c2211$var$styles.error
            ])
        }, "ERROR: ", (0, $iH6c1.getErrorHash)(error)));
    };
});
parcelRegister("4EIGo", function(module, exports) {
    module.exports = new URL("generic-error.76ff7c6a.svg", import.meta.url).toString();
});
parcelRegister("gnvfi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$525f5b24291fe557$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    var $525f5b24291fe557$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
        errorHeading: {
            "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-heading",
            "defaultMessage": "Something went wrong"
        },
        errorBody: {
            "id": "spa-apps-sidebar-common.common.error-boundary.fallback.error-body",
            "defaultMessage": "Try refreshing or navigating to another page."
        }
    });
});
parcelRegister("av9ef", function(module, exports) {
    $parcel$export(module.exports, "setPerformanceMarkLoadStart", ()=>$f6954eb5e712c16f$export$4166241bf9111f66);
    $parcel$export(module.exports, "setPerformanceMarkLoadEnd", ()=>$f6954eb5e712c16f$export$edbd543f308bbef5);
    var $8fxTv = parcelRequire("8fxTv");
    var $7webZ = parcelRequire("7webZ");
    const $f6954eb5e712c16f$export$4166241bf9111f66 = ()=>{
        const sideBarSegment = (0, $8fxTv.pageSegmentStore).getSegment((0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME));
        sideBarSegment.mark((0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadStart);
    };
    const $f6954eb5e712c16f$export$edbd543f308bbef5 = ()=>{
        const sideBarSegment = (0, $8fxTv.pageSegmentStore).getSegment((0, $7webZ.NAVIGATION_SIDEBAR_SEGMENT_NAME));
        sideBarSegment.mark((0, $7webZ.NAVIGATION_SIDEBAR_MARKS).loadEnd);
    };
});
parcelRegister("20902", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("8ciKp")
    ]).then(()=>parcelRequire('jSzUd'));
});
parcelRegister("1ykEC", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", ()=>$9751bf35bdfd526e$export$f601efaceb0636f4);
    var $eUqFw = parcelRequire("eUqFw");
    var $5iWql = parcelRequire("5iWql");
    var $2z5XU = parcelRequire("2z5XU");
    var $lB25E = parcelRequire("lB25E");
    var $9I91h = parcelRequire("9I91h");
    var $g9Ou9 = parcelRequire("g9Ou9");
    var $kNXHh = parcelRequire("kNXHh");
    const $9751bf35bdfd526e$var$getItemsMemo = (0, $5iWql.default)((d)=>(0, $g9Ou9.getLinks)(d, [
            'admin_system_menu'
        ], {
            skipFilter: true
        }).map((0, $kNXHh.transformLink)).filter(Boolean));
    const $9751bf35bdfd526e$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
    const $9751bf35bdfd526e$export$f601efaceb0636f4 = ()=>{
        const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
        const { data: data, loading: loading, error: error } = (0, $2z5XU.useNavigationGlobalResource)();
        const items = (0, $eUqFw.useMemo)(()=>data && $9751bf35bdfd526e$var$getItemsMemo(data), [
            data
        ]);
        const found = (0, $eUqFw.useMemo)(()=>route && items && $9751bf35bdfd526e$var$findItemAndStackMemo(items, route.name, location), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("2z5XU", function(module, exports) {
    $parcel$export(module.exports, "useNavigationGlobalResource", ()=>$c76604c890e3e940$export$1e1c317ed5b99faa);
    var $eUqFw = parcelRequire("eUqFw");
    var $9CFDS = parcelRequire("9CFDS");
    var $lB25E = parcelRequire("lB25E");
    const $c76604c890e3e940$export$1e1c317ed5b99faa = ()=>{
        const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)((0, $9CFDS.navigationSidebarGlobalResource));
        const response = (0, $eUqFw.useMemo)(()=>data && data.response, [
            data
        ]);
        return {
            data: response,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("9I91h", function(module, exports) {
    $parcel$export(module.exports, "findItemAndStack", ()=>$d193dad52b41fe54$export$751e2e6237002565);
    var $hTLlD = parcelRequire("hTLlD");
    var $elGVw = parcelRequire("elGVw");
    const $d193dad52b41fe54$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
    const $d193dad52b41fe54$var$isSameQuery = (locationQuery, itemQuery)=>(0, ($parcel$interopDefault($hTLlD)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, ($parcel$interopDefault($hTLlD)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
    const $d193dad52b41fe54$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
        let found = null;
        if (!(0, $elGVw.CONNECT_ROUTES_SET).has(routeName)) return found;
        const locationQuery = $d193dad52b41fe54$var$splitRelevantQs(location.search);
        items.some((item)=>{
            const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
            const itemQuery = $d193dad52b41fe54$var$splitRelevantQs(itemQs);
            const sameQuery = $d193dad52b41fe54$var$isSameQuery(locationQuery, itemQuery);
            if (item.section !== true && itemPath === location.pathname && sameQuery) {
                found = {
                    stack: parentStack,
                    selected: item
                };
                return true;
            }
            if (item.items) {
                const stack = item.section === true ? parentStack : parentStack.concat(item.id);
                found = $d193dad52b41fe54$export$751e2e6237002565(item.items, routeName, location, stack);
            }
            return Boolean(found);
        });
        return found;
    };
});
parcelRegister("g9Ou9", function(module, exports) {
    $parcel$export(module.exports, "getLinks", ()=>$bab768b8bde7a570$export$8054dcb2b42da45c);
    var $lDq4g = parcelRequire("lDq4g");
    var $WYbts = parcelRequire("WYbts");
    const $bab768b8bde7a570$export$8054dcb2b42da45c = (sidebarConfig, locations, { skipFilter: skipFilter, omitSections: omitSections } = {})=>{
        const acc = [];
        locations.forEach((location)=>{
            const links = (0, $lDq4g.getLinksFromSidebar)(sidebarConfig, location);
            if (omitSections === true) {
                Array.prototype.push.apply(acc, links.flatMap((item)=>item && item.section === true ? item.links || [] : item));
                return;
            }
            Array.prototype.push.apply(acc, links);
        });
        return acc.filter((item)=>{
            if (!item) return false;
            if (skipFilter === true) return true;
            const hasConnectPrefix = item.id && item.id.includes((0, $WYbts.connectPrefix));
            if (hasConnectPrefix) return true;
            const isConnectSection = (0, $WYbts.connectSections).includes(item.id);
            if (isConnectSection) return true;
            const isJsdConnectSection = item.id && item.id.includes((0, $WYbts.jsdConnectPrefix));
            if (isJsdConnectSection) return true;
            return false;
        });
    };
});
parcelRegister("lDq4g", function(module, exports) {
    $parcel$export(module.exports, "hasItemInSidebar", ()=>$7cfca2f550cf53a3$export$57dd40eec4c64521);
    $parcel$export(module.exports, "getLinksFromSidebar", ()=>$7cfca2f550cf53a3$export$9b7e0e4dd8bfade8);
    const $7cfca2f550cf53a3$var$findLink = (arrayOfLinks, legacyId, partialMatch = false)=>{
        if (!Array.isArray(arrayOfLinks)) return undefined;
        for(let i = 0; i < arrayOfLinks.length; i += 1){
            const link = arrayOfLinks[i];
            if (partialMatch && link.id.indexOf(legacyId) === 0) return link;
            if (link.id === legacyId) return link;
            if (link.links) {
                const linkFound = $7cfca2f550cf53a3$var$findLink(link.links, legacyId, partialMatch);
                if (linkFound) return linkFound;
            }
        }
        return undefined;
    };
    const $7cfca2f550cf53a3$export$f62346e9b1894488 = (sidebarConfig, legacyId, partialMatch = false)=>sidebarConfig && sidebarConfig.product && $7cfca2f550cf53a3$var$findLink(sidebarConfig.product.links, legacyId, partialMatch) || undefined;
    const $7cfca2f550cf53a3$export$57dd40eec4c64521 = (sidebarConfig, legacyId, partialMatch)=>Boolean($7cfca2f550cf53a3$export$f62346e9b1894488(sidebarConfig, legacyId, partialMatch));
    const $7cfca2f550cf53a3$var$findChildLinks = (arrayOfLinks, legacyId)=>arrayOfLinks && arrayOfLinks.map((item)=>{
            if (item.id === legacyId) return item.links;
            return item.links && $7cfca2f550cf53a3$var$findChildLinks(item.links, legacyId);
        }).find(Boolean);
    const $7cfca2f550cf53a3$export$9b7e0e4dd8bfade8 = (sidebarConfig, legacyId)=>{
        const links = legacyId != null ? $7cfca2f550cf53a3$var$findChildLinks(sidebarConfig.product && sidebarConfig.product.links, legacyId) : sidebarConfig.product && sidebarConfig.product.links;
        return links || [];
    };
});
parcelRegister("WYbts", function(module, exports) {
    $parcel$export(module.exports, "connectPrefix", ()=>$43407c27ba6284fa$export$196d83ebd873fb40);
    $parcel$export(module.exports, "jsdConnectPrefix", ()=>$43407c27ba6284fa$export$7fac8f726f52d70);
    $parcel$export(module.exports, "connectSections", ()=>$43407c27ba6284fa$export$b1c2c1fc5d10280);
    var $bgNoL = parcelRequire("bgNoL");
    const $43407c27ba6284fa$export$196d83ebd873fb40 = 'com.atlassian.plugins.atlassian-connect-plugin:';
    const $43407c27ba6284fa$export$7fac8f726f52d70 = 'com.atlassian.servicedesk.connect';
    const $43407c27ba6284fa$var$legacyAddonPanelLinkId = 'com.atlassian.jira.jira-projects-plugin:tab-panel-link-parent';
    const $43407c27ba6284fa$var$jsdQueuesConnectSection = 'sd-queues-addons';
    const $43407c27ba6284fa$export$b1c2c1fc5d10280 = [
        $43407c27ba6284fa$var$legacyAddonPanelLinkId,
        (0, $bgNoL.REPORTS_IDS).REPORTS_ADDONS,
        $43407c27ba6284fa$var$jsdQueuesConnectSection
    ];
});
parcelRegister("kNXHh", function(module, exports) {
    $parcel$export(module.exports, "transformLink", ()=>$2d642e9f9a6a4f93$export$5a32dc366b1d641f);
    $parcel$export(module.exports, "transformLinkV4", ()=>$2d642e9f9a6a4f93$export$27267b6b6650eaa5);
    const $2d642e9f9a6a4f93$export$5a32dc366b1d641f = (link)=>{
        const items = link.links && link.links.length ? link.links.map($2d642e9f9a6a4f93$export$5a32dc366b1d641f).filter(Boolean) : undefined;
        if (link.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(link.name)
            };
            return {
                id: link.id,
                name: String(link.name),
                section: !!link.section,
                items: items
            };
        }
        return {
            id: link.id,
            name: String(link.name),
            url: link.url,
            iconUrl: link.iconUrl || '',
            styleClass: link.styleClass || '',
            items: items
        };
    };
    const $2d642e9f9a6a4f93$export$27267b6b6650eaa5 = (data)=>{
        const items = data.links && data.links.length ? data.links.map($2d642e9f9a6a4f93$export$27267b6b6650eaa5).filter(Boolean) : undefined;
        if (data.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(data.name)
            };
            return {
                id: data.id,
                name: String(data.name),
                section: !!data.section,
                items: items
            };
        }
        return {
            id: data.id,
            name: String(data.name),
            url: data.url,
            iconUrl: data.iconUrl || '',
            styleClass: data.styleClass || '',
            items: items
        };
    };
});
parcelRegister("jGUct", function(module, exports) {
    $parcel$export(module.exports, "useGlobalSettingsConnectItems", ()=>$6494416747689c30$export$f0785b98c99d344c);
    var $eUqFw = parcelRequire("eUqFw");
    var $5iWql = parcelRequire("5iWql");
    var $2z5XU = parcelRequire("2z5XU");
    var $lB25E = parcelRequire("lB25E");
    var $9I91h = parcelRequire("9I91h");
    var $g9Ou9 = parcelRequire("g9Ou9");
    var $kNXHh = parcelRequire("kNXHh");
    const $6494416747689c30$var$getItemsMemo = (0, $5iWql.default)((d)=>(0, $g9Ou9.getLinks)(d, [
            'admin_plugins_menu'
        ], {
            skipFilter: true
        }).filter((v)=>![
                'upm_section',
                'jpo-ws-admin'
            ].includes(v.id)).map((0, $kNXHh.transformLink)).filter(Boolean));
    const $6494416747689c30$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
    const $6494416747689c30$export$f0785b98c99d344c = ()=>{
        const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
        const { data: data, loading: loading, error: error } = (0, $2z5XU.useNavigationGlobalResource)();
        const items = (0, $eUqFw.useMemo)(()=>data && $6494416747689c30$var$getItemsMemo(data), [
            data
        ]);
        const found = (0, $eUqFw.useMemo)(()=>route && items && $6494416747689c30$var$findItemAndStackMemo(items, route.name, location), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("hTlnZ", function(module, exports) {
    $parcel$export(module.exports, "useGlobalConnectItems", ()=>$c8e671af8fdbb6ce$export$ee355b2e42d6462b);
    var $eUqFw = parcelRequire("eUqFw");
    var $5iWql = parcelRequire("5iWql");
    var $2z5XU = parcelRequire("2z5XU");
    var $lB25E = parcelRequire("lB25E");
    var $9I91h = parcelRequire("9I91h");
    var $g9Ou9 = parcelRequire("g9Ou9");
    var $kNXHh = parcelRequire("kNXHh");
    const $c8e671af8fdbb6ce$var$getItemsMemo = (0, $5iWql.default)((d)=>(0, $g9Ou9.getLinks)(d, [
            'global-navigation-product'
        ]).map((0, $kNXHh.transformLink)).filter((item)=>item != null && item.items));
    const $c8e671af8fdbb6ce$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
    const $c8e671af8fdbb6ce$export$ee355b2e42d6462b = ()=>{
        const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
        const { data: data, loading: loading, error: error } = (0, $2z5XU.useNavigationGlobalResource)();
        const sidebars = (0, $eUqFw.useMemo)(()=>data && $c8e671af8fdbb6ce$var$getItemsMemo(data), [
            data
        ]);
        const searchResult = (0, $eUqFw.useMemo)(()=>{
            let result = {
                stack: [],
                selected: null,
                title: null,
                data: null
            };
            if (sidebars != null) sidebars.some((sidebar)=>{
                const { items: items } = sidebar || {};
                if (!sidebar || !route || items == null) return false;
                const found = $c8e671af8fdbb6ce$var$findItemAndStackMemo(items, route.name, location);
                if (found) {
                    result = {
                        ...found,
                        title: sidebar.name,
                        data: items
                    };
                    return true;
                }
                return false;
            });
            return result;
        }, [
            sidebars,
            route,
            location
        ]);
        return {
            ...searchResult,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("h2JwC", function(module, exports) {
    $parcel$export(module.exports, "useInsight", ()=>$051bcb4b32f93938$export$e24dad0705701755);
    $parcel$export(module.exports, "useInsightObjectSchemaSidebar", ()=>$051bcb4b32f93938$export$1f0bd21403710fc);
    var $6FP8W = parcelRequire("6FP8W");
    var $10fdS = parcelRequire("10fdS");
    const $051bcb4b32f93938$export$e24dad0705701755 = ()=>{
        const route = (0, $10fdS.useCurrentRoute)();
        if (route.navigation) return route.navigation.menuId === 'INSIGHT';
        return false;
    };
    const $051bcb4b32f93938$export$1f0bd21403710fc = ()=>{
        const route = (0, $10fdS.useCurrentRoute)();
        if ((0, $6FP8W.getWillShowNav4)()) return false;
        return route.name === 'servicedesk-cmdb-object-schema';
    };
});
parcelRegister("fpWGf", function(module, exports) {
    $parcel$export(module.exports, "useProjectReportsConnectItems", ()=>$45778cdd51b28ac7$export$a1c75c386c088992);
    var $eUqFw = parcelRequire("eUqFw");
    var $5iWql = parcelRequire("5iWql");
    var $2futN = parcelRequire("2futN");
    var $lB25E = parcelRequire("lB25E");
    var $9I91h = parcelRequire("9I91h");
    var $kNXHh = parcelRequire("kNXHh");
    const $45778cdd51b28ac7$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
    const $45778cdd51b28ac7$export$a1c75c386c088992 = ()=>{
        const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
        const { data: data, loading: loading, error: error } = (0, $2futN.useProjectReportsSidebarConnectNavigation)();
        const items = (0, $eUqFw.useMemo)(()=>data != null ? data.map((0, $kNXHh.transformLinkV4)).filter(Boolean) : [], [
            data
        ]);
        const found = (0, $eUqFw.useMemo)(()=>route && items && $45778cdd51b28ac7$var$findItemAndStackMemo(items, route.name, location, [
                'reports'
            ]), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            error: error,
            loading: loading,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("2RJCt", function(module, exports) {
    $parcel$export(module.exports, "useProjectSettingsConnectItems", ()=>$06b43f573ecea160$export$41a50100db18b578);
    var $eUqFw = parcelRequire("eUqFw");
    var $5iWql = parcelRequire("5iWql");
    var $2futN = parcelRequire("2futN");
    var $lB25E = parcelRequire("lB25E");
    var $9I91h = parcelRequire("9I91h");
    var $kNXHh = parcelRequire("kNXHh");
    const $06b43f573ecea160$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
    const $06b43f573ecea160$export$41a50100db18b578 = ()=>{
        const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
        const { data: data, loading: loading, error: error } = (0, $2futN.useProjectSettingsSidebarConnectNavigation)();
        const items = (0, $eUqFw.useMemo)(()=>data && data.map((0, $kNXHh.transformLinkV4)).filter(Boolean), [
            data
        ]);
        const found = (0, $eUqFw.useMemo)(()=>route && items && $06b43f573ecea160$var$findItemAndStackMemo(items, route.name, location, [
                'settings'
            ]), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("2jFgb", function(module, exports) {
    $parcel$export(module.exports, "useProjectConnectItems", ()=>$5f83aec5eda9bdea$export$f23d0c24c77d7608);
    var $eUqFw = parcelRequire("eUqFw");
    var $5iWql = parcelRequire("5iWql");
    var $2futN = parcelRequire("2futN");
    var $lB25E = parcelRequire("lB25E");
    var $9I91h = parcelRequire("9I91h");
    var $kNXHh = parcelRequire("kNXHh");
    const $5f83aec5eda9bdea$var$findItemAndStackMemo = (0, $5iWql.default)((0, $9I91h.findItemAndStack));
    const $5f83aec5eda9bdea$export$f23d0c24c77d7608 = ()=>{
        const [{ route: route, location: location }] = (0, $lB25E.useRouter)();
        const { data: data, loading: loading, error: error } = (0, $2futN.useProjectSidebarConnectNavigation)();
        const items = (0, $eUqFw.useMemo)(()=>data && data.map((0, $kNXHh.transformLinkV4)).filter(Boolean), [
            data
        ]);
        const found = (0, $eUqFw.useMemo)(()=>route && items && $5f83aec5eda9bdea$var$findItemAndStackMemo(items, route.name, location), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("buaC1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c95c2ed1c1661f63$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $9RvDp = parcelRequire("9RvDp");
    var $av9ef = parcelRequire("av9ef");
    var $56koX = parcelRequire("56koX");
    const $c95c2ed1c1661f63$var$LazyCoreProjectSidebar = (0, $56koX.lazyForPaint)(()=>{
        (0, $av9ef.setPerformanceMarkLoadStart)();
        return (parcelRequire("2U012")).then((bundle)=>{
            (0, $av9ef.setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/business/navigation/sidebar/src/ui/index.tsx"
    });
    const $c95c2ed1c1661f63$var$CoreProjectSidebar = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
            id: "coreProject"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($c95c2ed1c1661f63$var$LazyCoreProjectSidebar, null));
    var $c95c2ed1c1661f63$export$2e2bcd8739ae039 = (0, $eUqFw.memo)($c95c2ed1c1661f63$var$CoreProjectSidebar);
});
parcelRegister("2U012", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("eNmuD"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("kAEGG")
    ]).then(()=>parcelRequire('9urUx'));
});
parcelRegister("6cIOm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffa0ed116b82264e$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $9RvDp = parcelRequire("9RvDp");
    var $av9ef = parcelRequire("av9ef");
    const $ffa0ed116b82264e$var$LazyForPaintForgeGlobalPageSidebar = (0, $56koX.lazyForPaint)(()=>{
        (0, $av9ef.setPerformanceMarkLoadStart)();
        return (parcelRequire("lCHrb")).then((bundle)=>{
            (0, $av9ef.setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/forge-global-page/src/index.tsx"
    });
    const $ffa0ed116b82264e$var$ForgeGlobalPageSidebar = (0, $eUqFw.memo)(()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
            id: "forgeGlobalPage"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($ffa0ed116b82264e$var$LazyForPaintForgeGlobalPageSidebar, null)));
    $ffa0ed116b82264e$var$ForgeGlobalPageSidebar.displayName = 'ForgeGlobalPageSidebar';
    var $ffa0ed116b82264e$export$2e2bcd8739ae039 = $ffa0ed116b82264e$var$ForgeGlobalPageSidebar;
});
parcelRegister("lCHrb", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("jeOcw")
    ]).then(()=>parcelRequire('hBhU1'));
});
parcelRegister("jAMQL", function(module, exports) {
    $parcel$export(module.exports, "useForgeGlobalPageItems", ()=>$9f797773fe916c88$export$ff333fd2f0bf5254);
    var $eUqFw = parcelRequire("eUqFw");
    var $k9Roh = parcelRequire("k9Roh");
    var $jMYeN = parcelRequire("jMYeN");
    var $eOutC = parcelRequire("eOutC");
    var $lB25E = parcelRequire("lB25E");
    const $9f797773fe916c88$export$ff333fd2f0bf5254 = ()=>{
        const [{ match: match }] = (0, $lB25E.useRouter)();
        const { data: modules, loading: loading, error: error } = (0, $k9Roh.useGlobalForgeApps)();
        const extension = (0, $eOutC.useMatchedExtension)({
            modules: modules,
            match: match
        });
        const sections = (0, $eUqFw.useMemo)(()=>extension && (0, $jMYeN.toSections)(extension), [
            extension
        ]);
        return {
            extension: extension,
            sections: sections,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("k9Roh", function(module, exports) {
    $parcel$export(module.exports, "getItemHref", ()=>$9b956edc956601cb$export$ed6342e0e28465a6);
    $parcel$export(module.exports, "useGlobalForgeApps", ()=>$9b956edc956601cb$export$f834c14187f80532);
    var $eUqFw = parcelRequire("eUqFw");
    var $8LJqN = parcelRequire("8LJqN");
    var $eI5EY = parcelRequire("eI5EY");
    var $70ON1 = parcelRequire("70ON1");
    var $fTsDx = parcelRequire("fTsDx");
    var $l90Gp = parcelRequire("l90Gp");
    var $lB25E = parcelRequire("lB25E");
    const $9b956edc956601cb$export$ed6342e0e28465a6 = (extension)=>{
        const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
        return `/jira/apps/${appId}/${envId}`;
    };
    const $9b956edc956601cb$var$useGlobalForgeAppsV1 = ()=>{
        const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)((0, $l90Gp.forgeGlobalModuleV1Resource));
        const globalPageData = (0, $eUqFw.useMemo)(()=>data?.extensions || null, [
            data
        ]);
        return (0, $eUqFw.useMemo)(()=>({
                data: globalPageData ? globalPageData.filter((extension)=>(0, $fTsDx.doesExtensionMeetConditions)(extension, {})) : null,
                loading: loading,
                error: error
            }), [
            globalPageData,
            loading,
            error
        ]);
    };
    const $9b956edc956601cb$var$useGlobalForgeAppsV2 = ()=>(0, $lB25E.useResource)((0, $l90Gp.forgeGlobalModuleV2Resource));
    const $9b956edc956601cb$export$f834c14187f80532 = (0, $8LJqN.functionWithCondition)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $9b956edc956601cb$var$useGlobalForgeAppsV2, $9b956edc956601cb$var$useGlobalForgeAppsV1);
});
parcelRegister("70ON1", function(module, exports) {
    $parcel$export(module.exports, "parseExtensionId", ()=>$46692d02f47d8a1d$export$bae42cbaf7fa3e1b);
    $parcel$export(module.exports, "getSameEnvAppIdFromExtensionId", ()=>$46692d02f47d8a1d$export$a92b17288693d366);
    const $46692d02f47d8a1d$export$bae42cbaf7fa3e1b = (extensionId)=>{
        const [, appId, envId] = extensionId.split('/');
        return {
            appId: appId,
            envId: envId
        };
    };
    const $46692d02f47d8a1d$export$a92b17288693d366 = (extensionId)=>extensionId.split('/').slice(1, 3).join('/');
});
parcelRegister("fTsDx", function(module, exports) {
    $parcel$export(module.exports, "useDoesExtensionMeetConditions", ()=>$f49523f1e6c1d89f$export$642911220fb6609f);
    $parcel$export(module.exports, "doesExtensionMeetConditions", ()=>$f49523f1e6c1d89f$export$b1e4ed7044e85aa3);
    var $eUqFw = parcelRequire("eUqFw");
    var $iPaeE = parcelRequire("iPaeE");
    var $e91YZ = parcelRequire("e91YZ");
    var $fz8wa = parcelRequire("fz8wa");
    var $gd0Sp = parcelRequire("gd0Sp");
    const $f49523f1e6c1d89f$export$642911220fb6609f = ()=>{
        const { isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
        const { hasCoreAccess: hasCoreAccess, hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceManagementAccess } = (0, $fz8wa.useApplicationPermissions)();
        return (0, $eUqFw.useCallback)((extension, extraContext)=>{
            const { displayConditions: displayConditions } = extension.properties;
            if (displayConditions == null) return true;
            const context = {
                ...extraContext,
                isAdmin: isAdmin,
                isLoggedIn: !isAnonymous,
                isSiteAdmin: isSiteAdmin,
                hasCoreAccess: hasCoreAccess,
                hasServiceManagementAccess: hasServiceManagementAccess,
                hasSoftwareAccess: hasSoftwareAccess
            };
            return (0, $iPaeE.doesMeetConditions)(displayConditions, context);
        }, [
            hasCoreAccess,
            hasServiceManagementAccess,
            hasSoftwareAccess,
            isAdmin,
            isAnonymous,
            isSiteAdmin
        ]);
    };
    const $f49523f1e6c1d89f$export$b1e4ed7044e85aa3 = (extension, extraContext)=>{
        const { displayConditions: displayConditions } = extension.properties;
        const { appPermissions: { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess }, isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        const context = {
            ...extraContext,
            isAdmin: isAdmin,
            isLoggedIn: !isAnonymous,
            isSiteAdmin: isSiteAdmin,
            hasSoftwareAccess: hasSoftwareAccess,
            hasServiceManagementAccess: hasServiceDeskAccess,
            hasCoreAccess: hasCoreAccess
        };
        return displayConditions ? (0, $iPaeE.doesMeetConditions)(displayConditions, context) : true;
    };
});
parcelRegister("l90Gp", function(module, exports) {
    $parcel$export(module.exports, "forgeAdminModuleV1Resource", ()=>$a5dfafe975dbf279$export$168ac1f97221e90b);
    $parcel$export(module.exports, "forgeAdminModuleV2Resource", ()=>$a5dfafe975dbf279$export$536a08360f048bac);
    $parcel$export(module.exports, "getNavigationSidebarGlobalSettingsResources", ()=>$a5dfafe975dbf279$export$dcc98f4b36ce9223);
    $parcel$export(module.exports, "forgeProjectModuleV1Resource", ()=>$a5dfafe975dbf279$export$ad95e2d07d6fa1a);
    $parcel$export(module.exports, "forgeProjectModuleV2Resource", ()=>$a5dfafe975dbf279$export$1a17680eb0746291);
    $parcel$export(module.exports, "forgeProjectModuleResource", ()=>$a5dfafe975dbf279$export$72db683c2914a65e);
    $parcel$export(module.exports, "forgeProjectSettingsModuleV1Resource", ()=>$a5dfafe975dbf279$export$fa67d109c2a45864);
    $parcel$export(module.exports, "forgeProjectSettingsModuleV2Resource", ()=>$a5dfafe975dbf279$export$23c2bb87c561c9db);
    $parcel$export(module.exports, "forgeProjectSettingsModuleResource", ()=>$a5dfafe975dbf279$export$7a928d209faf75f);
    $parcel$export(module.exports, "useForgeProjectSettingsModuleResource", ()=>$a5dfafe975dbf279$export$e81e11bbc3239153);
    $parcel$export(module.exports, "forgeGlobalModuleV1Resource", ()=>$a5dfafe975dbf279$export$60e774d0427b56fc);
    $parcel$export(module.exports, "forgeGlobalModuleV2Resource", ()=>$a5dfafe975dbf279$export$75f594fe5ce76af);
    $parcel$export(module.exports, "getNavigationForgeGlobalPageResources", ()=>$a5dfafe975dbf279$export$80b2f91dabb3dd65);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleV1Resource", ()=>$a5dfafe975dbf279$export$b555dc3ff28ae9cc);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleV2Resource", ()=>$a5dfafe975dbf279$export$d2d6bc2f3bd0f942);
    $parcel$export(module.exports, "forgeServiceDeskQueueModuleResource", ()=>$a5dfafe975dbf279$export$ebf5369e4dcfad00);
    $parcel$export(module.exports, "forgeCustomFieldTypeResource", ()=>$a5dfafe975dbf279$export$e6be2f0ca0849869);
    var $h1xZf = parcelRequire("h1xZf");
    var $eI5EY = parcelRequire("eI5EY");
    var $2Rqjr = parcelRequire("2Rqjr");
    var $hsX10 = parcelRequire("hsX10");
    var $cSfWg = parcelRequire("cSfWg");
    var $8hg3R = parcelRequire("8hg3R");
    var $jwzNs = parcelRequire("jwzNs");
    var $lB25E = parcelRequire("lB25E");
    var $fSEqj = parcelRequire("fSEqj");
    var $iLkoO = parcelRequire("iLkoO");
    const $a5dfafe975dbf279$export$eb46cc3d7c1a6649 = (params, moduleName)=>{
        const isModuleWithAccessNarrowing = [
            (0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE),
            (0, $2Rqjr.PROJECT_PAGE_MODULE),
            (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
        ].includes(moduleName);
        const projectIdOrKey = (0, $8hg3R.getProjectKeyOrId)(params);
        if (typeof projectIdOrKey === 'string' && projectIdOrKey !== '' && isModuleWithAccessNarrowing) return {
            projectIdOrKey: projectIdOrKey
        };
        return null;
    };
    const $a5dfafe975dbf279$var$createDataGetter = (moduleName, shouldReturnANExtensions = false, createContextIds)=>(route, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>{
            const { match: params } = route;
            const dataClassification = $a5dfafe975dbf279$export$eb46cc3d7c1a6649(params, moduleName);
            const contextIds = typeof createContextIds === 'function' && createContextIds({
                cloudId: cloudId,
                activationId: activationId
            }) || undefined;
            return (0, $fSEqj.fetchForgeModule)({
                cloudId: cloudId,
                moduleName: moduleName,
                dataClassification: dataClassification,
                shouldReturnANExtensions: shouldReturnANExtensions,
                contextIds: contextIds,
                locale: locale
            });
        };
    const $a5dfafe975dbf279$var$createContextIds = ({ cloudId: cloudId, activationId: activationId })=>[
            `ari:cloud:jira:${cloudId}:workspace/${activationId}`
        ];
    const $a5dfafe975dbf279$export$168ac1f97221e90b = (0, $lB25E.createResource)({
        type: 'FORGE_ADMIN_MODULE',
        getKey: ()=>'extensions',
        getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.ADMIN_PAGE_MODULE), false, $a5dfafe975dbf279$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $a5dfafe975dbf279$export$536a08360f048bac = (0, $lB25E.createResource)({
        type: 'FORGE_ADMIN_MODULE',
        getKey: ()=>'extensions',
        getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, $cSfWg.fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, $2Rqjr.ADMIN_PAGE_MODULE)
                ],
                context: {},
                includeHidden: false,
                source: (0, $2Rqjr.SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$a5dfafe975dbf279$var$normalizeModules(modules[0, $2Rqjr.ADMIN_PAGE_MODULE], (0, $iLkoO.adminPageFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $a5dfafe975dbf279$var$forgeAdminModuleResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $a5dfafe975dbf279$export$536a08360f048bac, $a5dfafe975dbf279$export$168ac1f97221e90b);
    const $a5dfafe975dbf279$export$dcc98f4b36ce9223 = ()=>[
            $a5dfafe975dbf279$var$forgeAdminModuleResource
        ];
    const $a5dfafe975dbf279$export$ad95e2d07d6fa1a = (0, $lB25E.createResource)({
        type: 'FORGE_PROJECT_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.PROJECT_PAGE_MODULE), true, $a5dfafe975dbf279$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $a5dfafe975dbf279$export$1a17680eb0746291 = (0, $lB25E.createResource)({
        type: 'FORGE_PROJECT_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, $cSfWg.fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, $2Rqjr.PROJECT_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, $8hg3R.getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, $2Rqjr.SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$a5dfafe975dbf279$var$normalizeModules(modules[0, $2Rqjr.PROJECT_PAGE_MODULE], (0, $iLkoO.uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $a5dfafe975dbf279$export$72db683c2914a65e = (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $a5dfafe975dbf279$export$1a17680eb0746291, $a5dfafe975dbf279$export$ad95e2d07d6fa1a);
    const $a5dfafe975dbf279$export$fa67d109c2a45864 = (0, $lB25E.createResource)({
        type: 'FORGE_PROJECT_SETTINGS_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE), true, $a5dfafe975dbf279$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $a5dfafe975dbf279$export$23c2bb87c561c9db = (0, $lB25E.createResource)({
        type: 'FORGE_PROJECT_SETTINGS_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, $cSfWg.fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, $8hg3R.getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, $2Rqjr.SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$a5dfafe975dbf279$var$normalizeModules(modules[0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE], (0, $iLkoO.uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $a5dfafe975dbf279$export$7a928d209faf75f = (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $a5dfafe975dbf279$export$23c2bb87c561c9db, $a5dfafe975dbf279$export$fa67d109c2a45864);
    const $a5dfafe975dbf279$export$e81e11bbc3239153 = ()=>(0, $lB25E.useResource)($a5dfafe975dbf279$export$7a928d209faf75f);
    const $a5dfafe975dbf279$export$60e774d0427b56fc = (0, $lB25E.createResource)({
        type: 'FORGE_GLOBAL_MODULE',
        getKey: ()=>'extensions',
        getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.GLOBAL_PAGE_MODULE), false, $a5dfafe975dbf279$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $a5dfafe975dbf279$export$75f594fe5ce76af = (0, $lB25E.createResource)({
        type: 'FORGE_GLOBAL_MODULE',
        getKey: ()=>'extensions',
        getData: (_, { tenantContext: { cloudId: cloudId } })=>(0, $cSfWg.fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, $2Rqjr.GLOBAL_PAGE_MODULE)
                ],
                context: {},
                includeHidden: false,
                source: (0, $2Rqjr.SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$a5dfafe975dbf279$var$normalizeModules(modules[0, $2Rqjr.GLOBAL_PAGE_MODULE], (0, $iLkoO.uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $a5dfafe975dbf279$var$forgeGlobalModuleResource = (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $a5dfafe975dbf279$export$75f594fe5ce76af, $a5dfafe975dbf279$export$60e774d0427b56fc);
    const $a5dfafe975dbf279$export$80b2f91dabb3dd65 = ()=>[
            $a5dfafe975dbf279$var$forgeGlobalModuleResource
        ];
    const $a5dfafe975dbf279$export$b555dc3ff28ae9cc = (0, $lB25E.createResource)({
        type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: $a5dfafe975dbf279$var$createDataGetter((0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE), true, $a5dfafe975dbf279$var$createContextIds),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $a5dfafe975dbf279$export$d2d6bc2f3bd0f942 = (0, $lB25E.createResource)({
        type: 'FORGE_SERVICEDESK_QUEUE_MODULE',
        getKey: (routeContext)=>{
            const projectKeyOrId = (0, $8hg3R.getProjectKeyOrId)(routeContext.match);
            return `extensions-${projectKeyOrId}`;
        },
        getData: (routeContext, { tenantContext: { cloudId: cloudId } })=>(0, $cSfWg.fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE)
                ],
                context: {
                    projectKey: (0, $8hg3R.getProjectKeyOrId)(routeContext.match)
                },
                includeHidden: true,
                source: (0, $2Rqjr.SOURCE_FULL_PAGE_APP)
            }).then((modules)=>$a5dfafe975dbf279$var$normalizeModules(modules[0, $2Rqjr.SERVICEDESK_QUEUE_PAGE_MODULE], (0, $iLkoO.uniqueExtensionsFilter))),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    const $a5dfafe975dbf279$export$ebf5369e4dcfad00 = (0, $jwzNs.resourceWithCondition2)(()=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules'), $a5dfafe975dbf279$export$d2d6bc2f3bd0f942, $a5dfafe975dbf279$export$b555dc3ff28ae9cc);
    const $a5dfafe975dbf279$export$e6be2f0ca0849869 = (0, $lB25E.createResource)({
        type: 'FORGE_CUSTOM_FIELD_TYPE_MODULE',
        getKey: ()=>'extensions',
        getData: (_route, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>(0, $eI5EY.fg)('new_graphql_endpoint_for_fetching_forge_modules') ? (0, $cSfWg.fetchModules)({
                cloudId: cloudId,
                types: [
                    (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE)
                ],
                context: {},
                includeHidden: false,
                source: (0, $2Rqjr.SOURCE_NAVIGATION)
            }).then((modules)=>modules[0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE]) : (0, $hsX10.default)(cloudId, [
                (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE)
            ], null, undefined, (0, $2Rqjr.SOURCE_NAVIGATION), $a5dfafe975dbf279$var$createContextIds({
                cloudId: cloudId,
                activationId: activationId
            }), locale).then((modules)=>modules.extensions.jiraCustomFieldType),
        maxAge: Number.MAX_SAFE_INTEGER
    });
    function $a5dfafe975dbf279$var$normalizeModules(modules, filter) {
        return filter(modules).sort((a, b)=>(0, $h1xZf.alphabeticalSort)(a.properties.title, b.properties.title));
    }
});
parcelRegister("h1xZf", function(module, exports) {
    $parcel$export(module.exports, "alphabeticalSort", ()=>$cb5adf4a5b6d2436$export$89a1f01f2a7cb2a1);
    var $gUUjF = parcelRequire("gUUjF");
    const $cb5adf4a5b6d2436$export$89a1f01f2a7cb2a1 = (a, b)=>{
        if (a && b && a.localeCompare && b.localeCompare) return a.localeCompare(b, 'en', {
            numeric: true,
            caseFirst: 'upper'
        });
        const typeOfA = a === null ? 'null' : typeof a;
        const typeOfB = b === null ? 'null' : typeof b;
        const error = new Error(`type of a: ${typeOfA}. type of b: ${typeOfB}`);
        (0, $gUUjF.default).safeErrorWithoutCustomerData('software.board.filter', 'localeCompare is not a function', error);
        return 1;
    };
});
parcelRegister("2Rqjr", function(module, exports) {
    $parcel$export(module.exports, "STAGING_ENVIRONMENT", ()=>$24e2ca1817bcdc8d$export$71acbd662c478c42);
    $parcel$export(module.exports, "DEVELOPMENT_ENVIRONMENT", ()=>$24e2ca1817bcdc8d$export$978072fd3fd149);
    $parcel$export(module.exports, "DEFAULT_ENVIRONMENT_KEY", ()=>$24e2ca1817bcdc8d$export$ebc15d9cebfd6063);
    $parcel$export(module.exports, "ISSUE_ACTION_MODULE", ()=>$24e2ca1817bcdc8d$export$fcc4a18f46f80f16);
    $parcel$export(module.exports, "ISSUE_GLANCE_MODULE", ()=>$24e2ca1817bcdc8d$export$259bab989b0129d0);
    $parcel$export(module.exports, "ISSUE_CONTEXT_MODULE", ()=>$24e2ca1817bcdc8d$export$75f224942f595e13);
    $parcel$export(module.exports, "ISSUE_PANEL_MODULE", ()=>$24e2ca1817bcdc8d$export$ba0968f9752844);
    $parcel$export(module.exports, "ISSUE_ACTIVITY_MODULE", ()=>$24e2ca1817bcdc8d$export$cc20a5638825fbb0);
    $parcel$export(module.exports, "ISSUE_VIEW_BACKGROUND_SCRIPT_MODULE", ()=>$24e2ca1817bcdc8d$export$9069d4b945c3d532);
    $parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", ()=>$24e2ca1817bcdc8d$export$811b7f067a43b422);
    $parcel$export(module.exports, "CUSTOM_FIELD_MODULE", ()=>$24e2ca1817bcdc8d$export$e3887d6bafe8a17);
    $parcel$export(module.exports, "CUSTOM_FIELD_TYPE_MODULE", ()=>$24e2ca1817bcdc8d$export$7b7866c04a2ad947);
    $parcel$export(module.exports, "ADMIN_PAGE_MODULE", ()=>$24e2ca1817bcdc8d$export$52e4945e96bd2aa0);
    $parcel$export(module.exports, "PROJECT_PAGE_MODULE", ()=>$24e2ca1817bcdc8d$export$151b03356f566603);
    $parcel$export(module.exports, "PROJECT_SETTINGS_PAGE_MODULE", ()=>$24e2ca1817bcdc8d$export$ea0d6ac082b0d636);
    $parcel$export(module.exports, "GLOBAL_PAGE_MODULE", ()=>$24e2ca1817bcdc8d$export$31ac745ab2add7cc);
    $parcel$export(module.exports, "DASHBOARD_BACKGROUND_SCRIPT_MODULE", ()=>$24e2ca1817bcdc8d$export$353acf28daa75c79);
    $parcel$export(module.exports, "DASHBOARD_GADGET_MODULE", ()=>$24e2ca1817bcdc8d$export$25627f012b21b0b9);
    $parcel$export(module.exports, "WORKFLOW_VALIDATOR_MODULE", ()=>$24e2ca1817bcdc8d$export$42d6a8740fd42e58);
    $parcel$export(module.exports, "WORKFLOW_CONDITION_MODULE", ()=>$24e2ca1817bcdc8d$export$a7186e5a73395db4);
    $parcel$export(module.exports, "WORKFLOW_POST_FUNCTION_MODULE", ()=>$24e2ca1817bcdc8d$export$8fbcfe84dc845d17);
    $parcel$export(module.exports, "SERVICEDESK_QUEUE_PAGE_MODULE", ()=>$24e2ca1817bcdc8d$export$8af4cb794979f60d);
    $parcel$export(module.exports, "SERVICEDESK_ORGANIZATION_PANEL_MODULE", ()=>$24e2ca1817bcdc8d$export$5592ab836d562168);
    $parcel$export(module.exports, "SERVICEDESK_ASSETS_IMPORT_TYPE_MODULE", ()=>$24e2ca1817bcdc8d$export$842eb4236828ac9);
    $parcel$export(module.exports, "SUPPORTED_MODULES", ()=>$24e2ca1817bcdc8d$export$9b1a91242ce2a1b7);
    $parcel$export(module.exports, "ENTRY_POINT_EDIT", ()=>$24e2ca1817bcdc8d$export$2b8aeda236486576);
    $parcel$export(module.exports, "ENTRY_POINT_VIEW", ()=>$24e2ca1817bcdc8d$export$c41ce1ec1ea6e73d);
    $parcel$export(module.exports, "ENTRY_POINT_CREATE", ()=>$24e2ca1817bcdc8d$export$b37d58c3ed77c139);
    $parcel$export(module.exports, "ENTRY_POINT_CONTEXT_CONFIG", ()=>$24e2ca1817bcdc8d$export$ab94dbd1d02ac251);
    $parcel$export(module.exports, "NONE_PANEL_INSTANCE_ID", ()=>$24e2ca1817bcdc8d$export$b6a67a3131c6c48d);
    $parcel$export(module.exports, "ISSUE_PANEL_MULTIPLE_LIMIT", ()=>$24e2ca1817bcdc8d$export$b75dc2bfd20898fe);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_NATIVE", ()=>$24e2ca1817bcdc8d$export$8e96118a698216cb);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_BASIC", ()=>$24e2ca1817bcdc8d$export$9b72a8e9b92658fb);
    $parcel$export(module.exports, "FULL_PAGE_LAYOUT_BLANK", ()=>$24e2ca1817bcdc8d$export$2d6539e7d0553ae7);
    $parcel$export(module.exports, "SOURCE_UNKNOWN", ()=>$24e2ca1817bcdc8d$export$ecbd7135d66cb322);
    $parcel$export(module.exports, "SOURCE_GLOBAL_ISSUE_CREATE", ()=>$24e2ca1817bcdc8d$export$61d882aa7aba51c);
    $parcel$export(module.exports, "SOURCE_ISSUE_VIEW", ()=>$24e2ca1817bcdc8d$export$46cb92762d68a048);
    $parcel$export(module.exports, "SOURCE_NAVIGATION", ()=>$24e2ca1817bcdc8d$export$fe90e46aea58e30b);
    $parcel$export(module.exports, "SOURCE_FULL_PAGE_APP", ()=>$24e2ca1817bcdc8d$export$c5ccbdb9893f2a6a);
    $parcel$export(module.exports, "SOURCE_ROUTER", ()=>$24e2ca1817bcdc8d$export$eae46a3c13473a8d);
    $parcel$export(module.exports, "SOURCE_LEGACY", ()=>$24e2ca1817bcdc8d$export$ac11ee191d09688f);
    $parcel$export(module.exports, "SOURCE_ORGANIZATION_PANEL", ()=>$24e2ca1817bcdc8d$export$4346e4e240c84319);
    $parcel$export(module.exports, "SOURCE_ASSETS_IMPORT_TYPE", ()=>$24e2ca1817bcdc8d$export$d719bb340dc354e4);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JIRA", ()=>$24e2ca1817bcdc8d$export$4b6228758e800433);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_JSM", ()=>$24e2ca1817bcdc8d$export$70495c8cc141a7a4);
    $parcel$export(module.exports, "CONTEXT_TOKEN_TYPE_CMDB", ()=>$24e2ca1817bcdc8d$export$bc3d408418fdf9d2);
    $parcel$export(module.exports, "getEmptyExtensionsObject", ()=>$24e2ca1817bcdc8d$export$218a328f66b86f7d);
    $parcel$export(module.exports, "FORGE_FIELD_TYPE_PREFIX", ()=>$24e2ca1817bcdc8d$export$3193d714ab54ee26);
    $parcel$export(module.exports, "PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX", ()=>$24e2ca1817bcdc8d$export$df7774a415710cce);
    $parcel$export(module.exports, "LEGACY_FORGE_FIELD_TYPE_PREFIX", ()=>$24e2ca1817bcdc8d$export$51ab2784839ce348);
    const $24e2ca1817bcdc8d$export$9af0088c49bdedb = 'PRODUCTION';
    const $24e2ca1817bcdc8d$export$71acbd662c478c42 = 'STAGING';
    const $24e2ca1817bcdc8d$export$978072fd3fd149 = 'DEVELOPMENT';
    const $24e2ca1817bcdc8d$export$ebc15d9cebfd6063 = 'default';
    const $24e2ca1817bcdc8d$export$fcc4a18f46f80f16 = 'jira:issueAction';
    const $24e2ca1817bcdc8d$export$259bab989b0129d0 = 'jira:issueGlance';
    const $24e2ca1817bcdc8d$export$75f224942f595e13 = 'jira:issueContext';
    const $24e2ca1817bcdc8d$export$ba0968f9752844 = 'jira:issuePanel';
    const $24e2ca1817bcdc8d$export$cc20a5638825fbb0 = 'jira:issueActivity';
    const $24e2ca1817bcdc8d$export$9069d4b945c3d532 = 'jira:issueViewBackgroundScript';
    const $24e2ca1817bcdc8d$export$811b7f067a43b422 = 'jira:uiModifications';
    const $24e2ca1817bcdc8d$export$e3887d6bafe8a17 = 'jira:customField';
    const $24e2ca1817bcdc8d$export$7b7866c04a2ad947 = 'jira:customFieldType';
    const $24e2ca1817bcdc8d$export$52e4945e96bd2aa0 = 'jira:adminPage';
    const $24e2ca1817bcdc8d$export$151b03356f566603 = 'jira:projectPage';
    const $24e2ca1817bcdc8d$export$ea0d6ac082b0d636 = 'jira:projectSettingsPage';
    const $24e2ca1817bcdc8d$export$31ac745ab2add7cc = 'jira:globalPage';
    const $24e2ca1817bcdc8d$export$353acf28daa75c79 = 'jira:dashboardBackgroundScript';
    const $24e2ca1817bcdc8d$export$25627f012b21b0b9 = 'jira:dashboardGadget';
    const $24e2ca1817bcdc8d$export$42d6a8740fd42e58 = 'jira:workflowValidator';
    const $24e2ca1817bcdc8d$export$a7186e5a73395db4 = 'jira:workflowCondition';
    const $24e2ca1817bcdc8d$export$8fbcfe84dc845d17 = 'jira:workflowPostFunction';
    const $24e2ca1817bcdc8d$export$8af4cb794979f60d = 'jiraServiceManagement:queuePage';
    const $24e2ca1817bcdc8d$export$5592ab836d562168 = 'jiraServiceManagement:organizationPanel';
    const $24e2ca1817bcdc8d$export$842eb4236828ac9 = 'jiraServiceManagement:assetsImportType';
    const $24e2ca1817bcdc8d$export$9b1a91242ce2a1b7 = [
        $24e2ca1817bcdc8d$export$fcc4a18f46f80f16,
        $24e2ca1817bcdc8d$export$259bab989b0129d0,
        $24e2ca1817bcdc8d$export$75f224942f595e13,
        $24e2ca1817bcdc8d$export$ba0968f9752844,
        $24e2ca1817bcdc8d$export$cc20a5638825fbb0,
        $24e2ca1817bcdc8d$export$9069d4b945c3d532,
        $24e2ca1817bcdc8d$export$811b7f067a43b422,
        $24e2ca1817bcdc8d$export$e3887d6bafe8a17,
        $24e2ca1817bcdc8d$export$7b7866c04a2ad947,
        $24e2ca1817bcdc8d$export$52e4945e96bd2aa0,
        $24e2ca1817bcdc8d$export$151b03356f566603,
        $24e2ca1817bcdc8d$export$ea0d6ac082b0d636,
        $24e2ca1817bcdc8d$export$31ac745ab2add7cc,
        $24e2ca1817bcdc8d$export$353acf28daa75c79,
        $24e2ca1817bcdc8d$export$25627f012b21b0b9,
        $24e2ca1817bcdc8d$export$8af4cb794979f60d,
        $24e2ca1817bcdc8d$export$5592ab836d562168,
        $24e2ca1817bcdc8d$export$842eb4236828ac9,
        $24e2ca1817bcdc8d$export$42d6a8740fd42e58,
        $24e2ca1817bcdc8d$export$a7186e5a73395db4,
        $24e2ca1817bcdc8d$export$8fbcfe84dc845d17
    ];
    const $24e2ca1817bcdc8d$export$2b8aeda236486576 = 'edit';
    const $24e2ca1817bcdc8d$export$c41ce1ec1ea6e73d = 'view';
    const $24e2ca1817bcdc8d$export$b37d58c3ed77c139 = 'create';
    const $24e2ca1817bcdc8d$export$ab94dbd1d02ac251 = 'contextConfig';
    const $24e2ca1817bcdc8d$export$b6a67a3131c6c48d = 'none';
    const $24e2ca1817bcdc8d$export$b75dc2bfd20898fe = 5;
    const $24e2ca1817bcdc8d$export$8e96118a698216cb = 'native';
    const $24e2ca1817bcdc8d$export$9b72a8e9b92658fb = 'basic';
    const $24e2ca1817bcdc8d$export$2d6539e7d0553ae7 = 'blank';
    const $24e2ca1817bcdc8d$export$ecbd7135d66cb322 = 'unknownSource';
    const $24e2ca1817bcdc8d$export$61d882aa7aba51c = 'global-issue-create';
    const $24e2ca1817bcdc8d$export$46cb92762d68a048 = 'issue-view';
    const $24e2ca1817bcdc8d$export$fe90e46aea58e30b = 'navigation';
    const $24e2ca1817bcdc8d$export$c5ccbdb9893f2a6a = 'full-page-app';
    const $24e2ca1817bcdc8d$export$eae46a3c13473a8d = 'router';
    const $24e2ca1817bcdc8d$export$ac11ee191d09688f = 'legacy';
    const $24e2ca1817bcdc8d$export$6d00582aa947900f = 'workflow-list';
    const $24e2ca1817bcdc8d$export$4346e4e240c84319 = 'organization-panel';
    const $24e2ca1817bcdc8d$export$d719bb340dc354e4 = 'assets-import-type';
    const $24e2ca1817bcdc8d$export$bf75cf7720bd8fde = 'transition-view';
    const $24e2ca1817bcdc8d$export$4b6228758e800433 = 'jira';
    const $24e2ca1817bcdc8d$export$70495c8cc141a7a4 = 'jsm';
    const $24e2ca1817bcdc8d$export$bc3d408418fdf9d2 = 'cmdb';
    const $24e2ca1817bcdc8d$export$a48dade1864725a = {
        jiraIssueAction: [],
        jiraIssueContext: [],
        jiraIssueGlance: [],
        jiraIssuePanel: [],
        jiraIssueActivity: [],
        jiraIssueViewBackgroundScript: [],
        jiraCustomField: [],
        jiraCustomFieldType: [],
        jiraUiModifications: [],
        jiraAdminPage: [],
        jiraGlobalPage: [],
        jiraProjectPage: [],
        jiraProjectSettingsPage: [],
        jiraDashboardBackgroundScript: [],
        jiraDashboardGadget: [],
        jiraServiceManagementQueuePage: [],
        jiraServiceManagementOrganizationPanel: [],
        jiraServiceManagementAssetsImportType: [],
        jiraWorkflowValidator: [],
        jiraWorkflowCondition: [],
        jiraWorkflowPostFunction: []
    };
    const $24e2ca1817bcdc8d$var$STABLE_EMPTY_EXTENSIONS_OBJECT = {
        ...$24e2ca1817bcdc8d$export$a48dade1864725a
    };
    const $24e2ca1817bcdc8d$export$218a328f66b86f7d = ()=>({
            ...$24e2ca1817bcdc8d$var$STABLE_EMPTY_EXTENSIONS_OBJECT
        });
    const $24e2ca1817bcdc8d$export$3193d714ab54ee26 = 'ari:cloud:ecosystem::extension/';
    const $24e2ca1817bcdc8d$export$df7774a415710cce = 'com.atlassian.forge:';
    const $24e2ca1817bcdc8d$export$51ab2784839ce348 = `${$24e2ca1817bcdc8d$export$df7774a415710cce}${$24e2ca1817bcdc8d$export$3193d714ab54ee26}`;
});
parcelRegister("hsX10", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df5bab9bca496d0a$export$2e2bcd8739ae039);
    var $jh2R9 = parcelRequire("jh2R9");
    var $fcWBJ = parcelRequire("fcWBJ");
    var $cnRoI = parcelRequire("cnRoI");
    var $2vzCR = parcelRequire("2vzCR");
    var $eI5EY = parcelRequire("eI5EY");
    var $lRmyA = parcelRequire("lRmyA");
    var $eTZsp = parcelRequire("eTZsp");
    var $cHWHh = parcelRequire("cHWHh");
    var $hRcYT = parcelRequire("hRcYT");
    var $ibWQr = parcelRequire("ibWQr");
    var $2Rqjr = parcelRequire("2Rqjr");
    var $2NB1f = parcelRequire("2NB1f");
    var $02sMi = parcelRequire("02sMi");
    var $iD9au = parcelRequire("iD9au");
    var $c10S5 = parcelRequire("c10S5");
    var $dkvex = parcelRequire("dkvex");
    var $8ZBIo = parcelRequire("8ZBIo");
    const $df5bab9bca496d0a$var$moduleToVariableKey = (module)=>(0, ($parcel$interopDefault($jh2R9)))(module);
    const $df5bab9bca496d0a$export$3361e9be8093ddcc = (extensions)=>{
        const groupedExtensions = (0, ($parcel$interopDefault($fcWBJ)))(extensions, 'type');
        const groupedExtensionsWithMappedKeys = (0, ($parcel$interopDefault($cnRoI)))(groupedExtensions, (_, key)=>$df5bab9bca496d0a$var$moduleToVariableKey(key));
        return (0, ($parcel$interopDefault($2vzCR)))(groupedExtensionsWithMappedKeys, (0, $2Rqjr.getEmptyExtensionsObject)());
    };
    const $df5bab9bca496d0a$export$44097e02a91cd11a = (extensions)=>{
        const groupedExtensions = (0, ($parcel$interopDefault($fcWBJ)))(extensions, 'type');
        const groupedExtensionsWithMappedKeys = (0, ($parcel$interopDefault($2vzCR)))((0, ($parcel$interopDefault($cnRoI)))(groupedExtensions, (_, key)=>$df5bab9bca496d0a$var$moduleToVariableKey(key)), (0, $2Rqjr.getEmptyExtensionsObject)());
        const filteredOutDuplicatedExtensions = (0, $02sMi.filterOutDuplicatedExtensions)(groupedExtensionsWithMappedKeys);
        const allowedExtensions = (0, $2Rqjr.getEmptyExtensionsObject)();
        const accessNarrowedExtensions = (0, $2Rqjr.getEmptyExtensionsObject)();
        Object.entries(filteredOutDuplicatedExtensions).forEach(([key, module])=>{
            const allowedExtensionsMap = new Map();
            const accessNarrowedExtensionsMap = new Map();
            module.forEach((moduleItem)=>{
                if (moduleItem?.dataClassificationPolicyDecision?.status === 'BLOCKED') accessNarrowedExtensionsMap.set(moduleItem.id, moduleItem);
                else allowedExtensionsMap.set(moduleItem.id, moduleItem);
            });
            allowedExtensions[key] = [
                ...allowedExtensionsMap.values()
            ];
            accessNarrowedExtensions[key] = [
                ...accessNarrowedExtensionsMap.values()
            ];
        });
        return {
            extensions: allowedExtensions,
            accessNarrowedExtensions: accessNarrowedExtensions
        };
    };
    const $df5bab9bca496d0a$var$EXCLUDED_ERROR_TYPES = [
        (0, $eTZsp.FAILED_TO_FETCH),
        (0, $eTZsp.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
        (0, $eTZsp.DATA_CLASSIFICATION_NO_ACCESS)
    ];
    const $df5bab9bca496d0a$var$fetchModulesWithTraceId = async (cloudId, modules, dataClassification, extras, contextIds, source, locale)=>{
        if (modules.length === 0) throw new Error('No modules to fetch provided');
        const dataClassificationTags = await (0, $iD9au.getDataClassification)(dataClassification, source);
        const includeConfig = extras?.include || {};
        const query = (0, $8ZBIo.buildForgeQuery)(includeConfig);
        const variables = {
            contextIds: contextIds || [
                `ari:cloud:jira::site/${cloudId}`
            ],
            extensionsFilter: [
                {
                    type: 'EXTENSION_TYPE',
                    value: modules
                }
            ],
            dataClassificationTags: dataClassificationTags.map((id)=>`ari:cloud:platform::classification-tag/${id}`),
            locale: (0, $eI5EY.fg)('forge-ui-i18n-locale-enabled') ? locale : undefined
        };
        const { data: data, errors: errors, extensions: extensions } = await (0, $cHWHh.measureExecutionTimeMetrics)(()=>(0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: query,
                    variables: variables
                }),
                method: 'POST'
            }));
        const traceId = (0, $dkvex.getTraceIdFromExtensions)({
            extensions: extensions
        });
        if (errors) throw new (0, $c10S5.ForgeFetchError)(`Response ended with an error message: ${errors[0].message}`, traceId, errors);
        if (!data) throw new (0, $c10S5.ForgeFetchError)('No data returned', traceId, errors);
        if (data.extensionContexts.length < 1) throw new (0, $c10S5.ForgeFetchError)('No extensionContext returned', traceId, errors);
        return {
            data: data,
            traceId: traceId
        };
    };
    var $df5bab9bca496d0a$export$2e2bcd8739ae039 = async (cloudId, modules, dataClassification, extras, source = (0, $2Rqjr.SOURCE_UNKNOWN), contextIds, locale)=>{
        try {
            if (!(0, $2NB1f.canFetchForgeModules)()) return {
                extensions: (0, $2Rqjr.getEmptyExtensionsObject)(),
                accessNarrowedExtensions: (0, $2Rqjr.getEmptyExtensionsObject)()
            };
            const { data: data, traceId: traceId } = await $df5bab9bca496d0a$var$fetchModulesWithTraceId(cloudId, modules, dataClassification, extras, contextIds, source, locale);
            if (Math.random() * 100 < (0, $hRcYT.FORGE_SAMPLING_RATE)) (0, $ibWQr.fireInitializationFetchFinishedEvent)(source, {
                traceId: traceId
            });
            return $df5bab9bca496d0a$export$44097e02a91cd11a(data.extensionContexts[0].extensions);
        } catch (error) {
            const errorType = (0, $eTZsp.getErrorType)(error);
            const traceId = (0, $dkvex.getTraceIdFromError)(error);
            (0, $ibWQr.fireInitializationFetchFailedEvent)(source, {
                isSSR: false,
                errorType: errorType,
                error: error,
                traceId: traceId
            });
            if ($df5bab9bca496d0a$var$EXCLUDED_ERROR_TYPES.includes(errorType)) return {
                extensions: (0, $2Rqjr.getEmptyExtensionsObject)(),
                accessNarrowedExtensions: (0, $2Rqjr.getEmptyExtensionsObject)()
            };
            throw error;
        }
    };
});
parcelRegister("eTZsp", function(module, exports) {
    $parcel$export(module.exports, "DATA_CLASSIFICATION_NO_ACCESS", ()=>$11a471eb077355bb$export$23de3198bfe70090);
    $parcel$export(module.exports, "FAILED_TO_FETCH", ()=>$11a471eb077355bb$export$f52aa41ccd776f01);
    $parcel$export(module.exports, "AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS", ()=>$11a471eb077355bb$export$31d2ab0be67934f0);
    $parcel$export(module.exports, "INVOKE_VALUE_FUNCTION_FAILED", ()=>$11a471eb077355bb$export$89a175d4190df42e);
    $parcel$export(module.exports, "userConsentErrorRegex", ()=>$11a471eb077355bb$export$dddade71b333c01d);
    $parcel$export(module.exports, "getErrorType", ()=>$11a471eb077355bb$export$e19f9f08a6d79fd2);
    var $JRB5w = parcelRequire("JRB5w");
    var $lXcGv = parcelRequire("lXcGv");
    const $11a471eb077355bb$var$commonErrors = {
        MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
        OPERATION_ABORTED: 'The operation was aborted. ',
        CANCELLED: 'cancelled',
        UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
        NETWORK_CONNECTION_LOST: 'The network connection was lost.',
        TIMEOUT: 'The request timed out.',
        AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
        GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504',
        GADGET_PREFERENCES: 'failed to put gadget preference: Error server response: 429'
    };
    const $11a471eb077355bb$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
    const $11a471eb077355bb$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
    const $11a471eb077355bb$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
    const $11a471eb077355bb$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
    const $11a471eb077355bb$export$89a175d4190df42e = 'Invoke value functions failed:';
    const $11a471eb077355bb$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
    const $11a471eb077355bb$export$8a5d666d6e5b82fc = (error)=>{
        if ((0, $lXcGv.isLoaderError)(error) || typeof error === 'object' && error.name === 'ChunkLoadError') return true;
        const KNOWN_NETWORK_ERRORS = [
            'Failed to fetch dynamically imported module',
            'error loading dynamically imported module',
            'Importing a module script failed'
        ];
        const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>message.includes(networkErrorMessage));
        return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
    };
    const $11a471eb077355bb$export$e19f9f08a6d79fd2 = (_error)=>{
        if (_error == null) return 'NULL_OR_UNDEFINED';
        const error = _error;
        const message = String(error instanceof Error ? error.message : error).trim();
        const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
        if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
        const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
        if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
        const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
        const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
        if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $11a471eb077355bb$export$7a1bd8c001e7e9c;
        const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
        if (serverErrorRegex.test(message)) {
            const match = message.match(serverErrorRegex);
            const statusCode = match ? match[1] : 'NO_STATUS_CODE';
            return `ERROR_SERVER_RESPONSE_${statusCode}`;
        }
        const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
        if (aggGiraServerErrorRegex.test(message)) {
            const match = message.match(aggGiraServerErrorRegex);
            const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
            return `AGG_GIRA_ERROR_${statusCode}`;
        }
        const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
        const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
        if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $11a471eb077355bb$export$23de3198bfe70090;
        const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
        if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
        if ($11a471eb077355bb$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
        const appValueFunction = new RegExp("The app's value function failed", 'i');
        const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
        const invokeValueFunctionFailed = new RegExp($11a471eb077355bb$export$89a175d4190df42e, 'i');
        const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === (0, $1c3fbb431a173cc6$export$9de493bcd9b1d977);
        const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === (0, $1c3fbb431a173cc6$export$fa405bbf47d510e2);
        if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
        const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
        if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
        const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
        if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
        if ($11a471eb077355bb$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
        if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
        if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
        if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
        const entry = Object.entries($11a471eb077355bb$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
        if (entry) return entry[0];
        if ((0, $JRB5w.isClientFetchError)(error)) return $11a471eb077355bb$export$f52aa41ccd776f01;
        return 'OTHER';
    };
});
parcelRegister("cHWHh", function(module, exports) {
    $parcel$export(module.exports, "measureExecutionTimeMetrics", ()=>$69ad25e8e60753eb$export$a859f6866f4653e0);
    var $hompL = parcelRequire("hompL");
    var $eI5EY = parcelRequire("eI5EY");
    var $hRcYT = parcelRequire("hRcYT");
    var $d6g7g = parcelRequire("d6g7g");
    const $69ad25e8e60753eb$export$a859f6866f4653e0 = async (action)=>{
        const concurrentId = (0, ($parcel$interopDefault($hompL)))();
        const shouldSendTimeMetric = Math.random() * 100 < (0, $hRcYT.FORGE_SAMPLING_RATE);
        if ((0, $eI5EY.fg)('ditto-fcf_forge_fetch_time_metric_fix')) try {
            if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesConcurrentFetchTime)(concurrentId).start({
                startTime: performance.now()
            });
            const result = await action();
            if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesConcurrentFetchTime)(concurrentId).stop({
                stopTime: performance.now()
            });
            return result;
        } catch (error) {
            if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesConcurrentFetchTime)(concurrentId).cancel();
            throw error;
        }
        else try {
            if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).start({
                startTime: performance.now()
            });
            const result = await action();
            if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).stop({
                stopTime: performance.now()
            });
            return result;
        } catch (error) {
            if (shouldSendTimeMetric) (0, $d6g7g.forgeModulesFetchTime).cancel();
            throw error;
        }
    };
});
parcelRegister("hRcYT", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME_GASV3", ()=>$7ddaf55383536638$export$f892f621fb508154);
    $parcel$export(module.exports, "MODULE_TYPE_TRIGGER", ()=>$7ddaf55383536638$export$ed63b053e04e26df);
    $parcel$export(module.exports, "MODULE_TYPE_EXTENSION", ()=>$7ddaf55383536638$export$725bacc669333eef);
    $parcel$export(module.exports, "FORGE_SAMPLING_RATE", ()=>$7ddaf55383536638$export$d920cee73ec094d0);
    $parcel$export(module.exports, "PERFORMANCE_KEYS", ()=>$7ddaf55383536638$export$f048d91ccaf92408);
    $parcel$export(module.exports, "UI_ACTIONS", ()=>$7ddaf55383536638$export$2b7367f125154866);
    $parcel$export(module.exports, "OPERATIONAL_ACTIONS", ()=>$7ddaf55383536638$export$42bcca5cae2ce90b);
    $parcel$export(module.exports, "TRACK_ACTIONS", ()=>$7ddaf55383536638$export$2af0438304d7c4b2);
    const $7ddaf55383536638$export$f892f621fb508154 = 'jiraForgeUi';
    const $7ddaf55383536638$export$273f5980517336e2 = 'jiraforgeui';
    const $7ddaf55383536638$export$ed63b053e04e26df = 'trigger';
    const $7ddaf55383536638$export$725bacc669333eef = 'extension';
    const $7ddaf55383536638$export$d920cee73ec094d0 = 10;
    const $7ddaf55383536638$export$f048d91ccaf92408 = {
        FORGE_MODULES: {
            FETCH_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.forge-modules.fetch-time`,
            LOAD_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.forge-modules.load-time`
        },
        REAL_TIME_ISSUE_EVENTS: {
            INVOKE_TIME: `${$7ddaf55383536638$export$273f5980517336e2}.real-time-issue-events.invoke-time`
        },
        MARKS: {
            TTI_START: 'ECOSYSTEM_FORGE_MODULE_TTI_BEGIN_MARK',
            TTI_END: 'ECOSYSTEM_FORGE_MODULE_TTI_END_MARK',
            ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_EDIT_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END',
            ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_START',
            ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END: 'ASYNC_FORGE_UI_CUSTOM_FIELD_VALUE_FUNCTION_END'
        }
    };
    const $7ddaf55383536638$export$2b7367f125154866 = {
        CLICKED: 'clicked',
        SELECTED: 'selected',
        CANCELED: 'canceled',
        ACTION_CLICKED: 'action clicked',
        COLLAPSE_EXPAND_CLICKED: 'collapse-expand clicked',
        REMOVE_CLICKED: 'remove clicked'
    };
    const $7ddaf55383536638$export$42bcca5cae2ce90b = {
        FAILED: 'failed',
        INITIALIZED: 'initialized',
        EDIT_FAILED: 'edit failed',
        ACTION_FAILED: 'action failed',
        SAVE_FAILED: 'save failed',
        REMOVE_FAILED: 'remove failed',
        UPDATE_FAILED: 'update failed'
    };
    const $7ddaf55383536638$export$2af0438304d7c4b2 = {
        EDITED: 'edited',
        SAVED: 'saved',
        REMOVED: 'removed',
        ACTION_SUCCEED: 'action succeed',
        UPDATE_SUCCEED: 'update succeed'
    };
});
parcelRegister("d6g7g", function(module, exports) {
    $parcel$export(module.exports, "forgeModulesFetchTime", ()=>$2f54a22cce56cf6f$export$cd129f3639657eae);
    $parcel$export(module.exports, "forgeModulesConcurrentFetchTime", ()=>$2f54a22cce56cf6f$export$c3d8833fbea3e976);
    $parcel$export(module.exports, "forgeModulesConcurrentLoadTime", ()=>$2f54a22cce56cf6f$export$292f3b557281044f);
    $parcel$export(module.exports, "realTimeIssueEventInvokeTime", ()=>$2f54a22cce56cf6f$export$89ace7e2bb7d7685);
    $parcel$export(module.exports, "measureInitialPageLoadAsyncResourcesTiming", ()=>$2f54a22cce56cf6f$export$94f65f3b2556df23);
    $parcel$export(module.exports, "markAdditionalTimingsFromWindowPerformance", ()=>$2f54a22cce56cf6f$export$116d5e25caf0018d);
    $parcel$export(module.exports, "customFieldPageSegmentLoadMetric", ()=>$2f54a22cce56cf6f$export$3bd38623c2543fc0);
    $parcel$export(module.exports, "customFieldInteractionMetric", ()=>$2f54a22cce56cf6f$export$a318f99472db73c8);
    var $i8ojO = parcelRequire("i8ojO");
    var $hgcvd = parcelRequire("hgcvd");
    var $kZ1Xe = parcelRequire("kZ1Xe");
    var $gNeWw = parcelRequire("gNeWw");
    var $hRcYT = parcelRequire("hRcYT");
    const $2f54a22cce56cf6f$export$cd129f3639657eae = (0, $i8ojO.metrics).custom({
        key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
    });
    const $2f54a22cce56cf6f$export$c3d8833fbea3e976 = (0, $i8ojO.metrics).concurrent.custom({
        key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.FETCH_TIME
    });
    const $2f54a22cce56cf6f$export$292f3b557281044f = (0, $i8ojO.metrics).concurrent.custom({
        key: (0, $hRcYT.PERFORMANCE_KEYS).FORGE_MODULES.LOAD_TIME
    });
    const $2f54a22cce56cf6f$export$89ace7e2bb7d7685 = new (0, $gNeWw.UFOExperience)((0, $hRcYT.PERFORMANCE_KEYS).REAL_TIME_ISSUE_EVENTS.INVOKE_TIME, {
        type: (0, $kZ1Xe.ExperienceTypes).Experience,
        performanceType: (0, $kZ1Xe.ExperiencePerformanceTypes).InlineResult
    });
    async function $2f54a22cce56cf6f$export$94f65f3b2556df23(startMark, endMark, fn) {
        if (false || (0, $hgcvd.default).getEntriesByName(startMark).length > 0 || (0, $hgcvd.default).getEntriesByName(endMark).length > 0) return fn();
        (0, $hgcvd.default).mark(startMark);
        const result = await fn();
        (0, $hgcvd.default).mark(endMark);
        return result;
    }
    const $2f54a22cce56cf6f$export$116d5e25caf0018d = (metric, additionalTimings)=>{
        additionalTimings.flatMap(({ startMark: startMark, endMark: endMark, cleanStart: cleanStart, cleanEnd: cleanEnd })=>[
                ...(0, $hgcvd.default).getEntriesByName(startMark).map((entry)=>({
                        name: entry.name,
                        startTime: entry.startTime,
                        cleanStart: cleanStart,
                        cleanEnd: undefined
                    })),
                ...(0, $hgcvd.default).getEntriesByName(endMark).map((entry)=>({
                        name: entry.name,
                        startTime: entry.startTime,
                        cleanStart: undefined,
                        cleanEnd: cleanEnd
                    }))
            ]).forEach(({ name: name, startTime: startTime, cleanStart: cleanStart, cleanEnd: cleanEnd })=>{
            metric.mark(name, startTime);
            if (cleanStart || cleanEnd) (0, $hgcvd.default).clearMarks(name);
        });
    };
    const $2f54a22cce56cf6f$export$3bd38623c2543fc0 = (additionalTimings = [])=>(0, $i8ojO.metrics).pageSegmentLoad({
            key: 'forge-custom-field',
            timings: [
                ...additionalTimings,
                {
                    key: 'tti',
                    startMark: (0, $hRcYT.PERFORMANCE_KEYS).MARKS.TTI_START,
                    endMark: (0, $hRcYT.PERFORMANCE_KEYS).MARKS.TTI_END
                }
            ]
        });
    const $2f54a22cce56cf6f$export$a318f99472db73c8 = (additionalTimings = [])=>(0, $i8ojO.metrics).interaction({
            key: 'forge-custom-field',
            timings: [
                ...additionalTimings
            ]
        });
});
parcelRegister("ibWQr", function(module, exports) {
    $parcel$export(module.exports, "fireInitializationFetchFinishedEvent", ()=>$2c36a22053951caa$export$132ca822850e455f);
    $parcel$export(module.exports, "fireInitializationFetchFailedEvent", ()=>$2c36a22053951caa$export$b5ca88b1053f1ad0);
    $parcel$export(module.exports, "fireInitializationIssueViewFinishedEvent", ()=>$2c36a22053951caa$export$e914f7df1e4ad79b);
    $parcel$export(module.exports, "fireInitializationIssueViewFailedEvent", ()=>$2c36a22053951caa$export$b274c658390b491b);
    var $TrUS5 = parcelRequire("TrUS5");
    var $cYWDh = parcelRequire("cYWDh");
    const $2c36a22053951caa$var$INITIALIZATION_ACTIONS = {
        STARTED: 'started',
        FINISHED: 'finished',
        FAILED: 'failed'
    };
    const $2c36a22053951caa$export$917d0643b0111a02 = (0, $TrUS5.toEventId)('issueViewInitialization');
    const $2c36a22053951caa$export$43e875fd63e64525 = (0, $TrUS5.toEventId)('fetchModulesInitialization');
    const $2c36a22053951caa$export$132ca822850e455f = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FINISHED, {
            id: $2c36a22053951caa$export$43e875fd63e64525,
            source: source,
            attributes: attributes
        });
    const $2c36a22053951caa$export$b5ca88b1053f1ad0 = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FAILED, {
            id: $2c36a22053951caa$export$43e875fd63e64525,
            source: source,
            attributes: attributes
        });
    const $2c36a22053951caa$export$e914f7df1e4ad79b = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FINISHED, {
            id: $2c36a22053951caa$export$917d0643b0111a02,
            source: source,
            attributes: attributes
        });
    const $2c36a22053951caa$export$b274c658390b491b = (source, attributes)=>(0, $cYWDh.fireInitializationEvent)($2c36a22053951caa$var$INITIALIZATION_ACTIONS.FAILED, {
            id: $2c36a22053951caa$export$917d0643b0111a02,
            source: source,
            attributes: attributes
        });
});
parcelRegister("TrUS5", function(module, exports) {
    $parcel$export(module.exports, "toEventId", ()=>$157b5a46da0774f4$export$75e84ef5a3771f9a);
    const $157b5a46da0774f4$export$75e84ef5a3771f9a = (value)=>value;
});
parcelRegister("cYWDh", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalEvent", ()=>$6b16192b91ad756a$export$a1fb57756f0de62b);
    $parcel$export(module.exports, "fireUiEvent", ()=>$6b16192b91ad756a$export$bed7f228c94e5f2a);
    $parcel$export(module.exports, "fireTrackEvent", ()=>$6b16192b91ad756a$export$574d2f19a52d67ca);
    $parcel$export(module.exports, "fireInitializationEvent", ()=>$6b16192b91ad756a$export$390a62413962e4f0);
    var $3FyZ4 = parcelRequire("3FyZ4");
    var $hRcYT = parcelRequire("hRcYT");
    var $bBGpO = parcelRequire("bBGpO");
    var $7ALvE = parcelRequire("7ALvE");
    var $29pIG = parcelRequire("29pIG");
    const $6b16192b91ad756a$var$createAnalyticsProps = ({ id: id, source: source = 'unknownSource', action: action, attributes: attributes })=>({
            actionSubject: `${0, $hRcYT.PACKAGE_NAME_GASV3}.${id}`,
            attributes: (0, $bBGpO.createAttributes)(attributes),
            source: source,
            action: action
        });
    const $6b16192b91ad756a$var$getAnalyticsClient = async ()=>(await (0, $3FyZ4.getAnalyticsWebClientPromise)()).getInstance();
    const $6b16192b91ad756a$var$sendOperationalEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendOperationalEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
    const $6b16192b91ad756a$var$sendUiEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendUIEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
    const $6b16192b91ad756a$var$sendTrackEvent = async (props)=>(await $6b16192b91ad756a$var$getAnalyticsClient()).sendTrackEvent($6b16192b91ad756a$var$createAnalyticsProps(props));
    const $6b16192b91ad756a$export$a1fb57756f0de62b = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendOperationalEvent({
            ...eventProps,
            source: (0, $bBGpO.parseSource)(source),
            action: action
        });
    const $6b16192b91ad756a$export$bed7f228c94e5f2a = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendUiEvent({
            ...eventProps,
            source: (0, $bBGpO.parseSource)(source),
            action: action
        });
    const $6b16192b91ad756a$export$574d2f19a52d67ca = async (action, { source: source, ...eventProps })=>$6b16192b91ad756a$var$sendTrackEvent({
            ...eventProps,
            source: (0, $bBGpO.parseSource)(source),
            action: action
        });
    const $6b16192b91ad756a$export$390a62413962e4f0 = async (action, { id: id, attributes: attributes, source: source })=>Promise.all([
            $6b16192b91ad756a$export$a1fb57756f0de62b(action, {
                id: id,
                attributes: attributes,
                source: source
            }),
            attributes?.error && (0, $7ALvE.logError)((0, $7ALvE.ANALYTICS_UTIL), `Something went wrong with Forge initialization, isSynthetic=${(0, $29pIG.isSynthetic)().toString()}, id=${id}, source=${(0, $bBGpO.parseSource)(source)}, action=${action}`, attributes.error) || Promise.resolve()
        ]);
});
parcelRegister("bBGpO", function(module, exports) {
    $parcel$export(module.exports, "parseSource", ()=>$c13c8af67eb85442$export$e98201ef9a88ba70);
    $parcel$export(module.exports, "createAttributes", ()=>$c13c8af67eb85442$export$c7c9603a6b1fd815);
    var $7PHyj = parcelRequire("7PHyj");
    var $f4SFV = parcelRequire("f4SFV");
    var $eTZsp = parcelRequire("eTZsp");
    var $29pIG = parcelRequire("29pIG");
    const $c13c8af67eb85442$export$e98201ef9a88ba70 = (source)=>source != null ? source.toString() : 'unknownSource';
    const $c13c8af67eb85442$export$78c6267359db7e73 = (error)=>({
            ...error,
            stack: error.stack,
            message: error?.message
        });
    const $c13c8af67eb85442$export$c7c9603a6b1fd815 = (rawAttributes)=>{
        const attributes = {
            isSynthetic: (0, $29pIG.isSynthetic)(),
            isOverridingFragments: (0, $f4SFV.isOverridingFragments)(),
            isSSR: false
        };
        if (rawAttributes) {
            const { source: source, error: error, hasForgeAccess: hasForgeAccess } = rawAttributes;
            if (source) attributes.source = $c13c8af67eb85442$export$e98201ef9a88ba70(source);
            if (error) {
                attributes.error = $c13c8af67eb85442$export$78c6267359db7e73(error);
                attributes.errorType = (0, $eTZsp.getErrorType)(error);
            }
            if ((0, ($parcel$interopDefault($7PHyj)))(hasForgeAccess)) attributes.hasForgeAccess = hasForgeAccess;
        }
        return {
            ...rawAttributes,
            ...attributes
        };
    };
});
parcelRegister("f4SFV", function(module, exports) {
    $parcel$export(module.exports, "isOverridingFragments", ()=>$131b22271a46e6fc$export$1d1321d2b374d697);
    const $131b22271a46e6fc$export$1d1321d2b374d697 = ()=>{
        if (typeof window !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(window?.BUILD_KEY);
        if (typeof globalThis !== 'undefined') return /^(JF-TEST|JF-BB\d+-\d+)$/.test(globalThis.BUILD_KEY);
        return false;
    };
});
parcelRegister("29pIG", function(module, exports) {
    $parcel$export(module.exports, "isSynthetic", ()=>$4e7b61ea3e7b237b$export$947749d756ccb0a);
    var $eI5EY = parcelRequire("eI5EY");
    var $6rW04 = parcelRequire("6rW04");
    const $4e7b61ea3e7b237b$export$947749d756ccb0a = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true' || (0, $eI5EY.fg)('forge_ui_synthetic_check');
});
parcelRegister("7ALvE", function(module, exports) {
    $parcel$export(module.exports, "ANALYTICS_UTIL", ()=>$d44e65d0fc9da8f1$export$d1e4f308040bb0d5);
    $parcel$export(module.exports, "CUSTOM_FIELD_OBJECT_TYPE", ()=>$d44e65d0fc9da8f1$export$36f315a5c6daf40b);
    $parcel$export(module.exports, "logError", ()=>$d44e65d0fc9da8f1$export$58da9968c3170cb1);
    var $gUUjF = parcelRequire("gUUjF");
    var $hRcYT = parcelRequire("hRcYT");
    const $d44e65d0fc9da8f1$export$e31edcd35abe3bb1 = 'environment-mapping';
    const $d44e65d0fc9da8f1$export$d1e4f308040bb0d5 = 'analytics';
    const $d44e65d0fc9da8f1$export$36f315a5c6daf40b = 'custom-field-object-type';
    const $d44e65d0fc9da8f1$export$6ee8198f29fffdb4 = {
        [$d44e65d0fc9da8f1$export$d1e4f308040bb0d5]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.utils.analytics`,
        [$d44e65d0fc9da8f1$export$e31edcd35abe3bb1]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.utils.environment-mapping`,
        [$d44e65d0fc9da8f1$export$36f315a5c6daf40b]: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.error.custom-field.object-type`
    };
    const $d44e65d0fc9da8f1$export$58da9968c3170cb1 = (key, message, event)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData($d44e65d0fc9da8f1$export$6ee8198f29fffdb4[key], message, event);
    };
});
parcelRegister("2NB1f", function(module, exports) {
    $parcel$export(module.exports, "canFetchForgeModules", ()=>$54017b90132e06f5$export$bb3a4a3b8e654c08);
    var $e91YZ = parcelRequire("e91YZ");
    const $54017b90132e06f5$export$bb3a4a3b8e654c08 = ()=>{
        const { isAnonymous: isAnonymous, cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        if (String(cloudId) === 'bob') return false;
        return !isAnonymous;
    };
});
parcelRegister("02sMi", function(module, exports) {
    $parcel$export(module.exports, "filterOutDuplicatedExtensions", ()=>$e5793a48e1add67f$export$e0393e97f15a28a5);
    var $fUTZC = parcelRequire("fUTZC");
    var $2Rqjr = parcelRequire("2Rqjr");
    const $e5793a48e1add67f$export$e0393e97f15a28a5 = (modules)=>{
        const filteredModules = (0, $2Rqjr.getEmptyExtensionsObject)();
        (0, ($parcel$interopDefault($fUTZC)))(modules, (module, propName)=>{
            const moduleExtensions = new Map();
            (0, ($parcel$interopDefault($fUTZC)))(module, (moduleItem)=>{
                const moduleExtension = moduleExtensions.get(moduleItem.id);
                const appVersion = moduleItem?.appVersion || '0.0.0';
                const moduleAppVersion = moduleExtension?.appVersion || '0.0.0';
                if (!moduleExtension || moduleExtension && appVersion >= moduleAppVersion) moduleExtensions.set(moduleItem.id, moduleItem);
            });
            filteredModules[propName] = [
                ...moduleExtensions.values()
            ];
        });
        return filteredModules;
    };
});
parcelRegister("iD9au", function(module, exports) {
    $parcel$export(module.exports, "getDataClassification", ()=>$afc4148764d3af06$export$1635afa94064952c);
    var $lRmyA = parcelRequire("lRmyA");
    var $eTZsp = parcelRequire("eTZsp");
    var $ibWQr = parcelRequire("ibWQr");
    var $7i1xd = parcelRequire("7i1xd");
    var $fvGQu = parcelRequire("fvGQu");
    const $afc4148764d3af06$var$handleError = (err, source)=>{
        const errorMessage = err instanceof Error ? err.message : String(err);
        const error = Error(`Data classification request failed: ${errorMessage}`);
        const errorType = (0, $eTZsp.getErrorType)(error);
        if (errorType === (0, $eTZsp.DATA_CLASSIFICATION_NO_ACCESS)) throw error;
        (0, $ibWQr.fireInitializationFetchFailedEvent)(source, {
            isSSR: false,
            errorType: errorType,
            error: error
        });
        return [];
    };
    async function $afc4148764d3af06$var$getDataClassificationIssue(props, source) {
        try {
            const now = Date.now();
            const cachedResult = (0, $fvGQu.DataClassificationTagsCache).get(`${(0, $fvGQu.issueKeyPrefix)}-${props.issueKey}`);
            const isCacheResultTimePassed = Boolean(cachedResult && (0, $fvGQu.TTL) < now - cachedResult.timestamp);
            if (isCacheResultTimePassed || !cachedResult) {
                const data = await (0, $lRmyA.performGetRequest)(`/rest/internal/3/data-classification/resource/issue/${props.issueKey}`);
                (0, $fvGQu.DataClassificationTagsCache).set(`${(0, $fvGQu.issueKeyPrefix)}-${props.issueKey}`, {
                    tags: data.tags,
                    timestamp: now
                });
                return data.tags;
            }
            return cachedResult.tags;
        } catch (err) {
            return $afc4148764d3af06$var$handleError(err, source);
        }
    }
    async function $afc4148764d3af06$var$getDataClassificationProject(props, source) {
        try {
            const now = Date.now();
            const cachedResult = (0, $fvGQu.DataClassificationTagsCache).get(`${(0, $fvGQu.projectKeyPrefix)}-${props.projectIdOrKey}`);
            const isCacheResultTimePassed = Boolean(cachedResult && (0, $fvGQu.TTL) < now - cachedResult.timestamp);
            if (isCacheResultTimePassed || !cachedResult) {
                const data = await (0, $lRmyA.performGetRequest)(`/rest/internal/3/data-classification/resource/container/${props.projectIdOrKey}`);
                (0, $fvGQu.DataClassificationTagsCache).set(`${(0, $fvGQu.projectKeyPrefix)}-${props.projectIdOrKey}`, {
                    tags: data.tags,
                    timestamp: now
                });
                return data.tags;
            }
            return cachedResult.tags;
        } catch (err) {
            return $afc4148764d3af06$var$handleError(err, source);
        }
    }
    const $afc4148764d3af06$export$1635afa94064952c = async (props, source)=>{
        if (props !== null) {
            if ((0, $7i1xd.hasPrefetchedData)(props)) return props.tags;
            if ((0, $7i1xd.hasProjectIdOrKey)(props)) {
                const tags = await $afc4148764d3af06$var$getDataClassificationProject(props, source);
                return tags;
            }
            if ((0, $7i1xd.hasIssueKey)(props)) {
                const tags = await $afc4148764d3af06$var$getDataClassificationIssue(props, source);
                return tags;
            }
        }
        return [];
    };
});
parcelRegister("7i1xd", function(module, exports) {
    $parcel$export(module.exports, "hasPrefetchedData", ()=>$f4d16f0e4c0cff8e$export$c19d255b92c7c2da);
    $parcel$export(module.exports, "hasProjectIdOrKey", ()=>$f4d16f0e4c0cff8e$export$494434246e5dea0d);
    $parcel$export(module.exports, "hasIssueKey", ()=>$f4d16f0e4c0cff8e$export$b1490cfc7a90c75b);
    var $1c8hB = parcelRequire("1c8hB");
    const $f4d16f0e4c0cff8e$export$c19d255b92c7c2da = (props)=>props !== null && 'tags' in props && (0, ($parcel$interopDefault($1c8hB)))(props.tags);
    const $f4d16f0e4c0cff8e$export$494434246e5dea0d = (props)=>props !== null && 'projectIdOrKey' in props;
    const $f4d16f0e4c0cff8e$export$b1490cfc7a90c75b = (props)=>props !== null && 'issueKey' in props;
});
parcelRegister("fvGQu", function(module, exports) {
    $parcel$export(module.exports, "TTL", ()=>$e29cae659811c7d2$export$6ebb1381174e92a7);
    $parcel$export(module.exports, "issueKeyPrefix", ()=>$e29cae659811c7d2$export$a040db2850f159b0);
    $parcel$export(module.exports, "projectKeyPrefix", ()=>$e29cae659811c7d2$export$df256a06d24ff906);
    $parcel$export(module.exports, "DataClassificationTagsCache", ()=>$e29cae659811c7d2$export$b7adc37405b5ff0d);
    const $e29cae659811c7d2$export$6ebb1381174e92a7 = 60000;
    const $e29cae659811c7d2$export$a040db2850f159b0 = 'issue';
    const $e29cae659811c7d2$export$df256a06d24ff906 = 'project';
    const $e29cae659811c7d2$export$b7adc37405b5ff0d = new Map();
});
parcelRegister("c10S5", function(module, exports) {
    $parcel$export(module.exports, "ForgeFetchError", ()=>$be007d6d4af22f2a$export$2e3b53e53bafa);
    class $be007d6d4af22f2a$export$2e3b53e53bafa extends Error {
        constructor(message, traceId, errors){
            super(message);
            this.name = $be007d6d4af22f2a$export$2e3b53e53bafa.name;
            this.traceId = traceId;
            this.statusCodes = errors?.map((graphQLError)=>graphQLError?.extensions?.statusCode).filter((x)=>x != null);
            if ('captureStackTrace' in Error) Error.captureStackTrace(this, $be007d6d4af22f2a$export$2e3b53e53bafa);
        }
    }
});
parcelRegister("dkvex", function(module, exports) {
    $parcel$export(module.exports, "getTraceIdFromExtensions", ()=>$de55799bed033deb$export$eefb7f54c3b07211);
    $parcel$export(module.exports, "getTraceIdFromError", ()=>$de55799bed033deb$export$9955d05ba83067ba);
    var $7byHA = parcelRequire("7byHA");
    var $c10S5 = parcelRequire("c10S5");
    const $de55799bed033deb$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
        const traceId = extensions?.gateway?.request_id;
        if (traceId && typeof traceId === 'string') return traceId;
        return undefined;
    };
    const $de55799bed033deb$export$9955d05ba83067ba = (error)=>{
        if (error instanceof (0, $c10S5.ForgeFetchError) || error instanceof (0, $7byHA.default)) return error.traceId;
        return undefined;
    };
});
parcelRegister("8ZBIo", function(module, exports) {
    $parcel$export(module.exports, "buildForgeQuery", ()=>$a2e306a4af3081df$export$497b2dc04db7bd76);
    var $1ybV0 = parcelRequire("1ybV0");
    const $a2e306a4af3081df$export$497b2dc04db7bd76 = (include)=>{
        const consentFields = `
    consentUrl
    currentUserConsent {
        user {
            aaid
        }
        appEnvironmentVersion {
            id
        }
        consentedAt
    }
    requiresUserConsent`;
        const scopesField = include.scopes === true ? 'scopes' : '';
        const capabilitySetField = (0, $1ybV0.ff)('platform.forge-ui.license-capability-set') ? 'capabilitySet' : '';
        const licenseFields = `
    license {
        active
        type
        supportEntitlementNumber
        trialEndDate
        subscriptionEndDate
        isEvaluation
        billingPeriod
        ccpEntitlementId
        ccpEntitlementSlug
		    ${capabilitySetField}
    }`;
        return `query jira_forge_frontendModules($contextIds: [ID!]! $extensionsFilter: [ExtensionContextsFilter!]! $dataClassificationTags: [ID!]!, $locale: String) {
        extensionContexts(contextIds: $contextIds) @optIn(to: "Access-Narrowing") {
            extensions(filter: $extensionsFilter, locale: $locale) {
                id
                appVersion
                installationId
                environmentId
                environmentType
                environmentKey
                properties
                ${licenseFields}
                ${scopesField}
                type
                __typename
                ${consentFields}
                egress {
                    type
                    addresses
                }
                dataClassificationPolicyDecision(input: {
                    dataClassificationTags: $dataClassificationTags
                }) {
                    status
                }
            }
        }
    }`;
    };
});
parcelRegister("cSfWg", function(module, exports) {
    $parcel$export(module.exports, "fetchModules", ()=>$3ac00b838e4672c8$export$24d8e11b15325c53);
    var $khCLC = parcelRequire("khCLC");
    var $iWLL0 = parcelRequire("iWLL0");
    var $eTZsp = parcelRequire("eTZsp");
    var $cHWHh = parcelRequire("cHWHh");
    var $hRcYT = parcelRequire("hRcYT");
    var $ibWQr = parcelRequire("ibWQr");
    var $2Rqjr = parcelRequire("2Rqjr");
    var $amu7D = parcelRequire("amu7D");
    var $2NB1f = parcelRequire("2NB1f");
    var $e3k2q = parcelRequire("e3k2q");
    const $3ac00b838e4672c8$export$24d8e11b15325c53 = async (params)=>{
        const { types: types, source: source = (0, $2Rqjr.SOURCE_UNKNOWN) } = params;
        if (!(0, $2NB1f.canFetchForgeModules)()) return (0, $e3k2q.toMappedExtensions)(types, []);
        try {
            const extensions = await (0, $cHWHh.measureExecutionTimeMetrics)(()=>$3ac00b838e4672c8$export$8ff66c70be1c563a(params));
            if (Math.random() * 100 < (0, $hRcYT.FORGE_SAMPLING_RATE)) (0, $ibWQr.fireInitializationFetchFinishedEvent)(source);
            return (0, $e3k2q.toMappedExtensions)(types, extensions);
        } catch (error) {
            const errorType = (0, $eTZsp.getErrorType)(error);
            (0, $ibWQr.fireInitializationFetchFailedEvent)(source, {
                isSSR: false,
                errorType: errorType,
                error: error
            });
            if ($3ac00b838e4672c8$export$458cbcb6374269d2.includes(errorType)) return (0, $e3k2q.toMappedExtensions)(types, []);
            throw error;
        }
    };
    function $3ac00b838e4672c8$export$8ff66c70be1c563a(props) {
        const { cloudId: cloudId, types: types, context: context, includeHidden: includeHidden, includeScopes: includeScopes = false } = props;
        if (types.length === 0) throw new Error('No modules to fetch provided');
        return (0, $iWLL0.fetchQuery)((0, $amu7D.default)(), (0, $khCLC.default), {
            cloudId: cloudId,
            context: context,
            types: types,
            includeHidden: includeHidden,
            includeScopes: includeScopes
        }).toPromise().then((response)=>{
            return response.jira.forge.extensions.concat();
        });
    }
    const $3ac00b838e4672c8$export$458cbcb6374269d2 = [
        (0, $eTZsp.FAILED_TO_FETCH),
        (0, $eTZsp.AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS),
        (0, $eTZsp.DATA_CLASSIFICATION_NO_ACCESS)
    ];
});
parcelRegister("khCLC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1898485f6eb58c1d$export$2e2bcd8739ae039);
    const $1898485f6eb58c1d$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeScopes"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }, v5 = {
            "kind": "ScalarField",
            "name": "type"
        }, v6 = {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "JiraForgeExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                {
                    "condition": "includeHidden",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hiddenBy"
                        }
                    ]
                },
                {
                    "condition": "includeScopes",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "scopes"
                        }
                    ]
                },
                v5,
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "properties"
                },
                {
                    "concreteType": "JiraForgeAppEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        v5
                    ]
                },
                {
                    "concreteType": "JiraForgeExtensionLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        v5,
                        {
                            "kind": "ScalarField",
                            "name": "supportEntitlementNumber"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        }
                    ]
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4
                ],
                "kind": "Fragment",
                "name": "fetchModulesV2Query",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraForgeQuery",
                                        "kind": "LinkedField",
                                        "name": "forge",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v6,
                                                "action": "THROW",
                                                "path": "jira.forge.extensions"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.forge"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v4,
                    v2,
                    v3
                ],
                "kind": "Operation",
                "name": "fetchModulesV2Query",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraForgeQuery",
                                "kind": "LinkedField",
                                "name": "forge",
                                "plural": false,
                                "selections": [
                                    v6
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "7ec904788346b73ef73ba8d21a8d7a83b02cd5e8d03190f3c9f31995997aab05",
                "metadata": {},
                "name": "fetchModulesV2Query",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $1898485f6eb58c1d$var$node.hash = "7d0cf33c9221c468dec00db8d99ae484";
    var $1898485f6eb58c1d$export$2e2bcd8739ae039 = $1898485f6eb58c1d$var$node;
});
parcelRegister("e3k2q", function(module, exports) {
    $parcel$export(module.exports, "toMappedExtensions", ()=>$9af364078de98550$export$e073e0c0d1c23345);
    function $9af364078de98550$export$e073e0c0d1c23345(requestedModules, returnedExtensions) {
        const result = Object.fromEntries(requestedModules.map((type)=>[
                type,
                []
            ]));
        returnedExtensions.forEach((extension)=>{
            result[extension.type]?.push(extension);
        });
        return result;
    }
});
parcelRegister("jwzNs", function(module, exports) {
    $parcel$export(module.exports, "resourceWithCondition", ()=>$55f07a7915bec73f$export$cac04afc5a06c544);
    $parcel$export(module.exports, "resourceWithCondition2", ()=>$55f07a7915bec73f$export$78488a529a07cd46);
    $parcel$export(module.exports, "browserOnlyResourceWithCondition", ()=>$55f07a7915bec73f$export$5284559c6d2f1a7b);
    var $6qExu = parcelRequire("6qExu");
    const $55f07a7915bec73f$export$cac04afc5a06c544 = (conditionGetter, resourceTrue)=>resourceTrue && {
            get type () {
                return conditionGetter() ? resourceTrue.type : (0, $6qExu.RESOURCE_TYPE_NOOP);
            },
            getKey: resourceTrue.getKey,
            get maxAge () {
                return conditionGetter() ? resourceTrue.maxAge : Number.MAX_SAFE_INTEGER;
            },
            getData: (routerContext, customContext)=>conditionGetter() ? resourceTrue.getData(routerContext, customContext) : Promise.resolve(null),
            maxCache: resourceTrue.maxCache,
            get isBrowserOnly () {
                return resourceTrue.isBrowserOnly;
            },
            get depends () {
                return resourceTrue.depends;
            },
            get skipBrowser () {
                return resourceTrue.skipBrowser;
            }
        };
    const $55f07a7915bec73f$export$fbf6681b373be4c4 = (resource, amendments = {})=>resource && Object.defineProperties({}, {
            ...Object.getOwnPropertyDescriptors(resource),
            ...Object.getOwnPropertyDescriptors(amendments)
        });
    const $55f07a7915bec73f$export$78488a529a07cd46 = (conditionGetter, itemTrue, itemFalse = $55f07a7915bec73f$export$fbf6681b373be4c4(itemTrue, {
        getKey: ()=>'DEGENERATE_KEY',
        getData: ()=>null,
        maxAge: Number.MAX_SAFE_INTEGER
    }))=>itemTrue && Object.defineProperties({}, Object.fromEntries([
            ...Object.keys(itemTrue),
            ...Object.keys(itemFalse)
        ].filter((v, i, a)=>a.indexOf(v) === i).map((key)=>[
                key,
                {
                    configurable: false,
                    enumerable: true,
                    get: ()=>conditionGetter() ? itemTrue[key] : itemFalse[key]
                }
            ])));
    const $55f07a7915bec73f$export$5284559c6d2f1a7b = (conditionGetter, resource)=>resource && {
            ...resource,
            get isBrowserOnly () {
                return !!conditionGetter();
            }
        };
});
parcelRegister("6qExu", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_NOOP", ()=>$d6fba9243db8a331$export$eb37f5d331ea4de4);
    $parcel$export(module.exports, "MIN_MAX_AGE", ()=>$d6fba9243db8a331$export$5664a170ac5a9781);
    const $d6fba9243db8a331$export$eb37f5d331ea4de4 = 'NOOP';
    const $d6fba9243db8a331$export$5664a170ac5a9781 = 5000;
});
parcelRegister("fSEqj", function(module, exports) {
    $parcel$export(module.exports, "fetchForgeModule", ()=>$8729e3f9c8f23451$export$e1683e15cedb5f17);
    var $jh2R9 = parcelRequire("jh2R9");
    var $h1xZf = parcelRequire("h1xZf");
    var $2Rqjr = parcelRequire("2Rqjr");
    var $hsX10 = parcelRequire("hsX10");
    var $6vrw7 = parcelRequire("6vrw7");
    var $4MOAS = parcelRequire("4MOAS");
    const $8729e3f9c8f23451$var$dataClassificatedModulesConfig = {
        names: new Set(),
        request: Promise.resolve({})
    };
    const $8729e3f9c8f23451$export$e1683e15cedb5f17 = async ({ cloudId: cloudId, moduleName: moduleName, dataClassification: dataClassification, shouldReturnANExtensions: shouldReturnANExtensions = false, contextIds: contextIds, locale: locale })=>{
        $8729e3f9c8f23451$var$dataClassificatedModulesConfig.names.add(moduleName);
        await new Promise((resolve)=>setTimeout(resolve, 0));
        const moduleNamesToFetch = Array.from($8729e3f9c8f23451$var$dataClassificatedModulesConfig.names);
        let extensions = [];
        let accessNarrowedExtensions = [];
        if (moduleNamesToFetch.length > 0) {
            $8729e3f9c8f23451$var$dataClassificatedModulesConfig.names = new Set();
            $8729e3f9c8f23451$var$dataClassificatedModulesConfig.request = (0, $hsX10.default)((0, $6vrw7.toCloudId)(cloudId), moduleNamesToFetch, dataClassification, undefined, (0, $2Rqjr.SOURCE_FULL_PAGE_APP), contextIds, locale).then((extensionsMap)=>extensionsMap);
        }
        const result = await $8729e3f9c8f23451$var$dataClassificatedModulesConfig.request;
        extensions = result.extensions[(0, ($parcel$interopDefault($jh2R9)))(moduleName)];
        if (shouldReturnANExtensions) accessNarrowedExtensions = result.accessNarrowedExtensions[(0, ($parcel$interopDefault($jh2R9)))(moduleName)];
        const getExtensionsFilter = (fullPageModuleName)=>{
            switch(fullPageModuleName){
                case 0, $2Rqjr.ADMIN_PAGE_MODULE:
                    return 0, $4MOAS.adminPageFilter;
                default:
                    return 0, $4MOAS.uniqueExtensionsFilter;
            }
        };
        return {
            extensions: getExtensionsFilter(moduleName)(extensions).sort((a, b)=>(0, $h1xZf.alphabeticalSort)(a.properties.title, b.properties.title)),
            accessNarrowedExtensions: getExtensionsFilter(moduleName)(accessNarrowedExtensions).sort((a, b)=>(0, $h1xZf.alphabeticalSort)(a.properties.title, b.properties.title))
        };
    };
});
parcelRegister("4MOAS", function(module, exports) {
    $parcel$export(module.exports, "uniqueExtensionsFilter", ()=>$7eebe06f4aced941$export$2b91ba95eded67f6);
    $parcel$export(module.exports, "adminPageFilter", ()=>$7eebe06f4aced941$export$1eefd1d9cde49fd5);
    var $lyOYo = parcelRequire("lyOYo");
    var $70ON1 = parcelRequire("70ON1");
    const $7eebe06f4aced941$export$2b91ba95eded67f6 = (extensions)=>(0, ($parcel$interopDefault($lyOYo)))(extensions, (extension)=>{
            const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
            return `${appId}_${envId}`;
        });
    const $7eebe06f4aced941$export$1eefd1d9cde49fd5 = (extensions)=>{
        const configPageFilter = (extension)=>extension.properties.useAsConfig;
        const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
        const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
        const adminExtensions = extensions;
        return [
            ...$7eebe06f4aced941$export$2b91ba95eded67f6(adminExtensions.filter(mainPageFilter)),
            ...$7eebe06f4aced941$export$2b91ba95eded67f6(adminExtensions.filter(configPageFilter)),
            ...$7eebe06f4aced941$export$2b91ba95eded67f6(adminExtensions.filter(getStartedPageFilter))
        ];
    };
});
parcelRegister("iLkoO", function(module, exports) {
    $parcel$export(module.exports, "uniqueExtensionsFilter", ()=>$460a57d30e2d873b$export$2b91ba95eded67f6);
    $parcel$export(module.exports, "adminPageFilter", ()=>$460a57d30e2d873b$export$1eefd1d9cde49fd5);
    var $lyOYo = parcelRequire("lyOYo");
    var $70ON1 = parcelRequire("70ON1");
    const $460a57d30e2d873b$export$2b91ba95eded67f6 = (extensions)=>(0, ($parcel$interopDefault($lyOYo)))(extensions, (extension)=>{
            const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
            return `${appId}_${envId}`;
        });
    const $460a57d30e2d873b$export$1eefd1d9cde49fd5 = (extensions)=>{
        const configPageFilter = (extension)=>extension.properties.useAsConfig;
        const getStartedPageFilter = (extension)=>extension.properties.useAsGetStarted;
        const mainPageFilter = (extension)=>!configPageFilter(extension) && !getStartedPageFilter(extension);
        return [
            ...$460a57d30e2d873b$export$2b91ba95eded67f6(extensions.filter(mainPageFilter)),
            ...$460a57d30e2d873b$export$2b91ba95eded67f6(extensions.filter(configPageFilter)),
            ...$460a57d30e2d873b$export$2b91ba95eded67f6(extensions.filter(getStartedPageFilter))
        ];
    };
});
parcelRegister("jMYeN", function(module, exports) {
    $parcel$export(module.exports, "toSections", ()=>$eb609126a990fbb2$export$29678d1e04c0e8c4);
    var $5iWql = parcelRequire("5iWql");
    const $eb609126a990fbb2$var$normalizeSection = (section)=>({
            header: section?.header,
            pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                    icon: page?.icon,
                    route: page?.route,
                    title: page?.title
                })) : []
        });
    const $eb609126a990fbb2$export$29678d1e04c0e8c4 = (0, $5iWql.default)((extension)=>{
        const { properties: properties } = extension;
        if (typeof properties.resource !== 'string') return [];
        if (typeof properties.pages !== 'undefined' && properties.pages?.length) return [
            {
                pages: properties.pages
            }
        ].map($eb609126a990fbb2$var$normalizeSection);
        if (typeof properties.sections !== 'undefined' && properties.sections?.length) return properties.sections.map($eb609126a990fbb2$var$normalizeSection);
        return [];
    });
});
parcelRegister("eOutC", function(module, exports) {
    $parcel$export(module.exports, "useMatchedExtension", ()=>$503fa4d7a9769196$export$13375c0abccaf6f6);
    $parcel$export(module.exports, "useExtensionBasePath", ()=>$503fa4d7a9769196$export$25abed85383f0fbb);
    var $eUqFw = parcelRequire("eUqFw");
    var $70ON1 = parcelRequire("70ON1");
    const $503fa4d7a9769196$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $eUqFw.useMemo)(()=>(modules || []).find((app)=>{
                const parsedExtensionId = (0, $70ON1.parseExtensionId)(app.id);
                return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
            }), [
            modules,
            match.params.appId,
            match.params.envId
        ]);
    const $503fa4d7a9769196$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');
});
parcelRegister("5w4hM", function(module, exports) {
    $parcel$export(module.exports, "genericProjectSidebars", ()=>$541e179b5fa9e509$export$d88d2d25355bc89a);
    $parcel$export(module.exports, "classicBoardSidebars", ()=>$541e179b5fa9e509$export$c04daf123cec1f1e);
    $parcel$export(module.exports, "genericConnectSidebars", ()=>$541e179b5fa9e509$export$844d342b575ead35);
    var $497qU = parcelRequire("497qU");
    var $buaC1 = parcelRequire("buaC1");
    var $hUM03 = parcelRequire("hUM03");
    var $bt7QT = parcelRequire("bt7QT");
    var $iOOlt = parcelRequire("iOOlt");
    var $iTYGl = parcelRequire("iTYGl");
    var $2Fzrk = parcelRequire("2Fzrk");
    var $8rBPw = parcelRequire("8rBPw");
    const $541e179b5fa9e509$export$d88d2d25355bc89a = [
        (0, $buaC1.default),
        (0, $iOOlt.default),
        (0, $iTYGl.default),
        (0, $2Fzrk.default),
        (0, $8rBPw.default)
    ];
    const $541e179b5fa9e509$export$c04daf123cec1f1e = [
        (0, $2Fzrk.default),
        (0, $8rBPw.default)
    ];
    const $541e179b5fa9e509$export$844d342b575ead35 = [
        ...$541e179b5fa9e509$export$d88d2d25355bc89a,
        (0, $497qU.default),
        (0, $hUM03.default),
        (0, $bt7QT.default)
    ];
});
parcelRegister("hUM03", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea1b194caac4ce1a$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $9RvDp = parcelRequire("9RvDp");
    var $av9ef = parcelRequire("av9ef");
    const $ea1b194caac4ce1a$var$LazyGlobalAppsSettingsSidebar = (0, $56koX.lazyAfterPaint)(()=>{
        (0, $av9ef.setPerformanceMarkLoadStart)();
        return (parcelRequire("76Qc1")).then((bundle)=>{
            (0, $av9ef.setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-apps/src/index.tsx"
    });
    const $ea1b194caac4ce1a$var$GlobalAppsSettingsSidebar = (0, $eUqFw.memo)(()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
            id: "globalAppsSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($ea1b194caac4ce1a$var$LazyGlobalAppsSettingsSidebar, null)));
    $ea1b194caac4ce1a$var$GlobalAppsSettingsSidebar.displayName = 'GlobalAppsSettingsSidebar';
    var $ea1b194caac4ce1a$export$2e2bcd8739ae039 = $ea1b194caac4ce1a$var$GlobalAppsSettingsSidebar;
});
parcelRegister("76Qc1", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("iyqJ7")
    ]).then(()=>parcelRequire('60IuX'));
});
parcelRegister("bt7QT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93a98b92e63b4efb$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $9RvDp = parcelRequire("9RvDp");
    var $av9ef = parcelRequire("av9ef");
    const $93a98b92e63b4efb$var$LazyGlobalSystemSettingsSidebar = (0, $56koX.lazyAfterPaint)(()=>{
        (0, $av9ef.setPerformanceMarkLoadStart)();
        return (parcelRequire("fRLTC")).then((bundle)=>{
            (0, $av9ef.setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-system/src/index.tsx"
    });
    const $93a98b92e63b4efb$var$GlobalSystemSettingsSidebar = (0, $eUqFw.memo)(()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
            id: "globalSystemSettings"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($93a98b92e63b4efb$var$LazyGlobalSystemSettingsSidebar, null)));
    $93a98b92e63b4efb$var$GlobalSystemSettingsSidebar.displayName = 'GlobalSystemSettingsSidebar';
    var $93a98b92e63b4efb$export$2e2bcd8739ae039 = $93a98b92e63b4efb$var$GlobalSystemSettingsSidebar;
});
parcelRegister("fRLTC", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("eNmuD"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("SBVRB")
    ]).then(()=>parcelRequire('l15zb'));
});
parcelRegister("iOOlt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9c5b483f80318f8$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $9RvDp = parcelRequire("9RvDp");
    var $av9ef = parcelRequire("av9ef");
    const $a9c5b483f80318f8$var$LazyClassicSoftwareProjectSidebar = (0, $56koX.lazyAfterPaint)(()=>{
        (0, $av9ef.setPerformanceMarkLoadStart)();
        return (parcelRequire("8hvAI")).then((bundle)=>{
            (0, $av9ef.setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/next-gen/src/index.tsx"
    });
    const $a9c5b483f80318f8$var$SoftwareProjectSidebar = (0, $eUqFw.memo)(()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
            id: "softwareProject"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($a9c5b483f80318f8$var$LazyClassicSoftwareProjectSidebar, null)));
    $a9c5b483f80318f8$var$SoftwareProjectSidebar.displayName = 'SoftwareProjectSidebar';
    var $a9c5b483f80318f8$export$2e2bcd8739ae039 = $a9c5b483f80318f8$var$SoftwareProjectSidebar;
});
parcelRegister("8hvAI", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("eNmuD"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("bqmoa")
    ]).then(()=>parcelRequire('dSgKD'));
});
parcelRegister("iTYGl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2f67fc1f904f75a4$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $9RvDp = parcelRequire("9RvDp");
    var $av9ef = parcelRequire("av9ef");
    const $2f67fc1f904f75a4$export$5b9febabdab63fba = (0, $56koX.lazyAfterPaint)(()=>{
        (0, $av9ef.setPerformanceMarkLoadStart)();
        return (parcelRequire("5DwZR")).then((bundle)=>{
            (0, $av9ef.setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/servicedesk/src/index.tsx"
    });
    const $2f67fc1f904f75a4$var$ServicedeskSidebar = (0, $eUqFw.memo)(()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
            id: "servicedeskProject"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($2f67fc1f904f75a4$export$5b9febabdab63fba, null)));
    $2f67fc1f904f75a4$var$ServicedeskSidebar.displayName = 'ServicedeskSidebar';
    var $2f67fc1f904f75a4$export$2e2bcd8739ae039 = $2f67fc1f904f75a4$var$ServicedeskSidebar;
});
parcelRegister("5DwZR", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("kWrFZ"),
        $d1Cng("eNmuD"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("4673m")
    ]).then(()=>parcelRequire('2osKk'));
});
parcelRegister("2Fzrk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9bc2c6e90de3714$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $9RvDp = parcelRequire("9RvDp");
    var $av9ef = parcelRequire("av9ef");
    const $d9bc2c6e90de3714$var$LazyClassicSoftwareProjectSidebar = (0, $56koX.lazyAfterPaint)(()=>{
        (0, $av9ef.setPerformanceMarkLoadStart)();
        return (parcelRequire("kmwFb")).then((bundle)=>{
            (0, $av9ef.setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/software-classic/src/index.tsx"
    });
    const $d9bc2c6e90de3714$var$ClassicSoftwareProjectSidebar = (0, $eUqFw.memo)(()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
            id: "classicSoftwareProject"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($d9bc2c6e90de3714$var$LazyClassicSoftwareProjectSidebar, null)));
    $d9bc2c6e90de3714$var$ClassicSoftwareProjectSidebar.displayName = 'ClassicSoftwareProjectSidebar';
    var $d9bc2c6e90de3714$export$2e2bcd8739ae039 = $d9bc2c6e90de3714$var$ClassicSoftwareProjectSidebar;
});
parcelRegister("kmwFb", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("eNmuD"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("iN4Tu")
    ]).then(()=>parcelRequire('7bWFF'));
});
parcelRegister("8rBPw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d50106f0c2df90e8$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $9RvDp = parcelRequire("9RvDp");
    var $av9ef = parcelRequire("av9ef");
    const $d50106f0c2df90e8$var$LazyUserSidebar = (0, $56koX.lazyAfterPaint)(()=>{
        (0, $av9ef.setPerformanceMarkLoadStart)();
        return (parcelRequire("9toJY")).then((bundle)=>{
            (0, $av9ef.setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/user/src/index.tsx"
    });
    const $d50106f0c2df90e8$var$UserSidebar = (0, $eUqFw.memo)(()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
            id: "user"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($d50106f0c2df90e8$var$LazyUserSidebar, null)));
    $d50106f0c2df90e8$var$UserSidebar.displayName = 'UserSidebar';
    var $d50106f0c2df90e8$export$2e2bcd8739ae039 = $d50106f0c2df90e8$var$UserSidebar;
});
parcelRegister("9toJY", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("eNmuD"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("kmOrn")
    ]).then(()=>parcelRequire('fPz94'));
});
parcelRegister("lWODs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a283bb034822426$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $9RvDp = parcelRequire("9RvDp");
    var $av9ef = parcelRequire("av9ef");
    const $3a283bb034822426$var$LazyInsightObjectSchemaSidebar = (0, $56koX.lazyForPaint)(()=>{
        (0, $av9ef.setPerformanceMarkLoadStart)();
        return (parcelRequire("bZVOA")).then((bundle)=>{
            (0, $av9ef.setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/insight-object-schema/src/index.tsx"
    });
    const $3a283bb034822426$var$InsightObjectSchemaSidebar = (0, $eUqFw.memo)(()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
            id: "insight-object-schema-sidebar"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($3a283bb034822426$var$LazyInsightObjectSchemaSidebar, null)));
    $3a283bb034822426$var$InsightObjectSchemaSidebar.displayName = 'InsightObjectSchemaSidebar';
    var $3a283bb034822426$export$2e2bcd8739ae039 = $3a283bb034822426$var$InsightObjectSchemaSidebar;
});
parcelRegister("bZVOA", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("92sUi"),
        $d1Cng("i5RRW"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("c2mHX")
    ]).then(()=>parcelRequire('7JPCs'));
});
parcelRegister("29Nmz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$884186ee0b4383e1$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $9RvDp = parcelRequire("9RvDp");
    var $av9ef = parcelRequire("av9ef");
    const $884186ee0b4383e1$var$LazyPlanSidebar = (0, $56koX.lazyForPaint)(()=>{
        (0, $av9ef.setPerformanceMarkLoadStart)();
        return (parcelRequire("4KDfr")).then((bundle)=>{
            (0, $av9ef.setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/plan/src/index.tsx"
    });
    const $884186ee0b4383e1$var$PlanSidebar = (0, $eUqFw.memo)(()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
            id: "Plan"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($884186ee0b4383e1$var$LazyPlanSidebar, null)));
    $884186ee0b4383e1$var$PlanSidebar.displayName = 'PlanSidebar';
    var $884186ee0b4383e1$export$2e2bcd8739ae039 = $884186ee0b4383e1$var$PlanSidebar;
});
parcelRegister("4KDfr", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        (parcelRequire("1f3I0"))((parcelRequire("2MVa4")).resolve("kzUYN")),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("4I2Cp")
    ]).then(()=>parcelRequire('k3Z6q'));
});
parcelRegister("bSRyW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$67512e4ded0c1d23$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $56koX = parcelRequire("56koX");
    var $9RvDp = parcelRequire("9RvDp");
    var $av9ef = parcelRequire("av9ef");
    const $67512e4ded0c1d23$var$LazyPolarisProjectSidebar = (0, $56koX.lazyAfterPaint)(()=>{
        (0, $av9ef.setPerformanceMarkLoadStart)();
        return (parcelRequire("epSXR")).then((bundle)=>{
            (0, $av9ef.setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/polaris/src/index.tsx"
    });
    const $67512e4ded0c1d23$var$PolarisProjectSidebar = (0, $eUqFw.memo)(()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $9RvDp.SidebarBoundary), {
            id: "polarisProject"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($67512e4ded0c1d23$var$LazyPolarisProjectSidebar, null)));
    $67512e4ded0c1d23$var$PolarisProjectSidebar.displayName = 'PolarisProjectSidebar';
    var $67512e4ded0c1d23$export$2e2bcd8739ae039 = $67512e4ded0c1d23$var$PolarisProjectSidebar;
});
parcelRegister("epSXR", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("2jChg")
    ]).then(()=>parcelRequire('51gNq'));
});
parcelRegister("2W91Z", function(module, exports) {
    $parcel$export(module.exports, "AsyncNudgeBundledUsersFlagContainer", ()=>$5ceff6512532f6e8$export$30d9dff000fbaa2d);
    var $eUqFw = parcelRequire("eUqFw");
    var $0cdA8 = parcelRequire("0cdA8");
    var $gGtKh = parcelRequire("gGtKh");
    var $56koX = parcelRequire("56koX");
    const $5ceff6512532f6e8$var$NudgeBundledUsersFlagContainer = (0, $56koX.lazyForPaint)(()=>(parcelRequire("1C77s")).then((module)=>module.NudgeBundledUsersXflow), {
        ssr: false,
        moduleId: "./src/packages/growth/nudge-bundled-users-to-join-connie/src/ui/index.tsx"
    });
    const $5ceff6512532f6e8$export$30d9dff000fbaa2d = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "nudgeBundledUserFlag",
            packageName: "nudgeBundledUsersToJoinConnie",
            fallback: "unmount",
            teamName: "confluenceOnboarding"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "nudge-bundled-users-flag",
            fallback: null
        }, (0, ($parcel$interopDefault($eUqFw))).createElement($5ceff6512532f6e8$var$NudgeBundledUsersFlagContainer, null)));
});
parcelRegister("1C77s", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("7RDvS").then(()=>parcelRequire('cJqaO'));
});
parcelRegister("8C1im", function(module, exports) {
    $parcel$export(module.exports, "SidebarFeedbackButton", ()=>$3df3ce63e21ffa04$export$b270ed097d20c023);
    var $eUqFw = parcelRequire("eUqFw");
    var $7LEad = parcelRequire("7LEad");
    var $2jDL5 = parcelRequire("2jDL5");
    var $ghFHl = parcelRequire("ghFHl");
    var $jGR8u = parcelRequire("jGR8u");
    var $fHiYa = parcelRequire("fHiYa");
    var $1c02D = parcelRequire("1c02D");
    var $irg9D = parcelRequire("irg9D");
    var $8uD7Y = parcelRequire("8uD7Y");
    var $5JgJ2 = parcelRequire("5JgJ2");
    var $7BqbB = parcelRequire("7BqbB");
    var $h4Mb7 = parcelRequire("h4Mb7");
    var $b1is6 = parcelRequire("b1is6");
    var $9Anw5 = parcelRequire("9Anw5");
    var $dWLk9 = parcelRequire("dWLk9");
    var $3e9vj = parcelRequire("3e9vj");
    var $92kON = parcelRequire("92kON");
    const $3df3ce63e21ffa04$export$b270ed097d20c023 = ()=>{
        const environment = (0, $3e9vj.useEnvironment)();
        const cloudId = (0, $dWLk9.useCloudId)();
        const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
        const { openFeedbackCollector: openFeedbackCollector, closeFeedbackCollector: closeFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
        const onClickHandler = (0, $eUqFw.useCallback)(()=>{
            const showFeedbackTitleDetailsWithLink = (0, $h4Mb7.getWillShowNav4UserOptIn)() || (0, $b1is6.getWillShowNav4UserOptOut)();
            const formattedMessageNode = showFeedbackTitleDetailsWithLink ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $92kON.default).feedbackTitleDetailsWithLink,
                values: {
                    a: (chunks)=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $ghFHl.default), {
                            href: "/jira/settings/personal/general",
                            onClick: closeFeedbackCollector
                        }, chunks)
                }
            }) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $92kON.default).feedbackTitleDetailsNoLink);
            openFeedbackCollector({
                entrypointId: (0, $1c02D.ENTRYPOINT_ID_NAVIGATION_REFRESH),
                feedbackContext: [
                    {
                        id: 'environment',
                        value: environment
                    },
                    {
                        id: 'cloud-id',
                        value: cloudId
                    },
                    {
                        id: 'location',
                        value: (0, $9Anw5.default)(window?.location?.href ?? '')
                    }
                ],
                feedbackGroupId: (0, $7BqbB.NAV4_GENERAL_FEEDBACK_GROUP_ID),
                feedbackTitle: formatMessage((0, $92kON.default).feedbackTitle),
                feedbackTitleDetails: formattedMessageNode
            });
        }, [
            closeFeedbackCollector,
            cloudId,
            environment,
            formatMessage,
            openFeedbackCollector
        ]);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jGR8u.default), {
            xcss: $3df3ce63e21ffa04$var$containerStyles
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7LEad.default), {
            shouldFitContainer: true,
            iconBefore: (0, ($parcel$interopDefault($2jDL5))),
            appearance: "subtle",
            onClick: onClickHandler
        }, formatMessage((0, $92kON.default).sidebarFeedbackButtonLabel)));
    };
    const $3df3ce63e21ffa04$var$containerStyles = (0, $fHiYa.xcss)({
        flex: 'none',
        borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`,
        padding: 'space.150',
        background: "var(--ds-surface-raised, #FFF)"
    });
});
parcelRegister("2jDL5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1afc3252a2789428$var$_react = $1afc3252a2789428$var$_interopRequireDefault((parcelRequire("eUqFw")));
    var $1afc3252a2789428$var$_UNSAFE_baseNew = $1afc3252a2789428$var$_interopRequireDefault((parcelRequire("ay9aj")));
    function $1afc3252a2789428$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1afc3252a2789428$var$MegaphoneIcon = (props)=>$1afc3252a2789428$var$_react.default.createElement($1afc3252a2789428$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 4.25H3c-.69 0-1.25.56-1.25 1.25v3.25C1.75 9.44 2.31 10 3 10h1.25m2.5-5.75 5.786-2.314a1.25 1.25 0 0 1 1.714 1.16v8.058a1.25 1.25 0 0 1-1.714 1.16L6.75 10m0-5.75V10m0 0h-2.5m2.5 0v4.25H5.5c-.69 0-1.25-.56-1.25-1.25v-3"/>`
        }, props));
    $1afc3252a2789428$var$MegaphoneIcon.displayName = 'MegaphoneIcon';
    var $1afc3252a2789428$var$_default = module.exports.default = $1afc3252a2789428$var$MegaphoneIcon;
});
parcelRegister("1c02D", function(module, exports) {
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", ()=>$ccbba0a7f0f3304b$export$baea5c8192e79adc);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", ()=>$ccbba0a7f0f3304b$export$4eda1e3a4a311d13);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", ()=>$ccbba0a7f0f3304b$export$5fb38521eb7ad63c);
    $parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", ()=>$ccbba0a7f0f3304b$export$345c45dd28f28a32);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", ()=>$ccbba0a7f0f3304b$export$8962f2e618411469);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", ()=>$ccbba0a7f0f3304b$export$7d7f2319141db3c5);
    $parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", ()=>$ccbba0a7f0f3304b$export$4725635e6fe1907a);
    $parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", ()=>$ccbba0a7f0f3304b$export$3a50f2efd6cfd6f3);
    $parcel$export(module.exports, "ENTRY_POINT_ID_AIOPS", ()=>$ccbba0a7f0f3304b$export$5bd148c13bb23f7a);
    $parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", ()=>$ccbba0a7f0f3304b$export$b4de0744c1fd450d);
    $parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", ()=>$ccbba0a7f0f3304b$export$1a7c42187130faf9);
    $parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", ()=>$ccbba0a7f0f3304b$export$e84c34a7e1dbcf78);
    $parcel$export(module.exports, "ENTRYPOINT_ID_NAVIGATION_REFRESH", ()=>$ccbba0a7f0f3304b$export$23f6d7b16d2210c1);
    $parcel$export(module.exports, "ENTRY_POINT_ID_AUTODEV", ()=>$ccbba0a7f0f3304b$export$1b65c2053cba0686);
    $parcel$export(module.exports, "EntryKeys", ()=>$ccbba0a7f0f3304b$export$12d01b6c311a909a);
    const $ccbba0a7f0f3304b$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
    const $ccbba0a7f0f3304b$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
    const $ccbba0a7f0f3304b$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
    const $ccbba0a7f0f3304b$export$4a288e389131b3de = 'b6176efc-e703-426b-b4f8-3e43ce4aa0db';
    const $ccbba0a7f0f3304b$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
    const $ccbba0a7f0f3304b$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
    const $ccbba0a7f0f3304b$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
    const $ccbba0a7f0f3304b$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
    const $ccbba0a7f0f3304b$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
    const $ccbba0a7f0f3304b$export$5bd148c13bb23f7a = 'b6a8ea1d-9ec0-4bb6-9e22-01fd310c0591';
    const $ccbba0a7f0f3304b$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
    const $ccbba0a7f0f3304b$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
    const $ccbba0a7f0f3304b$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
    const $ccbba0a7f0f3304b$export$23f6d7b16d2210c1 = '5002b4f2-9df8-4bb2-8798-56005ef6cbfc';
    const $ccbba0a7f0f3304b$export$1b65c2053cba0686 = '88d39839-ba5c-4704-bfd6-7fe57ed8016b';
    const $ccbba0a7f0f3304b$export$12d01b6c311a909a = Object.freeze({
        CLOUD_ID: 'cloud-id',
        OPT_OUT: 'Opt-out',
        REASON: 'reason',
        FEELING: 'feeling',
        IS_ADMIN: 'is-admin',
        IS_SITE_ADMIN: 'is-site-admin',
        IS_PROJECT_SETTINGS: 'is-project-settings',
        INLINE_FEEDBACK_ID: 'inlineFeedbackId',
        IS_JSD_EVALUATOR: 'is-jsd-evaluator',
        IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
        SUPPORTED_PROJECT_TYPES: 'supported-project-types',
        FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
        FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
        FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
        LOCATION: 'Location',
        PROJECT_TYPE: 'project-type',
        BOARD_TYPE: 'board-type',
        REFERER: 'Referer',
        ROUTE_GROUP: 'route-group',
        ROUTE_NAME: 'route-name',
        USER_AGENT: 'User-Agent',
        SCREEN_RESOLUTION: 'Screen Resolution',
        SOURCE: 'Source',
        SUB_PRODUCT: 'Sub-product',
        JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
        JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
        DEPLOYMENT_PROVIDERS: 'deployment-providers',
        JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
        VERSION_CONTROL_PROVIDERS: 'version-control-providers',
        DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
        CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
        SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
        INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
        IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
        FEEDBACK_GROUP_ID: 'feedback-group-id',
        EDITION: 'edition',
        ENV: 'environment',
        SMART_REPLIES: 'smart-replies'
    });
});
parcelRegister("irg9D", function(module, exports) {
    $parcel$export(module.exports, "useFeedbackCollector", ()=>$8d3d8a971c5329dd$export$4be696be8a3bff13);
    $parcel$export(module.exports, "useFeedbackCollectorActions", ()=>$8d3d8a971c5329dd$export$dfb2ee2d9e73fa48);
    $parcel$export(module.exports, "FeedbackActionsSubscriber", ()=>$8d3d8a971c5329dd$export$c35dbf16ebe9df04);
    var $WBLbN = parcelRequire("WBLbN");
    const $8d3d8a971c5329dd$export$d4c72bab9d6cc13a = {
        isFeedbackCollectorOpen: false,
        entrypointId: undefined,
        email: undefined,
        additionalFields: undefined,
        feedbackTitle: undefined,
        feedbackContext: undefined,
        feedbackCollectorId: undefined,
        showTypeField: true,
        submitButtonLabel: undefined,
        canBeContactedLabel: undefined,
        summaryPlaceholder: undefined,
        feedbackGroupLabels: undefined,
        onClose: undefined,
        feedbackTitleDetails: undefined,
        triggerRef: undefined,
        renderCustomContent: undefined,
        customFeedbackOptions: []
    };
    const $8d3d8a971c5329dd$export$e324594224ef24da = {
        openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
                dispatch($8d3d8a971c5329dd$export$e324594224ef24da.resetFeedbackCollectorState());
                setState({
                    ...feedbackCollectorProps,
                    isFeedbackCollectorOpen: true
                });
            },
        closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
                const { triggerRef: triggerRef } = getState();
                if (triggerRef) setTimeout(()=>triggerRef.current?.focus(), 50);
                setState({
                    isFeedbackCollectorOpen: false,
                    triggerRef: undefined
                });
            },
        resetFeedbackCollectorState: ()=>({ setState: setState })=>{
                setState({
                    ...$8d3d8a971c5329dd$export$d4c72bab9d6cc13a
                });
            },
        updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
                setState({
                    renderCustomContent: updatedCustomRenderContent
                });
            },
        updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
                setState({
                    additionalFields: updatedAdditionalFields
                });
            }
    };
    const $8d3d8a971c5329dd$var$Store = (0, $WBLbN.createStore)({
        name: 'feedback-collector',
        initialState: $8d3d8a971c5329dd$export$d4c72bab9d6cc13a,
        actions: $8d3d8a971c5329dd$export$e324594224ef24da
    });
    const $8d3d8a971c5329dd$export$4be696be8a3bff13 = (0, $WBLbN.createHook)($8d3d8a971c5329dd$var$Store);
    const $8d3d8a971c5329dd$export$dfb2ee2d9e73fa48 = (0, $WBLbN.createActionsHook)($8d3d8a971c5329dd$var$Store);
    const $8d3d8a971c5329dd$export$c35dbf16ebe9df04 = (0, $WBLbN.createSubscriber)($8d3d8a971c5329dd$var$Store, {
        selector: null
    });
});
parcelRegister("h4Mb7", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptIn", ()=>$52d89fd9532d4f67$export$46a00895da9889a2);
    var $eI5EY = parcelRequire("eI5EY");
    const $52d89fd9532d4f67$export$46a00895da9889a2 = ()=>(0, $eI5EY.fg)('jira_nav4') && $52d89fd9532d4f67$var$getWillShowNav4UserOptInForExistingCustomers();
    const $52d89fd9532d4f67$var$getWillShowNav4UserOptInForExistingCustomers = ()=>false;
});
parcelRegister("b1is6", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptOut", ()=>$a8bd3e70aed7a6e6$export$acb346134ed05173);
    var $eI5EY = parcelRequire("eI5EY");
    var $6hzdX = parcelRequire("6hzdX");
    var $3z408 = parcelRequire("3z408");
    const $a8bd3e70aed7a6e6$export$acb346134ed05173 = ()=>(0, $eI5EY.fg)('jira_nav4') && ((0, $6hzdX.getWillShowNav4UserOptOutForDogfooding)() || (0, $eI5EY.fg)('jira_nav4_eap')) || (0, $3z408.getWillShowNav4UserOptOutForVisualRefresh)();
});
parcelRegister("6hzdX", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptOutForDogfooding", ()=>$ec1ebc37a1c8730e$export$9edbe3a98989e15b);
    var $eI5EY = parcelRequire("eI5EY");
    const $ec1ebc37a1c8730e$export$9edbe3a98989e15b = ()=>(0, $eI5EY.fg)('jira_nav4_dogfooding') && ((0, $eI5EY.fg)('jira_nav4_dogfooding_phase-1') || (0, $eI5EY.fg)('jira_nav4_dogfooding_phase-2'));
});
parcelRegister("3z408", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav4UserOptOutForVisualRefresh", ()=>$3d4201e1ff73b82c$export$17e35ae7beae962d);
    var $eI5EY = parcelRequire("eI5EY");
    const $3d4201e1ff73b82c$export$17e35ae7beae962d = ()=>(0, $eI5EY.fg)('visual-refresh') && ((0, $eI5EY.fg)('visual-refresh-dogfood') || (0, $eI5EY.fg)('visual-refresh-eap'));
});
parcelRegister("92kON", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86bb30320a718c7b$export$2e2bcd8739ae039);
    var $90IgZ = parcelRequire("90IgZ");
    var $86bb30320a718c7b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
        sidebarFeedbackButtonLabel: {
            "id": "sidebar-nav4-feedback-button.sidebar-feedback-button-label",
            "defaultMessage": "Give feedback on the new navigation"
        },
        feedbackTitle: {
            "id": "sidebar-nav4-feedback-button.utils.use-nav4-feedback-collector.feedback-title",
            "defaultMessage": "Help us improve the new navigation"
        },
        feedbackTitleDetailsWithLink: {
            "id": "sidebar-nav4-feedback-button.feedback-title-details",
            "defaultMessage": "We\u2019d love to hear about your experience with the new navigation. If needed, <a>you can switch back to the old navigation</a>."
        },
        feedbackTitleDetailsNoLink: {
            "id": "sidebar-nav4-feedback-button.feedback-title-details-no-link",
            "defaultMessage": "We\u2019d love to hear about your experience with the new navigation."
        }
    });
});
parcelRegister("4rBDy", function(module, exports) {
    $parcel$export(module.exports, "PanelSplitter", ()=>$fd52faa640609616$export$db67e3f8d3d6da0f);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $lEfVV = parcelRequire("lEfVV");
    var $8ynlC = parcelRequire("8ynlC");
    var $4oSDA = parcelRequire("4oSDA");
    var $iDwTy = parcelRequire("iDwTy");
    var $1wAEf = parcelRequire("1wAEf");
    var $fWAkH = parcelRequire("fWAkH");
    parcelRequire("iolG1");
    var $dsYXK = parcelRequire("dsYXK");
    parcelRequire("jiH9h");
    var $3CB23 = parcelRequire("3CB23");
    parcelRequire("kAO6F");
    var $3UhgL = parcelRequire("3UhgL");
    var $23gMr = parcelRequire("23gMr");
    var $62Dwb = parcelRequire("62Dwb");
    var $7f6oC = parcelRequire("7f6oC");
    var $bkH0j = parcelRequire("bkH0j");
    var $1LEDt = parcelRequire("1LEDt");
    const $fd52faa640609616$var$containerStyles = {
        root: "_1e0cglyw _kqswstnw _u7coidpf _152tidpf _12ji1r31 _1qu2glyw _12y31o36 _1pbykb7n _181n1ule",
        positionEnd: "_rjxpftgi",
        positionStart: "_1e02zeo2"
    };
    const $fd52faa640609616$var$buttonStyles = {
        grabArea: "_1bsbl52n _4t3i1osq _kqswstnw _1yt4ze3t _syaz3acm _bfhk18uv _v5645ge5 _1lww5cps _d0aluf7j _1gavfnf5 _v0vwaqb7 _30l3aqb7 _1gk412xp _o7ks12xp _9h8h16c2 _1gglglyw",
        content: "_1bsb1osq _4t3i1osq"
    };
    const $fd52faa640609616$var$lineStyles = {
        root: "_kqswstnw _1e0c1ule _1bsbjfq9 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e021v6z"
    };
    const $fd52faa640609616$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, interactionName: interactionName, testId: testId })=>{
        const splitterRef = (0, $eUqFw.useRef)(null);
        const panelSplitterContext = (0, $eUqFw.useContext)((0, $7f6oC.PanelSplitterContext));
        (0, $8ynlC.default)(panelSplitterContext, 'Panel splitter context must be set');
        const { panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, panelRef: panelRef, resizingCssVar: resizingCssVar, portalRef: portalRef, position: position, isEnabled: isEnabled } = panelSplitterContext;
        (0, $8ynlC.default)(portalRef.current, 'Portal ref must be set');
        const direction = (0, $1LEDt.useTextDirection)(portalRef.current);
        (0, $eUqFw.useEffect)(()=>{
            if (!isEnabled) return;
            const splitter = splitterRef.current;
            (0, $8ynlC.default)(splitter, 'Splitter ref must be set');
            return (0, $1wAEf.combine)((0, $iDwTy.fg)('jira_nav4_eap_drop_1') ? (0, $dsYXK.blockDraggingToIFrames)({
                element: splitter
            }) : (0, $4oSDA.default), (0, $fWAkH.draggable)({
                element: splitter,
                onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                    (0, $3CB23.disableNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage
                    });
                    (0, $3UhgL.preventUnhandled).start();
                },
                getInitialData () {
                    (0, $8ynlC.default)(panelRef.current, 'Panel ref must be set');
                    return {
                        initialWidth: (0, $bkH0j.getPixelWidth)(panelRef.current)
                    };
                },
                onDragStart ({ source: source }) {
                    (0, $8ynlC.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                    onResizeStart?.({
                        initialWidth: source.data.initialWidth
                    });
                },
                onDrag ({ location: location, source: source }) {
                    (0, $8ynlC.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                    panelRef.current?.style.setProperty(resizingCssVar, `clamp(${resizeBounds.min}, ${(0, $bkH0j.getWidthFromDragLocation)({
                        initialWidth: source.data.initialWidth,
                        location: location,
                        direction: direction,
                        position: position
                    })}px, ${resizeBounds.max})`);
                },
                onDrop ({ source: source }) {
                    (0, $3UhgL.preventUnhandled).stop();
                    (0, $8ynlC.default)(panelRef.current, 'Panel ref must be set');
                    (0, $8ynlC.default)(typeof source.data.initialWidth === 'number', 'expected initialWidth to be a number');
                    const finalWidth = (0, $bkH0j.getPixelWidth)(panelRef.current);
                    onCompleteResize(finalWidth);
                    onResizeEnd?.({
                        initialWidth: source.data.initialWidth,
                        finalWidth: finalWidth
                    });
                    panelRef.current.style.removeProperty(resizingCssVar);
                }
            }));
        }, [
            onCompleteResize,
            onResizeStart,
            onResizeEnd,
            panelRef,
            resizingCssVar,
            panelWidth,
            resizeBounds,
            direction,
            position,
            isEnabled
        ]);
        if (!isEnabled) return null;
        return (0, $lEfVV.createPortal)($eUqFw.createElement("div", {
            "data-testid": testId ? `${testId}-container` : undefined,
            className: (0, $7JEyt.default)([
                $fd52faa640609616$var$containerStyles.root,
                position === 'start' && $fd52faa640609616$var$containerStyles.positionStart,
                position === 'end' && $fd52faa640609616$var$containerStyles.positionEnd
            ])
        }, $eUqFw.createElement((0, $23gMr.default), {
            style: {
                outline: 'none'
            },
            ref: splitterRef,
            xcss: $fd52faa640609616$var$buttonStyles.grabArea,
            interactionName: interactionName,
            testId: testId
        }, $eUqFw.createElement("div", {
            className: (0, $7JEyt.default)([
                $fd52faa640609616$var$buttonStyles.content
            ])
        }, $eUqFw.createElement((0, $62Dwb.default), null, label), $eUqFw.createElement("span", {
            className: (0, $7JEyt.default)([
                $fd52faa640609616$var$lineStyles.root
            ])
        })))), portalRef.current);
    };
    const $fd52faa640609616$var$ClientOnly = ({ children: children })=>{
        const [hasMounted, setHasMounted] = (0, $eUqFw.useState)(false);
        (0, $eUqFw.useEffect)(()=>{
            setHasMounted(true);
        }, []);
        return $eUqFw.createElement((0, $eUqFw.Fragment), null, hasMounted ? children : null);
    };
    const $fd52faa640609616$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, interactionName: interactionName, testId: testId })=>$eUqFw.createElement($fd52faa640609616$var$ClientOnly, null, $eUqFw.createElement($fd52faa640609616$var$PortaledPanelSplitter, {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            interactionName: interactionName,
            testId: testId
        }));
});
parcelRegister("iolG1", function(module, exports) {
    $parcel$export(module.exports, "blockDraggingToIFrames", ()=>(parcelRequire("dsYXK")).blockDraggingToIFrames);
    var $dsYXK = parcelRequire("dsYXK");
});
parcelRegister("dsYXK", function(module, exports) {
    $parcel$export(module.exports, "blockDraggingToIFrames", ()=>$4a7f722b7dc026b0$export$6ae1d8fab001518c);
    var $lrgWo = parcelRequire("lrgWo");
    var $bqjYC = parcelRequire("bqjYC");
    function $4a7f722b7dc026b0$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
        const originalValue = el.style.getPropertyValue(property);
        const originalPriority = el.style.getPropertyPriority(property);
        el.style.setProperty(property, rule, priority);
        return function cleanup() {
            el.style.setProperty(property, originalValue, originalPriority);
        };
    }
    let $4a7f722b7dc026b0$var$isActive = false;
    function $4a7f722b7dc026b0$var$tryStart() {
        if ($4a7f722b7dc026b0$var$isActive) return;
        $4a7f722b7dc026b0$var$isActive = true;
        const iframeCleanups = Array.from(document.querySelectorAll('iframe')).map((iframe)=>$4a7f722b7dc026b0$var$setStyle(iframe, {
                property: 'pointer-events',
                rule: 'none',
                priority: 'important'
            }));
        const cleanup = (0, $bqjYC.combine)(...iframeCleanups, (0, $lrgWo.monitorForElements)({
            onDrop () {
                cleanup();
            }
        }), function release() {
            $4a7f722b7dc026b0$var$isActive = false;
        });
    }
    function $4a7f722b7dc026b0$export$6ae1d8fab001518c({ element: element }) {
        return (0, $lrgWo.monitorForElements)({
            onGenerateDragPreview ({ source: source }) {
                if (source.element === element) $4a7f722b7dc026b0$var$tryStart();
            }
        });
    }
});
parcelRegister("jiH9h", function(module, exports) {
    $parcel$export(module.exports, "disableNativeDragPreview", ()=>(parcelRequire("3CB23")).disableNativeDragPreview);
    var $3CB23 = parcelRequire("3CB23");
});
parcelRegister("3CB23", function(module, exports) {
    $parcel$export(module.exports, "disableNativeDragPreview", ()=>$06af117590edaebc$export$c588cb30ff3b876e);
    const $06af117590edaebc$var$tinyTransparentImage = (()=>{
        if (typeof window === 'undefined') return null;
        const img = new Image();
        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
        return img;
    })();
    function $06af117590edaebc$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
        if (nativeSetDragImage && $06af117590edaebc$var$tinyTransparentImage) nativeSetDragImage($06af117590edaebc$var$tinyTransparentImage, 0, 0);
    }
});
parcelRegister("kAO6F", function(module, exports) {
    $parcel$export(module.exports, "preventUnhandled", ()=>(parcelRequire("3UhgL")).preventUnhandled);
    var $3UhgL = parcelRequire("3UhgL");
});
parcelRegister("3UhgL", function(module, exports) {
    $parcel$export(module.exports, "preventUnhandled", ()=>$a748d927e4b00889$export$453c0582481cc59d);
    var $74BVL = parcelRequire("74BVL");
    var $haNM2 = parcelRequire("haNM2");
    function $a748d927e4b00889$var$acceptDrop(event) {
        if (event.defaultPrevented) return;
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        event.preventDefault();
    }
    let $a748d927e4b00889$var$unbindEvents = null;
    function $a748d927e4b00889$var$start() {
        $a748d927e4b00889$var$cleanup();
        $a748d927e4b00889$var$unbindEvents = (0, $74BVL.bindAll)(window, [
            {
                type: 'dragover',
                listener: $a748d927e4b00889$var$acceptDrop
            },
            {
                type: 'dragenter',
                listener: $a748d927e4b00889$var$acceptDrop
            },
            {
                type: 'drop',
                listener (event) {
                    event.preventDefault();
                    $a748d927e4b00889$var$cleanup();
                }
            },
            {
                type: 'dragend',
                listener: $a748d927e4b00889$var$cleanup
            },
            ...(0, $haNM2.getBindingsForBrokenDrags)({
                onDragEnd: $a748d927e4b00889$var$cleanup
            })
        ], {
            capture: false
        });
    }
    function $a748d927e4b00889$var$cleanup() {
        $a748d927e4b00889$var$unbindEvents?.();
        $a748d927e4b00889$var$unbindEvents = null;
    }
    function $a748d927e4b00889$var$stop() {
        if (window.event?.type === 'drop') window.event?.preventDefault();
        $a748d927e4b00889$var$cleanup();
    }
    const $a748d927e4b00889$export$453c0582481cc59d = {
        start: $a748d927e4b00889$var$start,
        stop: $a748d927e4b00889$var$stop
    };
});
parcelRegister("bkH0j", function(module, exports) {
    $parcel$export(module.exports, "getWidthFromDragLocation", ()=>$5c693e53ca64bdb5$export$e360234971cb95b8);
    $parcel$export(module.exports, "getPixelWidth", ()=>$5c693e53ca64bdb5$export$d942790ad00c41f9);
    const $5c693e53ca64bdb5$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, direction: direction, position: position })=>{
        const diffX = location.current.input.clientX - location.initial.input.clientX;
        if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
        return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
    };
    const $5c693e53ca64bdb5$export$d942790ad00c41f9 = (element)=>{
        const { width: width } = window.getComputedStyle(element);
        return parseInt(width);
    };
});
parcelRegister("1LEDt", function(module, exports) {
    $parcel$export(module.exports, "useTextDirection", ()=>$f2788565eb574107$export$cf24a79f32f45545);
    var $eUqFw = parcelRequire("eUqFw");
    const $f2788565eb574107$export$cf24a79f32f45545 = (element)=>(0, $eUqFw.useMemo)(()=>{
            const { direction: direction } = window.getComputedStyle(element);
            return direction === 'rtl' ? 'rtl' : 'ltr';
        }, [
            element
        ]);
});
parcelRegister("2D8YV", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$be3f30c8885e888c$export$defe85febe8b728c);
    var $90IgZ = parcelRequire("90IgZ");
    const $be3f30c8885e888c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
        sidebarNavigation: {
            "id": "page-container-v2.common.sidebar.sidebar-navigation",
            "defaultMessage": "Sidebar navigation"
        },
        sideBarPanelSplitterLabel: {
            "id": "page-container-v2.common.sidebar.side-bar-panel-splitter-label",
            "defaultMessage": "Resize side navigation panel"
        }
    });
});
parcelRegister("j6voN", function(module, exports) {
    $parcel$export(module.exports, "AsyncResizeButtonTooltip", ()=>$e7092259f8fc51fc$export$e12f5b3a390577de);
    var $56koX = parcelRequire("56koX");
    const $e7092259f8fc51fc$export$e12f5b3a390577de = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("3Iryw")), {
        ssr: false,
        moduleId: "./src/packages/page-container-v2/src/common/ui/sidebar/resize-button-tooltip/main.tsx"
    });
});
parcelRegister("3Iryw", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("lm6kY").then(()=>parcelRequire('eNPes'));
});
parcelRegister("4LQUt", function(module, exports) {
    $parcel$export(module.exports, "TopNav", ()=>$2934d73e9d5f196a$export$41d0d88a6b0e456f);
    var $eUqFw = parcelRequire("eUqFw");
    var $8fxTv = parcelRequire("8fxTv");
    var $7webZ = parcelRequire("7webZ");
    var $5kDtB = parcelRequire("5kDtB");
    var $iBTyI = parcelRequire("iBTyI");
    var $eDbLL = parcelRequire("eDbLL");
    var $aYtGv = parcelRequire("aYtGv");
    var $c9TLT = parcelRequire("c9TLT");
    var $0cdA8 = parcelRequire("0cdA8");
    var $4qhD6 = parcelRequire("4qhD6");
    var $9zysr = parcelRequire("9zysr");
    var $eQbJ4 = parcelRequire("eQbJ4");
    var $6VKSg = parcelRequire("6VKSg");
    var $6FP8W = parcelRequire("6FP8W");
    var $hwyJ1 = parcelRequire("hwyJ1");
    var $gGtKh = parcelRequire("gGtKh");
    var $inC6u = parcelRequire("inC6u");
    var $jK1pm = parcelRequire("jK1pm");
    var $ghXjN = parcelRequire("ghXjN");
    var $3EdDr = parcelRequire("3EdDr");
    var $7xu2f = parcelRequire("7xu2f");
    const $2934d73e9d5f196a$var$APP_NAVIGATION_TRACE_KEY = 'app_navigation';
    const $2934d73e9d5f196a$var$LegacyPageNavigationStyles = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `
                    #page-body { width: 100vw; max-width: 100%; }
                    #cloneissueprogressform { margin-top: ${(0, $c9TLT.gridSize) * 3}px; }
                    [data-testid="Content"] {margin-top: calc(${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)})!important;}
                    #view-projects-content { margin-top: calc(-1 * ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)}); } /* admin project dir hack */
                `
            }
        });
    const $2934d73e9d5f196a$var$TEST_ID = 'page-layout.top-nav';
    const $2934d73e9d5f196a$var$NewTopNav = ()=>{
        const { shouldRender: shouldRender } = (0, $6VKSg.useTopNavState)();
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "nav4.topNav"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "topNavigationSkipLink",
            packageName: "jiraPageContainerV2",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.TopNavigationSkipLink), null)), (0, ($parcel$interopDefault($eUqFw))).createElement($2934d73e9d5f196a$var$LegacyPageNavigationStyles, null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.TopNavigation), {
            isFixed: true,
            testId: $2934d73e9d5f196a$var$TEST_ID
        }, !false && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iBTyI.AtlassianNavigationStart), null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "navigation.atlassian-navigation",
            packageName: "jiraPageContainerV2",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eDbLL.JiraAtlassianNavigationSkeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7xu2f.AsyncAtlassianNavigation), null)))));
    };
    const $2934d73e9d5f196a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT = 56;
    const $2934d73e9d5f196a$var$OldTopNav = ()=>{
        const fullscreenRef = (0, $eUqFw.useRef)(null);
        const { isFullscreen: isFullscreen } = (0, $eQbJ4.useIsFullscreen)(fullscreenRef.current);
        const { shouldRender: shouldRender } = (0, $6VKSg.useTopNavState)();
        const onFail = (0, $4qhD6.useExperienceFail)({
            experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MAIN)
        });
        const height = isFullscreen ? 0 : $2934d73e9d5f196a$var$HORIZONTAL_GLOBAL_NAV_HEIGHT;
        if (!shouldRender) return null;
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
            name: "top-navigation"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "topNavigationSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.TopNavigationSkipLink), null)), (0, ($parcel$interopDefault($eUqFw))).createElement($2934d73e9d5f196a$var$LegacyPageNavigationStyles, null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3EdDr.ZIndexWrapper), {
            zIndex: (0, $c9TLT.layers).navigation,
            top: (0, $hwyJ1.UNSAFE_DO_NOT_USE_BANNER_HEIGHT),
            "data-fullscreen-id": "fullscreen.page-container-v2.topnav",
            ref: fullscreenRef
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.TopNavigation), {
            isFixed: true,
            height: height,
            id: "ak-jira-navigation"
        }, !false && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iBTyI.AtlassianNavigationStart), null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "navigation.atlassian-navigation",
            packageName: "jiraPageContainer",
            fallback: "flag",
            onError: onFail
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eDbLL.JiraAtlassianNavigationSkeleton), null)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavTopPerformanceMark), {
            metricKey: (0, $7webZ.NAVIGATION_TOP_MARKS).bundleLoadStart
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavTopSSRPerformanceMark), {
            metricKey: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrStart
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
            type: "start",
            traceKey: $2934d73e9d5f196a$var$APP_NAVIGATION_TRACE_KEY
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7xu2f.AsyncAtlassianNavigation), null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
            type: "end",
            traceKey: $2934d73e9d5f196a$var$APP_NAVIGATION_TRACE_KEY
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8fxTv.NavTopSSRPerformanceMark), {
            metricKey: (0, $7webZ.NAVIGATION_TOP_MARKS).renderSsrEnd
        }))))));
    };
    const $2934d73e9d5f196a$export$41d0d88a6b0e456f = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $2934d73e9d5f196a$var$NewTopNav, $2934d73e9d5f196a$var$OldTopNav);
});
parcelRegister("5kDtB", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$e27f7da44da2e940$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "DEFAULT_LOAD_COUNT_FAV", ()=>$e27f7da44da2e940$export$ea341e6cc435ed40);
    $parcel$export(module.exports, "DEFAULT_LOAD_COUNT_VIEWED", ()=>$e27f7da44da2e940$export$cb66c02d110b1531);
    $parcel$export(module.exports, "DEFAULT_LOAD_COUNT_RECENT", ()=>$e27f7da44da2e940$export$22ea57e66775a6b2);
    $parcel$export(module.exports, "TOP_LEVEL_ERROR_BOUNDARY_ID", ()=>$e27f7da44da2e940$export$4766f0c4b6fe35dc);
    $parcel$export(module.exports, "NAVIGATION_ITEM_ID", ()=>$e27f7da44da2e940$export$1a9b265c626e9d44);
    $parcel$export(module.exports, "MODAL_ID", ()=>$e27f7da44da2e940$export$ebdd5a8e5b1c2de5);
    $parcel$export(module.exports, "PROFILE_SPOTLIGHT_KEY", ()=>$e27f7da44da2e940$export$6037915bf3452cf3);
    $parcel$export(module.exports, "HELP_SPOTLIGHT_KEY", ()=>$e27f7da44da2e940$export$286c2faa2103eb9c);
    $parcel$export(module.exports, "SEARCH_SPOTLIGHT_KEY", ()=>$e27f7da44da2e940$export$c0d6ac131d4391b9);
    $parcel$export(module.exports, "PROJECTS_SPOTLIGHT_KEY", ()=>$e27f7da44da2e940$export$8d9442dfaec4086f);
    $parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MAIN", ()=>$e27f7da44da2e940$export$3014c5ec440d8824);
    $parcel$export(module.exports, "EXPERIENCE_NAVIGATION_TOP_MENU", ()=>$e27f7da44da2e940$export$69cbedccc0df48);
    $parcel$export(module.exports, "YOUR_WORK_DROPDOWN_TAB_ID", ()=>$e27f7da44da2e940$export$1935aad1d702494c);
    $parcel$export(module.exports, "JSW_TMP_BACKLOG_BOARD_REGEXP", ()=>$e27f7da44da2e940$export$cc578bc72d7a7308);
    const $e27f7da44da2e940$export$b8b9d90f9e5bd72b = '@atlassian/jira-atlassian-navigation';
    const $e27f7da44da2e940$export$ea341e6cc435ed40 = 15;
    const $e27f7da44da2e940$export$8666f31c8873bff = 10;
    const $e27f7da44da2e940$export$cb66c02d110b1531 = 10;
    const $e27f7da44da2e940$export$22ea57e66775a6b2 = 5;
    const $e27f7da44da2e940$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
    const $e27f7da44da2e940$export$1a9b265c626e9d44 = {
        ADDONS: 'apps',
        CREATE: 'createIssue',
        APP_SWITCHER: 'atlassianSwitcher',
        DASHBOARDS: 'dashboards',
        FILTERS: 'filters',
        HELP: 'help',
        HELP_BADGE: 'helpBadge',
        HOME: 'home',
        INSIGHT: 'insight',
        LOGO: 'productLogo',
        NOTIFICATIONS: 'notifications',
        PEOPLE: 'people',
        PLANS: 'plans',
        PROFILE: 'profile',
        PROJECTS: 'projects',
        ROADMAPS: 'roadmaps',
        SEARCH: 'search',
        SERVICE_HUB: 'services',
        SETTINGS: 'settings',
        SIGN_IN: 'signIn',
        YOUR_WORK_DROPDOWN: 'yourWorkDropdown',
        CONVERSATION_ASSISTANT: 'conversationAssistant'
    };
    const $e27f7da44da2e940$export$ebdd5a8e5b1c2de5 = {
        DASHBOARD_CREATE: 'DASHBOARD_CREATE',
        KEYBOARD_SHORTCUTS: 'keyboard-shortcuts',
        PROJECT_CREATE: 'PROJECT_CREATE'
    };
    const $e27f7da44da2e940$export$6037915bf3452cf3 = 'profile-spotlight';
    const $e27f7da44da2e940$export$286c2faa2103eb9c = 'help-spotlight';
    const $e27f7da44da2e940$export$c0d6ac131d4391b9 = 'search-spotlight';
    const $e27f7da44da2e940$export$8d9442dfaec4086f = 'projects-spotlight';
    const $e27f7da44da2e940$export$3014c5ec440d8824 = 'viewAtlassianNavigation';
    const $e27f7da44da2e940$export$69cbedccc0df48 = 'viewAtlassianNavigationMenu';
    const $e27f7da44da2e940$export$1935aad1d702494c = {
        RECENT: 'RECENT',
        BOARDS: 'BOARDS',
        QUEUES: 'QUEUES',
        ASSIGNED_TO_ME: 'ASSIGNED_TO_ME',
        ADD_FILTER: 'ADD_FILTER',
        ALERTS: 'ALERTS'
    };
    const $e27f7da44da2e940$export$bbaa49b5be375ff3 = 3;
    const $e27f7da44da2e940$export$cc578bc72d7a7308 = /jira\/software\/projects\/[a-zA-Z0-9]+\/boards\/\d+(\/backlog)?/;
    const $e27f7da44da2e940$export$9b8f5a607ecb9c5c = 'com.atlassian.jira.slack';
});
parcelRegister("iBTyI", function(module, exports) {
    $parcel$export(module.exports, "AtlassianNavigationStart", ()=>$27c6c05e2b688f95$export$831e6a6e875b5ef8);
    var $eUqFw = parcelRequire("eUqFw");
    var $bDhRl = parcelRequire("bDhRl");
    var $kIY50 = parcelRequire("kIY50");
    var $lcJyp = parcelRequire("lcJyp");
    var $3O0Td = parcelRequire("3O0Td");
    var $lB25E = parcelRequire("lB25E");
    var $5kDtB = parcelRequire("5kDtB");
    const $27c6c05e2b688f95$export$831e6a6e875b5ef8 = ()=>{
        const [{ location: location }] = (0, $lB25E.useRouter)();
        const [, { setAppStartWithAppId: setAppStartWithAppId }] = (0, $lcJyp.useSpaStateActions)();
        const pageId = (0, $3O0Td.usePageId)();
        const startRef = (0, $eUqFw.useRef)({
            location: location,
            startTime: Date.now()
        });
        (0, $eUqFw.useMemo)(()=>{
            if (location !== startRef.current.location) startRef.current = {
                location: location,
                startTime: Date.now()
            };
        }, [
            location
        ]);
        (0, $eUqFw.useLayoutEffect)(()=>{
            setAppStartWithAppId((0, $9c22638d2f17f9db$export$3a54edb6ba4daa82), startRef.current.startTime);
        }, [
            location,
            setAppStartWithAppId
        ]);
        return (0, $kIY50.getWillShowNav3)() && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $bDhRl.ExperienceStart), {
            experience: (0, $5kDtB.EXPERIENCE_NAVIGATION_TOP_MAIN),
            analyticsSource: "atlassian-navigation",
            experienceId: pageId
        });
    };
});
parcelRegister("kIY50", function(module, exports) {
    $parcel$export(module.exports, "getWillShowNav3", ()=>$21a9edbc09b4006b$export$23a7d978e17f1720);
    var $6FP8W = parcelRequire("6FP8W");
    const $21a9edbc09b4006b$export$23a7d978e17f1720 = ()=>!(0, $6FP8W.getWillShowNav4)();
});
parcelRegister("eDbLL", function(module, exports) {
    $parcel$export(module.exports, "JiraAtlassianNavigationSkeleton", ()=>$dcd9958c5ab18a6d$export$38e532bc6b824200);
    var $eUqFw = parcelRequire("eUqFw");
    var $1ppKi = parcelRequire("1ppKi");
    var $i4dIm = parcelRequire("i4dIm");
    var $lStiz = parcelRequire("lStiz");
    const $dcd9958c5ab18a6d$export$38e532bc6b824200 = ()=>{
        const theme = (0, $lStiz.useTheme)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $i4dIm.default), {
            name: "top-navigation"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $1ppKi.NavigationSkeleton), {
            theme: theme
        }));
    };
});
parcelRegister("1ppKi", function(module, exports) {
    $parcel$export(module.exports, "NavigationSkeleton", ()=>$b6542f7547e52f1f$export$ad5e8e6ace98cc2);
    var $byn9U = parcelRequire("byn9U");
    var $etyk7 = parcelRequire("etyk7");
    var $5Ykgt = parcelRequire("5Ykgt");
    var $4FWRP = parcelRequire("4FWRP");
    var $2SqJO = parcelRequire("2SqJO");
    var $8YzMi = parcelRequire("8YzMi");
    var $5CxUK = parcelRequire("5CxUK");
    var $1Vny2 = parcelRequire("1Vny2");
    function $b6542f7547e52f1f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b6542f7547e52f1f$var$containerStyles = (0, $byn9U.css)({
        display: 'flex',
        boxSizing: 'border-box',
        height: (0, $b156b847c373c90e$export$30fa7cc5f2690a43),
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
        borderBlockEnd: `1px solid ${`var(--ds-border, ${(0, $207acf722dcd432b$export$3e51e8f1440314ba)})`}`,
        paddingInlineEnd: "var(--ds-space-150, 12px)",
        paddingInlineStart: "var(--ds-space-150, 12px)"
    });
    const $b6542f7547e52f1f$var$leftStyles = {
        name: "vtikxo",
        styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
    };
    const $b6542f7547e52f1f$var$rightStyles = {
        name: "1mwlrd6",
        styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
    };
    const $b6542f7547e52f1f$export$ad5e8e6ace98cc2 = ({ primaryItemsCount: primaryItemsCount = 4, secondaryItemsCount: secondaryItemsCount = 4, theme: theme = (0, $etyk7.defaultTheme), showSiteName: showSiteName = false, shouldShowSearch: shouldShowSearch = true, testId: testId })=>{
        return (0, $byn9U.jsx)((0, $5Ykgt.ThemeProvider), {
            value: theme
        }, (0, $byn9U.jsx)("div", {
            style: theme.mode.navigation,
            css: $b6542f7547e52f1f$var$containerStyles,
            "data-testid": testId
        }, (0, $byn9U.jsx)("div", {
            css: $b6542f7547e52f1f$var$leftStyles
        }, (0, $byn9U.jsx)((0, $4FWRP.IconButtonSkeleton), {
            marginLeft: 0,
            marginRight: 5,
            size: 26
        }), (0, $byn9U.jsx)((0, $8YzMi.ProductHomeSkeleton), {
            showSiteName: showSiteName
        }), (0, $byn9U.jsx)((0, $2SqJO.PrimaryItemsContainerSkeleton), {
            count: primaryItemsCount
        })), (0, $byn9U.jsx)("div", {
            css: $b6542f7547e52f1f$var$rightStyles
        }, shouldShowSearch && (0, $byn9U.jsx)((0, $1Vny2.SearchSkeleton), null), Array.from({
            length: secondaryItemsCount
        }, (_, index)=>(0, $byn9U.jsx)((0, $4FWRP.IconButtonSkeleton), {
                key: index,
                marginLeft: 0,
                marginRight: 4,
                size: 26
            })), (0, $byn9U.jsx)((0, $5CxUK.ProfileSkeleton), null))));
    };
    var $b6542f7547e52f1f$export$2e2bcd8739ae039 = $b6542f7547e52f1f$export$ad5e8e6ace98cc2;
});
const $b156b847c373c90e$export$30fa7cc5f2690a43 = 56;
const $b156b847c373c90e$export$4033a111ca79977d = 1280;
const $b156b847c373c90e$export$24ec62cee78b7042 = 1130;
const $b156b847c373c90e$export$d8bde68ac946124f = '--ds--ans--fbc';
const $b156b847c373c90e$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $b156b847c373c90e$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $b156b847c373c90e$export$d81606c1fc5119bc = '--ds--ans--c';
const $b156b847c373c90e$export$65f656ad520ea71 = '--ds--ans--bc';
parcelRegister("4FWRP", function(module, exports) {
    $parcel$export(module.exports, "IconButtonSkeleton", ()=>$92df0d2b349380e3$export$7a24471cb6f25433);
    var $byn9U = parcelRequire("byn9U");
    var $aUZbY = parcelRequire("aUZbY");
    function $92df0d2b349380e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $92df0d2b349380e3$var$buttonHeight = "var(--ds-space-400, 32px)";
    const $92df0d2b349380e3$var$skeletonStyles = {
        name: "28gj0e",
        styles: "border-radius:var(--ds-border-radius-circle, 50%);opacity:0.15"
    };
    const $92df0d2b349380e3$export$7a24471cb6f25433 = ({ className: className, marginLeft: marginLeft, marginRight: marginRight, size: size })=>{
        const theme = (0, $aUZbY.useTheme)();
        const dynamicStyles = {
            marginLeft: typeof marginLeft === 'number' ? marginLeft : "var(--ds-space-050, 4px)",
            marginRight: typeof marginRight === 'number' ? marginRight : 0,
            width: typeof size === 'number' ? size : $92df0d2b349380e3$var$buttonHeight,
            height: typeof size === 'number' ? size : $92df0d2b349380e3$var$buttonHeight,
            ...theme.mode.skeleton
        };
        return (0, $byn9U.jsx)("div", {
            className: className,
            style: dynamicStyles,
            css: $92df0d2b349380e3$var$skeletonStyles
        });
    };
});
parcelRegister("2SqJO", function(module, exports) {
    $parcel$export(module.exports, "PrimaryItemsContainerSkeleton", ()=>$87f1575f052daec0$export$fdfc48d2117b79a8);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $9nHzI = parcelRequire("9nHzI");
    function $87f1575f052daec0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $87f1575f052daec0$var$primaryButtonSkeletonStyles = {
        name: "yn5kop",
        styles: "margin-inline-end:var(--ds-space-150, 12px);margin-inline-start:var(--ds-space-150, 12px)"
    };
    const $87f1575f052daec0$export$fdfc48d2117b79a8 = (0, $eUqFw.memo)(({ count: count })=>(0, $byn9U.jsx)((0, $eUqFw.Fragment), null, Array.from({
            length: count
        }, (_, index)=>(0, $byn9U.jsx)((0, $9nHzI.PrimaryButtonSkeleton), {
                key: index,
                css: $87f1575f052daec0$var$primaryButtonSkeletonStyles
            }))));
});
parcelRegister("9nHzI", function(module, exports) {
    $parcel$export(module.exports, "PrimaryButtonSkeleton", ()=>$fe92c97ffd191431$export$4bc51fe36728414d);
    var $byn9U = parcelRequire("byn9U");
    var $aUZbY = parcelRequire("aUZbY");
    const $fe92c97ffd191431$var$paddingAll = 4;
    const $fe92c97ffd191431$var$buttonHeight = 32;
    const $fe92c97ffd191431$var$skeletonStyles = (0, $byn9U.css)({
        display: 'inline-flex',
        width: '68px',
        height: `${$fe92c97ffd191431$var$buttonHeight - $fe92c97ffd191431$var$paddingAll * 2.5}px`,
        borderRadius: "var(--ds-border-radius, 4px)",
        opacity: 0.15
    });
    const $fe92c97ffd191431$export$4bc51fe36728414d = (props)=>{
        const theme = (0, $aUZbY.useTheme)();
        return (0, $byn9U.jsx)("div", {
            style: theme.mode.skeleton,
            css: $fe92c97ffd191431$var$skeletonStyles,
            className: props.className
        });
    };
});
parcelRegister("8YzMi", function(module, exports) {
    $parcel$export(module.exports, "ProductHomeSkeleton", ()=>$0a744699fcbc4b31$export$3e79e535d76cce4b);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $aUZbY = parcelRequire("aUZbY");
    var $6vHjL = parcelRequire("6vHjL");
    const $0a744699fcbc4b31$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
    const $0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
    const $0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
    const $0a744699fcbc4b31$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
    const $0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
    const $0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
    const $0a744699fcbc4b31$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
    const $0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
    const $0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
    const $0a744699fcbc4b31$var$VAR_SITE_TITLE_BG_COLOR_AFTER = '--site-title-bg-color-after';
    const $0a744699fcbc4b31$var$productHomeButtonStyles = (0, $byn9U.css)({
        display: 'flex',
        padding: "var(--ds-space-050, 4px)",
        alignItems: 'center',
        background: 'none',
        border: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        color: 'inherit',
        cursor: 'pointer',
        '&::-moz-focus-inner': {
            border: 0
        },
        '&:first-of-type': {
            marginInlineStart: 0
        },
        '&:active': {
            backgroundColor: `var(${$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
            boxShadow: `var(${$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
            color: `var(${$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
        },
        '&:focus': {
            backgroundColor: `var(${$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
            boxShadow: `var(${$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS})`,
            color: `var(${$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
            outline: 0
        },
        '&:hover': {
            backgroundColor: `var(${$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
            boxShadow: `var(${$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
            color: `var(${$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
        },
        'div&': {
            pointerEvents: 'none'
        },
        [`@media (max-width: ${(0, $b156b847c373c90e$export$4033a111ca79977d) - 0.1}px)`]: {
            margin: `0 ${"var(--ds-space-100, 8px)"}`
        },
        [`@media (min-width: ${0, $b156b847c373c90e$export$4033a111ca79977d}px)`]: {
            margin: `0 ${"var(--ds-space-200, 16px)"}`
        }
    });
    const $0a744699fcbc4b31$var$productLogoStyles = (0, $byn9U.css)({
        display: 'flex',
        width: 120,
        maxWidth: 120,
        height: 24,
        maxHeight: 28,
        opacity: 0.15,
        '& > *': {
            maxHeight: 24
        },
        [`@media (max-width: ${(0, $b156b847c373c90e$export$4033a111ca79977d) - 0.1}px)`]: {
            display: 'none'
        }
    });
    const $0a744699fcbc4b31$var$productIconStyles = (0, $byn9U.css)({
        display: 'flex',
        width: 28,
        height: 28,
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        opacity: 0.15,
        '& > *': {
            maxHeight: 24
        },
        [`@media (min-width: ${0, $b156b847c373c90e$export$4033a111ca79977d}px)`]: {
            display: 'none'
        }
    });
    const $0a744699fcbc4b31$var$siteTitleStyles = (0, $byn9U.css)({
        display: 'flex',
        width: "var(--ds-space-500, 40px)",
        alignItems: 'center',
        backgroundColor: 'transparent',
        marginInlineEnd: "var(--ds-space-050, 4px)",
        marginInlineStart: "var(--ds-space-050, 4px)",
        paddingInlineEnd: "var(--ds-space-200, 16px)",
        '&:after': {
            width: '100%',
            height: 14,
            backgroundColor: `var(${$0a744699fcbc4b31$var$VAR_SITE_TITLE_BG_COLOR_AFTER})`,
            borderRadius: "var(--ds-border-radius, 4px)",
            content: '""'
        }
    });
    const $0a744699fcbc4b31$export$3e79e535d76cce4b = ({ showSiteName: showSiteName })=>{
        const theme = (0, $aUZbY.useTheme)();
        const primaryButton = theme.mode.primaryButton;
        const productHomeButtonDynamicStyles = (0, $6vHjL.stripEmptyProperties)({
            [$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
            [$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
            [$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
            [$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
            [$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
            [$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
            [$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
            [$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
            [$0a744699fcbc4b31$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
            [$0a744699fcbc4b31$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
        });
        const siteTitleDynamicStyles = {
            borderRight: theme.mode.productHome.borderRight,
            opacity: theme.mode.skeleton.opacity,
            [$0a744699fcbc4b31$var$VAR_SITE_TITLE_BG_COLOR_AFTER]: theme.mode.skeleton.backgroundColor
        };
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("div", {
            style: productHomeButtonDynamicStyles,
            css: $0a744699fcbc4b31$var$productHomeButtonStyles
        }, (0, $byn9U.jsx)("div", {
            style: theme.mode.skeleton,
            css: $0a744699fcbc4b31$var$productLogoStyles
        }), (0, $byn9U.jsx)("div", {
            style: theme.mode.skeleton,
            css: $0a744699fcbc4b31$var$productIconStyles
        })), showSiteName && (0, $byn9U.jsx)("div", {
            style: siteTitleDynamicStyles,
            css: $0a744699fcbc4b31$var$siteTitleStyles
        }));
    };
});
parcelRegister("5CxUK", function(module, exports) {
    $parcel$export(module.exports, "ProfileSkeleton", ()=>$50dc2e2f1383fe64$export$2bab43fd33adda3b);
    var $eUqFw = parcelRequire("eUqFw");
    var $4FWRP = parcelRequire("4FWRP");
    const $50dc2e2f1383fe64$export$2bab43fd33adda3b = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $4FWRP.IconButtonSkeleton), {
            marginLeft: 6,
            marginRight: 6,
            size: 26
        });
});
parcelRegister("1Vny2", function(module, exports) {
    $parcel$export(module.exports, "SearchSkeleton", ()=>$cc804610a4dbf9f3$export$d8fbade3e5bbb8e0);
    var $eUqFw = parcelRequire("eUqFw");
    var $byn9U = parcelRequire("byn9U");
    var $aUZbY = parcelRequire("aUZbY");
    var $4FWRP = parcelRequire("4FWRP");
    const $cc804610a4dbf9f3$var$searchInputContainerStyles = (0, $byn9U.css)({
        marginRight: "var(--ds-space-100, 8px)",
        marginLeft: "var(--ds-space-250, 20px)",
        position: 'relative',
        [`@media (max-width: ${(0, $b156b847c373c90e$export$24ec62cee78b7042) - 1}px)`]: {
            display: 'none !important'
        }
    });
    const $cc804610a4dbf9f3$var$searchInputSkeletonStyles = (0, $byn9U.css)({
        boxSizing: 'border-box',
        width: '220px',
        height: "var(--ds-space-400, 32px)",
        padding: `0 ${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-500, 40px)"}`,
        borderRadius: "var(--ds-border-radius-200, 6px)",
        opacity: 0.15
    });
    const $cc804610a4dbf9f3$var$searchIconStyles = (0, $byn9U.css)({
        [`@media (min-width: ${0, $b156b847c373c90e$export$24ec62cee78b7042}px)`]: {
            display: 'none !important'
        }
    });
    const $cc804610a4dbf9f3$export$d8fbade3e5bbb8e0 = ()=>{
        const theme = (0, $aUZbY.useTheme)();
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("div", {
            css: $cc804610a4dbf9f3$var$searchInputContainerStyles
        }, (0, $byn9U.jsx)("div", {
            style: theme.mode.skeleton,
            css: $cc804610a4dbf9f3$var$searchInputSkeletonStyles
        })), (0, $byn9U.jsx)((0, $4FWRP.IconButtonSkeleton), {
            css: $cc804610a4dbf9f3$var$searchIconStyles,
            marginRight: 5,
            size: 26
        }));
    };
});
parcelRegister("lStiz", function(module, exports) {
    $parcel$export(module.exports, "useTheme", ()=>$d56434d06e6d3c92$export$93d4e7f90805808f);
    var $eUqFw = parcelRequire("eUqFw");
    var $4Zowo = parcelRequire("4Zowo");
    var $lrUL4 = parcelRequire("lrUL4");
    var $fjjRQ = parcelRequire("fjjRQ");
    var $7fSR6 = parcelRequire("7fSR6");
    var $3MEW8 = parcelRequire("3MEW8");
    var $hS368 = parcelRequire("hS368");
    var $3jHKg = parcelRequire("3jHKg");
    const $d56434d06e6d3c92$var$caseInsensitiveEquals = (one, two)=>one.toLowerCase() === two.toLowerCase();
    const $d56434d06e6d3c92$var$calculateBackground = (backgroundColor, isDarkMode)=>{
        if ($d56434d06e6d3c92$var$caseInsensitiveEquals(backgroundColor, '#ffffff')) {
            const fallback = isDarkMode ? '#1d2125' : '#ffffff';
            return (0, $lrUL4.default)('elevation.surface', fallback);
        }
        return isDarkMode ? (0, $3jHKg.capLightness)(backgroundColor, 35) : backgroundColor;
    };
    const $d56434d06e6d3c92$var$useIsDarkThemeResolver = ()=>{
        const { colorMode: colorMode } = (0, $fjjRQ.default)();
        const { theme: preference } = (0, $3MEW8.useThemePreference)();
        return false ? preference === 'dark' : colorMode === 'dark';
    };
    const $d56434d06e6d3c92$export$93d4e7f90805808f = ()=>{
        const [{ navigationTheme: { usesCustomColours: usesCustomColours, backgroundColor: backgroundColor, highlightColor: highlightColor } }] = (0, $7fSR6.useTheme)();
        const isDarkMode = $d56434d06e6d3c92$var$useIsDarkThemeResolver();
        const bg = (0, $eUqFw.useMemo)(()=>$d56434d06e6d3c92$var$calculateBackground(backgroundColor, isDarkMode), [
            backgroundColor,
            isDarkMode
        ]);
        (0, $eUqFw.useEffect)(()=>{
            (0, $hS368.addThemeColor)(bg);
        }, [
            bg
        ]);
        if (!usesCustomColours) return undefined;
        return (0, $4Zowo.generateTheme)({
            name: 'jira',
            backgroundColor: bg,
            highlightColor: highlightColor
        });
    };
});
parcelRegister("3MEW8", function(module, exports) {
    $parcel$export(module.exports, "themePreferenceResource", ()=>$aa9979c4bb771fd9$export$e5a423d1eb1cf1d0);
    $parcel$export(module.exports, "useThemePreference", ()=>$aa9979c4bb771fd9$export$3416635c8aeb5bab);
    var $eUqFw = parcelRequire("eUqFw");
    var $jMP2a = parcelRequire("jMP2a");
    var $1inzG = parcelRequire("1inzG");
    var $lB25E = parcelRequire("lB25E");
    var $YWIXh = parcelRequire("YWIXh");
    const $aa9979c4bb771fd9$var$getDataLoader = ()=>(parcelRequire("6OpTH"));
    const $aa9979c4bb771fd9$export$e5a423d1eb1cf1d0 = (0, $lB25E.createResource)({
        type: 'RESOURCE_THEME_PREFERENCE',
        getKey: ()=>'state',
        getDataLoader: $aa9979c4bb771fd9$var$getDataLoader,
        maxAge: 300000
    });
    const $aa9979c4bb771fd9$export$3416635c8aeb5bab = ()=>{
        const { data: data, update: updateThemePreferenceResource } = (0, $lB25E.useResource)($aa9979c4bb771fd9$export$e5a423d1eb1cf1d0);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        const fireThemeAnalytics = (0, $eUqFw.useCallback)((current, next)=>{
            const OStheme = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
            const analyticsEvent = createAnalyticsEvent({
                action: (0, $6f1b3f4a1b1409cf$export$89c5cf64ad15c3ea),
                actionSubject: (0, $6f1b3f4a1b1409cf$export$9e2cc65718a61846)
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                newPreference: next,
                oldPreference: current,
                OStheme: OStheme
            });
        }, [
            createAnalyticsEvent
        ]);
        const setTheme = (0, $eUqFw.useCallback)(async (theme)=>{
            updateThemePreferenceResource(()=>({
                    theme: theme
                }));
            if (data?.theme !== theme) {
                fireThemeAnalytics(data?.theme, theme);
                await (0, $YWIXh.setThemePreference)(theme);
            }
        }, [
            data?.theme,
            updateThemePreferenceResource,
            fireThemeAnalytics
        ]);
        return {
            theme: data?.theme,
            setTheme: setTheme
        };
    };
});
const $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27 = 'jira.user.theme.preference';
const $6f1b3f4a1b1409cf$export$9e2cc65718a61846 = 'themePreference';
const $6f1b3f4a1b1409cf$export$89c5cf64ad15c3ea = 'changed';
parcelRegister("YWIXh", function(module, exports) {
    $parcel$export(module.exports, "setThemePreference", ()=>$31ba3788a5049b63$export$a6b84eebd33787e2);
    $parcel$export(module.exports, "getThemePreference", ()=>$31ba3788a5049b63$export$2f7a12048d96237);
    var $eM3G3 = parcelRequire("eM3G3");
    var $guiFP = parcelRequire("guiFP");
    var $cm5m0 = parcelRequire("cm5m0");
    const $31ba3788a5049b63$export$a6b84eebd33787e2 = (theme)=>{
        const promise = (0, $cm5m0.userPreferenceAPI).set((0, $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27), theme);
        promise.catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: error,
                attributes: {
                    op: 'put',
                    errName: String(error.name),
                    statusCode: error.statusCode,
                    param: `to:${theme}`
                }
            });
        });
        return promise;
    };
    const $31ba3788a5049b63$export$2f7a12048d96237 = async ()=>{
        const promise = (0, $cm5m0.userPreferenceAPI).get((0, $6f1b3f4a1b1409cf$export$40bd77e1c9f49c27));
        promise.catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: error,
                attributes: {
                    op: 'get',
                    errName: String(error.name),
                    statusCode: error.statusCode
                }
            });
        });
        promise.then((theme)=>{
            if (theme && !(0, $eM3G3.ThemeOptions).includes(theme)) (0, $guiFP.default)({
                meta: {
                    id: 'ThemePreferenceCRUD',
                    packageName: 'jiraRouterResourcesThemePreference'
                },
                error: new Error('Unrecognized theme!'),
                attributes: {
                    op: 'get',
                    theme: theme,
                    errName: 'unrecognized value!'
                }
            });
        });
        const theme = await promise;
        return theme && (0, $eM3G3.ThemeOptions).includes(theme) ? theme : undefined;
    };
});
parcelRegister("eM3G3", function(module, exports) {
    $parcel$export(module.exports, "ThemeOptions", ()=>$65da877bf2b17a02$export$abe7936539cefefe);
    $parcel$export(module.exports, "DEFAULT_THEME", ()=>$65da877bf2b17a02$export$2faeed762aac6741);
    const $65da877bf2b17a02$export$abe7936539cefefe = [
        'light',
        'dark',
        'auto'
    ];
    const $65da877bf2b17a02$export$2faeed762aac6741 = 'light';
});
parcelRegister("cm5m0", function(module, exports) {
    $parcel$export(module.exports, "userPreferenceAPI", ()=>$65cd88220f00e257$export$4f7929ca6b50a436);
    var $lRmyA = parcelRequire("lRmyA");
    const $65cd88220f00e257$var$url = (key)=>`/rest/api/3/mypreferences?key=${key}`;
    const $65cd88220f00e257$var$get = async (key)=>{
        try {
            const result = await (0, $lRmyA.performGetRequest)($65cd88220f00e257$var$url(key));
            return result?.value;
        } catch (error) {
            if (error.statusCode === (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef)) return null;
            throw error;
        }
    };
    const $65cd88220f00e257$var$set = (key, value)=>(0, $lRmyA.performPutRequest)($65cd88220f00e257$var$url(key), {
            body: JSON.stringify({
                value: value
            })
        });
    const $65cd88220f00e257$var$remove = (key)=>(0, $lRmyA.performDeleteRequest)($65cd88220f00e257$var$url(key));
    const $65cd88220f00e257$export$4f7929ca6b50a436 = {
        get: $65cd88220f00e257$var$get,
        set: $65cd88220f00e257$var$set,
        remove: $65cd88220f00e257$var$remove
    };
});
parcelRegister("6OpTH", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("8mnLk")
    ]).then(()=>parcelRequire('foRwS'));
});
parcelRegister("hS368", function(module, exports) {
    $parcel$export(module.exports, "addThemeColor", ()=>$d4990bb3ca3a777b$export$7b20d133831b2b0f);
    const $d4990bb3ca3a777b$var$getMetaNode = (name)=>document.querySelector(`meta[name="${name}"]`);
    const $d4990bb3ca3a777b$var$getHead = ()=>document.head || document.querySelector('head');
    const $d4990bb3ca3a777b$export$7b20d133831b2b0f = (content)=>{
        if (!content || typeof document === 'undefined' || false) return;
        const existingMeta = $d4990bb3ca3a777b$var$getMetaNode('theme-color');
        const meta = document.createElement('meta');
        meta.name = 'theme-color';
        meta.content = content;
        if (existingMeta) existingMeta.replaceWith?.(meta);
        else {
            const head = $d4990bb3ca3a777b$var$getHead();
            if (head) head.appendChild?.(meta);
        }
    };
});
parcelRegister("3jHKg", function(module, exports) {
    $parcel$export(module.exports, "capLightness", ()=>$a436962de231d459$export$8b5544bab97b10dd);
    const $a436962de231d459$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
    const $a436962de231d459$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
    const $a436962de231d459$var$rgbFromHex = (input)=>{
        const fullHex = $a436962de231d459$var$expandShorthandHex(input);
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
        return result === null ? null : {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        };
    };
    const $a436962de231d459$var$rgbToHex = ({ r: r, g: g, b: b })=>{
        const convertComponent = (c)=>{
            const cBase16 = c.toString(16);
            return cBase16.length === 1 ? `0${cBase16}` : cBase16;
        };
        return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
    };
    const $a436962de231d459$var$rgbToXyz = (rgb)=>{
        const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
        const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
        const r = convertRgbComponent(rgb.r / 255);
        const g = convertRgbComponent(rgb.g / 255);
        const b = convertRgbComponent(rgb.b / 255);
        return {
            x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
            y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
            z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
        };
    };
    const $a436962de231d459$var$xyzToLab = ({ x: x, y: y, z: z })=>({
            l: Math.max(116 * y - 16, 0),
            a: 500 * (x - y),
            b: 200 * (y - z)
        });
    const $a436962de231d459$var$labToLch = ({ l: l, a: a, b: b })=>{
        let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
        const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
        if (Math.round(c * 10000) === 0) h = Number.NaN;
        return {
            l: l,
            c: c,
            h: h
        };
    };
    const $a436962de231d459$var$lchToLab = ({ l: l, c: c, h: h })=>{
        const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
        return {
            l: l,
            a: Math.cos(convertH) * c,
            b: Math.sin(convertH) * c
        };
    };
    const $a436962de231d459$var$labToXyz = ({ l: l, a: a, b: b })=>{
        const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
        const y = (l + 16) / 116;
        const x = a / 500 + y;
        const z = y - b / 200;
        return {
            x: convertComponent(x) * 0.95047,
            y: convertComponent(y),
            z: convertComponent(z) * 1.08883
        };
    };
    const $a436962de231d459$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
        const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
        return {
            r: $a436962de231d459$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
            g: $a436962de231d459$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
            b: $a436962de231d459$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
        };
    };
    const $a436962de231d459$var$rgbToLch = (rgb)=>$a436962de231d459$var$labToLch($a436962de231d459$var$xyzToLab($a436962de231d459$var$rgbToXyz(rgb)));
    const $a436962de231d459$var$lchToRgb = (lch)=>$a436962de231d459$var$xyzToRgb($a436962de231d459$var$labToXyz($a436962de231d459$var$lchToLab(lch)));
    const $a436962de231d459$export$8b5544bab97b10dd = (color, capPercent)=>{
        const rgb = $a436962de231d459$var$rgbFromHex(color);
        if (rgb === null) return color;
        const lch = $a436962de231d459$var$rgbToLch(rgb);
        if (lch.l > capPercent) lch.l = $a436962de231d459$var$clamp(capPercent, 0, 100);
        return $a436962de231d459$var$rgbToHex($a436962de231d459$var$lchToRgb(lch));
    };
});
parcelRegister("aYtGv", function(module, exports) {
    $parcel$export(module.exports, "PAGE_LAYOUT_OFFSET_TOP", ()=>$479507d87baa6502$export$d60454526e2281af);
    var $75Bx4 = parcelRequire("75Bx4");
    const $479507d87baa6502$export$d60454526e2281af = `(${(0, $75Bx4.TOP_NAVIGATION_HEIGHT)} + ${(0, $75Bx4.BANNER_HEIGHT)})`;
});
parcelRegister("eQbJ4", function(module, exports) {
    $parcel$export(module.exports, "useIsFullscreen", ()=>$1ce3a272474e08c0$export$d397eccea5f37b0a);
    var $eUqFw = parcelRequire("eUqFw");
    const $1ce3a272474e08c0$var$fullscreenClassnameExists = (target)=>target?.classList.contains('fullscreen') ?? false;
    const $1ce3a272474e08c0$export$d397eccea5f37b0a = (target)=>{
        const [isFullscreen, setIsFullscreen] = (0, $eUqFw.useState)(false);
        (0, $eUqFw.useEffect)(()=>{
            const handleFullscreen = ()=>{
                setIsFullscreen($1ce3a272474e08c0$var$fullscreenClassnameExists(target));
            };
            const mutationObserver = new MutationObserver(handleFullscreen);
            if (target) mutationObserver.observe(target, {
                attributes: true
            });
            return ()=>mutationObserver.disconnect();
        }, [
            target
        ]);
        return {
            isFullscreen: isFullscreen
        };
    };
});
parcelRegister("6VKSg", function(module, exports) {
    $parcel$export(module.exports, "useTopNavState", ()=>$f37199ef443364d1$export$bccbd45ab793bd09);
    var $WBLbN = parcelRequire("WBLbN");
    var $53ucm = parcelRequire("53ucm");
    const $f37199ef443364d1$var$useTopNav = (0, $WBLbN.createHook)((0, $53ucm.layoutStore), {
        selector: (state)=>({
                ...state.topNavigation,
                shouldRender: !state.isChromeless
            })
    });
    const $f37199ef443364d1$export$bccbd45ab793bd09 = ()=>{
        const [state] = $f37199ef443364d1$var$useTopNav();
        return state;
    };
});
parcelRegister("7xu2f", function(module, exports) {
    $parcel$export(module.exports, "AsyncAtlassianNavigation", ()=>$050373c2603582df$export$932edb7b1b20d079);
    var $eUqFw = parcelRequire("eUqFw");
    var $iWLL0 = parcelRequire("iWLL0");
    var $gC7XG = parcelRequire("gC7XG");
    var $cernH = parcelRequire("cernH");
    var $eDbLL = parcelRequire("eDbLL");
    var $hknOo = parcelRequire("hknOo");
    var $1FAd1 = parcelRequire("1FAd1");
    var $8R80x = parcelRequire("8R80x");
    var $10fdS = parcelRequire("10fdS");
    var $2B87Z = parcelRequire("2B87Z");
    const $050373c2603582df$export$932edb7b1b20d079 = ()=>{
        const isUsingEntryPoint = Boolean((0, $10fdS.useCurrentRoute)().entryPoint?.());
        const topNavEntryPointReference = (0, $1FAd1.usePageLayoutEntryPoint)((0, $d619e185f38e9ae8$export$bec6dca2e63de4ae));
        (0, $eUqFw.useState)(()=>{
            if (!false && isUsingEntryPoint) (0, $gC7XG.topNavigationEntryPoint).root.onComplete(()=>{
                (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
                const resources = performance.getEntriesByType('mark');
                for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $hknOo.JS_EVAL_START))) {
                    (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                    break;
                }
            });
            return undefined;
        });
        return isUsingEntryPoint ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholder), {
            name: "top_navigation_skeleton",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eDbLL.JiraAtlassianNavigationSkeleton), null),
            entryPoint: (0, $gC7XG.topNavigationEntryPoint)
        }, topNavEntryPointReference ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
            entryPointReference: topNavEntryPointReference,
            props: {}
        }) : null) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cernH.LazyAtlassianNavigation), null);
    };
});
parcelRegister("gC7XG", function(module, exports) {
    $parcel$export(module.exports, "topNavigationEntryPoint", ()=>$cb57489a3376471c$export$f780be9e138f456f);
    var $1ydNb = parcelRequire("1ydNb");
    var $6TOES = parcelRequire("6TOES");
    const $cb57489a3376471c$export$f780be9e138f456f = (0, $6TOES.createEntryPoint)({
        root: (0, $1ydNb.JSResourceForInteraction)(()=>(parcelRequire("72E3S")), {
            moduleId: "1f1265b4"
        }),
        getPreloadProps: (extraProps)=>({
                extraProps: extraProps
            })
    });
});
parcelRegister("72E3S", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("h49zL")
    ]).then(()=>parcelRequire('krHYB'));
});
parcelRegister("cernH", function(module, exports) {
    $parcel$export(module.exports, "LazyAtlassianNavigation", ()=>$d0ff8bb7dfb6147e$export$4caed23aa0274abb);
    var $56koX = parcelRequire("56koX");
    var $hknOo = parcelRequire("hknOo");
    var $2B87Z = parcelRequire("2B87Z");
    const $d0ff8bb7dfb6147e$export$4caed23aa0274abb = (0, $56koX.lazyForPaint)(()=>{
        const bundleReady = (parcelRequire("cQOow"));
        if (!false) bundleReady.then(()=>{
            (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.bundle-ready', 'jira-spa.js:eval-stop');
            const resources = performance.getEntriesByType('mark');
            for(let i = resources.length - 1; i >= 0; i -= 1)if ((resources[i].name.startsWith('async-navigation') || resources[i].name.startsWith('async-atlassian-navigation')) && resources[i].name.endsWith((0, $hknOo.JS_EVAL_START))) {
                (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('navigation-primary.eval', resources[i].name);
                break;
            }
        });
        return bundleReady;
    }, {
        moduleId: "./src/packages/navigation-apps/atlassian-navigation/src/index.tsx"
    });
});
parcelRegister("cQOow", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("BfK1C")
    ]).then(()=>parcelRequire('6OKpM'));
});
parcelRegister("fpQ73", function(module, exports) {
    $parcel$export(module.exports, "FullHeight", ()=>$634ce2a022efa5f0$export$33e617ec5e4e4f76);
    var $eUqFw = parcelRequire("eUqFw");
    const $634ce2a022efa5f0$var$styleFullHeight = {
        height: '100vh'
    };
    const $634ce2a022efa5f0$export$33e617ec5e4e4f76 = ({ children: children })=>(0, ($parcel$interopDefault($eUqFw))).createElement("div", {
            style: $634ce2a022efa5f0$var$styleFullHeight
        }, children);
});
parcelRegister("1cu0z", function(module, exports) {
    $parcel$export(module.exports, "ThemeSetter", ()=>$d6a0f9f1b975c5d3$export$ce1303eaa27a0d3a);
    var $eUqFw = parcelRequire("eUqFw");
    var $cbs5e = parcelRequire("cbs5e");
    var $fjjRQ = parcelRequire("fjjRQ");
    var $gpo0r = parcelRequire("gpo0r");
    var $3FyZ4 = parcelRequire("3FyZ4");
    var $3MEW8 = parcelRequire("3MEW8");
    var $lB25E = parcelRequire("lB25E");
    const $d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery = window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
    const $d6a0f9f1b975c5d3$var$GlobalThemeSetter = ()=>{
        const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)((0, $3MEW8.themePreferenceResource));
        const { colorMode: colorMode } = (0, $fjjRQ.default)();
        const [isThemeStylesInHead, setIsThemeStylesInHead] = (0, $eUqFw.useState)(false);
        const setThemeWithToken = (0, $eUqFw.useCallback)(async (theme)=>{
            if (theme !== colorMode) {
                const { loadThemeTokens: loadThemeTokens } = await (parcelRequire("f8DlR"));
                loadThemeTokens(theme);
            }
        }, [
            colorMode
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (loading || error || !data) return undefined;
            if (data?.theme === 'auto') {
                setThemeWithToken($d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light');
                const handler = (e)=>{
                    setThemeWithToken(e.matches ? 'dark' : 'light');
                };
                $d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery?.addEventListener('change', handler);
                return ()=>{
                    $d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery?.removeEventListener('change', handler);
                };
            }
            if (data?.theme === 'dark' || data?.theme === 'light') setThemeWithToken(data?.theme);
            if (!data?.theme) {
                document.documentElement.removeAttribute('data-theme');
                document.documentElement.removeAttribute('data-color-mode');
            }
            return undefined;
        }, [
            data,
            loading,
            error,
            setThemeWithToken
        ]);
        (0, $eUqFw.useEffect)(()=>{
            if (loading || error || !data) return;
            (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                if (data?.theme) client.setUIViewedAttributes({
                    theme: data.theme
                });
                else client.removeUIViewedAttribute('theme');
            });
        }, [
            data,
            loading,
            error
        ]);
        (0, $eUqFw.useEffect)(()=>{
            (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                client.setUIViewedAttributes({
                    OStheme: $d6a0f9f1b975c5d3$var$darkThemeMediaMatchQuery?.matches ? 'dark' : 'light'
                });
            });
        }, []);
        (0, $eUqFw.useEffect)(()=>{
            if (document.head.querySelector('style[data-theme]')) setIsThemeStylesInHead(true);
        }, []);
        if (!data?.theme || !data?.attrs || !data?.styles) return null;
        const ssrAutoScript = (0, $cbs5e.default)(data.theme);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, !isThemeStylesInHead ? data.styles.map((theme)=>(0, ($parcel$interopDefault($eUqFw))).createElement("style", {
                key: theme.id,
                ...theme.attrs,
                dangerouslySetInnerHTML: {
                    __html: theme.css
                }
            })) : null, (0, ($parcel$interopDefault($eUqFw))).createElement("script", {
            "data-defer-skip": true,
            dangerouslySetInnerHTML: {
                __html: data.styles.map((theme)=>`document.head.appendChild(document.body.querySelector('style[data-theme="${theme.id}"]'));`).join('\n')
            }
        }), (0, ($parcel$interopDefault($eUqFw))).createElement("script", {
            "data-defer-skip": true,
            dangerouslySetInnerHTML: {
                __html: Object.entries(data.attrs).map(([key, val])=>{
                    if (key === 'data-color-mode' && ssrAutoScript) return '';
                    return `document.documentElement.setAttribute("${key}", "${val}");`;
                }).join('\n')
            }
        }), ssrAutoScript ? (0, ($parcel$interopDefault($eUqFw))).createElement("script", {
            "data-defer-skip": true,
            dangerouslySetInnerHTML: {
                __html: ssrAutoScript
            }
        }) : null);
    };
    const $d6a0f9f1b975c5d3$export$ce1303eaa27a0d3a = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement($d6a0f9f1b975c5d3$var$GlobalThemeSetter, null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gpo0r.ThemeSetter), null));
});
parcelRegister("cbs5e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b07298559882541f$export$2e2bcd8739ae039);
    var $iDwTy = parcelRequire("iDwTy");
    var $1e6Pr = parcelRequire("1e6Pr");
    var $2sAUE = parcelRequire("2sAUE");
    const $b07298559882541f$var$getSSRAutoScript = (colorMode, contrastMode)=>{
        if (colorMode !== 'auto' && contrastMode !== 'auto') return undefined;
        const setColorMode = colorMode === 'auto' ? `\n  try {
    const darkModeMql = window.matchMedia('${0, $2sAUE.darkModeMediaQuery}');
    const colorMode = darkModeMql.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('${0, $1e6Pr.COLOR_MODE_ATTRIBUTE}', colorMode);
  } catch (e) {}` : '';
        const setContrastMode = contrastMode === 'auto' && (0, $iDwTy.fg)('platform_increased-contrast-themes') ? `\n  try {
    const contrastModeMql = window.matchMedia('${0, $2sAUE.moreContrastMediaQuery}');
    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';
    document.documentElement.setAttribute('${0, $1e6Pr.CONTRAST_MODE_ATTRIBUTE}', contrastMode);
  } catch (e) {}` : '';
        return `(() => {${setColorMode}${setContrastMode}})()`;
    };
    var $b07298559882541f$export$2e2bcd8739ae039 = $b07298559882541f$var$getSSRAutoScript;
});
parcelRegister("gpo0r", function(module, exports) {
    $parcel$export(module.exports, "ThemeSetter", ()=>$76ce003e44f43d6d$export$ce1303eaa27a0d3a);
    var $eUqFw = parcelRequire("eUqFw");
    var $3K2Fs = parcelRequire("3K2Fs");
    var $4EvIi = parcelRequire("4EvIi");
    var $4e72F = parcelRequire("4e72F");
    var $bcnRH = parcelRequire("bcnRH");
    var $exb0h = parcelRequire("exb0h");
    var $6FP8W = parcelRequire("6FP8W");
    var $10fdS = parcelRequire("10fdS");
    const $76ce003e44f43d6d$export$ce1303eaa27a0d3a = ()=>{
        const projectTheme = (0, $4EvIi.useProjectTheme)();
        const overviewTheme = (0, $3K2Fs.useOverviewTheme)();
        const route = (0, $10fdS.useCurrentRoute)();
        const entityTheme = (0, $eUqFw.useMemo)(()=>{
            let result = projectTheme ?? overviewTheme;
            if (result != null) {
                const isFormSubmitView = route.name === (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT) || route.name === (0, $exb0h.ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED);
                if (isFormSubmitView) result = {
                    ...result,
                    themeSetting: null
                };
            }
            return result;
        }, [
            projectTheme,
            overviewTheme,
            route.name
        ]);
        if ((0, $6FP8W.getWillShowNav4)()) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $bcnRH.ThemeContainer), {
            isGlobal: true,
            entityTheme: entityTheme
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4e72F.ThemeTokensSetter), null));
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, entityTheme != null && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $bcnRH.ThemeContainerOld), {
            isGlobal: true,
            ...entityTheme
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4e72F.ThemeTokensSetter), null));
    };
});
parcelRegister("3K2Fs", function(module, exports) {
    $parcel$export(module.exports, "useOverviewTheme", ()=>$88bfa969a9a43feb$export$a55763fd17eab357);
    var $kar7l = parcelRequire("kar7l");
    var $fzymf = parcelRequire("fzymf");
    const $88bfa969a9a43feb$export$a55763fd17eab357 = ()=>{
        const { data: data } = (0, $fzymf.useOverview)();
        if (data != null) return {
            themeSetting: {
                type: 'color',
                value: data.theme ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name
            },
            entityId: `overview/${data.id}`
        };
        return null;
    };
});
parcelRegister("kar7l", function(module, exports) {
    $parcel$export(module.exports, "STAR_ICON_COLOR", ()=>$15099970f99feec5$export$9e0962e0cb41695d);
    $parcel$export(module.exports, "Variables", ()=>$15099970f99feec5$export$8bb9d79ea938efc9);
    $parcel$export(module.exports, "Tokens", ()=>$15099970f99feec5$export$8e1e81ac145e31be);
    $parcel$export(module.exports, "BASE_THEME", ()=>$15099970f99feec5$export$8a6e9b3370a0f87a);
    $parcel$export(module.exports, "HIGH_BRIGHTNESS_THEME", ()=>$15099970f99feec5$export$f286efa6bd1e8f9d);
    $parcel$export(module.exports, "LOW_BRIGHTNESS_THEME", ()=>$15099970f99feec5$export$97cb21c6432e07e8);
    $parcel$export(module.exports, "GRADIENT_THEME", ()=>$15099970f99feec5$export$b124f62a6aab972);
    $parcel$export(module.exports, "IMAGE_BACKGROUND_CONFIG", ()=>$15099970f99feec5$export$9441e0d8f766c59a);
    $parcel$export(module.exports, "NO_BACKGROUND_CONFIG", ()=>$15099970f99feec5$export$4c351ec1dc290344);
    $parcel$export(module.exports, "BACKGROUND_CONFIGS_OLD", ()=>$15099970f99feec5$export$34373eced7ee212e);
    $parcel$export(module.exports, "BACKGROUND_COLOR_CONFIGS", ()=>$15099970f99feec5$export$5ddfadab7b1e12c1);
    $parcel$export(module.exports, "SOLID_COLOR_BACKGROUND_CONFIGS", ()=>$15099970f99feec5$export$349e5dbeac874253);
    $parcel$export(module.exports, "GRADIENT_BACKGROUND_CONFIGS", ()=>$15099970f99feec5$export$242b2d2213fedf27);
    $parcel$export(module.exports, "OLD_TO_NEW_BACKGROUND_CONFIG_MAP", ()=>$15099970f99feec5$export$fe05a238062e2c3d);
    $parcel$export(module.exports, "DEFAULT_BACKGROUND_CONFIG", ()=>$15099970f99feec5$export$cab9d853866386f2);
    $parcel$export(module.exports, "BANNER_HEIGHT", ()=>$15099970f99feec5$export$ed7cc0d417ee89e);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_PADDING", ()=>$15099970f99feec5$export$8e357501548afe78);
    $parcel$export(module.exports, "HORIZONTAL_NAV_HEIGHT", ()=>$15099970f99feec5$export$baaf8255c30ea280);
    $parcel$export(module.exports, "BUSINESS_NAV_HEIGHT", ()=>$15099970f99feec5$export$d9035bc768f8226d);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_HEIGHT", ()=>$15099970f99feec5$export$4810531e30462f89);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$15099970f99feec5$export$1c0b806722927549);
    $parcel$export(module.exports, "NAV4_HORIZONTAL_NAV_HEIGHT", ()=>$15099970f99feec5$export$2af5673c2fa63c55);
    $parcel$export(module.exports, "NAV4_BUSINESS_NAV_HEIGHT", ()=>$15099970f99feec5$export$5771162cdeebfb85);
    $parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_HEIGHT", ()=>$15099970f99feec5$export$a1626d6d785092a2);
    $parcel$export(module.exports, "NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$15099970f99feec5$export$410e3d6221a052e);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_HORIZONTAL_NAV_HEIGHT", ()=>$15099970f99feec5$export$8588194807a0ca4b);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_NAV_HEIGHT", ()=>$15099970f99feec5$export$254a8b23553b7df3);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_WRAPPER_HEIGHT", ()=>$15099970f99feec5$export$41cffad47189e5bd);
    $parcel$export(module.exports, "NAV4_HIGH_TAB_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT", ()=>$15099970f99feec5$export$ef343e01db40c562);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WIDTH", ()=>$15099970f99feec5$export$77cdace62a821419);
    $parcel$export(module.exports, "BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH", ()=>$15099970f99feec5$export$3efe68325dd9dc02);
    var $75Bx4 = parcelRequire("75Bx4");
    var $aYtGv = parcelRequire("aYtGv");
    const $15099970f99feec5$export$b8b9d90f9e5bd72b = 'jiraBusinessThemeConstants';
    const $15099970f99feec5$export$9e0962e0cb41695d = '#FFAB00';
    const $15099970f99feec5$export$8bb9d79ea938efc9 = {
        BACKDROP_FILTER: '--jwm-backdrop-filter',
        COLOR_BACKGROUND_BRAND_BOLD: '--jwm-color-background-brand-bold',
        COLOR_BACKGROUND_BRAND_BOLD_HOVERED: '--jwm-color-background-brand-bold-hovered',
        COLOR_BACKGROUND_BRAND_BOLD_PRESSED: '--jwm-color-background-brand-bold-pressed',
        COLOR_BACKGROUND_DISABLED: '--jwm-color-background-disabled',
        COLOR_BACKGROUND_INPUT: '--jwm-background-input',
        COLOR_BACKGROUND_NEUTRAL: '--jwm-background-neutral',
        COLOR_BACKGROUND_NEUTRAL_HOVERED: '--jwm-background-neutral-hovered',
        COLOR_BACKGROUND_NEUTRAL_PRESSED: '--jwm-background-neutral-pressed',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: '--jwm-background-neutral-subtle-hovered',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: '--jwm-background-neutral-subtle-pressed',
        COLOR_BACKGROUND_SELECTED: '--jwm-background-selected',
        COLOR_BORDER: '--jwm-color-border',
        COLOR_BORDER_INPUT: '--jwm-color-border-input',
        COLOR_BORDER_INVERSE: '--jwm-color-border-inverse',
        COLOR_BORDER_SELECTED: '--jwm-color-border-selected',
        COLOR_ELEVATION_SURFACE: '--jwm-color-elevation-surface',
        COLOR_ICON_DANGER: '--jwm-color-icon-danger',
        COLOR_ICON_INFORMATION: '--jwm-color-icon-information',
        COLOR_ICON_SUCCESS: '--jwm-color-icon-success',
        COLOR_ICON_WARNING: '--jwm-color-icon-warning',
        COLOR_LINK: '--jwm-color-link',
        COLOR_LINK_PRESSED: '--jwm-color-link-pressed',
        COLOR_SKELETON: '--jwm-skeleton',
        COLOR_TEXT: '--jwm-color-text',
        COLOR_TEXT_DISABLED: '--jwm-color-text-disabled',
        COLOR_TEXT_INVERSE: '--jwm-color-text-inverse',
        COLOR_TEXT_SELECTED: '--jwm-color-text-selected',
        COLOR_TEXT_SUBTLE: '--jwm-color-text-subtle',
        COLOR_TEXT_SUBTLEST: '--jwm-color-text-subtlest',
        CONTENT_HEIGHT: '--jwm-content-height',
        CONTENT_WIDTH: '--jwm-content-width',
        ELEVATION_SURFACE: '--jwm-elevation-surface',
        ELEVATION_SURFACE_CONTRAST: '--jwm-elevation-surface-contrast',
        ELEVATION_SURFACE_CONTRAST_BOLDER: '--jwm-elevation-surface-contrast-bolder',
        WRAPPER_BACKGROUND: '--jwm-wrapper-background',
        WRAPPER_BORDER_RADIUS: '--jwm-wrapper-border-radius',
        WRAPPER_HEIGHT: '--jwm-wrapper-height',
        WRAPPER_PADDING: '--jwm-wrapper-padding',
        WRAPPER_WIDTH: '--jwm-wrapper-width'
    };
    const $15099970f99feec5$export$8e1e81ac145e31be = {
        BACKDROP_FILTER: 'var(--jwm-backdrop-filter)',
        COLOR_BACKGROUND_BRAND_BOLD: 'var(--jwm-color-background-brand-bold)',
        COLOR_BACKGROUND_BRAND_BOLD_HOVERED: 'var(--jwm-color-background-brand-bold-hovered)',
        COLOR_BACKGROUND_BRAND_BOLD_PRESSED: 'var(--jwm-color-background-brand-bold-pressed)',
        COLOR_BACKGROUND_DISABLED: 'var(--jwm-color-background-disabled)',
        COLOR_BACKGROUND_INPUT: 'var(--jwm-background-input)',
        COLOR_BACKGROUND_NEUTRAL: 'var(--jwm-background-neutral)',
        COLOR_BACKGROUND_NEUTRAL_HOVERED: 'var(--jwm-background-neutral-hovered)',
        COLOR_BACKGROUND_NEUTRAL_PRESSED: 'var(--jwm-background-neutral-pressed)',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED: 'var(--jwm-background-neutral-subtle-hovered)',
        COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED: 'var(--jwm-background-neutral-subtle-pressed)',
        COLOR_BACKGROUND_SELECTED: 'var(--jwm-background-selected)',
        COLOR_BORDER: 'var(--jwm-color-border)',
        COLOR_BORDER_INPUT: 'var(--jwm-color-border-input)',
        COLOR_BORDER_INVERSE: 'var(--jwm-color-border-inverse)',
        COLOR_BORDER_SELECTED: 'var(--jwm-color-border-selected)',
        COLOR_ELEVATION_SURFACE: 'var(--jwm-color-elevation-surface)',
        COLOR_ICON_DANGER: 'var(--jwm-color-icon-danger)',
        COLOR_ICON_INFORMATION: 'var(--jwm-color-icon-information)',
        COLOR_ICON_SUCCESS: 'var(--jwm-color-icon-success)',
        COLOR_ICON_WARNING: 'var(--jwm-color-icon-warning)',
        COLOR_LINK: 'var(--jwm-color-link)',
        COLOR_LINK_PRESSED: 'var(--jwm-color-link-pressed)',
        COLOR_SKELETON: 'var(--jwm-skeleton)',
        COLOR_TEXT: 'var(--jwm-color-text)',
        COLOR_TEXT_DISABLED: 'var(--jwm-color-text-disabled)',
        COLOR_TEXT_INVERSE: 'var(--jwm-color-text-inverse)',
        COLOR_TEXT_SELECTED: 'var(--jwm-color-text-selected)',
        COLOR_TEXT_SUBTLE: 'var(--jwm-color-text-subtle)',
        COLOR_TEXT_SUBTLEST: 'var(--jwm-color-text-subtlest)',
        CONTENT_HEIGHT: 'var(--jwm-content-height)',
        CONTENT_WIDTH: 'var(--jwm-content-width)',
        ELEVATION_SURFACE: 'var(--jwm-elevation-surface)',
        ELEVATION_SURFACE_CONTRAST: 'var(--jwm-elevation-surface-contrast)',
        ELEVATION_SURFACE_CONTRAST_BOLDER: 'var(--jwm-elevation-surface-contrast-bolder)',
        WRAPPER_BACKGROUND: 'var(--jwm-wrapper-background)',
        WRAPPER_BORDER_RADIUS: 'var(--jwm-wrapper-border-radius)',
        WRAPPER_HEIGHT: 'var(--jwm-wrapper-height)',
        WRAPPER_PADDING: 'var(--jwm-wrapper-padding)',
        WRAPPER_WIDTH: 'var(--jwm-wrapper-width)'
    };
    const $15099970f99feec5$export$8a6e9b3370a0f87a = {
        'color.background.brand.bold': "var(--ds-background-brand-bold, #09326C)",
        'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0C66E4)",
        'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #09326C)",
        'color.background.disabled': "var(--ds-background-disabled, #091E4208)",
        'color.background.input': `var(--ds-background-input, ${(0, $207acf722dcd432b$exports).N0})`,
        'color.background.neutral': `var(--ds-background-neutral, ${(0, $207acf722dcd432b$exports).N30A})`,
        'color.background.neutral.hovered': `var(--ds-background-neutral-hovered, ${(0, $207acf722dcd432b$exports).N40A})`,
        'color.background.neutral.pressed': `var(--ds-background-neutral-pressed, ${(0, $207acf722dcd432b$exports).N50A})`,
        'color.background.neutral.subtle.hovered': `var(--ds-background-neutral-subtle-hovered, ${(0, $207acf722dcd432b$exports).N40A})`,
        'color.background.neutral.subtle.pressed': `var(--ds-background-neutral-subtle-pressed, ${(0, $207acf722dcd432b$exports).N50A})`,
        'color.background.selected': `var(--ds-background-selected, ${(0, $207acf722dcd432b$exports).B400})`,
        'color.elevation.surface': `var(--ds-surface, ${(0, $207acf722dcd432b$exports).N0})`,
        'color.border': `var(--ds-border, ${(0, $207acf722dcd432b$exports).N40A})`,
        'color.border.input': "var(--ds-border-input, #091E4224)",
        'color.border.inverse': `var(--ds-border-inverse, ${(0, $207acf722dcd432b$exports).N0})`,
        'color.border.selected': `var(--ds-border-selected, ${(0, $207acf722dcd432b$exports).B400})`,
        'color.icon.danger': `var(--ds-icon-danger, ${(0, $207acf722dcd432b$exports).R200})`,
        'color.icon.information': `var(--ds-icon-information, ${(0, $207acf722dcd432b$exports).B200})`,
        'color.icon.success': `var(--ds-icon-success, ${(0, $207acf722dcd432b$exports).G200})`,
        'color.icon.warning': `var(--ds-icon-warning, ${(0, $207acf722dcd432b$exports).Y200})`,
        'color.link': "var(--ds-link, #0c66e4)",
        'color.link.pressed': "var(--ds-link-pressed, #0055cc)",
        'color.skeleton': `var(--ds-background-neutral, ${(0, $207acf722dcd432b$exports).N20A})`,
        'color.text': `var(--ds-text, ${(0, $207acf722dcd432b$exports).N800})`,
        'color.text.disabled': "var(--ds-text-disabled, #091E424F)",
        'color.text.inverse': `var(--ds-text-inverse, ${(0, $207acf722dcd432b$exports).N0})`,
        'color.text.selected': `var(--ds-text-selected, ${(0, $207acf722dcd432b$exports).B400})`,
        'color.text.subtle': `var(--ds-text-subtle, ${(0, $207acf722dcd432b$exports).N500})`,
        'color.text.subtlest': "var(--ds-text-subtlest, #626f86)",
        'elevation.surface.contrast': 'transparent',
        'elevation.surface.contrast.bolder': 'transparent'
    };
    const $15099970f99feec5$export$f286efa6bd1e8f9d = {
        'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
        'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
        'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
        'color.background.disabled': "var(--ds-background-neutral, #091E420F)",
        'color.background.input': 'rgba(255, 255, 255, 0.8)',
        'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
        'color.text.selected': `var(--ds-text-inverse, ${(0, $207acf722dcd432b$exports).N0})`
    };
    const $15099970f99feec5$export$97cb21c6432e07e8 = {
        'color.background.brand.bold': 'rgba(255, 255, 255, 0.8)',
        'color.background.brand.bold.hovered': 'rgba(255, 255, 255, 0.6)',
        'color.background.brand.bold.pressed': 'rgba(255, 255, 255, 0.4)',
        'color.background.disabled': 'rgba(255, 255, 255, 0.08)',
        'color.background.input': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral.hovered': 'rgba(255, 255, 255, 0.16)',
        'color.background.neutral.pressed': 'rgba(255, 255, 255, 0.28)',
        'color.background.neutral.subtle.hovered': 'rgba(255, 255, 255, 0.08)',
        'color.background.neutral.subtle.pressed': 'rgba(255, 255, 255, 0.16)',
        'color.background.selected': 'rgba(255, 255, 255, 0.6)',
        'color.elevation.surface': '#172b4d',
        'color.border': 'rgba(255, 255, 255, 0.14)',
        'color.border.input': 'rgba(255, 255, 255, 0.3)',
        'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
        'color.border.selected': (0, $207acf722dcd432b$exports).N0,
        'color.icon.danger': (0, $207acf722dcd432b$exports).N0,
        'color.icon.information': (0, $207acf722dcd432b$exports).N0,
        'color.icon.success': (0, $207acf722dcd432b$exports).N0,
        'color.icon.warning': (0, $207acf722dcd432b$exports).N0,
        'color.skeleton': 'rgba(255,255,255,0.08)',
        'color.text': (0, $207acf722dcd432b$exports).N0,
        'color.text.disabled': 'rgba(255, 255, 255, 0.6)',
        'color.text.inverse': '#172B4D',
        'color.text.selected': '#172B4D',
        'color.text.subtle': 'rgba(255, 255, 255, 0.8)',
        'color.text.subtlest': 'rgba(255, 255, 255, 0.8)'
    };
    const $15099970f99feec5$export$b124f62a6aab972 = {
        'color.link': '#CCE0FF',
        'color.link.pressed': '#E9F2FF'
    };
    const $15099970f99feec5$export$9441e0d8f766c59a = {
        name: 'image',
        brightness: 'high',
        theme: {
            light: {
                'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #626F86)",
                'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
                'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
                'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #2C3E5D)",
                'color.link': "var(--ds-text-accent-blue-bolder, #09326C)",
                'color.link.pressed': "var(--ds-text-accent-blue, #0055CC)",
                'color.text.selected': `var(--ds-text-inverse, ${(0, $207acf722dcd432b$exports).N0})`,
                'elevation.surface.contrast': 'rgba(255,255,255,0.82)',
                'elevation.surface.contrast.bolder': `var(--ds-surface, ${(0, $207acf722dcd432b$exports).N0})`
            },
            dark: {
                'color.background.brand.bold': "var(--ds-background-accent-gray-bolder, #8C9BAB)",
                'color.background.brand.bold.hovered': "var(--ds-background-accent-gray-bolder-hovered, #9FADBC)",
                'color.background.brand.bold.pressed': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
                'color.background.input': 'rgba(34, 39, 43, 0.8)',
                'color.background.selected': "var(--ds-background-accent-gray-bolder-pressed, #B6C2CF)",
                'color.elevation.surface': '#172b4d',
                'color.border': 'rgba(255, 255, 255, 0.14)',
                'color.border.input': 'rgba(255, 255, 255, 0.3)',
                'color.border.inverse': 'rgba(255, 255, 255, 0.3)',
                'color.icon.danger': (0, $207acf722dcd432b$exports).N0,
                'color.icon.information': (0, $207acf722dcd432b$exports).N0,
                'color.icon.success': (0, $207acf722dcd432b$exports).N0,
                'color.icon.warning': (0, $207acf722dcd432b$exports).N0,
                'color.link': "var(--ds-text-accent-blue-bolder, #CCE0FF)",
                'color.link.pressed': "var(--ds-text-accent-blue, #85B8FF)",
                'color.skeleton': 'rgba(255,255,255,0.8)',
                'color.text': (0, $207acf722dcd432b$exports).N0,
                'color.text.selected': "var(--ds-text-inverse, #1D2125)",
                'elevation.surface.contrast': 'rgba(29, 33, 37, 0.82)',
                'elevation.surface.contrast.bolder': "var(--ds-surface, #1D2125)"
            }
        }
    };
    const $15099970f99feec5$var$WHITE_BACKGROUND_CONFIG = {
        name: 'white'
    };
    const $15099970f99feec5$var$LIGHT_PURPLE_BACKGROUND_CONFIG = {
        name: 'light-purple'
    };
    const $15099970f99feec5$var$LIGHT_BLUE_BACKGROUND_CONFIG = {
        name: 'light-blue'
    };
    const $15099970f99feec5$var$LIGHT_TEAL_BACKGROUND_CONFIG = {
        name: 'light-teal'
    };
    const $15099970f99feec5$var$LIGHT_GREEN_BACKGROUND_CONFIG = {
        name: 'light-green'
    };
    const $15099970f99feec5$var$LIGHT_YELLOW_BACKGROUND_CONFIG = {
        name: 'light-yellow'
    };
    const $15099970f99feec5$var$LIGHT_RED_BACKGROUND_CONFIG = {
        name: 'light-red'
    };
    const $15099970f99feec5$var$LIGHT_MAGENTA_BACKGROUND_CONFIG = {
        name: 'light-magenta'
    };
    const $15099970f99feec5$var$LIGHT_ORANGE_BACKGROUND_CONFIG = {
        name: 'light-orange'
    };
    const $15099970f99feec5$var$DARK_BACKGROUND_CONFIG = {
        name: 'dark'
    };
    const $15099970f99feec5$var$PURPLE_BACKGROUND_CONFIG = {
        name: 'purple'
    };
    const $15099970f99feec5$var$BLUE_BACKGROUND_CONFIG = {
        name: 'blue'
    };
    const $15099970f99feec5$var$TEAL_BACKGROUND_CONFIG = {
        name: 'teal'
    };
    const $15099970f99feec5$var$GREEN_BACKGROUND_CONFIG = {
        name: 'green'
    };
    const $15099970f99feec5$var$YELLOW_BACKGROUND_CONFIG = {
        name: 'yellow'
    };
    const $15099970f99feec5$var$RED_BACKGROUND_CONFIG = {
        name: 'red'
    };
    const $15099970f99feec5$var$MAGENTA_BACKGROUND_CONFIG = {
        name: 'magenta'
    };
    const $15099970f99feec5$var$ORANGE_BACKGROUND_CONFIG = {
        name: 'orange'
    };
    const $15099970f99feec5$var$DARKER_GRAY_BACKGROUND_CONFIG = {
        name: 'darker-gray',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG = {
        name: 'darker-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            },
            dark: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG = {
        name: 'darker-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            },
            dark: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG = {
        name: 'darker-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            },
            dark: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG = {
        name: 'darker-green',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            },
            dark: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $15099970f99feec5$var$DARKER_LIME_BACKGROUND_CONFIG = {
        name: 'darker-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            },
            dark: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG = {
        name: 'darker-yellow',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            },
            dark: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG = {
        name: 'darker-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            },
            dark: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG = {
        name: 'darker-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            },
            dark: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG = {
        name: 'darker-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            },
            dark: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG = {
        name: 'darkest-gray',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            },
            dark: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $15099970f99feec5$var$DARKEST_PURPLE_BACKGROUND_CONFIG = {
        name: 'darkest-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            },
            dark: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $15099970f99feec5$var$DARKEST_BLUE_BACKGROUND_CONFIG = {
        name: 'darkest-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            },
            dark: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $15099970f99feec5$var$DARKEST_TEAL_BACKGROUND_CONFIG = {
        name: 'darkest-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            },
            dark: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $15099970f99feec5$var$DARKEST_GREEN_BACKGROUND_CONFIG = {
        name: 'darkest-green',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            },
            dark: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $15099970f99feec5$var$DARKEST_LIME_BACKGROUND_CONFIG = {
        name: 'darkest-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            },
            dark: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $15099970f99feec5$var$DARKEST_YELLOW_BACKGROUND_CONFIG = {
        name: 'darkest-yellow',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            },
            dark: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $15099970f99feec5$var$DARKEST_ORANGE_BACKGROUND_CONFIG = {
        name: 'darkest-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            },
            dark: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $15099970f99feec5$var$DARKEST_RED_BACKGROUND_CONFIG = {
        name: 'darkest-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            },
            dark: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $15099970f99feec5$var$DARKEST_MAGENTA_BACKGROUND_CONFIG = {
        name: 'darkest-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            },
            dark: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTEST_GRAY_BACKGROUND_CONFIG = {
        name: 'lightest-gray',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F1F2F4',
                'color.link': '#44546F',
                'color.link.pressed': '#091E42'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG = {
        name: 'lightest-purple',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F3F0FF',
                'color.link': '#5E4DB2',
                'color.link.pressed': '#352C63'
            },
            dark: {
                'color.elevation.surface': '#5E4DB2',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG = {
        name: 'lightest-blue',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#E9F2FF',
                'color.link': '#0055CC',
                'color.link.pressed': '#09326C'
            },
            dark: {
                'color.elevation.surface': '#0055CC',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG = {
        name: 'lightest-teal',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#E7F9FF',
                'color.link': '#206A83',
                'color.link.pressed': '#164555'
            },
            dark: {
                'color.elevation.surface': '#206A83',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG = {
        name: 'lightest-green',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DCFFF1',
                'color.link': '#216E4E',
                'color.link.pressed': '#164B35'
            },
            dark: {
                'color.elevation.surface': '#216E4E',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTEST_LIME_BACKGROUND_CONFIG = {
        name: 'lightest-lime',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#EFFFD6',
                'color.link': '#4C6B1F',
                'color.link.pressed': '#37471F'
            },
            dark: {
                'color.elevation.surface': '#4C6B1F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG = {
        name: 'lightest-yellow',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFF7D6',
                'color.link': '#7F5F01',
                'color.link.pressed': '#533F04'
            },
            dark: {
                'color.elevation.surface': '#7F5F01',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG = {
        name: 'lightest-orange',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFF3EB',
                'color.link': '#A54800',
                'color.link.pressed': '#702E00'
            },
            dark: {
                'color.elevation.surface': '#A54800',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG = {
        name: 'lightest-red',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFECEB',
                'color.link': '#AE2E24',
                'color.link.pressed': '#5D1F1A'
            },
            dark: {
                'color.elevation.surface': '#AE2E24',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG = {
        name: 'lightest-magenta',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFECF8',
                'color.link': '#943D73',
                'color.link.pressed': '#50253F'
            },
            dark: {
                'color.elevation.surface': '#943D73',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTER_GRAY_BACKGROUND_CONFIG = {
        name: 'lighter-gray',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DCDFE4',
                'color.link': '#44546F',
                'color.link.pressed': '#091E42'
            },
            dark: {
                'color.elevation.surface': '#172B4D',
                'color.link': '#F1F2F4',
                'color.link.pressed': '#F7F8F9'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTER_PURPLE_BACKGROUND_CONFIG = {
        name: 'lighter-purple',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#DFD8FD',
                'color.link': '#5E4DB2',
                'color.link.pressed': '#352C63'
            },
            dark: {
                'color.elevation.surface': '#352C63',
                'color.link': '#DFD8FD',
                'color.link.pressed': '#F3F0FF'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTER_BLUE_BACKGROUND_CONFIG = {
        name: 'lighter-blue',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#CCE0FF',
                'color.link': '#0055CC',
                'color.link.pressed': '#09326C'
            },
            dark: {
                'color.elevation.surface': '#09326C',
                'color.link': '#CCE0FF',
                'color.link.pressed': '#E9F2FF'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTER_TEAL_BACKGROUND_CONFIG = {
        name: 'lighter-teal',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#C6EDFB',
                'color.link': '#206A83',
                'color.link.pressed': '#164555'
            },
            dark: {
                'color.elevation.surface': '#164555',
                'color.link': '#C6EDFB',
                'color.link.pressed': '#E7F9FF'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTER_GREEN_BACKGROUND_CONFIG = {
        name: 'lighter-green',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#BAF3DB',
                'color.link': '#216E4E',
                'color.link.pressed': '#164B35'
            },
            dark: {
                'color.elevation.surface': '#164B35',
                'color.link': '#BAF3DB',
                'color.link.pressed': '#DCFFF1'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTER_LIME_BACKGROUND_CONFIG = {
        name: 'lighter-lime',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#D3F1A7',
                'color.link': '#4C6B1F',
                'color.link.pressed': '#37471F'
            },
            dark: {
                'color.elevation.surface': '#37471F',
                'color.link': '#D3F1A7',
                'color.link.pressed': '#EFFFD6'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTER_YELLOW_BACKGROUND_CONFIG = {
        name: 'lighter-yellow',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#F8E6A0',
                'color.link': '#7F5F01',
                'color.link.pressed': '#533F04'
            },
            dark: {
                'color.elevation.surface': '#533F04',
                'color.link': '#F8E6A0',
                'color.link.pressed': '#FFF7D6'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTER_ORANGE_BACKGROUND_CONFIG = {
        name: 'lighter-orange',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FEDEC8',
                'color.link': '#A54800',
                'color.link.pressed': '#702E00'
            },
            dark: {
                'color.elevation.surface': '#702E00',
                'color.link': '#FEDEC8',
                'color.link.pressed': '#FFF3EB'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTER_RED_BACKGROUND_CONFIG = {
        name: 'lighter-red',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FFD5D2',
                'color.link': '#AE2E24',
                'color.link.pressed': '#5D1F1A'
            },
            dark: {
                'color.elevation.surface': '#5D1F1A',
                'color.link': '#FFD5D2',
                'color.link.pressed': '#FFECEB'
            }
        }
    };
    const $15099970f99feec5$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG = {
        name: 'lighter-magenta',
        brightness: 'high',
        theme: {
            light: {
                'color.elevation.surface': '#FDD0EC',
                'color.link': '#943D73',
                'color.link.pressed': '#50253F'
            },
            dark: {
                'color.elevation.surface': '#50253F',
                'color.link': '#FDD0EC',
                'color.link.pressed': '#FFECF8'
            }
        }
    };
    const $15099970f99feec5$export$4c351ec1dc290344 = {
        name: 'no-background',
        brightness: 'high',
        theme: {
            light: $15099970f99feec5$export$8a6e9b3370a0f87a,
            dark: $15099970f99feec5$export$8a6e9b3370a0f87a
        }
    };
    const $15099970f99feec5$var$GRADIENT_GRAY_TO_BLACK_META = {
        name: 'gradient-gray-to-black',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #0B1D3A 0%, #505F79 100%)'
            }
        }
    };
    const $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META = {
        name: 'gradient-dark-to-medium-purple',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #002D6D 0%, #61013C 100%)'
            }
        }
    };
    const $15099970f99feec5$var$GRADIENT_LIGHT_TO_DARK_BLUE_META = {
        name: 'gradient-light-to-dark-blue',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #001F4A 0%, #0033B7 100%)'
            }
        }
    };
    const $15099970f99feec5$var$GRADIENT_BLUE_TO_TEAL_META = {
        name: 'gradient-blue-to-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #000D81 0%, #1492A3 100%)'
            }
        }
    };
    const $15099970f99feec5$var$GRADIENT_PURPLE_TO_MAGENTA_META = {
        name: 'gradient-purple-to-magenta',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #13006F 0%, #CD519D 100%)'
            }
        }
    };
    const $15099970f99feec5$var$GRADIENT_MAGENTA_TO_ORANGE_META = {
        name: 'gradient-magenta-to-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #7D004B 28.5%, #BF3900 100%)'
            }
        }
    };
    const $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_RED_META = {
        name: 'gradient-dark-to-light-red',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #150000 0%, #CA0000 100%)'
            }
        }
    };
    const $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META = {
        name: 'gradient-dark-to-light-orange',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #650101 0%, #C75300 99.75%)'
            }
        }
    };
    const $15099970f99feec5$var$GRADIENT_DARK_GREEN_TO_LIME_META = {
        name: 'gradient-dark-green-to-lime',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #072C14 0%, #457200 100%)'
            }
        }
    };
    const $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META = {
        name: 'gradient-dark-to-medium-teal',
        brightness: 'low',
        theme: {
            light: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
            },
            dark: {
                'color.elevation.surface': '#44546F',
                'elevation.surface': 'linear-gradient(135deg, #00152D 0%, #02607E 100%)'
            }
        }
    };
    const $15099970f99feec5$export$34373eced7ee212e = [
        $15099970f99feec5$var$WHITE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHT_PURPLE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHT_BLUE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHT_TEAL_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHT_GREEN_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHT_YELLOW_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHT_ORANGE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHT_RED_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHT_MAGENTA_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARK_BACKGROUND_CONFIG,
        $15099970f99feec5$var$PURPLE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$BLUE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$TEAL_BACKGROUND_CONFIG,
        $15099970f99feec5$var$GREEN_BACKGROUND_CONFIG,
        $15099970f99feec5$var$YELLOW_BACKGROUND_CONFIG,
        $15099970f99feec5$var$ORANGE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$RED_BACKGROUND_CONFIG,
        $15099970f99feec5$var$MAGENTA_BACKGROUND_CONFIG
    ];
    const $15099970f99feec5$export$5ddfadab7b1e12c1 = [
        $15099970f99feec5$var$LIGHTEST_GRAY_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTEST_LIME_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTER_GRAY_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTER_PURPLE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTER_BLUE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTER_TEAL_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTER_GREEN_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTER_LIME_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTER_YELLOW_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTER_ORANGE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTER_RED_BACKGROUND_CONFIG,
        $15099970f99feec5$var$LIGHTER_MAGENTA_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKER_GRAY_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKER_LIME_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKEST_PURPLE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKEST_BLUE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKEST_TEAL_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKEST_GREEN_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKEST_LIME_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKEST_YELLOW_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKEST_ORANGE_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKEST_RED_BACKGROUND_CONFIG,
        $15099970f99feec5$var$DARKEST_MAGENTA_BACKGROUND_CONFIG
    ];
    const $15099970f99feec5$export$349e5dbeac874253 = [
        ...$15099970f99feec5$export$5ddfadab7b1e12c1,
        $15099970f99feec5$export$4c351ec1dc290344
    ];
    const $15099970f99feec5$export$242b2d2213fedf27 = [
        $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_RED_META,
        $15099970f99feec5$var$GRADIENT_MAGENTA_TO_ORANGE_META,
        $15099970f99feec5$var$GRADIENT_DARK_TO_LIGHT_ORANGE_META,
        $15099970f99feec5$var$GRADIENT_DARK_GREEN_TO_LIME_META,
        $15099970f99feec5$var$GRADIENT_BLUE_TO_TEAL_META,
        $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_TEAL_META,
        $15099970f99feec5$var$GRADIENT_LIGHT_TO_DARK_BLUE_META,
        $15099970f99feec5$var$GRADIENT_DARK_TO_MEDIUM_PURPLE_META,
        $15099970f99feec5$var$GRADIENT_PURPLE_TO_MAGENTA_META,
        $15099970f99feec5$var$GRADIENT_GRAY_TO_BLACK_META
    ];
    const $15099970f99feec5$export$8f118a95a310853a = [
        ...$15099970f99feec5$export$242b2d2213fedf27,
        ...$15099970f99feec5$export$349e5dbeac874253
    ];
    const $15099970f99feec5$export$fe05a238062e2c3d = {
        white: $15099970f99feec5$export$4c351ec1dc290344,
        'light-purple': $15099970f99feec5$var$LIGHTEST_PURPLE_BACKGROUND_CONFIG,
        'light-blue': $15099970f99feec5$var$LIGHTEST_BLUE_BACKGROUND_CONFIG,
        'light-teal': $15099970f99feec5$var$LIGHTEST_TEAL_BACKGROUND_CONFIG,
        'light-green': $15099970f99feec5$var$LIGHTEST_GREEN_BACKGROUND_CONFIG,
        'light-yellow': $15099970f99feec5$var$LIGHTEST_YELLOW_BACKGROUND_CONFIG,
        'light-orange': $15099970f99feec5$var$LIGHTEST_ORANGE_BACKGROUND_CONFIG,
        'light-red': $15099970f99feec5$var$LIGHTEST_RED_BACKGROUND_CONFIG,
        'light-magenta': $15099970f99feec5$var$LIGHTEST_MAGENTA_BACKGROUND_CONFIG,
        dark: $15099970f99feec5$var$DARKEST_GRAY_BACKGROUND_CONFIG,
        purple: $15099970f99feec5$var$DARKER_PURPLE_BACKGROUND_CONFIG,
        blue: $15099970f99feec5$var$DARKER_BLUE_BACKGROUND_CONFIG,
        teal: $15099970f99feec5$var$DARKER_TEAL_BACKGROUND_CONFIG,
        green: $15099970f99feec5$var$DARKER_GREEN_BACKGROUND_CONFIG,
        yellow: $15099970f99feec5$var$DARKER_YELLOW_BACKGROUND_CONFIG,
        orange: $15099970f99feec5$var$DARKER_ORANGE_BACKGROUND_CONFIG,
        red: $15099970f99feec5$var$DARKER_RED_BACKGROUND_CONFIG,
        magenta: $15099970f99feec5$var$DARKER_MAGENTA_BACKGROUND_CONFIG
    };
    const $15099970f99feec5$export$cab9d853866386f2 = $15099970f99feec5$export$4c351ec1dc290344;
    const $15099970f99feec5$export$ed7cc0d417ee89e = '--jwm-banner-height';
    const $15099970f99feec5$export$7009ab5fba189797 = `var(${$15099970f99feec5$export$ed7cc0d417ee89e}, 0px)`;
    const $15099970f99feec5$export$8e357501548afe78 = 24;
    const $15099970f99feec5$export$baaf8255c30ea280 = 95;
    const $15099970f99feec5$export$d9035bc768f8226d = `calc(${$15099970f99feec5$export$baaf8255c30ea280}px + ${$15099970f99feec5$export$7009ab5fba189797})`;
    const $15099970f99feec5$export$4810531e30462f89 = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$d9035bc768f8226d})`;
    const $15099970f99feec5$export$1c0b806722927549 = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$d9035bc768f8226d} - ${$15099970f99feec5$export$8e357501548afe78 * 2}px)`;
    const $15099970f99feec5$export$2af5673c2fa63c55 = 126;
    const $15099970f99feec5$export$5771162cdeebfb85 = `calc(${$15099970f99feec5$export$2af5673c2fa63c55}px + ${$15099970f99feec5$export$7009ab5fba189797})`;
    const $15099970f99feec5$export$a1626d6d785092a2 = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$5771162cdeebfb85})`;
    const $15099970f99feec5$export$410e3d6221a052e = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$5771162cdeebfb85} - ${$15099970f99feec5$export$8e357501548afe78 * 2}px)`;
    const $15099970f99feec5$export$8588194807a0ca4b = 146;
    const $15099970f99feec5$export$254a8b23553b7df3 = `calc(${$15099970f99feec5$export$8588194807a0ca4b}px + ${$15099970f99feec5$export$7009ab5fba189797})`;
    const $15099970f99feec5$export$41cffad47189e5bd = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$254a8b23553b7df3})`;
    const $15099970f99feec5$export$ef343e01db40c562 = `calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)} - ${$15099970f99feec5$export$254a8b23553b7df3} - ${$15099970f99feec5$export$8e357501548afe78 * 2}px)`;
    const $15099970f99feec5$export$77cdace62a821419 = `calc(100vw - ${(0, $75Bx4.LEFT_PANEL_WIDTH)} - ${(0, $75Bx4.LEFT_SIDEBAR_WIDTH)} - ${(0, $75Bx4.RIGHT_PANEL_WIDTH)} - ${(0, $75Bx4.RIGHT_SIDEBAR_WIDTH)}) !important`;
    const $15099970f99feec5$export$3efe68325dd9dc02 = `calc(100vw - ${(0, $75Bx4.LEFT_PANEL_WIDTH)} - ${(0, $75Bx4.LEFT_SIDEBAR_WIDTH)} - ${(0, $75Bx4.RIGHT_PANEL_WIDTH)} - ${(0, $75Bx4.RIGHT_SIDEBAR_WIDTH)} - ${$15099970f99feec5$export$8e357501548afe78 * 2}px) !important`;
});
parcelRegister("fzymf", function(module, exports) {
    $parcel$export(module.exports, "overviewDetailsResource", ()=>$a5200a1419c8dbcb$export$cd57aa046b167312);
    $parcel$export(module.exports, "useOverview", ()=>$a5200a1419c8dbcb$export$626541a5c6f2cfa1);
    var $lB25E = parcelRequire("lB25E");
    var $wLx84 = parcelRequire("wLx84");
    const $a5200a1419c8dbcb$var$RESOURCE_TYPE_KEY = 'BUSINESS_OVERVIEW_DETAILS';
    const $a5200a1419c8dbcb$export$cd57aa046b167312 = (0, $lB25E.createResource)({
        type: $a5200a1419c8dbcb$var$RESOURCE_TYPE_KEY,
        getKey: ({ match: match })=>`${$a5200a1419c8dbcb$var$RESOURCE_TYPE_KEY}_${match.params.overviewId}`,
        getData: async ({ match: match }, { tenantContext: { cloudId: cloudId, activationId: activationId } })=>(0, $wLx84.fetchOverviewDetails)(cloudId, activationId, match.params.overviewId),
        maxAge: 3600000
    });
    const $a5200a1419c8dbcb$export$626541a5c6f2cfa1 = ()=>(0, $lB25E.useResource)($a5200a1419c8dbcb$export$cd57aa046b167312);
});
parcelRegister("wLx84", function(module, exports) {
    $parcel$export(module.exports, "fetchOverviewDetails", ()=>$218a2f4d5429f49f$export$f0395142dbdd6c61);
    var $hhcsA = parcelRequire("hhcsA");
    var $dlVOn = parcelRequire("dlVOn");
    var $gUUjF = parcelRequire("gUUjF");
    var $guiFP = parcelRequire("guiFP");
    var $lRmyA = parcelRequire("lRmyA");
    var $huI7r = parcelRequire("huI7r");
    var $3UEL2 = parcelRequire("3UEL2");
    const $218a2f4d5429f49f$export$f0395142dbdd6c61 = async (cloudId, activationId, overviewId)=>{
        if (!overviewId) return null;
        try {
            const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $3UEL2.QUERY),
                    variables: {
                        id: (0, $huI7r.createAri)({
                            resourceOwner: 'jira',
                            cloudId: cloudId,
                            resourceType: 'project-overview',
                            resourceId: overviewId,
                            activationId: activationId
                        })
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'projectStyle'
                }
            });
            if (response?.data?.jira?.overview?.__typename === (0, $555b6ab3251d313a$export$62a5da7e3fa5ff88)) return (0, $hhcsA.mapOverviewFragment)(response.data.jira.overview);
            throw new (0, $dlVOn.GraphQLErrors)(response?.data?.jira?.overview ?? response.errors);
        } catch (error) {
            if (error?.statusCode === 410) throw error;
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessOverviewDetails', 'Something went wrong while fetching business overview details');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'overviewDetailsResource',
                        packageName: 'jiraRouterResourcesBusinessOverviewDetails',
                        teamName: 'wanjel'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
        return null;
    };
});
parcelRegister("hhcsA", function(module, exports) {
    $parcel$export(module.exports, "mapOverviewFragment", ()=>$bc15f4b08a142f23$export$e79bf238de33eabb);
    const $bc15f4b08a142f23$var$SIMPLIFIED_PROJECT_STYLE = 'TEAM_MANAGED_PROJECT';
    const $bc15f4b08a142f23$var$mapProjectsNode = (edges)=>edges.map((edge)=>{
            const { node: node } = edge || {};
            if (node == null) return null;
            return {
                key: node.key,
                id: Number(node.projectId),
                avatarUrl: node.avatar?.large ?? '',
                name: node.name,
                type: node.projectType.toLowerCase(),
                isSimplified: node.projectStyle === $bc15f4b08a142f23$var$SIMPLIFIED_PROJECT_STYLE,
                isFavorite: node.isFavourite === true,
                permissions: {
                    administerProject: node.administerProject.canPerform,
                    createIssues: node.createIssues.canPerform,
                    deleteIssues: node.deleteIssues.canPerform,
                    editIssues: node.editIssues.canPerform,
                    linkIssues: node.linkIssues.canPerform,
                    scheduleIssues: node.scheduleIssues.canPerform,
                    transitionIssues: node.transitionIssues?.canPerform === true,
                    viewIssues: node.viewIssues.canPerform
                }
            };
        }).filter((project)=>project);
    const $bc15f4b08a142f23$export$e79bf238de33eabb = (overview)=>{
        const { id: id, name: name, theme: theme, projects: projectsData } = overview;
        const projects = $bc15f4b08a142f23$var$mapProjectsNode(projectsData.edges);
        const unreachableProjectsCount = projectsData.edges.length - projects.length;
        return {
            id: id,
            name: name,
            theme: theme,
            projects: projects,
            unreachableProjectsCount: unreachableProjectsCount
        };
    };
});
parcelRegister("dlVOn", function(module, exports) {
    $parcel$export(module.exports, "GraphQLErrors", ()=>$c8c10c82db3c32ef$export$89c202e66b2de2b6);
    var $hbMki = parcelRequire("hbMki");
    var $1c8hB = parcelRequire("1c8hB");
    const $c8c10c82db3c32ef$var$generateErrorMessage = (err)=>{
        let message = '';
        if ((0, ($parcel$interopDefault($1c8hB)))(err.graphQLErrors) && err.graphQLErrors.length > 0) err.graphQLErrors.forEach((graphQLError)=>{
            const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
            message += `${errorMessage}\n`;
        });
        message = message.replace(/\n$/, '');
        return message;
    };
    class $c8c10c82db3c32ef$export$89c202e66b2de2b6 extends Error {
        constructor(graphQLErrors){
            super();
            this.graphQLErrors = graphQLErrors != null ? (0, ($parcel$interopDefault($hbMki)))(graphQLErrors) : [];
            this.message = $c8c10c82db3c32ef$var$generateErrorMessage(this);
            this.cause = this.graphQLErrors?.[0];
            this.statusCode = this.cause?.extensions?.statusCode ?? this.cause?.extensions?.[0]?.statusCode ?? -1;
            this.errorType = this.cause?.extensions?.errorType ?? this.cause?.extensions?.[0]?.errorType ?? null;
        }
    }
});
parcelRegister("hbMki", function(module, exports) {
    var $1c8hB = parcelRequire("1c8hB");
    function $c838f35dc30c870d$var$castArray() {
        if (!arguments.length) return [];
        var value = arguments[0];
        return $1c8hB(value) ? value : [
            value
        ];
    }
    module.exports = $c838f35dc30c870d$var$castArray;
});
parcelRegister("3UEL2", function(module, exports) {
    $parcel$export(module.exports, "QUERY", ()=>$286b893702b0066e$export$2b91517d6d5b4365);
    const $286b893702b0066e$export$2b91517d6d5b4365 = `
    query JwmOverviewDetails($id:ID!) {
      jira {
        overview: jwmOverview(id: $id) {
          __typename
          ... on JiraWorkManagementGiraOverview {
            ...OverviewGiraFragment
          }
          ... on QueryError {
            message
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
    ${(0, $fd066e0e866fe0bc$export$6f4bda7ea1dcf892)}
`;
});
const $fd066e0e866fe0bc$export$6f4bda7ea1dcf892 = `
fragment OverviewGiraFragment on JiraWorkManagementGiraOverview {
  id
  name
  theme
  projects {
    edges {
      node {
        key
        projectId
        avatar {
          large
        }
        name
        projectType
        projectStyle
        isFavourite
        administerProject: action(type: EDIT_PROJECT_CONFIG) {
          canPerform
        }
        createIssues: action(type: CREATE_ISSUES) {
          canPerform
        }
        deleteIssues: action(type: DELETE_ISSUES) {
          canPerform
        }
        editIssues: action(type: EDIT_ISSUES) {
          canPerform
        }
        linkIssues: action(type: LINK_ISSUES) {
          canPerform
        }
        scheduleIssues: action(type: SCHEDULE_ISSUES) {
          canPerform
        }
        transitionIssues: action(type: TRANSITION_ISSUES) {
          canPerform
        }
        viewIssues: action(type: VIEW_ISSUES) {
          canPerform
        }
      }
    }
  }
}
`;
const $555b6ab3251d313a$export$62a5da7e3fa5ff88 = 'JiraWorkManagementGiraOverview';
parcelRegister("4EvIi", function(module, exports) {
    $parcel$export(module.exports, "useProjectTheme", ()=>$1782e76953ed5a6c$export$18084206b9430153);
    var $eUqFw = parcelRequire("eUqFw");
    var $kar7l = parcelRequire("kar7l");
    var $aeIT6 = parcelRequire("aeIT6");
    var $lB25E = parcelRequire("lB25E");
    const $1782e76953ed5a6c$export$18084206b9430153 = ()=>{
        const { data: data } = (0, $lB25E.useResource)((0, $aeIT6.projectDetailsResource));
        return (0, $eUqFw.useMemo)(()=>{
            if (data != null) {
                const entityId = `project/${data.currentProject?.id}`;
                const themeSetting = data.themeSetting ?? {
                    type: 'color',
                    value: (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name
                };
                return {
                    themeSetting: themeSetting,
                    entityId: entityId
                };
            }
            return null;
        }, [
            data
        ]);
    };
});
parcelRegister("aeIT6", function(module, exports) {
    $parcel$export(module.exports, "projectDetailsResource", ()=>$d8cccda868228b81$export$e541d9eb202b4972);
    $parcel$export(module.exports, "useProject", ()=>$d8cccda868228b81$export$51b1383ef8844a7);
    $parcel$export(module.exports, "useMediaConfiguration", ()=>$d8cccda868228b81$export$ab5cf8327e07f046);
    var $9zYls = parcelRequire("9zYls");
    var $lB25E = parcelRequire("lB25E");
    var $Qqb3l = parcelRequire("Qqb3l");
    const $d8cccda868228b81$var$RESOURCE_TYPE_KEY = 'RESOURCE_TYPE_BUSINESS_PROJECT_DETAILS';
    const $d8cccda868228b81$export$e541d9eb202b4972 = (0, $lB25E.createResource)({
        type: $d8cccda868228b81$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            const projectIdOrKey = projectKey || projectId;
            return `${$d8cccda868228b81$var$RESOURCE_TYPE_KEY}_${projectIdOrKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(match, query);
            return (0, $Qqb3l.fetchProjectDetails)(cloudId, projectKey, projectId);
        },
        maxAge: 3600000
    });
    const $d8cccda868228b81$export$51b1383ef8844a7 = ()=>{
        const { data: data, loading: loading, error: error } = (0, $lB25E.useResource)($d8cccda868228b81$export$e541d9eb202b4972);
        return {
            data: data?.currentProject ?? null,
            loading: loading,
            error: error
        };
    };
    const $d8cccda868228b81$export$ab5cf8327e07f046 = ()=>{
        const { data: data } = (0, $lB25E.useResource)($d8cccda868228b81$export$e541d9eb202b4972);
        return data?.media ?? null;
    };
});
parcelRegister("Qqb3l", function(module, exports) {
    $parcel$export(module.exports, "fetchProjectDetails", ()=>$b6d7f500e2b72f80$export$78aa221476efa1c6);
    var $gUUjF = parcelRequire("gUUjF");
    var $guiFP = parcelRequire("guiFP");
    var $lRmyA = parcelRequire("lRmyA");
    var $huI7r = parcelRequire("huI7r");
    var $9RmFy = parcelRequire("9RmFy");
    const $b6d7f500e2b72f80$var$EMPTY_VALUE = {
        themeSetting: null,
        media: null
    };
    const $b6d7f500e2b72f80$export$78aa221476efa1c6 = async (cloudId, projectKey, projectId)=>{
        const projectIdOrKey = projectId || projectKey;
        if (!projectIdOrKey) return null;
        try {
            const response = await (0, $lRmyA.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
                body: JSON.stringify({
                    query: (0, $561d2537991d9a5d$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId,
                        projectIdOrKey: projectIdOrKey,
                        usingProjectKey: projectId == null,
                        projectId: projectId != null ? (0, $huI7r.createAri)({
                            resourceOwner: 'jira',
                            cloudId: cloudId,
                            resourceType: 'project',
                            resourceId: projectId
                        }) : ''
                    }
                })
            });
            return (0, $9RmFy.transformData)(response.data, projectIdOrKey);
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraRouterResourcesBusinessProjectDetails', 'Something went wrong while fetching business project details');
            const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
            if (!isClientError) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'projectDetailsResource',
                        packageName: 'jiraRouterResourcesBusinessProjectDetails',
                        teamName: 'wanjel'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
        return $b6d7f500e2b72f80$var$EMPTY_VALUE;
    };
});
const $561d2537991d9a5d$var$PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  status
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  deleteIssues: action(type: DELETE_ISSUES) {
    canPerform
  }
  editIssues: action(type: EDIT_ISSUES) {
    canPerform
  }
  linkIssues: action(type: LINK_ISSUES) {
    canPerform
  }
  scheduleIssues: action(type: SCHEDULE_ISSUES) {
    canPerform
  }
  transitionIssues: action(type: TRANSITION_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;
const $561d2537991d9a5d$export$2b91517d6d5b4365 = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jira {
    mediaClientId(cloudId: $cloudId)
    mediaExternalEndpointUrl(cloudId: $cloudId)
  }
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
    theme: jwmActiveBackgroundByProject(projectIdOrKey: $projectIdOrKey) {
      __typename
      ... on QueryError {
        identifier
        message
        extensions {
          statusCode
          errorType
        }
      }
      ... on JiraWorkManagementBackground {
        ... on JiraWorkManagementColorBackground {
          colorValue
        }
        ... on JiraWorkManagementGradientBackground {
          gradientValue
        }
        ... on JiraWorkManagementMediaBackground {
          customBackground {
            id
            mediaApiFileId
            mediaReadToken (durationInSeconds: 600)
            sourceType
            sourceIdentifier
            altText
          }
        }
      }
    }
  }
}
${$561d2537991d9a5d$var$PROJECT_FRAGMENT}
`;
parcelRegister("9RmFy", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$402e94b0015519f9$export$3ceb62baab058c6b);
    const $402e94b0015519f9$var$mapProjectNode = (node)=>{
        if (node == null) return null;
        return {
            key: node.key,
            id: Number(node.projectId),
            avatarUrl: node.avatar?.large ?? '',
            name: node.name,
            type: node.projectType.toLowerCase(),
            status: node.status,
            isSimplified: node.simplified,
            isFavorite: node.favorite === true,
            permissions: {
                administerProject: node.administerProject.canPerform,
                createIssues: node.createIssues.canPerform,
                deleteIssues: node.deleteIssues.canPerform,
                editIssues: node.editIssues.canPerform,
                linkIssues: node.linkIssues.canPerform,
                scheduleIssues: node.scheduleIssues.canPerform,
                transitionIssues: node.transitionIssues.canPerform,
                viewIssues: node.viewIssues.canPerform
            }
        };
    };
    const $402e94b0015519f9$var$parseThemeSetting = (data)=>{
        const theme = data?.jwmSidebar?.theme;
        if (theme?.__typename === 'JiraWorkManagementColorBackground') return {
            type: 'color',
            value: theme.colorValue
        };
        if (theme?.__typename === 'JiraWorkManagementGradientBackground') return {
            type: 'color',
            value: theme.gradientValue
        };
        if (theme?.__typename === 'JiraWorkManagementMediaBackground') {
            const { customBackground: customBackground } = theme;
            const { id: id, mediaApiFileId: mediaApiFileId, mediaReadToken: mediaReadToken, sourceType: sourceType, sourceIdentifier: sourceIdentifier, altText: altText } = customBackground;
            return {
                type: 'image',
                value: 'image',
                id: id,
                mediaApiFileId: mediaApiFileId,
                mediaReadToken: mediaReadToken,
                sourceType: sourceType,
                sourceIdentifier: sourceIdentifier,
                altText: altText
            };
        }
        return null;
    };
    const $402e94b0015519f9$var$parseMediaConfiguration = (data)=>{
        const clientId = data?.jira?.mediaClientId;
        const externalEndpointUrl = data?.jira?.mediaExternalEndpointUrl;
        if (clientId == null || externalEndpointUrl == null) return null;
        return {
            clientId: clientId,
            externalEndpointUrl: externalEndpointUrl
        };
    };
    const $402e94b0015519f9$export$3ceb62baab058c6b = (data, projectIdOrKey)=>({
            themeSetting: $402e94b0015519f9$var$parseThemeSetting(data),
            currentProject: $402e94b0015519f9$var$mapProjectNode(data?.jwmSidebar?.jiraProjectByKey) ?? $402e94b0015519f9$var$mapProjectNode(data?.jwmSidebar?.jiraProjectById) ?? null,
            projectIdOrKey: projectIdOrKey,
            media: $402e94b0015519f9$var$parseMediaConfiguration(data)
        });
});
parcelRegister("4e72F", function(module, exports) {
    $parcel$export(module.exports, "ThemeTokensSetter", ()=>$7fcf00ff916ea46e$export$41f41c7ff10d45cd);
    var $eUqFw = parcelRequire("eUqFw");
    var $2vzCR = parcelRequire("2vzCR");
    var $bcnRH = parcelRequire("bcnRH");
    var $c9TLT = parcelRequire("c9TLT");
    var $kar7l = parcelRequire("kar7l");
    var $bOA3Q = parcelRequire("bOA3Q");
    var $eI5EY = parcelRequire("eI5EY");
    var $6FP8W = parcelRequire("6FP8W");
    var $gDxeq = parcelRequire("gDxeq");
    function $7fcf00ff916ea46e$var$mergeThemes(theme, ...partialThemes) {
        return (0, ($parcel$interopDefault($2vzCR)))({}, theme, ...partialThemes);
    }
    const $7fcf00ff916ea46e$var$buildHorizontalNavVariables = (theme)=>{
        if ((0, $6FP8W.getWillShowNav4)()) return `${0, $c3cccbb619d075e7$export$539c074adec2188a}: ${theme['color.link']};
${0, $c3cccbb619d075e7$export$1cfe9795423425c}: ${theme['color.background.neutral.hovered']};
${0, $c3cccbb619d075e7$export$6f76912df5477959}: ${theme['color.link.pressed']};
${0, $c3cccbb619d075e7$export$fac615ceaa871e35}: ${theme['color.text.subtle']};
${0, $c3cccbb619d075e7$export$7748fdcd335afdc0}: ${theme['color.text']};
${0, $c3cccbb619d075e7$export$88e550ed188132a7}: ${theme['color.elevation.surface']};
${0, $c3cccbb619d075e7$export$e2e8fadb946a45d2}: ${theme['color.border.selected']};
${0, $c3cccbb619d075e7$export$4cd72d361867c565}: ${theme['color.border']};`;
        return '';
    };
    const $7fcf00ff916ea46e$var$buildThemeVariables = (config, backgroundImageUrl, isDarkMode)=>{
        const applicationColorMode = isDarkMode ? 'dark' : 'light';
        const brightnessOverrides = config.brightness === 'high' && !isDarkMode ? (0, $kar7l.HIGH_BRIGHTNESS_THEME) : (0, $kar7l.LOW_BRIGHTNESS_THEME);
        const isImageConfig = config.name === 'image';
        const isGradientConfig = (0, $bOA3Q.themeManager).isGradientTheme(config.name);
        const theme = $7fcf00ff916ea46e$var$mergeThemes((0, $kar7l.BASE_THEME), isImageConfig ? {} : brightnessOverrides, isGradientConfig ? (0, $kar7l.GRADIENT_THEME) : {}, config.theme[applicationColorMode]);
        let elevationSurface = theme['elevation.surface'] ?? theme['color.elevation.surface'];
        if (backgroundImageUrl) elevationSurface = `url(${backgroundImageUrl}) center center / cover no-repeat${isDarkMode ? ' #0000004d' : ''}`;
        else if (applicationColorMode === 'dark') {
            if ((0, $kar7l.NO_BACKGROUND_CONFIG).name !== config.name && !isGradientConfig) elevationSurface = `linear-gradient(180deg, ${theme['color.elevation.surface']} 0%, ${"var(--ds-surface, #1D2125)"} 400px)`;
        }
        const withWrapper = config.name !== (0, $kar7l.DEFAULT_BACKGROUND_CONFIG).name;
        const wrapperBackground = withWrapper ? `var(--ds-surface, ${0, $207acf722dcd432b$export$29a4f05edc054374})` : 'unset';
        const wrapperBorderRadius = withWrapper ? `${0, $c9TLT.gridSize}px` : '0';
        const isNav4 = (0, $6FP8W.getWillShowNav4)();
        const isNav4HighTab = (0, $eI5EY.fg)('horizontal_navigation_increase_tab_height');
        const businessWrapperWithBackgroundHeight = isNav4 ? isNav4HighTab ? (0, $kar7l.NAV4_HIGH_TAB_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, $kar7l.NAV4_BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT) : (0, $kar7l.BUSINESS_WRAPPER_WITH_BACKGROUND_HEIGHT);
        const businessWrapperHeight = isNav4 ? isNav4HighTab ? (0, $kar7l.NAV4_HIGH_TAB_BUSINESS_NAV_HEIGHT) : (0, $kar7l.NAV4_BUSINESS_WRAPPER_HEIGHT) : (0, $kar7l.BUSINESS_WRAPPER_HEIGHT);
        const wrapperHeight = withWrapper ? businessWrapperWithBackgroundHeight : businessWrapperHeight;
        const wrapperPadding = withWrapper ? `${0, $kar7l.BUSINESS_WRAPPER_PADDING}px` : '0';
        const wrapperWidth = withWrapper ? (0, $kar7l.BUSINESS_WRAPPER_WITH_BACKGROUND_WIDTH) : (0, $kar7l.BUSINESS_WRAPPER_WIDTH);
        return `
${(0, $kar7l.Variables).BACKDROP_FILTER}: ${isImageConfig ? 'blur(8px)' : 'none'};
${(0, $kar7l.Variables).COLOR_BACKGROUND_BRAND_BOLD}: ${theme['color.background.brand.bold']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_BRAND_BOLD_HOVERED}: ${theme['color.background.brand.bold.hovered']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_BRAND_BOLD_PRESSED}: ${theme['color.background.brand.bold.pressed']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_DISABLED}: ${theme['color.background.disabled']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_INPUT}: ${theme['color.background.input']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL}: ${theme['color.background.neutral']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL_HOVERED}: ${theme['color.background.neutral.hovered']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL_PRESSED}: ${theme['color.background.neutral.pressed']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED}: ${theme['color.background.neutral.subtle.hovered']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED}: ${theme['color.background.neutral.subtle.pressed']};
${(0, $kar7l.Variables).COLOR_BACKGROUND_SELECTED}: ${theme['color.background.selected']};
${(0, $kar7l.Variables).COLOR_BORDER}: ${theme['color.border']};
${(0, $kar7l.Variables).COLOR_BORDER_INPUT}: ${theme['color.border.input']};
${(0, $kar7l.Variables).COLOR_BORDER_INVERSE}: ${theme['color.border.inverse']};
${(0, $kar7l.Variables).COLOR_BORDER_SELECTED}: ${theme['color.border.selected']};
${(0, $kar7l.Variables).COLOR_ELEVATION_SURFACE}: ${theme['color.elevation.surface']};
${(0, $kar7l.Variables).COLOR_ICON_DANGER}: ${theme['color.icon.danger']};
${(0, $kar7l.Variables).COLOR_ICON_INFORMATION}: ${theme['color.icon.information']};
${(0, $kar7l.Variables).COLOR_ICON_SUCCESS}: ${theme['color.icon.success']};
${(0, $kar7l.Variables).COLOR_ICON_WARNING}: ${theme['color.icon.warning']};
${(0, $kar7l.Variables).COLOR_LINK}: ${theme['color.link']};
${(0, $kar7l.Variables).COLOR_LINK_PRESSED}: ${theme['color.link.pressed']};
${(0, $kar7l.Variables).COLOR_SKELETON}: ${theme['color.skeleton']};
${(0, $kar7l.Variables).COLOR_TEXT}: ${theme['color.text']};
${(0, $kar7l.Variables).COLOR_TEXT_DISABLED}: ${theme['color.text.disabled']};
${(0, $kar7l.Variables).COLOR_TEXT_INVERSE}: ${theme['color.text.inverse']};
${(0, $kar7l.Variables).COLOR_TEXT_SELECTED}: ${theme['color.text.selected']};
${(0, $kar7l.Variables).COLOR_TEXT_SUBTLE}: ${theme['color.text.subtle']};
${(0, $kar7l.Variables).COLOR_TEXT_SUBTLEST}: ${theme['color.text.subtlest']};
${(0, $kar7l.Variables).CONTENT_HEIGHT}: ${businessWrapperHeight};
${(0, $kar7l.Variables).CONTENT_WIDTH}: ${0, $kar7l.BUSINESS_WRAPPER_WIDTH};
${(0, $kar7l.Variables).ELEVATION_SURFACE}: ${elevationSurface};
${(0, $kar7l.Variables).ELEVATION_SURFACE_CONTRAST}: ${theme['elevation.surface.contrast']};
${(0, $kar7l.Variables).ELEVATION_SURFACE_CONTRAST_BOLDER}: ${theme['elevation.surface.contrast.bolder']};
${(0, $kar7l.Variables).WRAPPER_BACKGROUND}: ${wrapperBackground};
${(0, $kar7l.Variables).WRAPPER_BORDER_RADIUS}: ${wrapperBorderRadius};
${(0, $kar7l.Variables).WRAPPER_HEIGHT}: ${wrapperHeight};
${(0, $kar7l.Variables).WRAPPER_PADDING}: ${wrapperPadding};
${(0, $kar7l.Variables).WRAPPER_WIDTH}: ${wrapperWidth};
${$7fcf00ff916ea46e$var$buildHorizontalNavVariables(theme)}`;
    };
    const $7fcf00ff916ea46e$export$41f41c7ff10d45cd = (0, $eUqFw.memo)(()=>{
        const [{ themeSetting: themeSetting }] = (0, $bcnRH.useThemeHook)();
        const backgroundConfig = (0, $bOA3Q.themeManager).get({
            themeSetting: themeSetting,
            enableImages: true
        });
        const backgroundImageUrl = (0, $gDxeq.useBackgroundImageUrl)(themeSetting);
        return ((0, ($parcel$interopDefault($eUqFw))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `:root{ ${$7fcf00ff916ea46e$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, false)} }
        [data-color-mode=dark]{ ${$7fcf00ff916ea46e$var$buildThemeVariables(backgroundConfig, backgroundImageUrl, true)} }`
            }
        }));
    });
});
parcelRegister("bcnRH", function(module, exports) {
    $parcel$export(module.exports, "ThemeContainerOld", ()=>$0f9ed0aa218118d3$export$c6e50a832af54243);
    $parcel$export(module.exports, "ThemeContainer", ()=>$0f9ed0aa218118d3$export$11eb671888ed6e7d);
    $parcel$export(module.exports, "useThemeHook", ()=>$0f9ed0aa218118d3$export$b95ba2c6b597cfbb);
    $parcel$export(module.exports, "useThemeSetting", ()=>$0f9ed0aa218118d3$export$87d26f94ea053d38);
    $parcel$export(module.exports, "useSelectedThemeSetting", ()=>$0f9ed0aa218118d3$export$4ba6f9d407e18961);
    var $hTLlD = parcelRequire("hTLlD");
    var $bOA3Q = parcelRequire("bOA3Q");
    var $WBLbN = parcelRequire("WBLbN");
    const $0f9ed0aa218118d3$var$setTheme = (newTheme)=>({ getState: getState, setState: setState })=>{
            const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
            if ((0, $bOA3Q.themeManager).isValidTheme(newTheme) && !(0, ($parcel$interopDefault($hTLlD)))(themeSetting?.value, newTheme?.value)) setState({
                entityId: entityId,
                selectedThemeSetting: selectedThemeSetting,
                themeSetting: newTheme
            });
        };
    const $0f9ed0aa218118d3$var$setSelectedThemeSetting = (newTheme)=>({ getState: getState, setState: setState })=>{
            const { entityId: entityId, themeSetting: themeSetting, selectedThemeSetting: selectedThemeSetting } = getState();
            if (newTheme === null || (0, $bOA3Q.themeManager).isValidTheme(newTheme) && !(0, ($parcel$interopDefault($hTLlD)))(selectedThemeSetting?.type === 'image' ? selectedThemeSetting?.id : selectedThemeSetting?.value, newTheme?.type === 'image' ? newTheme?.id : newTheme?.value)) setState({
                entityId: entityId,
                themeSetting: themeSetting,
                selectedThemeSetting: newTheme
            });
        };
    const $0f9ed0aa218118d3$var$actions = {
        setTheme: $0f9ed0aa218118d3$var$setTheme,
        setSelectedThemeSetting: $0f9ed0aa218118d3$var$setSelectedThemeSetting
    };
    const $0f9ed0aa218118d3$var$initialState = {
        themeSetting: null,
        selectedThemeSetting: null,
        entityId: ''
    };
    const $0f9ed0aa218118d3$var$Store = (0, $WBLbN.createStore)({
        initialState: $0f9ed0aa218118d3$var$initialState,
        actions: $0f9ed0aa218118d3$var$actions,
        name: 'BusinessTheme'
    });
    const $0f9ed0aa218118d3$export$c6e50a832af54243 = (0, $WBLbN.createContainer)($0f9ed0aa218118d3$var$Store, {
        onInit: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme),
        onUpdate: ()=>({ setState: setState }, entityTheme)=>setState(entityTheme)
    });
    const $0f9ed0aa218118d3$export$11eb671888ed6e7d = (0, $WBLbN.createContainer)($0f9ed0aa218118d3$var$Store, {
        onInit: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
                setState(entityTheme ?? $0f9ed0aa218118d3$var$initialState);
            },
        onUpdate: ()=>({ setState: setState }, { entityTheme: entityTheme })=>{
                setState(entityTheme ?? $0f9ed0aa218118d3$var$initialState);
            }
    });
    const $0f9ed0aa218118d3$export$b95ba2c6b597cfbb = (0, $WBLbN.createHook)($0f9ed0aa218118d3$var$Store);
    const $0f9ed0aa218118d3$var$getThemeSetting = (0, $WBLbN.createSelector)((state)=>state.themeSetting, (themeSetting)=>themeSetting);
    const $0f9ed0aa218118d3$export$87d26f94ea053d38 = (0, $WBLbN.createHook)($0f9ed0aa218118d3$var$Store, {
        selector: $0f9ed0aa218118d3$var$getThemeSetting
    });
    const $0f9ed0aa218118d3$var$getSelectedThemeSetting = (0, $WBLbN.createSelector)((state)=>state.selectedThemeSetting, (selectedThemeSetting)=>selectedThemeSetting);
    const $0f9ed0aa218118d3$export$4ba6f9d407e18961 = (0, $WBLbN.createHook)($0f9ed0aa218118d3$var$Store, {
        selector: $0f9ed0aa218118d3$var$getSelectedThemeSetting
    });
});
parcelRegister("bOA3Q", function(module, exports) {
    $parcel$export(module.exports, "themeManager", ()=>$24bff9bf7f80d721$export$aba92a7f3273f617);
    $parcel$export(module.exports, "generateMediaImageUrl", ()=>$24bff9bf7f80d721$export$fe2402bbc6ac3125);
    var $kar7l = parcelRequire("kar7l");
    class $24bff9bf7f80d721$var$ThemeManager {
        init() {
            (0, $kar7l.GRADIENT_BACKGROUND_CONFIGS).forEach((theme)=>{
                this.gradients.set(theme.name, theme);
                this.gradientNames.add(theme.name);
            });
            (0, $kar7l.SOLID_COLOR_BACKGROUND_CONFIGS).forEach((theme)=>{
                this.colors.set(theme.name, theme);
                this.colorNames.add(theme.name);
            });
            (0, $kar7l.BACKGROUND_CONFIGS_OLD).forEach((theme)=>{
                this.oldColorNames.add(theme.name);
            });
        }
        isColorTheme(themeName) {
            return this.colorNames.has(themeName);
        }
        isOldColorTheme(themeName) {
            return this.oldColorNames.has(themeName);
        }
        isGradientTheme(themeName) {
            return this.gradientNames.has(themeName);
        }
        isImageTheme(themeSetting) {
            return themeSetting.type === 'image';
        }
        getGradient(themeName) {
            return this.gradients.get(themeName);
        }
        getColor(themeName) {
            return this.colors.get(themeName);
        }
        get({ themeSetting: themeSetting, enableImages: enableImages }) {
            if (!themeSetting) return 0, $kar7l.DEFAULT_BACKGROUND_CONFIG;
            if (enableImages && themeSetting.type === 'image') return 0, $kar7l.IMAGE_BACKGROUND_CONFIG;
            if (this.isGradientTheme(themeSetting.value)) return this.getGradient(themeSetting.value) ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG);
            if (this.isColorTheme(themeSetting.value)) return this.getColor(themeSetting.value) ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG);
            return ((0, $kar7l.OLD_TO_NEW_BACKGROUND_CONFIG_MAP)[themeSetting.value] ?? (0, $kar7l.DEFAULT_BACKGROUND_CONFIG));
        }
        constructor(){
            this.gradients = new Map();
            this.gradientNames = new Set();
            this.colors = new Map();
            this.colorNames = new Set();
            this.oldColorNames = new Set();
            this.isValidTheme = (themeSetting)=>this.isColorTheme(themeSetting.value) || this.isOldColorTheme(themeSetting.value) || this.isGradientTheme(themeSetting.value) || this.isImageTheme(themeSetting);
        }
    }
    const $24bff9bf7f80d721$export$aba92a7f3273f617 = new $24bff9bf7f80d721$var$ThemeManager();
    $24bff9bf7f80d721$export$aba92a7f3273f617.init();
    function $24bff9bf7f80d721$export$fe2402bbc6ac3125({ mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaEndpoint: mediaEndpoint, ...queryParams }) {
        const url = new URL(`${mediaExternalEndpointUrl}/file/${mediaApiFileId}/${mediaEndpoint}`);
        url.searchParams.append('client', mediaClientId);
        Object.entries(queryParams).forEach(([param, value])=>url.searchParams.append(param, String(value)));
        return url.toString();
    }
});
const $c3cccbb619d075e7$export$d1b9ea3245b6a5de = 2;
const $c3cccbb619d075e7$export$7f37240649d2a1e2 = 36;
const $c3cccbb619d075e7$export$d07bba395c9390f1 = 56;
const $c3cccbb619d075e7$export$29911ec08ab2ca2d = 5;
const $c3cccbb619d075e7$export$b61e6f89a9db76de = 12;
const $c3cccbb619d075e7$export$7fd2e391116c6ef5 = 9;
const $c3cccbb619d075e7$export$e1633e494d305bfb = 'MORE';
const $c3cccbb619d075e7$export$1cfe9795423425c = '--horizontal-navigation-color-background-neutral-hovered';
const $c3cccbb619d075e7$export$539c074adec2188a = '--horizontal-navigation-color-link';
const $c3cccbb619d075e7$export$6f76912df5477959 = '--horizontal-navigation-color-link-pressed';
const $c3cccbb619d075e7$export$fac615ceaa871e35 = '--horizontal-navigation-color-text-subtle';
const $c3cccbb619d075e7$export$7748fdcd335afdc0 = '--horizontal-navigation-color-text';
const $c3cccbb619d075e7$export$88e550ed188132a7 = '--horizontal-navigation-color-elevation-surface';
const $c3cccbb619d075e7$export$e2e8fadb946a45d2 = '--horizontal-navigation-color-border-selected';
const $c3cccbb619d075e7$export$4cd72d361867c565 = '--horizontal-navigation-color-border';
parcelRegister("gDxeq", function(module, exports) {
    $parcel$export(module.exports, "useBackgroundImageUrl", ()=>$1b8d41c84ad2c647$export$16f28a2a10ece447);
    var $eUqFw = parcelRequire("eUqFw");
    var $asu8X = parcelRequire("asu8X");
    var $ifH0n = parcelRequire("ifH0n");
    var $bOA3Q = parcelRequire("bOA3Q");
    var $guiFP = parcelRequire("guiFP");
    var $JRB5w = parcelRequire("JRB5w");
    var $aeIT6 = parcelRequire("aeIT6");
    const $1b8d41c84ad2c647$export$16f28a2a10ece447 = (themeSetting)=>{
        (0, $asu8X.di)(URL, fetch);
        const media = (0, $aeIT6.useMediaConfiguration)();
        const lowResUrl = (0, $eUqFw.useMemo)(()=>media && themeSetting?.type === 'image' ? (0, $bOA3Q.generateMediaImageUrl)({
                mediaClientId: media.clientId,
                mediaExternalEndpointUrl: media.externalEndpointUrl,
                mediaApiFileId: themeSetting.mediaApiFileId,
                token: themeSetting.mediaReadToken,
                mediaEndpoint: 'image',
                width: 1000,
                'max-age': Number.MAX_SAFE_INTEGER
            }) : null, [
            media,
            themeSetting
        ]);
        const [imageUrl, setImageUrl] = (0, $eUqFw.useState)(lowResUrl);
        const currentThemeId = (0, $eUqFw.useRef)(null);
        currentThemeId.current = themeSetting?.type === 'image' ? themeSetting.id : null;
        (0, $eUqFw.useEffect)(()=>{
            setImageUrl(lowResUrl);
            if (!media || themeSetting?.type !== 'image') return;
            const binaryUrl = (0, $bOA3Q.generateMediaImageUrl)({
                mediaClientId: media.clientId,
                mediaExternalEndpointUrl: media.externalEndpointUrl,
                mediaApiFileId: themeSetting.mediaApiFileId,
                mediaEndpoint: 'binary',
                'max-age': Number.MAX_SAFE_INTEGER
            });
            fetch(binaryUrl.toString(), {
                headers: {
                    Authorization: `Bearer ${themeSetting.mediaReadToken}`
                }
            }).then((response)=>response.blob()).then((blob)=>{
                const objectUrl = URL.createObjectURL(blob);
                if (currentThemeId.current === themeSetting.id) {
                    setImageUrl(objectUrl);
                    if (themeSetting.sourceType === 'UNSPLASH' && themeSetting.sourceIdentifier) (0, $ifH0n.unsplashTracker).trackImage(themeSetting.sourceIdentifier);
                }
            }).catch((error)=>{
                if (!(0, $JRB5w.isClientFetchError)(error)) (0, $guiFP.default)({
                    meta: {
                        id: 'fetchBinaryBackgroundImage',
                        packageName: 'jiraBusinessThemeComponents',
                        teamName: 'work-management-frontier'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }, [
            themeSetting,
            media,
            lowResUrl
        ]);
        return imageUrl;
    };
});
parcelRegister("ifH0n", function(module, exports) {
    $parcel$export(module.exports, "unsplashTracker", ()=>$8eb46b17b2c5777f$export$1869e04dbed4c16c);
    var $aYAw7 = parcelRequire("aYAw7");
    var $dxIU5 = parcelRequire("dxIU5");
    const $8eb46b17b2c5777f$var$APP_ID = '7066';
    const $8eb46b17b2c5777f$export$ca6dda5263526f75 = `https://views.unsplash.com/v?app_id=${$8eb46b17b2c5777f$var$APP_ID}`;
    const $8eb46b17b2c5777f$var$MAX_URL_LENGTH = 2083;
    const $8eb46b17b2c5777f$var$ID_LENGTH = 12;
    const $8eb46b17b2c5777f$export$28219189b23a0628 = Math.floor($8eb46b17b2c5777f$var$MAX_URL_LENGTH / $8eb46b17b2c5777f$var$ID_LENGTH);
    class $8eb46b17b2c5777f$var$UnsplashTracker {
        send() {
            if (this.queue.size === 0) return;
            const imageIds = Array.from(this.queue);
            this.queue.clear();
            (0, ($parcel$interopDefault($aYAw7)))(imageIds, $8eb46b17b2c5777f$export$28219189b23a0628).forEach((chunkIds)=>{
                const url = `${$8eb46b17b2c5777f$export$ca6dda5263526f75}&photoId=${chunkIds.join(',')}`;
                const now = new Date();
                imageIds.forEach((imageId)=>{
                    this.trackedImages.set(imageId, now);
                });
                const handleFailure = ()=>{
                    imageIds.forEach((imageId)=>{
                        this.queue.add(imageId);
                        this.trackedImages.delete(imageId);
                    });
                };
                fetch(url).then((response)=>{
                    if (!response.ok) handleFailure();
                }).catch(()=>handleFailure());
            });
        }
        trackImage(sourceIdentifier) {
            const imageId = sourceIdentifier.split('-').pop();
            if (!imageId) return;
            const lastTracked = this.trackedImages.get(imageId);
            if (lastTracked && Date.now() - lastTracked.getTime() < this.trackingInterval) return;
            this.queue.add(imageId);
            this.sendDebounced();
        }
        trackWhileInViewport(element, sourceIdentifier) {
            let trackIntervalId = null;
            const observer = new IntersectionObserver((entry)=>{
                if (entry[0].isIntersecting && !trackIntervalId) {
                    $8eb46b17b2c5777f$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                    trackIntervalId = window.setInterval(()=>{
                        $8eb46b17b2c5777f$export$1869e04dbed4c16c.trackImage(sourceIdentifier);
                    }, this.trackingInterval + 10);
                } else if (trackIntervalId) window.clearInterval(trackIntervalId);
            }, {
                rootMargin: '0px',
                threshold: 1.0
            });
            observer.observe(element);
            return ()=>{
                observer.disconnect();
                if (trackIntervalId) window.clearInterval(trackIntervalId);
            };
        }
        static getInstance() {
            if (!$8eb46b17b2c5777f$var$UnsplashTracker.instance) $8eb46b17b2c5777f$var$UnsplashTracker.instance = new $8eb46b17b2c5777f$var$UnsplashTracker();
            return $8eb46b17b2c5777f$var$UnsplashTracker.instance;
        }
        constructor(){
            this.trackedImages = new Map();
            this.trackingInterval = 600000;
            this.queue = new Set();
            this.sendDebounced = (0, ($parcel$interopDefault($dxIU5)))(this.send, 1000);
        }
    }
    const $8eb46b17b2c5777f$export$1869e04dbed4c16c = $8eb46b17b2c5777f$var$UnsplashTracker.getInstance();
});
parcelRegister("aYAw7", function(module, exports) {
    var $jADKY = parcelRequire("jADKY");
    var $3P7i5 = parcelRequire("3P7i5");
    var $hNahz = parcelRequire("hNahz");
    var $7fdbd58793adf3d8$var$nativeCeil = Math.ceil, $7fdbd58793adf3d8$var$nativeMax = Math.max;
    function $7fdbd58793adf3d8$var$chunk(array, size, guard) {
        if (guard ? $3P7i5(array, size, guard) : size === undefined) size = 1;
        else size = $7fdbd58793adf3d8$var$nativeMax($hNahz(size), 0);
        var length = array == null ? 0 : array.length;
        if (!length || size < 1) return [];
        var index = 0, resIndex = 0, result = Array($7fdbd58793adf3d8$var$nativeCeil(length / size));
        while(index < length)result[resIndex++] = $jADKY(array, index, index += size);
        return result;
    }
    module.exports = $7fdbd58793adf3d8$var$chunk;
});
parcelRegister("f8DlR", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("2etjo").then(()=>parcelRequire('eAAlI'));
});
parcelRegister("cEX90", function(module, exports) {
    $parcel$export(module.exports, "ThemedContentLayout", ()=>$82d01d0a73f3012e$export$c2c3c7c0b13a1f9d);
    $parcel$export(module.exports, "BusinessWrapper", ()=>$82d01d0a73f3012e$export$17220b5b22a6586);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $eI5EY = parcelRequire("eI5EY");
    var $8rQuz = parcelRequire("8rQuz");
    var $3zjRf = parcelRequire("3zjRf");
    const $82d01d0a73f3012e$var$styles = {
        rootOld: "_kqswh2mm",
        root: "_kqswh2mm _1pbyidpf",
        fullHeight: "_1tkeidpf _4t3i1osq",
        insetRoot: "_1yt4y22u",
        insetRootVisualRefresh: "_ca0qv47k",
        insetContainer: "_2rkolsi6 _bfhk8q8z"
    };
    const $82d01d0a73f3012e$export$c2c3c7c0b13a1f9d = ({ children: children, appearance: appearance })=>$eUqFw.createElement("div", {
            className: (0, $7JEyt.default)([
                (0, $eI5EY.fg)('jwm_fix_popup_broken_with_custom_background') && $82d01d0a73f3012e$var$styles.root,
                !(0, $eI5EY.fg)('jwm_fix_popup_broken_with_custom_background') && $82d01d0a73f3012e$var$styles.rootOld,
                $82d01d0a73f3012e$var$styles.fullHeight,
                appearance === 'inset' && $82d01d0a73f3012e$var$styles.insetRoot,
                (0, $8rQuz.isVisualRefreshEnabled)() && appearance === 'inset' && $82d01d0a73f3012e$var$styles.insetRootVisualRefresh
            ])
        }, $eUqFw.createElement("div", {
            className: (0, $7JEyt.default)([
                $82d01d0a73f3012e$var$styles.fullHeight,
                appearance === 'inset' && $82d01d0a73f3012e$var$styles.insetContainer
            ])
        }, children));
    const $82d01d0a73f3012e$export$17220b5b22a6586 = ({ withWhiteBackground: withWhiteBackground, children: children })=>{
        if (withWhiteBackground) return $eUqFw.createElement((0, $3zjRf.OuterWrapperWithBackground), null, $eUqFw.createElement((0, $3zjRf.InnerWrapperWithBackground), null, children));
        return $eUqFw.createElement((0, $3zjRf.OuterWrapper), null, $eUqFw.createElement((0, $3zjRf.InnerWrapper), null, children));
    };
});
parcelRegister("8rQuz", function(module, exports) {
    $parcel$export(module.exports, "isVisualRefreshEnabled", ()=>$867146288cf212f8$export$48345cb467db19b6);
    var $eI5EY = parcelRequire("eI5EY");
    var $6mXXc = parcelRequire("6mXXc");
    const $867146288cf212f8$var$DUMMY_CONDITION = true;
    const $867146288cf212f8$export$48345cb467db19b6 = ()=>(0, $eI5EY.fg)('visual-refresh') && ($867146288cf212f8$var$isVisualRefreshInDogfooding() || $867146288cf212f8$var$isVisualRefreshInEAP() || $867146288cf212f8$var$isVisualRefreshInOpenBeta());
    const $867146288cf212f8$var$isVisualRefreshInDogfooding = ()=>(0, $eI5EY.fg)('visual-refresh-dogfood') && !(0, $6mXXc.getIsNav4UserOptOut)();
    const $867146288cf212f8$var$isVisualRefreshInEAP = ()=>(0, $eI5EY.fg)('visual-refresh-eap') && !(0, $6mXXc.getIsNav4UserOptOut)();
    const $867146288cf212f8$var$isVisualRefreshInOpenBeta = ()=>$867146288cf212f8$var$DUMMY_CONDITION && (0, $eI5EY.fg)('visual-refresh-open-beta');
});
parcelRegister("3zjRf", function(module, exports) {
    $parcel$export(module.exports, "OuterWrapper", ()=>$d2afd9eae3f40ab2$export$edaaad985a878983);
    $parcel$export(module.exports, "OuterWrapperWithBackground", ()=>$d2afd9eae3f40ab2$export$69c6ec128d3729c9);
    $parcel$export(module.exports, "InnerWrapper", ()=>$d2afd9eae3f40ab2$export$f185744748c379a7);
    $parcel$export(module.exports, "InnerWrapperWithBackground", ()=>$d2afd9eae3f40ab2$export$2e149d12a18af14b);
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    var $9zysr = parcelRequire("9zysr");
    var $dnJL9 = parcelRequire("dnJL9");
    var $6FP8W = parcelRequire("6FP8W");
    const $d2afd9eae3f40ab2$var$Nav3OuterWrapper = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $eUqFw.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_kqswh2mm _154i1jzz",
                __cmplp.className
            ])
        });
    });
    const $d2afd9eae3f40ab2$var$Nav4OuterWrapper = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $eUqFw.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_kqswh2mm _154ieda8",
                __cmplp.className
            ])
        });
    });
    const $d2afd9eae3f40ab2$var$Nav4HighTabOuterWrapper = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $eUqFw.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_kqswh2mm _154i1f46",
                __cmplp.className
            ])
        });
    });
    const $d2afd9eae3f40ab2$export$edaaad985a878983 = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), (0, $dnJL9.componentWithFG)('horizontal_navigation_increase_tab_height', $d2afd9eae3f40ab2$var$Nav4HighTabOuterWrapper, $d2afd9eae3f40ab2$var$Nav4OuterWrapper), $d2afd9eae3f40ab2$var$Nav3OuterWrapper);
    const $d2afd9eae3f40ab2$export$69c6ec128d3729c9 = (0, $eUqFw.forwardRef)(({ as: C = $d2afd9eae3f40ab2$export$edaaad985a878983, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $eUqFw.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_1yt4y22u",
                __cmplp.className
            ])
        });
    });
    const $d2afd9eae3f40ab2$export$f185744748c379a7 = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $eUqFw.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_2d3f1oc1 _japi1mcq _iu1g1fl4 _fok81wug _q7c11wug",
                __cmplp.className
            ])
        });
    });
    const $d2afd9eae3f40ab2$export$2e149d12a18af14b = (0, $eUqFw.forwardRef)(({ as: C = $d2afd9eae3f40ab2$export$f185744748c379a7, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $eUqFw.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_2rkolsi6 _bfhk8q8z _2d3f1yz2 _japi1e8k",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1n0H8", function(module, exports) {
    $parcel$export(module.exports, "addLeadingSlash", ()=>$0ff87a68793148e2$export$5b4913142e03bca8, (v)=>$0ff87a68793148e2$export$5b4913142e03bca8 = v);
    $parcel$export(module.exports, "hasBasename", ()=>$0ff87a68793148e2$export$10497c7ce66fcb84, (v)=>$0ff87a68793148e2$export$10497c7ce66fcb84 = v);
    $parcel$export(module.exports, "stripBasename", ()=>$0ff87a68793148e2$export$b69e3301ce081aa3, (v)=>$0ff87a68793148e2$export$b69e3301ce081aa3 = v);
    $parcel$export(module.exports, "stripTrailingSlash", ()=>$0ff87a68793148e2$export$d95b4586d238a081, (v)=>$0ff87a68793148e2$export$d95b4586d238a081 = v);
    $parcel$export(module.exports, "parsePath", ()=>$0ff87a68793148e2$export$8ccf933b0513f8d0, (v)=>$0ff87a68793148e2$export$8ccf933b0513f8d0 = v);
    $parcel$export(module.exports, "createPath", ()=>$0ff87a68793148e2$export$fe53371bee54353d, (v)=>$0ff87a68793148e2$export$fe53371bee54353d = v);
    var $0ff87a68793148e2$export$1e511d4a378977f5;
    var $0ff87a68793148e2$export$5b4913142e03bca8;
    var $0ff87a68793148e2$export$79c5b1569e3be9e6;
    var $0ff87a68793148e2$export$10497c7ce66fcb84;
    var $0ff87a68793148e2$export$b69e3301ce081aa3;
    var $0ff87a68793148e2$export$d95b4586d238a081;
    var $0ff87a68793148e2$export$8ccf933b0513f8d0;
    var $0ff87a68793148e2$export$fe53371bee54353d;
    'use strict';
    $0ff87a68793148e2$export$1e511d4a378977f5 = true;
    var $0ff87a68793148e2$var$addLeadingSlash = $0ff87a68793148e2$export$5b4913142e03bca8 = function addLeadingSlash(path) {
        return path.charAt(0) === '/' ? path : '/' + path;
    };
    var $0ff87a68793148e2$var$stripLeadingSlash = $0ff87a68793148e2$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
        return path.charAt(0) === '/' ? path.substr(1) : path;
    };
    var $0ff87a68793148e2$var$hasBasename = $0ff87a68793148e2$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
        return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
    };
    var $0ff87a68793148e2$var$stripBasename = $0ff87a68793148e2$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
        return $0ff87a68793148e2$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
    };
    var $0ff87a68793148e2$var$stripTrailingSlash = $0ff87a68793148e2$export$d95b4586d238a081 = function stripTrailingSlash(path) {
        return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
    };
    var $0ff87a68793148e2$var$parsePath = $0ff87a68793148e2$export$8ccf933b0513f8d0 = function parsePath(path) {
        var pathname = path || '/';
        var search = '';
        var hash = '';
        var hashIndex = pathname.indexOf('#');
        if (hashIndex !== -1) {
            hash = pathname.substr(hashIndex);
            pathname = pathname.substr(0, hashIndex);
        }
        var searchIndex = pathname.indexOf('?');
        if (searchIndex !== -1) {
            search = pathname.substr(searchIndex);
            pathname = pathname.substr(0, searchIndex);
        }
        return {
            pathname: pathname,
            search: search === '?' ? '' : search,
            hash: hash === '#' ? '' : hash
        };
    };
    var $0ff87a68793148e2$var$createPath = $0ff87a68793148e2$export$fe53371bee54353d = function createPath(location) {
        var pathname = location.pathname, search = location.search, hash = location.hash;
        var path = pathname || '/';
        if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
        if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
        return path;
    };
});
parcelRegister("3oscM", function(module, exports) {
    $parcel$export(module.exports, "calcRapidBoardResetState", ()=>$c71ed4be82b11f4e$export$2350ed3ff6c1a082);
    $parcel$export(module.exports, "getApdexMatchObject", ()=>$c71ed4be82b11f4e$export$47e434f08768932b);
    $parcel$export(module.exports, "calcRapidBoardResetStateV2", ()=>$c71ed4be82b11f4e$export$dbd9185166d0d04c);
    $parcel$export(module.exports, "isValidRoute", ()=>$c71ed4be82b11f4e$export$9f3e656a7f6a3adc);
    var $exb0h = parcelRequire("exb0h");
    const $c71ed4be82b11f4e$export$2350ed3ff6c1a082 = (boardPaths, routeName, useStoredSettings)=>{
        let rapidBoardPaths = [
            ...boardPaths
        ];
        let resetDone = false;
        switch(routeName){
            case 0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
                rapidBoardPaths = [
                    (0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)
                ];
                resetDone = true;
                break;
            case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD:
            case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED:
            case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG:
            case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT:
                if (useStoredSettings) {
                    rapidBoardPaths = [
                        ...rapidBoardPaths,
                        'useStoredSettings'
                    ];
                    resetDone = false;
                    break;
                }
                if (!useStoredSettings && rapidBoardPaths.indexOf((0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) > -1 && rapidBoardPaths.indexOf('useStoredSettings') > -1 || rapidBoardPaths.indexOf('useStoredSettings') > -1) resetDone = true;
                rapidBoardPaths = [];
                break;
            default:
                resetDone = false;
        }
        return [
            rapidBoardPaths,
            resetDone
        ];
    };
    const $c71ed4be82b11f4e$export$47e434f08768932b = (match, route)=>{
        let cleanMatch = {
            ...match,
            params: {
                ...match.params
            },
            query: {
                ...match.query
            }
        };
        if (route.apdexIgnoreParams && route.apdexIgnoreParams.length > 0) route.apdexIgnoreParams.forEach((apdexIgnoreParam)=>{
            const { params: params, query: query } = match;
            const paramKeys = params && Object.keys(params);
            const queryKeys = query && Object.keys(query);
            const isIgnoreInParams = paramKeys && paramKeys.length > 0 && paramKeys.indexOf(apdexIgnoreParam) >= 0;
            const isIgnoreInQuery = queryKeys && queryKeys.length > 0 && queryKeys.indexOf(apdexIgnoreParam) >= 0;
            if (isIgnoreInParams) cleanMatch.params[apdexIgnoreParam] = apdexIgnoreParam;
            if (isIgnoreInQuery) cleanMatch.query[apdexIgnoreParam] = apdexIgnoreParam;
        });
        if (match.query && match.query.view && match.query.view === 'detail') cleanMatch.query.view = undefined;
        if (match.query && match.query.view && match.query.view === 'planning.nodetail') cleanMatch.query.view = 'planning';
        cleanMatch = {
            ...cleanMatch,
            url: ''
        };
        return cleanMatch;
    };
    const $c71ed4be82b11f4e$export$dbd9185166d0d04c = (boardPaths, routeName, useStoredSettings)=>{
        let rapidBoardPaths = [
            ...boardPaths
        ];
        let resetDone = false;
        switch(routeName){
            case 0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT:
                rapidBoardPaths = [];
                resetDone = true;
                break;
            case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG:
            case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD:
            case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT:
                if (rapidBoardPaths.includes((0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT)) || rapidBoardPaths.includes('useStoredSettings')) {
                    resetDone = true;
                    rapidBoardPaths = [];
                    break;
                } else if (useStoredSettings) {
                    rapidBoardPaths = [
                        ...rapidBoardPaths,
                        'useStoredSettings'
                    ];
                    break;
                } else {
                    rapidBoardPaths = [];
                    break;
                }
            default:
                if (rapidBoardPaths.includes((0, $exb0h.ROUTE_NAMES_BROWSE_PROJECT_REDIRECT))) {
                    resetDone = true;
                    rapidBoardPaths = [];
                }
        }
        return [
            rapidBoardPaths,
            resetDone
        ];
    };
    const $c71ed4be82b11f4e$export$d5eae90e177f1bdd = (appId, state, searchDepth = 0)=>{
        if (state) {
            const { currentPage: currentPage, visitedPages: visitedPages } = state;
            const visitedPageLength = visitedPages.length;
            if (currentPage && currentPage.apps[appId]) return true;
            if (visitedPageLength === 0 || searchDepth <= 0) return false;
            for(let i = 1; i <= Math.min(searchDepth, visitedPageLength); i += 1){
                if (visitedPages[visitedPageLength - i].apps[appId]) return true;
            }
        }
        return false;
    };
    const $c71ed4be82b11f4e$export$9f3e656a7f6a3adc = (routeToCheck)=>{
        switch(routeToCheck.name){
            case 0, $exb0h.ROUTE_NAMES_ISSUE:
            case 0, $exb0h.ROUTE_NAMES_ISSUE_EMBED:
            case 0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR:
            case 0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC:
            case 0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE:
            case 0, $exb0h.ROUTE_NAMES_SERVICEDESK_ISSUES:
                return true;
            default:
                return false;
        }
    };
});
parcelRegister("8vvIW", function(module, exports) {
    $parcel$export(module.exports, "RemoteActionsContainer", ()=>$9c4804be711e3553$export$28c2e4c663a86266);
    $parcel$export(module.exports, "useRemoteActions", ()=>$9c4804be711e3553$export$333357b3de3e67a0);
    $parcel$export(module.exports, "useRemoteActionsData", ()=>$9c4804be711e3553$export$3cc006661ae2a759);
    $parcel$export(module.exports, "useMeta", ()=>$9c4804be711e3553$export$3fb9275d3845bd5a);
    $parcel$export(module.exports, "useRemoteActionsStoreActions", ()=>$9c4804be711e3553$export$3fd21eaf97df4718);
    var $WBLbN = parcelRequire("WBLbN");
    var $alAYu = parcelRequire("alAYu");
    if (!Object.isFrozen((0, $WBLbN.defaults))) (0, $WBLbN.defaults).devtools = false;
    const $9c4804be711e3553$var$Store = (0, $WBLbN.createStore)({
        initialState: {
            meta: {},
            remoteActions: {},
            lastUpdatedAt: 0,
            isLoaded: false,
            product: undefined
        },
        actions: $alAYu.actions,
        name: 'remoteActionsStore'
    });
    const $9c4804be711e3553$export$28c2e4c663a86266 = (0, $WBLbN.createContainer)($9c4804be711e3553$var$Store, {
        onInit: ()=>({ dispatch: dispatch })=>{
                dispatch((0, $alAYu.actions).initStore());
            }
    });
    const $9c4804be711e3553$export$333357b3de3e67a0 = (selector)=>(0, $WBLbN.createHook)($9c4804be711e3553$var$Store, {
            selector: selector
        })();
    const $9c4804be711e3553$export$3cc006661ae2a759 = (0, $WBLbN.createStateHook)($9c4804be711e3553$var$Store, {
        selector: (state)=>state.remoteActions
    });
    const $9c4804be711e3553$export$3fb9275d3845bd5a = (0, $WBLbN.createStateHook)($9c4804be711e3553$var$Store, {
        selector: (state)=>state.meta
    });
    const $9c4804be711e3553$export$3fd21eaf97df4718 = (0, $WBLbN.createActionsHook)($9c4804be711e3553$var$Store);
});
parcelRegister("alAYu", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$bbec5a907e779f66$export$e324594224ef24da);
    var $anABZ = parcelRequire("anABZ");
    var $FVxjP = parcelRequire("FVxjP");
    var $lsU6u = parcelRequire("lsU6u");
    var $Tvs0M = parcelRequire("Tvs0M");
    const $bbec5a907e779f66$export$e324594224ef24da = {
        processRemoteActions: $lsU6u.processRemoteActions,
        saveActionPerformedAttempt: $Tvs0M.saveActionPerformedAttempt,
        initStore: $FVxjP.initStore,
        clearActionId: $anABZ.clearActionId
    };
});
parcelRegister("anABZ", function(module, exports) {
    $parcel$export(module.exports, "clearActionId", ()=>$5c08af692d3035c0$export$8d8b492eefa9efba);
    var $8QVAD = parcelRequire("8QVAD");
    const $5c08af692d3035c0$export$8d8b492eefa9efba = (actionId)=>({ getState: getState, setState: setState }, { product: product })=>{
            const { meta: meta } = getState();
            const newMeta = {
                ...meta
            };
            delete newMeta[actionId];
            setState({
                meta: newMeta
            });
            (0, $8QVAD.writeRemoteActionsMetasToLocalStorage)(product, meta);
        };
});
parcelRegister("8QVAD", function(module, exports) {
    $parcel$export(module.exports, "readRemoteActionsMetasFromLocalStorage", ()=>$789dbeb913115ba1$export$a221266a05084986);
    $parcel$export(module.exports, "writeRemoteActionsMetasToLocalStorage", ()=>$789dbeb913115ba1$export$7228aaade919a8b6);
    const $789dbeb913115ba1$export$b9e25d3c75cffd71 = 'atlassian-remote-actions';
    const $789dbeb913115ba1$export$a221266a05084986 = (product)=>{
        try {
            return JSON.parse(localStorage.getItem(`${$789dbeb913115ba1$export$b9e25d3c75cffd71}.${product}`) || '{}');
        } catch (e) {
            console.warn('Could not load from localStorage', e);
            return {};
        }
    };
    const $789dbeb913115ba1$export$7228aaade919a8b6 = (product, remoteActionsMetas)=>{
        try {
            localStorage.setItem(`${$789dbeb913115ba1$export$b9e25d3c75cffd71}.${product}`, JSON.stringify(remoteActionsMetas));
        } catch (e) {
            console.warn('Could not load from localStorage', e);
        }
    };
});
parcelRegister("FVxjP", function(module, exports) {
    $parcel$export(module.exports, "initStore", ()=>$6c2435ddf9c68c8b$export$41f27b3823a442c6);
    var $8QVAD = parcelRequire("8QVAD");
    const $6c2435ddf9c68c8b$export$41f27b3823a442c6 = ()=>({ setState: setState }, { product: product })=>{
            setState({
                meta: (0, $8QVAD.readRemoteActionsMetasFromLocalStorage)(product),
                isLoaded: true,
                product: product
            });
        };
});
parcelRegister("lsU6u", function(module, exports) {
    $parcel$export(module.exports, "processRemoteActions", ()=>$2bdbc3e08ae4e89a$export$15e69d1dd38ccaa3);
    var $4mm37 = parcelRequire("4mm37");
    const $2bdbc3e08ae4e89a$export$15e69d1dd38ccaa3 = (productData, remoteActionsResponse)=>({ getState: getState, setState: setState })=>{
            const { lastUpdatedAt: lastUpdatedAt, meta: meta } = getState();
            if (remoteActionsResponse.lastUpdatedAt <= lastUpdatedAt) return;
            const remoteActions = remoteActionsResponse.remoteActions.reduce((updatedRemoteActions, remoteAction)=>{
                if ((0, $4mm37.shouldProcessRemoteAction)(remoteAction)) {
                    const shouldAddAction = remoteAction.conditions.every((condition)=>(0, $4mm37.isActionConditionSatisfied)(productData, condition));
                    if (shouldAddAction) updatedRemoteActions[remoteAction.id] = remoteAction;
                }
                return updatedRemoteActions;
            }, {});
            setState({
                meta: Object.keys(remoteActions).reduce((newMeta, id)=>{
                    newMeta[id] = meta[id];
                    return newMeta;
                }, {}),
                remoteActions: remoteActions,
                lastUpdatedAt: Date.now()
            });
        };
});
parcelRegister("4mm37", function(module, exports) {
    $parcel$export(module.exports, "isActionConditionSatisfied", ()=>$168501cfeeac070c$export$9262d8191a70c677);
    $parcel$export(module.exports, "shouldProcessRemoteAction", ()=>$168501cfeeac070c$export$c7cc93192d09a3d7);
    var $9ylAW = parcelRequire("9ylAW");
    const $168501cfeeac070c$var$isFeatureFlagConditionSatisfied = (getFeatureFlagValue, condition)=>condition.affectedFeatureFlagValue === getFeatureFlagValue(condition.featureFlagKey);
    const $168501cfeeac070c$var$isFeatureGateConditionSatisfied = (getFeatureGateValue, condition)=>getFeatureGateValue && condition.affectedFeatureGateValue === getFeatureGateValue(condition.featureGateKey);
    const $168501cfeeac070c$var$isBuildInAffectedRangeV2 = (getBuildKey, getBuildInfoFromKey, condition)=>{
        try {
            const { buildNumber: currentBuildNumber, buildType: currentBuildType } = getBuildInfoFromKey(getBuildKey());
            const { buildNumber: firstAffectedBuildNumber, buildType: firstAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[0]);
            const { buildNumber: lastAffectedBuildNumber, buildType: lastAffectedBuildType } = getBuildInfoFromKey(condition.buildRange[1]);
            if (firstAffectedBuildType !== currentBuildType || lastAffectedBuildType !== currentBuildType) return false;
            if (firstAffectedBuildNumber <= currentBuildNumber && currentBuildNumber <= lastAffectedBuildNumber) return true;
        } catch (error) {
            console.warn('error while parsing a build key', error);
        }
        return false;
    };
    const $168501cfeeac070c$export$9262d8191a70c677 = (productData, condition)=>{
        switch(condition.type){
            case (0, $9ylAW.ConditionType).buildRange:
                return $168501cfeeac070c$var$isBuildInAffectedRangeV2(productData.getBuildKey, productData.getBuildInfoFromKey, condition);
            case (0, $9ylAW.ConditionType).featureFlag:
                return $168501cfeeac070c$var$isFeatureFlagConditionSatisfied(productData.getFeatureFlagValue, condition);
            case (0, $9ylAW.ConditionType).featureGate:
                return $168501cfeeac070c$var$isFeatureGateConditionSatisfied(productData.getFeatureGateValue, condition);
            default:
                return false;
        }
    };
    const $168501cfeeac070c$export$c7cc93192d09a3d7 = (remoteAction)=>remoteAction.enabled;
});
parcelRegister("9ylAW", function(module, exports) {
    $parcel$export(module.exports, "ConditionType", ()=>$495d8ad6e8ca1a75$export$748d1c753cdf4bfd);
    var $495d8ad6e8ca1a75$export$748d1c753cdf4bfd;
    (function(ConditionType) {
        ConditionType["featureFlag"] = "featureFlag";
        ConditionType["featureGate"] = "featureGate";
        ConditionType["buildRange"] = "buildRange";
    })($495d8ad6e8ca1a75$export$748d1c753cdf4bfd || ($495d8ad6e8ca1a75$export$748d1c753cdf4bfd = {}));
});
parcelRegister("Tvs0M", function(module, exports) {
    $parcel$export(module.exports, "saveActionPerformedAttempt", ()=>$dea1fb40f5740679$export$e3144a2e886e0e77);
    var $8QVAD = parcelRequire("8QVAD");
    const $dea1fb40f5740679$export$e3144a2e886e0e77 = (actionId)=>({ getState: getState, setState: setState })=>{
            const { meta: meta, product: product } = getState();
            const currentAttemptCount = meta[actionId]?.attemptCounts || 0;
            const updatedMetas = {
                ...meta,
                [actionId]: {
                    lastPerformAttemptedAt: Date.now(),
                    attemptCounts: currentAttemptCount + 1
                }
            };
            setState({
                meta: updatedMetas
            });
            if (!product) throw new Error('Product is not defined.');
            (0, $8QVAD.writeRemoteActionsMetasToLocalStorage)(product, updatedMetas);
        };
});
parcelRegister("3dxBh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b1c4436e864f401$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $ICvxP = parcelRequire("ICvxP");
    var $6iz4v = parcelRequire("6iz4v");
    var $3viaK = parcelRequire("3viaK");
    var $6xYPC = parcelRequire("6xYPC");
    var $87isp = parcelRequire("87isp");
    var $0S0fK = parcelRequire("0S0fK");
    var $1cNJ6 = parcelRequire("1cNJ6");
    class $8b1c4436e864f401$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
        render() {
            const { children: children, pageId: pageId } = this.props;
            return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0S0fK.default).Provider, {
                value: {
                    pageId: pageId,
                    onReady: this.onReady,
                    onCustomMark: this.onCustomMark
                }
            }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
                op: this.onStart,
                args: [
                    pageId
                ]
            }), children));
        }
        constructor(...args){
            super(...args);
            this.customMarks = [];
            this.onStart = ()=>{
                (0, $ICvxP.default)((0, $37f655a4e4d5690e$export$56940a9488e85199));
                (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$45c4b6bf7935c69a));
            };
            this.onCustomMark = (markName)=>{
                (0, $6iz4v.setMark)((0, $1cNJ6.getPrefixedMarkName)(markName));
                this.customMarks.push(markName);
            };
            this.onReady = (metricKeyForInitialRender, metricKeyForTransition, extra = {}, metric)=>{
                metric.stop({
                    customData: extra
                });
                if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
            };
        }
    }
});
const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("0S0fK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f943d45ee0ecaf49$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    const $f943d45ee0ecaf49$var$contextName = 'SpaApdexAnalytics';
    var $f943d45ee0ecaf49$export$2e2bcd8739ae039 = (0, $eUqFw.createContext)($f943d45ee0ecaf49$var$contextName);
});
parcelRegister("1cNJ6", function(module, exports) {
    $parcel$export(module.exports, "getPrefixedMarkName", ()=>$c844db40c28c8d19$export$c8f0e9837e7e9425);
    const $c844db40c28c8d19$export$c8f0e9837e7e9425 = (name)=>`${0, $37f655a4e4d5690e$export$56940a9488e85199}${name}`;
});
parcelRegister("iJHZm", function(module, exports) {
    $parcel$export(module.exports, "SpaStateContainer", ()=>$a6f32366b1daf5c0$export$e9a92b877fe80e80);
    $parcel$export(module.exports, "SpaStateAppStart", ()=>$a6f32366b1daf5c0$export$d18dd27183a635c);
    $parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", ()=>$a6f32366b1daf5c0$export$95a2912d76fb5433);
    $parcel$export(module.exports, "SpaStatePageReady", ()=>$a6f32366b1daf5c0$export$c34439f945fccbdf);
    $parcel$export(module.exports, "SpaStatePageReadyOnUpdate", ()=>$a6f32366b1daf5c0$export$41e70078eeddaddc);
    $parcel$export(module.exports, "SpaStatePageErrorReady", ()=>$a6f32366b1daf5c0$export$2583aa269898885c);
    $parcel$export(module.exports, "getSpaStateLastUserLocation", ()=>$a6f32366b1daf5c0$export$6e9ab893e97cccef);
    var $eUqFw = parcelRequire("eUqFw");
    var $3viaK = parcelRequire("3viaK");
    var $lB25E = parcelRequire("lB25E");
    var $WBLbN = parcelRequire("WBLbN");
    var $lcJyp = parcelRequire("lcJyp");
    var $cfLkw = parcelRequire("cfLkw");
    const $a6f32366b1daf5c0$export$e9a92b877fe80e80 = (0, $WBLbN.createContainer)((0, $cfLkw.default));
    const $a6f32366b1daf5c0$export$d18dd27183a635c = ()=>{
        const startRef = (0, $eUqFw.useRef)(Date.now());
        const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, $lcJyp.useSpaState)();
        (0, $eUqFw.useMemo)(()=>{
            startRef.current = Date.now();
        }, [
            visitedPages
        ]);
        (0, $eUqFw.useLayoutEffect)(()=>{
            setAppStart(startRef.current);
        }, [
            setAppStart,
            visitedPages
        ]);
        return null;
    };
    const $a6f32366b1daf5c0$var$useRouterMatchSelector = (0, $lB25E.createRouterSelector)((state)=>state.match);
    const $a6f32366b1daf5c0$var$useSpaStatePagesCount = (0, $WBLbN.createHook)((0, $cfLkw.default), {
        selector: ({ visitedPages: visitedPages })=>visitedPages.length
    });
    const $a6f32366b1daf5c0$export$95a2912d76fb5433 = ()=>{
        const match = $a6f32366b1daf5c0$var$useRouterMatchSelector();
        const [count, { setAppStart: setAppStart }] = $a6f32366b1daf5c0$var$useSpaStatePagesCount();
        return (0, ($parcel$interopDefault($eUqFw))).createElement($a6f32366b1daf5c0$export$ada7e0ec445851a2, {
            visitedPagesLength: count,
            onSetAppStart: setAppStart,
            match: match
        });
    };
    const $a6f32366b1daf5c0$export$c34439f945fccbdf = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
                op: setAppReady
            }));
    const $a6f32366b1daf5c0$export$41e70078eeddaddc = ({ comparer: comparer })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
                op: setAppReady,
                args: comparer
            }));
    const $a6f32366b1daf5c0$export$2583aa269898885c = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppErrorReady: setAppErrorReady })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
                op: setAppErrorReady
            }));
    class $a6f32366b1daf5c0$export$ada7e0ec445851a2 extends (0, $eUqFw.Component) {
        static getDerivedStateFromProps(props, state) {
            const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
            const matchHasChanged = props.match !== state.match;
            const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
            if (setAppStart) props.onSetAppStart(Date.now());
            if (setAppStart || !visitedPageLengthHasChanged) return {
                started: true,
                visitedPagesLength: props.visitedPagesLength,
                match: props.match
            };
            return state;
        }
        render() {
            return null;
        }
        constructor(...args){
            super(...args);
            this.state = {
                visitedPagesLength: 0,
                started: false,
                match: null
            };
        }
    }
    const $a6f32366b1daf5c0$export$6e9ab893e97cccef = ()=>{
        const { visitedPages: visitedPages } = (0, $WBLbN.defaultRegistry).getStore((0, $cfLkw.default)).storeState.getState();
        return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
    };
});
parcelRegister("geFaw", function(module, exports) {
    $parcel$export(module.exports, "StrictMode", ()=>$5551fe9c9ab4b7c0$export$5f8d39834fd61797);
    var $eUqFw = parcelRequire("eUqFw");
    var $1ybV0 = parcelRequire("1ybV0");
    const $5551fe9c9ab4b7c0$export$5f8d39834fd61797 = ({ children: children })=>{
        return (0, $1ybV0.ff)('jfp.magma.enable-strict-mode') ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).StrictMode, null, children) : children;
    };
});
parcelRegister("gTSbo", function(module, exports) {
    $parcel$export(module.exports, "Router", ()=>$cff2cba3bfe91f62$export$55185c17a0fcbe46);
    var $eUqFw = parcelRequire("eUqFw");
    var $lB25E = parcelRequire("lB25E");
    var $8W8mY = parcelRequire("8W8mY");
    const $cff2cba3bfe91f62$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
        const pluginsWithOverride = (0, $8W8mY.usePlugins)({
            resourceContext: props.resourceContext,
            resourceData: props.resourceData
        });
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Router), {
            plugins: pluginsWithOverride,
            ...props
        }, children);
    };
});
parcelRegister("8W8mY", function(module, exports) {
    $parcel$export(module.exports, "usePlugins", ()=>$e161d30d7f706347$export$c41e96fd89bc6106);
    var $eUqFw = parcelRequire("eUqFw");
    var $eoTRo = parcelRequire("eoTRo");
    var $amu7D = parcelRequire("amu7D");
    var $gd0Sp = parcelRequire("gd0Sp");
    var $dW81L = parcelRequire("dW81L");
    const $e161d30d7f706347$export$c41e96fd89bc6106 = ({ resourceContext: resourceContext, resourceData: resourceData })=>{
        const tenantContext = (0, $gd0Sp.useTenantContext)();
        const [pluginsWithOverride] = (0, $eUqFw.useState)(()=>{
            const jiraPlugins = [];
            const resourcesPlugin = (0, $dW81L.createResourcesPlugin)({
                context: resourceContext,
                resourceData: resourceData
            });
            jiraPlugins.push(resourcesPlugin);
            jiraPlugins.push((0, $eoTRo.createEntryPointsPlugin)({
                environment: (0, $amu7D.default)(),
                entryPointParams: {
                    tenantContext: tenantContext
                }
            }));
            return jiraPlugins;
        });
        return pluginsWithOverride;
    };
});
parcelRegister("eoTRo", function(module, exports) {
    $parcel$export(module.exports, "createEntryPointsPlugin", ()=>$8908df19809cff0a$export$33586718f82f356f);
    var $iWLL0 = parcelRequire("iWLL0");
    var $4Wbcp = parcelRequire("4Wbcp");
    var $gglAH = parcelRequire("gglAH");
    var $kP52E = parcelRequire("kP52E");
    const $8908df19809cff0a$export$33586718f82f356f = ({ environment: environment, entryPointParams: entryPointParams })=>({
            id: 'entry-points-plugin',
            routeLoad: ({ context: context })=>{
                const entryPoint = context.route.entryPoint?.();
                const prefetchingRoute = (0, $gglAH.getPrefetchingRoute)();
                let entryPointReference = null;
                if (entryPoint) {
                    if (prefetchingRoute && (0, $4Wbcp.isSameRouteMatch)({
                        prevContextMatch: prefetchingRoute.routerContext.match,
                        nextContextMatch: context.match
                    }) && !(0, $4Wbcp.isExpired)(prefetchingRoute.expiresAt)) entryPointReference = prefetchingRoute.entryPointReference;
                    else entryPointReference = (0, $iWLL0.loadEntryPoint)({
                        getEnvironment: ()=>environment
                    }, entryPoint, {
                        context: context,
                        ...entryPointParams
                    });
                }
                (0, $gglAH.getEntryPointsStore)().actions.setLastLoadedRoute({
                    route: context.route,
                    entryPointReference: entryPointReference
                });
                return {
                    entryPoint: entryPointReference
                };
            },
            routePrefetch: ({ nextContext: nextContext })=>{
                const entryPoint = nextContext.route.entryPoint?.();
                if (entryPoint) {
                    const prevPrefetchingRoute = (0, $gglAH.getPrefetchingRoute)();
                    if (prevPrefetchingRoute && (0, $4Wbcp.isSameRouteMatch)({
                        prevContextMatch: prevPrefetchingRoute.routerContext.match,
                        nextContextMatch: nextContext.match
                    }) && !(0, $4Wbcp.isExpired)(prevPrefetchingRoute.expiresAt)) return;
                    const entryPointReference = (0, $iWLL0.loadEntryPoint)({
                        getEnvironment: ()=>environment
                    }, entryPoint, {
                        context: nextContext,
                        ...entryPointParams
                    });
                    (0, $gglAH.getEntryPointsStore)().actions.setPrefetchingRoute({
                        routerContext: nextContext,
                        expiresAt: (0, $4Wbcp.getExpiresAt)(),
                        entryPointReference: entryPointReference
                    });
                } else (0, $gglAH.getEntryPointsStore)().actions.setPrefetchingRoute({
                    routerContext: nextContext,
                    expiresAt: 0,
                    entryPointReference: null
                });
            },
            waitForEntryPoint: ()=>{
                const lastLoadedRoute = (0, $gglAH.getLastLoadedRoute)();
                const entryPointReference = lastLoadedRoute?.entryPointReference ?? null;
                if (entryPointReference) return (0, $kP52E.waitForEntryPoint)(entryPointReference);
                return Promise.resolve();
            }
        });
});
parcelRegister("4Wbcp", function(module, exports) {
    $parcel$export(module.exports, "getExpiresAt", ()=>$7b677faf33f0c24f$export$b65d7ba7fbf150f1);
    $parcel$export(module.exports, "isExpired", ()=>$7b677faf33f0c24f$export$57947cfd429801a2);
    $parcel$export(module.exports, "isSameRouteMatch", ()=>$7b677faf33f0c24f$export$5997e70fc4543270);
    const $7b677faf33f0c24f$export$37d3126be6549b13 = 10000;
    const $7b677faf33f0c24f$export$b65d7ba7fbf150f1 = ()=>$7b677faf33f0c24f$export$37d3126be6549b13 + Date.now();
    const $7b677faf33f0c24f$export$57947cfd429801a2 = (expiresAt)=>expiresAt < Date.now();
    const $7b677faf33f0c24f$var$isShallowEqual = (o1, o2)=>{
        const objKeys1 = Object.keys(o1);
        const objKeys2 = Object.keys(o2);
        if (objKeys1.length !== objKeys2.length) return false;
        return objKeys1.every((key)=>o1[key] === o2[key]);
    };
    const $7b677faf33f0c24f$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $7b677faf33f0c24f$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $7b677faf33f0c24f$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);
});
parcelRegister("kP52E", function(module, exports) {
    $parcel$export(module.exports, "waitForEntryPoint", ()=>$865808bba2ff8fa0$export$944f853f194e5dd5);
    var $c7ifG = parcelRequire("c7ifG");
    const $865808bba2ff8fa0$export$944f853f194e5dd5 = (entryPointConfig)=>{
        const promises = [];
        try {
            entryPointConfig.getComponent();
        } catch (err) {
            if (err instanceof Promise) promises.push(err);
            else throw err;
        }
        const { queries: queries, entryPoints: entryPoints } = entryPointConfig;
        if (queries) Object.keys(queries).forEach((key)=>{
            if (queries[key].id) {
                const queryPromise = (0, $c7ifG.QueryPromisesMap).get(String(queries[key].id));
                if (queryPromise) promises.push(queryPromise);
            }
        });
        if (entryPoints) Object.keys(entryPoints).forEach((key)=>{
            const nestedEntryPointPromise = $865808bba2ff8fa0$export$944f853f194e5dd5(entryPoints[key]);
            promises.push(nestedEntryPointPromise);
        });
        return Promise.allSettled(promises);
    };
});
parcelRegister("dW81L", function(module, exports) {
    $parcel$export(module.exports, "createResourcesPlugin", ()=>$9aee4cd38ce58613$export$23ed892c481a96fe);
    var $e2YXo = parcelRequire("e2YXo");
    var $l0jNy = parcelRequire("l0jNy");
    const $9aee4cd38ce58613$export$a9bc0bb87abc2c4c = 'resources-plugin';
    const $9aee4cd38ce58613$var$loadOnUrlChange = (context, prevContext)=>{
        const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $e2YXo.getResourceStore)().actions;
        const nextResources = (0, $l0jNy.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
        return Promise.all(requestResources(nextResources, context, {}));
    };
    const $9aee4cd38ce58613$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
        const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $e2YXo.getResourceStore)().actions;
        const nextResources = (0, $l0jNy.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
        cleanExpiredResources(nextResources, nextContext);
    };
    const $9aee4cd38ce58613$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
        let latestLoadedResources = Promise.resolve([]);
        (0, $e2YXo.getResourceStore)().actions.hydrate({
            resourceContext: initialResourceContext,
            resourceData: initialResourceData
        });
        return {
            id: $9aee4cd38ce58613$export$a9bc0bb87abc2c4c,
            beforeRouteLoad: $9aee4cd38ce58613$var$beforeLoad,
            routeLoad: ({ context: context, prevContext: prevContext })=>{
                const { route: route, match: match, query: query } = context;
                if (prevContext) latestLoadedResources = $9aee4cd38ce58613$var$loadOnUrlChange(context, prevContext);
                else latestLoadedResources = (0, $e2YXo.getResourceStore)().actions.requestAllResources({
                    route: route,
                    match: match,
                    query: query
                }, {
                    timeout: timeout
                });
            },
            routePrefetch: ({ context: context, nextContext: nextContext })=>{
                const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $e2YXo.getResourceStore)().actions;
                const nextResources = (0, $l0jNy.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
                return {
                    resources: prefetchResources(nextResources, nextContext, {})
                };
            },
            getLatestResources: ()=>latestLoadedResources,
            getSerializedResources: async ()=>{
                await latestLoadedResources;
                return (0, $e2YXo.getResourceStore)().actions.getSafeData();
            }
        };
    };
});
parcelRegister("l0jNy", function(module, exports) {
    $parcel$export(module.exports, "getResourcesForNextLocation", ()=>$334bbc6cfe5a6fd8$export$7cbbc763e2f3d65d);
    var $8JMlp = parcelRequire("8JMlp");
    var $3DChr = parcelRequire("3DChr");
    const $334bbc6cfe5a6fd8$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
        const { route: prevRoute } = prevRouterStoreContext;
        const { resources: prevResources = [] } = prevRoute || {};
        const { route: nextRoute } = nextRouterStoreContext;
        const { resources: nextResources = [] } = nextRoute || {};
        if (!(0, $3DChr.routeHasResources)(nextRoute)) return [];
        if ((0, $3DChr.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
        const prevResourceIdentifiers = (0, $8JMlp.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
        return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $8JMlp.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
    };
});
parcelRegister("8JMlp", function(module, exports) {
    $parcel$export(module.exports, "getResourceIdentifier", ()=>$3e60e0806526708a$export$c616b176adf9ad4a);
    $parcel$export(module.exports, "getResourceIdentifiers", ()=>$3e60e0806526708a$export$cd7fbe7e979df558);
    const $3e60e0806526708a$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
        const { type: type, getKey: getKey } = resource;
        const key = getKey(routerStoreContext, resourceStoreContext);
        return `${type}/${key}`;
    };
    const $3e60e0806526708a$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$3e60e0806526708a$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));
});
parcelRegister("3DChr", function(module, exports) {
    $parcel$export(module.exports, "routeHasResources", ()=>$135cafef8578dfeb$export$740886389191c640);
    $parcel$export(module.exports, "routeHasChanged", ()=>$135cafef8578dfeb$export$221027ff1aa38f82);
    const $135cafef8578dfeb$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
    const $135cafef8578dfeb$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;
});
parcelRegister("9DIQe", function(module, exports) {
    $parcel$export(module.exports, "JiraRouterLinkConfiguration", ()=>$f7d9123ec5eaca80$export$a580704a2f3cfca);
    var $eUqFw = parcelRequire("eUqFw");
    var $lB25E = parcelRequire("lB25E");
    const $f7d9123ec5eaca80$export$a580704a2f3cfca = (0, $eUqFw.forwardRef)(({ href: href, children: children, ...rest }, ref)=>{
        if (!href || typeof href === 'string') return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
            ref: ref,
            href: href || '#',
            ...rest
        }, children);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Link), {
            ref: ref,
            href: href.href,
            to: href.to,
            replace: href.replace,
            params: href.params,
            query: href.query,
            prefetch: href.prefetch,
            ...rest
        }, children);
    });
});
parcelRegister("ieRGA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$209cb7ee89940e6b$export$2e2bcd8739ae039);
    var $78Ywx = parcelRequire("78Ywx");
    var $kFGm5 = parcelRequire("kFGm5");
    var $209cb7ee89940e6b$export$2e2bcd8739ae039 = (paramsToStrip)=>{
        try {
            const parsedUrl = (0, ($parcel$interopDefault($78Ywx))).parse(window.location.href, true);
            const strippedQuery = (0, ($parcel$interopDefault($kFGm5)))(parsedUrl.query || {}, paramsToStrip);
            let strippedUrl = (0, ($parcel$interopDefault($78Ywx))).format({
                ...parsedUrl,
                search: undefined,
                query: strippedQuery
            });
            const isConnect = /\?|&selectedItem=com.atlassian.plugins.atlassian-connect-plugin:/.test(window.location.search);
            if (isConnect) strippedUrl = strippedUrl.replace(/selectedItem=com.atlassian.plugins.atlassian-connect-plugin%3A/g, (match)=>match.replace(/%3A/i, ':'));
            window.history.replaceState({}, '', strippedUrl);
        } catch (e) {}
    };
});
parcelRegister("7BDEW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fe7d84710661a6d$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $c8Guq = parcelRequire("c8Guq");
    var $hFmdR = parcelRequire("hFmdR");
    var $5BRby = parcelRequire("5BRby");
    var $5CH2F = parcelRequire("5CH2F");
    const $9fe7d84710661a6d$var$defaultSource = 'dwellComponent';
    const $9fe7d84710661a6d$var$defaultActionSubject = 'dwellComponent';
    const $9fe7d84710661a6d$var$getDwellComponent = (source, actionSubject)=>(0, ($parcel$interopDefault($c8Guq)))((0, $hFmdR.AnalyticsSubject)(actionSubject || $9fe7d84710661a6d$var$defaultActionSubject), (0, $hFmdR.AnalyticsSource)(source || $9fe7d84710661a6d$var$defaultSource, (0, $41ea3621645e2acc$export$f636b5b56f1d624a)))((0, $5CH2F.default));
    class $9fe7d84710661a6d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
        static getDerivedStateFromProps(props) {
            const { data: data } = props;
            return {
                DwellTimeComponent: $9fe7d84710661a6d$var$getDwellComponent(data.source, data.actionSubject)
            };
        }
        constructor(props){
            super(props);
            this.state = {
                DwellTimeComponent: null
            };
        }
        render() {
            const { sessionId: sessionId, data: data } = this.props;
            const { DwellTimeComponent: DwellTimeComponent } = this.state;
            const enrichedData = {
                ...data,
                source: data && data.source || $9fe7d84710661a6d$var$defaultSource,
                actionSubject: data && data.actionSubject || $9fe7d84710661a6d$var$defaultActionSubject
            };
            if (sessionId && DwellTimeComponent) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), null, (0, ($parcel$interopDefault($eUqFw))).createElement(DwellTimeComponent, {
                sessionId: sessionId,
                data: enrichedData
            }));
            return null;
        }
    }
});
parcelRegister("5CH2F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6def25be35218960$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $aZSxk = parcelRequire("aZSxk");
    var $eGI9v = parcelRequire("eGI9v");
    var $jUhyG = parcelRequire("jUhyG");
    class $6def25be35218960$export$1c7ccff61c195c75 extends (0, $eUqFw.Component) {
        componentDidMount() {
            const { data: data, sessionId: sessionId } = this.props;
            this.dwellHelper = new (0, $aZSxk.default)(this.sendDwellEvent, data, sessionId);
            this.dwellHelper.start();
        }
        componentDidUpdate(oldProps) {
            if (oldProps.sessionId !== this.props.sessionId && this.dwellHelper !== null) this.dwellHelper.newPage(this.props.data, this.props.sessionId);
        }
        componentWillUnmount() {
            if (this.dwellHelper) {
                this.dwellHelper.stop();
                this.dwellHelper.destroy();
            }
        }
        render() {
            return (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, this.props.children);
        }
        constructor(...args){
            super(...args);
            this.sendDwellEvent = (payload)=>(0, $jUhyG.fireTrackAnalytics)(this.props.createAnalyticsEvent(), payload);
        }
    }
    var $6def25be35218960$export$2e2bcd8739ae039 = (0, $eGI9v.default)('dwellTime', {
        onDwell: 'dwelled'
    })($6def25be35218960$export$1c7ccff61c195c75);
});
parcelRegister("jUhyG", function(module, exports) {
    $parcel$export(module.exports, "fireTrackAnalytics", ()=>$5b05bd1f53288b4a$export$13990ad4625571ed);
    var $3LiTJ = parcelRequire("3LiTJ");
    var $etqm0 = parcelRequire("etqm0");
    var $klunD = parcelRequire("klunD");
    const $5b05bd1f53288b4a$var$isNotUndefined = (a)=>a !== undefined;
    const $5b05bd1f53288b4a$var$mapPayload = (payload)=>{
        const context = (0, $klunD.default)(payload);
        const { action: action, actionSubjectId: actionSubjectId } = payload;
        return (0, ($parcel$interopDefault($3LiTJ)))({
            ...context,
            ...context.attributes,
            attributes: undefined,
            action: action,
            actionSubjectId: actionSubjectId
        }, $5b05bd1f53288b4a$var$isNotUndefined);
    };
    const $5b05bd1f53288b4a$export$13990ad4625571ed = (event, payload)=>{
        event.update({
            ...$5b05bd1f53288b4a$var$mapPayload(payload),
            analyticsType: (0, $etqm0.TRACK_EVENT_TYPE)
        }).fire();
    };
});
parcelRegister("cprue", function(module, exports) {
    $parcel$export(module.exports, "CLEAR_SEARCH_SESSION", ()=>$994d5244595fd50a$export$b669eaa3e4786d5c);
    $parcel$export(module.exports, "skipClearSessionURLs", ()=>$994d5244595fd50a$export$c092460ed33e0e35);
    const $994d5244595fd50a$export$b669eaa3e4786d5c = 'CLEAR_SEARCH_SESSION';
    const $994d5244595fd50a$export$c092460ed33e0e35 = [
        /.*RapidBoard.jspa.*/,
        /\/jira\/software\/c\/projects\/[^/]*\/boards\/.*/,
        /\/jira\/people\/.*\/boards\/.*/
    ];
});
parcelRegister("4ea83", function(module, exports) {
    $parcel$export(module.exports, "setPrefetchStartMark", ()=>$e69acff038046e8f$export$405fde3eab8e39f6);
    $parcel$export(module.exports, "getPrefetchStartMark", ()=>$e69acff038046e8f$export$cbaceb7ffa84279);
    $parcel$export(module.exports, "clearPrefetchStartMarks", ()=>$e69acff038046e8f$export$d6b0928f07bafe57);
    const $e69acff038046e8f$var$prefetchTiming = new Map();
    const $e69acff038046e8f$export$405fde3eab8e39f6 = (match)=>{
        const currentMatch = JSON.stringify(match);
        if (!$e69acff038046e8f$var$prefetchTiming.has(currentMatch)) $e69acff038046e8f$var$prefetchTiming.set(currentMatch, {
            startPrefetchTime: Date.now()
        });
    };
    const $e69acff038046e8f$export$cbaceb7ffa84279 = (match)=>{
        const currentMatch = JSON.stringify(match);
        const { startPrefetchTime: startPrefetchTime } = $e69acff038046e8f$var$prefetchTiming.get(currentMatch) || {
            startPrefetchTime: null
        };
        return startPrefetchTime;
    };
    const $e69acff038046e8f$export$d6b0928f07bafe57 = (match)=>{
        if (!$e69acff038046e8f$var$prefetchTiming || !$e69acff038046e8f$var$prefetchTiming.keys) return;
        const currentMatch = JSON.stringify(match);
        const keys = Array.from($e69acff038046e8f$var$prefetchTiming.keys());
        keys.forEach((mark)=>{
            if (mark !== currentMatch && $e69acff038046e8f$var$prefetchTiming.has(mark)) $e69acff038046e8f$var$prefetchTiming.delete(mark);
        });
    };
});
parcelRegister("fGHk2", function(module, exports) {
    $parcel$export(module.exports, "getSpaRouterContext", ()=>$4819b6a0bbaf9e3c$export$1f61c5e3f6410afa);
    const $4819b6a0bbaf9e3c$export$1f61c5e3f6410afa = ({ tenantContext: tenantContext })=>({
            tenantContext: tenantContext
        });
});
parcelRegister("iE8ll", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a219f83d1047607$export$2e2bcd8739ae039);
    var $cm3xn = parcelRequire("cm3xn");
    var $1ybV0 = parcelRequire("1ybV0");
    var $eI5EY = parcelRequire("eI5EY");
    var $6rW04 = parcelRequire("6rW04");
    var $6ZwQ5 = parcelRequire("6ZwQ5");
    var $iWimt = parcelRequire("iWimt");
    var $dmGGV = parcelRequire("dmGGV");
    var $cpY9k = parcelRequire("cpY9k");
    var $fAobV = parcelRequire("fAobV");
    var $14f04 = parcelRequire("14f04");
    var $dZ9Pk = parcelRequire("dZ9Pk");
    var $emyPh = parcelRequire("emyPh");
    var $kvBcO = parcelRequire("kvBcO");
    var $8NQa5 = parcelRequire("8NQa5");
    var $g62MK = parcelRequire("g62MK");
    const $3a219f83d1047607$var$getUFOConfigFromFF = ()=>(0, $1ybV0.getFeatureFlagValue)('ufo.config', {});
    function $3a219f83d1047607$var$getAdditionalJiraFields(interaction) {
        try {
            return {
                jira: (0, $iWimt.getJiraCustomData)(interaction)
            };
        } catch (error) {
            return {};
        }
    }
    function $3a219f83d1047607$var$loadJiraAnalyticsWebClient() {
        return Promise.resolve((parcelRequire("3FyZ4")));
    }
    function $3a219f83d1047607$export$2e2bcd8739ae039() {
        const ufoConfigFromFF = $3a219f83d1047607$var$getUFOConfigFromFF();
        (0, $6ZwQ5.retrieveAndSetPageLoadTrace)((0, $6rW04.default));
        (0, $14f04.configure)((0, $8NQa5.jiraResourceTimingsConfig));
        (0, $dZ9Pk.startResourceTimingBuffer)();
        (0, $dmGGV.configure)((0, $kvBcO.jiraBundleEvalTimingsConfig));
        (0, $emyPh.configure)((0, $g62MK.jiraSsrConfig));
        (0, $cm3xn.GlobalReactLooselyLazyProfiler).current = (0, $cpY9k.ModuleLoadingProfiler);
        const stopVCAtInteractionFinish = (0, $eI5EY.fg)('stop_vc_at_interaction_finish');
        const enableSegmentHighlighting = (0, $eI5EY.fg)('ufo_enable_segment_highlighting_jira');
        (0, $fAobV.init)($3a219f83d1047607$var$loadJiraAnalyticsWebClient(), {
            ...ufoConfigFromFF,
            enableSegmentHighlighting: enableSegmentHighlighting,
            product: 'jira',
            region: (0, $6rW04.default)('ajs-region') || 'unknown',
            additionalPayloadData: $3a219f83d1047607$var$getAdditionalJiraFields,
            captureLateReRenders: (0, $eI5EY.fg)('ufo_capture_late_rerenders_jira'),
            vc: {
                enabled: (0, $1ybV0.ff)('uip.vc.partial', false),
                heatmapSize: 200,
                oldDomUpdates: false,
                devToolsEnabled: (0, $1ybV0.ff)('uip.vc.devtools', false),
                selectorConfig: {
                    id: true,
                    role: true,
                    className: true,
                    testId: false
                },
                ssr: (0, $1ybV0.ff)('uip.vc.ssr', false),
                stopVCAtInteractionFinish: stopVCAtInteractionFinish
            },
            enableBetterPageVisibilityApi: (0, $1ybV0.ff)('uip.vc.better-page-visibility', false)
        });
    }
});
parcelRegister("6ZwQ5", function(module, exports) {
    $parcel$export(module.exports, "retrieveAndSetPageLoadTrace", ()=>$1ac20787271a9005$export$1a71d2bbe236de99);
    var $dvy3D = parcelRequire("dvy3D");
    let $1ac20787271a9005$var$alreadySet = false;
    const $1ac20787271a9005$export$1a71d2bbe236de99 = (getMeta)=>{
        if (false || $1ac20787271a9005$var$alreadySet) return;
        const traceId = getMeta('X-B3-TraceId') || '';
        const spanId = traceId?.substring(traceId.length - 16) || '';
        $1ac20787271a9005$var$alreadySet = true;
        (0, $dvy3D.setActiveTrace)(traceId, spanId, 'page_load');
    };
});
parcelRegister("iWimt", function(module, exports) {
    $parcel$export(module.exports, "getJiraCustomData", ()=>$6e5e02981879d50b$export$abf5e20822fa925);
    var $eUqFw = parcelRequire("eUqFw");
    var $6rW04 = parcelRequire("6rW04");
    var $6FP8W = parcelRequire("6FP8W");
    var $beHKQ = parcelRequire("beHKQ");
    var $dwuRd = parcelRequire("dwuRd");
    var $kqUgM = parcelRequire("kqUgM");
    var $8eEfr = parcelRequire("8eEfr");
    var $aHzNY = parcelRequire("aHzNY");
    var $5asE8 = parcelRequire("5asE8");
    var $3J8Ab = parcelRequire("3J8Ab");
    var $jRw2l = parcelRequire("jRw2l");
    var $8Icn5 = parcelRequire("8Icn5");
    var $eRsSp = parcelRequire("eRsSp");
    var $byQ0F = parcelRequire("byQ0F");
    function $6e5e02981879d50b$export$abf5e20822fa925(interaction) {
        let customData = {};
        const shard = (0, $6rW04.default)('ajs-shard');
        if (shard !== null && shard !== '') customData.shard = shard;
        customData['network:assetEncoding'] = (0, $beHKQ.getAssetEncoding)();
        const buildVariant = window.BUILD_VARIANT;
        if (buildVariant) customData['app:buildVariant'] = buildVariant;
        const bundlerVersion = window.BUNDLER_VERSION;
        if (bundlerVersion) customData['app:bundlerVersion'] = bundlerVersion;
        const useBifrostGateway = window.USE_BIFROST_GATEWAY;
        if (useBifrostGateway) customData['app:useBifrostGateway'] = useBifrostGateway;
        customData.navType = (0, $6FP8W.getWillShowNav4)() ? 'nav4' : 'nav3';
        customData.httpProtocol = performance.getEntriesByType('resource').find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
        const { start: start, end: end, apdex: apdex } = interaction;
        const stop = apdex?.[0]?.stopTime ?? end;
        customData.memory = (0, $5asE8.getMemoryUsageReport)({
            start: start,
            stop: stop
        });
        const lightHouseMetrics = (0, $8eEfr.getLighthouseMetrics)({
            start: start,
            stop: stop
        });
        customData = {
            ...customData,
            ...lightHouseMetrics
        };
        if (interaction.type === 'page_load') customData = {
            ...customData,
            ...(0, $aHzNY.getMarks)({
                start: start
            }),
            ...(0, $3J8Ab.getPageSizeMetrics)(),
            ...(0, $3J8Ab.getExtraNavigationTimings)(),
            ...(0, $8Icn5.getServerDurationMetrics)(),
            ...(0, $jRw2l.getRouterResourceMetrics)(),
            ...(0, $byQ0F.getWRMStats)(),
            ...(0, $3J8Ab.getPageSizeInfo)({
                start: start,
                stop: stop
            }),
            ...(0, $dwuRd.getCacheHitRatio)({
                start: start
            }),
            ...(0, $kqUgM.getCHRInfo)({
                start: start
            }),
            ...(0, $eRsSp.getSSRStateInformation)(),
            'app:version:web': window.BUILD_KEY,
            'app:version:ssr': window.SSR_BUILD_KEY,
            'app:framework:name': 'react',
            'app:framework:version': (0, $eUqFw.version)
        };
        return customData;
    }
});
parcelRegister("beHKQ", function(module, exports) {
    $parcel$export(module.exports, "getAssetEncoding", ()=>$ddd7bcb16f8788d2$export$fd12d8f45e126585);
    function $ddd7bcb16f8788d2$export$fd12d8f45e126585() {
        const assetEncodings = Array.prototype.map.call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')).reduce((acc, i)=>{
            acc[i] = true;
            return acc;
        }, {});
        const uniqueEncodings = Object.keys(assetEncodings).sort();
        let result = 'unknown';
        if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
        if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
        return result;
    }
});
parcelRegister("dwuRd", function(module, exports) {
    $parcel$export(module.exports, "getCacheHitRatio", ()=>$a8062b19e2d539f7$export$e8a9322c3d9da8a6);
    var $hgcvd = parcelRequire("hgcvd");
    const $a8062b19e2d539f7$var$cacheableTypes = [
        'script',
        'link'
    ];
    const $a8062b19e2d539f7$var$CACHE_NETWORK = 'network';
    const $a8062b19e2d539f7$var$CACHE_MEMORY = 'memory';
    const $a8062b19e2d539f7$var$CACHE_DISK = 'disk';
    const $a8062b19e2d539f7$var$calculateTransferType = (type, duration, size)=>{
        if (!$a8062b19e2d539f7$var$cacheableTypes.includes(type)) return $a8062b19e2d539f7$var$CACHE_NETWORK;
        if ((size === undefined || size === 0) && duration === 0) return $a8062b19e2d539f7$var$CACHE_MEMORY;
        if (size === 0 && duration > 0) return $a8062b19e2d539f7$var$CACHE_DISK;
        if (size === undefined) return null;
        return $a8062b19e2d539f7$var$CACHE_NETWORK;
    };
    const $a8062b19e2d539f7$export$e8a9322c3d9da8a6 = ({ start: start })=>{
        let fromCache = 0;
        let preloadFromCache = 0;
        let total = 0;
        let totalPreload = 0;
        if (start !== 0) return {};
        try {
            for (const entry of (0, $hgcvd.default).getEntriesByType('resource')){
                const transferType = $a8062b19e2d539f7$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
                const isPreload = entry.initiatorType === 'link';
                if (transferType === 'disk' || transferType === 'memory') {
                    fromCache += 1;
                    if (isPreload) preloadFromCache += 1;
                }
                if (transferType !== null) {
                    total += 1;
                    if (isPreload) totalPreload += 1;
                }
            }
            const result = {};
            if (total > 0) result.cacheHitRatio = fromCache / total;
            if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
            return result;
        } catch (e) {
            return {};
        }
    };
});
parcelRegister("kqUgM", function(module, exports) {
    $parcel$export(module.exports, "getCHRInfo", ()=>$a49f9fd15e6ffe2a$export$9e005e111be93521);
    var $6iz4v = parcelRequire("6iz4v");
    var $hgcvd = parcelRequire("hgcvd");
    var $3nE1C = parcelRequire("3nE1C");
    const $a49f9fd15e6ffe2a$var$SPA_SSR_RENDERED = 'ssr.spa.rendered';
    const $a49f9fd15e6ffe2a$export$1faf7d001841a41c = ()=>(0, $6iz4v.getMark)($a49f9fd15e6ffe2a$var$SPA_SSR_RENDERED)?.startTime || null;
    const $a49f9fd15e6ffe2a$export$9e005e111be93521 = ({ start: start })=>{
        if (start !== 0) return {};
        const ssrMark = $a49f9fd15e6ffe2a$export$1faf7d001841a41c();
        const reporter = new (0, $3nE1C.CHRReporter)(ssrMark);
        try {
            for (const entry of (0, $hgcvd.default).getEntriesByType('resource'))reporter.add(entry);
            const chr = reporter.get();
            return chr === null ? {} : {
                chr: chr
            };
        } catch (e) {
            return {};
        }
    };
});
parcelRegister("3nE1C", function(module, exports) {
    $parcel$export(module.exports, "CHRReporter", ()=>$1c95c343c16ecaf5$export$7d0d4cfb6455ffa5);
    var $80Pke = parcelRequire("80Pke");
    var $eUF4z = parcelRequire("eUF4z");
    class $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5 {
        constructor(ssrMark){
            this.preloaded = new (0, $eUF4z.CHRSummary)();
            this.all = new (0, $eUF4z.CHRSummary)();
            this.ssrMark = null;
            this.ssrMark = ssrMark;
        }
        add(item) {
            if (item.encodedBodySize === 0) return;
            if (item.initiatorType === 'link' && (0, $80Pke.cacheableTypes).includes(item.initiatorType) && (this.ssrMark === null || item.startTime < this.ssrMark)) this.preloaded.add(item);
            this.all.add(item);
        }
        static round(n) {
            return Math.round(n * 10000) / 10000;
        }
        makePayload(summary) {
            const bundlesLoadType = {
                mem: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $eUF4z.CHRSummary).MEMORY_KEY] / summary.bundlesCount),
                disk: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $eUF4z.CHRSummary).DISK_KEY] / summary.bundlesCount),
                net: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $eUF4z.CHRSummary).NETWORK_KEY] / summary.bundlesCount)
            };
            const bundlesRatio = $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, $eUF4z.CHRSummary).MEMORY_KEY] + summary.bundles[(0, $eUF4z.CHRSummary).DISK_KEY]) / summary.bundlesCount);
            const sizeLoadType = {
                mem: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.size[(0, $eUF4z.CHRSummary).MEMORY_KEY] / summary.sizeTotal),
                disk: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.size[(0, $eUF4z.CHRSummary).DISK_KEY] / summary.sizeTotal),
                net: $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round(summary.size[(0, $eUF4z.CHRSummary).NETWORK_KEY] / summary.sizeTotal)
            };
            const sizeRatio = $1c95c343c16ecaf5$export$7d0d4cfb6455ffa5.round((summary.size[(0, $eUF4z.CHRSummary).MEMORY_KEY] + summary.size[(0, $eUF4z.CHRSummary).DISK_KEY]) / summary.sizeTotal);
            return {
                bundles: {
                    ratio: bundlesRatio,
                    count: summary.bundlesCount,
                    loadType: bundlesLoadType
                },
                size: {
                    ratio: sizeRatio,
                    total: summary.sizeTotal,
                    loadType: sizeLoadType
                }
            };
        }
        get() {
            if (this.all.bundlesCount === 0) return null;
            return {
                preloaded: this.makePayload(this.preloaded),
                all: this.makePayload(this.all)
            };
        }
    }
});
parcelRegister("80Pke", function(module, exports) {
    $parcel$export(module.exports, "cacheableTypes", ()=>$b8a696433745e025$export$5e1aa91d6932ddaa);
    const $b8a696433745e025$export$5e1aa91d6932ddaa = [
        'script',
        'link'
    ];
});
parcelRegister("eUF4z", function(module, exports) {
    $parcel$export(module.exports, "CHRSummary", ()=>$d4108de44c777dc2$export$783d6618ee601ba);
    var $80Pke = parcelRequire("80Pke");
    const $d4108de44c777dc2$var$calculateTransferType = (type, duration, size)=>{
        if (!(0, $80Pke.cacheableTypes).includes(type)) return null;
        if ((size === undefined || size === 0) && duration === 0) return $d4108de44c777dc2$export$783d6618ee601ba.MEMORY_KEY;
        if (size === 0 && duration > 0) return $d4108de44c777dc2$export$783d6618ee601ba.DISK_KEY;
        if (size === undefined) return null;
        return $d4108de44c777dc2$export$783d6618ee601ba.NETWORK_KEY;
    };
    class $d4108de44c777dc2$export$783d6618ee601ba {
        static{
            this.MEMORY_KEY = 'mem';
        }
        static{
            this.DISK_KEY = 'disk';
        }
        static{
            this.NETWORK_KEY = 'net';
        }
        add(item) {
            const type = $d4108de44c777dc2$var$calculateTransferType(item.initiatorType, item.duration, item.transferSize);
            if (type === null) return;
            this.bundles[type] += 1;
            this.bundlesCount += 1;
            this.size[type] += item.encodedBodySize;
            this.sizeTotal += item.encodedBodySize;
        }
        constructor(){
            this.bundles = {
                [$d4108de44c777dc2$export$783d6618ee601ba.MEMORY_KEY]: 0,
                [$d4108de44c777dc2$export$783d6618ee601ba.DISK_KEY]: 0,
                [$d4108de44c777dc2$export$783d6618ee601ba.NETWORK_KEY]: 0
            };
            this.bundlesCount = 0;
            this.size = {
                [$d4108de44c777dc2$export$783d6618ee601ba.MEMORY_KEY]: 0,
                [$d4108de44c777dc2$export$783d6618ee601ba.DISK_KEY]: 0,
                [$d4108de44c777dc2$export$783d6618ee601ba.NETWORK_KEY]: 0
            };
            this.sizeTotal = 0;
        }
    }
});
parcelRegister("8eEfr", function(module, exports) {
    $parcel$export(module.exports, "getLighthouseMetrics", ()=>$c429933143d93b08$export$b46cecdf698e4bb5);
    var $6yB0H = parcelRequire("6yB0H");
    var $fU1DZ = parcelRequire("fU1DZ");
    var $ki7im = parcelRequire("ki7im");
    var $HvJRS = parcelRequire("HvJRS");
    var $iv3lO = parcelRequire("iv3lO");
    function $c429933143d93b08$export$5ecf2aafafee3e0() {
        (0, $iv3lO.startLSObserver)();
        (0, $iv3lO.startLTObserver)();
    }
    const $c429933143d93b08$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
        const tbt = (0, $ki7im.getTBT)(start, stop, (0, $HvJRS.EntriesBuffer)[(0, $fU1DZ.PerformanceObserverEntryTypes).LongTask]);
        const cls = (0, $6yB0H.getCLS)(start, stop, (0, $HvJRS.EntriesBuffer)[(0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift]);
        return {
            'metric:tbt': Math.round(tbt.total),
            'metric:tbt:observed': Math.round(tbt.observed),
            'metric:cls': cls
        };
    };
});
parcelRegister("6yB0H", function(module, exports) {
    $parcel$export(module.exports, "getCLS", ()=>$d45da93e3b9b262f$export$fc6227831ee7c7);
    const $d45da93e3b9b262f$export$fc6227831ee7c7 = (start, stop, buffer)=>{
        const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
        const sessionWindows = [];
        let currentWindow = null;
        for (const shift of layoutShifts){
            const { startTime: startTime } = shift;
            const endTime = shift.startTime + shift.duration;
            const score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
        const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
        return Math.round(maxScore * 10000) / 10000;
    };
});
parcelRegister("fU1DZ", function(module, exports) {
    $parcel$export(module.exports, "PerformanceObserverEntryTypes", ()=>$234a057f27dc569a$export$a4def92db6fc8e17);
    const $234a057f27dc569a$export$a4def92db6fc8e17 = {
        LayoutShift: 'layout-shift',
        LongTask: 'longtask'
    };
});
parcelRegister("ki7im", function(module, exports) {
    $parcel$export(module.exports, "getTBT", ()=>$69d3b5006a881dee$export$2d6e933b35bd3407);
    const $69d3b5006a881dee$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
    const $69d3b5006a881dee$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $69d3b5006a881dee$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
            const longTaskStop = entry.startTime + entry.duration;
            const intersectStart = Math.max(entry.startTime + $69d3b5006a881dee$var$MAX_ACCEPTABLE_TASK_DURATION, start);
            const intersectStop = Math.min(longTaskStop, stop);
            const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
            tbt.observed += entry.duration - $69d3b5006a881dee$var$MAX_ACCEPTABLE_TASK_DURATION;
            tbt.total += longTaskIncluded;
            return tbt;
        }, {
            total: 0,
            observed: 0
        });
});
parcelRegister("HvJRS", function(module, exports) {
    $parcel$export(module.exports, "EntriesBuffer", ()=>$726140cc85f82002$export$f7dc16cbd16f7bbe);
    var $fU1DZ = parcelRequire("fU1DZ");
    class $726140cc85f82002$export$2c6e86519c9e8188 {
        constructor(maxLength = 1000){
            this.buffer = [];
            this.full = false;
            this.maxLength = maxLength;
        }
        push(item) {
            if (this.full || this.maxLength === this.buffer.length) {
                this.full = true;
                this.buffer.shift();
            }
            this.buffer.push(item);
        }
        getAll() {
            return this.buffer;
        }
    }
    const $726140cc85f82002$export$f7dc16cbd16f7bbe = {
        [(0, $fU1DZ.PerformanceObserverEntryTypes).LongTask]: new $726140cc85f82002$export$2c6e86519c9e8188(),
        [(0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift]: new $726140cc85f82002$export$2c6e86519c9e8188()
    };
});
parcelRegister("iv3lO", function(module, exports) {
    $parcel$export(module.exports, "startLSObserver", ()=>$dba5609f3cb4bc6f$export$768ccc3ab7bac3ea);
    $parcel$export(module.exports, "startLTObserver", ()=>$dba5609f3cb4bc6f$export$54fb8b6aaf70ec9c);
    var $fU1DZ = parcelRequire("fU1DZ");
    var $HvJRS = parcelRequire("HvJRS");
    let $dba5609f3cb4bc6f$var$pe = null;
    const $dba5609f3cb4bc6f$var$getObserver = ()=>{
        if ($dba5609f3cb4bc6f$var$pe !== null) return $dba5609f3cb4bc6f$var$pe;
        $dba5609f3cb4bc6f$var$pe = new PerformanceObserver((list)=>{
            list.getEntries().forEach((entry)=>{
                if (entry.entryType === (0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift) (0, $HvJRS.EntriesBuffer)[(0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift].push(entry);
                if (entry.entryType === (0, $fU1DZ.PerformanceObserverEntryTypes).LongTask) (0, $HvJRS.EntriesBuffer)[(0, $fU1DZ.PerformanceObserverEntryTypes).LongTask].push(entry);
            });
        });
        return $dba5609f3cb4bc6f$var$pe;
    };
    const $dba5609f3cb4bc6f$export$768ccc3ab7bac3ea = ()=>{
        $dba5609f3cb4bc6f$var$getObserver().observe({
            type: (0, $fU1DZ.PerformanceObserverEntryTypes).LayoutShift,
            buffered: true
        });
    };
    const $dba5609f3cb4bc6f$export$54fb8b6aaf70ec9c = ()=>{
        $dba5609f3cb4bc6f$var$getObserver().observe({
            type: (0, $fU1DZ.PerformanceObserverEntryTypes).LongTask,
            buffered: true
        });
    };
});
parcelRegister("aHzNY", function(module, exports) {
    $parcel$export(module.exports, "getMarks", ()=>$060b26259ca6e3b9$export$9d952633c9c2237b);
    var $llxpa = parcelRequire("llxpa");
    var $hknOo = parcelRequire("hknOo");
    const $060b26259ca6e3b9$export$9d952633c9c2237b = (data)=>{
        const userTiming = (0, $llxpa.getUserTiming)();
        if (userTiming === null) return null;
        const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
        const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
            let candidateName = baseName;
            let counter = 2;
            let validName;
            while(!validName)if (candidateName in collection) {
                candidateName = `${baseName}_${counter}`;
                counter += 1;
            } else validName = candidateName;
            return validName;
        };
        const marks = {};
        userTiming.filter((item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, $hknOo.JS_EVAL_START)) && !item.name.endsWith((0, $hknOo.JS_EVAL_STOP)) && item.startTime >= data.start).forEach((item)=>{
            const name = getNextAvailableName({
                baseName: `mark__${sanitizeName(item.name)}`,
                collection: marks
            });
            marks[name] = Math.round(item.startTime - data.start);
        });
        return marks;
    };
});
parcelRegister("5asE8", function(module, exports) {
    $parcel$export(module.exports, "getMemoryUsageReport", ()=>$94ae843e3148994a$export$e5bd2d61c7c80651);
    const $94ae843e3148994a$export$e5bd2d61c7c80651 = ({ start: start, stop: stop })=>{
        if (typeof performance === 'undefined' || performance?.memory == null) return null;
        const sessionTime = Math.round(stop - start);
        const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
        return {
            sessionTime: sessionTime,
            performanceMemoryEntry: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        };
    };
});
parcelRegister("3J8Ab", function(module, exports) {
    $parcel$export(module.exports, "getPageSizeMetrics", ()=>$3c810a8de2a9a285$export$84e3d676f1564c75);
    $parcel$export(module.exports, "getExtraNavigationTimings", ()=>$3c810a8de2a9a285$export$b37a70af06e58097);
    $parcel$export(module.exports, "getPageSizeInfo", ()=>$3c810a8de2a9a285$export$b72e035af6568be7);
    var $hgcvd = parcelRequire("hgcvd");
    const $3c810a8de2a9a285$export$84e3d676f1564c75 = ()=>{
        let maxDepth = -1;
        let maxWidth = -1;
        let numElements = 0;
        const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
            if (!el) return;
            if (depth > maxDepth) maxDepth = depth;
            if (el.children.length > maxWidth) maxWidth = el.children.length;
            let child = el.firstElementChild;
            while(child){
                calculateDOMsizeAndDepth(child, depth + 1);
                if (child.shadowRoot) calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
                child = child.nextElementSibling;
                numElements += 1;
            }
        };
        calculateDOMsizeAndDepth();
        return {
            totalBodyElements: numElements,
            maxNestedLevels: maxDepth,
            maxChildElements: maxWidth
        };
    };
    const $3c810a8de2a9a285$export$b37a70af06e58097 = ()=>{
        if (!(0, $hgcvd.default)) return {};
        const navigation = (0, $hgcvd.default).getEntriesByType('navigation')[0];
        if (!navigation) return {};
        return {
            decodedBodySize: navigation.decodedBodySize,
            encodedBodySize: navigation.encodedBodySize,
            transferSize: navigation.transferSize
        };
    };
    const $3c810a8de2a9a285$var$assetsTypes = [
        'script',
        'link'
    ];
    const $3c810a8de2a9a285$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
        const pageSize = $3c810a8de2a9a285$export$b37a70af06e58097();
        if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
        const decoded = {
            total: pageSize.decodedBodySize,
            pageSize: pageSize.decodedBodySize,
            assets: 0,
            endpoints: 0
        };
        const encoded = {
            total: pageSize.encodedBodySize,
            pageSize: pageSize.encodedBodySize,
            assets: 0,
            endpoints: 0
        };
        const net = {
            total: pageSize.transferSize,
            assets: 0,
            endpoints: 0
        };
        for (const entry of (0, $hgcvd.default).getEntriesByType('resource')){
            if (entry.startTime > stop) continue;
            if ($3c810a8de2a9a285$var$assetsTypes.includes(entry.initiatorType)) {
                decoded.total += entry.decodedBodySize;
                decoded.assets += entry.decodedBodySize;
                encoded.total += entry.encodedBodySize;
                encoded.assets += entry.encodedBodySize;
                net.total += entry.transferSize;
                net.assets += entry.transferSize;
            } else {
                decoded.total += entry.decodedBodySize;
                decoded.endpoints += entry.decodedBodySize;
                encoded.total += entry.encodedBodySize;
                encoded.endpoints += entry.encodedBodySize;
                net.total += entry.transferSize;
                net.endpoints += entry.transferSize;
            }
        }
        const returnValue = {};
        Object.keys(decoded).forEach((key)=>{
            returnValue[`size:decoded:${key}`] = decoded[key];
        });
        Object.keys(encoded).forEach((key)=>{
            returnValue[`size:encoded:${key}`] = encoded[key];
        });
        Object.keys(net).forEach((key)=>{
            returnValue[`size:net:${key}`] = net[key];
        });
        return returnValue;
    };
});
parcelRegister("jRw2l", function(module, exports) {
    $parcel$export(module.exports, "getRouterResourceMetrics", ()=>$408d5049c0fbe74b$export$e703af446a67c7f4);
    const $408d5049c0fbe74b$export$e703af446a67c7f4 = ()=>{
        const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
            if (key !== key.toUpperCase()) return false;
            const resource = window.SPA_STATE[key];
            if (typeof resource !== 'object') return false;
            const resourceResponse = resource[Object.keys(resource)[0]];
            return resourceResponse?.error?.name === 'TimeoutError';
        }) : [];
        return {
            ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
        };
    };
});
parcelRegister("8Icn5", function(module, exports) {
    $parcel$export(module.exports, "getServerDurationMetrics", ()=>$812c01dc8d4942e0$export$efd8b60b870e5282);
    const $812c01dc8d4942e0$export$efd8b60b870e5282 = ()=>{
        const metrics = {};
        try {
            const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
            if (serverDurationElem) {
                const serverDuration = Number(serverDurationElem.value);
                if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
            }
            const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
            if (serverTraceIdElem) {
                const serverRequestTraceId = serverTraceIdElem.value;
                metrics.serverRequestTraceId = serverRequestTraceId;
            }
            const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
            if (serverTraceSampledElem) {
                const serverRequestTraceSampled = serverTraceSampledElem.value;
                switch(serverRequestTraceSampled){
                    case 'true':
                        metrics.serverRequestTraceSampled = true;
                        break;
                    case 'false':
                        metrics.serverRequestTraceSampled = false;
                        break;
                    default:
                        metrics.serverRequestTraceSampled = null;
                        break;
                }
            }
            const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
            if (concurrentRequestsElem) {
                const concurrentRequests = concurrentRequestsElem.value;
                metrics.concurrentRequests = concurrentRequests;
            }
            const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
            if (serverRequestStartTimeElem) {
                const serverRequestStartTime = serverRequestStartTimeElem.value;
                metrics.serverRequestStartTime = serverRequestStartTime;
            }
            const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
            if (frontendFlushStartTimeElem) {
                const frontendFlushStartTime = frontendFlushStartTimeElem.value;
                metrics.frontendFlushStartTime = frontendFlushStartTime;
            }
        } catch (ignored) {}
        return metrics;
    };
});
parcelRegister("eRsSp", function(module, exports) {
    $parcel$export(module.exports, "getSSRStateInformation", ()=>$9d0a7886cfd1a973$export$9a46186893ad76bd);
    var $6iz4v = parcelRequire("6iz4v");
    const $9d0a7886cfd1a973$var$getState = ()=>{
        if ((0, $6iz4v.getMark)('ssr.spa.state')?.startTime) return 'success';
        if ((0, $6iz4v.getMark)('ssr.spa.early-common-flush:end')?.startTime) return 'spa-render-failure';
        return 'static-fallback';
    };
    const $9d0a7886cfd1a973$export$9a46186893ad76bd = ()=>{
        return {
            'ssr:state': $9d0a7886cfd1a973$var$getState()
        };
    };
});
parcelRegister("byQ0F", function(module, exports) {
    $parcel$export(module.exports, "getWRMStats", ()=>$3a9718319a9f67d8$export$d2d916ddd03b82bc);
    const $3a9718319a9f67d8$export$d2d916ddd03b82bc = ()=>{
        const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
        return {
            wrmStats: wrmStats
        };
    };
});
parcelRegister("dmGGV", function(module, exports) {
    $parcel$export(module.exports, "configure", ()=>$2f3d074884e5869d$export$8d21e34596265fa2);
    $parcel$export(module.exports, "getBundleEvalTimings", ()=>$2f3d074884e5869d$export$2eda1519e91a4386);
    var $65fDB = parcelRequire("65fDB");
    let $2f3d074884e5869d$var$config = null;
    function $2f3d074884e5869d$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
        $2f3d074884e5869d$var$config = bundleEvalTimingConfiguration;
    }
    const $2f3d074884e5869d$var$getPerformanceObject = ()=>(window ?? {}).performance;
    function $2f3d074884e5869d$export$2eda1519e91a4386(interactionStartTime) {
        if ($2f3d074884e5869d$var$config == null) return {};
        const started = {};
        const timings = {};
        const cachedConfig = $2f3d074884e5869d$var$config;
        const performance = $2f3d074884e5869d$var$getPerformanceObject();
        performance?.getEntriesByType('mark').forEach((mark)=>{
            const result = cachedConfig.mapPerformanceMark(mark.name);
            if (!result) return;
            const { type: type, name: name } = result;
            if (type === 'start' && mark.startTime >= interactionStartTime) {
                started[name] = mark;
                return;
            }
            if (type === 'end' && started[name]) {
                timings[name] = {
                    startTime: (0, $65fDB.roundEpsilon)(started[name].startTime - interactionStartTime),
                    duration: (0, $65fDB.roundEpsilon)(mark.startTime - started[name].startTime)
                };
                delete started[name];
            }
        });
        if (Object.keys(timings).length === 0) return {};
        return timings;
    }
});
parcelRegister("65fDB", function(module, exports) {
    $parcel$export(module.exports, "roundEpsilon", ()=>$06948f7509e4cee6$export$56014375de40214b);
    const $06948f7509e4cee6$export$56014375de40214b = (num, places = 3)=>{
        const factor = Math.pow(10, places);
        return Math.round((num + Number.EPSILON) * factor) / factor;
    };
});
parcelRegister("fAobV", function(module, exports) {
    $parcel$export(module.exports, "init", ()=>$71f08ac61b406203$export$2cd8252107eb640b);
    var $9oL1R = parcelRequire("9oL1R");
    var $hAKZZ = parcelRequire("hAKZZ");
    var $7mfzA = parcelRequire("7mfzA");
    var $1ozuH = parcelRequire("1ozuH");
    var $cpY9k = parcelRequire("cpY9k");
    var $ismmz = parcelRequire("ismmz");
    let $71f08ac61b406203$var$initialized = false;
    function $71f08ac61b406203$var$sinkInteraction(instance, payloadPackage) {
        (0, $cpY9k.sinkInteractionHandler)((interactionId, interaction)=>{
            (0, $9oL1R.unstable_scheduleCallback)((0, $9oL1R.unstable_IdlePriority), ()=>{
                const payloads = payloadPackage.createPayloads(interactionId, interaction);
                payloads?.forEach((payload)=>{
                    instance.sendOperationalEvent(payload);
                });
            });
        });
    }
    function $71f08ac61b406203$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
        (0, $cpY9k.sinkPostInteractionLogHandler)((logOutput)=>{
            (0, $9oL1R.unstable_scheduleCallback)((0, $9oL1R.unstable_IdlePriority), ()=>{
                const payload = createPostInteractionLogPayload(logOutput);
                if (payload) instance.sendOperationalEvent(payload);
            });
        });
    }
    const $71f08ac61b406203$export$2cd8252107eb640b = (analyticsWebClientAsync, config)=>{
        if ($71f08ac61b406203$var$initialized) return;
        (0, $7mfzA.setUFOConfig)(config);
        if (config.vc?.enabled) (0, $ismmz.getVCObserver)({
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig
        }).start({
            startTime: 0
        });
        (0, $1ozuH.setupHiddenTimingCapture)();
        (0, $hAKZZ.startLighthouseObserver)();
        $71f08ac61b406203$var$initialized = true;
        Promise.all([
            analyticsWebClientAsync,
            (parcelRequire("9h6de")),
            (parcelRequire("OliJI"))
        ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage])=>{
            if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
                const instance = client.getInstance();
                $71f08ac61b406203$var$sinkInteraction(instance, payloadPackage);
                if (config.captureLateReRenders) $71f08ac61b406203$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            });
            else if (awc.sendOperationalEvent) {
                $71f08ac61b406203$var$sinkInteraction(awc, payloadPackage);
                if (config.captureLateReRenders) $71f08ac61b406203$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            }
        });
    };
});
parcelRegister("hAKZZ", function(module, exports) {
    $parcel$export(module.exports, "startLighthouseObserver", ()=>$07e9487ead9f06a3$export$5ecf2aafafee3e0);
    $parcel$export(module.exports, "getLighthouseMetrics", ()=>$07e9487ead9f06a3$export$b46cecdf698e4bb5);
    var $6TfXJ = parcelRequire("6TfXJ");
    var $gEivM = parcelRequire("gEivM");
    var $j1HaJ = parcelRequire("j1HaJ");
    var $8laJw = parcelRequire("8laJw");
    var $5qLiP = parcelRequire("5qLiP");
    function $07e9487ead9f06a3$export$5ecf2aafafee3e0() {
        (0, $5qLiP.startLSObserver)();
        (0, $5qLiP.startLTObserver)();
    }
    const $07e9487ead9f06a3$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
        const tbt = (0, $j1HaJ.getTBT)(start, stop, (0, $8laJw.EntriesBuffer)[(0, $gEivM.PerformanceObserverEntryTypes).LongTask]);
        const cls = (0, $6TfXJ.getCLS)(start, stop, (0, $8laJw.EntriesBuffer)[(0, $gEivM.PerformanceObserverEntryTypes).LayoutShift]);
        return {
            'metric:tbt': Math.round(tbt.total),
            'metric:tbt:observed': Math.round(tbt.observed),
            'metric:cls': cls
        };
    };
});
parcelRegister("6TfXJ", function(module, exports) {
    $parcel$export(module.exports, "getCLS", ()=>$386dd19e0e0751c0$export$fc6227831ee7c7);
    const $386dd19e0e0751c0$export$fc6227831ee7c7 = (start, stop, buffer)=>{
        const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
        const sessionWindows = [];
        let currentWindow = null;
        for (const shift of layoutShifts){
            const { startTime: startTime } = shift;
            const endTime = shift.startTime + shift.duration;
            const score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
        const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
        return Math.round(maxScore * 10000) / 10000;
    };
});
parcelRegister("gEivM", function(module, exports) {
    $parcel$export(module.exports, "PerformanceObserverEntryTypes", ()=>$3ad831155e676b51$export$a4def92db6fc8e17);
    const $3ad831155e676b51$export$a4def92db6fc8e17 = {
        LayoutShift: 'layout-shift',
        LongTask: 'longtask'
    };
});
parcelRegister("j1HaJ", function(module, exports) {
    $parcel$export(module.exports, "getTBT", ()=>$050970d392181a76$export$2d6e933b35bd3407);
    const $050970d392181a76$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
    const $050970d392181a76$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $050970d392181a76$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
            const longTaskStop = entry.startTime + entry.duration;
            const intersectStart = Math.max(entry.startTime + $050970d392181a76$var$MAX_ACCEPTABLE_TASK_DURATION, start);
            const intersectStop = Math.min(longTaskStop, stop);
            const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
            tbt.observed += entry.duration - $050970d392181a76$var$MAX_ACCEPTABLE_TASK_DURATION;
            tbt.total += longTaskIncluded;
            return tbt;
        }, {
            total: 0,
            observed: 0
        });
});
parcelRegister("8laJw", function(module, exports) {
    $parcel$export(module.exports, "EntriesBuffer", ()=>$c3f5ad4268238d5b$export$f7dc16cbd16f7bbe);
    var $gEivM = parcelRequire("gEivM");
    class $c3f5ad4268238d5b$export$2c6e86519c9e8188 {
        constructor(maxLength = 1000){
            this.buffer = [];
            this.full = false;
            this.maxLength = maxLength;
        }
        push(item) {
            if (this.full || this.maxLength === this.buffer.length) {
                this.full = true;
                this.buffer.shift();
            }
            this.buffer.push(item);
        }
        getAll() {
            return this.buffer;
        }
    }
    const $c3f5ad4268238d5b$export$f7dc16cbd16f7bbe = {
        [(0, $gEivM.PerformanceObserverEntryTypes).LongTask]: new $c3f5ad4268238d5b$export$2c6e86519c9e8188(),
        [(0, $gEivM.PerformanceObserverEntryTypes).LayoutShift]: new $c3f5ad4268238d5b$export$2c6e86519c9e8188()
    };
});
parcelRegister("5qLiP", function(module, exports) {
    $parcel$export(module.exports, "startLSObserver", ()=>$e25a6ae1b52ddd55$export$768ccc3ab7bac3ea);
    $parcel$export(module.exports, "startLTObserver", ()=>$e25a6ae1b52ddd55$export$54fb8b6aaf70ec9c);
    var $gEivM = parcelRequire("gEivM");
    var $8laJw = parcelRequire("8laJw");
    let $e25a6ae1b52ddd55$var$pe = null;
    const $e25a6ae1b52ddd55$var$getObserver = ()=>{
        if ($e25a6ae1b52ddd55$var$pe !== null) return $e25a6ae1b52ddd55$var$pe;
        $e25a6ae1b52ddd55$var$pe = new PerformanceObserver((list)=>{
            list.getEntries().forEach((entry)=>{
                if (entry.entryType === (0, $gEivM.PerformanceObserverEntryTypes).LayoutShift) (0, $8laJw.EntriesBuffer)[(0, $gEivM.PerformanceObserverEntryTypes).LayoutShift].push(entry);
                if (entry.entryType === (0, $gEivM.PerformanceObserverEntryTypes).LongTask) (0, $8laJw.EntriesBuffer)[(0, $gEivM.PerformanceObserverEntryTypes).LongTask].push(entry);
            });
        });
        return $e25a6ae1b52ddd55$var$pe;
    };
    const $e25a6ae1b52ddd55$export$768ccc3ab7bac3ea = ()=>{
        $e25a6ae1b52ddd55$var$getObserver().observe({
            type: (0, $gEivM.PerformanceObserverEntryTypes).LayoutShift,
            buffered: true
        });
    };
    const $e25a6ae1b52ddd55$export$54fb8b6aaf70ec9c = ()=>{
        $e25a6ae1b52ddd55$var$getObserver().observe({
            type: (0, $gEivM.PerformanceObserverEntryTypes).LongTask,
            buffered: true
        });
    };
});
parcelRegister("1ozuH", function(module, exports) {
    $parcel$export(module.exports, "setupHiddenTimingCapture", ()=>$e2636c669d04c60b$export$554cefe0f0373da4);
    $parcel$export(module.exports, "getPageVisibilityState", ()=>$e2636c669d04c60b$export$768b2008623433e1);
    var $74BVL = parcelRequire("74BVL");
    const $e2636c669d04c60b$var$timings = [];
    let $e2636c669d04c60b$var$wasHiddenFlag;
    let $e2636c669d04c60b$var$setupFlag = false;
    function $e2636c669d04c60b$var$isPageHidden() {
        if ('visibilityState' in document) return document.visibilityState === 'hidden';
        else return document.hidden;
    }
    const $e2636c669d04c60b$var$SIZE = 50;
    let $e2636c669d04c60b$var$insertIndex = 0;
    function $e2636c669d04c60b$var$pushHidden(isPageHiddenFlag, time) {
        $e2636c669d04c60b$var$timings[$e2636c669d04c60b$var$insertIndex] = {
            time: time ?? performance.now(),
            hidden: isPageHiddenFlag
        };
        $e2636c669d04c60b$var$insertIndex = ($e2636c669d04c60b$var$insertIndex + 1) % $e2636c669d04c60b$var$SIZE;
        $e2636c669d04c60b$var$wasHiddenFlag = isPageHiddenFlag;
    }
    function $e2636c669d04c60b$var$handleChange() {
        const isPageHiddenFlag = $e2636c669d04c60b$var$isPageHidden();
        if (isPageHiddenFlag) {
            if (!$e2636c669d04c60b$var$wasHiddenFlag) $e2636c669d04c60b$var$pushHidden(isPageHiddenFlag);
            $e2636c669d04c60b$var$wasHiddenFlag = true;
        } else {
            if ($e2636c669d04c60b$var$wasHiddenFlag) $e2636c669d04c60b$var$pushHidden(isPageHiddenFlag);
            $e2636c669d04c60b$var$wasHiddenFlag = false;
        }
    }
    function $e2636c669d04c60b$var$setup() {
        (0, $74BVL.bind)(window, {
            type: 'pageshow',
            listener: $e2636c669d04c60b$var$handleChange
        });
        (0, $74BVL.bind)(window, {
            type: 'pagehide',
            listener: $e2636c669d04c60b$var$handleChange
        });
        (0, $74BVL.bind)(document, {
            type: 'visibilitychange',
            listener: $e2636c669d04c60b$var$handleChange
        });
    }
    function $e2636c669d04c60b$export$554cefe0f0373da4() {
        if (!$e2636c669d04c60b$var$setupFlag) {
            const isPageHiddenFlag = $e2636c669d04c60b$var$isPageHidden();
            $e2636c669d04c60b$var$pushHidden(isPageHiddenFlag, 0);
            $e2636c669d04c60b$var$setup();
            $e2636c669d04c60b$var$setupFlag = true;
        }
    }
    function $e2636c669d04c60b$export$768b2008623433e1(start, end) {
        if ($e2636c669d04c60b$var$timings.length === 0) return 'visible';
        const currentSize = $e2636c669d04c60b$var$timings.length;
        let hiddenState = 'mixed';
        let startIdx = $e2636c669d04c60b$var$insertIndex;
        let endIdx = $e2636c669d04c60b$var$insertIndex;
        for(let i = 0; i < currentSize; i++){
            const tmpIdx = ($e2636c669d04c60b$var$insertIndex + i) % currentSize;
            if ($e2636c669d04c60b$var$timings[tmpIdx].time <= end) {
                endIdx = tmpIdx;
                if ($e2636c669d04c60b$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
            }
        }
        if (endIdx - startIdx === 0) {
            if ($e2636c669d04c60b$var$timings[startIdx].hidden) hiddenState = 'hidden';
            else hiddenState = 'visible';
        }
        return hiddenState;
    }
});
parcelRegister("9h6de", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("k4zTi").then(()=>parcelRequire('gqqXP'));
});
parcelRegister("OliJI", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("g2QjI").then(()=>parcelRequire('l4oGf'));
});
parcelRegister("14f04", function(module, exports) {
    $parcel$export(module.exports, "configure", ()=>$ae4043485e7d66d2$export$8d21e34596265fa2);
    $parcel$export(module.exports, "getConfig", ()=>$ae4043485e7d66d2$export$44487a86467333c3);
    var $7mfzA = parcelRequire("7mfzA");
    const $ae4043485e7d66d2$var$defaultAllowedParams = [
        'operationName',
        'operation',
        'q'
    ];
    const $ae4043485e7d66d2$var$getAllowedParams = ()=>{
        const config = (0, $7mfzA.getConfig)();
        return config?.allowedResourcesParams || $ae4043485e7d66d2$var$defaultAllowedParams;
    };
    const $ae4043485e7d66d2$var$handleQueryParams = (urlString)=>{
        try {
            if (typeof urlString !== 'string') return urlString;
            const url = new URL(urlString);
            const params = new URLSearchParams(url.search);
            const allowedParams = $ae4043485e7d66d2$var$getAllowedParams();
            for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
            return url.toString();
        } catch (e) {
            return urlString;
        }
    };
    let $ae4043485e7d66d2$var$config = {
        mapResources: (url)=>url,
        sanitiseEndpoints: (url)=>{
            return $ae4043485e7d66d2$var$handleQueryParams(url);
        }
    };
    function $ae4043485e7d66d2$export$8d21e34596265fa2(resourceTimingConfig) {
        const newConfig = {
            mapResources: resourceTimingConfig.mapResources,
            sanitiseEndpoints: (url)=>{
                const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
                if (sanitised) return $ae4043485e7d66d2$var$handleQueryParams(sanitised);
                return sanitised;
            }
        };
        $ae4043485e7d66d2$var$config = newConfig;
    }
    const $ae4043485e7d66d2$export$44487a86467333c3 = ()=>$ae4043485e7d66d2$var$config;
});
parcelRegister("dZ9Pk", function(module, exports) {
    $parcel$export(module.exports, "startResourceTimingBuffer", ()=>$d1f813a4e49664bb$export$a311cb1baa7d2d62);
    var $bzZr9 = parcelRequire("bzZr9");
    function $d1f813a4e49664bb$export$a311cb1baa7d2d62() {
        (0, $bzZr9.resourceTimingBuffer).start();
    }
});
parcelRegister("bzZr9", function(module, exports) {
    $parcel$export(module.exports, "resourceTimingBuffer", ()=>$1f7fa0dceb968c52$export$bea963256235a63e);
    $parcel$export(module.exports, "filterResourceTimings", ()=>$1f7fa0dceb968c52$export$4138a729ef1db028);
    var $65fDB = parcelRequire("65fDB");
    const $1f7fa0dceb968c52$var$getPerformanceObject = ()=>(window ?? {}).performance;
    const $1f7fa0dceb968c52$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
    const $1f7fa0dceb968c52$export$bea963256235a63e = {
        timings: [],
        maxSize: 1000,
        observer: null,
        transformResource: (entry)=>{
            const duration = (0, $65fDB.roundEpsilon)(entry.duration);
            const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find((timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
            const serverTime = totalBackendTimeEntry ? (0, $65fDB.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
            const networkTime = serverTime ? duration - serverTime : undefined;
            return {
                name: entry.name,
                initiatorType: entry.initiatorType,
                transferSize: entry.transferSize,
                startTime: (0, $65fDB.roundEpsilon)(entry.startTime),
                duration: (0, $65fDB.roundEpsilon)(entry.duration),
                fetchStart: (0, $65fDB.roundEpsilon)(entry.fetchStart || 0),
                workerStart: (0, $65fDB.roundEpsilon)(entry.workerStart || 0),
                responseStart: (0, $65fDB.roundEpsilon)(entry.responseStart || 0),
                serverTime: serverTime,
                networkTime: networkTime,
                encodedSize: (0, $65fDB.roundEpsilon)(entry.encodedBodySize),
                decodedSize: (0, $65fDB.roundEpsilon)(entry.decodedBodySize)
            };
        },
        start: ()=>{
            const performance = $1f7fa0dceb968c52$var$getPerformanceObject();
            const PerformanceObserver = $1f7fa0dceb968c52$var$getPerformanceObserverObject();
            if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
            if ($1f7fa0dceb968c52$export$bea963256235a63e.observer) return;
            const resources = performance.getEntriesByType?.('resource');
            if (resources) $1f7fa0dceb968c52$export$bea963256235a63e.timings = resources.map((resource)=>$1f7fa0dceb968c52$export$bea963256235a63e.transformResource(resource));
            $1f7fa0dceb968c52$export$bea963256235a63e.observer = new PerformanceObserver($1f7fa0dceb968c52$export$bea963256235a63e.addTimings);
            $1f7fa0dceb968c52$export$bea963256235a63e.observer.observe({
                entryTypes: [
                    'resource'
                ]
            });
        },
        stop: ()=>{
            if ($1f7fa0dceb968c52$export$bea963256235a63e.observer) {
                $1f7fa0dceb968c52$export$bea963256235a63e.observer.disconnect();
                $1f7fa0dceb968c52$export$bea963256235a63e.observer = null;
            }
            $1f7fa0dceb968c52$export$bea963256235a63e.timings = [];
        },
        addTimings: (list)=>{
            const entries = list.getEntries().map((entry)=>$1f7fa0dceb968c52$export$bea963256235a63e.transformResource(entry));
            const overflow = $1f7fa0dceb968c52$export$bea963256235a63e.timings.length + entries.length;
            if (overflow > $1f7fa0dceb968c52$export$bea963256235a63e.maxSize) {
                const fieldsToRemove = overflow - $1f7fa0dceb968c52$export$bea963256235a63e.maxSize;
                $1f7fa0dceb968c52$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
            }
            $1f7fa0dceb968c52$export$bea963256235a63e.timings.push(...entries);
        }
    };
    const $1f7fa0dceb968c52$var$isValidTiming = (timing, startTime, endTime)=>timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
    const $1f7fa0dceb968c52$export$4138a729ef1db028 = (startTime, endTime)=>{
        const performance = $1f7fa0dceb968c52$var$getPerformanceObject();
        const PerformanceObserver = $1f7fa0dceb968c52$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !$1f7fa0dceb968c52$export$bea963256235a63e.observer) {
            const resources = performance?.getEntriesByType('resource');
            if (resources) return resources.filter((timing)=>$1f7fa0dceb968c52$var$isValidTiming(timing, startTime, endTime));
            return null;
        }
        return $1f7fa0dceb968c52$export$bea963256235a63e.timings.filter((timing)=>$1f7fa0dceb968c52$var$isValidTiming(timing, startTime, endTime));
    };
});
parcelRegister("emyPh", function(module, exports) {
    $parcel$export(module.exports, "configure", ()=>$cb479a715c92d1c4$export$8d21e34596265fa2);
    $parcel$export(module.exports, "getSSRTimings", ()=>$cb479a715c92d1c4$export$bf7408e83532dcd0);
    $parcel$export(module.exports, "getSSRSuccess", ()=>$cb479a715c92d1c4$export$c7ad864055e75537);
    $parcel$export(module.exports, "getSSRDoneTime", ()=>$cb479a715c92d1c4$export$3def7672244bab0c);
    $parcel$export(module.exports, "getSSRFeatureFlags", ()=>$cb479a715c92d1c4$export$1c4a9b5e6e22393d);
    const $cb479a715c92d1c4$var$NESTED_METRIC_SEPARATOR = '/';
    const $cb479a715c92d1c4$var$filterEntry = (entry)=>!(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
    const $cb479a715c92d1c4$var$mapEntry = (entry)=>({
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration)
        });
    const $cb479a715c92d1c4$var$SSR_PREFIX = 'ssr';
    const $cb479a715c92d1c4$var$mapKey = (key)=>{
        if (key === 'total') return $cb479a715c92d1c4$var$SSR_PREFIX;
        return `${$cb479a715c92d1c4$var$SSR_PREFIX}${$cb479a715c92d1c4$var$NESTED_METRIC_SEPARATOR}${key}`;
    };
    let $cb479a715c92d1c4$var$config;
    function $cb479a715c92d1c4$export$8d21e34596265fa2(ssrConfig) {
        $cb479a715c92d1c4$var$config = ssrConfig;
    }
    function $cb479a715c92d1c4$export$bf7408e83532dcd0() {
        if (!$cb479a715c92d1c4$var$config?.getTimings) return {};
        const timings = $cb479a715c92d1c4$var$config.getTimings();
        if (!timings) return {};
        const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
            if ($cb479a715c92d1c4$var$filterEntry(entry[1])) acc[$cb479a715c92d1c4$var$mapKey(entry[0])] = $cb479a715c92d1c4$var$mapEntry(entry[1]);
            return acc;
        }, {});
        return ssrTimings;
    }
    function $cb479a715c92d1c4$export$c7ad864055e75537() {
        return !!$cb479a715c92d1c4$var$config?.getDoneMark();
    }
    function $cb479a715c92d1c4$export$3def7672244bab0c() {
        return $cb479a715c92d1c4$var$config?.getDoneMark() ?? undefined;
    }
    function $cb479a715c92d1c4$export$1c4a9b5e6e22393d() {
        if (!$cb479a715c92d1c4$var$config?.getFeatureFlags) return undefined;
        try {
            return $cb479a715c92d1c4$var$config.getFeatureFlags() ?? undefined;
        } catch (e) {}
        return undefined;
    }
});
parcelRegister("kvBcO", function(module, exports) {
    $parcel$export(module.exports, "jiraBundleEvalTimingsConfig", ()=>$90678e6868a8e976$export$791b8c0cbd574ea9);
    var $hknOo = parcelRequire("hknOo");
    const $90678e6868a8e976$export$791b8c0cbd574ea9 = {
        mapPerformanceMark: (mark)=>{
            if (mark.endsWith((0, $hknOo.JS_EVAL_START))) return {
                name: mark.substring(0, mark.indexOf((0, $hknOo.JS_EVAL_START))),
                type: 'start'
            };
            if (mark.endsWith((0, $hknOo.JS_EVAL_STOP))) return {
                name: mark.substring(0, mark.indexOf((0, $hknOo.JS_EVAL_STOP))),
                type: 'end'
            };
            return null;
        }
    };
});
parcelRegister("8NQa5", function(module, exports) {
    $parcel$export(module.exports, "jiraResourceTimingsConfig", ()=>$0beb836a724a435f$export$8fa71550bcdc2104);
    var $k4nIh = parcelRequire("k4nIh");
    var $lCenZ = parcelRequire("lCenZ");
    const $0beb836a724a435f$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
    const $0beb836a724a435f$var$getWRMAssetName = (url)=>{
        const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
        const assetName = (0, $lCenZ.sanitiseAssetName)(false)(url);
        if (!resources) return assetName;
        return `wrm/${resources}/${assetName}`;
    };
    const $0beb836a724a435f$var$getFileName = (url)=>$0beb836a724a435f$var$isWRMResource(url) ? $0beb836a724a435f$var$getWRMAssetName(url) : (0, $lCenZ.sanitiseAssetName)(false)(url);
    const $0beb836a724a435f$var$sanitiseEndpoints = (url)=>{
        const parsedUrl = (0, ($parcel$interopDefault($k4nIh)))(url, true);
        const { operation: operation, operationName: operationName } = parsedUrl.query;
        const operationNameOverride = operation ?? operationName;
        if (operationNameOverride) return `/${operation}?operation=${operation}`;
        const fileName = parsedUrl.pathname.replace(/\/(project|agent)(-config|s)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(servicedesk)(-data)?\/([A-Z0-9]+)/g, '/$1$2/<project-key>').replace(/\/(browse|automation|pagination|permissions|async|dialog|itsm)\/([A-Z0-9]+)/g, '/$1/<project-key>').replace(/\/(board)(s)?\/([0-9]+)/g, '/$1$2/<board-id>').replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>').replace(/\/user\/[a-fA-F0-9\-:]+/i, '/user/<user-id>').replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/i, '<uuid>').replace(/\/\d+$/i, '/<id>');
        return fileName;
    };
    const $0beb836a724a435f$export$8fa71550bcdc2104 = {
        sanitiseEndpoints: $0beb836a724a435f$var$sanitiseEndpoints,
        mapResources: $0beb836a724a435f$var$getFileName,
        hasTimingHeaders: (url)=>url.includes('jira-frontend-static') || url.includes('jira-frontend-branch') || url.includes('jira-frontend-bifrost') || $0beb836a724a435f$var$isWRMResource(url),
        xhrFilter: (url)=>url.includes('/rest/greenhopper/')
    };
});
parcelRegister("g62MK", function(module, exports) {
    $parcel$export(module.exports, "jiraSsrConfig", ()=>$0781fcdae6ae9d6a$export$7bcf91e323db67dd);
    var $kd0cS = parcelRequire("kd0cS");
    var $6iz4v = parcelRequire("6iz4v");
    var $eI5EY = parcelRequire("eI5EY");
    var $6rW04 = parcelRequire("6rW04");
    function $0781fcdae6ae9d6a$var$getTimings() {
        if (!window.SPA_STATE) return null;
        const detailRenderTrace = window.SPA_STATE['ssr/detail_render_trace'];
        const detailRequestTrace = window.SPA_STATE['ssr/detail_request_trace'];
        const highLevelMetrics = window.SPA_STATE['ssr/metrics'];
        const timings = (0, ($parcel$interopDefault($kd0cS)))(detailRenderTrace?.data?.traces) || {};
        if (highLevelMetrics?.data) {
            if ('ssrTotal' in highLevelMetrics.data) timings.total = {
                startTime: 0,
                duration: highLevelMetrics.data.ssrTotal
            };
            if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
                startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
                duration: highLevelMetrics.data.ssrGetStyle
            };
            if ('ssrPrefetch' in highLevelMetrics.data) {
                const prefetchStartTime = Object.values(detailRenderTrace?.data?.traces || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
                timings.prefetch = {
                    startTime: prefetchStartTime,
                    duration: highLevelMetrics.data.ssrPrefetch
                };
            }
        }
        if (detailRequestTrace?.data) Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
            timings[`prefetch/${key}`] = value;
        });
        return timings;
    }
    const $0781fcdae6ae9d6a$var$SSR_FF_META_TAG = 'spa-service-flags';
    let $0781fcdae6ae9d6a$var$ffCache;
    let $0781fcdae6ae9d6a$var$ffCacheInitialiser = ()=>{
        try {
            const metaTagValue = (0, $6rW04.default)($0781fcdae6ae9d6a$var$SSR_FF_META_TAG);
            if (metaTagValue === null) return null;
            $0781fcdae6ae9d6a$var$ffCache = JSON.parse(metaTagValue) || null;
        } catch (e) {
            $0781fcdae6ae9d6a$var$ffCache = null;
        }
        $0781fcdae6ae9d6a$var$ffCacheInitialiser = null;
    };
    function $0781fcdae6ae9d6a$var$getFeatureFlags() {
        if ($0781fcdae6ae9d6a$var$ffCacheInitialiser != null) $0781fcdae6ae9d6a$var$ffCacheInitialiser();
        return $0781fcdae6ae9d6a$var$ffCache;
    }
    const $0781fcdae6ae9d6a$export$7bcf91e323db67dd = {
        getDoneMark: ()=>{
            if ((0, $eI5EY.fg)('ssr_success_when_spa_success')) {
                const SPASSRRenderedMark = (0, $6iz4v.getMark)((0, $37f655a4e4d5690e$export$135c96ab5afee429))?.startTime;
                if (SPASSRRenderedMark && (0, $6iz4v.getMark)('ssr.spa.state')?.startTime) return SPASSRRenderedMark;
                return null;
            }
            return (0, $6iz4v.getMark)((0, $37f655a4e4d5690e$export$135c96ab5afee429))?.startTime || null;
        },
        getTimings: $0781fcdae6ae9d6a$var$getTimings,
        getFeatureFlags: $0781fcdae6ae9d6a$var$getFeatureFlags
    };
});
parcelRegister("2ctsX", function(module, exports) {
    $parcel$export(module.exports, "visualRefreshResolverOverride", ()=>$03418a879dc1bb78$export$73a94df81a7c0f2c);
    var $8rQuz = parcelRequire("8rQuz");
    const $03418a879dc1bb78$var$visualRefreshPlatformFlags = [
        'platform-component-visual-refresh',
        'platform-visual-refresh-icons-legacy-facade',
        'platform-visual-refresh-icons'
    ];
    const $03418a879dc1bb78$export$73a94df81a7c0f2c = [
        (flagKey)=>$03418a879dc1bb78$var$visualRefreshPlatformFlags.includes(flagKey),
        (0, $8rQuz.isVisualRefreshEnabled)
    ];
});
parcelRegister("8JKCU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$feb634984f7ef6c9$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "updatePageloadName", ()=>$feb634984f7ef6c9$export$d0f99433cd4f4028);
    var $hompL = parcelRequire("hompL");
    var $4W8RK = parcelRequire("4W8RK");
    var $7mfzA = parcelRequire("7mfzA");
    var $dvy3D = parcelRequire("dvy3D");
    var $fIUvl = parcelRequire("fIUvl");
    var $cpY9k = parcelRequire("cpY9k");
    var $8WGFp = parcelRequire("8WGFp");
    const $feb634984f7ef6c9$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
    function $feb634984f7ef6c9$export$2e2bcd8739ae039(ufoName, routeName = ufoName) {
        const activeInteraction = (0, $cpY9k.getActiveInteraction)();
        if (activeInteraction && !ufoName) return;
        (0, $8WGFp.default).current = routeName || null;
        const rate = ufoName ? (0, $7mfzA.getInteractionRate)(ufoName, 'page_load') : 1;
        const enabledBySamplingRate = (0, $4W8RK.default)(rate);
        if (enabledBySamplingRate && !activeInteraction) {
            const newId = (0, $hompL.v4)();
            (0, $fIUvl.DefaultInteractionID).current = newId;
            (0, $cpY9k.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $dvy3D.getActiveTrace)());
            if (!ufoName) (0, $cpY9k.addHoldByID)(newId, [], $feb634984f7ef6c9$var$AWAITING_PAGELOAD_NAME, $feb634984f7ef6c9$var$AWAITING_PAGELOAD_NAME, true);
        } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') (0, $cpY9k.abort)(activeInteraction.id, 'excluded_by_sampling');
        else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
            (0, $cpY9k.updatePageLoadInteractionName)(ufoName, routeName);
            (0, $cpY9k.removeHoldByID)(activeInteraction.id, $feb634984f7ef6c9$var$AWAITING_PAGELOAD_NAME);
        }
    }
    function $feb634984f7ef6c9$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
        const interaction = (0, $cpY9k.getActiveInteraction)();
        if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
        if (ufoName) {
            const rate = (0, $7mfzA.getInteractionRate)(ufoName, 'page_load');
            (0, $cpY9k.updatePageLoadInteractionName)(ufoName, routeName);
            if ((0, $4W8RK.default)(rate)) (0, $8WGFp.default).current = ufoName;
            else (0, $cpY9k.abort)(interaction.id, 'excluded_by_sampling');
        }
        (0, $cpY9k.removeHoldByID)(interaction.id, $feb634984f7ef6c9$var$AWAITING_PAGELOAD_NAME);
    }
});
parcelRegister("foPCo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3caef8d053fb2a2$export$2e2bcd8739ae039);
    var $kFGm5 = parcelRequire("kFGm5");
    var $ieRGA = parcelRequire("ieRGA");
    var $1ybV0 = parcelRequire("1ybV0");
    var $6rW04 = parcelRequire("6rW04");
    var $2aRps = parcelRequire("2aRps");
    var $1Fe9v = parcelRequire("1Fe9v");
    const $d3caef8d053fb2a2$var$isHeartbeatEnabled = ()=>(0, $1ybV0.ff)('jfp.heartbeat_vfp2h', false);
    const $d3caef8d053fb2a2$var$renderEngagementMessages = ()=>{
        (parcelRequire("ll5c1"));
    };
    const $d3caef8d053fb2a2$var$renderProfileCardNextLegacy = ()=>{
        (parcelRequire("2QHbi"));
    };
    const $d3caef8d053fb2a2$var$renderHeartbeat = ()=>{
        (parcelRequire("6i2jN"));
    };
    const $d3caef8d053fb2a2$var$loadUpFlowAPI = ()=>(parcelRequire("5WlWz"));
    const $d3caef8d053fb2a2$var$installConnectModules = ()=>(parcelRequire("jPTXR"));
    const $d3caef8d053fb2a2$var$markSafeForAnalytics = (str)=>str || null;
    const $d3caef8d053fb2a2$var$renderSearchDwellTimeComponent = ()=>{
        const searchSessionId = (0, $6rW04.default)('ajs-search-session-id');
        const containerId = (0, $6rW04.default)('ajs-search-container-id');
        const objectId = (0, $6rW04.default)('ajs-search-object-id');
        const objectType = (0, $6rW04.default)('ajs-search-content-type');
        (0, $ieRGA.default)([
            'searchSessionId',
            'searchObjectId',
            'searchContainerId',
            'searchContentType'
        ]);
        (0, $1Fe9v.default)('search-dwell-time', $d3caef8d053fb2a2$var$markSafeForAnalytics(searchSessionId), {
            containerId: $d3caef8d053fb2a2$var$markSafeForAnalytics(containerId),
            objectId: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectId),
            objectType: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectType),
            actionSubject: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectType),
            source: $d3caef8d053fb2a2$var$markSafeForAnalytics(objectType)
        });
    };
    const $d3caef8d053fb2a2$var$installHighPriorityApps = (args)=>{
        const priorityApps = [];
        if (args.flags) priorityApps.push((0, $2aRps.renderFlags)());
        if (args.navigation) priorityApps.push(args.renderNavigation());
        return priorityApps;
    };
    const $d3caef8d053fb2a2$var$installLowPriorityApps = (args)=>{
        if (args.upflow) $d3caef8d053fb2a2$var$loadUpFlowAPI();
        if (args.profileCardNextLegacy) $d3caef8d053fb2a2$var$renderProfileCardNextLegacy();
        if (args.connectModules) $d3caef8d053fb2a2$var$installConnectModules();
        if (args.engagementMessages) $d3caef8d053fb2a2$var$renderEngagementMessages();
        if (args.heartbeat) $d3caef8d053fb2a2$var$renderHeartbeat();
        if (args.searchDwellTimeComponent) $d3caef8d053fb2a2$var$renderSearchDwellTimeComponent();
    };
    const $d3caef8d053fb2a2$var$installAppsWithPriorityOrder = async (args)=>{
        await Promise.all($d3caef8d053fb2a2$var$installHighPriorityApps({
            flags: args.flags,
            navigation: args.navigation,
            renderNavigation: args.renderNavigation
        }));
        $d3caef8d053fb2a2$var$installLowPriorityApps((0, ($parcel$interopDefault($kFGm5)))(args, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
    };
    const $d3caef8d053fb2a2$var$defaultArgs = {
        flags: true,
        navigation: true,
        upflow: true,
        profileCardNextLegacy: true,
        heartbeat: $d3caef8d053fb2a2$var$isHeartbeatEnabled(),
        connectModules: true,
        engagementMessages: true,
        searchDwellTimeComponent: true,
        renderNavigation: ()=>null
    };
    var $d3caef8d053fb2a2$export$2e2bcd8739ae039 = {
        install: (args)=>{
            const argsWithDefaults = {
                ...$d3caef8d053fb2a2$var$defaultArgs,
                ...args
            };
            $d3caef8d053fb2a2$var$installAppsWithPriorityOrder(argsWithDefaults);
        },
        installHighPriorityApps: (args)=>{
            const { flags: flags, navigation: navigation, renderNavigation: renderNavigation } = {
                ...$d3caef8d053fb2a2$var$defaultArgs,
                ...args
            };
            $d3caef8d053fb2a2$var$installHighPriorityApps({
                flags: flags,
                navigation: navigation,
                renderNavigation: renderNavigation
            });
        },
        installLowPriorityApps: (args)=>{
            const installArgs = (0, ($parcel$interopDefault($kFGm5)))({
                ...$d3caef8d053fb2a2$var$defaultArgs,
                ...args
            }, [
                'flags',
                'navigation',
                'renderNavigation'
            ]);
            $d3caef8d053fb2a2$var$installLowPriorityApps(installArgs);
        }
    };
});
parcelRegister("2aRps", function(module, exports) {
    $parcel$export(module.exports, "renderFlags", ()=>$6ef677b08ff57190$export$b6228dc14c5adf51);
    var $eUqFw = parcelRequire("eUqFw");
    var $lEfVV = parcelRequire("lEfVV");
    var $56koX = parcelRequire("56koX");
    var $gUUjF = parcelRequire("gUUjF");
    var $49235 = parcelRequire("49235");
    var $5L0Jp = parcelRequire("5L0Jp");
    var $geFaw = parcelRequire("geFaw");
    const $6ef677b08ff57190$var$throwError = (message)=>{
        const error = new Error(message);
        (0, $gUUjF.default).safeErrorWithoutCustomerData('flags.entry', message, error);
        throw error;
    };
    const $6ef677b08ff57190$var$getContainer = ()=>{
        let container = document.getElementById('flags');
        if (container == null) {
            container = document.createElement('div');
            container.id = 'flags';
            if (document.body) document.body.appendChild(container);
            else $6ef677b08ff57190$var$throwError('document.body was not found whilst trying to create the flags container');
        }
        return container;
    };
    const $6ef677b08ff57190$var$Flags = (0, $56koX.lazyForPaint)(()=>(parcelRequire("i5h8p")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
    });
    const $6ef677b08ff57190$var$AfterPaintFlags = (0, $56koX.lazyAfterPaint)(()=>(parcelRequire("i5h8p")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flag-app/src/main.tsx"
    });
    const $6ef677b08ff57190$export$b6228dc14c5adf51 = ()=>(0, $lEfVV.render)((0, ($parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
            packageName: "flags-entry"
        }, __SPA__ ? (0, ($parcel$interopDefault($eUqFw))).createElement($6ef677b08ff57190$var$AfterPaintFlags, null) : (0, ($parcel$interopDefault($eUqFw))).createElement($6ef677b08ff57190$var$Flags, null)))), $6ef677b08ff57190$var$getContainer());
});
parcelRegister("49235", function(module, exports) {
    $parcel$export(module.exports, "JiraContextContainer", ()=>$237d6228af360b7c$export$6f7845cc5e693f16);
    var $eUqFw = parcelRequire("eUqFw");
    var $3fQGY = parcelRequire("3fQGY");
    var $ao0hp = parcelRequire("ao0hp");
    var $fb5Sn = parcelRequire("fb5Sn");
    var $eX2O4 = parcelRequire("eX2O4");
    var $6rW04 = parcelRequire("6rW04");
    var $7LFzI = parcelRequire("7LFzI");
    var $jvfW6 = parcelRequire("jvfW6");
    var $gXEQH = parcelRequire("gXEQH");
    var $8WuJm = parcelRequire("8WuJm");
    var $ln3W8 = parcelRequire("ln3W8");
    var $jD3pk = parcelRequire("jD3pk");
    var $gd0Sp = parcelRequire("gd0Sp");
    var $4yYQo = parcelRequire("4yYQo");
    const $237d6228af360b7c$var$ContextualAnalyticsDataFeatureFlagged = ({ children: children })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            attributes: (0, $gXEQH.routeAnalyticsAttributes)
        }, children);
    const $237d6228af360b7c$export$6f7845cc5e693f16 = (props)=>{
        const state = {
            messages: (parcelRequire("7KGHt"))
        };
        const { data: orgId } = (0, $jD3pk.useOrgId)();
        return (0, ($parcel$interopDefault($eUqFw))).createElement($237d6228af360b7c$var$ContextualAnalyticsDataFeatureFlagged, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextContainer), {
            isGlobal: true,
            getMeta: (0, $6rW04.default)
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $7LFzI.IntlProvider), {
                messages: state.messages,
                locale: (0, $ao0hp.standardizeLocale)(tenantContext.locale)
            }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3fQGY.default), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $fb5Sn.default), {
                orgId: orgId
            }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $eX2O4.ExperienceTrackerProvider), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ln3W8.default), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jvfW6.ModalContextProvider), null, props.children)))))))), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $4yYQo.LoadingPhaseManager), null));
    };
});
parcelRegister("4yYQo", function(module, exports) {
    $parcel$export(module.exports, "LoadingPhaseManager", ()=>$01b326d4a0314926$export$6e4bfef9e80c7eb0);
    var $eUqFw = parcelRequire("eUqFw");
    var $gAS98 = parcelRequire("gAS98");
    const $01b326d4a0314926$export$6e4bfef9e80c7eb0 = ()=>{
        const { startNextPhase: startNextPhase } = (0, $gAS98.useLazyPhase)();
        (0, $eUqFw.useEffect)(()=>{
            if (__SPA__) return;
            setTimeout(()=>{
                performance.mark('rll-after-paint-phase');
                startNextPhase();
            }, 2000);
        }, [
            startNextPhase
        ]);
        return null;
    };
});
parcelRegister("7KGHt", function(module, exports) {
    module.exports = __LANG;
});
parcelRegister("5L0Jp", function(module, exports) {
    $parcel$export(module.exports, "FlagsBoundary", ()=>$3e0b01ebb413784c$export$8b4a0fffcddd96f4);
    var $eUqFw = parcelRequire("eUqFw");
    var $5GxEP = parcelRequire("5GxEP");
    var $gGtKh = parcelRequire("gGtKh");
    const $3e0b01ebb413784c$export$8b4a0fffcddd96f4 = ({ children: children, packageName: packageName })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
            id: "flags",
            packageName: packageName
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "flags-boundary",
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null)
        }, children));
});
parcelRegister("i5h8p", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("eNmuD"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("3WeJg")
    ]).then(()=>parcelRequire('dKe2f'));
});
parcelRegister("1Fe9v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab81d3bccac6ed19$export$2e2bcd8739ae039);
    var $eUqFw = parcelRequire("eUqFw");
    var $lEfVV = parcelRequire("lEfVV");
    var $geFaw = parcelRequire("geFaw");
    var $7BDEW = parcelRequire("7BDEW");
    const $ab81d3bccac6ed19$var$getPlaceholder = (placeholderId)=>{
        const existingPlaceholder = document.getElementById(placeholderId);
        if (existingPlaceholder) return existingPlaceholder;
        const div = document.createElement('div');
        div.id = placeholderId;
        if (document.body) document.body.appendChild(div);
        else throw new Error('document.body was not found whilst trying to create the dwell component placeholder.');
        return div;
    };
    const $ab81d3bccac6ed19$var$renderDwellTimeComponent = (placeholder, sessionId, data = {})=>{
        if (placeholder && sessionId) (0, $lEfVV.render)((0, ($parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7BDEW.default), {
            sessionId: sessionId,
            data: data
        })), $ab81d3bccac6ed19$var$getPlaceholder(placeholder));
    };
    var $ab81d3bccac6ed19$export$2e2bcd8739ae039 = $ab81d3bccac6ed19$var$renderDwellTimeComponent;
});
parcelRegister("ll5c1", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("eNmuD"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("53zvZ")
    ]).then(()=>parcelRequire('jqtYH'));
});
parcelRegister("2QHbi", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("eNmuD"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("fF7Ru")
    ]).then(()=>parcelRequire('9h92o'));
});
parcelRegister("6i2jN", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = $d1Cng("cBElD").then(()=>parcelRequire('bq09U'));
});
parcelRegister("5WlWz", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("kWrFZ"),
        $d1Cng("92sUi"),
        $d1Cng("i5RRW"),
        $d1Cng("561Jq"),
        $d1Cng("1QYl5"),
        $d1Cng("hPzOn"),
        $d1Cng("2Lfdl"),
        $d1Cng("dsiAd"),
        $d1Cng("eNmuD"),
        $d1Cng("8Ny04")
    ]).then(()=>parcelRequire('gibLG'));
});
parcelRegister("jPTXR", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("ihXca")
    ]).then(()=>parcelRequire('cfAPv'));
});
parcelRegister("kmii1", function(module, exports) {
    var $d1Cng = parcelRequire("d1Cng");
    module.exports = Promise.all([
        $d1Cng("eNmuD"),
        $d1Cng("hPzOn"),
        $d1Cng("h2MrD"),
        $d1Cng("bYT2S"),
        $d1Cng("cM9em"),
        $d1Cng("fr9NE"),
        $d1Cng("edC6D")
    ]).then(()=>parcelRequire('7k8kP'));
});
$parcel$global.rwr("bz9bg", ()=>{
    parcelRequire("7QpAw");
    parcelRequire("2EvGI");
    var $eUqFw = parcelRequire("eUqFw");
    var $lEfVV = parcelRequire("lEfVV");
    var $kFGm5 = parcelRequire("kFGm5");
    var $8dloj = parcelRequire("8dloj");
    var $gpO36 = parcelRequire("gpO36");
    var $9BVaU = parcelRequire("9BVaU");
    var $74RJ9 = parcelRequire("74RJ9");
    var $7Nhwm = parcelRequire("7Nhwm");
    var $dfiLi = parcelRequire("dfiLi");
    var $9lmTX = parcelRequire("9lmTX");
    var $zcJ0y = parcelRequire("zcJ0y");
    var $e91YZ = parcelRequire("e91YZ");
    var $guiFP = parcelRequire("guiFP");
    var $gXEQH = parcelRequire("gXEQH");
    const $0507482b123635a1$export$649804097de83b3b = [
        {
            browser: 'Chrome',
            browserVersion: '116.0.0',
            errorMessage: /Cannot read properties of undefined \(reading 'target'\)/
        }
    ];
    const $0507482b123635a1$var$checkBrowserCondition = (error, filterCriteria)=>filterCriteria.browser != null ? (0, $zcJ0y.getBrowser)().name === filterCriteria.browser : true;
    const $0507482b123635a1$var$checkBrowserVersionCondition = (error, filterCriteria)=>filterCriteria.browserVersion != null ? (0, $zcJ0y.getBrowser)().version === filterCriteria.browserVersion : true;
    const $0507482b123635a1$var$checkErrorMessageCondition = (error, filterCriteria)=>filterCriteria.errorMessage != null ? error.message.match(filterCriteria.errorMessage) : true;
    const $0507482b123635a1$export$a66ce4bea8340820 = (error, errorFilteringCriterias)=>{
        try {
            const conditionCheckers = [
                $0507482b123635a1$var$checkBrowserCondition,
                $0507482b123635a1$var$checkBrowserVersionCondition,
                $0507482b123635a1$var$checkErrorMessageCondition
            ];
            return !errorFilteringCriterias.some((filterCriteria)=>conditionCheckers.every((conditionChecker)=>conditionChecker(error, filterCriteria)));
        } catch (e) {
            return true;
        }
    };
    const $0507482b123635a1$export$a5c16644a2d3c205 = async (error)=>{
        const tenantContextData = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        (0, $dfiLi.default)(tenantContextData);
        if ($0507482b123635a1$export$a66ce4bea8340820(error, $0507482b123635a1$export$649804097de83b3b)) (0, $9lmTX.default)({
            analyticsSource: (0, $7688150c048b38d1$export$c9e16a15d65437),
            experience: (0, $7688150c048b38d1$export$b1534bc11f201efd),
            wasExperienceSuccesful: false,
            location: (0, $7688150c048b38d1$export$7dfef0177e883b05),
            application: (0, $7688150c048b38d1$export$aa6008fe0169b864),
            edition: (0, $7688150c048b38d1$export$39418a21fbb51487),
            additionalAttributes: (0, $gXEQH.routeAnalyticsAttributes)
        });
        (0, $guiFP.default)({
            meta: {
                packageName: 'jiraBootstrapSlaReporter',
                id: 'bootstrap-failure',
                teamName: 'magma'
            },
            error: error,
            attributes: (0, $gXEQH.routeAnalyticsAttributes)
        });
        throw error;
    };
    var $a5pCl = parcelRequire("a5pCl");
    const $d07297a4af13004b$export$ef94a84e2990361c = 'ISSUE_VIEW';
    const $d07297a4af13004b$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
    const $d07297a4af13004b$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
    const $d07297a4af13004b$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
    const $d07297a4af13004b$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
    const $d07297a4af13004b$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
    const $d07297a4af13004b$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
    const $d07297a4af13004b$export$6d592df97fba16ca = 'GIN_GLOBAL_ISSUE_NAVIGATOR';
    const $d07297a4af13004b$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
    const $d07297a4af13004b$export$4695c1a423ffe431 = 'DASHBOARD';
    const $d07297a4af13004b$export$4ce203fc8c0eb2d1 = 'ISSUE_MOVE';
    const $d07297a4af13004b$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
    const $d07297a4af13004b$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
    const $d07297a4af13004b$export$9a80695e72849f84 = 'X-Atlassian-Capability';
    var $gXgRp = parcelRequire("gXgRp");
    parcelRequire("80E03");
    var $6iz4v = parcelRequire("6iz4v");
    var $e91YZ = parcelRequire("e91YZ");
    var $8R80x = parcelRequire("8R80x");
    var $0cdA8 = parcelRequire("0cdA8");
    var $1ybV0 = parcelRequire("1ybV0");
    var $d16Bc = parcelRequire("d16Bc");
    var $eI5EY = parcelRequire("eI5EY");
    var $6U1dF = parcelRequire("6U1dF");
    var $eUqFw = parcelRequire("eUqFw");
    var $h97Af = parcelRequire("h97Af");
    var $2B87Z = parcelRequire("2B87Z");
    var $ibSOG = parcelRequire("ibSOG");
    var $eUqFw = parcelRequire("eUqFw");
    var $6WwlF = parcelRequire("6WwlF");
    var $cEX90 = parcelRequire("cEX90");
    var $0cdA8 = parcelRequire("0cdA8");
    var $1ybV0 = parcelRequire("1ybV0");
    var $9zysr = parcelRequire("9zysr");
    var $eUqFw = parcelRequire("eUqFw");
    var $aYtGv = parcelRequire("aYtGv");
    const $2fec3262065a5aa8$export$2fcd4100c556a49e = ()=>(0, ($parcel$interopDefault($eUqFw))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: `[data-ds--page-layout--slot="main"] { height: calc(100vh - ${(0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP)}) }`
            }
        });
    var $6FP8W = parcelRequire("6FP8W");
    var $hwyJ1 = parcelRequire("hwyJ1");
    var $inC6u = parcelRequire("inC6u");
    var $eUqFw = parcelRequire("eUqFw");
    var $5BRby = parcelRequire("5BRby");
    var $h97Af = parcelRequire("h97Af");
    var $2B87Z = parcelRequire("2B87Z");
    var $eUqFw = parcelRequire("eUqFw");
    var $fytMA = parcelRequire("fytMA");
    var $1n0H8 = parcelRequire("1n0H8");
    var $6iz4v = parcelRequire("6iz4v");
    var $gUUjF = parcelRequire("gUUjF");
    var $0cdA8 = parcelRequire("0cdA8");
    var $eI5EY = parcelRequire("eI5EY");
    var $jMP2a = parcelRequire("jMP2a");
    var $1inzG = parcelRequire("1inzG");
    var $2B87Z = parcelRequire("2B87Z");
    var $lcJyp = parcelRequire("lcJyp");
    var $hTLlD = parcelRequire("hTLlD");
    var $exb0h = parcelRequire("exb0h");
    var $3oscM = parcelRequire("3oscM");
    const $a8644990a56a3865$var$isReplaceActionAndPIN = (action, route)=>action === 'REPLACE' && route.group === (0, $exb0h.ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR);
    const $a8644990a56a3865$export$ffb8c03de895ae3 = ()=>{
        let rapidBoardPaths = [];
        return ({ currentMatch: currentMatch, currentRoute: currentRoute, nextMatch: nextMatch, nextRoute: nextRoute, action: action })=>{
            let shouldReset = true;
            if ($a8644990a56a3865$var$isReplaceActionAndPIN(action, nextRoute) || currentRoute.isRedirect === true) shouldReset = false;
            else {
                const cleanMatch = (0, $3oscM.getApdexMatchObject)(currentMatch, currentRoute);
                const cleanNextMatch = (0, $3oscM.getApdexMatchObject)(nextMatch, nextRoute);
                shouldReset = !(0, ($parcel$interopDefault($hTLlD)))(cleanMatch, cleanNextMatch) && shouldReset;
                if (shouldReset) {
                    const [paths, resetBoolean] = (0, $3oscM.calcRapidBoardResetStateV2)(rapidBoardPaths, nextRoute.name, !!nextMatch.query.useStoredSettings);
                    rapidBoardPaths = paths;
                    if ((0, $3oscM.isValidRoute)(nextRoute) || nextRoute.group === (0, $exb0h.ROUTE_GROUPS_CLASSIC_SOFTWARE)) shouldReset = !resetBoolean;
                }
            }
            return shouldReset;
        };
    };
    var $idiDE = parcelRequire("idiDE");
    var $lB25E = parcelRequire("lB25E");
    var $5XMmM = parcelRequire("5XMmM");
    function $c275061b2aed9c7d$export$2e2bcd8739ae039(route) {
        if (route.ufoName != null) return route.ufoName;
        return route.name;
    }
    var $fIUvl = parcelRequire("fIUvl");
    var $cpY9k = parcelRequire("cpY9k");
    var $8WGFp = parcelRequire("8WGFp");
    function $dec00d4fabe9c1ea$export$2e2bcd8739ae039(fromUfoName, nextUfoName, nextRouteName, time) {
        (0, $8WGFp.default).current = nextUfoName;
        const interactionId = (0, $fIUvl.DefaultInteractionID).current;
        if (interactionId) (0, $cpY9k.addRedirect)(interactionId, fromUfoName, nextUfoName, nextRouteName, time);
    }
    var $eUqFw = parcelRequire("eUqFw");
    var $8vvIW = parcelRequire("8vvIW");
    const $a49452c2dd8fb286$export$f2b2f5ef0b498d26 = 5000;
    const $a49452c2dd8fb286$export$f2c0b74311ada874 = 3;
    const $a49452c2dd8fb286$export$af2ff676951003fe = 60000;
    const $a49452c2dd8fb286$export$388bd7a7ebb11e7 = 'atlassian-remote-actions-v1';
    const $7a202bcf26f69e55$export$50dbcb44bba3aa5c = 60;
    const $7a202bcf26f69e55$export$b21f5a6e7051e2c2 = (actionMetas)=>{
        const now = Date.now();
        const timeDiff = now - actionMetas.lastPerformAttemptedAt;
        return timeDiff > $7a202bcf26f69e55$export$50dbcb44bba3aa5c * 1000;
    };
    const $7a202bcf26f69e55$export$6c7cf2cb7d75fad3 = (actionMetas)=>actionMetas.attemptCounts < (0, $a49452c2dd8fb286$export$f2c0b74311ada874);
    const $7a202bcf26f69e55$export$6e0db227c9674096 = (action, metas)=>{
        const actionMetas = metas[action.id];
        if (!actionMetas) return true;
        if (!$7a202bcf26f69e55$export$6c7cf2cb7d75fad3(actionMetas)) return false;
        if (!$7a202bcf26f69e55$export$b21f5a6e7051e2c2(actionMetas)) return false;
        return true;
    };
    const $b5bf33c7d1caa282$export$1bfa74483a8ca772 = ({ actionName: actionName })=>{
        const metas = (0, $8vvIW.useMeta)();
        const remoteActions = (0, $8vvIW.useRemoteActionsData)();
        const { saveActionPerformedAttempt: saveActionPerformedAttempt } = (0, $8vvIW.useRemoteActionsStoreActions)();
        const [actionToPerform, setActionToPerform] = (0, $eUqFw.useState)();
        const [shouldPerformAction, setShouldPerformAction] = (0, $eUqFw.useState)(false);
        (0, $eUqFw.useEffect)(()=>{
            const matchedAction = Object.values(remoteActions).find((action)=>{
                if (action.name !== actionName) return false;
                return true;
            });
            if (!matchedAction) return;
            setActionToPerform(matchedAction);
            setShouldPerformAction((0, $7a202bcf26f69e55$export$6e0db227c9674096)(matchedAction, metas));
        }, [
            actionName,
            remoteActions,
            metas
        ]);
        const performAction = (onSuccess, onCancel)=>{
            if (!actionToPerform) return;
            const metaForAnalytics = {
                attempts: metas[actionToPerform.id]?.attemptCounts ?? 0,
                lastAttemptedAt: metas[actionToPerform.id]?.lastPerformAttemptedAt
            };
            if (shouldPerformAction) onSuccess(actionToPerform, metaForAnalytics);
            else onCancel(actionToPerform, metaForAnalytics);
            saveActionPerformedAttempt(actionToPerform.id);
            setShouldPerformAction(false);
        };
        return {
            shouldPerformAction: shouldPerformAction,
            performAction: performAction
        };
    };
    var $4KuMM = parcelRequire("4KuMM");
    var $hTLlD = parcelRequire("hTLlD");
    var $8q0kG = parcelRequire("8q0kG");
    var $eI5EY = parcelRequire("eI5EY");
    const $036a05a78c408a0c$var$transitionValidator = (currentMatch, nextMatch)=>{
        if (!currentMatch) return true;
        if (!nextMatch || (0, $8q0kG.default)() && !(0, $eI5EY.fg)('jira_mobile_web_infinite_redirect_fix_gate')) return false;
        const isSameRoute = currentMatch.route === nextMatch.route;
        const isSameMatch = (0, ($parcel$interopDefault($hTLlD)))(currentMatch.match, nextMatch.match);
        if (isSameRoute && isSameMatch) return true;
        const canDoNext = nextMatch.route.canTransitionIn?.(currentMatch, nextMatch) ?? true;
        if (canDoNext) return true;
        return false;
    };
    var $036a05a78c408a0c$export$2e2bcd8739ae039 = $036a05a78c408a0c$var$transitionValidator;
    var $eUqFw = parcelRequire("eUqFw");
    var $iWLL0 = parcelRequire("iWLL0");
    var $gUUjF = parcelRequire("gUUjF");
    var $1FAd1 = parcelRequire("1FAd1");
    var $8R80x = parcelRequire("8R80x");
    var $3dxBh = parcelRequire("3dxBh");
    var $iJHZm = parcelRequire("iJHZm");
    const $ee11b761aa04a6e7$var$LOCATION = 'route-entry-point-container';
    const $ee11b761aa04a6e7$export$fb85bbdbfb3e6869 = ()=>null;
    const $ee11b761aa04a6e7$export$3e4cdfb894377bc9 = ({ location: location, route: route, match: match, action: action, query: query })=>{
        const entryPoint = (0, $eUqFw.useMemo)(()=>route.entryPoint?.(), [
            route
        ]);
        const entryPointReference = (0, $1FAd1.usePageLayoutEntryPoint)((0, $d619e185f38e9ae8$export$900ddb492c628f48));
        const Skeleton = route.skeleton || $ee11b761aa04a6e7$export$fb85bbdbfb3e6869;
        (0, $eUqFw.useEffect)(()=>{
            if (route.isRedirect) (0, $gUUjF.default).safeWarnWithoutCustomerData($ee11b761aa04a6e7$var$LOCATION, `EntryPoint was used inside a redirect component: ${route.name}`);
        }, [
            route.isRedirect,
            route.name
        ]);
        if (!entryPointReference || !entryPoint) return null;
        let pageId = route.name;
        if (route.pageId) {
            if (typeof route.pageId === 'function') pageId = route.pageId({
                route: route,
                action: action,
                location: location,
                match: match,
                query: query
            });
            else pageId = route.pageId;
        }
        return route.isRedirect ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholder), {
            entryPoint: entryPoint,
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement(Skeleton, null),
            name: "route_entry_point_redirect"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
            entryPointReference: entryPointReference,
            props: {}
        })) : (0, ($parcel$interopDefault($eUqFw))).createElement((0, $3dxBh.default), {
            pageId: pageId
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStateContainer), {
            isGlobal: true,
            appId: pageId
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStateAppStartWithMatchCheck), null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholder), {
            entryPoint: entryPoint,
            fallback: (0, ($parcel$interopDefault($eUqFw))).createElement(Skeleton, null),
            name: "route_entry_point"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.EntryPointContainer), {
            entryPointReference: entryPointReference,
            props: {}
        }))));
    };
    const $5ce39a2e342c0202$var$REMOTE_ACTIONS_OFF = 'OFF';
    const $5ce39a2e342c0202$var$REMOTE_ACTIONS_PERFORM = 'PERFORM';
    const $5ce39a2e342c0202$var$useRouterLocation = (0, $lB25E.createRouterSelector)((state)=>state.location);
    const $5ce39a2e342c0202$var$useRouterAction = (0, $lB25E.createRouterSelector)((state)=>state.action);
    const $5ce39a2e342c0202$var$useRouterQuery = (0, $lB25E.createRouterSelector)((state)=>state.query);
    const $5ce39a2e342c0202$var$useRouterRoute = (0, $lB25E.createRouterSelector)((state)=>state.route);
    const $5ce39a2e342c0202$var$useRouterMatch = (0, $lB25E.createRouterSelector)((state)=>state.match);
    const $5ce39a2e342c0202$var$useRouterRoutes = (0, $lB25E.createRouterSelector)((state)=>state.routes);
    let $5ce39a2e342c0202$var$hasPendingForceReloadAction = false;
    const $5ce39a2e342c0202$var$getRemoteActionsRolloutStage = ()=>(0, $eI5EY.fg)('remote_actions_-_killswitch_-_temporary') ? $5ce39a2e342c0202$var$REMOTE_ACTIONS_PERFORM : $5ce39a2e342c0202$var$REMOTE_ACTIONS_OFF;
    const $5ce39a2e342c0202$export$88fe66870dd8f843 = (value)=>{
        $5ce39a2e342c0202$var$hasPendingForceReloadAction = value;
    };
    const $5ce39a2e342c0202$export$39e8f9fc07dd3395 = ()=>$5ce39a2e342c0202$var$hasPendingForceReloadAction;
    const $5ce39a2e342c0202$var$fireRemoteActionAnalytics = (analyticsEvent, eventAction, remoteAction, currentRoute, targetRoute, attempts, lastAttemptedAt)=>(0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, `remoteAction ${eventAction}`, {
            source: 'transitionBlocker',
            actionId: remoteAction != null && remoteAction.id != null ? String(remoteAction.id) : '',
            frontendVersion: window.BUILD_KEY,
            currentRouteName: currentRoute?.route.name || '',
            targetRouteName: targetRoute?.route.name || '',
            remoteActionsRolloutStage: $5ce39a2e342c0202$var$getRemoteActionsRolloutStage(),
            attempts: attempts,
            lastAttemptedAt: lastAttemptedAt
        });
    const $5ce39a2e342c0202$var$updateSentryBreadcrumb = (route, nextRoute)=>{
        const from = route.path + (route.query ? `?${route.query.join('&')}` : '');
        const to = nextRoute?.path + (nextRoute?.query ? `?${nextRoute.query.join('&')}` : '');
        (0, $fytMA.addBreadcrumb)({
            type: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
    const $5ce39a2e342c0202$var$Spa = ({ routes: routes, initRoute: initRoute = null })=>{
        (0, $eUqFw.useMemo)(()=>{
            (0, $6iz4v.setMark)('jira-spa/view.start');
        }, []);
        const checkShouldResetPage = (0, $eUqFw.useMemo)(()=>(0, $a8644990a56a3865$export$ffb8c03de895ae3)(), []);
        const currentMatchObjectRef = (0, $eUqFw.useRef)(initRoute);
        (0, $eUqFw.useEffect)(()=>{
            (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/view', 'jira-spa/view.start', true);
        }, []);
        const { registerBlock: registerBlock } = (0, $lB25E.useRouterActions)();
        const location = $5ce39a2e342c0202$var$useRouterLocation();
        const action = $5ce39a2e342c0202$var$useRouterAction();
        const query = $5ce39a2e342c0202$var$useRouterQuery();
        const route = $5ce39a2e342c0202$var$useRouterRoute();
        const match = $5ce39a2e342c0202$var$useRouterMatch();
        const routerRoutes = $5ce39a2e342c0202$var$useRouterRoutes();
        if ((0, $5XMmM.isLazyRouteMapExperimentEnabled)()) routes = routerRoutes;
        const { shouldPerformAction: shouldPerformAction, performAction: performAction } = (0, $b5bf33c7d1caa282$export$1bfa74483a8ca772)({
            actionName: 'forceReload'
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $1inzG.useAnalyticsEvents)();
        if (route.isRedirect !== true) currentMatchObjectRef.current = {
            route: route,
            match: match
        };
        const [, { resetCurrentPage: resetCurrentPage }] = (0, $lcJyp.useSpaStateActions)();
        const transitionBlocker = (0, $eUqFw.useCallback)(async (nextLocation, nextAction)=>{
            const nextMatch = (0, $lB25E.matchRoute)(routes, nextLocation.pathname, nextLocation.search);
            const canDo = (0, $036a05a78c408a0c$export$2e2bcd8739ae039)(currentMatchObjectRef.current, nextMatch);
            if ((0, $5XMmM.isLazyRouteMapExperimentEnabled)()) {
                if (!canDo && routes.length <= 3) await (0, $gUUjF.default).safeInfoWithoutCustomerData('lazy_routes.transition', 'failure', {
                    route: nextMatch?.route.name
                });
            }
            if (!canDo) {
                const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                window.location[windowAction]((0, $1n0H8.createPath)(nextLocation));
            }
            const remoteActionsRolloutStage = $5ce39a2e342c0202$var$getRemoteActionsRolloutStage();
            if (remoteActionsRolloutStage !== $5ce39a2e342c0202$var$REMOTE_ACTIONS_OFF && createAnalyticsEvent !== null) {
                const currentMatch = currentMatchObjectRef.current;
                if (canDo && currentMatch?.route.name !== nextMatch?.route.name && shouldPerformAction && $5ce39a2e342c0202$var$hasPendingForceReloadAction === false) {
                    $5ce39a2e342c0202$var$hasPendingForceReloadAction = true;
                    const windowAction = nextAction === 'REPLACE' ? 'replace' : 'assign';
                    performAction((remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                        $5ce39a2e342c0202$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'performed', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                        window.location[windowAction]((0, $1n0H8.createPath)(nextLocation));
                    }, (remoteAction, { attempts: attempts, lastAttemptedAt: lastAttemptedAt })=>{
                        $5ce39a2e342c0202$var$fireRemoteActionAnalytics(createAnalyticsEvent({}), 'cancelled', remoteAction, currentMatch, nextMatch, attempts, lastAttemptedAt);
                    });
                }
            }
            return canDo;
        }, [
            performAction,
            routes,
            shouldPerformAction,
            createAnalyticsEvent
        ]);
        const resetCurrentPageBeforeRouteChangeBlocker = (0, $eUqFw.useCallback)((nextLocation, nextAction)=>{
            const nextMatchObject = (0, $lB25E.matchRoute)(routes, nextLocation.pathname, nextLocation.search);
            if (nextMatchObject && match && route) {
                const { match: nextMatch, route: nextRoute } = nextMatchObject;
                const shouldReset = checkShouldResetPage({
                    nextMatch: nextMatch,
                    nextRoute: nextRoute,
                    currentMatch: match,
                    currentRoute: route,
                    action: nextAction
                });
                const nextRouteUfoName = (0, $c275061b2aed9c7d$export$2e2bcd8739ae039)(nextRoute);
                if (shouldReset) {
                    resetCurrentPage(nextRouteUfoName, nextRoute.name);
                    (0, $4KuMM.GlobalPageLoadExperience).setPageLoadId(nextRoute.perfMetricKey || 'UNKNOWN');
                }
                const isCurrentRouteRedirecting = route.isRedirect === true;
                if (isCurrentRouteRedirecting) {
                    const currentRouteName = (0, $c275061b2aed9c7d$export$2e2bcd8739ae039)(route);
                    (0, $dec00d4fabe9c1ea$export$2e2bcd8739ae039)(currentRouteName, nextRouteUfoName, nextRoute.name, performance.now());
                }
            }
            $5ce39a2e342c0202$var$updateSentryBreadcrumb(route, nextMatchObject?.route);
            return true;
        }, [
            checkShouldResetPage,
            match,
            resetCurrentPage,
            route,
            routes
        ]);
        registerBlock(transitionBlocker);
        registerBlock(resetCurrentPageBeforeRouteChangeBlocker);
        if (!(route && match)) return null;
        const { component: RouteComponent, meta: meta } = route;
        const entryPoint = route.entryPoint?.();
        const { reporting: reporting } = meta || {};
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $idiDE.default), {
            name: "route-component"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: `routeApp.${String(route.name)}`,
            packageName: "jiraSpa",
            extraEventData: {
                routeGroup: route.group ?? '',
                isSSR: false
            },
            fallback: "page",
            sendToPrivacyUnsafeSplunk: Boolean(reporting),
            ...reporting
        }, entryPoint ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ee11b761aa04a6e7$export$3e4cdfb894377bc9), {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        }) : RouteComponent && (0, ($parcel$interopDefault($eUqFw))).createElement(RouteComponent, {
            location: location,
            route: route,
            match: match,
            action: action,
            query: query
        })));
    };
    var $5ce39a2e342c0202$export$2e2bcd8739ae039 = $5ce39a2e342c0202$var$Spa;
    const $08a5aa665e71bebd$var$onSpaShellReady = ()=>{
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/spa-shell/core', '_jira-spa/spa-shell.start', 'JIRA_SPA_SHELL_READY');
    };
    const $08a5aa665e71bebd$var$Spa = ({ initRoute: initRoute = null, routes: routes })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
            hasErrorBoundary: false
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: "JIRA_SPA_SHELL_READY",
            onSet: $08a5aa665e71bebd$var$onSpaShellReady
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $5ce39a2e342c0202$export$2e2bcd8739ae039), {
            initRoute: initRoute,
            routes: routes
        }));
    var $08a5aa665e71bebd$export$2e2bcd8739ae039 = $08a5aa665e71bebd$var$Spa;
    var $ghXjN = parcelRequire("ghXjN");
    var $eUqFw = parcelRequire("eUqFw");
    var $7JEyt = parcelRequire("7JEyt");
    const $95616b66187196af$export$712225703044cda = (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $eUqFw.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, $7JEyt.default)([
                "_1e0c1bgi _2d3f16n6 _iu1g1fl4",
                __cmplp.className
            ])
        });
    });
    const $b1974ec03c2a5bd2$var$SPA_TRACE_KEY = 'spa';
    const $b1974ec03c2a5bd2$var$NewContent = (props)=>{
        const { isInset: isInset, hasTheming: hasTheming } = (0, $6WwlF.useBusinessLookAndFeel)();
        const renderContent = (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "mainContentSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.MainContentSkipLink), null)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
            traceKey: $b1974ec03c2a5bd2$var$SPA_TRACE_KEY,
            type: "start"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $08a5aa665e71bebd$export$2e2bcd8739ae039), props), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
            traceKey: $b1974ec03c2a5bd2$var$SPA_TRACE_KEY,
            type: "end"
        }));
        if (hasTheming) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cEX90.ThemedContentLayout), {
            appearance: isInset ? 'inset' : 'default'
        }, renderContent);
        return renderContent;
    };
    const $b1974ec03c2a5bd2$var$OldContent = (props)=>{
        const { isInset: isInset, hasProjectViewNavigation: hasProjectViewNavigation } = (0, $6WwlF.useBusinessLookAndFeel)();
        const renderContent = (0, ($parcel$interopDefault($eUqFw))).createElement((0, ($parcel$interopDefault($eUqFw))).Fragment, null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $2fec3262065a5aa8$export$2fcd4100c556a49e), null), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "mainContentSkipLink",
            packageName: "jiraPageContainer",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ghXjN.MainContentSkipLink), null)), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $hwyJ1.Main), {
            id: "ak-main-content"
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
            traceKey: $b1974ec03c2a5bd2$var$SPA_TRACE_KEY,
            type: "start"
        }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $08a5aa665e71bebd$export$2e2bcd8739ae039), props), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $inC6u.RenderTracerMark), {
            traceKey: $b1974ec03c2a5bd2$var$SPA_TRACE_KEY,
            type: "end"
        })));
        if (hasProjectViewNavigation) return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $cEX90.BusinessWrapper), {
            withWhiteBackground: isInset
        }, renderContent);
        return (0, $1ybV0.ff)('iph.enabled') ? (0, ($parcel$interopDefault($eUqFw))).createElement((0, $95616b66187196af$export$712225703044cda), null, renderContent) : renderContent;
    };
    const $b1974ec03c2a5bd2$export$7c6e2c02157bb7d2 = (0, $9zysr.componentWithCondition)((0, $6FP8W.getWillShowNav4), $b1974ec03c2a5bd2$var$NewContent, $b1974ec03c2a5bd2$var$OldContent);
    const $37f6df81ea368cad$export$6d4069f4b64f7492 = ({ baseUrl: baseUrl, locale: locale, messages: messages, isPrewarming: isPrewarming = false, Router: Router, routes: routes, routerLinkComponent: routerLinkComponent, initRoute: initRoute })=>{
        const pageContainerPerformanceTiming = (0, $eUqFw.useCallback)(()=>{
            (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)((0, $7688150c048b38d1$export$21473105c510aacc), (0, $7688150c048b38d1$export$59f83d43fe209319), (0, $7688150c048b38d1$export$7114284ca03133ee), true, true);
        }, []);
        return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $ibSOG.PageContainer), {
            baseUrl: baseUrl,
            id: false ? 'jira.entry.ssr' : 'spa',
            locale: locale,
            messages: messages,
            Router: Router,
            routerLinkComponent: routerLinkComponent
        }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $7688150c048b38d1$export$7114284ca03133ee),
            onSet: pageContainerPerformanceTiming
        }), isPrewarming !== true && (0, ($parcel$interopDefault($eUqFw))).createElement((0, $b1974ec03c2a5bd2$export$7c6e2c02157bb7d2), {
            initRoute: initRoute,
            routes: routes
        }));
    };
    var $10fdS = parcelRequire("10fdS");
    var $keguF = parcelRequire("keguF");
    var $geFaw = parcelRequire("geFaw");
    var $gTSbo = parcelRequire("gTSbo");
    var $9DIQe = parcelRequire("9DIQe");
    var $eUqFw = parcelRequire("eUqFw");
    var $lEfVV = parcelRequire("lEfVV");
    var $78Ywx = parcelRequire("78Ywx");
    var $8blac = parcelRequire("8blac");
    var $ieRGA = parcelRequire("ieRGA");
    var $6rW04 = parcelRequire("6rW04");
    var $lB25E = parcelRequire("lB25E");
    var $7BDEW = parcelRequire("7BDEW");
    const $ba619299535bad37$export$c9d44c736471c518 = (name)=>document.querySelector(`meta[name="${name}"]`);
    const $ba619299535bad37$var$getHead = ()=>document.head || document.querySelector('head');
    const $ba619299535bad37$export$c79fd820617d7f = (name, content)=>{
        if (!name || !content) return;
        const existingMeta = $ba619299535bad37$export$c9d44c736471c518(name);
        const meta = document.createElement('meta');
        meta.name = name;
        meta.content = content;
        if (existingMeta) existingMeta.parentNode?.replaceChild(existingMeta, meta);
        else {
            const head = $ba619299535bad37$var$getHead();
            if (head) head.appendChild(meta);
        }
    };
    const $ba619299535bad37$export$4267657a25105d9d = (name)=>{
        const meta = $ba619299535bad37$export$c9d44c736471c518(name);
        if (meta) meta.parentNode?.removeChild(meta);
    };
    var $cprue = parcelRequire("cprue");
    const $36d7090ac0dde683$var$sessionQueryParams = [
        'searchSessionId',
        'searchObjectId',
        'searchContainerId',
        'searchContentType'
    ];
    const $36d7090ac0dde683$var$sessionMeta = [
        'ajs-search-session-id',
        'ajs-search-object-id',
        'ajs-search-container-id',
        'ajs-search-content-type'
    ];
    const $36d7090ac0dde683$var$removeDwellComponent = (placeholderId)=>{
        if (placeholderId && document.getElementById(placeholderId)) (0, $lEfVV.unmountComponentAtNode)(document.getElementById(placeholderId));
    };
    const $36d7090ac0dde683$var$removeSessionMeta = ()=>$36d7090ac0dde683$var$sessionMeta.forEach((0, $ba619299535bad37$export$4267657a25105d9d));
    const $36d7090ac0dde683$var$addSessionMeta = ({ sessionId: sessionId, objectId: objectId, containerId: containerId, objectType: objectType })=>{
        const newMeta = {
            'ajs-search-session-id': sessionId,
            'ajs-search-object-id': objectId,
            'ajs-search-container-id': containerId,
            'ajs-search-content-type': objectType
        };
        Object.entries(newMeta).forEach(([name, content])=>(0, $ba619299535bad37$export$c79fd820617d7f)(name, content));
    };
    const $36d7090ac0dde683$var$getPreviousSessionId = ()=>(0, $6rW04.default)('ajs-search-session-id');
    class $36d7090ac0dde683$export$f1e582dddb502dd6 extends (0, $eUqFw.Component) {
        constructor(props){
            super(props);
            this.onClearSessionEvent = ()=>{
                if (this.state.shouldRemoveSessionBeIgnored) this.setState({
                    shouldRemoveSessionBeIgnored: false
                });
            };
            this.onHistoryChange = (location)=>{
                $36d7090ac0dde683$var$removeDwellComponent('search-dwell-time');
                const parsedUrl = (0, ($parcel$interopDefault($78Ywx))).parse(location.pathname + location.search, true);
                const queryString = parsedUrl.query || {};
                const { searchSessionId: searchSessionId, searchObjectId: searchObjectId, searchContainerId: searchContainerId, searchContentType: searchContentType } = queryString;
                const { path: path } = parsedUrl;
                const previousSessionId = $36d7090ac0dde683$var$getPreviousSessionId();
                const { shouldRemoveSessionBeIgnored: shouldRemoveSessionBeIgnored } = this.state;
                if (!(0, ($parcel$interopDefault($8blac)))(previousSessionId) && !shouldRemoveSessionBeIgnored) $36d7090ac0dde683$var$removeSessionMeta();
                if (searchSessionId) {
                    (0, $ieRGA.default)($36d7090ac0dde683$var$sessionQueryParams);
                    const newState = {
                        sessionId: searchSessionId,
                        objectId: searchObjectId,
                        objectType: searchContentType,
                        containerId: searchContainerId,
                        previousSessionId: $36d7090ac0dde683$var$getPreviousSessionId()
                    };
                    $36d7090ac0dde683$var$addSessionMeta(newState);
                    const shouldRemoveSession = !!(0, $cprue.skipClearSessionURLs).find((skipUrlRegex)=>!(0, ($parcel$interopDefault($8blac)))(path) ? skipUrlRegex.test(path) : false);
                    this.setState({
                        ...newState,
                        shouldRemoveSessionBeIgnored: shouldRemoveSession
                    });
                }
            };
            this.props.history.listen(this.onHistoryChange);
            this.state = {
                shouldRemoveSessionBeIgnored: false,
                sessionId: ''
            };
        }
        componentDidMount() {
            window.addEventListener((0, $cprue.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
        }
        componentWillUnmount() {
            window.removeEventListener((0, $cprue.CLEAR_SEARCH_SESSION), this.onClearSessionEvent);
        }
        render() {
            if (this.state && this.state.sessionId) {
                const { objectId: objectId, containerId: containerId, objectType: objectType, sessionId: sessionId, previousSessionId: previousSessionId } = this.state;
                const data = {
                    objectId: objectId,
                    containerId: containerId,
                    objectType: objectType,
                    source: objectType,
                    actionSubject: objectType,
                    attributes: {
                        previousSessionId: previousSessionId
                    }
                };
                return (0, ($parcel$interopDefault($eUqFw))).createElement((0, $7BDEW.default), {
                    sessionId: sessionId,
                    data: data
                });
            }
            return null;
        }
    }
    var $36d7090ac0dde683$export$2e2bcd8739ae039 = (0, $lB25E.withRouter)($36d7090ac0dde683$export$f1e582dddb502dd6);
    var $2B87Z = parcelRequire("2B87Z");
    var $2B87Z = parcelRequire("2B87Z");
    const $ce0678b5063705cb$export$ce440b3d0fa0d5ed = ()=>{
        if (false) return;
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush', 'ssr.spa.early-common-flush:start', 'ssr.spa.early-route-flush:end');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/common-preload', 'ssr.spa.early-common-flush:start', 'ssr.spa.metatags:start');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/metatags', 'ssr.spa.metatags:start', 'ssr.spa.metatags:end');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/statsig', 'ssr.spa.statsig:start', 'ssr.spa.statsig:end');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/feature-flags', 'ssr.spa.feature-flags:start', 'ssr.spa.feature-flags:end');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/inline-scripts', 'ssr.spa.feature-flags:end', 'ssr.spa.early-common-flush:end');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('early-flush/route-preload', 'ssr.spa.early-route-flush:start', 'ssr.spa.early-route-flush:end');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('css-assets', 'ssr.spa.css-assets:start', 'ssr.spa.css-assets:end');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output', 'ssr.spa.start', 'ssr.spa.state');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/styles', 'ssr.spa.start', 'ssr.spa.styles');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/html', 'ssr.spa.styles', 'ssr.spa.html');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('ssr-output/state', 'ssr.spa.html', 'ssr.spa.state');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa', 'vendor-entry.js:eval-start', 'commons-entry.js:eval-stop');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/vendor', 'vendor-entry.js:eval-start', 'vendor-entry.js:eval-stop');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/commons', 'vendor-entry.js:eval-stop', 'commons-entry.js:eval-stop');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/commons/bundle-ready', 'vendor-entry.js:eval-stop', 'commons-entry.js:eval-start');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('pre-spa/commons/eval', 'commons-entry.js:eval-start', 'commons-entry.js:eval-stop');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/bundle-ready', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-start');
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa/language-pack', 'jira-spa/language-pack.start', 'jira-spa/language-pack.end', true, true);
        (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    };
    var $4ea83 = parcelRequire("4ea83");
    var $gUUjF = parcelRequire("gUUjF");
    var $lB25E = parcelRequire("lB25E");
    const $be11b329f399dd87$var$LOCATION = 'spa.create-spa-history';
    const $be11b329f399dd87$var$createCustomHistoryBlock = (routeBlockFns, currentRoutes, history)=>(blockFn)=>{
            const matchedRoute = (0, $lB25E.matchRoute)(currentRoutes, history.location.pathname, history.location.search);
            if (!matchedRoute) return ()=>{};
            if (!routeBlockFns.includes(blockFn)) routeBlockFns.push(blockFn);
            return ()=>{
                const idx = routeBlockFns.indexOf(blockFn);
                if (idx !== -1) routeBlockFns.splice(idx, 1);
            };
        };
    const $be11b329f399dd87$var$createSpaHistory = (initialRoutes)=>{
        const routeBlockFns = [];
        let blockArgs = [];
        let nextMatchedRoute;
        const currentRoutes = initialRoutes;
        const history = (0, $lB25E.createBrowserHistory)({
            getUserConfirmation: async (__, done)=>{
                try {
                    const matchedRoute = (0, $lB25E.matchRoute)(currentRoutes, history.location.pathname, history.location.search);
                    if (!matchedRoute || !nextMatchedRoute) return done(true);
                    for(let i = routeBlockFns.length - 1; i >= 0; i -= 1){
                        const result = await routeBlockFns[i](...blockArgs);
                        if (result === false) return done(false);
                    }
                    routeBlockFns.length = 0;
                    return done(true);
                } catch (err) {
                    (0, $gUUjF.default).safeErrorWithoutCustomerData($be11b329f399dd87$var$LOCATION, 'Error with getUserConfirmation', err);
                    return done(true);
                }
            }
        });
        history.refreshRoutes = (newRoutes)=>{
            currentRoutes.length = 0;
            currentRoutes.push(...newRoutes);
            routeBlockFns.length = 0;
        };
        history.block((location, action)=>{
            blockArgs = [
                location,
                action
            ];
            nextMatchedRoute = (0, $lB25E.matchRoute)(currentRoutes, location.pathname, location.search);
            return '';
        });
        history.block = $be11b329f399dd87$var$createCustomHistoryBlock(routeBlockFns, currentRoutes, history);
        return history;
    };
    var $be11b329f399dd87$export$2e2bcd8739ae039 = (routes)=>$be11b329f399dd87$var$createSpaHistory(routes);
    var $fGHk2 = parcelRequire("fGHk2");
    var $iE8ll = parcelRequire("iE8ll");
    var $jK1pm = parcelRequire("jK1pm");
    var $2ctsX = parcelRequire("2ctsX");
    var $lB25E = parcelRequire("lB25E");
    var $8JKCU = parcelRequire("8JKCU");
    var $jlwEU = parcelRequire("jlwEU");
    var $ismmz = parcelRequire("ismmz");
    var $4KuMM = parcelRequire("4KuMM");
    var $foPCo = parcelRequire("foPCo");
    const $077123d74a10e7f8$var$isPreprodSlow = ()=>(0, $1ybV0.getFeatureFlagValue)('uip.preprod.slow', 0);
    (0, $6iz4v.setMark)('JIRA_SPA_ENTRY_LOADED');
    window.__SPA__ = true;
    (0, $9BVaU.LooselyLazy).init({
        mode: (0, $74RJ9.MODE).RENDER,
        crossOrigin: 'anonymous'
    });
    const $077123d74a10e7f8$var$tenantContext = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    (0, $6iz4v.setMark)('jira-spa/language-pack.start');
    var $7KGHt = parcelRequire("7KGHt");
    (0, $6iz4v.setMark)('jira-spa/language-pack.end');
    const { locale: $077123d74a10e7f8$var$locale } = $077123d74a10e7f8$var$tenantContext;
    const $077123d74a10e7f8$var$superbatchInit = ()=>{
        window.DeferScripts = {
            deferState: 'done'
        };
        document.body && document.body.classList.remove('deferred');
    };
    const $077123d74a10e7f8$var$globalSettingsArgs = {
        navigation: false,
        upflow: false
    };
    const $077123d74a10e7f8$var$InstallGlobalComponentsOnce = ()=>{
        (0, $eUqFw.useEffect)(()=>{
            (0, $foPCo.default).installLowPriorityApps((0, ($parcel$interopDefault($kFGm5)))($077123d74a10e7f8$var$globalSettingsArgs, [
                'flags',
                'navigation',
                'renderNavigation'
            ]));
            (0, $6iz4v.setMark)('JIRA_SPA_ENTRY_GLOBAL_INSTALL');
        }, []);
        return null;
    };
    const $077123d74a10e7f8$var$updateCapability = (capability)=>{
        (0, $gXgRp.setCapability)(capability);
        if (capability === null && window.AJS?.$?.ajaxSettings?.headers?.[0, $d07297a4af13004b$export$9a80695e72849f84]) delete window.AJS.$.ajaxSettings.headers[0, $d07297a4af13004b$export$9a80695e72849f84];
        else window.AJS?.$?.ajaxSetup({
            headers: {
                [(0, $d07297a4af13004b$export$9a80695e72849f84)]: capability
            }
        });
    };
    const $077123d74a10e7f8$var$CapabilityTrackerConnector = ({ routes: routes })=>{
        const { registerBlock: registerBlock } = (0, $lB25E.useRouterActions)();
        registerBlock((nextLocation)=>{
            const nextMatchObject = (0, $lB25E.matchRoute)(routes, nextLocation.pathname, nextLocation.search, '');
            $077123d74a10e7f8$var$updateCapability(nextMatchObject?.route.meta?.capability || null);
            return true;
        });
        const route = (0, $10fdS.useCurrentRoute)();
        $077123d74a10e7f8$var$updateCapability(route.meta?.capability || null);
        return null;
    };
    const $077123d74a10e7f8$var$main = async ()=>{
        (0, $iE8ll.default)();
        (0, $a5pCl.initBrowserMetrics3)();
        (0, $d16Bc.initPlatformFeatureFlags)((0, $2ctsX.visualRefreshResolverOverride));
        (0, $ce0678b5063705cb$export$ce440b3d0fa0d5ed)();
        (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/init', 'jira-spa.js:eval-start');
        (0, $6iz4v.setMark)('jira-spa/setup.start');
        const getRoutes = await (0, $2B87Z.measureInitialPageLoadTimingAsync)('jira-spa/setup/load-routes', async ()=>{
            const module = await (parcelRequire("kmii1"));
            return module.default;
        });
        const routes = (0, $2B87Z.measureInitialPageLoadTiming)('jira-spa/setup/routes', ()=>getRoutes());
        const history = (0, $2B87Z.measureInitialPageLoadTiming)('jira-spa/setup/history', ()=>(0, $be11b329f399dd87$export$2e2bcd8739ae039)(routes));
        const initRoute = (0, $2B87Z.measureInitialPageLoadTiming)('jira-spa/setup/match-route', ()=>{
            const matchedRoute = (0, $lB25E.matchRoute)(routes, window.location.pathname, window.location.search);
            (0, $keguF.setMatchedRoute)(matchedRoute?.route, matchedRoute?.match);
            return matchedRoute;
        });
        if (initRoute != null) {
            const ufoName = (0, $c275061b2aed9c7d$export$2e2bcd8739ae039)(initRoute.route);
            (0, $8JKCU.default)(ufoName, initRoute.route.name);
        }
        const BrowserMetricsConnector = ()=>{
            const route = (0, $10fdS.useCurrentRoute)();
            (0, $7Nhwm.browserMetrics).setRoute(route.name);
            (0, $jlwEU.useUFOTransitionCompleter)();
            if ((0, $1ybV0.ff)('uip.ufo')) (0, $4KuMM.GlobalPageLoadExperience).setPageLoadId(route.perfMetricKey || 'UNKNOWN');
            return null;
        };
        if ((0, $1ybV0.ff)('uip.ufo')) (0, $4KuMM.GlobalPageLoadExperience).startPageLoad('UNKNOWN', true);
        const routerProps = {
            history: history,
            routes: routes,
            basePath: '',
            initialRoute: initRoute?.route,
            resourceData: window.SPA_STATE,
            resourceContext: (0, $fGHk2.getSpaRouterContext)({
                tenantContext: $077123d74a10e7f8$var$tenantContext
            }),
            onPrefetch: ({ route: route, match: match })=>{
                (0, $4ea83.setPrefetchStartMark)(match);
                if (!route.forPaint) return;
                route.forPaint.map((component)=>component.preload && component.preload());
            }
        };
        const SpaClientRouter = ({ children: children })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $gTSbo.Router), routerProps, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
                id: "spa-main.client-router",
                packageName: "jiraEntry",
                fallback: "unmount",
                teamName: "delorean-spa"
            }, (0, ($parcel$interopDefault($eUqFw))).createElement(BrowserMetricsConnector, null), (0, ($parcel$interopDefault($eUqFw))).createElement($077123d74a10e7f8$var$CapabilityTrackerConnector, {
                routes: routes
            }), (0, ($parcel$interopDefault($eUqFw))).createElement((0, $36d7090ac0dde683$export$2e2bcd8739ae039), null)), children, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $6U1dF.NonCritical), {
                id: "spa-main.client-router.non-critical",
                teamName: "delorean-spa"
            }, (0, ($parcel$interopDefault($eUqFw))).createElement($077123d74a10e7f8$var$InstallGlobalComponentsOnce, null)));
        const App = ({ placeholders: placeholders })=>(0, ($parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
                name: "jira-spa"
            }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $8R80x.EntryPointPlaceholderContext).Provider, {
                value: placeholders
            }, (0, ($parcel$interopDefault($eUqFw))).createElement((0, $37f6df81ea368cad$export$6d4069f4b64f7492), {
                baseUrl: "",
                locale: $077123d74a10e7f8$var$locale,
                messages: $7KGHt,
                Router: SpaClientRouter,
                initRoute: initRoute,
                routes: routes,
                routerLinkComponent: (0, $9DIQe.JiraRouterLinkConfiguration)
            }))));
        window.__NAV_VERSION__ = '3.0.0';
        (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/setup', 'jira-spa/setup.start', true);
        (0, $6iz4v.setMark)('_jira-spa/spa-shell.start');
        const container = document.getElementById('jira-frontend');
        if (container) {
            if ((0, $1ybV0.ff)('uip.vc.partial', false)) {
                (0, $ismmz.getVCObserver)().setSSRElement(container);
                (0, $ismmz.getVCObserver)().setReactRootRenderStart();
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        (0, $ismmz.getVCObserver)().setReactRootRenderStop();
                    });
                });
            }
            const placeholders = (0, $8R80x.getPlaceholdersFromHTML)();
            if (!(0, $eI5EY.fg)('jfp-magma-concurrent-root-jira-spa') && true) (0, $lEfVV.render)((0, ($parcel$interopDefault($eUqFw))).createElement(App, {
                placeholders: placeholders
            }), container);
            if ((0, $eI5EY.fg)('jfp-magma-concurrent-root-jira-spa')) {
                const root = (0, $gpO36.createRoot)(container);
                root.render((0, ($parcel$interopDefault($eUqFw))).createElement(App, {
                    placeholders: placeholders
                }));
            }
        }
        (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('jira-spa/spa-shell', '_jira-spa/spa-shell.start');
        (0, $6iz4v.setMark)('JIRA_SPA_ENTRY_REACT_DOM_RENDER');
        setTimeout(()=>{
            (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('jira-spa', 'commons-entry.js:eval-stop', 'jira-spa.js:eval-stop');
        });
        if ($077123d74a10e7f8$var$isPreprodSlow() > 0) {
            (0, $6iz4v.setMark)('slow-start');
            const end = performance.now() + $077123d74a10e7f8$var$isPreprodSlow();
            while(performance.now() < end);
            (0, $6iz4v.setMark)('slow-stop');
        }
        (0, $foPCo.default).installHighPriorityApps((0, ($parcel$interopDefault($8dloj)))($077123d74a10e7f8$var$globalSettingsArgs, [
            'flags',
            'navigation',
            'renderNavigation'
        ]));
        $077123d74a10e7f8$var$superbatchInit();
        return null;
    };
    $077123d74a10e7f8$var$main().catch((reason)=>(0, $0507482b123635a1$export$a5c16644a2d3c205)(reason));
}, [
    "eNmuD",
    "dsiAd",
    "2Lfdl",
    "hPzOn",
    "1QYl5",
    "561Jq",
    "i5RRW",
    "92sUi",
    "kWrFZ",
    "bYT2S",
    "h2MrD",
    "fr9NE",
    "cM9em",
    "lknvU"
]);
$parcel$global.rlb("bz9bg");
